
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("3sora", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $24737abaf730fa97$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("atKhx");

var $eRJ8t = parcelRequire("eRJ8t");
var $lhDyE = parcelRequire("lhDyE");

var $jD5no = parcelRequire("jD5no");

var $lf2Au = parcelRequire("lf2Au");

var $lL5b5 = parcelRequire("lL5b5");

var $8J6rn = parcelRequire("8J6rn");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $2gCtH = parcelRequire("2gCtH");

var $iixvy = parcelRequire("iixvy");

var $cfDZ3 = parcelRequire("cfDZ3");

var $5rqex = parcelRequire("5rqex");

var $14XJw = parcelRequire("14XJw");

var $htI2Q = parcelRequire("htI2Q");

var $6juLJ = parcelRequire("6juLJ");

var $cf7yQ = parcelRequire("cf7yQ");

var $lXCei = parcelRequire("lXCei");

var $4dRjY = parcelRequire("4dRjY");

var $6XsPQ = parcelRequire("6XsPQ");

var $dZw8H = parcelRequire("dZw8H");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $DVljb = parcelRequire("DVljb");

var $l8ruj = parcelRequire("l8ruj");

var $jprGi = parcelRequire("jprGi");

var $c9lD2 = parcelRequire("c9lD2");

var $fnaRp = parcelRequire("fnaRp");
const $24737abaf730fa97$var$PeopleProfilesShell = ({ history: history })=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const [{ data: gspData }, { fetchState: fetchState }] = (0, $6juLJ.useGettingStartedPanelState)();
    (0, $5uXOq.useEffect)(()=>{
        if (gspData === undefined) fetchState();
    }, [
        gspData,
        fetchState
    ]);
    const gspProjectId = gspData?.properties?.user?.projectId;
    const { isFirstProject: isFirstProject, isFirstProjectItsm: isFirstProjectItsm } = (0, $htI2Q.useIsFirstProjectITSM)(gspProjectId);
    /**
   * Initializes the active tab to 'alerts' within the Getting Started Panel
   * specifically for NPLE for ITSM experiment.
   */ (0, $lXCei.useInitializeActiveTab)('alerts', gspProjectId);
    const addFlag = (0, $5uXOq.useMemo)(()=>(0, $c9lD2.createShowFlagHandler)(showFlag, dismissFlag), [
        showFlag,
        dismissFlag
    ]);
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $2tT7R.useEnvironment)();
    const locale = (0, $DVljb.useLocale)();
    const previousSubProduct = (0, $cfDZ3.getPreviousSubProduct)();
    const invitePeopleExperimentalFeatures = {
        inviteThirdPartyTeams: 'variation'
    };
    const { openModal: openModal } = (0, $lhDyE.useInvitePeopleModal)({
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        continueUrl: window.location.href,
        enableThirdParty: true,
        experimentalFeatures: invitePeopleExperimentalFeatures,
        displayInfiSpotlight: true,
        resourceAri: `ari:cloud:jira::site/${cloudId}`,
        showFlag: addFlag,
        source: 'peopleDirectory',
        subProduct: previousSubProduct === 'unknown' || previousSubProduct === null ? undefined : previousSubProduct
    });
    const invitePeopleHandlers = (0, $5uXOq.useMemo)(()=>({
            handleOpenDialog: openModal
        }), [
        openModal
    ]);
    const { shouldUseJSM: shouldUseJSM } = (0, $8J6rn.useOgTenantInfo)();
    const isAiOptInEnabled = (0, $2gCtH.useIsAiEnabledForIssue)();
    const isPremium = (0, $iixvy.useIsPremium)();
    const isAIEnabled = isAiOptInEnabled && isPremium;
    if (!atlassianAccountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lL5b5.default), null);
    const { push: push, replace: replace } = history;
    const productFeatureFlags = {
        'event-on-call-consolidation_s97c8': true,
        'event-on-call-consolidation-state': shouldUseJSM
    };
    const isNpleForItsmEnabled = isFirstProject && isFirstProjectItsm && (0, $6s1PB.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "people-profiles"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
        id: "people-profiles"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lf2Au.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jprGi.default), {
        appName: "jira-directory",
        contextSpaPaths: [
            '/browse',
            '/jira',
            '/projects'
        ],
        contextEntryPoint: "/jira/people",
        env: environment === 'prod' ? 'prod' : 'stg',
        locale: locale,
        // @ts-expect-error - TS2322 - Type '(flagFromPTC: FlagFromPTC) => void' is not assignable to type '(props: FlagProps) => void'.
        addFlag: addFlag,
        push: push,
        replace: replace,
        docTitle: {
            end: 'Jira'
        },
        history: history,
        cloudId: cloudId,
        orgId: orgId,
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'JiraSubProduct | undefined'.
        subProduct: previousSubProduct,
        invitePeopleHandlers: invitePeopleHandlers,
        productFeatureFlags: productFeatureFlags,
        isAIEnabled: isAIEnabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        appName: "people-profiles",
        isExpectedToHaveSsr: false,
        // @ts-expect-error - TS2769 - No overload matches this call.
        metric: (0, $fnaRp.peopleProfilesPageLoad)
    }), (0, $4R6GH.fg)('set-embedded-directory-spa-ready') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null))), isNpleForItsmEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cf7yQ.JsdGettingStartedPanelShouldRender), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cf7yQ.JsdGettingStartedPanelOpenButton), null)));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$24737abaf730fa97$export$2e2bcd8739ae039 = ()=>// @ts-expect-error - TS2739 - Type '{ children: (history: any) => Element; }' is missing the following properties from type 'RouteContext': location, query, route, match, action
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6XsPQ.HistoryAdapter), null, (history)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eRJ8t.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($24737abaf730fa97$var$PeopleProfilesShell, {
            history: history
        })));

});
parcelRegister("lL5b5", function(module, exports) {

$parcel$export(module.exports, "default", () => $07c2532655d93687$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $j0xEB = parcelRequire("j0xEB");

var $j2Jlg = parcelRequire("j2Jlg");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$07c2532655d93687$export$2e2bcd8739ae039 = ()=>{
    const { href: href = null } = (0, $j0xEB.default)() || {};
    if (href && !href.includes('login.jsp')) {
        const encodedRedirectUrl = encodeURIComponent(href);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j2Jlg.default), {
            url: `/login.jsp?os_destination=${encodedRedirectUrl}`
        });
    }
    return null;
};

});
parcelRegister("j2Jlg", function(module, exports) {

$parcel$export(module.exports, "default", () => $773e6f988af77e5c$export$2e2bcd8739ae039);

var $gKZoD = parcelRequire("gKZoD");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$773e6f988af77e5c$export$2e2bcd8739ae039 = ({ url: url })=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.assign(url);
    return null;
};

});


parcelRegister("iixvy", function(module, exports) {

$parcel$export(module.exports, "useIsPremium", () => $545133d1825caa45$export$1bb5840a003dc643);
$parcel$export(module.exports, "useOptInStatus", () => $545133d1825caa45$export$5e56b08674e48311);
$parcel$export(module.exports, "useAIOptIn", () => $545133d1825caa45$export$49e57b9044cda91c);

var $5uXOq = parcelRequire("5uXOq");

var $2ys8y = parcelRequire("2ys8y");
var $b4PzF = parcelRequire("b4PzF");

var $2vSU6 = parcelRequire("2vSU6");

var $2gCtH = parcelRequire("2gCtH");

var $5NH95 = parcelRequire("5NH95");

var $93Yeu = parcelRequire("93Yeu");

var $14XJw = parcelRequire("14XJw");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");

var $4R6GH = parcelRequire("4R6GH");

var $ljlOe = parcelRequire("ljlOe");

var $44KLa = parcelRequire("44KLa");
const $545133d1825caa45$var$DISABLED = 'disabled';
const $545133d1825caa45$var$DISABLED_OPT_IN = 'disabled-opt-in';
const $545133d1825caa45$var$ENABLED = 'enabled';
const $545133d1825caa45$export$1bb5840a003dc643 = ()=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    if (!appEditions) return false;
    // currently admin hub AI BE endpoint for JWM already defaults to JSW value
    // so we reflect same logic for JWM here
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return appEditions.software === (0, $ldyPw.PREMIUM_EDITION);
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return appEditions.serviceDesk === (0, $ldyPw.PREMIUM_EDITION);
        default:
            return false;
    }
};
const $545133d1825caa45$export$10e0dafdd792475b = ()=>{
    // upsell us for standard but not free subscription admins
    const appEditions = (0, $k9JTq.useAppEditions)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    if (!appEditions) return false;
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
            return appEditions.core === (0, $ldyPw.STANDARD_EDITION);
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return appEditions.software === (0, $ldyPw.STANDARD_EDITION);
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return appEditions.serviceDesk === (0, $ldyPw.STANDARD_EDITION);
        default:
            return false;
    }
};
const $545133d1825caa45$export$bd66bcf1f00b19d2 = ()=>{
    const isOrgAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isPremium = $545133d1825caa45$export$1bb5840a003dc643();
    const isSupportedENV = !(0, $b4PzF.isFedRamp)();
    return isOrgAdmin && isPremium && isSupportedENV;
};
const $545133d1825caa45$export$1276193c77ae88bf = ()=>{
    const isOrgAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isStandard = $545133d1825caa45$export$10e0dafdd792475b();
    const isSupportedENV = !(0, $b4PzF.isFedRamp)();
    return isOrgAdmin && isStandard && isSupportedENV;
};
const $545133d1825caa45$export$5e56b08674e48311 = (isAIOptedIn, product)=>{
    const canOptIn = $545133d1825caa45$export$bd66bcf1f00b19d2();
    const canStartPremiumTrial = $545133d1825caa45$export$1276193c77ae88bf();
    if ((0, $b4PzF.isFedRamp)()) return $545133d1825caa45$var$DISABLED;
    // AI Upsell In Editor Experiment - implicitly checks product, fedramp, if edition is FREE and user is an admin
    const { experimentValue: aiUpsellInEditorCohort } = (0, $4R6GH.fg)('jira_free_ai_in_editor_v2_gate') ? (0, $5NH95.useAIUpsellInEditorRequirements)(product) : {
        experimentValue: 'not-enrolled'
    };
    if (aiUpsellInEditorCohort === 'variation') return $545133d1825caa45$var$DISABLED_OPT_IN;
    const isValidForGlobalOptIn = [
        product !== 'JPD',
        canOptIn
    ].every((condition)=>condition === true);
    const isValidForPremiumTrial = canStartPremiumTrial && product !== 'JPD';
    const globalOptInEnabled = isValidForGlobalOptIn || isValidForPremiumTrial ? $545133d1825caa45$var$DISABLED_OPT_IN : $545133d1825caa45$var$DISABLED;
    return isAIOptedIn ? $545133d1825caa45$var$ENABLED : globalOptInEnabled;
};
const $545133d1825caa45$export$49e57b9044cda91c = ({ editorPluginAIConfig: editorPluginAIConfig })=>{
    const { isAiOptInEnabled: isAiOptInEnabled, product: product } = editorPluginAIConfig || {};
    const optInStatus = $545133d1825caa45$export$5e56b08674e48311(isAiOptInEnabled, product);
    const isOrgAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const [showOptInModal, setShowOptInModal] = (0, $5uXOq.useState)(false);
    const [showPremiumTrialModal, setShowPremiumTrialModal] = (0, $5uXOq.useState)(false);
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const canStartTrial = $545133d1825caa45$export$1276193c77ae88bf();
    // AI Upsell In Editor Experiment
    const { isExperimentEnabled: isAIUpsellInEditorFreeEnabled, triggerUpsellFlow: triggerAIUpsellInEditorFreeFlow, UpsellModal: AIUpsellInEditorFreeModal } = (0, $4R6GH.fg)('jira_free_ai_in_editor_v2_gate') ? (0, $5NH95.useAIUpsellInEditorFree)(optInStatus, product) : {
        isExperimentEnabled: false,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        triggerUpsellFlow: ()=>{},
        UpsellModal: null
    };
    // Callback that will be called when AI buttons are clicked and opt in status is disabled-op-in
    const triggerOptInFlow = (0, $5uXOq.useCallback)(()=>{
        setShowOptInModal(true);
    }, [
        setShowOptInModal
    ]);
    // alt callback for standard admins to trigger a premium upsell in order to opt in
    const triggerUpsellFlow = (0, $5uXOq.useCallback)(()=>{
        setShowPremiumTrialModal(true);
    }, [
        setShowPremiumTrialModal
    ]);
    const aiOptInModal = (0, $5uXOq.useMemo)(()=>{
        const onCloseModal = ()=>setShowOptInModal(false);
        const adminLink = `${(0, $2ys8y.getATLContextUrl)('admin')}/o/${orgId}/atlassian-intelligence`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44KLa.OptInModal), {
            showOptInModal: showOptInModal,
            isOrgAdmin: isOrgAdmin,
            onCloseModal: onCloseModal,
            adminLink: adminLink
        });
    }, [
        orgId,
        isOrgAdmin,
        showOptInModal
    ]);
    const aiUpsellModal = (0, $5uXOq.useMemo)(()=>{
        const onCloseModal = ()=>setShowPremiumTrialModal(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ljlOe.AIUpsellPremiumTrialEntryPointContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44KLa.OptInUpsellModal), {
            "data-testid": "platform-react-hooks-use-ai-opt-in.upsell-modal",
            showPremiumTrialModal: showPremiumTrialModal,
            onCloseModal: onCloseModal
        }));
    }, [
        showPremiumTrialModal
    ]);
    if ((0, $b4PzF.isFedRamp)()) return {
        optInStatus: $545133d1825caa45$var$DISABLED,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        triggerOptInFlow: ()=>{},
        AIOptInModal: null
    };
    if (isAIUpsellInEditorFreeEnabled) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerAIUpsellInEditorFreeFlow,
        AIOptInModal: AIUpsellInEditorFreeModal
    };
    if (optInStatus === $545133d1825caa45$var$DISABLED || optInStatus === $545133d1825caa45$var$ENABLED) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerOptInFlow,
        AIOptInModal: null
    };
    if (canStartTrial && optInStatus === $545133d1825caa45$var$DISABLED_OPT_IN) return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerUpsellFlow,
        AIOptInModal: aiUpsellModal
    };
    return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerOptInFlow,
        AIOptInModal: aiOptInModal
    };
};

});
parcelRegister("5NH95", function(module, exports) {

$parcel$export(module.exports, "useAIUpsellInEditorRequirements", () => $26b3b3762ac33b52$export$38bfb0ec25eaa6b2);
$parcel$export(module.exports, "useAIUpsellInEditorFree", () => $26b3b3762ac33b52$export$beacfd188d344f95);
$parcel$export(module.exports, "AIUpsellButtonWrapper", () => $26b3b3762ac33b52$export$c44b9b0347b51c37);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $b4PzF = parcelRequire("b4PzF");

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $fmQtB = parcelRequire("fmQtB");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");

var $4R6GH = parcelRequire("4R6GH");

var $4SswE = parcelRequire("4SswE");

var $7xCut = parcelRequire("7xCut");
const $26b3b3762ac33b52$var$useGetSupportedProjectType = (product)=>{
    const siteHasOnlyJira = (0, $4SswE.useSiteHasOnlyJira)();
    switch(product){
        case 'JSW':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'JSM':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'JWM':
            // If tenant is configured with only JWM and JSW, we can provide an upgrade link for JSW
            return siteHasOnlyJira ? (0, $2vSU6.SOFTWARE_PROJECT) : undefined;
        case 'JPD':
        default:
            return undefined;
    }
};
const $26b3b3762ac33b52$var$useGetSupportedEdition = (product)=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const projectType = $26b3b3762ac33b52$var$useGetSupportedProjectType(product);
    if (!appEditions) return undefined;
    if (projectType) return (0, $ldyPw.getEditionForProject)(projectType, appEditions);
    return undefined;
};
const $26b3b3762ac33b52$export$38bfb0ec25eaa6b2 = (product)=>{
    const isOrgAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const supportedEdition = $26b3b3762ac33b52$var$useGetSupportedEdition(product);
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [config, fireExperimentExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_free_ai_in_editor_v2_experiment');
    const statsigExperimentValue = config.get('cohort', 'not-enrolled');
    const siteMeetsRequirements = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('jira_free_ai_in_editor_v2_gate') && supportedEdition === (0, $ldyPw.FREE_EDITION) && isOrgAdmin && !(0, $b4PzF.isFedRamp)();
    const experimentValue = siteMeetsRequirements ? statsigExperimentValue : 'not-enrolled';
    const fireExposure = (0, $5uXOq.useCallback)(()=>{
        fireExperimentExposure();
    }, [
        fireExperimentExposure
    ]);
    return {
        siteMeetsRequirements: siteMeetsRequirements,
        experimentValue: experimentValue,
        statsigExperimentValue: statsigExperimentValue,
        fireExperimentExposure: fireExposure
    };
};
const $26b3b3762ac33b52$export$beacfd188d344f95 = (optInStatus, product)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [showUpsellModal, setShowUpsellModal] = (0, $5uXOq.useState)(false);
    const { siteMeetsRequirements: siteMeetsRequirements, statsigExperimentValue: statsigExperimentValue, fireExperimentExposure: fireExperimentExposure } = $26b3b3762ac33b52$export$38bfb0ec25eaa6b2(product);
    const projectType = $26b3b3762ac33b52$var$useGetSupportedProjectType(product);
    const siteMeetsOptInRequirements = siteMeetsRequirements && // optInStatus 'disabled' means they are on control, 'disabled-opt-in' on variation
    optInStatus !== 'enabled';
    const experimentValue = siteMeetsOptInRequirements ? statsigExperimentValue : 'not-enrolled';
    // If the site is not FREE, or not on JSW/JSM, or the user is not billable, they are not enrolled
    const isEnrolledInExperiment = experimentValue !== 'not-enrolled';
    const isExperimentEnabled = isEnrolledInExperiment && experimentValue === 'variation';
    const triggerUpsellFlow = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'triggerUpsellFlow',
            actionSubject: 'aiUpsellInEditorFree'
        }), 'aiUpsellInEditorFreeTrigger', {});
        setShowUpsellModal(true);
        (0, $7xCut.setUpsellButtonWrapperClicked)(true);
    }, [
        createAnalyticsEvent
    ]);
    const UpsellModal = (0, $5uXOq.useMemo)(()=>showUpsellModal && projectType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fmQtB.AsyncAiUpsellInEditorFreeModal), {
            projectType: projectType,
            testId: "platform-react-hooks-use-ai-upsell-in-editor-free.growth-ai-upsell-in-editor-modal",
            onModalClose: ()=>setShowUpsellModal(false)
        }) : null, [
        showUpsellModal,
        projectType
    ]);
    return {
        isEnrolledInExperiment: isEnrolledInExperiment,
        isExperimentEnabled: isExperimentEnabled,
        fireExperimentExposure: fireExperimentExposure,
        triggerUpsellFlow: triggerUpsellFlow,
        UpsellModal: UpsellModal
    };
};
const $26b3b3762ac33b52$export$c44b9b0347b51c37 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const isClicked = (0, $7xCut.getUpsellButtonWrapperClicked)();
    const hasFired = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasFired.current) {
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button viewed', 'aiUpsellInEditorFreeToolbarButton', {});
            hasFired.current = true;
        }
    }, [
        createAnalyticsEvent
    ]);
    return !isClicked ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($26b3b3762ac33b52$var$AIUpsellButtonContainer, {
        "data-testid": "platform-react-hooks-use-ai-upsell-in-editor-free.ai-upsell-button-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($26b3b3762ac33b52$var$AIUpsellButtonInner, null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $26b3b3762ac33b52$var$AIUpsellButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko44q7 _11q7otc5 _ca0qt94y _u5f3t94y _n3tdt94y _19bvt94y _1e0c116y",
            __cmplp.className
        ])
    });
});
const $26b3b3762ac33b52$var$AIUpsellButtonInner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _bfhkvuon",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fmQtB", function(module, exports) {

$parcel$export(module.exports, "AsyncAiUpsellInEditorFreeModal", () => $2c23576aa5eb8dba$export$827041a383456a6a);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2c23576aa5eb8dba$var$LazyAiUpsellInEditorFreeModal = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("d6LGc")), {
    ssr: false,
    moduleId: "./src/packages/growth/ai-upsell-in-editor-free-modal/src/ui/index.tsx"
});
const $2c23576aa5eb8dba$export$827041a383456a6a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "asyncAiUpsellInEditorFreeModal",
        packageName: "jira-growth-ai-upsell-in-editor-free-modal",
        teamName: "growth-tako",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2c23576aa5eb8dba$var$LazyAiUpsellInEditorFreeModal, props));

});
parcelRegister("d6LGc", function(module, exports) {

let $98b0d21b5b5937ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $98b0d21b5b5937ec$var$load("h2MrD"),
    $98b0d21b5b5937ec$var$load("bYT2S"),
    $98b0d21b5b5937ec$var$load("bQd01")
]).then(()=>parcelRequire('b738i'));

});


parcelRegister("7xCut", function(module, exports) {

$parcel$export(module.exports, "getUpsellButtonWrapperClicked", () => $b8d3bd23ca283e73$export$f7d51ee95145148b);
$parcel$export(module.exports, "setUpsellButtonWrapperClicked", () => $b8d3bd23ca283e73$export$b595420beb43f9ce);

var $bSSG7 = parcelRequire("bSSG7");
const $b8d3bd23ca283e73$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)('ai-upsell-in-editor-free');
function $b8d3bd23ca283e73$export$f7d51ee95145148b() {
    return Boolean($b8d3bd23ca283e73$export$c2ed3351cac403d1.get('upsellButtonWrapperClicked') ?? false);
}
function $b8d3bd23ca283e73$export$b595420beb43f9ce(value) {
    $b8d3bd23ca283e73$export$c2ed3351cac403d1.set('upsellButtonWrapperClicked', value);
}

});


parcelRegister("ljlOe", function(module, exports) {

$parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContext", () => $82777381236a0306$export$77aa5ca661b0742c);
$parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContextProvider", () => $82777381236a0306$export$dd0a751f23b19473);

var $5uXOq = parcelRequire("5uXOq");

var $4mO32 = parcelRequire("4mO32");

var $l37qh = parcelRequire("l37qh");

var $b3Gth = parcelRequire("b3Gth");
const $82777381236a0306$export$77aa5ca661b0742c = (0, $l37qh.createUseEntryPointContext)();
const $82777381236a0306$export$dd0a751f23b19473 = ({ children: children })=>{
    const entryPointParams = {};
    const entryPointResult = (0, $4mO32.useEntryPoint)((0, $b3Gth.entryPointPremiumUpgradeModal), entryPointParams);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82777381236a0306$export$77aa5ca661b0742c.Provider, {
        value: entryPointResult
    }, children);
};

});
parcelRegister("l37qh", function(module, exports) {

$parcel$export(module.exports, "createUseEntryPointContext", () => $6e7e19c2d291c94c$export$41bce2223126846b);

var $5uXOq = parcelRequire("5uXOq");
const $6e7e19c2d291c94c$export$41bce2223126846b = ()=>/*#__PURE__*/ (0, $5uXOq.createContext)({
        entryPointActions: {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            cancelPreload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            load () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            preload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            unload () {}
        },
        entryPointReferenceSubject: {
            getValue: ()=>null,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            subscribe: ()=>()=>{}
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stopMetric () {}
    });

});


parcelRegister("44KLa", function(module, exports) {

$parcel$export(module.exports, "OptInModal", () => $bf7c19a18c627984$export$1697f043758ae8d2);
$parcel$export(module.exports, "OptInUpsellModal", () => $bf7c19a18c627984$export$bbf8d259a508a485);

var $5uXOq = parcelRequire("5uXOq");

var $kW74I = parcelRequire("kW74I");

var $7NYq5 = parcelRequire("7NYq5");

var $d4eIn = parcelRequire("d4eIn");

var $7XluA = parcelRequire("7XluA");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $ljlOe = parcelRequire("ljlOe");

var $ejjdc = parcelRequire("ejjdc");
const $bf7c19a18c627984$export$1697f043758ae8d2 = ({ showOptInModal: showOptInModal, onCloseModal: onCloseModal, isOrgAdmin: isOrgAdmin, adminLink: adminLink })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kW74I.default), null, showOptInModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "platform-react-hooks-use-ai-opt-in.ui.modal.ai-modal",
        messageType: "transactional",
        testId: "platform-react-hooks-use-ai-opt-in.ui.ai-modal-test",
        width: "fit-content",
        onClose: onCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4eIn.default), {
        source: "jira-editor",
        product: "jira",
        isOrgAdmin: isOrgAdmin,
        onAdminClose: onCloseModal,
        adminLink: adminLink
    })));
const $bf7c19a18c627984$export$bbf8d259a508a485 = ({ showPremiumTrialModal: showPremiumTrialModal, onCloseModal: onCloseModal })=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, $ljlOe.AIUpsellPremiumTrialEntryPointContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            onClose: ()=>{
                entryPointActions.unload();
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'button',
                    action: 'clicked'
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'closePremiumTrialModalFromIssueAiUpsell');
            }
        }), [
        entryPointActions,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kW74I.default), null, showPremiumTrialModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "platform-react-hooks-use-ai-opt-in.ui.modal.ai-premium-trial-modal",
        messageType: "transactional",
        testId: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-modal-test",
        width: "fit-content",
        onClose: onCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ejjdc.AIOptInPremiumUpsell), {
        onClose: onCloseModal
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-entry-point-container",
        packageName: "platform-react-hooks-use-ai-opt-in",
        runtimeProps: runtimeProps
    }));
};

});
parcelRegister("d4eIn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a094e43d8d2a5f37$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bngFq = parcelRequire("bngFq");

var $bMFGq = parcelRequire("bMFGq");
var $liZ21 = parcelRequire("liZ21");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $6EBIv = parcelRequire("6EBIv");


var $9hXhq = parcelRequire("9hXhq");

var $ffcls = parcelRequire("ffcls");
const $a094e43d8d2a5f37$var$VisibleTextOrgAdminStyles = (0, $2s57o.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $a094e43d8d2a5f37$var$AiOptIn = ({ source: source, product: product, isOrgAdmin: isOrgAdmin, image: image, headerText: headerText, bodyText: bodyText, width: width, testId: testId, onAdminCTA: onAdminCTA, onAdminClose: onAdminClose, adminBodyText: adminBodyText, adminHeaderText: adminHeaderText, adminCTAText: adminCTAText, adminCloseCTAText: adminCloseCTAText, adminLink: adminLink })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const onLearnMoreClicked = (e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogLearnMoreLink',
                attributes: {
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const formatMessageValues = {
        a: (s)=>/*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                href: (0, $576ac17a72e089a4$export$550fac1a4ec3d365),
                target: "_blank",
                onClick: onLearnMoreClicked,
                children: s
            }),
        br: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("br", {})
    };
    const defaultHeader = formatMessage((0, $9hXhq.messages).aiOptInDialogHeaderText);
    const header = headerText ?? defaultHeader;
    const body = bodyText ?? formatMessage((0, $9hXhq.messages).aiOptInDialogBodyText, formatMessageValues);
    const orgAdminBody = adminBodyText ?? formatMessage((0, $9hXhq.messages).aiOptInDialogAdminBodyText, formatMessageValues);
    const orgAdminHeader = adminHeaderText ?? defaultHeader;
    (0, $5uXOq.useEffect)(()=>{
        const preloadImages = (paths)=>{
            paths.forEach((path)=>{
                const img = new Image();
                img.src = path;
            });
        };
        preloadImages([
            (0, (/*@__PURE__*/$parcel$interopDefault($6EBIv)))
        ]);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'aiGlobalOptInDialog',
                attributes: {
                    source: source,
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source,
        product,
        isOrgAdmin
    ]);
    const onCloseClicked = (e)=>{
        e.stopPropagation();
        onAdminClose?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCloseButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const onCTAClicked = (e)=>{
        e.stopPropagation();
        onAdminCTA?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCTAButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ffcls.OptInBackgroundBorder), {
        width: width,
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ffcls.OptInContainer), {
            children: [
                image ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ffcls.ImageWrapper), {
                    children: image
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ffcls.ImageWrapper), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($6EBIv))),
                        height: "96px",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ffcls.ContentContainer), {
                    children: [
                        isOrgAdmin && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                            xcss: $a094e43d8d2a5f37$var$VisibleTextOrgAdminStyles,
                            children: formatMessage((0, $9hXhq.messages).aiOptInAdminOnlyVisible)
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ffcls.HeaderWrapper), {
                            children: isOrgAdmin ? orgAdminHeader : header
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ffcls.BodyWrapper), {
                            "data-testid": "dialog-body-text",
                            children: isOrgAdmin ? orgAdminBody : body
                        }),
                        isOrgAdmin && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ffcls.ButtonContainer), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMFGq.default), {
                                    appearance: "subtle",
                                    onClick: onCloseClicked,
                                    testId: "admin-close-button",
                                    children: adminCloseCTAText ?? formatMessage((0, $9hXhq.messages).aiOptInDialogAdminMaybeLaterButtonText)
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $liZ21.default), {
                                    appearance: "primary",
                                    onClick: onCTAClicked,
                                    href: adminLink ?? (0, $576ac17a72e089a4$export$bae9a077d7ed5dfe),
                                    target: "_blank",
                                    testId: "admin-cta-button",
                                    children: adminCTAText ?? formatMessage((0, $9hXhq.messages).aiOptInDialogAdminGetStartedButtonText)
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $a094e43d8d2a5f37$export$2e2bcd8739ae039 = $a094e43d8d2a5f37$var$AiOptIn;

});
parcelRegister("6EBIv", function(module, exports) {
module.exports = new URL("global-opt-in-default-image-banner.8c1c680b.svg", import.meta.url).toString();

});

const $576ac17a72e089a4$export$550fac1a4ec3d365 = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $576ac17a72e089a4$export$bae9a077d7ed5dfe = 'http://admin.atlassian.com/';

parcelRegister("9hXhq", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ea242358e4c278c9$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $ea242358e4c278c9$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    /**
	 * Messages for the AI Global Opt-in component
	 */ aiOptInDialogHeaderText: {
        id: 'ai-opt-in.dialog.header.text',
        defaultMessage: 'Work smarter, not harder',
        description: 'Header text for AI Opt In Dialog'
    },
    aiOptInDialogBodyText: {
        id: 'ai-opt-in.dialog.body.text',
        defaultMessage: `Get up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration.`,
        description: 'Body text for AI Opt In Dialog'
    },
    aiOptInDialogLearnMoreLinkText: {
        id: 'ai-opt-in.dialog.learn-more.link.text',
        defaultMessage: 'Learn more about Atlassian Intelligence',
        description: 'Learn more link text for AI Opt In Dialog'
    },
    aiOptInDialogAdminBodyText: {
        id: 'ai-opt-in.dialog.admin.body.text',
        defaultMessage: 'Get your team up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration.',
        description: 'Body text for Admin version of AI Opt In Dialog'
    },
    aiOptInDialogAdminMaybeLaterButtonText: {
        id: 'ai-opt-in.dialog.admin.maybe-later.button.text',
        defaultMessage: 'Maybe later',
        description: 'Admin maybe later button text'
    },
    aiOptInDialogAdminGetStartedButtonText: {
        id: 'ai-opt-in.dialog.admin.get-started.button.text',
        defaultMessage: 'Get started',
        description: 'Admin get started button text'
    },
    aiOptInBannerBodyText: {
        id: 'ai-opt-in.banner.body.text',
        defaultMessage: "Work smarter, not harder. Express your interest in Atlassian Intelligence so your admin knows you\u2019d like them to activate it.",
        description: 'Body text for Banner version of AI Opt In Dialog'
    },
    aiOptInBannerLearnMoreText: {
        id: 'ai-opt-in.banner.learn.more.text',
        defaultMessage: 'Learn more',
        description: 'Learn more text for Banner cta of AI Opt In Dialog'
    },
    aiOptInAdminBannerBodyText: {
        id: 'ai-opt-in.banner.admin.body.text',
        defaultMessage: 'Get everyone up to speed quickly and consume information with ease. Turn on <a>Atlassian Intelligence</a> features for your users from Atlassian Administration.',
        description: 'Body text for Admin version of the Banner Ai Opt In'
    },
    aiOptInAdminOnlyVisible: {
        id: 'ai-opt-in.admin.only.visible.text',
        defaultMessage: 'This message is only visible to org admins.',
        description: 'Text message to let org admins know that the content is only visible to them.'
    }
});

});

parcelRegister("ffcls", function(module, exports) {

$parcel$export(module.exports, "OptInBackgroundBorder", () => $b27fe0ab1059d485$export$24c280970213bb11);
$parcel$export(module.exports, "OptInContainer", () => $b27fe0ab1059d485$export$a0fab83bea8ccf2e);
$parcel$export(module.exports, "ImageWrapper", () => $b27fe0ab1059d485$export$75f07c36086c2c81);
$parcel$export(module.exports, "ContentContainer", () => $b27fe0ab1059d485$export$9d2b4227a95687cc);
$parcel$export(module.exports, "HeaderWrapper", () => $b27fe0ab1059d485$export$960a49cc3d27a090);
$parcel$export(module.exports, "BodyWrapper", () => $b27fe0ab1059d485$export$14966827497f4695);
$parcel$export(module.exports, "ButtonContainer", () => $b27fe0ab1059d485$export$eddf54ea3db8d0f0);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $b27fe0ab1059d485$export$24c280970213bb11 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $lD23V.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _2rko14y2 _11q71lxv _16qs1o46 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _kqswh2mm",
            __cmplp.width ? "_1bsb1efm" : "_1bsbkbql",
            __cmplp.className
        ])
    });
});
const $b27fe0ab1059d485$export$a0fab83bea8ccf2e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1e0c1txw _2lx21bp4 _bfhk1bhr",
            __cmplp.className
        ])
    });
});
const $b27fe0ab1059d485$export$75f07c36086c2c81 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1k7a _1e0c1txw _1biu1k7a _1jpx1dfr _mezj1osq",
            __cmplp.className
        ])
    });
});
const $b27fe0ab1059d485$export$9d2b4227a95687cc = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _2lx21bp4 _1wpz1fhb _4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $b27fe0ab1059d485$export$960a49cc3d27a090 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8nbxd",
            __cmplp.className
        ])
    });
});
const $b27fe0ab1059d485$export$14966827497f4695 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c82smr",
            __cmplp.className
        ])
    });
});
const $b27fe0ab1059d485$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _1bsb1osq _19pku2gc _1bahesu3",
            __cmplp.className
        ])
    });
});

});


parcelRegister("ejjdc", function(module, exports) {

$parcel$export(module.exports, "AIOptInPremiumUpsell", () => $678322372bbc5cca$export$54e4ba490d2c6bb5);

var $5uXOq = parcelRequire("5uXOq");

var $1Seuh = parcelRequire("1Seuh");

var $bWfiu = parcelRequire("bWfiu");

var $ieYuw = parcelRequire("ieYuw");

var $c3ZaD = parcelRequire("c3ZaD");
var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");
var $bEIgH = parcelRequire("bEIgH");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $gEusR = parcelRequire("gEusR");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $2ogyS = parcelRequire("2ogyS");

var $iau6N = parcelRequire("iau6N");
const $678322372bbc5cca$export$54e4ba490d2c6bb5 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'screen',
            action: 'viewed'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'IssueAiUpsellDialog');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $678322372bbc5cca$var$containerBorderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        alignBlock: "stretch",
        xcss: $678322372bbc5cca$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        alignInline: "end",
        grow: "fill",
        xcss: $678322372bbc5cca$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
        appearance: "subtle",
        onClick: onClose,
        label: formatMessage((0, $2ogyS.messages).closeModal),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ieYuw)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c3ZaD.default), {
        all: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEusR.default), {
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bEIgH.default), {
        alignInline: "stretch",
        space: "space.200",
        xcss: $678322372bbc5cca$var$textContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bWfiu.default), {
        size: "medium",
        as: "h2"
    }, formatMessage((0, $2ogyS.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        as: "p"
    }, formatMessage((0, $2ogyS.messages).body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iau6N.StartPremiumTrialButton), {
        onCloseParent: onClose
    })))));
};
const $678322372bbc5cca$var$containerBorderStyles = (0, $2s57o.xcss)({
    overflow: 'hidden',
    boxShadow: 'elevation.shadow.overlay',
    borderRadius: 'border.radius',
    width: '438px',
    position: 'relative',
    padding: 'space.025',
    background: `linear-gradient(
      112.4deg,
      ${"var(--ds-background-accent-blue-subtle, #579DFF)"} 0%,
      ${"var(--ds-background-accent-purple-subtle, #9F8FEF)"} 100%
    )`
});
const $678322372bbc5cca$var$containerStyles = (0, $2s57o.xcss)({
    borderRadius: 'border.radius',
    backgroundColor: 'elevation.surface.overlay',
    overflow: 'hidden'
});
const $678322372bbc5cca$var$headerStyles = (0, $2s57o.xcss)({
    position: 'absolute',
    padding: 'space.075',
    right: 'space.025'
});
const $678322372bbc5cca$var$textContainerStyles = (0, $2s57o.xcss)({
    padding: 'space.300'
});

});
parcelRegister("ieYuw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e514a79fafb6c57d068e94d2350d1008>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d4787521ed6b60ff$var$_react = $d4787521ed6b60ff$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d4787521ed6b60ff$var$_close = $d4787521ed6b60ff$var$_interopRequireDefault((parcelRequire("eh9vz")));

var $d4787521ed6b60ff$var$_close2 = $d4787521ed6b60ff$var$_interopRequireDefault((parcelRequire("gKTT6")));
function $d4787521ed6b60ff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d4787521ed6b60ff$var$CloseIcon = (props)=>/*#__PURE__*/ $d4787521ed6b60ff$var$_react.default.createElement($d4787521ed6b60ff$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $d4787521ed6b60ff$var$_close2.default
    }, props));
$d4787521ed6b60ff$var$CloseIcon.Name = 'CloseIconMigration';
var $d4787521ed6b60ff$var$_default = module.exports.default = $d4787521ed6b60ff$var$CloseIcon;

});

parcelRegister("gEusR", function(module, exports) {

$parcel$export(module.exports, "default", () => $daf0e2023e742d66$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $8nOP6 = parcelRequire("8nOP6");

var $4aPxh = parcelRequire("4aPxh");
const $daf0e2023e742d66$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($4aPxh)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($8nOP6))
});
var $daf0e2023e742d66$export$2e2bcd8739ae039 = $daf0e2023e742d66$var$Illustration;
// for advanced use only
const $daf0e2023e742d66$export$a179c88182cb9d56 = [
    0,
    0,
    438,
    96
];

});
parcelRegister("8nOP6", function(module, exports) {
module.exports = new URL("ai-chat-loading-promoted-darkmode.f2ea2011.svg", import.meta.url).toString();

});

parcelRegister("4aPxh", function(module, exports) {
module.exports = new URL("ai-chat-loading-promoted.9a9a0213.svg", import.meta.url).toString();

});


parcelRegister("2ogyS", function(module, exports) {

$parcel$export(module.exports, "messages", () => $703e8ca8733c69fc$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $703e8ca8733c69fc$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.title",
        "defaultMessage": "Write better, work faster with Atlassian Intelligence"
    },
    body: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.body",
        "defaultMessage": "Use AI to brainstorm, summarize, change tone, edit and more, with Jira Premium."
    },
    closeModal: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.close-modal",
        "defaultMessage": "Close Modal"
    },
    tryItFreeButton: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.try-it-free-button",
        "defaultMessage": "Try it free"
    }
});

});

parcelRegister("iau6N", function(module, exports) {

$parcel$export(module.exports, "StartPremiumTrialButton", () => $d916fa2fae12e75a$export$a2651a739f515dd4);

var $5uXOq = parcelRequire("5uXOq");

var $1nSOt = parcelRequire("1nSOt");

var $hWGQo = parcelRequire("hWGQo");

var $47gW9 = parcelRequire("47gW9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $ljlOe = parcelRequire("ljlOe");

var $2ogyS = parcelRequire("2ogyS");
const $d916fa2fae12e75a$export$a2651a739f515dd4 = ({ onCloseParent: onCloseParent })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, $ljlOe.AIUpsellPremiumTrialEntryPointContext));
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const onClickAnalytics = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openPremiumTrialModalFromIssueAiUpsell');
    }, [
        createAnalyticsEvent
    ]);
    const onClick = ()=>{
        // Nb. premium trial modal open is handled by entry point via ref
        onCloseParent && onCloseParent();
        onClickAnalytics();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1nSOt.default), {
        onClick: onClick,
        ref: triggerRef,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWGQo))), {
            LEGACY_size: "small",
            label: "",
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: "var(--ds-text-inverse, #FFFFFF)",
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    }, formatMessage((0, $2ogyS.messages).tryItFreeButton));
};

});




parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $eyWK5 = parcelRequire("eyWK5");

var $307qF = parcelRequire("307qF");

var $32M8E = parcelRequire("32M8E");

var $iLrcb = parcelRequire("iLrcb");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $iLrcb.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eyWK5.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $307qF.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $32M8E.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("307qF", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $60b371e0a217cca9$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $60b371e0a217cca9$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $60b371e0a217cca9$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $aatTc = parcelRequire("aatTc");

var $32M8E = parcelRequire("32M8E");

var $lAOer = parcelRequire("lAOer");
function $60b371e0a217cca9$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $60b371e0a217cca9$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $aatTc.default));
    const interactionId = (0, $32M8E.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $lAOer.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $60b371e0a217cca9$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $60b371e0a217cca9$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $32M8E.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $lAOer.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $60b371e0a217cca9$export$f02972da195a43bb(marks, timingsConfig);
        (0, $lAOer.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $aatTc = parcelRequire("aatTc");

var $bl6ih = parcelRequire("bl6ih");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $bl6ih.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $aatTc.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $aatTc = parcelRequire("aatTc");

var $iLrcb = parcelRequire("iLrcb");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $iLrcb.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $iLrcb.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $aatTc.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $32M8E = parcelRequire("32M8E");

var $lAOer = parcelRequire("lAOer");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $32M8E.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $lAOer.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $32M8E = parcelRequire("32M8E");

var $lAOer = parcelRequire("lAOer");

var $iLrcb = parcelRequire("iLrcb");
var $kYARE = parcelRequire("kYARE");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $32M8E.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $iLrcb.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $kYARE.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $lAOer.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $32M8E = parcelRequire("32M8E");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $32M8E.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("htI2Q", function(module, exports) {

$parcel$export(module.exports, "useGettingStartedPageStateActions", () => $33645e86b9772f1d$export$8d2572f02ec0aa4c);
$parcel$export(module.exports, "useIsFirstProjectITSM", () => $33645e86b9772f1d$export$852fe39748ba826d);
$parcel$export(module.exports, "useGetNpleDisabledProjectProperty", () => $33645e86b9772f1d$export$24659fa3abfd0100);
$parcel$export(module.exports, "useIsGettingStartedPageEnabled", () => $33645e86b9772f1d$export$a58e406dc976509e);

var $5uXOq = parcelRequire("5uXOq");

var $58GFP = parcelRequire("58GFP");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $bngFq = parcelRequire("bngFq");

var $O4MMs = parcelRequire("O4MMs");

var $dAfqg = parcelRequire("dAfqg");

var $324W5 = parcelRequire("324W5");

var $lbaDt = parcelRequire("lbaDt");

var $9OXo1 = parcelRequire("9OXo1");

var $3HwlS = parcelRequire("3HwlS");

var $5DnNI = parcelRequire("5DnNI");

var $jULiL = parcelRequire("jULiL");

var $kTQYw = parcelRequire("kTQYw");
const $33645e86b9772f1d$export$8d2572f02ec0aa4c = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const baseUrl = window.location.origin;
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { data: data } = (0, $dAfqg.useProjectContext)() || {};
    const { projectId: projectId } = data || {};
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const projectIdString = projectId ? projectId.toString() : '';
    return (0, $5uXOq.useMemo)(()=>{
        const actionProps = {
            baseUrl: baseUrl,
            cloudId: cloudId,
            projectId: projectIdString,
            createAnalyticsEvent: createAnalyticsEvent
        };
        return [
            {
                updateLandingPageStateProperties: (0, $kTQYw.updateLandingPageStateProperties)(actionProps),
                getLandingPageState: (0, $kTQYw.getLandingPageState)(actionProps),
                initialiseLandingPageState: (0, $kTQYw.initialiseLandingPageState)(actionProps)
            }
        ];
    }, [
        baseUrl,
        cloudId,
        createAnalyticsEvent,
        projectIdString
    ]);
};
const $33645e86b9772f1d$var$useIsFirstProjectITSMOld = (inputProjectId)=>{
    const { data: containerContext, loading: loading } = (0, $dAfqg.useProjectContext)();
    const currentProjectId = inputProjectId || containerContext?.projectId;
    const [isFirstProject, setIsFirstProject] = (0, $5uXOq.useState)(false);
    const [isFirstProjectItsm, setIsFirstProjectItsm] = (0, $5uXOq.useState)(false);
    const [isStateLoading, setStateLoading] = (0, $5uXOq.useState)(true);
    const { error: isFirstProjectError, firstProject: firstProject } = (0, $jULiL.useFirstProjectDetails)();
    (0, $5uXOq.useEffect)(()=>{
        if (currentProjectId && !isFirstProjectError && firstProject) {
            setIsFirstProject(firstProject.projectId === `${currentProjectId}`);
            setIsFirstProjectItsm(firstProject.projectTemplateKey === (0, $58GFP.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY));
            setStateLoading(false);
        } else if (isFirstProjectError) setStateLoading(false);
    }, [
        currentProjectId,
        firstProject,
        isFirstProjectError,
        setStateLoading
    ]);
    const memoizedValue = (0, $5uXOq.useMemo)(()=>({
            isLoading: loading || isStateLoading,
            isFirstProject: isFirstProject,
            isFirstProjectItsm: isFirstProjectItsm,
            isFirstProjectError: isFirstProjectError
        }), [
        isFirstProject,
        isFirstProjectItsm,
        isFirstProjectError,
        loading,
        isStateLoading
    ]);
    return memoizedValue;
};
const $33645e86b9772f1d$var$useIsFirstProjectITSMNew = (inputProjectId)=>{
    const { data: containerContext, loading: loading } = (0, $dAfqg.useProjectContext)();
    const currentProjectId = inputProjectId || containerContext?.projectId;
    const { data: { error: isFirstProjectError, firstProject: firstProject }, loading: isFirstProjectDetailsLoading } = (0, $jULiL.useFirstProjectDetailsNew)();
    const memoizedValue = (0, $5uXOq.useMemo)(()=>({
            isLoading: loading || isFirstProjectDetailsLoading,
            isFirstProject: firstProject?.projectId === `${currentProjectId}`,
            isFirstProjectItsm: firstProject?.projectTemplateKey === (0, $58GFP.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY),
            isFirstProjectError: isFirstProjectError
        }), [
        loading,
        firstProject,
        isFirstProjectDetailsLoading,
        isFirstProjectError,
        currentProjectId
    ]);
    return memoizedValue;
};
const $33645e86b9772f1d$export$852fe39748ba826d = (inputProjectId)=>{
    return (0, $3HwlS.getWillShowNav4)() && (0, $6s1PB.expVal)('hot-113350-ssr-jsm-project-menu-fix', 'isEnabled', false) ? $33645e86b9772f1d$var$useIsFirstProjectITSMNew(inputProjectId) : $33645e86b9772f1d$var$useIsFirstProjectITSMOld(inputProjectId);
};
const $33645e86b9772f1d$var$useInitialProjectTemplateProjectPropertyKeyWithFF = (projectId, customContext)=>{
    if ((0, $4R6GH.fg)('ssr_nav4_queues_sidebar')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: data, loading: loading } = (0, $324W5.useResourceWithCustomRouterContext)((0, $lbaDt.requiredFrontendProperties), customContext);
        if (!data) return [
            null,
            loading
        ];
        return [
            data[0, $58GFP.INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY],
            loading
        ];
    }
    const { [(0, $58GFP.INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY)]: initialProjectTemplateOld } = // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $O4MMs.useProjectProperties)([
        (0, $58GFP.INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY)
    ], projectId);
    const isLoadingOld = initialProjectTemplateOld === undefined;
    return [
        initialProjectTemplateOld,
        isLoadingOld
    ];
};
const $33645e86b9772f1d$export$da3441212b1c36fb = (projectId, customContext)=>{
    const [initialProjectTemplate, isLoading] = $33645e86b9772f1d$var$useInitialProjectTemplateProjectPropertyKeyWithFF(projectId, customContext);
    const { isLoading: isFirstProjectITSMLoading, isFirstProject: isFirstProject, isFirstProjectItsm: isFirstProjectItsm } = $33645e86b9772f1d$export$852fe39748ba826d(projectId);
    const excludedProjectTemplates = isFirstProject && isFirstProjectItsm && (0, $6s1PB.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation') ? (0, $5DnNI.GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_ITSM) : (0, $5DnNI.GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_PROD);
    return (0, $5uXOq.useMemo)(()=>[
            isLoading || isFirstProjectITSMLoading,
            excludedProjectTemplates.includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            initialProjectTemplate)
        ], [
        excludedProjectTemplates,
        initialProjectTemplate,
        isFirstProjectITSMLoading,
        isLoading
    ]);
};
const $33645e86b9772f1d$export$24659fa3abfd0100 = (projectKeyOrId)=>{
    const [npleDisabled, setNpleDisabled] = (0, $5uXOq.useState)(projectKeyOrId ? undefined : true);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
    const getNpleDisabledProjectProperty = (0, $5uXOq.useCallback)(async ()=>{
        try {
            const response = await (0, $eusud.performGetRequest)(`/rest/api/3/project/${projectKeyOrId}/properties/${(0, $5DnNI.DISABLE_NPLE_PROJECT_PROJECT_KEY)}`);
            setNpleDisabled(response.value);
            setIsLoading(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setNpleDisabled(error.statusCode !== 404);
            setIsLoading(false);
            error.statusCode !== 404 && (0, $jcw0u.default)({
                meta: {
                    id: 'getDisableNpleProjectProperty',
                    packageName: (0, $5DnNI.PACKAGE_NAME),
                    teamName: (0, $5DnNI.PACKAGE_TEAM_NAME)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        projectKeyOrId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (projectKeyOrId) getNpleDisabledProjectProperty();
    }, [
        getNpleDisabledProjectProperty,
        projectKeyOrId
    ]);
    return [
        isLoading,
        npleDisabled
    ];
};
const $33645e86b9772f1d$var$useGetNpleDisabledProjectPropertyWithFF = (projectKey, customContext)=>{
    const [isGetNpleDisabledLoadingOld, npleDisabledOld] = $33645e86b9772f1d$export$24659fa3abfd0100(// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('gsp_production_rollout') && !(0, $4R6GH.fg)('ssr_nav4_queues_sidebar') ? projectKey : undefined);
    const { data: requiredProjectPropertiesDataNew, loading: isGetNpleDisabledLoadingNew } = (0, $324W5.useResourceWithCustomRouterContext)((0, $lbaDt.requiredProjectProperties), customContext);
    const npleDisabledNew = requiredProjectPropertiesDataNew ? requiredProjectPropertiesDataNew[0, $5DnNI.DISABLE_NPLE_PROJECT_PROJECT_KEY] : false;
    const npleDisabled = (0, $4R6GH.fg)('ssr_nav4_queues_sidebar') ? npleDisabledNew : npleDisabledOld;
    const isGetNpleDisabledLoading = (0, $4R6GH.fg)('ssr_nav4_queues_sidebar') ? isGetNpleDisabledLoadingNew : isGetNpleDisabledLoadingOld;
    return [
        npleDisabled,
        isGetNpleDisabledLoading
    ];
};
const $33645e86b9772f1d$export$a58e406dc976509e = (customContext)=>{
    const { data: data, loading: projectContextLoading } = (0, $dAfqg.useProjectContext)(customContext) || {};
    const { simplified: isSimplified = false, isProjectAdmin: isProjectAdmin, projectKey: projectKey, projectId: projectId } = data || {};
    const [isLoading, isExcludedProject] = $33645e86b9772f1d$export$da3441212b1c36fb(projectId?.toString(), customContext);
    const [npleDisabled, isGetNpleDisabledLoading] = $33645e86b9772f1d$var$useGetNpleDisabledProjectPropertyWithFF(projectKey, customContext);
    const isDataLoading = isLoading || projectContextLoading || isGetNpleDisabledLoading && (0, $4R6GH.fg)('gsp_production_rollout');
    const { appPermissions: appPermissions } = (0, $9OXo1.useTenantContext)() || {};
    const hasJSMAccess = (0, $4R6GH.fg)('add-product-permission-check-for-nple') ? appPermissions?.hasServiceDeskAccess : true;
    return (0, $5uXOq.useMemo)(()=>[
            isDataLoading,
            !isDataLoading ? hasJSMAccess && isProjectAdmin && !isSimplified && !isExcludedProject && !npleDisabled && (0, $4R6GH.fg)('gsp_production_rollout') : false
        ], [
        isDataLoading,
        isProjectAdmin,
        isSimplified,
        isExcludedProject,
        npleDisabled,
        hasJSMAccess
    ]);
};

});
parcelRegister("5DnNI", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $52e659885063405d$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $52e659885063405d$export$2b3151a089bc8780);
$parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_REQUEST_CHANNELS_CUSTOMISED", () => $52e659885063405d$export$190fb6b68393ab0a);
$parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_REQUEST_REQUEST_TYPES_REVIEWED", () => $52e659885063405d$export$b51e545ada86528a);
$parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_REQUEST_QUEUE_CUSTOMISED", () => $52e659885063405d$export$2527ae3f75e929d);
$parcel$export(module.exports, "ERROR_CODE_NOT_FOUND", () => $52e659885063405d$export$7741797ac345bc17);
$parcel$export(module.exports, "CONTACT_SUPPORT_URL", () => $52e659885063405d$export$2c16bd1d8b68b11f);
$parcel$export(module.exports, "JSM_DOCUMENTATION_URL", () => $52e659885063405d$export$3b0c21ad7d48c17f);
$parcel$export(module.exports, "ASK_COMMUNITY_URL", () => $52e659885063405d$export$eb3a822ca5964b4c);
$parcel$export(module.exports, "SAMPLE_SPACE_URL", () => $52e659885063405d$export$7d64ff3c41d97984);
$parcel$export(module.exports, "ITSM_OPERATIONS_OVERVIEW_DOCUMENTATION_URL", () => $52e659885063405d$export$9485f2fbd78b0ffb);
$parcel$export(module.exports, "GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_PROD", () => $52e659885063405d$export$eb8426badfb143b);
$parcel$export(module.exports, "GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_ITSM", () => $52e659885063405d$export$6e4b80733f1b287d);
$parcel$export(module.exports, "JSM_EXCLUDED_TEMPLATES_FOR_NPLE", () => $52e659885063405d$export$849d996b61162ae5);
$parcel$export(module.exports, "REQUEST_CHANNEL_PORTAL", () => $52e659885063405d$export$84bc97b21fdd244a);
$parcel$export(module.exports, "REQUEST_CHANNEL_CHAT", () => $52e659885063405d$export$a45136678da730c);
$parcel$export(module.exports, "REQUEST_CHANNEL_EMAIL", () => $52e659885063405d$export$4585842137473138);
$parcel$export(module.exports, "REQUEST_TYPES_MAX_ELEMENTS", () => $52e659885063405d$export$4ff5ead961dddcb6);
$parcel$export(module.exports, "ManageQueuesArticleId", () => $52e659885063405d$export$337d9a01cb6ca6b9);
$parcel$export(module.exports, "RequestChannelsArticleId", () => $52e659885063405d$export$14ea17a7011e8003);
$parcel$export(module.exports, "RequestTypesArticleId", () => $52e659885063405d$export$bf7175403ae935b4);
$parcel$export(module.exports, "RequestQueuesArticleId", () => $52e659885063405d$export$f5f272385d51d0c);
$parcel$export(module.exports, "ViewIssueArticleId", () => $52e659885063405d$export$3a62b051817d4794);
$parcel$export(module.exports, "REQUEST_CHANNELS", () => $52e659885063405d$export$66b0ce7a4d805ff);
$parcel$export(module.exports, "REQUEST_TYPES", () => $52e659885063405d$export$b1183955728be615);
$parcel$export(module.exports, "NEW_LANDING_PAGE_EXPERIENCE_PROD", () => $52e659885063405d$export$56dfbf0bd0f6a594);
$parcel$export(module.exports, "NEW_LANDING_PAGE_EXPERIENCE_PROD_ITSM", () => $52e659885063405d$export$7153e91b542b7f0a);
$parcel$export(module.exports, "NEW_LANDING_PAGE_EXPERIENCE_PROD_ITOPS", () => $52e659885063405d$export$2dce1bec124ad97d);
$parcel$export(module.exports, "DEMO_ISSUE_LABEL", () => $52e659885063405d$export$fe4edbd608405ae2);
$parcel$export(module.exports, "DEMO_ISSUE_ERROR_FLAG_ID", () => $52e659885063405d$export$b2f56b9b16e7a5d8);
$parcel$export(module.exports, "DISABLE_NPLE_PROJECT_PROJECT_KEY", () => $52e659885063405d$export$8b55ba9520951f74);
$parcel$export(module.exports, "DISABLE_NPLE_ERROR_FLAG_ID", () => $52e659885063405d$export$8ce85ec44321d12);
$parcel$export(module.exports, "DISABLE_NPLE_SUCCESS_FLAG_ID", () => $52e659885063405d$export$2b5c9784d8cd5f0);
$parcel$export(module.exports, "INCIDENTS", () => $52e659885063405d$export$a50b49a533b5f7bc);
$parcel$export(module.exports, "CHANGES", () => $52e659885063405d$export$8598196f74460271);
$parcel$export(module.exports, "ALERTS", () => $52e659885063405d$export$bc57e9dea1fac017);
$parcel$export(module.exports, "CREATE_A_TEAM", () => $52e659885063405d$export$6ee8a54637c51e7d);
$parcel$export(module.exports, "SELECT_A_TEAM", () => $52e659885063405d$export$c6fd9f8cba84eaaf);
$parcel$export(module.exports, "MUTLI_OPS_TEAMS_OPTIIMISE_OPERATIONS", () => $52e659885063405d$export$c8c3ea29683272dd);
$parcel$export(module.exports, "SINGLE_OPS_TEAMS_OPTIMISE_OPERATIONS", () => $52e659885063405d$export$e3695100db882d1d);
$parcel$export(module.exports, "INTEGRATIONS", () => $52e659885063405d$export$d49fe9e32eb9b9c3);
$parcel$export(module.exports, "ONCALL", () => $52e659885063405d$export$4a57a4a93a9f526);

var $58GFP = parcelRequire("58GFP");
const $52e659885063405d$export$b8b9d90f9e5bd72b = 'jiraServicedeskGettingStartedPage';
const $52e659885063405d$export$2b3151a089bc8780 = 'itops-mithril';
const $52e659885063405d$export$190fb6b68393ab0a = 'servicedesk-getting-started-page-request-channels-customised';
const $52e659885063405d$export$b51e545ada86528a = 'servicedesk-getting-started-page-request-types-reviewed';
const $52e659885063405d$export$2527ae3f75e929d = 'servicedesk-getting-started-page-queue-customised';
const $52e659885063405d$var$IT_SERVICE_MANAGEMENT_KEY = 'jsm.it-service-management';
const $52e659885063405d$var$NEW_IT_SERVICE_MANAGEMENT_KEY = 'jsm.it-service-management-advanced';
const $52e659885063405d$export$7741797ac345bc17 = 404;
const $52e659885063405d$export$2c16bd1d8b68b11f = 'https://support.atlassian.com/contact/#/';
const $52e659885063405d$export$3b0c21ad7d48c17f = 'https://support.atlassian.com/jira-service-management-cloud/docs/get-started-with-jira-service-management/';
const $52e659885063405d$export$eb3a822ca5964b4c = 'https://community.atlassian.com/t5/Jira-Service-Management/Welcome-to-Jira-Service-Management/m-p/2690403?utm_source=community&utm_medium=inapp&utm_campaign=P:jira-service-management%7CO:community%7CC:community%7CW:jsmlp%7CH:05/07/2024%7CI:onboarding%7C';
const $52e659885063405d$export$7d64ff3c41d97984 = '/jira/servicedesk/itsm-sample-space';
const $52e659885063405d$export$9485f2fbd78b0ffb = 'https://support.atlassian.com/jira-service-management-cloud/docs/discover-alerting-and-on-call/';
const $52e659885063405d$var$UNKNOWN_PROJECT_TEMPLATE_KEY = '';
const $52e659885063405d$export$eb8426badfb143b = [
    (0, $58GFP.IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY),
    (0, $58GFP.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY),
    (0, $58GFP.JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY),
    $52e659885063405d$var$UNKNOWN_PROJECT_TEMPLATE_KEY
];
const $52e659885063405d$export$6e4b80733f1b287d = [
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY),
    $52e659885063405d$var$UNKNOWN_PROJECT_TEMPLATE_KEY
];
const $52e659885063405d$export$849d996b61162ae5 = [
    $52e659885063405d$var$IT_SERVICE_MANAGEMENT_KEY,
    $52e659885063405d$var$NEW_IT_SERVICE_MANAGEMENT_KEY,
    (0, $58GFP.IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY),
    (0, $58GFP.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY),
    (0, $58GFP.BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY),
    $52e659885063405d$var$UNKNOWN_PROJECT_TEMPLATE_KEY
];
const $52e659885063405d$export$84bc97b21fdd244a = 'Portal';
const $52e659885063405d$export$a45136678da730c = 'Chat';
const $52e659885063405d$export$4585842137473138 = 'Email';
const $52e659885063405d$export$4ff5ead961dddcb6 = 4;
const $52e659885063405d$export$337d9a01cb6ca6b9 = '5b7BuVaVJqmbyCZ2mbMYHD';
const $52e659885063405d$export$14ea17a7011e8003 = '3v4bqtuzeA4dOJq6A4yhiM';
const $52e659885063405d$export$bf7175403ae935b4 = 'eYQImfQnsXgIvrECKaQTF';
const $52e659885063405d$export$f5f272385d51d0c = 'bfeWmUW9tPB6MqlPnOXgF';
const $52e659885063405d$export$3a62b051817d4794 = '102lbF25oEeqn7GG1rXPUA';
const $52e659885063405d$export$66b0ce7a4d805ff = 'RequestChannel';
const $52e659885063405d$export$b1183955728be615 = 'RequestTypes';
const $52e659885063405d$export$5b2e9a43da487c8d = 'InviteTeam';
const $52e659885063405d$export$82cf56f84f36683f = 'ManageQueues';
const $52e659885063405d$export$56dfbf0bd0f6a594 = 'newLandingPageExperienceProd';
const $52e659885063405d$export$7153e91b542b7f0a = 'newLandingPageExperienceProdITSM';
const $52e659885063405d$export$2dce1bec124ad97d = 'newLandingPageExperienceProdITOPS';
const $52e659885063405d$export$fe4edbd608405ae2 = 'onboarding-learn-by-doing-demo-issue';
const $52e659885063405d$export$b2f56b9b16e7a5d8 = 'onboarding-sample-issue-error';
const $52e659885063405d$export$8b55ba9520951f74 = 'npleDisabled';
const $52e659885063405d$export$8ce85ec44321d12 = 'disable-nple-error';
const $52e659885063405d$export$2b5c9784d8cd5f0 = 'disable-nple-success';
const $52e659885063405d$export$a50b49a533b5f7bc = 'incidents';
const $52e659885063405d$export$8598196f74460271 = 'changes';
const $52e659885063405d$export$bc57e9dea1fac017 = 'alerts';
const $52e659885063405d$export$6ee8a54637c51e7d = 'createATeam';
const $52e659885063405d$export$c6fd9f8cba84eaaf = 'selectATeam';
const $52e659885063405d$export$c8c3ea29683272dd = 'optimiseOperationsMultiOps';
const $52e659885063405d$export$e3695100db882d1d = 'optimiseOperationsSingleOps';
const $52e659885063405d$export$d49fe9e32eb9b9c3 = 'integrations';
const $52e659885063405d$export$4a57a4a93a9f526 = 'oncall';

});

parcelRegister("jULiL", function(module, exports) {

$parcel$export(module.exports, "useFirstProjectDetails", () => $2151d2bb13849eac$export$a2dd21ca7232bc34);
$parcel$export(module.exports, "useFirstProjectDetailsNew", () => $2151d2bb13849eac$export$16beb41ec08bf629);

var $5uXOq = parcelRequire("5uXOq");


var $9OXo1 = parcelRequire("9OXo1");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $2YP9W = parcelRequire("2YP9W");

var $lbaDt = parcelRequire("lbaDt");

var $KbkKO = parcelRequire("KbkKO");
const $2151d2bb13849eac$var$initialState = {
    error: false,
    firstProject: undefined
};
const $2151d2bb13849eac$var$setError = (error)=>({ setState: setState })=>{
        setState({
            error: error
        });
    };
const $2151d2bb13849eac$var$setFirstProject = (firstProject)=>({ setState: setState })=>{
        setState({
            firstProject: firstProject
        });
    };
const $2151d2bb13849eac$export$e324594224ef24da = {
    setError: $2151d2bb13849eac$var$setError,
    setFirstProject: $2151d2bb13849eac$var$setFirstProject
};
const $2151d2bb13849eac$var$store = (0, $iXqE5.createStore)({
    name: 'getting-started-page-is-first-project',
    initialState: $2151d2bb13849eac$var$initialState,
    actions: $2151d2bb13849eac$export$e324594224ef24da
});
const $2151d2bb13849eac$export$a47f6b1a99a5e57f = (0, $3sQ5x.createHook)($2151d2bb13849eac$var$store);
const $2151d2bb13849eac$export$a2dd21ca7232bc34 = ()=>{
    const [data, { setError: setErrorState, setFirstProject: setFirstProjectDetails }] = $2151d2bb13849eac$export$a47f6b1a99a5e57f();
    const { licensedProducts: licensedProducts } = (0, $9OXo1.useTenantContext)() || {};
    const hasJsmLicense = licensedProducts && licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61];
    (0, $5uXOq.useEffect)(()=>{
        if (!hasJsmLicense || data.firstProject || data.error) return;
        (0, $KbkKO.default)().then((response)=>{
            setFirstProjectDetails(response);
        }).catch(()=>{
            setErrorState(true);
        });
    }, [
        hasJsmLicense,
        setErrorState,
        setFirstProjectDetails,
        data.firstProject,
        data.error
    ]);
    return data;
};
const $2151d2bb13849eac$export$16beb41ec08bf629 = ()=>{
    const [data, { setError: setErrorState, setFirstProject: setFirstProjectDetails }] = $2151d2bb13849eac$export$a47f6b1a99a5e57f();
    const { licensedProducts: licensedProducts } = (0, $9OXo1.useTenantContext)() || {};
    const hasJsmLicense = licensedProducts && licensedProducts[0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61];
    const { data: resourceData, error: error, loading: loading } = (0, $2YP9W.useResource)((0, $lbaDt.firstProjectResource));
    (0, $5uXOq.useEffect)(()=>{
        if (!hasJsmLicense || data.firstProject || data.error) return;
        if (error) setErrorState(true);
        else if (resourceData) setFirstProjectDetails(resourceData);
    }, [
        hasJsmLicense,
        resourceData,
        error,
        setErrorState,
        setFirstProjectDetails,
        data.firstProject,
        data.error
    ]);
    return {
        data: data,
        loading: loading
    };
};

});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';

parcelRegister("KbkKO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $746c95604cc49d58$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $lAOer = parcelRequire("lAOer");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $746c95604cc49d58$var$getFirstProject = async ()=>{
    try {
        const fetchStartTime = performance.now();
        const response = await (0, $eusud.performGetRequest)('/rest/servicedesk/latest/xflow/getFirstProject?type=service_desk');
        (0, $lAOer.addSpanToAll)('fetch', 'rest/servicedesk/latest/xflow/getFirstProject?type=service_desk', [
            {
                name: 'network'
            }
        ], fetchStartTime, performance.now());
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode !== 404) (0, $jcw0u.default)({
            meta: {
                id: 'getFirstProject',
                packageName: '@atlassian/jira-router-resources-service-desk-project-getting-started',
                teamName: 'itops-mithril'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
var // named export does not work with Bifrost templates CI build: 'index.tsx does not export 'then'`. Also, `getDataLoader:` in router works only with default exports
$746c95604cc49d58$export$2e2bcd8739ae039 = $746c95604cc49d58$var$getFirstProject;

});


parcelRegister("kTQYw", function(module, exports) {

$parcel$export(module.exports, "initialiseLandingPageState", () => $123174e2fee8004a$export$afc4bcbfce806408);
$parcel$export(module.exports, "getLandingPageState", () => $123174e2fee8004a$export$43654a89c1df0019);
$parcel$export(module.exports, "updateLandingPageStateProperties", () => $123174e2fee8004a$export$2dede61295d6c46);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");

var $5DnNI = parcelRequire("5DnNI");
const $123174e2fee8004a$export$afc4bcbfce806408 = ({ projectId: projectId, baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>async ()=>{
        try {
            await (0, $eusud.performPostRequest)(`${baseUrl}/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/project/${projectId}/list/jsm-getting-started-page`);
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({
                actionSubject: 'State',
                action: 'initialised'
            }), 'jiraServicedeskGettingStartedPage.State initialised');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'State',
                    packageName: (0, $5DnNI.PACKAGE_NAME),
                    teamName: (0, $5DnNI.PACKAGE_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
const $123174e2fee8004a$export$43654a89c1df0019 = ({ projectId: projectId, baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>async ()=>{
        try {
            const response = await (0, $eusud.performGetRequestWithRetry)(`${baseUrl}/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/project/${projectId}/list/jsm-getting-started-page`);
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: 'State',
                action: 'fetched'
            }), 'jiraServicedeskGettingStartedPage.State fetched');
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'State',
                    packageName: (0, $5DnNI.PACKAGE_NAME),
                    teamName: (0, $5DnNI.PACKAGE_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
const $123174e2fee8004a$export$2dede61295d6c46 = ({ projectId: projectId, baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>async (properties)=>{
        const sectionStateString = JSON.stringify(properties);
        try {
            await (0, $eusud.performPostRequest)(`${baseUrl}/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/project/${projectId}/list/jsm-getting-started-page/properties`, {
                body: JSON.stringify({
                    sectionState: sectionStateString
                })
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({
                actionSubject: 'Properties',
                action: 'updated'
            }), 'jiraServicedeskGettingStartedPage.Properties updated', {
                property: properties
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'Properties',
                    packageName: (0, $5DnNI.PACKAGE_NAME),
                    teamName: (0, $5DnNI.PACKAGE_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };

});


parcelRegister("6juLJ", function(module, exports) {

$parcel$export(module.exports, "useOpsTeamMode", () => $3726f54bfa1691c8$export$97247be508d7d058);
$parcel$export(module.exports, "useGettingStartedPanelState", () => $3726f54bfa1691c8$export$50f195e39d82318);
$parcel$export(module.exports, "useGettingStartedPanelActions", () => $3726f54bfa1691c8$export$bb089b373d239cdd);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $bngFq = parcelRequire("bngFq");

var $8J6rn = parcelRequire("8J6rn");

var $4DPZY = parcelRequire("4DPZY");

var $aNLeB = parcelRequire("aNLeB");


var $hO5fm = parcelRequire("hO5fm");

var $7HThi = parcelRequire("7HThi");

var $g5X3G = parcelRequire("g5X3G");

var $9OXo1 = parcelRequire("9OXo1");

var $bZlYm = parcelRequire("bZlYm");

var $bmKPg = parcelRequire("bmKPg");
var $doZTA = parcelRequire("doZTA");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $9TJvQ = parcelRequire("9TJvQ");
const $3726f54bfa1691c8$var$initialState = {
    data: undefined,
    isGspInitialized: true,
    isSaving: false,
    shouldRecordPerformanceExperiences: true
};
const $3726f54bfa1691c8$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'GettingStartedPanelState',
    initialState: $3726f54bfa1691c8$var$initialState,
    actions: (0, $9TJvQ.actions)
});
const $3726f54bfa1691c8$var$useGettingStartedPanelStoreState = (0, $3sQ5x.createHook)($3726f54bfa1691c8$export$6f57813fe9f31bf9, {
    selector: ({ data: data, isGspInitialized: isGspInitialized, shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences })=>{
        const canRender = isGspInitialized && data?.properties.user.activeState === (0, $bZlYm.ActiveState).On;
        const canRenderPanel = canRender && data?.properties.user.visualState === (0, $bZlYm.VisualState).FullPanel;
        const canRenderOpenButton = canRender && data?.properties.user.visualState === (0, $bZlYm.VisualState).Lozenge;
        const canRenderReopenButton = isGspInitialized && data?.properties.user.activeState === (0, $bZlYm.ActiveState).Off;
        const canRenderReopenSpotlight = canRenderReopenButton && data?.properties.user.hasSeenReopenSpotlight === (0, $bZlYm.HasSeenReopenSpotlight).No;
        const canPollPanelState = data?.properties.user.activeState === (0, $bZlYm.ActiveState).On;
        return {
            data: data,
            canRenderPanel: canRenderPanel,
            canRenderOpenButton: canRenderOpenButton,
            canRenderReopenButton: canRenderReopenButton,
            canRenderReopenSpotlight: canRenderReopenSpotlight,
            canPollPanelState: canPollPanelState,
            shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences
        };
    }
});
const $3726f54bfa1691c8$var$useGettingStartedPanelStoreActions = (0, $3sQ5x.createHook)($3726f54bfa1691c8$export$6f57813fe9f31bf9, {
    selector: null
});
/**
 * Hook returns if FSF tour is seen
 */ const $3726f54bfa1691c8$var$useIsProjectTourSeen = ()=>{
    const [{ data: data, isLoading: isLoading, error: error }, { getTourState: getTourState }] = (0, $hO5fm.useTourState)();
    const isError = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(error);
    const hasData = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(data);
    (0, $5uXOq.useEffect)(()=>{
        if (!hasData && !isLoading && !isError) getTourState();
    }, [
        hasData,
        isLoading,
        isError,
        getTourState
    ]);
    return data?.seenProjectTour === (0, $87b6a84c4fa7f907$export$e47bc222770d5cfd);
};
/**
 * Hook returns if ITSM sample project
 */ const $3726f54bfa1691c8$var$useIsSampleProject = ()=>{
    const { data: isItsmSampleProject } = (0, $7HThi.useIsItsmSampleProject)();
    const [{ data: containerContext }] = (0, $4DPZY.useContainerContext)();
    if (isItsmSampleProject != null) return isItsmSampleProject;
    /*
    When isItsmSampleProject is null or undefined - return null/undefined, but only if we are in project context
    (this is to identify that this var has not been initialized yet, see isItsmSampleProject usages, where we check for null/isNil);
    return false otherwise
 */ return containerContext?.contextType === 'project' ? isItsmSampleProject : false;
};
const $3726f54bfa1691c8$export$2486eddc1a0bc021 = ()=>{
    const { data: isItsmProject } = (0, $aNLeB.useIsItsmTemplateProject)();
    const [{ data: containerContext }] = (0, $4DPZY.useContainerContext)();
    const projectId = containerContext?.contextType === 'project' && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(containerContext.project) ? (0, $g5X3G.toProjectId)(String(containerContext.project.id)) : undefined;
    return {
        isItsmProject: !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(projectId) && isItsmProject === true,
        projectId: projectId
    };
};
const $3726f54bfa1691c8$export$97247be508d7d058 = ()=>{
    const [{ location: { pathname: pathname } }] = (0, $doZTA.useRouter)();
    const { shouldUseJSM: shouldUseJSM } = (0, $8J6rn.useOgTenantInfo)();
    const isOpsPage = pathname.startsWith('/jira/ops/teams/');
    const [teamId] = (0, $bmKPg.usePathParam)('teamId');
    const enableOpsTeamMode = isOpsPage && teamId !== undefined && !!shouldUseJSM;
    return {
        teamId: teamId,
        enableOpsTeamMode: enableOpsTeamMode
    };
};
const $3726f54bfa1691c8$export$678a38a9dc2d3a0 = ()=>{
    const { isItsmProject: isItsmProject } = $3726f54bfa1691c8$export$2486eddc1a0bc021();
    const { shouldUseJSM: shouldUseJSM } = (0, $8J6rn.useOgTenantInfo)();
    const enableUserCentricMode = isItsmProject && !!shouldUseJSM;
    return enableUserCentricMode;
};
const $3726f54bfa1691c8$var$useActionsMemo = ({ baseUrl: baseUrl, cloudId: cloudId, accountId: accountId, initializeState: initializeState, reopenGettingStartedPanel: reopenGettingStartedPanel, markReopenSpotlightAsSeen: markReopenSpotlightAsSeen, fetchState: fetchState, savePanelState: savePanelState, resolveTask: resolveTask, saveProperty: saveProperty, stopRecordingPerformanceExperiences: stopRecordingPerformanceExperiences, setOpsAdminTaskVisibility: setOpsAdminTaskVisibility })=>{
    const gatewayBaseUrl = (0, $g5X3G.toBaseUrl)(`${baseUrl}/gateway/api`);
    const isItsmSampleProject = $3726f54bfa1691c8$var$useIsSampleProject();
    const { isItsmProject: isItsmProject, projectId: projectId } = $3726f54bfa1691c8$export$2486eddc1a0bc021();
    const isProjectTourSeen = $3726f54bfa1691c8$var$useIsProjectTourSeen();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { teamId: teamId, enableOpsTeamMode: enableOpsTeamMode } = $3726f54bfa1691c8$export$97247be508d7d058();
    const enableUserCentricMode = $3726f54bfa1691c8$export$678a38a9dc2d3a0();
    return (0, $5uXOq.useMemo)(()=>{
        const actionProps = {
            createAnalyticsEvent: createAnalyticsEvent,
            baseUrl: gatewayBaseUrl,
            cloudId: cloudId,
            accountId: accountId,
            isItsmSampleProject: isItsmSampleProject,
            isProjectTourSeen: isProjectTourSeen,
            isItsmProject: isItsmProject,
            projectId: projectId,
            ...enableOpsTeamMode && {
                teamId: teamId,
                enableOpsTeamMode: enableOpsTeamMode
            },
            ...enableUserCentricMode && {
                enableUserCentricMode: enableUserCentricMode
            }
        };
        return {
            initializeState: initializeState(actionProps),
            reopenGettingStartedPanel: reopenGettingStartedPanel(actionProps),
            markReopenSpotlightAsSeen: markReopenSpotlightAsSeen(actionProps),
            fetchState: fetchState(actionProps),
            savePanelState: savePanelState(actionProps),
            resolveTask: resolveTask(actionProps),
            saveProperty: saveProperty(actionProps),
            stopRecordingPerformanceExperiences: stopRecordingPerformanceExperiences(),
            setOpsAdminTaskVisibility: setOpsAdminTaskVisibility(actionProps)
        };
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl,
        cloudId,
        accountId,
        isItsmSampleProject,
        isProjectTourSeen,
        isItsmProject,
        projectId,
        enableOpsTeamMode,
        teamId,
        enableUserCentricMode,
        initializeState,
        reopenGettingStartedPanel,
        markReopenSpotlightAsSeen,
        fetchState,
        savePanelState,
        resolveTask,
        saveProperty,
        stopRecordingPerformanceExperiences,
        setOpsAdminTaskVisibility
    ]);
};
const $3726f54bfa1691c8$var$useStateMemo = ({ data: data, canRenderPanel: canRenderPanel, canRenderOpenButton: canRenderOpenButton, canRenderReopenButton: canRenderReopenButton, canRenderReopenSpotlight: canRenderReopenSpotlight, canPollPanelState: canPollPanelState, shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences })=>(0, $5uXOq.useMemo)(()=>({
            data: data,
            canRenderPanel: canRenderPanel,
            canRenderOpenButton: canRenderOpenButton,
            canRenderReopenButton: canRenderReopenButton,
            canRenderReopenSpotlight: canRenderReopenSpotlight,
            canPollPanelState: canPollPanelState,
            shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences
        }), [
        data,
        canRenderPanel,
        canRenderOpenButton,
        canRenderReopenButton,
        canRenderReopenSpotlight,
        canPollPanelState,
        shouldRecordPerformanceExperiences
    ]);
const $3726f54bfa1691c8$export$50f195e39d82318 = ()=>{
    const { cloudId: cloudId, atlassianAccountId: accountId, baseUrl: baseUrl } = (0, $9OXo1.useTenantContext)();
    const [state, actions] = $3726f54bfa1691c8$var$useGettingStartedPanelStoreState();
    const memoizedActions = $3726f54bfa1691c8$var$useActionsMemo({
        ...actions,
        baseUrl: baseUrl,
        cloudId: cloudId,
        accountId: accountId
    });
    const memoizedState = $3726f54bfa1691c8$var$useStateMemo(state);
    return (0, $5uXOq.useMemo)(()=>[
            memoizedState,
            memoizedActions
        ], [
        memoizedActions,
        memoizedState
    ]);
};
const $3726f54bfa1691c8$export$bb089b373d239cdd = ()=>{
    const { cloudId: cloudId, atlassianAccountId: accountId, baseUrl: baseUrl } = (0, $9OXo1.useTenantContext)();
    const [, actions] = $3726f54bfa1691c8$var$useGettingStartedPanelStoreActions();
    const memoizedActions = $3726f54bfa1691c8$var$useActionsMemo({
        ...actions,
        baseUrl: baseUrl,
        cloudId: cloudId,
        accountId: accountId
    });
    return (0, $5uXOq.useMemo)(()=>[
            undefined,
            memoizedActions
        ], [
        memoizedActions
    ]);
};

});
const $87b6a84c4fa7f907$export$17227441e89ee693 = 'INITIAL';
const $87b6a84c4fa7f907$export$23324e66dcb20cea = 'NOTSEEN';
const $87b6a84c4fa7f907$export$e47bc222770d5cfd = 'SEEN';
const $87b6a84c4fa7f907$export$103bedf43ba882db = 'ERROR';
const $87b6a84c4fa7f907$export$b8b9d90f9e5bd72b = 'jiraServicedeskItsmFirstSessionFlow';
const $87b6a84c4fa7f907$export$d57b6b390e78d90f = 'itops-mithril';

parcelRegister("hO5fm", function(module, exports) {

$parcel$export(module.exports, "useTourState", () => $6d8bca487172cfe1$export$4aecabf781c5d857);

var $5uXOq = parcelRequire("5uXOq");

var $g5X3G = parcelRequire("g5X3G");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $7tQNr = parcelRequire("7tQNr");
const $6d8bca487172cfe1$export$d4c72bab9d6cc13a = {
    data: undefined,
    isLoading: false,
    error: undefined
};
const $6d8bca487172cfe1$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'ItsmFirstSessionFlowTourState',
    initialState: $6d8bca487172cfe1$export$d4c72bab9d6cc13a,
    actions: (0, $7tQNr.actions)
});
const $6d8bca487172cfe1$var$useStore = (0, $3sQ5x.createHook)($6d8bca487172cfe1$export$6f57813fe9f31bf9);
// @ts-expect-error - TS7031 - Binding element 'baseUrl' implicitly has an 'any' type. | TS7031 - Binding element 'getTourState' implicitly has an 'any' type. | TS7031 - Binding element 'setTourState' implicitly has an 'any' type.
const $6d8bca487172cfe1$var$useActionsMemo = ({ baseUrl: baseUrl, getTourState: getTourState, setTourState: setTourState })=>(0, $5uXOq.useMemo)(()=>({
            getTourState: getTourState({
                baseUrl: baseUrl
            }),
            setTourState: setTourState({
                baseUrl: baseUrl
            })
        }), [
        baseUrl,
        getTourState,
        setTourState
    ]);
const $6d8bca487172cfe1$var$useStateMemo = ({ data: data, isLoading: isLoading, error: error })=>(0, $5uXOq.useMemo)(()=>({
            data: data,
            isLoading: isLoading,
            error: error
        }), [
        data,
        isLoading,
        error
    ]);
const $6d8bca487172cfe1$export$4aecabf781c5d857 = ()=>{
    const baseUrl = (0, $g5X3G.toBaseUrl)('');
    const [state, actions] = $6d8bca487172cfe1$var$useStore();
    const memoizedActions = $6d8bca487172cfe1$var$useActionsMemo({
        ...actions,
        baseUrl: baseUrl
    });
    const memoizedState = $6d8bca487172cfe1$var$useStateMemo(state);
    return (0, $5uXOq.useMemo)(()=>[
            memoizedState,
            memoizedActions
        ], [
        memoizedActions,
        memoizedState
    ]);
};

});
parcelRegister("7tQNr", function(module, exports) {

$parcel$export(module.exports, "actions", () => $e522e9db5e833423$export$e324594224ef24da);

var $bXTMr = parcelRequire("bXTMr");

var $2SNiB = parcelRequire("2SNiB");
const $e522e9db5e833423$export$e324594224ef24da = {
    getTourState: $bXTMr.getTourState,
    setTourState: $2SNiB.setTourState
};

});
parcelRegister("bXTMr", function(module, exports) {

$parcel$export(module.exports, "getTourState", () => $eed4e52cff30c013$export$a758fd93ae41dde5);

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");

var $fZneA = parcelRequire("fZneA");

var $g5X3G = parcelRequire("g5X3G");

const $eed4e52cff30c013$var$getUrl = (baseUrl)=>`${baseUrl}/rest/servicedesk/onboarding/latest/fsf`;
const $eed4e52cff30c013$var$fetchTourState = async (baseUrl)=>{
    const url = $eed4e52cff30c013$var$getUrl(baseUrl);
    const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
    if (!response.ok) {
        const text = await response.text();
        const error = new (0, $jJZqs.default)(response.status, text);
        // Still throw the error even if it's a client fetch error,
        // so we get the error path in the handling code.
        // We only want to skip analytics firing.
        if (!(0, $fZneA.isClientFetchError)(error)) (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getTourState_responseNotOK',
                packageName: (0, $87b6a84c4fa7f907$export$b8b9d90f9e5bd72b),
                teamName: (0, $87b6a84c4fa7f907$export$d57b6b390e78d90f)
            },
            attributes: {
                message: error.message
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
    return response.json();
};
const $eed4e52cff30c013$export$a758fd93ae41dde5 = ({ baseUrl: baseUrl })=>({ getState: getState, setState: setState })=>async ()=>{
            const { data: data, isLoading: isLoading } = getState();
            if (data || isLoading) return;
            setState({
                error: undefined,
                isLoading: true
            });
            try {
                const result = await $eed4e52cff30c013$var$fetchTourState(baseUrl);
                const { seenProjectTour: seenProjectTour, projectId: projectId } = result;
                setState({
                    data: {
                        seenProjectTour: seenProjectTour,
                        projectId: projectId === null ? null : (0, $g5X3G.toProjectId)(projectId)
                    },
                    isLoading: false
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if (!(0, $fZneA.isClientFetchError)(error)) (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'getTourState',
                        packageName: (0, $87b6a84c4fa7f907$export$b8b9d90f9e5bd72b),
                        teamName: (0, $87b6a84c4fa7f907$export$d57b6b390e78d90f)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    error: error,
                    isLoading: false
                });
                if (!(0, $fZneA.isClientFetchError)(error)) throw error;
            }
        };

});

parcelRegister("2SNiB", function(module, exports) {

$parcel$export(module.exports, "setTourState", () => $e6283e07e269c047$export$35f9649c739aaca3);

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");

const $e6283e07e269c047$var$getUrl = (baseUrl)=>`${baseUrl}/rest/servicedesk/onboarding/latest/fsf`;
const $e6283e07e269c047$var$putTourState = async (baseUrl, tourState)=>{
    const url = $e6283e07e269c047$var$getUrl(baseUrl);
    const response = await fetch(url, {
        ...(0, $5HnTq.getDefaultOptions)(url),
        method: 'PUT',
        body: JSON.stringify(tourState)
    });
    if (!response.ok) {
        const text = await response.text();
        const error = new (0, $jJZqs.default)(response.status, text);
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'setTourState_responseNotOK',
                packageName: (0, $87b6a84c4fa7f907$export$b8b9d90f9e5bd72b),
                teamName: (0, $87b6a84c4fa7f907$export$d57b6b390e78d90f)
            },
            attributes: {
                message: error.message
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $e6283e07e269c047$export$35f9649c739aaca3 = ({ baseUrl: baseUrl })=>({ setState: setState })=>// @ts-expect-error - TS2322 - Type 'SetTourState' is not assignable to type 'void | Promise<void>'.
        async (tourState)=>{
            setState({
                error: undefined,
                data: tourState,
                isLoading: true
            });
            try {
                await $e6283e07e269c047$var$putTourState(baseUrl, tourState);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'setTourState',
                        packageName: (0, $87b6a84c4fa7f907$export$b8b9d90f9e5bd72b),
                        teamName: (0, $87b6a84c4fa7f907$export$d57b6b390e78d90f)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    error: error
                });
                throw error;
            } finally{
                setState({
                    isLoading: false
                });
            }
        };

});



parcelRegister("7HThi", function(module, exports) {

$parcel$export(module.exports, "useIsItsmSampleProject", () => $1bd32a46a0882e8f$export$b8afdaba4bd6f483);

var $hGgHi = parcelRequire("hGgHi");

var $aNLeB = parcelRequire("aNLeB");

var $g4ge5 = parcelRequire("g4ge5");
const $1bd32a46a0882e8f$export$b8afdaba4bd6f483 = ()=>{
    const { data: isDemoProject, loading: loadingIsDemoProject, error: errorIsDemoProject } = (0, $g4ge5.useIsDemoProject)();
    const { data: isItsmProject, loading: loadingIsItsmProject, error: errorIsItsmProject } = (0, $aNLeB.useIsItsmTemplateProject)();
    return {
        data: !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(isDemoProject) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(isItsmProject) ? isDemoProject === true && isItsmProject === true : null,
        loading: loadingIsDemoProject || loadingIsItsmProject,
        error: errorIsDemoProject || errorIsItsmProject
    };
};

});
parcelRegister("g4ge5", function(module, exports) {

$parcel$export(module.exports, "useIsDemoProject", () => $09e24bc2f005ce6a$export$9b4078600f2ad4d2);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $4DPZY = parcelRequire("4DPZY");

var $g5X3G = parcelRequire("g5X3G");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $dciEf = parcelRequire("dciEf");

var $6LFnT = parcelRequire("6LFnT");
const $09e24bc2f005ce6a$export$d4c72bab9d6cc13a = {};
const $09e24bc2f005ce6a$export$bf108b10a3a0ab90 = (0, $iXqE5.createStore)({
    name: 'IsDemoProject',
    initialState: $09e24bc2f005ce6a$export$d4c72bab9d6cc13a,
    actions: (0, $dciEf.actions)
});
const $09e24bc2f005ce6a$var$useIsDemoProjectStore = (0, $3sQ5x.createHook)($09e24bc2f005ce6a$export$bf108b10a3a0ab90);
// @ts-expect-error - TS7031 - Binding element 'data' implicitly has an 'any' type. | TS7031 - Binding element 'loading' implicitly has an 'any' type. | TS7031 - Binding element 'error' implicitly has an 'any' type.
const $09e24bc2f005ce6a$var$useStateMemo = ({ data: data, loading: loading, error: error })=>(0, $5uXOq.useMemo)(()=>({
            data: data,
            loading: loading,
            error: error
        }), [
        data,
        loading,
        error
    ]);
const $09e24bc2f005ce6a$export$9b4078600f2ad4d2 = ()=>{
    const [{ data: contextData }] = (0, $4DPZY.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'. | TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const numProjectId = contextData && contextData.project && contextData.project.id;
    const projectId = (0, $g5X3G.toProjectId)(String(numProjectId));
    const baseUrl = (0, $g5X3G.toBaseUrl)('');
    const [state, { fetchIsDemoProject: fetchIsDemoProject }] = $09e24bc2f005ce6a$var$useIsDemoProjectStore();
    const memoizedState = $09e24bc2f005ce6a$var$useStateMemo({
        ...state[projectId] ?? (0, $6LFnT.initialIsDemoProjectState)
    });
    const { data: data } = memoizedState;
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(numProjectId) && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(data)) // @ts-expect-error - TS2349 - This expression is not callable.
        fetchIsDemoProject({
            baseUrl: baseUrl,
            projectId: projectId
        })();
    }, [
        fetchIsDemoProject,
        baseUrl,
        numProjectId,
        projectId,
        data
    ]);
    return memoizedState;
};

});
parcelRegister("dciEf", function(module, exports) {

$parcel$export(module.exports, "actions", () => $ffc7e95937855e49$export$e324594224ef24da);

var $4MUdY = parcelRequire("4MUdY");
const $ffc7e95937855e49$export$e324594224ef24da = {
    fetchIsDemoProject: $4MUdY.fetchIsDemoProject
};

});
parcelRegister("4MUdY", function(module, exports) {

$parcel$export(module.exports, "fetchIsDemoProject", () => $19341c0fa64f8930$export$feaee63a215b34da);

var $hGgHi = parcelRequire("hGgHi");

var $i8xPd = parcelRequire("i8xPd");

var $6LFnT = parcelRequire("6LFnT");
const $19341c0fa64f8930$export$feaee63a215b34da = ({ baseUrl: baseUrl, projectId: projectId })=>// @ts-expect-error - TS2322 - Type '({ getState, setState }: StoreActionApi<Partial<Record<string, DataState<boolean>>>>) => () => Promise<void>' is not assignable to type 'Action<Partial<Record<string, DataState<boolean>>>, void, void | Promise<void>>'.
    ({ getState: getState, setState: setState })=>async ()=>{
            const projectState = getState()[projectId] ?? (0, $6LFnT.initialIsDemoProjectState);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(projectState.data) || projectState.loading) return;
            setState({
                ...getState(),
                [String(projectId)]: {
                    ...projectState,
                    loading: true
                }
            });
            try {
                const isDemo = await (0, $i8xPd.isDemoProject)({
                    baseUrl: baseUrl,
                    projectId: projectId
                });
                setState({
                    ...getState(),
                    [String(projectId)]: {
                        ...projectState,
                        data: isDemo,
                        error: null,
                        loading: false
                    }
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    ...getState(),
                    [String(projectId)]: {
                        ...projectState,
                        error: error,
                        loading: false
                    }
                });
                throw error;
            }
        };

});
parcelRegister("i8xPd", function(module, exports) {

$parcel$export(module.exports, "isDemoProject", () => $aef4f72f73469a32$export$cf7813449d38d4ac);
$parcel$export(module.exports, "getItsmSampleProject", () => $aef4f72f73469a32$export$c498e29d716efe7a);

var $38QcJ = parcelRequire("38QcJ");

var $6s1PB = parcelRequire("6s1PB");

var $eusud = parcelRequire("eusud");
const $aef4f72f73469a32$var$onFetchErrorCacheHandler = (error)=>{
    if (error.statusCode === 404) return {
        value: false
    };
    throw error;
};
const $aef4f72f73469a32$export$cf7813449d38d4ac = async ({ baseUrl: baseUrl, projectId: projectId })=>{
    try {
        if ((0, $6s1PB.expValEquals)('jira_caching_layer_milestone_1_exp', 'cohort', 'variation')) {
            const response = await (0, $38QcJ.performGetRequestWithCache)(`${baseUrl}/rest/api/3/project/${projectId}/properties/isDemo`, $aef4f72f73469a32$var$onFetchErrorCacheHandler);
            return !!response && !!response.value;
        }
        const response = await (0, $eusud.performGetRequest)(`${baseUrl}/rest/api/3/project/${projectId}/properties/isDemo`);
        return !!response && !!response.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 404) /**
			 * Expected when project property is not found.
			 * Demo project has project property "isDemo = true",
			 * otherwise property does not exist
			 * and response status will be 404
			 */ return false;
        throw error;
    }
};
const $aef4f72f73469a32$export$c498e29d716efe7a = async ({ baseUrl: baseUrl })=>{
    try {
        const response = await (0, $eusud.performGetRequest)(`${baseUrl}/rest/servicedesk/onboarding/1/itsm/sample-project`);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 404) return undefined;
        throw error;
    }
};

});
parcelRegister("38QcJ", function(module, exports) {

$parcel$export(module.exports, "performGetRequestWithCache", () => $babbea8c3a621dad$export$2df9cfe22532d245);

var $eusud = parcelRequire("eusud");

var $aDezs = parcelRequire("aDezs");
const $babbea8c3a621dad$export$2df9cfe22532d245 = (0, $aDezs.withCache)((0, $eusud.performGetRequest));

});
parcelRegister("aDezs", function(module, exports) {

$parcel$export(module.exports, "withCache", () => $807c4ec3ea856331$export$33b32b3abf8170f0);

var $x9xyg = parcelRequire("x9xyg");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $4ZYuM = parcelRequire("4ZYuM");

var $4sfTg = parcelRequire("4sfTg");

var $6JHHz = parcelRequire("6JHHz");

var $dw7IP = parcelRequire("dw7IP");
const $807c4ec3ea856331$export$33b32b3abf8170f0 = (fn)=>async (url, onFnErrorCacheHandler, maxAge = (0, $4ZYuM.SEVEN_DAYS_IN_MILLIS), options = {})=>{
        if (false) return fn(url, options);
        try {
            if (!(0, $6s1PB.expValEquals)('jira_caching_layer_milestone_1_exp', 'cohort', 'variation')) return fn(url, options);
            const cachedKey = (0, $4sfTg.createCacheKey)(url);
            const readMeasureName = 'indexed-db-cache-read';
            const readStartMark = `${readMeasureName}:start`;
            const readEndMark = `${readMeasureName}:end`;
            (0, $x9xyg.setMark)(readStartMark);
            const cachedData = await (0, $dw7IP.jiraCache).get(cachedKey);
            (0, $x9xyg.setMark)(readEndMark);
            (0, $x9xyg.setMeasure)(readMeasureName, readStartMark, readEndMark);
            if (cachedData !== undefined && Date.now() < cachedData.expiresAt) return cachedData.data;
            let data;
            try {
                data = await fn(url, options);
            } catch (error) {
                if (onFnErrorCacheHandler) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                data = onFnErrorCacheHandler(error);
                else throw error;
            }
            const writeMeasureName = 'indexed-db-cache-write';
            const writeStartMark = `${writeMeasureName}:start`;
            const writeEndMark = `${writeMeasureName}:end`;
            (0, $x9xyg.setMark)(writeStartMark);
            (0, $dw7IP.jiraCache).set(cachedKey, {
                data: data,
                expiresAt: Date.now() + maxAge
            }).then(()=>{
                (0, $x9xyg.setMark)(writeEndMark);
                (0, $x9xyg.setMeasure)(writeMeasureName, writeStartMark, writeEndMark);
            });
            return data;
        } catch (error) {
            if ((0, $4R6GH.fg)('jcl_error_handling_and_conditional_skip_sentry')) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $6JHHz.errorHandler)(error, 'withCache');
            else (0, $jcw0u.default)({
                meta: {
                    id: 'withCache',
                    packageName: (0, $4ZYuM.PACKAGE_NAME),
                    teamName: (0, $4ZYuM.TEAM_NAME)
                },
                error: new Error('Error in JCL withCache'),
                attributes: {
                    cause: error instanceof Error ? error.message : 'Not known'
                },
                sendToPrivacyUnsafeSplunk: true,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                skipSentry: (0, $jcw0u.isNetworkError)(error)
            });
            return fn(url, options);
        }
    };

});
parcelRegister("4ZYuM", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $14fef84cc1d179c0$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $14fef84cc1d179c0$export$d57b6b390e78d90f);
$parcel$export(module.exports, "SEVEN_DAYS_IN_MILLIS", () => $14fef84cc1d179c0$export$b14f1fa28090cb18);
$parcel$export(module.exports, "CACHE_NAME_PREFIX", () => $14fef84cc1d179c0$export$7c8c9e2fd09cd6cd);
const $14fef84cc1d179c0$export$b8b9d90f9e5bd72b = 'jiraCachingLayer';
const $14fef84cc1d179c0$export$d57b6b390e78d90f = 'itops-mithril';
const $14fef84cc1d179c0$export$b14f1fa28090cb18 = 604800000;
const $14fef84cc1d179c0$export$7c8c9e2fd09cd6cd = 'jira-cache';

});

parcelRegister("4sfTg", function(module, exports) {

$parcel$export(module.exports, "createCacheKey", () => $ae7ce70bbd907415$export$aa68fd26e593cc7e);

var $4Pf62 = parcelRequire("4Pf62");
const $ae7ce70bbd907415$export$aa68fd26e593cc7e = (endpoint)=>{
    const { atlassianAccountId: atlassianAccountId, cloudId: cloudId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const url = new URL(endpoint, window.location.origin);
    const searchParams = new URLSearchParams(url.search);
    const sortedParams = new URLSearchParams([
        ...searchParams.entries()
    ].sort());
    url.search = sortedParams.toString();
    const prefix = (atlassianAccountId + cloudId).replace(/-/g, '');
    const endpointWithSearch = prefix + url.pathname + url.search;
    return endpointWithSearch.replace(/[/?&=]/g, '-').substring(1);
};

});

parcelRegister("6JHHz", function(module, exports) {

$parcel$export(module.exports, "errorHandler", () => $17322007fa00b48f$export$cc3fdd528b56c4a9);

var $jcw0u = parcelRequire("jcw0u");

var $4ZYuM = parcelRequire("4ZYuM");
const $17322007fa00b48f$export$3b21ec5932035f63 = [
    'Internal error.',
    'Internal error opening backing store for indexedDB.open.',
    "Can't find variable: indexedDB",
    'Error looking up record in object store by key range',
    "IDBDatabase.transaction: 'keyval' is not a known object store name",
    'A mutation operation was attempted on a database that did not allow mutations.',
    'Encountered full disk while opening backing store for indexedDB.open.',
    "Failed to execute 'transaction' on 'IDBDatabase': One of the specified object stores was not found.",
    'Internal error retrieving bucket data directory.',
    'Connection to Indexed Database server lost. Refresh the page to try again',
    'The current transaction exceeded its quota limitations.',
    'The operation failed for reasons unrelated to the database itself and not covered by any other error code.',
    'Attempt to get a record from database without an in-progress transaction'
];
const $17322007fa00b48f$var$shouldSkipSentry = (error)=>(0, $jcw0u.isNetworkError)(error) || $17322007fa00b48f$export$3b21ec5932035f63.includes(error?.message);
const $17322007fa00b48f$export$cc3fdd528b56c4a9 = (error, source)=>{
    const cause = error instanceof Error ? error.message : 'Not known';
    (0, $jcw0u.default)({
        meta: {
            id: source,
            packageName: (0, $4ZYuM.PACKAGE_NAME),
            teamName: (0, $4ZYuM.TEAM_NAME)
        },
        error: new Error(`JCL ${source} - ${cause}`, {
            cause: error
        }),
        attributes: {
            cause: cause
        },
        sendToPrivacyUnsafeSplunk: true,
        skipSentry: $17322007fa00b48f$var$shouldSkipSentry(error)
    });
};

});

parcelRegister("dw7IP", function(module, exports) {

$parcel$export(module.exports, "jiraCache", () => $646f3c3ba9013057$export$8b9e5c9ea3bf5aac);

var $sn9QA = parcelRequire("sn9QA");

var $4ZYuM = parcelRequire("4ZYuM");
const $646f3c3ba9013057$export$8b9e5c9ea3bf5aac = (0, $sn9QA.createIndexedDBStorageProvider)((0, $4ZYuM.CACHE_NAME_PREFIX), {
    shouldAutoReconnect: true
});

});
parcelRegister("sn9QA", function(module, exports) {

$parcel$export(module.exports, "createIndexedDBStorageProvider", () => $cf3437e9474a0e2b$export$6ba36c4f5fb8919d);

var $gJBT6 = parcelRequire("gJBT6");

var $8vEj7 = parcelRequire("8vEj7");
const $cf3437e9474a0e2b$export$6ba36c4f5fb8919d = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix, options)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const provider = (0, $8vEj7.createStorageProvider)(appPrefix);
    if (options?.shouldAutoReconnect) return (0, $8vEj7.withAutoReconnect)(provider);
    return provider;
});

});
parcelRegister("8vEj7", function(module, exports) {

$parcel$export(module.exports, "createStorageProvider", () => $33b8db71261fb346$export$8441605555fbd60c);
$parcel$export(module.exports, "withAutoReconnect", () => $33b8db71261fb346$export$8432fe49db7d8865);

var $jIIX7 = parcelRequire("jIIX7");
const $33b8db71261fb346$export$7382f85ef4ff4314 = (prefix, key)=>`${prefix.replace(/_*$/, '')}__${key || ''}`;
const $33b8db71261fb346$var$createCustomStore = ()=>(0, $jIIX7.createStore)('keyval-store', 'keyval');
let $33b8db71261fb346$var$customStore;
const $33b8db71261fb346$var$getStore = ()=>{
    let store = $33b8db71261fb346$var$customStore;
    if (!store) {
        $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
        store = $33b8db71261fb346$var$customStore;
    }
    return store;
};
const $33b8db71261fb346$export$8441605555fbd60c = (appPrefix)=>{
    const KEYS_STORE_PREFIX = $33b8db71261fb346$export$7382f85ef4ff4314(appPrefix);
    const prefix = (key)=>$33b8db71261fb346$export$7382f85ef4ff4314(appPrefix, key);
    // Runtime check to ensure a key is provided as the prefix without a key
    // holds an array of all the keys that are prefixed by this store
    const assertKey = (key)=>{
        if (!key) throw Error('You must provide a key');
    };
    // Calling `clearAll` would require us to iterate over every key in the
    // indexed-db, filtering by this instance's prefix and subsequently deleting
    // all the filtered keys. As indexed-db gains traction within Jira, this
    // will quickly become an expensive operation. To counteract this, we
    // instead store all the keys that this instance has created so that when it
    // comes time to clear them all, we simply just have to clear every key in
    // this store. This removes the need for iterating and filtering all
    // together.
    const updateStoreKeys = async (key, remove = false)=>(0, $jIIX7.update)(KEYS_STORE_PREFIX, (currentKeys)=>{
            const storeKeys = new Set(currentKeys);
            if (remove) {
                storeKeys.delete(key);
                return Array.from(storeKeys.values());
            }
            storeKeys.add(key);
            return Array.from(storeKeys.values());
        }, $33b8db71261fb346$var$getStore());
    return {
        async get (key) {
            assertKey(key);
            return (0, $jIIX7.get)(prefix(key), $33b8db71261fb346$var$getStore());
        },
        async remove (key) {
            assertKey(key);
            const prefixedKey = prefix(key);
            await (0, $jIIX7.del)(prefixedKey, $33b8db71261fb346$var$getStore());
            return updateStoreKeys(prefixedKey, true);
        },
        async clearAll () {
            const prefixedKeys = await (0, $jIIX7.get)(KEYS_STORE_PREFIX, $33b8db71261fb346$var$getStore());
            if (!prefixedKeys || prefixedKeys.length === 0) return undefined;
            return (0, $jIIX7.delMany)(prefixedKeys.concat(KEYS_STORE_PREFIX));
        },
        async set (key, value) {
            assertKey(key);
            const prefixedKey = prefix(key);
            if (typeof value === 'function') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            (0, $jIIX7.update)(prefixedKey, value);
            else (0, $jIIX7.set)(prefixedKey, value, $33b8db71261fb346$var$getStore());
            return updateStoreKeys(prefixedKey);
        },
        async reconnect () {
            $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
        }
    };
};
const $33b8db71261fb346$export$8432fe49db7d8865 = (storageProvider)=>({
        async get (...args) {
            try {
                return await storageProvider.get(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.get(...args);
                }
                throw e;
            }
        },
        async set (...args) {
            try {
                return await storageProvider.set(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.set(...args);
                }
                throw e;
            }
        },
        async remove (...args) {
            try {
                return await storageProvider.remove(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.remove(...args);
                }
                throw e;
            }
        },
        async clearAll (...args) {
            try {
                return await storageProvider.clearAll(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.clearAll(...args);
                }
                throw e;
            }
        },
        async reconnect () {
            await storageProvider.reconnect?.();
        }
    });

});
parcelRegister("jIIX7", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $e5b4ff07e835609c$export$f51a9068ac82ea43);
$parcel$export(module.exports, "get", () => $e5b4ff07e835609c$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $e5b4ff07e835609c$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "update", () => $e5b4ff07e835609c$export$722fbec263ad908a);
$parcel$export(module.exports, "del", () => $e5b4ff07e835609c$export$1d2f21e549771e67);
$parcel$export(module.exports, "delMany", () => $e5b4ff07e835609c$export$c8aa84257229cac8);
function $e5b4ff07e835609c$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $e5b4ff07e835609c$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $e5b4ff07e835609c$export$b327150396135fe7(request);
    return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $e5b4ff07e835609c$var$defaultGetStoreFunc;
function $e5b4ff07e835609c$var$defaultGetStore() {
    if (!$e5b4ff07e835609c$var$defaultGetStoreFunc) $e5b4ff07e835609c$var$defaultGetStoreFunc = $e5b4ff07e835609c$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $e5b4ff07e835609c$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$3988ae62b71be9a3(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$adaa4cf7ef1b65be(key, value, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.put(value, key);
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$daa0a5170277c7a8(entries, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$5df405cccea42673(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$722fbec263ad908a(key, updater, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($e5b4ff07e835609c$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$1d2f21e549771e67(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.delete(key);
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$c8aa84257229cac8(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$42ffd38884aecdac(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.clear();
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
function $e5b4ff07e835609c$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$ed97f33186d4b816(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$68c286be0e7e55b7(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAll());
        const items = [];
        return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$3e9f948b41964866(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys()),
            $e5b4ff07e835609c$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return customStore('readonly', (store)=>$e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push([
                    cursor.key,
                    cursor.value
                ])).then(()=>items));
    });
}

});







parcelRegister("6LFnT", function(module, exports) {

$parcel$export(module.exports, "initialIsDemoProjectState", () => $21d88e1743f1ae3e$export$f6365b0f25aeae62);
const $21d88e1743f1ae3e$export$f6365b0f25aeae62 = {
    data: null,
    loading: false,
    error: null
};

});





parcelRegister("bZlYm", function(module, exports) {

$parcel$export(module.exports, "ActiveState", () => $e6e9da68cec0ea42$export$2f27df41e8b7edbb);
$parcel$export(module.exports, "VisualState", () => $e6e9da68cec0ea42$export$285eeaa5f468cfb6);
$parcel$export(module.exports, "Product", () => $e6e9da68cec0ea42$export$264ad599d7cef668);
$parcel$export(module.exports, "Environment", () => $e6e9da68cec0ea42$export$7dc6752a22ab011a);
$parcel$export(module.exports, "GspSectionKey", () => $e6e9da68cec0ea42$export$f4906a03a7a2d0af);
$parcel$export(module.exports, "ChecklistTabKey", () => $e6e9da68cec0ea42$export$4f1a05ccc35315c6);
$parcel$export(module.exports, "ProductTourKey", () => $e6e9da68cec0ea42$export$aa90cbc80c330872);
$parcel$export(module.exports, "HeaderState", () => $e6e9da68cec0ea42$export$38aab4015a34ead);
$parcel$export(module.exports, "TaskId", () => $e6e9da68cec0ea42$export$10cc267f702fbadd);
$parcel$export(module.exports, "BasicsTaskIdsProductionised", () => $e6e9da68cec0ea42$export$fe6666d729b0d637);
$parcel$export(module.exports, "TeamEfficiencyTaskIds", () => $e6e9da68cec0ea42$export$ed4dcaac45c6a484);
$parcel$export(module.exports, "ChangesTaskIds", () => $e6e9da68cec0ea42$export$3de0dd66b0de4cdc);
$parcel$export(module.exports, "IncidentsTaskIds", () => $e6e9da68cec0ea42$export$2852680309cf5a68);
$parcel$export(module.exports, "AlertsTaskIds", () => $e6e9da68cec0ea42$export$4f537e3bd8843f30);
$parcel$export(module.exports, "CompassAlertsTaskIds", () => $e6e9da68cec0ea42$export$62a4b5d6ebfd53e9);
$parcel$export(module.exports, "HasSeenReopenSpotlight", () => $e6e9da68cec0ea42$export$72401d057976d548);
$parcel$export(module.exports, "ContainerType", () => $e6e9da68cec0ea42$export$7d7a98f44861e6f7);
$parcel$export(module.exports, "ExplicitStringBoolean", () => $e6e9da68cec0ea42$export$d7341fa10d264a87);
$parcel$export(module.exports, "PropertyKey", () => $e6e9da68cec0ea42$export$e6bec6a1026bf0b4);
var $e6e9da68cec0ea42$export$2f27df41e8b7edbb = /*#__PURE__*/ function(ActiveState) {
    ActiveState["On"] = "on";
    ActiveState["Off"] = "off";
    return ActiveState;
}({});
var $e6e9da68cec0ea42$export$285eeaa5f468cfb6 = /*#__PURE__*/ function(VisualState) {
    VisualState["Lozenge"] = "lozenge";
    VisualState["FullPanel"] = "full-panel";
    return VisualState;
}({});
var $e6e9da68cec0ea42$export$264ad599d7cef668 = /*#__PURE__*/ function(Product) {
    Product["ServiceDesk"] = "serviceDesk";
    Product["Opsgenie"] = "opsgenie";
    Product["Compass"] = "compass";
    return Product;
}({});
var $e6e9da68cec0ea42$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["Local"] = "local";
    Environment["Dev"] = "dev";
    Environment["Staging"] = "staging";
    Environment["Prod"] = "prod";
    return Environment;
}({});
var $e6e9da68cec0ea42$export$f4906a03a7a2d0af = /*#__PURE__*/ function(GspSectionKey) {
    GspSectionKey["Checklist"] = "checklist";
    GspSectionKey["ProductTours"] = "productTours";
    GspSectionKey["Home"] = "home";
    return GspSectionKey;
}({});
var $e6e9da68cec0ea42$export$4f1a05ccc35315c6 = /*#__PURE__*/ function(ChecklistTabKey) {
    ChecklistTabKey["Basics"] = "basics";
    ChecklistTabKey["TeamEfficiency"] = "teamEfficiency";
    ChecklistTabKey["Incidents"] = "incidents";
    ChecklistTabKey["Changes"] = "changes";
    ChecklistTabKey["Alerts"] = "alerts";
    ChecklistTabKey["CompassAlerts"] = "compassAlerts";
    return ChecklistTabKey;
}({});
var $e6e9da68cec0ea42$export$aa90cbc80c330872 = /*#__PURE__*/ function(ProductTourKey) {
    ProductTourKey["Welcome"] = "welcome";
    ProductTourKey["IncidentManagement"] = "incident-management";
    ProductTourKey["ChangeManagement"] = "change-management";
    return ProductTourKey;
}({});
var $e6e9da68cec0ea42$export$38aab4015a34ead = /*#__PURE__*/ function(HeaderState) {
    HeaderState["Minimized"] = "minimized";
    HeaderState["Expanded"] = "expanded";
    return HeaderState;
}({});
var $e6e9da68cec0ea42$export$10cc267f702fbadd = /*#__PURE__*/ function(TaskId) {
    TaskId["CreateItsmProject"] = "servicedesk-itsm-project-created";
    TaskId["CustomizePortal"] = "servicedesk-portal-name-customized";
    TaskId["AddPortalLogo"] = "servicedesk-logo-added-to-portal";
    TaskId["SetupEmailRequests"] = "servicedesk-email-requests-setup";
    TaskId["SetupChatRequests"] = "servicedesk-chat-requests-setup";
    TaskId["SetupServices"] = "servicedesk-services-setup";
    TaskId["AddTeamMember"] = "servicedesk-team-member-added";
    TaskId["GoBeyondBasics"] = "servicedesk-basics-documentation-accessed";
    TaskId["AutomateYourWork"] = "servicedesk-team-efficiency-automate-your-work";
    TaskId["SetupKnowledgeBase"] = "servicedesk-team-efficiency-setup-knowledge-base";
    TaskId["ConnectCiCdPipeline"] = "servicedesk-change-management-pipeline-connected";
    TaskId["AddChangeApprovers"] = "servicedesk-change-management-change-approvers-added";
    TaskId["TurnOnAutomationRules"] = "servicedesk-change-management-automation-rules-on";
    TaskId["MakeTheMostOfChangeManagement"] = "servicedesk-change-management-documentation-accessed";
    TaskId["SetupProfileForNotifications"] = "opsgenie-user-profile-notifications-setup";
    TaskId["SetupTeam"] = "opsgenie-response-team-setup";
    TaskId["AssignOwnerTeamToServices"] = "opsgenie-owner-team-assigned-to-service";
    TaskId["LevelUpIncidentManagement"] = "opsgenie-incident-management-documentation-accessed";
    TaskId["CustomizeRequestChannels"] = "servicedesk-request-channels-email-portal-requests-customised";
    TaskId["CustomizeRequestTypes"] = "servicedesk-request-types-customised";
    TaskId["ReviewQueueConfigurations"] = "servicedesk-queue-configurations-reviewed";
    TaskId["EnableOpsForTeam"] = "opsgenie-enable-ops-for-team";
    TaskId["ReviewOnCallSetup"] = "opsgenie-review-oncall-setup";
    TaskId["AddIntegration"] = "opsgenie-add-integration";
    TaskId["SetupOpsNotifications"] = "opsgenie-setup-ops-notifications";
    TaskId["ReviewAlerts"] = "opsgenie-review-alerts";
    TaskId["ExploreAlertsCompass"] = "compass-explore-alerts";
    TaskId["OnCallSetupCompass"] = "compass-oncall-setup";
    TaskId["SetupIntegrationCompass"] = "compass-setup-integrations";
    TaskId["SetupOpsNotificationsCompass"] = "compass-setup-ops-notifications";
    TaskId["SetupTeamOperationsCompass"] = "compass-setup-operations";
    return TaskId;
}({});
const $e6e9da68cec0ea42$export$9846214c9c3411dc = [
    "servicedesk-itsm-project-created",
    "servicedesk-portal-name-customized",
    "servicedesk-logo-added-to-portal",
    "servicedesk-email-requests-setup",
    "servicedesk-services-setup",
    "servicedesk-team-member-added",
    "servicedesk-basics-documentation-accessed"
];
const $e6e9da68cec0ea42$export$fe6666d729b0d637 = [
    "servicedesk-itsm-project-created",
    "servicedesk-portal-name-customized",
    "servicedesk-email-requests-setup",
    "servicedesk-chat-requests-setup",
    "servicedesk-services-setup",
    "servicedesk-team-member-added"
];
const $e6e9da68cec0ea42$export$ed4dcaac45c6a484 = [
    "servicedesk-team-efficiency-automate-your-work",
    "servicedesk-team-efficiency-setup-knowledge-base"
];
const $e6e9da68cec0ea42$export$3de0dd66b0de4cdc = [
    "servicedesk-change-management-pipeline-connected",
    "servicedesk-change-management-change-approvers-added",
    "servicedesk-change-management-documentation-accessed"
];
const $e6e9da68cec0ea42$export$2852680309cf5a68 = [
    "opsgenie-user-profile-notifications-setup",
    "opsgenie-response-team-setup",
    "opsgenie-owner-team-assigned-to-service",
    "opsgenie-incident-management-documentation-accessed"
];
const $e6e9da68cec0ea42$export$4f537e3bd8843f30 = [
    "opsgenie-enable-ops-for-team",
    "opsgenie-review-oncall-setup",
    "opsgenie-add-integration",
    "opsgenie-setup-ops-notifications",
    "opsgenie-review-alerts"
];
const $e6e9da68cec0ea42$export$62a4b5d6ebfd53e9 = [
    "compass-setup-operations",
    "compass-oncall-setup",
    "compass-setup-integrations",
    "compass-setup-ops-notifications",
    "compass-explore-alerts"
];
var $e6e9da68cec0ea42$export$72401d057976d548 = /*#__PURE__*/ function(HasSeenReopenSpotlight) {
    HasSeenReopenSpotlight["Yes"] = "yes";
    HasSeenReopenSpotlight["No"] = "no";
    return HasSeenReopenSpotlight;
}({});
var $e6e9da68cec0ea42$export$7d7a98f44861e6f7 = /*#__PURE__*/ function(ContainerType) {
    ContainerType["Project"] = "project";
    return ContainerType;
}({});
var $e6e9da68cec0ea42$export$d7341fa10d264a87 = /*#__PURE__*/ function(ExplicitStringBoolean) {
    ExplicitStringBoolean["Yes"] = "yes";
    ExplicitStringBoolean["No"] = "no";
    return ExplicitStringBoolean;
}({});
var $e6e9da68cec0ea42$export$e6bec6a1026bf0b4 = /*#__PURE__*/ function(PropertyKey) {
    PropertyKey["VisualState"] = "visualState";
    PropertyKey["ActiveState"] = "activeState";
    PropertyKey["SectionState"] = "sectionState";
    PropertyKey["HasSeenReopenSpotlight"] = "hasSeenReopenSpotlight";
    return PropertyKey;
}({});

});

parcelRegister("9TJvQ", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5b9ea72599cc2c41$export$e324594224ef24da);

var $fnccg = parcelRequire("fnccg");

var $5lmbj = parcelRequire("5lmbj");

var $WkJdq = parcelRequire("WkJdq");

var $aLRn2 = parcelRequire("aLRn2");

var $6g0vj = parcelRequire("6g0vj");

var $jVCdW = parcelRequire("jVCdW");

var $kTf1j = parcelRequire("kTf1j");

var $01F1V = parcelRequire("01F1V");

var $9FflN = parcelRequire("9FflN");
const $5b9ea72599cc2c41$export$e324594224ef24da = {
    initializeState: $5lmbj.initializeState,
    fetchState: $fnccg.fetchState,
    savePanelState: $jVCdW.savePanelState,
    reopenGettingStartedPanel: $aLRn2.reopenGettingStartedPanel,
    markReopenSpotlightAsSeen: $WkJdq.markReopenSpotlightAsSeen,
    resolveTask: $6g0vj.resolveTask,
    saveProperty: $kTf1j.saveProperty,
    stopRecordingPerformanceExperiences: $9FflN.stopRecordingPerformanceExperiences,
    setOpsAdminTaskVisibility: $01F1V.setOpsAdminTaskVisibility
};

});
parcelRegister("fnccg", function(module, exports) {

$parcel$export(module.exports, "fetchState", () => $5cbeba9ce380e24a$export$f3df9013f2b58bce);

var $8LQ84 = parcelRequire("8LQ84");

var $ajpes = parcelRequire("ajpes");

var $hGgHi = parcelRequire("hGgHi");

var $k0qYG = parcelRequire("k0qYG");

var $agVdz = parcelRequire("agVdz");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $7f4tk = parcelRequire("7f4tk");

var $8zOmE = parcelRequire("8zOmE");


var $gcBmk = parcelRequire("gcBmk");

var $j25Gb = parcelRequire("j25Gb");

var $eRXyM = parcelRequire("eRXyM");

var $5lmbj = parcelRequire("5lmbj");
const $5cbeba9ce380e24a$export$e15c3a0c2c6f7c69 = {
    RESPONSE_NOT_OBJECT: 'response is not an object',
    RESPONSE_COMPLETED_ITEMS_NOT_ARRAY: 'response.completedItems is not an array',
    RESPONSE_PROPERTIES_NOT_OBJECT: 'response.properties is not an object',
    RESPONSE_PROPERTIES_USER_NOT_OBJECT: 'response.properties.user is not an object',
    RESPONSE_PROPERTIES_USER_SECTION_STATE_NOT_STRING: 'response.properties.user.sectionState is not a string',
    FAILED_PANEL_STATE_JSON_PARSE: 'Failed to parse panelState as JSON'
};
const $5cbeba9ce380e24a$var$tryInitializeState = async ({ dispatch: dispatch, ...actionProps })=>{
    const { isProjectTourSeen: isProjectTourSeen, isItsmProject: isItsmProject, projectId: projectId, isItsmSampleProject: isItsmSampleProject, enableOpsTeamMode: enableOpsTeamMode } = actionProps;
    const hasProject = ((0, $6s1PB.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation') || isProjectTourSeen) && isItsmProject && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(projectId) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(isItsmSampleProject);
    if (hasProject || // We will show the alert tab regardless of the project conditions.
    enableOpsTeamMode) await dispatch((0, $5lmbj.initializeState)(actionProps))({
        projectId: projectId
    });
};
const $5cbeba9ce380e24a$export$8f32748afb26c81d = (response)=>{
    try {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($k0qYG)))(response)) throw new Error($5cbeba9ce380e24a$export$e15c3a0c2c6f7c69.RESPONSE_NOT_OBJECT);
        const completedTasks = response?.completedItems;
        const properties = response?.properties;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8LQ84)))(completedTasks)) throw new Error($5cbeba9ce380e24a$export$e15c3a0c2c6f7c69.RESPONSE_COMPLETED_ITEMS_NOT_ARRAY);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($k0qYG)))(properties)) throw new Error($5cbeba9ce380e24a$export$e15c3a0c2c6f7c69.RESPONSE_PROPERTIES_NOT_OBJECT);
        const userProperties = properties.user;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($k0qYG)))(userProperties)) throw new Error($5cbeba9ce380e24a$export$e15c3a0c2c6f7c69.RESPONSE_PROPERTIES_USER_NOT_OBJECT);
        const sectionStateString = userProperties.sectionState;
        if (sectionStateString === undefined) return undefined;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($agVdz)))(sectionStateString)) throw new Error($5cbeba9ce380e24a$export$e15c3a0c2c6f7c69.RESPONSE_PROPERTIES_USER_SECTION_STATE_NOT_STRING);
        try {
            // further validation on this object to be done within the GSP component
            JSON.parse(sectionStateString);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (parseError) {
            throw new Error($5cbeba9ce380e24a$export$e15c3a0c2c6f7c69.FAILED_PANEL_STATE_JSON_PARSE);
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'fetchState_constructDataFromResponse',
                packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                teamName: 'itops-mithril'
            },
            attributes: {
                message: error.message
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $5cbeba9ce380e24a$export$f3df9013f2b58bce = (actionProps)=>({ getState: getState, setState: setState, dispatch: dispatch })=>async ()=>{
            const { isGspInitialized: isGspInitialized, isSaving: isSaving, data: currentData } = getState();
            const { baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent, enableOpsTeamMode: enableOpsTeamMode, teamId: teamId, enableUserCentricMode: enableUserCentricMode } = actionProps;
            // If state is being saved, do not fetch, as it could fetch old state before it has been saved.
            if (isSaving) return;
            // If state is initialized, fetch the state
            if (isGspInitialized) try {
                let response;
                try {
                    response = await (0, $7f4tk.default)((0, $5lmbj.getUrl)({
                        baseUrl: baseUrl,
                        cloudId: cloudId
                    }), {
                        method: 'GET',
                        mode: 'cors',
                        credentials: 'include'
                    });
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    // 404 indicates that the checklist is not yet initialized for the user
                    if (error.statusCode !== 404) throw error;
                }
                // If state is being saved, do not save fetched state,
                // as it will override current state that is being saved.
                if (isSaving) return;
                let data = response ? $5cbeba9ce380e24a$export$8f32748afb26c81d(response) : undefined;
                if (enableUserCentricMode && data) data = await (0, $eRXyM.handleUserCentricMode)(data, cloudId);
                else if (enableOpsTeamMode && teamId && data) {
                    const opsAdminTaskVisibility = currentData?.properties.user['ops-admin-tasks-visibility'];
                    data.properties.user['ops-admin-tasks-visibility'] = opsAdminTaskVisibility;
                    data = await (0, $j25Gb.handleOpsTeamMode)(data, teamId, cloudId);
                }
                // Skip unnecessary re-renders caused by the data reference changing
                if (!!data && (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(data, currentData)) return;
                setState({
                    data: data,
                    isGspInitialized: !!data
                });
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b)}.fetchState succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if ((0, $gcBmk.isExpectedError)(error)) return;
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'fetchState',
                        packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
            /**
		 * If state is not initialized - try to initialize it
		 * Re-getting isGspInitialized from the getState(), because it might be changed (to false) by the code above
		 */ const { isGspInitialized: currentIsGspInitialized } = getState();
            if (!currentIsGspInitialized) $5cbeba9ce380e24a$var$tryInitializeState({
                ...actionProps,
                dispatch: dispatch
            });
        };

});
const $fb1b8c66ae3d9468$export$a72c07e4474ec8ca = 'jiraServicedeskGettingStartedPanel';
const $fb1b8c66ae3d9468$export$47712c7937145142 = 320;
const $fb1b8c66ae3d9468$export$1cad4f611a1c0229 = 220;
const $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b = 'jiraServicedeskGettingStartedPanel';
const $fb1b8c66ae3d9468$export$bc8b984358922f81 = 'team';
const $fb1b8c66ae3d9468$export$d59a8243d815f2eb = 'jsm-getting-started-panel';
const $fb1b8c66ae3d9468$export$cbbd90bf5df877bd = 'cloudid';

parcelRegister("gcBmk", function(module, exports) {

$parcel$export(module.exports, "isInClassicSettingsPage", () => $7864772e348f8c72$export$a6e1eca03e2de987);
$parcel$export(module.exports, "getCurrentPageName", () => $7864772e348f8c72$export$e2c4f60e8cad01fb);
$parcel$export(module.exports, "isExpectedError", () => $7864772e348f8c72$export$8715824c16ceeca0);
$parcel$export(module.exports, "shouldIncludePathname", () => $7864772e348f8c72$export$83501d9ba065ef89);
$parcel$export(module.exports, "shouldExcludePathname", () => $7864772e348f8c72$export$8752a3c4a740bd52);
$parcel$export(module.exports, "shouldExcludeRouteName", () => $7864772e348f8c72$export$5d52a100c70d4375);
// TODO once all pages that checklist cover are in SPA, we should change this to use matchedRoute instead of pathname

var $9UgXz = parcelRequire("9UgXz");

var $fZneA = parcelRequire("fZneA");
const $7864772e348f8c72$export$d7638addf23014e7 = (pathname)=>/\/projects\/[\w\d]+\/queues\/custom\/[\d]+$/.test(pathname);
const $7864772e348f8c72$export$1b685dac913c7026 = (pathname)=>/\/projects\/[\w\d]+\/queues\/custom\/[\d]+\/[\w\W]+$/.test(pathname) || /\/browse\/[\w\W]+$/.test(pathname);
const $7864772e348f8c72$export$a05100bbf8bc68c3 = (pathname)=>/\/projects\/[\w\d]+\/reports/.test(pathname);
const $7864772e348f8c72$export$e75cc3ec1f686973 = (pathname)=>/\/projects\/[\w\d]+\/knowledge/.test(pathname);
const $7864772e348f8c72$export$6292763547421a38 = (pathname)=>/\/projects\/[\w\d]+\/customers$/.test(pathname);
const $7864772e348f8c72$export$35dc6022d31ad167 = (pathname)=>/\/projects\/[\w\d]+\/organization\/[\d]+$/.test(pathname);
const $7864772e348f8c72$export$f8f0d4e52d7e9716 = (pathname)=>$7864772e348f8c72$export$a05100bbf8bc68c3(pathname) && (pathname.endsWith('edit') || pathname.endsWith('new'));
const $7864772e348f8c72$export$753a23d2a857eec = (pathname)=>/\/projects\/[\w\d]+\/queues\/custom\/[\d]+\/edit$/.test(pathname) || /\/projects\/[\w\d]+\/queues\/custom\/new$/.test(pathname);
const $7864772e348f8c72$export$66d002c194bc72aa = (pathname)=>/\/projects\/[\w\d]+\/services\b\/*.*/.test(pathname);
const $7864772e348f8c72$export$430089990bd4af09 = (pathname)=>/\/projects\/[\w\d]+\/on-call-schedule\b\/*.*/.test(pathname);
const $7864772e348f8c72$export$a655a298d384c316 = (pathname)=>/\/projects\/[\w\d]+\/section\/incidents\b\/*.*/.test(pathname);
const $7864772e348f8c72$export$1c5f444b718144b7 = (pathname)=>/\/projects\/[\w\d]+\/section\/problems\b\/*.*/.test(pathname);
const $7864772e348f8c72$export$42dd8a49c7fa462c = (pathname)=>/\/projects\/[\w\d]+\/section\/changes\b\/*.*/.test(pathname);
const $7864772e348f8c72$export$5c77a7ea15a04e63 = (pathname)=>/\/projects\/[\w\d]+\/section\/service-requests\b\/*.*/.test(pathname);
const $7864772e348f8c72$export$dbf902576403f80e = (pathname)=>/\/secure\/project\/EditProject!default.jspa/.test(pathname);
const $7864772e348f8c72$export$458d0b4237ae1dad = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/people/.test(pathname);
const $7864772e348f8c72$export$3b5fbfd2bca32dde = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/summary/.test(pathname);
const $7864772e348f8c72$export$aeffbab88b3257bb = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/issuetypes/.test(pathname);
const $7864772e348f8c72$export$7e3236de8c2c8fcb = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/request-types\/category\/[\w]+/.test(pathname);
const $7864772e348f8c72$export$908f99db4c2098a0 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/change-management/.test(pathname);
const $7864772e348f8c72$export$c5b9a5ba6b3e9b66 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/customer-permissions/.test(pathname);
const $7864772e348f8c72$export$f4e3d864ce1a2f74 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/language/.test(pathname);
const $7864772e348f8c72$export$21361d1ad00e769e = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/portal-settings/.test(pathname);
const $7864772e348f8c72$export$6208845cb364d4de = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/email-settings/.test(pathname);
const $7864772e348f8c72$export$16978d524c086b4 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/email/.test(pathname);
const $7864772e348f8c72$export$b6d6b41b75346458 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/customer-notifications/.test(pathname);
const $7864772e348f8c72$export$5b2153f9a7427657 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/widget/.test(pathname);
const $7864772e348f8c72$export$c5434c69e9b50e81 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/feedback-settings/.test(pathname);
const $7864772e348f8c72$export$3a7002667b72e8d7 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/confluence-kb/.test(pathname);
const $7864772e348f8c72$export$542a1f79f5837827 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/sla/.test(pathname);
const $7864772e348f8c72$export$b748c9dbd5996d34 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/automation/.test(pathname);
const $7864772e348f8c72$export$455a6199a321423 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/apps/.test(pathname);
const $7864772e348f8c72$export$fa426b2da28e4ae2 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/workflows/.test(pathname);
const $7864772e348f8c72$export$fc0fba46b7584812 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/screens/.test(pathname);
const $7864772e348f8c72$export$882325faa1a194c6 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/fields/.test(pathname);
const $7864772e348f8c72$export$8bb0073f55baf38b = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/administer-versions/.test(pathname);
const $7864772e348f8c72$export$1b69f3aa169f179 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/administer-components/.test(pathname);
const $7864772e348f8c72$export$1c47b1cb87da237 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/permissions/.test(pathname);
const $7864772e348f8c72$export$ee56a66aa8efb6da = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/issuesecurity/.test(pathname);
const $7864772e348f8c72$export$6256b4d737fa56f2 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/notifications/.test(pathname);
const $7864772e348f8c72$export$3f77d24f8de610a0 = (pathname)=>/\/secure\/ViewCollectors!default.jspa/.test(pathname);
const $7864772e348f8c72$export$a6e1eca03e2de987 = (pathname)=>$7864772e348f8c72$export$dbf902576403f80e(pathname) || $7864772e348f8c72$export$458d0b4237ae1dad(pathname) || $7864772e348f8c72$export$3b5fbfd2bca32dde(pathname) || $7864772e348f8c72$export$aeffbab88b3257bb(pathname) || $7864772e348f8c72$export$7e3236de8c2c8fcb(pathname) || $7864772e348f8c72$export$908f99db4c2098a0(pathname) || $7864772e348f8c72$export$c5b9a5ba6b3e9b66(pathname) || $7864772e348f8c72$export$f4e3d864ce1a2f74(pathname) || $7864772e348f8c72$export$21361d1ad00e769e(pathname) || $7864772e348f8c72$export$6208845cb364d4de(pathname) || $7864772e348f8c72$export$16978d524c086b4(pathname) || $7864772e348f8c72$export$b6d6b41b75346458(pathname) || $7864772e348f8c72$export$5b2153f9a7427657(pathname) || $7864772e348f8c72$export$c5434c69e9b50e81(pathname) || $7864772e348f8c72$export$3a7002667b72e8d7(pathname) || $7864772e348f8c72$export$542a1f79f5837827(pathname) || $7864772e348f8c72$export$b748c9dbd5996d34(pathname) || $7864772e348f8c72$export$455a6199a321423(pathname) || $7864772e348f8c72$export$fa426b2da28e4ae2(pathname) || $7864772e348f8c72$export$fc0fba46b7584812(pathname) || $7864772e348f8c72$export$882325faa1a194c6(pathname) || $7864772e348f8c72$export$8bb0073f55baf38b(pathname) || $7864772e348f8c72$export$1b69f3aa169f179(pathname) || $7864772e348f8c72$export$1c47b1cb87da237(pathname) || $7864772e348f8c72$export$ee56a66aa8efb6da(pathname) || $7864772e348f8c72$export$6256b4d737fa56f2(pathname) || $7864772e348f8c72$export$3f77d24f8de610a0(pathname);
const $7864772e348f8c72$var$screenNameMap = {
    queues: $7864772e348f8c72$export$d7638addf23014e7,
    issues: $7864772e348f8c72$export$1b685dac913c7026,
    customers: $7864772e348f8c72$export$6292763547421a38,
    reports: $7864772e348f8c72$export$a05100bbf8bc68c3,
    knowledge: $7864772e348f8c72$export$e75cc3ec1f686973,
    services: $7864772e348f8c72$export$66d002c194bc72aa,
    onCall: $7864772e348f8c72$export$430089990bd4af09,
    incidents: $7864772e348f8c72$export$a655a298d384c316,
    problems: $7864772e348f8c72$export$1c5f444b718144b7,
    changes: $7864772e348f8c72$export$42dd8a49c7fa462c,
    serviceRequests: $7864772e348f8c72$export$5c77a7ea15a04e63,
    classicSettingsDetails: $7864772e348f8c72$export$dbf902576403f80e,
    classicSettingsPeople: $7864772e348f8c72$export$458d0b4237ae1dad,
    classicSettingsSummary: $7864772e348f8c72$export$3b5fbfd2bca32dde,
    classicSettingsIssueTypes: $7864772e348f8c72$export$aeffbab88b3257bb,
    classicSettingsRequestTypes: $7864772e348f8c72$export$7e3236de8c2c8fcb,
    classicSettingsChangeManagement: $7864772e348f8c72$export$908f99db4c2098a0,
    classicSettingsCustomerPermissions: $7864772e348f8c72$export$c5b9a5ba6b3e9b66,
    classicSettingsLanguage: $7864772e348f8c72$export$f4e3d864ce1a2f74,
    classicSettingsPortal: $7864772e348f8c72$export$21361d1ad00e769e,
    classicSettingsEmail: $7864772e348f8c72$export$6208845cb364d4de,
    classicSettingsEmailAlias: $7864772e348f8c72$export$16978d524c086b4,
    classicSettingsCustomerNotifications: $7864772e348f8c72$export$b6d6b41b75346458,
    classicSettingsWidget: $7864772e348f8c72$export$5b2153f9a7427657,
    classicSettingsFeedback: $7864772e348f8c72$export$c5434c69e9b50e81,
    classicSettingsConfluence: $7864772e348f8c72$export$3a7002667b72e8d7,
    classicSettingsSla: $7864772e348f8c72$export$542a1f79f5837827,
    classicSettingsAutomation: $7864772e348f8c72$export$b748c9dbd5996d34,
    classicSettingsApps: $7864772e348f8c72$export$455a6199a321423,
    classicSettingsWorkflows: $7864772e348f8c72$export$fa426b2da28e4ae2,
    classicSettingsScreens: $7864772e348f8c72$export$fc0fba46b7584812,
    classicSettingsFields: $7864772e348f8c72$export$882325faa1a194c6,
    classicSettingsVersions: $7864772e348f8c72$export$8bb0073f55baf38b,
    classicSettingsComponents: $7864772e348f8c72$export$1b69f3aa169f179,
    classicSettingsPermissions: $7864772e348f8c72$export$1c47b1cb87da237,
    classicSettingsIssueSecurity: $7864772e348f8c72$export$ee56a66aa8efb6da,
    classicSettingsNotifications: $7864772e348f8c72$export$6256b4d737fa56f2,
    classicSettingsIssueCollectors: $7864772e348f8c72$export$3f77d24f8de610a0
};
const $7864772e348f8c72$export$e2c4f60e8cad01fb = (pathname)=>(0, (/*@__PURE__*/$parcel$interopDefault($9UgXz)))($7864772e348f8c72$var$screenNameMap, (isCurrentScreen)=>isCurrentScreen(pathname)) || '';
const $7864772e348f8c72$export$8715824c16ceeca0 = (error)=>// these are out of our control so treat them as expected
    (0, $fZneA.isClientFetchError)(error);
const $7864772e348f8c72$var$GSP_EXCLUDED_PAGES_FILTER = {
    pathnameRegexes: [
        // 'Classic Settings Customer Notifications',
        '/servicedesk/admin/[\\w\\d]+/customer-notifications'
    ],
    pathnameRegexesForNple: [
        // 'Classic Settings Customer Notifications',
        '/servicedesk/admin/[\\w\\d]+/customer-notifications',
        // 'Portal Settings Page'
        '/jira/servicedesk/projects/[\\w\\d]+/settings/portal-settings',
        // 'People Page'
        '/plugins/servlet/project-config/[\\w\\d]+/people',
        // 'Getting Started Page'
        '/jira/servicedesk/projects/[\\w\\d]+/getting-started'
    ],
    routeNames: [
        // 'Reports',
        'servicedesk-reports',
        // 'Reports - Custom',
        'servicedesk-reports-custom',
        // 'Reports - Create',
        'servicedesk-reports-custom-create',
        // 'Reports - Edit',
        'servicedesk-reports-custom-edit',
        // 'Reports - Time Scale Issue',
        'servicedesk-reports-custom-time-scale-issue',
        // 'Reports - Time Scale',
        'servicedesk-reports-custom-time-scale',
        // 'Reports - Satisfaction',
        'servicedesk-reports-satisfaction',
        // 'Reports - Satisfaction Time Scale Issue',
        'servicedesk-reports-satisfaction-time-scale-issue',
        // 'Reports - Satisfaction TIme Scale',
        'servicedesk-reports-satisfaction-time-scale',
        // 'Reports - Type',
        'servicedesk-reports-type',
        // 'Reports - Workload',
        'servicedesk-reports-workload',
        // 'Queues - New',
        'servicedesk-queues-new',
        // 'Queues - Edit',
        'servicedesk-queues-edit'
    ]
};
const $7864772e348f8c72$var$GSP_INCLUDED_PAGES_FILTER = {
    pathnameRegexes: [
        '/jira/people/search'
    ]
};
const $7864772e348f8c72$export$83501d9ba065ef89 = (pathname)=>$7864772e348f8c72$var$GSP_INCLUDED_PAGES_FILTER.pathnameRegexes.some((regex)=>new RegExp(regex).test(pathname));
const $7864772e348f8c72$export$8752a3c4a740bd52 = (pathname, isNpleForItsmEnabled)=>isNpleForItsmEnabled ? $7864772e348f8c72$var$GSP_EXCLUDED_PAGES_FILTER.pathnameRegexesForNple.some((regex)=>new RegExp(regex).test(pathname)) : $7864772e348f8c72$var$GSP_EXCLUDED_PAGES_FILTER.pathnameRegexes.some((regex)=>new RegExp(regex).test(pathname));
const $7864772e348f8c72$export$5d52a100c70d4375 = (currentRouteName)=>$7864772e348f8c72$var$GSP_EXCLUDED_PAGES_FILTER.routeNames.some((routeName)=>routeName === currentRouteName);

});
parcelRegister("9UgXz", function(module, exports) {

var $fR2dZ = parcelRequire("fR2dZ");

var $hDnyx = parcelRequire("hDnyx");

var $bxDef = parcelRequire("bxDef");
/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */ function $73667fdf8c12f2c8$var$findKey(object, predicate) {
    return $fR2dZ(object, $bxDef(predicate, 3), $hDnyx);
}
module.exports = $73667fdf8c12f2c8$var$findKey;

});
parcelRegister("fR2dZ", function(module, exports) {
/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */ function $b8ad880aaae778a0$var$baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
            result = key;
            return false;
        }
    });
    return result;
}
module.exports = $b8ad880aaae778a0$var$baseFindKey;

});



parcelRegister("j25Gb", function(module, exports) {

$parcel$export(module.exports, "handleOpsTeamMode", () => $3e2c1b76a45e5e3a$export$b05151222ac96edd);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");


var $bZlYm = parcelRequire("bZlYm");
var $cO3PE = parcelRequire("cO3PE");
async function $3e2c1b76a45e5e3a$export$b05151222ac96edd(data, teamId, cloudId) {
    const mutatedData = {
        ...data
    };
    // we need to unset team centric items if they are set in the project page for the user
    mutatedData.completedItems = mutatedData.completedItems.filter((item)=>{
        if (item === (0, $bZlYm.TaskId).ReviewOnCallSetup || item === (0, $bZlYm.TaskId).AddIntegration) return false;
        return true;
    });
    // If user has not have right to see those items, we don't need to fetch them.
    if (mutatedData.properties.user['ops-admin-tasks-visibility'] === (0, $cO3PE.VisibilityValues).Visible) try {
        const teamCentricResponse = await (0, $7f4tk.default)(`/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/team/${teamId}/list/jsm-getting-started-panel`, {
            method: 'GET',
            mode: 'cors'
        });
        // we will override completed items by setting team-centric items
        mutatedData.completedItems = [
            ...mutatedData?.completedItems,
            ...teamCentricResponse?.completedItems
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The list is not initialized yet
        if (error.statusCode !== 404) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'handleOpsTeamMode-TeamCentricResponse',
                    packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                    teamName: 'Alexstrasza'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return mutatedData;
}

});
parcelRegister("cO3PE", function(module, exports) {

$parcel$export(module.exports, "OpsVisibilityKeys", () => $2a16e11965d11f05$export$3cae6a891a2fb0c1);
$parcel$export(module.exports, "CompassOpsVisibilityKeys", () => $2a16e11965d11f05$export$2a53d231696f66e9);
$parcel$export(module.exports, "SdVisibilityKeys", () => $2a16e11965d11f05$export$9ffa2df2d13a51e4);
$parcel$export(module.exports, "OgVisibilityKeys", () => $2a16e11965d11f05$export$37aa46ee833f23f2);
$parcel$export(module.exports, "VisibilityValues", () => $2a16e11965d11f05$export$b715b908ae0969fa);
$parcel$export(module.exports, "SdVisibilityRoles", () => $2a16e11965d11f05$export$47a23917fcedd235);
var $2a16e11965d11f05$export$3cae6a891a2fb0c1 = /*#__PURE__*/ function(OpsVisibilityKeys) {
    OpsVisibilityKeys["OpsTasksVisibility"] = "ops-tasks-visibility";
    OpsVisibilityKeys["OpsAdminTasksVisibility"] = "ops-admin-tasks-visibility";
    return OpsVisibilityKeys;
}({});
var $2a16e11965d11f05$export$2a53d231696f66e9 = /*#__PURE__*/ function(CompassOpsVisibilityKeys) {
    CompassOpsVisibilityKeys["CompassOpsTasksVisibility"] = "compass-ops-tasks-visibility";
    CompassOpsVisibilityKeys["CompassOpsAdminTasksVisibility"] = "compass-ops-admin-tasks-visibility";
    return CompassOpsVisibilityKeys;
}({});
var $2a16e11965d11f05$export$9ffa2df2d13a51e4 = /*#__PURE__*/ function(SdVisibilityKeys) {
    SdVisibilityKeys["SdStandardTasksVisibility"] = "servicedesk-standard-tasks-visibility";
    SdVisibilityKeys["SdAdvancedTasksVisibility"] = "servicedesk-advanced-tasks-visibility";
    return SdVisibilityKeys;
}({});
var $2a16e11965d11f05$export$37aa46ee833f23f2 = /*#__PURE__*/ function(OgVisibilityKeys) {
    OgVisibilityKeys["OgSetupProfileForNotificationsTaskVisibility"] = "opsgenie-user-profile-notifications-setup-task-visibility";
    OgVisibilityKeys["OgSetupTeamTaskVisibility"] = "opsgenie-response-team-setup-task-visibility";
    OgVisibilityKeys["OgAssignOwnerTeamToServicesTaskVisibility"] = "opsgenie-owner-team-assigned-to-service-task-visibility";
    OgVisibilityKeys["OgLevelUpIncidentManagementTaskVisibility"] = "opsgenie-incident-management-documentation-accessed-task-visibility";
    return OgVisibilityKeys;
}({});
var $2a16e11965d11f05$export$b715b908ae0969fa = /*#__PURE__*/ function(VisibilityValues) {
    VisibilityValues["Hidden"] = "hidden";
    VisibilityValues["Visible"] = "visible";
    VisibilityValues["Unset"] = "unset";
    return VisibilityValues;
}({});
var $2a16e11965d11f05$export$47a23917fcedd235 = /*#__PURE__*/ function(SdVisibilityRoles) {
    SdVisibilityRoles["Advanced"] = "advanced";
    SdVisibilityRoles["Standard"] = "standard";
    return SdVisibilityRoles;
}({});

});


parcelRegister("eRXyM", function(module, exports) {

$parcel$export(module.exports, "handleUserCentricMode", () => $d050cf1516f8f999$export$10caa25085bdca55);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");


var $bZlYm = parcelRequire("bZlYm");
async function $d050cf1516f8f999$export$10caa25085bdca55(data, cloudId) {
    const mutatedData = {
        ...data
    };
    // we need to unset user centric items if they are set in the ops team page for that user
    mutatedData.completedItems = mutatedData.completedItems.filter((item)=>{
        if (item === (0, $bZlYm.TaskId).ReviewOnCallSetup || item === (0, $bZlYm.TaskId).AddIntegration) return false;
        return true;
    });
    try {
        const userCentricResponse = await (0, $7f4tk.default)(`/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/jsm-getting-started-panel`, {
            method: 'GET',
            mode: 'cors'
        });
        // we will override completed items by getting/setting user-centric endpoint
        const userCentricCompletedItems = userCentricResponse.completedItems.filter((item)=>{
            if (item === (0, $bZlYm.TaskId).ReviewOnCallSetup || item === (0, $bZlYm.TaskId).AddIntegration) return true;
            return false;
        });
        mutatedData.completedItems = [
            ...mutatedData.completedItems,
            ...userCentricCompletedItems
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The list is not initialized yet
        if (error.statusCode !== 404) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'handleUserCentricMode-UserCentricResponse',
                    packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                    teamName: 'Alexstrasza'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return mutatedData;
}

});

parcelRegister("5lmbj", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $9d35edf9adbf7852$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "initializeState", () => $9d35edf9adbf7852$export$3ee49b4c70c0ec29);

var $hGgHi = parcelRequire("hGgHi");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $8zOmE = parcelRequire("8zOmE");


var $7aw4m = parcelRequire("7aw4m");

var $bQQgt = parcelRequire("bQQgt");
var $cO3PE = parcelRequire("cO3PE");

var $j25Gb = parcelRequire("j25Gb");

var $eRXyM = parcelRequire("eRXyM");

var $jVCdW = parcelRequire("jVCdW");
const $9d35edf9adbf7852$export$94df0e59ebebf4a7 = ({ baseUrl: baseUrl, cloudId: cloudId })=>`${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/aggregate/list/jsm-getting-started-panel`;
const $9d35edf9adbf7852$export$3ee49b4c70c0ec29 = (actionProps)=>({ setState: setState, getState: getState, dispatch: dispatch })=>async ({ projectId: projectId })=>{
            const { baseUrl: baseUrl, cloudId: cloudId, isItsmSampleProject: isItsmSampleProject, createAnalyticsEvent: createAnalyticsEvent, enableOpsTeamMode: enableOpsTeamMode, teamId: teamId, enableUserCentricMode: enableUserCentricMode } = actionProps;
            // Do not initialize unless it's known that project is not sample ITSM project
            if (isItsmSampleProject !== false) {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(isItsmSampleProject)) (0, $jcw0u.default)({
                    meta: {
                        id: 'initializeState_isItsmSampleProject_unknown',
                        packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    }
                });
                return;
            }
            const initializeStateOnce = async (attemptIndex, totalAttempts)=>{
                const isFinalAttempt = attemptIndex === totalAttempts - 1;
                // Stop any other updates to the state that might occur
                setState({
                    isSaving: true
                });
                // Fetch any existing data from ST (this will include any task visibility keys)
                let response;
                try {
                    response = await (0, $7f4tk.default)($9d35edf9adbf7852$export$94df0e59ebebf4a7({
                        baseUrl: baseUrl,
                        cloudId: cloudId
                    }), {
                        method: 'GET',
                        mode: 'cors',
                        credentials: 'include'
                    });
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    // 404 indicates that the checklist is not yet initialized for the user
                    if (error.statusCode === 404) {
                        setState({
                            isSaving: false,
                            isGspInitialized: false
                        });
                        return;
                    }
                    setState({
                        isSaving: false
                    });
                    if (isFinalAttempt) (0, $jcw0u.default)({
                        error: error,
                        meta: {
                            id: 'initializeState_fetch',
                            packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                            teamName: 'itops-mithril'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    throw error;
                }
                // TODO: validate properly https://jdog.jira-dev.com/browse/JIG-392
                // We can't use constructDataFromResponse because initial server data only
                // contains a subset of the full GSP state (just task visiblity keys)
                const serverData = response;
                /* Merge in server values and defaults, according to the following:
			 *  - completedItems from default state, to allow for reset behaviour with FSF override flag
			 *  - properties comes from server values first, to add task visibility and non-user properties
			 *  - default state user properties are merged in over the top of server properties to reset
			 *    things like sectionState, activeState, visualState, hasSeenReopenSpotlight in the
			 *    case of FSF override flag where server state already exists.
			 *    Assumption: the only properties contained in the default state are user properties
			 *  - projectId from current project
			 */ let data = {
                    completedItems: (0, $bQQgt.defaultGspState).completedItems,
                    properties: {
                        ...serverData.properties,
                        user: {
                            ...serverData.properties.user,
                            ...(0, $bQQgt.defaultGspState).properties.user,
                            projectId: projectId
                        }
                    }
                };
                if (enableUserCentricMode && data) data = await (0, $eRXyM.handleUserCentricMode)(data, cloudId);
                else if (enableOpsTeamMode && teamId && data) {
                    const opsAdminTaskVisibility = getState().data?.properties.user['ops-admin-tasks-visibility'] ?? (0, $cO3PE.VisibilityValues).Hidden;
                    data.properties.user['ops-admin-tasks-visibility'] = opsAdminTaskVisibility;
                    data = await (0, $j25Gb.handleOpsTeamMode)(data, teamId, cloudId);
                }
                // Save our newly merged state
                try {
                    setState({
                        data: data,
                        isGspInitialized: true,
                        isSaving: false
                    });
                    await dispatch((0, $jVCdW.savePanelState)(actionProps))(data);
                    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b)}.initializeState succeeded`);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    setState({
                        isGspInitialized: true,
                        isSaving: false
                    });
                    if (isFinalAttempt) (0, $jcw0u.default)({
                        error: error,
                        meta: {
                            id: 'initializeState',
                            packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                            teamName: 'itops-mithril'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            };
            await (0, $7aw4m.withExponentialBackoffRetries)({
                callback: initializeStateOnce,
                totalAttempts: 5,
                baseIntervalMs: 500
            });
        };

});
parcelRegister("7aw4m", function(module, exports) {

$parcel$export(module.exports, "withExponentialBackoffRetries", () => $2286d0a3de3201e1$export$344601bd15a7b6d);
const $2286d0a3de3201e1$var$waitTimeMs = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $2286d0a3de3201e1$export$344601bd15a7b6d = async ({ callback: callback, totalAttempts: totalAttempts, baseIntervalMs: baseIntervalMs })=>{
    for(let attemptIndex = 0; attemptIndex < totalAttempts; attemptIndex += 1)/* eslint-disable no-await-in-loop */ try {
        return await callback(attemptIndex, totalAttempts);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (attemptIndex + 1 < totalAttempts) // if retry attempts remain, wait time before trying again
        await $2286d0a3de3201e1$var$waitTimeMs(baseIntervalMs * Math.pow(2, attemptIndex));
        else // else if no more attempts, throw the error
        throw error;
    }
    throw Error('withExponentialBackoffRetries should not reach');
};

});

parcelRegister("bQQgt", function(module, exports) {

$parcel$export(module.exports, "defaultGspState", () => $69ce3ea601061b67$export$4db8363977bdf2d4);
$parcel$export(module.exports, "GSP", () => $69ce3ea601061b67$export$1cb8c028028700ec);

var $bZlYm = parcelRequire("bZlYm");
// This is duplicated to avoid importing from section-state
// to attempt to keep bundle size down.
// These values must be manually kept in sync.
const $69ce3ea601061b67$var$defaultSectionStateV2 = {
    version: 2,
    activeSection: (0, $bZlYm.GspSectionKey).Home,
    sections: {
        checklist: {
            headerState: (0, $bZlYm.HeaderState).Expanded,
            activeTab: (0, $bZlYm.ChecklistTabKey).Basics,
            tabs: {
                basics: {
                    activeTask: undefined
                },
                teamEfficiency: {
                    activeTask: undefined
                },
                incidents: {
                    activeTask: undefined
                },
                changes: {
                    activeTask: undefined
                },
                alerts: {
                    activeTask: undefined
                },
                compassAlerts: {
                    activeTask: undefined
                }
            }
        },
        productTours: {
            headerState: (0, $bZlYm.HeaderState).Expanded,
            activeTour: (0, $bZlYm.ProductTourKey).Welcome
        }
    }
};
const $69ce3ea601061b67$export$4db8363977bdf2d4 = {
    completedItems: [
        (0, $bZlYm.TaskId).CreateItsmProject
    ],
    properties: {
        containers: [],
        user: {
            activeState: (0, $bZlYm.ActiveState).On,
            visualState: (0, $bZlYm.VisualState).FullPanel,
            sectionState: JSON.stringify($69ce3ea601061b67$var$defaultSectionStateV2),
            hasSeenReopenSpotlight: (0, $bZlYm.HasSeenReopenSpotlight).No
        }
    }
};
const $69ce3ea601061b67$export$1cb8c028028700ec = 'GettingStartedPanel';

});

parcelRegister("jVCdW", function(module, exports) {

$parcel$export(module.exports, "savePanelState", () => $8308a60f9f5d610a$export$8756ef0989d9dd58);

var $jcw0u = parcelRequire("jcw0u");

var $7zmUm = parcelRequire("7zmUm");

var $8zOmE = parcelRequire("8zOmE");


var $7aw4m = parcelRequire("7aw4m");
const $8308a60f9f5d610a$var$getUrl = ({ baseUrl: baseUrl, cloudId: cloudId })=>`${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/jsm-getting-started-panel/properties`;
const $8308a60f9f5d610a$export$8756ef0989d9dd58 = ({ baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState })=>async (state)=>{
            const { data: data } = getState();
            try {
                if (!data) throw new Error('Trying to save panel state without current GSP state.');
                // Set the state locally without waiting for the API call
                setState({
                    data: state,
                    isSaving: true
                });
                const { sectionState: sectionState, activeState: activeState, visualState: visualState, projectId: projectId, hasSeenReopenSpotlight: hasSeenReopenSpotlight } = state.properties.user;
                await (0, $7aw4m.withExponentialBackoffRetries)({
                    callback: ()=>(0, $7zmUm.default)($8308a60f9f5d610a$var$getUrl({
                            baseUrl: baseUrl,
                            cloudId: cloudId
                        }), {
                            method: 'POST',
                            credentials: 'include',
                            body: JSON.stringify({
                                sectionState: sectionState,
                                activeState: activeState,
                                visualState: visualState,
                                projectId: projectId,
                                hasSeenReopenSpotlight: hasSeenReopenSpotlight
                            })
                        }).toPromise(),
                    totalAttempts: 5,
                    baseIntervalMs: 500
                });
                setState({
                    isSaving: false
                });
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b)}.savePanelState succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    isSaving: false
                });
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'savePanelState',
                        packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});
parcelRegister("7zmUm", function(module, exports) {

$parcel$export(module.exports, "default", () => $198ed207dec01cca$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $5HnTq = parcelRequire("5HnTq");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");
const $198ed207dec01cca$var$noContentStatus = 204;
var // This function returns a stream which emits a single string value on success, and throws
// an error on failure
// eslint-disable-next-line jira/import/no-anonymous-default-export
$198ed207dec01cca$export$2e2bcd8739ae039 = (url, options = {})=>(0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, $5HnTq.defaultOptions), options), (0, $51xpa.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
            if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, `Fetch call failed with status code: ${response.status}`, traceId);
            else throw new (0, $jJZqs.default)(status);
        }
        if (response.status === $198ed207dec01cca$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        // @ts-expect-error - TS2339 - Property 'responseText' does not exist on type 'Response'.
        return (0, $kVLXA.Observable).of(response.responseText || 'OK');
    });

});




parcelRegister("WkJdq", function(module, exports) {

$parcel$export(module.exports, "markReopenSpotlightAsSeen", () => $8fcd1eec0dfcfd09$export$e6838fe71dc9c3f5);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");


var $bZlYm = parcelRequire("bZlYm");

var $jVCdW = parcelRequire("jVCdW");
const $8fcd1eec0dfcfd09$export$e6838fe71dc9c3f5 = (actionProps)=>({ getState: getState, dispatch: dispatch })=>async ()=>{
            const { data: data } = getState();
            try {
                if (!data) throw new Error('Trying to mark reopen spotlight as seen without current state');
                await dispatch((0, $jVCdW.savePanelState)(actionProps))({
                    ...data,
                    properties: {
                        ...data.properties,
                        user: {
                            ...data.properties.user,
                            hasSeenReopenSpotlight: (0, $bZlYm.HasSeenReopenSpotlight).Yes
                        }
                    }
                });
                (0, $8zOmE.fireTrackAnalytics)(actionProps.createAnalyticsEvent({}), `${(0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b)}.markReopenSpotlightAsSeen succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'markReopenSpotlightAsSeen',
                        packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});

parcelRegister("aLRn2", function(module, exports) {

$parcel$export(module.exports, "reopenGettingStartedPanel", () => $8b8ba476581e4096$export$3f8a23b1578c0a37);

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");


var $7aw4m = parcelRequire("7aw4m");

var $bZlYm = parcelRequire("bZlYm");

var $5lmbj = parcelRequire("5lmbj");

var $kTf1j = parcelRequire("kTf1j");
const $8b8ba476581e4096$export$3f8a23b1578c0a37 = (actionProps)=>({ getState: getState, dispatch: dispatch })=>async ({ projectId: projectId } = {})=>{
            const getStateIfLoaded = async ()=>{
                const state = getState();
                const dataNotYetLoaded = state.isGspInitialized && state.data === undefined;
                if (dataNotYetLoaded) throw new Error('GSP data not yet loaded when trying to reopen');
                return state;
            };
            try {
                // a user can exit a tour and call `reopenGettingStartedPanel` before the GSP
                // state has loaded so retry a few times and hopefully the data will be there.
                // This will only log the final error that is thrown after the retries are exhausted.
                // 6 attempts at 500ms base interval gives us a ~15 second window. We could wait longer
                // but then the GSP reopening would be so far removed from closing the tour that it
                // probably isn't the user experience that we want
                const { data: data, isGspInitialized: isGspInitialized } = await (0, $7aw4m.withExponentialBackoffRetries)({
                    callback: getStateIfLoaded,
                    totalAttempts: 6,
                    baseIntervalMs: 500
                });
                if (!isGspInitialized) {
                    if (projectId !== undefined) {
                        await dispatch((0, $5lmbj.initializeState)(actionProps))({
                            projectId: projectId
                        });
                        return;
                    }
                    throw new Error('No projectId to initialize GSP with');
                }
                if (!data) throw new Error('Trying to reopen GSP without current state');
                await dispatch((0, $kTf1j.saveProperty)(actionProps))({
                    key: (0, $bZlYm.PropertyKey).VisualState,
                    value: (0, $bZlYm.VisualState).FullPanel
                });
                await dispatch((0, $kTf1j.saveProperty)(actionProps))({
                    key: (0, $bZlYm.PropertyKey).ActiveState,
                    value: (0, $bZlYm.ActiveState).On
                });
                (0, $8zOmE.fireTrackAnalytics)(actionProps.createAnalyticsEvent({}), `${(0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b)}.reopenGettingStartedPanel succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'reopenGettingStartedPanel',
                        packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});
parcelRegister("kTf1j", function(module, exports) {

$parcel$export(module.exports, "saveProperty", () => $424bc97a870986cf$export$3d751d226e9d1512);

var $jcw0u = parcelRequire("jcw0u");

var $7zmUm = parcelRequire("7zmUm");

var $8zOmE = parcelRequire("8zOmE");


var $7aw4m = parcelRequire("7aw4m");
const $424bc97a870986cf$var$getUrl = ({ baseUrl: baseUrl, cloudId: cloudId })=>`${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/jsm-getting-started-panel/properties`;
const $424bc97a870986cf$export$3d751d226e9d1512 = ({ baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState })=>async ({ key: key, value: value })=>{
            const { data: data } = getState();
            try {
                if (!data) throw new Error('Trying to save property without current GSP state.');
                // Set the state locally without waiting for the API call
                setState({
                    data: {
                        ...data,
                        properties: {
                            ...data.properties,
                            user: {
                                ...data.properties.user,
                                [key.toString()]: value
                            }
                        }
                    },
                    isSaving: true
                });
                await (0, $7aw4m.withExponentialBackoffRetries)({
                    callback: ()=>(0, $7zmUm.default)($424bc97a870986cf$var$getUrl({
                            baseUrl: baseUrl,
                            cloudId: cloudId
                        }), {
                            method: 'POST',
                            credentials: 'include',
                            body: JSON.stringify({
                                [key.toString()]: value
                            })
                        }).toPromise(),
                    totalAttempts: 5,
                    baseIntervalMs: 500
                });
                setState({
                    isSaving: false
                });
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b)}.saveProperty succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    isSaving: false
                });
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'saveProperty',
                        packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };

});


parcelRegister("6g0vj", function(module, exports) {

$parcel$export(module.exports, "resolveTask", () => $111c5eed0cfc16aa$export$7c43f246bcca61d3);

var $jcw0u = parcelRequire("jcw0u");

var $7zmUm = parcelRequire("7zmUm");

var $8zOmE = parcelRequire("8zOmE");


var $7aw4m = parcelRequire("7aw4m");

var $g5X3G = parcelRequire("g5X3G");
// Data taken from https://hello.atlassian.net/wiki/spaces/VPORT/pages/808505558/Checklist+Item+Scope+Auto+API+for+Completion
// where 'project' === 'container', 'user' === 'user' and 'instance' === 'workspace'
const $111c5eed0cfc16aa$var$getScopeFromTaskId = (taskId)=>{
    switch(taskId){
        // String literals used instead of `TaskId.<task>` for flow to acknowledge
        // that this is an exhaustive switch statement
        case 'servicedesk-itsm-project-created':
        case 'servicedesk-portal-name-customized':
        case 'servicedesk-logo-added-to-portal':
        case 'servicedesk-email-requests-setup':
        case 'servicedesk-team-member-added':
            return 'container';
        case 'servicedesk-change-management-documentation-accessed':
        case 'servicedesk-basics-documentation-accessed':
        case 'servicedesk-queue-configurations-reviewed':
        case 'servicedesk-request-types-customised':
        case 'servicedesk-request-channels-email-portal-requests-customised':
        case 'servicedesk-chat-requests-setup':
            return 'user';
        case 'servicedesk-services-setup':
        case 'servicedesk-change-management-pipeline-connected':
        case 'servicedesk-change-management-change-approvers-added':
        case 'servicedesk-change-management-automation-rules-on':
            return 'workspace';
        // Note that the following should only ever be completed in
        // Opsgenie but they are included here for type completeness
        case 'opsgenie-user-profile-notifications-setup':
        case 'opsgenie-incident-management-documentation-accessed':
            return 'user';
        case 'opsgenie-response-team-setup':
        case 'opsgenie-owner-team-assigned-to-service':
            return 'workspace';
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            taskId; // type level assertion that we have an exhaustive switch
            throw new Error(`Unknown scope for task ${taskId}`); // runtime assertion
    }
};
const $111c5eed0cfc16aa$export$94df0e59ebebf4a7 = ({ baseUrl: baseUrl, cloudId: cloudId, scope: scope, projectId: projectId, taskId: taskId })=>{
    let scopePath = ''; // scope === 'workspace'
    if (scope === 'container') scopePath = `project/${projectId}/`;
    if (scope === 'user') scopePath = 'user/';
    return `${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/${scopePath}list/jsm-getting-started-panel/item/${taskId}`;
};
const $111c5eed0cfc16aa$export$7c43f246bcca61d3 = ({ baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState })=>async (taskId)=>{
            const { data: data } = getState();
            try {
                if (!data) return;
                const { completedItems: completedItems, properties: properties } = data;
                const isTaskAlreadyCompleted = completedItems.includes(taskId);
                if (!isTaskAlreadyCompleted) {
                    const updatedTasks = [
                        ...completedItems,
                        taskId
                    ];
                    // Set the state locally without waiting for the API call
                    setState({
                        data: {
                            ...data,
                            completedItems: updatedTasks
                        },
                        isSaving: true
                    });
                    // Hit the appropriate checklist scope endpoint to add the newly completed task
                    const scope = $111c5eed0cfc16aa$var$getScopeFromTaskId(taskId);
                    const projectId = (0, $g5X3G.toProjectId)(properties.user.projectId || '');
                    await (0, $7aw4m.withExponentialBackoffRetries)({
                        callback: ()=>(0, $7zmUm.default)($111c5eed0cfc16aa$export$94df0e59ebebf4a7({
                                baseUrl: baseUrl,
                                cloudId: cloudId,
                                scope: scope,
                                projectId: projectId,
                                taskId: taskId
                            }), {
                                method: 'POST',
                                credentials: 'include'
                            }).toPromise(),
                        totalAttempts: 5,
                        baseIntervalMs: 500
                    });
                    // Resume polling for GSP state
                    setState({
                        isSaving: false
                    });
                }
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b)}.resolveTask succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    isSaving: false
                });
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'resolveTask',
                        packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});

parcelRegister("01F1V", function(module, exports) {

$parcel$export(module.exports, "setOpsAdminTaskVisibility", () => $3b1848fd2fed3e69$export$b9e7846826f1ebfd);

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");


var $cO3PE = parcelRequire("cO3PE");
const $3b1848fd2fed3e69$export$b9e7846826f1ebfd = ({ teamId: teamId, cloudId: cloudId })=>({ getState: getState, setState: setState })=>async ()=>{
            const { data: data } = getState();
            if (!data) throw new Error('Trying to set ops admin task visibility without current GSP state.');
            try {
                const adminTaskVisibilityResponse = await (0, $7f4tk.default)(`/gateway/api/jsm/ops/web/${cloudId}/v1/onboarding/full-panel-access?platformTeamId=${teamId}
            `, {
                    method: 'GET'
                });
                const visibility = adminTaskVisibilityResponse.embeddedValue ? (0, $cO3PE.VisibilityValues).Visible : (0, $cO3PE.VisibilityValues).Hidden;
                setState({
                    data: {
                        ...data,
                        properties: {
                            ...data.properties,
                            user: {
                                ...data.properties.user,
                                'ops-admin-tasks-visibility': visibility
                            }
                        }
                    }
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    data: {
                        ...data,
                        properties: {
                            ...data.properties,
                            user: {
                                ...data.properties.user,
                                'ops-admin-tasks-visibility': (0, $cO3PE.VisibilityValues).Hidden
                            }
                        }
                    }
                });
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'setOpsAdminTaskVisibility',
                        packageName: (0, $fb1b8c66ae3d9468$export$b8b9d90f9e5bd72b),
                        teamName: 'Alexstrasza'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };

});

parcelRegister("9FflN", function(module, exports) {

$parcel$export(module.exports, "stopRecordingPerformanceExperiences", () => $0ed29e6b515a7853$export$3566fd94709fa84a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $0ed29e6b515a7853$export$3566fd94709fa84a = ()=>({ setState: setState })=>()=>{
            setState({
                shouldRecordPerformanceExperiences: false
            });
        };

});



parcelRegister("cf7yQ", function(module, exports) {

$parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", () => $8aa55ef5824c4e4d$export$46976e0f90edfcfe);
$parcel$export(module.exports, "JsdGettingStartedPanel", () => $8aa55ef5824c4e4d$export$6f9913539cfb4ab6);
$parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", () => $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad);
$parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", () => $8aa55ef5824c4e4d$export$c7732c55900cf0b9);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("sXYgA")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanel = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("2OvSt")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("f6mEW")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight = (0, $b7Svb.lazyAfterPaint)(()=>(parcelRequire("1oRHz")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
});
const $8aa55ef5824c4e4d$export$46976e0f90edfcfe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-should-render",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender, null));
$8aa55ef5824c4e4d$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
const $8aa55ef5824c4e4d$export$6f9913539cfb4ab6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanel, null));
$8aa55ef5824c4e4d$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
const $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-open-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton, null));
$8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
const $8aa55ef5824c4e4d$export$c7732c55900cf0b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-reopen-spotlight",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight, null));
$8aa55ef5824c4e4d$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';

});
parcelRegister("sXYgA", function(module, exports) {

let $057122a3b41c04fd$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $057122a3b41c04fd$var$load("eNmuD"),
    $057122a3b41c04fd$var$load("chQyv")
]).then(()=>parcelRequire('hZyYK'));

});

parcelRegister("2OvSt", function(module, exports) {

let $20c8fa806ea6db90$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $20c8fa806ea6db90$var$load("eNmuD"),
    $20c8fa806ea6db90$var$load("cM9em"),
    $20c8fa806ea6db90$var$load("fr9NE"),
    $20c8fa806ea6db90$var$load("3Xgpx")
]).then(()=>parcelRequire('2NciN'));

});

parcelRegister("f6mEW", function(module, exports) {

let $afe8fe3c672ff16f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $afe8fe3c672ff16f$var$load("eNmuD"),
    $afe8fe3c672ff16f$var$load("cM9em"),
    $afe8fe3c672ff16f$var$load("fr9NE"),
    $afe8fe3c672ff16f$var$load("hlGg7")
]).then(()=>parcelRequire('4F6ZA'));

});

parcelRegister("1oRHz", function(module, exports) {

let $1051b0675adbeaab$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1051b0675adbeaab$var$load("eNmuD"),
    $1051b0675adbeaab$var$load("cM9em"),
    $1051b0675adbeaab$var$load("fr9NE"),
    $1051b0675adbeaab$var$load("eXDqW")
]).then(()=>parcelRequire('6Wput'));

});


parcelRegister("lXCei", function(module, exports) {

$parcel$export(module.exports, "useInitializeActiveTab", () => $5c30285de08a922f$export$b0f185249c3d08fd);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $htI2Q = parcelRequire("htI2Q");

var $6juLJ = parcelRequire("6juLJ");

var $bQQgt = parcelRequire("bQQgt");
var $bZlYm = parcelRequire("bZlYm");
const $5c30285de08a922f$export$b0f185249c3d08fd = (activeTabName, gspProjectId)=>{
    const { isFirstProject: isFirstProject, isFirstProjectItsm: isFirstProjectItsm } = (0, $htI2Q.useIsFirstProjectITSM)(gspProjectId);
    const isNpleForItsmEnabled = isFirstProject && isFirstProjectItsm && (0, $6s1PB.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation');
    const [{ data: gspStateData }, { saveProperty: saveProperty }] = (0, $6juLJ.useGettingStartedPanelState)();
    const [isInitializedActiveTab, setIsInitializedActiveTab] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (activeTabName === '') return;
        if (!isInitializedActiveTab && isNpleForItsmEnabled && gspStateData) {
            const sectionStateJSON = gspStateData.properties?.user?.sectionState ?? (0, $bQQgt.defaultGspState).properties.user.sectionState;
            const sectionState = JSON.parse(sectionStateJSON);
            if (sectionState.sections.checklist.activeTab !== activeTabName) {
                sectionState.sections.checklist.activeTab = activeTabName;
                saveProperty({
                    key: (0, $bZlYm.PropertyKey).SectionState,
                    value: JSON.stringify(sectionState)
                });
            }
            setIsInitializedActiveTab(true);
        }
    }, [
        isNpleForItsmEnabled,
        gspStateData,
        saveProperty,
        activeTabName,
        isInitializedActiveTab
    ]);
    const resetInitialization = ()=>setIsInitializedActiveTab(false);
    return {
        resetInitialization: resetInitialization
    };
};

});

parcelRegister("6XsPQ", function(module, exports) {

$parcel$export(module.exports, "HistoryAdapter", () => $c364a1ba7d823379$export$d852f51b8427aefc);

var $5uXOq = parcelRequire("5uXOq");

var $1bQGJ = parcelRequire("1bQGJ");

var $8oKIZ = parcelRequire("8oKIZ");
// eslint-disable-next-line jira/react/no-class-components
class $c364a1ba7d823379$var$HistoryAdapterComponent extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.compatibleHistory = (0, $8oKIZ.createReactRouterCompatibleHistory)(props.history);
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.children !== this.props.children;
    }
    componentWillUnmount() {
        this.compatibleHistory.destroy && this.compatibleHistory.destroy();
    }
    render() {
        const { children: children } = this.props;
        return children(this.compatibleHistory);
    }
}
const $c364a1ba7d823379$export$d852f51b8427aefc = (0, $1bQGJ.withRouter)($c364a1ba7d823379$var$HistoryAdapterComponent);

});
parcelRegister("8oKIZ", function(module, exports) {

$parcel$export(module.exports, "createReactRouterCompatibleHistory", () => $e043da36553b4806$export$2df73cd79c2401bf);

var $bxYf9 = parcelRequire("bxYf9");
const $e043da36553b4806$export$2df73cd79c2401bf = (history)=>{
    let cleaned = false;
    let listeners = [];
    // @ts-expect-error - TS2304 - Cannot find name 'HistoryAction'.
    const listen = (callback)=>{
        if (cleaned) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const unsubscribe = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(history.listen(callback));
        const listener = {
            unsubscribe: unsubscribe
        };
        listeners.push(listener);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(()=>{
            listener.unsubscribe();
        });
    };
    const cleanup = ()=>{
        listeners.forEach(({ unsubscribe: unsubscribe })=>{
            unsubscribe();
        });
        cleaned = true;
        listeners = [];
    };
    return {
        get length () {
            return history.length;
        },
        get location () {
            return history.location;
        },
        get action () {
            return history.action;
        },
        get index () {
            return history.index;
        },
        get entries () {
            return history.entries;
        },
        // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
        push: (path, state)=>history.push(path, state),
        // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
        replace: (path, state)=>history.replace(path, state),
        // @ts-expect-error - TS7006 - Parameter 'n' implicitly has an 'any' type.
        go: (n)=>history.go(n),
        goBack: ()=>history.goBack(),
        goForward: ()=>history.goForward(),
        // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
        createHref: (...args)=>history.createHref(...args),
        // Memory only
        // @ts-expect-error - TS7006 - Parameter 'n' implicitly has an 'any' type.
        canGo: (n)=>{
            if (history.canGo) return history.canGo(n);
            return true;
        },
        listen: listen,
        // @ts-expect-error - TS7006 - Parameter 'blocker' implicitly has an 'any' type.
        block: (blocker)=>history.block(blocker),
        destroy: cleanup
    };
};

});


parcelRegister("jprGi", function(module, exports) {

$parcel$export(module.exports, "default", () => $537b592746139f5e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $abfgz = parcelRequire("abfgz");
var $8b97b = parcelRequire("8b97b");

var $eeSmy = parcelRequire("eeSmy");

var $llJ2w = parcelRequire("llJ2w");

const $537b592746139f5e$var$EmbeddableDirectory = (props)=>{
    const { addFlag: addFlag, appName: appName, contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint, locale: locale, push: push, replace: replace, docTitle: docTitle, statusCodeHandlers: statusCodeHandlers, env: env, history: history, isSentryEnabled: isSentryEnabled = true, cloudId: cloudId, orgId: orgId, teamCentralHandlers: teamCentralHandlers, subProduct: subProduct, productFeatureFlags: productFeatureFlags, invitePeopleHandlers: invitePeopleHandlers, isAIEnabled: isAIEnabled } = props;
    if (env) (0, $eeSmy.setEnv)(env);
    const analyticsClient = (0, $abfgz.useSetupAnalyticsClient)(cloudId, appName, subProduct);
    const apolloClient = (0, $8b97b.useSetupApolloClient)(cloudId);
    if (!analyticsClient) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $llJ2w.default), {
        apolloClient: apolloClient,
        analytics: analyticsClient,
        appName: appName,
        contextSpaPaths: contextSpaPaths,
        contextEntryPoint: contextEntryPoint,
        env: env,
        push: push,
        replace: replace,
        addFlag: addFlag,
        locale: locale,
        docTitle: docTitle,
        statusCodeHandlers: statusCodeHandlers,
        history: history,
        cloudId: cloudId,
        orgId: orgId,
        teamCentralHandlers: teamCentralHandlers,
        skipI18nProvider: false,
        productFeatureFlags: productFeatureFlags,
        invitePeopleHandlers: invitePeopleHandlers,
        isSentryEnabled: isSentryEnabled,
        isAIEnabled: isAIEnabled
    });
};
var $537b592746139f5e$export$2e2bcd8739ae039 = $537b592746139f5e$var$EmbeddableDirectory;

});
parcelRegister("abfgz", function(module, exports) {

$parcel$export(module.exports, "useSetupAnalyticsClient", () => $6a21751ea8f54128$export$bcd55e98e7c6e45e);

var $5uXOq = parcelRequire("5uXOq");

var $bEDgO = parcelRequire("bEDgO");
function $6a21751ea8f54128$var$getAnalyticsSubproduct(appName, subProduct) {
    if (!subProduct) return appName;
    return `jira-${subProduct}-directory`;
}
function $6a21751ea8f54128$export$bcd55e98e7c6e45e(cloudId, appName, subProduct) {
    const analyticsSubProduct = (0, $5uXOq.useMemo)(()=>$6a21751ea8f54128$var$getAnalyticsSubproduct(appName, subProduct), [
        appName,
        subProduct
    ]);
    const [analyticsClient, setAnalyticsClient] = (0, $5uXOq.useState)((0, $bEDgO.getAnalyticsClient)({
        mode: appName,
        subproduct: analyticsSubProduct,
        cloudId: cloudId
    }));
    // setup analytics object
    (0, $5uXOq.useEffect)(()=>{
        if (!cloudId) return;
        const analytics = (0, $bEDgO.getAnalyticsClient)({
            mode: appName,
            subproduct: analyticsSubProduct,
            cloudId: cloudId
        });
        setAnalyticsClient(analytics);
    }, [
        cloudId,
        analyticsSubProduct,
        appName
    ]);
    // TODO: fix-me - currently, cloudId is required to render People app.
    // When analytics client without cloud id is used, Cypress test `dev-packages/cypress/src/specs/analytics.spec.ts` is flaky.
    // It seems that the analytics client without cloud id used first, then analytics client with cloud is replaced, but the app does not re-render in Cypress tests.
    return cloudId ? analyticsClient : undefined;
}

});
parcelRegister("bEDgO", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsClient", () => $0b3ce4afe77c042b$export$fde53e78fd93a54d);

var $aT5yh = parcelRequire("aT5yh");
var $9etNK = parcelRequire("9etNK");

var $4I3sQ = parcelRequire("4I3sQ");
var $971Nd = parcelRequire("971Nd");
var $eeSmy = parcelRequire("eeSmy");

var $kYARE = parcelRequire("kYARE");

var $cprXC = parcelRequire("cprXC");

var $6R9c8 = parcelRequire("6R9c8");

var $9NUk1 = parcelRequire("9NUk1");
function $0b3ce4afe77c042b$var$getServerName() {
    return window.location.hostname;
}
const { LOCAL: $0b3ce4afe77c042b$var$LOCAL, DEV: $0b3ce4afe77c042b$var$DEV, STAGING: $0b3ce4afe77c042b$var$STAGING, PROD: $0b3ce4afe77c042b$var$PROD } = (0, $9etNK.envType);
const $0b3ce4afe77c042b$var$ENV_MAP = {
    local: $0b3ce4afe77c042b$var$LOCAL,
    test: $0b3ce4afe77c042b$var$LOCAL,
    adev: $0b3ce4afe77c042b$var$DEV,
    'stg-east': $0b3ce4afe77c042b$var$STAGING,
    stg: $0b3ce4afe77c042b$var$STAGING
};
const $0b3ce4afe77c042b$var$getEnvType = (env)=>{
    return $0b3ce4afe77c042b$var$ENV_MAP[env] || $0b3ce4afe77c042b$var$PROD;
};
const $0b3ce4afe77c042b$var$analyticsConfig = (0, $971Nd.getConfig)().analytics;
const $0b3ce4afe77c042b$var$SUB_PRODUCT_DEFAULT = 'siteDirectory';
const $0b3ce4afe77c042b$var$PRODUCT_DEFAULT = 'people';
class $0b3ce4afe77c042b$var$AnalyticsClient {
    constructor(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    options = {}, { commonProperties: commonProperties = {}, eventPrefix: eventPrefix = 'atlassian.people', subproduct: subproduct = $0b3ce4afe77c042b$var$SUB_PRODUCT_DEFAULT, cloudId: cloudId = '' } = {}){
        const customOptions = {
            commonProperties: commonProperties,
            eventPrefix: eventPrefix
        };
        this.cloudId = cloudId;
        this.commonProperties = customOptions.commonProperties;
        this.eventPrefix = customOptions.eventPrefix;
        this.state = {
            analyticsscheme: $0b3ce4afe77c042b$var$analyticsConfig.scheme,
            analyticsserver: $0b3ce4afe77c042b$var$analyticsConfig.server,
            server: $0b3ce4afe77c042b$var$getServerName(),
            product: $0b3ce4afe77c042b$var$PRODUCT_DEFAULT,
            isReadyToSend: false,
            pendingEventsQueue: [],
            storage_key: 'atlassian.people.analytics',
            ...options
        };
        // New GAS pipeline client
        this.analyticsWebClient = new (0, $aT5yh.default)({
            env: $0b3ce4afe77c042b$var$getEnvType((0, $eeSmy.getEnv)()),
            product: 'people',
            subproduct: subproduct
        }, {});
        this.initUFO();
        this._expTracker = (0, $6R9c8.configureNewTracker)(this);
    }
    setTeamId(teamId) {
        this.teamId = teamId;
    }
    initUFO() {
        if ((0, $4I3sQ.getAppName)() !== (0, $4I3sQ.AppNames).STANDALONE_DIRECTORY) return;
        (0, $kYARE.payloadPublisher).setup({
            gasv3: this.analyticsWebClient,
            product: 'people',
            app: {
                // @ts-ignore
                version: {
                    web: __VERSION__
                }
            },
            region: (0, $eeSmy.getEnv)()
        });
    // import { ufologger } from @atlassian/ufo and uncomment the following line to see UFO logs:
    // ufologger.enable();
    }
    getAnalyticsWebClient() {
        return this.analyticsWebClient;
    }
    expTracker() {
        return this._expTracker;
    }
    sendTrackEvent(eventData) {
        this.analyticsWebClient.sendTrackEvent(eventData);
    }
    /**
	 * Checks whether the library has been initialized and decides whether the event should be sent or cached
	 * @param {*} eventType Values could be 'track', 'screen', 'operation, 'ui'
	 * @param {*} eventData Data of the event
	 * @param {Function} cb Callback is called when the event is sent successfully.
	 */ canEventBeSent(eventType, eventData, cb) {
        if (this.state.isReadyToSend) return true;
        // add to `pendingEventsQueue` in order to send the event later
        this.state.pendingEventsQueue.push({
            eventType: eventType,
            eventData: eventData,
            // `eventCallback` is called when `pendingEventsQueue` is processed and eventData is sent
            eventCallback: cb
        });
        return false;
    }
    pushTrackEvent(eventData, cb) {
        if (this.canEventBeSent('track', eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendTrackEvent(event, cb);
        }
    }
    pushUIEvent(eventData, cb) {
        if (this.canEventBeSent('ui', eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendUIEvent(event, cb);
        }
    }
    pushOperationalEvent(eventData, cb) {
        if (this.canEventBeSent('operation', eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendOperationalEvent(event, cb);
        }
    }
    pushScreenEvent(eventData, cb) {
        const additionalAttributes = (0, $9NUk1.default).get();
        (0, $9NUk1.default).markUsed();
        if (eventData && additionalAttributes) eventData = {
            ...eventData,
            attributes: {
                ...additionalAttributes,
                ...eventData.attributes
            }
        };
        if (this.canEventBeSent('screen', eventData, cb)) this.analyticsWebClient.sendScreenEvent(eventData, cb);
    }
    buildEventPayload(eventData) {
        const attributes = this.teamId || eventData.attributes ? {
            ...this.teamId && {
                teamId: this.teamId
            },
            ...eventData.attributes
        } : null;
        return {
            containerType: null,
            containerId: null,
            objectType: null,
            objectId: null,
            source: null,
            actionSubject: null,
            action: null,
            actionSubjectId: null,
            tags: [],
            ...eventData,
            attributes: attributes
        };
    }
    mapAnalyticsKeyToEvent(analyticsKey) {
        return (0, $cprXC.analyticsKeyToEventMap)[analyticsKey] || null;
    }
    /**
	 *  Start up E-MAU events in the new analytics pipeline (GAS v3)
	 *  See: https://extranet.atlassian.com/display/BPO/DACI%3A+E-MAU+Definition
	 */ async startUIViewedEvent(principalUserId) {
        if (!principalUserId) return;
        this.analyticsWebClient.setTenantInfo((0, $9etNK.tenantType).CLOUD_ID, this.cloudId || '');
        this.analyticsWebClient.setUserInfo((0, $9etNK.userType).ATLASSIAN_ACCOUNT, principalUserId);
        this.analyticsWebClient.startUIViewedEvent();
        this.state.isReadyToSend = true;
        this.flushPendingEventsQueue();
    }
    /**
	 * Flush all the pending events in the queue
	 */ flushPendingEventsQueue() {
        this.state.pendingEventsQueue.forEach((element)=>{
            const { eventType: eventType, eventData: eventData, eventCallback: eventCallback } = element;
            switch(eventType){
                case 'track':
                    this.pushTrackEvent(eventData, eventCallback);
                    break;
                case 'ui':
                    this.pushUIEvent(eventData, eventCallback);
                    break;
                case 'screen':
                    this.pushScreenEvent(eventData, eventCallback);
                    break;
                case 'operation':
                    this.pushOperationalEvent(eventData, eventCallback);
                    break;
                default:
                    // eslint-disable-next-line no-console
                    console.error('Invalide Event :', element);
                    break;
            }
        });
    }
}
var $0b3ce4afe77c042b$export$2e2bcd8739ae039 = $0b3ce4afe77c042b$var$AnalyticsClient;
let $0b3ce4afe77c042b$var$preservedAnaylticsClient;
const $0b3ce4afe77c042b$export$fde53e78fd93a54d = ({ mode: mode, subproduct: subproduct, cloudId: cloudId })=>{
    if (!cloudId) return;
    if ($0b3ce4afe77c042b$var$preservedAnaylticsClient) return $0b3ce4afe77c042b$var$preservedAnaylticsClient;
    $0b3ce4afe77c042b$var$preservedAnaylticsClient = new $0b3ce4afe77c042b$var$AnalyticsClient({}, {
        commonProperties: {
            mode: mode
        },
        subproduct: subproduct,
        cloudId: cloudId
    });
    return $0b3ce4afe77c042b$var$preservedAnaylticsClient;
};

});
parcelRegister("4I3sQ", function(module, exports) {

$parcel$export(module.exports, "AppNames", () => $fabd99beed616c13$export$b767e803e7ca9563);
$parcel$export(module.exports, "getAppName", () => $fabd99beed616c13$export$dcecb2dbc7fe753c);
var $fabd99beed616c13$export$b767e803e7ca9563 = /*#__PURE__*/ function(AppNames) {
    AppNames["EMBEDDABLE_DIRECTORY"] = "embeddableDirectory";
    AppNames["STANDALONE_DIRECTORY"] = "standaloneDirectory";
    return AppNames;
}({});
function $fabd99beed616c13$export$dcecb2dbc7fe753c() {
    // @ts-ignore
    return window.__app_name__ || "embeddableDirectory";
}

});

parcelRegister("971Nd", function(module, exports) {

$parcel$export(module.exports, "isFedramp", () => $36a4ac9f74fa0a2a$export$634ecc602a6871aa);
$parcel$export(module.exports, "getConfig", () => $36a4ac9f74fa0a2a$export$44487a86467333c3);

var $dyczo = parcelRequire("dyczo");

var $b4PzF = parcelRequire("b4PzF");

var $4I3sQ = parcelRequire("4I3sQ");

var $eeSmy = parcelRequire("eeSmy");

var $2KzEm = parcelRequire("2KzEm");
// default configs is also config for production env
const $36a4ac9f74fa0a2a$var$productionConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.atlassian.com'
};
const $36a4ac9f74fa0a2a$var$devAndStagingConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.stg.atlassian.com'
};
const $36a4ac9f74fa0a2a$var$localAndTestConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'http',
        server: 'localhost:3000'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.stg.atlassian.com'
};
const $36a4ac9f74fa0a2a$var$fedrampConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.atlassian-us-gov-mod.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralDisabled: true
};
const $36a4ac9f74fa0a2a$var$EnvOverrideKeys = [
    'adev',
    'stg-east',
    'local',
    'test',
    'fedramp',
    'prod-east'
];
const $36a4ac9f74fa0a2a$var$environmentOverrides = {
    'prod-east': $36a4ac9f74fa0a2a$var$productionConfig,
    local: {
        ...(0, $2KzEm.LOCAL_PRODUCTION_BACKEND) ? $36a4ac9f74fa0a2a$var$productionConfig : $36a4ac9f74fa0a2a$var$localAndTestConfig,
        analytics: {
            scheme: 'http',
            server: `${(0, (/*@__PURE__*/$parcel$interopDefault($dyczo))).location.hostname}:3000`
        }
    },
    test: {
        ...$36a4ac9f74fa0a2a$var$localAndTestConfig
    },
    adev: $36a4ac9f74fa0a2a$var$devAndStagingConfig,
    'stg-east': $36a4ac9f74fa0a2a$var$devAndStagingConfig,
    fedramp: $36a4ac9f74fa0a2a$var$fedrampConfig
};
const $36a4ac9f74fa0a2a$var$cachedConfig = {};
function $36a4ac9f74fa0a2a$export$634ecc602a6871aa() {
    return (0, $b4PzF.isFedRamp)();
}
function $36a4ac9f74fa0a2a$export$44487a86467333c3() {
    const env = $36a4ac9f74fa0a2a$export$634ecc602a6871aa() ? 'fedramp' : (0, $eeSmy.getEnv)();
    const appName = (0, $4I3sQ.getAppName)();
    const key = `${env}_${appName}`;
    if (!$36a4ac9f74fa0a2a$var$cachedConfig[key]) {
        if ($36a4ac9f74fa0a2a$var$EnvOverrideKeys.includes(env)) $36a4ac9f74fa0a2a$var$cachedConfig[key] = {
            ...$36a4ac9f74fa0a2a$var$environmentOverrides[env]
        };
        else // fallback to prod as customers can have custom domains.
        $36a4ac9f74fa0a2a$var$cachedConfig[key] = {
            ...$36a4ac9f74fa0a2a$var$environmentOverrides['prod-east']
        };
    }
    return $36a4ac9f74fa0a2a$var$cachedConfig[key];
}

});
parcelRegister("eeSmy", function(module, exports) {

$parcel$export(module.exports, "setEnv", () => $83c5514eada17774$export$84bc02d3c7a6b55f);
$parcel$export(module.exports, "getEnv", () => $83c5514eada17774$export$4bd44a2aa29d3d6e);

var $dyczo = parcelRequire("dyczo");

var $2KzEm = parcelRequire("2KzEm");
var $83c5514eada17774$export$e7dfafc24fab792e = /*#__PURE__*/ function(MicrosEnv) {
    MicrosEnv["ADEV"] = "adev";
    MicrosEnv["STG_EAST"] = "stg-east";
    MicrosEnv["PROD_EAST"] = "prod-east";
    return MicrosEnv;
}({});
const $83c5514eada17774$export$d76bdf9f4281ae1b = {
    local: 'local',
    test: 'test',
    prod: 'prod',
    stg: 'staging',
    ["adev"]: 'staging',
    ["stg-east"]: 'staging',
    ["prod-east"]: 'production'
};
const $83c5514eada17774$var$SIMPLE_TO_DAMN_COMPLEX_ENV = {
    prod: 'prod-east',
    stg: 'stg-east'
};
let $83c5514eada17774$var$presetEnv;
const $83c5514eada17774$export$84bc02d3c7a6b55f = (env)=>{
    const envOverride = $83c5514eada17774$var$SIMPLE_TO_DAMN_COMPLEX_ENV[env];
    if (envOverride) $83c5514eada17774$var$presetEnv = envOverride;
};
function $83c5514eada17774$export$4bd44a2aa29d3d6e() {
    if ($83c5514eada17774$var$presetEnv) return $83c5514eada17774$var$presetEnv;
    if (0, $2KzEm.DEV) return 'local';
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($dyczo))).__env__;
}
function $83c5514eada17774$export$15b8d8b1ba394f55() {
    return $83c5514eada17774$export$d76bdf9f4281ae1b[$83c5514eada17774$export$4bd44a2aa29d3d6e()];
}

});
parcelRegister("2KzEm", function(module, exports) {

$parcel$export(module.exports, "DEV", () => $cdaddbcbb00c269a$export$404582bc18fe4d9e);
$parcel$export(module.exports, "LOCAL_PRODUCTION_BACKEND", () => $cdaddbcbb00c269a$export$771a63345d182ddd);
// @ts-ignore
const $cdaddbcbb00c269a$export$404582bc18fe4d9e = typeof __DEV__ !== 'undefined' && __DEV__;
const $cdaddbcbb00c269a$export$771a63345d182ddd = // @ts-ignore
typeof __LOCAL_PRODUCTION_BACKEND__ !== 'undefined' && // @ts-ignore
__LOCAL_PRODUCTION_BACKEND__;

});



parcelRegister("cprXC", function(module, exports) {

$parcel$export(module.exports, "AnalyticsKeys", () => $4a967021ba12bfa2$export$e8d1ded05852e864);
$parcel$export(module.exports, "analyticsKeyToEventMap", () => $4a967021ba12bfa2$export$6430c2bbc66a6fa);
$parcel$export(module.exports, "AnalyticsEventSource", () => $4a967021ba12bfa2$export$2102531865f3e90e);
$parcel$export(module.exports, "AnalyticsEventActions", () => $4a967021ba12bfa2$export$74eee170ad238aae);
$parcel$export(module.exports, "AnalyticsEventSubjects", () => $4a967021ba12bfa2$export$670f80b77450980d);
const $4a967021ba12bfa2$export$e8d1ded05852e864 = {
    ACTIVITY_ALL_VIEW: 'activity.all.view',
    ACTIVITY_WATCHING_VIEW: 'activity.watching.view',
    HISTORY_VIEW: 'history.view',
    PEOPLE_VIEW: 'people-search.view',
    PROFILE_PAGE_VIEW: 'profile-page.view',
    AGENT_PROFILE_PAGE_VIEW: 'agent-profile-page.view',
    PROFILE_WORKED_ON_PAGE_VIEW: 'profile-worked-on-page.view',
    PROFILE_SETTINGS_CLOSE_ACCOUNT_VIEW: 'profile-settings.close-account.view',
    PROFILE_SETTINGS_EMAIL_VIEW: 'profile-settings.email.view',
    PROFILE_SETTINGS_GENERAL_VIEW: 'profile-settings.general.view',
    PROFILE_SETTINGS_PROFILE_AND_VISIBILITY_VIEW: 'profile-settings.profile-and-visibility.view',
    PROFILE_SETTINGS_PRIVACY_VIEW: 'profile-settings.privacy.view',
    PROFILE_SETTINGS_PRODUCT_VIEW: 'profile-settings.product.view',
    PROFILE_SETTINGS_SECURITY_VIEW: 'profile-settings.security.view',
    PROFILE_SETTINGS_TWO_STEP_VERIFICATION_VIEW: 'profile-settings.security.two-step-verification.view',
    PROFILE_SETTINGS_API_TOKENS_VIEW: 'profile-settings.security.api-tokens.view',
    PROFILE_SETTINGS_RECENT_DEVICES_VIEW: 'profile-settings.security.recent-devices.view',
    PROFILE_SETTINGS_CONNECTED_APPS_VIEW: 'profile-settings.connected-apps.view',
    TEAM_PROFILE_VIEW: 'team-profile.view',
    KUDOS_PAGE_VIEW: 'kudos-page.view',
    TEAM_PROFILE_BROWSE_ALL: 'team-profile.browse-all',
    ALL_TEAMS_DISABLED: 'profile-search.view.all-teams.disabled',
    // TODO: remove these once we move to a new analytics platform
    LEGACY_ACTIVITY_ALL_VIEW: 'newsfeed.view'
};
const $4a967021ba12bfa2$export$6430c2bbc66a6fa = {
    [$4a967021ba12bfa2$export$e8d1ded05852e864.PROFILE_PAGE_VIEW]: 'userProfile',
    [$4a967021ba12bfa2$export$e8d1ded05852e864.TEAM_PROFILE_BROWSE_ALL]: 'teamsPage'
};
var $4a967021ba12bfa2$export$2102531865f3e90e = /*#__PURE__*/ function(AnalyticsEventSource) {
    // `/people/<userId>` page
    AnalyticsEventSource["USER_PROFILE_SCREEN"] = "userProfileScreen";
    AnalyticsEventSource["USER_PROFILE_ABOUT"] = "userProfileAbout";
    // `/people/<userId>/work` page
    AnalyticsEventSource["USER_WORK_SCREEN"] = "userWorkScreen";
    // `/people/agent/<agentId>` page
    AnalyticsEventSource["AGENT_PROFILE_SCREEN"] = "agentProfileScreen";
    AnalyticsEventSource["AGENT_DELETE_SUCCESS_FLAG"] = "agentDeletedSuccessflag";
    AnalyticsEventSource["AGENT_DELETE_ERROR_FLAG"] = "agentDeletedErrorflag";
    // `/people/team/<teamId>` page
    AnalyticsEventSource["TEAM_PROFILE_SCREEN"] = "teamProfileScreen";
    AnalyticsEventSource["TEAM_PROFILE_ABOUT"] = "teamProfileAbout";
    AnalyticsEventSource["TEAM_RESTORE_SCREEN"] = "teamRestoreScreen";
    AnalyticsEventSource["TEAM_RESTORE_SUCCESS_FLAG"] = "teamReactivatedSuccessflag";
    AnalyticsEventSource["TEAM_RESTORE_ERROR_FLAG"] = "teamReactivatedErrorflag";
    AnalyticsEventSource["CREATE_TEAM_MODAL"] = "createTeamModal";
    // `/people/search` page
    AnalyticsEventSource["DIRECTORY_SCREEN"] = "directoryScreen";
    // new `/people/search` page
    AnalyticsEventSource["PEOPLE_HOME"] = "peopleHome";
    AnalyticsEventSource["PEOPLE_DRAWER"] = "peopleDrawer";
    // inside avatar menu
    AnalyticsEventSource["USER_MENU"] = "userMenu";
    // experimentLeaf */
    AnalyticsEventSource["ADD_PEOPLE_MODAL"] = "addPeopleModal";
    // generic metrics
    AnalyticsEventSource["CLIENT_METRICS"] = "clientMetrics";
    // generic metrics
    AnalyticsEventSource["DIRECTORY_APP"] = "directoryApp";
    AnalyticsEventSource["INITIALS_DIALOG"] = "avatarInitialsPicker";
    // /people/kudos/:uuid
    AnalyticsEventSource["KUDOS_SCREEN"] = "kudos";
    AnalyticsEventSource["PROFILE_CARD"] = "profilecard";
    // new `/people/search/teams` page
    AnalyticsEventSource["TEAMS_PAGE"] = "teamsPage";
    return AnalyticsEventSource;
}({});
var $4a967021ba12bfa2$export$74eee170ad238aae = /*#__PURE__*/ function(AnalyticsEventActions) {
    AnalyticsEventActions["ACCEPTED"] = "accepted";
    AnalyticsEventActions["CLICKED"] = "clicked";
    AnalyticsEventActions["CLOSED"] = "closed";
    AnalyticsEventActions["COLLAPSED"] = "collapsed";
    AnalyticsEventActions["CREATED"] = "created";
    AnalyticsEventActions["DECLINED"] = "declined";
    AnalyticsEventActions["DELETED"] = "deleted";
    AnalyticsEventActions["EDITED"] = "edited";
    AnalyticsEventActions["EXPANDED"] = "expanded";
    AnalyticsEventActions["EXPOSED"] = "exposed";
    AnalyticsEventActions["FAILED"] = "failed";
    AnalyticsEventActions["JOINED"] = "joined";
    AnalyticsEventActions["REDIRECTED"] = "redirected";
    AnalyticsEventActions["REMOVED"] = "removed";
    AnalyticsEventActions["SENT"] = "sent";
    AnalyticsEventActions["SORTED"] = "sorted";
    AnalyticsEventActions["STARTED"] = "started";
    AnalyticsEventActions["OPENED"] = "opened";
    AnalyticsEventActions["SHOWN"] = "shown";
    AnalyticsEventActions["SUBMITTED"] = "submitted";
    AnalyticsEventActions["SUCCEEDED"] = "succeeded";
    AnalyticsEventActions["TRIGGERED"] = "triggered";
    AnalyticsEventActions["TYPED"] = "typed";
    AnalyticsEventActions["VIEWED"] = "viewed";
    AnalyticsEventActions["MOUNTED"] = "mounted";
    AnalyticsEventActions["MOVED"] = "moved";
    AnalyticsEventActions["DRAGGED"] = "dragged";
    AnalyticsEventActions["SELECTED"] = "selected";
    return AnalyticsEventActions;
}({});
var $4a967021ba12bfa2$export$670f80b77450980d = /*#__PURE__*/ function(AnalyticsEventSubjects) {
    AnalyticsEventSubjects["TEAM_LINK"] = "teamLink";
    AnalyticsEventSubjects["BUTTON"] = "button";
    AnalyticsEventSubjects["MODAL_DIALOG"] = "modalDialog";
    AnalyticsEventSubjects["FORM"] = "form";
    AnalyticsEventSubjects["ERROR"] = "error";
    return AnalyticsEventSubjects;
}({});

});

parcelRegister("6R9c8", function(module, exports) {

$parcel$export(module.exports, "configureNewTracker", () => $3fd342dba0494632$export$54c7ecd74762af6a);
$parcel$export(module.exports, "isNetworkError", () => $3fd342dba0494632$export$476aa014e2fd89d5);

var $bFNgM = parcelRequire("bFNgM");

var $4I3sQ = parcelRequire("4I3sQ");

var $cprXC = parcelRequire("cprXC");

var $dWQK6 = parcelRequire("dWQK6");

var $8bKaH = parcelRequire("8bKaH");
function $3fd342dba0494632$export$54c7ecd74762af6a(analytics) {
    const tracker = new $3fd342dba0494632$var$DirectoryExperienceTracker({
        isNetworkOfflineError: $3fd342dba0494632$export$476aa014e2fd89d5
    });
    tracker.subscribe((event)=>{
        if (event.action === 'taskStart' || event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail') {
            const performanceAttributes = $3fd342dba0494632$var$computePerformanceAttributes(event);
            const errorAttributes = $3fd342dba0494632$var$computeErrorAttributes(event);
            const finalErrorDetails = Object.assign(errorAttributes, performanceAttributes, event.attributes, {
                // Because standalone app is deployed to prod quickly,
                // we will use this attribute to query in Splunk sooner.
                isStandalone: (0, $4I3sQ.getAppName)() === (0, $4I3sQ.AppNames).STANDALONE_DIRECTORY,
                hasBrowseUsersPermission: (0, $dWQK6.isFlagEnabled)((0, $c4887f80610693ab$export$28456d095a642fd))
            });
            const actionSubject = $3fd342dba0494632$var$sanitiseExperienceName(event.name);
            analytics.pushOperationalEvent({
                source: (0, $cprXC.AnalyticsEventSource).CLIENT_METRICS,
                actionSubject: actionSubject,
                action: event.action,
                attributes: finalErrorDetails
            });
        }
    });
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('unload', ()=>{
        tracker.abort({
            reason: 'Abort due to Window unloading',
            attributes: {
                cause: 'WINDOW_UNLOAD'
            }
        });
    });
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('pagehide', ()=>{
        tracker.abort({
            reason: 'Window unloading',
            attributes: {
                cause: 'PAGE_HIDE'
            }
        });
    });
    return tracker;
}
function $3fd342dba0494632$var$sanitiseExperienceName(name) {
    return name.replace(/[\/-]/g, '_');
}
function $3fd342dba0494632$var$computeErrorAttributes(event) {
    const attributes = {};
    if (event.action === 'taskFail' && event.error) {
        attributes.failError = event.error.message;
        attributes.traceId = event.error.traceId ?? null;
    }
    if (event.action === 'taskAbort' && event.reason) attributes.abortReason = event.reason;
    return attributes;
}
// compute sloSatisfied: true/false based on the latencySlo attribute
// for monitoring in SignalFx
function $3fd342dba0494632$var$computePerformanceAttributes(event) {
    if (event.action === 'taskStart') return {};
    const duration = event.duration;
    const latencySlo = event.attributes && event.attributes['latencySlo'];
    if (typeof duration !== 'number' || typeof latencySlo !== 'number') return {};
    return {
        sloSatisfied: duration <= latencySlo,
        taskDuration: duration,
        latencySlo: latencySlo
    };
}
class $3fd342dba0494632$var$DirectoryExperienceTracker extends (0, $bFNgM.ExperienceTracker) {
    constructor(options){
        super(options);
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if ((0, $8bKaH.isAuthError)(error)) {
            this.abort({
                name: name,
                reason: 'Abort due to user unauthenticated',
                attributes: {
                    cause: 'USER_UNAUTHENTICATED',
                    error: error,
                    ...attributes
                },
                checkForTimeout: false
            });
            return;
        }
        if ((0, $8bKaH.isErrorStatusCode)((0, $8bKaH.StatusCode).GONE, error)) {
            this.abort({
                name: name,
                reason: 'Abort due to unavailable resource',
                attributes: {
                    cause: 'GONE',
                    error: error,
                    ...attributes
                },
                checkForTimeout: false
            });
            return;
        }
        const reason = (0, $8bKaH.ignoredErrorReason)(error);
        if (reason) {
            this.abort({
                name: name,
                reason: 'Abort due to an error in ignore list',
                attributes: {
                    cause: reason,
                    ...attributes
                },
                checkForTimeout: false
            });
            return;
        }
        super.stopOnError({
            name: name,
            error: error,
            attributes: attributes
        });
    }
}
function $3fd342dba0494632$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    // @ts-ignore
    !!(error['graphQLErrors'] && error['networkError']));
}

});
const $c4887f80610693ab$export$28456d095a642fd = 'internal.browse-users-allowed';

parcelRegister("dWQK6", function(module, exports) {

$parcel$export(module.exports, "FeatureFlag", () => $da90f3e56ec6c907$export$df35587a8f95f16f);
$parcel$export(module.exports, "isFlagEnabled", () => $da90f3e56ec6c907$export$ba72073d757a1bc2);

var $2Z5MT = parcelRequire("2Z5MT");

var $eeSmy = parcelRequire("eeSmy");

var $6cAn5 = parcelRequire("6cAn5");
var $da90f3e56ec6c907$export$df35587a8f95f16f = /*#__PURE__*/ function(FeatureFlag) {
    //CA-13 Adding Tags at profile level
    FeatureFlag["ENABLE_PROJECT_CONNECT_USER_TAGS"] = "enable_skills_and_interest_tags_in_profile_page";
    //Teams in JSM Ops productFeatureFlags
    FeatureFlag["EVENT_ON_CALL_EFF"] = "event-on-call-consolidation_s97c8";
    FeatureFlag["EVENT_ON_CALL_CONSOLIDATION_STATE"] = "event-on-call-consolidation-state";
    // Control for Open Sites permissions check
    FeatureFlag["ENABLE_MOCK_OPEN_SITES_FAIL"] = "ptc-directory-ui.deny-open-sites-in-fe";
    // Atlas
    FeatureFlag["DISABLE_ATLAS_CROSSWFLOW_ADS"] = "disable_atlas_crossflow_ads";
    return FeatureFlag;
}({});
// All feature flags must be listed here so that they can be selectively fetched from LaunchDarkly
// For real execution environments, configure flags in https://app.launchdarkly.com/ppl-teams-collective/test/features
// The default values here are used as the fallback when everything else (LD, local storage cache, local overrides) fails
const $da90f3e56ec6c907$var$DEFAULT_FEATURE_FLAGS = {
    ["enable_skills_and_interest_tags_in_profile_page"]: false,
    ["ptc-directory-ui.deny-open-sites-in-fe"]: false,
    ["disable_atlas_crossflow_ads"]: false,
    ["event-on-call-consolidation_s97c8"]: false,
    ["event-on-call-consolidation-state"]: false
};
// Overrides only for local/CI environments
const $da90f3e56ec6c907$var$LOCAL_OVERRIDE_FEATURE_FLAGS = {
    // Features rolled out to 100%
    // Atlassian-only features
    ["enable_skills_and_interest_tags_in_profile_page"]: true
};
const $da90f3e56ec6c907$export$7101ae34ef1f53be = ()=>$6cAn5?.env?.NODE_ENV === 'development' || (0, $eeSmy.getEnv)() === 'local' ? {
        ...$da90f3e56ec6c907$var$DEFAULT_FEATURE_FLAGS,
        ...$da90f3e56ec6c907$var$LOCAL_OVERRIDE_FEATURE_FLAGS
    } : {
        ...$da90f3e56ec6c907$var$DEFAULT_FEATURE_FLAGS
    };
function $da90f3e56ec6c907$export$ba72073d757a1bc2(flag) {
    return (0, $2Z5MT.isFlagEnabled)(flag);
}

});
parcelRegister("2Z5MT", function(module, exports) {

$parcel$export(module.exports, "getSettingsFromStorage", () => $2c9381b44d3cd8ed$export$b40bc67e97afc0ed);
$parcel$export(module.exports, "isFlagEnabled", () => $2c9381b44d3cd8ed$export$ba72073d757a1bc2);

var $WUBOW = parcelRequire("WUBOW");

var $fDLjB = parcelRequire("fDLjB");

var $4jArG = parcelRequire("4jArG");
const $2c9381b44d3cd8ed$var$STORAGE_KEY_SETTINGS = 'atlassian.ptc-directory.settings';
function $2c9381b44d3cd8ed$export$d9d01ff109db30f0(settings) {
    (0, $fDLjB.default).setItem($2c9381b44d3cd8ed$var$STORAGE_KEY_SETTINGS, JSON.stringify(settings));
    $2c9381b44d3cd8ed$export$455c5cbefb010abd(settings);
}
function $2c9381b44d3cd8ed$export$b40bc67e97afc0ed() {
    const settingsString = (0, $fDLjB.default).getItem($2c9381b44d3cd8ed$var$STORAGE_KEY_SETTINGS);
    try {
        const parsed = settingsString ? JSON.parse(settingsString) : null;
        if ($2c9381b44d3cd8ed$var$isStringBooleanDictionary(parsed)) return parsed;
        return null;
    } catch (e) {
        (0, $WUBOW.logException)(e, 'Could not get settings from storage', {
            locallyStoredSettings: settingsString
        });
        return null;
    }
}
const $2c9381b44d3cd8ed$var$effectiveFlags = {
    ...(0, $4jArG.DEFAULT_FEATURE_FLAGS),
    ...$2c9381b44d3cd8ed$export$b40bc67e97afc0ed() || {}
};
function $2c9381b44d3cd8ed$export$455c5cbefb010abd(newFlags) {
    Object.assign($2c9381b44d3cd8ed$var$effectiveFlags, newFlags);
}
/**
 * We use this function to validate that the settings retrieved from local storage are of the correct shape.
 * We intentionally don't check against explicit keys, as keys may have changed since being stored.
 */ function $2c9381b44d3cd8ed$var$isStringBooleanDictionary(result) {
    return result !== null && Object.keys(result).every((resultKey)=>typeof resultKey === 'string' && typeof result[resultKey] === 'boolean');
}
function $2c9381b44d3cd8ed$export$2f63519103163252(featureFlag) {
    return Object.keys((0, $4jArG.PRODUCT_FEATURE_FLAGS)).includes(featureFlag);
}
function $2c9381b44d3cd8ed$export$ba72073d757a1bc2(flag) {
    return $2c9381b44d3cd8ed$var$effectiveFlags[flag];
}

});
parcelRegister("WUBOW", function(module, exports) {

$parcel$export(module.exports, "logException", () => $275a7284ad82cfc0$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logErrorMessage", () => $275a7284ad82cfc0$export$ece28f5cfa04608);
$parcel$export(module.exports, "logInfoMessage", () => $275a7284ad82cfc0$export$386587bcf05ee8ea);

var $jP0Fy = parcelRequire("jP0Fy");
const $275a7284ad82cfc0$var$packageContext = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $275a7284ad82cfc0$export$f86b2a1a2ce291b3 = (0, $jP0Fy.logExceptionWithPackageContext)($275a7284ad82cfc0$var$packageContext);
const $275a7284ad82cfc0$export$ece28f5cfa04608 = (0, $jP0Fy.logErrorMessageWithPackageContext)($275a7284ad82cfc0$var$packageContext);
const $275a7284ad82cfc0$export$386587bcf05ee8ea = (0, $jP0Fy.logInfoMessageWithPackageContext)($275a7284ad82cfc0$var$packageContext);
const $275a7284ad82cfc0$export$9edc7d6f1c33ddc = (0, $jP0Fy.createErrorHandlerWithPackageContext)($275a7284ad82cfc0$var$packageContext);

});

parcelRegister("fDLjB", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c72b66324308f6d$export$2e2bcd8739ae039);

var $WUBOW = parcelRequire("WUBOW");
const $3c72b66324308f6d$var$PREFIX = 'ptc-dir-ui.';
const $3c72b66324308f6d$var$memoryLocalStorage = {
    data: {},
    setItem: (key, value)=>{
        $3c72b66324308f6d$var$memoryLocalStorage.data[key] = value;
    },
    getItem: (key)=>{
        return $3c72b66324308f6d$var$memoryLocalStorage.data[key];
    },
    removeItem: (key)=>{
        delete $3c72b66324308f6d$var$memoryLocalStorage.data[key];
    }
};
const $3c72b66324308f6d$var$localStorage = window.localStorage || $3c72b66324308f6d$var$memoryLocalStorage;
var // A facade for browser localstorage.
$3c72b66324308f6d$export$2e2bcd8739ae039 = {
    isQuotaExceeded () {
        const key = `${$3c72b66324308f6d$var$PREFIX}:${Date.now()}`;
        try {
            $3c72b66324308f6d$var$localStorage.setItem(key, 'test');
        } catch (e) {
            return true;
        } finally{
            $3c72b66324308f6d$var$localStorage.removeItem(key);
        }
        return false;
    },
    setItem (key, value) {
        try {
            $3c72b66324308f6d$var$localStorage.setItem($3c72b66324308f6d$var$PREFIX + key, value);
            return true;
        } catch (error) {
            // maybe we can use cookie as alternative storage
            (0, $WUBOW.logInfoMessage)('Cannot read into localstorage', {
                error: error
            });
        }
        return false;
    },
    getItem (key) {
        try {
            return $3c72b66324308f6d$var$localStorage.getItem($3c72b66324308f6d$var$PREFIX + key);
        } catch (error) {
            (0, $WUBOW.logInfoMessage)('Cannot read into localstorage', {
                error: error
            });
        }
        return null;
    },
    getItemSafely (key, defaultValue, fallback) {
        try {
            const storedValue = $3c72b66324308f6d$var$localStorage.getItem($3c72b66324308f6d$var$PREFIX + key);
            if (storedValue) return storedValue;
            if (this.setItem(key, defaultValue)) return defaultValue;
        } catch (error) {
            (0, $WUBOW.logInfoMessage)('Cannot read into localstorage', {
                error: error
            });
        }
        return fallback;
    }
};

});

parcelRegister("4jArG", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_FEATURE_FLAGS", () => $bc46d40ec7cc6482$export$f55f538942f87030);
$parcel$export(module.exports, "DEFAULT_FEATURE_FLAGS", () => $bc46d40ec7cc6482$export$f38af5fc86a6e665);
// All feature flags must be listed here so that they can be selectively fetched from LaunchDarkly
// For real execution environments, configure flags in https://app.launchdarkly.com/ppl-teams-collective/test/features
// The default values here are used as the fallback when everything else (LD, local storage cache, local overrides) fails
// This is a list of feature flags that are overwritable by products. The defaults are still loaded from the client
const $bc46d40ec7cc6482$export$f55f538942f87030 = {};
const $bc46d40ec7cc6482$export$f38af5fc86a6e665 = {
    'ptc-directory-ui.enable.cancel-join-requests-silently': false,
    'ptc-directory-ui.deny-open-sites-in-fe': false,
    'ptc-directory-ui.enable.atlas-team-health-monitor': false,
    ...$bc46d40ec7cc6482$export$f55f538942f87030
};

});



parcelRegister("8bKaH", function(module, exports) {

$parcel$export(module.exports, "StatusCode", () => $79078fb84087079a$export$f66f92b8741acd5b);
$parcel$export(module.exports, "isAuthError", () => $79078fb84087079a$export$cde1786a482f9a1c);
$parcel$export(module.exports, "isErrorStatusCode", () => $79078fb84087079a$export$9677d7c364ada66c);
$parcel$export(module.exports, "ignoredErrorReason", () => $79078fb84087079a$export$ece443678e6cc3f5);
$parcel$export(module.exports, "is4xxError", () => $79078fb84087079a$export$94c4b26e937da69);
$parcel$export(module.exports, "doesErrorContainStatus", () => $79078fb84087079a$export$7c7624f23566b6ff);
$parcel$export(module.exports, "DirectoryErrorCode", () => $79078fb84087079a$export$b19e812222b57630);
$parcel$export(module.exports, "isApolloError", () => $79078fb84087079a$export$17f5e6bd290bb15d);
var $79078fb84087079a$export$fe4bb20808298551 = /*#__PURE__*/ function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
    return ErrorCategory;
}({});
var $79078fb84087079a$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
function $79078fb84087079a$export$cde1786a482f9a1c(error) {
    return $79078fb84087079a$export$9677d7c364ada66c(401, error) || $79078fb84087079a$export$9677d7c364ada66c(403, error);
}
const $79078fb84087079a$export$c27af9588f06f6fc = [
    'SentryIgnoreError'
];
const $79078fb84087079a$export$f4c3d57f2f41ffe2 = {
    'Could not verify accountId from header': 'AccountIdMismatch'
};
function $79078fb84087079a$export$ece443678e6cc3f5(error) {
    const constructor = error?.constructor.name;
    if (constructor && $79078fb84087079a$export$c27af9588f06f6fc.includes(constructor)) return constructor;
    const message = error?.message || '';
    const containedReason = message && Object.keys($79078fb84087079a$export$f4c3d57f2f41ffe2).find((ignoredMessage)=>message.includes(ignoredMessage));
    if (containedReason) return $79078fb84087079a$export$f4c3d57f2f41ffe2[containedReason];
}
function $79078fb84087079a$export$9677d7c364ada66c(statusCode, error) {
    if (!error) return false;
    if (error['status'] === statusCode || // error can be `ProperNetworkError` from `packages/graphql-client/src/links/error.ts`
    error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!error?.message?.match(reg);
}
function $79078fb84087079a$export$94c4b26e937da69(error) {
    if (!error) return false;
    const statusCode = error['status'] || error['statusCode'];
    // We want to log 429 errors to understand rate limiting
    if (parseInt(statusCode, 10) >= 400 && parseInt(statusCode, 10) < 500 && parseInt(statusCode, 10) !== 429) return true;
    const reg = new RegExp(/status (code)?.*(4\d\d)/g);
    return !!error.message?.match(reg);
}
function $79078fb84087079a$export$7c7624f23566b6ff(statusCode, message) {
    const reg = new RegExp(`status .*(${statusCode})`);
    return reg.test(message);
}
var $79078fb84087079a$export$b19e812222b57630 = /*#__PURE__*/ function(DirectoryErrorCode) {
    DirectoryErrorCode["MISSING_ERROR_MESSAGE"] = "MissingErrorMessage";
    return DirectoryErrorCode;
}({});
var $79078fb84087079a$export$c33cd4757598521c = /*#__PURE__*/ function(TeamErrorType) {
    TeamErrorType["TEAM_NOT_ACTIVE"] = "Team must be active";
    return TeamErrorType;
}({});
function $79078fb84087079a$export$76843b239f07f80a(error, field) {
    return error instanceof Error && field in error;
}
function $79078fb84087079a$export$17f5e6bd290bb15d(err) {
    return typeof err === 'object' && err !== null && 'graphQLErrors' in err;
}

});


parcelRegister("9NUk1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c58cde764d93290f$export$2e2bcd8739ae039);
/**
 * A singleton module that will store a referrer data in a closure
 * and retrieve that data in an analytics client untill the app has
 * a route transition happened.
 *
 * How it works:
 * 1. whenever we init our app with `src` or `ref` in the URL we gonna preserve them here
 * 2. in every screen event we gonna retrieve `src` and `ref` and add them to event attributes
 * 3. as soon as app transitions to any other route we gonna cleanup the stored referrer data
 *    to stop tracking it further.
 *
 * Notes:
 *  Due to how `referrerInfo` is used to store data temporarily, now it is used only at 2 places:
 * - Analytic Client `packages/common/src/clients/analytics-client.ts`
 * - RecordTransition `packages/embeddable-directory/src/components/RecordTransition/RecordTransition.tsx`
 * If other codes try to access value inside `referrerInfo`, they may access old/empty data.
 */ 
var $cz9fD = parcelRequire("cz9fD");
// the storage for our referrer info;
let $c58cde764d93290f$var$data = null;
const $c58cde764d93290f$var$referrerInfo = {
    // as we preserving the data, we should at least get it once to record in analytics before allowing cleanup
    isUsed: false,
    markUsed () {
        $c58cde764d93290f$var$referrerInfo.isUsed = true;
    },
    get () {
        return $c58cde764d93290f$var$data;
    },
    set ({ src: src = '', ref: ref = '' }) {
        // clean up strings
        $c58cde764d93290f$var$data = {
            src: (0, $cz9fD.sanitiseValue)(src || '', {
                shouldHaveSafeCharsOnly: true,
                shouldEncode: true
            }),
            ref: (0, $cz9fD.sanitiseValue)(ref, {
                shouldHaveSafeCharsOnly: true,
                shouldEncode: true
            })
        };
    },
    cleanup (force) {
        if (!$c58cde764d93290f$var$referrerInfo.isUsed && !force) return;
        $c58cde764d93290f$var$data = null;
    }
};
var $c58cde764d93290f$export$2e2bcd8739ae039 = $c58cde764d93290f$var$referrerInfo;

});
parcelRegister("cz9fD", function(module, exports) {

$parcel$export(module.exports, "sanitiseValue", () => $f17cca99bd8dadec$export$b66eb39ba856053f);
const $f17cca99bd8dadec$var$FORBIDDEN_CODE_CHARS = [
    8207
];
function $f17cca99bd8dadec$export$b66eb39ba856053f(value, options = {}) {
    let trimmedStr = value.trim();
    $f17cca99bd8dadec$var$FORBIDDEN_CODE_CHARS.forEach((codeChar)=>{
        const char = String.fromCharCode(codeChar);
        const re = new RegExp(char, 'gm');
        trimmedStr = trimmedStr.replace(re, '');
    });
    if (options.shouldHaveSafeCharsOnly) {
        trimmedStr = trimmedStr.replace(/[^a-z0-9_-]/gim, '');
        trimmedStr = trimmedStr.trim();
    }
    if (options.shouldEncode) trimmedStr = encodeURIComponent(trimmedStr);
    return trimmedStr;
}

});




parcelRegister("8b97b", function(module, exports) {

$parcel$export(module.exports, "useSetupApolloClient", () => $e59a1b0328aefcb6$export$78cd44b109ba6e2a);

var $5uXOq = parcelRequire("5uXOq");

var $1I06e = parcelRequire("1I06e");
function $e59a1b0328aefcb6$export$78cd44b109ba6e2a(cloudId) {
    const [apolloClient, setApolloClient] = (0, $5uXOq.useState)((0, $1I06e.getApolloClient)({
        getCloudId: ()=>cloudId
    }));
    const gatewayClient = (0, $1I06e.getGatewayClient)();
    // setup directory Apollo client
    (0, $5uXOq.useEffect)(()=>{
        if (!cloudId) return;
        const apolloClient = (0, $1I06e.getApolloClient)({
            getCloudId: ()=>cloudId
        });
        /**
		 * Enables the field @cloudId in apollo queries
		 */ apolloClient.writeData({
            data: {
                cloudId: cloudId
            }
        });
        setApolloClient(apolloClient);
    }, [
        cloudId
    ]);
    // setup gateway Apollo client
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * Enables the field @cloudId in apollo queries
		 */ gatewayClient.writeData({
            data: {
                cloudId: cloudId || 'None'
            }
        });
    }, [
        cloudId,
        gatewayClient
    ]);
    return apolloClient;
}

});
parcelRegister("1I06e", function(module, exports) {

$parcel$export(module.exports, "getApolloClient", () => $9c69470be07d991f$export$1e6cfeaf8b88bd01);
$parcel$export(module.exports, "getGatewayClient", () => $9c69470be07d991f$export$719274339c63410a);
$parcel$export(module.exports, "getTeamCentralClient", () => $9c69470be07d991f$export$6ef19f8a51b6041);

var $e7URe = parcelRequire("e7URe");

var $2KzEm = parcelRequire("2KzEm");
var $971Nd = parcelRequire("971Nd");

var $cModO = parcelRequire("cModO");
const $9c69470be07d991f$var$customFetch = (0, $cModO.withDefaultExponentialBackoff)(fetch);
/*************************************************/ // a common Apollo Client
let $9c69470be07d991f$var$cachedApolloClient;
const $9c69470be07d991f$export$1e6cfeaf8b88bd01 = (customConfig)=>{
    if ($9c69470be07d991f$var$cachedApolloClient) return $9c69470be07d991f$var$cachedApolloClient;
    const apolloClient = $9c69470be07d991f$export$67100df7b1079985(customConfig);
    // don't cache apolloClient when cloudId is empty string
    if (customConfig?.getCloudId && customConfig?.getCloudId()) $9c69470be07d991f$var$cachedApolloClient = apolloClient;
    return apolloClient;
};
const $9c69470be07d991f$export$67100df7b1079985 = (customConfig)=>(0, $e7URe.createApolloClient)({
        connectToDevTools: !!(0, $2KzEm.DEV),
        url: {
            stargateRoot: (0, $971Nd.getConfig)().stargateRoot,
            collaborationGraph: (0, $971Nd.getConfig)().collaborationGraph
        },
        customFetch: $9c69470be07d991f$var$customFetch,
        ...customConfig
    });
/*************************************************/ // Worklens client
let $9c69470be07d991f$var$cachedWorklensClient;
const $9c69470be07d991f$export$f0c45e63c1288a74 = ()=>{
    if ($9c69470be07d991f$var$cachedWorklensClient) return $9c69470be07d991f$var$cachedWorklensClient;
    $9c69470be07d991f$var$cachedWorklensClient = (0, $e7URe.createWorklensClient)({
        url: {
            stargateRoot: (0, $971Nd.getConfig)().stargateRoot
        },
        customFetch: $9c69470be07d991f$var$customFetch
    });
    return $9c69470be07d991f$var$cachedWorklensClient;
};
/*************************************************/ // GraphQL Gateway client
let $9c69470be07d991f$var$cachedGatewayClient;
const $9c69470be07d991f$export$719274339c63410a = ()=>{
    if ($9c69470be07d991f$var$cachedGatewayClient) return $9c69470be07d991f$var$cachedGatewayClient;
    $9c69470be07d991f$var$cachedGatewayClient = (0, $e7URe.createAtlassianGatewayClient)({
        url: {
            stargateRoot: (0, $971Nd.getConfig)().stargateRoot
        },
        customFetch: $9c69470be07d991f$var$customFetch
    });
    return $9c69470be07d991f$var$cachedGatewayClient;
};
/*************************************************/ // GraphQL Team Central client
let $9c69470be07d991f$var$cachedTeamCentralClients = new Map();
const $9c69470be07d991f$export$6ef19f8a51b6041 = (cloudId)=>$9c69470be07d991f$var$getTeamCentralClientInternal(cloudId);
const $9c69470be07d991f$export$53c1939d3ee92e9d = ()=>$9c69470be07d991f$var$getTeamCentralClientInternal();
const $9c69470be07d991f$var$getTeamCentralClientInternal = (cloudId)=>{
    let maybeCachedTeamCentralClient = $9c69470be07d991f$var$cachedTeamCentralClients.get(cloudId);
    if (maybeCachedTeamCentralClient) return maybeCachedTeamCentralClient;
    const teamCentralClient = (0, $e7URe.createTeamCentralClient)({
        url: {
            stargateRoot: (0, $971Nd.getConfig)().stargateRoot
        },
        customFetch: $9c69470be07d991f$var$customFetch,
        getCloudId: cloudId ? ()=>cloudId : undefined
    });
    $9c69470be07d991f$var$cachedTeamCentralClients.set(cloudId, teamCentralClient);
    return teamCentralClient;
};

});
parcelRegister("e7URe", function(module, exports) {

$parcel$export(module.exports, "createApolloClient", () => $caf67e162c432636$export$67100df7b1079985);
$parcel$export(module.exports, "createWorklensClient", () => $caf67e162c432636$export$72afd8225aad0e67);
$parcel$export(module.exports, "createAtlassianGatewayClient", () => $caf67e162c432636$export$a518457feff205cb);
$parcel$export(module.exports, "createTeamCentralClient", () => $caf67e162c432636$export$63d9e7c1fb26588f);

var $ivfDv = parcelRequire("ivfDv");

var $e3a3O = parcelRequire("e3a3O");

var $clSzL = parcelRequire("clSzL");

var $kH9C9 = parcelRequire("kH9C9");

var $cKbwx = parcelRequire("cKbwx");

var $cIxJO = parcelRequire("cIxJO");

var $6eJfB = parcelRequire("6eJfB");

var $iEp9R = parcelRequire("iEp9R");

var $bt0EZ = parcelRequire("bt0EZ");

var $ix0Xq = parcelRequire("ix0Xq");

var $jI3Xg = parcelRequire("jI3Xg");

var $g1jIg = parcelRequire("g1jIg");
const $caf67e162c432636$export$67100df7b1079985 = (options)=>{
    const { retryLink: retryOptions = {}, getCloudId: getCloudId, url: url, statusCodeHandlers: statusCodeHandlers = {}, customFetch: customFetch } = options;
    // Build up a list of Apollo links
    const links = [];
    /**
   * Apollo link for handling request errors
   */ const errorLink = (0, $bt0EZ.createErrorLink)({
        statusCodeHandlers: statusCodeHandlers
    });
    if (errorLink) links.push(errorLink);
    /**
   * Apollo link for retrying certain failed requests
   */ const retryLink = (0, $ix0Xq.createRetryLink)(retryOptions);
    if (retryLink) links.push(retryLink);
    /**
   * Apollo link that determines whether to send a request to directory
   * service or resolve the query locally using a custom resolver
   */ const customResolversLink = new (0, $kH9C9.SchemaLink)({
        schema: (0, $cKbwx.addResolveFunctionsToSchema)({
            schema: $g1jIg.schema,
            resolvers: $jI3Xg.default
        }),
        context: {
            url: url,
            fetch: (0, $cIxJO.getCustomResolversFetch)({
                fetch: customFetch || fetch,
                statusCodeHandlers: statusCodeHandlers
            })
        }
    });
    const directoryHttpLink = (0, $iEp9R.createDirectoryHttpLink)({
        url: `${url ? url.stargateRoot : ''}/directory/graphql`,
        getCloudId: getCloudId
    });
    links.push((0, $clSzL.split)(// if query has @custom, use customResolversLink
    (operation)=>(0, $6eJfB.isCustomQuery)(operation), customResolversLink, // use directory link
    directoryHttpLink));
    return new (0, $e3a3O.default)({
        connectToDevTools: !!options.connectToDevTools,
        link: (0, $clSzL.from)(links),
        cache: new (0, $ivfDv.InMemoryCache)(),
        // empty object enables @client directive
        resolvers: {}
    });
};
const $caf67e162c432636$export$72afd8225aad0e67 = (options)=>{
    const { retryLink: retryOptions = {}, url: url, statusCodeHandlers: statusCodeHandlers = {} } = options;
    const errorLink = (0, $bt0EZ.createErrorLink)({
        statusCodeHandlers: statusCodeHandlers
    });
    const retryLink = (0, $ix0Xq.createRetryLink)(retryOptions);
    const httpLink = (0, $iEp9R.createDirectoryHttpLink)({
        url: `${url.stargateRoot}/worklens/api/graphql`
    });
    const links = [
        errorLink,
        retryLink,
        httpLink
    ];
    return new (0, $e3a3O.default)({
        link: (0, $clSzL.from)(links),
        cache: new (0, $ivfDv.InMemoryCache)()
    });
};
const $caf67e162c432636$export$a518457feff205cb = (options)=>{
    const { retryLink: retryOptions = {}, url: url, statusCodeHandlers: statusCodeHandlers = {} } = options;
    const errorLink = (0, $bt0EZ.createErrorLink)({
        statusCodeHandlers: statusCodeHandlers
    });
    const retryLink = (0, $ix0Xq.createRetryLink)(retryOptions);
    const httpLink = (0, $iEp9R.createDirectoryHttpLink)({
        url: `${url.stargateRoot}/graphql`
    });
    const links = [
        errorLink,
        retryLink,
        httpLink
    ];
    return new (0, $e3a3O.default)({
        link: (0, $clSzL.from)(links),
        cache: new (0, $ivfDv.InMemoryCache)(),
        // empty object enables @client directive
        resolvers: {}
    });
};
const $caf67e162c432636$export$63d9e7c1fb26588f = (options)=>{
    const { retryLink: retryOptions = {}, url: { stargateRoot: stargateRoot }, statusCodeHandlers: statusCodeHandlers = {} } = options;
    const errorLink = (0, $bt0EZ.createErrorLink)({
        statusCodeHandlers: statusCodeHandlers
    });
    const retryLink = (0, $ix0Xq.createRetryLink)(retryOptions);
    const cloudId = options.getCloudId?.();
    const httpLink = (0, $iEp9R.createDirectoryHttpLink)({
        url: cloudId !== undefined ? `${stargateRoot}/townsquare/s/${cloudId}/graphql` : `${stargateRoot}/watermelon/graphql`
    });
    const links = [
        errorLink,
        retryLink,
        httpLink
    ];
    return new (0, $e3a3O.default)({
        link: (0, $clSzL.from)(links),
        cache: new (0, $ivfDv.InMemoryCache)({
            dataIdFromObject: (obj)=>{
                switch(obj.__typename){
                    case 'Icon':
                        return `${obj.id}:${obj.shortName}|${obj.color}`;
                    case 'GoalPhaseDetails':
                    case 'ProjectPhaseDetails':
                    case 'GqlJiraIssue':
                    case 'GqlJiraIssueType':
                    case 'GqlJiraStatus':
                    case 'GqlJiraStatusCategory':
                        return `${obj.__typename}:${obj.id}`;
                    default:
                        return obj.id;
                }
            }
        })
    });
};

});
parcelRegister("ivfDv", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $d7874048ca668ecb$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $d7874048ca668ecb$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $d7874048ca668ecb$export$467265324939f47f);

var $3VFsf = parcelRequire("3VFsf");

var $hzuXv = parcelRequire("hzuXv");

var $jojW6 = parcelRequire("jojW6");
var $bqMzA = parcelRequire("bqMzA");

var $gLy2H = parcelRequire("gLy2H");

var $1DiV8 = parcelRequire("1DiV8");
var $d7874048ca668ecb$var$haveWarned = false;
function $d7874048ca668ecb$var$shouldWarn() {
    var answer = !$d7874048ca668ecb$var$haveWarned;
    if (!(0, $jojW6.isTest)()) $d7874048ca668ecb$var$haveWarned = true;
    return answer;
}
var $d7874048ca668ecb$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $d7874048ca668ecb$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $d7874048ca668ecb$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $d7874048ca668ecb$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $1DiV8.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $1DiV8.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $d7874048ca668ecb$var$hasOwn = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $gLy2H.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($d7874048ca668ecb$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$d7874048ca668ecb$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $d7874048ca668ecb$var$defaultNormalizedCacheFactory(seed) {
    return new $d7874048ca668ecb$var$DepTrackingCache(seed);
}
var $d7874048ca668ecb$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $gLy2H.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $gLy2H.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $gLy2H.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $jojW6.getQueryDefinition)(query);
        variables = (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $1DiV8.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $bqMzA.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $d7874048ca668ecb$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $jojW6.getMainDefinition)(query);
        var fragments = (0, $jojW6.getFragmentDefinitions)(query);
        var fragmentMap = (0, $jojW6.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $jojW6.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $1DiV8.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $jojW6.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $jojW6.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $jojW6.resultKeyNameFromField)(field),
            directives: (0, $jojW6.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $jojW6.isIdValue)(value)) throw new (0, $1DiV8.InvariantError)(10);
}
function $d7874048ca668ecb$var$defaultFragmentMatcher() {
    return true;
}
function $d7874048ca668ecb$export$7a4899fe13f33235(idValue) {
    (0, $1DiV8.invariant)((0, $jojW6.isIdValue)(idValue), 11);
}
function $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $jojW6.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $jojW6.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $jojW6.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $d7874048ca668ecb$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $d7874048ca668ecb$export$7e2b40d1002de152(seed) {
    return new $d7874048ca668ecb$export$ee7258b8691956a3(seed);
}
var $d7874048ca668ecb$export$de4e6870dc6ac801 = function(_super) {
    (0, $3VFsf.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $d7874048ca668ecb$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $d7874048ca668ecb$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $d7874048ca668ecb$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $jojW6.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $jojW6.createFragmentMap)((0, $jojW6.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $d7874048ca668ecb$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var resultFieldKey = (0, $jojW6.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $1DiV8.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $jojW6.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $d7874048ca668ecb$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $jojW6.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $jojW6.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$d7874048ca668ecb$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $1DiV8.invariant)(!semanticId || !$d7874048ca668ecb$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $jojW6.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $jojW6.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $1DiV8.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $1DiV8.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $d7874048ca668ecb$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $bqMzA.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $jojW6.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $d7874048ca668ecb$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $d7874048ca668ecb$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $jojW6.isIdValue)(value) && $d7874048ca668ecb$var$isGeneratedId(value.id) && (0, $jojW6.isIdValue)(realValue) && !(0, $bqMzA.equal)(value, realValue) && $d7874048ca668ecb$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, generated), real);
    if ((0, $bqMzA.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $d7874048ca668ecb$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $d7874048ca668ecb$var$defaultConfig = {
    fragmentMatcher: new $d7874048ca668ecb$export$5d3fcf53267091de(),
    dataIdFromObject: $d7874048ca668ecb$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $d7874048ca668ecb$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $d7874048ca668ecb$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$OptimisticCacheLayer = function(_super) {
    (0, $3VFsf.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $d7874048ca668ecb$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($d7874048ca668ecb$export$ee7258b8691956a3);
var $d7874048ca668ecb$export$467265324939f47f = function(_super) {
    (0, $3VFsf.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, $d7874048ca668ecb$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $d7874048ca668ecb$var$DepTrackingCache() : new $d7874048ca668ecb$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $d7874048ca668ecb$export$eb8361c5d132fb8f();
        _this.storeReader = new $d7874048ca668ecb$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $gLy2H.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $d7874048ca668ecb$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $1DiV8.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $d7874048ca668ecb$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $d7874048ca668ecb$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $jojW6.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $hzuXv.ApolloCache));

});
parcelRegister("hzuXv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $ccadb856bf057658$export$5fc74f25506aa9c);

var $jojW6 = parcelRequire("jojW6");
function $ccadb856bf057658$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $ccadb856bf057658$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $ccadb856bf057658$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $ccadb856bf057658$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $ccadb856bf057658$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $ccadb856bf057658$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $ccadb856bf057658$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $ccadb856bf057658$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $ccadb856bf057658$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $ccadb856bf057658$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $ccadb856bf057658$export$94affb487e701bf2;
$ccadb856bf057658$export$94affb487e701bf2 || ($ccadb856bf057658$export$94affb487e701bf2 = {});

});

parcelRegister("gLy2H", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $c34b71496108423e$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $c34b71496108423e$export$4997ffc0176396a6);

var $jFbNy = parcelRequire("jFbNy");
function $c34b71496108423e$var$defaultDispose() {}
var $c34b71496108423e$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $c34b71496108423e$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $c34b71496108423e$var$parentEntrySlot = new (0, $jFbNy.Slot)();
var $c34b71496108423e$var$reusableEmptyArray = [];
var $c34b71496108423e$var$emptySetPool = [];
var $c34b71496108423e$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $c34b71496108423e$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $c34b71496108423e$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $c34b71496108423e$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $c34b71496108423e$var$valueCopy(value) {
    return value.slice(0);
}
var $c34b71496108423e$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $c34b71496108423e$var$assert(!this.recomputing, "already recomputing");
        if (!$c34b71496108423e$var$rememberParent(this) && $c34b71496108423e$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $c34b71496108423e$var$mightBeDirty(this) ? $c34b71496108423e$var$reallyRecompute(this) : $c34b71496108423e$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $c34b71496108423e$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $c34b71496108423e$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $c34b71496108423e$var$forgetChildren(this).forEach($c34b71496108423e$var$maybeReportOrphan);
        $c34b71496108423e$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $c34b71496108423e$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $c34b71496108423e$var$rememberParent(child) {
    var parent = $c34b71496108423e$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($c34b71496108423e$var$mightBeDirty(child)) $c34b71496108423e$var$reportDirtyChild(parent, child);
        else $c34b71496108423e$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $c34b71496108423e$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $c34b71496108423e$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $c34b71496108423e$var$parentEntrySlot.withValue(entry, $c34b71496108423e$var$recomputeNewValue, [
        entry
    ]);
    if ($c34b71496108423e$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $c34b71496108423e$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($c34b71496108423e$var$maybeReportOrphan);
    return $c34b71496108423e$var$valueGet(entry.value);
}
function $c34b71496108423e$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $c34b71496108423e$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $c34b71496108423e$var$setClean(entry) {
    entry.dirty = false;
    if ($c34b71496108423e$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $c34b71496108423e$var$reportClean(entry);
}
function $c34b71496108423e$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportDirtyChild(parent, child);
    });
}
function $c34b71496108423e$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $c34b71496108423e$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert($c34b71496108423e$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $c34b71496108423e$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $c34b71496108423e$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $c34b71496108423e$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert(!$c34b71496108423e$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $c34b71496108423e$var$valueCopy(child.value));
    else if (!$c34b71496108423e$var$valueIs(childValue, child.value)) parent.setDirty();
    $c34b71496108423e$var$removeDirtyChild(parent, child);
    if ($c34b71496108423e$var$mightBeDirty(parent)) return;
    $c34b71496108423e$var$reportClean(parent);
}
function $c34b71496108423e$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($c34b71496108423e$var$emptySetPool.length < $c34b71496108423e$var$POOL_TARGET_SIZE) $c34b71496108423e$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $c34b71496108423e$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $c34b71496108423e$var$forgetChildren(parent) {
    var children = $c34b71496108423e$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $c34b71496108423e$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $c34b71496108423e$var$assert(parent.dirtyChildren === null);
    return children;
}
function $c34b71496108423e$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $c34b71496108423e$var$removeDirtyChild(parent, child);
}
function $c34b71496108423e$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $c34b71496108423e$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $c34b71496108423e$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $c34b71496108423e$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $c34b71496108423e$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $c34b71496108423e$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $c34b71496108423e$var$keyTrie = new $c34b71496108423e$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $c34b71496108423e$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $c34b71496108423e$var$keyTrie.lookupArray(args);
}
var $c34b71496108423e$var$caches = new Set();
function $c34b71496108423e$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $c34b71496108423e$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $c34b71496108423e$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$c34b71496108423e$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $c34b71496108423e$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $c34b71496108423e$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$c34b71496108423e$var$parentEntrySlot.hasValue()) {
            $c34b71496108423e$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $c34b71496108423e$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("jFbNy", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $e50aff8f879ebe36$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $e50aff8f879ebe36$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $e50aff8f879ebe36$var$MISSING_VALUE = {};
var $e50aff8f879ebe36$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $e50aff8f879ebe36$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $e50aff8f879ebe36$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $e50aff8f879ebe36$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $e50aff8f879ebe36$var$MISSING_VALUE) break;
                if (context_1 !== $e50aff8f879ebe36$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $e50aff8f879ebe36$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($e50aff8f879ebe36$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $e50aff8f879ebe36$var$currentContext.slots[this.id] = $e50aff8f879ebe36$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $e50aff8f879ebe36$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $e50aff8f879ebe36$var$currentContext;
            $e50aff8f879ebe36$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $e50aff8f879ebe36$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $e50aff8f879ebe36$var$currentContext;
            return function() {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($e50aff8f879ebe36$var$currentContext) {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $e50aff8f879ebe36$var$globalKey = "@wry/context:Slot";
var $e50aff8f879ebe36$var$host = Array;
var $e50aff8f879ebe36$export$8c6ed5c666ac1360 = $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] || function() {
    var Slot = $e50aff8f879ebe36$var$makeSlotClass();
    try {
        Object.defineProperty($e50aff8f879ebe36$var$host, $e50aff8f879ebe36$var$globalKey, {
            value: $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $e50aff8f879ebe36$export$2385a24977818dd0 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.bind, $e50aff8f879ebe36$export$9fa6f2e300a97f8 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.noContext;
function $e50aff8f879ebe36$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($e50aff8f879ebe36$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $e50aff8f879ebe36$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $e50aff8f879ebe36$export$2385a24977818dd0(gen.next);
        var boundThrow = $e50aff8f879ebe36$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($e50aff8f879ebe36$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $e50aff8f879ebe36$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $e50aff8f879ebe36$var$wrappedFibers = [];
function $e50aff8f879ebe36$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($e50aff8f879ebe36$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $e50aff8f879ebe36$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $e50aff8f879ebe36$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("kH9C9", function(module, exports) {

$parcel$export(module.exports, "SchemaLink", () => $f10f47fba63df518$export$f2b7839aa4c35c8d);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");

var $mP8zZ = parcelRequire("mP8zZ");
var $f10f47fba63df518$export$f2b7839aa4c35c8d = function(_super) {
    (0, $3VFsf.__extends)(SchemaLink, _super);
    function SchemaLink(_a) {
        var schema = _a.schema, rootValue = _a.rootValue, context = _a.context;
        var _this = _super.call(this) || this;
        _this.schema = schema;
        _this.rootValue = rootValue;
        _this.context = context;
        return _this;
    }
    SchemaLink.prototype.request = function(operation) {
        var _this = this;
        return new (0, $clSzL.Observable)(function(observer) {
            Promise.resolve((0, $mP8zZ.execute)(_this.schema, operation.query, _this.rootValue, typeof _this.context === 'function' ? _this.context(operation) : _this.context, operation.variables, operation.operationName)).then(function(data) {
                if (!observer.closed) {
                    observer.next(data);
                    observer.complete();
                }
            }).catch(function(error) {
                if (!observer.closed) observer.error(error);
            });
        });
    };
    return SchemaLink;
}((0, $clSzL.ApolloLink));
var $f10f47fba63df518$export$2e2bcd8739ae039 = $f10f47fba63df518$export$f2b7839aa4c35c8d;

});
parcelRegister("mP8zZ", function(module, exports) {

$parcel$export(module.exports, "execute", () => $0449b901b9e9408e$export$51396ec711da548b);
$parcel$export(module.exports, "assertValidExecutionArguments", () => $0449b901b9e9408e$export$e02b605d81e17af1);
$parcel$export(module.exports, "buildExecutionContext", () => $0449b901b9e9408e$export$312a3f029bac48f9);
$parcel$export(module.exports, "defaultFieldResolver", () => $0449b901b9e9408e$export$21fc6d079630d659);
$parcel$export(module.exports, "collectFields", () => $0449b901b9e9408e$export$c23741d442fe90e9);
$parcel$export(module.exports, "getFieldDef", () => $0449b901b9e9408e$export$dab6dcab745bb1b6);
$parcel$export(module.exports, "buildResolveInfo", () => $0449b901b9e9408e$export$27b5443b7768606f);

var $yEDl8 = parcelRequire("yEDl8");

var $xeUe3 = parcelRequire("xeUe3");

var $fM9AB = parcelRequire("fM9AB");

var $a1qmV = parcelRequire("a1qmV");

var $jMqAK = parcelRequire("jMqAK");

var $cJPdE = parcelRequire("cJPdE");

var $iAT21 = parcelRequire("iAT21");

var $jyJ52 = parcelRequire("jyJ52");

var $efgSh = parcelRequire("efgSh");

var $hEo2F = parcelRequire("hEo2F");

var $g5yZB = parcelRequire("g5yZB");

var $csEv9 = parcelRequire("csEv9");

var $bzIlO = parcelRequire("bzIlO");

var $bKGOe = parcelRequire("bKGOe");

var $4Hpke = parcelRequire("4Hpke");

var $35Smo = parcelRequire("35Smo");

var $8oLgk = parcelRequire("8oLgk");

var $6D4Eu = parcelRequire("6D4Eu");

var $etM9Y = parcelRequire("etM9Y");

var $7dqoX = parcelRequire("7dqoX");
function $0449b901b9e9408e$export$51396ec711da548b(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver) {
    /* eslint-enable no-redeclare */ // Extract arguments from object args if provided.
    return arguments.length === 1 ? $0449b901b9e9408e$var$executeImpl(argsOrSchema) : $0449b901b9e9408e$var$executeImpl({
        schema: argsOrSchema,
        document: document,
        rootValue: rootValue,
        contextValue: contextValue,
        variableValues: variableValues,
        operationName: operationName,
        fieldResolver: fieldResolver,
        typeResolver: typeResolver
    });
}
function $0449b901b9e9408e$export$6d0f20a121527483(args) {
    var result = $0449b901b9e9408e$var$executeImpl(args); // Assert that the execution was synchronous.
    if ((0, $jMqAK.default)(result)) throw new Error('GraphQL execution failed to complete synchronously.');
    return result;
}
function $0449b901b9e9408e$var$executeImpl(args) {
    var schema = args.schema, document = args.document, rootValue = args.rootValue, contextValue = args.contextValue, variableValues = args.variableValues, operationName = args.operationName, fieldResolver = args.fieldResolver, typeResolver = args.typeResolver; // If arguments are missing or incorrect, throw an error.
    $0449b901b9e9408e$export$e02b605d81e17af1(schema, document, variableValues); // If a valid execution context cannot be created due to incorrect arguments,
    // a "Response" with only errors is returned.
    var exeContext = $0449b901b9e9408e$export$312a3f029bac48f9(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver); // Return early errors if execution context failed.
    if (Array.isArray(exeContext)) return {
        errors: exeContext
    };
     // Return a Promise that will eventually resolve to the data described by
    // The "Response" section of the GraphQL specification.
    //
    // If errors are encountered while executing a GraphQL field, only that
    // field and its descendants will be omitted, and sibling fields will still
    // be executed. An execution which encounters errors will still result in a
    // resolved Promise.
    var data = $0449b901b9e9408e$var$executeOperation(exeContext, exeContext.operation, rootValue);
    return $0449b901b9e9408e$var$buildResponse(exeContext, data);
}
/**
 * Given a completed execution context and data, build the { errors, data }
 * response defined by the "Response" section of the GraphQL specification.
 */ function $0449b901b9e9408e$var$buildResponse(exeContext, data) {
    if ((0, $jMqAK.default)(data)) return data.then(function(resolved) {
        return $0449b901b9e9408e$var$buildResponse(exeContext, resolved);
    });
    return exeContext.errors.length === 0 ? {
        data: data
    } : {
        errors: exeContext.errors,
        data: data
    };
}
function $0449b901b9e9408e$export$e02b605d81e17af1(schema, document, rawVariableValues) {
    document || (0, $a1qmV.default)(0, 'Must provide document.'); // If the schema used for execution is invalid, throw an error.
    (0, $bKGOe.assertValidSchema)(schema); // Variables, if provided, must be an object.
    rawVariableValues == null || (0, $cJPdE.default)(rawVariableValues) || (0, $a1qmV.default)(0, 'Variables must be provided as an Object where each property is a variable value. Perhaps look to see if an unparsed JSON string was provided.');
}
function $0449b901b9e9408e$export$312a3f029bac48f9(schema, document, rootValue, contextValue, rawVariableValues, operationName, fieldResolver, typeResolver) {
    var _definition$name, _operation$variableDe;
    var operation;
    var fragments = Object.create(null);
    for(var _i2 = 0, _document$definitions2 = document.definitions; _i2 < _document$definitions2.length; _i2++){
        var definition = _document$definitions2[_i2];
        switch(definition.kind){
            case (0, $bzIlO.Kind).OPERATION_DEFINITION:
                if (operationName == null) {
                    if (operation !== undefined) return [
                        new (0, $g5yZB.GraphQLError)('Must provide operation name if query contains multiple operations.')
                    ];
                    operation = definition;
                } else if (((_definition$name = definition.name) === null || _definition$name === void 0 ? void 0 : _definition$name.value) === operationName) operation = definition;
                break;
            case (0, $bzIlO.Kind).FRAGMENT_DEFINITION:
                fragments[definition.name.value] = definition;
                break;
        }
    }
    if (!operation) {
        if (operationName != null) return [
            new (0, $g5yZB.GraphQLError)("Unknown operation named \"".concat(operationName, "\"."))
        ];
        return [
            new (0, $g5yZB.GraphQLError)('Must provide an operation.')
        ];
    } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
    var variableDefinitions = (_operation$variableDe = operation.variableDefinitions) !== null && _operation$variableDe !== void 0 ? _operation$variableDe : [];
    var coercedVariableValues = (0, $7dqoX.getVariableValues)(schema, variableDefinitions, rawVariableValues !== null && rawVariableValues !== void 0 ? rawVariableValues : {}, {
        maxErrors: 50
    });
    if (coercedVariableValues.errors) return coercedVariableValues.errors;
    return {
        schema: schema,
        fragments: fragments,
        rootValue: rootValue,
        contextValue: contextValue,
        operation: operation,
        variableValues: coercedVariableValues.coerced,
        fieldResolver: fieldResolver !== null && fieldResolver !== void 0 ? fieldResolver : $0449b901b9e9408e$export$21fc6d079630d659,
        typeResolver: typeResolver !== null && typeResolver !== void 0 ? typeResolver : $0449b901b9e9408e$export$4a45c17a1ba2cb7,
        errors: []
    };
}
/**
 * Implements the "Evaluating operations" section of the spec.
 */ function $0449b901b9e9408e$var$executeOperation(exeContext, operation, rootValue) {
    var type = (0, $etM9Y.getOperationRootType)(exeContext.schema, operation);
    var fields = $0449b901b9e9408e$export$c23741d442fe90e9(exeContext, type, operation.selectionSet, Object.create(null), Object.create(null));
    var path = undefined; // Errors from sub-fields of a NonNull type may propagate to the top level,
    // at which point we still log the error and null the parent field, which
    // in this case is the entire response.
    try {
        var result = operation.operation === 'mutation' ? $0449b901b9e9408e$var$executeFieldsSerially(exeContext, type, rootValue, path, fields) : $0449b901b9e9408e$var$executeFields(exeContext, type, rootValue, path, fields);
        if ((0, $jMqAK.default)(result)) return result.then(undefined, function(error) {
            exeContext.errors.push(error);
            return Promise.resolve(null);
        });
        return result;
    } catch (error) {
        exeContext.errors.push(error);
        return null;
    }
}
/**
 * Implements the "Evaluating selection sets" section of the spec
 * for "write" mode.
 */ function $0449b901b9e9408e$var$executeFieldsSerially(exeContext, parentType, sourceValue, path, fields) {
    return (0, $jyJ52.default)(Object.keys(fields), function(results, responseName) {
        var fieldNodes = fields[responseName];
        var fieldPath = (0, $hEo2F.addPath)(path, responseName, parentType.name);
        var result = $0449b901b9e9408e$var$resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);
        if (result === undefined) return results;
        if ((0, $jMqAK.default)(result)) return result.then(function(resolvedResult) {
            results[responseName] = resolvedResult;
            return results;
        });
        results[responseName] = result;
        return results;
    }, Object.create(null));
}
/**
 * Implements the "Evaluating selection sets" section of the spec
 * for "read" mode.
 */ function $0449b901b9e9408e$var$executeFields(exeContext, parentType, sourceValue, path, fields) {
    var results = Object.create(null);
    var containsPromise = false;
    try {
        for(var _i4 = 0, _Object$keys2 = Object.keys(fields); _i4 < _Object$keys2.length; _i4++){
            var responseName = _Object$keys2[_i4];
            var fieldNodes = fields[responseName];
            var fieldPath = (0, $hEo2F.addPath)(path, responseName, parentType.name);
            var result = $0449b901b9e9408e$var$resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);
            if (result !== undefined) {
                results[responseName] = result;
                if ((0, $jMqAK.default)(result)) containsPromise = true;
            }
        }
    } catch (error) {
        if (containsPromise) // Ensure that any promises returned by other fields are handled, as they may also reject.
        return (0, $efgSh.default)(results).finally(function() {
            throw error;
        });
        throw error;
    } // If there are no promises, we can just return the object
    if (!containsPromise) return results;
     // Otherwise, results is a map from field name to the result of resolving that
    // field, which is possibly a promise. Return a promise that will return this
    // same map, but with any promises replaced with the values they resolved to.
    return (0, $efgSh.default)(results);
}
function $0449b901b9e9408e$export$c23741d442fe90e9(exeContext, runtimeType, selectionSet, fields, visitedFragmentNames) {
    for(var _i6 = 0, _selectionSet$selecti2 = selectionSet.selections; _i6 < _selectionSet$selecti2.length; _i6++){
        var selection = _selectionSet$selecti2[_i6];
        switch(selection.kind){
            case (0, $bzIlO.Kind).FIELD:
                if (!$0449b901b9e9408e$var$shouldIncludeNode(exeContext, selection)) continue;
                var name = $0449b901b9e9408e$var$getFieldEntryKey(selection);
                if (!fields[name]) fields[name] = [];
                fields[name].push(selection);
                break;
            case (0, $bzIlO.Kind).INLINE_FRAGMENT:
                if (!$0449b901b9e9408e$var$shouldIncludeNode(exeContext, selection) || !$0449b901b9e9408e$var$doesFragmentConditionMatch(exeContext, selection, runtimeType)) continue;
                $0449b901b9e9408e$export$c23741d442fe90e9(exeContext, runtimeType, selection.selectionSet, fields, visitedFragmentNames);
                break;
            case (0, $bzIlO.Kind).FRAGMENT_SPREAD:
                var fragName = selection.name.value;
                if (visitedFragmentNames[fragName] || !$0449b901b9e9408e$var$shouldIncludeNode(exeContext, selection)) continue;
                visitedFragmentNames[fragName] = true;
                var fragment = exeContext.fragments[fragName];
                if (!fragment || !$0449b901b9e9408e$var$doesFragmentConditionMatch(exeContext, fragment, runtimeType)) continue;
                $0449b901b9e9408e$export$c23741d442fe90e9(exeContext, runtimeType, fragment.selectionSet, fields, visitedFragmentNames);
                break;
        }
    }
    return fields;
}
/**
 * Determines if a field should be included based on the @include and @skip
 * directives, where @skip has higher precedence than @include.
 */ function $0449b901b9e9408e$var$shouldIncludeNode(exeContext, node) {
    var skip = (0, $7dqoX.getDirectiveValues)((0, $35Smo.GraphQLSkipDirective), node, exeContext.variableValues);
    if ((skip === null || skip === void 0 ? void 0 : skip.if) === true) return false;
    var include = (0, $7dqoX.getDirectiveValues)((0, $35Smo.GraphQLIncludeDirective), node, exeContext.variableValues);
    if ((include === null || include === void 0 ? void 0 : include.if) === false) return false;
    return true;
}
/**
 * Determines if a fragment is applicable to the given type.
 */ function $0449b901b9e9408e$var$doesFragmentConditionMatch(exeContext, fragment, type) {
    var typeConditionNode = fragment.typeCondition;
    if (!typeConditionNode) return true;
    var conditionalType = (0, $6D4Eu.typeFromAST)(exeContext.schema, typeConditionNode);
    if (conditionalType === type) return true;
    if ((0, $8oLgk.isAbstractType)(conditionalType)) return exeContext.schema.isSubType(conditionalType, type);
    return false;
}
/**
 * Implements the logic to compute the key of a given field's entry
 */ function $0449b901b9e9408e$var$getFieldEntryKey(node) {
    return node.alias ? node.alias.value : node.name.value;
}
/**
 * Resolves the field on the given source object. In particular, this
 * figures out the value that the field returns by calling its resolve function,
 * then calls completeValue to complete promises, serialize scalars, or execute
 * the sub-selection-set for objects.
 */ function $0449b901b9e9408e$var$resolveField(exeContext, parentType, source, fieldNodes, path) {
    var _fieldDef$resolve;
    var fieldNode = fieldNodes[0];
    var fieldName = fieldNode.name.value;
    var fieldDef = $0449b901b9e9408e$export$dab6dcab745bb1b6(exeContext.schema, parentType, fieldName);
    if (!fieldDef) return;
    var returnType = fieldDef.type;
    var resolveFn = (_fieldDef$resolve = fieldDef.resolve) !== null && _fieldDef$resolve !== void 0 ? _fieldDef$resolve : exeContext.fieldResolver;
    var info = $0449b901b9e9408e$export$27b5443b7768606f(exeContext, fieldDef, fieldNodes, parentType, path); // Get the resolve function, regardless of if its result is normal or abrupt (error).
    try {
        // Build a JS object of arguments from the field.arguments AST, using the
        // variables scope to fulfill any variable references.
        // TODO: find a way to memoize, in case this field is within a List type.
        var args = (0, $7dqoX.getArgumentValues)(fieldDef, fieldNodes[0], exeContext.variableValues); // The resolve function's optional third argument is a context value that
        // is provided to every resolve function within an execution. It is commonly
        // used to represent an authenticated user, or request-specific caches.
        var _contextValue = exeContext.contextValue;
        var result = resolveFn(source, args, _contextValue, info);
        var completed;
        if ((0, $jMqAK.default)(result)) completed = result.then(function(resolved) {
            return $0449b901b9e9408e$var$completeValue(exeContext, returnType, fieldNodes, info, path, resolved);
        });
        else completed = $0449b901b9e9408e$var$completeValue(exeContext, returnType, fieldNodes, info, path, result);
        if ((0, $jMqAK.default)(completed)) // Note: we don't rely on a `catch` method, but we do expect "thenable"
        // to take a second callback for the error case.
        return completed.then(undefined, function(rawError) {
            var error = (0, $csEv9.locatedError)(rawError, fieldNodes, (0, $hEo2F.pathToArray)(path));
            return $0449b901b9e9408e$var$handleFieldError(error, returnType, exeContext);
        });
        return completed;
    } catch (rawError) {
        var error = (0, $csEv9.locatedError)(rawError, fieldNodes, (0, $hEo2F.pathToArray)(path));
        return $0449b901b9e9408e$var$handleFieldError(error, returnType, exeContext);
    }
}
function $0449b901b9e9408e$export$27b5443b7768606f(exeContext, fieldDef, fieldNodes, parentType, path) {
    // The resolve function's optional fourth argument is a collection of
    // information about the current execution state.
    return {
        fieldName: fieldDef.name,
        fieldNodes: fieldNodes,
        returnType: fieldDef.type,
        parentType: parentType,
        path: path,
        schema: exeContext.schema,
        fragments: exeContext.fragments,
        rootValue: exeContext.rootValue,
        operation: exeContext.operation,
        variableValues: exeContext.variableValues
    };
}
function $0449b901b9e9408e$var$handleFieldError(error, returnType, exeContext) {
    // If the field type is non-nullable, then it is resolved without any
    // protection from errors, however it still properly locates the error.
    if ((0, $8oLgk.isNonNullType)(returnType)) throw error;
     // Otherwise, error protection is applied, logging the error and resolving
    // a null value for this field if one is encountered.
    exeContext.errors.push(error);
    return null;
}
/**
 * Implements the instructions for completeValue as defined in the
 * "Field entries" section of the spec.
 *
 * If the field type is Non-Null, then this recursively completes the value
 * for the inner type. It throws a field error if that completion returns null,
 * as per the "Nullability" section of the spec.
 *
 * If the field type is a List, then this recursively completes the value
 * for the inner type on each item in the list.
 *
 * If the field type is a Scalar or Enum, ensures the completed value is a legal
 * value of the type by calling the `serialize` method of GraphQL type
 * definition.
 *
 * If the field is an abstract type, determine the runtime type of the value
 * and then complete based on that type
 *
 * Otherwise, the field type expects a sub-selection set, and will complete the
 * value by evaluating all sub-selections.
 */ function $0449b901b9e9408e$var$completeValue(exeContext, returnType, fieldNodes, info, path, result) {
    // If result is an Error, throw a located error.
    if (result instanceof Error) throw result;
     // If field type is NonNull, complete for inner type, and throw field error
    // if result is null.
    if ((0, $8oLgk.isNonNullType)(returnType)) {
        var completed = $0449b901b9e9408e$var$completeValue(exeContext, returnType.ofType, fieldNodes, info, path, result);
        if (completed === null) throw new Error("Cannot return null for non-nullable field ".concat(info.parentType.name, ".").concat(info.fieldName, "."));
        return completed;
    } // If result value is null or undefined then return null.
    if (result == null) return null;
     // If field type is List, complete each item in the list with the inner type
    if ((0, $8oLgk.isListType)(returnType)) return $0449b901b9e9408e$var$completeListValue(exeContext, returnType, fieldNodes, info, path, result);
     // If field type is a leaf type, Scalar or Enum, serialize to a valid value,
    // returning null if serialization is not possible.
    if ((0, $8oLgk.isLeafType)(returnType)) return $0449b901b9e9408e$var$completeLeafValue(returnType, result);
     // If field type is an abstract type, Interface or Union, determine the
    // runtime Object type and complete for that type.
    if ((0, $8oLgk.isAbstractType)(returnType)) return $0449b901b9e9408e$var$completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result);
     // If field type is Object, execute and complete all sub-selections.
    // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $8oLgk.isObjectType)(returnType)) return $0449b901b9e9408e$var$completeObjectValue(exeContext, returnType, fieldNodes, info, path, result);
     // istanbul ignore next (Not reachable. All possible output types have been considered)
    (0, $fM9AB.default)(0, 'Cannot complete value of unexpected output type: ' + (0, $yEDl8.default)(returnType));
}
/**
 * Complete a list value by completing each item in the list with the
 * inner type
 */ function $0449b901b9e9408e$var$completeListValue(exeContext, returnType, fieldNodes, info, path, result) {
    // This is specified as a simple map, however we're optimizing the path
    // where the list contains no Promises by avoiding creating another Promise.
    var itemType = returnType.ofType;
    var containsPromise = false;
    var completedResults = (0, $iAT21.default)(result, function(item, index) {
        // No need to modify the info object containing the path,
        // since from here on it is not ever accessed by resolver functions.
        var itemPath = (0, $hEo2F.addPath)(path, index, undefined);
        try {
            var completedItem;
            if ((0, $jMqAK.default)(item)) completedItem = item.then(function(resolved) {
                return $0449b901b9e9408e$var$completeValue(exeContext, itemType, fieldNodes, info, itemPath, resolved);
            });
            else completedItem = $0449b901b9e9408e$var$completeValue(exeContext, itemType, fieldNodes, info, itemPath, item);
            if ((0, $jMqAK.default)(completedItem)) {
                containsPromise = true; // Note: we don't rely on a `catch` method, but we do expect "thenable"
                // to take a second callback for the error case.
                return completedItem.then(undefined, function(rawError) {
                    var error = (0, $csEv9.locatedError)(rawError, fieldNodes, (0, $hEo2F.pathToArray)(itemPath));
                    return $0449b901b9e9408e$var$handleFieldError(error, itemType, exeContext);
                });
            }
            return completedItem;
        } catch (rawError) {
            var error = (0, $csEv9.locatedError)(rawError, fieldNodes, (0, $hEo2F.pathToArray)(itemPath));
            return $0449b901b9e9408e$var$handleFieldError(error, itemType, exeContext);
        }
    });
    if (completedResults == null) throw new (0, $g5yZB.GraphQLError)("Expected Iterable, but did not find one for field \"".concat(info.parentType.name, ".").concat(info.fieldName, "\"."));
    return containsPromise ? Promise.all(completedResults) : completedResults;
}
/**
 * Complete a Scalar or Enum by serializing to a valid value, returning
 * null if serialization is not possible.
 */ function $0449b901b9e9408e$var$completeLeafValue(returnType, result) {
    var serializedResult = returnType.serialize(result);
    if (serializedResult === undefined) throw new Error("Expected a value of type \"".concat((0, $yEDl8.default)(returnType), "\" but ") + "received: ".concat((0, $yEDl8.default)(result)));
    return serializedResult;
}
/**
 * Complete a value of an abstract type by determining the runtime object type
 * of that value, then complete the value for that type.
 */ function $0449b901b9e9408e$var$completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result) {
    var _returnType$resolveTy;
    var resolveTypeFn = (_returnType$resolveTy = returnType.resolveType) !== null && _returnType$resolveTy !== void 0 ? _returnType$resolveTy : exeContext.typeResolver;
    var contextValue = exeContext.contextValue;
    var runtimeType = resolveTypeFn(result, contextValue, info, returnType);
    if ((0, $jMqAK.default)(runtimeType)) return runtimeType.then(function(resolvedRuntimeType) {
        return $0449b901b9e9408e$var$completeObjectValue(exeContext, $0449b901b9e9408e$var$ensureValidRuntimeType(resolvedRuntimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result);
    });
    return $0449b901b9e9408e$var$completeObjectValue(exeContext, $0449b901b9e9408e$var$ensureValidRuntimeType(runtimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result);
}
function $0449b901b9e9408e$var$ensureValidRuntimeType(runtimeTypeOrName, exeContext, returnType, fieldNodes, info, result) {
    if (runtimeTypeOrName == null) throw new (0, $g5yZB.GraphQLError)("Abstract type \"".concat(returnType.name, "\" must resolve to an Object type at runtime for field \"").concat(info.parentType.name, ".").concat(info.fieldName, "\". Either the \"").concat(returnType.name, "\" type should provide a \"resolveType\" function or each possible type should provide an \"isTypeOf\" function."), fieldNodes);
     // FIXME: temporary workaround until support for passing object types would be removed in v16.0.0
    var runtimeTypeName = (0, $8oLgk.isNamedType)(runtimeTypeOrName) ? runtimeTypeOrName.name : runtimeTypeOrName;
    if (typeof runtimeTypeName !== 'string') throw new (0, $g5yZB.GraphQLError)("Abstract type \"".concat(returnType.name, "\" must resolve to an Object type at runtime for field \"").concat(info.parentType.name, ".").concat(info.fieldName, "\" with ") + "value ".concat((0, $yEDl8.default)(result), ", received \"").concat((0, $yEDl8.default)(runtimeTypeOrName), "\"."));
    var runtimeType = exeContext.schema.getType(runtimeTypeName);
    if (runtimeType == null) throw new (0, $g5yZB.GraphQLError)("Abstract type \"".concat(returnType.name, "\" was resolve to a type \"").concat(runtimeTypeName, "\" that does not exist inside schema."), fieldNodes);
    if (!(0, $8oLgk.isObjectType)(runtimeType)) throw new (0, $g5yZB.GraphQLError)("Abstract type \"".concat(returnType.name, "\" was resolve to a non-object type \"").concat(runtimeTypeName, "\"."), fieldNodes);
    if (!exeContext.schema.isSubType(returnType, runtimeType)) throw new (0, $g5yZB.GraphQLError)("Runtime Object type \"".concat(runtimeType.name, "\" is not a possible type for \"").concat(returnType.name, "\"."), fieldNodes);
    return runtimeType;
}
/**
 * Complete an Object value by executing all sub-selections.
 */ function $0449b901b9e9408e$var$completeObjectValue(exeContext, returnType, fieldNodes, info, path, result) {
    // If there is an isTypeOf predicate function, call it with the
    // current result. If isTypeOf returns false, then raise an error rather
    // than continuing execution.
    if (returnType.isTypeOf) {
        var isTypeOf = returnType.isTypeOf(result, exeContext.contextValue, info);
        if ((0, $jMqAK.default)(isTypeOf)) return isTypeOf.then(function(resolvedIsTypeOf) {
            if (!resolvedIsTypeOf) throw $0449b901b9e9408e$var$invalidReturnTypeError(returnType, result, fieldNodes);
            return $0449b901b9e9408e$var$collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result);
        });
        if (!isTypeOf) throw $0449b901b9e9408e$var$invalidReturnTypeError(returnType, result, fieldNodes);
    }
    return $0449b901b9e9408e$var$collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result);
}
function $0449b901b9e9408e$var$invalidReturnTypeError(returnType, result, fieldNodes) {
    return new (0, $g5yZB.GraphQLError)("Expected value of type \"".concat(returnType.name, "\" but got: ").concat((0, $yEDl8.default)(result), "."), fieldNodes);
}
function $0449b901b9e9408e$var$collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result) {
    // Collect sub-fields to execute to complete this value.
    var subFieldNodes = $0449b901b9e9408e$var$collectSubfields(exeContext, returnType, fieldNodes);
    return $0449b901b9e9408e$var$executeFields(exeContext, returnType, result, path, subFieldNodes);
}
/**
 * A memoized collection of relevant subfields with regard to the return
 * type. Memoizing ensures the subfields are not repeatedly calculated, which
 * saves overhead when resolving lists of values.
 */ var $0449b901b9e9408e$var$collectSubfields = (0, $xeUe3.default)($0449b901b9e9408e$var$_collectSubfields);
function $0449b901b9e9408e$var$_collectSubfields(exeContext, returnType, fieldNodes) {
    var subFieldNodes = Object.create(null);
    var visitedFragmentNames = Object.create(null);
    for(var _i8 = 0; _i8 < fieldNodes.length; _i8++){
        var node = fieldNodes[_i8];
        if (node.selectionSet) subFieldNodes = $0449b901b9e9408e$export$c23741d442fe90e9(exeContext, returnType, node.selectionSet, subFieldNodes, visitedFragmentNames);
    }
    return subFieldNodes;
}
var $0449b901b9e9408e$export$4a45c17a1ba2cb7 = function defaultTypeResolver(value, contextValue, info, abstractType) {
    // First, look for `__typename`.
    if ((0, $cJPdE.default)(value) && typeof value.__typename === 'string') return value.__typename;
     // Otherwise, test each possible type.
    var possibleTypes = info.schema.getPossibleTypes(abstractType);
    var promisedIsTypeOfResults = [];
    for(var i = 0; i < possibleTypes.length; i++){
        var type = possibleTypes[i];
        if (type.isTypeOf) {
            var isTypeOfResult = type.isTypeOf(value, contextValue, info);
            if ((0, $jMqAK.default)(isTypeOfResult)) promisedIsTypeOfResults[i] = isTypeOfResult;
            else if (isTypeOfResult) return type.name;
        }
    }
    if (promisedIsTypeOfResults.length) return Promise.all(promisedIsTypeOfResults).then(function(isTypeOfResults) {
        for(var _i9 = 0; _i9 < isTypeOfResults.length; _i9++){
            if (isTypeOfResults[_i9]) return possibleTypes[_i9].name;
        }
    });
};
var $0449b901b9e9408e$export$21fc6d079630d659 = function defaultFieldResolver(source, args, contextValue, info) {
    // ensure source is a value for which property access is acceptable.
    if ((0, $cJPdE.default)(source) || typeof source === 'function') {
        var property = source[info.fieldName];
        if (typeof property === 'function') return source[info.fieldName](args, contextValue, info);
        return property;
    }
};
function $0449b901b9e9408e$export$dab6dcab745bb1b6(schema, parentType, fieldName) {
    if (fieldName === (0, $4Hpke.SchemaMetaFieldDef).name && schema.getQueryType() === parentType) return 0, $4Hpke.SchemaMetaFieldDef;
    else if (fieldName === (0, $4Hpke.TypeMetaFieldDef).name && schema.getQueryType() === parentType) return 0, $4Hpke.TypeMetaFieldDef;
    else if (fieldName === (0, $4Hpke.TypeNameMetaFieldDef).name) return 0, $4Hpke.TypeNameMetaFieldDef;
    return parentType.getFields()[fieldName];
}

});
parcelRegister("xeUe3", function(module, exports) {

$parcel$export(module.exports, "default", () => $063ea52d4dbbee9d$export$2e2bcd8739ae039);
/**
 * Memoizes the provided three-argument function.
 */ function $063ea52d4dbbee9d$export$2e2bcd8739ae039(fn) {
    var cache0;
    return function memoized(a1, a2, a3) {
        if (!cache0) cache0 = new WeakMap();
        var cache1 = cache0.get(a1);
        var cache2;
        if (cache1) {
            cache2 = cache1.get(a2);
            if (cache2) {
                var cachedValue = cache2.get(a3);
                if (cachedValue !== undefined) return cachedValue;
            }
        } else {
            cache1 = new WeakMap();
            cache0.set(a1, cache1);
        }
        if (!cache2) {
            cache2 = new WeakMap();
            cache1.set(a2, cache2);
        }
        var newValue = fn(a1, a2, a3);
        cache2.set(a3, newValue);
        return newValue;
    };
}

});

parcelRegister("jMqAK", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6672090fd5f8d8c$export$2e2bcd8739ae039);
/**
 * Returns true if the value acts like a Promise, i.e. has a "then" function,
 * otherwise returns false.
 */ // eslint-disable-next-line no-redeclare
function $e6672090fd5f8d8c$export$2e2bcd8739ae039(value) {
    return typeof (value === null || value === void 0 ? void 0 : value.then) === 'function';
}

});

parcelRegister("iAT21", function(module, exports) {

$parcel$export(module.exports, "default", () => $d89646edb2b9c31b$export$2e2bcd8739ae039);

var $6DBwa = parcelRequire("6DBwa");
function $d89646edb2b9c31b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d89646edb2b9c31b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d89646edb2b9c31b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d89646edb2b9c31b$var$_typeof(obj);
}
function $d89646edb2b9c31b$export$2e2bcd8739ae039(collection) {
    var mapFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function(item) {
        return item;
    };
    if (collection == null || $d89646edb2b9c31b$var$_typeof(collection) !== 'object') return null;
    if (Array.isArray(collection)) return collection.map(mapFn);
     // Is Iterable?
    var iteratorMethod = collection[0, $6DBwa.SYMBOL_ITERATOR];
    if (typeof iteratorMethod === 'function') {
        // $FlowFixMe[incompatible-use]
        var iterator = iteratorMethod.call(collection);
        var result = [];
        var step;
        for(var i = 0; !(step = iterator.next()).done; ++i)result.push(mapFn(step.value, i));
        return result;
    } // Is Array like?
    var length = collection.length;
    if (typeof length === 'number' && length >= 0 && length % 1 === 0) {
        var _result = [];
        for(var _i = 0; _i < length; ++_i){
            if (!Object.prototype.hasOwnProperty.call(collection, _i)) return null;
            _result.push(mapFn(collection[String(_i)], _i));
        }
        return _result;
    }
    return null;
}

});

parcelRegister("jyJ52", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3d4295120323fd9$export$2e2bcd8739ae039);

var $jMqAK = parcelRequire("jMqAK");
function $e3d4295120323fd9$export$2e2bcd8739ae039(values, callback, initialValue) {
    return values.reduce(function(previous, value) {
        return (0, $jMqAK.default)(previous) ? previous.then(function(resolved) {
            return callback(resolved, value);
        }) : callback(previous, value);
    }, initialValue);
}

});

parcelRegister("efgSh", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5ef8e565e79ecea$export$2e2bcd8739ae039);
/**
 * This function transforms a JS object `ObjMap<Promise<T>>` into
 * a `Promise<ObjMap<T>>`
 *
 * This is akin to bluebird's `Promise.props`, but implemented only using
 * `Promise.all` so it will work with any implementation of ES6 promises.
 */ function $a5ef8e565e79ecea$export$2e2bcd8739ae039(object) {
    var keys = Object.keys(object);
    var valuesAndPromises = keys.map(function(name) {
        return object[name];
    });
    return Promise.all(valuesAndPromises).then(function(values) {
        return values.reduce(function(resolvedObject, value, i) {
            resolvedObject[keys[i]] = value;
            return resolvedObject;
        }, Object.create(null));
    });
}

});

parcelRegister("hEo2F", function(module, exports) {

$parcel$export(module.exports, "addPath", () => $cd98d25b9dafb31a$export$4c25481b843feb0b);
$parcel$export(module.exports, "pathToArray", () => $cd98d25b9dafb31a$export$38d939edd7751830);
/**
 * Given a Path and a key, return a new Path containing the new key.
 */ function $cd98d25b9dafb31a$export$4c25481b843feb0b(prev, key, typename) {
    return {
        prev: prev,
        key: key,
        typename: typename
    };
}
function $cd98d25b9dafb31a$export$38d939edd7751830(path) {
    var flattened = [];
    var curr = path;
    while(curr){
        flattened.push(curr.key);
        curr = curr.prev;
    }
    return flattened.reverse();
}

});

parcelRegister("csEv9", function(module, exports) {

$parcel$export(module.exports, "locatedError", () => $912784482422d090$export$d6d5dddbbbfd3fca);

var $yEDl8 = parcelRequire("yEDl8");

var $g5yZB = parcelRequire("g5yZB");
function $912784482422d090$export$d6d5dddbbbfd3fca(rawOriginalError, nodes, path) {
    var _nodes;
    // Sometimes a non-error is thrown, wrap it as an Error instance to ensure a consistent Error interface.
    var originalError = rawOriginalError instanceof Error ? rawOriginalError : new Error('Unexpected error value: ' + (0, $yEDl8.default)(rawOriginalError)); // Note: this uses a brand-check to support GraphQL errors originating from other contexts.
    if (Array.isArray(originalError.path)) return originalError;
    return new (0, $g5yZB.GraphQLError)(originalError.message, (_nodes = originalError.nodes) !== null && _nodes !== void 0 ? _nodes : nodes, originalError.source, originalError.positions, path, originalError);
}

});

parcelRegister("bKGOe", function(module, exports) {

$parcel$export(module.exports, "validateSchema", () => $88e532994a71ff2b$export$4741711f07dbb8e7);
$parcel$export(module.exports, "assertValidSchema", () => $88e532994a71ff2b$export$d32aa1886d3569c6);

var $85NSv = parcelRequire("85NSv");

var $isVmt = parcelRequire("isVmt");

var $yEDl8 = parcelRequire("yEDl8");

var $g5yZB = parcelRequire("g5yZB");

var $csEv9 = parcelRequire("csEv9");

var $yHEIl = parcelRequire("yHEIl");

var $9GswX = parcelRequire("9GswX");

var $lUVCX = parcelRequire("lUVCX");

var $4Hpke = parcelRequire("4Hpke");

var $35Smo = parcelRequire("35Smo");

var $8oLgk = parcelRequire("8oLgk");
function $88e532994a71ff2b$export$4741711f07dbb8e7(schema) {
    // First check to ensure the provided value is in fact a GraphQLSchema.
    (0, $lUVCX.assertSchema)(schema); // If this Schema has already been validated, return the previous results.
    if (schema.__validationErrors) return schema.__validationErrors;
     // Validate the schema, producing a list of errors.
    var context = new $88e532994a71ff2b$var$SchemaValidationContext(schema);
    $88e532994a71ff2b$var$validateRootTypes(context);
    $88e532994a71ff2b$var$validateDirectives(context);
    $88e532994a71ff2b$var$validateTypes(context); // Persist the results of validation before returning to ensure validation
    // does not run multiple times for this schema.
    var errors = context.getErrors();
    schema.__validationErrors = errors;
    return errors;
}
function $88e532994a71ff2b$export$d32aa1886d3569c6(schema) {
    var errors = $88e532994a71ff2b$export$4741711f07dbb8e7(schema);
    if (errors.length !== 0) throw new Error(errors.map(function(error) {
        return error.message;
    }).join('\n\n'));
}
var $88e532994a71ff2b$var$SchemaValidationContext = /*#__PURE__*/ function() {
    function SchemaValidationContext(schema) {
        this._errors = [];
        this.schema = schema;
    }
    var _proto = SchemaValidationContext.prototype;
    _proto.reportError = function reportError(message, nodes) {
        var _nodes = Array.isArray(nodes) ? nodes.filter(Boolean) : nodes;
        this.addError(new (0, $g5yZB.GraphQLError)(message, _nodes));
    };
    _proto.addError = function addError(error) {
        this._errors.push(error);
    };
    _proto.getErrors = function getErrors() {
        return this._errors;
    };
    return SchemaValidationContext;
}();
function $88e532994a71ff2b$var$validateRootTypes(context) {
    var schema = context.schema;
    var queryType = schema.getQueryType();
    if (!queryType) context.reportError('Query root type must be provided.', schema.astNode);
    else if (!(0, $8oLgk.isObjectType)(queryType)) {
        var _getOperationTypeNode;
        context.reportError("Query root type must be Object type, it cannot be ".concat((0, $yEDl8.default)(queryType), "."), (_getOperationTypeNode = $88e532994a71ff2b$var$getOperationTypeNode(schema, 'query')) !== null && _getOperationTypeNode !== void 0 ? _getOperationTypeNode : queryType.astNode);
    }
    var mutationType = schema.getMutationType();
    if (mutationType && !(0, $8oLgk.isObjectType)(mutationType)) {
        var _getOperationTypeNode2;
        context.reportError('Mutation root type must be Object type if provided, it cannot be ' + "".concat((0, $yEDl8.default)(mutationType), "."), (_getOperationTypeNode2 = $88e532994a71ff2b$var$getOperationTypeNode(schema, 'mutation')) !== null && _getOperationTypeNode2 !== void 0 ? _getOperationTypeNode2 : mutationType.astNode);
    }
    var subscriptionType = schema.getSubscriptionType();
    if (subscriptionType && !(0, $8oLgk.isObjectType)(subscriptionType)) {
        var _getOperationTypeNode3;
        context.reportError('Subscription root type must be Object type if provided, it cannot be ' + "".concat((0, $yEDl8.default)(subscriptionType), "."), (_getOperationTypeNode3 = $88e532994a71ff2b$var$getOperationTypeNode(schema, 'subscription')) !== null && _getOperationTypeNode3 !== void 0 ? _getOperationTypeNode3 : subscriptionType.astNode);
    }
}
function $88e532994a71ff2b$var$getOperationTypeNode(schema, operation) {
    var operationNodes = $88e532994a71ff2b$var$getAllSubNodes(schema, function(node) {
        return node.operationTypes;
    });
    for(var _i2 = 0; _i2 < operationNodes.length; _i2++){
        var node = operationNodes[_i2];
        if (node.operation === operation) return node.type;
    }
    return undefined;
}
function $88e532994a71ff2b$var$validateDirectives(context) {
    for(var _i4 = 0, _context$schema$getDi2 = context.schema.getDirectives(); _i4 < _context$schema$getDi2.length; _i4++){
        var directive = _context$schema$getDi2[_i4];
        // Ensure all directives are in fact GraphQL directives.
        if (!(0, $35Smo.isDirective)(directive)) {
            context.reportError("Expected directive but got: ".concat((0, $yEDl8.default)(directive), "."), directive === null || directive === void 0 ? void 0 : directive.astNode);
            continue;
        } // Ensure they are named correctly.
        $88e532994a71ff2b$var$validateName(context, directive); // TODO: Ensure proper locations.
        // Ensure the arguments are valid.
        for(var _i6 = 0, _directive$args2 = directive.args; _i6 < _directive$args2.length; _i6++){
            var arg = _directive$args2[_i6];
            // Ensure they are named correctly.
            $88e532994a71ff2b$var$validateName(context, arg); // Ensure the type is an input type.
            if (!(0, $8oLgk.isInputType)(arg.type)) context.reportError("The type of @".concat(directive.name, "(").concat(arg.name, ":) must be Input Type ") + "but got: ".concat((0, $yEDl8.default)(arg.type), "."), arg.astNode);
            if ((0, $8oLgk.isRequiredArgument)(arg) && arg.deprecationReason != null) {
                var _arg$astNode;
                context.reportError("Required argument @".concat(directive.name, "(").concat(arg.name, ":) cannot be deprecated."), [
                    $88e532994a71ff2b$var$getDeprecatedDirectiveNode(arg.astNode),
                    (_arg$astNode = arg.astNode) === null || _arg$astNode === void 0 ? void 0 : _arg$astNode.type
                ]);
            }
        }
    }
}
function $88e532994a71ff2b$var$validateName(context, node) {
    // Ensure names are valid, however introspection types opt out.
    var error = (0, $yHEIl.isValidNameError)(node.name);
    if (error) context.addError((0, $csEv9.locatedError)(error, node.astNode));
}
function $88e532994a71ff2b$var$validateTypes(context) {
    var validateInputObjectCircularRefs = $88e532994a71ff2b$var$createInputObjectCircularRefsValidator(context);
    var typeMap = context.schema.getTypeMap();
    for(var _i8 = 0, _objectValues2 = (0, $isVmt.default)(typeMap); _i8 < _objectValues2.length; _i8++){
        var type = _objectValues2[_i8];
        // Ensure all provided types are in fact GraphQL type.
        if (!(0, $8oLgk.isNamedType)(type)) {
            context.reportError("Expected GraphQL named type but got: ".concat((0, $yEDl8.default)(type), "."), type.astNode);
            continue;
        } // Ensure it is named correctly (excluding introspection types).
        if (!(0, $4Hpke.isIntrospectionType)(type)) $88e532994a71ff2b$var$validateName(context, type);
        if ((0, $8oLgk.isObjectType)(type)) {
            // Ensure fields are valid
            $88e532994a71ff2b$var$validateFields(context, type); // Ensure objects implement the interfaces they claim to.
            $88e532994a71ff2b$var$validateInterfaces(context, type);
        } else if ((0, $8oLgk.isInterfaceType)(type)) {
            // Ensure fields are valid.
            $88e532994a71ff2b$var$validateFields(context, type); // Ensure interfaces implement the interfaces they claim to.
            $88e532994a71ff2b$var$validateInterfaces(context, type);
        } else if ((0, $8oLgk.isUnionType)(type)) // Ensure Unions include valid member types.
        $88e532994a71ff2b$var$validateUnionMembers(context, type);
        else if ((0, $8oLgk.isEnumType)(type)) // Ensure Enums have valid values.
        $88e532994a71ff2b$var$validateEnumValues(context, type);
        else if ((0, $8oLgk.isInputObjectType)(type)) {
            // Ensure Input Object fields are valid.
            $88e532994a71ff2b$var$validateInputFields(context, type); // Ensure Input Objects do not contain non-nullable circular references
            validateInputObjectCircularRefs(type);
        }
    }
}
function $88e532994a71ff2b$var$validateFields(context, type) {
    var fields = (0, $isVmt.default)(type.getFields()); // Objects and Interfaces both must define one or more fields.
    if (fields.length === 0) context.reportError("Type ".concat(type.name, " must define one or more fields."), $88e532994a71ff2b$var$getAllNodes(type));
    for(var _i10 = 0; _i10 < fields.length; _i10++){
        var field = fields[_i10];
        // Ensure they are named correctly.
        $88e532994a71ff2b$var$validateName(context, field); // Ensure the type is an output type
        if (!(0, $8oLgk.isOutputType)(field.type)) {
            var _field$astNode;
            context.reportError("The type of ".concat(type.name, ".").concat(field.name, " must be Output Type ") + "but got: ".concat((0, $yEDl8.default)(field.type), "."), (_field$astNode = field.astNode) === null || _field$astNode === void 0 ? void 0 : _field$astNode.type);
        } // Ensure the arguments are valid
        for(var _i12 = 0, _field$args2 = field.args; _i12 < _field$args2.length; _i12++){
            var arg = _field$args2[_i12];
            var argName = arg.name; // Ensure they are named correctly.
            $88e532994a71ff2b$var$validateName(context, arg); // Ensure the type is an input type
            if (!(0, $8oLgk.isInputType)(arg.type)) {
                var _arg$astNode2;
                context.reportError("The type of ".concat(type.name, ".").concat(field.name, "(").concat(argName, ":) must be Input ") + "Type but got: ".concat((0, $yEDl8.default)(arg.type), "."), (_arg$astNode2 = arg.astNode) === null || _arg$astNode2 === void 0 ? void 0 : _arg$astNode2.type);
            }
            if ((0, $8oLgk.isRequiredArgument)(arg) && arg.deprecationReason != null) {
                var _arg$astNode3;
                context.reportError("Required argument ".concat(type.name, ".").concat(field.name, "(").concat(argName, ":) cannot be deprecated."), [
                    $88e532994a71ff2b$var$getDeprecatedDirectiveNode(arg.astNode),
                    (_arg$astNode3 = arg.astNode) === null || _arg$astNode3 === void 0 ? void 0 : _arg$astNode3.type
                ]);
            }
        }
    }
}
function $88e532994a71ff2b$var$validateInterfaces(context, type) {
    var ifaceTypeNames = Object.create(null);
    for(var _i14 = 0, _type$getInterfaces2 = type.getInterfaces(); _i14 < _type$getInterfaces2.length; _i14++){
        var iface = _type$getInterfaces2[_i14];
        if (!(0, $8oLgk.isInterfaceType)(iface)) {
            context.reportError("Type ".concat((0, $yEDl8.default)(type), " must only implement Interface types, ") + "it cannot implement ".concat((0, $yEDl8.default)(iface), "."), $88e532994a71ff2b$var$getAllImplementsInterfaceNodes(type, iface));
            continue;
        }
        if (type === iface) {
            context.reportError("Type ".concat(type.name, " cannot implement itself because it would create a circular reference."), $88e532994a71ff2b$var$getAllImplementsInterfaceNodes(type, iface));
            continue;
        }
        if (ifaceTypeNames[iface.name]) {
            context.reportError("Type ".concat(type.name, " can only implement ").concat(iface.name, " once."), $88e532994a71ff2b$var$getAllImplementsInterfaceNodes(type, iface));
            continue;
        }
        ifaceTypeNames[iface.name] = true;
        $88e532994a71ff2b$var$validateTypeImplementsAncestors(context, type, iface);
        $88e532994a71ff2b$var$validateTypeImplementsInterface(context, type, iface);
    }
}
function $88e532994a71ff2b$var$validateTypeImplementsInterface(context, type, iface) {
    var typeFieldMap = type.getFields(); // Assert each interface field is implemented.
    for(var _i16 = 0, _objectValues4 = (0, $isVmt.default)(iface.getFields()); _i16 < _objectValues4.length; _i16++){
        var ifaceField = _objectValues4[_i16];
        var fieldName = ifaceField.name;
        var typeField = typeFieldMap[fieldName]; // Assert interface field exists on type.
        if (!typeField) {
            context.reportError("Interface field ".concat(iface.name, ".").concat(fieldName, " expected but ").concat(type.name, " does not provide it."), [
                ifaceField.astNode
            ].concat($88e532994a71ff2b$var$getAllNodes(type)));
            continue;
        } // Assert interface field type is satisfied by type field type, by being
        // a valid subtype. (covariant)
        if (!(0, $9GswX.isTypeSubTypeOf)(context.schema, typeField.type, ifaceField.type)) {
            var _ifaceField$astNode, _typeField$astNode;
            context.reportError("Interface field ".concat(iface.name, ".").concat(fieldName, " expects type ") + "".concat((0, $yEDl8.default)(ifaceField.type), " but ").concat(type.name, ".").concat(fieldName, " ") + "is type ".concat((0, $yEDl8.default)(typeField.type), "."), [
                (_ifaceField$astNode = ifaceField.astNode) === null || _ifaceField$astNode === void 0 ? void 0 : _ifaceField$astNode.type,
                (_typeField$astNode = typeField.astNode) === null || _typeField$astNode === void 0 ? void 0 : _typeField$astNode.type
            ]);
        } // Assert each interface field arg is implemented.
        var _loop = function _loop(_i18, _ifaceField$args2) {
            var ifaceArg = _ifaceField$args2[_i18];
            var argName = ifaceArg.name;
            var typeArg = (0, $85NSv.default)(typeField.args, function(arg) {
                return arg.name === argName;
            }); // Assert interface field arg exists on object field.
            if (!typeArg) {
                context.reportError("Interface field argument ".concat(iface.name, ".").concat(fieldName, "(").concat(argName, ":) expected but ").concat(type.name, ".").concat(fieldName, " does not provide it."), [
                    ifaceArg.astNode,
                    typeField.astNode
                ]);
                return "continue";
            } // Assert interface field arg type matches object field arg type.
            // (invariant)
            // TODO: change to contravariant?
            if (!(0, $9GswX.isEqualType)(ifaceArg.type, typeArg.type)) {
                var _ifaceArg$astNode, _typeArg$astNode;
                context.reportError("Interface field argument ".concat(iface.name, ".").concat(fieldName, "(").concat(argName, ":) ") + "expects type ".concat((0, $yEDl8.default)(ifaceArg.type), " but ") + "".concat(type.name, ".").concat(fieldName, "(").concat(argName, ":) is type ") + "".concat((0, $yEDl8.default)(typeArg.type), "."), [
                    (_ifaceArg$astNode = ifaceArg.astNode) === null || _ifaceArg$astNode === void 0 ? void 0 : _ifaceArg$astNode.type,
                    (_typeArg$astNode = typeArg.astNode) === null || _typeArg$astNode === void 0 ? void 0 : _typeArg$astNode.type
                ]);
            } // TODO: validate default values?
        };
        for(var _i18 = 0, _ifaceField$args2 = ifaceField.args; _i18 < _ifaceField$args2.length; _i18++){
            var _ret = _loop(_i18, _ifaceField$args2);
            if (_ret === "continue") continue;
        } // Assert additional arguments must not be required.
        var _loop2 = function _loop2(_i20, _typeField$args2) {
            var typeArg = _typeField$args2[_i20];
            var argName = typeArg.name;
            var ifaceArg = (0, $85NSv.default)(ifaceField.args, function(arg) {
                return arg.name === argName;
            });
            if (!ifaceArg && (0, $8oLgk.isRequiredArgument)(typeArg)) context.reportError("Object field ".concat(type.name, ".").concat(fieldName, " includes required argument ").concat(argName, " that is missing from the Interface field ").concat(iface.name, ".").concat(fieldName, "."), [
                typeArg.astNode,
                ifaceField.astNode
            ]);
        };
        for(var _i20 = 0, _typeField$args2 = typeField.args; _i20 < _typeField$args2.length; _i20++)_loop2(_i20, _typeField$args2);
    }
}
function $88e532994a71ff2b$var$validateTypeImplementsAncestors(context, type, iface) {
    var ifaceInterfaces = type.getInterfaces();
    for(var _i22 = 0, _iface$getInterfaces2 = iface.getInterfaces(); _i22 < _iface$getInterfaces2.length; _i22++){
        var transitive = _iface$getInterfaces2[_i22];
        if (ifaceInterfaces.indexOf(transitive) === -1) context.reportError(transitive === type ? "Type ".concat(type.name, " cannot implement ").concat(iface.name, " because it would create a circular reference.") : "Type ".concat(type.name, " must implement ").concat(transitive.name, " because it is implemented by ").concat(iface.name, "."), [].concat($88e532994a71ff2b$var$getAllImplementsInterfaceNodes(iface, transitive), $88e532994a71ff2b$var$getAllImplementsInterfaceNodes(type, iface)));
    }
}
function $88e532994a71ff2b$var$validateUnionMembers(context, union) {
    var memberTypes = union.getTypes();
    if (memberTypes.length === 0) context.reportError("Union type ".concat(union.name, " must define one or more member types."), $88e532994a71ff2b$var$getAllNodes(union));
    var includedTypeNames = Object.create(null);
    for(var _i24 = 0; _i24 < memberTypes.length; _i24++){
        var memberType = memberTypes[_i24];
        if (includedTypeNames[memberType.name]) {
            context.reportError("Union type ".concat(union.name, " can only include type ").concat(memberType.name, " once."), $88e532994a71ff2b$var$getUnionMemberTypeNodes(union, memberType.name));
            continue;
        }
        includedTypeNames[memberType.name] = true;
        if (!(0, $8oLgk.isObjectType)(memberType)) context.reportError("Union type ".concat(union.name, " can only include Object types, ") + "it cannot include ".concat((0, $yEDl8.default)(memberType), "."), $88e532994a71ff2b$var$getUnionMemberTypeNodes(union, String(memberType)));
    }
}
function $88e532994a71ff2b$var$validateEnumValues(context, enumType) {
    var enumValues = enumType.getValues();
    if (enumValues.length === 0) context.reportError("Enum type ".concat(enumType.name, " must define one or more values."), $88e532994a71ff2b$var$getAllNodes(enumType));
    for(var _i26 = 0; _i26 < enumValues.length; _i26++){
        var enumValue = enumValues[_i26];
        var valueName = enumValue.name; // Ensure valid name.
        $88e532994a71ff2b$var$validateName(context, enumValue);
        if (valueName === 'true' || valueName === 'false' || valueName === 'null') context.reportError("Enum type ".concat(enumType.name, " cannot include value: ").concat(valueName, "."), enumValue.astNode);
    }
}
function $88e532994a71ff2b$var$validateInputFields(context, inputObj) {
    var fields = (0, $isVmt.default)(inputObj.getFields());
    if (fields.length === 0) context.reportError("Input Object type ".concat(inputObj.name, " must define one or more fields."), $88e532994a71ff2b$var$getAllNodes(inputObj));
     // Ensure the arguments are valid
    for(var _i28 = 0; _i28 < fields.length; _i28++){
        var field = fields[_i28];
        // Ensure they are named correctly.
        $88e532994a71ff2b$var$validateName(context, field); // Ensure the type is an input type
        if (!(0, $8oLgk.isInputType)(field.type)) {
            var _field$astNode2;
            context.reportError("The type of ".concat(inputObj.name, ".").concat(field.name, " must be Input Type ") + "but got: ".concat((0, $yEDl8.default)(field.type), "."), (_field$astNode2 = field.astNode) === null || _field$astNode2 === void 0 ? void 0 : _field$astNode2.type);
        }
        if ((0, $8oLgk.isRequiredInputField)(field) && field.deprecationReason != null) {
            var _field$astNode3;
            context.reportError("Required input field ".concat(inputObj.name, ".").concat(field.name, " cannot be deprecated."), [
                $88e532994a71ff2b$var$getDeprecatedDirectiveNode(field.astNode),
                (_field$astNode3 = field.astNode) === null || _field$astNode3 === void 0 ? void 0 : _field$astNode3.type
            ]);
        }
    }
}
function $88e532994a71ff2b$var$createInputObjectCircularRefsValidator(context) {
    // Modified copy of algorithm from 'src/validation/rules/NoFragmentCycles.js'.
    // Tracks already visited types to maintain O(N) and to ensure that cycles
    // are not redundantly reported.
    var visitedTypes = Object.create(null); // Array of types nodes used to produce meaningful errors
    var fieldPath = []; // Position in the type path
    var fieldPathIndexByTypeName = Object.create(null);
    return detectCycleRecursive; // This does a straight-forward DFS to find cycles.
    // It does not terminate when a cycle was found but continues to explore
    // the graph to find all possible cycles.
    function detectCycleRecursive(inputObj) {
        if (visitedTypes[inputObj.name]) return;
        visitedTypes[inputObj.name] = true;
        fieldPathIndexByTypeName[inputObj.name] = fieldPath.length;
        var fields = (0, $isVmt.default)(inputObj.getFields());
        for(var _i30 = 0; _i30 < fields.length; _i30++){
            var field = fields[_i30];
            if ((0, $8oLgk.isNonNullType)(field.type) && (0, $8oLgk.isInputObjectType)(field.type.ofType)) {
                var fieldType = field.type.ofType;
                var cycleIndex = fieldPathIndexByTypeName[fieldType.name];
                fieldPath.push(field);
                if (cycleIndex === undefined) detectCycleRecursive(fieldType);
                else {
                    var cyclePath = fieldPath.slice(cycleIndex);
                    var pathStr = cyclePath.map(function(fieldObj) {
                        return fieldObj.name;
                    }).join('.');
                    context.reportError("Cannot reference Input Object \"".concat(fieldType.name, "\" within itself through a series of non-null fields: \"").concat(pathStr, "\"."), cyclePath.map(function(fieldObj) {
                        return fieldObj.astNode;
                    }));
                }
                fieldPath.pop();
            }
        }
        fieldPathIndexByTypeName[inputObj.name] = undefined;
    }
}
function $88e532994a71ff2b$var$getAllNodes(object) {
    var astNode = object.astNode, extensionASTNodes = object.extensionASTNodes;
    return astNode ? extensionASTNodes ? [
        astNode
    ].concat(extensionASTNodes) : [
        astNode
    ] : extensionASTNodes !== null && extensionASTNodes !== void 0 ? extensionASTNodes : [];
}
function $88e532994a71ff2b$var$getAllSubNodes(object, getter) {
    var subNodes = [];
    for(var _i32 = 0, _getAllNodes2 = $88e532994a71ff2b$var$getAllNodes(object); _i32 < _getAllNodes2.length; _i32++){
        var _getter;
        var node = _getAllNodes2[_i32];
        // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        subNodes = subNodes.concat((_getter = getter(node)) !== null && _getter !== void 0 ? _getter : []);
    }
    return subNodes;
}
function $88e532994a71ff2b$var$getAllImplementsInterfaceNodes(type, iface) {
    return $88e532994a71ff2b$var$getAllSubNodes(type, function(typeNode) {
        return typeNode.interfaces;
    }).filter(function(ifaceNode) {
        return ifaceNode.name.value === iface.name;
    });
}
function $88e532994a71ff2b$var$getUnionMemberTypeNodes(union, typeName) {
    return $88e532994a71ff2b$var$getAllSubNodes(union, function(unionNode) {
        return unionNode.types;
    }).filter(function(typeNode) {
        return typeNode.name.value === typeName;
    });
}
function $88e532994a71ff2b$var$getDeprecatedDirectiveNode(definitionNode) {
    var _definitionNode$direc;
    // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
    return definitionNode === null || definitionNode === void 0 ? void 0 : (_definitionNode$direc = definitionNode.directives) === null || _definitionNode$direc === void 0 ? void 0 : _definitionNode$direc.find(function(node) {
        return node.name.value === (0, $35Smo.GraphQLDeprecatedDirective).name;
    });
}

});
parcelRegister("85NSv", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e457b17533127a2$export$2e2bcd8739ae039);
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound]
var $5e457b17533127a2$var$find = Array.prototype.find ? function(list, predicate) {
    return Array.prototype.find.call(list, predicate);
} : function(list, predicate) {
    for(var _i2 = 0; _i2 < list.length; _i2++){
        var value = list[_i2];
        if (predicate(value)) return value;
    }
};
var $5e457b17533127a2$export$2e2bcd8739ae039 = $5e457b17533127a2$var$find;

});

parcelRegister("isVmt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d717564e7dffc7e6$export$2e2bcd8739ae039);
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var $d717564e7dffc7e6$var$objectValues = Object.values || function(obj) {
    return Object.keys(obj).map(function(key) {
        return obj[key];
    });
};
var $d717564e7dffc7e6$export$2e2bcd8739ae039 = $d717564e7dffc7e6$var$objectValues;

});

parcelRegister("yHEIl", function(module, exports) {

$parcel$export(module.exports, "isValidNameError", () => $06850a33089e598e$export$4ecdb5b419400d23);

var $a1qmV = parcelRequire("a1qmV");

var $g5yZB = parcelRequire("g5yZB");
var $06850a33089e598e$var$NAME_RX = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
function $06850a33089e598e$export$38c12a9ffd7a1417(name) {
    var error = $06850a33089e598e$export$4ecdb5b419400d23(name);
    if (error) throw error;
    return name;
}
function $06850a33089e598e$export$4ecdb5b419400d23(name) {
    typeof name === 'string' || (0, $a1qmV.default)(0, 'Expected name to be a string.');
    if (name.length > 1 && name[0] === '_' && name[1] === '_') return new (0, $g5yZB.GraphQLError)("Name \"".concat(name, "\" must not begin with \"__\", which is reserved by GraphQL introspection."));
    if (!$06850a33089e598e$var$NAME_RX.test(name)) return new (0, $g5yZB.GraphQLError)("Names must match /^[_a-zA-Z][_a-zA-Z0-9]*$/ but \"".concat(name, "\" does not."));
}

});

parcelRegister("9GswX", function(module, exports) {

$parcel$export(module.exports, "isEqualType", () => $70ce2ade98c385c8$export$c8e484a9929e6d9f);
$parcel$export(module.exports, "isTypeSubTypeOf", () => $70ce2ade98c385c8$export$c3f31adb68f3e853);
$parcel$export(module.exports, "doTypesOverlap", () => $70ce2ade98c385c8$export$5e7a8ea86de754bd);

var $8oLgk = parcelRequire("8oLgk");
function $70ce2ade98c385c8$export$c8e484a9929e6d9f(typeA, typeB) {
    // Equivalent types are equal.
    if (typeA === typeB) return true;
     // If either type is non-null, the other must also be non-null.
    if ((0, $8oLgk.isNonNullType)(typeA) && (0, $8oLgk.isNonNullType)(typeB)) return $70ce2ade98c385c8$export$c8e484a9929e6d9f(typeA.ofType, typeB.ofType);
     // If either type is a list, the other must also be a list.
    if ((0, $8oLgk.isListType)(typeA) && (0, $8oLgk.isListType)(typeB)) return $70ce2ade98c385c8$export$c8e484a9929e6d9f(typeA.ofType, typeB.ofType);
     // Otherwise the types are not equal.
    return false;
}
function $70ce2ade98c385c8$export$c3f31adb68f3e853(schema, maybeSubType, superType) {
    // Equivalent type is a valid subtype
    if (maybeSubType === superType) return true;
     // If superType is non-null, maybeSubType must also be non-null.
    if ((0, $8oLgk.isNonNullType)(superType)) {
        if ((0, $8oLgk.isNonNullType)(maybeSubType)) return $70ce2ade98c385c8$export$c3f31adb68f3e853(schema, maybeSubType.ofType, superType.ofType);
        return false;
    }
    if ((0, $8oLgk.isNonNullType)(maybeSubType)) // If superType is nullable, maybeSubType may be non-null or nullable.
    return $70ce2ade98c385c8$export$c3f31adb68f3e853(schema, maybeSubType.ofType, superType);
     // If superType type is a list, maybeSubType type must also be a list.
    if ((0, $8oLgk.isListType)(superType)) {
        if ((0, $8oLgk.isListType)(maybeSubType)) return $70ce2ade98c385c8$export$c3f31adb68f3e853(schema, maybeSubType.ofType, superType.ofType);
        return false;
    }
    if ((0, $8oLgk.isListType)(maybeSubType)) // If superType is not a list, maybeSubType must also be not a list.
    return false;
     // If superType type is an abstract type, check if it is super type of maybeSubType.
    // Otherwise, the child type is not a valid subtype of the parent type.
    return (0, $8oLgk.isAbstractType)(superType) && ((0, $8oLgk.isInterfaceType)(maybeSubType) || (0, $8oLgk.isObjectType)(maybeSubType)) && schema.isSubType(superType, maybeSubType);
}
function $70ce2ade98c385c8$export$5e7a8ea86de754bd(schema, typeA, typeB) {
    // Equivalent types overlap
    if (typeA === typeB) return true;
    if ((0, $8oLgk.isAbstractType)(typeA)) {
        if ((0, $8oLgk.isAbstractType)(typeB)) // If both types are abstract, then determine if there is any intersection
        // between possible concrete types of each.
        return schema.getPossibleTypes(typeA).some(function(type) {
            return schema.isSubType(typeB, type);
        });
         // Determine if the latter type is a possible concrete type of the former.
        return schema.isSubType(typeA, typeB);
    }
    if ((0, $8oLgk.isAbstractType)(typeB)) // Determine if the former type is a possible concrete type of the latter.
    return schema.isSubType(typeB, typeA);
     // Otherwise the types do not overlap.
    return false;
}

});
parcelRegister("8oLgk", function(module, exports) {

$parcel$export(module.exports, "isType", () => $61d539f5c2a76fac$export$26b9f946b448f23e);
$parcel$export(module.exports, "isScalarType", () => $61d539f5c2a76fac$export$5ef3b9aefb31c08b);
$parcel$export(module.exports, "isObjectType", () => $61d539f5c2a76fac$export$f3091ca7b0907a5f);
$parcel$export(module.exports, "isInterfaceType", () => $61d539f5c2a76fac$export$32fba5696fa641e);
$parcel$export(module.exports, "isUnionType", () => $61d539f5c2a76fac$export$cca4caab5ef5a545);
$parcel$export(module.exports, "isEnumType", () => $61d539f5c2a76fac$export$360fc30cf304623);
$parcel$export(module.exports, "isInputObjectType", () => $61d539f5c2a76fac$export$594edc80cf154b94);
$parcel$export(module.exports, "isListType", () => $61d539f5c2a76fac$export$f1003c1e9d4b008c);
$parcel$export(module.exports, "isNonNullType", () => $61d539f5c2a76fac$export$146b6508fa0d6c82);
$parcel$export(module.exports, "GraphQLScalarType", () => $61d539f5c2a76fac$export$64842b98ea53a3c9);
$parcel$export(module.exports, "GraphQLObjectType", () => $61d539f5c2a76fac$export$375d3757a19c2e6e);
$parcel$export(module.exports, "assertObjectType", () => $61d539f5c2a76fac$export$37a13eb12fbf3bc7);
$parcel$export(module.exports, "GraphQLInterfaceType", () => $61d539f5c2a76fac$export$148e92587b8bf1f9);
$parcel$export(module.exports, "assertInterfaceType", () => $61d539f5c2a76fac$export$b0fa8729bfe4811b);
$parcel$export(module.exports, "GraphQLUnionType", () => $61d539f5c2a76fac$export$33c479b4c3812d0b);
$parcel$export(module.exports, "GraphQLEnumType", () => $61d539f5c2a76fac$export$2577fb93f8748953);
$parcel$export(module.exports, "GraphQLInputObjectType", () => $61d539f5c2a76fac$export$ea29baa44b9fd772);
$parcel$export(module.exports, "GraphQLList", () => $61d539f5c2a76fac$export$de552006a6243367);
$parcel$export(module.exports, "GraphQLNonNull", () => $61d539f5c2a76fac$export$ea3122a3d819ac9d);
$parcel$export(module.exports, "isInputType", () => $61d539f5c2a76fac$export$1e617af703572bb5);
$parcel$export(module.exports, "isOutputType", () => $61d539f5c2a76fac$export$27aadee607de5794);
$parcel$export(module.exports, "isLeafType", () => $61d539f5c2a76fac$export$b390adabc64bab3);
$parcel$export(module.exports, "isCompositeType", () => $61d539f5c2a76fac$export$3d8f0e61f2e75bb0);
$parcel$export(module.exports, "isAbstractType", () => $61d539f5c2a76fac$export$6ea44a810dec4ac5);
$parcel$export(module.exports, "assertNullableType", () => $61d539f5c2a76fac$export$9c6e9b78e1767de4);
$parcel$export(module.exports, "getNullableType", () => $61d539f5c2a76fac$export$88b885687e78334b);
$parcel$export(module.exports, "isNamedType", () => $61d539f5c2a76fac$export$f99194494d5b1a26);
$parcel$export(module.exports, "getNamedType", () => $61d539f5c2a76fac$export$e6cd8ba67f39ede0);
$parcel$export(module.exports, "argsToArgsConfig", () => $61d539f5c2a76fac$export$ae5ade30c645f6fd);
$parcel$export(module.exports, "isRequiredArgument", () => $61d539f5c2a76fac$export$caef08b21560291a);
$parcel$export(module.exports, "isRequiredInputField", () => $61d539f5c2a76fac$export$2657dcc79c2b6229);

var $ge05d = parcelRequire("ge05d");

var $6DBwa = parcelRequire("6DBwa");

var $yEDl8 = parcelRequire("yEDl8");

var $aRWmX = parcelRequire("aRWmX");

var $eqSe6 = parcelRequire("eqSe6");

var $2mUbt = parcelRequire("2mUbt");

var $a1qmV = parcelRequire("a1qmV");

var $2gSpW = parcelRequire("2gSpW");

var $6B4dU = parcelRequire("6B4dU");

var $h4f6N = parcelRequire("h4f6N");

var $cJPdE = parcelRequire("cJPdE");

var $frao6 = parcelRequire("frao6");

var $520Pd = parcelRequire("520Pd");

var $gXVhx = parcelRequire("gXVhx");

var $g5yZB = parcelRequire("g5yZB");

var $bzIlO = parcelRequire("bzIlO");

var $1c8Um = parcelRequire("1c8Um");

var $ccOQ3 = parcelRequire("ccOQ3");
function $61d539f5c2a76fac$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $61d539f5c2a76fac$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $61d539f5c2a76fac$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $61d539f5c2a76fac$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $61d539f5c2a76fac$export$26b9f946b448f23e(type) {
    return $61d539f5c2a76fac$export$5ef3b9aefb31c08b(type) || $61d539f5c2a76fac$export$f3091ca7b0907a5f(type) || $61d539f5c2a76fac$export$32fba5696fa641e(type) || $61d539f5c2a76fac$export$cca4caab5ef5a545(type) || $61d539f5c2a76fac$export$360fc30cf304623(type) || $61d539f5c2a76fac$export$594edc80cf154b94(type) || $61d539f5c2a76fac$export$f1003c1e9d4b008c(type) || $61d539f5c2a76fac$export$146b6508fa0d6c82(type);
}
function $61d539f5c2a76fac$export$804de46662e4ac95(type) {
    if (!$61d539f5c2a76fac$export$26b9f946b448f23e(type)) throw new Error("Expected ".concat((0, $yEDl8.default)(type), " to be a GraphQL type."));
    return type;
}
function $61d539f5c2a76fac$export$5ef3b9aefb31c08b(type) {
    return (0, $6B4dU.default)(type, $61d539f5c2a76fac$export$64842b98ea53a3c9);
}
function $61d539f5c2a76fac$export$6bfb69547e804cfa(type) {
    if (!$61d539f5c2a76fac$export$5ef3b9aefb31c08b(type)) throw new Error("Expected ".concat((0, $yEDl8.default)(type), " to be a GraphQL Scalar type."));
    return type;
}
function $61d539f5c2a76fac$export$f3091ca7b0907a5f(type) {
    return (0, $6B4dU.default)(type, $61d539f5c2a76fac$export$375d3757a19c2e6e);
}
function $61d539f5c2a76fac$export$37a13eb12fbf3bc7(type) {
    if (!$61d539f5c2a76fac$export$f3091ca7b0907a5f(type)) throw new Error("Expected ".concat((0, $yEDl8.default)(type), " to be a GraphQL Object type."));
    return type;
}
function $61d539f5c2a76fac$export$32fba5696fa641e(type) {
    return (0, $6B4dU.default)(type, $61d539f5c2a76fac$export$148e92587b8bf1f9);
}
function $61d539f5c2a76fac$export$b0fa8729bfe4811b(type) {
    if (!$61d539f5c2a76fac$export$32fba5696fa641e(type)) throw new Error("Expected ".concat((0, $yEDl8.default)(type), " to be a GraphQL Interface type."));
    return type;
}
function $61d539f5c2a76fac$export$cca4caab5ef5a545(type) {
    return (0, $6B4dU.default)(type, $61d539f5c2a76fac$export$33c479b4c3812d0b);
}
function $61d539f5c2a76fac$export$fd1fc643145b79aa(type) {
    if (!$61d539f5c2a76fac$export$cca4caab5ef5a545(type)) throw new Error("Expected ".concat((0, $yEDl8.default)(type), " to be a GraphQL Union type."));
    return type;
}
function $61d539f5c2a76fac$export$360fc30cf304623(type) {
    return (0, $6B4dU.default)(type, $61d539f5c2a76fac$export$2577fb93f8748953);
}
function $61d539f5c2a76fac$export$152b058be1610b0e(type) {
    if (!$61d539f5c2a76fac$export$360fc30cf304623(type)) throw new Error("Expected ".concat((0, $yEDl8.default)(type), " to be a GraphQL Enum type."));
    return type;
}
function $61d539f5c2a76fac$export$594edc80cf154b94(type) {
    return (0, $6B4dU.default)(type, $61d539f5c2a76fac$export$ea29baa44b9fd772);
}
function $61d539f5c2a76fac$export$d3177a47c4ed448a(type) {
    if (!$61d539f5c2a76fac$export$594edc80cf154b94(type)) throw new Error("Expected ".concat((0, $yEDl8.default)(type), " to be a GraphQL Input Object type."));
    return type;
}
function $61d539f5c2a76fac$export$f1003c1e9d4b008c(type) {
    return (0, $6B4dU.default)(type, $61d539f5c2a76fac$export$de552006a6243367);
}
function $61d539f5c2a76fac$export$a4a2309317558e91(type) {
    if (!$61d539f5c2a76fac$export$f1003c1e9d4b008c(type)) throw new Error("Expected ".concat((0, $yEDl8.default)(type), " to be a GraphQL List type."));
    return type;
}
function $61d539f5c2a76fac$export$146b6508fa0d6c82(type) {
    return (0, $6B4dU.default)(type, $61d539f5c2a76fac$export$ea3122a3d819ac9d);
}
function $61d539f5c2a76fac$export$4c0a7702e4a2acc9(type) {
    if (!$61d539f5c2a76fac$export$146b6508fa0d6c82(type)) throw new Error("Expected ".concat((0, $yEDl8.default)(type), " to be a GraphQL Non-Null type."));
    return type;
}
function $61d539f5c2a76fac$export$1e617af703572bb5(type) {
    return $61d539f5c2a76fac$export$5ef3b9aefb31c08b(type) || $61d539f5c2a76fac$export$360fc30cf304623(type) || $61d539f5c2a76fac$export$594edc80cf154b94(type) || $61d539f5c2a76fac$export$2dbe78c78d9c62bb(type) && $61d539f5c2a76fac$export$1e617af703572bb5(type.ofType);
}
function $61d539f5c2a76fac$export$6e3e8b9b85427518(type) {
    if (!$61d539f5c2a76fac$export$1e617af703572bb5(type)) throw new Error("Expected ".concat((0, $yEDl8.default)(type), " to be a GraphQL input type."));
    return type;
}
function $61d539f5c2a76fac$export$27aadee607de5794(type) {
    return $61d539f5c2a76fac$export$5ef3b9aefb31c08b(type) || $61d539f5c2a76fac$export$f3091ca7b0907a5f(type) || $61d539f5c2a76fac$export$32fba5696fa641e(type) || $61d539f5c2a76fac$export$cca4caab5ef5a545(type) || $61d539f5c2a76fac$export$360fc30cf304623(type) || $61d539f5c2a76fac$export$2dbe78c78d9c62bb(type) && $61d539f5c2a76fac$export$27aadee607de5794(type.ofType);
}
function $61d539f5c2a76fac$export$3efb5e473c31d62b(type) {
    if (!$61d539f5c2a76fac$export$27aadee607de5794(type)) throw new Error("Expected ".concat((0, $yEDl8.default)(type), " to be a GraphQL output type."));
    return type;
}
function $61d539f5c2a76fac$export$b390adabc64bab3(type) {
    return $61d539f5c2a76fac$export$5ef3b9aefb31c08b(type) || $61d539f5c2a76fac$export$360fc30cf304623(type);
}
function $61d539f5c2a76fac$export$2bb5b8127c27d0cc(type) {
    if (!$61d539f5c2a76fac$export$b390adabc64bab3(type)) throw new Error("Expected ".concat((0, $yEDl8.default)(type), " to be a GraphQL leaf type."));
    return type;
}
function $61d539f5c2a76fac$export$3d8f0e61f2e75bb0(type) {
    return $61d539f5c2a76fac$export$f3091ca7b0907a5f(type) || $61d539f5c2a76fac$export$32fba5696fa641e(type) || $61d539f5c2a76fac$export$cca4caab5ef5a545(type);
}
function $61d539f5c2a76fac$export$5b55b276a74cf725(type) {
    if (!$61d539f5c2a76fac$export$3d8f0e61f2e75bb0(type)) throw new Error("Expected ".concat((0, $yEDl8.default)(type), " to be a GraphQL composite type."));
    return type;
}
function $61d539f5c2a76fac$export$6ea44a810dec4ac5(type) {
    return $61d539f5c2a76fac$export$32fba5696fa641e(type) || $61d539f5c2a76fac$export$cca4caab5ef5a545(type);
}
function $61d539f5c2a76fac$export$d7092fd91c1fbaf8(type) {
    if (!$61d539f5c2a76fac$export$6ea44a810dec4ac5(type)) throw new Error("Expected ".concat((0, $yEDl8.default)(type), " to be a GraphQL abstract type."));
    return type;
}
function $61d539f5c2a76fac$export$de552006a6243367(ofType) {
    // istanbul ignore else (to be removed in v16.0.0)
    if (this instanceof $61d539f5c2a76fac$export$de552006a6243367) this.ofType = $61d539f5c2a76fac$export$804de46662e4ac95(ofType);
    else return new $61d539f5c2a76fac$export$de552006a6243367(ofType);
} // Need to cast through any to alter the prototype.
$61d539f5c2a76fac$export$de552006a6243367.prototype.toString = function toString() {
    return '[' + String(this.ofType) + ']';
};
$61d539f5c2a76fac$export$de552006a6243367.prototype.toJSON = function toJSON() {
    return this.toString();
};
Object.defineProperty($61d539f5c2a76fac$export$de552006a6243367.prototype, (0, $6DBwa.SYMBOL_TO_STRING_TAG), {
    get: function get() {
        return 'GraphQLList';
    }
}); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $520Pd.default)($61d539f5c2a76fac$export$de552006a6243367);
function $61d539f5c2a76fac$export$ea3122a3d819ac9d(ofType) {
    // istanbul ignore else (to be removed in v16.0.0)
    if (this instanceof $61d539f5c2a76fac$export$ea3122a3d819ac9d) this.ofType = $61d539f5c2a76fac$export$9c6e9b78e1767de4(ofType);
    else return new $61d539f5c2a76fac$export$ea3122a3d819ac9d(ofType);
} // Need to cast through any to alter the prototype.
$61d539f5c2a76fac$export$ea3122a3d819ac9d.prototype.toString = function toString() {
    return String(this.ofType) + '!';
};
$61d539f5c2a76fac$export$ea3122a3d819ac9d.prototype.toJSON = function toJSON() {
    return this.toString();
};
Object.defineProperty($61d539f5c2a76fac$export$ea3122a3d819ac9d.prototype, (0, $6DBwa.SYMBOL_TO_STRING_TAG), {
    get: function get() {
        return 'GraphQLNonNull';
    }
}); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $520Pd.default)($61d539f5c2a76fac$export$ea3122a3d819ac9d);
function $61d539f5c2a76fac$export$2dbe78c78d9c62bb(type) {
    return $61d539f5c2a76fac$export$f1003c1e9d4b008c(type) || $61d539f5c2a76fac$export$146b6508fa0d6c82(type);
}
function $61d539f5c2a76fac$export$ee52e012d8d583c6(type) {
    if (!$61d539f5c2a76fac$export$2dbe78c78d9c62bb(type)) throw new Error("Expected ".concat((0, $yEDl8.default)(type), " to be a GraphQL wrapping type."));
    return type;
}
function $61d539f5c2a76fac$export$103e38848746832(type) {
    return $61d539f5c2a76fac$export$26b9f946b448f23e(type) && !$61d539f5c2a76fac$export$146b6508fa0d6c82(type);
}
function $61d539f5c2a76fac$export$9c6e9b78e1767de4(type) {
    if (!$61d539f5c2a76fac$export$103e38848746832(type)) throw new Error("Expected ".concat((0, $yEDl8.default)(type), " to be a GraphQL nullable type."));
    return type;
}
function $61d539f5c2a76fac$export$88b885687e78334b(type) {
    /* eslint-enable no-redeclare */ if (type) return $61d539f5c2a76fac$export$146b6508fa0d6c82(type) ? type.ofType : type;
}
function $61d539f5c2a76fac$export$f99194494d5b1a26(type) {
    return $61d539f5c2a76fac$export$5ef3b9aefb31c08b(type) || $61d539f5c2a76fac$export$f3091ca7b0907a5f(type) || $61d539f5c2a76fac$export$32fba5696fa641e(type) || $61d539f5c2a76fac$export$cca4caab5ef5a545(type) || $61d539f5c2a76fac$export$360fc30cf304623(type) || $61d539f5c2a76fac$export$594edc80cf154b94(type);
}
function $61d539f5c2a76fac$export$57234e7b640498aa(type) {
    if (!$61d539f5c2a76fac$export$f99194494d5b1a26(type)) throw new Error("Expected ".concat((0, $yEDl8.default)(type), " to be a GraphQL named type."));
    return type;
}
function $61d539f5c2a76fac$export$e6cd8ba67f39ede0(type) {
    /* eslint-enable no-redeclare */ if (type) {
        var unwrappedType = type;
        while($61d539f5c2a76fac$export$2dbe78c78d9c62bb(unwrappedType))unwrappedType = unwrappedType.ofType;
        return unwrappedType;
    }
}
/**
 * Used while defining GraphQL types to allow for circular references in
 * otherwise immutable type definitions.
 */ function $61d539f5c2a76fac$var$resolveThunk(thunk) {
    // $FlowFixMe[incompatible-use]
    return typeof thunk === 'function' ? thunk() : thunk;
}
function $61d539f5c2a76fac$var$undefineIfEmpty(arr) {
    return arr && arr.length > 0 ? arr : undefined;
}
var $61d539f5c2a76fac$export$64842b98ea53a3c9 = /*#__PURE__*/ function() {
    function GraphQLScalarType(config) {
        var _config$parseValue, _config$serialize, _config$parseLiteral;
        var parseValue = (_config$parseValue = config.parseValue) !== null && _config$parseValue !== void 0 ? _config$parseValue : (0, $frao6.default);
        this.name = config.name;
        this.description = config.description;
        this.specifiedByUrl = config.specifiedByUrl;
        this.serialize = (_config$serialize = config.serialize) !== null && _config$serialize !== void 0 ? _config$serialize : (0, $frao6.default);
        this.parseValue = parseValue;
        this.parseLiteral = (_config$parseLiteral = config.parseLiteral) !== null && _config$parseLiteral !== void 0 ? _config$parseLiteral : function(node, variables) {
            return parseValue((0, $ccOQ3.valueFromASTUntyped)(node, variables));
        };
        this.extensions = config.extensions && (0, $2mUbt.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $61d539f5c2a76fac$var$undefineIfEmpty(config.extensionASTNodes);
        typeof config.name === 'string' || (0, $a1qmV.default)(0, 'Must provide name.');
        config.specifiedByUrl == null || typeof config.specifiedByUrl === 'string' || (0, $a1qmV.default)(0, "".concat(this.name, " must provide \"specifiedByUrl\" as a string, ") + "but got: ".concat((0, $yEDl8.default)(config.specifiedByUrl), "."));
        config.serialize == null || typeof config.serialize === 'function' || (0, $a1qmV.default)(0, "".concat(this.name, " must provide \"serialize\" function. If this custom Scalar is also used as an input type, ensure \"parseValue\" and \"parseLiteral\" functions are also provided."));
        if (config.parseLiteral) typeof config.parseValue === 'function' && typeof config.parseLiteral === 'function' || (0, $a1qmV.default)(0, "".concat(this.name, " must provide both \"parseValue\" and \"parseLiteral\" functions."));
    }
    var _proto = GraphQLScalarType.prototype;
    _proto.toConfig = function toConfig() {
        var _this$extensionASTNod;
        return {
            name: this.name,
            description: this.description,
            specifiedByUrl: this.specifiedByUrl,
            serialize: this.serialize,
            parseValue: this.parseValue,
            parseLiteral: this.parseLiteral,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod = this.extensionASTNodes) !== null && _this$extensionASTNod !== void 0 ? _this$extensionASTNod : []
        };
    };
    _proto.toString = function toString() {
        return this.name;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $61d539f5c2a76fac$var$_createClass(GraphQLScalarType, [
        {
            key: (0, $6DBwa.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLScalarType';
            }
        }
    ]);
    return GraphQLScalarType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $520Pd.default)($61d539f5c2a76fac$export$64842b98ea53a3c9);
var $61d539f5c2a76fac$export$375d3757a19c2e6e = /*#__PURE__*/ function() {
    function GraphQLObjectType(config) {
        this.name = config.name;
        this.description = config.description;
        this.isTypeOf = config.isTypeOf;
        this.extensions = config.extensions && (0, $2mUbt.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $61d539f5c2a76fac$var$undefineIfEmpty(config.extensionASTNodes);
        this._fields = $61d539f5c2a76fac$var$defineFieldMap.bind(undefined, config);
        this._interfaces = $61d539f5c2a76fac$var$defineInterfaces.bind(undefined, config);
        typeof config.name === 'string' || (0, $a1qmV.default)(0, 'Must provide name.');
        config.isTypeOf == null || typeof config.isTypeOf === 'function' || (0, $a1qmV.default)(0, "".concat(this.name, " must provide \"isTypeOf\" as a function, ") + "but got: ".concat((0, $yEDl8.default)(config.isTypeOf), "."));
    }
    var _proto2 = GraphQLObjectType.prototype;
    _proto2.getFields = function getFields() {
        if (typeof this._fields === 'function') this._fields = this._fields();
        return this._fields;
    };
    _proto2.getInterfaces = function getInterfaces() {
        if (typeof this._interfaces === 'function') this._interfaces = this._interfaces();
        return this._interfaces;
    };
    _proto2.toConfig = function toConfig() {
        return {
            name: this.name,
            description: this.description,
            interfaces: this.getInterfaces(),
            fields: $61d539f5c2a76fac$var$fieldsToFieldsConfig(this.getFields()),
            isTypeOf: this.isTypeOf,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: this.extensionASTNodes || []
        };
    };
    _proto2.toString = function toString() {
        return this.name;
    };
    _proto2.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $61d539f5c2a76fac$var$_createClass(GraphQLObjectType, [
        {
            key: (0, $6DBwa.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLObjectType';
            }
        }
    ]);
    return GraphQLObjectType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $520Pd.default)($61d539f5c2a76fac$export$375d3757a19c2e6e);
function $61d539f5c2a76fac$var$defineInterfaces(config) {
    var _resolveThunk;
    var interfaces = (_resolveThunk = $61d539f5c2a76fac$var$resolveThunk(config.interfaces)) !== null && _resolveThunk !== void 0 ? _resolveThunk : [];
    Array.isArray(interfaces) || (0, $a1qmV.default)(0, "".concat(config.name, " interfaces must be an Array or a function which returns an Array."));
    return interfaces;
}
function $61d539f5c2a76fac$var$defineFieldMap(config) {
    var fieldMap = $61d539f5c2a76fac$var$resolveThunk(config.fields);
    $61d539f5c2a76fac$var$isPlainObj(fieldMap) || (0, $a1qmV.default)(0, "".concat(config.name, " fields must be an object with field names as keys or a function which returns such an object."));
    return (0, $eqSe6.default)(fieldMap, function(fieldConfig, fieldName) {
        var _fieldConfig$args;
        $61d539f5c2a76fac$var$isPlainObj(fieldConfig) || (0, $a1qmV.default)(0, "".concat(config.name, ".").concat(fieldName, " field config must be an object."));
        !('isDeprecated' in fieldConfig) || (0, $a1qmV.default)(0, "".concat(config.name, ".").concat(fieldName, " should provide \"deprecationReason\" instead of \"isDeprecated\"."));
        fieldConfig.resolve == null || typeof fieldConfig.resolve === 'function' || (0, $a1qmV.default)(0, "".concat(config.name, ".").concat(fieldName, " field resolver must be a function if ") + "provided, but got: ".concat((0, $yEDl8.default)(fieldConfig.resolve), "."));
        var argsConfig = (_fieldConfig$args = fieldConfig.args) !== null && _fieldConfig$args !== void 0 ? _fieldConfig$args : {};
        $61d539f5c2a76fac$var$isPlainObj(argsConfig) || (0, $a1qmV.default)(0, "".concat(config.name, ".").concat(fieldName, " args must be an object with argument names as keys."));
        var args = (0, $ge05d.default)(argsConfig).map(function(_ref) {
            var argName = _ref[0], argConfig = _ref[1];
            return {
                name: argName,
                description: argConfig.description,
                type: argConfig.type,
                defaultValue: argConfig.defaultValue,
                deprecationReason: argConfig.deprecationReason,
                extensions: argConfig.extensions && (0, $2mUbt.default)(argConfig.extensions),
                astNode: argConfig.astNode
            };
        });
        return {
            name: fieldName,
            description: fieldConfig.description,
            type: fieldConfig.type,
            args: args,
            resolve: fieldConfig.resolve,
            subscribe: fieldConfig.subscribe,
            isDeprecated: fieldConfig.deprecationReason != null,
            deprecationReason: fieldConfig.deprecationReason,
            extensions: fieldConfig.extensions && (0, $2mUbt.default)(fieldConfig.extensions),
            astNode: fieldConfig.astNode
        };
    });
}
function $61d539f5c2a76fac$var$isPlainObj(obj) {
    return (0, $cJPdE.default)(obj) && !Array.isArray(obj);
}
function $61d539f5c2a76fac$var$fieldsToFieldsConfig(fields) {
    return (0, $eqSe6.default)(fields, function(field) {
        return {
            description: field.description,
            type: field.type,
            args: $61d539f5c2a76fac$export$ae5ade30c645f6fd(field.args),
            resolve: field.resolve,
            subscribe: field.subscribe,
            deprecationReason: field.deprecationReason,
            extensions: field.extensions,
            astNode: field.astNode
        };
    });
}
function $61d539f5c2a76fac$export$ae5ade30c645f6fd(args) {
    return (0, $2gSpW.default)(args, function(arg) {
        return arg.name;
    }, function(arg) {
        return {
            description: arg.description,
            type: arg.type,
            defaultValue: arg.defaultValue,
            deprecationReason: arg.deprecationReason,
            extensions: arg.extensions,
            astNode: arg.astNode
        };
    });
}
function $61d539f5c2a76fac$export$caef08b21560291a(arg) {
    return $61d539f5c2a76fac$export$146b6508fa0d6c82(arg.type) && arg.defaultValue === undefined;
}
var $61d539f5c2a76fac$export$148e92587b8bf1f9 = /*#__PURE__*/ function() {
    function GraphQLInterfaceType(config) {
        this.name = config.name;
        this.description = config.description;
        this.resolveType = config.resolveType;
        this.extensions = config.extensions && (0, $2mUbt.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $61d539f5c2a76fac$var$undefineIfEmpty(config.extensionASTNodes);
        this._fields = $61d539f5c2a76fac$var$defineFieldMap.bind(undefined, config);
        this._interfaces = $61d539f5c2a76fac$var$defineInterfaces.bind(undefined, config);
        typeof config.name === 'string' || (0, $a1qmV.default)(0, 'Must provide name.');
        config.resolveType == null || typeof config.resolveType === 'function' || (0, $a1qmV.default)(0, "".concat(this.name, " must provide \"resolveType\" as a function, ") + "but got: ".concat((0, $yEDl8.default)(config.resolveType), "."));
    }
    var _proto3 = GraphQLInterfaceType.prototype;
    _proto3.getFields = function getFields() {
        if (typeof this._fields === 'function') this._fields = this._fields();
        return this._fields;
    };
    _proto3.getInterfaces = function getInterfaces() {
        if (typeof this._interfaces === 'function') this._interfaces = this._interfaces();
        return this._interfaces;
    };
    _proto3.toConfig = function toConfig() {
        var _this$extensionASTNod2;
        return {
            name: this.name,
            description: this.description,
            interfaces: this.getInterfaces(),
            fields: $61d539f5c2a76fac$var$fieldsToFieldsConfig(this.getFields()),
            resolveType: this.resolveType,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod2 = this.extensionASTNodes) !== null && _this$extensionASTNod2 !== void 0 ? _this$extensionASTNod2 : []
        };
    };
    _proto3.toString = function toString() {
        return this.name;
    };
    _proto3.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $61d539f5c2a76fac$var$_createClass(GraphQLInterfaceType, [
        {
            key: (0, $6DBwa.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLInterfaceType';
            }
        }
    ]);
    return GraphQLInterfaceType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $520Pd.default)($61d539f5c2a76fac$export$148e92587b8bf1f9);
var $61d539f5c2a76fac$export$33c479b4c3812d0b = /*#__PURE__*/ function() {
    function GraphQLUnionType(config) {
        this.name = config.name;
        this.description = config.description;
        this.resolveType = config.resolveType;
        this.extensions = config.extensions && (0, $2mUbt.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $61d539f5c2a76fac$var$undefineIfEmpty(config.extensionASTNodes);
        this._types = $61d539f5c2a76fac$var$defineTypes.bind(undefined, config);
        typeof config.name === 'string' || (0, $a1qmV.default)(0, 'Must provide name.');
        config.resolveType == null || typeof config.resolveType === 'function' || (0, $a1qmV.default)(0, "".concat(this.name, " must provide \"resolveType\" as a function, ") + "but got: ".concat((0, $yEDl8.default)(config.resolveType), "."));
    }
    var _proto4 = GraphQLUnionType.prototype;
    _proto4.getTypes = function getTypes() {
        if (typeof this._types === 'function') this._types = this._types();
        return this._types;
    };
    _proto4.toConfig = function toConfig() {
        var _this$extensionASTNod3;
        return {
            name: this.name,
            description: this.description,
            types: this.getTypes(),
            resolveType: this.resolveType,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod3 = this.extensionASTNodes) !== null && _this$extensionASTNod3 !== void 0 ? _this$extensionASTNod3 : []
        };
    };
    _proto4.toString = function toString() {
        return this.name;
    };
    _proto4.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $61d539f5c2a76fac$var$_createClass(GraphQLUnionType, [
        {
            key: (0, $6DBwa.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLUnionType';
            }
        }
    ]);
    return GraphQLUnionType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $520Pd.default)($61d539f5c2a76fac$export$33c479b4c3812d0b);
function $61d539f5c2a76fac$var$defineTypes(config) {
    var types = $61d539f5c2a76fac$var$resolveThunk(config.types);
    Array.isArray(types) || (0, $a1qmV.default)(0, "Must provide Array of types or a function which returns such an array for Union ".concat(config.name, "."));
    return types;
}
var $61d539f5c2a76fac$export$2577fb93f8748953 = /*#__PURE__*/ function() {
    function GraphQLEnumType(config) {
        this.name = config.name;
        this.description = config.description;
        this.extensions = config.extensions && (0, $2mUbt.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $61d539f5c2a76fac$var$undefineIfEmpty(config.extensionASTNodes);
        this._values = $61d539f5c2a76fac$var$defineEnumValues(this.name, config.values);
        this._valueLookup = new Map(this._values.map(function(enumValue) {
            return [
                enumValue.value,
                enumValue
            ];
        }));
        this._nameLookup = (0, $aRWmX.default)(this._values, function(value) {
            return value.name;
        });
        typeof config.name === 'string' || (0, $a1qmV.default)(0, 'Must provide name.');
    }
    var _proto5 = GraphQLEnumType.prototype;
    _proto5.getValues = function getValues() {
        return this._values;
    };
    _proto5.getValue = function getValue(name) {
        return this._nameLookup[name];
    };
    _proto5.serialize = function serialize(outputValue) {
        var enumValue = this._valueLookup.get(outputValue);
        if (enumValue === undefined) throw new (0, $g5yZB.GraphQLError)("Enum \"".concat(this.name, "\" cannot represent value: ").concat((0, $yEDl8.default)(outputValue)));
        return enumValue.name;
    };
    _proto5.parseValue = function parseValue(inputValue) /* T */ {
        if (typeof inputValue !== 'string') {
            var valueStr = (0, $yEDl8.default)(inputValue);
            throw new (0, $g5yZB.GraphQLError)("Enum \"".concat(this.name, "\" cannot represent non-string value: ").concat(valueStr, ".") + $61d539f5c2a76fac$var$didYouMeanEnumValue(this, valueStr));
        }
        var enumValue = this.getValue(inputValue);
        if (enumValue == null) throw new (0, $g5yZB.GraphQLError)("Value \"".concat(inputValue, "\" does not exist in \"").concat(this.name, "\" enum.") + $61d539f5c2a76fac$var$didYouMeanEnumValue(this, inputValue));
        return enumValue.value;
    };
    _proto5.parseLiteral = function parseLiteral(valueNode, _variables) /* T */ {
        // Note: variables will be resolved to a value before calling this function.
        if (valueNode.kind !== (0, $bzIlO.Kind).ENUM) {
            var valueStr = (0, $1c8Um.print)(valueNode);
            throw new (0, $g5yZB.GraphQLError)("Enum \"".concat(this.name, "\" cannot represent non-enum value: ").concat(valueStr, ".") + $61d539f5c2a76fac$var$didYouMeanEnumValue(this, valueStr), valueNode);
        }
        var enumValue = this.getValue(valueNode.value);
        if (enumValue == null) {
            var _valueStr = (0, $1c8Um.print)(valueNode);
            throw new (0, $g5yZB.GraphQLError)("Value \"".concat(_valueStr, "\" does not exist in \"").concat(this.name, "\" enum.") + $61d539f5c2a76fac$var$didYouMeanEnumValue(this, _valueStr), valueNode);
        }
        return enumValue.value;
    };
    _proto5.toConfig = function toConfig() {
        var _this$extensionASTNod4;
        var values = (0, $2gSpW.default)(this.getValues(), function(value) {
            return value.name;
        }, function(value) {
            return {
                description: value.description,
                value: value.value,
                deprecationReason: value.deprecationReason,
                extensions: value.extensions,
                astNode: value.astNode
            };
        });
        return {
            name: this.name,
            description: this.description,
            values: values,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod4 = this.extensionASTNodes) !== null && _this$extensionASTNod4 !== void 0 ? _this$extensionASTNod4 : []
        };
    };
    _proto5.toString = function toString() {
        return this.name;
    };
    _proto5.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $61d539f5c2a76fac$var$_createClass(GraphQLEnumType, [
        {
            key: (0, $6DBwa.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLEnumType';
            }
        }
    ]);
    return GraphQLEnumType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $520Pd.default)($61d539f5c2a76fac$export$2577fb93f8748953);
function $61d539f5c2a76fac$var$didYouMeanEnumValue(enumType, unknownValueStr) {
    var allNames = enumType.getValues().map(function(value) {
        return value.name;
    });
    var suggestedValues = (0, $gXVhx.default)(unknownValueStr, allNames);
    return (0, $h4f6N.default)('the enum value', suggestedValues);
}
function $61d539f5c2a76fac$var$defineEnumValues(typeName, valueMap) {
    $61d539f5c2a76fac$var$isPlainObj(valueMap) || (0, $a1qmV.default)(0, "".concat(typeName, " values must be an object with value names as keys."));
    return (0, $ge05d.default)(valueMap).map(function(_ref2) {
        var valueName = _ref2[0], valueConfig = _ref2[1];
        $61d539f5c2a76fac$var$isPlainObj(valueConfig) || (0, $a1qmV.default)(0, "".concat(typeName, ".").concat(valueName, " must refer to an object with a \"value\" key ") + "representing an internal value but got: ".concat((0, $yEDl8.default)(valueConfig), "."));
        !('isDeprecated' in valueConfig) || (0, $a1qmV.default)(0, "".concat(typeName, ".").concat(valueName, " should provide \"deprecationReason\" instead of \"isDeprecated\"."));
        return {
            name: valueName,
            description: valueConfig.description,
            value: valueConfig.value !== undefined ? valueConfig.value : valueName,
            isDeprecated: valueConfig.deprecationReason != null,
            deprecationReason: valueConfig.deprecationReason,
            extensions: valueConfig.extensions && (0, $2mUbt.default)(valueConfig.extensions),
            astNode: valueConfig.astNode
        };
    });
}
var $61d539f5c2a76fac$export$ea29baa44b9fd772 = /*#__PURE__*/ function() {
    function GraphQLInputObjectType(config) {
        this.name = config.name;
        this.description = config.description;
        this.extensions = config.extensions && (0, $2mUbt.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $61d539f5c2a76fac$var$undefineIfEmpty(config.extensionASTNodes);
        this._fields = $61d539f5c2a76fac$var$defineInputFieldMap.bind(undefined, config);
        typeof config.name === 'string' || (0, $a1qmV.default)(0, 'Must provide name.');
    }
    var _proto6 = GraphQLInputObjectType.prototype;
    _proto6.getFields = function getFields() {
        if (typeof this._fields === 'function') this._fields = this._fields();
        return this._fields;
    };
    _proto6.toConfig = function toConfig() {
        var _this$extensionASTNod5;
        var fields = (0, $eqSe6.default)(this.getFields(), function(field) {
            return {
                description: field.description,
                type: field.type,
                defaultValue: field.defaultValue,
                deprecationReason: field.deprecationReason,
                extensions: field.extensions,
                astNode: field.astNode
            };
        });
        return {
            name: this.name,
            description: this.description,
            fields: fields,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod5 = this.extensionASTNodes) !== null && _this$extensionASTNod5 !== void 0 ? _this$extensionASTNod5 : []
        };
    };
    _proto6.toString = function toString() {
        return this.name;
    };
    _proto6.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $61d539f5c2a76fac$var$_createClass(GraphQLInputObjectType, [
        {
            key: (0, $6DBwa.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLInputObjectType';
            }
        }
    ]);
    return GraphQLInputObjectType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $520Pd.default)($61d539f5c2a76fac$export$ea29baa44b9fd772);
function $61d539f5c2a76fac$var$defineInputFieldMap(config) {
    var fieldMap = $61d539f5c2a76fac$var$resolveThunk(config.fields);
    $61d539f5c2a76fac$var$isPlainObj(fieldMap) || (0, $a1qmV.default)(0, "".concat(config.name, " fields must be an object with field names as keys or a function which returns such an object."));
    return (0, $eqSe6.default)(fieldMap, function(fieldConfig, fieldName) {
        !('resolve' in fieldConfig) || (0, $a1qmV.default)(0, "".concat(config.name, ".").concat(fieldName, " field has a resolve property, but Input Types cannot define resolvers."));
        return {
            name: fieldName,
            description: fieldConfig.description,
            type: fieldConfig.type,
            defaultValue: fieldConfig.defaultValue,
            deprecationReason: fieldConfig.deprecationReason,
            extensions: fieldConfig.extensions && (0, $2mUbt.default)(fieldConfig.extensions),
            astNode: fieldConfig.astNode
        };
    });
}
function $61d539f5c2a76fac$export$2657dcc79c2b6229(field) {
    return $61d539f5c2a76fac$export$146b6508fa0d6c82(field.type) && field.defaultValue === undefined;
}

});
parcelRegister("ge05d", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcfe04aa44184a0f$export$2e2bcd8739ae039);
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var $bcfe04aa44184a0f$var$objectEntries = Object.entries || function(obj) {
    return Object.keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
};
var $bcfe04aa44184a0f$export$2e2bcd8739ae039 = $bcfe04aa44184a0f$var$objectEntries;

});

parcelRegister("aRWmX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e9c21869d55a3eb$export$2e2bcd8739ae039);
/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * for each value in the array.
 *
 * This provides a convenient lookup for the array items if the key function
 * produces unique results.
 *
 *     const phoneBook = [
 *       { name: 'Jon', num: '555-1234' },
 *       { name: 'Jenny', num: '867-5309' }
 *     ]
 *
 *     // { Jon: { name: 'Jon', num: '555-1234' },
 *     //   Jenny: { name: 'Jenny', num: '867-5309' } }
 *     const entriesByName = keyMap(
 *       phoneBook,
 *       entry => entry.name
 *     )
 *
 *     // { name: 'Jenny', num: '857-6309' }
 *     const jennyEntry = entriesByName['Jenny']
 *
 */ function $7e9c21869d55a3eb$export$2e2bcd8739ae039(list, keyFn) {
    return list.reduce(function(map, item) {
        map[keyFn(item)] = item;
        return map;
    }, Object.create(null));
}

});

parcelRegister("eqSe6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a81d8e9dff162917$export$2e2bcd8739ae039);

var $ge05d = parcelRequire("ge05d");
function $a81d8e9dff162917$export$2e2bcd8739ae039(map, fn) {
    var result = Object.create(null);
    for(var _i2 = 0, _objectEntries2 = (0, $ge05d.default)(map); _i2 < _objectEntries2.length; _i2++){
        var _ref2 = _objectEntries2[_i2];
        var _key = _ref2[0];
        var _value = _ref2[1];
        result[_key] = fn(_value, _key);
    }
    return result;
}

});

parcelRegister("2mUbt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b9937d6c2ec8989$export$2e2bcd8739ae039);

var $ge05d = parcelRequire("ge05d");
function $1b9937d6c2ec8989$export$2e2bcd8739ae039(obj) {
    /* eslint-enable no-redeclare */ if (Object.getPrototypeOf(obj) === null) return obj;
    var map = Object.create(null);
    for(var _i2 = 0, _objectEntries2 = (0, $ge05d.default)(obj); _i2 < _objectEntries2.length; _i2++){
        var _ref2 = _objectEntries2[_i2];
        var key = _ref2[0];
        var value = _ref2[1];
        map[key] = value;
    }
    return map;
}

});

parcelRegister("2gSpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a774990d750550b$export$2e2bcd8739ae039);
/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * and a function to produce the values from each item in the array.
 *
 *     const phoneBook = [
 *       { name: 'Jon', num: '555-1234' },
 *       { name: 'Jenny', num: '867-5309' }
 *     ]
 *
 *     // { Jon: '555-1234', Jenny: '867-5309' }
 *     const phonesByName = keyValMap(
 *       phoneBook,
 *       entry => entry.name,
 *       entry => entry.num
 *     )
 *
 */ function $1a774990d750550b$export$2e2bcd8739ae039(list, keyFn, valFn) {
    return list.reduce(function(map, item) {
        map[keyFn(item)] = valFn(item);
        return map;
    }, Object.create(null));
}

});

parcelRegister("h4f6N", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6ce87a84ef3a40e$export$2e2bcd8739ae039);
var $c6ce87a84ef3a40e$var$MAX_SUGGESTIONS = 5;
function $c6ce87a84ef3a40e$export$2e2bcd8739ae039(firstArg, secondArg) {
    var _ref = typeof firstArg === 'string' ? [
        firstArg,
        secondArg
    ] : [
        undefined,
        firstArg
    ], subMessage = _ref[0], suggestionsArg = _ref[1];
    var message = ' Did you mean ';
    if (subMessage) message += subMessage + ' ';
    var suggestions = suggestionsArg.map(function(x) {
        return "\"".concat(x, "\"");
    });
    switch(suggestions.length){
        case 0:
            return '';
        case 1:
            return message + suggestions[0] + '?';
        case 2:
            return message + suggestions[0] + ' or ' + suggestions[1] + '?';
    }
    var selected = suggestions.slice(0, $c6ce87a84ef3a40e$var$MAX_SUGGESTIONS);
    var lastItem = selected.pop();
    return message + selected.join(', ') + ', or ' + lastItem + '?';
}

});

parcelRegister("frao6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3d16f6eadb525f2$export$2e2bcd8739ae039);
/**
 * Returns the first argument it receives.
 */ function $b3d16f6eadb525f2$export$2e2bcd8739ae039(x) {
    return x;
}

});

parcelRegister("gXVhx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c59e970258122f7e$export$2e2bcd8739ae039);

var $Jh3Fc = parcelRequire("Jh3Fc");
function $c59e970258122f7e$export$2e2bcd8739ae039(input, options) {
    var optionsByDistance = Object.create(null);
    var lexicalDistance = new $c59e970258122f7e$var$LexicalDistance(input);
    var threshold = Math.floor(input.length * 0.4) + 1;
    for(var _i2 = 0; _i2 < options.length; _i2++){
        var option = options[_i2];
        var distance = lexicalDistance.measure(option, threshold);
        if (distance !== undefined) optionsByDistance[option] = distance;
    }
    return Object.keys(optionsByDistance).sort(function(a, b) {
        var distanceDiff = optionsByDistance[a] - optionsByDistance[b];
        return distanceDiff !== 0 ? distanceDiff : (0, $Jh3Fc.default)(a, b);
    });
}
/**
 * Computes the lexical distance between strings A and B.
 *
 * The "distance" between two strings is given by counting the minimum number
 * of edits needed to transform string A into string B. An edit can be an
 * insertion, deletion, or substitution of a single character, or a swap of two
 * adjacent characters.
 *
 * Includes a custom alteration from Damerau-Levenshtein to treat case changes
 * as a single edit which helps identify mis-cased values with an edit distance
 * of 1.
 *
 * This distance can be useful for detecting typos in input or sorting
 */ var $c59e970258122f7e$var$LexicalDistance = /*#__PURE__*/ function() {
    function LexicalDistance(input) {
        this._input = input;
        this._inputLowerCase = input.toLowerCase();
        this._inputArray = $c59e970258122f7e$var$stringToArray(this._inputLowerCase);
        this._rows = [
            new Array(input.length + 1).fill(0),
            new Array(input.length + 1).fill(0),
            new Array(input.length + 1).fill(0)
        ];
    }
    var _proto = LexicalDistance.prototype;
    _proto.measure = function measure(option, threshold) {
        if (this._input === option) return 0;
        var optionLowerCase = option.toLowerCase(); // Any case change counts as a single edit
        if (this._inputLowerCase === optionLowerCase) return 1;
        var a = $c59e970258122f7e$var$stringToArray(optionLowerCase);
        var b = this._inputArray;
        if (a.length < b.length) {
            var tmp = a;
            a = b;
            b = tmp;
        }
        var aLength = a.length;
        var bLength = b.length;
        if (aLength - bLength > threshold) return undefined;
        var rows = this._rows;
        for(var j = 0; j <= bLength; j++)rows[0][j] = j;
        for(var i = 1; i <= aLength; i++){
            var upRow = rows[(i - 1) % 3];
            var currentRow = rows[i % 3];
            var smallestCell = currentRow[0] = i;
            for(var _j = 1; _j <= bLength; _j++){
                var cost = a[i - 1] === b[_j - 1] ? 0 : 1;
                var currentCell = Math.min(upRow[_j] + 1, currentRow[_j - 1] + 1, upRow[_j - 1] + cost // substitute
                );
                if (i > 1 && _j > 1 && a[i - 1] === b[_j - 2] && a[i - 2] === b[_j - 1]) {
                    // transposition
                    var doubleDiagonalCell = rows[(i - 2) % 3][_j - 2];
                    currentCell = Math.min(currentCell, doubleDiagonalCell + 1);
                }
                if (currentCell < smallestCell) smallestCell = currentCell;
                currentRow[_j] = currentCell;
            } // Early exit, since distance can't go smaller than smallest element of the previous row.
            if (smallestCell > threshold) return undefined;
        }
        var distance = rows[aLength % 3][bLength];
        return distance <= threshold ? distance : undefined;
    };
    return LexicalDistance;
}();
function $c59e970258122f7e$var$stringToArray(str) {
    var strLength = str.length;
    var array = new Array(strLength);
    for(var i = 0; i < strLength; ++i)array[i] = str.charCodeAt(i);
    return array;
}

});
parcelRegister("Jh3Fc", function(module, exports) {

$parcel$export(module.exports, "default", () => $08816f772b4485d9$export$2e2bcd8739ae039);
/**
 * Returns a number indicating whether a reference string comes before, or after,
 * or is the same as the given string in natural sort order.
 *
 * See: https://en.wikipedia.org/wiki/Natural_sort_order
 *
 */ function $08816f772b4485d9$export$2e2bcd8739ae039(aStr, bStr) {
    var aIdx = 0;
    var bIdx = 0;
    while(aIdx < aStr.length && bIdx < bStr.length){
        var aChar = aStr.charCodeAt(aIdx);
        var bChar = bStr.charCodeAt(bIdx);
        if ($08816f772b4485d9$var$isDigit(aChar) && $08816f772b4485d9$var$isDigit(bChar)) {
            var aNum = 0;
            do {
                ++aIdx;
                aNum = aNum * 10 + aChar - $08816f772b4485d9$var$DIGIT_0;
                aChar = aStr.charCodeAt(aIdx);
            }while ($08816f772b4485d9$var$isDigit(aChar) && aNum > 0);
            var bNum = 0;
            do {
                ++bIdx;
                bNum = bNum * 10 + bChar - $08816f772b4485d9$var$DIGIT_0;
                bChar = bStr.charCodeAt(bIdx);
            }while ($08816f772b4485d9$var$isDigit(bChar) && bNum > 0);
            if (aNum < bNum) return -1;
            if (aNum > bNum) return 1;
        } else {
            if (aChar < bChar) return -1;
            if (aChar > bChar) return 1;
            ++aIdx;
            ++bIdx;
        }
    }
    return aStr.length - bStr.length;
}
var $08816f772b4485d9$var$DIGIT_0 = 48;
var $08816f772b4485d9$var$DIGIT_9 = 57;
function $08816f772b4485d9$var$isDigit(code) {
    return !isNaN(code) && $08816f772b4485d9$var$DIGIT_0 <= code && code <= $08816f772b4485d9$var$DIGIT_9;
}

});


parcelRegister("ccOQ3", function(module, exports) {

$parcel$export(module.exports, "valueFromASTUntyped", () => $8e2e0a854baa24a1$export$448e0963aec9442f);

var $yEDl8 = parcelRequire("yEDl8");

var $fM9AB = parcelRequire("fM9AB");

var $2gSpW = parcelRequire("2gSpW");

var $bzIlO = parcelRequire("bzIlO");
function $8e2e0a854baa24a1$export$448e0963aec9442f(valueNode, variables) {
    switch(valueNode.kind){
        case (0, $bzIlO.Kind).NULL:
            return null;
        case (0, $bzIlO.Kind).INT:
            return parseInt(valueNode.value, 10);
        case (0, $bzIlO.Kind).FLOAT:
            return parseFloat(valueNode.value);
        case (0, $bzIlO.Kind).STRING:
        case (0, $bzIlO.Kind).ENUM:
        case (0, $bzIlO.Kind).BOOLEAN:
            return valueNode.value;
        case (0, $bzIlO.Kind).LIST:
            return valueNode.values.map(function(node) {
                return $8e2e0a854baa24a1$export$448e0963aec9442f(node, variables);
            });
        case (0, $bzIlO.Kind).OBJECT:
            return (0, $2gSpW.default)(valueNode.fields, function(field) {
                return field.name.value;
            }, function(field) {
                return $8e2e0a854baa24a1$export$448e0963aec9442f(field.value, variables);
            });
        case (0, $bzIlO.Kind).VARIABLE:
            return variables === null || variables === void 0 ? void 0 : variables[valueNode.name.value];
    } // istanbul ignore next (Not reachable. All possible value nodes have been considered)
    (0, $fM9AB.default)(0, 'Unexpected value node: ' + (0, $yEDl8.default)(valueNode));
}

});



parcelRegister("lUVCX", function(module, exports) {

$parcel$export(module.exports, "GraphQLSchema", () => $ff4b878cb0d3aa2a$export$730e8b0fd6e4f02b);
$parcel$export(module.exports, "assertSchema", () => $ff4b878cb0d3aa2a$export$6554dabc0f90e0c3);

var $85NSv = parcelRequire("85NSv");

var $awIoQ = parcelRequire("awIoQ");

var $isVmt = parcelRequire("isVmt");

var $6DBwa = parcelRequire("6DBwa");

var $yEDl8 = parcelRequire("yEDl8");

var $2mUbt = parcelRequire("2mUbt");

var $a1qmV = parcelRequire("a1qmV");

var $6B4dU = parcelRequire("6B4dU");

var $cJPdE = parcelRequire("cJPdE");

var $4Hpke = parcelRequire("4Hpke");

var $35Smo = parcelRequire("35Smo");

var $8oLgk = parcelRequire("8oLgk");
function $ff4b878cb0d3aa2a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ff4b878cb0d3aa2a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ff4b878cb0d3aa2a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ff4b878cb0d3aa2a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $ff4b878cb0d3aa2a$export$213e2a3e7c4f326e(schema) {
    return (0, $6B4dU.default)(schema, $ff4b878cb0d3aa2a$export$730e8b0fd6e4f02b);
}
function $ff4b878cb0d3aa2a$export$6554dabc0f90e0c3(schema) {
    if (!$ff4b878cb0d3aa2a$export$213e2a3e7c4f326e(schema)) throw new Error("Expected ".concat((0, $yEDl8.default)(schema), " to be a GraphQL schema."));
    return schema;
}
var $ff4b878cb0d3aa2a$export$730e8b0fd6e4f02b = /*#__PURE__*/ function() {
    // Used as a cache for validateSchema().
    function GraphQLSchema(config) {
        var _config$directives;
        // If this schema was built from a source known to be valid, then it may be
        // marked with assumeValid to avoid an additional type system validation.
        this.__validationErrors = config.assumeValid === true ? [] : undefined; // Check for common mistakes during construction to produce early errors.
        (0, $cJPdE.default)(config) || (0, $a1qmV.default)(0, 'Must provide configuration object.');
        !config.types || Array.isArray(config.types) || (0, $a1qmV.default)(0, "\"types\" must be Array if provided but got: ".concat((0, $yEDl8.default)(config.types), "."));
        !config.directives || Array.isArray(config.directives) || (0, $a1qmV.default)(0, '"directives" must be Array if provided but got: ' + "".concat((0, $yEDl8.default)(config.directives), "."));
        this.description = config.description;
        this.extensions = config.extensions && (0, $2mUbt.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = config.extensionASTNodes;
        this._queryType = config.query;
        this._mutationType = config.mutation;
        this._subscriptionType = config.subscription; // Provide specified directives (e.g. @include and @skip) by default.
        this._directives = (_config$directives = config.directives) !== null && _config$directives !== void 0 ? _config$directives : (0, $35Smo.specifiedDirectives); // To preserve order of user-provided types, we add first to add them to
        // the set of "collected" types, so `collectReferencedTypes` ignore them.
        var allReferencedTypes = new Set(config.types);
        if (config.types != null) for(var _i2 = 0, _config$types2 = config.types; _i2 < _config$types2.length; _i2++){
            var type = _config$types2[_i2];
            // When we ready to process this type, we remove it from "collected" types
            // and then add it together with all dependent types in the correct position.
            allReferencedTypes.delete(type);
            $ff4b878cb0d3aa2a$var$collectReferencedTypes(type, allReferencedTypes);
        }
        if (this._queryType != null) $ff4b878cb0d3aa2a$var$collectReferencedTypes(this._queryType, allReferencedTypes);
        if (this._mutationType != null) $ff4b878cb0d3aa2a$var$collectReferencedTypes(this._mutationType, allReferencedTypes);
        if (this._subscriptionType != null) $ff4b878cb0d3aa2a$var$collectReferencedTypes(this._subscriptionType, allReferencedTypes);
        for(var _i4 = 0, _this$_directives2 = this._directives; _i4 < _this$_directives2.length; _i4++){
            var directive = _this$_directives2[_i4];
            // Directives are not validated until validateSchema() is called.
            if ((0, $35Smo.isDirective)(directive)) for(var _i6 = 0, _directive$args2 = directive.args; _i6 < _directive$args2.length; _i6++){
                var arg = _directive$args2[_i6];
                $ff4b878cb0d3aa2a$var$collectReferencedTypes(arg.type, allReferencedTypes);
            }
        }
        $ff4b878cb0d3aa2a$var$collectReferencedTypes((0, $4Hpke.__Schema), allReferencedTypes); // Storing the resulting map for reference by the schema.
        this._typeMap = Object.create(null);
        this._subTypeMap = Object.create(null); // Keep track of all implementations by interface name.
        this._implementationsMap = Object.create(null);
        for(var _i8 = 0, _arrayFrom2 = (0, $awIoQ.default)(allReferencedTypes); _i8 < _arrayFrom2.length; _i8++){
            var namedType = _arrayFrom2[_i8];
            if (namedType == null) continue;
            var typeName = namedType.name;
            typeName || (0, $a1qmV.default)(0, 'One of the provided types for building the Schema is missing a name.');
            if (this._typeMap[typeName] !== undefined) throw new Error("Schema must contain uniquely named types but contains multiple types named \"".concat(typeName, "\"."));
            this._typeMap[typeName] = namedType;
            if ((0, $8oLgk.isInterfaceType)(namedType)) // Store implementations by interface.
            for(var _i10 = 0, _namedType$getInterfa2 = namedType.getInterfaces(); _i10 < _namedType$getInterfa2.length; _i10++){
                var iface = _namedType$getInterfa2[_i10];
                if ((0, $8oLgk.isInterfaceType)(iface)) {
                    var implementations = this._implementationsMap[iface.name];
                    if (implementations === undefined) implementations = this._implementationsMap[iface.name] = {
                        objects: [],
                        interfaces: []
                    };
                    implementations.interfaces.push(namedType);
                }
            }
            else if ((0, $8oLgk.isObjectType)(namedType)) // Store implementations by objects.
            for(var _i12 = 0, _namedType$getInterfa4 = namedType.getInterfaces(); _i12 < _namedType$getInterfa4.length; _i12++){
                var _iface = _namedType$getInterfa4[_i12];
                if ((0, $8oLgk.isInterfaceType)(_iface)) {
                    var _implementations = this._implementationsMap[_iface.name];
                    if (_implementations === undefined) _implementations = this._implementationsMap[_iface.name] = {
                        objects: [],
                        interfaces: []
                    };
                    _implementations.objects.push(namedType);
                }
            }
        }
    }
    var _proto = GraphQLSchema.prototype;
    _proto.getQueryType = function getQueryType() {
        return this._queryType;
    };
    _proto.getMutationType = function getMutationType() {
        return this._mutationType;
    };
    _proto.getSubscriptionType = function getSubscriptionType() {
        return this._subscriptionType;
    };
    _proto.getTypeMap = function getTypeMap() {
        return this._typeMap;
    };
    _proto.getType = function getType(name) {
        return this.getTypeMap()[name];
    };
    _proto.getPossibleTypes = function getPossibleTypes(abstractType) {
        return (0, $8oLgk.isUnionType)(abstractType) ? abstractType.getTypes() : this.getImplementations(abstractType).objects;
    };
    _proto.getImplementations = function getImplementations(interfaceType) {
        var implementations = this._implementationsMap[interfaceType.name];
        return implementations !== null && implementations !== void 0 ? implementations : {
            objects: [],
            interfaces: []
        };
    } // @deprecated: use isSubType instead - will be removed in v16.
    ;
    _proto.isPossibleType = function isPossibleType(abstractType, possibleType) {
        return this.isSubType(abstractType, possibleType);
    };
    _proto.isSubType = function isSubType(abstractType, maybeSubType) {
        var map = this._subTypeMap[abstractType.name];
        if (map === undefined) {
            map = Object.create(null);
            if ((0, $8oLgk.isUnionType)(abstractType)) for(var _i14 = 0, _abstractType$getType2 = abstractType.getTypes(); _i14 < _abstractType$getType2.length; _i14++){
                var type = _abstractType$getType2[_i14];
                map[type.name] = true;
            }
            else {
                var implementations = this.getImplementations(abstractType);
                for(var _i16 = 0, _implementations$obje2 = implementations.objects; _i16 < _implementations$obje2.length; _i16++){
                    var _type = _implementations$obje2[_i16];
                    map[_type.name] = true;
                }
                for(var _i18 = 0, _implementations$inte2 = implementations.interfaces; _i18 < _implementations$inte2.length; _i18++){
                    var _type2 = _implementations$inte2[_i18];
                    map[_type2.name] = true;
                }
            }
            this._subTypeMap[abstractType.name] = map;
        }
        return map[maybeSubType.name] !== undefined;
    };
    _proto.getDirectives = function getDirectives() {
        return this._directives;
    };
    _proto.getDirective = function getDirective(name) {
        return (0, $85NSv.default)(this.getDirectives(), function(directive) {
            return directive.name === name;
        });
    };
    _proto.toConfig = function toConfig() {
        var _this$extensionASTNod;
        return {
            description: this.description,
            query: this.getQueryType(),
            mutation: this.getMutationType(),
            subscription: this.getSubscriptionType(),
            types: (0, $isVmt.default)(this.getTypeMap()),
            directives: this.getDirectives().slice(),
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod = this.extensionASTNodes) !== null && _this$extensionASTNod !== void 0 ? _this$extensionASTNod : [],
            assumeValid: this.__validationErrors !== undefined
        };
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $ff4b878cb0d3aa2a$var$_createClass(GraphQLSchema, [
        {
            key: (0, $6DBwa.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLSchema';
            }
        }
    ]);
    return GraphQLSchema;
}();
function $ff4b878cb0d3aa2a$var$collectReferencedTypes(type, typeSet) {
    var namedType = (0, $8oLgk.getNamedType)(type);
    if (!typeSet.has(namedType)) {
        typeSet.add(namedType);
        if ((0, $8oLgk.isUnionType)(namedType)) for(var _i20 = 0, _namedType$getTypes2 = namedType.getTypes(); _i20 < _namedType$getTypes2.length; _i20++){
            var memberType = _namedType$getTypes2[_i20];
            $ff4b878cb0d3aa2a$var$collectReferencedTypes(memberType, typeSet);
        }
        else if ((0, $8oLgk.isObjectType)(namedType) || (0, $8oLgk.isInterfaceType)(namedType)) {
            for(var _i22 = 0, _namedType$getInterfa6 = namedType.getInterfaces(); _i22 < _namedType$getInterfa6.length; _i22++){
                var interfaceType = _namedType$getInterfa6[_i22];
                $ff4b878cb0d3aa2a$var$collectReferencedTypes(interfaceType, typeSet);
            }
            for(var _i24 = 0, _objectValues2 = (0, $isVmt.default)(namedType.getFields()); _i24 < _objectValues2.length; _i24++){
                var field = _objectValues2[_i24];
                $ff4b878cb0d3aa2a$var$collectReferencedTypes(field.type, typeSet);
                for(var _i26 = 0, _field$args2 = field.args; _i26 < _field$args2.length; _i26++){
                    var arg = _field$args2[_i26];
                    $ff4b878cb0d3aa2a$var$collectReferencedTypes(arg.type, typeSet);
                }
            }
        } else if ((0, $8oLgk.isInputObjectType)(namedType)) for(var _i28 = 0, _objectValues4 = (0, $isVmt.default)(namedType.getFields()); _i28 < _objectValues4.length; _i28++){
            var _field = _objectValues4[_i28];
            $ff4b878cb0d3aa2a$var$collectReferencedTypes(_field.type, typeSet);
        }
    }
    return typeSet;
}

});
parcelRegister("awIoQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $01fa4fd43d92a80a$export$2e2bcd8739ae039);

var $6DBwa = parcelRequire("6DBwa");
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound]
var $01fa4fd43d92a80a$var$arrayFrom = Array.from || function(obj, mapFn, thisArg) {
    if (obj == null) throw new TypeError('Array.from requires an array-like object - not null or undefined');
     // Is Iterable?
    var iteratorMethod = obj[0, $6DBwa.SYMBOL_ITERATOR];
    if (typeof iteratorMethod === 'function') {
        var iterator = iteratorMethod.call(obj);
        var result = [];
        var step;
        for(var i = 0; !(step = iterator.next()).done; ++i){
            result.push(mapFn.call(thisArg, step.value, i)); // Infinite Iterators could cause forEach to run forever.
            // After a very large number of iterations, produce an error.
            // istanbul ignore if (Too big to actually test)
            if (i > 9999999) throw new TypeError('Near-infinite iteration.');
        }
        return result;
    } // Is Array like?
    var length = obj.length;
    if (typeof length === 'number' && length >= 0 && length % 1 === 0) {
        var _result = [];
        for(var _i = 0; _i < length; ++_i)if (Object.prototype.hasOwnProperty.call(obj, _i)) _result.push(mapFn.call(thisArg, obj[_i], _i));
        return _result;
    }
    return [];
};
var $01fa4fd43d92a80a$export$2e2bcd8739ae039 = $01fa4fd43d92a80a$var$arrayFrom;

});

parcelRegister("4Hpke", function(module, exports) {

$parcel$export(module.exports, "__Schema", () => $36bed2a2a1d2d06b$export$1f18df711f6fa0ac);
$parcel$export(module.exports, "TypeKind", () => $36bed2a2a1d2d06b$export$c29cf3c48471da7c);
$parcel$export(module.exports, "SchemaMetaFieldDef", () => $36bed2a2a1d2d06b$export$36ed059ad2080404);
$parcel$export(module.exports, "TypeMetaFieldDef", () => $36bed2a2a1d2d06b$export$87a968d084148b61);
$parcel$export(module.exports, "TypeNameMetaFieldDef", () => $36bed2a2a1d2d06b$export$b9c17490e825648e);
$parcel$export(module.exports, "introspectionTypes", () => $36bed2a2a1d2d06b$export$560bc6e8f6d098f4);
$parcel$export(module.exports, "isIntrospectionType", () => $36bed2a2a1d2d06b$export$e1862b156b15ce4f);

var $isVmt = parcelRequire("isVmt");

var $yEDl8 = parcelRequire("yEDl8");

var $fM9AB = parcelRequire("fM9AB");

var $1c8Um = parcelRequire("1c8Um");

var $jADQJ = parcelRequire("jADQJ");

var $d1i3Z = parcelRequire("d1i3Z");

var $djKly = parcelRequire("djKly");

var $8oLgk = parcelRequire("8oLgk");
var $36bed2a2a1d2d06b$export$1f18df711f6fa0ac = new (0, $8oLgk.GraphQLObjectType)({
    name: '__Schema',
    description: 'A GraphQL Schema defines the capabilities of a GraphQL server. It exposes all available types and directives on the server, as well as the entry points for query, mutation, and subscription operations.',
    fields: function fields() {
        return {
            description: {
                type: (0, $djKly.GraphQLString),
                resolve: function resolve(schema) {
                    return schema.description;
                }
            },
            types: {
                description: 'A list of all types supported by this server.',
                type: new (0, $8oLgk.GraphQLNonNull)(new (0, $8oLgk.GraphQLList)(new (0, $8oLgk.GraphQLNonNull)($36bed2a2a1d2d06b$export$b46ca740abcddda7))),
                resolve: function resolve(schema) {
                    return (0, $isVmt.default)(schema.getTypeMap());
                }
            },
            queryType: {
                description: 'The type that query operations will be rooted at.',
                type: new (0, $8oLgk.GraphQLNonNull)($36bed2a2a1d2d06b$export$b46ca740abcddda7),
                resolve: function resolve(schema) {
                    return schema.getQueryType();
                }
            },
            mutationType: {
                description: 'If this server supports mutation, the type that mutation operations will be rooted at.',
                type: $36bed2a2a1d2d06b$export$b46ca740abcddda7,
                resolve: function resolve(schema) {
                    return schema.getMutationType();
                }
            },
            subscriptionType: {
                description: 'If this server support subscription, the type that subscription operations will be rooted at.',
                type: $36bed2a2a1d2d06b$export$b46ca740abcddda7,
                resolve: function resolve(schema) {
                    return schema.getSubscriptionType();
                }
            },
            directives: {
                description: 'A list of all directives supported by this server.',
                type: new (0, $8oLgk.GraphQLNonNull)(new (0, $8oLgk.GraphQLList)(new (0, $8oLgk.GraphQLNonNull)($36bed2a2a1d2d06b$export$2492e8c5b8ba489f))),
                resolve: function resolve(schema) {
                    return schema.getDirectives();
                }
            }
        };
    }
});
var $36bed2a2a1d2d06b$export$2492e8c5b8ba489f = new (0, $8oLgk.GraphQLObjectType)({
    name: '__Directive',
    description: "A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.\n\nIn some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.",
    fields: function fields() {
        return {
            name: {
                type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString)),
                resolve: function resolve(directive) {
                    return directive.name;
                }
            },
            description: {
                type: (0, $djKly.GraphQLString),
                resolve: function resolve(directive) {
                    return directive.description;
                }
            },
            isRepeatable: {
                type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLBoolean)),
                resolve: function resolve(directive) {
                    return directive.isRepeatable;
                }
            },
            locations: {
                type: new (0, $8oLgk.GraphQLNonNull)(new (0, $8oLgk.GraphQLList)(new (0, $8oLgk.GraphQLNonNull)($36bed2a2a1d2d06b$export$70e870c5930737d1))),
                resolve: function resolve(directive) {
                    return directive.locations;
                }
            },
            args: {
                type: new (0, $8oLgk.GraphQLNonNull)(new (0, $8oLgk.GraphQLList)(new (0, $8oLgk.GraphQLNonNull)($36bed2a2a1d2d06b$export$bc79df5a9719c05b))),
                args: {
                    includeDeprecated: {
                        type: (0, $djKly.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(field, _ref) {
                    var includeDeprecated = _ref.includeDeprecated;
                    return includeDeprecated ? field.args : field.args.filter(function(arg) {
                        return arg.deprecationReason == null;
                    });
                }
            }
        };
    }
});
var $36bed2a2a1d2d06b$export$70e870c5930737d1 = new (0, $8oLgk.GraphQLEnumType)({
    name: '__DirectiveLocation',
    description: 'A Directive can be adjacent to many parts of the GraphQL language, a __DirectiveLocation describes one such possible adjacencies.',
    values: {
        QUERY: {
            value: (0, $jADQJ.DirectiveLocation).QUERY,
            description: 'Location adjacent to a query operation.'
        },
        MUTATION: {
            value: (0, $jADQJ.DirectiveLocation).MUTATION,
            description: 'Location adjacent to a mutation operation.'
        },
        SUBSCRIPTION: {
            value: (0, $jADQJ.DirectiveLocation).SUBSCRIPTION,
            description: 'Location adjacent to a subscription operation.'
        },
        FIELD: {
            value: (0, $jADQJ.DirectiveLocation).FIELD,
            description: 'Location adjacent to a field.'
        },
        FRAGMENT_DEFINITION: {
            value: (0, $jADQJ.DirectiveLocation).FRAGMENT_DEFINITION,
            description: 'Location adjacent to a fragment definition.'
        },
        FRAGMENT_SPREAD: {
            value: (0, $jADQJ.DirectiveLocation).FRAGMENT_SPREAD,
            description: 'Location adjacent to a fragment spread.'
        },
        INLINE_FRAGMENT: {
            value: (0, $jADQJ.DirectiveLocation).INLINE_FRAGMENT,
            description: 'Location adjacent to an inline fragment.'
        },
        VARIABLE_DEFINITION: {
            value: (0, $jADQJ.DirectiveLocation).VARIABLE_DEFINITION,
            description: 'Location adjacent to a variable definition.'
        },
        SCHEMA: {
            value: (0, $jADQJ.DirectiveLocation).SCHEMA,
            description: 'Location adjacent to a schema definition.'
        },
        SCALAR: {
            value: (0, $jADQJ.DirectiveLocation).SCALAR,
            description: 'Location adjacent to a scalar definition.'
        },
        OBJECT: {
            value: (0, $jADQJ.DirectiveLocation).OBJECT,
            description: 'Location adjacent to an object type definition.'
        },
        FIELD_DEFINITION: {
            value: (0, $jADQJ.DirectiveLocation).FIELD_DEFINITION,
            description: 'Location adjacent to a field definition.'
        },
        ARGUMENT_DEFINITION: {
            value: (0, $jADQJ.DirectiveLocation).ARGUMENT_DEFINITION,
            description: 'Location adjacent to an argument definition.'
        },
        INTERFACE: {
            value: (0, $jADQJ.DirectiveLocation).INTERFACE,
            description: 'Location adjacent to an interface definition.'
        },
        UNION: {
            value: (0, $jADQJ.DirectiveLocation).UNION,
            description: 'Location adjacent to a union definition.'
        },
        ENUM: {
            value: (0, $jADQJ.DirectiveLocation).ENUM,
            description: 'Location adjacent to an enum definition.'
        },
        ENUM_VALUE: {
            value: (0, $jADQJ.DirectiveLocation).ENUM_VALUE,
            description: 'Location adjacent to an enum value definition.'
        },
        INPUT_OBJECT: {
            value: (0, $jADQJ.DirectiveLocation).INPUT_OBJECT,
            description: 'Location adjacent to an input object type definition.'
        },
        INPUT_FIELD_DEFINITION: {
            value: (0, $jADQJ.DirectiveLocation).INPUT_FIELD_DEFINITION,
            description: 'Location adjacent to an input object field definition.'
        }
    }
});
var $36bed2a2a1d2d06b$export$b46ca740abcddda7 = new (0, $8oLgk.GraphQLObjectType)({
    name: '__Type',
    description: 'The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.\n\nDepending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.',
    fields: function fields() {
        return {
            kind: {
                type: new (0, $8oLgk.GraphQLNonNull)($36bed2a2a1d2d06b$export$163610506c99e78f),
                resolve: function resolve(type) {
                    if ((0, $8oLgk.isScalarType)(type)) return $36bed2a2a1d2d06b$export$c29cf3c48471da7c.SCALAR;
                    if ((0, $8oLgk.isObjectType)(type)) return $36bed2a2a1d2d06b$export$c29cf3c48471da7c.OBJECT;
                    if ((0, $8oLgk.isInterfaceType)(type)) return $36bed2a2a1d2d06b$export$c29cf3c48471da7c.INTERFACE;
                    if ((0, $8oLgk.isUnionType)(type)) return $36bed2a2a1d2d06b$export$c29cf3c48471da7c.UNION;
                    if ((0, $8oLgk.isEnumType)(type)) return $36bed2a2a1d2d06b$export$c29cf3c48471da7c.ENUM;
                    if ((0, $8oLgk.isInputObjectType)(type)) return $36bed2a2a1d2d06b$export$c29cf3c48471da7c.INPUT_OBJECT;
                    if ((0, $8oLgk.isListType)(type)) return $36bed2a2a1d2d06b$export$c29cf3c48471da7c.LIST;
                     // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
                    if ((0, $8oLgk.isNonNullType)(type)) return $36bed2a2a1d2d06b$export$c29cf3c48471da7c.NON_NULL;
                     // istanbul ignore next (Not reachable. All possible types have been considered)
                    (0, $fM9AB.default)(0, "Unexpected type: \"".concat((0, $yEDl8.default)(type), "\"."));
                }
            },
            name: {
                type: (0, $djKly.GraphQLString),
                resolve: function resolve(type) {
                    return type.name !== undefined ? type.name : undefined;
                }
            },
            description: {
                type: (0, $djKly.GraphQLString),
                resolve: function resolve(type) {
                    return type.description !== undefined ? type.description : undefined;
                }
            },
            specifiedByUrl: {
                type: (0, $djKly.GraphQLString),
                resolve: function resolve(obj) {
                    return obj.specifiedByUrl !== undefined ? obj.specifiedByUrl : undefined;
                }
            },
            fields: {
                type: new (0, $8oLgk.GraphQLList)(new (0, $8oLgk.GraphQLNonNull)($36bed2a2a1d2d06b$export$c93780024e419b02)),
                args: {
                    includeDeprecated: {
                        type: (0, $djKly.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(type, _ref2) {
                    var includeDeprecated = _ref2.includeDeprecated;
                    if ((0, $8oLgk.isObjectType)(type) || (0, $8oLgk.isInterfaceType)(type)) {
                        var fields = (0, $isVmt.default)(type.getFields());
                        return includeDeprecated ? fields : fields.filter(function(field) {
                            return field.deprecationReason == null;
                        });
                    }
                }
            },
            interfaces: {
                type: new (0, $8oLgk.GraphQLList)(new (0, $8oLgk.GraphQLNonNull)($36bed2a2a1d2d06b$export$b46ca740abcddda7)),
                resolve: function resolve(type) {
                    if ((0, $8oLgk.isObjectType)(type) || (0, $8oLgk.isInterfaceType)(type)) return type.getInterfaces();
                }
            },
            possibleTypes: {
                type: new (0, $8oLgk.GraphQLList)(new (0, $8oLgk.GraphQLNonNull)($36bed2a2a1d2d06b$export$b46ca740abcddda7)),
                resolve: function resolve(type, _args, _context, _ref3) {
                    var schema = _ref3.schema;
                    if ((0, $8oLgk.isAbstractType)(type)) return schema.getPossibleTypes(type);
                }
            },
            enumValues: {
                type: new (0, $8oLgk.GraphQLList)(new (0, $8oLgk.GraphQLNonNull)($36bed2a2a1d2d06b$export$b93e3441ec96b29a)),
                args: {
                    includeDeprecated: {
                        type: (0, $djKly.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(type, _ref4) {
                    var includeDeprecated = _ref4.includeDeprecated;
                    if ((0, $8oLgk.isEnumType)(type)) {
                        var values = type.getValues();
                        return includeDeprecated ? values : values.filter(function(field) {
                            return field.deprecationReason == null;
                        });
                    }
                }
            },
            inputFields: {
                type: new (0, $8oLgk.GraphQLList)(new (0, $8oLgk.GraphQLNonNull)($36bed2a2a1d2d06b$export$bc79df5a9719c05b)),
                args: {
                    includeDeprecated: {
                        type: (0, $djKly.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(type, _ref5) {
                    var includeDeprecated = _ref5.includeDeprecated;
                    if ((0, $8oLgk.isInputObjectType)(type)) {
                        var values = (0, $isVmt.default)(type.getFields());
                        return includeDeprecated ? values : values.filter(function(field) {
                            return field.deprecationReason == null;
                        });
                    }
                }
            },
            ofType: {
                type: $36bed2a2a1d2d06b$export$b46ca740abcddda7,
                resolve: function resolve(type) {
                    return type.ofType !== undefined ? type.ofType : undefined;
                }
            }
        };
    }
});
var $36bed2a2a1d2d06b$export$c93780024e419b02 = new (0, $8oLgk.GraphQLObjectType)({
    name: '__Field',
    description: 'Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type.',
    fields: function fields() {
        return {
            name: {
                type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString)),
                resolve: function resolve(field) {
                    return field.name;
                }
            },
            description: {
                type: (0, $djKly.GraphQLString),
                resolve: function resolve(field) {
                    return field.description;
                }
            },
            args: {
                type: new (0, $8oLgk.GraphQLNonNull)(new (0, $8oLgk.GraphQLList)(new (0, $8oLgk.GraphQLNonNull)($36bed2a2a1d2d06b$export$bc79df5a9719c05b))),
                args: {
                    includeDeprecated: {
                        type: (0, $djKly.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(field, _ref6) {
                    var includeDeprecated = _ref6.includeDeprecated;
                    return includeDeprecated ? field.args : field.args.filter(function(arg) {
                        return arg.deprecationReason == null;
                    });
                }
            },
            type: {
                type: new (0, $8oLgk.GraphQLNonNull)($36bed2a2a1d2d06b$export$b46ca740abcddda7),
                resolve: function resolve(field) {
                    return field.type;
                }
            },
            isDeprecated: {
                type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLBoolean)),
                resolve: function resolve(field) {
                    return field.deprecationReason != null;
                }
            },
            deprecationReason: {
                type: (0, $djKly.GraphQLString),
                resolve: function resolve(field) {
                    return field.deprecationReason;
                }
            }
        };
    }
});
var $36bed2a2a1d2d06b$export$bc79df5a9719c05b = new (0, $8oLgk.GraphQLObjectType)({
    name: '__InputValue',
    description: 'Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value.',
    fields: function fields() {
        return {
            name: {
                type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString)),
                resolve: function resolve(inputValue) {
                    return inputValue.name;
                }
            },
            description: {
                type: (0, $djKly.GraphQLString),
                resolve: function resolve(inputValue) {
                    return inputValue.description;
                }
            },
            type: {
                type: new (0, $8oLgk.GraphQLNonNull)($36bed2a2a1d2d06b$export$b46ca740abcddda7),
                resolve: function resolve(inputValue) {
                    return inputValue.type;
                }
            },
            defaultValue: {
                type: (0, $djKly.GraphQLString),
                description: 'A GraphQL-formatted string representing the default value for this input value.',
                resolve: function resolve(inputValue) {
                    var type = inputValue.type, defaultValue = inputValue.defaultValue;
                    var valueAST = (0, $d1i3Z.astFromValue)(defaultValue, type);
                    return valueAST ? (0, $1c8Um.print)(valueAST) : null;
                }
            },
            isDeprecated: {
                type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLBoolean)),
                resolve: function resolve(field) {
                    return field.deprecationReason != null;
                }
            },
            deprecationReason: {
                type: (0, $djKly.GraphQLString),
                resolve: function resolve(obj) {
                    return obj.deprecationReason;
                }
            }
        };
    }
});
var $36bed2a2a1d2d06b$export$b93e3441ec96b29a = new (0, $8oLgk.GraphQLObjectType)({
    name: '__EnumValue',
    description: 'One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string.',
    fields: function fields() {
        return {
            name: {
                type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString)),
                resolve: function resolve(enumValue) {
                    return enumValue.name;
                }
            },
            description: {
                type: (0, $djKly.GraphQLString),
                resolve: function resolve(enumValue) {
                    return enumValue.description;
                }
            },
            isDeprecated: {
                type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLBoolean)),
                resolve: function resolve(enumValue) {
                    return enumValue.deprecationReason != null;
                }
            },
            deprecationReason: {
                type: (0, $djKly.GraphQLString),
                resolve: function resolve(enumValue) {
                    return enumValue.deprecationReason;
                }
            }
        };
    }
});
var $36bed2a2a1d2d06b$export$c29cf3c48471da7c = Object.freeze({
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    INPUT_OBJECT: 'INPUT_OBJECT',
    LIST: 'LIST',
    NON_NULL: 'NON_NULL'
});
var $36bed2a2a1d2d06b$export$163610506c99e78f = new (0, $8oLgk.GraphQLEnumType)({
    name: '__TypeKind',
    description: 'An enum describing what kind of type a given `__Type` is.',
    values: {
        SCALAR: {
            value: $36bed2a2a1d2d06b$export$c29cf3c48471da7c.SCALAR,
            description: 'Indicates this type is a scalar.'
        },
        OBJECT: {
            value: $36bed2a2a1d2d06b$export$c29cf3c48471da7c.OBJECT,
            description: 'Indicates this type is an object. `fields` and `interfaces` are valid fields.'
        },
        INTERFACE: {
            value: $36bed2a2a1d2d06b$export$c29cf3c48471da7c.INTERFACE,
            description: 'Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields.'
        },
        UNION: {
            value: $36bed2a2a1d2d06b$export$c29cf3c48471da7c.UNION,
            description: 'Indicates this type is a union. `possibleTypes` is a valid field.'
        },
        ENUM: {
            value: $36bed2a2a1d2d06b$export$c29cf3c48471da7c.ENUM,
            description: 'Indicates this type is an enum. `enumValues` is a valid field.'
        },
        INPUT_OBJECT: {
            value: $36bed2a2a1d2d06b$export$c29cf3c48471da7c.INPUT_OBJECT,
            description: 'Indicates this type is an input object. `inputFields` is a valid field.'
        },
        LIST: {
            value: $36bed2a2a1d2d06b$export$c29cf3c48471da7c.LIST,
            description: 'Indicates this type is a list. `ofType` is a valid field.'
        },
        NON_NULL: {
            value: $36bed2a2a1d2d06b$export$c29cf3c48471da7c.NON_NULL,
            description: 'Indicates this type is a non-null. `ofType` is a valid field.'
        }
    }
});
var $36bed2a2a1d2d06b$export$36ed059ad2080404 = {
    name: '__schema',
    type: new (0, $8oLgk.GraphQLNonNull)($36bed2a2a1d2d06b$export$1f18df711f6fa0ac),
    description: 'Access the current type schema of this server.',
    args: [],
    resolve: function resolve(_source, _args, _context, _ref7) {
        var schema = _ref7.schema;
        return schema;
    },
    isDeprecated: false,
    deprecationReason: undefined,
    extensions: undefined,
    astNode: undefined
};
var $36bed2a2a1d2d06b$export$87a968d084148b61 = {
    name: '__type',
    type: $36bed2a2a1d2d06b$export$b46ca740abcddda7,
    description: 'Request the type information of a single type.',
    args: [
        {
            name: 'name',
            description: undefined,
            type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString)),
            defaultValue: undefined,
            deprecationReason: undefined,
            extensions: undefined,
            astNode: undefined
        }
    ],
    resolve: function resolve(_source, _ref8, _context, _ref9) {
        var name = _ref8.name;
        var schema = _ref9.schema;
        return schema.getType(name);
    },
    isDeprecated: false,
    deprecationReason: undefined,
    extensions: undefined,
    astNode: undefined
};
var $36bed2a2a1d2d06b$export$b9c17490e825648e = {
    name: '__typename',
    type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString)),
    description: 'The name of the current Object type at runtime.',
    args: [],
    resolve: function resolve(_source, _args, _context, _ref10) {
        var parentType = _ref10.parentType;
        return parentType.name;
    },
    isDeprecated: false,
    deprecationReason: undefined,
    extensions: undefined,
    astNode: undefined
};
var $36bed2a2a1d2d06b$export$560bc6e8f6d098f4 = Object.freeze([
    $36bed2a2a1d2d06b$export$1f18df711f6fa0ac,
    $36bed2a2a1d2d06b$export$2492e8c5b8ba489f,
    $36bed2a2a1d2d06b$export$70e870c5930737d1,
    $36bed2a2a1d2d06b$export$b46ca740abcddda7,
    $36bed2a2a1d2d06b$export$c93780024e419b02,
    $36bed2a2a1d2d06b$export$bc79df5a9719c05b,
    $36bed2a2a1d2d06b$export$b93e3441ec96b29a,
    $36bed2a2a1d2d06b$export$163610506c99e78f
]);
function $36bed2a2a1d2d06b$export$e1862b156b15ce4f(type) {
    return $36bed2a2a1d2d06b$export$560bc6e8f6d098f4.some(function(_ref11) {
        var name = _ref11.name;
        return type.name === name;
    });
}

});
parcelRegister("d1i3Z", function(module, exports) {

$parcel$export(module.exports, "astFromValue", () => $97a9615c2db018a5$export$973c016b19737b40);

var $eeEse = parcelRequire("eeEse");

var $isVmt = parcelRequire("isVmt");

var $yEDl8 = parcelRequire("yEDl8");

var $fM9AB = parcelRequire("fM9AB");

var $cJPdE = parcelRequire("cJPdE");

var $iAT21 = parcelRequire("iAT21");

var $bzIlO = parcelRequire("bzIlO");

var $djKly = parcelRequire("djKly");

var $8oLgk = parcelRequire("8oLgk");
function $97a9615c2db018a5$export$973c016b19737b40(value, type) {
    if ((0, $8oLgk.isNonNullType)(type)) {
        var astValue = $97a9615c2db018a5$export$973c016b19737b40(value, type.ofType);
        if ((astValue === null || astValue === void 0 ? void 0 : astValue.kind) === (0, $bzIlO.Kind).NULL) return null;
        return astValue;
    } // only explicit null, not undefined, NaN
    if (value === null) return {
        kind: (0, $bzIlO.Kind).NULL
    };
     // undefined
    if (value === undefined) return null;
     // Convert JavaScript array to GraphQL list. If the GraphQLType is a list, but
    // the value is not an array, convert the value using the list's item type.
    if ((0, $8oLgk.isListType)(type)) {
        var itemType = type.ofType;
        var items = (0, $iAT21.default)(value);
        if (items != null) {
            var valuesNodes = [];
            for(var _i2 = 0; _i2 < items.length; _i2++){
                var item = items[_i2];
                var itemNode = $97a9615c2db018a5$export$973c016b19737b40(item, itemType);
                if (itemNode != null) valuesNodes.push(itemNode);
            }
            return {
                kind: (0, $bzIlO.Kind).LIST,
                values: valuesNodes
            };
        }
        return $97a9615c2db018a5$export$973c016b19737b40(value, itemType);
    } // Populate the fields of the input object by creating ASTs from each value
    // in the JavaScript object according to the fields in the input type.
    if ((0, $8oLgk.isInputObjectType)(type)) {
        if (!(0, $cJPdE.default)(value)) return null;
        var fieldNodes = [];
        for(var _i4 = 0, _objectValues2 = (0, $isVmt.default)(type.getFields()); _i4 < _objectValues2.length; _i4++){
            var field = _objectValues2[_i4];
            var fieldValue = $97a9615c2db018a5$export$973c016b19737b40(value[field.name], field.type);
            if (fieldValue) fieldNodes.push({
                kind: (0, $bzIlO.Kind).OBJECT_FIELD,
                name: {
                    kind: (0, $bzIlO.Kind).NAME,
                    value: field.name
                },
                value: fieldValue
            });
        }
        return {
            kind: (0, $bzIlO.Kind).OBJECT,
            fields: fieldNodes
        };
    } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $8oLgk.isLeafType)(type)) {
        // Since value is an internally represented value, it must be serialized
        // to an externally represented value before converting into an AST.
        var serialized = type.serialize(value);
        if (serialized == null) return null;
         // Others serialize based on their corresponding JavaScript scalar types.
        if (typeof serialized === 'boolean') return {
            kind: (0, $bzIlO.Kind).BOOLEAN,
            value: serialized
        };
         // JavaScript numbers can be Int or Float values.
        if (typeof serialized === 'number' && (0, $eeEse.default)(serialized)) {
            var stringNum = String(serialized);
            return $97a9615c2db018a5$var$integerStringRegExp.test(stringNum) ? {
                kind: (0, $bzIlO.Kind).INT,
                value: stringNum
            } : {
                kind: (0, $bzIlO.Kind).FLOAT,
                value: stringNum
            };
        }
        if (typeof serialized === 'string') {
            // Enum types use Enum literals.
            if ((0, $8oLgk.isEnumType)(type)) return {
                kind: (0, $bzIlO.Kind).ENUM,
                value: serialized
            };
             // ID types can use Int literals.
            if (type === (0, $djKly.GraphQLID) && $97a9615c2db018a5$var$integerStringRegExp.test(serialized)) return {
                kind: (0, $bzIlO.Kind).INT,
                value: serialized
            };
            return {
                kind: (0, $bzIlO.Kind).STRING,
                value: serialized
            };
        }
        throw new TypeError("Cannot convert value to AST: ".concat((0, $yEDl8.default)(serialized), "."));
    } // istanbul ignore next (Not reachable. All possible input types have been considered)
    (0, $fM9AB.default)(0, 'Unexpected input type: ' + (0, $yEDl8.default)(type));
}
/**
 * IntValue:
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit ( Digit+ )?
 */ var $97a9615c2db018a5$var$integerStringRegExp = /^-?(?:0|[1-9][0-9]*)$/;

});
parcelRegister("eeEse", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5d1c0e1c384cc48$export$2e2bcd8739ae039);
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var $a5d1c0e1c384cc48$var$isFinitePolyfill = Number.isFinite || function(value) {
    return typeof value === 'number' && isFinite(value);
};
var $a5d1c0e1c384cc48$export$2e2bcd8739ae039 = $a5d1c0e1c384cc48$var$isFinitePolyfill;

});

parcelRegister("djKly", function(module, exports) {

$parcel$export(module.exports, "GraphQLInt", () => $9b21002c0b481d2b$export$4d4383325330928b);
$parcel$export(module.exports, "GraphQLFloat", () => $9b21002c0b481d2b$export$3b54cc45efb7ef0d);
$parcel$export(module.exports, "GraphQLString", () => $9b21002c0b481d2b$export$bf00325280f7630c);
$parcel$export(module.exports, "GraphQLBoolean", () => $9b21002c0b481d2b$export$bcd144a2158fe517);
$parcel$export(module.exports, "GraphQLID", () => $9b21002c0b481d2b$export$530df982af95a879);
$parcel$export(module.exports, "specifiedScalarTypes", () => $9b21002c0b481d2b$export$5df80378609411b9);
$parcel$export(module.exports, "isSpecifiedScalarType", () => $9b21002c0b481d2b$export$5d6bb1cb0ae296ca);

var $eeEse = parcelRequire("eeEse");

var $bC0K0 = parcelRequire("bC0K0");

var $yEDl8 = parcelRequire("yEDl8");

var $cJPdE = parcelRequire("cJPdE");

var $bzIlO = parcelRequire("bzIlO");

var $1c8Um = parcelRequire("1c8Um");

var $g5yZB = parcelRequire("g5yZB");

var $8oLgk = parcelRequire("8oLgk");
// 32-bit signed integer, providing the broadest support across platforms.
//
// n.b. JavaScript's integers are safe between -(2^53 - 1) and 2^53 - 1 because
// they are internally represented as IEEE 754 doubles.
var $9b21002c0b481d2b$var$MAX_INT = 2147483647;
var $9b21002c0b481d2b$var$MIN_INT = -2147483648;
function $9b21002c0b481d2b$var$serializeInt(outputValue) {
    var coercedValue = $9b21002c0b481d2b$var$serializeObject(outputValue);
    if (typeof coercedValue === 'boolean') return coercedValue ? 1 : 0;
    var num = coercedValue;
    if (typeof coercedValue === 'string' && coercedValue !== '') num = Number(coercedValue);
    if (!(0, $bC0K0.default)(num)) throw new (0, $g5yZB.GraphQLError)("Int cannot represent non-integer value: ".concat((0, $yEDl8.default)(coercedValue)));
    if (num > $9b21002c0b481d2b$var$MAX_INT || num < $9b21002c0b481d2b$var$MIN_INT) throw new (0, $g5yZB.GraphQLError)('Int cannot represent non 32-bit signed integer value: ' + (0, $yEDl8.default)(coercedValue));
    return num;
}
function $9b21002c0b481d2b$var$coerceInt(inputValue) {
    if (!(0, $bC0K0.default)(inputValue)) throw new (0, $g5yZB.GraphQLError)("Int cannot represent non-integer value: ".concat((0, $yEDl8.default)(inputValue)));
    if (inputValue > $9b21002c0b481d2b$var$MAX_INT || inputValue < $9b21002c0b481d2b$var$MIN_INT) throw new (0, $g5yZB.GraphQLError)("Int cannot represent non 32-bit signed integer value: ".concat(inputValue));
    return inputValue;
}
var $9b21002c0b481d2b$export$4d4383325330928b = new (0, $8oLgk.GraphQLScalarType)({
    name: 'Int',
    description: 'The `Int` scalar type represents non-fractional signed whole numeric values. Int can represent values between -(2^31) and 2^31 - 1.',
    serialize: $9b21002c0b481d2b$var$serializeInt,
    parseValue: $9b21002c0b481d2b$var$coerceInt,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, $bzIlO.Kind).INT) throw new (0, $g5yZB.GraphQLError)("Int cannot represent non-integer value: ".concat((0, $1c8Um.print)(valueNode)), valueNode);
        var num = parseInt(valueNode.value, 10);
        if (num > $9b21002c0b481d2b$var$MAX_INT || num < $9b21002c0b481d2b$var$MIN_INT) throw new (0, $g5yZB.GraphQLError)("Int cannot represent non 32-bit signed integer value: ".concat(valueNode.value), valueNode);
        return num;
    }
});
function $9b21002c0b481d2b$var$serializeFloat(outputValue) {
    var coercedValue = $9b21002c0b481d2b$var$serializeObject(outputValue);
    if (typeof coercedValue === 'boolean') return coercedValue ? 1 : 0;
    var num = coercedValue;
    if (typeof coercedValue === 'string' && coercedValue !== '') num = Number(coercedValue);
    if (!(0, $eeEse.default)(num)) throw new (0, $g5yZB.GraphQLError)("Float cannot represent non numeric value: ".concat((0, $yEDl8.default)(coercedValue)));
    return num;
}
function $9b21002c0b481d2b$var$coerceFloat(inputValue) {
    if (!(0, $eeEse.default)(inputValue)) throw new (0, $g5yZB.GraphQLError)("Float cannot represent non numeric value: ".concat((0, $yEDl8.default)(inputValue)));
    return inputValue;
}
var $9b21002c0b481d2b$export$3b54cc45efb7ef0d = new (0, $8oLgk.GraphQLScalarType)({
    name: 'Float',
    description: 'The `Float` scalar type represents signed double-precision fractional values as specified by [IEEE 754](https://en.wikipedia.org/wiki/IEEE_floating_point).',
    serialize: $9b21002c0b481d2b$var$serializeFloat,
    parseValue: $9b21002c0b481d2b$var$coerceFloat,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, $bzIlO.Kind).FLOAT && valueNode.kind !== (0, $bzIlO.Kind).INT) throw new (0, $g5yZB.GraphQLError)("Float cannot represent non numeric value: ".concat((0, $1c8Um.print)(valueNode)), valueNode);
        return parseFloat(valueNode.value);
    }
}); // Support serializing objects with custom valueOf() or toJSON() functions -
// a common way to represent a complex value which can be represented as
// a string (ex: MongoDB id objects).
function $9b21002c0b481d2b$var$serializeObject(outputValue) {
    if ((0, $cJPdE.default)(outputValue)) {
        if (typeof outputValue.valueOf === 'function') {
            var valueOfResult = outputValue.valueOf();
            if (!(0, $cJPdE.default)(valueOfResult)) return valueOfResult;
        }
        if (typeof outputValue.toJSON === 'function') // $FlowFixMe[incompatible-use]
        return outputValue.toJSON();
    }
    return outputValue;
}
function $9b21002c0b481d2b$var$serializeString(outputValue) {
    var coercedValue = $9b21002c0b481d2b$var$serializeObject(outputValue); // Serialize string, boolean and number values to a string, but do not
    // attempt to coerce object, function, symbol, or other types as strings.
    if (typeof coercedValue === 'string') return coercedValue;
    if (typeof coercedValue === 'boolean') return coercedValue ? 'true' : 'false';
    if ((0, $eeEse.default)(coercedValue)) return coercedValue.toString();
    throw new (0, $g5yZB.GraphQLError)("String cannot represent value: ".concat((0, $yEDl8.default)(outputValue)));
}
function $9b21002c0b481d2b$var$coerceString(inputValue) {
    if (typeof inputValue !== 'string') throw new (0, $g5yZB.GraphQLError)("String cannot represent a non string value: ".concat((0, $yEDl8.default)(inputValue)));
    return inputValue;
}
var $9b21002c0b481d2b$export$bf00325280f7630c = new (0, $8oLgk.GraphQLScalarType)({
    name: 'String',
    description: 'The `String` scalar type represents textual data, represented as UTF-8 character sequences. The String type is most often used by GraphQL to represent free-form human-readable text.',
    serialize: $9b21002c0b481d2b$var$serializeString,
    parseValue: $9b21002c0b481d2b$var$coerceString,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, $bzIlO.Kind).STRING) throw new (0, $g5yZB.GraphQLError)("String cannot represent a non string value: ".concat((0, $1c8Um.print)(valueNode)), valueNode);
        return valueNode.value;
    }
});
function $9b21002c0b481d2b$var$serializeBoolean(outputValue) {
    var coercedValue = $9b21002c0b481d2b$var$serializeObject(outputValue);
    if (typeof coercedValue === 'boolean') return coercedValue;
    if ((0, $eeEse.default)(coercedValue)) return coercedValue !== 0;
    throw new (0, $g5yZB.GraphQLError)("Boolean cannot represent a non boolean value: ".concat((0, $yEDl8.default)(coercedValue)));
}
function $9b21002c0b481d2b$var$coerceBoolean(inputValue) {
    if (typeof inputValue !== 'boolean') throw new (0, $g5yZB.GraphQLError)("Boolean cannot represent a non boolean value: ".concat((0, $yEDl8.default)(inputValue)));
    return inputValue;
}
var $9b21002c0b481d2b$export$bcd144a2158fe517 = new (0, $8oLgk.GraphQLScalarType)({
    name: 'Boolean',
    description: 'The `Boolean` scalar type represents `true` or `false`.',
    serialize: $9b21002c0b481d2b$var$serializeBoolean,
    parseValue: $9b21002c0b481d2b$var$coerceBoolean,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, $bzIlO.Kind).BOOLEAN) throw new (0, $g5yZB.GraphQLError)("Boolean cannot represent a non boolean value: ".concat((0, $1c8Um.print)(valueNode)), valueNode);
        return valueNode.value;
    }
});
function $9b21002c0b481d2b$var$serializeID(outputValue) {
    var coercedValue = $9b21002c0b481d2b$var$serializeObject(outputValue);
    if (typeof coercedValue === 'string') return coercedValue;
    if ((0, $bC0K0.default)(coercedValue)) return String(coercedValue);
    throw new (0, $g5yZB.GraphQLError)("ID cannot represent value: ".concat((0, $yEDl8.default)(outputValue)));
}
function $9b21002c0b481d2b$var$coerceID(inputValue) {
    if (typeof inputValue === 'string') return inputValue;
    if ((0, $bC0K0.default)(inputValue)) return inputValue.toString();
    throw new (0, $g5yZB.GraphQLError)("ID cannot represent value: ".concat((0, $yEDl8.default)(inputValue)));
}
var $9b21002c0b481d2b$export$530df982af95a879 = new (0, $8oLgk.GraphQLScalarType)({
    name: 'ID',
    description: 'The `ID` scalar type represents a unique identifier, often used to refetch an object or as key for a cache. The ID type appears in a JSON response as a String; however, it is not intended to be human-readable. When expected as an input type, any string (such as `"4"`) or integer (such as `4`) input value will be accepted as an ID.',
    serialize: $9b21002c0b481d2b$var$serializeID,
    parseValue: $9b21002c0b481d2b$var$coerceID,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, $bzIlO.Kind).STRING && valueNode.kind !== (0, $bzIlO.Kind).INT) throw new (0, $g5yZB.GraphQLError)('ID cannot represent a non-string and non-integer value: ' + (0, $1c8Um.print)(valueNode), valueNode);
        return valueNode.value;
    }
});
var $9b21002c0b481d2b$export$5df80378609411b9 = Object.freeze([
    $9b21002c0b481d2b$export$bf00325280f7630c,
    $9b21002c0b481d2b$export$4d4383325330928b,
    $9b21002c0b481d2b$export$3b54cc45efb7ef0d,
    $9b21002c0b481d2b$export$bcd144a2158fe517,
    $9b21002c0b481d2b$export$530df982af95a879
]);
function $9b21002c0b481d2b$export$5d6bb1cb0ae296ca(type) {
    return $9b21002c0b481d2b$export$5df80378609411b9.some(function(_ref) {
        var name = _ref.name;
        return type.name === name;
    });
}

});
parcelRegister("bC0K0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8743d1790da9a0f5$export$2e2bcd8739ae039);
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var $8743d1790da9a0f5$var$isInteger = Number.isInteger || function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};
var $8743d1790da9a0f5$export$2e2bcd8739ae039 = $8743d1790da9a0f5$var$isInteger;

});




parcelRegister("35Smo", function(module, exports) {

$parcel$export(module.exports, "isDirective", () => $240c01893cbc0376$export$4b5d79f26e0e3ad5);
$parcel$export(module.exports, "GraphQLDirective", () => $240c01893cbc0376$export$90407e48aac654e9);
$parcel$export(module.exports, "GraphQLIncludeDirective", () => $240c01893cbc0376$export$f92fb5dbf075dbee);
$parcel$export(module.exports, "GraphQLSkipDirective", () => $240c01893cbc0376$export$7adbe9be7084cfe3);
$parcel$export(module.exports, "DEFAULT_DEPRECATION_REASON", () => $240c01893cbc0376$export$15edbda76f1f9a89);
$parcel$export(module.exports, "GraphQLDeprecatedDirective", () => $240c01893cbc0376$export$ed64f8040ac801d1);
$parcel$export(module.exports, "GraphQLSpecifiedByDirective", () => $240c01893cbc0376$export$26ce3cf10bb75d41);
$parcel$export(module.exports, "specifiedDirectives", () => $240c01893cbc0376$export$c48d2e3f4e034403);
$parcel$export(module.exports, "isSpecifiedDirective", () => $240c01893cbc0376$export$7d2e48434602f4fe);

var $ge05d = parcelRequire("ge05d");

var $6DBwa = parcelRequire("6DBwa");

var $yEDl8 = parcelRequire("yEDl8");

var $2mUbt = parcelRequire("2mUbt");

var $a1qmV = parcelRequire("a1qmV");

var $6B4dU = parcelRequire("6B4dU");

var $cJPdE = parcelRequire("cJPdE");

var $520Pd = parcelRequire("520Pd");

var $jADQJ = parcelRequire("jADQJ");

var $djKly = parcelRequire("djKly");

var $8oLgk = parcelRequire("8oLgk");
function $240c01893cbc0376$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $240c01893cbc0376$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $240c01893cbc0376$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $240c01893cbc0376$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $240c01893cbc0376$export$4b5d79f26e0e3ad5(directive) {
    return (0, $6B4dU.default)(directive, $240c01893cbc0376$export$90407e48aac654e9);
}
function $240c01893cbc0376$export$976bef3b79eaee5d(directive) {
    if (!$240c01893cbc0376$export$4b5d79f26e0e3ad5(directive)) throw new Error("Expected ".concat((0, $yEDl8.default)(directive), " to be a GraphQL directive."));
    return directive;
}
var $240c01893cbc0376$export$90407e48aac654e9 = /*#__PURE__*/ function() {
    function GraphQLDirective(config) {
        var _config$isRepeatable, _config$args;
        this.name = config.name;
        this.description = config.description;
        this.locations = config.locations;
        this.isRepeatable = (_config$isRepeatable = config.isRepeatable) !== null && _config$isRepeatable !== void 0 ? _config$isRepeatable : false;
        this.extensions = config.extensions && (0, $2mUbt.default)(config.extensions);
        this.astNode = config.astNode;
        config.name || (0, $a1qmV.default)(0, 'Directive must be named.');
        Array.isArray(config.locations) || (0, $a1qmV.default)(0, "@".concat(config.name, " locations must be an Array."));
        var args = (_config$args = config.args) !== null && _config$args !== void 0 ? _config$args : {};
        (0, $cJPdE.default)(args) && !Array.isArray(args) || (0, $a1qmV.default)(0, "@".concat(config.name, " args must be an object with argument names as keys."));
        this.args = (0, $ge05d.default)(args).map(function(_ref) {
            var argName = _ref[0], argConfig = _ref[1];
            return {
                name: argName,
                description: argConfig.description,
                type: argConfig.type,
                defaultValue: argConfig.defaultValue,
                deprecationReason: argConfig.deprecationReason,
                extensions: argConfig.extensions && (0, $2mUbt.default)(argConfig.extensions),
                astNode: argConfig.astNode
            };
        });
    }
    var _proto = GraphQLDirective.prototype;
    _proto.toConfig = function toConfig() {
        return {
            name: this.name,
            description: this.description,
            locations: this.locations,
            args: (0, $8oLgk.argsToArgsConfig)(this.args),
            isRepeatable: this.isRepeatable,
            extensions: this.extensions,
            astNode: this.astNode
        };
    };
    _proto.toString = function toString() {
        return '@' + this.name;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $240c01893cbc0376$var$_createClass(GraphQLDirective, [
        {
            key: (0, $6DBwa.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLDirective';
            }
        }
    ]);
    return GraphQLDirective;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $520Pd.default)($240c01893cbc0376$export$90407e48aac654e9);
var $240c01893cbc0376$export$f92fb5dbf075dbee = new $240c01893cbc0376$export$90407e48aac654e9({
    name: 'include',
    description: 'Directs the executor to include this field or fragment only when the `if` argument is true.',
    locations: [
        (0, $jADQJ.DirectiveLocation).FIELD,
        (0, $jADQJ.DirectiveLocation).FRAGMENT_SPREAD,
        (0, $jADQJ.DirectiveLocation).INLINE_FRAGMENT
    ],
    args: {
        if: {
            type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLBoolean)),
            description: 'Included when true.'
        }
    }
});
var $240c01893cbc0376$export$7adbe9be7084cfe3 = new $240c01893cbc0376$export$90407e48aac654e9({
    name: 'skip',
    description: 'Directs the executor to skip this field or fragment when the `if` argument is true.',
    locations: [
        (0, $jADQJ.DirectiveLocation).FIELD,
        (0, $jADQJ.DirectiveLocation).FRAGMENT_SPREAD,
        (0, $jADQJ.DirectiveLocation).INLINE_FRAGMENT
    ],
    args: {
        if: {
            type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLBoolean)),
            description: 'Skipped when true.'
        }
    }
});
var $240c01893cbc0376$export$15edbda76f1f9a89 = 'No longer supported';
var $240c01893cbc0376$export$ed64f8040ac801d1 = new $240c01893cbc0376$export$90407e48aac654e9({
    name: 'deprecated',
    description: 'Marks an element of a GraphQL schema as no longer supported.',
    locations: [
        (0, $jADQJ.DirectiveLocation).FIELD_DEFINITION,
        (0, $jADQJ.DirectiveLocation).ARGUMENT_DEFINITION,
        (0, $jADQJ.DirectiveLocation).INPUT_FIELD_DEFINITION,
        (0, $jADQJ.DirectiveLocation).ENUM_VALUE
    ],
    args: {
        reason: {
            type: (0, $djKly.GraphQLString),
            description: 'Explains why this element was deprecated, usually also including a suggestion for how to access supported similar data. Formatted using the Markdown syntax, as specified by [CommonMark](https://commonmark.org/).',
            defaultValue: $240c01893cbc0376$export$15edbda76f1f9a89
        }
    }
});
var $240c01893cbc0376$export$26ce3cf10bb75d41 = new $240c01893cbc0376$export$90407e48aac654e9({
    name: 'specifiedBy',
    description: 'Exposes a URL that specifies the behaviour of this scalar.',
    locations: [
        (0, $jADQJ.DirectiveLocation).SCALAR
    ],
    args: {
        url: {
            type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString)),
            description: 'The URL that specifies the behaviour of this scalar.'
        }
    }
});
var $240c01893cbc0376$export$c48d2e3f4e034403 = Object.freeze([
    $240c01893cbc0376$export$f92fb5dbf075dbee,
    $240c01893cbc0376$export$7adbe9be7084cfe3,
    $240c01893cbc0376$export$ed64f8040ac801d1,
    $240c01893cbc0376$export$26ce3cf10bb75d41
]);
function $240c01893cbc0376$export$7d2e48434602f4fe(directive) {
    return $240c01893cbc0376$export$c48d2e3f4e034403.some(function(_ref2) {
        var name = _ref2.name;
        return name === directive.name;
    });
}

});



parcelRegister("6D4Eu", function(module, exports) {

$parcel$export(module.exports, "typeFromAST", () => $4d39fe60a5e10327$export$292685f75a322892);

var $yEDl8 = parcelRequire("yEDl8");

var $fM9AB = parcelRequire("fM9AB");

var $bzIlO = parcelRequire("bzIlO");

var $8oLgk = parcelRequire("8oLgk");
function $4d39fe60a5e10327$export$292685f75a322892(schema, typeNode) {
    /* eslint-enable no-redeclare */ var innerType;
    if (typeNode.kind === (0, $bzIlO.Kind).LIST_TYPE) {
        innerType = $4d39fe60a5e10327$export$292685f75a322892(schema, typeNode.type);
        return innerType && new (0, $8oLgk.GraphQLList)(innerType);
    }
    if (typeNode.kind === (0, $bzIlO.Kind).NON_NULL_TYPE) {
        innerType = $4d39fe60a5e10327$export$292685f75a322892(schema, typeNode.type);
        return innerType && new (0, $8oLgk.GraphQLNonNull)(innerType);
    } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if (typeNode.kind === (0, $bzIlO.Kind).NAMED_TYPE) return schema.getType(typeNode.name.value);
     // istanbul ignore next (Not reachable. All possible type nodes have been considered)
    (0, $fM9AB.default)(0, 'Unexpected type node: ' + (0, $yEDl8.default)(typeNode));
}

});

parcelRegister("etM9Y", function(module, exports) {

$parcel$export(module.exports, "getOperationRootType", () => $a8a921a61a378224$export$f5bcbf8a32f314e5);

var $g5yZB = parcelRequire("g5yZB");
function $a8a921a61a378224$export$f5bcbf8a32f314e5(schema, operation) {
    if (operation.operation === 'query') {
        var queryType = schema.getQueryType();
        if (!queryType) throw new (0, $g5yZB.GraphQLError)('Schema does not define the required query root type.', operation);
        return queryType;
    }
    if (operation.operation === 'mutation') {
        var mutationType = schema.getMutationType();
        if (!mutationType) throw new (0, $g5yZB.GraphQLError)('Schema is not configured for mutations.', operation);
        return mutationType;
    }
    if (operation.operation === 'subscription') {
        var subscriptionType = schema.getSubscriptionType();
        if (!subscriptionType) throw new (0, $g5yZB.GraphQLError)('Schema is not configured for subscriptions.', operation);
        return subscriptionType;
    }
    throw new (0, $g5yZB.GraphQLError)('Can only have query, mutation and subscription operations.', operation);
}

});

parcelRegister("7dqoX", function(module, exports) {

$parcel$export(module.exports, "getVariableValues", () => $540e3a190dcd969f$export$2038fbf5c9bccf57);
$parcel$export(module.exports, "getArgumentValues", () => $540e3a190dcd969f$export$5af04a8495f7ef54);
$parcel$export(module.exports, "getDirectiveValues", () => $540e3a190dcd969f$export$1f7174681493b2aa);

var $85NSv = parcelRequire("85NSv");

var $aRWmX = parcelRequire("aRWmX");

var $yEDl8 = parcelRequire("yEDl8");

var $lnnuh = parcelRequire("lnnuh");

var $g5yZB = parcelRequire("g5yZB");

var $bzIlO = parcelRequire("bzIlO");

var $1c8Um = parcelRequire("1c8Um");

var $8oLgk = parcelRequire("8oLgk");

var $6D4Eu = parcelRequire("6D4Eu");

var $9aGhX = parcelRequire("9aGhX");

var $7B3dt = parcelRequire("7B3dt");
function $540e3a190dcd969f$export$2038fbf5c9bccf57(schema, varDefNodes, inputs, options) {
    var errors = [];
    var maxErrors = options === null || options === void 0 ? void 0 : options.maxErrors;
    try {
        var coerced = $540e3a190dcd969f$var$coerceVariableValues(schema, varDefNodes, inputs, function(error) {
            if (maxErrors != null && errors.length >= maxErrors) throw new (0, $g5yZB.GraphQLError)('Too many errors processing variables, error limit reached. Execution aborted.');
            errors.push(error);
        });
        if (errors.length === 0) return {
            coerced: coerced
        };
    } catch (error) {
        errors.push(error);
    }
    return {
        errors: errors
    };
}
function $540e3a190dcd969f$var$coerceVariableValues(schema, varDefNodes, inputs, onError) {
    var coercedValues = {};
    var _loop = function _loop(_i2) {
        var varDefNode = varDefNodes[_i2];
        var varName = varDefNode.variable.name.value;
        var varType = (0, $6D4Eu.typeFromAST)(schema, varDefNode.type);
        if (!(0, $8oLgk.isInputType)(varType)) {
            // Must use input types for variables. This should be caught during
            // validation, however is checked again here for safety.
            var varTypeStr = (0, $1c8Um.print)(varDefNode.type);
            onError(new (0, $g5yZB.GraphQLError)("Variable \"$".concat(varName, "\" expected value of type \"").concat(varTypeStr, "\" which cannot be used as an input type."), varDefNode.type));
            return "continue";
        }
        if (!$540e3a190dcd969f$var$hasOwnProperty(inputs, varName)) {
            if (varDefNode.defaultValue) coercedValues[varName] = (0, $9aGhX.valueFromAST)(varDefNode.defaultValue, varType);
            else if ((0, $8oLgk.isNonNullType)(varType)) {
                var _varTypeStr = (0, $yEDl8.default)(varType);
                onError(new (0, $g5yZB.GraphQLError)("Variable \"$".concat(varName, "\" of required type \"").concat(_varTypeStr, "\" was not provided."), varDefNode));
            }
            return "continue";
        }
        var value = inputs[varName];
        if (value === null && (0, $8oLgk.isNonNullType)(varType)) {
            var _varTypeStr2 = (0, $yEDl8.default)(varType);
            onError(new (0, $g5yZB.GraphQLError)("Variable \"$".concat(varName, "\" of non-null type \"").concat(_varTypeStr2, "\" must not be null."), varDefNode));
            return "continue";
        }
        coercedValues[varName] = (0, $7B3dt.coerceInputValue)(value, varType, function(path, invalidValue, error) {
            var prefix = "Variable \"$".concat(varName, "\" got invalid value ") + (0, $yEDl8.default)(invalidValue);
            if (path.length > 0) prefix += " at \"".concat(varName).concat((0, $lnnuh.default)(path), "\"");
            onError(new (0, $g5yZB.GraphQLError)(prefix + '; ' + error.message, varDefNode, undefined, undefined, undefined, error.originalError));
        });
    };
    for(var _i2 = 0; _i2 < varDefNodes.length; _i2++){
        var _ret = _loop(_i2);
        if (_ret === "continue") continue;
    }
    return coercedValues;
}
function $540e3a190dcd969f$export$5af04a8495f7ef54(def, node, variableValues) {
    var _node$arguments;
    var coercedValues = {}; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
    var argumentNodes = (_node$arguments = node.arguments) !== null && _node$arguments !== void 0 ? _node$arguments : [];
    var argNodeMap = (0, $aRWmX.default)(argumentNodes, function(arg) {
        return arg.name.value;
    });
    for(var _i4 = 0, _def$args2 = def.args; _i4 < _def$args2.length; _i4++){
        var argDef = _def$args2[_i4];
        var name = argDef.name;
        var argType = argDef.type;
        var argumentNode = argNodeMap[name];
        if (!argumentNode) {
            if (argDef.defaultValue !== undefined) coercedValues[name] = argDef.defaultValue;
            else if ((0, $8oLgk.isNonNullType)(argType)) throw new (0, $g5yZB.GraphQLError)("Argument \"".concat(name, "\" of required type \"").concat((0, $yEDl8.default)(argType), "\" ") + 'was not provided.', node);
            continue;
        }
        var valueNode = argumentNode.value;
        var isNull = valueNode.kind === (0, $bzIlO.Kind).NULL;
        if (valueNode.kind === (0, $bzIlO.Kind).VARIABLE) {
            var variableName = valueNode.name.value;
            if (variableValues == null || !$540e3a190dcd969f$var$hasOwnProperty(variableValues, variableName)) {
                if (argDef.defaultValue !== undefined) coercedValues[name] = argDef.defaultValue;
                else if ((0, $8oLgk.isNonNullType)(argType)) throw new (0, $g5yZB.GraphQLError)("Argument \"".concat(name, "\" of required type \"").concat((0, $yEDl8.default)(argType), "\" ") + "was provided the variable \"$".concat(variableName, "\" which was not provided a runtime value."), valueNode);
                continue;
            }
            isNull = variableValues[variableName] == null;
        }
        if (isNull && (0, $8oLgk.isNonNullType)(argType)) throw new (0, $g5yZB.GraphQLError)("Argument \"".concat(name, "\" of non-null type \"").concat((0, $yEDl8.default)(argType), "\" ") + 'must not be null.', valueNode);
        var coercedValue = (0, $9aGhX.valueFromAST)(valueNode, argType, variableValues);
        if (coercedValue === undefined) // Note: ValuesOfCorrectTypeRule validation should catch this before
        // execution. This is a runtime check to ensure execution does not
        // continue with an invalid argument value.
        throw new (0, $g5yZB.GraphQLError)("Argument \"".concat(name, "\" has invalid value ").concat((0, $1c8Um.print)(valueNode), "."), valueNode);
        coercedValues[name] = coercedValue;
    }
    return coercedValues;
}
function $540e3a190dcd969f$export$1f7174681493b2aa(directiveDef, node, variableValues) {
    var directiveNode = node.directives && (0, $85NSv.default)(node.directives, function(directive) {
        return directive.name.value === directiveDef.name;
    });
    if (directiveNode) return $540e3a190dcd969f$export$5af04a8495f7ef54(directiveDef, directiveNode, variableValues);
}
function $540e3a190dcd969f$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

});
parcelRegister("lnnuh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8fdf7159fd2d5ff$export$2e2bcd8739ae039);
/**
 * Build a string describing the path.
 */ function $f8fdf7159fd2d5ff$export$2e2bcd8739ae039(path) {
    return path.map(function(key) {
        return typeof key === 'number' ? '[' + key.toString() + ']' : '.' + key;
    }).join('');
}

});

parcelRegister("9aGhX", function(module, exports) {

$parcel$export(module.exports, "valueFromAST", () => $6ad5d9e2e202f145$export$d32bfdfcfbe60e55);

var $isVmt = parcelRequire("isVmt");

var $aRWmX = parcelRequire("aRWmX");

var $yEDl8 = parcelRequire("yEDl8");

var $fM9AB = parcelRequire("fM9AB");

var $bzIlO = parcelRequire("bzIlO");

var $8oLgk = parcelRequire("8oLgk");
function $6ad5d9e2e202f145$export$d32bfdfcfbe60e55(valueNode, type, variables) {
    if (!valueNode) // When there is no node, then there is also no value.
    // Importantly, this is different from returning the value null.
    return;
    if (valueNode.kind === (0, $bzIlO.Kind).VARIABLE) {
        var variableName = valueNode.name.value;
        if (variables == null || variables[variableName] === undefined) // No valid return value.
        return;
        var variableValue = variables[variableName];
        if (variableValue === null && (0, $8oLgk.isNonNullType)(type)) return; // Invalid: intentionally return no value.
         // Note: This does no further checking that this variable is correct.
        // This assumes that this query has been validated and the variable
        // usage here is of the correct type.
        return variableValue;
    }
    if ((0, $8oLgk.isNonNullType)(type)) {
        if (valueNode.kind === (0, $bzIlO.Kind).NULL) return; // Invalid: intentionally return no value.
        return $6ad5d9e2e202f145$export$d32bfdfcfbe60e55(valueNode, type.ofType, variables);
    }
    if (valueNode.kind === (0, $bzIlO.Kind).NULL) // This is explicitly returning the value null.
    return null;
    if ((0, $8oLgk.isListType)(type)) {
        var itemType = type.ofType;
        if (valueNode.kind === (0, $bzIlO.Kind).LIST) {
            var coercedValues = [];
            for(var _i2 = 0, _valueNode$values2 = valueNode.values; _i2 < _valueNode$values2.length; _i2++){
                var itemNode = _valueNode$values2[_i2];
                if ($6ad5d9e2e202f145$var$isMissingVariable(itemNode, variables)) {
                    // If an array contains a missing variable, it is either coerced to
                    // null or if the item type is non-null, it considered invalid.
                    if ((0, $8oLgk.isNonNullType)(itemType)) return; // Invalid: intentionally return no value.
                    coercedValues.push(null);
                } else {
                    var itemValue = $6ad5d9e2e202f145$export$d32bfdfcfbe60e55(itemNode, itemType, variables);
                    if (itemValue === undefined) return; // Invalid: intentionally return no value.
                    coercedValues.push(itemValue);
                }
            }
            return coercedValues;
        }
        var coercedValue = $6ad5d9e2e202f145$export$d32bfdfcfbe60e55(valueNode, itemType, variables);
        if (coercedValue === undefined) return; // Invalid: intentionally return no value.
        return [
            coercedValue
        ];
    }
    if ((0, $8oLgk.isInputObjectType)(type)) {
        if (valueNode.kind !== (0, $bzIlO.Kind).OBJECT) return; // Invalid: intentionally return no value.
        var coercedObj = Object.create(null);
        var fieldNodes = (0, $aRWmX.default)(valueNode.fields, function(field) {
            return field.name.value;
        });
        for(var _i4 = 0, _objectValues2 = (0, $isVmt.default)(type.getFields()); _i4 < _objectValues2.length; _i4++){
            var field = _objectValues2[_i4];
            var fieldNode = fieldNodes[field.name];
            if (!fieldNode || $6ad5d9e2e202f145$var$isMissingVariable(fieldNode.value, variables)) {
                if (field.defaultValue !== undefined) coercedObj[field.name] = field.defaultValue;
                else if ((0, $8oLgk.isNonNullType)(field.type)) return; // Invalid: intentionally return no value.
                continue;
            }
            var fieldValue = $6ad5d9e2e202f145$export$d32bfdfcfbe60e55(fieldNode.value, field.type, variables);
            if (fieldValue === undefined) return; // Invalid: intentionally return no value.
            coercedObj[field.name] = fieldValue;
        }
        return coercedObj;
    } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $8oLgk.isLeafType)(type)) {
        // Scalars and Enums fulfill parsing a literal value via parseLiteral().
        // Invalid values represent a failure to parse correctly, in which case
        // no value is returned.
        var result;
        try {
            result = type.parseLiteral(valueNode, variables);
        } catch (_error) {
            return; // Invalid: intentionally return no value.
        }
        if (result === undefined) return; // Invalid: intentionally return no value.
        return result;
    } // istanbul ignore next (Not reachable. All possible input types have been considered)
    (0, $fM9AB.default)(0, 'Unexpected input type: ' + (0, $yEDl8.default)(type));
} // Returns true if the provided valueNode is a variable which is not defined
// in the set of variables.
function $6ad5d9e2e202f145$var$isMissingVariable(valueNode, variables) {
    return valueNode.kind === (0, $bzIlO.Kind).VARIABLE && (variables == null || variables[valueNode.name.value] === undefined);
}

});

parcelRegister("7B3dt", function(module, exports) {

$parcel$export(module.exports, "coerceInputValue", () => $587e7bc9fafdbc8f$export$7964ec791f1fa3f1);

var $isVmt = parcelRequire("isVmt");

var $yEDl8 = parcelRequire("yEDl8");

var $fM9AB = parcelRequire("fM9AB");

var $h4f6N = parcelRequire("h4f6N");

var $cJPdE = parcelRequire("cJPdE");

var $iAT21 = parcelRequire("iAT21");

var $gXVhx = parcelRequire("gXVhx");

var $lnnuh = parcelRequire("lnnuh");

var $hEo2F = parcelRequire("hEo2F");

var $g5yZB = parcelRequire("g5yZB");

var $8oLgk = parcelRequire("8oLgk");
function $587e7bc9fafdbc8f$export$7964ec791f1fa3f1(inputValue, type) {
    var onError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $587e7bc9fafdbc8f$var$defaultOnError;
    return $587e7bc9fafdbc8f$var$coerceInputValueImpl(inputValue, type, onError);
}
function $587e7bc9fafdbc8f$var$defaultOnError(path, invalidValue, error) {
    var errorPrefix = 'Invalid value ' + (0, $yEDl8.default)(invalidValue);
    if (path.length > 0) errorPrefix += " at \"value".concat((0, $lnnuh.default)(path), "\"");
    error.message = errorPrefix + ': ' + error.message;
    throw error;
}
function $587e7bc9fafdbc8f$var$coerceInputValueImpl(inputValue, type, onError, path) {
    if ((0, $8oLgk.isNonNullType)(type)) {
        if (inputValue != null) return $587e7bc9fafdbc8f$var$coerceInputValueImpl(inputValue, type.ofType, onError, path);
        onError((0, $hEo2F.pathToArray)(path), inputValue, new (0, $g5yZB.GraphQLError)("Expected non-nullable type \"".concat((0, $yEDl8.default)(type), "\" not to be null.")));
        return;
    }
    if (inputValue == null) // Explicitly return the value null.
    return null;
    if ((0, $8oLgk.isListType)(type)) {
        var itemType = type.ofType;
        var coercedList = (0, $iAT21.default)(inputValue, function(itemValue, index) {
            var itemPath = (0, $hEo2F.addPath)(path, index, undefined);
            return $587e7bc9fafdbc8f$var$coerceInputValueImpl(itemValue, itemType, onError, itemPath);
        });
        if (coercedList != null) return coercedList;
         // Lists accept a non-list value as a list of one.
        return [
            $587e7bc9fafdbc8f$var$coerceInputValueImpl(inputValue, itemType, onError, path)
        ];
    }
    if ((0, $8oLgk.isInputObjectType)(type)) {
        if (!(0, $cJPdE.default)(inputValue)) {
            onError((0, $hEo2F.pathToArray)(path), inputValue, new (0, $g5yZB.GraphQLError)("Expected type \"".concat(type.name, "\" to be an object.")));
            return;
        }
        var coercedValue = {};
        var fieldDefs = type.getFields();
        for(var _i2 = 0, _objectValues2 = (0, $isVmt.default)(fieldDefs); _i2 < _objectValues2.length; _i2++){
            var field = _objectValues2[_i2];
            var fieldValue = inputValue[field.name];
            if (fieldValue === undefined) {
                if (field.defaultValue !== undefined) coercedValue[field.name] = field.defaultValue;
                else if ((0, $8oLgk.isNonNullType)(field.type)) {
                    var typeStr = (0, $yEDl8.default)(field.type);
                    onError((0, $hEo2F.pathToArray)(path), inputValue, new (0, $g5yZB.GraphQLError)("Field \"".concat(field.name, "\" of required type \"").concat(typeStr, "\" was not provided.")));
                }
                continue;
            }
            coercedValue[field.name] = $587e7bc9fafdbc8f$var$coerceInputValueImpl(fieldValue, field.type, onError, (0, $hEo2F.addPath)(path, field.name, type.name));
        } // Ensure every provided field is defined.
        for(var _i4 = 0, _Object$keys2 = Object.keys(inputValue); _i4 < _Object$keys2.length; _i4++){
            var fieldName = _Object$keys2[_i4];
            if (!fieldDefs[fieldName]) {
                var suggestions = (0, $gXVhx.default)(fieldName, Object.keys(type.getFields()));
                onError((0, $hEo2F.pathToArray)(path), inputValue, new (0, $g5yZB.GraphQLError)("Field \"".concat(fieldName, "\" is not defined by type \"").concat(type.name, "\".") + (0, $h4f6N.default)(suggestions)));
            }
        }
        return coercedValue;
    } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $8oLgk.isLeafType)(type)) {
        var parseResult; // Scalars and Enums determine if a input value is valid via parseValue(),
        // which can throw to indicate failure. If it throws, maintain a reference
        // to the original error.
        try {
            parseResult = type.parseValue(inputValue);
        } catch (error) {
            if (error instanceof (0, $g5yZB.GraphQLError)) onError((0, $hEo2F.pathToArray)(path), inputValue, error);
            else onError((0, $hEo2F.pathToArray)(path), inputValue, new (0, $g5yZB.GraphQLError)("Expected type \"".concat(type.name, "\". ") + error.message, undefined, undefined, undefined, undefined, error));
            return;
        }
        if (parseResult === undefined) onError((0, $hEo2F.pathToArray)(path), inputValue, new (0, $g5yZB.GraphQLError)("Expected type \"".concat(type.name, "\".")));
        return parseResult;
    } // istanbul ignore next (Not reachable. All possible input types have been considered)
    (0, $fM9AB.default)(0, 'Unexpected input type: ' + (0, $yEDl8.default)(type));
}

});




parcelRegister("cKbwx", function(module, exports) {
function $9472b847e3d286b8$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9472b847e3d286b8$var$__export((parcelRequire("gIDuj")));

$9472b847e3d286b8$var$__export((parcelRequire("cCTSK")));

$9472b847e3d286b8$var$__export((parcelRequire("h3H2i")));

$9472b847e3d286b8$var$__export((parcelRequire("810gP")));

var $48EbR = parcelRequire("48EbR");
module.exports.SchemaDirectiveVisitor = $48EbR.SchemaDirectiveVisitor;

});
parcelRegister("gIDuj", function(module, exports) {
function $c2bf62df9ea62751$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $mP8zZ = parcelRequire("mP8zZ");

var $48EbR = parcelRequire("48EbR");

var $4Imtl = parcelRequire("4Imtl");

function $c2bf62df9ea62751$var$makeExecutableSchema(_a) {
    var typeDefs = _a.typeDefs, _b = _a.resolvers, resolvers = _b === void 0 ? {} : _b, connectors = _a.connectors, logger = _a.logger, _c = _a.allowUndefinedInResolve, allowUndefinedInResolve = _c === void 0 ? true : _c, _d = _a.resolverValidationOptions, resolverValidationOptions = _d === void 0 ? {} : _d, _e = _a.directiveResolvers, directiveResolvers = _e === void 0 ? null : _e, _f = _a.schemaDirectives, schemaDirectives = _f === void 0 ? null : _f, _g = _a.parseOptions, parseOptions = _g === void 0 ? {} : _g, _h = _a.inheritResolversFromInterfaces, inheritResolversFromInterfaces = _h === void 0 ? false : _h;
    // Validate and clean up arguments
    if (typeof resolverValidationOptions !== 'object') throw new (parcelRequire("l9QLJ")).SchemaError('Expected `resolverValidationOptions` to be an object');
    if (!typeDefs) throw new (parcelRequire("l9QLJ")).SchemaError('Must provide typeDefs');
    if (!resolvers) throw new (parcelRequire("l9QLJ")).SchemaError('Must provide resolvers');
    // We allow passing in an array of resolver maps, in which case we merge them
    var resolverMap = Array.isArray(resolvers) ? resolvers.filter(function(resolverObj) {
        return typeof resolverObj === 'object';
    }).reduce($4Imtl.default, {}) : resolvers;
    // Arguments are now validated and cleaned up
    var schema = (parcelRequire("l9QLJ")).buildSchemaFromTypeDefinitions(typeDefs, parseOptions);
    schema = (parcelRequire("l9QLJ")).addResolveFunctionsToSchema({
        schema: schema,
        resolvers: resolverMap,
        resolverValidationOptions: resolverValidationOptions,
        inheritResolversFromInterfaces: inheritResolversFromInterfaces
    });
    (parcelRequire("l9QLJ")).assertResolveFunctionsPresent(schema, resolverValidationOptions);
    if (!allowUndefinedInResolve) $c2bf62df9ea62751$var$addCatchUndefinedToSchema(schema);
    if (logger) $c2bf62df9ea62751$var$addErrorLoggingToSchema(schema, logger);
    if (typeof resolvers['__schema'] === 'function') // TODO a bit of a hack now, better rewrite generateSchema to attach it there.
    // not doing that now, because I'd have to rewrite a lot of tests.
    (parcelRequire("l9QLJ")).addSchemaLevelResolveFunction(schema, resolvers['__schema']);
    if (connectors) // connectors are optional, at least for now. That means you can just import them in the resolve
    // function if you want.
    (parcelRequire("l9QLJ")).attachConnectorsToContext(schema, connectors);
    if (directiveResolvers) (parcelRequire("l9QLJ")).attachDirectiveResolvers(schema, directiveResolvers);
    if (schemaDirectives) $48EbR.SchemaDirectiveVisitor.visitSchemaDirectives(schema, schemaDirectives);
    return schema;
}
module.exports.makeExecutableSchema = $c2bf62df9ea62751$var$makeExecutableSchema;
function $c2bf62df9ea62751$var$decorateToCatchUndefined(fn, hint) {
    if (typeof fn === 'undefined') fn = $mP8zZ.defaultFieldResolver;
    return function(root, args, ctx, info) {
        var result = fn(root, args, ctx, info);
        if (typeof result === 'undefined') throw new Error("Resolve function for \"" + hint + "\" returned undefined");
        return result;
    };
}
function $c2bf62df9ea62751$var$addCatchUndefinedToSchema(schema) {
    (parcelRequire("l9QLJ")).forEachField(schema, function(field, typeName, fieldName) {
        var errorHint = typeName + "." + fieldName;
        field.resolve = $c2bf62df9ea62751$var$decorateToCatchUndefined(field.resolve, errorHint);
    });
}
module.exports.addCatchUndefinedToSchema = $c2bf62df9ea62751$var$addCatchUndefinedToSchema;
function $c2bf62df9ea62751$var$addErrorLoggingToSchema(schema, logger) {
    if (!logger) throw new Error('Must provide a logger');
    if (typeof logger.log !== 'function') throw new Error('Logger.log must be a function');
    (parcelRequire("l9QLJ")).forEachField(schema, function(field, typeName, fieldName) {
        var errorHint = typeName + "." + fieldName;
        field.resolve = (parcelRequire("l9QLJ")).decorateWithLogger(field.resolve, logger, errorHint);
    });
}
module.exports.addErrorLoggingToSchema = $c2bf62df9ea62751$var$addErrorLoggingToSchema;

$c2bf62df9ea62751$var$__export((parcelRequire("l9QLJ")));

});
parcelRegister("48EbR", function(module, exports) {
var $303715b63bc39cec$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $303715b63bc39cec$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8oLgk = parcelRequire("8oLgk");
var $lUVCX = parcelRequire("lUVCX");
var $bzIlO = parcelRequire("bzIlO");

var $7dqoX = parcelRequire("7dqoX");
var $303715b63bc39cec$var$hasOwn = Object.prototype.hasOwnProperty;
// Abstract base class of any visitor implementation, defining the available
// visitor methods along with their parameter types, and providing a static
// helper function for determining whether a subclass implements a given
// visitor method, as opposed to inheriting one of the stubs defined here.
var $303715b63bc39cec$var$SchemaVisitor = /** @class */ function() {
    function SchemaVisitor() {}
    // Determine if this SchemaVisitor (sub)class implements a particular
    // visitor method.
    SchemaVisitor.implementsVisitorMethod = function(methodName) {
        if (!methodName.startsWith('visit')) return false;
        var method = this.prototype[methodName];
        if (typeof method !== 'function') return false;
        if (this === SchemaVisitor) // The SchemaVisitor class implements every visitor method.
        return true;
        var stub = SchemaVisitor.prototype[methodName];
        if (method === stub) // If this.prototype[methodName] was just inherited from SchemaVisitor,
        // then this class does not really implement the method.
        return false;
        return true;
    };
    // Concrete subclasses of SchemaVisitor should override one or more of these
    // visitor methods, in order to express their interest in handling certain
    // schema types/locations. Each method may return null to remove the given
    // type from the schema, a non-null value of the same type to update the
    // type in the schema, or nothing to leave the type as it was.
    /* tslint:disable:no-empty */ SchemaVisitor.prototype.visitSchema = function(schema) {};
    SchemaVisitor.prototype.visitScalar = function(scalar) {};
    SchemaVisitor.prototype.visitObject = function(object) {};
    SchemaVisitor.prototype.visitFieldDefinition = function(field, details) {};
    SchemaVisitor.prototype.visitArgumentDefinition = function(argument, details) {};
    SchemaVisitor.prototype.visitInterface = function(iface) {};
    SchemaVisitor.prototype.visitUnion = function(union) {};
    SchemaVisitor.prototype.visitEnum = function(type) {};
    SchemaVisitor.prototype.visitEnumValue = function(value, details) {};
    SchemaVisitor.prototype.visitInputObject = function(object) {};
    SchemaVisitor.prototype.visitInputFieldDefinition = function(field, details) {};
    return SchemaVisitor;
}();
module.exports.SchemaVisitor = $303715b63bc39cec$var$SchemaVisitor;
// Generic function for visiting GraphQLSchema objects.
function $303715b63bc39cec$var$visitSchema(schema, // To accommodate as many different visitor patterns as possible, the
// visitSchema function does not simply accept a single instance of the
// SchemaVisitor class, but instead accepts a function that takes the
// current VisitableSchemaType object and the name of a visitor method and
// returns an array of SchemaVisitor instances that implement the visitor
// method and have an interest in handling the given VisitableSchemaType
// object. In the simplest case, this function can always return an array
// containing a single visitor object, without even looking at the type or
// methodName parameters. In other cases, this function might sometimes
// return an empty array to indicate there are no visitors that should be
// applied to the given VisitableSchemaType object. For an example of a
// visitor pattern that benefits from this abstraction, see the
// SchemaDirectiveVisitor class below.
visitorSelector) {
    // Helper function that calls visitorSelector and applies the resulting
    // visitors to the given type, with arguments [type, ...args].
    function callMethod(methodName, type) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        visitorSelector(type, methodName).every(function(visitor) {
            var newType = visitor[methodName].apply(visitor, $303715b63bc39cec$var$__spreadArrays([
                type
            ], args));
            if (typeof newType === 'undefined') // Keep going without modifying type.
            return true;
            if (methodName === 'visitSchema' || type instanceof $lUVCX.GraphQLSchema) throw new Error("Method " + methodName + " cannot replace schema with " + newType);
            if (newType === null) {
                // Stop the loop and return null form callMethod, which will cause
                // the type to be removed from the schema.
                type = null;
                return false;
            }
            // Update type to the new type returned by the visitor method, so that
            // later directives will see the new type, and callMethod will return
            // the final type.
            type = newType;
            return true;
        });
        // If there were no directives for this type object, or if all visitor
        // methods returned nothing, type will be returned unmodified.
        return type;
    }
    // Recursive helper function that calls any appropriate visitor methods for
    // each object in the schema, then traverses the object's children (if any).
    function visit(type) {
        if (type instanceof $lUVCX.GraphQLSchema) {
            // Unlike the other types, the root GraphQLSchema object cannot be
            // replaced by visitor methods, because that would make life very hard
            // for SchemaVisitor subclasses that rely on the original schema object.
            callMethod('visitSchema', type);
            $303715b63bc39cec$var$updateEachKey(type.getTypeMap(), function(namedType, typeName) {
                if (!typeName.startsWith('__')) // Call visit recursively to let it determine which concrete
                // subclass of GraphQLNamedType we found in the type map. Because
                // we're using updateEachKey, the result of visit(namedType) may
                // cause the type to be removed or replaced.
                return visit(namedType);
            });
            return type;
        }
        if (type instanceof $8oLgk.GraphQLObjectType) {
            // Note that callMethod('visitObject', type) may not actually call any
            // methods, if there are no @directive annotations associated with this
            // type, or if this SchemaDirectiveVisitor subclass does not override
            // the visitObject method.
            var newObject = callMethod('visitObject', type);
            if (newObject) visitFields(newObject);
            return newObject;
        }
        if (type instanceof $8oLgk.GraphQLInterfaceType) {
            var newInterface = callMethod('visitInterface', type);
            if (newInterface) visitFields(newInterface);
            return newInterface;
        }
        if (type instanceof $8oLgk.GraphQLInputObjectType) {
            var newInputObject_1 = callMethod('visitInputObject', type);
            if (newInputObject_1) $303715b63bc39cec$var$updateEachKey(newInputObject_1.getFields(), function(field) {
                // Since we call a different method for input object fields, we
                // can't reuse the visitFields function here.
                return callMethod('visitInputFieldDefinition', field, {
                    objectType: newInputObject_1
                });
            });
            return newInputObject_1;
        }
        if (type instanceof $8oLgk.GraphQLScalarType) return callMethod('visitScalar', type);
        if (type instanceof $8oLgk.GraphQLUnionType) return callMethod('visitUnion', type);
        if (type instanceof $8oLgk.GraphQLEnumType) {
            var newEnum_1 = callMethod('visitEnum', type);
            if (newEnum_1) $303715b63bc39cec$var$updateEachKey(newEnum_1.getValues(), function(value) {
                return callMethod('visitEnumValue', value, {
                    enumType: newEnum_1
                });
            });
            return newEnum_1;
        }
        throw new Error("Unexpected schema type: " + type);
    }
    function visitFields(type) {
        $303715b63bc39cec$var$updateEachKey(type.getFields(), function(field) {
            // It would be nice if we could call visit(field) recursively here, but
            // GraphQLField is merely a type, not a value that can be detected using
            // an instanceof check, so we have to visit the fields in this lexical
            // context, so that TypeScript can validate the call to
            // visitFieldDefinition.
            var newField = callMethod('visitFieldDefinition', field, {
                // While any field visitor needs a reference to the field object, some
                // field visitors may also need to know the enclosing (parent) type,
                // perhaps to determine if the parent is a GraphQLObjectType or a
                // GraphQLInterfaceType. To obtain a reference to the parent, a
                // visitor method can have a second parameter, which will be an object
                // with an .objectType property referring to the parent.
                objectType: type
            });
            if (newField && newField.args) $303715b63bc39cec$var$updateEachKey(newField.args, function(arg) {
                return callMethod('visitArgumentDefinition', arg, {
                    // Like visitFieldDefinition, visitArgumentDefinition takes a
                    // second parameter that provides additional context, namely the
                    // parent .field and grandparent .objectType. Remember that the
                    // current GraphQLSchema is always available via this.schema.
                    field: newField,
                    objectType: type
                });
            });
            return newField;
        });
    }
    visit(schema);
    // Return the original schema for convenience, even though it cannot have
    // been replaced or removed by the code above.
    return schema;
}
module.exports.visitSchema = $303715b63bc39cec$var$visitSchema;
// Update any references to named schema types that disagree with the named
// types found in schema.getTypeMap().
function $303715b63bc39cec$var$healSchema(schema) {
    heal(schema);
    return schema;
    function heal(type) {
        if (type instanceof $lUVCX.GraphQLSchema) {
            var originalTypeMap_1 = type.getTypeMap();
            var actualNamedTypeMap_1 = Object.create(null);
            // If any of the .name properties of the GraphQLNamedType objects in
            // schema.getTypeMap() have changed, the keys of the type map need to
            // be updated accordingly.
            $303715b63bc39cec$var$each(originalTypeMap_1, function(namedType, typeName) {
                if (typeName.startsWith('__')) return;
                var actualName = namedType.name;
                if (actualName.startsWith('__')) return;
                if ($303715b63bc39cec$var$hasOwn.call(actualNamedTypeMap_1, actualName)) throw new Error("Duplicate schema type name " + actualName);
                actualNamedTypeMap_1[actualName] = namedType;
            // Note: we are deliberately leaving namedType in the schema by its
            // original name (which might be different from actualName), so that
            // references by that name can be healed.
            });
            // Now add back every named type by its actual name.
            $303715b63bc39cec$var$each(actualNamedTypeMap_1, function(namedType, typeName) {
                originalTypeMap_1[typeName] = namedType;
            });
            // Directive declaration argument types can refer to named types.
            $303715b63bc39cec$var$each(type.getDirectives(), function(decl) {
                if (decl.args) $303715b63bc39cec$var$each(decl.args, function(arg) {
                    arg.type = healType(arg.type);
                });
            });
            $303715b63bc39cec$var$each(originalTypeMap_1, function(namedType, typeName) {
                if (!typeName.startsWith('__')) heal(namedType);
            });
            $303715b63bc39cec$var$updateEachKey(originalTypeMap_1, function(namedType, typeName) {
                // Dangling references to renamed types should remain in the schema
                // during healing, but must be removed now, so that the following
                // invariant holds for all names: schema.getType(name).name === name
                if (!typeName.startsWith('__') && !$303715b63bc39cec$var$hasOwn.call(actualNamedTypeMap_1, typeName)) return null;
            });
        } else if (type instanceof $8oLgk.GraphQLObjectType) {
            healFields(type);
            $303715b63bc39cec$var$each(type.getInterfaces(), function(iface) {
                return heal(iface);
            });
        } else if (type instanceof $8oLgk.GraphQLInterfaceType) healFields(type);
        else if (type instanceof $8oLgk.GraphQLInputObjectType) $303715b63bc39cec$var$each(type.getFields(), function(field) {
            field.type = healType(field.type);
        });
        else if (type instanceof $8oLgk.GraphQLScalarType) ;
        else if (type instanceof $8oLgk.GraphQLUnionType) $303715b63bc39cec$var$updateEachKey(type.getTypes(), function(t) {
            return healType(t);
        });
        else if (type instanceof $8oLgk.GraphQLEnumType) ;
        else throw new Error("Unexpected schema type: " + type);
    }
    function healFields(type) {
        $303715b63bc39cec$var$each(type.getFields(), function(field) {
            field.type = healType(field.type);
            if (field.args) $303715b63bc39cec$var$each(field.args, function(arg) {
                arg.type = healType(arg.type);
            });
        });
    }
    function healType(type) {
        // Unwrap the two known wrapper types
        if (type instanceof $8oLgk.GraphQLList) type = new $8oLgk.GraphQLList(healType(type.ofType));
        else if (type instanceof $8oLgk.GraphQLNonNull) type = new $8oLgk.GraphQLNonNull(healType(type.ofType));
        else if ($8oLgk.isNamedType(type)) {
            // If a type annotation on a field or an argument or a union member is
            // any `GraphQLNamedType` with a `name`, then it must end up identical
            // to `schema.getType(name)`, since `schema.getTypeMap()` is the source
            // of truth for all named schema types.
            var namedType = type;
            var officialType = schema.getType(namedType.name);
            if (officialType && namedType !== officialType) return officialType;
        }
        return type;
    }
}
module.exports.healSchema = $303715b63bc39cec$var$healSchema;
// This class represents a reusable implementation of a @directive that may
// appear in a GraphQL schema written in Schema Definition Language.
//
// By overriding one or more visit{Object,Union,...} methods, a subclass
// registers interest in certain schema types, such as GraphQLObjectType,
// GraphQLUnionType, etc. When SchemaDirectiveVisitor.visitSchemaDirectives is
// called with a GraphQLSchema object and a map of visitor subclasses, the
// overidden methods of those subclasses allow the visitors to obtain
// references to any type objects that have @directives attached to them,
// enabling visitors to inspect or modify the schema as appropriate.
//
// For example, if a directive called @rest(url: "...") appears after a field
// definition, a SchemaDirectiveVisitor subclass could provide meaning to that
// directive by overriding the visitFieldDefinition method (which receives a
// GraphQLField parameter), and then the body of that visitor method could
// manipulate the field's resolver function to fetch data from a REST endpoint
// described by the url argument passed to the @rest directive:
//
//   const typeDefs = `
//   type Query {
//     people: [Person] @rest(url: "/api/v1/people")
//   }`;
//
//   const schema = makeExecutableSchema({ typeDefs });
//
//   SchemaDirectiveVisitor.visitSchemaDirectives(schema, {
//     rest: class extends SchemaDirectiveVisitor {
//       public visitFieldDefinition(field: GraphQLField<any, any>) {
//         const { url } = this.args;
//         field.resolve = () => fetch(url);
//       }
//     }
//   });
//
// The subclass in this example is defined as an anonymous class expression,
// for brevity. A truly reusable SchemaDirectiveVisitor would most likely be
// defined in a library using a named class declaration, and then exported for
// consumption by other modules and packages.
//
// See below for a complete list of overridable visitor methods, their
// parameter types, and more details about the properties exposed by instances
// of the SchemaDirectiveVisitor class.
var $303715b63bc39cec$var$SchemaDirectiveVisitor = /** @class */ function(_super) {
    $303715b63bc39cec$var$__extends(SchemaDirectiveVisitor, _super);
    // Mark the constructor protected to enforce passing SchemaDirectiveVisitor
    // subclasses (not instances) to visitSchemaDirectives.
    function SchemaDirectiveVisitor(config) {
        var _this = _super.call(this) || this;
        _this.name = config.name;
        _this.args = config.args;
        _this.visitedType = config.visitedType;
        _this.schema = config.schema;
        _this.context = config.context;
        return _this;
    }
    // Override this method to return a custom GraphQLDirective (or modify one
    // already present in the schema) to enforce argument types, provide default
    // argument values, or specify schema locations where this @directive may
    // appear. By default, any declaration found in the schema will be returned.
    SchemaDirectiveVisitor.getDirectiveDeclaration = function(directiveName, schema) {
        return schema.getDirective(directiveName);
    };
    // Call SchemaDirectiveVisitor.visitSchemaDirectives to visit every
    // @directive in the schema and create an appropriate SchemaDirectiveVisitor
    // instance to visit the object decorated by the @directive.
    SchemaDirectiveVisitor.visitSchemaDirectives = function(schema, directiveVisitors, // Optional context object that will be available to all visitor instances
    // via this.context. Defaults to an empty null-prototype object.
    context) {
        if (context === void 0) context = Object.create(null);
        // If the schema declares any directives for public consumption, record
        // them here so that we can properly coerce arguments when/if we encounter
        // an occurrence of the directive while walking the schema below.
        var declaredDirectives = this.getDeclaredDirectives(schema, directiveVisitors);
        // Map from directive names to lists of SchemaDirectiveVisitor instances
        // created while visiting the schema.
        var createdVisitors = Object.create(null);
        Object.keys(directiveVisitors).forEach(function(directiveName) {
            createdVisitors[directiveName] = [];
        });
        function visitorSelector(type, methodName) {
            var visitors = [];
            var directiveNodes = type.astNode && type.astNode.directives;
            if (!directiveNodes) return visitors;
            directiveNodes.forEach(function(directiveNode) {
                var directiveName = directiveNode.name.value;
                if (!$303715b63bc39cec$var$hasOwn.call(directiveVisitors, directiveName)) return;
                var visitorClass = directiveVisitors[directiveName];
                // Avoid creating visitor objects if visitorClass does not override
                // the visitor method named by methodName.
                if (!visitorClass.implementsVisitorMethod(methodName)) return;
                var decl = declaredDirectives[directiveName];
                var args;
                if (decl) // If this directive was explicitly declared, use the declared
                // argument types (and any default values) to check, coerce, and/or
                // supply default values for the given arguments.
                args = $7dqoX.getArgumentValues(decl, directiveNode);
                else {
                    // If this directive was not explicitly declared, just convert the
                    // argument nodes to their corresponding JavaScript values.
                    args = Object.create(null);
                    directiveNode.arguments.forEach(function(arg) {
                        args[arg.name.value] = $303715b63bc39cec$var$valueFromASTUntyped(arg.value);
                    });
                }
                // As foretold in comments near the top of the visitSchemaDirectives
                // method, this is where instances of the SchemaDirectiveVisitor class
                // get created and assigned names. While subclasses could override the
                // constructor method, the constructor is marked as protected, so
                // these are the only arguments that will ever be passed.
                visitors.push(new visitorClass({
                    name: directiveName,
                    args: args,
                    visitedType: type,
                    schema: schema,
                    context: context
                }));
            });
            if (visitors.length > 0) visitors.forEach(function(visitor) {
                createdVisitors[visitor.name].push(visitor);
            });
            return visitors;
        }
        $303715b63bc39cec$var$visitSchema(schema, visitorSelector);
        // Automatically update any references to named schema types replaced
        // during the traversal, so implementors don't have to worry about that.
        $303715b63bc39cec$var$healSchema(schema);
        return createdVisitors;
    };
    SchemaDirectiveVisitor.getDeclaredDirectives = function(schema, directiveVisitors) {
        var declaredDirectives = Object.create(null);
        $303715b63bc39cec$var$each(schema.getDirectives(), function(decl) {
            declaredDirectives[decl.name] = decl;
        });
        // If the visitor subclass overrides getDirectiveDeclaration, and it
        // returns a non-null GraphQLDirective, use that instead of any directive
        // declared in the schema itself. Reasoning: if a SchemaDirectiveVisitor
        // goes to the trouble of implementing getDirectiveDeclaration, it should
        // be able to rely on that implementation.
        $303715b63bc39cec$var$each(directiveVisitors, function(visitorClass, directiveName) {
            var decl = visitorClass.getDirectiveDeclaration(directiveName, schema);
            if (decl) declaredDirectives[directiveName] = decl;
        });
        $303715b63bc39cec$var$each(declaredDirectives, function(decl, name) {
            if (!$303715b63bc39cec$var$hasOwn.call(directiveVisitors, name)) // SchemaDirectiveVisitors.visitSchemaDirectives might be called
            // multiple times with partial directiveVisitors maps, so it's not
            // necessarily an error for directiveVisitors to be missing an
            // implementation of a directive that was declared in the schema.
            return;
            var visitorClass = directiveVisitors[name];
            $303715b63bc39cec$var$each(decl.locations, function(loc) {
                var visitorMethodName = $303715b63bc39cec$var$directiveLocationToVisitorMethodName(loc);
                if ($303715b63bc39cec$var$SchemaVisitor.implementsVisitorMethod(visitorMethodName) && !visitorClass.implementsVisitorMethod(visitorMethodName)) // While visitor subclasses may implement extra visitor methods,
                // it's definitely a mistake if the GraphQLDirective declares itself
                // applicable to certain schema locations, and the visitor subclass
                // does not implement all the corresponding methods.
                throw new Error("SchemaDirectiveVisitor for @" + name + " must implement " + visitorMethodName + " method");
            });
        });
        return declaredDirectives;
    };
    return SchemaDirectiveVisitor;
}($303715b63bc39cec$var$SchemaVisitor);
module.exports.SchemaDirectiveVisitor = $303715b63bc39cec$var$SchemaDirectiveVisitor;
// Convert a string like "FIELD_DEFINITION" to "visitFieldDefinition".
function $303715b63bc39cec$var$directiveLocationToVisitorMethodName(loc) {
    return 'visit' + loc.replace(/([^_]*)_?/g, function(wholeMatch, part) {
        return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    });
}
function $303715b63bc39cec$var$each(arrayOrObject, callback) {
    Object.keys(arrayOrObject).forEach(function(key) {
        callback(arrayOrObject[key], key);
    });
}
// A more powerful version of each that has the ability to replace or remove
// array or object keys.
function $303715b63bc39cec$var$updateEachKey(arrayOrObject, // The callback can return nothing to leave the key untouched, null to remove
// the key from the array or object, or a non-null V to replace the value.
callback) {
    var deletedCount = 0;
    Object.keys(arrayOrObject).forEach(function(key) {
        var result = callback(arrayOrObject[key], key);
        if (typeof result === 'undefined') return;
        if (result === null) {
            delete arrayOrObject[key];
            deletedCount++;
            return;
        }
        arrayOrObject[key] = result;
    });
    if (deletedCount > 0 && Array.isArray(arrayOrObject)) // Remove any holes from the array due to deleted elements.
    arrayOrObject.splice(0).forEach(function(elem) {
        arrayOrObject.push(elem);
    });
}
// Similar to the graphql-js function of the same name, slightly simplified:
// https://github.com/graphql/graphql-js/blob/master/src/utilities/valueFromASTUntyped.js
function $303715b63bc39cec$var$valueFromASTUntyped(valueNode) {
    switch(valueNode.kind){
        case $bzIlO.Kind.NULL:
            return null;
        case $bzIlO.Kind.INT:
            return parseInt(valueNode.value, 10);
        case $bzIlO.Kind.FLOAT:
            return parseFloat(valueNode.value);
        case $bzIlO.Kind.STRING:
        case $bzIlO.Kind.ENUM:
        case $bzIlO.Kind.BOOLEAN:
            return valueNode.value;
        case $bzIlO.Kind.LIST:
            return valueNode.values.map($303715b63bc39cec$var$valueFromASTUntyped);
        case $bzIlO.Kind.OBJECT:
            var obj_1 = Object.create(null);
            valueNode.fields.forEach(function(field) {
                obj_1[field.name.value] = $303715b63bc39cec$var$valueFromASTUntyped(field.value);
            });
            return obj_1;
        /* istanbul ignore next */ default:
            throw new Error('Unexpected value kind: ' + valueNode.kind);
    }
}

});

parcelRegister("4Imtl", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $36ecb406f3832123$var$mergeDeep(target, source) {
    var output = Object.assign({}, target);
    if ($36ecb406f3832123$var$isObject(target) && $36ecb406f3832123$var$isObject(source)) Object.keys(source).forEach(function(key) {
        var _a, _b;
        if ($36ecb406f3832123$var$isObject(source[key])) {
            if (!(key in target)) Object.assign(output, (_a = {}, _a[key] = source[key], _a));
            else output[key] = $36ecb406f3832123$var$mergeDeep(target[key], source[key]);
        } else Object.assign(output, (_b = {}, _b[key] = source[key], _b));
    });
    return output;
}
module.exports.default = $36ecb406f3832123$var$mergeDeep;
function $36ecb406f3832123$var$isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}

});

parcelRegister("l9QLJ", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jfNiv = parcelRequire("jfNiv");
module.exports.addResolveFunctionsToSchema = $jfNiv.default;

var $eEIIZ = parcelRequire("eEIIZ");
module.exports.addSchemaLevelResolveFunction = $eEIIZ.default;

var $2cFOE = parcelRequire("2cFOE");
module.exports.assertResolveFunctionsPresent = $2cFOE.default;

var $6uSkr = parcelRequire("6uSkr");
module.exports.attachDirectiveResolvers = $6uSkr.default;

var $7QdUr = parcelRequire("7QdUr");
module.exports.attachConnectorsToContext = $7QdUr.default;

var $6VZNv = parcelRequire("6VZNv");
module.exports.buildSchemaFromTypeDefinitions = $6VZNv.default;

var $fZSSc = parcelRequire("fZSSc");
module.exports.chainResolvers = $fZSSc.chainResolvers;

var $3xw8r = parcelRequire("3xw8r");
module.exports.checkForResolveTypeResolver = $3xw8r.default;

var $7Bsga = parcelRequire("7Bsga");
module.exports.concatenateTypeDefs = $7Bsga.default;

var $3qMTx = parcelRequire("3qMTx");
module.exports.decorateWithLogger = $3qMTx.default;

var $gk7uh = parcelRequire("gk7uh");
module.exports.extendResolversFromInterfaces = $gk7uh.default;

var $cfI70 = parcelRequire("cfI70");
module.exports.extractExtensionDefinitions = $cfI70.default;

var $izDlb = parcelRequire("izDlb");
module.exports.forEachField = $izDlb.default;

var $5gUcG = parcelRequire("5gUcG");
module.exports.SchemaError = $5gUcG.default;

});
parcelRegister("jfNiv", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l9QLJ = parcelRequire("l9QLJ");

var $8oLgk = parcelRequire("8oLgk");
var $lUVCX = parcelRequire("lUVCX");

var $9CEZe = parcelRequire("9CEZe");

var $l9QLJ = parcelRequire("l9QLJ");

var $JUrSs = parcelRequire("JUrSs");
function $e045a8785573f7ad$var$addResolveFunctionsToSchema(options, legacyInputResolvers, legacyInputValidationOptions) {
    if (options instanceof $lUVCX.GraphQLSchema) {
        console.warn('The addResolveFunctionsToSchema function takes named options now; see IAddResolveFunctionsToSchemaOptions');
        options = {
            schema: options,
            resolvers: legacyInputResolvers,
            resolverValidationOptions: legacyInputValidationOptions
        };
    }
    var schema = options.schema, inputResolvers = options.resolvers, _a = options.resolverValidationOptions, resolverValidationOptions = _a === void 0 ? {} : _a, _b = options.inheritResolversFromInterfaces, inheritResolversFromInterfaces = _b === void 0 ? false : _b;
    var _c = resolverValidationOptions.allowResolversNotInSchema, allowResolversNotInSchema = _c === void 0 ? false : _c, requireResolversForResolveType = resolverValidationOptions.requireResolversForResolveType;
    var resolvers = inheritResolversFromInterfaces ? $l9QLJ.extendResolversFromInterfaces(schema, inputResolvers) : inputResolvers;
    // Used to map the external value of an enum to its internal value, when
    // that internal value is provided by a resolver.
    var enumValueMap = Object.create(null);
    Object.keys(resolvers).forEach(function(typeName) {
        var resolverValue = resolvers[typeName];
        var resolverType = typeof resolverValue;
        if (resolverType !== 'object' && resolverType !== 'function') throw new $l9QLJ.SchemaError("\"" + typeName + "\" defined in resolvers, but has invalid value \"" + resolverValue + "\". A resolver's value " + "must be of type object or function.");
        var type = schema.getType(typeName);
        if (!type && typeName !== '__schema') {
            if (allowResolversNotInSchema) return;
            throw new $l9QLJ.SchemaError("\"" + typeName + "\" defined in resolvers, but not in schema");
        }
        Object.keys(resolverValue).forEach(function(fieldName) {
            if (fieldName.startsWith('__')) {
                // this is for isTypeOf and resolveType and all the other stuff.
                type[fieldName.substring(2)] = resolverValue[fieldName];
                return;
            }
            if (type instanceof $8oLgk.GraphQLScalarType) {
                type[fieldName] = resolverValue[fieldName];
                return;
            }
            if (type instanceof $8oLgk.GraphQLEnumType) {
                if (!type.getValue(fieldName)) {
                    if (allowResolversNotInSchema) return;
                    throw new $l9QLJ.SchemaError(typeName + "." + fieldName + " was defined in resolvers, but enum is not in schema");
                }
                // We've encountered an enum resolver that is being used to provide an
                // internal enum value.
                // Reference: https://www.apollographql.com/docs/graphql-tools/scalars.html#internal-values
                //
                // We're storing a map of the current enums external facing value to
                // its resolver provided internal value. This map is used to transform
                // the current schema to a new schema that includes enums with the new
                // internal value.
                enumValueMap[type.name] = enumValueMap[type.name] || {};
                enumValueMap[type.name][fieldName] = resolverValue[fieldName];
                return;
            }
            // object type
            var fields = $e045a8785573f7ad$var$getFieldsForType(type);
            if (!fields) {
                if (allowResolversNotInSchema) return;
                throw new $l9QLJ.SchemaError(typeName + " was defined in resolvers, but it's not an object");
            }
            if (!fields[fieldName]) {
                if (allowResolversNotInSchema) return;
                throw new $l9QLJ.SchemaError(typeName + "." + fieldName + " defined in resolvers, but not in schema");
            }
            var field = fields[fieldName];
            var fieldResolve = resolverValue[fieldName];
            if (typeof fieldResolve === 'function') // for convenience. Allows shorter syntax in resolver definition file
            $e045a8785573f7ad$var$setFieldProperties(field, {
                resolve: fieldResolve
            });
            else {
                if (typeof fieldResolve !== 'object') throw new $l9QLJ.SchemaError("Resolver " + typeName + "." + fieldName + " must be object or function");
                $e045a8785573f7ad$var$setFieldProperties(field, fieldResolve);
            }
        });
    });
    $l9QLJ.checkForResolveTypeResolver(schema, requireResolversForResolveType);
    // If there are any enum resolver functions (that are used to return
    // internal enum values), create a new schema that includes enums with the
    // new internal facing values.
    var updatedSchema = $9CEZe.applySchemaTransforms(schema, [
        new $JUrSs.default(enumValueMap)
    ]);
    return updatedSchema;
}
function $e045a8785573f7ad$var$getFieldsForType(type) {
    if (type instanceof $8oLgk.GraphQLObjectType || type instanceof $8oLgk.GraphQLInterfaceType) return type.getFields();
    else return undefined;
}
function $e045a8785573f7ad$var$setFieldProperties(field, propertiesObj) {
    Object.keys(propertiesObj).forEach(function(propertyName) {
        field[propertyName] = propertiesObj[propertyName];
    });
}
module.exports.default = $e045a8785573f7ad$var$addResolveFunctionsToSchema;

});
parcelRegister("9CEZe", function(module, exports) {
var $701774c08b2cc58f$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $701774c08b2cc58f$var$applySchemaTransforms(originalSchema, transforms) {
    return transforms.reduce(function(schema, transform) {
        return transform.transformSchema ? transform.transformSchema(schema) : schema;
    }, originalSchema);
}
module.exports.applySchemaTransforms = $701774c08b2cc58f$var$applySchemaTransforms;
function $701774c08b2cc58f$var$applyRequestTransforms(originalRequest, transforms) {
    return transforms.reduce(function(request, transform) {
        return transform.transformRequest ? transform.transformRequest(request) : request;
    }, originalRequest);
}
module.exports.applyRequestTransforms = $701774c08b2cc58f$var$applyRequestTransforms;
function $701774c08b2cc58f$var$applyResultTransforms(originalResult, transforms) {
    return transforms.reduce(function(result, transform) {
        return transform.transformResult ? transform.transformResult(result) : result;
    }, originalResult);
}
module.exports.applyResultTransforms = $701774c08b2cc58f$var$applyResultTransforms;
function $701774c08b2cc58f$var$composeTransforms() {
    var transforms = [];
    for(var _i = 0; _i < arguments.length; _i++)transforms[_i] = arguments[_i];
    var reverseTransforms = $701774c08b2cc58f$var$__spreadArrays(transforms).reverse();
    return {
        transformSchema: function(originalSchema) {
            return $701774c08b2cc58f$var$applySchemaTransforms(originalSchema, transforms);
        },
        transformRequest: function(originalRequest) {
            return $701774c08b2cc58f$var$applyRequestTransforms(originalRequest, reverseTransforms);
        },
        transformResult: function(result) {
            return $701774c08b2cc58f$var$applyResultTransforms(result, reverseTransforms);
        }
    };
}
module.exports.composeTransforms = $701774c08b2cc58f$var$composeTransforms;

});

parcelRegister("JUrSs", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8oLgk = parcelRequire("8oLgk");

var $1e7FQ = parcelRequire("1e7FQ");
// Transformation used to modifiy `GraphQLEnumType` values in a schema.
var $089ffd9b7a105de6$var$ConvertEnumValues = /** @class */ function() {
    function ConvertEnumValues(enumValueMap) {
        this.enumValueMap = enumValueMap;
    }
    // Walk a schema looking for `GraphQLEnumType` types. If found, and
    // matching types have been identified in `this.enumValueMap`, create new
    // `GraphQLEnumType` types using the `this.enumValueMap` specified new
    // values, and return them in the new schema.
    ConvertEnumValues.prototype.transformSchema = function(schema) {
        var _a;
        var enumValueMap = this.enumValueMap;
        if (!enumValueMap || Object.keys(enumValueMap).length === 0) return schema;
        var transformedSchema = $1e7FQ.visitSchema(schema, (_a = {}, _a[$1e7FQ.VisitSchemaKind.ENUM_TYPE] = function(enumType) {
            var externalToInternalValueMap = enumValueMap[enumType.name];
            if (externalToInternalValueMap) {
                var values = enumType.getValues();
                var newValues_1 = {};
                values.forEach(function(value) {
                    var newValue = Object.keys(externalToInternalValueMap).includes(value.name) ? externalToInternalValueMap[value.name] : value.name;
                    newValues_1[value.name] = {
                        value: newValue,
                        deprecationReason: value.deprecationReason,
                        description: value.description,
                        astNode: value.astNode
                    };
                });
                return new $8oLgk.GraphQLEnumType({
                    name: enumType.name,
                    description: enumType.description,
                    astNode: enumType.astNode,
                    values: newValues_1
                });
            }
            return enumType;
        }, _a));
        return transformedSchema;
    };
    return ConvertEnumValues;
}();
module.exports.default = $089ffd9b7a105de6$var$ConvertEnumValues;

});
parcelRegister("1e7FQ", function(module, exports) {
var $0e4d0d21041b9ff9$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8oLgk = parcelRequire("8oLgk");
var $lUVCX = parcelRequire("lUVCX");

var $cPwLY = parcelRequire("cPwLY");
var $0e4d0d21041b9ff9$var$VisitSchemaKind;
(function(VisitSchemaKind) {
    VisitSchemaKind["TYPE"] = "VisitSchemaKind.TYPE";
    VisitSchemaKind["SCALAR_TYPE"] = "VisitSchemaKind.SCALAR_TYPE";
    VisitSchemaKind["ENUM_TYPE"] = "VisitSchemaKind.ENUM_TYPE";
    VisitSchemaKind["COMPOSITE_TYPE"] = "VisitSchemaKind.COMPOSITE_TYPE";
    VisitSchemaKind["OBJECT_TYPE"] = "VisitSchemaKind.OBJECT_TYPE";
    VisitSchemaKind["INPUT_OBJECT_TYPE"] = "VisitSchemaKind.INPUT_OBJECT_TYPE";
    VisitSchemaKind["ABSTRACT_TYPE"] = "VisitSchemaKind.ABSTRACT_TYPE";
    VisitSchemaKind["UNION_TYPE"] = "VisitSchemaKind.UNION_TYPE";
    VisitSchemaKind["INTERFACE_TYPE"] = "VisitSchemaKind.INTERFACE_TYPE";
    VisitSchemaKind["ROOT_OBJECT"] = "VisitSchemaKind.ROOT_OBJECT";
    VisitSchemaKind["QUERY"] = "VisitSchemaKind.QUERY";
    VisitSchemaKind["MUTATION"] = "VisitSchemaKind.MUTATION";
    VisitSchemaKind["SUBSCRIPTION"] = "VisitSchemaKind.SUBSCRIPTION";
})($0e4d0d21041b9ff9$var$VisitSchemaKind = module.exports.VisitSchemaKind || (module.exports.VisitSchemaKind = {}));
function $0e4d0d21041b9ff9$var$visitSchema(schema, visitor, stripResolvers) {
    var types = {};
    var resolveType = $cPwLY.createResolveType(function(name) {
        if (typeof types[name] === 'undefined') throw new Error("Can't find type " + name + ".");
        return types[name];
    });
    var queryType = schema.getQueryType();
    var mutationType = schema.getMutationType();
    var subscriptionType = schema.getSubscriptionType();
    var typeMap = schema.getTypeMap();
    Object.keys(typeMap).map(function(typeName) {
        var type = typeMap[typeName];
        if ($8oLgk.isNamedType(type) && $8oLgk.getNamedType(type).name.slice(0, 2) !== '__') {
            var specifiers = $0e4d0d21041b9ff9$var$getTypeSpecifiers(type, schema);
            var typeVisitor = $0e4d0d21041b9ff9$var$getVisitor(visitor, specifiers);
            if (typeVisitor) {
                var result = typeVisitor(type, schema);
                if (typeof result === 'undefined') types[typeName] = $cPwLY.recreateType(type, resolveType, !stripResolvers);
                else if (result === null) types[typeName] = null;
                else types[typeName] = $cPwLY.recreateType(result, resolveType, !stripResolvers);
            } else types[typeName] = $cPwLY.recreateType(type, resolveType, !stripResolvers);
        }
    });
    return new $lUVCX.GraphQLSchema({
        query: queryType ? types[queryType.name] : null,
        mutation: mutationType ? types[mutationType.name] : null,
        subscription: subscriptionType ? types[subscriptionType.name] : null,
        types: Object.keys(types).map(function(name) {
            return types[name];
        })
    });
}
module.exports.visitSchema = $0e4d0d21041b9ff9$var$visitSchema;
function $0e4d0d21041b9ff9$var$getTypeSpecifiers(type, schema) {
    var specifiers = [
        $0e4d0d21041b9ff9$var$VisitSchemaKind.TYPE
    ];
    if (type instanceof $8oLgk.GraphQLObjectType) {
        specifiers.unshift($0e4d0d21041b9ff9$var$VisitSchemaKind.COMPOSITE_TYPE, $0e4d0d21041b9ff9$var$VisitSchemaKind.OBJECT_TYPE);
        var query = schema.getQueryType();
        var mutation = schema.getMutationType();
        var subscription = schema.getSubscriptionType();
        if (type === query) specifiers.push($0e4d0d21041b9ff9$var$VisitSchemaKind.ROOT_OBJECT, $0e4d0d21041b9ff9$var$VisitSchemaKind.QUERY);
        else if (type === mutation) specifiers.push($0e4d0d21041b9ff9$var$VisitSchemaKind.ROOT_OBJECT, $0e4d0d21041b9ff9$var$VisitSchemaKind.MUTATION);
        else if (type === subscription) specifiers.push($0e4d0d21041b9ff9$var$VisitSchemaKind.ROOT_OBJECT, $0e4d0d21041b9ff9$var$VisitSchemaKind.SUBSCRIPTION);
    } else if (type instanceof $8oLgk.GraphQLInputObjectType) specifiers.push($0e4d0d21041b9ff9$var$VisitSchemaKind.INPUT_OBJECT_TYPE);
    else if (type instanceof $8oLgk.GraphQLInterfaceType) specifiers.push($0e4d0d21041b9ff9$var$VisitSchemaKind.COMPOSITE_TYPE, $0e4d0d21041b9ff9$var$VisitSchemaKind.ABSTRACT_TYPE, $0e4d0d21041b9ff9$var$VisitSchemaKind.INTERFACE_TYPE);
    else if (type instanceof $8oLgk.GraphQLUnionType) specifiers.push($0e4d0d21041b9ff9$var$VisitSchemaKind.COMPOSITE_TYPE, $0e4d0d21041b9ff9$var$VisitSchemaKind.ABSTRACT_TYPE, $0e4d0d21041b9ff9$var$VisitSchemaKind.UNION_TYPE);
    else if (type instanceof $8oLgk.GraphQLEnumType) specifiers.push($0e4d0d21041b9ff9$var$VisitSchemaKind.ENUM_TYPE);
    else if (type instanceof $8oLgk.GraphQLScalarType) specifiers.push($0e4d0d21041b9ff9$var$VisitSchemaKind.SCALAR_TYPE);
    return specifiers;
}
function $0e4d0d21041b9ff9$var$getVisitor(visitor, specifiers) {
    var typeVisitor = null;
    var stack = $0e4d0d21041b9ff9$var$__spreadArrays(specifiers);
    while(!typeVisitor && stack.length > 0){
        var next = stack.pop();
        typeVisitor = visitor[next];
    }
    return typeVisitor;
}

});
parcelRegister("cPwLY", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8oLgk = parcelRequire("8oLgk");
var $djKly = parcelRequire("djKly");
var $35Smo = parcelRequire("35Smo");
var $bzIlO = parcelRequire("bzIlO");

var $7qT3x = parcelRequire("7qT3x");

var $akAWC = parcelRequire("akAWC");

var $kptle = parcelRequire("kptle");
function $9573ab71d24e9252$var$recreateType(type, resolveType, keepResolvers) {
    if (type instanceof $8oLgk.GraphQLObjectType) {
        var fields_1 = type.getFields();
        var interfaces_1 = type.getInterfaces();
        return new $8oLgk.GraphQLObjectType({
            name: type.name,
            description: type.description,
            astNode: type.astNode,
            isTypeOf: keepResolvers ? type.isTypeOf : undefined,
            fields: function() {
                return $9573ab71d24e9252$var$fieldMapToFieldConfigMap(fields_1, resolveType, keepResolvers);
            },
            interfaces: function() {
                return interfaces_1.map(function(iface) {
                    return resolveType(iface);
                });
            }
        });
    } else if (type instanceof $8oLgk.GraphQLInterfaceType) {
        var fields_2 = type.getFields();
        return new $8oLgk.GraphQLInterfaceType({
            name: type.name,
            description: type.description,
            astNode: type.astNode,
            fields: function() {
                return $9573ab71d24e9252$var$fieldMapToFieldConfigMap(fields_2, resolveType, keepResolvers);
            },
            resolveType: keepResolvers ? type.resolveType : function(parent, context, info) {
                return $akAWC.default(parent, info.schema);
            }
        });
    } else if (type instanceof $8oLgk.GraphQLUnionType) return new $8oLgk.GraphQLUnionType({
        name: type.name,
        description: type.description,
        astNode: type.astNode,
        types: function() {
            return type.getTypes().map(function(unionMember) {
                return resolveType(unionMember);
            });
        },
        resolveType: keepResolvers ? type.resolveType : function(parent, context, info) {
            return $akAWC.default(parent, info.schema);
        }
    });
    else if (type instanceof $8oLgk.GraphQLInputObjectType) return new $8oLgk.GraphQLInputObjectType({
        name: type.name,
        description: type.description,
        astNode: type.astNode,
        fields: function() {
            return $9573ab71d24e9252$var$inputFieldMapToFieldConfigMap(type.getFields(), resolveType);
        }
    });
    else if (type instanceof $8oLgk.GraphQLEnumType) {
        var values = type.getValues();
        var newValues_1 = {};
        values.forEach(function(value) {
            newValues_1[value.name] = {
                value: value.value,
                deprecationReason: value.deprecationReason,
                description: value.description,
                astNode: value.astNode
            };
        });
        return new $8oLgk.GraphQLEnumType({
            name: type.name,
            description: type.description,
            astNode: type.astNode,
            values: newValues_1
        });
    } else if (type instanceof $8oLgk.GraphQLScalarType) {
        if (keepResolvers || $7qT3x.default(type)) return type;
        else return new $8oLgk.GraphQLScalarType({
            name: type.name,
            description: type.description,
            astNode: type.astNode,
            serialize: function(value) {
                return value;
            },
            parseValue: function(value) {
                return value;
            },
            parseLiteral: function(ast) {
                return $9573ab71d24e9252$var$parseLiteral(ast);
            }
        });
    } else throw new Error("Invalid type " + type);
}
module.exports.recreateType = $9573ab71d24e9252$var$recreateType;
function $9573ab71d24e9252$var$recreateDirective(directive, resolveType) {
    return new $35Smo.GraphQLDirective({
        name: directive.name,
        description: directive.description,
        locations: directive.locations,
        args: $9573ab71d24e9252$var$argsToFieldConfigArgumentMap(directive.args, resolveType),
        astNode: directive.astNode
    });
}
module.exports.recreateDirective = $9573ab71d24e9252$var$recreateDirective;
function $9573ab71d24e9252$var$parseLiteral(ast) {
    switch(ast.kind){
        case $bzIlO.Kind.STRING:
        case $bzIlO.Kind.BOOLEAN:
            return ast.value;
        case $bzIlO.Kind.INT:
        case $bzIlO.Kind.FLOAT:
            return parseFloat(ast.value);
        case $bzIlO.Kind.OBJECT:
            var value_1 = Object.create(null);
            ast.fields.forEach(function(field) {
                value_1[field.name.value] = $9573ab71d24e9252$var$parseLiteral(field.value);
            });
            return value_1;
        case $bzIlO.Kind.LIST:
            return ast.values.map($9573ab71d24e9252$var$parseLiteral);
        default:
            return null;
    }
}
function $9573ab71d24e9252$var$fieldMapToFieldConfigMap(fields, resolveType, keepResolvers) {
    var result = {};
    Object.keys(fields).forEach(function(name) {
        var field = fields[name];
        var type = resolveType(field.type);
        if (type !== null) result[name] = $9573ab71d24e9252$var$fieldToFieldConfig(fields[name], resolveType, keepResolvers);
    });
    return result;
}
module.exports.fieldMapToFieldConfigMap = $9573ab71d24e9252$var$fieldMapToFieldConfigMap;
function $9573ab71d24e9252$var$createResolveType(getType) {
    var resolveType = function(type) {
        if (type instanceof $8oLgk.GraphQLList) {
            var innerType = resolveType(type.ofType);
            if (innerType === null) return null;
            else return new $8oLgk.GraphQLList(innerType);
        } else if (type instanceof $8oLgk.GraphQLNonNull) {
            var innerType = resolveType(type.ofType);
            if (innerType === null) return null;
            else return new $8oLgk.GraphQLNonNull(innerType);
        } else if ($8oLgk.isNamedType(type)) {
            var typeName = $8oLgk.getNamedType(type).name;
            switch(typeName){
                case $djKly.GraphQLInt.name:
                    return $djKly.GraphQLInt;
                case $djKly.GraphQLFloat.name:
                    return $djKly.GraphQLFloat;
                case $djKly.GraphQLString.name:
                    return $djKly.GraphQLString;
                case $djKly.GraphQLBoolean.name:
                    return $djKly.GraphQLBoolean;
                case $djKly.GraphQLID.name:
                    return $djKly.GraphQLID;
                default:
                    return getType(typeName, type);
            }
        } else return type;
    };
    return resolveType;
}
module.exports.createResolveType = $9573ab71d24e9252$var$createResolveType;
function $9573ab71d24e9252$var$fieldToFieldConfig(field, resolveType, keepResolvers) {
    return {
        type: resolveType(field.type),
        args: $9573ab71d24e9252$var$argsToFieldConfigArgumentMap(field.args, resolveType),
        resolve: keepResolvers ? field.resolve : $kptle.default,
        subscribe: keepResolvers ? field.subscribe : null,
        description: field.description,
        deprecationReason: field.deprecationReason,
        astNode: field.astNode
    };
}
module.exports.fieldToFieldConfig = $9573ab71d24e9252$var$fieldToFieldConfig;
function $9573ab71d24e9252$var$argsToFieldConfigArgumentMap(args, resolveType) {
    var result = {};
    args.forEach(function(arg) {
        var newArg = $9573ab71d24e9252$var$argumentToArgumentConfig(arg, resolveType);
        if (newArg) result[newArg[0]] = newArg[1];
    });
    return result;
}
module.exports.argsToFieldConfigArgumentMap = $9573ab71d24e9252$var$argsToFieldConfigArgumentMap;
function $9573ab71d24e9252$var$argumentToArgumentConfig(argument, resolveType) {
    var type = resolveType(argument.type);
    if (type === null) return null;
    else return [
        argument.name,
        {
            type: type,
            defaultValue: argument.defaultValue,
            description: argument.description
        }
    ];
}
module.exports.argumentToArgumentConfig = $9573ab71d24e9252$var$argumentToArgumentConfig;
function $9573ab71d24e9252$var$inputFieldMapToFieldConfigMap(fields, resolveType) {
    var result = {};
    Object.keys(fields).forEach(function(name) {
        var field = fields[name];
        var type = resolveType(field.type);
        if (type !== null) result[name] = $9573ab71d24e9252$var$inputFieldToFieldConfig(fields[name], resolveType);
    });
    return result;
}
module.exports.inputFieldMapToFieldConfigMap = $9573ab71d24e9252$var$inputFieldMapToFieldConfigMap;
function $9573ab71d24e9252$var$inputFieldToFieldConfig(field, resolveType) {
    return {
        type: resolveType(field.type),
        defaultValue: field.defaultValue,
        description: field.description,
        astNode: field.astNode
    };
}
module.exports.inputFieldToFieldConfig = $9573ab71d24e9252$var$inputFieldToFieldConfig;

});
parcelRegister("7qT3x", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $djKly = parcelRequire("djKly");
var $8oLgk = parcelRequire("8oLgk");
// FIXME: Replace with https://github.com/graphql/graphql-js/blob/master/src/type/scalars.js#L139
module.exports.specifiedScalarTypes = [
    $djKly.GraphQLString,
    $djKly.GraphQLInt,
    $djKly.GraphQLFloat,
    $djKly.GraphQLBoolean,
    $djKly.GraphQLID
];
function $5695ab17b574f1df$var$isSpecifiedScalarType(type) {
    return $8oLgk.isNamedType(type) && // Would prefer to use specifiedScalarTypes.some(), however %checks needs
    // a simple expression.
    (type.name === $djKly.GraphQLString.name || type.name === $djKly.GraphQLInt.name || type.name === $djKly.GraphQLFloat.name || type.name === $djKly.GraphQLBoolean.name || type.name === $djKly.GraphQLID.name);
}
module.exports.default = $5695ab17b574f1df$var$isSpecifiedScalarType;

});

parcelRegister("akAWC", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8oLgk = parcelRequire("8oLgk");
function $78586e0882c00923$var$resolveFromParentTypename(parent, schema) {
    var parentTypename = parent['__typename'];
    if (!parentTypename) throw new Error('Did not fetch typename for object, unable to resolve interface.');
    var resolvedType = schema.getType(parentTypename);
    if (!(resolvedType instanceof $8oLgk.GraphQLObjectType)) throw new Error('__typename did not match an object type: ' + parentTypename);
    return resolvedType;
}
module.exports.default = $78586e0882c00923$var$resolveFromParentTypename;

});

parcelRegister("kptle", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hEo2F = parcelRequire("hEo2F");

var $csEv9 = parcelRequire("csEv9");

var $2JIWi = parcelRequire("2JIWi");

var $fqJQz = parcelRequire("fqJQz");
// Resolver that knows how to:
// a) handle aliases for proxied schemas
// b) handle errors from proxied schemas
var $edbce70fe578bc16$var$defaultMergedResolver = function(parent, args, context, info) {
    if (!parent) return null;
    var responseKey = $fqJQz.getResponseKeyFromInfo(info);
    var errorResult = $2JIWi.getErrorsFromParent(parent, responseKey);
    if (errorResult.kind === 'OWN') throw $csEv9.locatedError(new Error(errorResult.error.message), info.fieldNodes, $hEo2F.pathToArray(info.path));
    var result = parent[responseKey];
    if (result == null) result = parent[info.fieldName];
    // subscription result mapping
    if (!result && parent.data && parent.data[responseKey]) result = parent.data[responseKey];
    if (errorResult.errors) result = $2JIWi.annotateWithChildrenErrors(result, errorResult.errors);
    return result;
};
module.exports.default = $edbce70fe578bc16$var$defaultMergedResolver;

});
parcelRegister("2JIWi", function(module, exports) {
var $1fe2a4bd62c0a6a2$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $1fe2a4bd62c0a6a2$var$__assign = module.exports && module.exports.__assign || function() {
    $1fe2a4bd62c0a6a2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1fe2a4bd62c0a6a2$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hEo2F = parcelRequire("hEo2F");

var $csEv9 = parcelRequire("csEv9");

var $fqJQz = parcelRequire("fqJQz");
if (typeof $parcel$global !== 'undefined' && 'Symbol' in $parcel$global || typeof window !== 'undefined' && 'Symbol' in window) module.exports.ERROR_SYMBOL = Symbol('subSchemaErrors');
else module.exports.ERROR_SYMBOL = '@@__subSchemaErrors';
function $1fe2a4bd62c0a6a2$var$annotateWithChildrenErrors(object, childrenErrors) {
    var _a;
    if (!childrenErrors || childrenErrors.length === 0) // Nothing to see here, move along
    return object;
    if (Array.isArray(object)) {
        var byIndex_1 = {};
        childrenErrors.forEach(function(error) {
            if (!error.path) return;
            var index = error.path[1];
            var current = byIndex_1[index] || [];
            current.push($1fe2a4bd62c0a6a2$var$__assign($1fe2a4bd62c0a6a2$var$__assign({}, error), {
                path: error.path.slice(1)
            }));
            byIndex_1[index] = current;
        });
        return object.map(function(item, index) {
            return $1fe2a4bd62c0a6a2$var$annotateWithChildrenErrors(item, byIndex_1[index]);
        });
    }
    return $1fe2a4bd62c0a6a2$var$__assign($1fe2a4bd62c0a6a2$var$__assign({}, object), (_a = {}, _a[module.exports.ERROR_SYMBOL] = childrenErrors.map(function(error) {
        return $1fe2a4bd62c0a6a2$var$__assign($1fe2a4bd62c0a6a2$var$__assign({}, error), error.path ? {
            path: error.path.slice(1)
        } : {});
    }), _a));
}
module.exports.annotateWithChildrenErrors = $1fe2a4bd62c0a6a2$var$annotateWithChildrenErrors;
function $1fe2a4bd62c0a6a2$var$getErrorsFromParent(object, fieldName) {
    var errors = object && object[module.exports.ERROR_SYMBOL] || [];
    var childrenErrors = [];
    for(var _i = 0, errors_1 = errors; _i < errors_1.length; _i++){
        var error = errors_1[_i];
        if (!error.path || error.path.length === 1 && error.path[0] === fieldName) return {
            kind: 'OWN',
            error: error
        };
        else if (error.path[0] === fieldName) childrenErrors.push(error);
    }
    return {
        kind: 'CHILDREN',
        errors: childrenErrors
    };
}
module.exports.getErrorsFromParent = $1fe2a4bd62c0a6a2$var$getErrorsFromParent;
var $1fe2a4bd62c0a6a2$var$CombinedError = /** @class */ function(_super) {
    $1fe2a4bd62c0a6a2$var$__extends(CombinedError, _super);
    function CombinedError(message, errors) {
        var _this = _super.call(this, message) || this;
        _this.errors = errors;
        return _this;
    }
    return CombinedError;
}(Error);
function $1fe2a4bd62c0a6a2$var$checkResultAndHandleErrors(result, info, responseKey) {
    if (!responseKey) responseKey = $fqJQz.getResponseKeyFromInfo(info);
    if (result.errors && (!result.data || result.data[responseKey] == null)) {
        // apollo-link-http & http-link-dataloader need the
        // result property to be passed through for better error handling.
        // If there is only one error, which contains a result property, pass the error through
        var newError = result.errors.length === 1 && $1fe2a4bd62c0a6a2$var$hasResult(result.errors[0]) ? result.errors[0] : new $1fe2a4bd62c0a6a2$var$CombinedError($1fe2a4bd62c0a6a2$var$concatErrors(result.errors), result.errors);
        throw $csEv9.locatedError(newError, info.fieldNodes, $hEo2F.pathToArray(info.path));
    }
    var resultObject = result.data[responseKey];
    if (result.errors) resultObject = $1fe2a4bd62c0a6a2$var$annotateWithChildrenErrors(resultObject, result.errors);
    return resultObject;
}
module.exports.checkResultAndHandleErrors = $1fe2a4bd62c0a6a2$var$checkResultAndHandleErrors;
function $1fe2a4bd62c0a6a2$var$concatErrors(errors) {
    return errors.map(function(error) {
        return error.message;
    }).join('\n');
}
function $1fe2a4bd62c0a6a2$var$hasResult(error) {
    return error.result || error.extensions || error.originalError && error.originalError.result;
}

});
parcelRegister("fqJQz", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Get the key under which the result of this resolver will be placed in the response JSON. Basically, just
 * resolves aliases.
 * @param info The info argument to the resolver.
 */ function $b3bcd8f78f765cb3$var$getResponseKeyFromInfo(info) {
    return info.fieldNodes[0].alias ? info.fieldNodes[0].alias.value : info.fieldName;
}
module.exports.getResponseKeyFromInfo = $b3bcd8f78f765cb3$var$getResponseKeyFromInfo;

});







parcelRegister("eEIIZ", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $mP8zZ = parcelRequire("mP8zZ");
// wraps all resolve functions of query, mutation or subscription fields
// with the provided function to simulate a root schema level resolve funciton
function $aab77e808c96b318$var$addSchemaLevelResolveFunction(schema, fn) {
    // TODO test that schema is a schema, fn is a function
    var rootTypes = [
        schema.getQueryType(),
        schema.getMutationType(),
        schema.getSubscriptionType()
    ].filter(function(x) {
        return !!x;
    });
    rootTypes.forEach(function(type) {
        // XXX this should run at most once per request to simulate a true root resolver
        // for graphql-js this is an approximation that works with queries but not mutations
        var rootResolveFn = $aab77e808c96b318$var$runAtMostOncePerRequest(fn);
        var fields = type.getFields();
        Object.keys(fields).forEach(function(fieldName) {
            // XXX if the type is a subscription, a same query AST will be ran multiple times so we
            // deactivate here the runOnce if it's a subscription. This may not be optimal though...
            if (type === schema.getSubscriptionType()) fields[fieldName].resolve = $aab77e808c96b318$var$wrapResolver(fields[fieldName].resolve, fn);
            else fields[fieldName].resolve = $aab77e808c96b318$var$wrapResolver(fields[fieldName].resolve, rootResolveFn);
        });
    });
}
// XXX badly named function. this doesn't really wrap, it just chains resolvers...
function $aab77e808c96b318$var$wrapResolver(innerResolver, outerResolver) {
    return function(obj, args, ctx, info) {
        return Promise.resolve(outerResolver(obj, args, ctx, info)).then(function(root) {
            if (innerResolver) return innerResolver(root, args, ctx, info);
            return $mP8zZ.defaultFieldResolver(root, args, ctx, info);
        });
    };
}
// XXX this function only works for resolvers
// XXX very hacky way to remember if the function
// already ran for this request. This will only work
// if people don't actually cache the operation.
// if they do cache the operation, they will have to
// manually remove the __runAtMostOnce before every request.
function $aab77e808c96b318$var$runAtMostOncePerRequest(fn) {
    var value;
    var randomNumber = Math.random();
    return function(root, args, ctx, info) {
        if (!info.operation['__runAtMostOnce']) info.operation['__runAtMostOnce'] = {};
        if (!info.operation['__runAtMostOnce'][randomNumber]) {
            info.operation['__runAtMostOnce'][randomNumber] = true;
            value = fn(root, args, ctx, info);
        }
        return value;
    };
}
module.exports.default = $aab77e808c96b318$var$addSchemaLevelResolveFunction;

});

parcelRegister("2cFOE", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8oLgk = parcelRequire("8oLgk");

var $l9QLJ = parcelRequire("l9QLJ");
function $19ad2383c183403f$var$assertResolveFunctionsPresent(schema, resolverValidationOptions) {
    if (resolverValidationOptions === void 0) resolverValidationOptions = {};
    var _a = resolverValidationOptions.requireResolversForArgs, requireResolversForArgs = _a === void 0 ? false : _a, _b = resolverValidationOptions.requireResolversForNonScalar, requireResolversForNonScalar = _b === void 0 ? false : _b, _c = resolverValidationOptions.requireResolversForAllFields, requireResolversForAllFields = _c === void 0 ? false : _c;
    if (requireResolversForAllFields && (requireResolversForArgs || requireResolversForNonScalar)) throw new TypeError("requireResolversForAllFields takes precedence over the more specific assertions. Please configure either requireResolversForAllFields or requireResolversForArgs / requireResolversForNonScalar, but not a combination of them.");
    $l9QLJ.forEachField(schema, function(field, typeName, fieldName) {
        // requires a resolve function for *every* field.
        if (requireResolversForAllFields) $19ad2383c183403f$var$expectResolveFunction(field, typeName, fieldName);
        // requires a resolve function on every field that has arguments
        if (requireResolversForArgs && field.args.length > 0) $19ad2383c183403f$var$expectResolveFunction(field, typeName, fieldName);
        // requires a resolve function on every field that returns a non-scalar type
        if (requireResolversForNonScalar && !($8oLgk.getNamedType(field.type) instanceof $8oLgk.GraphQLScalarType)) $19ad2383c183403f$var$expectResolveFunction(field, typeName, fieldName);
    });
}
function $19ad2383c183403f$var$expectResolveFunction(field, typeName, fieldName) {
    if (!field.resolve) {
        console.warn(// tslint:disable-next-line: max-line-length
        "Resolve function missing for \"" + typeName + "." + fieldName + "\". To disable this warning check https://github.com/apollostack/graphql-tools/issues/131");
        return;
    }
    if (typeof field.resolve !== 'function') throw new $l9QLJ.SchemaError("Resolver \"" + typeName + "." + fieldName + "\" must be a function");
}
module.exports.default = $19ad2383c183403f$var$assertResolveFunctionsPresent;

});

parcelRegister("6uSkr", function(module, exports) {
var $4bafaff7912ca240$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4bafaff7912ca240$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4bafaff7912ca240$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $mP8zZ = parcelRequire("mP8zZ");

var $48EbR = parcelRequire("48EbR");
function $4bafaff7912ca240$var$attachDirectiveResolvers(schema, directiveResolvers) {
    if (typeof directiveResolvers !== 'object') throw new Error("Expected directiveResolvers to be of type object, got " + typeof directiveResolvers);
    if (Array.isArray(directiveResolvers)) throw new Error('Expected directiveResolvers to be of type object, got Array');
    var schemaDirectives = Object.create(null);
    Object.keys(directiveResolvers).forEach(function(directiveName) {
        schemaDirectives[directiveName] = /** @class */ function(_super) {
            $4bafaff7912ca240$var$__extends(class_1, _super);
            function class_1() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            class_1.prototype.visitFieldDefinition = function(field) {
                var _this = this;
                var resolver = directiveResolvers[directiveName];
                var originalResolver = field.resolve || $mP8zZ.defaultFieldResolver;
                var directiveArgs = this.args;
                field.resolve = function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var source = args[0], context = args[2], info = args[3];
                    return resolver(function() {
                        return $4bafaff7912ca240$var$__awaiter(_this, void 0, void 0, function() {
                            return $4bafaff7912ca240$var$__generator(this, function(_a) {
                                return [
                                    2 /*return*/ ,
                                    originalResolver.apply(field, args)
                                ];
                            });
                        });
                    }, source, directiveArgs, context, info);
                };
            };
            return class_1;
        }($48EbR.SchemaDirectiveVisitor);
    });
    $48EbR.SchemaDirectiveVisitor.visitSchemaDirectives(schema, schemaDirectives);
}
module.exports.default = $4bafaff7912ca240$var$attachDirectiveResolvers;

});

parcelRegister("7QdUr", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lUVCX = parcelRequire("lUVCX");

var $dmeHw = parcelRequire("dmeHw");

var $l9QLJ = parcelRequire("l9QLJ");
// takes a GraphQL-JS schema and an object of connectors, then attaches
// the connectors to the context by wrapping each query or mutation resolve
// function with a function that attaches connectors if they don't exist.
// attaches connectors only once to make sure they are singletons
var $5b582dd7d9bb943b$var$attachConnectorsToContext = $dmeHw.deprecated({
    version: '0.7.0',
    url: 'https://github.com/apollostack/graphql-tools/issues/140'
}, function(schema, connectors) {
    if (!schema || !(schema instanceof $lUVCX.GraphQLSchema)) throw new Error("schema must be an instance of GraphQLSchema. This error could be caused by installing more than one version of GraphQL-JS");
    if (typeof connectors !== 'object') {
        var connectorType = typeof connectors;
        throw new Error("Expected connectors to be of type object, got " + connectorType);
    }
    if (Object.keys(connectors).length === 0) throw new Error('Expected connectors to not be an empty object');
    if (Array.isArray(connectors)) throw new Error('Expected connectors to be of type object, got Array');
    if (schema['_apolloConnectorsAttached']) throw new Error('Connectors already attached to context, cannot attach more than once');
    schema['_apolloConnectorsAttached'] = true;
    var attachconnectorFn = function(root, args, ctx) {
        if (typeof ctx !== 'object') {
            // if in any way possible, we should throw an error when the attachconnectors
            // function is called, not when a query is executed.
            var contextType = typeof ctx;
            throw new Error("Cannot attach connector because context is not an object: " + contextType);
        }
        if (typeof ctx.connectors === 'undefined') ctx.connectors = {};
        Object.keys(connectors).forEach(function(connectorName) {
            var connector = connectors[connectorName];
            if (!!connector.prototype) ctx.connectors[connectorName] = new connector(ctx);
            else throw new Error("Connector must be a function or an class");
        });
        return root;
    };
    $l9QLJ.addSchemaLevelResolveFunction(schema, attachconnectorFn);
});
module.exports.default = $5b582dd7d9bb943b$var$attachConnectorsToContext;

});
parcelRegister("dmeHw", function(module, exports) {
/*
    Deprecated Decorator v0.1
    https://github.com/vilic/deprecated-decorator
*/ "use strict";
/** @internal */ module.exports.options = {
    getWarner: undefined
};
function $9b98bbbf098f27a5$var$createWarner(type, name, alternative, version, url) {
    var warnedPositions = {};
    return function() {
        var stack = new Error().stack || '';
        var at = (stack.match(/(?:\s+at\s.+){2}\s+at\s(.+)/) || [
            undefined,
            ''
        ])[1];
        if (/\)$/.test(at)) at = at.match(/[^(]+(?=\)$)/)[0];
        else at = at.trim();
        if (at in warnedPositions) return;
        warnedPositions[at] = true;
        var message;
        switch(type){
            case 'class':
                message = 'Class';
                break;
            case 'property':
                message = 'Property';
                break;
            case 'method':
                message = 'Method';
                break;
            case 'function':
                message = 'Function';
                break;
        }
        message += " `" + name + "` has been deprecated";
        if (version) message += " since version " + version;
        if (alternative) message += ", use `" + alternative + "` instead";
        message += '.';
        if (at) message += "\n    at " + at;
        if (url) message += "\nCheck out " + url + " for more information.";
        console.warn(message);
    };
}
function $9b98bbbf098f27a5$var$decorateProperty(type, name, descriptor, alternative, version, url) {
    var warner = (module.exports.options.getWarner || $9b98bbbf098f27a5$var$createWarner)(type, name, alternative, version, url);
    descriptor = descriptor || {
        writable: true,
        enumerable: false,
        configurable: true
    };
    var deprecatedDescriptor = {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable
    };
    if (descriptor.get || descriptor.set) {
        if (descriptor.get) deprecatedDescriptor.get = function() {
            warner();
            return descriptor.get.call(this);
        };
        if (descriptor.set) deprecatedDescriptor.set = function(value) {
            warner();
            return descriptor.set.call(this, value);
        };
    } else {
        var propertyValue_1 = descriptor.value;
        deprecatedDescriptor.get = function() {
            warner();
            return propertyValue_1;
        };
        if (descriptor.writable) deprecatedDescriptor.set = function(value) {
            warner();
            propertyValue_1 = value;
        };
    }
    return deprecatedDescriptor;
}
function $9b98bbbf098f27a5$var$decorateFunction(type, target, alternative, version, url) {
    var name = target.name;
    var warner = (module.exports.options.getWarner || $9b98bbbf098f27a5$var$createWarner)(type, name, alternative, version, url);
    var fn = function() {
        warner();
        return target.apply(this, arguments);
    };
    for(var _i = 0, _a = Object.getOwnPropertyNames(target); _i < _a.length; _i++){
        var propertyName = _a[_i];
        var descriptor = Object.getOwnPropertyDescriptor(target, propertyName);
        if (descriptor.writable) fn[propertyName] = target[propertyName];
        else if (descriptor.configurable) Object.defineProperty(fn, propertyName, descriptor);
    }
    return fn;
}
function $9b98bbbf098f27a5$var$deprecated() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
    var fn = args[args.length - 1];
    if (typeof fn === 'function') fn = args.pop();
    else fn = undefined;
    var options = args[0];
    var alternative;
    var version;
    var url;
    if (typeof options === 'string') {
        alternative = options;
        version = args[1];
        url = args[2];
    } else if (options) alternative = options.alternative, version = options.version, url = options.url, options;
    if (fn) return $9b98bbbf098f27a5$var$decorateFunction('function', fn, alternative, version, url);
    return function(target, name, descriptor) {
        if (typeof name === 'string') {
            var type = descriptor && typeof descriptor.value === 'function' ? 'method' : 'property';
            return $9b98bbbf098f27a5$var$decorateProperty(type, name, descriptor, alternative, version, url);
        } else if (typeof target === 'function') {
            var constructor = $9b98bbbf098f27a5$var$decorateFunction('class', target, alternative, version, url);
            var className = target.name;
            for(var _i = 0, _a = Object.getOwnPropertyNames(constructor); _i < _a.length; _i++){
                var propertyName = _a[_i];
                var descriptor_1 = Object.getOwnPropertyDescriptor(constructor, propertyName);
                descriptor_1 = $9b98bbbf098f27a5$var$decorateProperty('class', className, descriptor_1, alternative, version, url);
                if (descriptor_1.writable) constructor[propertyName] = target[propertyName];
                else if (descriptor_1.configurable) Object.defineProperty(constructor, propertyName, descriptor_1);
            }
            return constructor;
        }
    };
}
module.exports.deprecated = $9b98bbbf098f27a5$var$deprecated;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9b98bbbf098f27a5$var$deprecated;

});


parcelRegister("6VZNv", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dQXZA = parcelRequire("dQXZA");
var $8mJYM = parcelRequire("8mJYM");
var $8uUC9 = parcelRequire("8uUC9");

var $l9QLJ = parcelRequire("l9QLJ");

var $b06Gv = parcelRequire("b06Gv");
function $50c800a4e928dc15$var$buildSchemaFromTypeDefinitions(typeDefinitions, parseOptions) {
    // TODO: accept only array here, otherwise interfaces get confusing.
    var myDefinitions = typeDefinitions;
    var astDocument;
    if ($50c800a4e928dc15$var$isDocumentNode(typeDefinitions)) astDocument = typeDefinitions;
    else if (typeof myDefinitions !== 'string') {
        if (!Array.isArray(myDefinitions)) {
            var type = typeof myDefinitions;
            throw new $l9QLJ.SchemaError("typeDefs must be a string, array or schema AST, got " + type);
        }
        myDefinitions = $l9QLJ.concatenateTypeDefs(myDefinitions);
    }
    if (typeof myDefinitions === 'string') astDocument = $8uUC9.parse(myDefinitions, parseOptions);
    var backcompatOptions = {
        commentDescriptions: true
    };
    var typesAst = $b06Gv.default(astDocument);
    // TODO fix types https://github.com/apollographql/graphql-tools/issues/542
    var schema = $dQXZA.buildASTSchema(typesAst, backcompatOptions);
    var extensionsAst = $l9QLJ.extractExtensionDefinitions(astDocument);
    if (extensionsAst.definitions.length > 0) // TODO fix types https://github.com/apollographql/graphql-tools/issues/542
    schema = $8mJYM.extendSchema(schema, extensionsAst, backcompatOptions);
    return schema;
}
function $50c800a4e928dc15$var$isDocumentNode(typeDefinitions) {
    return typeDefinitions.kind !== undefined;
}
module.exports.default = $50c800a4e928dc15$var$buildSchemaFromTypeDefinitions;

});
parcelRegister("dQXZA", function(module, exports) {

$parcel$export(module.exports, "buildASTSchema", () => $a15eaae627e0015f$export$25eeb85cb306d87);
$parcel$export(module.exports, "buildSchema", () => $a15eaae627e0015f$export$f668ee82107a74bd);

var $a1qmV = parcelRequire("a1qmV");

var $bzIlO = parcelRequire("bzIlO");

var $8uUC9 = parcelRequire("8uUC9");

var $c6jur = parcelRequire("c6jur");

var $lUVCX = parcelRequire("lUVCX");

var $35Smo = parcelRequire("35Smo");

var $8mJYM = parcelRequire("8mJYM");
function $a15eaae627e0015f$export$25eeb85cb306d87(documentAST, options) {
    documentAST != null && documentAST.kind === (0, $bzIlO.Kind).DOCUMENT || (0, $a1qmV.default)(0, 'Must provide valid Document AST.');
    if ((options === null || options === void 0 ? void 0 : options.assumeValid) !== true && (options === null || options === void 0 ? void 0 : options.assumeValidSDL) !== true) (0, $c6jur.assertValidSDL)(documentAST);
    var emptySchemaConfig = {
        description: undefined,
        types: [],
        directives: [],
        extensions: undefined,
        extensionASTNodes: [],
        assumeValid: false
    };
    var config = (0, $8mJYM.extendSchemaImpl)(emptySchemaConfig, documentAST, options);
    if (config.astNode == null) for(var _i2 = 0, _config$types2 = config.types; _i2 < _config$types2.length; _i2++){
        var type = _config$types2[_i2];
        switch(type.name){
            // Note: While this could make early assertions to get the correctly
            // typed values below, that would throw immediately while type system
            // validation with validateSchema() will produce more actionable results.
            case 'Query':
                config.query = type;
                break;
            case 'Mutation':
                config.mutation = type;
                break;
            case 'Subscription':
                config.subscription = type;
                break;
        }
    }
    var directives = config.directives; // If specified directives were not explicitly declared, add them.
    var _loop = function _loop(_i4) {
        var stdDirective = (0, $35Smo.specifiedDirectives)[_i4];
        if (directives.every(function(directive) {
            return directive.name !== stdDirective.name;
        })) directives.push(stdDirective);
    };
    for(var _i4 = 0; _i4 < (0, $35Smo.specifiedDirectives).length; _i4++)_loop(_i4);
    return new (0, $lUVCX.GraphQLSchema)(config);
}
function $a15eaae627e0015f$export$f668ee82107a74bd(source, options) {
    var document = (0, $8uUC9.parse)(source, {
        noLocation: options === null || options === void 0 ? void 0 : options.noLocation,
        allowLegacySDLEmptyFields: options === null || options === void 0 ? void 0 : options.allowLegacySDLEmptyFields,
        allowLegacySDLImplementsInterfaces: options === null || options === void 0 ? void 0 : options.allowLegacySDLImplementsInterfaces,
        experimentalFragmentVariables: options === null || options === void 0 ? void 0 : options.experimentalFragmentVariables
    });
    return $a15eaae627e0015f$export$25eeb85cb306d87(document, {
        commentDescriptions: options === null || options === void 0 ? void 0 : options.commentDescriptions,
        assumeValidSDL: options === null || options === void 0 ? void 0 : options.assumeValidSDL,
        assumeValid: options === null || options === void 0 ? void 0 : options.assumeValid
    });
}

});
parcelRegister("c6jur", function(module, exports) {

$parcel$export(module.exports, "validate", () => $8cf529db72906245$export$a22775fa5e2eebd9);
$parcel$export(module.exports, "assertValidSDL", () => $8cf529db72906245$export$e53e4d7168bd6d92);
$parcel$export(module.exports, "assertValidSDLExtension", () => $8cf529db72906245$export$9917845776f624a4);

var $a1qmV = parcelRequire("a1qmV");

var $g5yZB = parcelRequire("g5yZB");

var $12QNw = parcelRequire("12QNw");

var $bKGOe = parcelRequire("bKGOe");

var $jjG8c = parcelRequire("jjG8c");

var $1W847 = parcelRequire("1W847");

var $1zF5q = parcelRequire("1zF5q");
function $8cf529db72906245$export$a22775fa5e2eebd9(schema, documentAST) {
    var rules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $1W847.specifiedRules);
    var typeInfo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new (0, $jjG8c.TypeInfo)(schema);
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        maxErrors: undefined
    };
    documentAST || (0, $a1qmV.default)(0, 'Must provide document.'); // If the schema used for validation is invalid, throw an error.
    (0, $bKGOe.assertValidSchema)(schema);
    var abortObj = Object.freeze({});
    var errors = [];
    var context = new (0, $1zF5q.ValidationContext)(schema, documentAST, typeInfo, function(error) {
        if (options.maxErrors != null && errors.length >= options.maxErrors) {
            errors.push(new (0, $g5yZB.GraphQLError)('Too many validation errors, error limit reached. Validation aborted.'));
            throw abortObj;
        }
        errors.push(error);
    }); // This uses a specialized visitor which runs multiple visitors in parallel,
    // while maintaining the visitor skip and break API.
    var visitor = (0, $12QNw.visitInParallel)(rules.map(function(rule) {
        return rule(context);
    })); // Visit the whole document with each instance of all provided rules.
    try {
        (0, $12QNw.visit)(documentAST, (0, $jjG8c.visitWithTypeInfo)(typeInfo, visitor));
    } catch (e) {
        if (e !== abortObj) throw e;
    }
    return errors;
}
function $8cf529db72906245$export$664b3e1af4fc59b0(documentAST, schemaToExtend) {
    var rules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $1W847.specifiedSDLRules);
    var errors = [];
    var context = new (0, $1zF5q.SDLValidationContext)(documentAST, schemaToExtend, function(error) {
        errors.push(error);
    });
    var visitors = rules.map(function(rule) {
        return rule(context);
    });
    (0, $12QNw.visit)(documentAST, (0, $12QNw.visitInParallel)(visitors));
    return errors;
}
function $8cf529db72906245$export$e53e4d7168bd6d92(documentAST) {
    var errors = $8cf529db72906245$export$664b3e1af4fc59b0(documentAST);
    if (errors.length !== 0) throw new Error(errors.map(function(error) {
        return error.message;
    }).join('\n\n'));
}
function $8cf529db72906245$export$9917845776f624a4(documentAST, schema) {
    var errors = $8cf529db72906245$export$664b3e1af4fc59b0(documentAST, schema);
    if (errors.length !== 0) throw new Error(errors.map(function(error) {
        return error.message;
    }).join('\n\n'));
}

});
parcelRegister("jjG8c", function(module, exports) {

$parcel$export(module.exports, "TypeInfo", () => $e10079122696b9a0$export$f0c1fe746ce4bb1e);
$parcel$export(module.exports, "visitWithTypeInfo", () => $e10079122696b9a0$export$18ca434620348336);

var $85NSv = parcelRequire("85NSv");

var $bzIlO = parcelRequire("bzIlO");

var $98oUl = parcelRequire("98oUl");

var $12QNw = parcelRequire("12QNw");

var $8oLgk = parcelRequire("8oLgk");

var $4Hpke = parcelRequire("4Hpke");

var $6D4Eu = parcelRequire("6D4Eu");
var $e10079122696b9a0$export$f0c1fe746ce4bb1e = /*#__PURE__*/ function() {
    function TypeInfo(schema, // to support non-spec-compliant code bases. You should never need to use it.
    // It may disappear in the future.
    getFieldDefFn, // beginning somewhere other than documents.
    initialType) {
        this._schema = schema;
        this._typeStack = [];
        this._parentTypeStack = [];
        this._inputTypeStack = [];
        this._fieldDefStack = [];
        this._defaultValueStack = [];
        this._directive = null;
        this._argument = null;
        this._enumValue = null;
        this._getFieldDef = getFieldDefFn !== null && getFieldDefFn !== void 0 ? getFieldDefFn : $e10079122696b9a0$var$getFieldDef;
        if (initialType) {
            if ((0, $8oLgk.isInputType)(initialType)) this._inputTypeStack.push(initialType);
            if ((0, $8oLgk.isCompositeType)(initialType)) this._parentTypeStack.push(initialType);
            if ((0, $8oLgk.isOutputType)(initialType)) this._typeStack.push(initialType);
        }
    }
    var _proto = TypeInfo.prototype;
    _proto.getType = function getType() {
        if (this._typeStack.length > 0) return this._typeStack[this._typeStack.length - 1];
    };
    _proto.getParentType = function getParentType() {
        if (this._parentTypeStack.length > 0) return this._parentTypeStack[this._parentTypeStack.length - 1];
    };
    _proto.getInputType = function getInputType() {
        if (this._inputTypeStack.length > 0) return this._inputTypeStack[this._inputTypeStack.length - 1];
    };
    _proto.getParentInputType = function getParentInputType() {
        if (this._inputTypeStack.length > 1) return this._inputTypeStack[this._inputTypeStack.length - 2];
    };
    _proto.getFieldDef = function getFieldDef() {
        if (this._fieldDefStack.length > 0) return this._fieldDefStack[this._fieldDefStack.length - 1];
    };
    _proto.getDefaultValue = function getDefaultValue() {
        if (this._defaultValueStack.length > 0) return this._defaultValueStack[this._defaultValueStack.length - 1];
    };
    _proto.getDirective = function getDirective() {
        return this._directive;
    };
    _proto.getArgument = function getArgument() {
        return this._argument;
    };
    _proto.getEnumValue = function getEnumValue() {
        return this._enumValue;
    };
    _proto.enter = function enter(node) {
        var schema = this._schema; // Note: many of the types below are explicitly typed as "mixed" to drop
        // any assumptions of a valid schema to ensure runtime types are properly
        // checked before continuing since TypeInfo is used as part of validation
        // which occurs before guarantees of schema and document validity.
        switch(node.kind){
            case (0, $bzIlO.Kind).SELECTION_SET:
                var namedType = (0, $8oLgk.getNamedType)(this.getType());
                this._parentTypeStack.push((0, $8oLgk.isCompositeType)(namedType) ? namedType : undefined);
                break;
            case (0, $bzIlO.Kind).FIELD:
                var parentType = this.getParentType();
                var fieldDef;
                var fieldType;
                if (parentType) {
                    fieldDef = this._getFieldDef(schema, parentType, node);
                    if (fieldDef) fieldType = fieldDef.type;
                }
                this._fieldDefStack.push(fieldDef);
                this._typeStack.push((0, $8oLgk.isOutputType)(fieldType) ? fieldType : undefined);
                break;
            case (0, $bzIlO.Kind).DIRECTIVE:
                this._directive = schema.getDirective(node.name.value);
                break;
            case (0, $bzIlO.Kind).OPERATION_DEFINITION:
                var type;
                switch(node.operation){
                    case 'query':
                        type = schema.getQueryType();
                        break;
                    case 'mutation':
                        type = schema.getMutationType();
                        break;
                    case 'subscription':
                        type = schema.getSubscriptionType();
                        break;
                }
                this._typeStack.push((0, $8oLgk.isObjectType)(type) ? type : undefined);
                break;
            case (0, $bzIlO.Kind).INLINE_FRAGMENT:
            case (0, $bzIlO.Kind).FRAGMENT_DEFINITION:
                var typeConditionAST = node.typeCondition;
                var outputType = typeConditionAST ? (0, $6D4Eu.typeFromAST)(schema, typeConditionAST) : (0, $8oLgk.getNamedType)(this.getType());
                this._typeStack.push((0, $8oLgk.isOutputType)(outputType) ? outputType : undefined);
                break;
            case (0, $bzIlO.Kind).VARIABLE_DEFINITION:
                var inputType = (0, $6D4Eu.typeFromAST)(schema, node.type);
                this._inputTypeStack.push((0, $8oLgk.isInputType)(inputType) ? inputType : undefined);
                break;
            case (0, $bzIlO.Kind).ARGUMENT:
                var _this$getDirective;
                var argDef;
                var argType;
                var fieldOrDirective = (_this$getDirective = this.getDirective()) !== null && _this$getDirective !== void 0 ? _this$getDirective : this.getFieldDef();
                if (fieldOrDirective) {
                    argDef = (0, $85NSv.default)(fieldOrDirective.args, function(arg) {
                        return arg.name === node.name.value;
                    });
                    if (argDef) argType = argDef.type;
                }
                this._argument = argDef;
                this._defaultValueStack.push(argDef ? argDef.defaultValue : undefined);
                this._inputTypeStack.push((0, $8oLgk.isInputType)(argType) ? argType : undefined);
                break;
            case (0, $bzIlO.Kind).LIST:
                var listType = (0, $8oLgk.getNullableType)(this.getInputType());
                var itemType = (0, $8oLgk.isListType)(listType) ? listType.ofType : listType; // List positions never have a default value.
                this._defaultValueStack.push(undefined);
                this._inputTypeStack.push((0, $8oLgk.isInputType)(itemType) ? itemType : undefined);
                break;
            case (0, $bzIlO.Kind).OBJECT_FIELD:
                var objectType = (0, $8oLgk.getNamedType)(this.getInputType());
                var inputFieldType;
                var inputField;
                if ((0, $8oLgk.isInputObjectType)(objectType)) {
                    inputField = objectType.getFields()[node.name.value];
                    if (inputField) inputFieldType = inputField.type;
                }
                this._defaultValueStack.push(inputField ? inputField.defaultValue : undefined);
                this._inputTypeStack.push((0, $8oLgk.isInputType)(inputFieldType) ? inputFieldType : undefined);
                break;
            case (0, $bzIlO.Kind).ENUM:
                var enumType = (0, $8oLgk.getNamedType)(this.getInputType());
                var enumValue;
                if ((0, $8oLgk.isEnumType)(enumType)) enumValue = enumType.getValue(node.value);
                this._enumValue = enumValue;
                break;
        }
    };
    _proto.leave = function leave(node) {
        switch(node.kind){
            case (0, $bzIlO.Kind).SELECTION_SET:
                this._parentTypeStack.pop();
                break;
            case (0, $bzIlO.Kind).FIELD:
                this._fieldDefStack.pop();
                this._typeStack.pop();
                break;
            case (0, $bzIlO.Kind).DIRECTIVE:
                this._directive = null;
                break;
            case (0, $bzIlO.Kind).OPERATION_DEFINITION:
            case (0, $bzIlO.Kind).INLINE_FRAGMENT:
            case (0, $bzIlO.Kind).FRAGMENT_DEFINITION:
                this._typeStack.pop();
                break;
            case (0, $bzIlO.Kind).VARIABLE_DEFINITION:
                this._inputTypeStack.pop();
                break;
            case (0, $bzIlO.Kind).ARGUMENT:
                this._argument = null;
                this._defaultValueStack.pop();
                this._inputTypeStack.pop();
                break;
            case (0, $bzIlO.Kind).LIST:
            case (0, $bzIlO.Kind).OBJECT_FIELD:
                this._defaultValueStack.pop();
                this._inputTypeStack.pop();
                break;
            case (0, $bzIlO.Kind).ENUM:
                this._enumValue = null;
                break;
        }
    };
    return TypeInfo;
}();
/**
 * Not exactly the same as the executor's definition of getFieldDef, in this
 * statically evaluated environment we do not always have an Object type,
 * and need to handle Interface and Union types.
 */ function $e10079122696b9a0$var$getFieldDef(schema, parentType, fieldNode) {
    var name = fieldNode.name.value;
    if (name === (0, $4Hpke.SchemaMetaFieldDef).name && schema.getQueryType() === parentType) return 0, $4Hpke.SchemaMetaFieldDef;
    if (name === (0, $4Hpke.TypeMetaFieldDef).name && schema.getQueryType() === parentType) return 0, $4Hpke.TypeMetaFieldDef;
    if (name === (0, $4Hpke.TypeNameMetaFieldDef).name && (0, $8oLgk.isCompositeType)(parentType)) return 0, $4Hpke.TypeNameMetaFieldDef;
    if ((0, $8oLgk.isObjectType)(parentType) || (0, $8oLgk.isInterfaceType)(parentType)) return parentType.getFields()[name];
}
function $e10079122696b9a0$export$18ca434620348336(typeInfo, visitor) {
    return {
        enter: function enter(node) {
            typeInfo.enter(node);
            var fn = (0, $12QNw.getVisitFn)(visitor, node.kind, /* isLeaving */ false);
            if (fn) {
                var result = fn.apply(visitor, arguments);
                if (result !== undefined) {
                    typeInfo.leave(node);
                    if ((0, $98oUl.isNode)(result)) typeInfo.enter(result);
                }
                return result;
            }
        },
        leave: function leave(node) {
            var fn = (0, $12QNw.getVisitFn)(visitor, node.kind, /* isLeaving */ true);
            var result;
            if (fn) result = fn.apply(visitor, arguments);
            typeInfo.leave(node);
            return result;
        }
    };
}

});

parcelRegister("1W847", function(module, exports) {

$parcel$export(module.exports, "specifiedRules", () => $169176d8a596a904$export$ac8e8f03d4e8a76c);
$parcel$export(module.exports, "specifiedSDLRules", () => $169176d8a596a904$export$117d63808a280985);
// Spec Section: "Executable Definitions"

var $DFCPk = parcelRequire("DFCPk");

var $30WWH = parcelRequire("30WWH");

var $eyFIg = parcelRequire("eyFIg");

var $09Bdf = parcelRequire("09Bdf");

var $7bFax = parcelRequire("7bFax");

var $dbQGB = parcelRequire("dbQGB");

var $1co8V = parcelRequire("1co8V");

var $aPMtH = parcelRequire("aPMtH");

var $jQZ5i = parcelRequire("jQZ5i");

var $8PIus = parcelRequire("8PIus");

var $coK44 = parcelRequire("coK44");

var $8m6li = parcelRequire("8m6li");

var $3wQxN = parcelRequire("3wQxN");

var $90jMN = parcelRequire("90jMN");

var $5OxVI = parcelRequire("5OxVI");

var $4uTwu = parcelRequire("4uTwu");

var $9TmyO = parcelRequire("9TmyO");

var $3N4Hj = parcelRequire("3N4Hj");

var $VWtb8 = parcelRequire("VWtb8");

var $9WoAw = parcelRequire("9WoAw");

var $36Mx7 = parcelRequire("36Mx7");

var $5wBGi = parcelRequire("5wBGi");

var $jpyH1 = parcelRequire("jpyH1");

var $8gRGf = parcelRequire("8gRGf");

var $gA8jd = parcelRequire("gA8jd");

var $dAQg3 = parcelRequire("dAQg3");

var $66C9m = parcelRequire("66C9m");

var $beSbb = parcelRequire("beSbb");

var $gBAc1 = parcelRequire("gBAc1");

var $3iH5k = parcelRequire("3iH5k");

var $j74Ua = parcelRequire("j74Ua");

var $9mu02 = parcelRequire("9mu02");

var $6i9pg = parcelRequire("6i9pg");

var $ixjnC = parcelRequire("ixjnC");
var $169176d8a596a904$export$b6056a9df69e677d = Object.freeze([
    (0, $66C9m.MaxIntrospectionDepthRule)
]);
var $169176d8a596a904$export$ac8e8f03d4e8a76c = Object.freeze([
    (0, $DFCPk.ExecutableDefinitionsRule),
    (0, $30WWH.UniqueOperationNamesRule),
    (0, $eyFIg.LoneAnonymousOperationRule),
    (0, $09Bdf.SingleFieldSubscriptionsRule),
    (0, $7bFax.KnownTypeNamesRule),
    (0, $dbQGB.FragmentsOnCompositeTypesRule),
    (0, $1co8V.VariablesAreInputTypesRule),
    (0, $aPMtH.ScalarLeafsRule),
    (0, $jQZ5i.FieldsOnCorrectTypeRule),
    (0, $8PIus.UniqueFragmentNamesRule),
    (0, $coK44.KnownFragmentNamesRule),
    (0, $8m6li.NoUnusedFragmentsRule),
    (0, $3wQxN.PossibleFragmentSpreadsRule),
    (0, $90jMN.NoFragmentCyclesRule),
    (0, $5OxVI.UniqueVariableNamesRule),
    (0, $4uTwu.NoUndefinedVariablesRule),
    (0, $9TmyO.NoUnusedVariablesRule),
    (0, $3N4Hj.KnownDirectivesRule),
    (0, $VWtb8.UniqueDirectivesPerLocationRule),
    (0, $9WoAw.KnownArgumentNamesRule),
    (0, $36Mx7.UniqueArgumentNamesRule),
    (0, $5wBGi.ValuesOfCorrectTypeRule),
    (0, $jpyH1.ProvidedRequiredArgumentsRule),
    (0, $8gRGf.VariablesInAllowedPositionRule),
    (0, $gA8jd.OverlappingFieldsCanBeMergedRule),
    (0, $dAQg3.UniqueInputFieldNamesRule)
].concat($169176d8a596a904$export$b6056a9df69e677d));
var $169176d8a596a904$export$117d63808a280985 = Object.freeze([
    (0, $beSbb.LoneSchemaDefinitionRule),
    (0, $gBAc1.UniqueOperationTypesRule),
    (0, $3iH5k.UniqueTypeNamesRule),
    (0, $j74Ua.UniqueEnumValueNamesRule),
    (0, $9mu02.UniqueFieldDefinitionNamesRule),
    (0, $6i9pg.UniqueDirectiveNamesRule),
    (0, $7bFax.KnownTypeNamesRule),
    (0, $3N4Hj.KnownDirectivesRule),
    (0, $VWtb8.UniqueDirectivesPerLocationRule),
    (0, $ixjnC.PossibleTypeExtensionsRule),
    (0, $9WoAw.KnownArgumentNamesOnDirectivesRule),
    (0, $36Mx7.UniqueArgumentNamesRule),
    (0, $dAQg3.UniqueInputFieldNamesRule),
    (0, $jpyH1.ProvidedRequiredArgumentsOnDirectivesRule)
]);

});
parcelRegister("DFCPk", function(module, exports) {

$parcel$export(module.exports, "ExecutableDefinitionsRule", () => $0773ee89c9209122$export$c3d3637a3c3c605e);

var $g5yZB = parcelRequire("g5yZB");

var $bzIlO = parcelRequire("bzIlO");

var $Zbk4Z = parcelRequire("Zbk4Z");
function $0773ee89c9209122$export$c3d3637a3c3c605e(context) {
    return {
        Document: function Document(node) {
            for(var _i2 = 0, _node$definitions2 = node.definitions; _i2 < _node$definitions2.length; _i2++){
                var definition = _node$definitions2[_i2];
                if (!(0, $Zbk4Z.isExecutableDefinitionNode)(definition)) {
                    var defName = definition.kind === (0, $bzIlO.Kind).SCHEMA_DEFINITION || definition.kind === (0, $bzIlO.Kind).SCHEMA_EXTENSION ? 'schema' : '"' + definition.name.value + '"';
                    context.reportError(new (0, $g5yZB.GraphQLError)("The ".concat(defName, " definition is not executable."), definition));
                }
            }
            return false;
        }
    };
}

});
parcelRegister("Zbk4Z", function(module, exports) {

$parcel$export(module.exports, "isExecutableDefinitionNode", () => $0b7e7b1ac74e324c$export$4cedd8740794bd78);
$parcel$export(module.exports, "isTypeSystemDefinitionNode", () => $0b7e7b1ac74e324c$export$b05c7141ec7770ba);
$parcel$export(module.exports, "isTypeSystemExtensionNode", () => $0b7e7b1ac74e324c$export$fbc18e88163d676d);
$parcel$export(module.exports, "isSelectionNode", () => $0b7e7b1ac74e324c$export$65772b71e1d017ba);
$parcel$export(module.exports, "isTypeDefinitionNode", () => $0b7e7b1ac74e324c$export$a3584bba04f5bfe0);
$parcel$export(module.exports, "isTypeExtensionNode", () => $0b7e7b1ac74e324c$export$d7907721b241e11f);

var $bzIlO = parcelRequire("bzIlO");
function $0b7e7b1ac74e324c$export$e7ecd7c16613ccfd(node) {
    return $0b7e7b1ac74e324c$export$4cedd8740794bd78(node) || $0b7e7b1ac74e324c$export$b05c7141ec7770ba(node) || $0b7e7b1ac74e324c$export$fbc18e88163d676d(node);
}
function $0b7e7b1ac74e324c$export$4cedd8740794bd78(node) {
    return node.kind === (0, $bzIlO.Kind).OPERATION_DEFINITION || node.kind === (0, $bzIlO.Kind).FRAGMENT_DEFINITION;
}
function $0b7e7b1ac74e324c$export$65772b71e1d017ba(node) {
    return node.kind === (0, $bzIlO.Kind).FIELD || node.kind === (0, $bzIlO.Kind).FRAGMENT_SPREAD || node.kind === (0, $bzIlO.Kind).INLINE_FRAGMENT;
}
function $0b7e7b1ac74e324c$export$ab65b54ec7cbe9e4(node) {
    return node.kind === (0, $bzIlO.Kind).VARIABLE || node.kind === (0, $bzIlO.Kind).INT || node.kind === (0, $bzIlO.Kind).FLOAT || node.kind === (0, $bzIlO.Kind).STRING || node.kind === (0, $bzIlO.Kind).BOOLEAN || node.kind === (0, $bzIlO.Kind).NULL || node.kind === (0, $bzIlO.Kind).ENUM || node.kind === (0, $bzIlO.Kind).LIST || node.kind === (0, $bzIlO.Kind).OBJECT;
}
function $0b7e7b1ac74e324c$export$26e8a4730f4310f4(node) {
    return node.kind === (0, $bzIlO.Kind).NAMED_TYPE || node.kind === (0, $bzIlO.Kind).LIST_TYPE || node.kind === (0, $bzIlO.Kind).NON_NULL_TYPE;
}
function $0b7e7b1ac74e324c$export$b05c7141ec7770ba(node) {
    return node.kind === (0, $bzIlO.Kind).SCHEMA_DEFINITION || $0b7e7b1ac74e324c$export$a3584bba04f5bfe0(node) || node.kind === (0, $bzIlO.Kind).DIRECTIVE_DEFINITION;
}
function $0b7e7b1ac74e324c$export$a3584bba04f5bfe0(node) {
    return node.kind === (0, $bzIlO.Kind).SCALAR_TYPE_DEFINITION || node.kind === (0, $bzIlO.Kind).OBJECT_TYPE_DEFINITION || node.kind === (0, $bzIlO.Kind).INTERFACE_TYPE_DEFINITION || node.kind === (0, $bzIlO.Kind).UNION_TYPE_DEFINITION || node.kind === (0, $bzIlO.Kind).ENUM_TYPE_DEFINITION || node.kind === (0, $bzIlO.Kind).INPUT_OBJECT_TYPE_DEFINITION;
}
function $0b7e7b1ac74e324c$export$fbc18e88163d676d(node) {
    return node.kind === (0, $bzIlO.Kind).SCHEMA_EXTENSION || $0b7e7b1ac74e324c$export$d7907721b241e11f(node);
}
function $0b7e7b1ac74e324c$export$d7907721b241e11f(node) {
    return node.kind === (0, $bzIlO.Kind).SCALAR_TYPE_EXTENSION || node.kind === (0, $bzIlO.Kind).OBJECT_TYPE_EXTENSION || node.kind === (0, $bzIlO.Kind).INTERFACE_TYPE_EXTENSION || node.kind === (0, $bzIlO.Kind).UNION_TYPE_EXTENSION || node.kind === (0, $bzIlO.Kind).ENUM_TYPE_EXTENSION || node.kind === (0, $bzIlO.Kind).INPUT_OBJECT_TYPE_EXTENSION;
}

});


parcelRegister("30WWH", function(module, exports) {

$parcel$export(module.exports, "UniqueOperationNamesRule", () => $231f189a5fb9214e$export$a40a702cd7ad2eae);

var $g5yZB = parcelRequire("g5yZB");
function $231f189a5fb9214e$export$a40a702cd7ad2eae(context) {
    var knownOperationNames = Object.create(null);
    return {
        OperationDefinition: function OperationDefinition(node) {
            var operationName = node.name;
            if (operationName) {
                if (knownOperationNames[operationName.value]) context.reportError(new (0, $g5yZB.GraphQLError)("There can be only one operation named \"".concat(operationName.value, "\"."), [
                    knownOperationNames[operationName.value],
                    operationName
                ]));
                else knownOperationNames[operationName.value] = operationName;
            }
            return false;
        },
        FragmentDefinition: function FragmentDefinition() {
            return false;
        }
    };
}

});

parcelRegister("eyFIg", function(module, exports) {

$parcel$export(module.exports, "LoneAnonymousOperationRule", () => $a99498fb0f12eeb9$export$3a79c63c3de7a55f);

var $g5yZB = parcelRequire("g5yZB");

var $bzIlO = parcelRequire("bzIlO");
function $a99498fb0f12eeb9$export$3a79c63c3de7a55f(context) {
    var operationCount = 0;
    return {
        Document: function Document(node) {
            operationCount = node.definitions.filter(function(definition) {
                return definition.kind === (0, $bzIlO.Kind).OPERATION_DEFINITION;
            }).length;
        },
        OperationDefinition: function OperationDefinition(node) {
            if (!node.name && operationCount > 1) context.reportError(new (0, $g5yZB.GraphQLError)('This anonymous operation must be the only defined operation.', node));
        }
    };
}

});

parcelRegister("09Bdf", function(module, exports) {

$parcel$export(module.exports, "SingleFieldSubscriptionsRule", () => $000772678217c64a$export$477fa0c787c0222d);

var $g5yZB = parcelRequire("g5yZB");
function $000772678217c64a$export$477fa0c787c0222d(context) {
    return {
        OperationDefinition: function OperationDefinition(node) {
            if (node.operation === 'subscription') {
                if (node.selectionSet.selections.length !== 1) context.reportError(new (0, $g5yZB.GraphQLError)(node.name ? "Subscription \"".concat(node.name.value, "\" must select only one top level field.") : 'Anonymous Subscription must select only one top level field.', node.selectionSet.selections.slice(1)));
            }
        }
    };
}

});

parcelRegister("7bFax", function(module, exports) {

$parcel$export(module.exports, "KnownTypeNamesRule", () => $53b97ecd605f9be8$export$2317edbae2efecbd);

var $h4f6N = parcelRequire("h4f6N");

var $gXVhx = parcelRequire("gXVhx");

var $g5yZB = parcelRequire("g5yZB");

var $Zbk4Z = parcelRequire("Zbk4Z");

var $djKly = parcelRequire("djKly");

var $4Hpke = parcelRequire("4Hpke");
function $53b97ecd605f9be8$export$2317edbae2efecbd(context) {
    var schema = context.getSchema();
    var existingTypesMap = schema ? schema.getTypeMap() : Object.create(null);
    var definedTypes = Object.create(null);
    for(var _i2 = 0, _context$getDocument$2 = context.getDocument().definitions; _i2 < _context$getDocument$2.length; _i2++){
        var def = _context$getDocument$2[_i2];
        if ((0, $Zbk4Z.isTypeDefinitionNode)(def)) definedTypes[def.name.value] = true;
    }
    var typeNames = Object.keys(existingTypesMap).concat(Object.keys(definedTypes));
    return {
        NamedType: function NamedType(node, _1, parent, _2, ancestors) {
            var typeName = node.name.value;
            if (!existingTypesMap[typeName] && !definedTypes[typeName]) {
                var _ancestors$;
                var definitionNode = (_ancestors$ = ancestors[2]) !== null && _ancestors$ !== void 0 ? _ancestors$ : parent;
                var isSDL = definitionNode != null && $53b97ecd605f9be8$var$isSDLNode(definitionNode);
                if (isSDL && $53b97ecd605f9be8$var$isStandardTypeName(typeName)) return;
                var suggestedTypes = (0, $gXVhx.default)(typeName, isSDL ? $53b97ecd605f9be8$var$standardTypeNames.concat(typeNames) : typeNames);
                context.reportError(new (0, $g5yZB.GraphQLError)("Unknown type \"".concat(typeName, "\".") + (0, $h4f6N.default)(suggestedTypes), node));
            }
        }
    };
}
var $53b97ecd605f9be8$var$standardTypeNames = [].concat((0, $djKly.specifiedScalarTypes), (0, $4Hpke.introspectionTypes)).map(function(type) {
    return type.name;
});
function $53b97ecd605f9be8$var$isStandardTypeName(typeName) {
    return $53b97ecd605f9be8$var$standardTypeNames.indexOf(typeName) !== -1;
}
function $53b97ecd605f9be8$var$isSDLNode(value) {
    return !Array.isArray(value) && ((0, $Zbk4Z.isTypeSystemDefinitionNode)(value) || (0, $Zbk4Z.isTypeSystemExtensionNode)(value));
}

});

parcelRegister("dbQGB", function(module, exports) {

$parcel$export(module.exports, "FragmentsOnCompositeTypesRule", () => $99a52bd0560cc038$export$cb5241ba71fd55e0);

var $g5yZB = parcelRequire("g5yZB");

var $1c8Um = parcelRequire("1c8Um");

var $8oLgk = parcelRequire("8oLgk");

var $6D4Eu = parcelRequire("6D4Eu");
function $99a52bd0560cc038$export$cb5241ba71fd55e0(context) {
    return {
        InlineFragment: function InlineFragment(node) {
            var typeCondition = node.typeCondition;
            if (typeCondition) {
                var type = (0, $6D4Eu.typeFromAST)(context.getSchema(), typeCondition);
                if (type && !(0, $8oLgk.isCompositeType)(type)) {
                    var typeStr = (0, $1c8Um.print)(typeCondition);
                    context.reportError(new (0, $g5yZB.GraphQLError)("Fragment cannot condition on non composite type \"".concat(typeStr, "\"."), typeCondition));
                }
            }
        },
        FragmentDefinition: function FragmentDefinition(node) {
            var type = (0, $6D4Eu.typeFromAST)(context.getSchema(), node.typeCondition);
            if (type && !(0, $8oLgk.isCompositeType)(type)) {
                var typeStr = (0, $1c8Um.print)(node.typeCondition);
                context.reportError(new (0, $g5yZB.GraphQLError)("Fragment \"".concat(node.name.value, "\" cannot condition on non composite type \"").concat(typeStr, "\"."), node.typeCondition));
            }
        }
    };
}

});

parcelRegister("1co8V", function(module, exports) {

$parcel$export(module.exports, "VariablesAreInputTypesRule", () => $0df9a3b429e106f2$export$f20a29632b437591);

var $g5yZB = parcelRequire("g5yZB");

var $1c8Um = parcelRequire("1c8Um");

var $8oLgk = parcelRequire("8oLgk");

var $6D4Eu = parcelRequire("6D4Eu");
function $0df9a3b429e106f2$export$f20a29632b437591(context) {
    return {
        VariableDefinition: function VariableDefinition(node) {
            var type = (0, $6D4Eu.typeFromAST)(context.getSchema(), node.type);
            if (type && !(0, $8oLgk.isInputType)(type)) {
                var variableName = node.variable.name.value;
                var typeName = (0, $1c8Um.print)(node.type);
                context.reportError(new (0, $g5yZB.GraphQLError)("Variable \"$".concat(variableName, "\" cannot be non-input type \"").concat(typeName, "\"."), node.type));
            }
        }
    };
}

});

parcelRegister("aPMtH", function(module, exports) {

$parcel$export(module.exports, "ScalarLeafsRule", () => $7e3445851432b2be$export$d779f66f65c88b9a);

var $yEDl8 = parcelRequire("yEDl8");

var $g5yZB = parcelRequire("g5yZB");

var $8oLgk = parcelRequire("8oLgk");
function $7e3445851432b2be$export$d779f66f65c88b9a(context) {
    return {
        Field: function Field(node) {
            var type = context.getType();
            var selectionSet = node.selectionSet;
            if (type) {
                if ((0, $8oLgk.isLeafType)((0, $8oLgk.getNamedType)(type))) {
                    if (selectionSet) {
                        var fieldName = node.name.value;
                        var typeStr = (0, $yEDl8.default)(type);
                        context.reportError(new (0, $g5yZB.GraphQLError)("Field \"".concat(fieldName, "\" must not have a selection since type \"").concat(typeStr, "\" has no subfields."), selectionSet));
                    }
                } else if (!selectionSet) {
                    var _fieldName = node.name.value;
                    var _typeStr = (0, $yEDl8.default)(type);
                    context.reportError(new (0, $g5yZB.GraphQLError)("Field \"".concat(_fieldName, "\" of type \"").concat(_typeStr, "\" must have a selection of subfields. Did you mean \"").concat(_fieldName, " { ... }\"?"), node));
                }
            }
        }
    };
}

});

parcelRegister("jQZ5i", function(module, exports) {

$parcel$export(module.exports, "FieldsOnCorrectTypeRule", () => $e74241bbdeb8f50c$export$595e5c0bf2d10a85);

var $awIoQ = parcelRequire("awIoQ");

var $h4f6N = parcelRequire("h4f6N");

var $gXVhx = parcelRequire("gXVhx");

var $Jh3Fc = parcelRequire("Jh3Fc");

var $g5yZB = parcelRequire("g5yZB");

var $8oLgk = parcelRequire("8oLgk");
function $e74241bbdeb8f50c$export$595e5c0bf2d10a85(context) {
    return {
        Field: function Field(node) {
            var type = context.getParentType();
            if (type) {
                var fieldDef = context.getFieldDef();
                if (!fieldDef) {
                    // This field doesn't exist, lets look for suggestions.
                    var schema = context.getSchema();
                    var fieldName = node.name.value; // First determine if there are any suggested types to condition on.
                    var suggestion = (0, $h4f6N.default)('to use an inline fragment on', $e74241bbdeb8f50c$var$getSuggestedTypeNames(schema, type, fieldName)); // If there are no suggested types, then perhaps this was a typo?
                    if (suggestion === '') suggestion = (0, $h4f6N.default)($e74241bbdeb8f50c$var$getSuggestedFieldNames(type, fieldName));
                     // Report an error, including helpful suggestions.
                    context.reportError(new (0, $g5yZB.GraphQLError)("Cannot query field \"".concat(fieldName, "\" on type \"").concat(type.name, "\".") + suggestion, node));
                }
            }
        }
    };
}
/**
 * Go through all of the implementations of type, as well as the interfaces that
 * they implement. If any of those types include the provided field, suggest them,
 * sorted by how often the type is referenced.
 */ function $e74241bbdeb8f50c$var$getSuggestedTypeNames(schema, type, fieldName) {
    if (!(0, $8oLgk.isAbstractType)(type)) // Must be an Object type, which does not have possible fields.
    return [];
    var suggestedTypes = new Set();
    var usageCount = Object.create(null);
    for(var _i2 = 0, _schema$getPossibleTy2 = schema.getPossibleTypes(type); _i2 < _schema$getPossibleTy2.length; _i2++){
        var possibleType = _schema$getPossibleTy2[_i2];
        if (!possibleType.getFields()[fieldName]) continue;
         // This object type defines this field.
        suggestedTypes.add(possibleType);
        usageCount[possibleType.name] = 1;
        for(var _i4 = 0, _possibleType$getInte2 = possibleType.getInterfaces(); _i4 < _possibleType$getInte2.length; _i4++){
            var _usageCount$possibleI;
            var possibleInterface = _possibleType$getInte2[_i4];
            if (!possibleInterface.getFields()[fieldName]) continue;
             // This interface type defines this field.
            suggestedTypes.add(possibleInterface);
            usageCount[possibleInterface.name] = ((_usageCount$possibleI = usageCount[possibleInterface.name]) !== null && _usageCount$possibleI !== void 0 ? _usageCount$possibleI : 0) + 1;
        }
    }
    return (0, $awIoQ.default)(suggestedTypes).sort(function(typeA, typeB) {
        // Suggest both interface and object types based on how common they are.
        var usageCountDiff = usageCount[typeB.name] - usageCount[typeA.name];
        if (usageCountDiff !== 0) return usageCountDiff;
         // Suggest super types first followed by subtypes
        if ((0, $8oLgk.isInterfaceType)(typeA) && schema.isSubType(typeA, typeB)) return -1;
        if ((0, $8oLgk.isInterfaceType)(typeB) && schema.isSubType(typeB, typeA)) return 1;
        return (0, $Jh3Fc.default)(typeA.name, typeB.name);
    }).map(function(x) {
        return x.name;
    });
}
/**
 * For the field name provided, determine if there are any similar field names
 * that may be the result of a typo.
 */ function $e74241bbdeb8f50c$var$getSuggestedFieldNames(type, fieldName) {
    if ((0, $8oLgk.isObjectType)(type) || (0, $8oLgk.isInterfaceType)(type)) {
        var possibleFieldNames = Object.keys(type.getFields());
        return (0, $gXVhx.default)(fieldName, possibleFieldNames);
    } // Otherwise, must be a Union type, which does not define fields.
    return [];
}

});

parcelRegister("8PIus", function(module, exports) {

$parcel$export(module.exports, "UniqueFragmentNamesRule", () => $66e598feff36d541$export$a920e0f1967f4b0a);

var $g5yZB = parcelRequire("g5yZB");
function $66e598feff36d541$export$a920e0f1967f4b0a(context) {
    var knownFragmentNames = Object.create(null);
    return {
        OperationDefinition: function OperationDefinition() {
            return false;
        },
        FragmentDefinition: function FragmentDefinition(node) {
            var fragmentName = node.name.value;
            if (knownFragmentNames[fragmentName]) context.reportError(new (0, $g5yZB.GraphQLError)("There can be only one fragment named \"".concat(fragmentName, "\"."), [
                knownFragmentNames[fragmentName],
                node.name
            ]));
            else knownFragmentNames[fragmentName] = node.name;
            return false;
        }
    };
}

});

parcelRegister("coK44", function(module, exports) {

$parcel$export(module.exports, "KnownFragmentNamesRule", () => $906b756e66eb2437$export$94c8dd81fb6d3111);

var $g5yZB = parcelRequire("g5yZB");
function $906b756e66eb2437$export$94c8dd81fb6d3111(context) {
    return {
        FragmentSpread: function FragmentSpread(node) {
            var fragmentName = node.name.value;
            var fragment = context.getFragment(fragmentName);
            if (!fragment) context.reportError(new (0, $g5yZB.GraphQLError)("Unknown fragment \"".concat(fragmentName, "\"."), node.name));
        }
    };
}

});

parcelRegister("8m6li", function(module, exports) {

$parcel$export(module.exports, "NoUnusedFragmentsRule", () => $61554c485d05a096$export$d29d2e5ed74717af);

var $g5yZB = parcelRequire("g5yZB");
function $61554c485d05a096$export$d29d2e5ed74717af(context) {
    var operationDefs = [];
    var fragmentDefs = [];
    return {
        OperationDefinition: function OperationDefinition(node) {
            operationDefs.push(node);
            return false;
        },
        FragmentDefinition: function FragmentDefinition(node) {
            fragmentDefs.push(node);
            return false;
        },
        Document: {
            leave: function leave() {
                var fragmentNameUsed = Object.create(null);
                for(var _i2 = 0; _i2 < operationDefs.length; _i2++){
                    var operation = operationDefs[_i2];
                    for(var _i4 = 0, _context$getRecursive2 = context.getRecursivelyReferencedFragments(operation); _i4 < _context$getRecursive2.length; _i4++){
                        var fragment = _context$getRecursive2[_i4];
                        fragmentNameUsed[fragment.name.value] = true;
                    }
                }
                for(var _i6 = 0; _i6 < fragmentDefs.length; _i6++){
                    var fragmentDef = fragmentDefs[_i6];
                    var fragName = fragmentDef.name.value;
                    if (fragmentNameUsed[fragName] !== true) context.reportError(new (0, $g5yZB.GraphQLError)("Fragment \"".concat(fragName, "\" is never used."), fragmentDef));
                }
            }
        }
    };
}

});

parcelRegister("3wQxN", function(module, exports) {

$parcel$export(module.exports, "PossibleFragmentSpreadsRule", () => $291d1e654f5f2bf9$export$aa7b39ab48da3359);

var $yEDl8 = parcelRequire("yEDl8");

var $g5yZB = parcelRequire("g5yZB");

var $8oLgk = parcelRequire("8oLgk");

var $6D4Eu = parcelRequire("6D4Eu");

var $9GswX = parcelRequire("9GswX");
function $291d1e654f5f2bf9$export$aa7b39ab48da3359(context) {
    return {
        InlineFragment: function InlineFragment(node) {
            var fragType = context.getType();
            var parentType = context.getParentType();
            if ((0, $8oLgk.isCompositeType)(fragType) && (0, $8oLgk.isCompositeType)(parentType) && !(0, $9GswX.doTypesOverlap)(context.getSchema(), fragType, parentType)) {
                var parentTypeStr = (0, $yEDl8.default)(parentType);
                var fragTypeStr = (0, $yEDl8.default)(fragType);
                context.reportError(new (0, $g5yZB.GraphQLError)("Fragment cannot be spread here as objects of type \"".concat(parentTypeStr, "\" can never be of type \"").concat(fragTypeStr, "\"."), node));
            }
        },
        FragmentSpread: function FragmentSpread(node) {
            var fragName = node.name.value;
            var fragType = $291d1e654f5f2bf9$var$getFragmentType(context, fragName);
            var parentType = context.getParentType();
            if (fragType && parentType && !(0, $9GswX.doTypesOverlap)(context.getSchema(), fragType, parentType)) {
                var parentTypeStr = (0, $yEDl8.default)(parentType);
                var fragTypeStr = (0, $yEDl8.default)(fragType);
                context.reportError(new (0, $g5yZB.GraphQLError)("Fragment \"".concat(fragName, "\" cannot be spread here as objects of type \"").concat(parentTypeStr, "\" can never be of type \"").concat(fragTypeStr, "\"."), node));
            }
        }
    };
}
function $291d1e654f5f2bf9$var$getFragmentType(context, name) {
    var frag = context.getFragment(name);
    if (frag) {
        var type = (0, $6D4Eu.typeFromAST)(context.getSchema(), frag.typeCondition);
        if ((0, $8oLgk.isCompositeType)(type)) return type;
    }
}

});

parcelRegister("90jMN", function(module, exports) {

$parcel$export(module.exports, "NoFragmentCyclesRule", () => $68e3764329525fe9$export$25eccb87f5a000e6);

var $g5yZB = parcelRequire("g5yZB");
function $68e3764329525fe9$export$25eccb87f5a000e6(context) {
    // Tracks already visited fragments to maintain O(N) and to ensure that cycles
    // are not redundantly reported.
    var visitedFrags = Object.create(null); // Array of AST nodes used to produce meaningful errors
    var spreadPath = []; // Position in the spread path
    var spreadPathIndexByName = Object.create(null);
    return {
        OperationDefinition: function OperationDefinition() {
            return false;
        },
        FragmentDefinition: function FragmentDefinition(node) {
            detectCycleRecursive(node);
            return false;
        }
    }; // This does a straight-forward DFS to find cycles.
    // It does not terminate when a cycle was found but continues to explore
    // the graph to find all possible cycles.
    function detectCycleRecursive(fragment) {
        if (visitedFrags[fragment.name.value]) return;
        var fragmentName = fragment.name.value;
        visitedFrags[fragmentName] = true;
        var spreadNodes = context.getFragmentSpreads(fragment.selectionSet);
        if (spreadNodes.length === 0) return;
        spreadPathIndexByName[fragmentName] = spreadPath.length;
        for(var _i2 = 0; _i2 < spreadNodes.length; _i2++){
            var spreadNode = spreadNodes[_i2];
            var spreadName = spreadNode.name.value;
            var cycleIndex = spreadPathIndexByName[spreadName];
            spreadPath.push(spreadNode);
            if (cycleIndex === undefined) {
                var spreadFragment = context.getFragment(spreadName);
                if (spreadFragment) detectCycleRecursive(spreadFragment);
            } else {
                var cyclePath = spreadPath.slice(cycleIndex);
                var viaPath = cyclePath.slice(0, -1).map(function(s) {
                    return '"' + s.name.value + '"';
                }).join(', ');
                context.reportError(new (0, $g5yZB.GraphQLError)("Cannot spread fragment \"".concat(spreadName, "\" within itself") + (viaPath !== '' ? " via ".concat(viaPath, ".") : '.'), cyclePath));
            }
            spreadPath.pop();
        }
        spreadPathIndexByName[fragmentName] = undefined;
    }
}

});

parcelRegister("5OxVI", function(module, exports) {

$parcel$export(module.exports, "UniqueVariableNamesRule", () => $43bbf10c49115329$export$b9352e3a23ba4aa2);

var $g5yZB = parcelRequire("g5yZB");
function $43bbf10c49115329$export$b9352e3a23ba4aa2(context) {
    var knownVariableNames = Object.create(null);
    return {
        OperationDefinition: function OperationDefinition() {
            knownVariableNames = Object.create(null);
        },
        VariableDefinition: function VariableDefinition(node) {
            var variableName = node.variable.name.value;
            if (knownVariableNames[variableName]) context.reportError(new (0, $g5yZB.GraphQLError)("There can be only one variable named \"$".concat(variableName, "\"."), [
                knownVariableNames[variableName],
                node.variable.name
            ]));
            else knownVariableNames[variableName] = node.variable.name;
        }
    };
}

});

parcelRegister("4uTwu", function(module, exports) {

$parcel$export(module.exports, "NoUndefinedVariablesRule", () => $34650881b8ee1909$export$207476dbb3f797ab);

var $g5yZB = parcelRequire("g5yZB");
function $34650881b8ee1909$export$207476dbb3f797ab(context) {
    var variableNameDefined = Object.create(null);
    return {
        OperationDefinition: {
            enter: function enter() {
                variableNameDefined = Object.create(null);
            },
            leave: function leave(operation) {
                var usages = context.getRecursiveVariableUsages(operation);
                for(var _i2 = 0; _i2 < usages.length; _i2++){
                    var _ref2 = usages[_i2];
                    var node = _ref2.node;
                    var varName = node.name.value;
                    if (variableNameDefined[varName] !== true) context.reportError(new (0, $g5yZB.GraphQLError)(operation.name ? "Variable \"$".concat(varName, "\" is not defined by operation \"").concat(operation.name.value, "\".") : "Variable \"$".concat(varName, "\" is not defined."), [
                        node,
                        operation
                    ]));
                }
            }
        },
        VariableDefinition: function VariableDefinition(node) {
            variableNameDefined[node.variable.name.value] = true;
        }
    };
}

});

parcelRegister("9TmyO", function(module, exports) {

$parcel$export(module.exports, "NoUnusedVariablesRule", () => $733ac02bd245c808$export$300a3bc5a4f49273);

var $g5yZB = parcelRequire("g5yZB");
function $733ac02bd245c808$export$300a3bc5a4f49273(context) {
    var variableDefs = [];
    return {
        OperationDefinition: {
            enter: function enter() {
                variableDefs = [];
            },
            leave: function leave(operation) {
                var variableNameUsed = Object.create(null);
                var usages = context.getRecursiveVariableUsages(operation);
                for(var _i2 = 0; _i2 < usages.length; _i2++){
                    var _ref2 = usages[_i2];
                    var node = _ref2.node;
                    variableNameUsed[node.name.value] = true;
                }
                for(var _i4 = 0, _variableDefs2 = variableDefs; _i4 < _variableDefs2.length; _i4++){
                    var variableDef = _variableDefs2[_i4];
                    var variableName = variableDef.variable.name.value;
                    if (variableNameUsed[variableName] !== true) context.reportError(new (0, $g5yZB.GraphQLError)(operation.name ? "Variable \"$".concat(variableName, "\" is never used in operation \"").concat(operation.name.value, "\".") : "Variable \"$".concat(variableName, "\" is never used."), variableDef));
                }
            }
        },
        VariableDefinition: function VariableDefinition(def) {
            variableDefs.push(def);
        }
    };
}

});

parcelRegister("3N4Hj", function(module, exports) {

$parcel$export(module.exports, "KnownDirectivesRule", () => $2c299789e5aa218d$export$f4ca94d7d1cf5874);

var $yEDl8 = parcelRequire("yEDl8");

var $fM9AB = parcelRequire("fM9AB");

var $g5yZB = parcelRequire("g5yZB");

var $bzIlO = parcelRequire("bzIlO");

var $jADQJ = parcelRequire("jADQJ");

var $35Smo = parcelRequire("35Smo");
function $2c299789e5aa218d$export$f4ca94d7d1cf5874(context) {
    var locationsMap = Object.create(null);
    var schema = context.getSchema();
    var definedDirectives = schema ? schema.getDirectives() : (0, $35Smo.specifiedDirectives);
    for(var _i2 = 0; _i2 < definedDirectives.length; _i2++){
        var directive = definedDirectives[_i2];
        locationsMap[directive.name] = directive.locations;
    }
    var astDefinitions = context.getDocument().definitions;
    for(var _i4 = 0; _i4 < astDefinitions.length; _i4++){
        var def = astDefinitions[_i4];
        if (def.kind === (0, $bzIlO.Kind).DIRECTIVE_DEFINITION) locationsMap[def.name.value] = def.locations.map(function(name) {
            return name.value;
        });
    }
    return {
        Directive: function Directive(node, _key, _parent, _path, ancestors) {
            var name = node.name.value;
            var locations = locationsMap[name];
            if (!locations) {
                context.reportError(new (0, $g5yZB.GraphQLError)("Unknown directive \"@".concat(name, "\"."), node));
                return;
            }
            var candidateLocation = $2c299789e5aa218d$var$getDirectiveLocationForASTPath(ancestors);
            if (candidateLocation && locations.indexOf(candidateLocation) === -1) context.reportError(new (0, $g5yZB.GraphQLError)("Directive \"@".concat(name, "\" may not be used on ").concat(candidateLocation, "."), node));
        }
    };
}
function $2c299789e5aa218d$var$getDirectiveLocationForASTPath(ancestors) {
    var appliedTo = ancestors[ancestors.length - 1];
    !Array.isArray(appliedTo) || (0, $fM9AB.default)(0);
    switch(appliedTo.kind){
        case (0, $bzIlO.Kind).OPERATION_DEFINITION:
            return $2c299789e5aa218d$var$getDirectiveLocationForOperation(appliedTo.operation);
        case (0, $bzIlO.Kind).FIELD:
            return (0, $jADQJ.DirectiveLocation).FIELD;
        case (0, $bzIlO.Kind).FRAGMENT_SPREAD:
            return (0, $jADQJ.DirectiveLocation).FRAGMENT_SPREAD;
        case (0, $bzIlO.Kind).INLINE_FRAGMENT:
            return (0, $jADQJ.DirectiveLocation).INLINE_FRAGMENT;
        case (0, $bzIlO.Kind).FRAGMENT_DEFINITION:
            return (0, $jADQJ.DirectiveLocation).FRAGMENT_DEFINITION;
        case (0, $bzIlO.Kind).VARIABLE_DEFINITION:
            return (0, $jADQJ.DirectiveLocation).VARIABLE_DEFINITION;
        case (0, $bzIlO.Kind).SCHEMA_DEFINITION:
        case (0, $bzIlO.Kind).SCHEMA_EXTENSION:
            return (0, $jADQJ.DirectiveLocation).SCHEMA;
        case (0, $bzIlO.Kind).SCALAR_TYPE_DEFINITION:
        case (0, $bzIlO.Kind).SCALAR_TYPE_EXTENSION:
            return (0, $jADQJ.DirectiveLocation).SCALAR;
        case (0, $bzIlO.Kind).OBJECT_TYPE_DEFINITION:
        case (0, $bzIlO.Kind).OBJECT_TYPE_EXTENSION:
            return (0, $jADQJ.DirectiveLocation).OBJECT;
        case (0, $bzIlO.Kind).FIELD_DEFINITION:
            return (0, $jADQJ.DirectiveLocation).FIELD_DEFINITION;
        case (0, $bzIlO.Kind).INTERFACE_TYPE_DEFINITION:
        case (0, $bzIlO.Kind).INTERFACE_TYPE_EXTENSION:
            return (0, $jADQJ.DirectiveLocation).INTERFACE;
        case (0, $bzIlO.Kind).UNION_TYPE_DEFINITION:
        case (0, $bzIlO.Kind).UNION_TYPE_EXTENSION:
            return (0, $jADQJ.DirectiveLocation).UNION;
        case (0, $bzIlO.Kind).ENUM_TYPE_DEFINITION:
        case (0, $bzIlO.Kind).ENUM_TYPE_EXTENSION:
            return (0, $jADQJ.DirectiveLocation).ENUM;
        case (0, $bzIlO.Kind).ENUM_VALUE_DEFINITION:
            return (0, $jADQJ.DirectiveLocation).ENUM_VALUE;
        case (0, $bzIlO.Kind).INPUT_OBJECT_TYPE_DEFINITION:
        case (0, $bzIlO.Kind).INPUT_OBJECT_TYPE_EXTENSION:
            return (0, $jADQJ.DirectiveLocation).INPUT_OBJECT;
        case (0, $bzIlO.Kind).INPUT_VALUE_DEFINITION:
            var parentNode = ancestors[ancestors.length - 3];
            return parentNode.kind === (0, $bzIlO.Kind).INPUT_OBJECT_TYPE_DEFINITION ? (0, $jADQJ.DirectiveLocation).INPUT_FIELD_DEFINITION : (0, $jADQJ.DirectiveLocation).ARGUMENT_DEFINITION;
    }
}
function $2c299789e5aa218d$var$getDirectiveLocationForOperation(operation) {
    switch(operation){
        case 'query':
            return (0, $jADQJ.DirectiveLocation).QUERY;
        case 'mutation':
            return (0, $jADQJ.DirectiveLocation).MUTATION;
        case 'subscription':
            return (0, $jADQJ.DirectiveLocation).SUBSCRIPTION;
    } // istanbul ignore next (Not reachable. All possible types have been considered)
    (0, $fM9AB.default)(0, 'Unexpected operation: ' + (0, $yEDl8.default)(operation));
}

});

parcelRegister("VWtb8", function(module, exports) {

$parcel$export(module.exports, "UniqueDirectivesPerLocationRule", () => $0ae2add5c5a85d4e$export$4a38f68ea408504c);

var $g5yZB = parcelRequire("g5yZB");

var $bzIlO = parcelRequire("bzIlO");

var $Zbk4Z = parcelRequire("Zbk4Z");

var $35Smo = parcelRequire("35Smo");
function $0ae2add5c5a85d4e$export$4a38f68ea408504c(context) {
    var uniqueDirectiveMap = Object.create(null);
    var schema = context.getSchema();
    var definedDirectives = schema ? schema.getDirectives() : (0, $35Smo.specifiedDirectives);
    for(var _i2 = 0; _i2 < definedDirectives.length; _i2++){
        var directive = definedDirectives[_i2];
        uniqueDirectiveMap[directive.name] = !directive.isRepeatable;
    }
    var astDefinitions = context.getDocument().definitions;
    for(var _i4 = 0; _i4 < astDefinitions.length; _i4++){
        var def = astDefinitions[_i4];
        if (def.kind === (0, $bzIlO.Kind).DIRECTIVE_DEFINITION) uniqueDirectiveMap[def.name.value] = !def.repeatable;
    }
    var schemaDirectives = Object.create(null);
    var typeDirectivesMap = Object.create(null);
    return {
        // Many different AST nodes may contain directives. Rather than listing
        // them all, just listen for entering any node, and check to see if it
        // defines any directives.
        enter: function enter(node) {
            if (node.directives == null) return;
            var seenDirectives;
            if (node.kind === (0, $bzIlO.Kind).SCHEMA_DEFINITION || node.kind === (0, $bzIlO.Kind).SCHEMA_EXTENSION) seenDirectives = schemaDirectives;
            else if ((0, $Zbk4Z.isTypeDefinitionNode)(node) || (0, $Zbk4Z.isTypeExtensionNode)(node)) {
                var typeName = node.name.value;
                seenDirectives = typeDirectivesMap[typeName];
                if (seenDirectives === undefined) typeDirectivesMap[typeName] = seenDirectives = Object.create(null);
            } else seenDirectives = Object.create(null);
            for(var _i6 = 0, _node$directives2 = node.directives; _i6 < _node$directives2.length; _i6++){
                var _directive = _node$directives2[_i6];
                var directiveName = _directive.name.value;
                if (uniqueDirectiveMap[directiveName]) {
                    if (seenDirectives[directiveName]) context.reportError(new (0, $g5yZB.GraphQLError)("The directive \"@".concat(directiveName, "\" can only be used once at this location."), [
                        seenDirectives[directiveName],
                        _directive
                    ]));
                    else seenDirectives[directiveName] = _directive;
                }
            }
        }
    };
}

});

parcelRegister("9WoAw", function(module, exports) {

$parcel$export(module.exports, "KnownArgumentNamesRule", () => $73cc9a88ccecd808$export$5d7b3b4b6779c802);
$parcel$export(module.exports, "KnownArgumentNamesOnDirectivesRule", () => $73cc9a88ccecd808$export$6eb6eb4c5417f2c4);

var $h4f6N = parcelRequire("h4f6N");

var $gXVhx = parcelRequire("gXVhx");

var $g5yZB = parcelRequire("g5yZB");

var $bzIlO = parcelRequire("bzIlO");

var $35Smo = parcelRequire("35Smo");
function $73cc9a88ccecd808$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $73cc9a88ccecd808$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $73cc9a88ccecd808$var$ownKeys(Object(source), true).forEach(function(key) {
            $73cc9a88ccecd808$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $73cc9a88ccecd808$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $73cc9a88ccecd808$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $73cc9a88ccecd808$export$5d7b3b4b6779c802(context) {
    return $73cc9a88ccecd808$var$_objectSpread($73cc9a88ccecd808$var$_objectSpread({}, $73cc9a88ccecd808$export$6eb6eb4c5417f2c4(context)), {}, {
        Argument: function Argument(argNode) {
            var argDef = context.getArgument();
            var fieldDef = context.getFieldDef();
            var parentType = context.getParentType();
            if (!argDef && fieldDef && parentType) {
                var argName = argNode.name.value;
                var knownArgsNames = fieldDef.args.map(function(arg) {
                    return arg.name;
                });
                var suggestions = (0, $gXVhx.default)(argName, knownArgsNames);
                context.reportError(new (0, $g5yZB.GraphQLError)("Unknown argument \"".concat(argName, "\" on field \"").concat(parentType.name, ".").concat(fieldDef.name, "\".") + (0, $h4f6N.default)(suggestions), argNode));
            }
        }
    });
}
function $73cc9a88ccecd808$export$6eb6eb4c5417f2c4(context) {
    var directiveArgs = Object.create(null);
    var schema = context.getSchema();
    var definedDirectives = schema ? schema.getDirectives() : (0, $35Smo.specifiedDirectives);
    for(var _i2 = 0; _i2 < definedDirectives.length; _i2++){
        var directive = definedDirectives[_i2];
        directiveArgs[directive.name] = directive.args.map(function(arg) {
            return arg.name;
        });
    }
    var astDefinitions = context.getDocument().definitions;
    for(var _i4 = 0; _i4 < astDefinitions.length; _i4++){
        var def = astDefinitions[_i4];
        if (def.kind === (0, $bzIlO.Kind).DIRECTIVE_DEFINITION) {
            var _def$arguments;
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var argsNodes = (_def$arguments = def.arguments) !== null && _def$arguments !== void 0 ? _def$arguments : [];
            directiveArgs[def.name.value] = argsNodes.map(function(arg) {
                return arg.name.value;
            });
        }
    }
    return {
        Directive: function Directive(directiveNode) {
            var directiveName = directiveNode.name.value;
            var knownArgs = directiveArgs[directiveName];
            if (directiveNode.arguments && knownArgs) for(var _i6 = 0, _directiveNode$argume2 = directiveNode.arguments; _i6 < _directiveNode$argume2.length; _i6++){
                var argNode = _directiveNode$argume2[_i6];
                var argName = argNode.name.value;
                if (knownArgs.indexOf(argName) === -1) {
                    var suggestions = (0, $gXVhx.default)(argName, knownArgs);
                    context.reportError(new (0, $g5yZB.GraphQLError)("Unknown argument \"".concat(argName, "\" on directive \"@").concat(directiveName, "\".") + (0, $h4f6N.default)(suggestions), argNode));
                }
            }
            return false;
        }
    };
}

});

parcelRegister("36Mx7", function(module, exports) {

$parcel$export(module.exports, "UniqueArgumentNamesRule", () => $243794514e5ad328$export$8598b5acb1d855ca);

var $g5yZB = parcelRequire("g5yZB");
function $243794514e5ad328$export$8598b5acb1d855ca(context) {
    var knownArgNames = Object.create(null);
    return {
        Field: function Field() {
            knownArgNames = Object.create(null);
        },
        Directive: function Directive() {
            knownArgNames = Object.create(null);
        },
        Argument: function Argument(node) {
            var argName = node.name.value;
            if (knownArgNames[argName]) context.reportError(new (0, $g5yZB.GraphQLError)("There can be only one argument named \"".concat(argName, "\"."), [
                knownArgNames[argName],
                node.name
            ]));
            else knownArgNames[argName] = node.name;
            return false;
        }
    };
}

});

parcelRegister("5wBGi", function(module, exports) {

$parcel$export(module.exports, "ValuesOfCorrectTypeRule", () => $405d2ba245013b29$export$669bf87f50cfda9b);

var $isVmt = parcelRequire("isVmt");

var $aRWmX = parcelRequire("aRWmX");

var $yEDl8 = parcelRequire("yEDl8");

var $h4f6N = parcelRequire("h4f6N");

var $gXVhx = parcelRequire("gXVhx");

var $g5yZB = parcelRequire("g5yZB");

var $1c8Um = parcelRequire("1c8Um");

var $8oLgk = parcelRequire("8oLgk");
function $405d2ba245013b29$export$669bf87f50cfda9b(context) {
    return {
        ListValue: function ListValue(node) {
            // Note: TypeInfo will traverse into a list's item type, so look to the
            // parent input type to check if it is a list.
            var type = (0, $8oLgk.getNullableType)(context.getParentInputType());
            if (!(0, $8oLgk.isListType)(type)) {
                $405d2ba245013b29$var$isValidValueNode(context, node);
                return false; // Don't traverse further.
            }
        },
        ObjectValue: function ObjectValue(node) {
            var type = (0, $8oLgk.getNamedType)(context.getInputType());
            if (!(0, $8oLgk.isInputObjectType)(type)) {
                $405d2ba245013b29$var$isValidValueNode(context, node);
                return false; // Don't traverse further.
            } // Ensure every required field exists.
            var fieldNodeMap = (0, $aRWmX.default)(node.fields, function(field) {
                return field.name.value;
            });
            for(var _i2 = 0, _objectValues2 = (0, $isVmt.default)(type.getFields()); _i2 < _objectValues2.length; _i2++){
                var fieldDef = _objectValues2[_i2];
                var fieldNode = fieldNodeMap[fieldDef.name];
                if (!fieldNode && (0, $8oLgk.isRequiredInputField)(fieldDef)) {
                    var typeStr = (0, $yEDl8.default)(fieldDef.type);
                    context.reportError(new (0, $g5yZB.GraphQLError)("Field \"".concat(type.name, ".").concat(fieldDef.name, "\" of required type \"").concat(typeStr, "\" was not provided."), node));
                }
            }
        },
        ObjectField: function ObjectField(node) {
            var parentType = (0, $8oLgk.getNamedType)(context.getParentInputType());
            var fieldType = context.getInputType();
            if (!fieldType && (0, $8oLgk.isInputObjectType)(parentType)) {
                var suggestions = (0, $gXVhx.default)(node.name.value, Object.keys(parentType.getFields()));
                context.reportError(new (0, $g5yZB.GraphQLError)("Field \"".concat(node.name.value, "\" is not defined by type \"").concat(parentType.name, "\".") + (0, $h4f6N.default)(suggestions), node));
            }
        },
        NullValue: function NullValue(node) {
            var type = context.getInputType();
            if ((0, $8oLgk.isNonNullType)(type)) context.reportError(new (0, $g5yZB.GraphQLError)("Expected value of type \"".concat((0, $yEDl8.default)(type), "\", found ").concat((0, $1c8Um.print)(node), "."), node));
        },
        EnumValue: function EnumValue(node) {
            return $405d2ba245013b29$var$isValidValueNode(context, node);
        },
        IntValue: function IntValue(node) {
            return $405d2ba245013b29$var$isValidValueNode(context, node);
        },
        FloatValue: function FloatValue(node) {
            return $405d2ba245013b29$var$isValidValueNode(context, node);
        },
        StringValue: function StringValue(node) {
            return $405d2ba245013b29$var$isValidValueNode(context, node);
        },
        BooleanValue: function BooleanValue(node) {
            return $405d2ba245013b29$var$isValidValueNode(context, node);
        }
    };
}
/**
 * Any value literal may be a valid representation of a Scalar, depending on
 * that scalar type.
 */ function $405d2ba245013b29$var$isValidValueNode(context, node) {
    // Report any error at the full type expected by the location.
    var locationType = context.getInputType();
    if (!locationType) return;
    var type = (0, $8oLgk.getNamedType)(locationType);
    if (!(0, $8oLgk.isLeafType)(type)) {
        var typeStr = (0, $yEDl8.default)(locationType);
        context.reportError(new (0, $g5yZB.GraphQLError)("Expected value of type \"".concat(typeStr, "\", found ").concat((0, $1c8Um.print)(node), "."), node));
        return;
    } // Scalars and Enums determine if a literal value is valid via parseLiteral(),
    // which may throw or return an invalid value to indicate failure.
    try {
        var parseResult = type.parseLiteral(node, undefined);
        if (parseResult === undefined) {
            var _typeStr = (0, $yEDl8.default)(locationType);
            context.reportError(new (0, $g5yZB.GraphQLError)("Expected value of type \"".concat(_typeStr, "\", found ").concat((0, $1c8Um.print)(node), "."), node));
        }
    } catch (error) {
        var _typeStr2 = (0, $yEDl8.default)(locationType);
        if (error instanceof (0, $g5yZB.GraphQLError)) context.reportError(error);
        else context.reportError(new (0, $g5yZB.GraphQLError)("Expected value of type \"".concat(_typeStr2, "\", found ").concat((0, $1c8Um.print)(node), "; ") + error.message, node, undefined, undefined, undefined, error));
    }
}

});

parcelRegister("jpyH1", function(module, exports) {

$parcel$export(module.exports, "ProvidedRequiredArgumentsRule", () => $e21b436f05c5ec12$export$4df169576372c8b2);
$parcel$export(module.exports, "ProvidedRequiredArgumentsOnDirectivesRule", () => $e21b436f05c5ec12$export$5ff6a71c337c020f);

var $yEDl8 = parcelRequire("yEDl8");

var $aRWmX = parcelRequire("aRWmX");

var $g5yZB = parcelRequire("g5yZB");

var $bzIlO = parcelRequire("bzIlO");

var $1c8Um = parcelRequire("1c8Um");

var $35Smo = parcelRequire("35Smo");

var $8oLgk = parcelRequire("8oLgk");
function $e21b436f05c5ec12$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e21b436f05c5ec12$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e21b436f05c5ec12$var$ownKeys(Object(source), true).forEach(function(key) {
            $e21b436f05c5ec12$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e21b436f05c5ec12$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e21b436f05c5ec12$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e21b436f05c5ec12$export$4df169576372c8b2(context) {
    return $e21b436f05c5ec12$var$_objectSpread($e21b436f05c5ec12$var$_objectSpread({}, $e21b436f05c5ec12$export$5ff6a71c337c020f(context)), {}, {
        Field: {
            // Validate on leave to allow for deeper errors to appear first.
            leave: function leave(fieldNode) {
                var _fieldNode$arguments;
                var fieldDef = context.getFieldDef();
                if (!fieldDef) return false;
                 // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
                var argNodes = (_fieldNode$arguments = fieldNode.arguments) !== null && _fieldNode$arguments !== void 0 ? _fieldNode$arguments : [];
                var argNodeMap = (0, $aRWmX.default)(argNodes, function(arg) {
                    return arg.name.value;
                });
                for(var _i2 = 0, _fieldDef$args2 = fieldDef.args; _i2 < _fieldDef$args2.length; _i2++){
                    var argDef = _fieldDef$args2[_i2];
                    var argNode = argNodeMap[argDef.name];
                    if (!argNode && (0, $8oLgk.isRequiredArgument)(argDef)) {
                        var argTypeStr = (0, $yEDl8.default)(argDef.type);
                        context.reportError(new (0, $g5yZB.GraphQLError)("Field \"".concat(fieldDef.name, "\" argument \"").concat(argDef.name, "\" of type \"").concat(argTypeStr, "\" is required, but it was not provided."), fieldNode));
                    }
                }
            }
        }
    });
}
function $e21b436f05c5ec12$export$5ff6a71c337c020f(context) {
    var requiredArgsMap = Object.create(null);
    var schema = context.getSchema();
    var definedDirectives = schema ? schema.getDirectives() : (0, $35Smo.specifiedDirectives);
    for(var _i4 = 0; _i4 < definedDirectives.length; _i4++){
        var directive = definedDirectives[_i4];
        requiredArgsMap[directive.name] = (0, $aRWmX.default)(directive.args.filter((0, $8oLgk.isRequiredArgument)), function(arg) {
            return arg.name;
        });
    }
    var astDefinitions = context.getDocument().definitions;
    for(var _i6 = 0; _i6 < astDefinitions.length; _i6++){
        var def = astDefinitions[_i6];
        if (def.kind === (0, $bzIlO.Kind).DIRECTIVE_DEFINITION) {
            var _def$arguments;
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var argNodes = (_def$arguments = def.arguments) !== null && _def$arguments !== void 0 ? _def$arguments : [];
            requiredArgsMap[def.name.value] = (0, $aRWmX.default)(argNodes.filter($e21b436f05c5ec12$var$isRequiredArgumentNode), function(arg) {
                return arg.name.value;
            });
        }
    }
    return {
        Directive: {
            // Validate on leave to allow for deeper errors to appear first.
            leave: function leave(directiveNode) {
                var directiveName = directiveNode.name.value;
                var requiredArgs = requiredArgsMap[directiveName];
                if (requiredArgs) {
                    var _directiveNode$argume;
                    // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
                    var _argNodes = (_directiveNode$argume = directiveNode.arguments) !== null && _directiveNode$argume !== void 0 ? _directiveNode$argume : [];
                    var argNodeMap = (0, $aRWmX.default)(_argNodes, function(arg) {
                        return arg.name.value;
                    });
                    for(var _i8 = 0, _Object$keys2 = Object.keys(requiredArgs); _i8 < _Object$keys2.length; _i8++){
                        var argName = _Object$keys2[_i8];
                        if (!argNodeMap[argName]) {
                            var argType = requiredArgs[argName].type;
                            var argTypeStr = (0, $8oLgk.isType)(argType) ? (0, $yEDl8.default)(argType) : (0, $1c8Um.print)(argType);
                            context.reportError(new (0, $g5yZB.GraphQLError)("Directive \"@".concat(directiveName, "\" argument \"").concat(argName, "\" of type \"").concat(argTypeStr, "\" is required, but it was not provided."), directiveNode));
                        }
                    }
                }
            }
        }
    };
}
function $e21b436f05c5ec12$var$isRequiredArgumentNode(arg) {
    return arg.type.kind === (0, $bzIlO.Kind).NON_NULL_TYPE && arg.defaultValue == null;
}

});

parcelRegister("8gRGf", function(module, exports) {

$parcel$export(module.exports, "VariablesInAllowedPositionRule", () => $605975302951678f$export$7251631d636f2f74);

var $yEDl8 = parcelRequire("yEDl8");

var $g5yZB = parcelRequire("g5yZB");

var $bzIlO = parcelRequire("bzIlO");

var $8oLgk = parcelRequire("8oLgk");

var $6D4Eu = parcelRequire("6D4Eu");

var $9GswX = parcelRequire("9GswX");
function $605975302951678f$export$7251631d636f2f74(context) {
    var varDefMap = Object.create(null);
    return {
        OperationDefinition: {
            enter: function enter() {
                varDefMap = Object.create(null);
            },
            leave: function leave(operation) {
                var usages = context.getRecursiveVariableUsages(operation);
                for(var _i2 = 0; _i2 < usages.length; _i2++){
                    var _ref2 = usages[_i2];
                    var node = _ref2.node;
                    var type = _ref2.type;
                    var defaultValue = _ref2.defaultValue;
                    var varName = node.name.value;
                    var varDef = varDefMap[varName];
                    if (varDef && type) {
                        // A var type is allowed if it is the same or more strict (e.g. is
                        // a subtype of) than the expected type. It can be more strict if
                        // the variable type is non-null when the expected type is nullable.
                        // If both are list types, the variable item type can be more strict
                        // than the expected item type (contravariant).
                        var schema = context.getSchema();
                        var varType = (0, $6D4Eu.typeFromAST)(schema, varDef.type);
                        if (varType && !$605975302951678f$var$allowedVariableUsage(schema, varType, varDef.defaultValue, type, defaultValue)) {
                            var varTypeStr = (0, $yEDl8.default)(varType);
                            var typeStr = (0, $yEDl8.default)(type);
                            context.reportError(new (0, $g5yZB.GraphQLError)("Variable \"$".concat(varName, "\" of type \"").concat(varTypeStr, "\" used in position expecting type \"").concat(typeStr, "\"."), [
                                varDef,
                                node
                            ]));
                        }
                    }
                }
            }
        },
        VariableDefinition: function VariableDefinition(node) {
            varDefMap[node.variable.name.value] = node;
        }
    };
}
/**
 * Returns true if the variable is allowed in the location it was found,
 * which includes considering if default values exist for either the variable
 * or the location at which it is located.
 */ function $605975302951678f$var$allowedVariableUsage(schema, varType, varDefaultValue, locationType, locationDefaultValue) {
    if ((0, $8oLgk.isNonNullType)(locationType) && !(0, $8oLgk.isNonNullType)(varType)) {
        var hasNonNullVariableDefaultValue = varDefaultValue != null && varDefaultValue.kind !== (0, $bzIlO.Kind).NULL;
        var hasLocationDefaultValue = locationDefaultValue !== undefined;
        if (!hasNonNullVariableDefaultValue && !hasLocationDefaultValue) return false;
        var nullableLocationType = locationType.ofType;
        return (0, $9GswX.isTypeSubTypeOf)(schema, varType, nullableLocationType);
    }
    return (0, $9GswX.isTypeSubTypeOf)(schema, varType, locationType);
}

});

parcelRegister("gA8jd", function(module, exports) {

$parcel$export(module.exports, "OverlappingFieldsCanBeMergedRule", () => $c126741f4d796028$export$ca8652d62af5670);

var $85NSv = parcelRequire("85NSv");

var $ge05d = parcelRequire("ge05d");

var $yEDl8 = parcelRequire("yEDl8");

var $g5yZB = parcelRequire("g5yZB");

var $bzIlO = parcelRequire("bzIlO");

var $1c8Um = parcelRequire("1c8Um");

var $8oLgk = parcelRequire("8oLgk");

var $6D4Eu = parcelRequire("6D4Eu");
function $c126741f4d796028$var$reasonMessage(reason) {
    if (Array.isArray(reason)) return reason.map(function(_ref) {
        var responseName = _ref[0], subReason = _ref[1];
        return "subfields \"".concat(responseName, "\" conflict because ") + $c126741f4d796028$var$reasonMessage(subReason);
    }).join(' and ');
    return reason;
}
function $c126741f4d796028$export$ca8652d62af5670(context) {
    // A memoization for when two fragments are compared "between" each other for
    // conflicts. Two fragments may be compared many times, so memoizing this can
    // dramatically improve the performance of this validator.
    var comparedFragmentPairs = new $c126741f4d796028$var$PairSet(); // A cache for the "field map" and list of fragment names found in any given
    // selection set. Selection sets may be asked for this information multiple
    // times, so this improves the performance of this validator.
    var cachedFieldsAndFragmentNames = new Map();
    return {
        SelectionSet: function SelectionSet(selectionSet) {
            var conflicts = $c126741f4d796028$var$findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, context.getParentType(), selectionSet);
            for(var _i2 = 0; _i2 < conflicts.length; _i2++){
                var _ref3 = conflicts[_i2];
                var _ref2$ = _ref3[0];
                var responseName = _ref2$[0];
                var reason = _ref2$[1];
                var fields1 = _ref3[1];
                var fields2 = _ref3[2];
                var reasonMsg = $c126741f4d796028$var$reasonMessage(reason);
                context.reportError(new (0, $g5yZB.GraphQLError)("Fields \"".concat(responseName, "\" conflict because ").concat(reasonMsg, ". Use different aliases on the fields to fetch both if this was intentional."), fields1.concat(fields2)));
            }
        }
    };
}
/**
 * Algorithm:
 *
 * Conflicts occur when two fields exist in a query which will produce the same
 * response name, but represent differing values, thus creating a conflict.
 * The algorithm below finds all conflicts via making a series of comparisons
 * between fields. In order to compare as few fields as possible, this makes
 * a series of comparisons "within" sets of fields and "between" sets of fields.
 *
 * Given any selection set, a collection produces both a set of fields by
 * also including all inline fragments, as well as a list of fragments
 * referenced by fragment spreads.
 *
 * A) Each selection set represented in the document first compares "within" its
 * collected set of fields, finding any conflicts between every pair of
 * overlapping fields.
 * Note: This is the *only time* that a the fields "within" a set are compared
 * to each other. After this only fields "between" sets are compared.
 *
 * B) Also, if any fragment is referenced in a selection set, then a
 * comparison is made "between" the original set of fields and the
 * referenced fragment.
 *
 * C) Also, if multiple fragments are referenced, then comparisons
 * are made "between" each referenced fragment.
 *
 * D) When comparing "between" a set of fields and a referenced fragment, first
 * a comparison is made between each field in the original set of fields and
 * each field in the the referenced set of fields.
 *
 * E) Also, if any fragment is referenced in the referenced selection set,
 * then a comparison is made "between" the original set of fields and the
 * referenced fragment (recursively referring to step D).
 *
 * F) When comparing "between" two fragments, first a comparison is made between
 * each field in the first referenced set of fields and each field in the the
 * second referenced set of fields.
 *
 * G) Also, any fragments referenced by the first must be compared to the
 * second, and any fragments referenced by the second must be compared to the
 * first (recursively referring to step F).
 *
 * H) When comparing two fields, if both have selection sets, then a comparison
 * is made "between" both selection sets, first comparing the set of fields in
 * the first selection set with the set of fields in the second.
 *
 * I) Also, if any fragment is referenced in either selection set, then a
 * comparison is made "between" the other set of fields and the
 * referenced fragment.
 *
 * J) Also, if two fragments are referenced in both selection sets, then a
 * comparison is made "between" the two fragments.
 *
 */ // Find all conflicts found "within" a selection set, including those found
// via spreading in fragments. Called when visiting each SelectionSet in the
// GraphQL Document.
function $c126741f4d796028$var$findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentType, selectionSet) {
    var conflicts = [];
    var _getFieldsAndFragment = $c126741f4d796028$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet), fieldMap = _getFieldsAndFragment[0], fragmentNames = _getFieldsAndFragment[1]; // (A) Find find all conflicts "within" the fields of this selection set.
    // Note: this is the *only place* `collectConflictsWithin` is called.
    $c126741f4d796028$var$collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap);
    if (fragmentNames.length !== 0) // (B) Then collect conflicts between these fields and those represented by
    // each spread fragment name found.
    for(var i = 0; i < fragmentNames.length; i++){
        $c126741f4d796028$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, fieldMap, fragmentNames[i]); // (C) Then compare this fragment with all other fragments found in this
        // selection set to collect conflicts between fragments spread together.
        // This compares each item in the list of fragment names to every other
        // item in that same list (except for itself).
        for(var j = i + 1; j < fragmentNames.length; j++)$c126741f4d796028$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, fragmentNames[i], fragmentNames[j]);
    }
    return conflicts;
} // Collect all conflicts found between a set of fields and a fragment reference
// including via spreading in any nested fragments.
function $c126741f4d796028$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fragmentName) {
    var fragment = context.getFragment(fragmentName);
    if (!fragment) return;
    var _getReferencedFieldsA = $c126741f4d796028$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment), fieldMap2 = _getReferencedFieldsA[0], fragmentNames2 = _getReferencedFieldsA[1]; // Do not compare a fragment's fieldMap to itself.
    if (fieldMap === fieldMap2) return;
     // (D) First collect any conflicts between the provided collection of fields
    // and the collection of fields represented by the given fragment.
    $c126741f4d796028$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fieldMap2); // (E) Then collect any conflicts between the provided collection of fields
    // and any fragment names found in the given fragment.
    for(var i = 0; i < fragmentNames2.length; i++){
        var referencedFragmentName = fragmentNames2[i]; // Memoize so two fragments are not compared for conflicts more than once.
        if (comparedFragmentPairs.has(referencedFragmentName, fragmentName, areMutuallyExclusive)) continue;
        comparedFragmentPairs.add(referencedFragmentName, fragmentName, areMutuallyExclusive);
        $c126741f4d796028$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fragmentNames2[i]);
    }
} // Collect all conflicts found between two fragments, including via spreading in
// any nested fragments.
function $c126741f4d796028$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentName2) {
    // No need to compare a fragment to itself.
    if (fragmentName1 === fragmentName2) return;
     // Memoize so two fragments are not compared for conflicts more than once.
    if (comparedFragmentPairs.has(fragmentName1, fragmentName2, areMutuallyExclusive)) return;
    comparedFragmentPairs.add(fragmentName1, fragmentName2, areMutuallyExclusive);
    var fragment1 = context.getFragment(fragmentName1);
    var fragment2 = context.getFragment(fragmentName2);
    if (!fragment1 || !fragment2) return;
    var _getReferencedFieldsA2 = $c126741f4d796028$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment1), fieldMap1 = _getReferencedFieldsA2[0], fragmentNames1 = _getReferencedFieldsA2[1];
    var _getReferencedFieldsA3 = $c126741f4d796028$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment2), fieldMap2 = _getReferencedFieldsA3[0], fragmentNames2 = _getReferencedFieldsA3[1]; // (F) First, collect all conflicts between these two collections of fields
    // (not including any nested fragments).
    $c126741f4d796028$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2); // (G) Then collect conflicts between the first fragment and any nested
    // fragments spread in the second fragment.
    for(var j = 0; j < fragmentNames2.length; j++)$c126741f4d796028$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentNames2[j]);
     // (G) Then collect conflicts between the second fragment and any nested
    // fragments spread in the first fragment.
    for(var i = 0; i < fragmentNames1.length; i++)$c126741f4d796028$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentNames1[i], fragmentName2);
} // Find all conflicts found between two selection sets, including those found
// via spreading in fragments. Called when determining if conflicts exist
// between the sub-fields of two overlapping fields.
function $c126741f4d796028$var$findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, parentType1, selectionSet1, parentType2, selectionSet2) {
    var conflicts = [];
    var _getFieldsAndFragment2 = $c126741f4d796028$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType1, selectionSet1), fieldMap1 = _getFieldsAndFragment2[0], fragmentNames1 = _getFieldsAndFragment2[1];
    var _getFieldsAndFragment3 = $c126741f4d796028$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType2, selectionSet2), fieldMap2 = _getFieldsAndFragment3[0], fragmentNames2 = _getFieldsAndFragment3[1]; // (H) First, collect all conflicts between these two collections of field.
    $c126741f4d796028$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2); // (I) Then collect conflicts between the first collection of fields and
    // those referenced by each fragment name associated with the second.
    if (fragmentNames2.length !== 0) for(var j = 0; j < fragmentNames2.length; j++)$c126741f4d796028$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fragmentNames2[j]);
     // (I) Then collect conflicts between the second collection of fields and
    // those referenced by each fragment name associated with the first.
    if (fragmentNames1.length !== 0) for(var i = 0; i < fragmentNames1.length; i++)$c126741f4d796028$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap2, fragmentNames1[i]);
     // (J) Also collect conflicts between any fragment names by the first and
    // fragment names by the second. This compares each item in the first set of
    // names to each item in the second set of names.
    for(var _i3 = 0; _i3 < fragmentNames1.length; _i3++)for(var _j = 0; _j < fragmentNames2.length; _j++)$c126741f4d796028$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentNames1[_i3], fragmentNames2[_j]);
    return conflicts;
} // Collect all Conflicts "within" one collection of fields.
function $c126741f4d796028$var$collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap) {
    // A field map is a keyed collection, where each key represents a response
    // name and the value at that key is a list of all fields which provide that
    // response name. For every response name, if there are multiple fields, they
    // must be compared to find a potential conflict.
    for(var _i5 = 0, _objectEntries2 = (0, $ge05d.default)(fieldMap); _i5 < _objectEntries2.length; _i5++){
        var _ref5 = _objectEntries2[_i5];
        var responseName = _ref5[0];
        var fields = _ref5[1];
        // This compares every field in the list to every other field in this list
        // (except to itself). If the list only has one item, nothing needs to
        // be compared.
        if (fields.length > 1) {
            for(var i = 0; i < fields.length; i++)for(var j = i + 1; j < fields.length; j++){
                var conflict = $c126741f4d796028$var$findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, responseName, fields[i], fields[j]);
                if (conflict) conflicts.push(conflict);
            }
        }
    }
} // Collect all Conflicts between two collections of fields. This is similar to,
// but different from the `collectConflictsWithin` function above. This check
// assumes that `collectConflictsWithin` has already been called on each
// provided collection of fields. This is true because this validator traverses
// each individual selection set.
function $c126741f4d796028$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, fieldMap1, fieldMap2) {
    // A field map is a keyed collection, where each key represents a response
    // name and the value at that key is a list of all fields which provide that
    // response name. For any response name which appears in both provided field
    // maps, each field from the first field map must be compared to every field
    // in the second field map to find potential conflicts.
    for(var _i7 = 0, _Object$keys2 = Object.keys(fieldMap1); _i7 < _Object$keys2.length; _i7++){
        var responseName = _Object$keys2[_i7];
        var fields2 = fieldMap2[responseName];
        if (fields2) {
            var fields1 = fieldMap1[responseName];
            for(var i = 0; i < fields1.length; i++)for(var j = 0; j < fields2.length; j++){
                var conflict = $c126741f4d796028$var$findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, fields1[i], fields2[j]);
                if (conflict) conflicts.push(conflict);
            }
        }
    }
} // Determines if there is a conflict between two particular fields, including
// comparing their sub-fields.
function $c126741f4d796028$var$findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, field1, field2) {
    var parentType1 = field1[0], node1 = field1[1], def1 = field1[2];
    var parentType2 = field2[0], node2 = field2[1], def2 = field2[2]; // If it is known that two fields could not possibly apply at the same
    // time, due to the parent types, then it is safe to permit them to diverge
    // in aliased field or arguments used as they will not present any ambiguity
    // by differing.
    // It is known that two parent types could never overlap if they are
    // different Object types. Interface or Union types might overlap - if not
    // in the current state of the schema, then perhaps in some future version,
    // thus may not safely diverge.
    var areMutuallyExclusive = parentFieldsAreMutuallyExclusive || parentType1 !== parentType2 && (0, $8oLgk.isObjectType)(parentType1) && (0, $8oLgk.isObjectType)(parentType2);
    if (!areMutuallyExclusive) {
        var _node1$arguments, _node2$arguments;
        // Two aliases must refer to the same field.
        var name1 = node1.name.value;
        var name2 = node2.name.value;
        if (name1 !== name2) return [
            [
                responseName,
                "\"".concat(name1, "\" and \"").concat(name2, "\" are different fields")
            ],
            [
                node1
            ],
            [
                node2
            ]
        ];
         // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var args1 = (_node1$arguments = node1.arguments) !== null && _node1$arguments !== void 0 ? _node1$arguments : []; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var args2 = (_node2$arguments = node2.arguments) !== null && _node2$arguments !== void 0 ? _node2$arguments : []; // Two field calls must have the same arguments.
        if (!$c126741f4d796028$var$sameArguments(args1, args2)) return [
            [
                responseName,
                'they have differing arguments'
            ],
            [
                node1
            ],
            [
                node2
            ]
        ];
    } // The return type for each field.
    var type1 = def1 === null || def1 === void 0 ? void 0 : def1.type;
    var type2 = def2 === null || def2 === void 0 ? void 0 : def2.type;
    if (type1 && type2 && $c126741f4d796028$var$doTypesConflict(type1, type2)) return [
        [
            responseName,
            "they return conflicting types \"".concat((0, $yEDl8.default)(type1), "\" and \"").concat((0, $yEDl8.default)(type2), "\"")
        ],
        [
            node1
        ],
        [
            node2
        ]
    ];
     // Collect and compare sub-fields. Use the same "visited fragment names" list
    // for both collections so fields in a fragment reference are never
    // compared to themselves.
    var selectionSet1 = node1.selectionSet;
    var selectionSet2 = node2.selectionSet;
    if (selectionSet1 && selectionSet2) {
        var conflicts = $c126741f4d796028$var$findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, (0, $8oLgk.getNamedType)(type1), selectionSet1, (0, $8oLgk.getNamedType)(type2), selectionSet2);
        return $c126741f4d796028$var$subfieldConflicts(conflicts, responseName, node1, node2);
    }
}
function $c126741f4d796028$var$sameArguments(arguments1, arguments2) {
    if (arguments1.length !== arguments2.length) return false;
    return arguments1.every(function(argument1) {
        var argument2 = (0, $85NSv.default)(arguments2, function(argument) {
            return argument.name.value === argument1.name.value;
        });
        if (!argument2) return false;
        return $c126741f4d796028$var$sameValue(argument1.value, argument2.value);
    });
}
function $c126741f4d796028$var$sameValue(value1, value2) {
    return (0, $1c8Um.print)(value1) === (0, $1c8Um.print)(value2);
} // Two types conflict if both types could not apply to a value simultaneously.
// Composite types are ignored as their individual field types will be compared
// later recursively. However List and Non-Null types must match.
function $c126741f4d796028$var$doTypesConflict(type1, type2) {
    if ((0, $8oLgk.isListType)(type1)) return (0, $8oLgk.isListType)(type2) ? $c126741f4d796028$var$doTypesConflict(type1.ofType, type2.ofType) : true;
    if ((0, $8oLgk.isListType)(type2)) return true;
    if ((0, $8oLgk.isNonNullType)(type1)) return (0, $8oLgk.isNonNullType)(type2) ? $c126741f4d796028$var$doTypesConflict(type1.ofType, type2.ofType) : true;
    if ((0, $8oLgk.isNonNullType)(type2)) return true;
    if ((0, $8oLgk.isLeafType)(type1) || (0, $8oLgk.isLeafType)(type2)) return type1 !== type2;
    return false;
} // Given a selection set, return the collection of fields (a mapping of response
// name to field nodes and definitions) as well as a list of fragment names
// referenced via fragment spreads.
function $c126741f4d796028$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet) {
    var cached = cachedFieldsAndFragmentNames.get(selectionSet);
    if (!cached) {
        var nodeAndDefs = Object.create(null);
        var fragmentNames = Object.create(null);
        $c126741f4d796028$var$_collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames);
        cached = [
            nodeAndDefs,
            Object.keys(fragmentNames)
        ];
        cachedFieldsAndFragmentNames.set(selectionSet, cached);
    }
    return cached;
} // Given a reference to a fragment, return the represented collection of fields
// as well as a list of nested fragment names referenced via fragment spreads.
function $c126741f4d796028$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment) {
    // Short-circuit building a type from the node if possible.
    var cached = cachedFieldsAndFragmentNames.get(fragment.selectionSet);
    if (cached) return cached;
    var fragmentType = (0, $6D4Eu.typeFromAST)(context.getSchema(), fragment.typeCondition);
    return $c126741f4d796028$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragmentType, fragment.selectionSet);
}
function $c126741f4d796028$var$_collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames) {
    for(var _i9 = 0, _selectionSet$selecti2 = selectionSet.selections; _i9 < _selectionSet$selecti2.length; _i9++){
        var selection = _selectionSet$selecti2[_i9];
        switch(selection.kind){
            case (0, $bzIlO.Kind).FIELD:
                var fieldName = selection.name.value;
                var fieldDef = void 0;
                if ((0, $8oLgk.isObjectType)(parentType) || (0, $8oLgk.isInterfaceType)(parentType)) fieldDef = parentType.getFields()[fieldName];
                var responseName = selection.alias ? selection.alias.value : fieldName;
                if (!nodeAndDefs[responseName]) nodeAndDefs[responseName] = [];
                nodeAndDefs[responseName].push([
                    parentType,
                    selection,
                    fieldDef
                ]);
                break;
            case (0, $bzIlO.Kind).FRAGMENT_SPREAD:
                fragmentNames[selection.name.value] = true;
                break;
            case (0, $bzIlO.Kind).INLINE_FRAGMENT:
                var typeCondition = selection.typeCondition;
                var inlineFragmentType = typeCondition ? (0, $6D4Eu.typeFromAST)(context.getSchema(), typeCondition) : parentType;
                $c126741f4d796028$var$_collectFieldsAndFragmentNames(context, inlineFragmentType, selection.selectionSet, nodeAndDefs, fragmentNames);
                break;
        }
    }
} // Given a series of Conflicts which occurred between two sub-fields, generate
// a single Conflict.
function $c126741f4d796028$var$subfieldConflicts(conflicts, responseName, node1, node2) {
    if (conflicts.length > 0) return [
        [
            responseName,
            conflicts.map(function(_ref6) {
                var reason = _ref6[0];
                return reason;
            })
        ],
        conflicts.reduce(function(allFields, _ref7) {
            var fields1 = _ref7[1];
            return allFields.concat(fields1);
        }, [
            node1
        ]),
        conflicts.reduce(function(allFields, _ref8) {
            var fields2 = _ref8[2];
            return allFields.concat(fields2);
        }, [
            node2
        ])
    ];
}
/**
 * A way to keep track of pairs of things when the ordering of the pair does
 * not matter. We do this by maintaining a sort of double adjacency sets.
 */ var $c126741f4d796028$var$PairSet = /*#__PURE__*/ function() {
    function PairSet() {
        this._data = Object.create(null);
    }
    var _proto = PairSet.prototype;
    _proto.has = function has(a, b, areMutuallyExclusive) {
        var first = this._data[a];
        var result = first && first[b];
        if (result === undefined) return false;
         // areMutuallyExclusive being false is a superset of being true,
        // hence if we want to know if this PairSet "has" these two with no
        // exclusivity, we have to ensure it was added as such.
        if (areMutuallyExclusive === false) return result === false;
        return true;
    };
    _proto.add = function add(a, b, areMutuallyExclusive) {
        this._pairSetAdd(a, b, areMutuallyExclusive);
        this._pairSetAdd(b, a, areMutuallyExclusive);
    };
    _proto._pairSetAdd = function _pairSetAdd(a, b, areMutuallyExclusive) {
        var map = this._data[a];
        if (!map) {
            map = Object.create(null);
            this._data[a] = map;
        }
        map[b] = areMutuallyExclusive;
    };
    return PairSet;
}();

});

parcelRegister("dAQg3", function(module, exports) {

$parcel$export(module.exports, "UniqueInputFieldNamesRule", () => $9e572c7b7d0b165f$export$de7865c052ebdd8c);

var $g5yZB = parcelRequire("g5yZB");
function $9e572c7b7d0b165f$export$de7865c052ebdd8c(context) {
    var knownNameStack = [];
    var knownNames = Object.create(null);
    return {
        ObjectValue: {
            enter: function enter() {
                knownNameStack.push(knownNames);
                knownNames = Object.create(null);
            },
            leave: function leave() {
                knownNames = knownNameStack.pop();
            }
        },
        ObjectField: function ObjectField(node) {
            var fieldName = node.name.value;
            if (knownNames[fieldName]) context.reportError(new (0, $g5yZB.GraphQLError)("There can be only one input field named \"".concat(fieldName, "\"."), [
                knownNames[fieldName],
                node.name
            ]));
            else knownNames[fieldName] = node.name;
        }
    };
}

});

parcelRegister("66C9m", function(module, exports) {

$parcel$export(module.exports, "MaxIntrospectionDepthRule", () => $4720e5619497e6f3$export$a81aa1cd0a710ef);

var $g5yZB = parcelRequire("g5yZB");

var $bzIlO = parcelRequire("bzIlO");
var $4720e5619497e6f3$var$MAX_LISTS_DEPTH = 3;
function $4720e5619497e6f3$export$a81aa1cd0a710ef(context) {
    /**
   * Counts the depth of list fields in "__Type" recursively and
   * returns `true` if the limit has been reached.
   */ function checkDepth(node) {
        var visitedFragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.create(null);
        var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        if (node.kind === (0, $bzIlO.Kind).FRAGMENT_SPREAD) {
            var _fragmentName = node.name.value;
            if (visitedFragments[_fragmentName] === true) // Fragment cycles are handled by `NoFragmentCyclesRule`.
            return false;
            var fragment = context.getFragment(_fragmentName);
            if (!fragment) // Missing fragments checks are handled by `KnownFragmentNamesRule`.
            return false;
             // Rather than following an immutable programming pattern which has
            // significant memory and garbage collection overhead, we've opted to
            // take a mutable approach for efficiency's sake. Importantly visiting a
            // fragment twice is fine, so long as you don't do one visit inside the
            // other.
            try {
                visitedFragments[_fragmentName] = true;
                return checkDepth(fragment, visitedFragments, depth);
            } finally{
                visitedFragments[_fragmentName] = null;
            }
        }
        if (node.kind === (0, $bzIlO.Kind).FIELD && (node.name.value === 'fields' || node.name.value === 'interfaces' || node.name.value === 'possibleTypes' || node.name.value === 'inputFields')) {
            // $FlowFixMe[reassign-const] why are argument parameters treated as const in flow?
            depth++; // eslint-disable-line no-param-reassign
            if (depth >= $4720e5619497e6f3$var$MAX_LISTS_DEPTH) return true;
        } // handles fields and inline fragments
        if ('selectionSet' in node && node.selectionSet) for(var _i2 = 0, _node$selectionSet$se2 = node.selectionSet.selections; _i2 < _node$selectionSet$se2.length; _i2++){
            var child = _node$selectionSet$se2[_i2];
            if (checkDepth(child, visitedFragments, depth)) return true;
        }
        return false;
    }
    return {
        Field: function Field(node) {
            if (node.name.value === '__schema' || node.name.value === '__type') {
                if (checkDepth(node)) {
                    context.reportError(new (0, $g5yZB.GraphQLError)('Maximum introspection depth exceeded', [
                        node
                    ]));
                    return false;
                }
            }
        }
    };
}

});

parcelRegister("beSbb", function(module, exports) {

$parcel$export(module.exports, "LoneSchemaDefinitionRule", () => $82eb0766008462c1$export$9eae4c44f9d64405);

var $g5yZB = parcelRequire("g5yZB");
function $82eb0766008462c1$export$9eae4c44f9d64405(context) {
    var _ref, _ref2, _oldSchema$astNode;
    var oldSchema = context.getSchema();
    var alreadyDefined = (_ref = (_ref2 = (_oldSchema$astNode = oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.astNode) !== null && _oldSchema$astNode !== void 0 ? _oldSchema$astNode : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getQueryType()) !== null && _ref2 !== void 0 ? _ref2 : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getMutationType()) !== null && _ref !== void 0 ? _ref : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getSubscriptionType();
    var schemaDefinitionsCount = 0;
    return {
        SchemaDefinition: function SchemaDefinition(node) {
            if (alreadyDefined) {
                context.reportError(new (0, $g5yZB.GraphQLError)('Cannot define a new schema within a schema extension.', node));
                return;
            }
            if (schemaDefinitionsCount > 0) context.reportError(new (0, $g5yZB.GraphQLError)('Must provide only one schema definition.', node));
            ++schemaDefinitionsCount;
        }
    };
}

});

parcelRegister("gBAc1", function(module, exports) {

$parcel$export(module.exports, "UniqueOperationTypesRule", () => $c16c2d2ce33c43fe$export$d9750570c6d13894);

var $g5yZB = parcelRequire("g5yZB");
function $c16c2d2ce33c43fe$export$d9750570c6d13894(context) {
    var schema = context.getSchema();
    var definedOperationTypes = Object.create(null);
    var existingOperationTypes = schema ? {
        query: schema.getQueryType(),
        mutation: schema.getMutationType(),
        subscription: schema.getSubscriptionType()
    } : {};
    return {
        SchemaDefinition: checkOperationTypes,
        SchemaExtension: checkOperationTypes
    };
    function checkOperationTypes(node) {
        var _node$operationTypes;
        // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var operationTypesNodes = (_node$operationTypes = node.operationTypes) !== null && _node$operationTypes !== void 0 ? _node$operationTypes : [];
        for(var _i2 = 0; _i2 < operationTypesNodes.length; _i2++){
            var operationType = operationTypesNodes[_i2];
            var operation = operationType.operation;
            var alreadyDefinedOperationType = definedOperationTypes[operation];
            if (existingOperationTypes[operation]) context.reportError(new (0, $g5yZB.GraphQLError)("Type for ".concat(operation, " already defined in the schema. It cannot be redefined."), operationType));
            else if (alreadyDefinedOperationType) context.reportError(new (0, $g5yZB.GraphQLError)("There can be only one ".concat(operation, " type in schema."), [
                alreadyDefinedOperationType,
                operationType
            ]));
            else definedOperationTypes[operation] = operationType;
        }
        return false;
    }
}

});

parcelRegister("3iH5k", function(module, exports) {

$parcel$export(module.exports, "UniqueTypeNamesRule", () => $2674794b3064400c$export$380307ee0123f80e);

var $g5yZB = parcelRequire("g5yZB");
function $2674794b3064400c$export$380307ee0123f80e(context) {
    var knownTypeNames = Object.create(null);
    var schema = context.getSchema();
    return {
        ScalarTypeDefinition: checkTypeName,
        ObjectTypeDefinition: checkTypeName,
        InterfaceTypeDefinition: checkTypeName,
        UnionTypeDefinition: checkTypeName,
        EnumTypeDefinition: checkTypeName,
        InputObjectTypeDefinition: checkTypeName
    };
    function checkTypeName(node) {
        var typeName = node.name.value;
        if (schema !== null && schema !== void 0 && schema.getType(typeName)) {
            context.reportError(new (0, $g5yZB.GraphQLError)("Type \"".concat(typeName, "\" already exists in the schema. It cannot also be defined in this type definition."), node.name));
            return;
        }
        if (knownTypeNames[typeName]) context.reportError(new (0, $g5yZB.GraphQLError)("There can be only one type named \"".concat(typeName, "\"."), [
            knownTypeNames[typeName],
            node.name
        ]));
        else knownTypeNames[typeName] = node.name;
        return false;
    }
}

});

parcelRegister("j74Ua", function(module, exports) {

$parcel$export(module.exports, "UniqueEnumValueNamesRule", () => $dea279ceaaf7e545$export$f5a22bb45cdc635d);

var $g5yZB = parcelRequire("g5yZB");

var $8oLgk = parcelRequire("8oLgk");
function $dea279ceaaf7e545$export$f5a22bb45cdc635d(context) {
    var schema = context.getSchema();
    var existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
    var knownValueNames = Object.create(null);
    return {
        EnumTypeDefinition: checkValueUniqueness,
        EnumTypeExtension: checkValueUniqueness
    };
    function checkValueUniqueness(node) {
        var _node$values;
        var typeName = node.name.value;
        if (!knownValueNames[typeName]) knownValueNames[typeName] = Object.create(null);
         // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var valueNodes = (_node$values = node.values) !== null && _node$values !== void 0 ? _node$values : [];
        var valueNames = knownValueNames[typeName];
        for(var _i2 = 0; _i2 < valueNodes.length; _i2++){
            var valueDef = valueNodes[_i2];
            var valueName = valueDef.name.value;
            var existingType = existingTypeMap[typeName];
            if ((0, $8oLgk.isEnumType)(existingType) && existingType.getValue(valueName)) context.reportError(new (0, $g5yZB.GraphQLError)("Enum value \"".concat(typeName, ".").concat(valueName, "\" already exists in the schema. It cannot also be defined in this type extension."), valueDef.name));
            else if (valueNames[valueName]) context.reportError(new (0, $g5yZB.GraphQLError)("Enum value \"".concat(typeName, ".").concat(valueName, "\" can only be defined once."), [
                valueNames[valueName],
                valueDef.name
            ]));
            else valueNames[valueName] = valueDef.name;
        }
        return false;
    }
}

});

parcelRegister("9mu02", function(module, exports) {

$parcel$export(module.exports, "UniqueFieldDefinitionNamesRule", () => $6d0d7072a4eb089d$export$b3dfc0de81924308);

var $g5yZB = parcelRequire("g5yZB");

var $8oLgk = parcelRequire("8oLgk");
function $6d0d7072a4eb089d$export$b3dfc0de81924308(context) {
    var schema = context.getSchema();
    var existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
    var knownFieldNames = Object.create(null);
    return {
        InputObjectTypeDefinition: checkFieldUniqueness,
        InputObjectTypeExtension: checkFieldUniqueness,
        InterfaceTypeDefinition: checkFieldUniqueness,
        InterfaceTypeExtension: checkFieldUniqueness,
        ObjectTypeDefinition: checkFieldUniqueness,
        ObjectTypeExtension: checkFieldUniqueness
    };
    function checkFieldUniqueness(node) {
        var _node$fields;
        var typeName = node.name.value;
        if (!knownFieldNames[typeName]) knownFieldNames[typeName] = Object.create(null);
         // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var fieldNodes = (_node$fields = node.fields) !== null && _node$fields !== void 0 ? _node$fields : [];
        var fieldNames = knownFieldNames[typeName];
        for(var _i2 = 0; _i2 < fieldNodes.length; _i2++){
            var fieldDef = fieldNodes[_i2];
            var fieldName = fieldDef.name.value;
            if ($6d0d7072a4eb089d$var$hasField(existingTypeMap[typeName], fieldName)) context.reportError(new (0, $g5yZB.GraphQLError)("Field \"".concat(typeName, ".").concat(fieldName, "\" already exists in the schema. It cannot also be defined in this type extension."), fieldDef.name));
            else if (fieldNames[fieldName]) context.reportError(new (0, $g5yZB.GraphQLError)("Field \"".concat(typeName, ".").concat(fieldName, "\" can only be defined once."), [
                fieldNames[fieldName],
                fieldDef.name
            ]));
            else fieldNames[fieldName] = fieldDef.name;
        }
        return false;
    }
}
function $6d0d7072a4eb089d$var$hasField(type, fieldName) {
    if ((0, $8oLgk.isObjectType)(type) || (0, $8oLgk.isInterfaceType)(type) || (0, $8oLgk.isInputObjectType)(type)) return type.getFields()[fieldName] != null;
    return false;
}

});

parcelRegister("6i9pg", function(module, exports) {

$parcel$export(module.exports, "UniqueDirectiveNamesRule", () => $494bb872ab7f38a5$export$b06952068b20c86f);

var $g5yZB = parcelRequire("g5yZB");
function $494bb872ab7f38a5$export$b06952068b20c86f(context) {
    var knownDirectiveNames = Object.create(null);
    var schema = context.getSchema();
    return {
        DirectiveDefinition: function DirectiveDefinition(node) {
            var directiveName = node.name.value;
            if (schema !== null && schema !== void 0 && schema.getDirective(directiveName)) {
                context.reportError(new (0, $g5yZB.GraphQLError)("Directive \"@".concat(directiveName, "\" already exists in the schema. It cannot be redefined."), node.name));
                return;
            }
            if (knownDirectiveNames[directiveName]) context.reportError(new (0, $g5yZB.GraphQLError)("There can be only one directive named \"@".concat(directiveName, "\"."), [
                knownDirectiveNames[directiveName],
                node.name
            ]));
            else knownDirectiveNames[directiveName] = node.name;
            return false;
        }
    };
}

});

parcelRegister("ixjnC", function(module, exports) {

$parcel$export(module.exports, "PossibleTypeExtensionsRule", () => $d7ea578843014dc3$export$50309357bc4f0e8b);

var $yEDl8 = parcelRequire("yEDl8");

var $fM9AB = parcelRequire("fM9AB");

var $h4f6N = parcelRequire("h4f6N");

var $gXVhx = parcelRequire("gXVhx");

var $g5yZB = parcelRequire("g5yZB");

var $bzIlO = parcelRequire("bzIlO");

var $Zbk4Z = parcelRequire("Zbk4Z");

var $8oLgk = parcelRequire("8oLgk");
var $d7ea578843014dc3$var$_defKindToExtKind;
function $d7ea578843014dc3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d7ea578843014dc3$export$50309357bc4f0e8b(context) {
    var schema = context.getSchema();
    var definedTypes = Object.create(null);
    for(var _i2 = 0, _context$getDocument$2 = context.getDocument().definitions; _i2 < _context$getDocument$2.length; _i2++){
        var def = _context$getDocument$2[_i2];
        if ((0, $Zbk4Z.isTypeDefinitionNode)(def)) definedTypes[def.name.value] = def;
    }
    return {
        ScalarTypeExtension: checkExtension,
        ObjectTypeExtension: checkExtension,
        InterfaceTypeExtension: checkExtension,
        UnionTypeExtension: checkExtension,
        EnumTypeExtension: checkExtension,
        InputObjectTypeExtension: checkExtension
    };
    function checkExtension(node) {
        var typeName = node.name.value;
        var defNode = definedTypes[typeName];
        var existingType = schema === null || schema === void 0 ? void 0 : schema.getType(typeName);
        var expectedKind;
        if (defNode) expectedKind = $d7ea578843014dc3$var$defKindToExtKind[defNode.kind];
        else if (existingType) expectedKind = $d7ea578843014dc3$var$typeToExtKind(existingType);
        if (expectedKind) {
            if (expectedKind !== node.kind) {
                var kindStr = $d7ea578843014dc3$var$extensionKindToTypeName(node.kind);
                context.reportError(new (0, $g5yZB.GraphQLError)("Cannot extend non-".concat(kindStr, " type \"").concat(typeName, "\"."), defNode ? [
                    defNode,
                    node
                ] : node));
            }
        } else {
            var allTypeNames = Object.keys(definedTypes);
            if (schema) allTypeNames = allTypeNames.concat(Object.keys(schema.getTypeMap()));
            var suggestedTypes = (0, $gXVhx.default)(typeName, allTypeNames);
            context.reportError(new (0, $g5yZB.GraphQLError)("Cannot extend type \"".concat(typeName, "\" because it is not defined.") + (0, $h4f6N.default)(suggestedTypes), node.name));
        }
    }
}
var $d7ea578843014dc3$var$defKindToExtKind = ($d7ea578843014dc3$var$_defKindToExtKind = {}, $d7ea578843014dc3$var$_defineProperty($d7ea578843014dc3$var$_defKindToExtKind, (0, $bzIlO.Kind).SCALAR_TYPE_DEFINITION, (0, $bzIlO.Kind).SCALAR_TYPE_EXTENSION), $d7ea578843014dc3$var$_defineProperty($d7ea578843014dc3$var$_defKindToExtKind, (0, $bzIlO.Kind).OBJECT_TYPE_DEFINITION, (0, $bzIlO.Kind).OBJECT_TYPE_EXTENSION), $d7ea578843014dc3$var$_defineProperty($d7ea578843014dc3$var$_defKindToExtKind, (0, $bzIlO.Kind).INTERFACE_TYPE_DEFINITION, (0, $bzIlO.Kind).INTERFACE_TYPE_EXTENSION), $d7ea578843014dc3$var$_defineProperty($d7ea578843014dc3$var$_defKindToExtKind, (0, $bzIlO.Kind).UNION_TYPE_DEFINITION, (0, $bzIlO.Kind).UNION_TYPE_EXTENSION), $d7ea578843014dc3$var$_defineProperty($d7ea578843014dc3$var$_defKindToExtKind, (0, $bzIlO.Kind).ENUM_TYPE_DEFINITION, (0, $bzIlO.Kind).ENUM_TYPE_EXTENSION), $d7ea578843014dc3$var$_defineProperty($d7ea578843014dc3$var$_defKindToExtKind, (0, $bzIlO.Kind).INPUT_OBJECT_TYPE_DEFINITION, (0, $bzIlO.Kind).INPUT_OBJECT_TYPE_EXTENSION), $d7ea578843014dc3$var$_defKindToExtKind);
function $d7ea578843014dc3$var$typeToExtKind(type) {
    if ((0, $8oLgk.isScalarType)(type)) return (0, $bzIlO.Kind).SCALAR_TYPE_EXTENSION;
    if ((0, $8oLgk.isObjectType)(type)) return (0, $bzIlO.Kind).OBJECT_TYPE_EXTENSION;
    if ((0, $8oLgk.isInterfaceType)(type)) return (0, $bzIlO.Kind).INTERFACE_TYPE_EXTENSION;
    if ((0, $8oLgk.isUnionType)(type)) return (0, $bzIlO.Kind).UNION_TYPE_EXTENSION;
    if ((0, $8oLgk.isEnumType)(type)) return (0, $bzIlO.Kind).ENUM_TYPE_EXTENSION;
     // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $8oLgk.isInputObjectType)(type)) return (0, $bzIlO.Kind).INPUT_OBJECT_TYPE_EXTENSION;
     // istanbul ignore next (Not reachable. All possible types have been considered)
    (0, $fM9AB.default)(0, 'Unexpected type: ' + (0, $yEDl8.default)(type));
}
function $d7ea578843014dc3$var$extensionKindToTypeName(kind) {
    switch(kind){
        case (0, $bzIlO.Kind).SCALAR_TYPE_EXTENSION:
            return 'scalar';
        case (0, $bzIlO.Kind).OBJECT_TYPE_EXTENSION:
            return 'object';
        case (0, $bzIlO.Kind).INTERFACE_TYPE_EXTENSION:
            return 'interface';
        case (0, $bzIlO.Kind).UNION_TYPE_EXTENSION:
            return 'union';
        case (0, $bzIlO.Kind).ENUM_TYPE_EXTENSION:
            return 'enum';
        case (0, $bzIlO.Kind).INPUT_OBJECT_TYPE_EXTENSION:
            return 'input object';
    } // istanbul ignore next (Not reachable. All possible types have been considered)
    (0, $fM9AB.default)(0, 'Unexpected kind: ' + (0, $yEDl8.default)(kind));
}

});


parcelRegister("1zF5q", function(module, exports) {

$parcel$export(module.exports, "SDLValidationContext", () => $1258ee3b2554d4d5$export$62ce401b55355c79);
$parcel$export(module.exports, "ValidationContext", () => $1258ee3b2554d4d5$export$d452675449e81987);

var $bzIlO = parcelRequire("bzIlO");

var $12QNw = parcelRequire("12QNw");

var $jjG8c = parcelRequire("jjG8c");
function $1258ee3b2554d4d5$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $1258ee3b2554d4d5$export$ebdf7b7a2f7aef8b = /*#__PURE__*/ function() {
    function ASTValidationContext(ast, onError) {
        this._ast = ast;
        this._fragments = undefined;
        this._fragmentSpreads = new Map();
        this._recursivelyReferencedFragments = new Map();
        this._onError = onError;
    }
    var _proto = ASTValidationContext.prototype;
    _proto.reportError = function reportError(error) {
        this._onError(error);
    };
    _proto.getDocument = function getDocument() {
        return this._ast;
    };
    _proto.getFragment = function getFragment(name) {
        var fragments = this._fragments;
        if (!fragments) this._fragments = fragments = this.getDocument().definitions.reduce(function(frags, statement) {
            if (statement.kind === (0, $bzIlO.Kind).FRAGMENT_DEFINITION) frags[statement.name.value] = statement;
            return frags;
        }, Object.create(null));
        return fragments[name];
    };
    _proto.getFragmentSpreads = function getFragmentSpreads(node) {
        var spreads = this._fragmentSpreads.get(node);
        if (!spreads) {
            spreads = [];
            var setsToVisit = [
                node
            ];
            while(setsToVisit.length !== 0){
                var set = setsToVisit.pop();
                for(var _i2 = 0, _set$selections2 = set.selections; _i2 < _set$selections2.length; _i2++){
                    var selection = _set$selections2[_i2];
                    if (selection.kind === (0, $bzIlO.Kind).FRAGMENT_SPREAD) spreads.push(selection);
                    else if (selection.selectionSet) setsToVisit.push(selection.selectionSet);
                }
            }
            this._fragmentSpreads.set(node, spreads);
        }
        return spreads;
    };
    _proto.getRecursivelyReferencedFragments = function getRecursivelyReferencedFragments(operation) {
        var fragments = this._recursivelyReferencedFragments.get(operation);
        if (!fragments) {
            fragments = [];
            var collectedNames = Object.create(null);
            var nodesToVisit = [
                operation.selectionSet
            ];
            while(nodesToVisit.length !== 0){
                var node = nodesToVisit.pop();
                for(var _i4 = 0, _this$getFragmentSpre2 = this.getFragmentSpreads(node); _i4 < _this$getFragmentSpre2.length; _i4++){
                    var spread = _this$getFragmentSpre2[_i4];
                    var fragName = spread.name.value;
                    if (collectedNames[fragName] !== true) {
                        collectedNames[fragName] = true;
                        var fragment = this.getFragment(fragName);
                        if (fragment) {
                            fragments.push(fragment);
                            nodesToVisit.push(fragment.selectionSet);
                        }
                    }
                }
            }
            this._recursivelyReferencedFragments.set(operation, fragments);
        }
        return fragments;
    };
    return ASTValidationContext;
}();
var $1258ee3b2554d4d5$export$62ce401b55355c79 = /*#__PURE__*/ function(_ASTValidationContext) {
    $1258ee3b2554d4d5$var$_inheritsLoose(SDLValidationContext, _ASTValidationContext);
    function SDLValidationContext(ast, schema, onError) {
        var _this;
        _this = _ASTValidationContext.call(this, ast, onError) || this;
        _this._schema = schema;
        return _this;
    }
    var _proto2 = SDLValidationContext.prototype;
    _proto2.getSchema = function getSchema() {
        return this._schema;
    };
    return SDLValidationContext;
}($1258ee3b2554d4d5$export$ebdf7b7a2f7aef8b);
var $1258ee3b2554d4d5$export$d452675449e81987 = /*#__PURE__*/ function(_ASTValidationContext2) {
    $1258ee3b2554d4d5$var$_inheritsLoose(ValidationContext, _ASTValidationContext2);
    function ValidationContext(schema, ast, typeInfo, onError) {
        var _this2;
        _this2 = _ASTValidationContext2.call(this, ast, onError) || this;
        _this2._schema = schema;
        _this2._typeInfo = typeInfo;
        _this2._variableUsages = new Map();
        _this2._recursiveVariableUsages = new Map();
        return _this2;
    }
    var _proto3 = ValidationContext.prototype;
    _proto3.getSchema = function getSchema() {
        return this._schema;
    };
    _proto3.getVariableUsages = function getVariableUsages(node) {
        var usages = this._variableUsages.get(node);
        if (!usages) {
            var newUsages = [];
            var typeInfo = new (0, $jjG8c.TypeInfo)(this._schema);
            (0, $12QNw.visit)(node, (0, $jjG8c.visitWithTypeInfo)(typeInfo, {
                VariableDefinition: function VariableDefinition() {
                    return false;
                },
                Variable: function Variable(variable) {
                    newUsages.push({
                        node: variable,
                        type: typeInfo.getInputType(),
                        defaultValue: typeInfo.getDefaultValue()
                    });
                }
            }));
            usages = newUsages;
            this._variableUsages.set(node, usages);
        }
        return usages;
    };
    _proto3.getRecursiveVariableUsages = function getRecursiveVariableUsages(operation) {
        var usages = this._recursiveVariableUsages.get(operation);
        if (!usages) {
            usages = this.getVariableUsages(operation);
            for(var _i6 = 0, _this$getRecursivelyR2 = this.getRecursivelyReferencedFragments(operation); _i6 < _this$getRecursivelyR2.length; _i6++){
                var frag = _this$getRecursivelyR2[_i6];
                usages = usages.concat(this.getVariableUsages(frag));
            }
            this._recursiveVariableUsages.set(operation, usages);
        }
        return usages;
    };
    _proto3.getType = function getType() {
        return this._typeInfo.getType();
    };
    _proto3.getParentType = function getParentType() {
        return this._typeInfo.getParentType();
    };
    _proto3.getInputType = function getInputType() {
        return this._typeInfo.getInputType();
    };
    _proto3.getParentInputType = function getParentInputType() {
        return this._typeInfo.getParentInputType();
    };
    _proto3.getFieldDef = function getFieldDef() {
        return this._typeInfo.getFieldDef();
    };
    _proto3.getDirective = function getDirective() {
        return this._typeInfo.getDirective();
    };
    _proto3.getArgument = function getArgument() {
        return this._typeInfo.getArgument();
    };
    _proto3.getEnumValue = function getEnumValue() {
        return this._typeInfo.getEnumValue();
    };
    return ValidationContext;
}($1258ee3b2554d4d5$export$ebdf7b7a2f7aef8b);

});


parcelRegister("8mJYM", function(module, exports) {

$parcel$export(module.exports, "extendSchema", () => $61740b5c0596c7dc$export$35f5fe5f3e862ea3);
$parcel$export(module.exports, "extendSchemaImpl", () => $61740b5c0596c7dc$export$97eac8f938300c6f);
$parcel$export(module.exports, "getDescription", () => $61740b5c0596c7dc$export$67580b1c13935958);

var $isVmt = parcelRequire("isVmt");

var $aRWmX = parcelRequire("aRWmX");

var $yEDl8 = parcelRequire("yEDl8");

var $eqSe6 = parcelRequire("eqSe6");

var $fM9AB = parcelRequire("fM9AB");

var $a1qmV = parcelRequire("a1qmV");

var $bzIlO = parcelRequire("bzIlO");

var $2z7TS = parcelRequire("2z7TS");

var $541Mz = parcelRequire("541Mz");

var $Zbk4Z = parcelRequire("Zbk4Z");

var $c6jur = parcelRequire("c6jur");

var $7dqoX = parcelRequire("7dqoX");

var $lUVCX = parcelRequire("lUVCX");

var $djKly = parcelRequire("djKly");

var $4Hpke = parcelRequire("4Hpke");

var $35Smo = parcelRequire("35Smo");

var $8oLgk = parcelRequire("8oLgk");

var $9aGhX = parcelRequire("9aGhX");
function $61740b5c0596c7dc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $61740b5c0596c7dc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $61740b5c0596c7dc$var$ownKeys(Object(source), true).forEach(function(key) {
            $61740b5c0596c7dc$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $61740b5c0596c7dc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $61740b5c0596c7dc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $61740b5c0596c7dc$export$35f5fe5f3e862ea3(schema, documentAST, options) {
    (0, $lUVCX.assertSchema)(schema);
    documentAST != null && documentAST.kind === (0, $bzIlO.Kind).DOCUMENT || (0, $a1qmV.default)(0, 'Must provide valid Document AST.');
    if ((options === null || options === void 0 ? void 0 : options.assumeValid) !== true && (options === null || options === void 0 ? void 0 : options.assumeValidSDL) !== true) (0, $c6jur.assertValidSDLExtension)(documentAST, schema);
    var schemaConfig = schema.toConfig();
    var extendedConfig = $61740b5c0596c7dc$export$97eac8f938300c6f(schemaConfig, documentAST, options);
    return schemaConfig === extendedConfig ? schema : new (0, $lUVCX.GraphQLSchema)(extendedConfig);
}
function $61740b5c0596c7dc$export$97eac8f938300c6f(schemaConfig, documentAST, options) {
    var _schemaDef, _schemaDef$descriptio, _schemaDef2, _options$assumeValid;
    // Collect the type definitions and extensions found in the document.
    var typeDefs = [];
    var typeExtensionsMap = Object.create(null); // New directives and types are separate because a directives and types can
    // have the same name. For example, a type named "skip".
    var directiveDefs = [];
    var schemaDef; // Schema extensions are collected which may add additional operation types.
    var schemaExtensions = [];
    for(var _i2 = 0, _documentAST$definiti2 = documentAST.definitions; _i2 < _documentAST$definiti2.length; _i2++){
        var def = _documentAST$definiti2[_i2];
        if (def.kind === (0, $bzIlO.Kind).SCHEMA_DEFINITION) schemaDef = def;
        else if (def.kind === (0, $bzIlO.Kind).SCHEMA_EXTENSION) schemaExtensions.push(def);
        else if ((0, $Zbk4Z.isTypeDefinitionNode)(def)) typeDefs.push(def);
        else if ((0, $Zbk4Z.isTypeExtensionNode)(def)) {
            var extendedTypeName = def.name.value;
            var existingTypeExtensions = typeExtensionsMap[extendedTypeName];
            typeExtensionsMap[extendedTypeName] = existingTypeExtensions ? existingTypeExtensions.concat([
                def
            ]) : [
                def
            ];
        } else if (def.kind === (0, $bzIlO.Kind).DIRECTIVE_DEFINITION) directiveDefs.push(def);
    } // If this document contains no new types, extensions, or directives then
    // return the same unmodified GraphQLSchema instance.
    if (Object.keys(typeExtensionsMap).length === 0 && typeDefs.length === 0 && directiveDefs.length === 0 && schemaExtensions.length === 0 && schemaDef == null) return schemaConfig;
    var typeMap = Object.create(null);
    for(var _i4 = 0, _schemaConfig$types2 = schemaConfig.types; _i4 < _schemaConfig$types2.length; _i4++){
        var existingType = _schemaConfig$types2[_i4];
        typeMap[existingType.name] = extendNamedType(existingType);
    }
    for(var _i6 = 0; _i6 < typeDefs.length; _i6++){
        var _stdTypeMap$name;
        var typeNode = typeDefs[_i6];
        var name = typeNode.name.value;
        typeMap[name] = (_stdTypeMap$name = $61740b5c0596c7dc$var$stdTypeMap[name]) !== null && _stdTypeMap$name !== void 0 ? _stdTypeMap$name : buildType(typeNode);
    }
    var operationTypes = $61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({
        // Get the extended root operation types.
        query: schemaConfig.query && replaceNamedType(schemaConfig.query),
        mutation: schemaConfig.mutation && replaceNamedType(schemaConfig.mutation),
        subscription: schemaConfig.subscription && replaceNamedType(schemaConfig.subscription)
    }, schemaDef && getOperationTypes([
        schemaDef
    ])), getOperationTypes(schemaExtensions)); // Then produce and return a Schema config with these types.
    return $61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({
        description: (_schemaDef = schemaDef) === null || _schemaDef === void 0 ? void 0 : (_schemaDef$descriptio = _schemaDef.description) === null || _schemaDef$descriptio === void 0 ? void 0 : _schemaDef$descriptio.value
    }, operationTypes), {}, {
        types: (0, $isVmt.default)(typeMap),
        directives: [].concat(schemaConfig.directives.map(replaceDirective), directiveDefs.map(buildDirective)),
        extensions: undefined,
        astNode: (_schemaDef2 = schemaDef) !== null && _schemaDef2 !== void 0 ? _schemaDef2 : schemaConfig.astNode,
        extensionASTNodes: schemaConfig.extensionASTNodes.concat(schemaExtensions),
        assumeValid: (_options$assumeValid = options === null || options === void 0 ? void 0 : options.assumeValid) !== null && _options$assumeValid !== void 0 ? _options$assumeValid : false
    }); // Below are functions used for producing this schema that have closed over
    // this scope and have access to the schema, cache, and newly defined types.
    function replaceType(type) {
        if ((0, $8oLgk.isListType)(type)) // $FlowFixMe[incompatible-return]
        return new (0, $8oLgk.GraphQLList)(replaceType(type.ofType));
        if ((0, $8oLgk.isNonNullType)(type)) // $FlowFixMe[incompatible-return]
        return new (0, $8oLgk.GraphQLNonNull)(replaceType(type.ofType));
        return replaceNamedType(type);
    }
    function replaceNamedType(type) {
        // Note: While this could make early assertions to get the correctly
        // typed values, that would throw immediately while type system
        // validation with validateSchema() will produce more actionable results.
        return typeMap[type.name];
    }
    function replaceDirective(directive) {
        var config = directive.toConfig();
        return new (0, $35Smo.GraphQLDirective)($61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, config), {}, {
            args: (0, $eqSe6.default)(config.args, extendArg)
        }));
    }
    function extendNamedType(type) {
        if ((0, $4Hpke.isIntrospectionType)(type) || (0, $djKly.isSpecifiedScalarType)(type)) // Builtin types are not extended.
        return type;
        if ((0, $8oLgk.isScalarType)(type)) return extendScalarType(type);
        if ((0, $8oLgk.isObjectType)(type)) return extendObjectType(type);
        if ((0, $8oLgk.isInterfaceType)(type)) return extendInterfaceType(type);
        if ((0, $8oLgk.isUnionType)(type)) return extendUnionType(type);
        if ((0, $8oLgk.isEnumType)(type)) return extendEnumType(type);
         // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
        if ((0, $8oLgk.isInputObjectType)(type)) return extendInputObjectType(type);
         // istanbul ignore next (Not reachable. All possible types have been considered)
        (0, $fM9AB.default)(0, 'Unexpected type: ' + (0, $yEDl8.default)(type));
    }
    function extendInputObjectType(type) {
        var _typeExtensionsMap$co;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co !== void 0 ? _typeExtensionsMap$co : [];
        return new (0, $8oLgk.GraphQLInputObjectType)($61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, config), {}, {
            fields: function fields() {
                return $61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, (0, $eqSe6.default)(config.fields, function(field) {
                    return $61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, field), {}, {
                        type: replaceType(field.type)
                    });
                })), buildInputFieldMap(extensions));
            },
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendEnumType(type) {
        var _typeExtensionsMap$ty;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$ty = typeExtensionsMap[type.name]) !== null && _typeExtensionsMap$ty !== void 0 ? _typeExtensionsMap$ty : [];
        return new (0, $8oLgk.GraphQLEnumType)($61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, config), {}, {
            values: $61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, config.values), buildEnumValueMap(extensions)),
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendScalarType(type) {
        var _typeExtensionsMap$co2;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co2 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co2 !== void 0 ? _typeExtensionsMap$co2 : [];
        var specifiedByUrl = config.specifiedByUrl;
        for(var _i8 = 0; _i8 < extensions.length; _i8++){
            var _getSpecifiedByUrl;
            var extensionNode = extensions[_i8];
            specifiedByUrl = (_getSpecifiedByUrl = $61740b5c0596c7dc$var$getSpecifiedByUrl(extensionNode)) !== null && _getSpecifiedByUrl !== void 0 ? _getSpecifiedByUrl : specifiedByUrl;
        }
        return new (0, $8oLgk.GraphQLScalarType)($61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, config), {}, {
            specifiedByUrl: specifiedByUrl,
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendObjectType(type) {
        var _typeExtensionsMap$co3;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co3 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co3 !== void 0 ? _typeExtensionsMap$co3 : [];
        return new (0, $8oLgk.GraphQLObjectType)($61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, config), {}, {
            interfaces: function interfaces() {
                return [].concat(type.getInterfaces().map(replaceNamedType), buildInterfaces(extensions));
            },
            fields: function fields() {
                return $61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, (0, $eqSe6.default)(config.fields, extendField)), buildFieldMap(extensions));
            },
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendInterfaceType(type) {
        var _typeExtensionsMap$co4;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co4 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co4 !== void 0 ? _typeExtensionsMap$co4 : [];
        return new (0, $8oLgk.GraphQLInterfaceType)($61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, config), {}, {
            interfaces: function interfaces() {
                return [].concat(type.getInterfaces().map(replaceNamedType), buildInterfaces(extensions));
            },
            fields: function fields() {
                return $61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, (0, $eqSe6.default)(config.fields, extendField)), buildFieldMap(extensions));
            },
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendUnionType(type) {
        var _typeExtensionsMap$co5;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co5 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co5 !== void 0 ? _typeExtensionsMap$co5 : [];
        return new (0, $8oLgk.GraphQLUnionType)($61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, config), {}, {
            types: function types() {
                return [].concat(type.getTypes().map(replaceNamedType), buildUnionTypes(extensions));
            },
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendField(field) {
        return $61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, field), {}, {
            type: replaceType(field.type),
            // $FlowFixMe[incompatible-call]
            args: (0, $eqSe6.default)(field.args, extendArg)
        });
    }
    function extendArg(arg) {
        return $61740b5c0596c7dc$var$_objectSpread($61740b5c0596c7dc$var$_objectSpread({}, arg), {}, {
            type: replaceType(arg.type)
        });
    }
    function getOperationTypes(nodes) {
        var opTypes = {};
        for(var _i10 = 0; _i10 < nodes.length; _i10++){
            var _node$operationTypes;
            var node = nodes[_i10];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var operationTypesNodes = (_node$operationTypes = node.operationTypes) !== null && _node$operationTypes !== void 0 ? _node$operationTypes : [];
            for(var _i12 = 0; _i12 < operationTypesNodes.length; _i12++){
                var operationType = operationTypesNodes[_i12];
                opTypes[operationType.operation] = getNamedType(operationType.type);
            }
        } // Note: While this could make early assertions to get the correctly
        // typed values below, that would throw immediately while type system
        // validation with validateSchema() will produce more actionable results.
        return opTypes;
    }
    function getNamedType(node) {
        var _stdTypeMap$name2;
        var name = node.name.value;
        var type = (_stdTypeMap$name2 = $61740b5c0596c7dc$var$stdTypeMap[name]) !== null && _stdTypeMap$name2 !== void 0 ? _stdTypeMap$name2 : typeMap[name];
        if (type === undefined) throw new Error("Unknown type: \"".concat(name, "\"."));
        return type;
    }
    function getWrappedType(node) {
        if (node.kind === (0, $bzIlO.Kind).LIST_TYPE) return new (0, $8oLgk.GraphQLList)(getWrappedType(node.type));
        if (node.kind === (0, $bzIlO.Kind).NON_NULL_TYPE) return new (0, $8oLgk.GraphQLNonNull)(getWrappedType(node.type));
        return getNamedType(node);
    }
    function buildDirective(node) {
        var locations = node.locations.map(function(_ref) {
            var value = _ref.value;
            return value;
        });
        return new (0, $35Smo.GraphQLDirective)({
            name: node.name.value,
            description: $61740b5c0596c7dc$export$67580b1c13935958(node, options),
            locations: locations,
            isRepeatable: node.repeatable,
            args: buildArgumentMap(node.arguments),
            astNode: node
        });
    }
    function buildFieldMap(nodes) {
        var fieldConfigMap = Object.create(null);
        for(var _i14 = 0; _i14 < nodes.length; _i14++){
            var _node$fields;
            var node = nodes[_i14];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var nodeFields = (_node$fields = node.fields) !== null && _node$fields !== void 0 ? _node$fields : [];
            for(var _i16 = 0; _i16 < nodeFields.length; _i16++){
                var field = nodeFields[_i16];
                fieldConfigMap[field.name.value] = {
                    // Note: While this could make assertions to get the correctly typed
                    // value, that would throw immediately while type system validation
                    // with validateSchema() will produce more actionable results.
                    type: getWrappedType(field.type),
                    description: $61740b5c0596c7dc$export$67580b1c13935958(field, options),
                    args: buildArgumentMap(field.arguments),
                    deprecationReason: $61740b5c0596c7dc$var$getDeprecationReason(field),
                    astNode: field
                };
            }
        }
        return fieldConfigMap;
    }
    function buildArgumentMap(args) {
        // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var argsNodes = args !== null && args !== void 0 ? args : [];
        var argConfigMap = Object.create(null);
        for(var _i18 = 0; _i18 < argsNodes.length; _i18++){
            var arg = argsNodes[_i18];
            // Note: While this could make assertions to get the correctly typed
            // value, that would throw immediately while type system validation
            // with validateSchema() will produce more actionable results.
            var type = getWrappedType(arg.type);
            argConfigMap[arg.name.value] = {
                type: type,
                description: $61740b5c0596c7dc$export$67580b1c13935958(arg, options),
                defaultValue: (0, $9aGhX.valueFromAST)(arg.defaultValue, type),
                deprecationReason: $61740b5c0596c7dc$var$getDeprecationReason(arg),
                astNode: arg
            };
        }
        return argConfigMap;
    }
    function buildInputFieldMap(nodes) {
        var inputFieldMap = Object.create(null);
        for(var _i20 = 0; _i20 < nodes.length; _i20++){
            var _node$fields2;
            var node = nodes[_i20];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var fieldsNodes = (_node$fields2 = node.fields) !== null && _node$fields2 !== void 0 ? _node$fields2 : [];
            for(var _i22 = 0; _i22 < fieldsNodes.length; _i22++){
                var field = fieldsNodes[_i22];
                // Note: While this could make assertions to get the correctly typed
                // value, that would throw immediately while type system validation
                // with validateSchema() will produce more actionable results.
                var type = getWrappedType(field.type);
                inputFieldMap[field.name.value] = {
                    type: type,
                    description: $61740b5c0596c7dc$export$67580b1c13935958(field, options),
                    defaultValue: (0, $9aGhX.valueFromAST)(field.defaultValue, type),
                    deprecationReason: $61740b5c0596c7dc$var$getDeprecationReason(field),
                    astNode: field
                };
            }
        }
        return inputFieldMap;
    }
    function buildEnumValueMap(nodes) {
        var enumValueMap = Object.create(null);
        for(var _i24 = 0; _i24 < nodes.length; _i24++){
            var _node$values;
            var node = nodes[_i24];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var valuesNodes = (_node$values = node.values) !== null && _node$values !== void 0 ? _node$values : [];
            for(var _i26 = 0; _i26 < valuesNodes.length; _i26++){
                var value = valuesNodes[_i26];
                enumValueMap[value.name.value] = {
                    description: $61740b5c0596c7dc$export$67580b1c13935958(value, options),
                    deprecationReason: $61740b5c0596c7dc$var$getDeprecationReason(value),
                    astNode: value
                };
            }
        }
        return enumValueMap;
    }
    function buildInterfaces(nodes) {
        var interfaces = [];
        for(var _i28 = 0; _i28 < nodes.length; _i28++){
            var _node$interfaces;
            var node = nodes[_i28];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var interfacesNodes = (_node$interfaces = node.interfaces) !== null && _node$interfaces !== void 0 ? _node$interfaces : [];
            for(var _i30 = 0; _i30 < interfacesNodes.length; _i30++){
                var type = interfacesNodes[_i30];
                // Note: While this could make assertions to get the correctly typed
                // values below, that would throw immediately while type system
                // validation with validateSchema() will produce more actionable
                // results.
                interfaces.push(getNamedType(type));
            }
        }
        return interfaces;
    }
    function buildUnionTypes(nodes) {
        var types = [];
        for(var _i32 = 0; _i32 < nodes.length; _i32++){
            var _node$types;
            var node = nodes[_i32];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var typeNodes = (_node$types = node.types) !== null && _node$types !== void 0 ? _node$types : [];
            for(var _i34 = 0; _i34 < typeNodes.length; _i34++){
                var type = typeNodes[_i34];
                // Note: While this could make assertions to get the correctly typed
                // values below, that would throw immediately while type system
                // validation with validateSchema() will produce more actionable
                // results.
                types.push(getNamedType(type));
            }
        }
        return types;
    }
    function buildType(astNode) {
        var _typeExtensionsMap$na;
        var name = astNode.name.value;
        var description = $61740b5c0596c7dc$export$67580b1c13935958(astNode, options);
        var extensionNodes = (_typeExtensionsMap$na = typeExtensionsMap[name]) !== null && _typeExtensionsMap$na !== void 0 ? _typeExtensionsMap$na : [];
        switch(astNode.kind){
            case (0, $bzIlO.Kind).OBJECT_TYPE_DEFINITION:
                var extensionASTNodes = extensionNodes;
                var allNodes = [
                    astNode
                ].concat(extensionASTNodes);
                return new (0, $8oLgk.GraphQLObjectType)({
                    name: name,
                    description: description,
                    interfaces: function interfaces() {
                        return buildInterfaces(allNodes);
                    },
                    fields: function fields() {
                        return buildFieldMap(allNodes);
                    },
                    astNode: astNode,
                    extensionASTNodes: extensionASTNodes
                });
            case (0, $bzIlO.Kind).INTERFACE_TYPE_DEFINITION:
                var _extensionASTNodes = extensionNodes;
                var _allNodes = [
                    astNode
                ].concat(_extensionASTNodes);
                return new (0, $8oLgk.GraphQLInterfaceType)({
                    name: name,
                    description: description,
                    interfaces: function interfaces() {
                        return buildInterfaces(_allNodes);
                    },
                    fields: function fields() {
                        return buildFieldMap(_allNodes);
                    },
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes
                });
            case (0, $bzIlO.Kind).ENUM_TYPE_DEFINITION:
                var _extensionASTNodes2 = extensionNodes;
                var _allNodes2 = [
                    astNode
                ].concat(_extensionASTNodes2);
                return new (0, $8oLgk.GraphQLEnumType)({
                    name: name,
                    description: description,
                    values: buildEnumValueMap(_allNodes2),
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes2
                });
            case (0, $bzIlO.Kind).UNION_TYPE_DEFINITION:
                var _extensionASTNodes3 = extensionNodes;
                var _allNodes3 = [
                    astNode
                ].concat(_extensionASTNodes3);
                return new (0, $8oLgk.GraphQLUnionType)({
                    name: name,
                    description: description,
                    types: function types() {
                        return buildUnionTypes(_allNodes3);
                    },
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes3
                });
            case (0, $bzIlO.Kind).SCALAR_TYPE_DEFINITION:
                var _extensionASTNodes4 = extensionNodes;
                return new (0, $8oLgk.GraphQLScalarType)({
                    name: name,
                    description: description,
                    specifiedByUrl: $61740b5c0596c7dc$var$getSpecifiedByUrl(astNode),
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes4
                });
            case (0, $bzIlO.Kind).INPUT_OBJECT_TYPE_DEFINITION:
                var _extensionASTNodes5 = extensionNodes;
                var _allNodes4 = [
                    astNode
                ].concat(_extensionASTNodes5);
                return new (0, $8oLgk.GraphQLInputObjectType)({
                    name: name,
                    description: description,
                    fields: function fields() {
                        return buildInputFieldMap(_allNodes4);
                    },
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes5
                });
        } // istanbul ignore next (Not reachable. All possible type definition nodes have been considered)
        (0, $fM9AB.default)(0, 'Unexpected type definition node: ' + (0, $yEDl8.default)(astNode));
    }
}
var $61740b5c0596c7dc$var$stdTypeMap = (0, $aRWmX.default)((0, $djKly.specifiedScalarTypes).concat((0, $4Hpke.introspectionTypes)), function(type) {
    return type.name;
});
/**
 * Given a field or enum value node, returns the string value for the
 * deprecation reason.
 */ function $61740b5c0596c7dc$var$getDeprecationReason(node) {
    var deprecated = (0, $7dqoX.getDirectiveValues)((0, $35Smo.GraphQLDeprecatedDirective), node);
    return deprecated === null || deprecated === void 0 ? void 0 : deprecated.reason;
}
/**
 * Given a scalar node, returns the string value for the specifiedByUrl.
 */ function $61740b5c0596c7dc$var$getSpecifiedByUrl(node) {
    var specifiedBy = (0, $7dqoX.getDirectiveValues)((0, $35Smo.GraphQLSpecifiedByDirective), node);
    return specifiedBy === null || specifiedBy === void 0 ? void 0 : specifiedBy.url;
}
function $61740b5c0596c7dc$export$67580b1c13935958(node, options) {
    if (node.description) return node.description.value;
    if ((options === null || options === void 0 ? void 0 : options.commentDescriptions) === true) {
        var rawValue = $61740b5c0596c7dc$var$getLeadingCommentBlock(node);
        if (rawValue !== undefined) return (0, $541Mz.dedentBlockStringValue)('\n' + rawValue);
    }
}
function $61740b5c0596c7dc$var$getLeadingCommentBlock(node) {
    var loc = node.loc;
    if (!loc) return;
    var comments = [];
    var token = loc.startToken.prev;
    while(token != null && token.kind === (0, $2z7TS.TokenKind).COMMENT && token.next && token.prev && token.line + 1 === token.next.line && token.line !== token.prev.line){
        var value = String(token.value);
        comments.push(value);
        token = token.prev;
    }
    return comments.length > 0 ? comments.reverse().join('\n') : undefined;
}

});


parcelRegister("b06Gv", function(module, exports) {
var $8024e1333e60e731$var$__assign = module.exports && module.exports.__assign || function() {
    $8024e1333e60e731$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8024e1333e60e731$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bzIlO = parcelRequire("bzIlO");
function $8024e1333e60e731$var$filterExtensionDefinitions(ast) {
    var extensionDefs = ast.definitions.filter(function(def) {
        return def.kind !== $bzIlO.Kind.OBJECT_TYPE_EXTENSION && def.kind !== $bzIlO.Kind.INTERFACE_TYPE_EXTENSION && def.kind !== $bzIlO.Kind.INPUT_OBJECT_TYPE_EXTENSION && def.kind !== $bzIlO.Kind.UNION_TYPE_EXTENSION && def.kind !== $bzIlO.Kind.ENUM_TYPE_EXTENSION && def.kind !== $bzIlO.Kind.SCALAR_TYPE_EXTENSION && def.kind !== $bzIlO.Kind.SCHEMA_EXTENSION;
    });
    return $8024e1333e60e731$var$__assign($8024e1333e60e731$var$__assign({}, ast), {
        definitions: extensionDefs
    });
}
module.exports.default = $8024e1333e60e731$var$filterExtensionDefinitions;

});


parcelRegister("fZSSc", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $mP8zZ = parcelRequire("mP8zZ");
function $ba571e3447b21cbd$var$chainResolvers(resolvers) {
    return function(root, args, ctx, info) {
        return resolvers.reduce(function(prev, curResolver) {
            if (curResolver) return curResolver(prev, args, ctx, info);
            return $mP8zZ.defaultFieldResolver(prev, args, ctx, info);
        }, root);
    };
}
module.exports.chainResolvers = $ba571e3447b21cbd$var$chainResolvers;

});

parcelRegister("3xw8r", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8oLgk = parcelRequire("8oLgk");

var $l9QLJ = parcelRequire("l9QLJ");
// If we have any union or interface types throw if no there is no resolveType or isTypeOf resolvers
function $293d618a4e8045fb$var$checkForResolveTypeResolver(schema, requireResolversForResolveType) {
    Object.keys(schema.getTypeMap()).map(function(typeName) {
        return schema.getType(typeName);
    }).forEach(function(type) {
        if (!(type instanceof $8oLgk.GraphQLUnionType || type instanceof $8oLgk.GraphQLInterfaceType)) return;
        if (!type.resolveType) {
            if (requireResolversForResolveType === false) return;
            if (requireResolversForResolveType === true) throw new $l9QLJ.SchemaError("Type \"" + type.name + "\" is missing a \"resolveType\" resolver");
            // tslint:disable-next-line:max-line-length
            console.warn("Type \"" + type.name + "\" is missing a \"__resolveType\" resolver. Pass false into " + "\"resolverValidationOptions.requireResolversForResolveType\" to disable this warning.");
        }
    });
}
module.exports.default = $293d618a4e8045fb$var$checkForResolveTypeResolver;

});

parcelRegister("7Bsga", function(module, exports) {
var $5891e8edaaf7aa7f$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1c8Um = parcelRequire("1c8Um");

var $l9QLJ = parcelRequire("l9QLJ");
function $5891e8edaaf7aa7f$var$concatenateTypeDefs(typeDefinitionsAry, calledFunctionRefs) {
    if (calledFunctionRefs === void 0) calledFunctionRefs = [];
    var resolvedTypeDefinitions = [];
    typeDefinitionsAry.forEach(function(typeDef) {
        if (typeDef.kind !== undefined) typeDef = $1c8Um.print(typeDef);
        if (typeof typeDef === 'function') {
            if (calledFunctionRefs.indexOf(typeDef) === -1) {
                calledFunctionRefs.push(typeDef);
                resolvedTypeDefinitions = resolvedTypeDefinitions.concat($5891e8edaaf7aa7f$var$concatenateTypeDefs(typeDef(), calledFunctionRefs));
            }
        } else if (typeof typeDef === 'string') resolvedTypeDefinitions.push(typeDef.trim());
        else {
            var type = typeof typeDef;
            throw new $l9QLJ.SchemaError("typeDef array must contain only strings and functions, got " + type);
        }
    });
    return $5891e8edaaf7aa7f$var$uniq(resolvedTypeDefinitions.map(function(x) {
        return x.trim();
    })).join('\n');
}
function $5891e8edaaf7aa7f$var$uniq(array) {
    return array.reduce(function(accumulator, currentValue) {
        return accumulator.indexOf(currentValue) === -1 ? $5891e8edaaf7aa7f$var$__spreadArrays(accumulator, [
            currentValue
        ]) : accumulator;
    }, []);
}
module.exports.default = $5891e8edaaf7aa7f$var$concatenateTypeDefs;

});

parcelRegister("3qMTx", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $mP8zZ = parcelRequire("mP8zZ");
/*
 * fn: The function to decorate with the logger
 * logger: an object instance of type Logger
 * hint: an optional hint to add to the error's message
 */ function $27f9ba4487d8128b$var$decorateWithLogger(fn, logger, hint) {
    if (typeof fn === 'undefined') fn = $mP8zZ.defaultFieldResolver;
    var logError = function(e) {
        // TODO: clone the error properly
        var newE = new Error();
        newE.stack = e.stack;
        /* istanbul ignore else: always get the hint from addErrorLoggingToSchema */ if (hint) {
            newE['originalMessage'] = e.message;
            newE['message'] = "Error in resolver " + hint + "\n" + e.message;
        }
        logger.log(newE);
    };
    return function(root, args, ctx, info) {
        try {
            var result = fn(root, args, ctx, info);
            // If the resolve function returns a Promise log any Promise rejects.
            if (result && typeof result.then === 'function' && typeof result.catch === 'function') result.catch(function(reason) {
                // make sure that it's an error we're logging.
                var error = reason instanceof Error ? reason : new Error(reason);
                logError(error);
                // We don't want to leave an unhandled exception so pass on error.
                return reason;
            });
            return result;
        } catch (e) {
            logError(e);
            // we want to pass on the error, just in case.
            throw e;
        }
    };
}
module.exports.default = $27f9ba4487d8128b$var$decorateWithLogger;

});

parcelRegister("gk7uh", function(module, exports) {
var $be24526cbd37b195$var$__assign = module.exports && module.exports.__assign || function() {
    $be24526cbd37b195$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $be24526cbd37b195$var$__assign.apply(this, arguments);
};
var $be24526cbd37b195$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8oLgk = parcelRequire("8oLgk");
function $be24526cbd37b195$var$extendResolversFromInterfaces(schema, resolvers) {
    var typeNames = Object.keys($be24526cbd37b195$var$__assign($be24526cbd37b195$var$__assign({}, schema.getTypeMap()), resolvers));
    var extendedResolvers = {};
    typeNames.forEach(function(typeName) {
        var typeResolvers = resolvers[typeName];
        var type = schema.getType(typeName);
        if (type instanceof $8oLgk.GraphQLObjectType) {
            var interfaceResolvers = type.getInterfaces().map(function(iFace) {
                return resolvers[iFace.name];
            });
            extendedResolvers[typeName] = Object.assign.apply(Object, $be24526cbd37b195$var$__spreadArrays([
                {}
            ], interfaceResolvers, [
                typeResolvers
            ]));
        } else if (typeResolvers) extendedResolvers[typeName] = typeResolvers;
    });
    return extendedResolvers;
}
module.exports.default = $be24526cbd37b195$var$extendResolversFromInterfaces;

});

parcelRegister("cfI70", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8eb91a74a0b54807$var$newExtensionDefinitionKind = 'ObjectTypeExtension';
var $8eb91a74a0b54807$var$interfaceExtensionDefinitionKind = 'InterfaceTypeExtension';
var $8eb91a74a0b54807$var$inputObjectExtensionDefinitionKind = 'InputObjectTypeExtension';
var $8eb91a74a0b54807$var$unionExtensionDefinitionKind = 'UnionTypeExtension';
var $8eb91a74a0b54807$var$enumExtensionDefinitionKind = 'EnumTypeExtension';
function $8eb91a74a0b54807$var$extractExtensionDefinitions(ast) {
    var extensionDefs = ast.definitions.filter(function(def) {
        return def.kind === $8eb91a74a0b54807$var$newExtensionDefinitionKind || def.kind === $8eb91a74a0b54807$var$interfaceExtensionDefinitionKind || def.kind === $8eb91a74a0b54807$var$inputObjectExtensionDefinitionKind || def.kind === $8eb91a74a0b54807$var$unionExtensionDefinitionKind || def.kind === $8eb91a74a0b54807$var$enumExtensionDefinitionKind;
    });
    return Object.assign({}, ast, {
        definitions: extensionDefs
    });
}
module.exports.default = $8eb91a74a0b54807$var$extractExtensionDefinitions;

});

parcelRegister("izDlb", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8oLgk = parcelRequire("8oLgk");
function $d85a031d97c1df1b$var$forEachField(schema, fn) {
    var typeMap = schema.getTypeMap();
    Object.keys(typeMap).forEach(function(typeName) {
        var type = typeMap[typeName];
        // TODO: maybe have an option to include these?
        if (!$8oLgk.getNamedType(type).name.startsWith('__') && type instanceof $8oLgk.GraphQLObjectType) {
            var fields_1 = type.getFields();
            Object.keys(fields_1).forEach(function(fieldName) {
                var field = fields_1[fieldName];
                fn(field, typeName, fieldName);
            });
        }
    });
}
module.exports.default = $d85a031d97c1df1b$var$forEachField;

});

parcelRegister("5gUcG", function(module, exports) {
var $3d6a0b3bbe13496e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// @schemaDefinition: A GraphQL type schema in shorthand
// @resolvers: Definitions for resolvers to be merged with schema
var $3d6a0b3bbe13496e$var$SchemaError = /** @class */ function(_super) {
    $3d6a0b3bbe13496e$var$__extends(SchemaError, _super);
    function SchemaError(message) {
        var _this = _super.call(this, message) || this;
        _this.message = message;
        Error.captureStackTrace(_this, _this.constructor);
        return _this;
    }
    return SchemaError;
}(Error);
module.exports.default = $3d6a0b3bbe13496e$var$SchemaError;

});



parcelRegister("cCTSK", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8oLgk = parcelRequire("8oLgk");
var $cQaSR = parcelRequire("cQaSR");
var $lUVCX = parcelRequire("lUVCX");

var $7Jxgt = parcelRequire("7Jxgt");

var $gIDuj = parcelRequire("gIDuj");
// This function wraps addMockFunctionsToSchema for more convenience
function $931461a66c79b285$var$mockServer(schema, mocks, preserveResolvers) {
    if (preserveResolvers === void 0) preserveResolvers = false;
    var mySchema;
    if (!(schema instanceof $lUVCX.GraphQLSchema)) // TODO: provide useful error messages here if this fails
    mySchema = $gIDuj.buildSchemaFromTypeDefinitions(schema);
    else mySchema = schema;
    $931461a66c79b285$var$addMockFunctionsToSchema({
        schema: mySchema,
        mocks: mocks,
        preserveResolvers: preserveResolvers
    });
    return {
        query: function(query, vars) {
            return $cQaSR.graphql(mySchema, query, {}, {}, vars);
        }
    };
}
module.exports.mockServer = $931461a66c79b285$var$mockServer;
var $931461a66c79b285$var$defaultMockMap = new Map();
$931461a66c79b285$var$defaultMockMap.set('Int', function() {
    return Math.round(Math.random() * 200) - 100;
});
$931461a66c79b285$var$defaultMockMap.set('Float', function() {
    return Math.random() * 200 - 100;
});
$931461a66c79b285$var$defaultMockMap.set('String', function() {
    return 'Hello World';
});
$931461a66c79b285$var$defaultMockMap.set('Boolean', function() {
    return Math.random() > 0.5;
});
$931461a66c79b285$var$defaultMockMap.set('ID', function() {
    return $7Jxgt.v4();
});
// TODO allow providing a seed such that lengths of list could be deterministic
// this could be done by using casual to get a random list length if the casual
// object is global.
function $931461a66c79b285$var$addMockFunctionsToSchema(_a) {
    var schema = _a.schema, _b = _a.mocks, mocks = _b === void 0 ? {} : _b, _c = _a.preserveResolvers, preserveResolvers = _c === void 0 ? false : _c;
    if (!schema) throw new Error('Must provide schema to mock');
    if (!(schema instanceof $lUVCX.GraphQLSchema)) throw new Error('Value at "schema" must be of type GraphQLSchema');
    if (!$931461a66c79b285$var$isObject(mocks)) throw new Error('mocks must be of type Object');
    // use Map internally, because that API is nicer.
    var mockFunctionMap = new Map();
    Object.keys(mocks).forEach(function(typeName) {
        mockFunctionMap.set(typeName, mocks[typeName]);
    });
    mockFunctionMap.forEach(function(mockFunction, mockTypeName) {
        if (typeof mockFunction !== 'function') throw new Error("mockFunctionMap[" + mockTypeName + "] must be a function");
    });
    var mockType = function(type, typeName, fieldName) {
        // order of precendence for mocking:
        // 1. if the object passed in already has fieldName, just use that
        // --> if it's a function, that becomes your resolver
        // --> if it's a value, the mock resolver will return that
        // 2. if the nullableType is a list, recurse
        // 2. if there's a mock defined for this typeName, that will be used
        // 3. if there's no mock defined, use the default mocks for this type
        return function(root, args, context, info) {
            // nullability doesn't matter for the purpose of mocking.
            var fieldType = $8oLgk.getNullableType(type);
            var namedFieldType = $8oLgk.getNamedType(fieldType);
            if (root && typeof root[fieldName] !== 'undefined') {
                var result = void 0;
                // if we're here, the field is already defined
                if (typeof root[fieldName] === 'function') {
                    result = root[fieldName](root, args, context, info);
                    if (result instanceof $931461a66c79b285$var$MockList) result = result.mock(root, args, context, info, fieldType, mockType);
                } else result = root[fieldName];
                // Now we merge the result with the default mock for this type.
                // This allows overriding defaults while writing very little code.
                if (mockFunctionMap.has(namedFieldType.name)) result = $931461a66c79b285$var$mergeMocks(mockFunctionMap.get(namedFieldType.name).bind(null, root, args, context, info), result);
                return result;
            }
            if (fieldType instanceof $8oLgk.GraphQLList || fieldType instanceof $8oLgk.GraphQLNonNull) return [
                mockType(fieldType.ofType)(root, args, context, info),
                mockType(fieldType.ofType)(root, args, context, info)
            ];
            if (mockFunctionMap.has(fieldType.name) && !(fieldType instanceof $8oLgk.GraphQLUnionType || fieldType instanceof $8oLgk.GraphQLInterfaceType)) // the object passed doesn't have this field, so we apply the default mock
            return mockFunctionMap.get(fieldType.name)(root, args, context, info);
            if (fieldType instanceof $8oLgk.GraphQLObjectType) // objects don't return actual data, we only need to mock scalars!
            return {};
            // if a mock function is provided for unionType or interfaceType, execute it to resolve the concrete type
            // otherwise randomly pick a type from all implementation types
            if (fieldType instanceof $8oLgk.GraphQLUnionType || fieldType instanceof $8oLgk.GraphQLInterfaceType) {
                var implementationType = void 0;
                if (mockFunctionMap.has(fieldType.name)) {
                    var interfaceMockObj = mockFunctionMap.get(fieldType.name)(root, args, context, info);
                    if (!interfaceMockObj || !interfaceMockObj.__typename) return Error("Please return a __typename in \"" + fieldType.name + "\"");
                    implementationType = schema.getType(interfaceMockObj.__typename);
                } else {
                    var possibleTypes = schema.getPossibleTypes(fieldType);
                    implementationType = $931461a66c79b285$var$getRandomElement(possibleTypes);
                }
                return Object.assign({
                    __typename: implementationType
                }, mockType(implementationType)(root, args, context, info));
            }
            if (fieldType instanceof $8oLgk.GraphQLEnumType) return $931461a66c79b285$var$getRandomElement(fieldType.getValues()).value;
            if ($931461a66c79b285$var$defaultMockMap.has(fieldType.name)) return $931461a66c79b285$var$defaultMockMap.get(fieldType.name)(root, args, context, info);
            // if we get to here, we don't have a value, and we don't have a mock for this type,
            // we could return undefined, but that would be hard to debug, so we throw instead.
            // however, we returning it instead of throwing it, so preserveResolvers can handle the failures.
            return Error("No mock defined for type \"" + fieldType.name + "\"");
        };
    };
    $gIDuj.forEachField(schema, function(field, typeName, fieldName) {
        $931461a66c79b285$var$assignResolveType(field.type, preserveResolvers);
        var mockResolver;
        // we have to handle the root mutation and root query types differently,
        // because no resolver is called at the root.
        /* istanbul ignore next: Must provide schema DefinitionNode with query type or a type named Query. */ var isOnQueryType = schema.getQueryType() && schema.getQueryType().name === typeName;
        var isOnMutationType = schema.getMutationType() && schema.getMutationType().name === typeName;
        if (isOnQueryType || isOnMutationType) {
            if (mockFunctionMap.has(typeName)) {
                var rootMock_1 = mockFunctionMap.get(typeName);
                // XXX: BUG in here, need to provide proper signature for rootMock.
                if (typeof rootMock_1(undefined, {}, {}, {})[fieldName] === 'function') mockResolver = function(root, args, context, info) {
                    var updatedRoot = root || {}; // TODO: should we clone instead?
                    updatedRoot[fieldName] = rootMock_1(root, args, context, info)[fieldName];
                    // XXX this is a bit of a hack to still use mockType, which
                    // lets you mock lists etc. as well
                    // otherwise we could just set field.resolve to rootMock()[fieldName]
                    // it's like pretending there was a resolve function that ran before
                    // the root resolve function.
                    return mockType(field.type, typeName, fieldName)(updatedRoot, args, context, info);
                };
            }
        }
        if (!mockResolver) mockResolver = mockType(field.type, typeName, fieldName);
        if (!preserveResolvers || !field.resolve) field.resolve = mockResolver;
        else {
            var oldResolver_1 = field.resolve;
            field.resolve = function(rootObject, args, context, info) {
                return Promise.all([
                    mockResolver(rootObject, args, context, info),
                    oldResolver_1(rootObject, args, context, info)
                ]).then(function(values) {
                    var mockedValue = values[0], resolvedValue = values[1];
                    // In case we couldn't mock
                    if (mockedValue instanceof Error) {
                        // only if value was not resolved, populate the error.
                        if (undefined === resolvedValue) throw mockedValue;
                        return resolvedValue;
                    }
                    if (resolvedValue instanceof Date && mockedValue instanceof Date) return undefined !== resolvedValue ? resolvedValue : mockedValue;
                    if ($931461a66c79b285$var$isObject(mockedValue) && $931461a66c79b285$var$isObject(resolvedValue)) {
                        // Object.assign() won't do here, as we need to all properties, including
                        // the non-enumerable ones and defined using Object.defineProperty
                        var emptyObject = Object.create(Object.getPrototypeOf(resolvedValue));
                        return $931461a66c79b285$var$copyOwnProps(emptyObject, resolvedValue, mockedValue);
                    }
                    return undefined !== resolvedValue ? resolvedValue : mockedValue;
                });
            };
        }
    });
}
module.exports.addMockFunctionsToSchema = $931461a66c79b285$var$addMockFunctionsToSchema;
function $931461a66c79b285$var$isObject(thing) {
    return thing === Object(thing) && !Array.isArray(thing);
}
// returns a random element from that ary
function $931461a66c79b285$var$getRandomElement(ary) {
    var sample = Math.floor(Math.random() * ary.length);
    return ary[sample];
}
function $931461a66c79b285$var$mergeObjects(a, b) {
    return Object.assign(a, b);
}
function $931461a66c79b285$var$copyOwnPropsIfNotPresent(target, source) {
    Object.getOwnPropertyNames(source).forEach(function(prop) {
        if (!Object.getOwnPropertyDescriptor(target, prop)) Object.defineProperty(target, prop, Object.getOwnPropertyDescriptor(source, prop));
    });
}
function $931461a66c79b285$var$copyOwnProps(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        var chain = source;
        while(chain){
            $931461a66c79b285$var$copyOwnPropsIfNotPresent(target, chain);
            chain = Object.getPrototypeOf(chain);
        }
    });
    return target;
}
// takes either an object or a (possibly nested) array
// and completes the customMock object with any fields
// defined on genericMock
// only merges objects or arrays. Scalars are returned as is
function $931461a66c79b285$var$mergeMocks(genericMockFunction, customMock) {
    if (Array.isArray(customMock)) return customMock.map(function(el) {
        return $931461a66c79b285$var$mergeMocks(genericMockFunction, el);
    });
    if ($931461a66c79b285$var$isObject(customMock)) return $931461a66c79b285$var$mergeObjects(genericMockFunction(), customMock);
    return customMock;
}
function $931461a66c79b285$var$getResolveType(namedFieldType) {
    if (namedFieldType instanceof $8oLgk.GraphQLInterfaceType || namedFieldType instanceof $8oLgk.GraphQLUnionType) return namedFieldType.resolveType;
    else return undefined;
}
function $931461a66c79b285$var$assignResolveType(type, preserveResolvers) {
    var fieldType = $8oLgk.getNullableType(type);
    var namedFieldType = $8oLgk.getNamedType(fieldType);
    var oldResolveType = $931461a66c79b285$var$getResolveType(namedFieldType);
    if (preserveResolvers && oldResolveType && oldResolveType.length) return;
    if (namedFieldType instanceof $8oLgk.GraphQLUnionType || namedFieldType instanceof $8oLgk.GraphQLInterfaceType) // the default `resolveType` always returns null. We add a fallback
    // resolution that works with how unions and interface are mocked
    namedFieldType.resolveType = function(data, context, info) {
        return info.schema.getType(data.__typename);
    };
}
var $931461a66c79b285$var$MockList = /** @class */ function() {
    // wrappedFunction can return another MockList or a value
    function MockList(len, wrappedFunction) {
        this.len = len;
        if (typeof wrappedFunction !== 'undefined') {
            if (typeof wrappedFunction !== 'function') throw new Error('Second argument to MockList must be a function or undefined');
            this.wrappedFunction = wrappedFunction;
        }
    }
    MockList.prototype.mock = function(root, args, context, info, fieldType, mockTypeFunc) {
        var arr;
        if (Array.isArray(this.len)) arr = new Array(this.randint(this.len[0], this.len[1]));
        else arr = new Array(this.len);
        for(var i = 0; i < arr.length; i++)if (typeof this.wrappedFunction === 'function') {
            var res = this.wrappedFunction(root, args, context, info);
            if (res instanceof MockList) {
                var nullableType = $8oLgk.getNullableType(fieldType.ofType);
                arr[i] = res.mock(root, args, context, info, nullableType, mockTypeFunc);
            } else arr[i] = res;
        } else arr[i] = mockTypeFunc(fieldType.ofType)(root, args, context, info);
        return arr;
    };
    MockList.prototype.randint = function(low, high) {
        return Math.floor(Math.random() * (high - low + 1) + low);
    };
    return MockList;
}();
module.exports.MockList = $931461a66c79b285$var$MockList;

});
parcelRegister("cQaSR", function(module, exports) {

$parcel$export(module.exports, "graphql", () => $9592c8b00f2b6e28$export$1eb4e7c0ed67b035);

var $jMqAK = parcelRequire("jMqAK");

var $8uUC9 = parcelRequire("8uUC9");

var $c6jur = parcelRequire("c6jur");

var $bKGOe = parcelRequire("bKGOe");

var $mP8zZ = parcelRequire("mP8zZ");
function $9592c8b00f2b6e28$export$1eb4e7c0ed67b035(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver) {
    var _arguments = arguments;
    /* eslint-enable no-redeclare */ // Always return a Promise for a consistent API.
    return new Promise(function(resolve) {
        return resolve(_arguments.length === 1 ? $9592c8b00f2b6e28$var$graphqlImpl(argsOrSchema) : $9592c8b00f2b6e28$var$graphqlImpl({
            schema: argsOrSchema,
            source: source,
            rootValue: rootValue,
            contextValue: contextValue,
            variableValues: variableValues,
            operationName: operationName,
            fieldResolver: fieldResolver,
            typeResolver: typeResolver
        }));
    });
}
function $9592c8b00f2b6e28$export$51b1816fb8b0711e(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver) {
    /* eslint-enable no-redeclare */ // Extract arguments from object args if provided.
    var result = arguments.length === 1 ? $9592c8b00f2b6e28$var$graphqlImpl(argsOrSchema) : $9592c8b00f2b6e28$var$graphqlImpl({
        schema: argsOrSchema,
        source: source,
        rootValue: rootValue,
        contextValue: contextValue,
        variableValues: variableValues,
        operationName: operationName,
        fieldResolver: fieldResolver,
        typeResolver: typeResolver
    }); // Assert that the execution was synchronous.
    if ((0, $jMqAK.default)(result)) throw new Error('GraphQL execution failed to complete synchronously.');
    return result;
}
function $9592c8b00f2b6e28$var$graphqlImpl(args) {
    var schema = args.schema, source = args.source, rootValue = args.rootValue, contextValue = args.contextValue, variableValues = args.variableValues, operationName = args.operationName, fieldResolver = args.fieldResolver, typeResolver = args.typeResolver; // Validate Schema
    var schemaValidationErrors = (0, $bKGOe.validateSchema)(schema);
    if (schemaValidationErrors.length > 0) return {
        errors: schemaValidationErrors
    };
     // Parse
    var document;
    try {
        document = (0, $8uUC9.parse)(source);
    } catch (syntaxError) {
        return {
            errors: [
                syntaxError
            ]
        };
    } // Validate
    var validationErrors = (0, $c6jur.validate)(schema, document);
    if (validationErrors.length > 0) return {
        errors: validationErrors
    };
     // Execute
    return (0, $mP8zZ.execute)({
        schema: schema,
        document: document,
        rootValue: rootValue,
        contextValue: contextValue,
        variableValues: variableValues,
        operationName: operationName,
        fieldResolver: fieldResolver,
        typeResolver: typeResolver
    });
}

});


parcelRegister("h3H2i", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ebVkX = parcelRequire("ebVkX");
module.exports.makeRemoteExecutableSchema = $ebVkX.default;
module.exports.defaultCreateRemoteResolver = $ebVkX.createResolver;

var $hedUd = parcelRequire("hedUd");
module.exports.introspectSchema = $hedUd.default;

var $5Cx8V = parcelRequire("5Cx8V");
module.exports.mergeSchemas = $5Cx8V.default;

var $bkP2b = parcelRequire("bkP2b");
module.exports.delegateToSchema = $bkP2b.default;

var $kptle = parcelRequire("kptle");
module.exports.defaultMergedResolver = $kptle.default;

});
parcelRegister("ebVkX", function(module, exports) {
var $a54e91b71ba2d067$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a54e91b71ba2d067$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $a54e91b71ba2d067$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dQXZA = parcelRequire("dQXZA");
var $djKly = parcelRequire("djKly");
var $8oLgk = parcelRequire("8oLgk");
var $bzIlO = parcelRequire("bzIlO");
var $2dbGi = parcelRequire("2dbGi");

var $kd1Ee = parcelRequire("kd1Ee");

var $bZzKT = parcelRequire("bZzKT");

var $gIDuj = parcelRequire("gIDuj");

var $cPwLY = parcelRequire("cPwLY");

var $akAWC = parcelRequire("akAWC");

var $kptle = parcelRequire("kptle");

var $2JIWi = parcelRequire("2JIWi");

var $0qKk1 = parcelRequire("0qKk1");
function $a54e91b71ba2d067$var$makeRemoteExecutableSchema(_a) {
    var _b;
    var schema = _a.schema, link = _a.link, fetcher = _a.fetcher, _c = _a.createResolver, customCreateResolver = _c === void 0 ? $a54e91b71ba2d067$var$createResolver : _c, buildSchemaOptions = _a.buildSchemaOptions, _d = _a.printSchemaOptions, printSchemaOptions = _d === void 0 ? {
        commentDescriptions: true
    } : _d;
    if (!fetcher && link) fetcher = $kd1Ee.default(link);
    var typeDefs;
    if (typeof schema === 'string') {
        typeDefs = schema;
        schema = $dQXZA.buildSchema(typeDefs, buildSchemaOptions);
    } else typeDefs = $2dbGi.printSchema(schema, printSchemaOptions);
    // prepare query resolvers
    var queryResolvers = {};
    var queryType = schema.getQueryType();
    var queries = queryType.getFields();
    Object.keys(queries).forEach(function(key) {
        queryResolvers[key] = customCreateResolver(fetcher);
    });
    // prepare mutation resolvers
    var mutationResolvers = {};
    var mutationType = schema.getMutationType();
    if (mutationType) {
        var mutations = mutationType.getFields();
        Object.keys(mutations).forEach(function(key) {
            mutationResolvers[key] = customCreateResolver(fetcher);
        });
    }
    // prepare subscription resolvers
    var subscriptionResolvers = {};
    var subscriptionType = schema.getSubscriptionType();
    if (subscriptionType) {
        var subscriptions = subscriptionType.getFields();
        Object.keys(subscriptions).forEach(function(key) {
            subscriptionResolvers[key] = {
                subscribe: $a54e91b71ba2d067$var$createSubscriptionResolver(key, link)
            };
        });
    }
    // merge resolvers into resolver map
    var resolvers = (_b = {}, _b[queryType.name] = queryResolvers, _b);
    if (!$bZzKT.default(mutationResolvers)) resolvers[mutationType.name] = mutationResolvers;
    if (!$bZzKT.default(subscriptionResolvers)) resolvers[subscriptionType.name] = subscriptionResolvers;
    // add missing abstract resolvers (scalar, unions, interfaces)
    var typeMap = schema.getTypeMap();
    var types = Object.keys(typeMap).map(function(name) {
        return typeMap[name];
    });
    var _loop_1 = function(type) {
        if (type instanceof $8oLgk.GraphQLInterfaceType || type instanceof $8oLgk.GraphQLUnionType) resolvers[type.name] = {
            __resolveType: function(parent, context, info) {
                return $akAWC.default(parent, info.schema);
            }
        };
        else if (type instanceof $8oLgk.GraphQLScalarType) {
            if (!(type === $djKly.GraphQLID || type === $djKly.GraphQLString || type === $djKly.GraphQLFloat || type === $djKly.GraphQLBoolean || type === $djKly.GraphQLInt)) resolvers[type.name] = $cPwLY.recreateType(type, function(name) {
                return null;
            }, false);
        } else if (type instanceof $8oLgk.GraphQLObjectType && type.name.slice(0, 2) !== '__' && type !== queryType && type !== mutationType && type !== subscriptionType) {
            var resolver_1 = {};
            Object.keys(type.getFields()).forEach(function(field) {
                resolver_1[field] = $kptle.default;
            });
            resolvers[type.name] = resolver_1;
        }
    };
    for(var _i = 0, types_1 = types; _i < types_1.length; _i++){
        var type = types_1[_i];
        _loop_1(type);
    }
    return $gIDuj.makeExecutableSchema({
        typeDefs: typeDefs,
        resolvers: resolvers
    });
}
module.exports.default = $a54e91b71ba2d067$var$makeRemoteExecutableSchema;
function $a54e91b71ba2d067$var$createResolver(fetcher) {
    var _this = this;
    return function(root, args, context, info) {
        return $a54e91b71ba2d067$var$__awaiter(_this, void 0, void 0, function() {
            var fragments, document, result;
            return $a54e91b71ba2d067$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        fragments = Object.keys(info.fragments).map(function(fragment) {
                            return info.fragments[fragment];
                        });
                        document = {
                            kind: $bzIlO.Kind.DOCUMENT,
                            definitions: $a54e91b71ba2d067$var$__spreadArrays([
                                info.operation
                            ], fragments)
                        };
                        return [
                            4 /*yield*/ ,
                            fetcher({
                                query: document,
                                variables: info.variableValues,
                                context: {
                                    graphqlContext: context
                                }
                            })
                        ];
                    case 1:
                        result = _a.sent();
                        return [
                            2 /*return*/ ,
                            $2JIWi.checkResultAndHandleErrors(result, info)
                        ];
                }
            });
        });
    };
}
module.exports.createResolver = $a54e91b71ba2d067$var$createResolver;
function $a54e91b71ba2d067$var$createSubscriptionResolver(name, link) {
    return function(root, args, context, info) {
        var fragments = Object.keys(info.fragments).map(function(fragment) {
            return info.fragments[fragment];
        });
        var document = {
            kind: $bzIlO.Kind.DOCUMENT,
            definitions: $a54e91b71ba2d067$var$__spreadArrays([
                info.operation
            ], fragments)
        };
        var operation = {
            query: document,
            variables: info.variableValues,
            context: {
                graphqlContext: context
            }
        };
        var observable = $kd1Ee.execute(link, operation);
        return $0qKk1.observableToAsyncIterable(observable);
    };
}

});
parcelRegister("2dbGi", function(module, exports) {

$parcel$export(module.exports, "printSchema", () => $19c5db4b93436126$export$f7c984b74d0fc2e7);

var $isVmt = parcelRequire("isVmt");

var $yEDl8 = parcelRequire("yEDl8");

var $fM9AB = parcelRequire("fM9AB");

var $1c8Um = parcelRequire("1c8Um");

var $541Mz = parcelRequire("541Mz");

var $4Hpke = parcelRequire("4Hpke");

var $djKly = parcelRequire("djKly");

var $35Smo = parcelRequire("35Smo");

var $8oLgk = parcelRequire("8oLgk");

var $d1i3Z = parcelRequire("d1i3Z");
function $19c5db4b93436126$export$f7c984b74d0fc2e7(schema, options) {
    return $19c5db4b93436126$var$printFilteredSchema(schema, function(n) {
        return !(0, $35Smo.isSpecifiedDirective)(n);
    }, $19c5db4b93436126$var$isDefinedType, options);
}
function $19c5db4b93436126$export$436bfe9e87d1be55(schema, options) {
    return $19c5db4b93436126$var$printFilteredSchema(schema, (0, $35Smo.isSpecifiedDirective), (0, $4Hpke.isIntrospectionType), options);
}
function $19c5db4b93436126$var$isDefinedType(type) {
    return !(0, $djKly.isSpecifiedScalarType)(type) && !(0, $4Hpke.isIntrospectionType)(type);
}
function $19c5db4b93436126$var$printFilteredSchema(schema, directiveFilter, typeFilter, options) {
    var directives = schema.getDirectives().filter(directiveFilter);
    var types = (0, $isVmt.default)(schema.getTypeMap()).filter(typeFilter);
    return [
        $19c5db4b93436126$var$printSchemaDefinition(schema)
    ].concat(directives.map(function(directive) {
        return $19c5db4b93436126$var$printDirective(directive, options);
    }), types.map(function(type) {
        return $19c5db4b93436126$export$199528f8b0f9bf49(type, options);
    })).filter(Boolean).join('\n\n') + '\n';
}
function $19c5db4b93436126$var$printSchemaDefinition(schema) {
    if (schema.description == null && $19c5db4b93436126$var$isSchemaOfCommonNames(schema)) return;
    var operationTypes = [];
    var queryType = schema.getQueryType();
    if (queryType) operationTypes.push("  query: ".concat(queryType.name));
    var mutationType = schema.getMutationType();
    if (mutationType) operationTypes.push("  mutation: ".concat(mutationType.name));
    var subscriptionType = schema.getSubscriptionType();
    if (subscriptionType) operationTypes.push("  subscription: ".concat(subscriptionType.name));
    return $19c5db4b93436126$var$printDescription({}, schema) + "schema {\n".concat(operationTypes.join('\n'), "\n}");
}
/**
 * GraphQL schema define root types for each type of operation. These types are
 * the same as any other type and can be named in any manner, however there is
 * a common naming convention:
 *
 *   schema {
 *     query: Query
 *     mutation: Mutation
 *   }
 *
 * When using this naming convention, the schema description can be omitted.
 */ function $19c5db4b93436126$var$isSchemaOfCommonNames(schema) {
    var queryType = schema.getQueryType();
    if (queryType && queryType.name !== 'Query') return false;
    var mutationType = schema.getMutationType();
    if (mutationType && mutationType.name !== 'Mutation') return false;
    var subscriptionType = schema.getSubscriptionType();
    if (subscriptionType && subscriptionType.name !== 'Subscription') return false;
    return true;
}
function $19c5db4b93436126$export$199528f8b0f9bf49(type, options) {
    if ((0, $8oLgk.isScalarType)(type)) return $19c5db4b93436126$var$printScalar(type, options);
    if ((0, $8oLgk.isObjectType)(type)) return $19c5db4b93436126$var$printObject(type, options);
    if ((0, $8oLgk.isInterfaceType)(type)) return $19c5db4b93436126$var$printInterface(type, options);
    if ((0, $8oLgk.isUnionType)(type)) return $19c5db4b93436126$var$printUnion(type, options);
    if ((0, $8oLgk.isEnumType)(type)) return $19c5db4b93436126$var$printEnum(type, options);
     // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $8oLgk.isInputObjectType)(type)) return $19c5db4b93436126$var$printInputObject(type, options);
     // istanbul ignore next (Not reachable. All possible types have been considered)
    (0, $fM9AB.default)(0, 'Unexpected type: ' + (0, $yEDl8.default)(type));
}
function $19c5db4b93436126$var$printScalar(type, options) {
    return $19c5db4b93436126$var$printDescription(options, type) + "scalar ".concat(type.name) + $19c5db4b93436126$var$printSpecifiedByUrl(type);
}
function $19c5db4b93436126$var$printImplementedInterfaces(type) {
    var interfaces = type.getInterfaces();
    return interfaces.length ? ' implements ' + interfaces.map(function(i) {
        return i.name;
    }).join(' & ') : '';
}
function $19c5db4b93436126$var$printObject(type, options) {
    return $19c5db4b93436126$var$printDescription(options, type) + "type ".concat(type.name) + $19c5db4b93436126$var$printImplementedInterfaces(type) + $19c5db4b93436126$var$printFields(options, type);
}
function $19c5db4b93436126$var$printInterface(type, options) {
    return $19c5db4b93436126$var$printDescription(options, type) + "interface ".concat(type.name) + $19c5db4b93436126$var$printImplementedInterfaces(type) + $19c5db4b93436126$var$printFields(options, type);
}
function $19c5db4b93436126$var$printUnion(type, options) {
    var types = type.getTypes();
    var possibleTypes = types.length ? ' = ' + types.join(' | ') : '';
    return $19c5db4b93436126$var$printDescription(options, type) + 'union ' + type.name + possibleTypes;
}
function $19c5db4b93436126$var$printEnum(type, options) {
    var values = type.getValues().map(function(value, i) {
        return $19c5db4b93436126$var$printDescription(options, value, '  ', !i) + '  ' + value.name + $19c5db4b93436126$var$printDeprecated(value.deprecationReason);
    });
    return $19c5db4b93436126$var$printDescription(options, type) + "enum ".concat(type.name) + $19c5db4b93436126$var$printBlock(values);
}
function $19c5db4b93436126$var$printInputObject(type, options) {
    var fields = (0, $isVmt.default)(type.getFields()).map(function(f, i) {
        return $19c5db4b93436126$var$printDescription(options, f, '  ', !i) + '  ' + $19c5db4b93436126$var$printInputValue(f);
    });
    return $19c5db4b93436126$var$printDescription(options, type) + "input ".concat(type.name) + $19c5db4b93436126$var$printBlock(fields);
}
function $19c5db4b93436126$var$printFields(options, type) {
    var fields = (0, $isVmt.default)(type.getFields()).map(function(f, i) {
        return $19c5db4b93436126$var$printDescription(options, f, '  ', !i) + '  ' + f.name + $19c5db4b93436126$var$printArgs(options, f.args, '  ') + ': ' + String(f.type) + $19c5db4b93436126$var$printDeprecated(f.deprecationReason);
    });
    return $19c5db4b93436126$var$printBlock(fields);
}
function $19c5db4b93436126$var$printBlock(items) {
    return items.length !== 0 ? ' {\n' + items.join('\n') + '\n}' : '';
}
function $19c5db4b93436126$var$printArgs(options, args) {
    var indentation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    if (args.length === 0) return '';
     // If every arg does not have a description, print them on one line.
    if (args.every(function(arg) {
        return !arg.description;
    })) return '(' + args.map($19c5db4b93436126$var$printInputValue).join(', ') + ')';
    return '(\n' + args.map(function(arg, i) {
        return $19c5db4b93436126$var$printDescription(options, arg, '  ' + indentation, !i) + '  ' + indentation + $19c5db4b93436126$var$printInputValue(arg);
    }).join('\n') + '\n' + indentation + ')';
}
function $19c5db4b93436126$var$printInputValue(arg) {
    var defaultAST = (0, $d1i3Z.astFromValue)(arg.defaultValue, arg.type);
    var argDecl = arg.name + ': ' + String(arg.type);
    if (defaultAST) argDecl += " = ".concat((0, $1c8Um.print)(defaultAST));
    return argDecl + $19c5db4b93436126$var$printDeprecated(arg.deprecationReason);
}
function $19c5db4b93436126$var$printDirective(directive, options) {
    return $19c5db4b93436126$var$printDescription(options, directive) + 'directive @' + directive.name + $19c5db4b93436126$var$printArgs(options, directive.args) + (directive.isRepeatable ? ' repeatable' : '') + ' on ' + directive.locations.join(' | ');
}
function $19c5db4b93436126$var$printDeprecated(reason) {
    if (reason == null) return '';
    var reasonAST = (0, $d1i3Z.astFromValue)(reason, (0, $djKly.GraphQLString));
    if (reasonAST && reason !== (0, $35Smo.DEFAULT_DEPRECATION_REASON)) return ' @deprecated(reason: ' + (0, $1c8Um.print)(reasonAST) + ')';
    return ' @deprecated';
}
function $19c5db4b93436126$var$printSpecifiedByUrl(scalar) {
    if (scalar.specifiedByUrl == null) return '';
    var url = scalar.specifiedByUrl;
    var urlAST = (0, $d1i3Z.astFromValue)(url, (0, $djKly.GraphQLString));
    urlAST || (0, $fM9AB.default)(0, 'Unexpected null value returned from `astFromValue` for specifiedByUrl');
    return ' @specifiedBy(url: ' + (0, $1c8Um.print)(urlAST) + ')';
}
function $19c5db4b93436126$var$printDescription(options, def) {
    var indentation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var firstInBlock = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var description = def.description;
    if (description == null) return '';
    if ((options === null || options === void 0 ? void 0 : options.commentDescriptions) === true) return $19c5db4b93436126$var$printDescriptionWithComments(description, indentation, firstInBlock);
    var preferMultipleLines = description.length > 70;
    var blockString = (0, $541Mz.printBlockString)(description, '', preferMultipleLines);
    var prefix = indentation && !firstInBlock ? '\n' + indentation : indentation;
    return prefix + blockString.replace(/\n/g, '\n' + indentation) + '\n';
}
function $19c5db4b93436126$var$printDescriptionWithComments(description, indentation, firstInBlock) {
    var prefix = indentation && !firstInBlock ? '\n' : '';
    var comment = description.split('\n').map(function(line) {
        return indentation + (line !== '' ? '# ' + line : '#');
    }).join('\n');
    return prefix + comment + '\n';
}

});

parcelRegister("kd1Ee", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $clSzL = parcelRequire("clSzL");

var $clSzL = parcelRequire("clSzL");
module.exports.execute = $clSzL.execute;
function $eb664ccd27fb29eb$var$linkToFetcher(link) {
    return function(fetcherOperation) {
        return $clSzL.makePromise($clSzL.execute(link, fetcherOperation));
    };
}
module.exports.default = $eb664ccd27fb29eb$var$linkToFetcher;

});

parcelRegister("bZzKT", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $8bb1207673418f48$var$isEmptyObject(obj) {
    if (!obj) return true;
    for(var key in obj){
        if (Object.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
module.exports.default = $8bb1207673418f48$var$isEmptyObject;

});

parcelRegister("0qKk1", function(module, exports) {
var $0014bf6d11b17ae1$var$__assign = module.exports && module.exports.__assign || function() {
    $0014bf6d11b17ae1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0014bf6d11b17ae1$var$__assign.apply(this, arguments);
};
var $0014bf6d11b17ae1$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0014bf6d11b17ae1$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6PRDg = parcelRequire("6PRDg");
function $0014bf6d11b17ae1$var$observableToAsyncIterable(observable) {
    var _a;
    var pullQueue = [];
    var pushQueue = [];
    var listening = true;
    var pushValue = function(_a) {
        var data = _a.data;
        if (pullQueue.length !== 0) pullQueue.shift()({
            value: data,
            done: false
        });
        else pushQueue.push({
            value: data
        });
    };
    var pushError = function(error) {
        if (pullQueue.length !== 0) pullQueue.shift()({
            value: {
                errors: [
                    error
                ]
            },
            done: false
        });
        else pushQueue.push({
            value: {
                errors: [
                    error
                ]
            }
        });
    };
    var pullValue = function() {
        return new Promise(function(resolve) {
            if (pushQueue.length !== 0) {
                var element = pushQueue.shift();
                // either {value: {errors: [...]}} or {value: ...}
                resolve($0014bf6d11b17ae1$var$__assign($0014bf6d11b17ae1$var$__assign({}, element), {
                    done: false
                }));
            } else pullQueue.push(resolve);
        });
    };
    var subscription = observable.subscribe({
        next: function(value) {
            pushValue(value);
        },
        error: function(err) {
            pushError(err);
        }
    });
    var emptyQueue = function() {
        if (listening) {
            listening = false;
            subscription.unsubscribe();
            pullQueue.forEach(function(resolve) {
                return resolve({
                    value: undefined,
                    done: true
                });
            });
            pullQueue.length = 0;
            pushQueue.length = 0;
        }
    };
    return _a = {
        next: function() {
            return $0014bf6d11b17ae1$var$__awaiter(this, void 0, void 0, function() {
                return $0014bf6d11b17ae1$var$__generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        listening ? pullValue() : this.return()
                    ];
                });
            });
        },
        return: function() {
            emptyQueue();
            return Promise.resolve({
                value: undefined,
                done: true
            });
        },
        throw: function(error) {
            emptyQueue();
            return Promise.reject(error);
        }
    }, _a[$6PRDg.$$asyncIterator] = function() {
        return this;
    }, _a;
}
module.exports.observableToAsyncIterable = $0014bf6d11b17ae1$var$observableToAsyncIterable;

});
parcelRegister("6PRDg", function(module, exports) {

$parcel$export(module.exports, "$$asyncIterator", () => $4fa11bc3c2ea1320$export$5ee754c34122a0ae);
/**
 * Copyright (c) 2016, Lee Byron
 * All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 * @ignore
 */ /**
 * [Iterator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterator)
 * is a *protocol* which describes a standard way to produce a sequence of
 * values, typically the values of the Iterable represented by this Iterator.
 *
 * While described by the [ES2015 version of JavaScript](http://www.ecma-international.org/ecma-262/6.0/#sec-iterator-interface)
 * it can be utilized by any version of JavaScript.
 *
 * @external Iterator
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterator|MDN Iteration protocols}
 */ /**
 * [Iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
 * is a *protocol* which when implemented allows a JavaScript object to define
 * their iteration behavior, such as what values are looped over in a
 * [`for...of`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/for...of)
 * loop or `iterall`'s `forEach` function. Many [built-in types](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#Builtin_iterables)
 * implement the Iterable protocol, including `Array` and `Map`.
 *
 * While described by the [ES2015 version of JavaScript](http://www.ecma-international.org/ecma-262/6.0/#sec-iterable-interface)
 * it can be utilized by any version of JavaScript.
 *
 * @external Iterable
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable|MDN Iteration protocols}
 */ // In ES2015 environments, Symbol exists
var $4fa11bc3c2ea1320$var$SYMBOL /*: any */  = typeof Symbol === 'function' ? Symbol : void 0;
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
var $4fa11bc3c2ea1320$var$SYMBOL_ITERATOR = $4fa11bc3c2ea1320$var$SYMBOL && $4fa11bc3c2ea1320$var$SYMBOL.iterator;
var $4fa11bc3c2ea1320$export$9785f547d3164dac = $4fa11bc3c2ea1320$var$SYMBOL_ITERATOR || '@@iterator';
function $4fa11bc3c2ea1320$export$9652023d9040757(obj) {
    return !!$4fa11bc3c2ea1320$export$23f5ee39f998bf6f(obj);
}
function $4fa11bc3c2ea1320$export$1e2f57719e155213(obj) {
    var length = obj != null && obj.length;
    return typeof length === 'number' && length >= 0 && length % 1 === 0;
}
function $4fa11bc3c2ea1320$export$cea7aa84e978eba5(obj) {
    return Object(obj) === obj && ($4fa11bc3c2ea1320$export$1e2f57719e155213(obj) || $4fa11bc3c2ea1320$export$9652023d9040757(obj));
}
function $4fa11bc3c2ea1320$export$6731da38428a8625(iterable) {
    var method = $4fa11bc3c2ea1320$export$23f5ee39f998bf6f(iterable);
    if (method) return method.call(iterable);
}
function $4fa11bc3c2ea1320$export$23f5ee39f998bf6f(iterable) {
    if (iterable != null) {
        var method = $4fa11bc3c2ea1320$var$SYMBOL_ITERATOR && iterable[$4fa11bc3c2ea1320$var$SYMBOL_ITERATOR] || iterable['@@iterator'];
        if (typeof method === 'function') return method;
    }
}
function $4fa11bc3c2ea1320$export$7342c78d7e13e778(collection) {
    if (collection != null) {
        var iterator = $4fa11bc3c2ea1320$export$6731da38428a8625(collection);
        if (iterator) return iterator;
        if ($4fa11bc3c2ea1320$export$1e2f57719e155213(collection)) return new $4fa11bc3c2ea1320$var$ArrayLikeIterator(collection);
    }
}
// When the object provided to `createIterator` is not Iterable but is
// Array-like, this simple Iterator is created.
function $4fa11bc3c2ea1320$var$ArrayLikeIterator(obj) {
    this._o = obj;
    this._i = 0;
}
// Note: all Iterators are themselves Iterable.
$4fa11bc3c2ea1320$var$ArrayLikeIterator.prototype[$4fa11bc3c2ea1320$export$9785f547d3164dac] = function() {
    return this;
};
// A simple state-machine determines the IteratorResult returned, yielding
// each value in the Array-like object in order of their indicies.
$4fa11bc3c2ea1320$var$ArrayLikeIterator.prototype.next = function() {
    if (this._o === void 0 || this._i >= this._o.length) {
        this._o = void 0;
        return {
            value: void 0,
            done: true
        };
    }
    return {
        value: this._o[this._i++],
        done: false
    };
};
function $4fa11bc3c2ea1320$export$4b80e395e36b5a56(collection, callback, thisArg) {
    if (collection != null) {
        if (typeof collection.forEach === 'function') return collection.forEach(callback, thisArg);
        var i = 0;
        var iterator = $4fa11bc3c2ea1320$export$6731da38428a8625(collection);
        if (iterator) {
            var step;
            while(!(step = iterator.next()).done){
                callback.call(thisArg, step.value, i++, collection);
                // Infinite Iterators could cause forEach to run forever.
                // After a very large number of iterations, produce an error.
                /* istanbul ignore if */ if (i > 9999999) throw new TypeError('Near-infinite iteration.');
            }
        } else if ($4fa11bc3c2ea1320$export$1e2f57719e155213(collection)) {
            for(; i < collection.length; i++)if (collection.hasOwnProperty(i)) callback.call(thisArg, collection[i], i, collection);
        }
    }
}
/////////////////////////////////////////////////////
//                                                 //
//                 ASYNC ITERATORS                 //
//                                                 //
/////////////////////////////////////////////////////
/**
 * [AsyncIterable](https://tc39.github.io/proposal-async-iteration/#sec-asynciterable-interface)
 * is a *protocol* which when implemented allows a JavaScript object to define
 * an asynchronous iteration behavior, such as what values are looped over in
 * a [`for-await-of`](https://tc39.github.io/proposal-async-iteration/#sec-for-in-and-for-of-statements)
 * loop or `iterall`'s {@link forAwaitEach} function.
 *
 * While described as a proposed addition to the [ES2017 version of JavaScript](https://tc39.github.io/proposal-async-iteration/)
 * it can be utilized by any version of JavaScript.
 *
 * @external AsyncIterable
 * @see {@link https://tc39.github.io/proposal-async-iteration/#sec-asynciterable-interface|Async Iteration Proposal}
 * @template T The type of each iterated value
 * @property {function (): AsyncIterator<T>} Symbol.asyncIterator
 *   A method which produces an AsyncIterator for this AsyncIterable.
 */ /**
 * [AsyncIterator](https://tc39.github.io/proposal-async-iteration/#sec-asynciterator-interface)
 * is a *protocol* which describes a standard way to produce and consume an
 * asynchronous sequence of values, typically the values of the
 * {@link AsyncIterable} represented by this {@link AsyncIterator}.
 *
 * AsyncIterator is similar to Observable or Stream. Like an {@link Iterator} it
 * also as a `next()` method, however instead of an IteratorResult,
 * calling this method returns a {@link Promise} for a IteratorResult.
 *
 * While described as a proposed addition to the [ES2017 version of JavaScript](https://tc39.github.io/proposal-async-iteration/)
 * it can be utilized by any version of JavaScript.
 *
 * @external AsyncIterator
 * @see {@link https://tc39.github.io/proposal-async-iteration/#sec-asynciterator-interface|Async Iteration Proposal}
 */ // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $4fa11bc3c2ea1320$var$SYMBOL_ASYNC_ITERATOR = $4fa11bc3c2ea1320$var$SYMBOL && $4fa11bc3c2ea1320$var$SYMBOL.asyncIterator;
var $4fa11bc3c2ea1320$export$5ee754c34122a0ae = $4fa11bc3c2ea1320$var$SYMBOL_ASYNC_ITERATOR || '@@asyncIterator';
function $4fa11bc3c2ea1320$export$edb10ab8dd75a915(obj) {
    return !!$4fa11bc3c2ea1320$export$b39a85787ec1202f(obj);
}
function $4fa11bc3c2ea1320$export$d5127502cdffbf83(asyncIterable) {
    var method = $4fa11bc3c2ea1320$export$b39a85787ec1202f(asyncIterable);
    if (method) return method.call(asyncIterable);
}
function $4fa11bc3c2ea1320$export$b39a85787ec1202f(asyncIterable) {
    if (asyncIterable != null) {
        var method = $4fa11bc3c2ea1320$var$SYMBOL_ASYNC_ITERATOR && asyncIterable[$4fa11bc3c2ea1320$var$SYMBOL_ASYNC_ITERATOR] || asyncIterable['@@asyncIterator'];
        if (typeof method === 'function') return method;
    }
}
function $4fa11bc3c2ea1320$export$86c18c6347f4a8c4(source) {
    if (source != null) {
        var asyncIterator = $4fa11bc3c2ea1320$export$d5127502cdffbf83(source);
        if (asyncIterator) return asyncIterator;
        var iterator = $4fa11bc3c2ea1320$export$7342c78d7e13e778(source);
        if (iterator) return new $4fa11bc3c2ea1320$var$AsyncFromSyncIterator(iterator);
    }
}
// When the object provided to `createAsyncIterator` is not AsyncIterable but is
// sync Iterable, this simple wrapper is created.
function $4fa11bc3c2ea1320$var$AsyncFromSyncIterator(iterator) {
    this._i = iterator;
}
// Note: all AsyncIterators are themselves AsyncIterable.
$4fa11bc3c2ea1320$var$AsyncFromSyncIterator.prototype[$4fa11bc3c2ea1320$export$5ee754c34122a0ae] = function() {
    return this;
};
// A simple state-machine determines the IteratorResult returned, yielding
// each value in the Array-like object in order of their indicies.
$4fa11bc3c2ea1320$var$AsyncFromSyncIterator.prototype.next = function(value) {
    return $4fa11bc3c2ea1320$var$unwrapAsyncFromSync(this._i, 'next', value);
};
$4fa11bc3c2ea1320$var$AsyncFromSyncIterator.prototype.return = function(value) {
    return this._i.return ? $4fa11bc3c2ea1320$var$unwrapAsyncFromSync(this._i, 'return', value) : Promise.resolve({
        value: value,
        done: true
    });
};
$4fa11bc3c2ea1320$var$AsyncFromSyncIterator.prototype.throw = function(value) {
    return this._i.throw ? $4fa11bc3c2ea1320$var$unwrapAsyncFromSync(this._i, 'throw', value) : Promise.reject(value);
};
function $4fa11bc3c2ea1320$var$unwrapAsyncFromSync(iterator, fn, value) {
    var step;
    return new Promise(function(resolve) {
        step = iterator[fn](value);
        resolve(step.value);
    }).then(function(value) {
        return {
            value: value,
            done: step.done
        };
    });
}
function $4fa11bc3c2ea1320$export$186aebae43ba1fda(source, callback, thisArg) {
    var asyncIterator = $4fa11bc3c2ea1320$export$86c18c6347f4a8c4(source);
    if (asyncIterator) {
        var i = 0;
        return new Promise(function(resolve, reject) {
            function next() {
                asyncIterator.next().then(function(step) {
                    if (!step.done) Promise.resolve(callback.call(thisArg, step.value, i++, source)).then(next).catch(reject);
                    else resolve();
                    // Explicitly return null, silencing bluebird-style warnings.
                    return null;
                }).catch(reject);
                // Explicitly return null, silencing bluebird-style warnings.
                return null;
            }
            next();
        });
    }
}

});



parcelRegister("hedUd", function(module, exports) {
var $c8ae87e141aaa748$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c8ae87e141aaa748$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eqS1b = parcelRequire("eqS1b");
var $8uUC9 = parcelRequire("8uUC9");

var $kOX49 = parcelRequire("kOX49");

var $kd1Ee = parcelRequire("kd1Ee");
var $c8ae87e141aaa748$var$parsedIntrospectionQuery = $8uUC9.parse($kOX49.getIntrospectionQuery());
function $c8ae87e141aaa748$var$introspectSchema(fetcher, linkContext) {
    return $c8ae87e141aaa748$var$__awaiter(this, void 0, void 0, function() {
        var introspectionResult, schema;
        return $c8ae87e141aaa748$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    // Convert link to fetcher
                    if (fetcher.request) fetcher = $kd1Ee.default(fetcher);
                    return [
                        4 /*yield*/ ,
                        fetcher({
                            query: $c8ae87e141aaa748$var$parsedIntrospectionQuery,
                            context: linkContext
                        })
                    ];
                case 1:
                    introspectionResult = _a.sent();
                    if (introspectionResult.errors && introspectionResult.errors.length || !introspectionResult.data.__schema) throw introspectionResult.errors;
                    else {
                        schema = $eqS1b.buildClientSchema(introspectionResult.data);
                        return [
                            2 /*return*/ ,
                            schema
                        ];
                    }
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.default = $c8ae87e141aaa748$var$introspectSchema;

});
parcelRegister("eqS1b", function(module, exports) {

$parcel$export(module.exports, "buildClientSchema", () => $a81d653f06430efe$export$de8c236cf09c987c);

var $isVmt = parcelRequire("isVmt");

var $yEDl8 = parcelRequire("yEDl8");

var $a1qmV = parcelRequire("a1qmV");

var $2gSpW = parcelRequire("2gSpW");

var $cJPdE = parcelRequire("cJPdE");

var $8uUC9 = parcelRequire("8uUC9");

var $lUVCX = parcelRequire("lUVCX");

var $35Smo = parcelRequire("35Smo");

var $djKly = parcelRequire("djKly");

var $4Hpke = parcelRequire("4Hpke");

var $8oLgk = parcelRequire("8oLgk");

var $9aGhX = parcelRequire("9aGhX");
function $a81d653f06430efe$export$de8c236cf09c987c(introspection, options) {
    (0, $cJPdE.default)(introspection) && (0, $cJPdE.default)(introspection.__schema) || (0, $a1qmV.default)(0, "Invalid or incomplete introspection result. Ensure that you are passing \"data\" property of introspection response and no \"errors\" was returned alongside: ".concat((0, $yEDl8.default)(introspection), ".")); // Get the schema from the introspection result.
    var schemaIntrospection = introspection.__schema; // Iterate through all types, getting the type definition for each.
    var typeMap = (0, $2gSpW.default)(schemaIntrospection.types, function(typeIntrospection) {
        return typeIntrospection.name;
    }, function(typeIntrospection) {
        return buildType(typeIntrospection);
    }); // Include standard types only if they are used.
    for(var _i2 = 0, _ref2 = [].concat((0, $djKly.specifiedScalarTypes), (0, $4Hpke.introspectionTypes)); _i2 < _ref2.length; _i2++){
        var stdType = _ref2[_i2];
        if (typeMap[stdType.name]) typeMap[stdType.name] = stdType;
    } // Get the root Query, Mutation, and Subscription types.
    var queryType = schemaIntrospection.queryType ? getObjectType(schemaIntrospection.queryType) : null;
    var mutationType = schemaIntrospection.mutationType ? getObjectType(schemaIntrospection.mutationType) : null;
    var subscriptionType = schemaIntrospection.subscriptionType ? getObjectType(schemaIntrospection.subscriptionType) : null; // Get the directives supported by Introspection, assuming empty-set if
    // directives were not queried for.
    var directives = schemaIntrospection.directives ? schemaIntrospection.directives.map(buildDirective) : []; // Then produce and return a Schema with these types.
    return new (0, $lUVCX.GraphQLSchema)({
        description: schemaIntrospection.description,
        query: queryType,
        mutation: mutationType,
        subscription: subscriptionType,
        types: (0, $isVmt.default)(typeMap),
        directives: directives,
        assumeValid: options === null || options === void 0 ? void 0 : options.assumeValid
    }); // Given a type reference in introspection, return the GraphQLType instance.
    // preferring cached instances before building new instances.
    function getType(typeRef) {
        if (typeRef.kind === (0, $4Hpke.TypeKind).LIST) {
            var itemRef = typeRef.ofType;
            if (!itemRef) throw new Error('Decorated type deeper than introspection query.');
            return new (0, $8oLgk.GraphQLList)(getType(itemRef));
        }
        if (typeRef.kind === (0, $4Hpke.TypeKind).NON_NULL) {
            var nullableRef = typeRef.ofType;
            if (!nullableRef) throw new Error('Decorated type deeper than introspection query.');
            var nullableType = getType(nullableRef);
            return new (0, $8oLgk.GraphQLNonNull)((0, $8oLgk.assertNullableType)(nullableType));
        }
        return getNamedType(typeRef);
    }
    function getNamedType(typeRef) {
        var typeName = typeRef.name;
        if (!typeName) throw new Error("Unknown type reference: ".concat((0, $yEDl8.default)(typeRef), "."));
        var type = typeMap[typeName];
        if (!type) throw new Error("Invalid or incomplete schema, unknown type: ".concat(typeName, ". Ensure that a full introspection query is used in order to build a client schema."));
        return type;
    }
    function getObjectType(typeRef) {
        return (0, $8oLgk.assertObjectType)(getNamedType(typeRef));
    }
    function getInterfaceType(typeRef) {
        return (0, $8oLgk.assertInterfaceType)(getNamedType(typeRef));
    } // Given a type's introspection result, construct the correct
    // GraphQLType instance.
    function buildType(type) {
        if (type != null && type.name != null && type.kind != null) switch(type.kind){
            case (0, $4Hpke.TypeKind).SCALAR:
                return buildScalarDef(type);
            case (0, $4Hpke.TypeKind).OBJECT:
                return buildObjectDef(type);
            case (0, $4Hpke.TypeKind).INTERFACE:
                return buildInterfaceDef(type);
            case (0, $4Hpke.TypeKind).UNION:
                return buildUnionDef(type);
            case (0, $4Hpke.TypeKind).ENUM:
                return buildEnumDef(type);
            case (0, $4Hpke.TypeKind).INPUT_OBJECT:
                return buildInputObjectDef(type);
        }
        var typeStr = (0, $yEDl8.default)(type);
        throw new Error("Invalid or incomplete introspection result. Ensure that a full introspection query is used in order to build a client schema: ".concat(typeStr, "."));
    }
    function buildScalarDef(scalarIntrospection) {
        return new (0, $8oLgk.GraphQLScalarType)({
            name: scalarIntrospection.name,
            description: scalarIntrospection.description,
            specifiedByUrl: scalarIntrospection.specifiedByUrl
        });
    }
    function buildImplementationsList(implementingIntrospection) {
        // TODO: Temporary workaround until GraphQL ecosystem will fully support
        // 'interfaces' on interface types.
        if (implementingIntrospection.interfaces === null && implementingIntrospection.kind === (0, $4Hpke.TypeKind).INTERFACE) return [];
        if (!implementingIntrospection.interfaces) {
            var implementingIntrospectionStr = (0, $yEDl8.default)(implementingIntrospection);
            throw new Error("Introspection result missing interfaces: ".concat(implementingIntrospectionStr, "."));
        }
        return implementingIntrospection.interfaces.map(getInterfaceType);
    }
    function buildObjectDef(objectIntrospection) {
        return new (0, $8oLgk.GraphQLObjectType)({
            name: objectIntrospection.name,
            description: objectIntrospection.description,
            interfaces: function interfaces() {
                return buildImplementationsList(objectIntrospection);
            },
            fields: function fields() {
                return buildFieldDefMap(objectIntrospection);
            }
        });
    }
    function buildInterfaceDef(interfaceIntrospection) {
        return new (0, $8oLgk.GraphQLInterfaceType)({
            name: interfaceIntrospection.name,
            description: interfaceIntrospection.description,
            interfaces: function interfaces() {
                return buildImplementationsList(interfaceIntrospection);
            },
            fields: function fields() {
                return buildFieldDefMap(interfaceIntrospection);
            }
        });
    }
    function buildUnionDef(unionIntrospection) {
        if (!unionIntrospection.possibleTypes) {
            var unionIntrospectionStr = (0, $yEDl8.default)(unionIntrospection);
            throw new Error("Introspection result missing possibleTypes: ".concat(unionIntrospectionStr, "."));
        }
        return new (0, $8oLgk.GraphQLUnionType)({
            name: unionIntrospection.name,
            description: unionIntrospection.description,
            types: function types() {
                return unionIntrospection.possibleTypes.map(getObjectType);
            }
        });
    }
    function buildEnumDef(enumIntrospection) {
        if (!enumIntrospection.enumValues) {
            var enumIntrospectionStr = (0, $yEDl8.default)(enumIntrospection);
            throw new Error("Introspection result missing enumValues: ".concat(enumIntrospectionStr, "."));
        }
        return new (0, $8oLgk.GraphQLEnumType)({
            name: enumIntrospection.name,
            description: enumIntrospection.description,
            values: (0, $2gSpW.default)(enumIntrospection.enumValues, function(valueIntrospection) {
                return valueIntrospection.name;
            }, function(valueIntrospection) {
                return {
                    description: valueIntrospection.description,
                    deprecationReason: valueIntrospection.deprecationReason
                };
            })
        });
    }
    function buildInputObjectDef(inputObjectIntrospection) {
        if (!inputObjectIntrospection.inputFields) {
            var inputObjectIntrospectionStr = (0, $yEDl8.default)(inputObjectIntrospection);
            throw new Error("Introspection result missing inputFields: ".concat(inputObjectIntrospectionStr, "."));
        }
        return new (0, $8oLgk.GraphQLInputObjectType)({
            name: inputObjectIntrospection.name,
            description: inputObjectIntrospection.description,
            fields: function fields() {
                return buildInputValueDefMap(inputObjectIntrospection.inputFields);
            }
        });
    }
    function buildFieldDefMap(typeIntrospection) {
        if (!typeIntrospection.fields) throw new Error("Introspection result missing fields: ".concat((0, $yEDl8.default)(typeIntrospection), "."));
        return (0, $2gSpW.default)(typeIntrospection.fields, function(fieldIntrospection) {
            return fieldIntrospection.name;
        }, buildField);
    }
    function buildField(fieldIntrospection) {
        var type = getType(fieldIntrospection.type);
        if (!(0, $8oLgk.isOutputType)(type)) {
            var typeStr = (0, $yEDl8.default)(type);
            throw new Error("Introspection must provide output type for fields, but received: ".concat(typeStr, "."));
        }
        if (!fieldIntrospection.args) {
            var fieldIntrospectionStr = (0, $yEDl8.default)(fieldIntrospection);
            throw new Error("Introspection result missing field args: ".concat(fieldIntrospectionStr, "."));
        }
        return {
            description: fieldIntrospection.description,
            deprecationReason: fieldIntrospection.deprecationReason,
            type: type,
            args: buildInputValueDefMap(fieldIntrospection.args)
        };
    }
    function buildInputValueDefMap(inputValueIntrospections) {
        return (0, $2gSpW.default)(inputValueIntrospections, function(inputValue) {
            return inputValue.name;
        }, buildInputValue);
    }
    function buildInputValue(inputValueIntrospection) {
        var type = getType(inputValueIntrospection.type);
        if (!(0, $8oLgk.isInputType)(type)) {
            var typeStr = (0, $yEDl8.default)(type);
            throw new Error("Introspection must provide input type for arguments, but received: ".concat(typeStr, "."));
        }
        var defaultValue = inputValueIntrospection.defaultValue != null ? (0, $9aGhX.valueFromAST)((0, $8uUC9.parseValue)(inputValueIntrospection.defaultValue), type) : undefined;
        return {
            description: inputValueIntrospection.description,
            type: type,
            defaultValue: defaultValue,
            deprecationReason: inputValueIntrospection.deprecationReason
        };
    }
    function buildDirective(directiveIntrospection) {
        if (!directiveIntrospection.args) {
            var directiveIntrospectionStr = (0, $yEDl8.default)(directiveIntrospection);
            throw new Error("Introspection result missing directive args: ".concat(directiveIntrospectionStr, "."));
        }
        if (!directiveIntrospection.locations) {
            var _directiveIntrospectionStr = (0, $yEDl8.default)(directiveIntrospection);
            throw new Error("Introspection result missing directive locations: ".concat(_directiveIntrospectionStr, "."));
        }
        return new (0, $35Smo.GraphQLDirective)({
            name: directiveIntrospection.name,
            description: directiveIntrospection.description,
            isRepeatable: directiveIntrospection.isRepeatable,
            locations: directiveIntrospection.locations.slice(),
            args: buildInputValueDefMap(directiveIntrospection.args)
        });
    }
}

});

parcelRegister("kOX49", function(module, exports) {

$parcel$export(module.exports, "getIntrospectionQuery", () => $f2864b6b34ba48ee$export$67a66015194c88d7);
function $f2864b6b34ba48ee$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f2864b6b34ba48ee$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f2864b6b34ba48ee$var$ownKeys(Object(source), true).forEach(function(key) {
            $f2864b6b34ba48ee$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f2864b6b34ba48ee$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f2864b6b34ba48ee$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f2864b6b34ba48ee$export$67a66015194c88d7(options) {
    var optionsWithDefault = $f2864b6b34ba48ee$var$_objectSpread({
        descriptions: true,
        specifiedByUrl: false,
        directiveIsRepeatable: false,
        schemaDescription: false,
        inputValueDeprecation: false
    }, options);
    var descriptions = optionsWithDefault.descriptions ? 'description' : '';
    var specifiedByUrl = optionsWithDefault.specifiedByUrl ? 'specifiedByUrl' : '';
    var directiveIsRepeatable = optionsWithDefault.directiveIsRepeatable ? 'isRepeatable' : '';
    var schemaDescription = optionsWithDefault.schemaDescription ? descriptions : '';
    function inputDeprecation(str) {
        return optionsWithDefault.inputValueDeprecation ? str : '';
    }
    return "\n    query IntrospectionQuery {\n      __schema {\n        ".concat(schemaDescription, "\n        queryType { name }\n        mutationType { name }\n        subscriptionType { name }\n        types {\n          ...FullType\n        }\n        directives {\n          name\n          ").concat(descriptions, "\n          ").concat(directiveIsRepeatable, "\n          locations\n          args").concat(inputDeprecation('(includeDeprecated: true)'), " {\n            ...InputValue\n          }\n        }\n      }\n    }\n\n    fragment FullType on __Type {\n      kind\n      name\n      ").concat(descriptions, "\n      ").concat(specifiedByUrl, "\n      fields(includeDeprecated: true) {\n        name\n        ").concat(descriptions, "\n        args").concat(inputDeprecation('(includeDeprecated: true)'), " {\n          ...InputValue\n        }\n        type {\n          ...TypeRef\n        }\n        isDeprecated\n        deprecationReason\n      }\n      inputFields").concat(inputDeprecation('(includeDeprecated: true)'), " {\n        ...InputValue\n      }\n      interfaces {\n        ...TypeRef\n      }\n      enumValues(includeDeprecated: true) {\n        name\n        ").concat(descriptions, "\n        isDeprecated\n        deprecationReason\n      }\n      possibleTypes {\n        ...TypeRef\n      }\n    }\n\n    fragment InputValue on __InputValue {\n      name\n      ").concat(descriptions, "\n      type { ...TypeRef }\n      defaultValue\n      ").concat(inputDeprecation('isDeprecated'), "\n      ").concat(inputDeprecation('deprecationReason'), "\n    }\n\n    fragment TypeRef on __Type {\n      kind\n      name\n      ofType {\n        kind\n        name\n        ofType {\n          kind\n          name\n          ofType {\n            kind\n            name\n            ofType {\n              kind\n              name\n              ofType {\n                kind\n                name\n                ofType {\n                  kind\n                  name\n                  ofType {\n                    kind\n                    name\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  ");
}

});


parcelRegister("5Cx8V", function(module, exports) {
var $417a35e0728175b6$var$__assign = module.exports && module.exports.__assign || function() {
    $417a35e0728175b6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $417a35e0728175b6$var$__assign.apply(this, arguments);
};
var $417a35e0728175b6$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8mJYM = parcelRequire("8mJYM");
var $8oLgk = parcelRequire("8oLgk");
var $35Smo = parcelRequire("35Smo");
var $lUVCX = parcelRequire("lUVCX");
var $bzIlO = parcelRequire("bzIlO");
var $8uUC9 = parcelRequire("8uUC9");

var $gIDuj = parcelRequire("gIDuj");

var $cPwLY = parcelRequire("cPwLY");

var $bkP2b = parcelRequire("bkP2b");

var $dfTWq = parcelRequire("dfTWq");

var $810gP = parcelRequire("810gP");

var $4Imtl = parcelRequire("4Imtl");

var $48EbR = parcelRequire("48EbR");
function $417a35e0728175b6$var$mergeSchemas(_a) {
    var schemas = _a.schemas, onTypeConflict = _a.onTypeConflict, resolvers = _a.resolvers, schemaDirectives = _a.schemaDirectives, inheritResolversFromInterfaces = _a.inheritResolversFromInterfaces, mergeDirectives = _a.mergeDirectives;
    return $417a35e0728175b6$var$mergeSchemasImplementation({
        schemas: schemas,
        resolvers: resolvers,
        schemaDirectives: schemaDirectives,
        inheritResolversFromInterfaces: inheritResolversFromInterfaces,
        mergeDirectives: mergeDirectives
    });
}
module.exports.default = $417a35e0728175b6$var$mergeSchemas;
function $417a35e0728175b6$var$mergeSchemasImplementation(_a) {
    var schemas = _a.schemas, resolvers = _a.resolvers, schemaDirectives = _a.schemaDirectives, inheritResolversFromInterfaces = _a.inheritResolversFromInterfaces, mergeDirectives = _a.mergeDirectives;
    var allSchemas = [];
    var typeCandidates = {};
    var types = {};
    var extensions = [];
    var directives = [];
    var fragments = [];
    var resolveType = $cPwLY.createResolveType(function(name) {
        if (types[name] === undefined) throw new Error("Can't find type " + name + ".");
        return types[name];
    });
    schemas.forEach(function(schema) {
        if (schema instanceof $lUVCX.GraphQLSchema) {
            allSchemas.push(schema);
            var queryType_1 = schema.getQueryType();
            var mutationType_1 = schema.getMutationType();
            var subscriptionType_1 = schema.getSubscriptionType();
            if (queryType_1) $417a35e0728175b6$var$addTypeCandidate(typeCandidates, 'Query', {
                schema: schema,
                type: queryType_1
            });
            if (mutationType_1) $417a35e0728175b6$var$addTypeCandidate(typeCandidates, 'Mutation', {
                schema: schema,
                type: mutationType_1
            });
            if (subscriptionType_1) $417a35e0728175b6$var$addTypeCandidate(typeCandidates, 'Subscription', {
                schema: schema,
                type: subscriptionType_1
            });
            if (mergeDirectives) {
                var directiveInstances = schema.getDirectives();
                directiveInstances.forEach(function(directive) {
                    directives.push(directive);
                });
            }
            var typeMap_1 = schema.getTypeMap();
            Object.keys(typeMap_1).forEach(function(typeName) {
                var type = typeMap_1[typeName];
                if ($8oLgk.isNamedType(type) && $8oLgk.getNamedType(type).name.slice(0, 2) !== '__' && type !== queryType_1 && type !== mutationType_1 && type !== subscriptionType_1) $417a35e0728175b6$var$addTypeCandidate(typeCandidates, type.name, {
                    schema: schema,
                    type: type
                });
            });
        } else if (typeof schema === 'string' || schema && schema.kind === $bzIlO.Kind.DOCUMENT) {
            var parsedSchemaDocument = typeof schema === 'string' ? $8uUC9.parse(schema) : schema;
            parsedSchemaDocument.definitions.forEach(function(def) {
                var type = $dfTWq.default(def);
                if (type instanceof $35Smo.GraphQLDirective && mergeDirectives) directives.push(type);
                else if (type && !(type instanceof $35Smo.GraphQLDirective)) $417a35e0728175b6$var$addTypeCandidate(typeCandidates, type.name, {
                    type: type
                });
            });
            var extensionsDocument = $gIDuj.extractExtensionDefinitions(parsedSchemaDocument);
            if (extensionsDocument.definitions.length > 0) extensions.push(extensionsDocument);
        } else if (Array.isArray(schema)) schema.forEach(function(type) {
            $417a35e0728175b6$var$addTypeCandidate(typeCandidates, type.name, {
                type: type
            });
        });
        else throw new Error("Invalid schema passed");
    });
    var mergeInfo = $417a35e0728175b6$var$createMergeInfo(allSchemas, fragments);
    if (!resolvers) resolvers = {};
    else if (typeof resolvers === 'function') {
        console.warn('Passing functions as resolver parameter is deprecated. Use `info.mergeInfo` instead.');
        resolvers = resolvers(mergeInfo);
    } else if (Array.isArray(resolvers)) resolvers = resolvers.reduce(function(left, right) {
        if (typeof right === 'function') {
            console.warn('Passing functions as resolver parameter is deprecated. Use `info.mergeInfo` instead.');
            right = right(mergeInfo);
        }
        return $4Imtl.default(left, right);
    }, {});
    var generatedResolvers = {};
    Object.keys(typeCandidates).forEach(function(typeName) {
        var resultType = $417a35e0728175b6$var$defaultVisitType(typeName, typeCandidates[typeName]);
        if (resultType === null) types[typeName] = null;
        else {
            var type = void 0;
            var typeResolvers = void 0;
            if ($8oLgk.isNamedType(resultType)) type = resultType;
            else if (resultType.type) {
                type = resultType.type;
                typeResolvers = resultType.resolvers;
            } else throw new Error("Invalid visitType result for type " + typeName);
            types[typeName] = $cPwLY.recreateType(type, resolveType, false);
            if (typeResolvers) generatedResolvers[typeName] = typeResolvers;
        }
    });
    var mergedSchema = new $lUVCX.GraphQLSchema({
        query: types.Query,
        mutation: types.Mutation,
        subscription: types.Subscription,
        types: Object.keys(types).map(function(key) {
            return types[key];
        }),
        directives: directives.map(function(directive) {
            return $cPwLY.recreateDirective(directive, resolveType);
        })
    });
    extensions.forEach(function(extension) {
        mergedSchema = $8mJYM.extendSchema(mergedSchema, extension, {
            commentDescriptions: true
        });
    });
    if (!resolvers) resolvers = {};
    else if (Array.isArray(resolvers)) resolvers = resolvers.reduce($4Imtl.default, {});
    Object.keys(resolvers).forEach(function(typeName) {
        var type = resolvers[typeName];
        if (type instanceof $8oLgk.GraphQLScalarType) return;
        Object.keys(type).forEach(function(fieldName) {
            var field = type[fieldName];
            if (field.fragment) fragments.push({
                field: fieldName,
                fragment: field.fragment
            });
        });
    });
    mergedSchema = $gIDuj.addResolveFunctionsToSchema({
        schema: mergedSchema,
        resolvers: $4Imtl.default(generatedResolvers, resolvers),
        inheritResolversFromInterfaces: inheritResolversFromInterfaces
    });
    $417a35e0728175b6$var$forEachField(mergedSchema, function(field) {
        if (field.resolve) {
            var fieldResolver_1 = field.resolve;
            field.resolve = function(parent, args, context, info) {
                var newInfo = $417a35e0728175b6$var$__assign($417a35e0728175b6$var$__assign({}, info), {
                    mergeInfo: mergeInfo
                });
                return fieldResolver_1(parent, args, context, newInfo);
            };
        }
        if (field.subscribe) {
            var fieldResolver_2 = field.subscribe;
            field.subscribe = function(parent, args, context, info) {
                var newInfo = $417a35e0728175b6$var$__assign($417a35e0728175b6$var$__assign({}, info), {
                    mergeInfo: mergeInfo
                });
                return fieldResolver_2(parent, args, context, newInfo);
            };
        }
    });
    if (schemaDirectives) $48EbR.SchemaDirectiveVisitor.visitSchemaDirectives(mergedSchema, schemaDirectives);
    return mergedSchema;
}
function $417a35e0728175b6$var$createMergeInfo(allSchemas, fragments) {
    return {
        delegate: function(operation, fieldName, args, context, info, transforms) {
            console.warn("`mergeInfo.delegate` is deprecated. Use `mergeInfo.delegateToSchema and pass explicit schema instances.");
            var schema = $417a35e0728175b6$var$guessSchemaByRootField(allSchemas, operation, fieldName);
            var expandTransforms = new $810gP.ExpandAbstractTypes(info.schema, schema);
            var fragmentTransform = new $810gP.ReplaceFieldWithFragment(schema, fragments);
            return $bkP2b.default({
                schema: schema,
                operation: operation,
                fieldName: fieldName,
                args: args,
                context: context,
                info: info,
                transforms: $417a35e0728175b6$var$__spreadArrays(transforms || [], [
                    expandTransforms,
                    fragmentTransform
                ])
            });
        },
        delegateToSchema: function(options) {
            return $bkP2b.default($417a35e0728175b6$var$__assign($417a35e0728175b6$var$__assign({}, options), {
                transforms: options.transforms
            }));
        },
        fragments: fragments
    };
}
function $417a35e0728175b6$var$guessSchemaByRootField(schemas, operation, fieldName) {
    for(var _i = 0, schemas_1 = schemas; _i < schemas_1.length; _i++){
        var schema = schemas_1[_i];
        var rootObject = void 0;
        if (operation === 'subscription') rootObject = schema.getSubscriptionType();
        else if (operation === 'mutation') rootObject = schema.getMutationType();
        else rootObject = schema.getQueryType();
        if (rootObject) {
            var fields = rootObject.getFields();
            if (fields[fieldName]) return schema;
        }
    }
    throw new Error("Could not find subschema with field `" + operation + "." + fieldName + "`");
}
function $417a35e0728175b6$var$createDelegatingResolver(schema, operation, fieldName) {
    return function(root, args, context, info) {
        return info.mergeInfo.delegateToSchema({
            schema: schema,
            operation: operation,
            fieldName: fieldName,
            args: args,
            context: context,
            info: info
        });
    };
}
function $417a35e0728175b6$var$forEachField(schema, fn) {
    var typeMap = schema.getTypeMap();
    Object.keys(typeMap).forEach(function(typeName) {
        var type = typeMap[typeName];
        if (!$8oLgk.getNamedType(type).name.startsWith('__') && type instanceof $8oLgk.GraphQLObjectType) {
            var fields_1 = type.getFields();
            Object.keys(fields_1).forEach(function(fieldName) {
                var field = fields_1[fieldName];
                fn(field, typeName, fieldName);
            });
        }
    });
}
function $417a35e0728175b6$var$addTypeCandidate(typeCandidates, name, typeCandidate) {
    if (!typeCandidates[name]) typeCandidates[name] = [];
    typeCandidates[name].push(typeCandidate);
}
function $417a35e0728175b6$var$defaultVisitType(name, candidates, candidateSelector) {
    if (!candidateSelector) candidateSelector = function(cands) {
        return cands[cands.length - 1];
    };
    var resolveType = $cPwLY.createResolveType(function(_, type) {
        return type;
    });
    if (name === 'Query' || name === 'Mutation' || name === 'Subscription') {
        var fields_2 = {};
        var operationName_1;
        switch(name){
            case 'Query':
                operationName_1 = 'query';
                break;
            case 'Mutation':
                operationName_1 = 'mutation';
                break;
            case 'Subscription':
                operationName_1 = 'subscription';
                break;
            default:
                break;
        }
        var resolvers_1 = {};
        var resolverKey_1 = operationName_1 === 'subscription' ? 'subscribe' : 'resolve';
        candidates.forEach(function(_a) {
            var candidateType = _a.type, schema = _a.schema;
            var candidateFields = candidateType.getFields();
            fields_2 = $417a35e0728175b6$var$__assign($417a35e0728175b6$var$__assign({}, fields_2), candidateFields);
            Object.keys(candidateFields).forEach(function(fieldName) {
                var _a;
                resolvers_1[fieldName] = (_a = {}, _a[resolverKey_1] = $417a35e0728175b6$var$createDelegatingResolver(schema, operationName_1, fieldName), _a);
            });
        });
        var type = new $8oLgk.GraphQLObjectType({
            name: name,
            fields: $cPwLY.fieldMapToFieldConfigMap(fields_2, resolveType, false)
        });
        return {
            type: type,
            resolvers: resolvers_1
        };
    } else {
        var candidate = candidateSelector(candidates);
        return candidate.type;
    }
}

});
parcelRegister("bkP2b", function(module, exports) {
var $8409264dd9216e7f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8409264dd9216e7f$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $8409264dd9216e7f$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $mP8zZ = parcelRequire("mP8zZ");
var $lUVCX = parcelRequire("lUVCX");
var $8oLgk = parcelRequire("8oLgk");
var $bzIlO = parcelRequire("bzIlO");
var $40hj3 = parcelRequire("40hj3");
var $c6jur = parcelRequire("c6jur");

var $9CEZe = parcelRequire("9CEZe");

var $4oDNM = parcelRequire("4oDNM");

var $b9txq = parcelRequire("b9txq");

var $5FnE9 = parcelRequire("5FnE9");

var $XeiAr = parcelRequire("XeiAr");

var $3Cwvd = parcelRequire("3Cwvd");

var $6Qqmu = parcelRequire("6Qqmu");

var $2WTvk = parcelRequire("2WTvk");

var $iP6T0 = parcelRequire("iP6T0");
function $8409264dd9216e7f$var$delegateToSchema(options) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (options instanceof $lUVCX.GraphQLSchema) throw new Error("Passing positional arguments to delegateToSchema is a deprecated. Please pass named parameters instead.");
    return $8409264dd9216e7f$var$delegateToSchemaImplementation(options);
}
module.exports.default = $8409264dd9216e7f$var$delegateToSchema;
function $8409264dd9216e7f$var$delegateToSchemaImplementation(options) {
    return $8409264dd9216e7f$var$__awaiter(this, void 0, void 0, function() {
        var info, _a, args, operation, rawDocument, rawRequest, transforms, processedRequest, errors, _b, executionResult;
        return $8409264dd9216e7f$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    info = options.info, _a = options.args, args = _a === void 0 ? {} : _a;
                    operation = options.operation || info.operation.operation;
                    rawDocument = $8409264dd9216e7f$var$createDocument(options.fieldName, operation, info.fieldNodes, Object.keys(info.fragments).map(function(fragmentName) {
                        return info.fragments[fragmentName];
                    }), info.operation.variableDefinitions, info.operation.name);
                    rawRequest = {
                        document: rawDocument,
                        variables: info.variableValues
                    };
                    transforms = $8409264dd9216e7f$var$__spreadArrays(options.transforms || [], [
                        new $6Qqmu.default(info.schema, options.schema)
                    ]);
                    if (info.mergeInfo && info.mergeInfo.fragments) transforms.push(new $2WTvk.default(options.schema, info.mergeInfo.fragments));
                    transforms = transforms.concat([
                        new $4oDNM.default(options.schema, args),
                        new $b9txq.default(options.schema),
                        new $5FnE9.default(options.schema),
                        new $XeiAr.default(info, options.fieldName)
                    ]);
                    if ($8oLgk.isEnumType(options.info.returnType)) transforms = transforms.concat(new $iP6T0.default(options.info.returnType));
                    processedRequest = $9CEZe.applyRequestTransforms(rawRequest, transforms);
                    if (!options.skipValidation) {
                        errors = $c6jur.validate(options.schema, processedRequest.document);
                        if (errors.length > 0) throw errors;
                    }
                    if (!(operation === 'query' || operation === 'mutation')) return [
                        3 /*break*/ ,
                        2
                    ];
                    _b = $9CEZe.applyResultTransforms;
                    return [
                        4 /*yield*/ ,
                        $mP8zZ.execute(options.schema, processedRequest.document, info.rootValue, options.context, processedRequest.variables)
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _b.apply(void 0, [
                            _c.sent(),
                            transforms
                        ])
                    ];
                case 2:
                    if (!(operation === 'subscription')) return [
                        3 /*break*/ ,
                        4
                    ];
                    return [
                        4 /*yield*/ ,
                        $40hj3.subscribe(options.schema, processedRequest.document, info.rootValue, options.context, processedRequest.variables)
                    ];
                case 3:
                    executionResult = _c.sent();
                    // "subscribe" to the subscription result and map the result through the transforms
                    return [
                        2 /*return*/ ,
                        $3Cwvd.default(executionResult, function(result) {
                            var _a;
                            var transformedResult = $9CEZe.applyResultTransforms(result, transforms);
                            var subscriptionKey = Object.keys(result.data)[0];
                            // for some reason the returned transformedResult needs to be nested inside the root subscription field
                            // does not work otherwise...
                            return _a = {}, _a[subscriptionKey] = transformedResult, _a;
                        })
                    ];
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $8409264dd9216e7f$var$createDocument(targetField, targetOperation, originalSelections, fragments, variables, operationName) {
    var selections = [];
    var args = [];
    originalSelections.forEach(function(field) {
        var fieldSelections = field.selectionSet ? field.selectionSet.selections : [];
        selections = selections.concat(fieldSelections);
        args = args.concat(field.arguments || []);
    });
    var selectionSet = null;
    if (selections.length > 0) selectionSet = {
        kind: $bzIlO.Kind.SELECTION_SET,
        selections: selections
    };
    var rootField = {
        kind: $bzIlO.Kind.FIELD,
        alias: null,
        arguments: args,
        selectionSet: selectionSet,
        name: {
            kind: $bzIlO.Kind.NAME,
            value: targetField
        }
    };
    var rootSelectionSet = {
        kind: $bzIlO.Kind.SELECTION_SET,
        selections: [
            rootField
        ]
    };
    var operationDefinition = {
        kind: $bzIlO.Kind.OPERATION_DEFINITION,
        operation: targetOperation,
        variableDefinitions: variables,
        selectionSet: rootSelectionSet,
        name: operationName
    };
    return {
        kind: $bzIlO.Kind.DOCUMENT,
        definitions: $8409264dd9216e7f$var$__spreadArrays([
            operationDefinition
        ], fragments)
    };
}

});
parcelRegister("40hj3", function(module, exports) {

$parcel$export(module.exports, "subscribe", () => $2ea4962eb4b8b875$export$ec068583843480e7);

var $yEDl8 = parcelRequire("yEDl8");

var $lLo68 = parcelRequire("lLo68");

var $hEo2F = parcelRequire("hEo2F");

var $g5yZB = parcelRequire("g5yZB");

var $csEv9 = parcelRequire("csEv9");

var $7dqoX = parcelRequire("7dqoX");

var $mP8zZ = parcelRequire("mP8zZ");

var $etM9Y = parcelRequire("etM9Y");

var $iLnJr = parcelRequire("iLnJr");
function $2ea4962eb4b8b875$export$ec068583843480e7(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, subscribeFieldResolver) {
    /* eslint-enable no-redeclare */ // Extract arguments from object args if provided.
    return arguments.length === 1 ? $2ea4962eb4b8b875$var$subscribeImpl(argsOrSchema) : $2ea4962eb4b8b875$var$subscribeImpl({
        schema: argsOrSchema,
        document: document,
        rootValue: rootValue,
        contextValue: contextValue,
        variableValues: variableValues,
        operationName: operationName,
        fieldResolver: fieldResolver,
        subscribeFieldResolver: subscribeFieldResolver
    });
}
/**
 * This function checks if the error is a GraphQLError. If it is, report it as
 * an ExecutionResult, containing only errors and no data. Otherwise treat the
 * error as a system-class error and re-throw it.
 */ function $2ea4962eb4b8b875$var$reportGraphQLError(error) {
    if (error instanceof (0, $g5yZB.GraphQLError)) return {
        errors: [
            error
        ]
    };
    throw error;
}
function $2ea4962eb4b8b875$var$subscribeImpl(args) {
    var schema = args.schema, document = args.document, rootValue = args.rootValue, contextValue = args.contextValue, variableValues = args.variableValues, operationName = args.operationName, fieldResolver = args.fieldResolver, subscribeFieldResolver = args.subscribeFieldResolver;
    var sourcePromise = $2ea4962eb4b8b875$export$640ee730a9007071(schema, document, rootValue, contextValue, variableValues, operationName, subscribeFieldResolver); // For each payload yielded from a subscription, map it over the normal
    // GraphQL `execute` function, with `payload` as the rootValue.
    // This implements the "MapSourceToResponseEvent" algorithm described in
    // the GraphQL specification. The `execute` function provides the
    // "ExecuteSubscriptionEvent" algorithm, as it is nearly identical to the
    // "ExecuteQuery" algorithm, for which `execute` is also used.
    var mapSourceToResponse = function mapSourceToResponse(payload) {
        return (0, $mP8zZ.execute)({
            schema: schema,
            document: document,
            rootValue: payload,
            contextValue: contextValue,
            variableValues: variableValues,
            operationName: operationName,
            fieldResolver: fieldResolver
        });
    }; // Resolve the Source Stream, then map every source value to a
    // ExecutionResult value as described above.
    return sourcePromise.then(function(resultOrStream) {
        return (0, $lLo68.default)(resultOrStream) ? (0, $iLnJr.default)(resultOrStream, mapSourceToResponse, $2ea4962eb4b8b875$var$reportGraphQLError) : resultOrStream;
    });
}
function $2ea4962eb4b8b875$export$640ee730a9007071(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver) {
    // If arguments are missing or incorrectly typed, this is an internal
    // developer mistake which should throw an early error.
    (0, $mP8zZ.assertValidExecutionArguments)(schema, document, variableValues);
    return new Promise(function(resolve) {
        // If a valid context cannot be created due to incorrect arguments,
        // this will throw an error.
        var exeContext = (0, $mP8zZ.buildExecutionContext)(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver);
        resolve(Array.isArray(exeContext) ? {
            errors: exeContext
        } : $2ea4962eb4b8b875$var$executeSubscription(exeContext));
    }).catch($2ea4962eb4b8b875$var$reportGraphQLError);
}
function $2ea4962eb4b8b875$var$executeSubscription(exeContext) {
    var schema = exeContext.schema, operation = exeContext.operation, variableValues = exeContext.variableValues, rootValue = exeContext.rootValue;
    var type = (0, $etM9Y.getOperationRootType)(schema, operation);
    var fields = (0, $mP8zZ.collectFields)(exeContext, type, operation.selectionSet, Object.create(null), Object.create(null));
    var responseNames = Object.keys(fields);
    var responseName = responseNames[0];
    var fieldNodes = fields[responseName];
    var fieldNode = fieldNodes[0];
    var fieldName = fieldNode.name.value;
    var fieldDef = (0, $mP8zZ.getFieldDef)(schema, type, fieldName);
    if (!fieldDef) throw new (0, $g5yZB.GraphQLError)("The subscription field \"".concat(fieldName, "\" is not defined."), fieldNodes);
    var path = (0, $hEo2F.addPath)(undefined, responseName, type.name);
    var info = (0, $mP8zZ.buildResolveInfo)(exeContext, fieldDef, fieldNodes, type, path); // Coerce to Promise for easier error handling and consistent return type.
    return new Promise(function(resolveResult) {
        var _fieldDef$subscribe;
        // Implements the "ResolveFieldEventStream" algorithm from GraphQL specification.
        // It differs from "ResolveFieldValue" due to providing a different `resolveFn`.
        // Build a JS object of arguments from the field.arguments AST, using the
        // variables scope to fulfill any variable references.
        var args = (0, $7dqoX.getArgumentValues)(fieldDef, fieldNodes[0], variableValues); // The resolve function's optional third argument is a context value that
        // is provided to every resolve function within an execution. It is commonly
        // used to represent an authenticated user, or request-specific caches.
        var contextValue = exeContext.contextValue; // Call the `subscribe()` resolver or the default resolver to produce an
        // AsyncIterable yielding raw payloads.
        var resolveFn = (_fieldDef$subscribe = fieldDef.subscribe) !== null && _fieldDef$subscribe !== void 0 ? _fieldDef$subscribe : exeContext.fieldResolver;
        resolveResult(resolveFn(rootValue, args, contextValue, info));
    }).then(function(eventStream) {
        if (eventStream instanceof Error) throw (0, $csEv9.locatedError)(eventStream, fieldNodes, (0, $hEo2F.pathToArray)(path));
         // Assert field returned an event stream, otherwise yield an error.
        if (!(0, $lLo68.default)(eventStream)) throw new Error('Subscription field must return Async Iterable. ' + "Received: ".concat((0, $yEDl8.default)(eventStream), "."));
        return eventStream;
    }, function(error) {
        throw (0, $csEv9.locatedError)(error, fieldNodes, (0, $hEo2F.pathToArray)(path));
    });
}

});
parcelRegister("lLo68", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd80ae1b6a9b0f46$export$2e2bcd8739ae039);

var $6DBwa = parcelRequire("6DBwa");
function $fd80ae1b6a9b0f46$export$2e2bcd8739ae039(maybeAsyncIterable) {
    return typeof (maybeAsyncIterable === null || maybeAsyncIterable === void 0 ? void 0 : maybeAsyncIterable[0, $6DBwa.SYMBOL_ASYNC_ITERATOR]) === 'function';
}

});

parcelRegister("iLnJr", function(module, exports) {

$parcel$export(module.exports, "default", () => $da8f0678f4258a56$export$2e2bcd8739ae039);

var $6DBwa = parcelRequire("6DBwa");
function $da8f0678f4258a56$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $da8f0678f4258a56$export$2e2bcd8739ae039(iterable, callback, rejectCallback) {
    // $FlowFixMe[prop-missing]
    var iteratorMethod = iterable[0, $6DBwa.SYMBOL_ASYNC_ITERATOR];
    var iterator = iteratorMethod.call(iterable);
    var $return;
    var abruptClose;
    if (typeof iterator.return === 'function') {
        $return = iterator.return;
        abruptClose = function abruptClose(error) {
            var rethrow = function rethrow() {
                return Promise.reject(error);
            };
            return $return.call(iterator).then(rethrow, rethrow);
        };
    }
    function mapResult(result) {
        return result.done ? result : $da8f0678f4258a56$var$asyncMapValue(result.value, callback).then($da8f0678f4258a56$var$iteratorResult, abruptClose);
    }
    var mapReject;
    if (rejectCallback) {
        // Capture rejectCallback to ensure it cannot be null.
        var reject = rejectCallback;
        mapReject = function mapReject(error) {
            return $da8f0678f4258a56$var$asyncMapValue(error, reject).then($da8f0678f4258a56$var$iteratorResult, abruptClose);
        };
    }
    /* TODO: Flow doesn't support symbols as keys:
     https://github.com/facebook/flow/issues/3258 */ return $da8f0678f4258a56$var$_defineProperty({
        next: function next() {
            return iterator.next().then(mapResult, mapReject);
        },
        return: function _return() {
            return $return ? $return.call(iterator).then(mapResult, mapReject) : Promise.resolve({
                value: undefined,
                done: true
            });
        },
        throw: function _throw(error) {
            if (typeof iterator.throw === 'function') return iterator.throw(error).then(mapResult, mapReject);
            return Promise.reject(error).catch(abruptClose);
        }
    }, (0, $6DBwa.SYMBOL_ASYNC_ITERATOR), function() {
        return this;
    });
}
function $da8f0678f4258a56$var$asyncMapValue(value, callback) {
    return new Promise(function(resolve) {
        return resolve(callback(value));
    });
}
function $da8f0678f4258a56$var$iteratorResult(value) {
    return {
        value: value,
        done: false
    };
}

});


parcelRegister("4oDNM", function(module, exports) {
var $3338471fdbe5b1f4$var$__assign = module.exports && module.exports.__assign || function() {
    $3338471fdbe5b1f4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3338471fdbe5b1f4$var$__assign.apply(this, arguments);
};
var $3338471fdbe5b1f4$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8oLgk = parcelRequire("8oLgk");
var $bzIlO = parcelRequire("bzIlO");
var $3338471fdbe5b1f4$var$AddArgumentsAsVariablesTransform = /** @class */ function() {
    function AddArgumentsAsVariablesTransform(schema, args) {
        this.schema = schema;
        this.args = args;
    }
    AddArgumentsAsVariablesTransform.prototype.transformRequest = function(originalRequest) {
        var _a = $3338471fdbe5b1f4$var$addVariablesToRootField(this.schema, originalRequest.document, this.args), document = _a.document, newVariables = _a.newVariables;
        var variables = $3338471fdbe5b1f4$var$__assign($3338471fdbe5b1f4$var$__assign({}, originalRequest.variables), newVariables);
        return {
            document: document,
            variables: variables
        };
    };
    return AddArgumentsAsVariablesTransform;
}();
module.exports.default = $3338471fdbe5b1f4$var$AddArgumentsAsVariablesTransform;
function $3338471fdbe5b1f4$var$addVariablesToRootField(targetSchema, document, args) {
    var operations = document.definitions.filter(function(def) {
        return def.kind === $bzIlO.Kind.OPERATION_DEFINITION;
    });
    var fragments = document.definitions.filter(function(def) {
        return def.kind === $bzIlO.Kind.FRAGMENT_DEFINITION;
    });
    var variableNames = {};
    var newOperations = operations.map(function(operation) {
        var existingVariables = operation.variableDefinitions.map(function(variableDefinition) {
            return variableDefinition.variable.name.value;
        });
        var variableCounter = 0;
        var variables = {};
        var generateVariableName = function(argName) {
            var varName;
            do {
                varName = "_v" + variableCounter + "_" + argName;
                variableCounter++;
            }while (existingVariables.indexOf(varName) !== -1);
            return varName;
        };
        var type;
        if (operation.operation === 'subscription') type = targetSchema.getSubscriptionType();
        else if (operation.operation === 'mutation') type = targetSchema.getMutationType();
        else type = targetSchema.getQueryType();
        var newSelectionSet = [];
        operation.selectionSet.selections.forEach(function(selection) {
            if (selection.kind === $bzIlO.Kind.FIELD) {
                var newArgs_1 = {};
                selection.arguments.forEach(function(argument) {
                    newArgs_1[argument.name.value] = argument;
                });
                var name_1 = selection.name.value;
                var field = type.getFields()[name_1];
                field.args.forEach(function(argument) {
                    if (argument.name in args) {
                        var variableName = generateVariableName(argument.name);
                        variableNames[argument.name] = variableName;
                        newArgs_1[argument.name] = {
                            kind: $bzIlO.Kind.ARGUMENT,
                            name: {
                                kind: $bzIlO.Kind.NAME,
                                value: argument.name
                            },
                            value: {
                                kind: $bzIlO.Kind.VARIABLE,
                                name: {
                                    kind: $bzIlO.Kind.NAME,
                                    value: variableName
                                }
                            }
                        };
                        existingVariables.push(variableName);
                        variables[variableName] = {
                            kind: $bzIlO.Kind.VARIABLE_DEFINITION,
                            variable: {
                                kind: $bzIlO.Kind.VARIABLE,
                                name: {
                                    kind: $bzIlO.Kind.NAME,
                                    value: variableName
                                }
                            },
                            type: $3338471fdbe5b1f4$var$typeToAst(argument.type)
                        };
                    }
                });
                newSelectionSet.push($3338471fdbe5b1f4$var$__assign($3338471fdbe5b1f4$var$__assign({}, selection), {
                    arguments: Object.keys(newArgs_1).map(function(argName) {
                        return newArgs_1[argName];
                    })
                }));
            } else newSelectionSet.push(selection);
        });
        return $3338471fdbe5b1f4$var$__assign($3338471fdbe5b1f4$var$__assign({}, operation), {
            variableDefinitions: operation.variableDefinitions.concat(Object.keys(variables).map(function(varName) {
                return variables[varName];
            })),
            selectionSet: {
                kind: $bzIlO.Kind.SELECTION_SET,
                selections: newSelectionSet
            }
        });
    });
    var newVariables = {};
    Object.keys(variableNames).forEach(function(name) {
        newVariables[variableNames[name]] = args[name];
    });
    return {
        document: $3338471fdbe5b1f4$var$__assign($3338471fdbe5b1f4$var$__assign({}, document), {
            definitions: $3338471fdbe5b1f4$var$__spreadArrays(newOperations, fragments)
        }),
        newVariables: newVariables
    };
}
function $3338471fdbe5b1f4$var$typeToAst(type) {
    if (type instanceof $8oLgk.GraphQLNonNull) {
        var innerType = $3338471fdbe5b1f4$var$typeToAst(type.ofType);
        if (innerType.kind === $bzIlO.Kind.LIST_TYPE || innerType.kind === $bzIlO.Kind.NAMED_TYPE) return {
            kind: $bzIlO.Kind.NON_NULL_TYPE,
            type: innerType
        };
        else throw new Error('Incorrent inner non-null type');
    } else if (type instanceof $8oLgk.GraphQLList) return {
        kind: $bzIlO.Kind.LIST_TYPE,
        type: $3338471fdbe5b1f4$var$typeToAst(type.ofType)
    };
    else return {
        kind: $bzIlO.Kind.NAMED_TYPE,
        name: {
            kind: $bzIlO.Kind.NAME,
            value: type.toString()
        }
    };
}

});

parcelRegister("b9txq", function(module, exports) {
var $81e7729e1342f8d1$var$__assign = module.exports && module.exports.__assign || function() {
    $81e7729e1342f8d1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $81e7729e1342f8d1$var$__assign.apply(this, arguments);
};
var $81e7729e1342f8d1$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8oLgk = parcelRequire("8oLgk");
var $bzIlO = parcelRequire("bzIlO");
var $4Hpke = parcelRequire("4Hpke");
var $12QNw = parcelRequire("12QNw");

var $jdSTa = parcelRequire("jdSTa");
var $81e7729e1342f8d1$var$FilterToSchema = /** @class */ function() {
    function FilterToSchema(targetSchema) {
        this.targetSchema = targetSchema;
    }
    FilterToSchema.prototype.transformRequest = function(originalRequest) {
        var document = $81e7729e1342f8d1$var$filterDocumentToSchema(this.targetSchema, originalRequest.document);
        return $81e7729e1342f8d1$var$__assign($81e7729e1342f8d1$var$__assign({}, originalRequest), {
            document: document
        });
    };
    return FilterToSchema;
}();
module.exports.default = $81e7729e1342f8d1$var$FilterToSchema;
function $81e7729e1342f8d1$var$filterDocumentToSchema(targetSchema, document) {
    var operations = document.definitions.filter(function(def) {
        return def.kind === $bzIlO.Kind.OPERATION_DEFINITION;
    });
    var fragments = document.definitions.filter(function(def) {
        return def.kind === $bzIlO.Kind.FRAGMENT_DEFINITION;
    });
    var usedFragments = [];
    var newOperations = [];
    var newFragments = [];
    var validFragments = fragments.filter(function(fragment) {
        var typeName = fragment.typeCondition.name.value;
        return Boolean(targetSchema.getType(typeName));
    });
    var validFragmentsWithType = {};
    validFragments.forEach(function(fragment) {
        var typeName = fragment.typeCondition.name.value;
        var type = targetSchema.getType(typeName);
        validFragmentsWithType[fragment.name.value] = type;
    });
    var fragmentSet = Object.create(null);
    operations.forEach(function(operation) {
        var type;
        if (operation.operation === 'subscription') type = targetSchema.getSubscriptionType();
        else if (operation.operation === 'mutation') type = targetSchema.getMutationType();
        else type = targetSchema.getQueryType();
        var _a = $81e7729e1342f8d1$var$filterSelectionSet(targetSchema, type, validFragmentsWithType, operation.selectionSet), selectionSet = _a.selectionSet, operationUsedFragments = _a.usedFragments, operationUsedVariables = _a.usedVariables;
        usedFragments = $81e7729e1342f8d1$var$union(usedFragments, operationUsedFragments);
        var _b = $81e7729e1342f8d1$var$collectFragmentVariables(targetSchema, fragmentSet, validFragments, validFragmentsWithType, usedFragments), collectedUsedVariables = _b.usedVariables, collectedNewFragments = _b.newFragments, collectedFragmentSet = _b.fragmentSet;
        var fullUsedVariables = $81e7729e1342f8d1$var$union(operationUsedVariables, collectedUsedVariables);
        newFragments = collectedNewFragments;
        fragmentSet = collectedFragmentSet;
        var variableDefinitions = operation.variableDefinitions.filter(function(variable) {
            return fullUsedVariables.indexOf(variable.variable.name.value) !== -1;
        });
        newOperations.push({
            kind: $bzIlO.Kind.OPERATION_DEFINITION,
            operation: operation.operation,
            name: operation.name,
            directives: operation.directives,
            variableDefinitions: variableDefinitions,
            selectionSet: selectionSet
        });
    });
    return {
        kind: $bzIlO.Kind.DOCUMENT,
        definitions: $81e7729e1342f8d1$var$__spreadArrays(newOperations, newFragments)
    };
}
function $81e7729e1342f8d1$var$collectFragmentVariables(targetSchema, fragmentSet, validFragments, validFragmentsWithType, usedFragments) {
    var usedVariables = [];
    var newFragments = [];
    var _loop_1 = function() {
        var nextFragmentName = usedFragments.pop();
        var fragment = validFragments.find(function(fr) {
            return fr.name.value === nextFragmentName;
        });
        if (fragment) {
            var name_1 = nextFragmentName;
            var typeName = fragment.typeCondition.name.value;
            var type = targetSchema.getType(typeName);
            var _a = $81e7729e1342f8d1$var$filterSelectionSet(targetSchema, type, validFragmentsWithType, fragment.selectionSet), selectionSet = _a.selectionSet, fragmentUsedFragments = _a.usedFragments, fragmentUsedVariables = _a.usedVariables;
            usedFragments = $81e7729e1342f8d1$var$union(usedFragments, fragmentUsedFragments);
            usedVariables = $81e7729e1342f8d1$var$union(usedVariables, fragmentUsedVariables);
            if (!fragmentSet[name_1]) {
                fragmentSet[name_1] = true;
                newFragments.push({
                    kind: $bzIlO.Kind.FRAGMENT_DEFINITION,
                    name: {
                        kind: $bzIlO.Kind.NAME,
                        value: name_1
                    },
                    typeCondition: fragment.typeCondition,
                    selectionSet: selectionSet
                });
            }
        }
    };
    while(usedFragments.length !== 0)_loop_1();
    return {
        usedVariables: usedVariables,
        newFragments: newFragments,
        fragmentSet: fragmentSet
    };
}
function $81e7729e1342f8d1$var$filterSelectionSet(schema, type, validFragments, selectionSet) {
    var _a;
    var usedFragments = [];
    var usedVariables = [];
    var typeStack = [
        type
    ];
    // Should be rewritten using visitWithSchema
    var filteredSelectionSet = $12QNw.visit(selectionSet, (_a = {}, _a[$bzIlO.Kind.FIELD] = {
        enter: function(node) {
            var parentType = $81e7729e1342f8d1$var$resolveType(typeStack[typeStack.length - 1]);
            if (parentType instanceof $8oLgk.GraphQLObjectType || parentType instanceof $8oLgk.GraphQLInterfaceType) {
                var fields = parentType.getFields();
                var field = node.name.value === '__typename' ? $4Hpke.TypeNameMetaFieldDef : fields[node.name.value];
                if (!field) return null;
                else typeStack.push(field.type);
                var argNames_1 = (field.args || []).map(function(arg) {
                    return arg.name;
                });
                if (node.arguments) {
                    var args = node.arguments.filter(function(arg) {
                        return argNames_1.indexOf(arg.name.value) !== -1;
                    });
                    if (args.length !== node.arguments.length) return $81e7729e1342f8d1$var$__assign($81e7729e1342f8d1$var$__assign({}, node), {
                        arguments: args
                    });
                }
            } else if (parentType instanceof $8oLgk.GraphQLUnionType && node.name.value === '__typename') typeStack.push($4Hpke.TypeNameMetaFieldDef.type);
        },
        leave: function(node) {
            var _a;
            var currentType = typeStack.pop();
            var resolvedType = $81e7729e1342f8d1$var$resolveType(currentType);
            if (resolvedType instanceof $8oLgk.GraphQLObjectType || resolvedType instanceof $8oLgk.GraphQLInterfaceType) {
                var selections = node.selectionSet && node.selectionSet.selections || null;
                if (!selections || selections.length === 0) {
                    // need to remove any added variables. Is there a better way to do this?
                    $12QNw.visit(node, (_a = {}, _a[$bzIlO.Kind.VARIABLE] = function(variableNode) {
                        var index = usedVariables.indexOf(variableNode.name.value);
                        if (index !== -1) usedVariables.splice(index, 1);
                    }, _a));
                    return null;
                }
            }
        }
    }, _a[$bzIlO.Kind.FRAGMENT_SPREAD] = function(node) {
        if (node.name.value in validFragments) {
            var parentType = $81e7729e1342f8d1$var$resolveType(typeStack[typeStack.length - 1]);
            var innerType = validFragments[node.name.value];
            if (!$jdSTa.default(schema, parentType, innerType)) return null;
            else {
                usedFragments.push(node.name.value);
                return;
            }
        } else return null;
    }, _a[$bzIlO.Kind.INLINE_FRAGMENT] = {
        enter: function(node) {
            if (node.typeCondition) {
                var innerType = schema.getType(node.typeCondition.name.value);
                var parentType = $81e7729e1342f8d1$var$resolveType(typeStack[typeStack.length - 1]);
                if ($jdSTa.default(schema, parentType, innerType)) typeStack.push(innerType);
                else return null;
            }
        },
        leave: function(node) {
            typeStack.pop();
        }
    }, _a[$bzIlO.Kind.VARIABLE] = function(node) {
        usedVariables.push(node.name.value);
    }, _a));
    return {
        selectionSet: filteredSelectionSet,
        usedFragments: usedFragments,
        usedVariables: usedVariables
    };
}
function $81e7729e1342f8d1$var$resolveType(type) {
    var lastType = type;
    while(lastType instanceof $8oLgk.GraphQLNonNull || lastType instanceof $8oLgk.GraphQLList)lastType = lastType.ofType;
    return lastType;
}
function $81e7729e1342f8d1$var$union() {
    var arrays = [];
    for(var _i = 0; _i < arguments.length; _i++)arrays[_i] = arguments[_i];
    var cache = {};
    var result = [];
    arrays.forEach(function(array) {
        array.forEach(function(item) {
            if (!cache[item]) {
                cache[item] = true;
                result.push(item);
            }
        });
    });
    return result;
}

});
parcelRegister("jdSTa", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9GswX = parcelRequire("9GswX");
var $8oLgk = parcelRequire("8oLgk");
function $dfe9cef9f2476969$var$implementsAbstractType(schema, typeA, typeB) {
    if (typeA === typeB) return true;
    else if ($8oLgk.isCompositeType(typeA) && $8oLgk.isCompositeType(typeB)) return $9GswX.doTypesOverlap(schema, typeA, typeB);
    else return false;
}
module.exports.default = $dfe9cef9f2476969$var$implementsAbstractType;

});


parcelRegister("5FnE9", function(module, exports) {
var $42031fc988697446$var$__assign = module.exports && module.exports.__assign || function() {
    $42031fc988697446$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $42031fc988697446$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8oLgk = parcelRequire("8oLgk");
var $bzIlO = parcelRequire("bzIlO");
var $jjG8c = parcelRequire("jjG8c");
var $12QNw = parcelRequire("12QNw");
var $42031fc988697446$var$AddTypenameToAbstract = /** @class */ function() {
    function AddTypenameToAbstract(targetSchema) {
        this.targetSchema = targetSchema;
    }
    AddTypenameToAbstract.prototype.transformRequest = function(originalRequest) {
        var document = $42031fc988697446$var$addTypenameToAbstract(this.targetSchema, originalRequest.document);
        return $42031fc988697446$var$__assign($42031fc988697446$var$__assign({}, originalRequest), {
            document: document
        });
    };
    return AddTypenameToAbstract;
}();
module.exports.default = $42031fc988697446$var$AddTypenameToAbstract;
function $42031fc988697446$var$addTypenameToAbstract(targetSchema, document) {
    var _a;
    var typeInfo = new $jjG8c.TypeInfo(targetSchema);
    return $12QNw.visit(document, $jjG8c.visitWithTypeInfo(typeInfo, (_a = {}, _a[$bzIlO.Kind.SELECTION_SET] = function(node) {
        var parentType = typeInfo.getParentType();
        var selections = node.selections;
        if (parentType && (parentType instanceof $8oLgk.GraphQLInterfaceType || parentType instanceof $8oLgk.GraphQLUnionType) && !selections.find(function(_) {
            return _.kind === $bzIlO.Kind.FIELD && _.name.value === '__typename';
        })) selections = selections.concat({
            kind: $bzIlO.Kind.FIELD,
            name: {
                kind: $bzIlO.Kind.NAME,
                value: '__typename'
            }
        });
        if (selections !== node.selections) return $42031fc988697446$var$__assign($42031fc988697446$var$__assign({}, node), {
            selections: selections
        });
    }, _a)));
}

});

parcelRegister("XeiAr", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2JIWi = parcelRequire("2JIWi");
var $0b209a3e8eeada1f$var$CheckResultAndHandleErrors = /** @class */ function() {
    function CheckResultAndHandleErrors(info, fieldName) {
        this.info = info;
        this.fieldName = fieldName;
    }
    CheckResultAndHandleErrors.prototype.transformResult = function(result) {
        return $2JIWi.checkResultAndHandleErrors(result, this.info, this.fieldName);
    };
    return CheckResultAndHandleErrors;
}();
module.exports.default = $0b209a3e8eeada1f$var$CheckResultAndHandleErrors;

});

parcelRegister("3Cwvd", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6PRDg = parcelRequire("6PRDg");
/**
 * Given an AsyncIterable and a callback function, return an AsyncIterator
 * which produces values mapped via calling the callback function.
 */ function $2a2e2200b981df31$var$mapAsyncIterator(iterator, callback, rejectCallback) {
    var _a;
    var $return;
    var abruptClose;
    if (typeof iterator.return === 'function') {
        $return = iterator.return;
        abruptClose = function(error) {
            var rethrow = function() {
                return Promise.reject(error);
            };
            return $return.call(iterator).then(rethrow, rethrow);
        };
    }
    function mapResult(result) {
        return result.done ? result : $2a2e2200b981df31$var$asyncMapValue(result.value, callback).then($2a2e2200b981df31$var$iteratorResult, abruptClose);
    }
    var mapReject;
    if (rejectCallback) {
        // Capture rejectCallback to ensure it cannot be null.
        var reject_1 = rejectCallback;
        mapReject = function(error) {
            return $2a2e2200b981df31$var$asyncMapValue(error, reject_1).then($2a2e2200b981df31$var$iteratorResult, abruptClose);
        };
    }
    return _a = {
        next: function() {
            return iterator.next().then(mapResult, mapReject);
        },
        return: function() {
            return $return ? $return.call(iterator).then(mapResult, mapReject) : Promise.resolve({
                value: undefined,
                done: true
            });
        },
        throw: function(error) {
            if (typeof iterator.throw === 'function') return iterator.throw(error).then(mapResult, mapReject);
            return Promise.reject(error).catch(abruptClose);
        }
    }, _a[$6PRDg.$$asyncIterator] = function() {
        return this;
    }, _a;
}
module.exports.default = $2a2e2200b981df31$var$mapAsyncIterator;
function $2a2e2200b981df31$var$asyncMapValue(value, callback) {
    return new Promise(function(resolve) {
        return resolve(callback(value));
    });
}
function $2a2e2200b981df31$var$iteratorResult(value) {
    return {
        value: value,
        done: false
    };
}

});

parcelRegister("6Qqmu", function(module, exports) {
var $4fbc0c488f64fb05$var$__assign = module.exports && module.exports.__assign || function() {
    $4fbc0c488f64fb05$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4fbc0c488f64fb05$var$__assign.apply(this, arguments);
};
var $4fbc0c488f64fb05$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8oLgk = parcelRequire("8oLgk");
var $bzIlO = parcelRequire("bzIlO");
var $jjG8c = parcelRequire("jjG8c");
var $12QNw = parcelRequire("12QNw");

var $jdSTa = parcelRequire("jdSTa");
var $4fbc0c488f64fb05$var$ExpandAbstractTypes = /** @class */ function() {
    function ExpandAbstractTypes(transformedSchema, targetSchema) {
        this.targetSchema = targetSchema;
        this.mapping = $4fbc0c488f64fb05$var$extractPossibleTypes(transformedSchema, targetSchema);
        this.reverseMapping = $4fbc0c488f64fb05$var$flipMapping(this.mapping);
    }
    ExpandAbstractTypes.prototype.transformRequest = function(originalRequest) {
        var document = $4fbc0c488f64fb05$var$expandAbstractTypes(this.targetSchema, this.mapping, this.reverseMapping, originalRequest.document);
        return $4fbc0c488f64fb05$var$__assign($4fbc0c488f64fb05$var$__assign({}, originalRequest), {
            document: document
        });
    };
    return ExpandAbstractTypes;
}();
module.exports.default = $4fbc0c488f64fb05$var$ExpandAbstractTypes;
function $4fbc0c488f64fb05$var$extractPossibleTypes(transformedSchema, targetSchema) {
    var typeMap = transformedSchema.getTypeMap();
    var mapping = {};
    Object.keys(typeMap).forEach(function(typeName) {
        var type = typeMap[typeName];
        if ($8oLgk.isAbstractType(type)) {
            var targetType = targetSchema.getType(typeName);
            if (!$8oLgk.isAbstractType(targetType)) {
                var implementations = transformedSchema.getPossibleTypes(type) || [];
                mapping[typeName] = implementations.filter(function(impl) {
                    return targetSchema.getType(impl.name);
                }).map(function(impl) {
                    return impl.name;
                });
            }
        }
    });
    return mapping;
}
function $4fbc0c488f64fb05$var$flipMapping(mapping) {
    var result = {};
    Object.keys(mapping).forEach(function(typeName) {
        var toTypeNames = mapping[typeName];
        toTypeNames.forEach(function(toTypeName) {
            if (!result[toTypeName]) result[toTypeName] = [];
            result[toTypeName].push(typeName);
        });
    });
    return result;
}
function $4fbc0c488f64fb05$var$expandAbstractTypes(targetSchema, mapping, reverseMapping, document) {
    var _a;
    var operations = document.definitions.filter(function(def) {
        return def.kind === $bzIlO.Kind.OPERATION_DEFINITION;
    });
    var fragments = document.definitions.filter(function(def) {
        return def.kind === $bzIlO.Kind.FRAGMENT_DEFINITION;
    });
    var existingFragmentNames = fragments.map(function(fragment) {
        return fragment.name.value;
    });
    var fragmentCounter = 0;
    var generateFragmentName = function(typeName) {
        var fragmentName;
        do {
            fragmentName = "_" + typeName + "_Fragment" + fragmentCounter;
            fragmentCounter++;
        }while (existingFragmentNames.indexOf(fragmentName) !== -1);
        return fragmentName;
    };
    var newFragments = [];
    var fragmentReplacements = {};
    fragments.forEach(function(fragment) {
        newFragments.push(fragment);
        var possibleTypes = mapping[fragment.typeCondition.name.value];
        if (possibleTypes) {
            fragmentReplacements[fragment.name.value] = [];
            possibleTypes.forEach(function(possibleTypeName) {
                var name = generateFragmentName(possibleTypeName);
                existingFragmentNames.push(name);
                var newFragment = {
                    kind: $bzIlO.Kind.FRAGMENT_DEFINITION,
                    name: {
                        kind: $bzIlO.Kind.NAME,
                        value: name
                    },
                    typeCondition: {
                        kind: $bzIlO.Kind.NAMED_TYPE,
                        name: {
                            kind: $bzIlO.Kind.NAME,
                            value: possibleTypeName
                        }
                    },
                    selectionSet: fragment.selectionSet
                };
                newFragments.push(newFragment);
                fragmentReplacements[fragment.name.value].push({
                    fragmentName: name,
                    typeName: possibleTypeName
                });
            });
        }
    });
    var newDocument = $4fbc0c488f64fb05$var$__assign($4fbc0c488f64fb05$var$__assign({}, document), {
        definitions: $4fbc0c488f64fb05$var$__spreadArrays(operations, newFragments)
    });
    var typeInfo = new $jjG8c.TypeInfo(targetSchema);
    return $12QNw.visit(newDocument, $jjG8c.visitWithTypeInfo(typeInfo, (_a = {}, _a[$bzIlO.Kind.SELECTION_SET] = function(node) {
        var newSelections = $4fbc0c488f64fb05$var$__spreadArrays(node.selections);
        var parentType = $8oLgk.getNamedType(typeInfo.getParentType());
        node.selections.forEach(function(selection) {
            if (selection.kind === $bzIlO.Kind.INLINE_FRAGMENT) {
                var possibleTypes = mapping[selection.typeCondition.name.value];
                if (possibleTypes) possibleTypes.forEach(function(possibleType) {
                    if ($jdSTa.default(targetSchema, parentType, targetSchema.getType(possibleType))) newSelections.push({
                        kind: $bzIlO.Kind.INLINE_FRAGMENT,
                        typeCondition: {
                            kind: $bzIlO.Kind.NAMED_TYPE,
                            name: {
                                kind: $bzIlO.Kind.NAME,
                                value: possibleType
                            }
                        },
                        selectionSet: selection.selectionSet
                    });
                });
            } else if (selection.kind === $bzIlO.Kind.FRAGMENT_SPREAD) {
                var fragmentName = selection.name.value;
                var replacements = fragmentReplacements[fragmentName];
                if (replacements) replacements.forEach(function(replacement) {
                    var typeName = replacement.typeName;
                    if ($jdSTa.default(targetSchema, parentType, targetSchema.getType(typeName))) newSelections.push({
                        kind: $bzIlO.Kind.FRAGMENT_SPREAD,
                        name: {
                            kind: $bzIlO.Kind.NAME,
                            value: replacement.fragmentName
                        }
                    });
                });
            }
        });
        if (parentType && reverseMapping[parentType.name]) newSelections.push({
            kind: $bzIlO.Kind.FIELD,
            name: {
                kind: $bzIlO.Kind.NAME,
                value: '__typename'
            }
        });
        if (newSelections.length !== node.selections.length) return $4fbc0c488f64fb05$var$__assign($4fbc0c488f64fb05$var$__assign({}, node), {
            selections: newSelections
        });
    }, _a)));
}

});

parcelRegister("2WTvk", function(module, exports) {
var $225c0d909bed3526$var$__assign = module.exports && module.exports.__assign || function() {
    $225c0d909bed3526$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $225c0d909bed3526$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bzIlO = parcelRequire("bzIlO");
var $8uUC9 = parcelRequire("8uUC9");
var $jjG8c = parcelRequire("jjG8c");
var $12QNw = parcelRequire("12QNw");
var $225c0d909bed3526$var$ReplaceFieldWithFragment = /** @class */ function() {
    function ReplaceFieldWithFragment(targetSchema, fragments) {
        this.targetSchema = targetSchema;
        this.mapping = {};
        for(var _i = 0, fragments_1 = fragments; _i < fragments_1.length; _i++){
            var _a = fragments_1[_i], field = _a.field, fragment = _a.fragment;
            var parsedFragment = $225c0d909bed3526$var$parseFragmentToInlineFragment(fragment);
            var actualTypeName = parsedFragment.typeCondition.name.value;
            this.mapping[actualTypeName] = this.mapping[actualTypeName] || {};
            if (this.mapping[actualTypeName][field]) this.mapping[actualTypeName][field].push(parsedFragment);
            else this.mapping[actualTypeName][field] = [
                parsedFragment
            ];
        }
    }
    ReplaceFieldWithFragment.prototype.transformRequest = function(originalRequest) {
        var document = $225c0d909bed3526$var$replaceFieldsWithFragments(this.targetSchema, originalRequest.document, this.mapping);
        return $225c0d909bed3526$var$__assign($225c0d909bed3526$var$__assign({}, originalRequest), {
            document: document
        });
    };
    return ReplaceFieldWithFragment;
}();
module.exports.default = $225c0d909bed3526$var$ReplaceFieldWithFragment;
function $225c0d909bed3526$var$replaceFieldsWithFragments(targetSchema, document, mapping) {
    var _a;
    var typeInfo = new $jjG8c.TypeInfo(targetSchema);
    return $12QNw.visit(document, $jjG8c.visitWithTypeInfo(typeInfo, (_a = {}, _a[$bzIlO.Kind.SELECTION_SET] = function(node) {
        var parentType = typeInfo.getParentType();
        if (parentType) {
            var parentTypeName_1 = parentType.name;
            var selections_1 = node.selections;
            if (mapping[parentTypeName_1]) node.selections.forEach(function(selection) {
                if (selection.kind === $bzIlO.Kind.FIELD) {
                    var name_1 = selection.name.value;
                    var fragments = mapping[parentTypeName_1][name_1];
                    if (fragments && fragments.length > 0) {
                        var fragment = $225c0d909bed3526$var$concatInlineFragments(parentTypeName_1, fragments);
                        selections_1 = selections_1.concat(fragment);
                    }
                }
            });
            if (selections_1 !== node.selections) return $225c0d909bed3526$var$__assign($225c0d909bed3526$var$__assign({}, node), {
                selections: selections_1
            });
        }
    }, _a)));
}
function $225c0d909bed3526$var$parseFragmentToInlineFragment(definitions) {
    if (definitions.trim().startsWith('fragment')) {
        var document_1 = $8uUC9.parse(definitions);
        for(var _i = 0, _a = document_1.definitions; _i < _a.length; _i++){
            var definition = _a[_i];
            if (definition.kind === $bzIlO.Kind.FRAGMENT_DEFINITION) return {
                kind: $bzIlO.Kind.INLINE_FRAGMENT,
                typeCondition: definition.typeCondition,
                selectionSet: definition.selectionSet
            };
        }
    }
    var query = $8uUC9.parse("{" + definitions + "}").definitions[0];
    for(var _b = 0, _c = query.selectionSet.selections; _b < _c.length; _b++){
        var selection = _c[_b];
        if (selection.kind === $bzIlO.Kind.INLINE_FRAGMENT) return selection;
    }
    throw new Error('Could not parse fragment');
}
function $225c0d909bed3526$var$concatInlineFragments(type, fragments) {
    var fragmentSelections = fragments.reduce(function(selections, fragment) {
        return selections.concat(fragment.selectionSet.selections);
    }, []);
    var deduplicatedFragmentSelection = $225c0d909bed3526$var$deduplicateSelection(fragmentSelections);
    return {
        kind: $bzIlO.Kind.INLINE_FRAGMENT,
        typeCondition: {
            kind: $bzIlO.Kind.NAMED_TYPE,
            name: {
                kind: $bzIlO.Kind.NAME,
                value: type
            }
        },
        selectionSet: {
            kind: $bzIlO.Kind.SELECTION_SET,
            selections: deduplicatedFragmentSelection
        }
    };
}
function $225c0d909bed3526$var$deduplicateSelection(nodes) {
    var selectionMap = nodes.reduce(function(map, node) {
        var _a, _b, _c;
        switch(node.kind){
            case 'Field':
                if (node.alias) {
                    if (map.hasOwnProperty(node.alias.value)) return map;
                    else return $225c0d909bed3526$var$__assign($225c0d909bed3526$var$__assign({}, map), (_a = {}, _a[node.alias.value] = node, _a));
                } else {
                    if (map.hasOwnProperty(node.name.value)) return map;
                    else return $225c0d909bed3526$var$__assign($225c0d909bed3526$var$__assign({}, map), (_b = {}, _b[node.name.value] = node, _b));
                }
            case 'FragmentSpread':
                if (map.hasOwnProperty(node.name.value)) return map;
                else return $225c0d909bed3526$var$__assign($225c0d909bed3526$var$__assign({}, map), (_c = {}, _c[node.name.value] = node, _c));
            case 'InlineFragment':
                if (map.__fragment) {
                    var fragment = map.__fragment;
                    return $225c0d909bed3526$var$__assign($225c0d909bed3526$var$__assign({}, map), {
                        __fragment: $225c0d909bed3526$var$concatInlineFragments(fragment.typeCondition.name.value, [
                            fragment,
                            node
                        ])
                    });
                } else return $225c0d909bed3526$var$__assign($225c0d909bed3526$var$__assign({}, map), {
                    __fragment: node
                });
            default:
                return map;
        }
    }, {});
    var selection = Object.keys(selectionMap).reduce(function(selectionList, node) {
        return selectionList.concat(selectionMap[node]);
    }, []);
    return selection;
}

});

parcelRegister("iP6T0", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $db4254e23189f1df$var$ConvertEnumResponse = /** @class */ function() {
    function ConvertEnumResponse(enumNode) {
        this.enumNode = enumNode;
    }
    ConvertEnumResponse.prototype.transformResult = function(result) {
        var value = this.enumNode.getValue(result);
        if (value) return value.value;
        return result;
    };
    return ConvertEnumResponse;
}();
module.exports.default = $db4254e23189f1df$var$ConvertEnumResponse;

});


parcelRegister("dfTWq", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jADQJ = parcelRequire("jADQJ");
var $8mJYM = parcelRequire("8mJYM");
var $35Smo = parcelRequire("35Smo");
var $8oLgk = parcelRequire("8oLgk");
var $djKly = parcelRequire("djKly");
var $bzIlO = parcelRequire("bzIlO");
var $9aGhX = parcelRequire("9aGhX");

var $akAWC = parcelRequire("akAWC");
var $9a6811dc9fc4c35f$var$backcompatOptions = {
    commentDescriptions: true
};
function $9a6811dc9fc4c35f$var$typeFromAST(node) {
    switch(node.kind){
        case $bzIlO.Kind.OBJECT_TYPE_DEFINITION:
            return $9a6811dc9fc4c35f$var$makeObjectType(node);
        case $bzIlO.Kind.INTERFACE_TYPE_DEFINITION:
            return $9a6811dc9fc4c35f$var$makeInterfaceType(node);
        case $bzIlO.Kind.ENUM_TYPE_DEFINITION:
            return $9a6811dc9fc4c35f$var$makeEnumType(node);
        case $bzIlO.Kind.UNION_TYPE_DEFINITION:
            return $9a6811dc9fc4c35f$var$makeUnionType(node);
        case $bzIlO.Kind.SCALAR_TYPE_DEFINITION:
            return $9a6811dc9fc4c35f$var$makeScalarType(node);
        case $bzIlO.Kind.INPUT_OBJECT_TYPE_DEFINITION:
            return $9a6811dc9fc4c35f$var$makeInputObjectType(node);
        case $bzIlO.Kind.DIRECTIVE_DEFINITION:
            return $9a6811dc9fc4c35f$var$makeDirective(node);
        default:
            return null;
    }
}
module.exports.default = $9a6811dc9fc4c35f$var$typeFromAST;
function $9a6811dc9fc4c35f$var$makeObjectType(node) {
    return new $8oLgk.GraphQLObjectType({
        name: node.name.value,
        fields: function() {
            return $9a6811dc9fc4c35f$var$makeFields(node.fields);
        },
        interfaces: function() {
            return node.interfaces.map(function(iface) {
                return $9a6811dc9fc4c35f$var$createNamedStub(iface.name.value, 'interface');
            });
        },
        description: $8mJYM.getDescription(node, $9a6811dc9fc4c35f$var$backcompatOptions)
    });
}
function $9a6811dc9fc4c35f$var$makeInterfaceType(node) {
    return new $8oLgk.GraphQLInterfaceType({
        name: node.name.value,
        fields: function() {
            return $9a6811dc9fc4c35f$var$makeFields(node.fields);
        },
        description: $8mJYM.getDescription(node, $9a6811dc9fc4c35f$var$backcompatOptions),
        resolveType: function(parent, context, info) {
            return $akAWC.default(parent, info.schema);
        }
    });
}
function $9a6811dc9fc4c35f$var$makeEnumType(node) {
    var values = {};
    node.values.forEach(function(value) {
        values[value.name.value] = {
            description: $8mJYM.getDescription(value, $9a6811dc9fc4c35f$var$backcompatOptions)
        };
    });
    return new $8oLgk.GraphQLEnumType({
        name: node.name.value,
        values: values,
        description: $8mJYM.getDescription(node, $9a6811dc9fc4c35f$var$backcompatOptions)
    });
}
function $9a6811dc9fc4c35f$var$makeUnionType(node) {
    return new $8oLgk.GraphQLUnionType({
        name: node.name.value,
        types: function() {
            return node.types.map(function(type) {
                return $9a6811dc9fc4c35f$var$resolveType(type, 'object');
            });
        },
        description: $8mJYM.getDescription(node, $9a6811dc9fc4c35f$var$backcompatOptions),
        resolveType: function(parent, context, info) {
            return $akAWC.default(parent, info.schema);
        }
    });
}
function $9a6811dc9fc4c35f$var$makeScalarType(node) {
    return new $8oLgk.GraphQLScalarType({
        name: node.name.value,
        description: $8mJYM.getDescription(node, $9a6811dc9fc4c35f$var$backcompatOptions),
        serialize: function() {
            return null;
        },
        // Note: validation calls the parse functions to determine if a
        // literal value is correct. Returning null would cause use of custom
        // scalars to always fail validation. Returning false causes them to
        // always pass validation.
        parseValue: function() {
            return false;
        },
        parseLiteral: function() {
            return false;
        }
    });
}
function $9a6811dc9fc4c35f$var$makeInputObjectType(node) {
    return new $8oLgk.GraphQLInputObjectType({
        name: node.name.value,
        fields: function() {
            return $9a6811dc9fc4c35f$var$makeValues(node.fields);
        },
        description: $8mJYM.getDescription(node, $9a6811dc9fc4c35f$var$backcompatOptions)
    });
}
function $9a6811dc9fc4c35f$var$makeFields(nodes) {
    var result = {};
    nodes.forEach(function(node) {
        var deprecatedDirective = node.directives.find(function(directive) {
            return directive && directive.name && directive.name.value === 'deprecated';
        });
        var deprecatedArgument = deprecatedDirective && deprecatedDirective.arguments && deprecatedDirective.arguments.find(function(arg) {
            return arg && arg.name && arg.name.value === 'reason';
        });
        var deprecationReason = deprecatedArgument && deprecatedArgument.value && deprecatedArgument.value.value;
        result[node.name.value] = {
            type: $9a6811dc9fc4c35f$var$resolveType(node.type, 'object'),
            args: $9a6811dc9fc4c35f$var$makeValues(node.arguments),
            description: $8mJYM.getDescription(node, $9a6811dc9fc4c35f$var$backcompatOptions),
            deprecationReason: deprecationReason
        };
    });
    return result;
}
function $9a6811dc9fc4c35f$var$makeValues(nodes) {
    var result = {};
    nodes.forEach(function(node) {
        var type = $9a6811dc9fc4c35f$var$resolveType(node.type, 'input');
        result[node.name.value] = {
            type: type,
            defaultValue: $9aGhX.valueFromAST(node.defaultValue, type),
            description: $8mJYM.getDescription(node, $9a6811dc9fc4c35f$var$backcompatOptions)
        };
    });
    return result;
}
function $9a6811dc9fc4c35f$var$resolveType(node, type) {
    switch(node.kind){
        case $bzIlO.Kind.LIST_TYPE:
            return new $8oLgk.GraphQLList($9a6811dc9fc4c35f$var$resolveType(node.type, type));
        case $bzIlO.Kind.NON_NULL_TYPE:
            return new $8oLgk.GraphQLNonNull($9a6811dc9fc4c35f$var$resolveType(node.type, type));
        default:
            return $9a6811dc9fc4c35f$var$createNamedStub(node.name.value, type);
    }
}
function $9a6811dc9fc4c35f$var$createNamedStub(name, type) {
    var constructor;
    if (type === 'object') constructor = $8oLgk.GraphQLObjectType;
    else if (type === 'interface') constructor = $8oLgk.GraphQLInterfaceType;
    else constructor = $8oLgk.GraphQLInputObjectType;
    return new constructor({
        name: name,
        fields: {
            __fake: {
                type: $djKly.GraphQLString
            }
        }
    });
}
function $9a6811dc9fc4c35f$var$makeDirective(node) {
    var locations = [];
    node.locations.forEach(function(location) {
        if (location.value in $jADQJ.DirectiveLocation) locations.push(location.value);
    });
    return new $35Smo.GraphQLDirective({
        name: node.name.value,
        description: node.description ? node.description.value : null,
        args: $9a6811dc9fc4c35f$var$makeValues(node.arguments),
        locations: locations
    });
}

});

parcelRegister("810gP", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2QBPc = parcelRequire("2QBPc");
module.exports.transformSchema = $2QBPc.default;

var $4oDNM = parcelRequire("4oDNM");
module.exports.AddArgumentsAsVariables = $4oDNM.default;

var $XeiAr = parcelRequire("XeiAr");
module.exports.CheckResultAndHandleErrors = $XeiAr.default;

var $2WTvk = parcelRequire("2WTvk");
module.exports.ReplaceFieldWithFragment = $2WTvk.default;

var $5FnE9 = parcelRequire("5FnE9");
module.exports.AddTypenameToAbstract = $5FnE9.default;

var $b9txq = parcelRequire("b9txq");
module.exports.FilterToSchema = $b9txq.default;

var $3G9my = parcelRequire("3G9my");
module.exports.RenameTypes = $3G9my.default;

var $c3TFq = parcelRequire("c3TFq");
module.exports.FilterTypes = $c3TFq.default;

var $jRU8r = parcelRequire("jRU8r");
module.exports.TransformRootFields = $jRU8r.default;

var $kG751 = parcelRequire("kG751");
module.exports.RenameRootFields = $kG751.default;

var $4NN8S = parcelRequire("4NN8S");
module.exports.FilterRootFields = $4NN8S.default;

var $6Qqmu = parcelRequire("6Qqmu");
module.exports.ExpandAbstractTypes = $6Qqmu.default;

var $bORvX = parcelRequire("bORvX");
module.exports.ExtractField = $bORvX.default;

var $d9ptK = parcelRequire("d9ptK");
module.exports.WrapQuery = $d9ptK.default;

});
parcelRegister("2QBPc", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gIDuj = parcelRequire("gIDuj");

var $1e7FQ = parcelRequire("1e7FQ");

var $9CEZe = parcelRequire("9CEZe");

var $1cuZu = parcelRequire("1cuZu");
function $212dc74e242b95ff$var$transformSchema(targetSchema, transforms) {
    var schema = $1e7FQ.visitSchema(targetSchema, {}, true);
    var mapping = $1cuZu.generateSimpleMapping(targetSchema);
    var resolvers = $1cuZu.generateProxyingResolvers(targetSchema, transforms, mapping);
    schema = $gIDuj.addResolveFunctionsToSchema({
        schema: schema,
        resolvers: resolvers,
        resolverValidationOptions: {
            allowResolversNotInSchema: true
        }
    });
    schema = $9CEZe.applySchemaTransforms(schema, transforms);
    schema.transforms = transforms;
    return schema;
}
module.exports.default = $212dc74e242b95ff$var$transformSchema;

});
parcelRegister("1cuZu", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bkP2b = parcelRequire("bkP2b");
function $0dfef39330e66398$var$generateProxyingResolvers(targetSchema, transforms, mapping) {
    var result = {};
    Object.keys(mapping).forEach(function(name) {
        result[name] = {};
        var innerMapping = mapping[name];
        Object.keys(innerMapping).forEach(function(from) {
            var _a;
            var to = innerMapping[from];
            var resolverType = to.operation === 'subscription' ? 'subscribe' : 'resolve';
            result[name][from] = (_a = {}, _a[resolverType] = $0dfef39330e66398$var$createProxyingResolver(targetSchema, to.operation, to.name, transforms), _a);
        });
    });
    return result;
}
module.exports.generateProxyingResolvers = $0dfef39330e66398$var$generateProxyingResolvers;
function $0dfef39330e66398$var$generateSimpleMapping(targetSchema) {
    var query = targetSchema.getQueryType();
    var mutation = targetSchema.getMutationType();
    var subscription = targetSchema.getSubscriptionType();
    var result = {};
    if (query) result[query.name] = $0dfef39330e66398$var$generateMappingFromObjectType(query, 'query');
    if (mutation) result[mutation.name] = $0dfef39330e66398$var$generateMappingFromObjectType(mutation, 'mutation');
    if (subscription) result[subscription.name] = $0dfef39330e66398$var$generateMappingFromObjectType(subscription, 'subscription');
    return result;
}
module.exports.generateSimpleMapping = $0dfef39330e66398$var$generateSimpleMapping;
function $0dfef39330e66398$var$generateMappingFromObjectType(type, operation) {
    var result = {};
    var fields = type.getFields();
    Object.keys(fields).forEach(function(fieldName) {
        result[fieldName] = {
            name: fieldName,
            operation: operation
        };
    });
    return result;
}
module.exports.generateMappingFromObjectType = $0dfef39330e66398$var$generateMappingFromObjectType;
function $0dfef39330e66398$var$createProxyingResolver(schema, operation, fieldName, transforms) {
    return function(parent, args, context, info) {
        return $bkP2b.default({
            schema: schema,
            operation: operation,
            fieldName: fieldName,
            args: {},
            context: context,
            info: info,
            transforms: transforms
        });
    };
}

});


parcelRegister("3G9my", function(module, exports) {
var $2adc8e96c4519a95$var$__assign = module.exports && module.exports.__assign || function() {
    $2adc8e96c4519a95$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2adc8e96c4519a95$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8oLgk = parcelRequire("8oLgk");
var $bzIlO = parcelRequire("bzIlO");
var $12QNw = parcelRequire("12QNw");

var $7qT3x = parcelRequire("7qT3x");

var $1e7FQ = parcelRequire("1e7FQ");
var $2adc8e96c4519a95$var$RenameTypes = /** @class */ function() {
    function RenameTypes(renamer, options) {
        this.renamer = renamer;
        this.reverseMap = {};
        var _a = options || {}, _b = _a.renameBuiltins, renameBuiltins = _b === void 0 ? false : _b, _c = _a.renameScalars, renameScalars = _c === void 0 ? true : _c;
        this.renameBuiltins = renameBuiltins;
        this.renameScalars = renameScalars;
    }
    RenameTypes.prototype.transformSchema = function(originalSchema) {
        var _a;
        var _this = this;
        return $1e7FQ.visitSchema(originalSchema, (_a = {}, _a[$1e7FQ.VisitSchemaKind.TYPE] = function(type) {
            if ($7qT3x.default(type) && !_this.renameBuiltins) return undefined;
            if (type instanceof $8oLgk.GraphQLScalarType && !_this.renameScalars) return undefined;
            var newName = _this.renamer(type.name);
            if (newName && newName !== type.name) {
                _this.reverseMap[newName] = type.name;
                var newType = Object.assign(Object.create(type), type);
                newType.name = newName;
                return newType;
            }
        }, _a[$1e7FQ.VisitSchemaKind.ROOT_OBJECT] = function(type) {
            return undefined;
        }, _a));
    };
    RenameTypes.prototype.transformRequest = function(originalRequest) {
        var _a;
        var _this = this;
        var newDocument = $12QNw.visit(originalRequest.document, (_a = {}, _a[$bzIlO.Kind.NAMED_TYPE] = function(node) {
            var name = node.name.value;
            if (name in _this.reverseMap) return $2adc8e96c4519a95$var$__assign($2adc8e96c4519a95$var$__assign({}, node), {
                name: {
                    kind: $bzIlO.Kind.NAME,
                    value: _this.reverseMap[name]
                }
            });
        }, _a));
        return {
            document: newDocument,
            variables: originalRequest.variables
        };
    };
    RenameTypes.prototype.transformResult = function(result) {
        if (result.data) {
            var data = this.renameTypes(result.data, 'data');
            if (data !== result.data) return $2adc8e96c4519a95$var$__assign($2adc8e96c4519a95$var$__assign({}, result), {
                data: data
            });
        }
        return result;
    };
    RenameTypes.prototype.renameTypes = function(value, name) {
        var _this = this;
        if (name === '__typename') return this.renamer(value);
        if (value && typeof value === 'object') {
            var newValue_1 = Array.isArray(value) ? [] : Object.create(Object.getPrototypeOf(value));
            var returnNewValue_1 = false;
            Object.keys(value).forEach(function(key) {
                var oldChild = value[key];
                var newChild = _this.renameTypes(oldChild, key);
                newValue_1[key] = newChild;
                if (newChild !== oldChild) returnNewValue_1 = true;
            });
            if (returnNewValue_1) return newValue_1;
        }
        return value;
    };
    return RenameTypes;
}();
module.exports.default = $2adc8e96c4519a95$var$RenameTypes;

});

parcelRegister("c3TFq", function(module, exports) {
/* tslint:disable:no-unused-expression */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1e7FQ = parcelRequire("1e7FQ");
var $8c80f22a6477398d$var$FilterTypes = /** @class */ function() {
    function FilterTypes(filter) {
        this.filter = filter;
    }
    FilterTypes.prototype.transformSchema = function(schema) {
        var _a;
        var _this = this;
        return $1e7FQ.visitSchema(schema, (_a = {}, _a[$1e7FQ.VisitSchemaKind.TYPE] = function(type) {
            if (_this.filter(type)) return undefined;
            else return null;
        }, _a));
    };
    return FilterTypes;
}();
module.exports.default = $8c80f22a6477398d$var$FilterTypes;

});

parcelRegister("jRU8r", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8oLgk = parcelRequire("8oLgk");

var $bZzKT = parcelRequire("bZzKT");

var $1e7FQ = parcelRequire("1e7FQ");

var $cPwLY = parcelRequire("cPwLY");
var $e76e82d2793e197c$var$TransformRootFields = /** @class */ function() {
    function TransformRootFields(transform) {
        this.transform = transform;
    }
    TransformRootFields.prototype.transformSchema = function(originalSchema) {
        var _a;
        var _this = this;
        return $1e7FQ.visitSchema(originalSchema, (_a = {}, _a[$1e7FQ.VisitSchemaKind.QUERY] = function(type) {
            return $e76e82d2793e197c$var$transformFields(type, function(fieldName, field) {
                return _this.transform('Query', fieldName, field);
            });
        }, _a[$1e7FQ.VisitSchemaKind.MUTATION] = function(type) {
            return $e76e82d2793e197c$var$transformFields(type, function(fieldName, field) {
                return _this.transform('Mutation', fieldName, field);
            });
        }, _a[$1e7FQ.VisitSchemaKind.SUBSCRIPTION] = function(type) {
            return $e76e82d2793e197c$var$transformFields(type, function(fieldName, field) {
                return _this.transform('Subscription', fieldName, field);
            });
        }, _a));
    };
    return TransformRootFields;
}();
module.exports.default = $e76e82d2793e197c$var$TransformRootFields;
function $e76e82d2793e197c$var$transformFields(type, transformer) {
    var resolveType = $cPwLY.createResolveType(function(name, originalType) {
        return originalType;
    });
    var fields = type.getFields();
    var newFields = {};
    Object.keys(fields).forEach(function(fieldName) {
        var field = fields[fieldName];
        var newField = transformer(fieldName, field);
        if (typeof newField === 'undefined') newFields[fieldName] = $cPwLY.fieldToFieldConfig(field, resolveType, true);
        else if (newField !== null) {
            if (newField.name) newFields[newField.name] = newField.field;
            else newFields[fieldName] = newField;
        }
    });
    if ($bZzKT.default(newFields)) return null;
    else return new $8oLgk.GraphQLObjectType({
        name: type.name,
        description: type.description,
        astNode: type.astNode,
        fields: newFields
    });
}

});

parcelRegister("kG751", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cPwLY = parcelRequire("cPwLY");

var $jRU8r = parcelRequire("jRU8r");
var $f0dd38d15cd69b70$var$RenameRootFields = /** @class */ function() {
    function RenameRootFields(renamer) {
        var resolveType = $cPwLY.createResolveType(function(name, type) {
            return type;
        });
        this.transformer = new $jRU8r.default(function(operation, fieldName, field) {
            return {
                name: renamer(operation, fieldName, field),
                field: $cPwLY.fieldToFieldConfig(field, resolveType, true)
            };
        });
    }
    RenameRootFields.prototype.transformSchema = function(originalSchema) {
        return this.transformer.transformSchema(originalSchema);
    };
    return RenameRootFields;
}();
module.exports.default = $f0dd38d15cd69b70$var$RenameRootFields;

});

parcelRegister("4NN8S", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jRU8r = parcelRequire("jRU8r");
var $37f1dba7a5891a8d$var$FilterRootFields = /** @class */ function() {
    function FilterRootFields(filter) {
        this.transformer = new $jRU8r.default(function(operation, fieldName, field) {
            if (filter(operation, fieldName, field)) return undefined;
            else return null;
        });
    }
    FilterRootFields.prototype.transformSchema = function(originalSchema) {
        return this.transformer.transformSchema(originalSchema);
    };
    return FilterRootFields;
}();
module.exports.default = $37f1dba7a5891a8d$var$FilterRootFields;

});

parcelRegister("bORvX", function(module, exports) {
var $89ade00df5ab3c69$var$__assign = module.exports && module.exports.__assign || function() {
    $89ade00df5ab3c69$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $89ade00df5ab3c69$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $12QNw = parcelRequire("12QNw");
var $bzIlO = parcelRequire("bzIlO");
var $89ade00df5ab3c69$var$ExtractField = /** @class */ function() {
    function ExtractField(_a) {
        var from = _a.from, to = _a.to;
        this.from = from;
        this.to = to;
    }
    ExtractField.prototype.transformRequest = function(originalRequest) {
        var _a, _b;
        var fromSelection;
        var ourPathFrom = JSON.stringify(this.from);
        var ourPathTo = JSON.stringify(this.to);
        var fieldPath = [];
        $12QNw.visit(originalRequest.document, (_a = {}, _a[$bzIlO.Kind.FIELD] = {
            enter: function(node) {
                fieldPath.push(node.name.value);
                if (ourPathFrom === JSON.stringify(fieldPath)) {
                    fromSelection = node.selectionSet;
                    return $12QNw.BREAK;
                }
            },
            leave: function(node) {
                fieldPath.pop();
            }
        }, _a));
        fieldPath = [];
        var newDocument = $12QNw.visit(originalRequest.document, (_b = {}, _b[$bzIlO.Kind.FIELD] = {
            enter: function(node) {
                fieldPath.push(node.name.value);
                if (ourPathTo === JSON.stringify(fieldPath) && fromSelection) return $89ade00df5ab3c69$var$__assign($89ade00df5ab3c69$var$__assign({}, node), {
                    selectionSet: fromSelection
                });
            },
            leave: function(node) {
                fieldPath.pop();
            }
        }, _b));
        return $89ade00df5ab3c69$var$__assign($89ade00df5ab3c69$var$__assign({}, originalRequest), {
            document: newDocument
        });
    };
    return ExtractField;
}();
module.exports.default = $89ade00df5ab3c69$var$ExtractField;

});

parcelRegister("d9ptK", function(module, exports) {
var $992fe12a2cb75340$var$__assign = module.exports && module.exports.__assign || function() {
    $992fe12a2cb75340$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $992fe12a2cb75340$var$__assign.apply(this, arguments);
};
var $992fe12a2cb75340$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bzIlO = parcelRequire("bzIlO");
var $12QNw = parcelRequire("12QNw");
var $992fe12a2cb75340$var$WrapQuery = /** @class */ function() {
    function WrapQuery(path, wrapper, extractor) {
        this.path = path;
        this.wrapper = wrapper;
        this.extractor = extractor;
    }
    WrapQuery.prototype.transformRequest = function(originalRequest) {
        var _a;
        var _this = this;
        var document = originalRequest.document;
        var fieldPath = [];
        var ourPath = JSON.stringify(this.path);
        var newDocument = $12QNw.visit(document, (_a = {}, _a[$bzIlO.Kind.FIELD] = {
            enter: function(node) {
                fieldPath.push(node.name.value);
                if (ourPath === JSON.stringify(fieldPath)) {
                    var wrapResult = _this.wrapper(node.selectionSet);
                    // Selection can be either a single selection or a selection set. If it's just one selection,
                    // let's wrap it in a selection set. Otherwise, keep it as is.
                    var selectionSet = wrapResult.kind === $bzIlO.Kind.SELECTION_SET ? wrapResult : {
                        kind: $bzIlO.Kind.SELECTION_SET,
                        selections: [
                            wrapResult
                        ]
                    };
                    return $992fe12a2cb75340$var$__assign($992fe12a2cb75340$var$__assign({}, node), {
                        selectionSet: selectionSet
                    });
                }
            },
            leave: function(node) {
                fieldPath.pop();
            }
        }, _a));
        return $992fe12a2cb75340$var$__assign($992fe12a2cb75340$var$__assign({}, originalRequest), {
            document: newDocument
        });
    };
    WrapQuery.prototype.transformResult = function(originalResult) {
        var rootData = originalResult.data;
        if (rootData) {
            var data = rootData;
            var path = $992fe12a2cb75340$var$__spreadArrays(this.path);
            while(path.length > 1){
                var next = path.shift();
                if (data[next]) data = data[next];
            }
            data[path[0]] = this.extractor(data[path[0]]);
        }
        return {
            data: rootData,
            errors: originalResult.errors
        };
    };
    return WrapQuery;
}();
module.exports.default = $992fe12a2cb75340$var$WrapQuery;

});





parcelRegister("cIxJO", function(module, exports) {

$parcel$export(module.exports, "getCustomResolversFetch", () => $fed100cdd397ac36$export$18b0a4b86a372cdb);
class $fed100cdd397ac36$export$26e841bcf1aeb894 extends Error {
    constructor(response, resBody){
        super(`[FetchError] Request failed with status ${response.status} and statusMessage=${response.statusText}`);
        this.status = response.status;
        this.response = response;
        this.responseBody = resBody;
        this.name = this.constructor.name;
    }
}
function $fed100cdd397ac36$var$removeEmptyProp(obj) {
    const result = {
        ...obj
    };
    Object.entries(result).forEach(([key, val])=>{
        if (val === undefined || val === null) // @ts-ignore (TS7053)
        delete result[key];
    });
    return result;
}
// In docs of fetch API, https://developer.mozilla.org/en/docs/Web/API/Fetch_API,
// fetch just throw error for network error, it does not throw error for server error like 400,...
async function $fed100cdd397ac36$var$handleFetchCommonResponse(res) {
    if (!res.ok) {
        let resBody;
        try {
            resBody = await res.json();
        } catch (e) {
        // ignore parsing body error
        }
        throw new $fed100cdd397ac36$export$26e841bcf1aeb894(res, resBody);
    }
    return res;
}
const $fed100cdd397ac36$export$18b0a4b86a372cdb = ({ fetch: fetch, statusCodeHandlers: statusCodeHandlers = {} })=>(url, fetchOptions = {})=>{
        const headers = {
            'Content-Type': 'application/json',
            ...fetchOptions.headers
        };
        return fetch(url, {
            credentials: 'include',
            ...fetchOptions,
            headers: $fed100cdd397ac36$var$removeEmptyProp(headers)
        }).then((response)=>{
            const { status: status } = response;
            const handler = statusCodeHandlers[status];
            if (typeof handler === 'function') handler(response);
            return response;
        }).then($fed100cdd397ac36$var$handleFetchCommonResponse);
    };

});

parcelRegister("6eJfB", function(module, exports) {

$parcel$export(module.exports, "isCustomQuery", () => $7357b2f9673283f9$export$e722a3789f7fabfb);

var $bERqM = parcelRequire("bERqM");
const $7357b2f9673283f9$var$isDefinitionObjectHasDirective = (def, directiveName)=>{
    if (!def) return false;
    for (const node of def){
        const { operation: type, directives: directives } = node;
        if (type === 'query' || type === 'mutation') return directives && directives.some((directive)=>directive.name.value === directiveName);
    }
};
const $7357b2f9673283f9$var$isQueryContainDirective = (opt, directiveName)=>{
    const globalDef = opt.query && opt.query.definitions;
    const childDef = opt.query && // @ts-ignore (TS7053)
    opt.query[opt.operationName] && // @ts-ignore (TS7053)
    opt.query[opt.operationName].definitions;
    return !!($7357b2f9673283f9$var$isDefinitionObjectHasDirective(globalDef, directiveName) || $7357b2f9673283f9$var$isDefinitionObjectHasDirective(childDef, directiveName));
};
const $7357b2f9673283f9$export$e722a3789f7fabfb = (opt)=>{
    return $7357b2f9673283f9$var$isQueryContainDirective(opt, (0, $bERqM.Directives).CUSTOM);
};

});
parcelRegister("bERqM", function(module, exports) {

$parcel$export(module.exports, "Directives", () => $d8728d89b6cd52e2$export$129646a0e1af8d85);
$parcel$export(module.exports, "CustomDirective", () => $d8728d89b6cd52e2$export$97a7ea7443254e53);

var $jADQJ = parcelRequire("jADQJ");
var $35Smo = parcelRequire("35Smo");
var $d8728d89b6cd52e2$export$129646a0e1af8d85 = /*#__PURE__*/ function(Directives) {
    Directives["CUSTOM"] = "custom";
    return Directives;
}({});
const $d8728d89b6cd52e2$export$97a7ea7443254e53 = new (0, $35Smo.GraphQLDirective)({
    name: "custom",
    locations: [
        (0, $jADQJ.DirectiveLocation).QUERY,
        (0, $jADQJ.DirectiveLocation).MUTATION
    ]
});

});


parcelRegister("iEp9R", function(module, exports) {

$parcel$export(module.exports, "createDirectoryHttpLink", () => $f286626c2313b379$export$bacc55ff336c5f9d);
/*
 * Apollo link that does the fetching
 * Docs: https://www.apollographql.com/docs/link/links/http.html
 */ 
var $JPsIz = parcelRequire("JPsIz");
const $f286626c2313b379$export$bacc55ff336c5f9d = ({ url: url, getCloudId: getCloudId })=>{
    const customFetch = async (uri, options)=>{
        const body = JSON.parse(options.body);
        const uriWithOps = body.operationName ? `${uri}?q=${body.operationName}` : uri;
        if (body.variables && body.variables._withCloudId && getCloudId) {
            delete body.variables._withCloudId;
            body.variables.cloudId = getCloudId();
            options.body = JSON.stringify(body);
        }
        return fetch(uriWithOps, options);
    };
    return new (0, $JPsIz.HttpLink)({
        uri: url,
        credentials: 'include',
        fetch: customFetch
    });
};

});
parcelRegister("JPsIz", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $089c1f6736cf7295$export$f4bbf1aec241cc1);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");

var $f0Elb = parcelRequire("f0Elb");
var $089c1f6736cf7295$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $3VFsf.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $f0Elb.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $clSzL.ApolloLink)(function(operation) {
        var chosenURI = (0, $f0Elb.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $3VFsf.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $f0Elb.selectHttpOptionsAndBody)(operation, (0, $f0Elb.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $f0Elb.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $clSzL.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $f0Elb.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $clSzL.fromError)(parseError);
        }
        return new (0, $clSzL.Observable)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $f0Elb.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $f0Elb.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $f0Elb.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $089c1f6736cf7295$export$f4bbf1aec241cc1 = function(_super) {
    (0, $3VFsf.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $089c1f6736cf7295$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $clSzL.ApolloLink));

});
parcelRegister("f0Elb", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $aed625edf13c57eb$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $aed625edf13c57eb$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $aed625edf13c57eb$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $aed625edf13c57eb$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $aed625edf13c57eb$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $aed625edf13c57eb$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $aed625edf13c57eb$export$63ccc2571850f81a);

var $3VFsf = parcelRequire("3VFsf");

var $1c8Um = parcelRequire("1c8Um");

var $1DiV8 = parcelRequire("1DiV8");
var $aed625edf13c57eb$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $aed625edf13c57eb$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $aed625edf13c57eb$var$defaultOptions = {
    method: 'POST'
};
var $aed625edf13c57eb$export$dd86f00dc866e75d = {
    http: $aed625edf13c57eb$var$defaultHttpOptions,
    headers: $aed625edf13c57eb$var$defaultHeaders,
    options: $aed625edf13c57eb$var$defaultOptions
};
var $aed625edf13c57eb$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $aed625edf13c57eb$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $aed625edf13c57eb$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $1DiV8.InvariantError)(1);
    }
};
var $aed625edf13c57eb$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $aed625edf13c57eb$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $3VFsf.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $3VFsf.__assign)({}, options, config.options, {
            headers: (0, $3VFsf.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $3VFsf.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $1c8Um.print)(query);
    return {
        options: options,
        body: body
    };
};
var $aed625edf13c57eb$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $1DiV8.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $aed625edf13c57eb$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});



parcelRegister("bt0EZ", function(module, exports) {

$parcel$export(module.exports, "createErrorLink", () => $44438376439d7784$export$d0106730d0f8f3b5);
/*
 * Apollo Link for additional requests error handling
 * Docs: https://www.apollographql.com/docs/link/links/error.html
 */ 
var $h4ppL = parcelRequire("h4ppL");

var $iqTSr = parcelRequire("iqTSr");
const $44438376439d7784$export$d0106730d0f8f3b5 = ({ statusCodeHandlers: statusCodeHandlers })=>(0, $h4ppL.onError)((errorResponse)=>{
        const networkError = errorResponse.networkError;
        const graphQLErrors = errorResponse.graphQLErrors;
        if (graphQLErrors) // Our existing GraphQLError has its own type, and graphql one is not exposing the type information correctly
        // So in here we gonna go with `any` type for now
        // eslint-disable-next-line no-console
        console.error((0, $iqTSr.GraphQLError).from(errorResponse.graphQLErrors));
        if (networkError) {
            const statusCode = networkError.statusCode;
            const handler = statusCodeHandlers[statusCode];
            if (typeof handler === 'function') {
                /**
				 * these functions are expecting a Response object, which is not present here.
				 * It appears statusCodeHandlers are never passed to createErrorLink, so we should investigate removal
				 */ // @ts-ignore
                handler();
                return;
            }
        }
    });

});
parcelRegister("h4ppL", function(module, exports) {

$parcel$export(module.exports, "onError", () => $c6d6862dd229df53$export$2288787135a8f66e);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $c6d6862dd229df53$export$2288787135a8f66e(errorHandler) {
    return new (0, $clSzL.ApolloLink)(function(operation, forward) {
        return new (0, $clSzL.Observable)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $c6d6862dd229df53$export$d2c8415987899609 = function(_super) {
    (0, $3VFsf.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $c6d6862dd229df53$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $clSzL.ApolloLink));

});

parcelRegister("iqTSr", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $acec204a347c28b0$export$92d6ed0888e7cb7f);
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
class $acec204a347c28b0$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        this.message = message;
        this.stack = new Error(message).stack || '';
    }
}
class $acec204a347c28b0$export$c73ca302efeda3b4 extends $acec204a347c28b0$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $acec204a347c28b0$export$c73ca302efeda3b4.prototype);
    }
}
class $acec204a347c28b0$export$20de9a0e470e95aa extends $acec204a347c28b0$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $acec204a347c28b0$export$20de9a0e470e95aa.prototype);
    }
}
class $acec204a347c28b0$export$65bd6083489bd8bb extends $acec204a347c28b0$var$CommonError {
    constructor({ message: message, status: status }){
        super(message);
        Object.setPrototypeOf(this, $acec204a347c28b0$export$65bd6083489bd8bb.prototype);
        this.status = status;
    }
}
class $acec204a347c28b0$export$92d6ed0888e7cb7f extends $acec204a347c28b0$var$CommonError {
    constructor({ message: message = 'unknown', category: category = 'default', fields: fields }){
        super(message);
        Object.setPrototypeOf(this, $acec204a347c28b0$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
    static{
        this.from = (rawErrors)=>{
            const firstError = rawErrors[0];
            const errorData = {
                category: firstError.category,
                message: firstError.message
            };
            if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
                obj[item.field] = item.message;
                return obj;
            }, {});
            return new $acec204a347c28b0$export$92d6ed0888e7cb7f(errorData);
        };
    }
}

});


parcelRegister("ix0Xq", function(module, exports) {

$parcel$export(module.exports, "createRetryLink", () => $d9bd2780fcea6bab$export$91ceafe7c6f4a732);
/*
 * Apollo Link to make sure our requests have re-try functionality in case of request failure
 * Docs: https://www.apollographql.com/docs/link/links/retry.html
 */ 
var $lC4FX = parcelRequire("lC4FX");
const $d9bd2780fcea6bab$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $d9bd2780fcea6bab$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
const $d9bd2780fcea6bab$export$91ceafe7c6f4a732 = (retryOptions)=>new (0, $lC4FX.RetryLink)({
        delay: {
            initial: $d9bd2780fcea6bab$export$8f4286bf21155381.INITIAL_DELAY,
            max: Infinity,
            jitter: $d9bd2780fcea6bab$export$8f4286bf21155381.JITTER,
            ...retryOptions.delay
        },
        attempts: {
            max: $d9bd2780fcea6bab$export$8f4286bf21155381.MAX_RETRIES,
            retryIf: (error, operation)=>{
                const context = operation.getContext();
                const response = context.response;
                const noRetry = context.noRetry;
                return $d9bd2780fcea6bab$export$55b2fbd5d4a32495(response && response.status) && !noRetry;
            },
            ...retryOptions.attempts
        }
    });

});
parcelRegister("lC4FX", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $fbc0c610016bf5c5$export$943d544ad120494a);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $fbc0c610016bf5c5$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $fbc0c610016bf5c5$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $fbc0c610016bf5c5$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $3VFsf.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $fbc0c610016bf5c5$export$943d544ad120494a = function(_super) {
    (0, $3VFsf.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $fbc0c610016bf5c5$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $fbc0c610016bf5c5$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $fbc0c610016bf5c5$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $clSzL.Observable)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $clSzL.ApolloLink));

});


parcelRegister("jI3Xg", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b75d2592e489015$export$2e2bcd8739ae039);
// queries

var $8rPJd = parcelRequire("8rPJd");

var $2CHdu = parcelRequire("2CHdu");

var $8WlKg = parcelRequire("8WlKg");

var $dY0XN = parcelRequire("dY0XN");

var $d8kYj = parcelRequire("d8kYj");

var $krDmI = parcelRequire("krDmI");

var $byBIs = parcelRequire("byBIs");

var $hDXSt = parcelRequire("hDXSt");

var $cvmaR = parcelRequire("cvmaR");

var $dstEw = parcelRequire("dstEw");

var $2fAj6 = parcelRequire("2fAj6");

var $g3q2n = parcelRequire("g3q2n");

var $g7s65 = parcelRequire("g7s65");

var $cJGGV = parcelRequire("cJGGV");

var $9g24m = parcelRequire("9g24m");

var $ZMsiv = parcelRequire("ZMsiv");
// mutations
const $3b75d2592e489015$var$resolvers = {
    Query: {
        User: $2fAj6.default,
        MyAvatar: $dY0XN.default,
        UserOrganization: $ZMsiv.default,
        UserManageConfig: $g3q2n.default,
        UserManagePrivacySettings: $cJGGV.default,
        UserManageLinkedAccounts: $g7s65.default,
        UserManagePrivacySettingsAllowed: $9g24m.default,
        TeamInSlack: $d8kYj.default,
        Containers: $8rPJd.default,
        TeamLinkIcons: $krDmI.default
    },
    Mutation: {
        updateUser: $hDXSt.default,
        deleteUserAvatar: $2CHdu.default,
        updateUserAvatar: $cvmaR.default,
        updateUserPrivacySettings: $dstEw.default,
        updateTeamInSlack: $byBIs.default,
        disconnectTeamInSlack: $8WlKg.default
    }
};
var $3b75d2592e489015$export$2e2bcd8739ae039 = $3b75d2592e489015$var$resolvers;

});
parcelRegister("8rPJd", function(module, exports) {

$parcel$export(module.exports, "default", () => $248db30d935ff8fa$export$2e2bcd8739ae039);
const $248db30d935ff8fa$var$Containers = async (_, args, context, info)=>{
    const { userId: userId, maxNumberOfResults: maxNumberOfResults, principalId: principalId, siteId: siteId, sessionId: sessionId } = args;
    return await context.fetch(`${context.url.collaborationGraph}/v1/collaborationgraph/user/container`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            context: {
                contextType: 'atlassianDirectory',
                principalId: principalId,
                siteId: siteId,
                sessionId: sessionId
            },
            containerTypes: [
                'confluenceSpace',
                'jiraProject'
            ],
            maxNumberOfResults: maxNumberOfResults,
            userId: userId,
            expanded: true
        })
    }).then((res)=>{
        // Matches type of QueryData['Containers'] in
        // packages/embeddable-directory/src/components/CGContainers/ContainersQuery.tsx
        return res.json();
    });
};
var $248db30d935ff8fa$export$2e2bcd8739ae039 = $248db30d935ff8fa$var$Containers;

});

parcelRegister("2CHdu", function(module, exports) {

$parcel$export(module.exports, "default", () => $30eefcefae0bd54d$export$2e2bcd8739ae039);
const $30eefcefae0bd54d$var$deleteUserAvatar = async (_, args, context)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/avatar`;
    return context.fetch(url, {
        method: 'DELETE'
    }).then(()=>true);
};
var $30eefcefae0bd54d$export$2e2bcd8739ae039 = $30eefcefae0bd54d$var$deleteUserAvatar;

});

parcelRegister("8WlKg", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb1737e37e858cfa$export$2e2bcd8739ae039);
const $fb1737e37e858cfa$var$disconnectTeamInSlack = async (_, args, context)=>{
    const { teamId: teamId } = args;
    const url = `${context.url.stargateRoot}/teamsslack/api/team/${teamId}`;
    return context.fetch(url, {
        method: 'DELETE'
    }).then((data)=>data.json()).then((data)=>({
            id: teamId,
            ...data
        }));
};
var $fb1737e37e858cfa$export$2e2bcd8739ae039 = $fb1737e37e858cfa$var$disconnectTeamInSlack;

});

parcelRegister("dY0XN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db45058bf23d6c2$export$2e2bcd8739ae039);
const $9db45058bf23d6c2$var$myAvatar = async (root, args, context)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/avatar`;
    return context.fetch(url).then((data)=>data.json());
};
var $9db45058bf23d6c2$export$2e2bcd8739ae039 = $9db45058bf23d6c2$var$myAvatar;

});

parcelRegister("d8kYj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d847e5033f05bd7$export$2e2bcd8739ae039);
const $1d847e5033f05bd7$var$teamInSlack = async (root, args, context)=>{
    const { teamId: teamId, teamName: teamName } = args;
    const url = `${context.url.stargateRoot}/teamsslack/api/team/${teamId}?teamName=${encodeURIComponent(teamName)}`;
    return context.fetch(url).then((data)=>data.json()).then((data)=>({
            id: teamId,
            ...data
        }));
};
var $1d847e5033f05bd7$export$2e2bcd8739ae039 = $1d847e5033f05bd7$var$teamInSlack;

});

parcelRegister("krDmI", function(module, exports) {

$parcel$export(module.exports, "default", () => $717dde55fda6f2cd$export$2e2bcd8739ae039);

var $ljCZB = parcelRequire("ljCZB");
const $717dde55fda6f2cd$var$TeamLinkIcons = async (_, args, context, info)=>{
    const requestBody = args.teamLinkUrls.map((url)=>({
            resourceUrl: url
        }));
    const options = {
        method: 'POST',
        body: JSON.stringify(requestBody)
    };
    return context.fetch(`${context.url.stargateRoot}/object-resolver/resolve/batch`, options).then((res)=>res.json()).then((0, $ljCZB.transformIconData));
};
var $717dde55fda6f2cd$export$2e2bcd8739ae039 = $717dde55fda6f2cd$var$TeamLinkIcons;

});
parcelRegister("ljCZB", function(module, exports) {

$parcel$export(module.exports, "transformIconData", () => $ea2556bf41c3353f$export$39f4468adf4cb57c);
/**
 * This type matches the props for the TeamLinkIcon component in embeddable-directory
 */ /**
 * These names match the Provider Name in the JSON-LD response from respective resolvers
 */ var $ea2556bf41c3353f$var$ProviderNames = /*#__PURE__*/ function(ProviderNames) {
    ProviderNames["CONFLUENCE"] = "Confluence";
    ProviderNames["JIRA"] = "Jira";
    return ProviderNames;
}($ea2556bf41c3353f$var$ProviderNames || {});
const $ea2556bf41c3353f$export$c64ca1c808335e8b = (jsonLd)=>{
    const { url: url, generator: { name: name, icon: icon } } = jsonLd;
    switch(name){
        case "Confluence":
            return {
                linkUrl: url,
                iconUrl: $ea2556bf41c3353f$var$getConfluenceFavicon(url),
                productName: name
            };
        case "Jira":
            return {
                linkUrl: url,
                iconUrl: $ea2556bf41c3353f$var$getJiraFavicon(url),
                productName: name
            };
        default:
            return {
                linkUrl: url,
                iconUrl: typeof icon === 'object' ? icon['url'] : icon,
                productName: name
            };
    }
};
const $ea2556bf41c3353f$var$isIconItemSuccess = (response)=>{
    return response.status === 200;
};
const $ea2556bf41c3353f$export$39f4468adf4cb57c = (batchResp)=>batchResp.filter($ea2556bf41c3353f$var$isIconItemSuccess).map((resp)=>resp.body.data).map($ea2556bf41c3353f$export$c64ca1c808335e8b).filter((linkIconData)=>linkIconData.iconUrl !== undefined);
const $ea2556bf41c3353f$var$getConfluenceFavicon = (url)=>`https://${new URL(url).hostname}/wiki/favicon.ico`;
const $ea2556bf41c3353f$var$getJiraFavicon = (url)=>`https://${new URL(url).hostname}/favicon.ico`;

});


parcelRegister("byBIs", function(module, exports) {

$parcel$export(module.exports, "default", () => $72f35690e2f0e920$export$2e2bcd8739ae039);
const $72f35690e2f0e920$var$updateTeamInSlack = async (_, args, context)=>{
    const { teamId: teamId, channelId: channelId, usergroupHandle: usergroupHandle } = args;
    const url = `${context.url.stargateRoot}/teamsslack/api/team/${teamId}?channel=${channelId}&groupName=${usergroupHandle}`;
    return context.fetch(url, {
        method: 'POST'
    }).then((data)=>data.json()).then((data)=>({
            id: teamId,
            ...data
        }));
};
var $72f35690e2f0e920$export$2e2bcd8739ae039 = $72f35690e2f0e920$var$updateTeamInSlack;

});

parcelRegister("hDXSt", function(module, exports) {

$parcel$export(module.exports, "default", () => $e759f334923a3a8d$export$2e2bcd8739ae039);

var $3tlCg = parcelRequire("3tlCg");
const $e759f334923a3a8d$var$updateUser = async (_, args, context, info)=>{
    const { id: id, input: input } = args;
    const url = `${context.url.stargateRoot}/users/${id}/manage/profile`;
    const body = JSON.stringify($3tlCg.toManageAPIInput(input));
    return context.fetch(url, {
        method: 'PATCH',
        body: body
    }).then((data)=>data.json()).then((res)=>$3tlCg.fromManageAPIResponse(res));
};
var $e759f334923a3a8d$export$2e2bcd8739ae039 = $e759f334923a3a8d$var$updateUser;

});
parcelRegister("3tlCg", function(module, exports) {

$parcel$export(module.exports, "fromManageAPIResponse", () => $1802fb57d6268c24$export$5299664357e4f3dd);
$parcel$export(module.exports, "toManageAPIInput", () => $1802fb57d6268c24$export$7b103107c889cb67);
parcelRequire("6vEP1");
var $iJONX = parcelRequire("iJONX");
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $1802fb57d6268c24$var$PROFILE_PROPS_MAP = new Map([
    [
        'id',
        'account_id'
    ],
    [
        'fullName',
        'name'
    ],
    [
        'nickname',
        'nickname'
    ],
    [
        'timezone',
        'zoneinfo'
    ],
    [
        'locale',
        'locale'
    ],
    [
        'avatarUrl',
        'picture'
    ],
    [
        'email',
        'email'
    ]
]);
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $1802fb57d6268c24$var$EXTENDED_PROFILE_PROPS_MAP = new Map([
    [
        'title',
        'job_title'
    ],
    [
        'department',
        'department'
    ],
    [
        'companyName',
        'organization'
    ],
    [
        'location',
        'location'
    ],
    [
        'phoneNumber',
        'phone_number'
    ]
]);
const $1802fb57d6268c24$export$5299664357e4f3dd = (res)=>{
    const data = res.account;
    const extendedData = data && data.extended_profile || {};
    if (!data) return null;
    const timeZone = data.zoneinfo;
    const localTime = ({ format: format })=>{
        if (!timeZone) return null;
        try {
            return (0, $iJONX.default)(new Date(), timeZone, format);
        } catch (error) {
            // TODO: PTC-4908 send error to sentry for reporting
            return null;
        }
    };
    const profileProps = Array.from($1802fb57d6268c24$var$PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($1802fb57d6268c24$var$PROFILE_PROPS_MAP.has(key)) acc[key] = data[$1802fb57d6268c24$var$PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    const extendedProfileProps = Array.from($1802fb57d6268c24$var$EXTENDED_PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($1802fb57d6268c24$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) acc[key] = extendedData[$1802fb57d6268c24$var$EXTENDED_PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    return {
        ...profileProps,
        ...extendedProfileProps,
        localTime: localTime
    };
};
const $1802fb57d6268c24$export$7b103107c889cb67 = (input)=>{
    const output = {
        extended_profile: {}
    };
    Object.keys(input).forEach((key)=>{
        if ($1802fb57d6268c24$var$PROFILE_PROPS_MAP.has(key)) output[$1802fb57d6268c24$var$PROFILE_PROPS_MAP.get(key)] = input[key];
        if ($1802fb57d6268c24$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) output.extended_profile[$1802fb57d6268c24$var$EXTENDED_PROFILE_PROPS_MAP.get(key)] = input[key];
    });
    return output;
};

});
parcelRegister("6vEP1", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("iJONX")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $iJONX = parcelRequire("iJONX");





});
parcelRegister("iJONX", function(module, exports) {

$parcel$export(module.exports, "default", () => $da43d6ba75208a6e$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $9yZxc = parcelRequire("9yZxc");

var $7UyUq = parcelRequire("7UyUq");
function $da43d6ba75208a6e$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $9yZxc.default)((0, $7UyUq.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("9yZxc", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f6705816eccbe5c$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $6vTG6 = parcelRequire("6vTG6");

var $4l8fR = parcelRequire("4l8fR");
var $6f6705816eccbe5c$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $6f6705816eccbe5c$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($6f6705816eccbe5c$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $4l8fR.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $6vTG6.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("6vTG6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4be0d3da30bde1e3$export$2e2bcd8739ae039);

var $hOTDy = parcelRequire("hOTDy");

var $QYiyC = parcelRequire("QYiyC");
var $4be0d3da30bde1e3$var$MILLISECONDS_IN_MINUTE = 60000;
var $4be0d3da30bde1e3$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $4be0d3da30bde1e3$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $4be0d3da30bde1e3$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $4be0d3da30bde1e3$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $4be0d3da30bde1e3$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $4be0d3da30bde1e3$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $4be0d3da30bde1e3$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $4be0d3da30bde1e3$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $4be0d3da30bde1e3$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $4be0d3da30bde1e3$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $4be0d3da30bde1e3$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $4be0d3da30bde1e3$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $hOTDy.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $hOTDy.default)('long', date, options);
        }
    }
};
function $4be0d3da30bde1e3$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $QYiyC.default)(timeZone, originalDate, true) / $4be0d3da30bde1e3$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $4be0d3da30bde1e3$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $4be0d3da30bde1e3$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $4be0d3da30bde1e3$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $4be0d3da30bde1e3$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $4be0d3da30bde1e3$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $4be0d3da30bde1e3$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $4be0d3da30bde1e3$var$formatTimezone(offset, dirtyDelimeter);
}
function $4be0d3da30bde1e3$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $4be0d3da30bde1e3$var$addLeadingZeros(minutes, 2);
}
var $4be0d3da30bde1e3$export$2e2bcd8739ae039 = $4be0d3da30bde1e3$var$formatters;

});
parcelRegister("hOTDy", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf92438666c99b96$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $cf92438666c99b96$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $cf92438666c99b96$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $cf92438666c99b96$var$partsTimeZone(dtf, date) : $cf92438666c99b96$var$hackyTimeZone(dtf, date);
}
function $cf92438666c99b96$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $cf92438666c99b96$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $cf92438666c99b96$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("QYiyC", function(module, exports) {

$parcel$export(module.exports, "default", () => $09f3a16ea202a983$export$2e2bcd8739ae039);

var $4SLL7 = parcelRequire("4SLL7");

var $4jnP4 = parcelRequire("4jnP4");
var $09f3a16ea202a983$var$MILLISECONDS_IN_HOUR = 3600000;
var $09f3a16ea202a983$var$MILLISECONDS_IN_MINUTE = 60000;
var $09f3a16ea202a983$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $09f3a16ea202a983$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $09f3a16ea202a983$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $09f3a16ea202a983$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$09f3a16ea202a983$var$validateTimezone(hours)) return NaN;
        return -(hours * $09f3a16ea202a983$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $09f3a16ea202a983$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$09f3a16ea202a983$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $09f3a16ea202a983$var$MILLISECONDS_IN_HOUR + minutes * $09f3a16ea202a983$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($09f3a16ea202a983$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $09f3a16ea202a983$var$toUtcDate(date);
        var offset = $09f3a16ea202a983$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $09f3a16ea202a983$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $09f3a16ea202a983$var$toUtcDate(date) {
    return (0, $4jnP4.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $09f3a16ea202a983$var$calcOffset(date, timezoneString) {
    var tokens = (0, $4SLL7.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $4jnP4.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $09f3a16ea202a983$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $09f3a16ea202a983$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $09f3a16ea202a983$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $09f3a16ea202a983$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $09f3a16ea202a983$var$validIANATimezoneCache = {};
function $09f3a16ea202a983$var$isValidTimezoneIANAString(timeZoneString) {
    if ($09f3a16ea202a983$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $09f3a16ea202a983$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("4SLL7", function(module, exports) {

$parcel$export(module.exports, "default", () => $38e14080776d6678$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $38e14080776d6678$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $38e14080776d6678$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $38e14080776d6678$var$partsOffset(dtf, date) : $38e14080776d6678$var$hackyOffset(dtf, date);
}
var $38e14080776d6678$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $38e14080776d6678$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $38e14080776d6678$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $38e14080776d6678$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $38e14080776d6678$var$dtfCache = {};
function $38e14080776d6678$var$getDateTimeFormat(timeZone) {
    if (!$38e14080776d6678$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $38e14080776d6678$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $38e14080776d6678$var$dtfCache[timeZone];
}

});

parcelRegister("4jnP4", function(module, exports) {

$parcel$export(module.exports, "default", () => $323b6a73538a6c3b$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $323b6a73538a6c3b$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("4l8fR", function(module, exports) {

$parcel$export(module.exports, "default", () => $328f86cf369d015c$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $QYiyC = parcelRequire("QYiyC");

var $6pTN0 = parcelRequire("6pTN0");
var $328f86cf369d015c$var$MILLISECONDS_IN_HOUR = 3600000;
var $328f86cf369d015c$var$MILLISECONDS_IN_MINUTE = 60000;
var $328f86cf369d015c$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $328f86cf369d015c$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $6pTN0.default)
};
function $328f86cf369d015c$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $328f86cf369d015c$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $328f86cf369d015c$var$splitDateString(argument);
    var parseYearResult = $328f86cf369d015c$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $328f86cf369d015c$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $328f86cf369d015c$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $QYiyC.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $328f86cf369d015c$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $328f86cf369d015c$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $328f86cf369d015c$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $328f86cf369d015c$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $328f86cf369d015c$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $328f86cf369d015c$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $328f86cf369d015c$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $328f86cf369d015c$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $328f86cf369d015c$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $328f86cf369d015c$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $328f86cf369d015c$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$328f86cf369d015c$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $328f86cf369d015c$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$328f86cf369d015c$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $328f86cf369d015c$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$328f86cf369d015c$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $328f86cf369d015c$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$328f86cf369d015c$var$validateWeekDate(year, week)) return new Date(NaN);
        return $328f86cf369d015c$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $328f86cf369d015c$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$328f86cf369d015c$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $328f86cf369d015c$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $328f86cf369d015c$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $328f86cf369d015c$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$328f86cf369d015c$var$validateTime(hours)) return NaN;
        return hours % 24 * $328f86cf369d015c$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $328f86cf369d015c$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$328f86cf369d015c$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $328f86cf369d015c$var$MILLISECONDS_IN_HOUR + minutes * $328f86cf369d015c$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $328f86cf369d015c$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$328f86cf369d015c$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $328f86cf369d015c$var$MILLISECONDS_IN_HOUR + minutes * $328f86cf369d015c$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $328f86cf369d015c$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $328f86cf369d015c$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $328f86cf369d015c$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $328f86cf369d015c$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $328f86cf369d015c$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $328f86cf369d015c$var$isLeapYearIndex(year);
        if (isLeapYear && date > $328f86cf369d015c$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $328f86cf369d015c$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $328f86cf369d015c$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $328f86cf369d015c$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $328f86cf369d015c$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $328f86cf369d015c$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("6pTN0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ac05a8080780859$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $4ac05a8080780859$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $4ac05a8080780859$export$2e2bcd8739ae039 = $4ac05a8080780859$var$tzPattern;

});



parcelRegister("7UyUq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c28d7925dd12d37$export$2e2bcd8739ae039);

var $QYiyC = parcelRequire("QYiyC");

var $4l8fR = parcelRequire("4l8fR");
function $5c28d7925dd12d37$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $4l8fR.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $QYiyC.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});





parcelRegister("cvmaR", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdd97240b83b3eae$export$2e2bcd8739ae039);

var $46Nm5 = parcelRequire("46Nm5");
const $bdd97240b83b3eae$var$updateUserAvatar = async (_, args, context)=>{
    const { userId: userId, fileURI: fileURI } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/avatar`;
    const fileObject = (0, $46Nm5.dataURItoFile)(fileURI);
    const formData = new FormData();
    formData.append('file', fileObject);
    const fetchOptions = {
        method: 'PUT',
        body: formData,
        headers: {
            'Content-Type': undefined
        }
    };
    return context// @ts-ignore: we want to not pass 'Content-Type' header explicitly
    .fetch(url, fetchOptions)// Although current API in id-public-api-facade does not return new uploaded avatar,
    // we still want to have it in client-side
    .then(()=>({
            url: fileURI
        }));
};
var $bdd97240b83b3eae$export$2e2bcd8739ae039 = $bdd97240b83b3eae$var$updateUserAvatar;

});
parcelRegister("46Nm5", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $acb6ce141bc085dd$export$80d19edb7b1ae293);
function $acb6ce141bc085dd$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const byteString = dataURI.split(',')[0].includes('base64') ? atob(dataURI.split(',')[1]) : decodeURIComponent(dataURI.split(',')[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        mimeString = 'unknown';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 and Safari does not support the File constructor.
        return blob;
    }
}

});


parcelRegister("dstEw", function(module, exports) {

$parcel$export(module.exports, "default", () => $65bcfd800d341243$export$2e2bcd8739ae039);

var $eDtHp = parcelRequire("eDtHp");
const $65bcfd800d341243$var$updateUserPrivacySettings = async (_, args, context, info)=>{
    const { id: id, input: input } = args;
    const url = `${context.url.stargateRoot}/users/${id}/manage/privacy-settings`;
    const body = JSON.stringify((0, $eDtHp.transformPrivacySettingsFormatFromSchemaToApi)(input));
    return context.fetch(url, {
        method: 'PATCH',
        body: body
    }).then((data)=>data.json()).then((data)=>(0, $eDtHp.transformPrivacySettingsFormatFromApiToSchema)(data)).then((data)=>({
            ...data,
            id: id
        }));
};
var $65bcfd800d341243$export$2e2bcd8739ae039 = $65bcfd800d341243$var$updateUserPrivacySettings;

});
parcelRegister("eDtHp", function(module, exports) {

$parcel$export(module.exports, "PRIVACY_SETTINGS_SCHEMA_TO_API_MAP", () => $af59ad1b959733fe$export$4154b9b275895abf);
$parcel$export(module.exports, "transformPrivacySettingsFormatFromApiToSchema", () => $af59ad1b959733fe$export$bfc3808f21c9d49d);
$parcel$export(module.exports, "transformPrivacySettingsFormatFromSchemaToApi", () => $af59ad1b959733fe$export$f5a6643bba95b2d0);

var $eit7F = parcelRequire("eit7F");
const $af59ad1b959733fe$var$manageUserPrivacySettingsKeys = [
    'name',
    'nickname',
    'zoneinfo',
    'picture',
    'email',
    'phoneNumber',
    'jobTitle',
    'organization',
    'department',
    'location'
];
const $af59ad1b959733fe$var$schemaKeys = {
    name: 'name',
    nickname: 'nickname',
    zoneinfo: 'zoneinfo',
    picture: 'picture',
    email: 'email',
    phoneNumber: 'phoneNumber',
    jobTitle: 'jobTitle',
    organization: 'organization',
    department: 'department',
    location: 'location'
};
const $af59ad1b959733fe$var$apiKeys = {
    name: 'name',
    nickname: 'nickname',
    zoneinfo: 'zoneinfo',
    picture: 'picture',
    email: 'email',
    phoneNumber: 'extended_profile.phone_number',
    jobTitle: 'extended_profile.job_title',
    organization: 'extended_profile.organization',
    department: 'extended_profile.department',
    location: 'extended_profile.location'
};
const $af59ad1b959733fe$export$4154b9b275895abf = {
    [$af59ad1b959733fe$var$schemaKeys.name]: $af59ad1b959733fe$var$apiKeys.name,
    [$af59ad1b959733fe$var$schemaKeys.nickname]: $af59ad1b959733fe$var$apiKeys.nickname,
    [$af59ad1b959733fe$var$schemaKeys.zoneinfo]: $af59ad1b959733fe$var$apiKeys.zoneinfo,
    [$af59ad1b959733fe$var$schemaKeys.picture]: $af59ad1b959733fe$var$apiKeys.picture,
    [$af59ad1b959733fe$var$schemaKeys.email]: $af59ad1b959733fe$var$apiKeys.email,
    [$af59ad1b959733fe$var$schemaKeys.phoneNumber]: $af59ad1b959733fe$var$apiKeys.phoneNumber,
    // extended profile
    [$af59ad1b959733fe$var$schemaKeys.jobTitle]: $af59ad1b959733fe$var$apiKeys.jobTitle,
    [$af59ad1b959733fe$var$schemaKeys.organization]: $af59ad1b959733fe$var$apiKeys.organization,
    [$af59ad1b959733fe$var$schemaKeys.department]: $af59ad1b959733fe$var$apiKeys.department,
    [$af59ad1b959733fe$var$schemaKeys.location]: $af59ad1b959733fe$var$apiKeys.location
};
const $af59ad1b959733fe$export$bfc3808f21c9d49d = (data)=>Object.keys($af59ad1b959733fe$export$4154b9b275895abf).reduce((memo, schemaValue)=>{
        const apiResponseKey = $af59ad1b959733fe$export$4154b9b275895abf[schemaValue];
        const privacySetting = data[apiResponseKey];
        memo[schemaValue] = (0, $eit7F.toUpperCase)(privacySetting);
        return memo;
    }, {});
const $af59ad1b959733fe$export$64774399daaaf8ff = {
    [$af59ad1b959733fe$var$apiKeys.name]: $af59ad1b959733fe$var$schemaKeys.name,
    [$af59ad1b959733fe$var$apiKeys.nickname]: $af59ad1b959733fe$var$schemaKeys.nickname,
    [$af59ad1b959733fe$var$apiKeys.zoneinfo]: $af59ad1b959733fe$var$schemaKeys.zoneinfo,
    [$af59ad1b959733fe$var$apiKeys.picture]: $af59ad1b959733fe$var$schemaKeys.picture,
    [$af59ad1b959733fe$var$apiKeys.email]: $af59ad1b959733fe$var$schemaKeys.email,
    [$af59ad1b959733fe$var$apiKeys.phoneNumber]: $af59ad1b959733fe$var$schemaKeys.phoneNumber,
    // extended profile
    [$af59ad1b959733fe$var$apiKeys.jobTitle]: $af59ad1b959733fe$var$schemaKeys.jobTitle,
    [$af59ad1b959733fe$var$apiKeys.organization]: $af59ad1b959733fe$var$schemaKeys.organization,
    [$af59ad1b959733fe$var$apiKeys.department]: $af59ad1b959733fe$var$schemaKeys.department,
    [$af59ad1b959733fe$var$apiKeys.location]: $af59ad1b959733fe$var$schemaKeys.location
};
const $af59ad1b959733fe$export$f5a6643bba95b2d0 = (data)=>Object.keys($af59ad1b959733fe$export$64774399daaaf8ff).reduce((memo, apiValue)=>{
        const apiResponseKey = $af59ad1b959733fe$export$64774399daaaf8ff[apiValue];
        const privacySetting = data[apiResponseKey];
        if (privacySetting) memo[apiValue] = privacySetting.toLowerCase();
        return memo;
    }, {});

});
parcelRegister("eit7F", function(module, exports) {

$parcel$export(module.exports, "toUpperCase", () => $cfee0254d44deb02$export$d80c591a9e16646);
const $cfee0254d44deb02$export$d80c591a9e16646 = (input)=>{
    if (typeof input === 'string') return input.toUpperCase();
    return null;
};

});



parcelRegister("2fAj6", function(module, exports) {

$parcel$export(module.exports, "default", () => $291ce7ac2516b2f5$export$2e2bcd8739ae039);
// https://developer.atlassian.com/cloud/admin/user-management/rest/#api-users-account-id-manage-profile-get

var $3tlCg = parcelRequire("3tlCg");
const $291ce7ac2516b2f5$var$User = async (_, args, context, info)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/profile`;
    return context.fetch(url).then((data)=>data.json()).then((res)=>$3tlCg.fromManageAPIResponse(res));
};
var $291ce7ac2516b2f5$export$2e2bcd8739ae039 = $291ce7ac2516b2f5$var$User;

});

parcelRegister("g3q2n", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c9e0293200063ca$export$2e2bcd8739ae039);
// https://developer.atlassian.com/cloud/admin/user-management/rest/#api-users-account-id-manage-profile-get

var $hqeA6 = parcelRequire("hqeA6");
const $1c9e0293200063ca$var$UserManageConfig = async (_, args, context)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage`;
    return context.fetch(url).then((data)=>data.json()).then((data)=>(0, $hqeA6.transformUserManageConfig)(data));
};
var $1c9e0293200063ca$export$2e2bcd8739ae039 = $1c9e0293200063ca$var$UserManageConfig;

});
parcelRegister("hqeA6", function(module, exports) {

$parcel$export(module.exports, "transformUserManageConfig", () => $30fa8eef1b462195$export$d7725d3d27b80a68);
const $30fa8eef1b462195$var$MUTABILITY_DETAILS_MAP = {
    fullName: 'name',
    nickname: 'nickname',
    timezone: 'zoneinfo',
    locale: 'locale',
    email: 'email',
    // extended profile
    title: 'extended_profile.job_title',
    phoneNumber: 'extended_profile.phone_number',
    companyName: 'extended_profile.organization',
    department: 'extended_profile.department',
    location: 'extended_profile.location'
};
const $30fa8eef1b462195$var$CUSTOM_FIELD_PLACE = {
    email: 'email.initiateChange',
    picture: 'avatar'
};
const $30fa8eef1b462195$var$getFieldConfig = (data, field)=>{
    if ((field === 'email' || field === 'picture') && $30fa8eef1b462195$var$CUSTOM_FIELD_PLACE[field]) return data[$30fa8eef1b462195$var$CUSTOM_FIELD_PLACE[field]];
    const mappedFieldKey = $30fa8eef1b462195$var$MUTABILITY_DETAILS_MAP[field];
    // @ts-ignore
    return data['profile.write'][mappedFieldKey];
};
const $30fa8eef1b462195$var$getMutabilityConstraintFor = (data, field)=>{
    const fieldConfig = $30fa8eef1b462195$var$getFieldConfig(data, field);
    if (!fieldConfig || fieldConfig.allowed) return null;
    const reason = fieldConfig.reason;
    return {
        field: field,
        reason: reason && reason.key || null
    };
};
const $30fa8eef1b462195$export$d7725d3d27b80a68 = (data)=>({
        mutabilityConstraints: Object.keys($30fa8eef1b462195$var$MUTABILITY_DETAILS_MAP)// @ts-ignore
        .map((field)=>$30fa8eef1b462195$var$getMutabilityConstraintFor(data, field)).filter((truthy)=>truthy)
    });

});


parcelRegister("g7s65", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa7d9fe2c6a7a5ca$export$2e2bcd8739ae039);
const $aa7d9fe2c6a7a5ca$var$UserManageLinkedAccounts = (_, args, context, info)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/linked-accounts`;
    return context.fetch(url).then((res)=>res.json()).then((data)=>{
        return {
            google: Boolean(data && data.google && data.google.linked),
            microsoft: Boolean(data && data.microsoft && data.microsoft.linked),
            apple: Boolean(data && data.apple && data.apple.linked),
            saml: Boolean(data && data.saml && data.saml.linked)
        };
    });
};
var $aa7d9fe2c6a7a5ca$export$2e2bcd8739ae039 = $aa7d9fe2c6a7a5ca$var$UserManageLinkedAccounts;

});

parcelRegister("cJGGV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba32466074503581$export$2e2bcd8739ae039);

var $eDtHp = parcelRequire("eDtHp");
const $ba32466074503581$var$UserManagePrivacySettings = async (_, args, context, info)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/privacy-settings`;
    return context.fetch(url).then((data)=>data.json()).then((data)=>(0, $eDtHp.transformPrivacySettingsFormatFromApiToSchema)(data)).then((data)=>({
            ...data,
            id: userId
        }));
};
var $ba32466074503581$export$2e2bcd8739ae039 = $ba32466074503581$var$UserManagePrivacySettings;

});

parcelRegister("9g24m", function(module, exports) {

$parcel$export(module.exports, "default", () => $368a2b24364aaaf5$export$2e2bcd8739ae039);

var $isxcI = parcelRequire("isxcI");
const $368a2b24364aaaf5$var$UserManagePrivacySettingsAllowed = async (_, args, context, info)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/privacy-settings/allowed`;
    return context.fetch(url).then((data)=>data.json()).then((data)=>(0, $isxcI.transformUserManagePrivacySettingsAllowed)(data));
};
var $368a2b24364aaaf5$export$2e2bcd8739ae039 = $368a2b24364aaaf5$var$UserManagePrivacySettingsAllowed;

});
parcelRegister("isxcI", function(module, exports) {

$parcel$export(module.exports, "transformUserManagePrivacySettingsAllowed", () => $7d6cb31091c5bb1c$export$3f9c63641eb8459e);

var $eit7F = parcelRequire("eit7F");

var $eDtHp = parcelRequire("eDtHp");
const $7d6cb31091c5bb1c$var$getAllowedPrivacySettingsFor = (data, schemaValue)=>{
    const apiResponseKey = (0, $eDtHp.PRIVACY_SETTINGS_SCHEMA_TO_API_MAP)[schemaValue];
    const allowedPrivacySettings = data[apiResponseKey];
    if (!allowedPrivacySettings || !allowedPrivacySettings.length) return null;
    return allowedPrivacySettings.map((0, $eit7F.toUpperCase));
};
const $7d6cb31091c5bb1c$export$3f9c63641eb8459e = (data)=>Object.keys((0, $eDtHp.PRIVACY_SETTINGS_SCHEMA_TO_API_MAP)).reduce((memo, schemaValue)=>{
        memo[schemaValue] = $7d6cb31091c5bb1c$var$getAllowedPrivacySettingsFor(data, schemaValue);
        return memo;
    }, {});

});


parcelRegister("ZMsiv", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fc315689cef1ffe$export$2e2bcd8739ae039);
const $5fc315689cef1ffe$var$UserOrganization = async (_, args, context, info)=>{
    const url = `${context.url.stargateRoot}/my-orgs`;
    return context.fetch(url).then((data)=>data.json()).then((res)=>({
            cloudId: res.managedBy && res.managedBy.id || null,
            name: res.managedBy && res.managedBy.name || null
        }));
};
var $5fc315689cef1ffe$export$2e2bcd8739ae039 = $5fc315689cef1ffe$var$UserOrganization;

});


parcelRegister("g1jIg", function(module, exports) {

$parcel$export(module.exports, "schema", () => $6e01a296e20c9d55$export$4902baddc787debb);

var $lUVCX = parcelRequire("lUVCX");

var $bERqM = parcelRequire("bERqM");

var $2R8he = parcelRequire("2R8he");

var $8c0cm = parcelRequire("8c0cm");
const $6e01a296e20c9d55$export$4902baddc787debb = new (0, $lUVCX.GraphQLSchema)({
    directives: [
        (0, $bERqM.CustomDirective)
    ],
    query: (0, $8c0cm.default),
    mutation: (0, $2R8he.default)
});

});
parcelRegister("2R8he", function(module, exports) {

$parcel$export(module.exports, "default", () => $c159e0ec0689f975$export$2e2bcd8739ae039);

var $djKly = parcelRequire("djKly");
var $8oLgk = parcelRequire("8oLgk");

var $3jI5w = parcelRequire("3jI5w");

var $diqc0 = parcelRequire("diqc0");

var $byeAv = parcelRequire("byeAv");

var $jI4vA = parcelRequire("jI4vA");
const $c159e0ec0689f975$var$MutationRoot = new (0, $8oLgk.GraphQLObjectType)({
    fields: {
        updateUser: {
            type: (0, $byeAv.default),
            args: {
                id: {
                    type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
                },
                input: {
                    type: (0, $byeAv.UserInput)
                }
            }
        },
        deleteUserAvatar: {
            description: "Delete user's Atlassian account avatar. In the absence of an Atlassian account avatar, the user's gravatar will be used",
            type: (0, $djKly.GraphQLBoolean),
            args: {
                userId: {
                    description: "User's Atlassian account ID",
                    type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
                }
            }
        },
        updateUserAvatar: {
            description: 'Upload an Atlassian account avatar.',
            type: new (0, $8oLgk.GraphQLObjectType)({
                fields: {
                    url: {
                        type: (0, $djKly.GraphQLString)
                    }
                },
                name: (0, $3jI5w.TypeNames).AVATAR,
                description: 'New avatar URL after uploading successfully'
            }),
            args: {
                userId: {
                    description: "User's Atlassian account ID",
                    type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
                },
                fileURI: {
                    description: `Encoded string of image file will be uploaded.
            The avatar has a file size limit of 1MB.`,
                    type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
                }
            }
        },
        updateUserPrivacySettings: {
            description: "Updates a user\u2019s privacy settings.",
            type: (0, $jI4vA.default),
            args: {
                id: {
                    type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
                },
                input: {
                    type: (0, $jI4vA.UserPrivacySettingsInput)
                }
            }
        },
        updateTeamInSlack: {
            type: (0, $diqc0.default),
            args: {
                teamId: {
                    type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
                },
                channelId: {
                    type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
                },
                usergroupHandle: {
                    type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
                }
            }
        },
        disconnectTeamInSlack: {
            type: (0, $diqc0.default),
            args: {
                teamId: {
                    type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
                }
            }
        }
    },
    name: 'Mutation'
});
var $c159e0ec0689f975$export$2e2bcd8739ae039 = $c159e0ec0689f975$var$MutationRoot;

});
parcelRegister("3jI5w", function(module, exports) {

$parcel$export(module.exports, "TypeNames", () => $8c2d07389c5146e3$export$df40df59413bc65c);
var $8c2d07389c5146e3$export$df40df59413bc65c = /*#__PURE__*/ function(TypeNames) {
    TypeNames["USER"] = "_custom_User";
    TypeNames["USER_INPUT"] = "_custom_UserInput";
    TypeNames["USER_MANAGE_CONFIG"] = "_custom_UserManageConfig";
    TypeNames["USER_DETAILS_MUTABILITY_CONSTRAINTS"] = "_custom_UserDetailsMutabilityConstraints";
    TypeNames["USER_MANAGE_LINKED_ACCOUNTS"] = "_custom_UserManageLinkedAccounts";
    TypeNames["PRIVACY_VALUE"] = "_custom_PrivacyValue";
    TypeNames["PRIVACY_VALUE_INPUT"] = "_custom_PrivacyValueInput";
    TypeNames["PRIVACY_SETTINGS"] = "_custom_PrivacySettings";
    TypeNames["PRIVACY_SETTINGS_INPUT"] = "_custom_PrivacySettingsInput";
    TypeNames["PRIVACY_VALUES_CONFIG"] = "_custom_PrivacyValuesConfig";
    TypeNames["USER_PLACE"] = "_custom_UserPlace";
    TypeNames["USER_ORGANIZATION"] = "_custom_UserOrganization";
    TypeNames["PERMISSION_VALUE"] = "_custom_PermissionValue";
    TypeNames["AVATAR"] = "_custom_Avatar";
    TypeNames["MY_AVATAR"] = "_custom_MyAvatar";
    // Whether a team is active in slack
    TypeNames["TeamSlackStatus"] = "_custom_TeamSlackStatus";
    TypeNames["CLASSIC_APP"] = "_custom_ClassicApp";
    TypeNames["CLASSIC_APPS"] = "_custom_ClassicApps";
    TypeNames["MARKETPLACE_APP"] = "_custom_MarketplaceApp";
    TypeNames["CLASSIC_APP_INSTALLATION"] = "_custom_ClassicAppInstallation";
    TypeNames["MARKETPLACE_APP_PERMISSION"] = "_custom_MarketplaceAppPermission";
    TypeNames["MARKETPLACE_APP_PERMISSIONS"] = "_custom_MarketplaceAppPermissions";
    TypeNames["API_TOKEN"] = "_custom_ApiToken";
    TypeNames["SESSIONS_AND_DEVICES"] = "_custom_SessionsAndDevices";
    TypeNames["SESSION"] = "_custom_Session";
    TypeNames["DEVICE"] = "_custom_Device";
    TypeNames["ELEVATED_SESSION"] = "_custom_ElevatedSession";
    TypeNames["TSV_ENROLLMENT_DETAILS"] = "_custom_TsvEnrollmentDetails";
    TypeNames["CONTAINERS"] = "_custom_Containers";
    TypeNames["CONTAINER"] = "_custom_Container";
    TypeNames["CONTAINER_DETAILS"] = "_custom_ContainerDetails";
    TypeNames["COLOUR_SETTING"] = "_custom_ColourSetting";
    TypeNames["TEAM_LINK_ICON"] = "_custom_TeamLinkIcon";
    return TypeNames;
}({});

});

parcelRegister("diqc0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0acfb2511de5f50b$export$2e2bcd8739ae039);

var $djKly = parcelRequire("djKly");
var $8oLgk = parcelRequire("8oLgk");

var $3jI5w = parcelRequire("3jI5w");
const $0acfb2511de5f50b$var$TeamInSlackStatusType = new (0, $8oLgk.GraphQLObjectType)({
    fields: {
        id: {
            type: (0, $djKly.GraphQLString)
        },
        connected: {
            type: (0, $djKly.GraphQLBoolean)
        },
        slackChannelId: {
            type: (0, $djKly.GraphQLString)
        },
        slackChannelName: {
            type: (0, $djKly.GraphQLString)
        },
        usergroupHandle: {
            type: (0, $djKly.GraphQLString)
        }
    },
    name: (0, $3jI5w.TypeNames).TeamSlackStatus,
    description: 'Whether the team has opted in to being synced with slack'
});
var $0acfb2511de5f50b$export$2e2bcd8739ae039 = $0acfb2511de5f50b$var$TeamInSlackStatusType;

});

parcelRegister("byeAv", function(module, exports) {

$parcel$export(module.exports, "default", () => $2996eedf8d7f62da$export$2e2bcd8739ae039);
$parcel$export(module.exports, "UserInput", () => $2996eedf8d7f62da$export$3ac5e585cf392ee0);

var $8oLgk = parcelRequire("8oLgk");
var $djKly = parcelRequire("djKly");

var $3jI5w = parcelRequire("3jI5w");
const $2996eedf8d7f62da$var$User = new (0, $8oLgk.GraphQLObjectType)({
    fields: {
        id: {
            type: (0, $djKly.GraphQLString)
        },
        fullName: {
            type: (0, $djKly.GraphQLString)
        },
        nickname: {
            type: (0, $djKly.GraphQLString)
        },
        timezone: {
            type: (0, $djKly.GraphQLString)
        },
        locale: {
            type: (0, $djKly.GraphQLString)
        },
        avatarUrl: {
            type: (0, $djKly.GraphQLString)
        },
        email: {
            type: (0, $djKly.GraphQLString)
        },
        status: {
            type: (0, $djKly.GraphQLString)
        },
        // extended profile
        title: {
            type: (0, $djKly.GraphQLString)
        },
        companyName: {
            type: (0, $djKly.GraphQLString)
        },
        department: {
            type: (0, $djKly.GraphQLString)
        },
        location: {
            type: (0, $djKly.GraphQLString)
        },
        phoneNumber: {
            type: (0, $djKly.GraphQLString)
        },
        // This should be considered to move to component level that uses timezone
        localTime: {
            type: (0, $djKly.GraphQLString),
            args: {
                format: {
                    description: 'moment.js format string',
                    type: (0, $djKly.GraphQLString),
                    defaultValue: ''
                },
                locale: {
                    description: 'locale for output',
                    type: (0, $djKly.GraphQLString),
                    defaultValue: 'en'
                }
            }
        }
    },
    name: (0, $3jI5w.TypeNames).USER,
    description: 'All User related data will be behind this GraphQL section'
});
var $2996eedf8d7f62da$export$2e2bcd8739ae039 = $2996eedf8d7f62da$var$User;
const $2996eedf8d7f62da$export$3ac5e585cf392ee0 = new (0, $8oLgk.GraphQLInputObjectType)({
    fields: {
        fullName: {
            type: (0, $djKly.GraphQLString)
        },
        nickname: {
            type: (0, $djKly.GraphQLString)
        },
        timezone: {
            type: (0, $djKly.GraphQLString)
        },
        locale: {
            type: (0, $djKly.GraphQLString)
        },
        email: {
            type: (0, $djKly.GraphQLString)
        },
        status: {
            type: (0, $djKly.GraphQLString)
        },
        // extended profile
        title: {
            type: (0, $djKly.GraphQLString)
        },
        companyName: {
            type: (0, $djKly.GraphQLString)
        },
        department: {
            type: (0, $djKly.GraphQLString)
        },
        location: {
            type: (0, $djKly.GraphQLString)
        },
        phoneNumber: {
            type: (0, $djKly.GraphQLString)
        }
    },
    name: (0, $3jI5w.TypeNames).USER_INPUT
});

});

parcelRegister("jI4vA", function(module, exports) {

$parcel$export(module.exports, "UserPrivacySettingsInput", () => $646bf118d6afe1b3$export$5d92383dfb6e3588);
$parcel$export(module.exports, "PrivacyValue", () => $646bf118d6afe1b3$export$8d71fec0dbffb7e5);
$parcel$export(module.exports, "default", () => $646bf118d6afe1b3$export$2e2bcd8739ae039);

var $8oLgk = parcelRequire("8oLgk");
var $djKly = parcelRequire("djKly");

var $3jI5w = parcelRequire("3jI5w");
const $646bf118d6afe1b3$export$5c97c5d10d84e13c = new (0, $8oLgk.GraphQLEnumType)({
    name: (0, $3jI5w.TypeNames).PRIVACY_VALUE_INPUT,
    values: {
        PUBLIC: {
            value: 'public'
        },
        COLLABORATOR: {
            value: 'collaborator'
        },
        PRIVATE: {
            value: 'private'
        }
    }
});
const $646bf118d6afe1b3$export$5d92383dfb6e3588 = new (0, $8oLgk.GraphQLInputObjectType)({
    fields: {
        name: {
            type: (0, $djKly.GraphQLString)
        },
        nickname: {
            type: (0, $djKly.GraphQLString)
        },
        jobTitle: {
            type: (0, $djKly.GraphQLString)
        },
        department: {
            type: (0, $djKly.GraphQLString)
        },
        organization: {
            type: (0, $djKly.GraphQLString)
        },
        location: {
            type: (0, $djKly.GraphQLString)
        },
        zoneinfo: {
            type: (0, $djKly.GraphQLString)
        },
        email: {
            type: (0, $djKly.GraphQLString)
        },
        phoneNumber: {
            type: (0, $djKly.GraphQLString)
        },
        picture: {
            type: (0, $djKly.GraphQLString)
        },
        teamType: {
            type: (0, $djKly.GraphQLString)
        }
    },
    name: (0, $3jI5w.TypeNames).PRIVACY_SETTINGS_INPUT,
    description: 'User privacy settings values to be set'
});
const $646bf118d6afe1b3$var$DefaultPrivacyValue = new (0, $8oLgk.GraphQLEnumType)({
    name: (0, $3jI5w.TypeNames).PRIVACY_VALUE,
    values: {
        PUBLIC: {
            value: 'PUBLIC'
        },
        COLLABORATOR: {
            value: 'COLLABORATOR'
        },
        PRIVATE: {
            value: 'PRIVATE'
        }
    }
});
const $646bf118d6afe1b3$export$8d71fec0dbffb7e5 = new (0, $8oLgk.GraphQLNonNull)($646bf118d6afe1b3$var$DefaultPrivacyValue);
const $646bf118d6afe1b3$var$UserManagePrivacySettings = new (0, $8oLgk.GraphQLObjectType)({
    fields: {
        id: {
            type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
        },
        name: {
            type: $646bf118d6afe1b3$export$8d71fec0dbffb7e5
        },
        nickname: {
            type: $646bf118d6afe1b3$export$8d71fec0dbffb7e5
        },
        jobTitle: {
            type: $646bf118d6afe1b3$export$8d71fec0dbffb7e5
        },
        department: {
            type: $646bf118d6afe1b3$export$8d71fec0dbffb7e5
        },
        organization: {
            type: $646bf118d6afe1b3$export$8d71fec0dbffb7e5
        },
        location: {
            type: $646bf118d6afe1b3$export$8d71fec0dbffb7e5
        },
        zoneinfo: {
            type: $646bf118d6afe1b3$export$8d71fec0dbffb7e5
        },
        email: {
            type: $646bf118d6afe1b3$export$8d71fec0dbffb7e5
        },
        phoneNumber: {
            type: $646bf118d6afe1b3$var$DefaultPrivacyValue
        },
        picture: {
            type: $646bf118d6afe1b3$export$8d71fec0dbffb7e5
        },
        teamType: {
            type: $646bf118d6afe1b3$export$8d71fec0dbffb7e5
        }
    },
    name: (0, $3jI5w.TypeNames).PRIVACY_SETTINGS,
    description: 'User privacy settings values'
});
var $646bf118d6afe1b3$export$2e2bcd8739ae039 = $646bf118d6afe1b3$var$UserManagePrivacySettings;

});


parcelRegister("8c0cm", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f3752b16f950744$export$2e2bcd8739ae039);

var $djKly = parcelRequire("djKly");
var $8oLgk = parcelRequire("8oLgk");

var $axdd0 = parcelRequire("axdd0");
var $diqc0 = parcelRequire("diqc0");
var $k5raj = parcelRequire("k5raj");
var $byeAv = parcelRequire("byeAv");
var $cYahQ = parcelRequire("cYahQ");
var $aFLfH = parcelRequire("aFLfH");
var $jI4vA = parcelRequire("jI4vA");
var $hRqna = parcelRequire("hRqna");
var $ile8l = parcelRequire("ile8l");

var $gCVT9 = parcelRequire("gCVT9");
const $8f3752b16f950744$var$QueryRoot = new (0, $8oLgk.GraphQLObjectType)({
    fields: {
        UserOrganization: {
            type: (0, $ile8l.default)
        },
        User: {
            type: (0, $byeAv.default),
            args: {
                userId: {
                    type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
                }
            }
        },
        MyAvatar: {
            type: (0, $axdd0.default),
            args: {
                userId: {
                    type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
                }
            }
        },
        UserManageConfig: {
            type: (0, $cYahQ.default),
            args: {
                userId: {
                    type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
                }
            }
        },
        UserManagePrivacySettings: {
            type: (0, $jI4vA.default),
            args: {
                userId: {
                    type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
                }
            }
        },
        UserManagePrivacySettingsAllowed: {
            type: (0, $hRqna.default),
            args: {
                userId: {
                    type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
                }
            }
        },
        UserManageLinkedAccounts: {
            type: (0, $aFLfH.default),
            args: {
                userId: {
                    type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
                }
            }
        },
        TeamInSlack: {
            type: (0, $diqc0.default),
            args: {
                teamId: {
                    type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
                },
                teamName: {
                    type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
                }
            }
        },
        Containers: {
            type: (0, $gCVT9.default),
            args: {
                principalId: {
                    type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
                },
                siteId: {
                    type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
                },
                userId: {
                    type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
                },
                maxNumberOfResults: {
                    type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLInt))
                },
                sessionId: {
                    type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
                }
            }
        },
        TeamLinkIcons: {
            type: new (0, $8oLgk.GraphQLList)((0, $k5raj.default)),
            args: {
                teamLinkUrls: {
                    type: new (0, $8oLgk.GraphQLList)((0, $djKly.GraphQLString))
                }
            }
        }
    },
    name: 'Query'
});
var $8f3752b16f950744$export$2e2bcd8739ae039 = $8f3752b16f950744$var$QueryRoot;

});
parcelRegister("axdd0", function(module, exports) {

$parcel$export(module.exports, "default", () => $13007d32fd4172f4$export$2e2bcd8739ae039);

var $djKly = parcelRequire("djKly");
var $8oLgk = parcelRequire("8oLgk");

var $3jI5w = parcelRequire("3jI5w");
const $13007d32fd4172f4$var$MyAvatar = new (0, $8oLgk.GraphQLObjectType)({
    fields: {
        url: {
            type: (0, $djKly.GraphQLString)
        },
        uploaded: {
            type: (0, $djKly.GraphQLBoolean)
        }
    },
    name: (0, $3jI5w.TypeNames).MY_AVATAR,
    description: "Get meta-data about current user\u2019s avatar"
});
var $13007d32fd4172f4$export$2e2bcd8739ae039 = $13007d32fd4172f4$var$MyAvatar;

});

parcelRegister("k5raj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bb94e37eb5b33fe$export$2e2bcd8739ae039);

var $8oLgk = parcelRequire("8oLgk");
var $djKly = parcelRequire("djKly");

var $3jI5w = parcelRequire("3jI5w");
const $7bb94e37eb5b33fe$var$TeamLinkIcon = new (0, $8oLgk.GraphQLObjectType)({
    fields: {
        linkUrl: {
            type: (0, $djKly.GraphQLString)
        },
        iconUrl: {
            type: (0, $djKly.GraphQLString)
        },
        productName: {
            type: (0, $djKly.GraphQLString)
        }
    },
    name: (0, $3jI5w.TypeNames).TEAM_LINK_ICON,
    description: 'Icon URL to use for a link'
});
var $7bb94e37eb5b33fe$export$2e2bcd8739ae039 = $7bb94e37eb5b33fe$var$TeamLinkIcon;

});

parcelRegister("cYahQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fb53ff8506e41eb$export$2e2bcd8739ae039);

var $8oLgk = parcelRequire("8oLgk");
var $djKly = parcelRequire("djKly");

var $3jI5w = parcelRequire("3jI5w");
const $6fb53ff8506e41eb$var$MutabilityConstraints = new (0, $8oLgk.GraphQLObjectType)({
    fields: {
        field: {
            type: (0, $djKly.GraphQLString)
        },
        reason: {
            type: (0, $djKly.GraphQLString)
        }
    },
    name: (0, $3jI5w.TypeNames).USER_DETAILS_MUTABILITY_CONSTRAINTS
});
const $6fb53ff8506e41eb$var$UserManageConfig = new (0, $8oLgk.GraphQLObjectType)({
    fields: {
        mutabilityConstraints: {
            type: new (0, $8oLgk.GraphQLList)($6fb53ff8506e41eb$var$MutabilityConstraints)
        }
    },
    name: (0, $3jI5w.TypeNames).USER_MANAGE_CONFIG,
    description: 'User mutability constraints values'
});
var $6fb53ff8506e41eb$export$2e2bcd8739ae039 = $6fb53ff8506e41eb$var$UserManageConfig;

});

parcelRegister("aFLfH", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb9b7b269e7a844c$export$2e2bcd8739ae039);

var $djKly = parcelRequire("djKly");
var $8oLgk = parcelRequire("8oLgk");

var $3jI5w = parcelRequire("3jI5w");
const $fb9b7b269e7a844c$var$LinkedAccounts = new (0, $8oLgk.GraphQLObjectType)({
    fields: {
        google: {
            type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLBoolean))
        },
        microsoft: {
            type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLBoolean))
        },
        apple: {
            type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLBoolean))
        },
        saml: {
            type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLBoolean))
        }
    },
    name: (0, $3jI5w.TypeNames).USER_MANAGE_LINKED_ACCOUNTS
});
var $fb9b7b269e7a844c$export$2e2bcd8739ae039 = $fb9b7b269e7a844c$var$LinkedAccounts;

});

parcelRegister("hRqna", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b1d16ba636f720a$export$2e2bcd8739ae039);

var $8oLgk = parcelRequire("8oLgk");

var $3jI5w = parcelRequire("3jI5w");

var $jI4vA = parcelRequire("jI4vA");
const $1b1d16ba636f720a$var$AllowedPrivacyValue = new (0, $8oLgk.GraphQLList)((0, $jI4vA.PrivacyValue));
const $1b1d16ba636f720a$var$UserManagePrivacySettingsAllowed = new (0, $8oLgk.GraphQLObjectType)({
    fields: {
        name: {
            type: $1b1d16ba636f720a$var$AllowedPrivacyValue
        },
        nickname: {
            type: $1b1d16ba636f720a$var$AllowedPrivacyValue
        },
        jobTitle: {
            type: $1b1d16ba636f720a$var$AllowedPrivacyValue
        },
        department: {
            type: $1b1d16ba636f720a$var$AllowedPrivacyValue
        },
        organization: {
            type: $1b1d16ba636f720a$var$AllowedPrivacyValue
        },
        location: {
            type: $1b1d16ba636f720a$var$AllowedPrivacyValue
        },
        zoneinfo: {
            type: $1b1d16ba636f720a$var$AllowedPrivacyValue
        },
        email: {
            type: $1b1d16ba636f720a$var$AllowedPrivacyValue
        },
        phoneNumber: {
            type: $1b1d16ba636f720a$var$AllowedPrivacyValue
        },
        picture: {
            type: $1b1d16ba636f720a$var$AllowedPrivacyValue
        },
        teamType: {
            type: $1b1d16ba636f720a$var$AllowedPrivacyValue
        }
    },
    name: (0, $3jI5w.TypeNames).PRIVACY_VALUES_CONFIG,
    description: 'User privacy settings allowed values'
});
var $1b1d16ba636f720a$export$2e2bcd8739ae039 = $1b1d16ba636f720a$var$UserManagePrivacySettingsAllowed;

});

parcelRegister("ile8l", function(module, exports) {

$parcel$export(module.exports, "default", () => $21c2d118e2c2e6d9$export$2e2bcd8739ae039);

var $8oLgk = parcelRequire("8oLgk");
var $djKly = parcelRequire("djKly");

var $3jI5w = parcelRequire("3jI5w");
const $21c2d118e2c2e6d9$var$UserPlace = new (0, $8oLgk.GraphQLObjectType)({
    fields: {
        cloudId: {
            type: (0, $djKly.GraphQLString)
        },
        name: {
            type: (0, $djKly.GraphQLString)
        }
    },
    name: (0, $3jI5w.TypeNames).USER_ORGANIZATION,
    description: 'Organization a user belongs to'
});
var $21c2d118e2c2e6d9$export$2e2bcd8739ae039 = $21c2d118e2c2e6d9$var$UserPlace;

});

parcelRegister("gCVT9", function(module, exports) {

$parcel$export(module.exports, "default", () => $68365df937c8d926$export$2e2bcd8739ae039);

var $djKly = parcelRequire("djKly");
var $8oLgk = parcelRequire("8oLgk");

var $3jI5w = parcelRequire("3jI5w");
const $68365df937c8d926$var$ContainerDetails = new (0, $8oLgk.GraphQLObjectType)({
    fields: {
        id: {
            type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
        },
        key: {
            type: (0, $djKly.GraphQLString)
        },
        name: {
            type: (0, $djKly.GraphQLString)
        },
        url: {
            type: (0, $djKly.GraphQLString)
        },
        iconUrl: {
            type: (0, $djKly.GraphQLString)
        }
    },
    name: (0, $3jI5w.TypeNames).CONTAINER_DETAILS
});
const $68365df937c8d926$var$Container = new (0, $8oLgk.GraphQLObjectType)({
    fields: {
        id: {
            type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
        },
        entityType: {
            type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
        },
        containerType: {
            type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLString))
        },
        score: {
            type: new (0, $8oLgk.GraphQLNonNull)((0, $djKly.GraphQLFloat))
        },
        containerDetails: {
            type: $68365df937c8d926$var$ContainerDetails
        }
    },
    name: (0, $3jI5w.TypeNames).CONTAINER
});
const $68365df937c8d926$var$Containers = new (0, $8oLgk.GraphQLObjectType)({
    fields: {
        collaborationGraphEntities: {
            type: new (0, $8oLgk.GraphQLNonNull)(new (0, $8oLgk.GraphQLList)(new (0, $8oLgk.GraphQLNonNull)($68365df937c8d926$var$Container)))
        }
    },
    name: (0, $3jI5w.TypeNames).CONTAINERS,
    description: 'A list of Places Spaces/Projects'
});
var $68365df937c8d926$export$2e2bcd8739ae039 = $68365df937c8d926$var$Containers;

});




parcelRegister("cModO", function(module, exports) {

$parcel$export(module.exports, "withDefaultExponentialBackoff", () => $662cd54cd40ccccb$export$455df4c93665fa4a);
const $662cd54cd40ccccb$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $662cd54cd40ccccb$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
// tslint:disable-next-line no-any
const $662cd54cd40ccccb$var$defaultRetryIfCallback = (a)=>!a;
const $662cd54cd40ccccb$var$defaultOptions = {
    initial: 200,
    jitter: false,
    max: 5,
    retryIf: $662cd54cd40ccccb$var$defaultRetryIfCallback
};
function $662cd54cd40ccccb$export$20eaa22f2295996f(toTry, hofOptions = $662cd54cd40ccccb$var$defaultOptions) {
    const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
    // Initialize max retry decrementing counter (range of max...0)
    let attemptsRemaining = max;
    // Initialize delay. This will exponentially increase each retry (delay = intial * 2^n)
    let delay = initial;
    /**
	 * This function calls itself recursively until `retryIf` evaluates false or the retry limit is reached.
	 * The functioned-to-be-retried is called on each recursion.
	 */ return async function tryWithExponentialBackoff(...args) {
        // "An attempt was made"
        const result = await toTry(...args);
        --attemptsRemaining;
        // If tried function was unsuccessful and there are still retries remaining, retry!
        if (retryIf && retryIf(result) && attemptsRemaining > 0) {
            // Wait for delay
            await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
            // Exponentially increase delay
            delay *= 2;
            // Initiate retry
            return tryWithExponentialBackoff(...args);
        }
        // Return result of tried function if it is successful or if the retry limit
        // was reached regardless of success.
        return result;
    };
}
function $662cd54cd40ccccb$export$455df4c93665fa4a(fetchOp) {
    return $662cd54cd40ccccb$export$20eaa22f2295996f(fetchOp, {
        initial: $662cd54cd40ccccb$export$8f4286bf21155381.INITIAL_DELAY,
        jitter: $662cd54cd40ccccb$export$8f4286bf21155381.JITTER,
        max: $662cd54cd40ccccb$export$8f4286bf21155381.MAX_RETRIES,
        retryIf: (response)=>$662cd54cd40ccccb$export$55b2fbd5d4a32495(response.status)
    });
}

});



parcelRegister("llJ2w", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbca80a37f3264ec$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bvsgq = parcelRequire("bvsgq");

var $fHpHg = parcelRequire("fHpHg");

var $47QoQ = parcelRequire("47QoQ");

var $6PNiw = parcelRequire("6PNiw");
var $h2IKP = parcelRequire("h2IKP");
var $7bl9X = parcelRequire("7bl9X");
var $lURml = parcelRequire("lURml");
var $1lfNR = parcelRequire("1lfNR");
var $a4jrI = parcelRequire("a4jrI");
var $glY8Q = parcelRequire("glY8Q");

var $5qEtQ = parcelRequire("5qEtQ");

var $3gj6A = parcelRequire("3gj6A");

var $jP0Fy = parcelRequire("jP0Fy");

var $971Nd = parcelRequire("971Nd");

var $cWJwU = parcelRequire("cWJwU");

var $ewXsc = parcelRequire("ewXsc");

var $52kuW = parcelRequire("52kuW");

var $hKTTU = parcelRequire("hKTTU");

var $5WY7F = parcelRequire("5WY7F");

var $cOGeJ = parcelRequire("cOGeJ");

var $kUn7S = parcelRequire("kUn7S");
function $bbca80a37f3264ec$export$2e2bcd8739ae039(props) {
    const { appName: appName, analytics: analytics, apolloClient: apolloClient, contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint, replace: replace, push: push, locale: locale, skipI18nProvider: skipI18nProvider, addFlag: addFlag, docTitle: docTitle, env: env, history: history, statusCodeHandlers: statusCodeHandlers, cloudId: cloudId, orgId: orgId, teamCentralHandlers: teamCentralHandlers, productFeatureFlags: productFeatureFlags, invitePeopleHandlers: invitePeopleHandlers, isAIEnabled: isAIEnabled } = props;
    const [, { setCloudId: setCloudId }] = (0, $a4jrI.useSite)();
    const [, { setOrgId: setOrgId }] = (0, $1lfNR.useOrg)();
    const [, { initTeamCentral: initTeamCentral }] = (0, $glY8Q.useTeamCentralStoreApi)();
    const orgIdLoadingTimer = (0, $5uXOq.useRef)(null);
    const cloudIdLoadingTimer = (0, $5uXOq.useRef)(null);
    const { isJiraAvailable: isJiraAvailable } = (0, $5qEtQ.useJiraCheckService)(cloudId);
    // when FG off, set cloud id to empty string to skip api call
    const { data: licenseCheckResult } = (0, $cWJwU.useLicenseCheck)((0, $fHpHg.fg)('enable_site_url_context_in_teams') ? cloudId : '');
    const expTracker = analytics.expTracker();
    const analyticsClient = analytics.getAnalyticsWebClient();
    (0, $5uXOq.useEffect)(()=>{
        if (orgId) // @ts-expect-error - Property 'setOrgInfo' does not exist on type 'Promise<AnalyticsWebClient>'
        analyticsClient?.setOrgInfo(orgId);
    }, [
        analyticsClient,
        orgId
    ]);
    const appConfig = (0, $5uXOq.useMemo)(()=>({
            env: env,
            appName: appName,
            contextSpaPaths: contextSpaPaths,
            contextEntryPoint: contextEntryPoint,
            push: push,
            replace: replace,
            addFlag: addFlag,
            locale: locale,
            docTitle: docTitle,
            cloudId: cloudId,
            orgId: orgId,
            productFeatureFlags: productFeatureFlags,
            stargateRoot: (0, $971Nd.getConfig)().stargateRoot,
            isJiraAvailable: isJiraAvailable,
            isAIEnabled: isAIEnabled,
            siteUrl: licenseCheckResult?.hostname
        }), [
        env,
        appName,
        contextSpaPaths,
        contextEntryPoint,
        isJiraAvailable,
        push,
        replace,
        addFlag,
        locale,
        docTitle,
        cloudId,
        orgId,
        productFeatureFlags,
        isAIEnabled,
        licenseCheckResult?.hostname
    ]);
    // init statusCodeHandlersProvider
    (0, $5uXOq.useEffect)(()=>{
        if (statusCodeHandlers) (0, $lURml.statusCodeHandlersProvider).setHandlers(statusCodeHandlers);
    }, [
        statusCodeHandlers
    ]);
    // save cloud id passed from consumers to a remote state management.
    (0, $5uXOq.useEffect)(()=>{
        setCloudId(cloudId);
        if (!cloudId) cloudIdLoadingTimer.current = setTimeout(()=>{
            (0, $jP0Fy.logErrorMessage)('No cloudId set - App.tsx');
        }, 3000);
        else if (cloudIdLoadingTimer.current) clearInterval(cloudIdLoadingTimer.current);
    }, [
        cloudId,
        setCloudId
    ]);
    // save org id passed from consumers to a remote state management.
    (0, $5uXOq.useEffect)(()=>{
        setOrgId(orgId);
        if (!orgId) orgIdLoadingTimer.current = setTimeout(()=>{
            (0, $jP0Fy.logErrorMessage)('No orgId set - App.tsx');
        }, 3000);
        else if (orgIdLoadingTimer.current) clearInterval(orgIdLoadingTimer.current);
    }, [
        orgId,
        setOrgId
    ]);
    // Init and save various team central related data and preconditions
    (0, $5uXOq.useEffect)(()=>{
        initTeamCentral(appName, cloudId, teamCentralHandlers);
    }, [
        appName,
        cloudId,
        teamCentralHandlers,
        initTeamCentral
    ]);
    const handleTransition = (0, $5uXOq.useCallback)((pathname)=>{
        if (expTracker) expTracker.abort({
            reason: 'Route changes.'
        });
        (0, $jP0Fy.addBreadcrumb)(pathname);
    }, [
        expTracker
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7bl9X.default), {
        messagesConfig: (0, $ewXsc.default),
        skip: typeof skipI18nProvider !== 'undefined' ? skipI18nProvider : !locale,
        locale: locale,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5WY7F.default), {
            analytics: analytics,
            appName: appName,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3gj6A.TeamsWrapper), {
                appConfig: appConfig,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hKTTU.default), {
                    env: env,
                    contextSpaPaths: contextSpaPaths,
                    contextEntryPoint: contextEntryPoint,
                    docTitle: docTitle,
                    appName: appName,
                    addFlag: addFlag,
                    push: push,
                    locale: locale,
                    replace: replace,
                    history: history,
                    cloudId: cloudId,
                    orgId: orgId,
                    isJiraAvailable: isJiraAvailable,
                    teamCentralHandlers: teamCentralHandlers,
                    productFeatureFlags: productFeatureFlags,
                    invitePeopleHandlers: invitePeopleHandlers,
                    isAIEnabled: isAIEnabled,
                    siteUrl: licenseCheckResult?.hostname,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6PNiw.default), {
                        analytics: analytics,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $47QoQ.ExperienceTrackerContext).Provider, {
                            value: analytics.expTracker(),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)($cOGeJ.RelativeWrapperOfHeaderImage, {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bvsgq.ApolloProvider), {
                                    client: apolloClient,
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h2IKP.default), {
                                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kUn7S.default), {
                                            appName: appName,
                                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $52kuW.default), {
                                                contextEntryPoint: contextEntryPoint,
                                                history: history,
                                                onTransition: handleTransition
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
}

});
parcelRegister("bvsgq", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $02296d7a3662bd2d$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $02296d7a3662bd2d$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $02296d7a3662bd2d$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $02296d7a3662bd2d$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $02296d7a3662bd2d$export$8f49e4af10703ce3);

var $5uXOq = parcelRequire("5uXOq");

var $1DiV8 = parcelRequire("1DiV8");
var $02296d7a3662bd2d$var$apolloContext;
function $02296d7a3662bd2d$export$a47505d961ee3a1() {
    if (!$02296d7a3662bd2d$var$apolloContext) $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
    return $02296d7a3662bd2d$var$apolloContext;
}
function $02296d7a3662bd2d$export$c2ee824bcc89ca6a() {
    $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
}
var $02296d7a3662bd2d$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $1DiV8.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $02296d7a3662bd2d$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $1DiV8.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $02296d7a3662bd2d$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($02296d7a3662bd2d$export$d1d99cf900472499 || ($02296d7a3662bd2d$export$d1d99cf900472499 = {}));
var $02296d7a3662bd2d$var$cache = new Map();
function $02296d7a3662bd2d$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $02296d7a3662bd2d$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $02296d7a3662bd2d$export$8f49e4af10703ce3(document) {
    var cached = $02296d7a3662bd2d$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $1DiV8.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $1DiV8.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $1DiV8.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $02296d7a3662bd2d$export$d1d99cf900472499.Query : $02296d7a3662bd2d$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $02296d7a3662bd2d$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $1DiV8.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $02296d7a3662bd2d$var$cache.set(document, payload);
    return payload;
}

});

parcelRegister("6PNiw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4e3614f9a387176$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3C9WL = parcelRequire("3C9WL");
class $c4e3614f9a387176$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3C9WL.AnalyticsContext).Provider, {
            value: this.state,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.state = {
            analytics: this.props.analytics
        };
    }
}

});
parcelRegister("3C9WL", function(module, exports) {

$parcel$export(module.exports, "defaultAnalyticsClient", () => $83e811200cf34d7b$export$7fa70eb12a96b7d1);
$parcel$export(module.exports, "AnalyticsContext", () => $83e811200cf34d7b$export$83cd6c3eba7d8d9e);

var $5uXOq = parcelRequire("5uXOq");

var $aVe3r = parcelRequire("aVe3r");
const $83e811200cf34d7b$var$defaultAnalyticsMethod = ()=>{
    // tslint:disable-next-line no-console
    // eslint-disable-next-line no-console
    console.warn('No analytics client has been provided.');
    (0, $aVe3r.logInfoMessage)('Analytics Context accessed before AnalyticsClient was loaded');
};
const $83e811200cf34d7b$export$7fa70eb12a96b7d1 = {
    getAnalyticsWebClient: ()=>{
        $83e811200cf34d7b$var$defaultAnalyticsMethod();
        return;
    },
    pushTrackEvent: $83e811200cf34d7b$var$defaultAnalyticsMethod,
    pushScreenEvent: $83e811200cf34d7b$var$defaultAnalyticsMethod,
    pushUIEvent: $83e811200cf34d7b$var$defaultAnalyticsMethod,
    pushOperationalEvent: $83e811200cf34d7b$var$defaultAnalyticsMethod,
    startUIViewedEvent: $83e811200cf34d7b$var$defaultAnalyticsMethod,
    expTracker: ()=>{
        throw new Error('No analytics client has been provided');
    },
    setTeamId: ()=>{
        throw new Error('No analytics client has been provided');
    }
};
const $83e811200cf34d7b$var$AnalyticsContextState = {
    analytics: $83e811200cf34d7b$export$7fa70eb12a96b7d1
};
const $83e811200cf34d7b$export$83cd6c3eba7d8d9e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($83e811200cf34d7b$var$AnalyticsContextState);

});
parcelRegister("aVe3r", function(module, exports) {

$parcel$export(module.exports, "logException", () => $1062d7e96f5b96c5$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logErrorMessage", () => $1062d7e96f5b96c5$export$ece28f5cfa04608);
$parcel$export(module.exports, "logInfoMessage", () => $1062d7e96f5b96c5$export$386587bcf05ee8ea);
$parcel$export(module.exports, "createErrorHandler", () => $1062d7e96f5b96c5$export$9edc7d6f1c33ddc);

var $jP0Fy = parcelRequire("jP0Fy");
const $1062d7e96f5b96c5$var$packageContext = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $1062d7e96f5b96c5$export$f86b2a1a2ce291b3 = (0, $jP0Fy.logExceptionWithPackageContext)($1062d7e96f5b96c5$var$packageContext);
const $1062d7e96f5b96c5$export$ece28f5cfa04608 = (0, $jP0Fy.logErrorMessageWithPackageContext)($1062d7e96f5b96c5$var$packageContext);
const $1062d7e96f5b96c5$export$386587bcf05ee8ea = (0, $jP0Fy.logInfoMessageWithPackageContext)($1062d7e96f5b96c5$var$packageContext);
const $1062d7e96f5b96c5$export$9edc7d6f1c33ddc = (0, $jP0Fy.createErrorHandlerWithPackageContext)($1062d7e96f5b96c5$var$packageContext);

});



parcelRegister("h2IKP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e7111eee6c3acc2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5zb0v = parcelRequire("5zb0v");

var $lvtc2 = parcelRequire("lvtc2");
const $7e7111eee6c3acc2$var$initialStates = {
    DialogComponent: null,
    dialogProps: null,
    isOpen: false
};
function $7e7111eee6c3acc2$var$dialogReducer(state, action) {
    switch(action.type){
        case 'open':
            return {
                ...state,
                DialogComponent: action.payload?.DialogComponent || null,
                dialogProps: action.payload?.dialogProps || null,
                isOpen: true
            };
        case 'close':
            return {
                ...state,
                DialogComponent: null,
                dialogProps: null,
                isOpen: false
            };
        default:
            throw new Error();
    }
}
function $7e7111eee6c3acc2$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const [stateDialogProvider, dispatch] = (0, $5uXOq.useReducer)($7e7111eee6c3acc2$var$dialogReducer, $7e7111eee6c3acc2$var$initialStates);
    const valueProvider = (0, $5uXOq.useMemo)(()=>({
            openDialog: (DialogComponent, dialogProps = null)=>dispatch({
                    type: 'open',
                    payload: {
                        DialogComponent: DialogComponent,
                        dialogProps: dialogProps
                    }
                }),
            closeDialog: ()=>dispatch({
                    type: 'close'
                })
        }), []);
    return(// @ts-ignore
    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $lvtc2.DialogsContext).Provider, {
        value: valueProvider,
        children: [
            children,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5zb0v.default), {
                ...stateDialogProvider
            })
        ]
    }));
}

});
parcelRegister("5zb0v", function(module, exports) {

$parcel$export(module.exports, "default", () => $0641627d5eb92e4e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kW74I = parcelRequire("kW74I");

var $lvtc2 = parcelRequire("lvtc2");
function $0641627d5eb92e4e$export$2e2bcd8739ae039(props) {
    const { DialogComponent: DialogComponent, isOpen: isOpen, onClose: onClose, dialogProps: dialogProps } = props;
    const { closeDialog: closeDialog } = (0, $5uXOq.useContext)((0, $lvtc2.DialogsContext));
    if (!DialogComponent) return null;
    const handleCloseDialog = ()=>{
        closeDialog();
        if (onClose) onClose();
        if (dialogProps?.onClose) dialogProps.onClose();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kW74I.default), {
        children: isOpen && /*#__PURE__*/ (0, $2OMIu.jsx)(DialogComponent, {
            ...dialogProps,
            onClose: handleCloseDialog
        })
    });
}

});
parcelRegister("lvtc2", function(module, exports) {

$parcel$export(module.exports, "DialogsContext", () => $f40028f95085a416$export$412f7f691e39b0da);

var $5uXOq = parcelRequire("5uXOq");
const $f40028f95085a416$var$dialogsContextState = {
    openDialog: ()=>null,
    closeDialog: ()=>null
};
const $f40028f95085a416$export$412f7f691e39b0da = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($f40028f95085a416$var$dialogsContextState);

});



parcelRegister("7bl9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $22cc2e4abef7cd04$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");

var $aVe3r = parcelRequire("aVe3r");

var $RbbRb = parcelRequire("RbbRb");
/**
 * Sets up the react-intl IntlProvider for its children, blocking until translations are loaded
 */ const $22cc2e4abef7cd04$var$NO_MESSAGES = {};
class $22cc2e4abef7cd04$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    componentDidMount() {
        if (this.props.skip !== true) this.loadData();
    }
    async loadData() {
        const { messagesConfig: messagesConfig, locale: predefinedLocale } = this.props;
        const locale = await (0, $RbbRb.getEffectiveLocale)(predefinedLocale);
        if (locale === (0, $RbbRb.DEFAULT_LOCALE)) {
            // Everything is already loaded for English
            this.setState({
                locale: (0, $RbbRb.DEFAULT_LOCALE),
                messages: {}
            });
            return;
        }
        try {
            const messages = await (0, $RbbRb.loadIntlData)(messagesConfig, locale);
            this.setState({
                locale: locale,
                messages: messages || $22cc2e4abef7cd04$var$NO_MESSAGES
            });
        } catch (error) {
            // @ts-ignore
            (0, $aVe3r.logException)(error, 'Error loading translations.', {
                locale: locale
            });
            // show english on error
            this.setState({
                locale: (0, $RbbRb.DEFAULT_LOCALE),
                messages: $22cc2e4abef7cd04$var$NO_MESSAGES
            });
        }
    }
    render() {
        const { skip: skip } = this.props;
        // TODO: [PTC-4968] Long term 'skip' prop to be removed in favour being skipped by
        //       default and `embeddable-directory` to rely on parent product i18n provider.
        //       The idea is to merge package i18n files into product ones, and ship that
        //       one global product i18n translation rather than packages fetching their own.
        if (skip) return this.props.children;
        const { locale: locale, messages: messages } = this.state;
        // Idea for improvement we should not block rendering UI while fetching messages
        // https://product-fabric.atlassian.net/browse/PTC-2176
        if (!messages) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
            "data-test-language": locale,
            locale: locale,
            defaultLocale: (0, $RbbRb.DEFAULT_LOCALE),
            messages: messages,
            children: this.props.children
        }, `intl-provider-5-${locale}`);
    }
    constructor(...args){
        super(...args), this.state = {
            locale: (0, $RbbRb.DEFAULT_LOCALE),
            messages: undefined
        };
    }
}

});
parcelRegister("RbbRb", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", () => $bb5ab9d27c81a6d4$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "getEffectiveLocale", () => $bb5ab9d27c81a6d4$export$5211f28df9ef284a);
$parcel$export(module.exports, "loadIntlData", () => $bb5ab9d27c81a6d4$export$d225990554fb28f7);

var $daiCS = parcelRequire("daiCS");

var $dyczo = parcelRequire("dyczo");

var $6NlCv = parcelRequire("6NlCv");
const $bb5ab9d27c81a6d4$export$1af4c7e47ad72f44 = 'en';
const $bb5ab9d27c81a6d4$export$b6a046f0eef1bb2 = [
    'cs',
    'cs-CZ',
    'da',
    'da-DK',
    'de',
    'de-DE',
    'en',
    'en-GB',
    'en-US',
    'en-ZZ',
    'es',
    'es-ES',
    'et',
    'et-EE',
    'fi',
    'fi-FI',
    'fr',
    'fr-FR',
    'hu',
    'hu-HU',
    'is',
    'is-IS',
    'it',
    'it-IT',
    'ja',
    'ja-JP',
    'ko',
    'ko-KR',
    'nb',
    'nb-NO',
    'nl',
    'nl-NL',
    'pl',
    'pl-PL',
    'pt',
    'pt-BR',
    'pt-PT',
    'ro',
    'ro-RO',
    'ru',
    'ru-RU',
    'sk',
    'sk-SK',
    'sv',
    'sv-SE',
    'tr',
    'tr-TR',
    'th',
    'th-TH',
    'uk',
    'uk-UA',
    'vi',
    'vi-VN',
    'zh',
    'zh-TW',
    'zh-HK',
    'zh-ZH',
    'zh-CN'
];
// In URL, a tester can pass lang code or locale into URL, e.g `?locale=fr` or `?locale=cs-CZ`
const $bb5ab9d27c81a6d4$var$getLocaleFromUrl = ()=>{
    const { locale: locale } = (0, (/*@__PURE__*/$parcel$interopDefault($daiCS))).parse((0, (/*@__PURE__*/$parcel$interopDefault($dyczo))).location.search);
    const localeFromUrl = Array.isArray(locale) ? locale[0] : locale;
    return localeFromUrl;
};
function $bb5ab9d27c81a6d4$var$getSupportedLocale(locale) {
    if (typeof locale !== 'string') return null;
    locale = locale.replace('_', '-');
    if ($bb5ab9d27c81a6d4$export$b6a046f0eef1bb2.includes(locale)) return locale;
    // If we don't have the exact locale available, attempt to match just the language
    const languageCode = locale.substring(0, 2);
    if ($bb5ab9d27c81a6d4$export$b6a046f0eef1bb2.includes(languageCode)) return languageCode;
}
const $bb5ab9d27c81a6d4$export$5211f28df9ef284a = async (predefinedLocale)=>{
    // locale that we can manually pass to intl provider
    const receivedLocale = $bb5ab9d27c81a6d4$var$getSupportedLocale(predefinedLocale);
    if (receivedLocale) return receivedLocale;
    // locale that we can pass to intl provider via `locale` GET param
    const localeInUrl = $bb5ab9d27c81a6d4$var$getSupportedLocale($bb5ab9d27c81a6d4$var$getLocaleFromUrl());
    if (localeInUrl) return localeInUrl;
    let userLocale;
    try {
        userLocale = (await (0, $6NlCv.userInfoProvider).get()).locale;
    } catch (e) {
        userLocale = $bb5ab9d27c81a6d4$export$1af4c7e47ad72f44;
    }
    return $bb5ab9d27c81a6d4$var$getSupportedLocale(userLocale) || $bb5ab9d27c81a6d4$export$1af4c7e47ad72f44;
};
const $bb5ab9d27c81a6d4$export$d225990554fb28f7 = (localesConfig, locale)=>{
    const pickedConfig = localesConfig.find((config)=>config.locales.includes(locale));
    const loader = pickedConfig?.loader;
    if (!loader) return Promise.resolve(null);
    return new Promise((resolve, reject)=>{
        // Fails if we haven't loaded/resolved after 30 seconds
        const rejectTimer = setTimeout(reject, 30000);
        loader().then((res)=>{
            clearTimeout(rejectTimer);
            // depending on a builder and config used in a project the result of dynamic imports could be behind `default`
            // this way we'll cover both cases
            resolve(res && res.default || res);
        });
    });
};

});
parcelRegister("daiCS", function(module, exports) {

$parcel$export(module.exports, "extract", () => $995aa8419c16eff8$export$f9380c9a627682d3, (v) => $995aa8419c16eff8$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $995aa8419c16eff8$export$98e6a39c04603d36, (v) => $995aa8419c16eff8$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $995aa8419c16eff8$export$fac44ee5b035f737, (v) => $995aa8419c16eff8$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $995aa8419c16eff8$export$7a5253c0f62e0150, (v) => $995aa8419c16eff8$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $995aa8419c16eff8$export$a8c1621ea79325d3, (v) => $995aa8419c16eff8$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $995aa8419c16eff8$export$357523c63a2253b9, (v) => $995aa8419c16eff8$export$357523c63a2253b9 = v);
$parcel$export(module.exports, "exclude", () => $995aa8419c16eff8$export$44c361b8ec72ef7f, (v) => $995aa8419c16eff8$export$44c361b8ec72ef7f = v);
var $995aa8419c16eff8$export$f9380c9a627682d3;
var $995aa8419c16eff8$export$98e6a39c04603d36;
var $995aa8419c16eff8$export$fac44ee5b035f737;
var $995aa8419c16eff8$export$7a5253c0f62e0150;
var $995aa8419c16eff8$export$a8c1621ea79325d3;
var $995aa8419c16eff8$export$357523c63a2253b9;
var $995aa8419c16eff8$export$44c361b8ec72ef7f;
'use strict';

var $hlggt = parcelRequire("hlggt");

var $aCrRe = parcelRequire("aCrRe");

var $gjKya = parcelRequire("gjKya");

var $cNVkY = parcelRequire("cNVkY");
const $995aa8419c16eff8$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $995aa8419c16eff8$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $995aa8419c16eff8$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $995aa8419c16eff8$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $995aa8419c16eff8$var$encode(key, options),
                            '[',
                            $995aa8419c16eff8$var$encode(index, options),
                            ']=',
                            $995aa8419c16eff8$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $995aa8419c16eff8$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $995aa8419c16eff8$var$encode(key, options),
                            '[]=',
                            $995aa8419c16eff8$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $995aa8419c16eff8$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $995aa8419c16eff8$var$encode(key, options),
                            ':list=',
                            $995aa8419c16eff8$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $995aa8419c16eff8$var$encode(key, options),
                                keyValueSep,
                                $995aa8419c16eff8$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $995aa8419c16eff8$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $995aa8419c16eff8$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $995aa8419c16eff8$var$encode(key, options),
                            '=',
                            $995aa8419c16eff8$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $995aa8419c16eff8$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $995aa8419c16eff8$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $995aa8419c16eff8$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$995aa8419c16eff8$var$decode(item, options)) : value === null ? value : $995aa8419c16eff8$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $995aa8419c16eff8$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$995aa8419c16eff8$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $995aa8419c16eff8$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $995aa8419c16eff8$var$encode(value, options) {
    if (options.encode) return options.strict ? $hlggt(value) : encodeURIComponent(value);
    return value;
}
function $995aa8419c16eff8$var$decode(value, options) {
    if (options.decode) return $aCrRe(value);
    return value;
}
function $995aa8419c16eff8$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $995aa8419c16eff8$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $995aa8419c16eff8$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $995aa8419c16eff8$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $995aa8419c16eff8$var$extract(input) {
    input = $995aa8419c16eff8$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $995aa8419c16eff8$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $995aa8419c16eff8$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $995aa8419c16eff8$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $995aa8419c16eff8$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $gjKya(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $995aa8419c16eff8$var$decode(value, options);
        formatter($995aa8419c16eff8$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $995aa8419c16eff8$var$parseValue(value[k], options);
        else ret[key] = $995aa8419c16eff8$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $995aa8419c16eff8$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$995aa8419c16eff8$export$f9380c9a627682d3 = $995aa8419c16eff8$var$extract;
$995aa8419c16eff8$export$98e6a39c04603d36 = $995aa8419c16eff8$var$parse;
$995aa8419c16eff8$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $995aa8419c16eff8$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $995aa8419c16eff8$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $995aa8419c16eff8$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $995aa8419c16eff8$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $995aa8419c16eff8$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $995aa8419c16eff8$var$encode(key, options) + '=' + $995aa8419c16eff8$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$995aa8419c16eff8$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $gjKya(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $995aa8419c16eff8$var$parse($995aa8419c16eff8$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $995aa8419c16eff8$var$decode(hash, options)
    } : {});
};
$995aa8419c16eff8$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$995aa8419c16eff8$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $995aa8419c16eff8$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $995aa8419c16eff8$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $995aa8419c16eff8$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $995aa8419c16eff8$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $995aa8419c16eff8$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$995aa8419c16eff8$var$encodeFragmentIdentifier] ? $995aa8419c16eff8$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$995aa8419c16eff8$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$995aa8419c16eff8$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $995aa8419c16eff8$export$7a5253c0f62e0150(input, options);
    return $995aa8419c16eff8$export$a8c1621ea79325d3({
        url: url,
        query: $cNVkY(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$995aa8419c16eff8$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $995aa8419c16eff8$export$357523c63a2253b9(input, exclusionFilter, options);
};

});

parcelRegister("6NlCv", function(module, exports) {

$parcel$export(module.exports, "userInfoProvider", () => $ceef1447a2dfa339$export$30a852ca4cb27370);

var $971Nd = parcelRequire("971Nd");
// Needs to be declared here to avoid blowing up this earlyInit bundle
class $ceef1447a2dfa339$var$FetchError extends Error {
    constructor(response){
        super(`Request failed with status ${response.status}`);
        this.response = response;
        this.name = this.constructor.name;
    }
}
class $ceef1447a2dfa339$export$dc10e400a1189789 {
    get(fetchOp = fetch) {
        if (this.promise) return this.promise;
        const getJson = (url)=>fetchOp(url, {
                method: 'GET',
                mode: 'cors',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response)=>{
                if (!response.ok) throw new $ceef1447a2dfa339$var$FetchError(response);
                return response.json();
            });
        this.promise = getJson(`${(0, $971Nd.getConfig)().stargateRoot}/me`).then((me)=>{
            return {
                userId: me.account_id,
                locale: me.locale,
                fullName: me.name,
                avatarUrl: me.picture,
                email: me.email,
                title: me.extended_profile?.job_title
            };
        });
        return this.promise;
    }
}
const $ceef1447a2dfa339$export$30a852ca4cb27370 = new $ceef1447a2dfa339$export$dc10e400a1189789();

});



parcelRegister("lURml", function(module, exports) {

$parcel$export(module.exports, "statusCodeHandlersProvider", () => $4b627070d4e13be0$export$8c005e458e12d501);
$parcel$export(module.exports, "handleResponse", () => $4b627070d4e13be0$export$c113a67a6762ad2e);
/**
 * Our REST clients are initialised when their module loads which makes it tricky for them to consume the `statusCodeHandlers` prop passed to App from the host application.
 * This is a temporary measure to enable the clients to consume `statusCodeHandlers`.
 * The long term solution is to replace our REST clients with Apollo client custom resolvers
 * This will unify all remote data handling under the apollo-client module which is able to easily receive `statusCodeHandlers` as it is initialised within the React portion of our app.
 */ const $4b627070d4e13be0$export$8c005e458e12d501 = {
    handlers: {},
    get () {
        return $4b627070d4e13be0$export$8c005e458e12d501.handlers;
    },
    setHandlers (handlers) {
        $4b627070d4e13be0$export$8c005e458e12d501.handlers = handlers;
    }
};
function $4b627070d4e13be0$export$c113a67a6762ad2e(response) {
    const { status: status } = response;
    const handler = $4b627070d4e13be0$export$8c005e458e12d501.get()[status];
    if (typeof handler === 'function') handler(response);
}

});

parcelRegister("1lfNR", function(module, exports) {

$parcel$export(module.exports, "useOrg", () => $015bf95084aef23b$export$7f785727a26e156);

var $3sQ5x = parcelRequire("3sQ5x");

var $bRG9l = parcelRequire("bRG9l");
const $015bf95084aef23b$export$7f785727a26e156 = (0, $3sQ5x.createHook)((0, $bRG9l.Store));

});
parcelRegister("bRG9l", function(module, exports) {

$parcel$export(module.exports, "Store", () => $f6005cf71975fa61$export$390f32400eaf98c9);

var $iXqE5 = parcelRequire("iXqE5");
const $f6005cf71975fa61$var$actions = {
    setOrgId: (orgId)=>({ setState: setState })=>{
            setState({
                orgId: orgId
            });
        }
};
const $f6005cf71975fa61$var$initialState = {
    orgId: undefined
};
const $f6005cf71975fa61$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    initialState: $f6005cf71975fa61$var$initialState,
    actions: $f6005cf71975fa61$var$actions,
    name: 'Org'
});

});


parcelRegister("a4jrI", function(module, exports) {

$parcel$export(module.exports, "useSite", () => $4e1fb45a766f5e85$export$7870fa8e7cdd59f8);
$parcel$export(module.exports, "useCloudId", () => $4e1fb45a766f5e85$export$9da0f7c65f28ed16);

var $3sQ5x = parcelRequire("3sQ5x");

var $j7JiP = parcelRequire("j7JiP");
const $4e1fb45a766f5e85$export$7870fa8e7cdd59f8 = (0, $3sQ5x.createHook)((0, $j7JiP.Store));
const $4e1fb45a766f5e85$export$9da0f7c65f28ed16 = ()=>$4e1fb45a766f5e85$export$7870fa8e7cdd59f8()[0].cloudId;

});
parcelRegister("j7JiP", function(module, exports) {

$parcel$export(module.exports, "Store", () => $0553d3742fdb7b4d$export$390f32400eaf98c9);

var $iXqE5 = parcelRequire("iXqE5");
const $0553d3742fdb7b4d$var$actions = {
    // This action is used by EmbeddedDirectory to get Cloud Id in a remote store.
    setCloudId: (cloudId)=>({ setState: setState })=>{
            setState({
                cloudId: cloudId
            });
        }
};
const $0553d3742fdb7b4d$var$initialState = {
    cloudId: ''
};
const $0553d3742fdb7b4d$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    initialState: $0553d3742fdb7b4d$var$initialState,
    actions: $0553d3742fdb7b4d$var$actions,
    name: 'Site'
});

});


parcelRegister("glY8Q", function(module, exports) {

$parcel$export(module.exports, "useTeamCentralStore", () => $2effe856d37b5ac3$export$39314e672c06693f);
$parcel$export(module.exports, "useTeamCentralStoreApi", () => $2effe856d37b5ac3$export$7c58a39ba496932b);
$parcel$export(module.exports, "useIsTeamCentral", () => $2effe856d37b5ac3$export$9da989c55553d02d);
$parcel$export(module.exports, "useTeamCentralPresent", () => $2effe856d37b5ac3$export$20f07b26e9a56b9);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $2ys8y = parcelRequire("2ys8y");

var $971Nd = parcelRequire("971Nd");

var $73xf5 = parcelRequire("73xf5");
const $2effe856d37b5ac3$var$initialState = {
    isTeamCentral: false,
    hasWorkspace: false,
    orgHasWorkspace: false,
    teamCentralHandlers: {},
    teamCentralUrl: undefined
};
const $2effe856d37b5ac3$var$actions = {
    initTeamCentral: (appName, cloudId, teamCentralHandlers = {})=>({ setState: setState })=>{
            const isTeamCentral = appName === 'teamcentral-directory';
            let teamCentralUrlPromise;
            if ((0, $971Nd.getConfig)().teamCentralDisabled === true) teamCentralUrlPromise = Promise.resolve(undefined);
            else teamCentralUrlPromise = (0, $73xf5.default).isGlobalExperienceWorkspaceForCloudId(cloudId).then((isGlobalExperience)=>{
                return isGlobalExperience ? (0, $2ys8y.getATLContextUrl)('home') : (0, $2ys8y.getATLContextUrl)('team');
            });
            if (isTeamCentral) // Assume site already has a TC workspace if directory is running in TC mode
            teamCentralUrlPromise.then((teamCentralUrl)=>{
                setState({
                    isTeamCentral: isTeamCentral,
                    hasWorkspace: true,
                    orgHasWorkspace: true,
                    teamCentralHandlers: teamCentralHandlers,
                    teamCentralUrl: teamCentralUrl
                });
            });
            else {
                // Otherwise, fetch for workspace information
                const requests = [
                    (0, $73xf5.default).hasWorkspaceForCloudId(cloudId),
                    (0, $73xf5.default).doesOrgContainAnyWorkspace(cloudId),
                    teamCentralUrlPromise
                ];
                Promise.all(requests).then(([hasWorkspace, orgHasWorkspace, teamCentralUrl])=>{
                    setState({
                        isTeamCentral: false,
                        hasWorkspace: hasWorkspace,
                        orgHasWorkspace: orgHasWorkspace,
                        teamCentralHandlers: teamCentralHandlers,
                        teamCentralUrl: teamCentralUrl
                    });
                });
            }
        }
};
/**
 * Manage states of searching People and Teams in search home page.
 */ const $2effe856d37b5ac3$var$Store = (0, $iXqE5.createStore)({
    initialState: $2effe856d37b5ac3$var$initialState,
    actions: $2effe856d37b5ac3$var$actions,
    name: 'SearchHomePage'
});
const $2effe856d37b5ac3$export$39314e672c06693f = (0, $3sQ5x.createHook)($2effe856d37b5ac3$var$Store);
const $2effe856d37b5ac3$export$7c58a39ba496932b = (0, $3sQ5x.createHook)($2effe856d37b5ac3$var$Store, {
    selector: null
});
const $2effe856d37b5ac3$export$9da989c55553d02d = (0, $3sQ5x.createHook)($2effe856d37b5ac3$var$Store, {
    selector: (s)=>s.isTeamCentral
});
const $2effe856d37b5ac3$export$20f07b26e9a56b9 = (0, $3sQ5x.createHook)($2effe856d37b5ac3$var$Store, {
    selector: (s)=>s.isTeamCentral || s.hasWorkspace || s.orgHasWorkspace
});

});
parcelRegister("73xf5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7189860722a81f8$export$2e2bcd8739ae039);

var $fHpHg = parcelRequire("fHpHg");

var $971Nd = parcelRequire("971Nd");

var $9HMKn = parcelRequire("9HMKn");
const $a7189860722a81f8$var$UNSHARDED_PREFIX = '/watermelon';
class $a7189860722a81f8$export$424050aeba67e883 extends (0, $9HMKn.default) {
    constructor(){
        super({
            serviceUrl: (0, $971Nd.getConfig)().stargateRoot
        });
    }
    async hasWorkspaceForCloudId(cloudId) {
        try {
            await this.getResource(`${this.buildShardedPrefix(cloudId)}/workspace/exists?cloudId=${cloudId}`);
            return true;
        } catch (err) {
            return false;
        }
    }
    async doesOrgContainAnyWorkspace(cloudId) {
        try {
            await this.getResource(((0, $fHpHg.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? $a7189860722a81f8$var$UNSHARDED_PREFIX : this.buildShardedPrefix(cloudId)) + `/organization/containsAnyWorkspace?cloudId=${cloudId}`);
            return true;
        } catch (err) {
            return false;
        }
    }
    async isGlobalExperienceWorkspaceForCloudId(cloudId) {
        try {
            const res = await this.makeRequest(`${this.buildShardedPrefix(cloudId)}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`, {
                headers: {
                    Accept: 'text/plain'
                }
            });
            return Promise.resolve(res === 'GLOBAL_EXPERIENCE');
        } catch (err) {
            return Promise.resolve(false);
        }
    }
    buildShardedPrefix(cloudId) {
        return `/townsquare/s/${cloudId}`;
    }
}
var /**
 * REST Client to make calls to resources on the team central service.
 *
 * Note: You probably don't want to use this directly. Use the centralised store instead where these values
 * have already been fetched. See useTeamCentralStore().
 *
 * @type {RestClient}
 */ // eslint-disable-next-line import/no-anonymous-default-export
$a7189860722a81f8$export$2e2bcd8739ae039 = new $a7189860722a81f8$export$424050aeba67e883();

});
parcelRegister("9HMKn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8452e4792ea1230e$export$2e2bcd8739ae039);

var $1UikQ = parcelRequire("1UikQ");

var $bxYf9 = parcelRequire("bxYf9");

var $iotKb = parcelRequire("iotKb");

var $f8WsG = parcelRequire("f8WsG");

var $8bKaH = parcelRequire("8bKaH");

var $cModO = parcelRequire("cModO");

var $lURml = parcelRequire("lURml");
const $8452e4792ea1230e$var$defaultFetchOptions = {
    credentials: 'include',
    headers: {
        Accept: 'application/json'
    },
    mode: 'cors'
};
const $8452e4792ea1230e$var$fetchWithExponentialBackoff = (0, $cModO.withDefaultExponentialBackoff)(fetch);
// tslint:disable-next-line no-any
function $8452e4792ea1230e$var$parseResponse(response) {
    const responseStatusCode = response.status;
    if (responseStatusCode === 204 || responseStatusCode === 202) return null;
    const contentType = response.headers.get('content-type');
    if (!contentType || contentType.includes('text/html') || contentType.includes('text/plain')) return response.text();
    if (contentType.includes('application/json')) return response.json();
    return null;
}
async function $8452e4792ea1230e$export$91c32f1b22d29b2d(response) {
    let json;
    const text = await response.text();
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp; // to dedupe sentry, scrub non-unique 'timestamp' field from the error body
    if (json.errors) {
        const errs = json.errors.map((error)=>typeof error === 'string' ? error : error.code || error.message || (0, $8bKaH.DirectoryErrorCode).MISSING_ERROR_MESSAGE);
        return errs.join('\n - ');
    }
    return JSON.stringify(json);
}
let $8452e4792ea1230e$var$incrementRedirectCount;
let $8452e4792ea1230e$var$clearRedirectCount;
$8452e4792ea1230e$export$7a0fc52d8c359feb();
function $8452e4792ea1230e$export$7a0fc52d8c359feb() {
    $8452e4792ea1230e$var$incrementRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(()=>(0, $f8WsG.setCookie)((0, $f8WsG.REDIRECT_COUNT), (0, $f8WsG.getCookieAsInteger)((0, $f8WsG.REDIRECT_COUNT)) + 1));
    $8452e4792ea1230e$var$clearRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(()=>(0, $f8WsG.clearCookie)((0, $f8WsG.REDIRECT_COUNT)));
}
class $8452e4792ea1230e$var$RestClient {
    constructor({ serviceUrl: serviceUrl = '' } = {}){
        /**
	 * This function is necessary for if `statusCodeHandler` prescribes a login
	 * redirect upon a 401 response.
	 * While the default redirect behaviour may be overriden, this function has
	 * been kept separate to ensure it cannot be overriden, lest a host
	 * application supply embeddable-directory with a custom handler that suffers
	 * the infinite redirect bug.
	 */ this.preventInfiniteRedirectLoop = (response)=>{
            if (!response.ok) {
                const responseStatusCode = response.status;
                if (responseStatusCode === 401) $8452e4792ea1230e$var$incrementRedirectCount();
            } else $8452e4792ea1230e$var$clearRedirectCount();
        };
        this.serviceUrl = serviceUrl;
    }
    async getResource(path) {
        return this.makeRequest(path);
    }
    async postResource(path, data, fetchOptions = {}) {
        return this.postResourceRaw(path, JSON.stringify(data), fetchOptions);
    }
    async postResourceRaw(path, data, fetchOptions = {}) {
        fetchOptions = {
            method: 'post',
            headers: {},
            ...fetchOptions
        };
        if (data) fetchOptions = {
            body: data,
            ...fetchOptions,
            headers: {
                'Content-Type': 'application/json',
                ...fetchOptions.headers
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async patchResource(path, data) {
        let fetchOptions = {
            /**
			 * PATCH must be uppercase as per fetch spec only
			 * DELETE, GET, HEAD, OPTIONS, POST, and PUT methods
			 * are normalised to uppercase.
			 *
			 * https://github.com/github/fetch/issues/37
			 * https://fetch.spec.whatwg.org/#methods
			 */ method: 'PATCH'
        };
        if (data) fetchOptions = {
            ...fetchOptions,
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async putResource(path, data, additionalFetchOptions = {}) {
        const fetchOptions = {
            method: 'put'
        };
        if (data) Object.assign(fetchOptions, {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return this.makeRequest(path, {
            ...fetchOptions,
            ...additionalFetchOptions
        });
    }
    async deleteResource(path, options = {}) {
        const fetchOptions = {
            ...options,
            method: 'delete'
        };
        return this.makeRequest(path, fetchOptions);
    }
    async makeRequest(path, additionalFetchOptions = {}) {
        const url = this.serviceUrl + path;
        const options = (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, $8452e4792ea1230e$var$defaultFetchOptions, additionalFetchOptions);
        const response = await $8452e4792ea1230e$var$fetchWithExponentialBackoff(url, options);
        this.preventInfiniteRedirectLoop(response);
        (0, $lURml.handleResponse)(response);
        const responseStatusCode = response.status;
        const traceId = response.headers.get('atl-traceid');
        if (!response.ok) {
            if (responseStatusCode === 401) throw new (0, $iotKb.SentryIgnoreError)({
                message: 'Unauthorized Request - incrementing redirect count'
            });
            else {
                const message = await $8452e4792ea1230e$export$91c32f1b22d29b2d(response);
                throw new (0, $iotKb.HttpError)({
                    message: message,
                    status: responseStatusCode,
                    traceId: traceId ?? undefined
                });
            }
        }
        return additionalFetchOptions.ignoreResponse ? null : $8452e4792ea1230e$var$parseResponse(response);
    }
}
var $8452e4792ea1230e$export$2e2bcd8739ae039 = $8452e4792ea1230e$var$RestClient;

});
parcelRegister("iotKb", function(module, exports) {

$parcel$export(module.exports, "SentryIgnoreError", () => $03433e70ecd1aecc$export$20de9a0e470e95aa);
$parcel$export(module.exports, "HttpError", () => $03433e70ecd1aecc$export$65bd6083489bd8bb);
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
class $03433e70ecd1aecc$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        this.message = message;
        this.stack = new Error(message).stack || '';
    }
}
class $03433e70ecd1aecc$export$c73ca302efeda3b4 extends $03433e70ecd1aecc$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $03433e70ecd1aecc$export$c73ca302efeda3b4.prototype);
    }
}
class $03433e70ecd1aecc$export$20de9a0e470e95aa extends $03433e70ecd1aecc$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $03433e70ecd1aecc$export$20de9a0e470e95aa.prototype);
    }
}
class $03433e70ecd1aecc$export$65bd6083489bd8bb extends $03433e70ecd1aecc$var$CommonError {
    constructor({ message: message, status: status, traceId: traceId }){
        super(message);
        Object.setPrototypeOf(this, $03433e70ecd1aecc$export$65bd6083489bd8bb.prototype);
        this.status = status;
        this.traceId = traceId;
    }
}
class $03433e70ecd1aecc$export$92d6ed0888e7cb7f extends $03433e70ecd1aecc$var$CommonError {
    constructor({ message: message, category: category = 'default', fields: fields }){
        super(message);
        Object.setPrototypeOf(this, $03433e70ecd1aecc$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
    static{
        this.from = (rawErrors)=>{
            const firstError = rawErrors[0];
            const errorData = {
                category: firstError.category,
                message: firstError.message
            };
            if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
                obj[item.field] = item.message;
                return obj;
            }, {});
            return new $03433e70ecd1aecc$export$92d6ed0888e7cb7f(errorData);
        };
    }
}

});

parcelRegister("f8WsG", function(module, exports) {

$parcel$export(module.exports, "REDIRECT_COUNT", () => $5be6c824cbc8f077$export$f6101897f0230549);
$parcel$export(module.exports, "setCookie", () => $5be6c824cbc8f077$export$110700823644f4a6);
$parcel$export(module.exports, "getCookieAsInteger", () => $5be6c824cbc8f077$export$6a289e5003f59269);
$parcel$export(module.exports, "clearCookie", () => $5be6c824cbc8f077$export$ad3506281d5a5e5d);
const $5be6c824cbc8f077$export$f6101897f0230549 = 'redirectCount';
const $5be6c824cbc8f077$export$5a7d8afb87170e45 = 'avatar.csrf.token';
function $5be6c824cbc8f077$export$110700823644f4a6(key, value) {
    document.cookie = `${key}=${value};path=/;max-age=30`;
}
function $5be6c824cbc8f077$export$6a289e5003f59269(key, defaultValue = 0) {
    const regex = new RegExp(`${key}=(\\d+)`);
    const result = document.cookie.match(regex);
    return result ? parseInt(result[1], 10) : defaultValue;
}
function $5be6c824cbc8f077$export$ad3506281d5a5e5d(key) {
    document.cookie = `${key}=doesntmatter;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
}

});




parcelRegister("5qEtQ", function(module, exports) {

$parcel$export(module.exports, "useJiraCheckService", () => $49347ec697cf40bc$export$b998d6ed276aaffa);

var $5uXOq = parcelRequire("5uXOq");

var $6h0eh = parcelRequire("6h0eh");

var $gU7a6 = parcelRequire("gU7a6");
const $49347ec697cf40bc$export$3847702755d66eb8 = (cloudId, options)=>{
    const [request, controller] = (0, $5uXOq.useMemo)(()=>(0, $gU7a6.defaultRequestAbort)(cloudId), [
        cloudId
    ]);
    const [getJiraCheck, result] = (0, $6h0eh.useLazyService)(request, controller, {
        initialState: {
            ...options?.initialState
        }
    });
    return [
        getJiraCheck,
        {
            ...result,
            isJiraAvailable: Boolean(result.data?.permitted)
        }
    ];
};
const $49347ec697cf40bc$export$b998d6ed276aaffa = (...[cloudId, options])=>{
    const [getJiraCheck, result] = $49347ec697cf40bc$export$3847702755d66eb8(cloudId, options);
    (0, $5uXOq.useEffect)(()=>{
        if (cloudId) getJiraCheck();
    }, [
        cloudId,
        getJiraCheck
    ]);
    return result;
};

});
parcelRegister("6h0eh", function(module, exports) {

$parcel$export(module.exports, "useLazyService", () => $d940bdf671fdc4d8$export$1a85343b4dbf3bf5);
$parcel$export(module.exports, "useService", () => $d940bdf671fdc4d8$export$6de4685a6c88b4e9);
$parcel$export(module.exports, "useServiceLight", () => $d940bdf671fdc4d8$export$fb699d9076441ae7);

var $5uXOq = parcelRequire("5uXOq");

var $hWg7l = parcelRequire("hWg7l");
const $d940bdf671fdc4d8$export$1a85343b4dbf3bf5 = (...[request, controller, options])=>{
    const [state, setState] = (0, $5uXOq.useState)({
        loading: false,
        error: undefined,
        data: undefined,
        ...options?.initialState
    });
    const getData = (0, $5uXOq.useCallback)(async ()=>{
        setState((s)=>({
                ...s,
                loading: true
            }));
        try {
            const response = await request();
            const traceId = response?.headers?.get('atl-traceid');
            let jsonResponse;
            let isResponseText = false;
            const resText = await response?.text() || '{}';
            try {
                jsonResponse = JSON.parse(resText);
            } catch  {
                isResponseText = true;
            }
            if (!response?.ok || isResponseText) {
                if (options?.ErrorHandler) throw new options.ErrorHandler({
                    ...jsonResponse,
                    traceId: traceId,
                    status: response?.status,
                    statusText: response?.statusText || resText
                });
                else throw new (0, $hWg7l.HttpError)(response?.status, response?.statusText || resText, traceId);
            }
            setState((s)=>({
                    ...s,
                    loading: false,
                    data: jsonResponse
                }));
            return response;
        } catch (error) {
            setState((s)=>({
                    ...s,
                    loading: false,
                    error: error
                }));
        }
    }, [
        request,
        options?.ErrorHandler
    ]);
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            controller.abort();
        };
    }, [
        controller
    ]);
    return [
        getData,
        state
    ];
};
const $d940bdf671fdc4d8$export$6de4685a6c88b4e9 = (...[request, controller, options])=>{
    const [getData, state] = $d940bdf671fdc4d8$export$1a85343b4dbf3bf5(request, controller, {
        ...options,
        initialState: {
            ...options?.initialState,
            loading: true
        }
    });
    (0, $5uXOq.useEffect)(()=>{
        getData();
    }, [
        getData
    ]);
    return state;
};
const $d940bdf671fdc4d8$export$fb699d9076441ae7 = (request, initialState = {})=>{
    const [state, setStateRaw] = (0, $5uXOq.useState)({
        loading: false,
        ...initialState
    });
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    });
    const setState = (0, $5uXOq.useCallback)((state)=>{
        if (isMounted.current) setStateRaw(state);
    }, []);
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request();
            setState({
                loading: false,
                error: undefined,
                data: data
            });
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
        }
    }, [
        request,
        setState
    ]);
    return {
        ...state,
        fetchData: fetchData
    };
};

});
parcelRegister("hWg7l", function(module, exports) {

$parcel$export(module.exports, "requestWithAbort", () => $6cb7a34e48e10289$export$970d18814fa0cb04);
$parcel$export(module.exports, "HttpError", () => $6cb7a34e48e10289$export$65bd6083489bd8bb);

var $b4HwW = parcelRequire("b4HwW");
const $6cb7a34e48e10289$export$b5fe3f66a567bec0 = (url, options = {})=>()=>fetch(url, {
            method: 'POST',
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            ...options
        });
const $6cb7a34e48e10289$export$970d18814fa0cb04 = (url, options = {})=>{
    const controller = new (0, $b4HwW.AbortControllerFacade)();
    return [
        $6cb7a34e48e10289$export$b5fe3f66a567bec0(url, {
            signal: controller.signal,
            ...options
        }),
        controller
    ];
};
class $6cb7a34e48e10289$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = code;
        this.traceId = traceId;
    }
}

});
parcelRegister("b4HwW", function(module, exports) {

$parcel$export(module.exports, "AbortControllerFacade", () => $51c84ee29141b5c0$export$f5cffffa581a7d2c);
class $51c84ee29141b5c0$var$AbortSignalFacade {
    constructor(){
        this.aborted = false;
        this.reason = '';
        this.onabort = ()=>{};
        this.throwIfAborted = ()=>{};
        this.addEventListener = ()=>{};
        this.removeEventListener = ()=>{};
        this.dispatchEvent = ()=>false;
    }
}
class $51c84ee29141b5c0$export$f5cffffa581a7d2c {
    abort() {}
    constructor(){
        this.signal = new $51c84ee29141b5c0$var$AbortSignalFacade();
        if (typeof window === 'object' && window.AbortController) {
            const controller = new AbortController();
            this.abort = controller.abort.bind(controller);
            this.signal = controller.signal;
        }
    }
}

});



parcelRegister("gU7a6", function(module, exports) {

$parcel$export(module.exports, "defaultRequestAbort", () => $922ec61540658700$export$46f584bffbc74fe);

var $hWg7l = parcelRequire("hWg7l");
const $922ec61540658700$export$5cf469f83bcf3f9e = '/gateway/api/permissions/permitted';
const $922ec61540658700$export$fcd6a587480f569c = (cloudId)=>({
        permissionId: 'write',
        resourceId: `ari:cloud:jira-software::site/${cloudId}`
    });
const $922ec61540658700$export$46f584bffbc74fe = (cloudId)=>cloudId ? (0, $hWg7l.requestWithAbort)($922ec61540658700$export$5cf469f83bcf3f9e, {
        body: JSON.stringify($922ec61540658700$export$fcd6a587480f569c(cloudId))
    }) : [
        ()=>Promise.resolve(new Response()),
        new AbortController()
    ];

});


parcelRegister("3gj6A", function(module, exports) {

$parcel$export(module.exports, "TeamsWrapper", () => $46908e0c41cd0d07$export$7d5cea3023a4360c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dAEoS = parcelRequire("dAEoS");

var $a90bU = parcelRequire("a90bU");

var $7UizO = parcelRequire("7UizO");

var $dTB35 = parcelRequire("dTB35");

var $32gz8 = parcelRequire("32gz8");

var $5gk7V = parcelRequire("5gk7V");
const $46908e0c41cd0d07$var$IS_LOCAL = false;
function $46908e0c41cd0d07$export$7d5cea3023a4360c({ children: children, appConfig: appConfig }) {
    (0, $7UizO.useTeamsSentryClientSetup)(!$46908e0c41cd0d07$var$IS_LOCAL, {
        env: appConfig.env,
        appName: appConfig.appName ? `${appConfig.appName}` : undefined
    });
    (0, $dTB35.useSetAppConfig)(appConfig);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $32gz8.AppConfigProvider), {
        ...appConfig,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5gk7V.ProfileCardClientConfigProvider), {
            ...appConfig,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dAEoS.PeopleTeamsAnalyticsProvider), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a90bU.DialogProvider), {
                    children: children
                })
            })
        })
    });
}

});
parcelRegister("dAEoS", function(module, exports) {

$parcel$export(module.exports, "PeopleTeamsAnalyticsProvider", () => $3332fc5d426b8deb$export$2776b3e0720ed6df);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cnhic = parcelRequire("cnhic");
const $3332fc5d426b8deb$var$defaultAnalyticsContextData = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $3332fc5d426b8deb$export$2776b3e0720ed6df({ analyticsContextData: analyticsContextData, children: children }) {
    const data = (0, $5uXOq.useMemo)(()=>{
        if (typeof analyticsContextData === 'object') return {
            ...$3332fc5d426b8deb$var$defaultAnalyticsContextData,
            ...analyticsContextData
        };
        return $3332fc5d426b8deb$var$defaultAnalyticsContextData;
    }, [
        analyticsContextData
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cnhic.PeopleTeamsAnalyticsContext), {
        data: data,
        children: children
    });
}

});

parcelRegister("a90bU", function(module, exports) {

$parcel$export(module.exports, "DialogProvider", () => $e491906d97dd713c$export$7ab5cfe96fae86d3);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kW74I = parcelRequire("kW74I");

var $3M66s = parcelRequire("3M66s");
const $e491906d97dd713c$var$dialogProviderReducer = (state, action)=>{
    switch(action.type){
        case 'open':
            return {
                ...state,
                DialogComponent: action.payload?.DialogComponent || null,
                isOpen: true
            };
        case 'close':
            return {
                ...state,
                DialogComponent: null,
                dialogProps: null,
                isOpen: false
            };
        default:
            throw new Error(`Unhandled type for dialogReducer: ${action.type}`);
    }
};
const $e491906d97dd713c$export$b52337b35cd3c980 = (props)=>{
    const { DialogComponent: DialogComponent, isOpen: isOpen, onClose: onClose } = props;
    const { closeDialog: closeDialog } = (0, $5uXOq.useContext)((0, $3M66s.DialogContext));
    if (!DialogComponent) return null;
    const handleCloseDialog = ()=>{
        closeDialog();
        if (onClose) onClose();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kW74I.default), {
        children: isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(DialogComponent, {
            onClose: handleCloseDialog
        })
    });
};
const $e491906d97dd713c$export$7ab5cfe96fae86d3 = ({ children: children })=>{
    const [dialogProviderState, dispatch] = (0, $5uXOq.useReducer)($e491906d97dd713c$var$dialogProviderReducer, {
        DialogComponent: null,
        isOpen: false
    });
    const value = (0, $5uXOq.useMemo)(()=>({
            openDialog: (DialogComponent)=>dispatch({
                    type: 'open',
                    payload: {
                        DialogComponent: DialogComponent
                    }
                }),
            closeDialog: ()=>dispatch({
                    type: 'close'
                })
        }), []);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3M66s.DialogContext).Provider, {
        value: value,
        children: [
            children,
            /*#__PURE__*/ (0, $2OMIu.jsx)($e491906d97dd713c$export$b52337b35cd3c980, {
                ...dialogProviderState
            })
        ]
    });
};

});
parcelRegister("3M66s", function(module, exports) {

$parcel$export(module.exports, "DialogContext", () => $8f3b2ad28ecdbbe0$export$8b93a07348a7730c);

var $5uXOq = parcelRequire("5uXOq");
const $8f3b2ad28ecdbbe0$export$8b93a07348a7730c = (0, $5uXOq.createContext)({
    openDialog: ()=>null,
    closeDialog: ()=>null
});

});


parcelRegister("7UizO", function(module, exports) {

$parcel$export(module.exports, "useTeamsSentryClientSetup", () => $161a0d4e6ec70589$export$e30f49f36a0eeaeb);

var $5uXOq = parcelRequire("5uXOq");

var $chKb5 = parcelRequire("chKb5");
const $161a0d4e6ec70589$export$e30f49f36a0eeaeb = (isSentryEnabled, config)=>{
    const [sentryInitialised, setSentryInitialised] = (0, $5uXOq.useState)(false);
    const setupSentry = (0, $5uXOq.useCallback)(async ()=>{
        if (!sentryInitialised && isSentryEnabled && !(0, $chKb5.sentryClient)) await (0, $chKb5.setupSentryClient)(config);
    }, [
        config,
        isSentryEnabled,
        sentryInitialised
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setupSentry().then(()=>setSentryInitialised(true));
    }, [
        setupSentry
    ]);
    return 0, $chKb5.sentryClient;
};

});

parcelRegister("dTB35", function(module, exports) {

$parcel$export(module.exports, "useSetAppConfig", () => $66b2ac30f9bee9fd$export$338e93cfada2e9d7);

var $e4Jb1 = parcelRequire("e4Jb1");

var $ckH8r = parcelRequire("ckH8r");

var $dQxVk = parcelRequire("dQxVk");
const $66b2ac30f9bee9fd$export$338e93cfada2e9d7 = (appConfig)=>{
    (0, $e4Jb1.useSetClientConfig)({
        cloudId: appConfig.cloudId,
        stargateRoot: appConfig.stargateRoot,
        env: appConfig.env,
        orgId: appConfig.orgId,
        principalUserId: appConfig.principalUserId
    });
    (0, $dQxVk.useSetTeamsProductConfig)({
        appName: appConfig.appName,
        productName: appConfig.productName,
        isJiraAvailable: appConfig.isJiraAvailable,
        subProduct: appConfig.subProduct,
        locale: appConfig.locale,
        productFeatureFlags: appConfig.productFeatureFlags
    });
    (0, $ckH8r.useSetTeamsNavigationConfig)({
        contextSpaPaths: appConfig.contextSpaPaths,
        contextEntryPoint: appConfig.contextEntryPoint
    });
};

});
parcelRegister("e4Jb1", function(module, exports) {

$parcel$export(module.exports, "useSetClientConfig", () => $da7f995e38b6a748$export$2f68760d90a1443f);

var $5uXOq = parcelRequire("5uXOq");

var $hgx8x = parcelRequire("hgx8x");

var $5v5PA = parcelRequire("5v5PA");
const $da7f995e38b6a748$export$2f68760d90a1443f = (clientConfig)=>{
    const { setClientConfig: setClientConfig } = (0, $5v5PA.useSetTeamsConfigActions)();
    (0, $hgx8x.useTeamsClientSetupNext)({
        stargateRoot: clientConfig.stargateRoot,
        cloudId: clientConfig.cloudId,
        orgId: clientConfig.orgId,
        principalUserId: clientConfig.principalUserId
    });
    (0, $5uXOq.useEffect)(()=>{
        setClientConfig(clientConfig);
    }, [
        setClientConfig,
        clientConfig
    ]);
};

});
parcelRegister("hgx8x", function(module, exports) {

$parcel$export(module.exports, "useTeamsClientSetupNext", () => $019e9154dd0f7ed7$export$5eae9f59196893ac);

var $5uXOq = parcelRequire("5uXOq");

var $2Ixyh = parcelRequire("2Ixyh");

var $jP0Fy = parcelRequire("jP0Fy");
const $019e9154dd0f7ed7$export$50a3d4f5c944b117 = (stargateRoot, cloudId, orgId, principalUserId)=>{
    $019e9154dd0f7ed7$export$5eae9f59196893ac({
        stargateRoot: stargateRoot,
        cloudId: cloudId,
        orgId: orgId,
        principalUserId: principalUserId
    });
};
const $019e9154dd0f7ed7$export$5eae9f59196893ac = ({ stargateRoot: stargateRoot, cloudId: cloudId, orgId: orgId, principalUserId: principalUserId })=>{
    (0, $5uXOq.useEffect)(()=>{
        if (!stargateRoot) return;
        (0, $2Ixyh.teamsClient).setBaseUrl(stargateRoot);
    }, [
        stargateRoot
    ]);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2Ixyh.teamsClient).setContext({
            cloudId: cloudId,
            orgId: orgId,
            userId: principalUserId
        });
        if (!orgId) (0, $jP0Fy.logInfoMessage)(`No orgId set - useTeamsClientSetup`, {
            cloudId: cloudId
        });
    }, [
        cloudId,
        orgId,
        principalUserId
    ]);
};

});

parcelRegister("5v5PA", function(module, exports) {

$parcel$export(module.exports, "useAppConfigStoreState", () => $3671d48bb0d77e8b$export$ace1f350f4f044c0);
$parcel$export(module.exports, "useSetTeamsConfigActions", () => $3671d48bb0d77e8b$export$b652cf4936246835);
$parcel$export(module.exports, "useNavigationState", () => $3671d48bb0d77e8b$export$e482f4662aebc4a0);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $3671d48bb0d77e8b$var$defaultNavigationState = {
    contextSpaPaths: [],
    contextEntryPoint: null
};
const $3671d48bb0d77e8b$var$defaultClientConfigState = {
    cloudId: null,
    stargateRoot: '',
    env: undefined
};
const $3671d48bb0d77e8b$var$defaultTeamsProductConfigState = {
    appName: null,
    productName: null,
    isJiraAvailable: false
};
const $3671d48bb0d77e8b$var$defaultState = {
    ...$3671d48bb0d77e8b$var$defaultNavigationState,
    ...$3671d48bb0d77e8b$var$defaultClientConfigState,
    ...$3671d48bb0d77e8b$var$defaultTeamsProductConfigState,
    docTitle: {}
};
const $3671d48bb0d77e8b$var$actions = {
    setNavigationConfig: (navigationConfig)=>({ setState: setState })=>{
            setState({
                ...navigationConfig
            });
        },
    setClientConfig: (clientConfig)=>({ setState: setState })=>{
            setState({
                ...clientConfig
            });
        },
    setTeamsProductConfig: (teamsProductConfig)=>({ setState: setState })=>{
            setState({
                ...teamsProductConfig
            });
        },
    // Set all config at once
    setAppConfig: (appConfig)=>({ setState: setState })=>{
            setState({
                ...appConfig
            });
        }
};
const $3671d48bb0d77e8b$var$AppConfigStore = (0, $iXqE5.createStore)({
    initialState: $3671d48bb0d77e8b$var$defaultState,
    actions: $3671d48bb0d77e8b$var$actions
});
const $3671d48bb0d77e8b$export$61884cfbde7fd829 = (0, $3sQ5x.createHook)($3671d48bb0d77e8b$var$AppConfigStore);
const $3671d48bb0d77e8b$var$useAppConfigActions = (0, $3sQ5x.createHook)($3671d48bb0d77e8b$var$AppConfigStore, {
    selector: null
});
const $3671d48bb0d77e8b$export$ace1f350f4f044c0 = ()=>$3671d48bb0d77e8b$export$61884cfbde7fd829()[0];
const $3671d48bb0d77e8b$export$b652cf4936246835 = ()=>{
    return $3671d48bb0d77e8b$var$useAppConfigActions()[1];
};
const $3671d48bb0d77e8b$export$7b278989f04c1040 = ()=>$3671d48bb0d77e8b$export$ace1f350f4f044c0().appName;
const $3671d48bb0d77e8b$export$e482f4662aebc4a0 = ()=>{
    const { contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint } = $3671d48bb0d77e8b$export$ace1f350f4f044c0();
    return {
        contextSpaPaths: contextSpaPaths,
        contextEntryPoint: contextEntryPoint
    };
};

});


parcelRegister("ckH8r", function(module, exports) {

$parcel$export(module.exports, "useSetTeamsNavigationConfig", () => $fde35075be6d7e2f$export$254030771a907fca);

var $5uXOq = parcelRequire("5uXOq");

var $5v5PA = parcelRequire("5v5PA");
const $fde35075be6d7e2f$export$254030771a907fca = (config)=>{
    const { setNavigationConfig: setNavigationConfig } = (0, $5v5PA.useSetTeamsConfigActions)();
    (0, $5uXOq.useEffect)(()=>{
        setNavigationConfig(config);
    }, [
        setNavigationConfig,
        config
    ]);
};

});

parcelRegister("dQxVk", function(module, exports) {

$parcel$export(module.exports, "useSetTeamsProductConfig", () => $28d4b1419fbdb901$export$f8296902b02e4ba1);

var $5uXOq = parcelRequire("5uXOq");

var $5v5PA = parcelRequire("5v5PA");
const $28d4b1419fbdb901$export$f8296902b02e4ba1 = (teamsProductConfig)=>{
    const { setTeamsProductConfig: setTeamsProductConfig } = (0, $5v5PA.useSetTeamsConfigActions)();
    (0, $5uXOq.useEffect)(()=>{
        setTeamsProductConfig(teamsProductConfig);
    }, [
        setTeamsProductConfig,
        teamsProductConfig
    ]);
};

});


parcelRegister("32gz8", function(module, exports) {

$parcel$export(module.exports, "AppConfigProvider", () => $734f2ff4d9532de5$export$42f491f31057ae78);
$parcel$export(module.exports, "useNavigationActions", () => $734f2ff4d9532de5$export$d52b0df9de5d0e40);
$parcel$export(module.exports, "useAddFlag", () => $734f2ff4d9532de5$export$6d75236f0e3dc17e);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lKWu8 = parcelRequire("lKWu8");

var $4J9cG = parcelRequire("4J9cG");

var $5v5PA = parcelRequire("5v5PA");
const $734f2ff4d9532de5$var$error = new Error('AppConfig is not setup in RSS');
const $734f2ff4d9532de5$var$defaultValue = {
    push: ()=>{
        throw $734f2ff4d9532de5$var$error;
    },
    replace: ()=>{
        throw $734f2ff4d9532de5$var$error;
    },
    addFlag: ()=>{
        throw $734f2ff4d9532de5$var$error;
    }
};
const $734f2ff4d9532de5$var$AppConfigContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($734f2ff4d9532de5$var$defaultValue);
function $734f2ff4d9532de5$export$42f491f31057ae78({ children: children, push: pushProp, replace: replaceProp, addFlag: addFlagProp }) {
    const { contextEntryPoint: contextEntryPoint } = (0, $5v5PA.useNavigationState)();
    const addFlag = (0, $5uXOq.useCallback)((props)=>{
        const { type: type, ...rest } = props;
        addFlagProp({
            ...rest,
            id: rest.id ? `${rest.id}.${Date.now()}` : Date.now(),
            type: type,
            appearance: 'normal',
            icon: (0, $lKWu8.getTypeIcon)(type)
        });
    }, [
        addFlagProp
    ]);
    const push = (0, $5uXOq.useCallback)((path)=>{
        const finalPath = (0, $4J9cG.prefixWithContextEntryPoint)(path, contextEntryPoint);
        return pushProp(finalPath);
    }, [
        pushProp,
        contextEntryPoint
    ]);
    const replace = (0, $5uXOq.useCallback)((path)=>{
        const finalPath = (0, $4J9cG.prefixWithContextEntryPoint)(path, contextEntryPoint);
        return replaceProp(finalPath);
    }, [
        contextEntryPoint,
        replaceProp
    ]);
    const configValue = (0, $5uXOq.useMemo)(()=>({
            addFlag: addFlag,
            push: push,
            replace: replace
        }), [
        addFlag,
        push,
        replace
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($734f2ff4d9532de5$var$AppConfigContext.Provider, {
        value: configValue,
        children: children
    });
}
const $734f2ff4d9532de5$var$useAppConfigProvider = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext($734f2ff4d9532de5$var$AppConfigContext);
const $734f2ff4d9532de5$export$d52b0df9de5d0e40 = ()=>{
    const { push: push, replace: replace } = $734f2ff4d9532de5$var$useAppConfigProvider();
    return {
        push: push,
        replace: replace
    };
};
const $734f2ff4d9532de5$export$6d75236f0e3dc17e = ()=>{
    const { addFlag: addFlag } = $734f2ff4d9532de5$var$useAppConfigProvider();
    return addFlag;
};

});
parcelRegister("lKWu8", function(module, exports) {

$parcel$export(module.exports, "getTypeIcon", () => $a6d1f6ee1e882727$export$672f92b0d52b7cfe);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5E93O = parcelRequire("5E93O");

var $bMdrA = parcelRequire("bMdrA");

var $85eFT = parcelRequire("85eFT");

const $a6d1f6ee1e882727$var$flagIconByType = {
    error: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
        spacing: "spacious",
        label: "",
        color: `var(--ds-icon-danger, ${(0, $a7f8c6b391092279$export$4a7404f376229999)})`
    }),
    warning: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($85eFT))), {
        spacing: "spacious",
        label: "",
        color: `var(--ds-icon-warning, ${(0, $a7f8c6b391092279$export$c6930421db9fa514)})`
    })
};
const $a6d1f6ee1e882727$var$DefaultIcon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bMdrA))), {
    spacing: "spacious",
    label: "",
    color: `var(--ds-icon-success, ${(0, $a7f8c6b391092279$export$940e1f69e873f202)})`
});
const $a6d1f6ee1e882727$export$672f92b0d52b7cfe = (type = 'normal')=>$a6d1f6ee1e882727$var$flagIconByType[type] || $a6d1f6ee1e882727$var$DefaultIcon;

});
var $a7f8c6b391092279$exports = {};

$parcel$export($a7f8c6b391092279$exports, "R50", () => $a7f8c6b391092279$export$4b84fd0e2c617bd);
$parcel$export($a7f8c6b391092279$exports, "R75", () => $a7f8c6b391092279$export$b34b069eff244586);
$parcel$export($a7f8c6b391092279$exports, "R100", () => $a7f8c6b391092279$export$be802dd0d8b57f35);
$parcel$export($a7f8c6b391092279$exports, "R200", () => $a7f8c6b391092279$export$60847d42f9da92a6);
$parcel$export($a7f8c6b391092279$exports, "R300", () => $a7f8c6b391092279$export$4a7404f376229999);
$parcel$export($a7f8c6b391092279$exports, "R400", () => $a7f8c6b391092279$export$2010d0fb4295b346);
$parcel$export($a7f8c6b391092279$exports, "R500", () => $a7f8c6b391092279$export$2837b5a1a71d5c02);
$parcel$export($a7f8c6b391092279$exports, "Y50", () => $a7f8c6b391092279$export$8d9596b529bbb9cf);
$parcel$export($a7f8c6b391092279$exports, "Y75", () => $a7f8c6b391092279$export$41060a744ab0b7ae);
$parcel$export($a7f8c6b391092279$exports, "Y100", () => $a7f8c6b391092279$export$1cc05bbbf340e559);
$parcel$export($a7f8c6b391092279$exports, "Y200", () => $a7f8c6b391092279$export$5aae31392d72caaa);
$parcel$export($a7f8c6b391092279$exports, "Y300", () => $a7f8c6b391092279$export$c6930421db9fa514);
$parcel$export($a7f8c6b391092279$exports, "Y400", () => $a7f8c6b391092279$export$59619663aa6500fb);
$parcel$export($a7f8c6b391092279$exports, "Y500", () => $a7f8c6b391092279$export$874739ea9e379ab6);
$parcel$export($a7f8c6b391092279$exports, "G50", () => $a7f8c6b391092279$export$8a6341c32b6a3ee6);
$parcel$export($a7f8c6b391092279$exports, "G75", () => $a7f8c6b391092279$export$69a3bf21b9686c2b);
$parcel$export($a7f8c6b391092279$exports, "G100", () => $a7f8c6b391092279$export$afbce1382ec95f73);
$parcel$export($a7f8c6b391092279$exports, "G200", () => $a7f8c6b391092279$export$747d86715d4175de);
$parcel$export($a7f8c6b391092279$exports, "G300", () => $a7f8c6b391092279$export$940e1f69e873f202);
$parcel$export($a7f8c6b391092279$exports, "G400", () => $a7f8c6b391092279$export$a49394138f7b8e85);
$parcel$export($a7f8c6b391092279$exports, "G500", () => $a7f8c6b391092279$export$6fa04827ac68a4fb);
$parcel$export($a7f8c6b391092279$exports, "B50", () => $a7f8c6b391092279$export$226de0355ed012f8);
$parcel$export($a7f8c6b391092279$exports, "B75", () => $a7f8c6b391092279$export$8c13c2ee36917869);
$parcel$export($a7f8c6b391092279$exports, "B100", () => $a7f8c6b391092279$export$ecfc1dff386a3e7a);
$parcel$export($a7f8c6b391092279$exports, "B200", () => $a7f8c6b391092279$export$215b7063051591f1);
$parcel$export($a7f8c6b391092279$exports, "B300", () => $a7f8c6b391092279$export$e62e8919cca44969);
$parcel$export($a7f8c6b391092279$exports, "B400", () => $a7f8c6b391092279$export$b3de0ae08da2ce64);
$parcel$export($a7f8c6b391092279$exports, "B500", () => $a7f8c6b391092279$export$a6ee3d71bc067634);
$parcel$export($a7f8c6b391092279$exports, "B600", () => $a7f8c6b391092279$export$67f15409e87642a1);
$parcel$export($a7f8c6b391092279$exports, "B700", () => $a7f8c6b391092279$export$f0539dbc42dbb067);
$parcel$export($a7f8c6b391092279$exports, "P50", () => $a7f8c6b391092279$export$363e4475840015bb);
$parcel$export($a7f8c6b391092279$exports, "P75", () => $a7f8c6b391092279$export$4b0a4417ed59760f);
$parcel$export($a7f8c6b391092279$exports, "P100", () => $a7f8c6b391092279$export$6011520a64d9a187);
$parcel$export($a7f8c6b391092279$exports, "P200", () => $a7f8c6b391092279$export$a7175d4e9206bc80);
$parcel$export($a7f8c6b391092279$exports, "P300", () => $a7f8c6b391092279$export$b48405b95304b5a1);
$parcel$export($a7f8c6b391092279$exports, "P400", () => $a7f8c6b391092279$export$c71e4279dd54a18d);
$parcel$export($a7f8c6b391092279$exports, "P500", () => $a7f8c6b391092279$export$147899de772240ec);
$parcel$export($a7f8c6b391092279$exports, "T50", () => $a7f8c6b391092279$export$2cf711fe14c66f06);
$parcel$export($a7f8c6b391092279$exports, "T75", () => $a7f8c6b391092279$export$7a8f4d33f6f9772c);
$parcel$export($a7f8c6b391092279$exports, "T100", () => $a7f8c6b391092279$export$776c9c497ef08533);
$parcel$export($a7f8c6b391092279$exports, "T200", () => $a7f8c6b391092279$export$69cb3ca10c1e330e);
$parcel$export($a7f8c6b391092279$exports, "T300", () => $a7f8c6b391092279$export$9dc1ef0f3f48059b);
$parcel$export($a7f8c6b391092279$exports, "T400", () => $a7f8c6b391092279$export$7c835c78b6fcdef8);
$parcel$export($a7f8c6b391092279$exports, "T500", () => $a7f8c6b391092279$export$6036577f95c3877e);
$parcel$export($a7f8c6b391092279$exports, "N0", () => $a7f8c6b391092279$export$29a4f05edc054374);
$parcel$export($a7f8c6b391092279$exports, "N10", () => $a7f8c6b391092279$export$e655ef011c4aa1a2);
$parcel$export($a7f8c6b391092279$exports, "N20", () => $a7f8c6b391092279$export$9fdfb749e33cdf97);
$parcel$export($a7f8c6b391092279$exports, "N30", () => $a7f8c6b391092279$export$3e51e8f1440314ba);
$parcel$export($a7f8c6b391092279$exports, "N40", () => $a7f8c6b391092279$export$1ce2d1575d444ceb);
$parcel$export($a7f8c6b391092279$exports, "N50", () => $a7f8c6b391092279$export$8754fc7e6d8b3000);
$parcel$export($a7f8c6b391092279$exports, "N60", () => $a7f8c6b391092279$export$c2e91cbeada39b8b);
$parcel$export($a7f8c6b391092279$exports, "N70", () => $a7f8c6b391092279$export$5f71e19f3a7ad9de);
$parcel$export($a7f8c6b391092279$exports, "N80", () => $a7f8c6b391092279$export$eaa8c8a70ac22806);
$parcel$export($a7f8c6b391092279$exports, "N90", () => $a7f8c6b391092279$export$7c87d337fb91a97d);
$parcel$export($a7f8c6b391092279$exports, "N100", () => $a7f8c6b391092279$export$d6447c357493214f);
$parcel$export($a7f8c6b391092279$exports, "N200", () => $a7f8c6b391092279$export$f563ee71e9ee74cd);
$parcel$export($a7f8c6b391092279$exports, "N300", () => $a7f8c6b391092279$export$e2ef2124cf4024b1);
$parcel$export($a7f8c6b391092279$exports, "N400", () => $a7f8c6b391092279$export$eece5f492e429f08);
$parcel$export($a7f8c6b391092279$exports, "N500", () => $a7f8c6b391092279$export$c39c0fe0f26207ae);
$parcel$export($a7f8c6b391092279$exports, "N600", () => $a7f8c6b391092279$export$7090862dc3038a9f);
$parcel$export($a7f8c6b391092279$exports, "N700", () => $a7f8c6b391092279$export$ad0bacf983b7ddaa);
$parcel$export($a7f8c6b391092279$exports, "N800", () => $a7f8c6b391092279$export$7d61b15e0da132af);
$parcel$export($a7f8c6b391092279$exports, "N900", () => $a7f8c6b391092279$export$fbda843f0a27fe96);
$parcel$export($a7f8c6b391092279$exports, "N10A", () => $a7f8c6b391092279$export$791e57b27ca738ef);
$parcel$export($a7f8c6b391092279$exports, "N20A", () => $a7f8c6b391092279$export$8d43898f60b96a82);
$parcel$export($a7f8c6b391092279$exports, "N30A", () => $a7f8c6b391092279$export$920c0d5c49070351);
$parcel$export($a7f8c6b391092279$exports, "N40A", () => $a7f8c6b391092279$export$46987b49aab6d1a8);
$parcel$export($a7f8c6b391092279$exports, "N50A", () => $a7f8c6b391092279$export$7d3359664e8bb0e5);
$parcel$export($a7f8c6b391092279$exports, "N60A", () => $a7f8c6b391092279$export$d2d3bedfb276cac0);
$parcel$export($a7f8c6b391092279$exports, "N70A", () => $a7f8c6b391092279$export$6e5e7499ff054f6d);
$parcel$export($a7f8c6b391092279$exports, "N80A", () => $a7f8c6b391092279$export$59264b346c877fa7);
$parcel$export($a7f8c6b391092279$exports, "N90A", () => $a7f8c6b391092279$export$d092757d7c64925c);
$parcel$export($a7f8c6b391092279$exports, "N100A", () => $a7f8c6b391092279$export$486ab785e4bac3c6);
$parcel$export($a7f8c6b391092279$exports, "N200A", () => $a7f8c6b391092279$export$fba592bbc6419fea);
$parcel$export($a7f8c6b391092279$exports, "N300A", () => $a7f8c6b391092279$export$13609db0e6812ab8);
$parcel$export($a7f8c6b391092279$exports, "N400A", () => $a7f8c6b391092279$export$fbae4efaa892d883);
$parcel$export($a7f8c6b391092279$exports, "N500A", () => $a7f8c6b391092279$export$f13946d26f440ce6);
$parcel$export($a7f8c6b391092279$exports, "N600A", () => $a7f8c6b391092279$export$19f58225ac52a306);
$parcel$export($a7f8c6b391092279$exports, "N700A", () => $a7f8c6b391092279$export$6384f09da70e7b62);
$parcel$export($a7f8c6b391092279$exports, "N800A", () => $a7f8c6b391092279$export$d0dccc730683edc2);
$parcel$export($a7f8c6b391092279$exports, "DN900", () => $a7f8c6b391092279$export$2f6319cf7d736c2a);
$parcel$export($a7f8c6b391092279$exports, "DN800", () => $a7f8c6b391092279$export$95126bc8884d6634);
$parcel$export($a7f8c6b391092279$exports, "DN700", () => $a7f8c6b391092279$export$8338d8c35d44ff1);
$parcel$export($a7f8c6b391092279$exports, "DN600", () => $a7f8c6b391092279$export$5368d76ae4fbbda7);
$parcel$export($a7f8c6b391092279$exports, "DN500", () => $a7f8c6b391092279$export$9f0a771d16ec8d36);
$parcel$export($a7f8c6b391092279$exports, "DN400", () => $a7f8c6b391092279$export$abcf8c38338b4aa5);
$parcel$export($a7f8c6b391092279$exports, "DN300", () => $a7f8c6b391092279$export$97e81faa16a182c7);
$parcel$export($a7f8c6b391092279$exports, "DN200", () => $a7f8c6b391092279$export$bfe21c59123ecf33);
$parcel$export($a7f8c6b391092279$exports, "DN100", () => $a7f8c6b391092279$export$ee82aa2ea6a1558);
$parcel$export($a7f8c6b391092279$exports, "DN90", () => $a7f8c6b391092279$export$682927c6ed76be02);
$parcel$export($a7f8c6b391092279$exports, "DN80", () => $a7f8c6b391092279$export$91fd9994c5be9757);
$parcel$export($a7f8c6b391092279$exports, "DN70", () => $a7f8c6b391092279$export$d281fbfe3cff2df6);
$parcel$export($a7f8c6b391092279$exports, "DN60", () => $a7f8c6b391092279$export$3902c91d8b98a753);
$parcel$export($a7f8c6b391092279$exports, "DN50", () => $a7f8c6b391092279$export$8e8133c1ba5845b5);
$parcel$export($a7f8c6b391092279$exports, "DN40", () => $a7f8c6b391092279$export$33ff357f6620b39);
$parcel$export($a7f8c6b391092279$exports, "DN30", () => $a7f8c6b391092279$export$633847cf062b69e0);
$parcel$export($a7f8c6b391092279$exports, "DN20", () => $a7f8c6b391092279$export$9776a6e503bdbf76);
$parcel$export($a7f8c6b391092279$exports, "DN10", () => $a7f8c6b391092279$export$6c813d5160dff5db);
$parcel$export($a7f8c6b391092279$exports, "DN0", () => $a7f8c6b391092279$export$3d4f271a500072a);
$parcel$export($a7f8c6b391092279$exports, "DN800A", () => $a7f8c6b391092279$export$fe151285c22759ec);
$parcel$export($a7f8c6b391092279$exports, "DN700A", () => $a7f8c6b391092279$export$a101c6190d0da34);
$parcel$export($a7f8c6b391092279$exports, "DN600A", () => $a7f8c6b391092279$export$4b16f52932fda51);
$parcel$export($a7f8c6b391092279$exports, "DN500A", () => $a7f8c6b391092279$export$a74bcd7b9845b0d8);
$parcel$export($a7f8c6b391092279$exports, "DN400A", () => $a7f8c6b391092279$export$9209c179316d1751);
$parcel$export($a7f8c6b391092279$exports, "DN300A", () => $a7f8c6b391092279$export$88f55133f636c8dd);
$parcel$export($a7f8c6b391092279$exports, "DN200A", () => $a7f8c6b391092279$export$51126f85d1009512);
$parcel$export($a7f8c6b391092279$exports, "DN100A", () => $a7f8c6b391092279$export$a069b547bd23af78);
$parcel$export($a7f8c6b391092279$exports, "DN90A", () => $a7f8c6b391092279$export$40cce05af3b2600a);
$parcel$export($a7f8c6b391092279$exports, "DN80A", () => $a7f8c6b391092279$export$b78942185925a0d);
$parcel$export($a7f8c6b391092279$exports, "DN70A", () => $a7f8c6b391092279$export$e058fb44b8eaafca);
$parcel$export($a7f8c6b391092279$exports, "DN60A", () => $a7f8c6b391092279$export$92b0b8de26920c18);
$parcel$export($a7f8c6b391092279$exports, "DN50A", () => $a7f8c6b391092279$export$67564f7459d3fc9e);
$parcel$export($a7f8c6b391092279$exports, "DN40A", () => $a7f8c6b391092279$export$77868e1ca884ffa3);
$parcel$export($a7f8c6b391092279$exports, "DN30A", () => $a7f8c6b391092279$export$2afd71d7d3ea2cd5);
$parcel$export($a7f8c6b391092279$exports, "DN20A", () => $a7f8c6b391092279$export$f2a0acaab9972c70);
$parcel$export($a7f8c6b391092279$exports, "DN10A", () => $a7f8c6b391092279$export$9ab70e67d6475361);
$parcel$export($a7f8c6b391092279$exports, "T30", () => $a7f8c6b391092279$export$d2adc5dedf09fced);
$parcel$export($a7f8c6b391092279$exports, "L50", () => $a7f8c6b391092279$export$f51762073d2bb381);
$parcel$export($a7f8c6b391092279$exports, "L75", () => $a7f8c6b391092279$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $a7f8c6b391092279$export$4b84fd0e2c617bd = '#FFEBE6';
const $a7f8c6b391092279$export$b34b069eff244586 = '#FFBDAD';
const $a7f8c6b391092279$export$be802dd0d8b57f35 = '#FF8F73';
const $a7f8c6b391092279$export$60847d42f9da92a6 = '#FF7452';
const $a7f8c6b391092279$export$4a7404f376229999 = '#FF5630';
const $a7f8c6b391092279$export$2010d0fb4295b346 = '#DE350B';
const $a7f8c6b391092279$export$2837b5a1a71d5c02 = '#BF2600';
const $a7f8c6b391092279$export$8d9596b529bbb9cf = '#FFFAE6';
const $a7f8c6b391092279$export$41060a744ab0b7ae = '#FFF0B3';
const $a7f8c6b391092279$export$1cc05bbbf340e559 = '#FFE380';
const $a7f8c6b391092279$export$5aae31392d72caaa = '#FFC400';
const $a7f8c6b391092279$export$c6930421db9fa514 = '#FFAB00';
const $a7f8c6b391092279$export$59619663aa6500fb = '#FF991F';
const $a7f8c6b391092279$export$874739ea9e379ab6 = '#FF8B00';
const $a7f8c6b391092279$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $a7f8c6b391092279$export$69a3bf21b9686c2b = '#ABF5D1';
const $a7f8c6b391092279$export$afbce1382ec95f73 = '#79F2C0';
const $a7f8c6b391092279$export$747d86715d4175de = '#57D9A3';
const $a7f8c6b391092279$export$940e1f69e873f202 = '#36B37E';
const $a7f8c6b391092279$export$a49394138f7b8e85 = '#00875A';
const $a7f8c6b391092279$export$6fa04827ac68a4fb = '#006644';
const $a7f8c6b391092279$export$226de0355ed012f8 = '#DEEBFF';
const $a7f8c6b391092279$export$8c13c2ee36917869 = '#B3D4FF';
const $a7f8c6b391092279$export$ecfc1dff386a3e7a = '#4C9AFF';
const $a7f8c6b391092279$export$215b7063051591f1 = '#2684FF';
const $a7f8c6b391092279$export$e62e8919cca44969 = '#0065FF';
const $a7f8c6b391092279$export$b3de0ae08da2ce64 = '#0052CC';
const $a7f8c6b391092279$export$a6ee3d71bc067634 = '#0747A6';
const $a7f8c6b391092279$export$67f15409e87642a1 = '#669DF1';
const $a7f8c6b391092279$export$f0539dbc42dbb067 = '#8FB8F6';
const $a7f8c6b391092279$export$363e4475840015bb = '#EAE6FF';
const $a7f8c6b391092279$export$4b0a4417ed59760f = '#C0B6F2';
const $a7f8c6b391092279$export$6011520a64d9a187 = '#998DD9';
const $a7f8c6b391092279$export$a7175d4e9206bc80 = '#8777D9';
const $a7f8c6b391092279$export$b48405b95304b5a1 = '#6554C0';
const $a7f8c6b391092279$export$c71e4279dd54a18d = '#5243AA';
const $a7f8c6b391092279$export$147899de772240ec = '#403294';
const $a7f8c6b391092279$export$2cf711fe14c66f06 = '#E6FCFF';
const $a7f8c6b391092279$export$7a8f4d33f6f9772c = '#B3F5FF';
const $a7f8c6b391092279$export$776c9c497ef08533 = '#79E2F2';
const $a7f8c6b391092279$export$69cb3ca10c1e330e = '#00C7E6';
const $a7f8c6b391092279$export$9dc1ef0f3f48059b = '#00B8D9';
const $a7f8c6b391092279$export$7c835c78b6fcdef8 = '#00A3BF';
const $a7f8c6b391092279$export$6036577f95c3877e = '#008DA6';
const $a7f8c6b391092279$export$29a4f05edc054374 = '#FFFFFF';
const $a7f8c6b391092279$export$e655ef011c4aa1a2 = '#FAFBFC';
const $a7f8c6b391092279$export$9fdfb749e33cdf97 = '#F4F5F7';
const $a7f8c6b391092279$export$3e51e8f1440314ba = '#EBECF0';
const $a7f8c6b391092279$export$1ce2d1575d444ceb = '#DFE1E6';
const $a7f8c6b391092279$export$8754fc7e6d8b3000 = '#C1C7D0';
const $a7f8c6b391092279$export$c2e91cbeada39b8b = '#B3BAC5';
const $a7f8c6b391092279$export$5f71e19f3a7ad9de = '#A5ADBA';
const $a7f8c6b391092279$export$eaa8c8a70ac22806 = '#97A0AF';
const $a7f8c6b391092279$export$7c87d337fb91a97d = '#8993A4';
const $a7f8c6b391092279$export$d6447c357493214f = '#7A869A';
const $a7f8c6b391092279$export$f563ee71e9ee74cd = '#6B778C';
const $a7f8c6b391092279$export$e2ef2124cf4024b1 = '#5E6C84';
const $a7f8c6b391092279$export$eece5f492e429f08 = '#505F79';
const $a7f8c6b391092279$export$c39c0fe0f26207ae = '#42526E';
const $a7f8c6b391092279$export$7090862dc3038a9f = '#344563';
const $a7f8c6b391092279$export$ad0bacf983b7ddaa = '#253858';
const $a7f8c6b391092279$export$7d61b15e0da132af = '#172B4D';
const $a7f8c6b391092279$export$fbda843f0a27fe96 = '#091E42';
const $a7f8c6b391092279$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $a7f8c6b391092279$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $a7f8c6b391092279$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $a7f8c6b391092279$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $a7f8c6b391092279$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $a7f8c6b391092279$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $a7f8c6b391092279$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $a7f8c6b391092279$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $a7f8c6b391092279$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $a7f8c6b391092279$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $a7f8c6b391092279$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $a7f8c6b391092279$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $a7f8c6b391092279$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $a7f8c6b391092279$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $a7f8c6b391092279$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $a7f8c6b391092279$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $a7f8c6b391092279$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $a7f8c6b391092279$export$2f6319cf7d736c2a = '#E6EDFA';
const $a7f8c6b391092279$export$95126bc8884d6634 = '#DCE5F5';
const $a7f8c6b391092279$export$8338d8c35d44ff1 = '#CED9EB';
const $a7f8c6b391092279$export$5368d76ae4fbbda7 = '#B8C7E0';
const $a7f8c6b391092279$export$9f0a771d16ec8d36 = '#ABBBD6';
const $a7f8c6b391092279$export$abcf8c38338b4aa5 = '#9FB0CC';
const $a7f8c6b391092279$export$97e81faa16a182c7 = '#8C9CB8';
const $a7f8c6b391092279$export$bfe21c59123ecf33 = '#7988A3';
const $a7f8c6b391092279$export$ee82aa2ea6a1558 = '#67758F';
const $a7f8c6b391092279$export$682927c6ed76be02 = '#56637A';
const $a7f8c6b391092279$export$91fd9994c5be9757 = '#455166';
const $a7f8c6b391092279$export$d281fbfe3cff2df6 = '#3B475C';
const $a7f8c6b391092279$export$3902c91d8b98a753 = '#313D52';
const $a7f8c6b391092279$export$8e8133c1ba5845b5 = '#283447';
const $a7f8c6b391092279$export$33ff357f6620b39 = '#202B3D';
const $a7f8c6b391092279$export$633847cf062b69e0 = '#1B2638';
const $a7f8c6b391092279$export$9776a6e503bdbf76 = '#121A29';
const $a7f8c6b391092279$export$6c813d5160dff5db = '#0E1624';
const $a7f8c6b391092279$export$3d4f271a500072a = '#0D1424';
const $a7f8c6b391092279$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $a7f8c6b391092279$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $a7f8c6b391092279$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $a7f8c6b391092279$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $a7f8c6b391092279$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $a7f8c6b391092279$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $a7f8c6b391092279$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $a7f8c6b391092279$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $a7f8c6b391092279$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $a7f8c6b391092279$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $a7f8c6b391092279$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $a7f8c6b391092279$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $a7f8c6b391092279$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $a7f8c6b391092279$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $a7f8c6b391092279$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $a7f8c6b391092279$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $a7f8c6b391092279$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $a7f8c6b391092279$export$d2adc5dedf09fced = '#292A2E';
const $a7f8c6b391092279$export$f51762073d2bb381 = '#94C748';
const $a7f8c6b391092279$export$95e26d54def96891 = '#B3DF72';


parcelRegister("4J9cG", function(module, exports) {

$parcel$export(module.exports, "isAbsoluteLink", () => $364dfe448fd09b74$export$895d6838d29edd02);
$parcel$export(module.exports, "prefixWithContextEntryPoint", () => $364dfe448fd09b74$export$715c8f9057ac0c01);
$parcel$export(module.exports, "getRelativeUrl", () => $364dfe448fd09b74$export$d614758658023fd);
$parcel$export(module.exports, "EXTERNAL_LINKS", () => $364dfe448fd09b74$export$4cf71c31cd7fa836);

var $hIKTz = parcelRequire("hIKTz");

var $WUBOW = parcelRequire("WUBOW");
const $364dfe448fd09b74$export$895d6838d29edd02 = (url)=>{
    return url.startsWith('http') || url.startsWith('www');
};
const $364dfe448fd09b74$export$715c8f9057ac0c01 = (path, contextEntryPoint = null)=>{
    if ($364dfe448fd09b74$export$895d6838d29edd02(path) || // do not prefix for absolute URL
    contextEntryPoint && path.startsWith(contextEntryPoint) || // do not prefix if the link already has product context path
    path.startsWith('/')) return path;
    return `${contextEntryPoint}/${path}`;
};
const $364dfe448fd09b74$export$d614758658023fd = (url)=>{
    if (!$364dfe448fd09b74$export$895d6838d29edd02(url)) return url;
    try {
        const { pathname: pathname, search: search, hash: hash } = new URL(url);
        return `${pathname}${search}${hash}`;
    } catch (error) {
        (0, $WUBOW.logException)(error, 'Cannot parse URL in getRelativeUrl', {
            url: url
        });
    }
    return url;
};
const $364dfe448fd09b74$export$4cf71c31cd7fa836 = {
    TEAM_INVITE_LEARN_MORE: `${(0, $hIKTz.getAtlassianContextUrl)('support')}/atlassian-account/docs/start-an-atlassian-team/#Add-or-remove-members-of-a-team`
};

});
parcelRegister("hIKTz", function(module, exports) {

$parcel$export(module.exports, "getAtlassianContextUrl", () => $762000cdb04f9cd0$export$9986ff99701c314f);
$parcel$export(module.exports, "getAtlassianContextDomain", () => $762000cdb04f9cd0$export$50f0d77e468746eb);

var $2ys8y = parcelRequire("2ys8y");

var $971Nd = parcelRequire("971Nd");
function $762000cdb04f9cd0$export$9986ff99701c314f(domainKey) {
    if ((0, $971Nd.isFedramp)()) return (0, $2ys8y.getATLContextUrl)(domainKey);
    else return `https://${domainKey}.atlassian.com`;
}
function $762000cdb04f9cd0$export$50f0d77e468746eb(domainKey) {
    if ((0, $971Nd.isFedramp)()) return (0, $2ys8y.getATLContextDomain)(domainKey);
    else return `${domainKey}.atlassian.com`;
}

});



parcelRegister("5gk7V", function(module, exports) {

$parcel$export(module.exports, "ProfileCardClientConfigProvider", () => $afd2540581cdc0eb$export$47bd48f80e3bc7b3);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Rwj0 = parcelRequire("8Rwj0");

var $4QBf5 = parcelRequire("4QBf5");
function $afd2540581cdc0eb$export$47bd48f80e3bc7b3({ children: children, ...props }) {
    const profileCardClient = (0, $4QBf5.useProfileClient)();
    const config = (0, $5uXOq.useMemo)(()=>({
            ...props,
            profileCardClient: profileCardClient
        }), [
        props,
        profileCardClient
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Rwj0.ProfileCardClientConfigContext).Provider, {
        value: config,
        children: children
    });
}

});
parcelRegister("8Rwj0", function(module, exports) {

$parcel$export(module.exports, "ProfileCardClientConfigContext", () => $ceab354c5b0912ee$export$c804cb3b184b670f);
$parcel$export(module.exports, "useProfileCardClientConfig", () => $ceab354c5b0912ee$export$a3c560c84e5d436d);

var $5uXOq = parcelRequire("5uXOq");
const $ceab354c5b0912ee$var$error = new Error('ProfileCardClientConfigProvider is not found in higher components');
const $ceab354c5b0912ee$var$defaultState = {
    addFlag: ()=>{
        // eslint-disable-next-line no-console
        console.error($ceab354c5b0912ee$var$error);
    },
    push: ()=>{
        // eslint-disable-next-line no-console
        console.error($ceab354c5b0912ee$var$error);
    },
    contextEntryPoint: null,
    cloudId: null
};
const $ceab354c5b0912ee$export$c804cb3b184b670f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($ceab354c5b0912ee$var$defaultState);
const $ceab354c5b0912ee$export$a3c560c84e5d436d = ()=>(0, $5uXOq.useContext)($ceab354c5b0912ee$export$c804cb3b184b670f);

});

parcelRegister("4QBf5", function(module, exports) {

$parcel$export(module.exports, "useProfileClient", () => $4e3701c62728f1be$export$d43dc22a8337ee9f);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $7VfBo = parcelRequire("7VfBo");

var $gKRfs = parcelRequire("gKRfs");
const $4e3701c62728f1be$var$CACHE_MAX_AGE = 60000;
const $4e3701c62728f1be$var$actions = {
    createClient: (stargateRoot, enableTeamCentral = false)=>({ setState: setState })=>{
            const profileClient = new (0, $7VfBo.default)({
                gatewayGraphqlUrl: `${stargateRoot}/graphql`,
                url: `${stargateRoot}/directory/graphql`,
                teamCentralDisabled: !enableTeamCentral,
                // teamCentralBaseUrl: enableTeamCentral
                //   ? getConfig().teamCentralUrl
                //   : undefined,
                cacheSize: 20,
                cacheMaxAge: $4e3701c62728f1be$var$CACHE_MAX_AGE
            });
            setState({
                profileClient: profileClient
            });
            return profileClient;
        }
};
const $4e3701c62728f1be$var$ProfileClientStore = (0, $iXqE5.createStore)({
    initialState: {},
    actions: $4e3701c62728f1be$var$actions
});
const $4e3701c62728f1be$var$useProfileClientState = (0, $3sQ5x.createHook)($4e3701c62728f1be$var$ProfileClientStore);
const $4e3701c62728f1be$export$d43dc22a8337ee9f = ()=>{
    // const [teamCentralStore] = useTeamCentralStore();
    const [{ profileClient: profileClient }, { createClient: createClient }] = $4e3701c62728f1be$var$useProfileClientState();
    const { stargateRoot: stargateRoot } = (0, $gKRfs.useAppConfig)();
    (0, $5uXOq.useEffect)(()=>{
        createClient(stargateRoot);
    }, [
        createClient,
        stargateRoot
    ]);
    // TODO: enable team central
    // useEffect(() => {
    //   if (teamCentralStore.hasWorkspace || teamCentralStore.orgHasWorkspace) {
    //     // re-create the client and enable team central features
    //     createClient(true);
    //   }
    // }, [teamCentralStore.hasWorkspace, teamCentralStore.orgHasWorkspace]);
    return profileClient;
};

});
parcelRegister("7VfBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $15705befa788ab65$export$2e2bcd8739ae039);


var $juq2W = parcelRequire("juq2W");


var $15705befa788ab65$export$2e2bcd8739ae039 = (0, $juq2W.default);

});
parcelRegister("juq2W", function(module, exports) {

$parcel$export(module.exports, "default", () => $23792da22668dcfb$export$2e2bcd8739ae039);

var $2ys8y = parcelRequire("2ys8y");
var $b4PzF = parcelRequire("b4PzF");

var $kAPet = parcelRequire("kAPet");

var $652W8 = parcelRequire("652W8");

var $hJRFB = parcelRequire("hJRFB");

var $cdyCC = parcelRequire("cdyCC");
const $23792da22668dcfb$var$defaultConfig = {
    gatewayGraphqlUrl: '/gateway/api/graphql'
};
class $23792da22668dcfb$var$ProfileCardClient {
    constructor(config, clients){
        //This default can be removed once all the clients are updated to pass the gatewayGraphqlUrl
        const withDefaultConfig = {
            ...$23792da22668dcfb$var$defaultConfig,
            ...config,
            gatewayGraphqlUrl: config.gatewayGraphqlUrl ?? $23792da22668dcfb$var$defaultConfig.gatewayGraphqlUrl
        };
        this.userClient = clients?.userClient || new (0, $cdyCC.default)(withDefaultConfig);
        this.teamClient = clients?.teamClient || new (0, $hJRFB.default)(withDefaultConfig);
        this.rovoAgentClient = clients?.rovoAgentClient || new (0, $kAPet.default)(withDefaultConfig);
        this.tcClient = $23792da22668dcfb$var$maybeCreateTeamCentralClient(withDefaultConfig, clients);
    }
    flushCache() {
        this.userClient.flushCache();
        this.teamClient.flushCache();
        this.tcClient?.flushCache();
        this.rovoAgentClient?.flushCache();
    }
    getProfile(cloudId, userId, analytics) {
        return this.userClient.getProfile(cloudId, userId, analytics);
    }
    getTeamProfile(teamId, orgId, analytics) {
        return this.teamClient.getProfile(teamId, orgId, analytics);
    }
    getReportingLines(userId) {
        return this.tcClient?.getReportingLines(userId) || Promise.resolve({
            managers: [],
            reports: []
        });
    }
    async getTeamCentralBaseUrl(teamCentralScopes) {
        if (this.tcClient === undefined) return Promise.resolve(undefined);
        const isGlobalExperienceWorkspace = await this.tcClient.getIsGlobalExperienceWorkspace();
        if (!isGlobalExperienceWorkspace) return Promise.resolve((0, $2ys8y.getATLContextUrl)('team'));
        let suffix = '';
        if (teamCentralScopes !== undefined) {
            const orgId = await this.tcClient.getOrgId();
            if (orgId === null) return Promise.resolve(undefined);
            suffix += `/o/${orgId}`;
            if (teamCentralScopes.withSiteContext) suffix += `/s/${this.tcClient.options.cloudId}`;
        }
        return Promise.resolve(`${(0, $2ys8y.getATLContextUrl)('home')}${suffix}`);
    }
    async shouldShowGiveKudos() {
        if (!this.tcClient || !await this.getTeamCentralBaseUrl()) return Promise.resolve(false);
        return this.tcClient.checkWorkspaceExists();
    }
    getRovoAgentProfile(id, analytics) {
        return this.rovoAgentClient?.getProfile(id, analytics);
    }
    getRovoAgentPermissions(id, fireAnalytics) {
        return this.rovoAgentClient?.getPermissions(id, fireAnalytics);
    }
    deleteAgent(id, analytics) {
        return this.rovoAgentClient?.deleteAgent(id, analytics);
    }
    setFavouriteAgent(id, isFavourite, analytics) {
        return this.rovoAgentClient?.setFavouriteAgent(id, isFavourite, analytics);
    }
}
function $23792da22668dcfb$var$maybeCreateTeamCentralClient(config, clients) {
    if ((0, $b4PzF.isFedRamp)()) return undefined;
    if (clients?.teamCentralClient) return clients.teamCentralClient;
    const teamCentralEnabled = config.teamCentralDisabled !== true;
    return teamCentralEnabled ? new (0, $652W8.default)({
        ...config
    }) : undefined;
}
var $23792da22668dcfb$export$2e2bcd8739ae039 = $23792da22668dcfb$var$ProfileCardClient;

});
parcelRegister("kAPet", function(module, exports) {

$parcel$export(module.exports, "default", () => $af582d71804b9dd0$export$2e2bcd8739ae039);

var $jQ0hK = parcelRequire("jQ0hK");

var $1P8ZX = parcelRequire("1P8ZX");

var $c4uSJ = parcelRequire("c4uSJ");

var $j92Xk = parcelRequire("j92Xk");
const $af582d71804b9dd0$var$createHeaders = (product, cloudId, isBodyJson)=>{
    const headers = new Headers({
        'X-Product': product,
        'X-Experience-Id': 'profile-card',
        'X-Cloudid': cloudId || ''
    });
    if (isBodyJson) headers.set('Content-Type', 'application/json');
    return headers;
};
class $af582d71804b9dd0$export$2e2bcd8739ae039 extends (0, $c4uSJ.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(id, cloudId) {
        const product = this.options.productIdentifier || 'rovo';
        const headers = $af582d71804b9dd0$var$createHeaders(product, this.options.cloudId);
        if (id.type === 'identity') return fetch(new Request(`/gateway/api/assist/agents/v1/accountid/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
        return fetch(new Request(`/gateway/api/assist/agents/v1/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
    }
    getProfile(id, analytics) {
        if (!id.value) return Promise.reject(new Error('Id is missing'));
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        const cache = this.getCachedProfile(id.value);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1P8ZX.getPageTime)();
            if (analytics) analytics((0, $jQ0hK.agentRequestAnalytics)('triggered'));
            this.makeRequest(id, this.options.cloudId || '').then((data)=>{
                if (this.cache) this.setCachedProfile(id.value, data);
                if (analytics) analytics((0, $jQ0hK.agentRequestAnalytics)('succeeded', 'request', {
                    duration: (0, $1P8ZX.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $jQ0hK.agentRequestAnalytics)('failed', 'request', {
                    duration: (0, $1P8ZX.getPageTime)() - startTime,
                    ...(0, $j92Xk.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    deleteAgent(agentId, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1P8ZX.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (analytics) analytics((0, $jQ0hK.agentRequestAnalytics)('triggered'));
            const headers = $af582d71804b9dd0$var$createHeaders(product, this.options.cloudId);
            fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}`, {
                method: 'DELETE',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $jQ0hK.agentRequestAnalytics)('succeeded', 'deleteAgent', {
                    duration: (0, $1P8ZX.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $jQ0hK.agentRequestAnalytics)('failed', 'deleteAgent', {
                    duration: (0, $1P8ZX.getPageTime)() - startTime,
                    ...(0, $j92Xk.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    setFavouriteAgent(agentId, isFavourite, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise(async (resolve, reject)=>{
            const startTime = (0, $1P8ZX.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            const actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
            const requestMethod = isFavourite ? 'POST' : 'DELETE';
            if (analytics) analytics((0, $jQ0hK.agentRequestAnalytics)('triggered', 'actionSubjectId'));
            const headers = $af582d71804b9dd0$var$createHeaders(product, this.options.cloudId);
            await fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}/favourite`, {
                method: requestMethod,
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $jQ0hK.agentRequestAnalytics)('succeeded', actionSubjectId, {
                    duration: (0, $1P8ZX.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $jQ0hK.agentRequestAnalytics)('failed', actionSubjectId, {
                    duration: (0, $1P8ZX.getPageTime)() - startTime,
                    ...(0, $j92Xk.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    getPermissions(id, fireAnalytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1P8ZX.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (fireAnalytics) fireAnalytics((0, $jQ0hK.agentRequestAnalytics)('triggered'));
            const headers = $af582d71804b9dd0$var$createHeaders(product, this.options.cloudId, true);
            fetch(new Request(`/gateway/api/assist/api/rovo/v2/permissions/agents/${id}`, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: headers,
                body: JSON.stringify({
                    permission_ids: [
                        'AGENT_CREATE',
                        'AGENT_UPDATE',
                        'AGENT_DELETE',
                        'AGENT_DEACTIVATE',
                        'AGENT_READ'
                    ]
                })
            })).then((response)=>response.json()).then((data)=>{
                if (fireAnalytics) fireAnalytics((0, $jQ0hK.agentRequestAnalytics)('succeeded', 'getAgentPermissions', {
                    duration: (0, $1P8ZX.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (fireAnalytics) fireAnalytics((0, $jQ0hK.agentRequestAnalytics)('failed', 'getAgentPermissions', {
                    duration: (0, $1P8ZX.getPageTime)() - startTime,
                    ...(0, $j92Xk.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("jQ0hK", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $85e2a5a074f627a8$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $85e2a5a074f627a8$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $85e2a5a074f627a8$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $85e2a5a074f627a8$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $85e2a5a074f627a8$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $85e2a5a074f627a8$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $85e2a5a074f627a8$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $85e2a5a074f627a8$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $85e2a5a074f627a8$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $85e2a5a074f627a8$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $85e2a5a074f627a8$export$c86679da702d560e);
$parcel$export(module.exports, "agentRequestAnalytics", () => $85e2a5a074f627a8$export$a9f8c9f412cf5664);

var $1P8ZX = parcelRequire("1P8ZX");
/** Below lines are copied from teams common analytics */ const $85e2a5a074f627a8$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $85e2a5a074f627a8$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $85e2a5a074f627a8$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $85e2a5a074f627a8$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($85e2a5a074f627a8$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $85e2a5a074f627a8$var$TEAM_SUBJECT = 'teamProfileCard';
const $85e2a5a074f627a8$var$USER_SUBJECT = 'profilecard';
const $85e2a5a074f627a8$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
const $85e2a5a074f627a8$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $1P8ZX.getPageTime)())
        }
    });
const $85e2a5a074f627a8$var$getActionSubject = (type)=>{
    switch(type){
        case 'user':
            return $85e2a5a074f627a8$var$USER_SUBJECT;
        case 'team':
            return $85e2a5a074f627a8$var$TEAM_SUBJECT;
        case 'agent':
            return $85e2a5a074f627a8$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $85e2a5a074f627a8$export$d50ab8a3b6975c = (type, method)=>{
    return $85e2a5a074f627a8$var$createEvent('ui', 'triggered', $85e2a5a074f627a8$var$getActionSubject(type), undefined, {
        method: method
    });
};
const $85e2a5a074f627a8$export$c9b0e37b229a297b = (action, attributes)=>$85e2a5a074f627a8$var$createEvent('operational', action, $85e2a5a074f627a8$var$TEAM_SUBJECT, 'request', attributes);
const $85e2a5a074f627a8$export$12dae48763368ac9 = (action, attributes)=>$85e2a5a074f627a8$var$createEvent('operational', action, $85e2a5a074f627a8$var$USER_SUBJECT, 'request', attributes);
const $85e2a5a074f627a8$export$41816a317479160b = (type, actionSubjectId, attributes)=>$85e2a5a074f627a8$var$createEvent('ui', 'rendered', $85e2a5a074f627a8$var$getActionSubject(type), actionSubjectId, attributes);
const $85e2a5a074f627a8$export$fdcd134fbeb1f921 = (type, attributes)=>$85e2a5a074f627a8$var$createEvent('ui', 'clicked', $85e2a5a074f627a8$var$getActionSubject(type), 'action', attributes);
const $85e2a5a074f627a8$export$93260987012593be = (attributes)=>$85e2a5a074f627a8$var$createEvent('ui', 'clicked', $85e2a5a074f627a8$var$USER_SUBJECT, 'reportingLines', attributes);
const $85e2a5a074f627a8$export$79befd155063a6a7 = (type, attributes)=>$85e2a5a074f627a8$var$createEvent('ui', 'clicked', $85e2a5a074f627a8$var$getActionSubject(type), 'moreActions', attributes);
const $85e2a5a074f627a8$export$2703289b35687fde = (attributes)=>$85e2a5a074f627a8$var$createEvent('ui', 'clicked', $85e2a5a074f627a8$var$TEAM_SUBJECT, 'avatar', attributes);
const $85e2a5a074f627a8$export$b4411a7661cf2d3f = (attributes)=>$85e2a5a074f627a8$var$createEvent('ui', 'clicked', $85e2a5a074f627a8$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $85e2a5a074f627a8$export$c86679da702d560e = (attributes)=>$85e2a5a074f627a8$var$createEvent('ui', 'clicked', $85e2a5a074f627a8$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $85e2a5a074f627a8$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$85e2a5a074f627a8$var$createEvent('operational', action, $85e2a5a074f627a8$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);

});
parcelRegister("1P8ZX", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $0389323ef0b3cb79$export$e9faea7c41053334);
const $0389323ef0b3cb79$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $0389323ef0b3cb79$var$performanceAvailable = $0389323ef0b3cb79$var$isPerformanceAvailable();
const $0389323ef0b3cb79$var$initialPageTime = Date.now();
const $0389323ef0b3cb79$export$e9faea7c41053334 = ()=>{
    if ($0389323ef0b3cb79$var$performanceAvailable) return performance.now();
    return Date.now() - $0389323ef0b3cb79$var$initialPageTime;
};

});


parcelRegister("c4uSJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $abe00b516f07df56$export$2e2bcd8739ae039);

var $iwKVT = parcelRequire("iwKVT");
class $abe00b516f07df56$export$2e2bcd8739ae039 {
    constructor(config){
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $iwKVT.LRUMap)(this.config.cacheSize);
    }
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
}

});

parcelRegister("j92Xk", function(module, exports) {

$parcel$export(module.exports, "getErrorAttributes", () => $92bc5beb125c9446$export$6ad9e7706a4ee0f8);
$parcel$export(module.exports, "handleDirectoryGraphQLErrors", () => $92bc5beb125c9446$export$7642af465ceb7f05);
$parcel$export(module.exports, "handleAGGErrors", () => $92bc5beb125c9446$export$d9ad65d422ee3f8c);

var $c3s8O = parcelRequire("c3s8O");
const $92bc5beb125c9446$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $92bc5beb125c9446$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $92bc5beb125c9446$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $92bc5beb125c9446$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $c3s8O.DirectoryGraphQLError)) return !!error && $92bc5beb125c9446$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $c3s8O.AGGError)) return !!error.errorType && $92bc5beb125c9446$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $92bc5beb125c9446$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $92bc5beb125c9446$export$6ad9e7706a4ee0f8 = (error)=>{
    if (error instanceof (0, $c3s8O.DirectoryGraphQLErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($92bc5beb125c9446$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($92bc5beb125c9446$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $c3s8O.DirectoryGraphQLError)) return {
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber,
        isSLOFailure: !$92bc5beb125c9446$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $c3s8O.AGGErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($92bc5beb125c9446$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($92bc5beb125c9446$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $c3s8O.AGGError)) return {
        errorMessage: error.message,
        errorType: error.errorType,
        errorStatusCode: error.statusCode,
        isSLOFailure: !$92bc5beb125c9446$var$isIgnoredError(error),
        errorCategory: error.classification
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $c3s8O.DirectoryGraphQLErrors) || causeError instanceof (0, $c3s8O.AGGErrors)) return $92bc5beb125c9446$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $92bc5beb125c9446$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $c3s8O.DirectoryGraphQLErrors)(errors, traceId);
};
const $92bc5beb125c9446$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $c3s8O.AGGErrors)(errors, traceId);
};

});
parcelRegister("c3s8O", function(module, exports) {

$parcel$export(module.exports, "HttpError", () => $ad258c62b481cd08$export$65bd6083489bd8bb);
$parcel$export(module.exports, "DirectoryGraphQLError", () => $ad258c62b481cd08$export$c1e4d0de940c06a2);
$parcel$export(module.exports, "DirectoryGraphQLErrors", () => $ad258c62b481cd08$export$5a5fbfed34a590a1);
$parcel$export(module.exports, "AGGError", () => $ad258c62b481cd08$export$4a696f048dcc929);
$parcel$export(module.exports, "AGGErrors", () => $ad258c62b481cd08$export$60d8267243755b9c);
class $ad258c62b481cd08$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = code;
        this.traceId = traceId;
    }
}
class $ad258c62b481cd08$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $ad258c62b481cd08$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $ad258c62b481cd08$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $ad258c62b481cd08$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $ad258c62b481cd08$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $ad258c62b481cd08$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}

});



parcelRegister("652W8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ca23c04f5ff6beb$export$2e2bcd8739ae039);

var $fHpHg = parcelRequire("fHpHg");

var $c4uSJ = parcelRequire("c4uSJ");

var $h5xeR = parcelRequire("h5xeR");

var $lhuAF = parcelRequire("lhuAF");
const $9ca23c04f5ff6beb$var$UNSHARDED_PREFIX = '/gateway/api/watermelon';
const $9ca23c04f5ff6beb$export$1862ef0c3880ca8d = (aaid)=>({
        query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
        variables: {
            aaid: aaid
        }
    });
const $9ca23c04f5ff6beb$var$orgContainsAnyWorkspacePromiseCache = new Map();
const $9ca23c04f5ff6beb$var$orgIdPromiseCache = new Map();
const $9ca23c04f5ff6beb$var$workspaceExistsWithTypePromiseCache = new Map();
class $9ca23c04f5ff6beb$var$TeamCentralCardClient extends (0, $c4uSJ.default) {
    constructor(options){
        super(options);
        this.options = options;
        this.bypassOnFailure = false;
        this.orgContainsAnyWorkspacePromise = this.createOrgContainsAnyWorkspacePromise(options);
        this.workspaceExistsWithTypePromise = this.preloadWorkspaceExistsWithType(options.cloudId);
        this.orgIdPromise = this.preloadOrgId(options.gatewayGraphqlUrl, options.cloudId, options.orgId);
    }
    createOrgContainsAnyWorkspacePromise(config) {
        if (config.cloudId) {
            let promise = $9ca23c04f5ff6beb$var$orgContainsAnyWorkspacePromiseCache.get(config.cloudId);
            if (!promise) {
                promise = this.getOrgContainsAnyWorkspace(config.cloudId);
                $9ca23c04f5ff6beb$var$orgContainsAnyWorkspacePromiseCache.set(config.cloudId, promise);
            }
            return promise;
        }
        return Promise.resolve(true);
    }
    getReportingLines(userId) {
        return this.orgContainsAnyWorkspacePromise.then((orgContainsAnyWorkspace)=>{
            if (orgContainsAnyWorkspace) {
                if (!userId) return Promise.reject(new Error('userId missing'));
                const cache = this.getCachedProfile(userId);
                if (cache) return Promise.resolve(cache);
                if (this.bypassOnFailure) return Promise.resolve({});
                return new Promise((resolve)=>{
                    this.makeRequest(userId).then((data)=>{
                        const enhancedData = {
                            managers: this.filterReportingLinesUser(data?.managers),
                            reports: this.filterReportingLinesUser(data?.reports)
                        };
                        if (this.cache) this.setCachedProfile(userId, enhancedData);
                        resolve(enhancedData);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        /**
								 * Reporting lines aren't part of the critical path of profile card.
								 * Just resolve with empty values instead of bubbling up the error.
								 */ resolve({});
                    });
                });
            }
            return Promise.resolve({
                managers: [],
                reports: []
            });
        }, ()=>Promise.resolve({
                managers: [],
                reports: []
            }));
    }
    /**
	 * `public` so that mock client can override it; do not use it otherwise!
	 */ async makeRequest(userId) {
        if (this.options.teamCentralDisabled === true) throw new Error('makeRequest cannot be called when the client has been disabled');
        const query = $9ca23c04f5ff6beb$export$1862ef0c3880ca8d(userId);
        const response = await (0, $lhuAF.directoryGraphqlQuery)('/gateway/api/watermelon/graphql?operationName=ReportingLines', query);
        return response.reportingLines;
    }
    async checkWorkspaceExists() {
        const workspaceExistsPromise = (0, $fHpHg.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? this.workspaceExistsWithTypePromise.then((workspaceExistsWithType)=>workspaceExistsWithType !== undefined) : this.orgContainsAnyWorkspacePromise;
        return workspaceExistsPromise.then((workspaceExistsWithType)=>{
            if (workspaceExistsWithType) return Promise.resolve(true);
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    async getIsGlobalExperienceWorkspace() {
        return await this.workspaceExistsWithTypePromise === 'GLOBAL_EXPERIENCE';
    }
    getOrgId() {
        return this.orgIdPromise;
    }
    preloadWorkspaceExistsWithType(cloudId) {
        if (cloudId === undefined) return Promise.resolve(undefined);
        const maybeWorkspaceExistsWithTypePromise = $9ca23c04f5ff6beb$var$workspaceExistsWithTypePromiseCache.get(cloudId);
        if (maybeWorkspaceExistsWithTypePromise !== undefined) return maybeWorkspaceExistsWithTypePromise;
        const workspaceExistsWithTypePromise = this.getWorkspaceExistsWithType(cloudId);
        $9ca23c04f5ff6beb$var$workspaceExistsWithTypePromiseCache.set(cloudId, workspaceExistsWithTypePromise);
        return workspaceExistsWithTypePromise;
    }
    getOrgContainsAnyWorkspace(cloudId) {
        if (cloudId) return fetch(((0, $fHpHg.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? $9ca23c04f5ff6beb$var$UNSHARDED_PREFIX : this.getShardedApiPath(cloudId)) + `/organization/containsAnyWorkspace?cloudId=${cloudId}`).then((res)=>{
            return !res || res && res.ok;
        });
        else return Promise.resolve(false);
    }
    async getWorkspaceExistsWithType(cloudId) {
        try {
            const response = await fetch(`${this.getShardedApiPath(cloudId)}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`, {
                credentials: 'include'
            });
            if (response.ok) {
                const workspaceType = await response.text();
                return Promise.resolve(workspaceType);
            }
        } catch (err) {
            return Promise.resolve(undefined);
        }
    }
    preloadOrgId(gatewayGraphqlUrl, cloudId, orgId) {
        if (cloudId === undefined) return Promise.resolve(null);
        if (orgId !== undefined) return Promise.resolve(orgId);
        const maybeOrgIdForCloudIdPromise = $9ca23c04f5ff6beb$var$orgIdPromiseCache.get(cloudId);
        if (maybeOrgIdForCloudIdPromise !== undefined) return maybeOrgIdForCloudIdPromise;
        const orgIdForCloudIdPromise = (0, $h5xeR.getOrgIdForCloudIdFromAGG)(gatewayGraphqlUrl, cloudId);
        $9ca23c04f5ff6beb$var$orgIdPromiseCache.set(cloudId, orgIdForCloudIdPromise);
        return orgIdForCloudIdPromise;
    }
    getShardedApiPath(cloudId) {
        return `/gateway/api/townsquare/s/${cloudId}`;
    }
    filterReportingLinesUser(users = []) {
        return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
    }
}
var $9ca23c04f5ff6beb$export$2e2bcd8739ae039 = $9ca23c04f5ff6beb$var$TeamCentralCardClient;

});
parcelRegister("h5xeR", function(module, exports) {

$parcel$export(module.exports, "getOrgIdForCloudIdFromAGG", () => $e20bc15584b69ecf$export$d38a536fd806c68f);

var $lhuAF = parcelRequire("lhuAF");
const $e20bc15584b69ecf$var$ORG_ID_FROM_CLOUD_ID_QUERY = `query OrgIdFromCloudId($cloudId: ID!) {
	tenantContexts(cloudIds: [$cloudId]) {
		orgId
	}
}`;
const $e20bc15584b69ecf$var$addHeaders = (headers)=>{
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $e20bc15584b69ecf$export$d38a536fd806c68f(url, cloudId) {
    const query = {
        query: $e20bc15584b69ecf$var$ORG_ID_FROM_CLOUD_ID_QUERY,
        variables: {
            cloudId: cloudId
        }
    };
    try {
        const { tenantContexts: tenantContexts } = await (0, $lhuAF.AGGQuery)(url, query, $e20bc15584b69ecf$var$addHeaders);
        if (!tenantContexts || tenantContexts.length === 0 || tenantContexts[0] === null) return null;
        return tenantContexts[0].orgId;
    } catch (err) {
        // don't bubble up the error, and let consumers handle it as if the cloud ID
        // doesn't resolve to an org ID
        return null;
    }
}

});
parcelRegister("lhuAF", function(module, exports) {

$parcel$export(module.exports, "directoryGraphqlQuery", () => $98ef723f563477ce$export$a5b5995619d4fe36);
$parcel$export(module.exports, "AGGQuery", () => $98ef723f563477ce$export$a14afb5f82fe705);

var $c3s8O = parcelRequire("c3s8O");

var $j92Xk = parcelRequire("j92Xk");
const $98ef723f563477ce$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $98ef723f563477ce$var$id = (headers)=>headers;
async function $98ef723f563477ce$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $98ef723f563477ce$var$id) {
    return $98ef723f563477ce$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $j92Xk.handleDirectoryGraphQLErrors));
}
async function $98ef723f563477ce$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $98ef723f563477ce$var$id) {
    return $98ef723f563477ce$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $j92Xk.handleAGGErrors));
}
async function $98ef723f563477ce$var$graphQLQuery(serviceUrl, query, processHeaders = $98ef723f563477ce$var$id, handleErrors) {
    const headers = processHeaders($98ef723f563477ce$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $c3s8O.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}

});



parcelRegister("hJRFB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b669385e624e94cd$export$2e2bcd8739ae039);

var $jQ0hK = parcelRequire("jQ0hK");

var $1P8ZX = parcelRequire("1P8ZX");

var $c4uSJ = parcelRequire("c4uSJ");

var $j92Xk = parcelRequire("j92Xk");

var $cfNQo = parcelRequire("cfNQo");
class $b669385e624e94cd$export$2e2bcd8739ae039 extends (0, $c4uSJ.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(teamId, _orgId) {
        if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
        return (0, $cfNQo.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
    }
    getProfile(teamId, orgId, analytics) {
        if (!teamId) return Promise.reject(new Error('teamId is missing'));
        const cache = this.getCachedProfile(teamId);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1P8ZX.getPageTime)();
            if (analytics) analytics((0, $jQ0hK.teamRequestAnalytics)('triggered'));
            this.makeRequest(teamId, orgId).then((data)=>{
                if (this.cache) this.setCachedProfile(teamId, data);
                if (analytics) analytics((0, $jQ0hK.teamRequestAnalytics)('succeeded', {
                    duration: (0, $1P8ZX.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $jQ0hK.teamRequestAnalytics)('failed', {
                    duration: (0, $1P8ZX.getPageTime)() - startTime,
                    ...(0, $j92Xk.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("cfNQo", function(module, exports) {

$parcel$export(module.exports, "getTeamFromAGG", () => $e3c376581486e934$export$26a8aad0c7182dd6);

var $fHpHg = parcelRequire("fHpHg");

var $lhuAF = parcelRequire("lhuAF");
const $e3c376581486e934$var$ARI_PREFIX = 'ari:cloud:identity::team/';
const $e3c376581486e934$export$5816a09dbb711691 = (ari)=>{
    const slashPos = ari.indexOf('/');
    const id = ari.slice(slashPos + 1);
    return id;
};
const $e3c376581486e934$export$681597d03c8a0fd2 = (teamId)=>{
    return `ari:cloud:identity::team/${teamId}`;
};
const $e3c376581486e934$export$7878e28c136af76 = (teamIdOrTeamAri)=>teamIdOrTeamAri.startsWith($e3c376581486e934$var$ARI_PREFIX) ? teamIdOrTeamAri : $e3c376581486e934$export$681597d03c8a0fd2(teamIdOrTeamAri);
const $e3c376581486e934$export$fce1abb40bf8db94 = (result)=>{
    const { team: team } = result;
    return {
        ...team,
        id: $e3c376581486e934$export$5816a09dbb711691(team.id),
        members: team.members?.nodes.map(({ member: member })=>({
                id: member.accountId,
                fullName: member.name,
                avatarUrl: member.picture
            }))
    };
};
// indented so it's
const $e3c376581486e934$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
	  isVerified
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
const $e3c376581486e934$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$e3c376581486e934$var$TEAM_FRAGMENT}
    }
  }
}`;
const $e3c376581486e934$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
        query: $e3c376581486e934$export$4968f4e0119a5d9c,
        variables: {
            teamId: (0, $fHpHg.fg)('team_id_to_ari_safe') ? $e3c376581486e934$export$7878e28c136af76(teamId) : $e3c376581486e934$export$681597d03c8a0fd2(teamId),
            siteId: siteId || 'None'
        }
    });
const $e3c376581486e934$export$1229c72526c01df2 = (headers)=>{
    headers.append('X-ExperimentalApi', 'teams-beta');
    headers.append('X-ExperimentalApi', 'team-members-beta');
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $e3c376581486e934$export$26a8aad0c7182dd6(url, teamId, siteId) {
    const query = $e3c376581486e934$export$695d743d1401e038({
        teamId: teamId,
        siteId: siteId
    });
    const { Team: Team } = await (0, $lhuAF.AGGQuery)(url, query, $e3c376581486e934$export$1229c72526c01df2);
    return $e3c376581486e934$export$fce1abb40bf8db94(Team);
}

});


parcelRegister("cdyCC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b59270c19cd0c881$export$2e2bcd8739ae039);

var $1c8Um = parcelRequire("1c8Um");

var $5cllN = parcelRequire("5cllN");

var $fHpHg = parcelRequire("fHpHg");

var $jQ0hK = parcelRequire("jQ0hK");

var $a4E5y = parcelRequire("a4E5y");

var $1P8ZX = parcelRequire("1P8ZX");

var $c4uSJ = parcelRequire("c4uSJ");

var $j92Xk = parcelRequire("j92Xk");

var $lhuAF = parcelRequire("lhuAF");
const $b59270c19cd0c881$export$b26b7f9bcf400835 = (response)=>{
    const data = {
        ...response.User
    };
    const localWeekdayIndex = new Date().getDay().toString();
    if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = `${data.remoteWeekdayString} ${data.remoteTimeString}`;
    return {
        isBot: data.isBot,
        isCurrentUser: data.isCurrentUser,
        status: data.status,
        statusModifiedDate: data.statusModifiedDate || undefined,
        avatarUrl: data.avatarUrl || undefined,
        email: data.email || undefined,
        fullName: data.fullName || undefined,
        location: data.location || undefined,
        meta: data.meta || undefined,
        nickname: data.nickname || undefined,
        companyName: data.companyName || undefined,
        timestring: data.remoteTimeString || undefined,
        accountType: data.accountType || undefined
    };
};
const $b59270c19cd0c881$var$aggUserQuery = (0, $5cllN.default)`
	query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
				appType
			}
		}
	}
`;
const $b59270c19cd0c881$var$aggUserQueryString = `query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
      			appType
    		}
		}
	}`;
const $b59270c19cd0c881$export$8230f28f7ae567ea = (userId)=>({
        query: (0, $fHpHg.fg)('platform_agg_user_query_doc_change') ? (0, $1c8Um.print)($b59270c19cd0c881$var$aggUserQuery) : $b59270c19cd0c881$var$aggUserQueryString,
        variables: {
            userId: userId
        }
    });
const $b59270c19cd0c881$var$queryAGGUser = async (url, userId)=>{
    const query = $b59270c19cd0c881$export$8230f28f7ae567ea(userId);
    const { user: user } = await (0, $lhuAF.AGGQuery)(url, query);
    return user;
};
class $b59270c19cd0c881$export$2e2bcd8739ae039 extends (0, $c4uSJ.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    async makeRequest(cloudId, userId) {
        const gatewayGraphqlUrl = this.options.gatewayGraphqlUrl || '/gateway/api/graphql';
        const urlWithOperationName = `${gatewayGraphqlUrl}?operationName=aggUserQuery`;
        const userQueryPromise = $b59270c19cd0c881$var$queryAGGUser(urlWithOperationName, userId);
        const user = await userQueryPromise;
        let timestring;
        const localWeekdayIndex = new Date().getDay().toString();
        if (user.zoneinfo) {
            if ((0, $a4E5y.localTime)(user.zoneinfo, 'i') === localWeekdayIndex) timestring = (0, $a4E5y.localTime)(user.zoneinfo, 'h:mmbbb') || undefined;
            else timestring = (0, $a4E5y.localTime)(user.zoneinfo, 'eee h:mmbbb') || undefined;
        }
        return {
            ...user,
            isBot: user.__typename === 'AppUser',
            isAgent: user.appType === 'agent',
            status: user.accountStatus,
            statusModifiedDate: user.extendedProfile?.closedDate || user.extendedProfile?.inactiveDate,
            avatarUrl: user.picture,
            email: user.email,
            fullName: user.name,
            location: user.extendedProfile?.location,
            meta: user.extendedProfile?.jobTitle,
            nickname: user.nickname,
            companyName: user.extendedProfile?.organization,
            timestring: timestring
        };
    }
    getProfile(cloudId, userId, analytics) {
        if (!userId) return Promise.reject(new Error('userId missing'));
        const cacheIdentifier = `${cloudId}/${userId}`;
        const cache = this.getCachedProfile(cacheIdentifier);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1P8ZX.getPageTime)();
            if (analytics) analytics((0, $jQ0hK.userRequestAnalytics)('triggered'));
            this.makeRequest(cloudId, userId).then((data)=>{
                if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                if (analytics) analytics((0, $jQ0hK.userRequestAnalytics)('succeeded', {
                    duration: (0, $1P8ZX.getPageTime)() - startTime
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $jQ0hK.userRequestAnalytics)('failed', {
                    duration: (0, $1P8ZX.getPageTime)() - startTime,
                    ...(0, $j92Xk.getErrorAttributes)(error)
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("a4E5y", function(module, exports) {

$parcel$export(module.exports, "localTime", () => $4fc1717a9ed01087$export$f0dfd716e7b023cd);
parcelRequire("bvXiK");
var $cjVx1 = parcelRequire("cjVx1");
const $4fc1717a9ed01087$export$f0dfd716e7b023cd = (timezone, format)=>{
    if (!timezone) return null;
    try {
        return (0, $cjVx1.default)(new Date(), timezone, format);
    } catch (error) {
        return null;
    }
};

});
parcelRegister("bvXiK", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("cjVx1")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $cjVx1 = parcelRequire("cjVx1");





});
parcelRegister("cjVx1", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f83e2f603f04f8b$export$2e2bcd8739ae039);

var $fwbX5 = parcelRequire("fwbX5");

var $kWAFD = parcelRequire("kWAFD");

var $bzFEY = parcelRequire("bzFEY");
function $8f83e2f603f04f8b$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($fwbX5)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $kWAFD.default)((0, $bzFEY.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("kWAFD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3f5ab696079cf9e$export$2e2bcd8739ae039);

var $aR9Qf = parcelRequire("aR9Qf");

var $a0AoV = parcelRequire("a0AoV");

var $hPb5g = parcelRequire("hPb5g");
var $f3f5ab696079cf9e$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $f3f5ab696079cf9e$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($f3f5ab696079cf9e$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $hPb5g.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $a0AoV.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aR9Qf)))(dirtyDate, formatStr, options);
}

});
parcelRegister("a0AoV", function(module, exports) {

$parcel$export(module.exports, "default", () => $749623fa41b373b0$export$2e2bcd8739ae039);

var $4HQad = parcelRequire("4HQad");

var $dJe12 = parcelRequire("dJe12");
var $749623fa41b373b0$var$MILLISECONDS_IN_MINUTE = 60000;
var $749623fa41b373b0$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $749623fa41b373b0$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $749623fa41b373b0$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $749623fa41b373b0$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $749623fa41b373b0$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $749623fa41b373b0$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $749623fa41b373b0$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $749623fa41b373b0$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $749623fa41b373b0$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $749623fa41b373b0$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $749623fa41b373b0$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $749623fa41b373b0$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $4HQad.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $4HQad.default)('long', date, options);
        }
    }
};
function $749623fa41b373b0$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $dJe12.default)(timeZone, originalDate, true) / $749623fa41b373b0$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $749623fa41b373b0$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $749623fa41b373b0$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $749623fa41b373b0$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $749623fa41b373b0$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $749623fa41b373b0$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $749623fa41b373b0$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $749623fa41b373b0$var$formatTimezone(offset, dirtyDelimeter);
}
function $749623fa41b373b0$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $749623fa41b373b0$var$addLeadingZeros(minutes, 2);
}
var $749623fa41b373b0$export$2e2bcd8739ae039 = $749623fa41b373b0$var$formatters;

});
parcelRegister("4HQad", function(module, exports) {

$parcel$export(module.exports, "default", () => $36d3a43c0eedc11e$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $36d3a43c0eedc11e$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $36d3a43c0eedc11e$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $36d3a43c0eedc11e$var$partsTimeZone(dtf, date) : $36d3a43c0eedc11e$var$hackyTimeZone(dtf, date);
}
function $36d3a43c0eedc11e$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $36d3a43c0eedc11e$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $36d3a43c0eedc11e$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("dJe12", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fea598d71cce197$export$2e2bcd8739ae039);

var $YidMk = parcelRequire("YidMk");

var $14jIa = parcelRequire("14jIa");
var $9fea598d71cce197$var$MILLISECONDS_IN_HOUR = 3600000;
var $9fea598d71cce197$var$MILLISECONDS_IN_MINUTE = 60000;
var $9fea598d71cce197$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $9fea598d71cce197$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $9fea598d71cce197$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $9fea598d71cce197$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$9fea598d71cce197$var$validateTimezone(hours)) return NaN;
        return -(hours * $9fea598d71cce197$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $9fea598d71cce197$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$9fea598d71cce197$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $9fea598d71cce197$var$MILLISECONDS_IN_HOUR + minutes * $9fea598d71cce197$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($9fea598d71cce197$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $9fea598d71cce197$var$toUtcDate(date);
        var offset = $9fea598d71cce197$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $9fea598d71cce197$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $9fea598d71cce197$var$toUtcDate(date) {
    return (0, $14jIa.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $9fea598d71cce197$var$calcOffset(date, timezoneString) {
    var tokens = (0, $YidMk.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $14jIa.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $9fea598d71cce197$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $9fea598d71cce197$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $9fea598d71cce197$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $9fea598d71cce197$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $9fea598d71cce197$var$validIANATimezoneCache = {};
function $9fea598d71cce197$var$isValidTimezoneIANAString(timeZoneString) {
    if ($9fea598d71cce197$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $9fea598d71cce197$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("YidMk", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b53bd11b51a1a98$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $0b53bd11b51a1a98$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $0b53bd11b51a1a98$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $0b53bd11b51a1a98$var$partsOffset(dtf, date) : $0b53bd11b51a1a98$var$hackyOffset(dtf, date);
}
var $0b53bd11b51a1a98$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $0b53bd11b51a1a98$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $0b53bd11b51a1a98$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $0b53bd11b51a1a98$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $0b53bd11b51a1a98$var$dtfCache = {};
function $0b53bd11b51a1a98$var$getDateTimeFormat(timeZone) {
    if (!$0b53bd11b51a1a98$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $0b53bd11b51a1a98$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $0b53bd11b51a1a98$var$dtfCache[timeZone];
}

});

parcelRegister("14jIa", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c757471af3a5e68$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $0c757471af3a5e68$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("hPb5g", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf9fcc1b038219f4$export$2e2bcd8739ae039);

var $aSksP = parcelRequire("aSksP");

var $jGQTC = parcelRequire("jGQTC");

var $dJe12 = parcelRequire("dJe12");

var $gFzxn = parcelRequire("gFzxn");
var $cf9fcc1b038219f4$var$MILLISECONDS_IN_HOUR = 3600000;
var $cf9fcc1b038219f4$var$MILLISECONDS_IN_MINUTE = 60000;
var $cf9fcc1b038219f4$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $cf9fcc1b038219f4$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $gFzxn.default)
};
function $cf9fcc1b038219f4$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $cf9fcc1b038219f4$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($aSksP)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $cf9fcc1b038219f4$var$splitDateString(argument);
    var parseYearResult = $cf9fcc1b038219f4$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $cf9fcc1b038219f4$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $cf9fcc1b038219f4$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $dJe12.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($jGQTC)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $cf9fcc1b038219f4$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $cf9fcc1b038219f4$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $cf9fcc1b038219f4$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $cf9fcc1b038219f4$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $cf9fcc1b038219f4$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $cf9fcc1b038219f4$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $cf9fcc1b038219f4$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $cf9fcc1b038219f4$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $cf9fcc1b038219f4$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $cf9fcc1b038219f4$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $cf9fcc1b038219f4$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$cf9fcc1b038219f4$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $cf9fcc1b038219f4$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$cf9fcc1b038219f4$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $cf9fcc1b038219f4$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$cf9fcc1b038219f4$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $cf9fcc1b038219f4$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$cf9fcc1b038219f4$var$validateWeekDate(year, week)) return new Date(NaN);
        return $cf9fcc1b038219f4$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $cf9fcc1b038219f4$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$cf9fcc1b038219f4$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $cf9fcc1b038219f4$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $cf9fcc1b038219f4$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $cf9fcc1b038219f4$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$cf9fcc1b038219f4$var$validateTime(hours)) return NaN;
        return hours % 24 * $cf9fcc1b038219f4$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $cf9fcc1b038219f4$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$cf9fcc1b038219f4$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $cf9fcc1b038219f4$var$MILLISECONDS_IN_HOUR + minutes * $cf9fcc1b038219f4$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $cf9fcc1b038219f4$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$cf9fcc1b038219f4$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $cf9fcc1b038219f4$var$MILLISECONDS_IN_HOUR + minutes * $cf9fcc1b038219f4$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $cf9fcc1b038219f4$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $cf9fcc1b038219f4$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $cf9fcc1b038219f4$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $cf9fcc1b038219f4$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $cf9fcc1b038219f4$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $cf9fcc1b038219f4$var$isLeapYearIndex(year);
        if (isLeapYear && date > $cf9fcc1b038219f4$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $cf9fcc1b038219f4$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $cf9fcc1b038219f4$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $cf9fcc1b038219f4$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $cf9fcc1b038219f4$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $cf9fcc1b038219f4$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("gFzxn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c22c0aabeb22307b$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $c22c0aabeb22307b$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $c22c0aabeb22307b$export$2e2bcd8739ae039 = $c22c0aabeb22307b$var$tzPattern;

});



parcelRegister("bzFEY", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d3475c92a521d5$export$2e2bcd8739ae039);

var $dJe12 = parcelRequire("dJe12");

var $hPb5g = parcelRequire("hPb5g");
function $86d3475c92a521d5$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $hPb5g.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $dJe12.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});







parcelRegister("gKRfs", function(module, exports) {

$parcel$export(module.exports, "useNavigation", () => $77960e11f435f437$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useAppConfig", () => $77960e11f435f437$export$a3e0ece8c3f698d7);

var $32gz8 = parcelRequire("32gz8");

var $5v5PA = parcelRequire("5v5PA");

var $5v5PA = parcelRequire("5v5PA");
const $77960e11f435f437$export$d0fd4b7106de2769 = ()=>{
    const state = (0, $5v5PA.useNavigationState)();
    const actions = (0, $32gz8.useNavigationActions)();
    return {
        ...actions,
        ...state
    };
};
const $77960e11f435f437$export$a3e0ece8c3f698d7 = ()=>{
    const storeState = (0, $5v5PA.useAppConfigStoreState)();
    const navigation = $77960e11f435f437$export$d0fd4b7106de2769();
    const addFlag = (0, $32gz8.useAddFlag)();
    return {
        ...storeState,
        ...navigation,
        addFlag: addFlag
    };
};

});




parcelRegister("cWJwU", function(module, exports) {

$parcel$export(module.exports, "useLicenseCheck", () => $ad045cc30e912e48$export$710d990c66bc31bc);

var $5uXOq = parcelRequire("5uXOq");

var $hWg7l = parcelRequire("hWg7l");
var $6h0eh = parcelRequire("6h0eh");
const $ad045cc30e912e48$export$710d990c66bc31bc = (cloudId)=>{
    const [request, controller] = (0, $5uXOq.useMemo)(()=>(0, $hWg7l.requestWithAbort)(`/gateway/api/xflow/${cloudId}/license-information`, {
            method: 'GET'
        }), [
        cloudId
    ]);
    const [getLicenseCheck, result] = (0, $6h0eh.useLazyService)(request, controller);
    (0, $5uXOq.useEffect)(()=>{
        if (cloudId) getLicenseCheck();
    }, [
        cloudId,
        getLicenseCheck
    ]);
    return result;
};

});

parcelRegister("ewXsc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3f819eb90e4315c$export$2e2bcd8739ae039);
// TODO: PTC-2088 - simplify list of locales



























const $e3f819eb90e4315c$var$messagesConfig = [
    // Czech
    {
        locales: [
            'cs',
            'cs-CZ'
        ],
        loader: ()=>(parcelRequire("Ikvfn"))
    },
    // Danish
    {
        locales: [
            'da',
            'da-DK'
        ],
        loader: ()=>(parcelRequire("04uIG"))
    },
    // German
    {
        locales: [
            'de',
            'de-DE'
        ],
        loader: ()=>(parcelRequire("a4KRO"))
    },
    // Spain
    {
        locales: [
            'es',
            'es-ES'
        ],
        loader: ()=>(parcelRequire("bzInt"))
    },
    // Finnish
    {
        locales: [
            'fi',
            'fi-FI'
        ],
        loader: ()=>(parcelRequire("alvWG"))
    },
    // French
    {
        locales: [
            'fr',
            'fr-FR'
        ],
        loader: ()=>(parcelRequire("EHteK"))
    },
    // Hungarian
    {
        locales: [
            'hu',
            'hu-HU'
        ],
        loader: ()=>(parcelRequire("42QKD"))
    },
    // Icelandic
    {
        locales: [
            'is',
            'is-IS'
        ],
        loader: ()=>(parcelRequire("ivy5h"))
    },
    // Italian
    {
        locales: [
            'it',
            'it-IT'
        ],
        loader: ()=>(parcelRequire("aC21z"))
    },
    // Japanese
    {
        locales: [
            'ja',
            'ja-JP'
        ],
        loader: ()=>(parcelRequire("9dLax"))
    },
    // Korean
    {
        locales: [
            'ko',
            'ko-KR'
        ],
        loader: ()=>(parcelRequire("9LDV3"))
    },
    // Dutch
    {
        locales: [
            'nl',
            'nl-NL'
        ],
        loader: ()=>(parcelRequire("gHnwG"))
    },
    // Norwegian (Norway)
    {
        locales: [
            'nb',
            'nb-NO'
        ],
        loader: ()=>(parcelRequire("kA7F8"))
    },
    // Polish
    {
        locales: [
            'pl',
            'pl-PL'
        ],
        loader: ()=>(parcelRequire("gSmxL"))
    },
    // Portuguese -
    {
        locales: [
            'pt-BR'
        ],
        loader: ()=>(parcelRequire("8cVaa"))
    },
    // Romanian
    {
        locales: [
            'ro',
            'ro-RO'
        ],
        loader: ()=>(parcelRequire("azRDR"))
    },
    // Russian
    {
        locales: [
            'ru',
            'ru-RU'
        ],
        loader: ()=>(parcelRequire("8Vp2h"))
    },
    // Swedish
    {
        locales: [
            'sv',
            'sv-SE'
        ],
        loader: ()=>(parcelRequire("3sJQV"))
    },
    // China uses Chinese (Simplified)
    {
        locales: [
            'zh',
            'zh-CN',
            'zh-Hans'
        ],
        loader: ()=>(parcelRequire("jsN2W"))
    },
    // Taiwan or Hong Kong uses Chinese (Traditional)
    {
        locales: [
            'zh-TW',
            'zh-HK',
            'zh-Hant'
        ],
        loader: ()=>(parcelRequire("bg5Rn"))
    },
    // Turkish
    {
        locales: [
            'tr',
            'tr-TR'
        ],
        loader: ()=>(parcelRequire("dDNBw"))
    },
    // Thai
    {
        locales: [
            'th',
            'th-TH'
        ],
        loader: ()=>(parcelRequire("6WmdZ"))
    },
    // Ukrainian
    {
        locales: [
            'uk',
            'uk-UA'
        ],
        loader: ()=>(parcelRequire("dknzM"))
    },
    // Vietnamese
    {
        locales: [
            'vi',
            'vi-VN'
        ],
        loader: ()=>(parcelRequire("bQchw"))
    },
    // English (UK)
    {
        locales: [
            'en-GB'
        ],
        loader: ()=>(parcelRequire("6ZgFf"))
    },
    // English (US)
    {
        locales: [
            'en',
            'en-US'
        ],
        loader: ()=>(parcelRequire("clYv6"))
    },
    // English (Instrumented) used by i18n in staging
    {
        locales: [
            'en-ZZ'
        ],
        loader: ()=>(parcelRequire("SDA9L"))
    }
];
var $e3f819eb90e4315c$export$2e2bcd8739ae039 = $e3f819eb90e4315c$var$messagesConfig;

});
parcelRegister("Ikvfn", function(module, exports) {

let $085403a42e6a730f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $085403a42e6a730f$var$load("9Fk1b").then(()=>parcelRequire('ldp7B'));

});

parcelRegister("04uIG", function(module, exports) {

let $00d8342376788d82$var$load = (parcelRequire("28QjX"))(4);
module.exports = $00d8342376788d82$var$load("2BZqw").then(()=>parcelRequire('cEb7H'));

});

parcelRegister("a4KRO", function(module, exports) {

let $755ea1e2849370af$var$load = (parcelRequire("28QjX"))(4);
module.exports = $755ea1e2849370af$var$load("7C5Eq").then(()=>parcelRequire('lJZpy'));

});

parcelRegister("bzInt", function(module, exports) {

let $86d5630d8e131227$var$load = (parcelRequire("28QjX"))(4);
module.exports = $86d5630d8e131227$var$load("8C3LU").then(()=>parcelRequire('1yXKv'));

});

parcelRegister("alvWG", function(module, exports) {

let $7884a546dd1f9749$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7884a546dd1f9749$var$load("fgo7c").then(()=>parcelRequire('jjpT7'));

});

parcelRegister("EHteK", function(module, exports) {

let $07a574e3dc410764$var$load = (parcelRequire("28QjX"))(4);
module.exports = $07a574e3dc410764$var$load("c8CO7").then(()=>parcelRequire('gAW3D'));

});

parcelRegister("42QKD", function(module, exports) {

let $2f20449ba08cba31$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2f20449ba08cba31$var$load("kGCbs").then(()=>parcelRequire('diY9m'));

});

parcelRegister("ivy5h", function(module, exports) {

let $d7958faaebaba711$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d7958faaebaba711$var$load("7cZb2").then(()=>parcelRequire('cDWEB'));

});

parcelRegister("aC21z", function(module, exports) {

let $7b9f05fa7bc1741f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7b9f05fa7bc1741f$var$load("ayoaE").then(()=>parcelRequire('kDjtt'));

});

parcelRegister("9dLax", function(module, exports) {

let $6b69eab9900def3c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6b69eab9900def3c$var$load("1EXp5").then(()=>parcelRequire('5G87x'));

});

parcelRegister("9LDV3", function(module, exports) {

let $71c777f590e2db49$var$load = (parcelRequire("28QjX"))(4);
module.exports = $71c777f590e2db49$var$load("3mmrG").then(()=>parcelRequire('g7FbZ'));

});

parcelRegister("gHnwG", function(module, exports) {

let $c282e94f67850055$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c282e94f67850055$var$load("kjZwm").then(()=>parcelRequire('hevA3'));

});

parcelRegister("kA7F8", function(module, exports) {

let $efbd1d05b414bef6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $efbd1d05b414bef6$var$load("77uHS").then(()=>parcelRequire('23qMP'));

});

parcelRegister("gSmxL", function(module, exports) {

let $c4932d3262433893$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c4932d3262433893$var$load("ksumR").then(()=>parcelRequire('6YUPK'));

});

parcelRegister("8cVaa", function(module, exports) {

let $5f9bc914516c1d0a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5f9bc914516c1d0a$var$load("bpWcz").then(()=>parcelRequire('lX1N8'));

});

parcelRegister("azRDR", function(module, exports) {

let $7b36c8756c3b637a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7b36c8756c3b637a$var$load("3CGoh").then(()=>parcelRequire('b2xf7'));

});

parcelRegister("8Vp2h", function(module, exports) {

let $67f7112fd98587c7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $67f7112fd98587c7$var$load("ei2d9").then(()=>parcelRequire('7nDzI'));

});

parcelRegister("3sJQV", function(module, exports) {

let $28578dfe5c9bf8ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $28578dfe5c9bf8ca$var$load("eeKkV").then(()=>parcelRequire('fmF7L'));

});

parcelRegister("jsN2W", function(module, exports) {

let $e2b6ad77319fcc6e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e2b6ad77319fcc6e$var$load("c2ZGy").then(()=>parcelRequire('6gDcj'));

});

parcelRegister("bg5Rn", function(module, exports) {

let $8325bbfd56553e7a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8325bbfd56553e7a$var$load("cW05q").then(()=>parcelRequire('f5JFn'));

});

parcelRegister("dDNBw", function(module, exports) {

let $9ee5653810aff6f3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9ee5653810aff6f3$var$load("56j8G").then(()=>parcelRequire('bhsNK'));

});

parcelRegister("6WmdZ", function(module, exports) {

let $50d966352c0597da$var$load = (parcelRequire("28QjX"))(4);
module.exports = $50d966352c0597da$var$load("7rqgS").then(()=>parcelRequire('8DP43'));

});

parcelRegister("dknzM", function(module, exports) {

let $9b3f6e55557eaa80$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9b3f6e55557eaa80$var$load("5QHM0").then(()=>parcelRequire('lhHw4'));

});

parcelRegister("bQchw", function(module, exports) {

let $89ee13e6b816de36$var$load = (parcelRequire("28QjX"))(4);
module.exports = $89ee13e6b816de36$var$load("7TPpx").then(()=>parcelRequire('aPPcs'));

});

parcelRegister("6ZgFf", function(module, exports) {

let $51655dc0a6cb6713$var$load = (parcelRequire("28QjX"))(4);
module.exports = $51655dc0a6cb6713$var$load("7K5qC").then(()=>parcelRequire('h9p3s'));

});

parcelRegister("clYv6", function(module, exports) {

let $8fe6605e54cb300c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8fe6605e54cb300c$var$load("aoBJN").then(()=>parcelRequire('eNtnc'));

});

parcelRegister("SDA9L", function(module, exports) {

let $0a43bf7459d5d049$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0a43bf7459d5d049$var$load("bCmA5").then(()=>parcelRequire('L7hge'));

});


parcelRegister("52kuW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a03d916914add299$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fCZyz = parcelRequire("fCZyz");
var $heJqE = parcelRequire("heJqE");
var $fj1sb = parcelRequire("fj1sb");

var $W11xX = parcelRequire("W11xX");

var $17JOF = parcelRequire("17JOF");

var $gOnVe = parcelRequire("gOnVe");

var $8VgL2 = parcelRequire("8VgL2");

var $2ZwzQ = parcelRequire("2ZwzQ");

var $3w4by = parcelRequire("3w4by");

var $jc4mG = parcelRequire("jc4mG");

var $5vxza = parcelRequire("5vxza");

var $dSoDN = parcelRequire("dSoDN");

var $7toiV = parcelRequire("7toiV");

var $fWVIY = parcelRequire("fWVIY");

var $fl2tR = parcelRequire("fl2tR");

var $fNxAa = parcelRequire("fNxAa");
// Team Profile
// Kudos
const $a03d916914add299$var$renderRoutes = (contextEntryPoint, canViewTeams)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $fj1sb.default), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCZyz.default), {
                exact: true,
                path: `${contextEntryPoint}/`,
                render: (0, $2ZwzQ.default)
            }),
            !canViewTeams && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCZyz.default), {
                path: `${contextEntryPoint}/search/teams`,
                render: (0, $5vxza.default)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCZyz.default), {
                path: `${contextEntryPoint}/search`,
                render: (0, $jc4mG.default)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCZyz.default), {
                path: `${contextEntryPoint}/kudos/:uuid`,
                render: (0, $gOnVe.default)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCZyz.default), {
                exact: true,
                path: `${contextEntryPoint}/team`,
                render: (0, $7toiV.default)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3w4by.RouteWithOrgIdLoading), {
                path: `${contextEntryPoint}/team/:teamId`,
                render: (0, $dSoDN.default)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCZyz.default), {
                path: `${contextEntryPoint}/agent/:agentId`,
                render: (0, $17JOF.default)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCZyz.default), {
                path: `${contextEntryPoint}/:userId/work`,
                render: (0, $fNxAa.default)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCZyz.default), {
                path: `${contextEntryPoint}/:userId/*`,
                render: (0, $fl2tR.default)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCZyz.default), {
                path: `${contextEntryPoint}/me`,
                render: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $8VgL2.default), {
                        ...props,
                        contextEntryPoint: contextEntryPoint
                    })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCZyz.default), {
                path: `${contextEntryPoint}/:userId`,
                render: (0, $fWVIY.default)
            })
        ]
    });
};
function $a03d916914add299$var$AppRoutes(props) {
    const { contextEntryPoint: contextEntryPoint, history: history, onTransition: onTransition } = props;
    const { permissions: { canViewTeams: canViewTeams } } = (0, $W11xX.useTeamVisibility)();
    (0, $5uXOq.useEffect)(()=>{
        if (!onTransition) return;
        let unsubscribeBlockingHistory = ()=>{};
        let unsubscribeListeningHistory = ()=>{};
        if (history) {
            let lastHistoryLocation;
            unsubscribeListeningHistory = history.listen(({ pathname: pathname })=>{
                lastHistoryLocation = pathname;
            });
            // We're using history.block() here instead of history.listen()
            // because we want this to run BEFORE transition happens.
            unsubscribeBlockingHistory = history.block(({ pathname: pathname })=>{
                if (lastHistoryLocation !== pathname) onTransition(pathname);
            });
        }
        return ()=>{
            unsubscribeBlockingHistory();
            unsubscribeListeningHistory();
        };
    }, [
        onTransition,
        history
    ]);
    const routes = $a03d916914add299$var$renderRoutes(contextEntryPoint, canViewTeams);
    // If `history` object is not passed to `EmbeddableDirectory`, `EmbeddableDirectory` will use `Router` component from product in higher component tree.
    // If `history` object is passed to `EmbeddableDirectory`, `EmbeddableDirectory` will render its own `Router` component.
    // @ts-ignore - Property 'children' does not exist on type 'IntrinsicAttributes & IntrinsicClassAttributes<Router> & Readonly<RouterProps>'
    // This was added when enrolling `@atlassian/ptc-embeddable-directory` into JFE local consumption
    return history ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $heJqE.default), {
        history: history,
        children: routes
    }) : routes;
}
var $a03d916914add299$export$2e2bcd8739ae039 = $a03d916914add299$var$AppRoutes;

});
parcelRegister("fCZyz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b60a277c7a1030b5$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $e0XoQ = parcelRequire("e0XoQ");
var $b60a277c7a1030b5$export$2e2bcd8739ae039 = (0, $e0XoQ.default);

});
parcelRegister("e0XoQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a33f2454f0f795a6$export$2e2bcd8739ae039);

var $hBYjV = parcelRequire("hBYjV");

var $aE1Lc = parcelRequire("aE1Lc");

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");

var $70VoX = parcelRequire("70VoX");
var $a33f2454f0f795a6$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $a33f2454f0f795a6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a33f2454f0f795a6$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a33f2454f0f795a6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a33f2454f0f795a6$var$isEmptyChildren = function isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.count(children) === 0;
};
/**
 * The public API for matching a single path and rendering.
 */ var $a33f2454f0f795a6$var$Route = function(_React$Component) {
    $a33f2454f0f795a6$var$_inherits(Route, _React$Component);
    function Route() {
        var _temp, _this, _ret;
        $a33f2454f0f795a6$var$_classCallCheck(this, Route);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $a33f2454f0f795a6$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props, _this.context.router)
        }, _temp), $a33f2454f0f795a6$var$_possibleConstructorReturn(_this, _ret);
    }
    Route.prototype.getChildContext = function getChildContext() {
        return {
            router: $a33f2454f0f795a6$var$_extends({}, this.context.router, {
                route: {
                    location: this.props.location || this.context.router.route.location,
                    match: this.state.match
                }
            })
        };
    };
    Route.prototype.computeMatch = function computeMatch(_ref, router) {
        var computedMatch = _ref.computedMatch, location = _ref.location, path = _ref.path, strict = _ref.strict, exact = _ref.exact, sensitive = _ref.sensitive;
        if (computedMatch) return computedMatch; // <Switch> already computed the match for us
        (0, (/*@__PURE__*/$parcel$interopDefault($aE1Lc)))(router, "You should not use <Route> or withRouter() outside a <Router>");
        var route = router.route;
        var pathname = (location || route.location).pathname;
        return (0, $70VoX.default)(pathname, {
            path: path,
            strict: strict,
            exact: exact,
            sensitive: sensitive
        }, route.match);
    };
    Route.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(!(this.props.component && this.props.children && !$a33f2454f0f795a6$var$isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(!(this.props.render && this.props.children && !$a33f2454f0f795a6$var$isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
    };
    Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
        this.setState({
            match: this.computeMatch(nextProps, nextContext.router)
        });
    };
    Route.prototype.render = function render() {
        var match = this.state.match;
        var _props = this.props, children = _props.children, component = _props.component, render = _props.render;
        var _context$router = this.context.router, history = _context$router.history, route = _context$router.route, staticContext = _context$router.staticContext;
        var location = this.props.location || route.location;
        var props = {
            match: match,
            location: location,
            history: history,
            staticContext: staticContext
        };
        if (component) return match ? (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(component, props) : null;
        if (render) return match ? render(props) : null;
        if (typeof children === "function") return children(props);
        if (children && !$a33f2454f0f795a6$var$isEmptyChildren(children)) return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(children);
        return null;
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component);
$a33f2454f0f795a6$var$Route.propTypes = {
    computedMatch: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object,
    path: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).string,
    exact: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).bool,
    strict: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).bool,
    sensitive: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).bool,
    component: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func,
    render: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).node
    ]),
    location: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object
};
$a33f2454f0f795a6$var$Route.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object.isRequired,
        route: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object.isRequired,
        staticContext: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object
    })
};
$a33f2454f0f795a6$var$Route.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object.isRequired
};
var $a33f2454f0f795a6$export$2e2bcd8739ae039 = $a33f2454f0f795a6$var$Route;

});
parcelRegister("70VoX", function(module, exports) {

$parcel$export(module.exports, "default", () => $51b50f39010f1f0a$export$2e2bcd8739ae039);

var $d4Ora = parcelRequire("d4Ora");
var $51b50f39010f1f0a$var$patternCache = {};
var $51b50f39010f1f0a$var$cacheLimit = 10000;
var $51b50f39010f1f0a$var$cacheCount = 0;
var $51b50f39010f1f0a$var$compilePath = function compilePath(pattern, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var cache = $51b50f39010f1f0a$var$patternCache[cacheKey] || ($51b50f39010f1f0a$var$patternCache[cacheKey] = {});
    if (cache[pattern]) return cache[pattern];
    var keys = [];
    var re = (0, (/*@__PURE__*/$parcel$interopDefault($d4Ora)))(pattern, keys, options);
    var compiledPattern = {
        re: re,
        keys: keys
    };
    if ($51b50f39010f1f0a$var$cacheCount < $51b50f39010f1f0a$var$cacheLimit) {
        cache[pattern] = compiledPattern;
        $51b50f39010f1f0a$var$cacheCount++;
    }
    return compiledPattern;
};
/**
 * Public API for matching a URL pathname to a path pattern.
 */ var $51b50f39010f1f0a$var$matchPath = function matchPath(pathname) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var parent = arguments[2];
    if (typeof options === "string") options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === undefined ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === undefined ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === undefined ? false : _options$sensitive;
    if (path == null) return parent;
    var _compilePath = $51b50f39010f1f0a$var$compilePath(path, {
        end: exact,
        strict: strict,
        sensitive: sensitive
    }), re = _compilePath.re, keys = _compilePath.keys;
    var match = re.exec(pathname);
    if (!match) return null;
    var url = match[0], values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
        path: path,
        url: path === "/" && url === "" ? "/" : url,
        isExact: isExact,
        params: keys.reduce(function(memo, key, index) {
            memo[key.name] = values[index];
            return memo;
        }, {})
    };
};
var $51b50f39010f1f0a$export$2e2bcd8739ae039 = $51b50f39010f1f0a$var$matchPath;

});
parcelRegister("d4Ora", function(module, exports) {

var $oJ7gO = parcelRequire("oJ7gO");
/**
 * Expose `pathToRegexp`.
 */ module.exports = $9852c5da38ba91d1$var$pathToRegexp;
module.exports.parse = $9852c5da38ba91d1$var$parse;
module.exports.compile = $9852c5da38ba91d1$var$compile;
module.exports.tokensToFunction = $9852c5da38ba91d1$var$tokensToFunction;
module.exports.tokensToRegExp = $9852c5da38ba91d1$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $9852c5da38ba91d1$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $9852c5da38ba91d1$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $9852c5da38ba91d1$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $9852c5da38ba91d1$var$escapeGroup(pattern) : asterisk ? '.*' : $9852c5da38ba91d1$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $9852c5da38ba91d1$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $9852c5da38ba91d1$var$escapeString(delimiter) + ']+?';
    return $9852c5da38ba91d1$var$escapeString(prevText) + '|(?:(?!' + $9852c5da38ba91d1$var$escapeString(prevText) + ')[^' + $9852c5da38ba91d1$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $9852c5da38ba91d1$var$compile(str, options) {
    return $9852c5da38ba91d1$var$tokensToFunction($9852c5da38ba91d1$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $9852c5da38ba91d1$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $9852c5da38ba91d1$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $9852c5da38ba91d1$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $9852c5da38ba91d1$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $9852c5da38ba91d1$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($oJ7gO(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $9852c5da38ba91d1$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $9852c5da38ba91d1$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $9852c5da38ba91d1$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $9852c5da38ba91d1$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $9852c5da38ba91d1$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($9852c5da38ba91d1$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $9852c5da38ba91d1$var$flags(options));
    return $9852c5da38ba91d1$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$stringToRegexp(path, keys, options) {
    return $9852c5da38ba91d1$var$tokensToRegExp($9852c5da38ba91d1$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$tokensToRegExp(tokens, keys, options) {
    if (!$oJ7gO(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $9852c5da38ba91d1$var$escapeString(token);
        else {
            var prefix = $9852c5da38ba91d1$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $9852c5da38ba91d1$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $9852c5da38ba91d1$var$attachKeys(new RegExp('^' + route, $9852c5da38ba91d1$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $9852c5da38ba91d1$var$pathToRegexp(path, keys, options) {
    if (!$oJ7gO(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $9852c5da38ba91d1$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($oJ7gO(path)) return $9852c5da38ba91d1$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $9852c5da38ba91d1$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});
parcelRegister("oJ7gO", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

});





parcelRegister("heJqE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8c6fbb4471fedde$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $12Lcw = parcelRequire("12Lcw");
var $c8c6fbb4471fedde$export$2e2bcd8739ae039 = (0, $12Lcw.default);

});
parcelRegister("12Lcw", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c2a978068c36407$export$2e2bcd8739ae039);

var $hBYjV = parcelRequire("hBYjV");

var $aE1Lc = parcelRequire("aE1Lc");

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");
var $0c2a978068c36407$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $0c2a978068c36407$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0c2a978068c36407$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $0c2a978068c36407$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for putting history on context.
 */ var $0c2a978068c36407$var$Router = function(_React$Component) {
    $0c2a978068c36407$var$_inherits(Router, _React$Component);
    function Router() {
        var _temp, _this, _ret;
        $0c2a978068c36407$var$_classCallCheck(this, Router);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $0c2a978068c36407$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props.history.location.pathname)
        }, _temp), $0c2a978068c36407$var$_possibleConstructorReturn(_this, _ret);
    }
    Router.prototype.getChildContext = function getChildContext() {
        return {
            router: $0c2a978068c36407$var$_extends({}, this.context.router, {
                history: this.props.history,
                route: {
                    location: this.props.history.location,
                    match: this.state.match
                }
            })
        };
    };
    Router.prototype.computeMatch = function computeMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    Router.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        var _props = this.props, children = _props.children, history = _props.history;
        (0, (/*@__PURE__*/$parcel$interopDefault($aE1Lc)))(children == null || (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.count(children) === 1, "A <Router> may have only one child element");
        // Do this here so we can setState when a <Redirect> changes the
        // location in componentWillMount. This happens e.g. when doing
        // server rendering using a <StaticRouter>.
        this.unlisten = history.listen(function() {
            _this2.setState({
                match: _this2.computeMatch(history.location.pathname)
            });
        });
    };
    Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(this.props.history === nextProps.history, "You cannot change <Router history>");
    };
    Router.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unlisten();
    };
    Router.prototype.render = function render() {
        var children = this.props.children;
        return children ? (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(children) : null;
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component);
$0c2a978068c36407$var$Router.propTypes = {
    history: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).node
};
$0c2a978068c36407$var$Router.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object
};
$0c2a978068c36407$var$Router.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object.isRequired
};
var $0c2a978068c36407$export$2e2bcd8739ae039 = $0c2a978068c36407$var$Router;

});


parcelRegister("fj1sb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b249c201006a228b$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $hd3Qv = parcelRequire("hd3Qv");
var $b249c201006a228b$export$2e2bcd8739ae039 = (0, $hd3Qv.default);

});
parcelRegister("hd3Qv", function(module, exports) {

$parcel$export(module.exports, "default", () => $c876a245a4c7da8b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");

var $hBYjV = parcelRequire("hBYjV");

var $aE1Lc = parcelRequire("aE1Lc");

var $70VoX = parcelRequire("70VoX");
function $c876a245a4c7da8b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c876a245a4c7da8b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $c876a245a4c7da8b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for rendering the first <Route> that matches.
 */ var $c876a245a4c7da8b$var$Switch = function(_React$Component) {
    $c876a245a4c7da8b$var$_inherits(Switch, _React$Component);
    function Switch() {
        $c876a245a4c7da8b$var$_classCallCheck(this, Switch);
        return $c876a245a4c7da8b$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Switch.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($aE1Lc)))(this.context.router, "You should not use <Switch> outside a <Router>");
    };
    Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
    };
    Switch.prototype.render = function render() {
        var route = this.context.router.route;
        var children = this.props.children;
        var location = this.props.location || route.location;
        var match = void 0, child = void 0;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.forEach(children, function(element) {
            if (match == null && (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(element)) {
                var _element$props = element.props, pathProp = _element$props.path, exact = _element$props.exact, strict = _element$props.strict, sensitive = _element$props.sensitive, from = _element$props.from;
                var path = pathProp || from;
                child = element;
                match = (0, $70VoX.default)(location.pathname, {
                    path: path,
                    exact: exact,
                    strict: strict,
                    sensitive: sensitive
                }, route.match);
            }
        });
        return match ? (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(child, {
            location: location,
            computedMatch: match
        }) : null;
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component);
$c876a245a4c7da8b$var$Switch.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).shape({
        route: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object.isRequired
    }).isRequired
};
$c876a245a4c7da8b$var$Switch.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).node,
    location: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).object
};
var $c876a245a4c7da8b$export$2e2bcd8739ae039 = $c876a245a4c7da8b$var$Switch;

});


parcelRegister("W11xX", function(module, exports) {

$parcel$export(module.exports, "useTeamVisibility", () => $8792faa9484f774e$export$acf57ff2f92f51c1);

var $5uXOq = parcelRequire("5uXOq");

var $js2Ve = parcelRequire("js2Ve");

var $98eWh = parcelRequire("98eWh");

var $WUBOW = parcelRequire("WUBOW");

var $7Sf9H = parcelRequire("7Sf9H");

var $1geG0 = parcelRequire("1geG0");

var $a4jrI = parcelRequire("a4jrI");
const $8792faa9484f774e$export$7d97a022bd09a6fb = ()=>{
    return {
        isTeamsVisiblityEnabled: true,
        failOpenSites: false
    };
};
const $8792faa9484f774e$var$useTeamPermissionsAnalytics = ({ data: data, error: error, permissions: permissions })=>{
    const { fireEvent: fireEvent } = (0, $js2Ve.usePeopleTeamAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (error) {
            (0, $WUBOW.logException)(error, 'Error loading team permissions in useTeamsPermissionsService');
            const { status: status, path: path } = error instanceof Error ? {
                status: 'unknown',
                path: 'unknown'
            } : error;
            fireEvent('operational.teamsPermissionsRequest.failed', {
                message: error.message,
                status: status,
                path: path
            });
        }
    }, [
        error,
        fireEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (data && permissions) fireEvent('operational.teamsPermissionsRequest.succeeded', {
            canCreateTeams: permissions.canCreateTeams,
            canViewTeams: permissions.canViewTeams,
            canAdminTeams: !!permissions.canAdminTeams
        });
    }, [
        data,
        fireEvent,
        permissions
    ]);
};
const $8792faa9484f774e$export$acf57ff2f92f51c1 = ()=>{
    const { orgId: orgId } = (0, $7Sf9H.useV3OrgIdStatus)();
    const [{ cloudId: cloudId }] = (0, $a4jrI.useSite)();
    const [{ principalUserId: principalUserId }] = (0, $1geG0.usePrincipalUser)();
    const result = (0, $98eWh.useTeamsPermissionsService)({
        orgId: orgId,
        cloudId: cloudId
    }, {
        // Wait for cloudId to be available before making the request
        enabled: !!cloudId,
        attributes: {
            userId: principalUserId
        }
    });
    $8792faa9484f774e$var$useTeamPermissionsAnalytics(result);
    return {
        isLoading: !cloudId || result.isLoading,
        permissions: result.permissions
    };
};

});
parcelRegister("js2Ve", function(module, exports) {

$parcel$export(module.exports, "usePeopleTeamAnalyticsEvents", () => $86c34708c01ec26b$export$48acf7e27d4331f);
$parcel$export(module.exports, "useTeamsExperienceTracker", () => $86c34708c01ec26b$export$5792e6ebc464482e);

var $5uXOq = parcelRequire("5uXOq");

var $lbMXQ = parcelRequire("lbMXQ");

var $6j2T3 = parcelRequire("6j2T3");

var $1iXG7 = parcelRequire("1iXG7");

var $i7KZ5 = parcelRequire("i7KZ5");
const $86c34708c01ec26b$export$48acf7e27d4331f = ()=>{
    const [{ eventAttributes: injectedEventAttributes }, { setEventAttributes: setEventAttributes }] = (0, $lbMXQ.usePeopleTeamsAnalyticsSubcontext)();
    const { fireEvent: fireEvent } = (0, $1iXG7.useAnalyticsEvents)();
    const fireEventWithSubcontextAttributesInjected = (0, $5uXOq.useCallback)((...params)=>{
        const [event, attributes] = params;
        const eventWithSubcontextAttributes = {
            ...attributes,
            ...injectedEventAttributes
        };
        // @ts-ignore allow injecting subcontext attributes
        fireEvent(event, eventWithSubcontextAttributes);
    }, [
        fireEvent,
        injectedEventAttributes
    ]);
    return {
        fireEvent: fireEventWithSubcontextAttributesInjected,
        setInjectedEventAttributes: setEventAttributes
    };
};
const $86c34708c01ec26b$export$b72f2eb2a11f7b8 = ()=>(0, $i7KZ5.useAnalyticsEventsWithTags)();
const $86c34708c01ec26b$export$5792e6ebc464482e = ()=>{
    const { fireEvent: fireEvent } = $86c34708c01ec26b$export$48acf7e27d4331f();
    const fireExperienceEvent = (0, $5uXOq.useCallback)((action, subject, attributes)=>{
        // @ts-ignore TODO: we may need to declare the keys to a const in the types file so we can do a check here
        fireEvent(`operational.${subject.replace(/[\/-]/g, '_')}.${action}`, {
            ...attributes,
            source: 'clientMetrics'
        });
    }, [
        fireEvent
    ]);
    const experienceTracker = (0, $5uXOq.useMemo)(()=>(0, $6j2T3.createTeamsExperienceTracker)(fireExperienceEvent), [
        fireExperienceEvent
    ]);
    return experienceTracker;
};

});
parcelRegister("lbMXQ", function(module, exports) {

$parcel$export(module.exports, "usePeopleTeamsAnalyticsSubcontext", () => $1f37af346f421238$export$86448e866930ba8d);
$parcel$export(module.exports, "useInjectedEventAttribute", () => $1f37af346f421238$export$831917a198e22e70);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $1f37af346f421238$var$initialState = {
    eventAttributes: {}
};
const $1f37af346f421238$var$actions = {
    setEventAttributes: (eventAttributes)=>({ setState: setState, getState: getState })=>{
            const existingEventAttributes = getState().eventAttributes;
            const newEventAttributes = {
                ...existingEventAttributes,
                ...eventAttributes
            };
            Object.keys(newEventAttributes).forEach((keyString)=>{
                const key = keyString;
                if (newEventAttributes[key] === undefined) delete newEventAttributes[key];
            });
            setState({
                eventAttributes: newEventAttributes
            });
        }
};
const $1f37af346f421238$var$AnalyticsSubcontextStore = (0, $iXqE5.createStore)({
    initialState: $1f37af346f421238$var$initialState,
    actions: $1f37af346f421238$var$actions
});
const $1f37af346f421238$export$86448e866930ba8d = (0, $3sQ5x.createHook)($1f37af346f421238$var$AnalyticsSubcontextStore);
const $1f37af346f421238$export$831917a198e22e70 = (key, value)=>{
    const { setEventAttributes: setEventAttributes } = $1f37af346f421238$export$86448e866930ba8d()[1];
    (0, $5uXOq.useEffect)(()=>{
        setEventAttributes({
            [key]: value
        });
        return ()=>setEventAttributes({
                [key]: undefined
            });
    }, [
        key,
        value,
        setEventAttributes
    ]);
};

});

parcelRegister("6j2T3", function(module, exports) {

$parcel$export(module.exports, "createTeamsExperienceTracker", () => $360bf8bfa40c92c9$export$c0c885a04612b38d);

var $cBeZP = parcelRequire("cBeZP");

var $jNZqv = parcelRequire("jNZqv");

var $hnty1 = parcelRequire("hnty1");
function $360bf8bfa40c92c9$export$c0c885a04612b38d(fireExperienceEvent, options) {
    const tracker = new (0, $jNZqv.TeamsExperienceTracker)({
        isNetworkOfflineError: (0, $hnty1.isNetworkError)
    });
    tracker.subscribe((event)=>{
        if (event.action === 'taskStart' || event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail') {
            const performanceAttributes = (0, $hnty1.computePerformanceAttributes)(event);
            const errorAttributes = (0, $hnty1.computeErrorAttributes)(event);
            const finalErrorDetails = Object.assign(errorAttributes, performanceAttributes, event.attributes, {
                // Because standalone app is deployed to prod quickly,
                // we will use this attribute to query in Splunk sooner.
                isStandalone: !!options?.isStandalone,
                hasBrowseUsersPermission: !!options?.hasBrowseUsersPermission
            });
            fireExperienceEvent(event.action, event.name, finalErrorDetails);
            if (event.action === 'taskFail' && options?.logErrorMessage) options.logErrorMessage(`taskFail:${event.name}`, finalErrorDetails);
        }
    });
    (0, $cBeZP.bindAll)(window, [
        {
            type: 'unload',
            listener: ()=>tracker.abort({
                    reason: 'Abort due to Window unloading',
                    attributes: {
                        cause: 'WINDOW_UNLOAD'
                    }
                })
        },
        {
            type: 'pagehide',
            listener: ()=>{
                tracker.abort({
                    reason: 'Window unloading',
                    attributes: {
                        cause: 'PAGE_HIDE'
                    }
                });
            }
        }
    ]);
    return tracker;
}

});
parcelRegister("jNZqv", function(module, exports) {

$parcel$export(module.exports, "TeamsExperienceTracker", () => $c41144d779250526$export$9e9a48cf2c297bd1);

var $bFNgM = parcelRequire("bFNgM");

var $d7dku = parcelRequire("d7dku");
class $c41144d779250526$export$9e9a48cf2c297bd1 extends (0, $bFNgM.ExperienceTracker) {
    _errorNameInIgnoredList(error) {
        const name = error && error.constructor.name;
        return this._ignoredErrors.includes(name) ? name : undefined;
    }
    constructor(options){
        super(options), // error names here will also be sent in the attribute `cause`
        this._ignoredErrors = [
            'SentryIgnoreError'
        ];
    }
    stopOnError({ name: name, error: error }) {
        if ((0, $d7dku.isAuthError)(error)) {
            this.abort({
                name: name,
                reason: 'Abort due to user unauthenticated',
                attributes: {
                    cause: 'USER_UNAUTHENTICATED',
                    error: error
                },
                checkForTimeout: false
            });
            return;
        }
        if ((0, $d7dku.isErrorStatusCode)((0, $d7dku.StatusCode).GONE, error)) {
            this.abort({
                name: name,
                reason: 'Abort due to unavailable resource',
                attributes: {
                    cause: 'GONE',
                    error: error
                },
                checkForTimeout: false
            });
            return;
        }
        const ignoredErrorName = this._errorNameInIgnoredList(error);
        if (ignoredErrorName) {
            this.abort({
                name: name,
                reason: 'Abort due to an error in ignore list',
                attributes: {
                    cause: ignoredErrorName
                },
                checkForTimeout: false
            });
            return;
        }
        super.stopOnError({
            name: name,
            error: error
        });
    }
}

});
parcelRegister("d7dku", function(module, exports) {

$parcel$export(module.exports, "StatusCode", () => $f9654bd48f9e2162$export$f66f92b8741acd5b);
$parcel$export(module.exports, "isAuthError", () => $f9654bd48f9e2162$export$cde1786a482f9a1c);
$parcel$export(module.exports, "isErrorStatusCode", () => $f9654bd48f9e2162$export$9677d7c364ada66c);
var $f9654bd48f9e2162$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
function $f9654bd48f9e2162$export$cde1786a482f9a1c(error) {
    return $f9654bd48f9e2162$export$9677d7c364ada66c(401, error) || $f9654bd48f9e2162$export$9677d7c364ada66c(403, error);
}
function $f9654bd48f9e2162$export$9677d7c364ada66c(statusCode, error) {
    if (!error) return false;
    if (error['status'] === statusCode || error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!error?.message?.match(reg);
}

});


parcelRegister("hnty1", function(module, exports) {

$parcel$export(module.exports, "isNetworkError", () => $62ce1cca8e4440e5$export$476aa014e2fd89d5);
$parcel$export(module.exports, "computeErrorAttributes", () => $62ce1cca8e4440e5$export$5e7501d1cb9a5aa0);
$parcel$export(module.exports, "computePerformanceAttributes", () => $62ce1cca8e4440e5$export$b978343735080139);

var $8YP6t = parcelRequire("8YP6t");
function $62ce1cca8e4440e5$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    !!(error['graphQLErrors'] && error['networkError']));
}
function $62ce1cca8e4440e5$export$5e7501d1cb9a5aa0(event) {
    const attributes = {};
    if ($62ce1cca8e4440e5$var$isFailEvent(event)) attributes.failError = event.error;
    if ($62ce1cca8e4440e5$var$isAbortEvent(event)) attributes.abortReason = event.reason;
    return attributes;
}
function $62ce1cca8e4440e5$export$b978343735080139(event) {
    if ($62ce1cca8e4440e5$var$isStopEvent(event)) {
        const duration = event.duration;
        const latencySlo = event.attributes && $62ce1cca8e4440e5$var$hasLatencySLO(event.attributes) && event.attributes['latencySlo'];
        if (typeof duration !== 'number' || typeof latencySlo !== 'number') return {};
        return {
            sloSatisfied: duration <= latencySlo,
            taskDuration: duration,
            latencySlo: latencySlo
        };
    }
    return {};
}
function $62ce1cca8e4440e5$var$isStopEvent(e) {
    return (0, $8YP6t.isStop)(e);
}
function $62ce1cca8e4440e5$var$isFailEvent(e) {
    return e.action === 'taskFail';
}
function $62ce1cca8e4440e5$var$isAbortEvent(e) {
    return e.action === 'taskAbort';
}
function $62ce1cca8e4440e5$var$hasLatencySLO(attributes) {
    return Object(attributes).hasOwnProperty('latencySlo');
}

});
parcelRegister("8YP6t", function(module, exports) {

$parcel$export(module.exports, "isStop", () => $06d5a4008844e7f5$export$16e3f1b03b231b35);
$parcel$export(module.exports, "hasName", () => $06d5a4008844e7f5$export$57069f5b2ecc9128);
const $06d5a4008844e7f5$export$16e3f1b03b231b35 = (event)=>event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';
const $06d5a4008844e7f5$export$57069f5b2ecc9128 = (event, ...names)=>names.includes(event.name);

});



parcelRegister("1iXG7", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $846adb04960e5acf$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::c3d283871d950ad96ce62ded8c21524b>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen people-teams-ui
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $6uOvM = parcelRequire("6uOvM");

var $aUhvd = parcelRequire("aUhvd");
const $846adb04960e5acf$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fireEvent = (0, $5uXOq.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $aUhvd.default)(...params));
        event.fire((0, $6uOvM.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
parcelRegister("6uOvM", function(module, exports) {

$parcel$export(module.exports, "EVENT_CHANNEL", () => $b6acdfd48604f39c$export$3f072f06b90c3985);

var $c9l08 = parcelRequire("c9l08");
const $b6acdfd48604f39c$export$3f072f06b90c3985 = (0, $c9l08.FabricChannel).peopleTeams;

});

parcelRegister("aUhvd", function(module, exports) {

$parcel$export(module.exports, "default", () => $017eef91f510c6d9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::f6bdf2649443a00944d1014ec7e17d50>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen people-teams-ui
 */ const $017eef91f510c6d9$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $017eef91f510c6d9$export$2e2bcd8739ae039 = $017eef91f510c6d9$var$createEventPayload;

});


parcelRegister("i7KZ5", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEventsWithTags", () => $8e20d334dc78b253$export$e8e0cef07f76dd91);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $6uOvM = parcelRequire("6uOvM");

var $aUhvd = parcelRequire("aUhvd");
const $8e20d334dc78b253$export$e8e0cef07f76dd91 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fireEventWithTags = (0, $5uXOq.useCallback)((tags, ...params)=>{
        const event = createAnalyticsEvent((0, $aUhvd.default)(...params));
        if (event.payload) event.payload.tags = tags;
        event.fire((0, $6uOvM.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEventWithTags: fireEventWithTags
    };
};

});


parcelRegister("7Sf9H", function(module, exports) {

$parcel$export(module.exports, "useV3OrgIdStatus", () => $b8e5902c657d1794$export$52558c271a487a01);

var $1lfNR = parcelRequire("1lfNR");
function $b8e5902c657d1794$export$52558c271a487a01() {
    const [{ orgId: orgId }] = (0, $1lfNR.useOrg)();
    return {
        orgId: orgId,
        isOrgLoading: !orgId
    };
}

});

parcelRegister("1geG0", function(module, exports) {

$parcel$export(module.exports, "usePrincipalUser", () => $5125506ab7d6645a$export$33e3bf16c7530dd4);
$parcel$export(module.exports, "useAvatarUploadedStatus", () => $5125506ab7d6645a$export$b26d2c7f264f51a8);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $2Ixyh = parcelRequire("2Ixyh");
var $hhuKf = parcelRequire("hhuKf");
// Private actions:
// It is called by `getPrincipalUserInfo` action
const $5125506ab7d6645a$var$getIsSiteAdmin = (cloudId)=>async ({ setState: setState })=>{
        if (!cloudId) {
            setState({
                isSiteAdmin: false
            });
            return;
        }
        let isSiteAdmin = false;
        try {
            isSiteAdmin = await (0, $2Ixyh.teamsClient).getIsSiteAdmin(cloudId);
        } catch (e) {
        // do nothing because isSiteAdmin is returned as false
        } finally{
            setState({
                isSiteAdmin: isSiteAdmin
            });
        }
    };
// it is called by `getPrincipalUserInfo` action
const $5125506ab7d6645a$var$getMutability = (userId)=>async ({ setState: setState })=>{
        try {
            const data = await (0, $2Ixyh.teamsClient).getProfileWithMutability(userId);
            setState({
                mutabilityConstraints: data
            });
        } catch (e) {
        // do nothing because isSiteAdmin is returned as false
        }
    };
const $5125506ab7d6645a$var$getAvatarUploadedStatus = (userId)=>async ({ setState: setState })=>{
        try {
            setState({
                avatarUploaded: {
                    isLoading: true,
                    error: undefined,
                    uploaded: undefined
                }
            });
            const data = await (0, $2Ixyh.teamsClient).getMyAvatarUploadedStatus(userId);
            setState({
                avatarUploaded: {
                    isLoading: false,
                    uploaded: data.uploaded
                }
            });
        } catch (e) {
            setState({
                avatarUploaded: {
                    isLoading: false,
                    error: e instanceof Error ? e : new Error('Unknown error'),
                    uploaded: undefined
                }
            });
        }
    };
const $5125506ab7d6645a$var$actions = {
    /**
	 * Get user information of current logged-in user.
	 * @param cloudId: If Cloud Id is passed, that means People Directory is rendered in a site and we use Cloud Id to check 'isSiteAdmin' info.
	 * If Cloud Id is not passed, `isSiteAdmin` is false by default.
	 */ getPrincipalUserInfo: (cloudId)=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            // stop fetching when it is already fetched
            if (getState().isFetching || getState().hasLoaded) return;
            setState({
                isFetching: true,
                hasLoaded: false
            });
            try {
                const userBasicData = await (0, $hhuKf.userInfoProvider).get();
                setState({
                    principalUserId: userBasicData.userId,
                    ...userBasicData
                });
                dispatch($5125506ab7d6645a$var$getIsSiteAdmin(cloudId));
                dispatch($5125506ab7d6645a$var$getMutability(userBasicData.userId));
                setState({
                    hasLoaded: true
                });
            } catch (e) {
                setState({
                    hasError: true,
                    hasLoaded: false
                });
            } finally{
                setState({
                    isFetching: false
                });
            }
        },
    getAvatarUploadedStatus: $5125506ab7d6645a$var$getAvatarUploadedStatus,
    setAvatarUploadedStatus: (uploaded)=>({ setState: setState })=>{
            setState({
                avatarUploaded: {
                    uploaded: uploaded,
                    isLoading: false,
                    isDeleting: false
                }
            });
        },
    deleteUserAvatar: ()=>async ({ getState: getState, dispatch: dispatch, setState: setState })=>{
            try {
                setState({
                    avatarUrl: undefined,
                    avatarUploaded: {
                        isDeleting: true,
                        isLoading: true,
                        error: undefined
                    }
                });
                await (0, $2Ixyh.teamsClient).deleteAvatar(getState().principalUserId);
                dispatch($5125506ab7d6645a$var$actions.fetchAvatarInfo());
            } catch (e) {
                setState({
                    avatarUploaded: {
                        isLoading: false,
                        isDeleting: false,
                        error: e instanceof Error ? e : new Error('Unknown error')
                    }
                });
            } finally{
                setState({
                    avatarUploaded: {
                        isLoading: false,
                        isDeleting: false
                    }
                });
            }
        },
    fetchAvatarInfo: ()=>async ({ getState: getState, setState: setState })=>{
            const avatarInfo = await (0, $2Ixyh.teamsClient).fetchUserAvatarInfo(getState().principalUserId);
            setState({
                avatarUrl: avatarInfo.url,
                avatarUploaded: {
                    uploaded: avatarInfo.uploaded,
                    isLoading: false
                }
            });
        },
    updateUserAvatar: (userId, fileURI)=>async ({ setState: setState })=>{
            setState({
                avatarUrl: undefined,
                avatarUploaded: {
                    isDeleting: false,
                    isLoading: true,
                    isUploading: true,
                    hasUploadedAvatar: false,
                    error: undefined
                }
            });
            try {
                const avatarUrl = await (0, $2Ixyh.teamsClient).updateUserAvatar({
                    id: userId,
                    fileURI: fileURI
                });
                setState({
                    avatarUrl: avatarUrl,
                    avatarUploaded: {
                        uploaded: true,
                        isLoading: false,
                        isUploading: false,
                        hasUploadedAvatar: true
                    }
                });
            } catch (error) {
                setState({
                    avatarUploaded: {
                        isLoading: false,
                        isUploading: false,
                        error: error instanceof Error ? error : new Error('Unknown error'),
                        hasUploadedAvatar: undefined
                    }
                });
            }
        },
    setPrincipalUserInfo: (data)=>({ setState: setState })=>{
            setState(data);
        }
};
const $5125506ab7d6645a$var$initialState = {
    principalUserId: '',
    avatarUrl: '',
    email: '',
    fullName: '',
    title: '',
    isSiteAdmin: false,
    isFetching: false,
    hasError: false,
    hasLoaded: false,
    avatarUploaded: {
        isLoading: false
    }
};
/**
 * Manage states of a site
 */ const $5125506ab7d6645a$var$Store = (0, $iXqE5.createStore)({
    initialState: $5125506ab7d6645a$var$initialState,
    actions: $5125506ab7d6645a$var$actions,
    name: 'PrincipalUser'
});
const $5125506ab7d6645a$export$33e3bf16c7530dd4 = (0, $3sQ5x.createHook)($5125506ab7d6645a$var$Store);
const $5125506ab7d6645a$export$b26d2c7f264f51a8 = (0, $3sQ5x.createHook)($5125506ab7d6645a$var$Store, {
    selector: (state)=>state.avatarUploaded
});

});
parcelRegister("hhuKf", function(module, exports) {

$parcel$export(module.exports, "userInfoProvider", () => $8ea72e77442becf5$export$30a852ca4cb27370);

var $baA0M = parcelRequire("baA0M");
// Needs to be declared here to avoid blowing up this earlyInit bundle
class $8ea72e77442becf5$var$FetchError extends Error {
    constructor(response){
        super(`Request failed with status ${response.status}`);
        this.response = response;
        this.name = this.constructor.name;
    }
}
class $8ea72e77442becf5$export$dc10e400a1189789 {
    get(fetchOp = fetch) {
        if (this.promise) return this.promise;
        const getJson = (url)=>fetchOp(url, {
                method: 'GET',
                mode: 'cors',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response)=>{
                if (!response.ok) throw new $8ea72e77442becf5$var$FetchError(response);
                return response.json();
            });
        this.promise = getJson(`${(0, $baA0M.DEFAULT_CONFIG).stargateRoot}/me`).then((me)=>{
            return {
                userId: me.account_id,
                locale: me.locale,
                fullName: me.name,
                avatarUrl: me.picture,
                email: me.email,
                title: me.extended_profile?.job_title
            };
        });
        return this.promise;
    }
}
const $8ea72e77442becf5$export$30a852ca4cb27370 = new $8ea72e77442becf5$export$dc10e400a1189789();

});



parcelRegister("17JOF", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a308adf8646d66f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cprXC = parcelRequire("cprXC");
var $70e7z = parcelRequire("70e7z");

var $gtzON = parcelRequire("gtzON");

var $iVTy4 = parcelRequire("iVTy4");
const $2a308adf8646d66f$var$AgentProfileRoute = ({ match: match })=>{
    const { agentId: agentId } = match.params;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVTy4.default), {
                name: (0, $cprXC.AnalyticsKeys).AGENT_PROFILE_PAGE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $70e7z.default), {
                name: (0, $cprXC.AnalyticsKeys).AGENT_PROFILE_PAGE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gtzON.default), {
                agentId: decodeURIComponent(agentId)
            })
        ]
    });
};
var $2a308adf8646d66f$export$2e2bcd8739ae039 = $2a308adf8646d66f$var$AgentProfileRoute;

});
parcelRegister("70e7z", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b493898d39225bb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cprXC = parcelRequire("cprXC");
var $358cZ = parcelRequire("358cZ");
const $4b493898d39225bb$export$430619e48d4c20bb = (props)=>{
    const analytics = (0, $358cZ.default)();
    const { name: name } = props;
    (0, $5uXOq.useEffect)(()=>{
        analytics.pushOperationalEvent({
            source: (0, $cprXC.AnalyticsEventSource).CLIENT_METRICS,
            actionSubject: name,
            action: (0, $cprXC.AnalyticsEventActions).MOUNTED
        });
    }, [
        analytics,
        name
    ]);
    return null;
};
var $4b493898d39225bb$export$2e2bcd8739ae039 = $4b493898d39225bb$export$430619e48d4c20bb;

});
parcelRegister("358cZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5d5b20ec1de3729$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3C9WL = parcelRequire("3C9WL");
const $d5d5b20ec1de3729$var$useAnalytics = ()=>(0, $5uXOq.useContext)((0, $3C9WL.AnalyticsContext)).analytics;
var $d5d5b20ec1de3729$export$2e2bcd8739ae039 = $d5d5b20ec1de3729$var$useAnalytics;

});


parcelRegister("gtzON", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5405fd416f7a6b0$export$2e2bcd8739ae039);

var $4qBtX = parcelRequire("4qBtX");

var $2hOqT = parcelRequire("2hOqT");

const $b5405fd416f7a6b0$var$LazyAgentProfile = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("gkYls")),
    loading: ()=>null
});
$b5405fd416f7a6b0$var$LazyAgentProfile.displayName = 'lazy(AgentProfile)';
var $b5405fd416f7a6b0$export$2e2bcd8739ae039 = (0, $2hOqT.AgentProfilePageComponent);

});
parcelRegister("2hOqT", function(module, exports) {

$parcel$export(module.exports, "AgentProfilePageComponent", () => $607835794f3d63df$export$555f6d88454da0bb);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $0yZbT = parcelRequire("0yZbT");
var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");

var $5ztjJ = parcelRequire("5ztjJ");
var $jGAMc = parcelRequire("jGAMc");
var $dc822 = parcelRequire("dc822");
var $g0x5Z = parcelRequire("g0x5Z");

var $clxo5 = parcelRequire("clxo5");

var $39GG1 = parcelRequire("39GG1");

var $l31vR = parcelRequire("l31vR");
var $jETdZ = parcelRequire("jETdZ");

var $js2Ve = parcelRequire("js2Ve");

var $kRFJP = parcelRequire("kRFJP");
var $l3JiM = parcelRequire("l3JiM");
var $1ii8i = parcelRequire("1ii8i");

var $8bKaH = parcelRequire("8bKaH");
var $d2HJp = parcelRequire("d2HJp");
var $ax2O8 = parcelRequire("ax2O8");
var $c5iyg = parcelRequire("c5iyg");
var $1geG0 = parcelRequire("1geG0");
var $hOFm5 = parcelRequire("hOFm5");
var $a4jrI = parcelRequire("a4jrI");

var $9OeO9 = parcelRequire("9OeO9");

var $dHLes = parcelRequire("dHLes");

var $cOGeJ = parcelRequire("cOGeJ");

var $22aG8 = parcelRequire("22aG8");

var $aoiNp = parcelRequire("aoiNp");

var $l598s = parcelRequire("l598s");
var $iW5hh = parcelRequire("iW5hh");
var $2D4Mv = parcelRequire("2D4Mv");
var $hvRGR = parcelRequire("hvRGR");

var $5QqXa = parcelRequire("5QqXa");

var $4A6VZ = parcelRequire("4A6VZ");

var $jpaA4 = parcelRequire("jpaA4");

var $b3aog = parcelRequire("b3aog");

var $bAcbB = parcelRequire("bAcbB");

var $ejUW9 = parcelRequire("ejUW9");

var $fHBgM = parcelRequire("fHBgM");

var $kc4uV = parcelRequire("kc4uV");
const $607835794f3d63df$var$AGENT_PROFILE_PAGE_LATENCY_TARGET = 1000;
const $607835794f3d63df$var$mainColumnStyle = (0, $2s57o.xcss)({});
const $607835794f3d63df$var$bannerStyles = (0, $2s57o.xcss)({
    marginBottom: 'space.500',
    marginInline: 'space.negative.400'
});
const $607835794f3d63df$var$avatarStyles = (0, $2s57o.xcss)({
    marginBottom: 'space.300'
});
const $607835794f3d63df$export$555f6d88454da0bb = (props)=>{
    const { agentId: agentId } = props;
    const [{ cloudId: cloudId }] = (0, $a4jrI.useSite)();
    const [{ agentData: agentData }, { setAgentInfo: setAgentInfo }] = (0, $dHLes.useRovoAgentData)();
    const [{ principalUserId: principalUserId }] = (0, $1geG0.usePrincipalUser)();
    const { fireEvent: fireEvent } = (0, $js2Ve.usePeopleTeamAnalyticsEvents)();
    const [starCount, setStarCount] = (0, $5uXOq.useState)(0);
    const [isStarred, setIsStarred] = (0, $5uXOq.useState)(false);
    const { setContainerWidth: setContainerWidth } = (0, $1ii8i.useLayoutStoreActions)();
    const assistanceServiceParams = (0, $5uXOq.useMemo)(()=>{
        return {
            experienceId: 'profile-page',
            product: 'rovo',
            siteId: cloudId,
            touchpointSource: 'agent-profile-page'
        };
    }, [
        cloudId
    ]);
    const { data: data, error: error, isFetching: isFetching } = (0, $jETdZ.useAgentDetailsController)({
        agentId: agentId,
        enabled: agentData?.id !== agentId,
        assistanceServiceParams: assistanceServiceParams
    });
    (0, $5uXOq.useEffect)(()=>{
        fireEvent('screen.agentProfile.viewed', {});
    }, [
        fireEvent
    ]);
    (0, $ax2O8.useExpTrackerStart)({
        id: agentId,
        name: (0, $hOFm5.UserExperienceNames).AGENT_PROFILE_PAGE,
        latencySloMs: $607835794f3d63df$var$AGENT_PROFILE_PAGE_LATENCY_TARGET
    });
    (0, $c5iyg.useExpTrackerStop)({
        name: (0, $hOFm5.UserExperienceNames).AGENT_PROFILE_PAGE,
        checkShouldAbort: (error)=>{
            if (!(0, $8bKaH.isAuthError)(error)) return;
            return error.message;
        },
        error: error
    });
    const agentIdentityId = (0, $5uXOq.useMemo)(()=>{
        return agentData?.identity_account_id ? (0, $9OeO9.trimUserARI)(agentData?.identity_account_id) : '';
    }, [
        agentData?.identity_account_id
    ]);
    const isAgentCreatedByCurrentUser = (0, $5uXOq.useMemo)(()=>{
        return agentData?.creator_type === 'CUSTOMER' ? (0, $9OeO9.trimUserARI)(agentData?.creator || '') === principalUserId : false;
    }, [
        agentData?.creator,
        agentData?.creator_type,
        principalUserId
    ]);
    const { openDialog: openDialog } = (0, $d2HJp.useDialog)();
    (0, $5uXOq.useEffect)(()=>{
        if (data) {
            setAgentInfo(data);
            setStarCount(data.favourite_count);
            setIsStarred(data.favourite);
        }
    }, [
        data,
        setAgentInfo
    ]);
    const { setFavouriteAgent: setFavouriteAgent, editAgent: editAgent, copyAgent: copyAgent, duplicateAgent: duplicateAgent, deleteAgent: deleteAgent, onChatWithAgent: onChatWithAgent, startConversation: startConversation } = (0, $kc4uV.useAgentActions)({
        agentId: agentData?.id,
        agentIdentityAccountId: agentData?.identity_account_id,
        agentName: agentData?.name,
        assistanceServiceParams: assistanceServiceParams
    });
    const handleOnDeleteAgent = ()=>{
        openDialog((0, $fHBgM.default), {
            agentName: agentData?.name,
            agentId: agentData?.id,
            onDelete: deleteAgent,
            onClose: ()=>{}
        });
    };
    const isForgeAgent = (0, $5uXOq.useMemo)(()=>agentData?.creator_type === 'THIRD_PARTY' || agentData?.creator_type === 'FORGE', [
        agentData?.creator_type
    ]);
    const handleCopyInstructions = ()=>{
        if (agentData?.system_prompt_template) navigator.clipboard.writeText(agentData?.system_prompt_template.toString());
    };
    if (error) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5QqXa.ErrorScreen), {
        error: error
    }, agentId);
    if (isFetching) /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cOGeJ.App), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {
            size: "medium"
        })
    });
    if (!agentData) return null;
    const handleFavouriteAgent = async ()=>{
        const onSuccessCallBack = ()=>{
            setStarCount(isStarred ? starCount - 1 : starCount + 1);
            setIsStarred(!isStarred);
        };
        setFavouriteAgent(!isStarred, onSuccessCallBack);
    };
    const BodyComponent = (0, $fHpHg.fg)('user-profile-refresh') ? (0, $l3JiM.ProfileContent) : (0, $iW5hh.Body);
    const Aside = (0, $fHpHg.fg)('user-profile-refresh') ? (0, $kRFJP.LeftAside) : (0, $l598s.AsideColumn);
    const MaybeResponsiveSection = (0, $fHpHg.fg)('user-profile-refresh') ? (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment : (0, $hvRGR.ResponsiveSection);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aoiNp.default), {
            title: agentData.name,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cOGeJ.App), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $39GG1.WidthObserver), {
                        setWidth: setContainerWidth
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                        xcss: $607835794f3d63df$var$bannerStyles,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jGAMc.AgentBanner), {
                            agentId: agentData.id,
                            agentNamedId: agentData.external_config_reference ?? agentData.named_id,
                            agentIdentityAccountId: agentData.identity_account_id,
                            height: 192
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)(BodyComponent, {
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)(MaybeResponsiveSection, {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)(Aside, {
                                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bEIgH.default), {
                                        space: "space.300",
                                        children: [
                                            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bEIgH.default), {
                                                space: "space.200",
                                                children: [
                                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                                                        xcss: $607835794f3d63df$var$avatarStyles,
                                                        style: {
                                                            marginTop: '-105px'
                                                        },
                                                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5ztjJ.AgentAvatar), {
                                                            agentId: agentData.id,
                                                            agentNamedId: agentData.external_config_reference ?? agentData.named_id,
                                                            agentIdentityAccountId: agentData.identity_account_id,
                                                            size: "xxlarge",
                                                            isForgeAgent: agentData.creator_type === 'FORGE' || agentData.creator_type === 'THIRD_PARTY',
                                                            forgeAgentIconUrl: agentData.icon
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dc822.AgentProfileInfo), {
                                                        agentName: agentData?.name,
                                                        isStarred: isStarred,
                                                        onStarToggle: ()=>handleFavouriteAgent(),
                                                        creatorRender: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ejUW9.AgentCreator), {
                                                            create_type: agentData.creator_type,
                                                            creator: agentData.creator || undefined
                                                        }),
                                                        starCountRender: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g0x5Z.AgentStarCount), {
                                                            isLoading: isFetching,
                                                            starCount: starCount
                                                        }),
                                                        agentDescription: agentData.description,
                                                        isHidden: agentData.visibility === 'PRIVATE'
                                                    }),
                                                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b3aog.AgentActions), {
                                                        agentId: agentData.id,
                                                        isAgentCreatedByUser: isAgentCreatedByCurrentUser,
                                                        onEditAgent: editAgent,
                                                        onCopyAgent: copyAgent,
                                                        onDuplicateAgent: duplicateAgent,
                                                        onDeleteAgent: handleOnDeleteAgent,
                                                        onChatClick: onChatWithAgent,
                                                        isForgeAgent: isForgeAgent,
                                                        assistanceServiceParams: assistanceServiceParams
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jpaA4.AgentAboutPanel), {
                                                agent: agentData,
                                                assistanceServiceParams: assistanceServiceParams
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2D4Mv.MainColumn), {
                                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bEIgH.default), {
                                        space: "space.500",
                                        xcss: $607835794f3d63df$var$mainColumnStyle,
                                        children: [
                                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bAcbB.AgentConversationStartersSection), {
                                                isAgentDefault: agentData.is_default,
                                                userDefinedConversationStarters: agentData.user_defined_conversation_starters?.map((starter)=>{
                                                    return {
                                                        message: starter,
                                                        type: 'user-defined'
                                                    };
                                                }),
                                                onConversationStarterClick: (conversationStarter)=>{
                                                    startConversation(conversationStarter.message);
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l31vR.AgentInstructions), {
                                                promptTemplate: agentData.system_prompt_template,
                                                onCopy: handleCopyInstructions,
                                                isForgeAgent: isForgeAgent,
                                                fullHeightText: false
                                            }),
                                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4A6VZ.default), {
                                                userId: agentIdentityId
                                            }),
                                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $22aG8.default), {
                                                userId: agentIdentityId,
                                                status: agentData.deactivated ? 'inactive' : 'active',
                                                userFullName: agentData.name
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};

});
parcelRegister("5ztjJ", function(module, exports) {

$parcel$export(module.exports, "AgentAvatar", () => $07ae2c702eeb1ea1$export$38b71b080e1832c8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $7a4uG = parcelRequire("7a4uG");

var $5sRpy = parcelRequire("5sRpy");

var $jGAMc = parcelRequire("jGAMc");

var $4Xp76 = parcelRequire("4Xp76");
const $07ae2c702eeb1ea1$var$styles = {
    agentAvatar: "_1e0c1txw _1bah1h6o _4cvr1h6o _mkrz1k6g",
    image: "_5ral1dfr _4t3i1osq _1bsb1osq",
    avatarContentContainer: "_1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _4cvr1h6o"
};
const $07ae2c702eeb1ea1$var$stylesCompiled = {
    innerShape: "_4t3i1lk2 _1bsb1lk2 _mkrz1k6g"
};
const $07ae2c702eeb1ea1$export$38b71b080e1832c8 = ({ imageUrl: imageUrl, size: size = 'medium', label: label, name: name, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, showBorder: showBorder = true, isForgeAgent: isForgeAgent, forgeAgentIconUrl: forgeAgentIconUrl })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const imgUrl = isForgeAgent && forgeAgentIconUrl ? forgeAgentIconUrl : imageUrl;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        "aria-label": label,
        xcss: $07ae2c702eeb1ea1$var$styles.agentAvatar,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            height: (0, $7a4uG.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            width: (0, $7a4uG.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/ensure-design-token-usage
            ...showBorder ? {
                backgroundColor: '#fff'
            } : {}
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                $07ae2c702eeb1ea1$var$stylesCompiled.innerShape
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                xcss: $07ae2c702eeb1ea1$var$styles.avatarContentContainer,
                children: imgUrl ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    as: "img",
                    xcss: $07ae2c702eeb1ea1$var$styles.image,
                    src: imgUrl,
                    alt: name || label || formatMessage((0, $4Xp76.messages).agentAvatarLabel)
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jGAMc.GeneratedAvatar), {
                    agentId: agentId,
                    agentNamedId: agentNamedId,
                    agentIdentityAccountId: agentIdentityAccountId,
                    size: size
                })
            })
        })
    });
};

});
parcelRegister("jGAMc", function(module, exports) {

$parcel$export(module.exports, "AgentBanner", () => $b000f811ab41b211$export$6efaefb8ad2fba40);
$parcel$export(module.exports, "GeneratedAvatar", () => $b000f811ab41b211$export$96bb253b7de22616);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7a4uG = parcelRequire("7a4uG");

var $6tzHJ = parcelRequire("6tzHJ");

var $5sRpy = parcelRequire("5sRpy");
const $b000f811ab41b211$var$styles = {
    image: "_5ral1dfr _4t3i1osq _1bsb1osq _1e0c1txw _1bah1h6o _4cvr1h6o",
    banner: "_1bsb1osq",
    bannerFillSpace: "_1bsb1osq _4t3i1osq _5ral1dfr"
};

const $b000f811ab41b211$var$AutoDevAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("gf5Fp")));

const $b000f811ab41b211$var$AutoFixAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("7wKO4")));

const $b000f811ab41b211$var$AutoReviewAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("eiugb")));

const $b000f811ab41b211$var$BacklogBuddyAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("b5gHi")));

const $b000f811ab41b211$var$CommsCrafterAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("hZZbo")));

const $b000f811ab41b211$var$CultureAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("e32uO")));

const $b000f811ab41b211$var$CustomerInsightAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("lK9BN")));

const $b000f811ab41b211$var$DecisionDirectorAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("1ySno")));

const $b000f811ab41b211$var$FeatureFlagAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("evKSx")));

const $b000f811ab41b211$var$GenericAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("cNnWP")));

const $b000f811ab41b211$var$HireWriterAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("19lsO")));

const $b000f811ab41b211$var$MarketingMessageMaestroAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("lMWn1")));

const $b000f811ab41b211$var$MyUserManualAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("OVhEX")));

const $b000f811ab41b211$var$OkrOracleAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("dv51y")));

const $b000f811ab41b211$var$OpsAgentAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("6ZkWv")));

const $b000f811ab41b211$var$PitchPerfectorAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("5HnH0")));

const $b000f811ab41b211$var$ProductRequirementAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("5oOlU")));

const $b000f811ab41b211$var$ReleaseNotesAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("1ZbxV")));

const $b000f811ab41b211$var$ResearchScoutAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("lD4hW")));

const $b000f811ab41b211$var$SocialMediaScribeAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("2u2bq")));

const $b000f811ab41b211$var$TeamConnectionAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("1wfox")));

const $b000f811ab41b211$var$WorkflowBuilderAvatar = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("3SoiX")));
const $b000f811ab41b211$var$yellowColor = {
    primary: '#FCA700',
    secondary: '#FFC716'
};
const $b000f811ab41b211$var$purpleColor = {
    primary: '#BF63F3',
    secondary: '#D8A0F7'
};
const $b000f811ab41b211$var$greenColor = {
    primary: '#82B536',
    secondary: '#B3DF72'
};
const $b000f811ab41b211$var$blueColor = {
    primary: '#357DE8',
    secondary: '#669DF1'
};
const $b000f811ab41b211$var$colorList = [
    $b000f811ab41b211$var$yellowColor,
    $b000f811ab41b211$var$purpleColor,
    $b000f811ab41b211$var$greenColor,
    $b000f811ab41b211$var$blueColor
];
const $b000f811ab41b211$var$avatarList = [
    $b000f811ab41b211$var$CustomerInsightAvatar,
    $b000f811ab41b211$var$BacklogBuddyAvatar,
    $b000f811ab41b211$var$DecisionDirectorAvatar,
    $b000f811ab41b211$var$CommsCrafterAvatar,
    $b000f811ab41b211$var$AutoDevAvatar,
    $b000f811ab41b211$var$OkrOracleAvatar,
    $b000f811ab41b211$var$CultureAvatar,
    $b000f811ab41b211$var$SocialMediaScribeAvatar,
    $b000f811ab41b211$var$TeamConnectionAvatar,
    $b000f811ab41b211$var$HireWriterAvatar,
    $b000f811ab41b211$var$OpsAgentAvatar,
    $b000f811ab41b211$var$ResearchScoutAvatar,
    $b000f811ab41b211$var$ReleaseNotesAvatar,
    $b000f811ab41b211$var$MyUserManualAvatar,
    $b000f811ab41b211$var$PitchPerfectorAvatar,
    $b000f811ab41b211$var$AutoDevAvatar,
    $b000f811ab41b211$var$AutoFixAvatar,
    $b000f811ab41b211$var$AutoReviewAvatar,
    $b000f811ab41b211$var$MarketingMessageMaestroAvatar,
    $b000f811ab41b211$var$FeatureFlagAvatar,
    $b000f811ab41b211$var$ProductRequirementAvatar
];
const $b000f811ab41b211$export$a834793a4d0d739e = $b000f811ab41b211$var$avatarList.length * $b000f811ab41b211$var$colorList.length;
const $b000f811ab41b211$var$outOfTheBoxAgentAvatar = {
    decision_director_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b000f811ab41b211$var$DecisionDirectorAvatar, {
                size: (0, $7a4uG.AVATAR_SIZES)[size],
                primaryColor: $b000f811ab41b211$var$greenColor.primary,
                secondaryColor: $b000f811ab41b211$var$greenColor.secondary
            }),
        color: $b000f811ab41b211$var$greenColor
    },
    user_manual_writer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b000f811ab41b211$var$MyUserManualAvatar, {
                size: (0, $7a4uG.AVATAR_SIZES)[size],
                primaryColor: $b000f811ab41b211$var$yellowColor.primary,
                secondaryColor: $b000f811ab41b211$var$yellowColor.secondary
            }),
        color: $b000f811ab41b211$var$yellowColor
    },
    product_requirements_expert_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b000f811ab41b211$var$ProductRequirementAvatar, {
                size: (0, $7a4uG.AVATAR_SIZES)[size],
                primaryColor: $b000f811ab41b211$var$yellowColor.primary,
                secondaryColor: $b000f811ab41b211$var$yellowColor.secondary
            }),
        color: $b000f811ab41b211$var$yellowColor
    },
    issue_organizer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b000f811ab41b211$var$BacklogBuddyAvatar, {
                size: (0, $7a4uG.AVATAR_SIZES)[size],
                primaryColor: $b000f811ab41b211$var$greenColor.primary,
                secondaryColor: $b000f811ab41b211$var$greenColor.secondary
            }),
        color: $b000f811ab41b211$var$greenColor
    },
    it_ops_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b000f811ab41b211$var$OpsAgentAvatar, {
                size: (0, $7a4uG.AVATAR_SIZES)[size],
                primaryColor: $b000f811ab41b211$var$purpleColor.primary,
                secondaryColor: $b000f811ab41b211$var$purpleColor.secondary
            }),
        color: $b000f811ab41b211$var$purpleColor
    },
    jira_workflow_wizard_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b000f811ab41b211$var$WorkflowBuilderAvatar, {
                size: (0, $7a4uG.AVATAR_SIZES)[size],
                primaryColor: $b000f811ab41b211$var$blueColor.primary,
                secondaryColor: $b000f811ab41b211$var$blueColor.secondary
            }),
        color: $b000f811ab41b211$var$blueColor
    }
};
const $b000f811ab41b211$export$c84eb7708138dd4 = ({ agentIdentityAccountId: agentIdentityAccountId, agentId: agentId })=>{
    // we prioritise agentIdentityAccountId first if it is available
    // this is because agentIdentityAccountId is more widely available (e.g. in ProfilePage)
    const idForAgentAvatar = agentIdentityAccountId || agentId;
    if (idForAgentAvatar) {
        // Take the last 8 characters of the id because JS can't handle 16 digit numbers
        const trimmedId = idForAgentAvatar.slice(-8).replace(/[-:]/g, '');
        const parsedId = parseInt(trimmedId, 16);
        if (isNaN(parsedId)) return 0;
        else return parsedId;
    }
    return null;
};
const $b000f811ab41b211$var$getAvatarRender = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, size: size })=>{
    if (typeof agentNamedId === 'string' && $b000f811ab41b211$var$outOfTheBoxAgentAvatar[agentNamedId]) {
        const ootbAvatarResult = $b000f811ab41b211$var$outOfTheBoxAgentAvatar[agentNamedId];
        return {
            render: ootbAvatarResult.getRender(size),
            color: ootbAvatarResult.color
        };
    }
    const numberId = $b000f811ab41b211$export$c84eb7708138dd4({
        agentIdentityAccountId: agentIdentityAccountId,
        agentId: agentId
    });
    if (numberId !== null) {
        /**
     * this create all possible combinations of avatars and colors
     * e.g. [[avatar1, color1], [avatar1, color2], [avatar2, color1], [avatar2, color2]]
     * then choose 1 based on agentId
     */ const totalCombinations = $b000f811ab41b211$var$avatarList.length * $b000f811ab41b211$var$colorList.length;
        const combinationIndex = numberId % totalCombinations;
        const avatarIndex = Math.floor(combinationIndex / $b000f811ab41b211$var$colorList.length);
        const colorIndex = combinationIndex % $b000f811ab41b211$var$colorList.length;
        const Avatar = $b000f811ab41b211$var$avatarList[avatarIndex];
        const color = $b000f811ab41b211$var$colorList[colorIndex];
        return {
            render: /*#__PURE__*/ (0, $2OMIu.jsx)(Avatar, {
                size: (0, $7a4uG.AVATAR_SIZES)[size],
                primaryColor: color.primary,
                secondaryColor: color.secondary
            }),
            color: color
        };
    }
    return {
        render: /*#__PURE__*/ (0, $2OMIu.jsx)($b000f811ab41b211$var$GenericAvatar, {
            size: (0, $7a4uG.AVATAR_SIZES)[size],
            primaryColor: $b000f811ab41b211$var$blueColor.primary,
            secondaryColor: $b000f811ab41b211$var$blueColor.secondary
        }),
        color: $b000f811ab41b211$var$blueColor
    };
};
const $b000f811ab41b211$export$6efaefb8ad2fba40 = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, height: height, fillSpace: fillSpace })=>{
    const { color: color } = $b000f811ab41b211$var$getAvatarRender({
        agentNamedId: agentNamedId,
        agentId: agentId,
        agentIdentityAccountId: agentIdentityAccountId,
        size: 'medium'
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($b000f811ab41b211$var$styles.banner, fillSpace ? $b000f811ab41b211$var$styles.bannerFillSpace : undefined),
        style: {
            backgroundColor: color.primary,
            height: height ? `${height}px` : undefined
        }
    });
};
const $b000f811ab41b211$export$96bb253b7de22616 = (props)=>{
    const { render: render, color: color } = $b000f811ab41b211$var$getAvatarRender(props);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $b000f811ab41b211$var$styles.image,
        style: {
            backgroundColor: color.primary
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: null,
            children: render
        })
    });
};

});
parcelRegister("gf5Fp", function(module, exports) {

let $bd3271635a78b130$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bd3271635a78b130$var$load("lR2LL").then(()=>parcelRequire('2TTZa'));

});

parcelRegister("7wKO4", function(module, exports) {

let $57afd4609260140a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $57afd4609260140a$var$load("2j3wg").then(()=>parcelRequire('4fbfN'));

});

parcelRegister("eiugb", function(module, exports) {

let $a68a38269ff32d90$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a68a38269ff32d90$var$load("1TTRe").then(()=>parcelRequire('gTqGx'));

});

parcelRegister("b5gHi", function(module, exports) {

let $811d1d15cbfa77e0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $811d1d15cbfa77e0$var$load("6NWHB").then(()=>parcelRequire('kG7PH'));

});

parcelRegister("hZZbo", function(module, exports) {

let $d1a797d1ea789659$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d1a797d1ea789659$var$load("cJcac").then(()=>parcelRequire('kMGJW'));

});

parcelRegister("e32uO", function(module, exports) {

let $a3a348257c534892$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a3a348257c534892$var$load("4yzAn").then(()=>parcelRequire('8Kjj3'));

});

parcelRegister("lK9BN", function(module, exports) {

let $fd4558f2af4450d2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fd4558f2af4450d2$var$load("8HPzM").then(()=>parcelRequire('92xbP'));

});

parcelRegister("1ySno", function(module, exports) {

let $12332565bb4d1c65$var$load = (parcelRequire("28QjX"))(4);
module.exports = $12332565bb4d1c65$var$load("h9TUo").then(()=>parcelRequire('ia5my'));

});

parcelRegister("evKSx", function(module, exports) {

let $a908531495569140$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a908531495569140$var$load("EeYXL").then(()=>parcelRequire('dHPnq'));

});

parcelRegister("cNnWP", function(module, exports) {

let $950ca332ec84ec3f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $950ca332ec84ec3f$var$load("4IT7d").then(()=>parcelRequire('3KwI5'));

});

parcelRegister("19lsO", function(module, exports) {

let $0d6747f056c455c6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0d6747f056c455c6$var$load("2Tw41").then(()=>parcelRequire('7Uu6B'));

});

parcelRegister("lMWn1", function(module, exports) {

let $fdcb5bcec8d43d39$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fdcb5bcec8d43d39$var$load("7DfmP").then(()=>parcelRequire('jvA3V'));

});

parcelRegister("OVhEX", function(module, exports) {

let $09911b009f794757$var$load = (parcelRequire("28QjX"))(4);
module.exports = $09911b009f794757$var$load("iFodq").then(()=>parcelRequire('e42N9'));

});

parcelRegister("dv51y", function(module, exports) {

let $9d42114a10b97297$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9d42114a10b97297$var$load("dMm0y").then(()=>parcelRequire('flVB7'));

});

parcelRegister("6ZkWv", function(module, exports) {

let $5168af54533cf46b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5168af54533cf46b$var$load("2Dli8").then(()=>parcelRequire('j5UIG'));

});

parcelRegister("5HnH0", function(module, exports) {

let $426358c8763db6ea$var$load = (parcelRequire("28QjX"))(4);
module.exports = $426358c8763db6ea$var$load("7IpDj").then(()=>parcelRequire('8bJfI'));

});

parcelRegister("5oOlU", function(module, exports) {

let $3ee640958bdcf887$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3ee640958bdcf887$var$load("cVaSO").then(()=>parcelRequire('7cYiW'));

});

parcelRegister("1ZbxV", function(module, exports) {

let $172471ccbe835853$var$load = (parcelRequire("28QjX"))(4);
module.exports = $172471ccbe835853$var$load("8LJeo").then(()=>parcelRequire('eQlck'));

});

parcelRegister("lD4hW", function(module, exports) {

let $fbf0910ed63ae934$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fbf0910ed63ae934$var$load("hGcUW").then(()=>parcelRequire('5wXz6'));

});

parcelRegister("2u2bq", function(module, exports) {

let $1cf013a59068e847$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1cf013a59068e847$var$load("e85aH").then(()=>parcelRequire('6BQ4w'));

});

parcelRegister("1wfox", function(module, exports) {

let $11b4b8abf7d657eb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $11b4b8abf7d657eb$var$load("1l6zN").then(()=>parcelRequire('9LHuy'));

});

parcelRegister("3SoiX", function(module, exports) {

let $2d2944acaf62c4de$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2d2944acaf62c4de$var$load("92ca6").then(()=>parcelRequire('kFPMS'));

});


parcelRegister("4Xp76", function(module, exports) {

$parcel$export(module.exports, "messages", () => $800423efdca9fc97$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $800423efdca9fc97$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    agentAvatarLabel: {
        id: 'ai-mate.agent-avatar-label',
        defaultMessage: 'Agent avatar',
        description: 'Accessible label for agent avatar img'
    }
});

});


parcelRegister("dc822", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCreator", () => $6cde292c586325f0$export$f35b2eeaa7e3db15);
$parcel$export(module.exports, "AgentProfileInfo", () => $6cde292c586325f0$export$e02348ba0b01a210);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bWfiu = parcelRequire("bWfiu");

var $iItCF = parcelRequire("iItCF");
var $kk4W6 = parcelRequire("kk4W6");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $gOkqF = parcelRequire("gOkqF");

var $4CMbn = parcelRequire("4CMbn");

var $5KCCi = parcelRequire("5KCCi");

var $5qwwA = parcelRequire("5qwwA");

var $dfVR0 = parcelRequire("dfVR0");

var $liWXx = parcelRequire("liWXx");
const $6cde292c586325f0$var$styles = {
    clickableItem: "_zulp1b66 _1e0c1txw _4cvr1h6o",
    name: "_1bah1yb4 _4cvr1y6m",
    description: "_19pkze3t _otyru2gc",
    wrapper: "_otyru2gc",
    tooltipWrapper: "_195gu2gc _1e0c116y _kqswh2mm _94n5v77o",
    headingWrapper: "_kqswh2mm"
};
const $6cde292c586325f0$export$f35b2eeaa7e3db15 = ({ creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getCreatorRender = ()=>{
        if (isLoading) return formatMessage((0, $liWXx.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4CMbn.default), {
                testId: "agent-profile-creator-skeleton",
                isShimmering: true,
                height: 18,
                width: 100,
                borderRadius: 3
            })
        });
        if (!creator) return null;
        if (creator.type === 'SYSTEM' || creator.type === 'OOTB') return formatMessage((0, $liWXx.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                alignBlock: "center",
                testId: "atlassian-icon",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iItCF.AtlassianIcon), {
                        size: "small",
                        appearance: "brand"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                        children: "Atlassian"
                    })
                ]
            })
        });
        if (creator.type === 'CUSTOMER') return formatMessage((0, $liWXx.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, $2OMIu.jsxs)("a", {
                "aria-label": creator.name || formatMessage((0, $liWXx.messages).creatorLabel),
                href: creator.profileLink,
                onClick: ()=>onCreatorLinkClick(),
                target: "_blank",
                children: [
                    creator.name,
                    ' ',
                    creator.status === 'inactive' && formatMessage((0, $liWXx.messages).agentDeactivated)
                ]
            })
        });
        if (creator.type === 'THIRD_PARTY') return formatMessage((0, $liWXx.messages).agentCreatedBy, {
            creatorNameWithLink: creator.name
        });
        return null;
    };
    const creatorRender = getCreatorRender();
    return creatorRender ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sRpy.default), {
        xcss: $6cde292c586325f0$var$styles.clickableItem,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kk4W6.RovoIcon), {
                appearance: "brand",
                size: "small"
            }),
            creatorRender
        ]
    }) : null;
};
const $6cde292c586325f0$export$e02348ba0b01a210 = ({ agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
        space: "space.100",
        xcss: $6cde292c586325f0$var$styles.wrapper,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                xcss: $6cde292c586325f0$var$styles.name,
                space: "space.100",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sRpy.default), {
                        xcss: $6cde292c586325f0$var$styles.headingWrapper,
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
                                as: "span",
                                size: "xlarge",
                                children: agentName
                            }),
                            isHidden && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                                xcss: $6cde292c586325f0$var$styles.tooltipWrapper,
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
                                    content: formatMessage((0, $liWXx.messages).hiddenTooltip),
                                    position: "top",
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5qwwA.HiddenIcon), {
                                        label: formatMessage((0, $liWXx.messages).hiddenIcon)
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dfVR0.StarIconButton), {
                        isStarred: isStarred,
                        handleToggle: onStarToggle
                    })
                ]
            }),
            creatorRender,
            !!agentDescription && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                xcss: $6cde292c586325f0$var$styles.description,
                as: "p",
                children: agentDescription
            }),
            starCountRender
        ]
    });
};

});
parcelRegister("5qwwA", function(module, exports) {

$parcel$export(module.exports, "HiddenIcon", () => $b7a7311effbc560f$export$bce21421c351deb1);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $2vuY0 = parcelRequire("2vuY0");
const $b7a7311effbc560f$export$bce21421c351deb1 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2vuY0))), {
        ...props
    });

});
parcelRegister("2vuY0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a08317faf7bb722eae48d675a4ede28d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1d367f5dd9c1b56f$var$_react = $1d367f5dd9c1b56f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1d367f5dd9c1b56f$var$_baseNew = $1d367f5dd9c1b56f$var$_interopRequireDefault((parcelRequire("enEmH")));
function $1d367f5dd9c1b56f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpenStrikethrough".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Intended uses: unwatch page in Confluence, hide password in text field, and unfollow in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1d367f5dd9c1b56f$var$EyeOpenStrikethroughIcon = (props)=>/*#__PURE__*/ $1d367f5dd9c1b56f$var$_react.default.createElement($1d367f5dd9c1b56f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.76 3.82.47 1.53 1.53.47l14 14-1.06 1.06-2.513-2.512A8.44 8.44 0 0 1 8 14C4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24A8.1 8.1 0 0 1 2.76 3.82m1.069 1.07a6.63 6.63 0 0 0-2.253 3.006.3.3 0 0 0 0 .208C2.509 10.656 5.057 12.5 8 12.5a6.9 6.9 0 0 0 2.836-.604l-1.312-1.311a3 3 0 0 1-4.108-4.108zm2.722 2.72q-.05.187-.051.39a1.5 1.5 0 0 0 1.889 1.448zM8 3.501q-.737 0-1.432.147L6.26 2.18A8.5 8.5 0 0 1 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24a8 8 0 0 1-1.31 2.295l-1.163-.947a6.5 6.5 0 0 0 1.064-1.864.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5" clip-rule="evenodd"/>`
    }, props));
$1d367f5dd9c1b56f$var$EyeOpenStrikethroughIcon.displayName = 'EyeOpenStrikethroughIcon';
var $1d367f5dd9c1b56f$var$_default = module.exports.default = $1d367f5dd9c1b56f$var$EyeOpenStrikethroughIcon;

});


parcelRegister("dfVR0", function(module, exports) {

$parcel$export(module.exports, "StarIconButton", () => $7d5d03580e322dbe$export$703abb8bd2abdfa5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $6tzHJ = parcelRequire("6tzHJ");

var $caKPP = parcelRequire("caKPP");

var $1lcIk = parcelRequire("1lcIk");

var $7rJgC = parcelRequire("7rJgC");

var $7HvRi = parcelRequire("7HvRi");
const $7d5d03580e322dbe$var$styles = {
    pressableStarIcon: "_bfhk18uv _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _4t3i1tcg _1bsb1tcg",
    hidden: "_tzy4idpf"
};
const $7d5d03580e322dbe$export$703abb8bd2abdfa5 = ({ isStarred: isStarred, handleToggle: handleToggle, visible: visible = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
        xcss: (0, $6tzHJ.cx)($7d5d03580e322dbe$var$styles.pressableStarIcon, !visible && $7d5d03580e322dbe$var$styles.hidden),
        onClick: handleToggle,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        children: isStarred || isHovered ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($caKPP))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $7HvRi.default).removeFromFavouritesLabel),
            color: "var(--ds-icon-accent-orange, #E56910)"
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1lcIk))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $7HvRi.default).clickToFavouriteLabel),
            color: "var(--ds-icon, #44546F)"
        })
    });
};

});
parcelRegister("7HvRi", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c54e675c6bc8c21$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6c54e675c6bc8c21$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    removeFromFavouritesLabel: {
        id: 'rovo-chat.browse-agents.remove-from-favourites-label',
        defaultMessage: 'Remove from favourites',
        description: 'Remove from favourites label'
    },
    clickToFavouriteLabel: {
        id: 'rovo-chat.browse-agents.click-to-favourite-label',
        defaultMessage: 'Not favourited, click to favourite',
        description: 'Click to favourite agent label'
    }
});

});


parcelRegister("liWXx", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b795365dcaec72c6$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $b795365dcaec72c6$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    agentCreatedBy: {
        id: 'ai-mate.agent-profile-info.created-by',
        defaultMessage: 'Rovo Agent by {creatorNameWithLink}',
        description: 'Message to show who created this Rovo agent'
    },
    agentDeactivated: {
        id: 'ai-mate.agent-profile-info.deactivated',
        defaultMessage: '(deactivated)',
        description: 'Message to show that this agent is deactivated'
    },
    starredCount: {
        id: 'ai-mate.agent-profile-info.starred-count',
        defaultMessage: '{count} starred',
        description: 'Message to show how many times this agent has been starred by users'
    },
    hiddenIcon: {
        id: 'ai-mate.agent-profile-info.hidden-icon',
        defaultMessage: 'Hidden',
        description: 'Icon to show that this agent is hidden'
    },
    hiddenTooltip: {
        id: 'ai-mate.agent-profile-info.hidden-tooltip',
        defaultMessage: "Agent won't show in search results",
        description: 'Tooltip to explain what strikethough eye icon means'
    },
    starAgentTooltip: {
        id: 'ai-mate.agent-profile-info.star-agent-tooltip',
        defaultMessage: 'Star Agent',
        description: 'Tooltip to explain what star icon does'
    },
    creatorLabel: {
        id: 'ai-mate.agent-profile-info.creator',
        defaultMessage: 'Creator',
        description: 'Accessible label for creator link'
    }
});

});


parcelRegister("g0x5Z", function(module, exports) {

$parcel$export(module.exports, "AgentStarCount", () => $c5f2422f355268cf$export$65f8fe094f79ae2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $a8qYi = parcelRequire("a8qYi");

var $5sRpy = parcelRequire("5sRpy");

var $4CMbn = parcelRequire("4CMbn");

var $kvs0K = parcelRequire("kvs0K");

var $3JVCb = parcelRequire("3JVCb");
const $c5f2422f355268cf$var$styles = {
    count: "_11c81o8v _zulp1b66 _1e0c1txw _4cvr1h6o _bozgv77o"
};
const $c5f2422f355268cf$export$65f8fe094f79ae2 = ({ starCount: starCount, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if ((starCount === null || starCount === undefined) && !isLoading) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sRpy.default), {
        xcss: $c5f2422f355268cf$var$styles.count,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a8qYi))), {
                LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`,
                color: "currentColor",
                label: "",
                LEGACY_size: "small"
            }),
            isLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4CMbn.default), {
                testId: "agent-profile-info-star-count-skeleton",
                isShimmering: true,
                height: 16,
                width: 75,
                borderRadius: 3
            }) : formatMessage((0, $kvs0K.messages).starredCount, {
                starCount: (0, $3JVCb.formatNumber)(starCount ?? 0)
            })
        ]
    });
};

});
parcelRegister("a8qYi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a16470c3bb291b102b1f88d7113da531>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $760f92bdadaaacaf$var$_react = $760f92bdadaaacaf$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $760f92bdadaaacaf$var$_starUnstarred = $760f92bdadaaacaf$var$_interopRequireDefault((parcelRequire("1fvKj")));

var $760f92bdadaaacaf$var$_star = $760f92bdadaaacaf$var$_interopRequireDefault((parcelRequire("k71Jv")));
function $760f92bdadaaacaf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StarUnstarredIcon.
 * This component is StarUnstarredIcon, with `UNSAFE_fallbackIcon` set to "StarIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for starring or favoriting objects as a secondary/tertiary action.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $760f92bdadaaacaf$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $760f92bdadaaacaf$var$_react.default.createElement($760f92bdadaaacaf$var$_starUnstarred.default, Object.assign({
        LEGACY_fallbackIcon: $760f92bdadaaacaf$var$_star.default
    }, props));
$760f92bdadaaacaf$var$StarUnstarredIcon.Name = 'StarUnstarredIconMigration';
var $760f92bdadaaacaf$var$_default = module.exports.default = $760f92bdadaaacaf$var$StarUnstarredIcon;

});

parcelRegister("kvs0K", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7ceab68aefb066f4$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7ceab68aefb066f4$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    starredCount: {
        id: 'ai-mate.agent-profile-info.starred-count',
        defaultMessage: '{starCount} {starCount, plural, one {user} other {users}}',
        description: 'Text showing the number of times an agent has been favourited or starred'
    }
});

});

parcelRegister("3JVCb", function(module, exports) {

$parcel$export(module.exports, "formatNumber", () => $df0f8414a9cb0884$export$f5dd818bff069720);
/* Example usage
formatNumber(4100); // Output: "4.1k"
formatNumber(1234567); // Output: "1.2M"
formatNumber(9876543210); // Output: "9.9B"
formatNumber(500); // Output: "500"
*/ const $df0f8414a9cb0884$export$f5dd818bff069720 = (inputNumber)=>{
    if (inputNumber >= 1e9) return (inputNumber / 1e9).toFixed(1) + 'B';
    else if (inputNumber >= 1e6) return (inputNumber / 1e6).toFixed(1) + 'M';
    else if (inputNumber >= 1e3) return (inputNumber / 1e3).toFixed(1) + 'k';
    else return inputNumber.toString();
};

});


parcelRegister("l31vR", function(module, exports) {

$parcel$export(module.exports, "AgentInstructions", () => $363ced64673ab2a7$export$48d253a044b54931);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $6tzHJ = parcelRequire("6tzHJ");

var $lGgwk = parcelRequire("lGgwk");

var $62UZ9 = parcelRequire("62UZ9");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $7rJgC = parcelRequire("7rJgC");
var $gOkqF = parcelRequire("gOkqF");
var $k9nuy = parcelRequire("k9nuy");

var $5KCCi = parcelRequire("5KCCi");

var $iFTfq = parcelRequire("iFTfq");
const $363ced64673ab2a7$var$styles = {
    copyButton: "_2rkosqtm _1bsbzwfg _4t3izwfg _bfhk11bn _irr312j4",
    fullSizeText: "_c71l1osq _18m91wug",
    instructionsContainer: "_2rkoiti9 _16jlkb7n _1o9zkb7n _i0dlf1ug _189ee4h9 _1dqonqa1 _1h6d1elr _o5726vc6 _kqswh2mm _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
    smallText: "_c71l1kdj _18m915zi",
    hidden: "_tzy4idpf",
    heading: "_1e0c1txw",
    forgeAgentWrapper: "_2rkoiti9 _16qszucj _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
};
const $363ced64673ab2a7$var$stylesCompiled = {
    copyContainer: "_kqswstnw _154i19bv _1xi219bv"
};
const $363ced64673ab2a7$export$48d253a044b54931 = ({ promptTemplate: promptTemplate, onCopy: onCopy, isForgeAgent: isForgeAgent, fullHeightText: fullHeightText = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [instructionsHovered, setInstructionsHovered] = (0, $5uXOq.useState)(false);
    const getInstructionsRender = ()=>{
        if (isForgeAgent) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
            xcss: $363ced64673ab2a7$var$styles.forgeAgentWrapper,
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($62UZ9))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
                    space: "space.100",
                    alignBlock: "start",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                            weight: "bold",
                            children: formatMessage((0, $iFTfq.default).privateInstructionsTitle)
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                            size: "small",
                            children: formatMessage((0, $iFTfq.default).privateInstructionsDescription)
                        })
                    ]
                })
            ]
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
            xcss: (0, $6tzHJ.cx)($363ced64673ab2a7$var$styles.instructionsContainer, fullHeightText ? $363ced64673ab2a7$var$styles.fullSizeText : $363ced64673ab2a7$var$styles.smallText),
            onMouseEnter: ()=>{
                setInstructionsHovered(true);
            },
            onMouseLeave: ()=>{
                setInstructionsHovered(false);
            },
            children: promptTemplate ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                        children: promptTemplate
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        className: (0, $bwpsq.default)([
                            $363ced64673ab2a7$var$stylesCompiled.copyContainer,
                            !instructionsHovered && $363ced64673ab2a7$var$styles.hidden
                        ]),
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
                            content: formatMessage((0, $iFTfq.default).copyInstructionsTooltip),
                            position: "top",
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
                                "aria-label": formatMessage((0, $iFTfq.default).copyInstructionsTooltip),
                                xcss: $363ced64673ab2a7$var$styles.copyButton,
                                onBlur: ()=>setInstructionsHovered(false),
                                onFocus: ()=>setInstructionsHovered(true),
                                onClick: ()=>onCopy(promptTemplate),
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lGgwk))), {
                                    color: "var(--ds-icon)",
                                    label: ""
                                })
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                as: "em",
                color: "color.text.subtle",
                children: formatMessage((0, $iFTfq.default).noInstructionPlaceholder)
            })
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gOkqF.default), {
        space: "space.100",
        grow: "fill",
        alignBlock: "start",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    as: "h2",
                    xcss: $363ced64673ab2a7$var$styles.heading,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                        size: "large",
                        color: "color.text.subtle",
                        weight: "semibold",
                        children: formatMessage((0, $iFTfq.default).instructionsLabel)
                    })
                }),
                getInstructionsRender()
            ]
        })
    });
};

});
parcelRegister("62UZ9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::766864a6ad12ee0b57d7ed41e0a75cca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $466f220dfb291cc3$var$_react = $466f220dfb291cc3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $466f220dfb291cc3$var$_lockLocked = $466f220dfb291cc3$var$_interopRequireDefault((parcelRequire("5DSGX")));

var $466f220dfb291cc3$var$_lock = $466f220dfb291cc3$var$_interopRequireDefault((parcelRequire("cln90")));
function $466f220dfb291cc3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LockLockedIcon.
 * This component is LockLockedIcon, with `UNSAFE_fallbackIcon` set to "LockIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $466f220dfb291cc3$var$LockLockedIcon = (props)=>/*#__PURE__*/ $466f220dfb291cc3$var$_react.default.createElement($466f220dfb291cc3$var$_lockLocked.default, Object.assign({
        LEGACY_fallbackIcon: $466f220dfb291cc3$var$_lock.default
    }, props));
$466f220dfb291cc3$var$LockLockedIcon.Name = 'LockLockedIconMigration';
var $466f220dfb291cc3$var$_default = module.exports.default = $466f220dfb291cc3$var$LockLockedIcon;

});
parcelRegister("5DSGX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $41bb04ef30194277$var$_react = $41bb04ef30194277$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $41bb04ef30194277$var$_baseNew = $41bb04ef30194277$var$_interopRequireDefault((parcelRequire("enEmH")));
function $41bb04ef30194277$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $41bb04ef30194277$var$LockLockedIcon = (props)=>/*#__PURE__*/ $41bb04ef30194277$var$_react.default.createElement($41bb04ef30194277$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$41bb04ef30194277$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $41bb04ef30194277$var$_default = module.exports.default = $41bb04ef30194277$var$LockLockedIcon;

});

parcelRegister("cln90", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8fc9662f19240bd3$var$_react = $8fc9662f19240bd3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $8fc9662f19240bd3$var$_lockLocked = $8fc9662f19240bd3$var$_interopRequireDefault((parcelRequire("5DSGX")));
function $8fc9662f19240bd3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8fc9662f19240bd3$var$LockIcon = (props)=>/*#__PURE__*/ $8fc9662f19240bd3$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props, {
        newIcon: $8fc9662f19240bd3$var$_lockLocked.default
    }));
$8fc9662f19240bd3$var$LockIcon.displayName = 'LockIcon';
var $8fc9662f19240bd3$var$_default = module.exports.default = $8fc9662f19240bd3$var$LockIcon;

});


parcelRegister("iFTfq", function(module, exports) {

$parcel$export(module.exports, "default", () => $923ecd8870165306$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $923ecd8870165306$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    instructionsLabel: {
        id: 'rovo-chat.view-agent.instructions-label',
        defaultMessage: 'Instructions',
        description: 'Label for instructions'
    },
    copyInstructionsLabel: {
        id: 'rovo-chat.view-agent.copy-instructions-label',
        defaultMessage: 'Copy',
        description: 'Label for copy instructions button'
    },
    copyInstructionsTooltip: {
        id: 'rovo-chat.view-agent.copy-instructions-tooltip',
        defaultMessage: 'Copy instructions',
        description: 'Label for copy instructions tooltip'
    },
    noInstructionPlaceholder: {
        id: 'rovo-chat.view-agent.no-instruction-placeholder',
        defaultMessage: 'This Agent has no custom instructions',
        description: 'Placeholder for no instructions'
    },
    privateInstructionsTitle: {
        id: 'rovo-chat.view-agent.hidden-instructions-title',
        defaultMessage: 'These instructions are private',
        description: 'Title of the instructions section, this is displayed when instructions are purposely hidden'
    },
    privateInstructionsDescription: {
        id: 'rovo-chat.view-agent.hidden-instructions-description',
        defaultMessage: 'Forge Agents built with code have their instructions hidden for privacy.',
        description: 'Description of the instructions section, this is displayed when instructions are purposely hidden'
    }
});

});


parcelRegister("jETdZ", function(module, exports) {

$parcel$export(module.exports, "useAgentDetailsController", () => $15453e445de87ba6$export$e65200649bbc56ce);
$parcel$export(module.exports, "useAgentDetailsByIdentityAccountId", () => $15453e445de87ba6$export$7d1c308c0d5404ad);

var $7yKOM = parcelRequire("7yKOM");

var $5XeR3 = parcelRequire("5XeR3");
var $1xmyx = parcelRequire("1xmyx");
const $15453e445de87ba6$export$e65200649bbc56ce = (0, $5XeR3.createHookWithAssistanceService)(({ agentId: agentId, enabled: enabled = true, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    const queryResult = (0, $1xmyx.useQuery)({
        queryKey: [
            'fetchAgentDetails',
            agentId
        ],
        queryFn: ()=>{
            experienceTracker.start({
                id: (0, $7yKOM.ExperienceName).FETCH_AGENT_BY_AGENT_ID,
                name: (0, $7yKOM.ExperienceName).FETCH_AGENT_BY_AGENT_ID
            });
            return assistanceService.getAgentDetails(agentId);
        },
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $7yKOM.ExperienceName).FETCH_AGENT_BY_AGENT_ID
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $7yKOM.ExperienceName).FETCH_AGENT_BY_AGENT_ID,
                error: error
            });
        },
        enabled: enabled
    });
    return queryResult;
});
const $15453e445de87ba6$export$7d1c308c0d5404ad = (0, $5XeR3.createHookWithAssistanceService)(({ identityAccountId: identityAccountId, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, enabled: enabled = true })=>{
    const queryResult = (0, $1xmyx.useQuery)({
        queryKey: [
            'fetchAgentDetails',
            identityAccountId
        ],
        queryFn: ()=>{
            experienceTracker.start({
                id: (0, $7yKOM.ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID,
                name: (0, $7yKOM.ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID
            });
            return assistanceService.getAgentDetailsByIdentityAccountId(identityAccountId);
        },
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $7yKOM.ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $7yKOM.ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID,
                error: error
            });
        },
        enabled: enabled
    });
    return queryResult;
});

});
parcelRegister("7yKOM", function(module, exports) {

$parcel$export(module.exports, "ExperienceName", () => $38417caab376e351$export$b881bd9f00ed8ed1);
const $38417caab376e351$export$b881bd9f00ed8ed1 = {
    LOAD_PANEL: 'aiMateLoadPanel',
    LOAD_BROWSE_AGENTS: 'aiMateLoadBrowseAgents',
    LOAD_CREATE_AGENT: 'aiMateLoadCreateAgent',
    FETCH_CHAT: 'aiMateFetchChat',
    FETCH_AGENTS: 'aiMateFetchAgents',
    FETCH_AGENT_BY_AGENT_ID: 'aiMateFetchAgentByAgentId',
    FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID: 'aiMateFetchAgentByIdentityAccountId',
    CREATE_AGENT: 'aiMateCreateAgent',
    UPDATE_AGENT: 'aiMateUpdateAgent',
    DELETE_AGENT: 'aiMateDeleteAgent',
    FAVOURITE_AGENT: 'aiMateFavouriteAgent',
    UNFAVOURITE_AGENT: 'aiMateUnfavouriteAgent',
    CLEAR_CHAT: 'aiMateClearChat',
    SEND_MESSAGE: 'aiMateSendMessage',
    ABORT_AGENT_STREAM: 'aiMateAbortAgentStream',
    GET_CONVERSATION_CHANNELS: 'aiMateGetConversationChannels',
    UPDATE_CONVERSATION_CHANNEL: 'aiMateUpdateConversationChannel',
    CREATE_SEEDED_CONVERSATION_CHANNEL: 'aiMateCreateSeededConversationChannel',
    PUBSUB_LISTENER: 'aiMatePubSubListener',
    FETCH_AGENT_TENANT_DATA: 'aiMateFetchAgentTenantData',
    RESOLVE_CONVERSATION_ACTION: 'aiMateResolveConversationAction',
    MESSAGE_RENDERER: 'aiMateMessageRenderer',
    FETCH_CONTEXTUAL_STARTERS: 'aiMateFetchContextualStarters',
    GENERATE_CONVERSATION_STARTERS: 'aiMateGenerateConversationStarters',
    FETCH_AGENT_TEAM_DATA: 'aiMateFetchAgentTeamData',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES: 'aiMateFetchConnectedKnowledgeSources',
    FETCH_AGENT_ACTIONS: 'aiMateFetchAgentActions',
    CHANGE_AGENT_OWNER: 'aiMateChangeAgentOwner',
    GET_AGENT_PERMISSIONS: 'aiMateGetAgentPermissions',
    SEND_MESSAGE_NL_AGENT: 'aiMateSendMessageNLAgent',
    GET_RECOMMENDED_AGENTS: 'aiMateGetRecommendedAgents',
    UPLOAD_FILES_TO_CONVERSATION: 'aiMateUploadFilesToConversation',
    GET_CONVERSATION_FILES: 'aiMateGetConversationFiles',
    CSM_WIDGET_RENDER: 'csmWidgetRender'
};

});

parcelRegister("5XeR3", function(module, exports) {

$parcel$export(module.exports, "AssistanceServiceBase", () => $e845276806fa61f3$export$40a7802808e2fbe3);
$parcel$export(module.exports, "AssistanceServiceImpl", () => $e845276806fa61f3$export$a522c5f4ccda1c94);
$parcel$export(module.exports, "AssistanceServiceProvider", () => $e845276806fa61f3$export$8fe647eb935c33db);
$parcel$export(module.exports, "useAssistanceService", () => $e845276806fa61f3$export$7e31a1844ebbaf85);
$parcel$export(module.exports, "createHookWithAssistanceService", () => $e845276806fa61f3$export$5a9ea20fc196ec62);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $fHpHg = parcelRequire("fHpHg");

var $jopI1 = parcelRequire("jopI1");

var $kD6NT = parcelRequire("kD6NT");

var $7lCro = parcelRequire("7lCro");

var $dX66M = parcelRequire("dX66M");

var $2caWH = parcelRequire("2caWH");

var $gmTID = parcelRequire("gmTID");

var $aJ4bL = parcelRequire("aJ4bL");

var $kwREC = parcelRequire("kwREC");
const $e845276806fa61f3$var$PRODUCT_HEADER = 'x-product';
const $e845276806fa61f3$var$EXPERIENCE_ID_HEADER = 'x-experience-id';
class $e845276806fa61f3$export$40a7802808e2fbe3 {
    constructor(props){
        this.endpointSpecificBaseUrl = {
            chat: '/gateway/api/assist/chat/v1',
            agent: '/gateway/api/assist/agents/v1',
            agentConfiguration: '/gateway/api/assist/agents/configuration/v1',
            conversationStarters: '/gateway/api/assist/rovo/v1/conversation-starters'
        };
        this.getConfig = ()=>{
            return {
                ...this.config
            };
        };
        const defaultBaseUrl = '/gateway/api/assist';
        const defaultConfig = {
            baseUrl: defaultBaseUrl,
            headers: {}
        };
        this.config = {
            ...props,
            baseUrl: props.baseUrl || defaultConfig.baseUrl,
            credentials: props.credentials,
            headers: {
                ...props.headers || defaultConfig.headers
            }
        };
    }
    createHeaders(init) {
        return new Headers({
            [$e845276806fa61f3$var$PRODUCT_HEADER]: this.config.product,
            [$e845276806fa61f3$var$EXPERIENCE_ID_HEADER]: this.config.experienceId,
            ...this.config.headers || {},
            ...init || {}
        });
    }
    async fetch({ path: path, options: options, endpointGroup: endpointGroup }) {
        const { baseUrl: configBaseUrl, credentials: configCredentials } = this.config;
        let baseUrlOverride = endpointGroup ? this.endpointSpecificBaseUrl[endpointGroup] : undefined;
        const baseUrl = baseUrlOverride ?? configBaseUrl;
        const requestUrl = (0, $2caWH.addPath)(baseUrl, path);
        const response = await (0, $kwREC.fetchFn)(requestUrl, {
            credentials: configCredentials,
            ...options
        });
        return (0, $2caWH.processResponse)({
            response: response
        });
    }
    async fetchJson(options) {
        const response = await this.fetch(options);
        const json = await response.json();
        return json;
    }
    async fetchStream(options) {
        const response = await this.fetch(options);
        return {
            responseData: {
                traceId: (0, $2caWH.getTraceIdFromResponse)(response)
            },
            generator: (0, $7lCro.readJsonStream)(response)
        };
    }
}
class $e845276806fa61f3$export$a522c5f4ccda1c94 extends $e845276806fa61f3$export$40a7802808e2fbe3 {
    constructor(props){
        super(props), this.getAgentActions = async ()=>{
            const response = await this.fetchJson({
                path: '/actions',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                endpointGroup: 'agentConfiguration'
            });
            return response.actions;
        }, this.getAgentKnowledgeConfiguration = ()=>{
            return this.fetchJson({
                path: '/knowledge',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                endpointGroup: 'agentConfiguration'
            });
        }, this.getAgentPermissions = (agentId, payload)=>{
            return this.fetchJson({
                path: `/api/rovo/v2/permissions/agents/${agentId}`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify(payload)
                }
            });
        }, this.getRecommendedAgents = ({ limit: limit, query: query })=>{
            return this.fetchJson({
                path: `/recommend/v2?limit=${limit}&query=${query}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                endpointGroup: 'agent'
            });
        }, this.getConversationDebugLogs = async (conversationId)=>{
            const response = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}/debug-logs`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                }
            });
            return response.items;
        }, this.uploadFiles = async (payload)=>{
            const formData = new FormData();
            for (const file of payload.files)formData.append('files', file);
            const response = await this.fetchJson({
                path: `/rovo/v1/chat/message/file`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders(),
                    body: formData
                }
            });
            return response;
        };
        if ((0, $fHpHg.fg)('rovo_convo_ai_migration')) {
            this.endpointSpecificBaseUrl.chat = '/gateway/api/assist/rovo/v1/chat';
            this.endpointSpecificBaseUrl.agent = '/gateway/api/assist/rovo/v1/agents';
            this.endpointSpecificBaseUrl.agentConfiguration = '/gateway/api/assist/rovo/v1/agents/configuration';
        }
    }
    async sendMessageStream({ agentNamedId: agentNamedId, agentId: agentId, message: message, conversationId: conversationId, controller: controller, storeMessage: storeMessage = false, citationsEnabled: citationsEnabled = true, editorContext: editorContext, browserContext: browserContext, additionalContext: additionalContext, fileIds: fileIds, webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        // If browserContext received and context is undefined, assume we're unable to retrieve the context of the page in focus
        const url = browserContext ? browserContext.context?.browserUrl : window?.location?.href;
        const body = {
            content: message,
            context: {
                browser_url: url,
                webSearchEnabled: webSearchEnabled,
                deepResearchEnabled: deepResearchEnabled,
                ...editorContext ? {
                    editor: editorContext
                } : {},
                // If browserUrl is inaccessable, fallback to htmlBody or canvasText if they exist
                ...browserContext ? {
                    browser: {
                        htmlBody: browserContext.context?.htmlBody,
                        canvasText: browserContext.context?.canvasText
                    }
                } : {},
                ...additionalContext,
                fileIds: fileIds
            },
            recipient_agent_named_id: agentNamedId,
            agent_id: agentId,
            mimeType: typeof message === 'string' ? 'text/markdown' : 'text/adf',
            // don't allow store message if feature flag is off
            store_message: (0, $fHpHg.fg)('ai_mate_show_store_messages') ? storeMessage : false,
            citations_enabled: citationsEnabled
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/${(0, $fHpHg.fg)('rovo_convo_ai_migration') ? 'conversation' : 'channel'}/${conversationId}/message/stream`,
            options: options,
            endpointGroup: 'chat'
        });
    }
    async getChat(conversationId) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        // Clean up `RawChat | { items: RawChat }` when fg('rovo_convo_ai_migration') is removed
        const rawChat = await this.fetchJson({
            path: `/${(0, $fHpHg.fg)('rovo_convo_ai_migration') ? 'conversation' : 'channel'}/${conversationId}/messages`,
            options: options,
            endpointGroup: 'chat'
        });
        const chatArray = 'items' in rawChat ? rawChat.items : rawChat;
        return chatArray.map((message)=>// Must be converted into StreamResponse
            (0, $dX66M.isHumanMessage)(message) ? message : (0, $aJ4bL.toStreamResponse)(message));
    }
    async deleteChat(conversationId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        await this.fetch({
            path: `/${(0, $fHpHg.fg)('rovo_convo_ai_migration') ? 'conversation' : 'channel'}/${conversationId}`,
            options: options,
            endpointGroup: 'chat'
        });
    }
    async getAgents(controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: '',
            options: options,
            endpointGroup: 'agent'
        });
        return 'items' in response ? response.items : response;
    }
    async getAgentDetails(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/${id}`,
            options: options,
            endpointGroup: 'agent'
        });
    }
    async getAgentDetailsByIdentityAccountId(identityAccountId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `accountid/${identityAccountId}`,
            options: options,
            endpointGroup: 'agent'
        });
    }
    async getAgentFileUploadToken(controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: 'agents/v1/media/upload/credentials',
            options: options
        });
    }
    async createAgent(payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        return this.fetchJson({
            path: '',
            options: options,
            endpointGroup: 'agent'
        });
    }
    async updateAgent(id, payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: `/${id}`,
            options: options,
            endpointGroup: 'agent'
        });
        return response;
    }
    async deleteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/${id}`,
            options: options,
            endpointGroup: 'agent'
        });
    }
    async favouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'POST',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/${id}/favourite`,
            options: options,
            endpointGroup: 'agent'
        });
    }
    async unfavouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/${id}/favourite`,
            options: options,
            endpointGroup: 'agent'
        });
    }
    async createConversationChannel(options) {
        return this.fetchJson({
            path: `/${(0, $fHpHg.fg)('rovo_convo_ai_migration') ? 'conversation' : 'channel'}`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify({
                    name: options?.name ?? (0, $gmTID.generateConversationName)(),
                    dialogues: options?.dialogues ?? undefined
                })
            },
            endpointGroup: 'chat'
        });
    }
    async getConversationChannels() {
        // Clean up `ConversationChannel[] | { items: ConversationChannel[] }` when fg('rovo_convo_ai_migration') is removed
        const result = await this.fetchJson({
            path: `/${(0, $fHpHg.fg)('rovo_convo_ai_migration') ? 'conversations' : 'channels'}`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            },
            endpointGroup: 'chat'
        });
        const channels = 'items' in result ? result.items : result;
        return channels;
    }
    updateConversationChannel(id, payload) {
        return this.fetchJson({
            path: `/${(0, $fHpHg.fg)('rovo_convo_ai_migration') ? 'conversation' : 'channel'}/${id}`,
            options: {
                method: 'PUT',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify(payload)
            },
            endpointGroup: 'chat'
        });
    }
    async resolveConversationAction(id, payload) {
        return this.fetchJson({
            path: `/${(0, $fHpHg.fg)('rovo_convo_ai_migration') ? 'conversation' : 'channel'}/${id}/action`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify({
                    ...payload,
                    context: {
                        ...payload.context,
                        browser_url: window.location.href
                    }
                })
            },
            endpointGroup: 'chat'
        });
    }
    async speechToText(blob) {
        const formData = new FormData();
        formData.append('audio_recording', blob);
        const response = await this.fetchJson({
            path: '/speech/inference',
            options: {
                method: 'POST',
                headers: this.createHeaders(),
                body: formData
            }
        });
        return response.transcription;
    }
    // REST starters, newer API
    async generateAgentStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/agent-starter-suggestion',
            options: options,
            endpointGroup: 'conversationStarters'
        });
    }
    /**
	 * @private
	 * @deprecated Use `generateAgentStarters` instead
	 */ async generateConversationStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/suggest-conversation-starter',
            options: options,
            endpointGroup: 'agent'
        });
    }
    // REST conversation starters, newer API
    async generateContextualStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/page-contextual',
            options: options,
            endpointGroup: 'conversationStarters'
        });
    }
    /**
	 * @private
	 * @deprecated Use `generateContextualStarters` instead
	 */ async generateContextualConversationStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchStream({
            path: '/conversation-starter',
            options: options,
            endpointGroup: 'agent'
        });
    }
}
const $e845276806fa61f3$var$AssistanceServiceContext = /*#__PURE__*/ (0, $5uXOq.createContext)(new $e845276806fa61f3$export$a522c5f4ccda1c94({
    baseUrl: '',
    product: '',
    experienceId: ''
}));
const $e845276806fa61f3$export$8fe647eb935c33db = ({ value: value, children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)($e845276806fa61f3$var$AssistanceServiceContext.Provider, {
        value: value,
        children: children
    });
const $e845276806fa61f3$export$7e31a1844ebbaf85 = (props)=>{
    (0, $gKZoD.di)((0, $5uXOq.useContext), $e845276806fa61f3$export$a522c5f4ccda1c94);
    const service = (0, $5uXOq.useContext)($e845276806fa61f3$var$AssistanceServiceContext);
    (0, $kD6NT.setRovoChatProduct)(props?.product ?? service.getConfig().product);
    if (!props || !props.experienceId && !props.product && !props.headers) return service;
    const product = props.product ?? service.getConfig().product;
    const experienceId = props.experienceId ?? service.getConfig().experienceId;
    const headers = props.headers ?? service.getConfig().headers;
    return new $e845276806fa61f3$export$a522c5f4ccda1c94({
        ...service.getConfig(),
        product: product,
        experienceId: experienceId,
        headers: headers
    });
};
const $e845276806fa61f3$export$5a9ea20fc196ec62 = (originalHook)=>{
    return (props)=>{
        (0, $gKZoD.di)($e845276806fa61f3$export$a522c5f4ccda1c94, (0, $jopI1.useAIMateExperienceTracker));
        const { assistanceServiceParams: assistanceServiceParams, ...restProps } = props;
        const experienceTracker = (0, $jopI1.useAIMateExperienceTracker)({
            touchpointSource: assistanceServiceParams.touchpointSource
        });
        const headers = (0, $5uXOq.useMemo)(()=>{
            return {
                'x-cloudid': props.assistanceServiceParams.siteId,
                ...props.assistanceServiceParams.headers
            };
        }, [
            props.assistanceServiceParams.siteId,
            props.assistanceServiceParams.headers
        ]);
        const assistanceService = (0, $5uXOq.useMemo)(()=>{
            return new $e845276806fa61f3$export$a522c5f4ccda1c94({
                product: assistanceServiceParams.product,
                experienceId: assistanceServiceParams.experienceId,
                headers: headers
            });
        }, [
            assistanceServiceParams.experienceId,
            assistanceServiceParams.product,
            headers
        ]);
        const result = originalHook({
            ...restProps,
            assistanceServiceInjectedParams: {
                ...assistanceServiceParams,
                headers: headers,
                experienceTracker: experienceTracker,
                assistanceService: assistanceService
            }
        });
        return result;
    };
};

});
parcelRegister("jopI1", function(module, exports) {

$parcel$export(module.exports, "useAIMateExperienceTracker", () => $4a779278da9eb90e$export$412c53791574f6f0);

var $5uXOq = parcelRequire("5uXOq");

var $bFNgM = parcelRequire("bFNgM");

var $l7HQg = parcelRequire("l7HQg");

var $9TAsu = parcelRequire("9TAsu");

var $edoq1 = parcelRequire("edoq1");
const $4a779278da9eb90e$var$isRovoInstrumentedError = (error)=>error && typeof error === 'object' && 'errorAttributes' in error && typeof error.errorAttributes === 'object';
class $4a779278da9eb90e$var$ExperienceTrackerHandler {
    constructor(){
        this.experienceTracker = new (0, $bFNgM.ExperienceTracker)();
        this.sendAnalyticsEvent = null;
        this.experienceTracker.subscribe((event)=>{
            // for FailEvent
            if ('error' in event) {
                // do not fail experience tracking if the error is a client fetch error
                if ((0, $l7HQg.isClientFetchError)(event.error)) return;
                let filteredErrorAttributes = {};
                if ($4a779278da9eb90e$var$isRovoInstrumentedError(event.error)) {
                    const errorAttributes = event.error.errorAttributes;
                    // Remove undefined properties
                    filteredErrorAttributes = Object.fromEntries(Object.entries(errorAttributes).filter(([_, value])=>value !== undefined));
                    // Filter 5xx errors since backend monitoring will cover this
                    // as per https://hello.atlassian.net/wiki/spaces/CONVAI/pages/3547354267/Meeting+notes+FE+SLOs+which+one+to+promote
                    if (errorAttributes?.statusCode && errorAttributes?.statusCode >= 500) return;
                }
                const error = event.error instanceof Error ? event.error : new Error(JSON.stringify(event.error));
                // this is added by `useExperienceTracker` below
                const touchpointSource = event.attributes?.touchpointSource;
                (0, $9TAsu.logException)({
                    exception: error,
                    name: event.name,
                    tags: {
                        source: 'aiMateExperienceTracker',
                        ...filteredErrorAttributes,
                        ...touchpointSource && {
                            touchpointSource: touchpointSource
                        }
                    }
                });
            }
            this.sendAnalyticsEvent?.({
                eventType: 'operational',
                action: event.action,
                actionSubject: 'ui',
                attributes: {
                    task: event.name,
                    taskId: event.id,
                    startTime: event.startTime,
                    ...event.attributes
                }
            }, {
                removeDefaultTags: true
            });
        });
    }
    setSendAnalyticsEvent(sendAnalyticsEvent) {
        this.sendAnalyticsEvent = sendAnalyticsEvent;
    }
    static getInstance() {
        if (!$4a779278da9eb90e$var$ExperienceTrackerHandler.instance) $4a779278da9eb90e$var$ExperienceTrackerHandler.instance = new $4a779278da9eb90e$var$ExperienceTrackerHandler();
        return $4a779278da9eb90e$var$ExperienceTrackerHandler.instance;
    }
}
const $4a779278da9eb90e$export$412c53791574f6f0 = (params)=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $edoq1.useAnalytics)();
    (0, $5uXOq.useMemo)(()=>{
        const experienceTracker = $4a779278da9eb90e$var$ExperienceTrackerHandler.getInstance();
        // this is not ideal, okay just because `sendAnalyticsEvent` is never change
        // since every hook instance will override the singleton sendAnalyticsEvent
        experienceTracker.setSendAnalyticsEvent(sendAnalyticsEvent);
    }, [
        sendAnalyticsEvent
    ]);
    const experienceTrackerProxy = (0, $5uXOq.useMemo)(()=>{
        const proxyHandler = {
            get: (target, prop)=>{
                // Overriding the fail method to add touchpointSource to the attributes
                if (prop === 'fail') return (failParams)=>{
                    target.fail({
                        ...failParams,
                        attributes: {
                            ...failParams.attributes,
                            touchpointSource: params?.touchpointSource
                        }
                    });
                };
                return typeof target[prop] === 'function' ? target[prop].bind(target) : target[prop];
            }
        };
        return new Proxy($4a779278da9eb90e$var$ExperienceTrackerHandler.getInstance().experienceTracker, proxyHandler);
    }, [
        params?.touchpointSource
    ]);
    return experienceTrackerProxy;
};

});
parcelRegister("l7HQg", function(module, exports) {

$parcel$export(module.exports, "isClientFetchError", () => $83aa62ff0a453e3c$export$2e7adc44463c3f4f);
// Referenced from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
const $83aa62ff0a453e3c$var$KNOWN_NETWORK_ERRORS = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $83aa62ff0a453e3c$var$isClientFetchErrorMessage = (message)=>Boolean(message) && !!$83aa62ff0a453e3c$var$KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $83aa62ff0a453e3c$var$KNOWN_NETWORK_ERRORS_TYPES = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $83aa62ff0a453e3c$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($83aa62ff0a453e3c$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.name) || $83aa62ff0a453e3c$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($83aa62ff0a453e3c$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.cause.name) || $83aa62ff0a453e3c$var$isClientFetchErrorMessage(error.cause.message)));

});

parcelRegister("9TAsu", function(module, exports) {

$parcel$export(module.exports, "setupSentryClient", () => $00af9eadb7d7ae94$export$d8bd0edf6c978788);
$parcel$export(module.exports, "logException", () => $00af9eadb7d7ae94$export$f86b2a1a2ce291b3);

var $2Ixla = parcelRequire("2Ixla");

var $l7HQg = parcelRequire("l7HQg");

var $cKFMg = parcelRequire("cKFMg");

var $8LaNB = parcelRequire("8LaNB");

// importing local file instead of from '@sentry/browser' otherwise there will be typescript errors
const $00af9eadb7d7ae94$var$importSentryAsync = async ()=>Promise.resolve((parcelRequire("8Xuap")));
let $00af9eadb7d7ae94$var$sentryClient;
// copied from platform/packages/people-and-teams/teams-client/src/services/sentry/utils/initialise-sentry.ts
const $00af9eadb7d7ae94$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
const $00af9eadb7d7ae94$var$getEnvironment = ()=>{
    return 'production';
};
const $00af9eadb7d7ae94$export$d8bd0edf6c978788 = async ({ customSentryDsn: customSentryDsn, packageName: packageName, product: productOverride } = {})=>{
    let accountId = 'UNKNOWN_AAID';
    let product = productOverride ?? (0, $cKFMg.getRovoChatProduct)();
    try {
        const profileData = await (0, $2Ixla.performHttpFetch)({
            path: '/gateway/api/me',
            options: {
                method: 'GET'
            }
        });
        if (profileData?.account_id) accountId = profileData.account_id;
    } catch (_) {
    // do nothing
    }
    if ($00af9eadb7d7ae94$var$sentryClient) {
        // if sentry is trying to be initialized again with new product or account id
        // update the user and tags
        $00af9eadb7d7ae94$var$sentryClient.setTag('product', product);
        $00af9eadb7d7ae94$var$sentryClient.setUser({
            id: accountId
        });
        // do not initialise sentry again, only update the existing one
        return;
    }
    let importedSentry;
    try {
        importedSentry = await $00af9eadb7d7ae94$var$importSentryAsync();
    } catch (e) {
        console.warn('Failed to load conversation-assistant sentry', e); // eslint-disable-line no-console
        return;
    }
    // https://atlassian-2y.sentry.io/projects/ai-mate-conversation-assistant/getting-started/
    const defaultSentryDsn = 'https://0d679a1c0fe3816e2b2e34d4ca85d5da@o55978.ingest.sentry.io/4506794008903680';
    importedSentry.init({
        dsn: customSentryDsn || defaultSentryDsn,
        environment: $00af9eadb7d7ae94$var$getEnvironment(),
        integrations: (integrations)=>{
            return integrations.filter((integration)=>{
                return $00af9eadb7d7ae94$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        },
        initialScope: {
            user: {
                id: accountId
            },
            tags: {
                packageName: packageName || '@atlassian/conversation-assistant',
                product: product
            }
        },
        // referencing jira/src/packages/platform/observability/errors-handling/src/utils/sentry/handling/normalise-sentry-event.tsx
        beforeSend: (event, hint)=>{
            const exception = hint?.originalException;
            // Ignore network-like errors
            if ((0, $l7HQg.isClientFetchError)(exception)) return null;
            if (!event.tags?.name) // we only want to capture errors that has `name` tag from `logException` function below
            // since the `DISABLED_INTEGRATIONS` filter above is not enough to prevent unhandled errors
            return null;
            let updatedEvent = event;
            if (updatedEvent.request?.url) {
                // Ignore events from localhost and staging
                if (updatedEvent.request.url.includes('localhost') || updatedEvent.request.url.includes('jira-dev.com') || updatedEvent.request.url.includes('stg.atlassian.com') || updatedEvent.request.url.includes('stg.internal.atlassian.com') || updatedEvent.request.url.includes('stg-east.frontend.public.atl-paas.net')) return null;
                updatedEvent.request.url = (0, $8LaNB.normaliseUrl)(updatedEvent.request.url);
            }
            return updatedEvent;
        },
        attachStacktrace: true
    });
    $00af9eadb7d7ae94$var$sentryClient = importedSentry;
};
const $00af9eadb7d7ae94$var$getSentryClient = async ()=>{
    if (!$00af9eadb7d7ae94$var$sentryClient) // this only happens if something using sentry before the initialisation in root app
    await $00af9eadb7d7ae94$export$d8bd0edf6c978788();
    return $00af9eadb7d7ae94$var$sentryClient;
};
const $00af9eadb7d7ae94$export$f86b2a1a2ce291b3 = async ({ exception: exception, name: name, tags: tags })=>{
    const sentryClient = await $00af9eadb7d7ae94$var$getSentryClient();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        scope.setTag('name', name);
        if (tags) scope.setTags(tags);
        sentryClient.captureException(exception, scope);
    });
};

});
parcelRegister("2Ixla", function(module, exports) {

$parcel$export(module.exports, "performHttpFetch", () => $edb5f075f21912a7$export$a38d93aa782475f6);
//Shared code with conversation-assistant-service/src/common/utils/fetch.ts

var $6JVUc = parcelRequire("6JVUc");
//TODO have this extend RovoInstrumentedError once that PR is merged
class $edb5f075f21912a7$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $edb5f075f21912a7$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $edb5f075f21912a7$var$processHttpErrorResponse({
            response: response
        });
        return await response.json();
    } catch (err) {
        throw new (0, $6JVUc.FetchError)(`performHttpFetch error whle fetching ${path}`, {
            cause: err
        });
    }
};
const $edb5f075f21912a7$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $edb5f075f21912a7$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status
    });
};

});
parcelRegister("6JVUc", function(module, exports) {

$parcel$export(module.exports, "FetchError", () => $e4f2d67d931012f1$export$26e841bcf1aeb894);
class $e4f2d67d931012f1$export$26e841bcf1aeb894 extends Error {
    constructor(message, cause){
        super(message), this.cause = cause;
        this.name = 'FetchError';
        if (cause) this.cause = cause;
    }
}

});


parcelRegister("cKFMg", function(module, exports) {

$parcel$export(module.exports, "getRovoChatProduct", () => $5fd48de3a64967f2$export$d4fdfa93c283ffc);
const $5fd48de3a64967f2$export$d4fdfa93c283ffc = ()=>{
    let product = 'UNKNOWN';
    if (window && window.__ROVO_CHAT_CONFIG_PRODUCT__) product = window.__ROVO_CHAT_CONFIG_PRODUCT__;
    return product;
};

});

parcelRegister("8LaNB", function(module, exports) {

$parcel$export(module.exports, "normaliseUrl", () => $56876a0cb88c13b0$export$d57ae76c6dc57a5);
const $56876a0cb88c13b0$var$pathnamePrefixes = [
    '/jira/',
    '/wiki/',
    '/browse/'
];
const $56876a0cb88c13b0$var$ATLAS_HOST = 'home.atlassian.com';
const $56876a0cb88c13b0$var$ATLAS_TEAM_HOST = 'team.atlassian.com';
const $56876a0cb88c13b0$export$d57ae76c6dc57a5 = (url)=>{
    try {
        let parsedUrl = new URL(url);
        let normalizedPath = '/any/';
        if (parsedUrl.host === $56876a0cb88c13b0$var$ATLAS_HOST || parsedUrl.host === $56876a0cb88c13b0$var$ATLAS_TEAM_HOST) // Replace org ID with "orgId" in the path
        normalizedPath = parsedUrl.pathname.replace(/\/o\/[^/]+/, '/o/orgId');
        const prefixRegex = new RegExp(`^(${$56876a0cb88c13b0$var$pathnamePrefixes.join('|')})`);
        if (prefixRegex.test(parsedUrl.pathname)) normalizedPath = parsedUrl.pathname.match(prefixRegex)[0];
        const normalizedUrl = `${parsedUrl.protocol}//${parsedUrl.host}${normalizedPath}`;
        return normalizedUrl;
    } catch (error) {
        return 'https://could-not-parse.example.com';
    }
};

});



parcelRegister("kD6NT", function(module, exports) {

$parcel$export(module.exports, "setRovoChatProduct", () => $254f824dbc14ec7e$export$caa27b16709bc2df);
// Dupe of same function from conversation-assistant
// No need to add a whole dependency just for this function
const $254f824dbc14ec7e$export$caa27b16709bc2df = (product)=>{
    if (window) window.__ROVO_CHAT_CONFIG_PRODUCT__ = product;
};

});

parcelRegister("7lCro", function(module, exports) {

$parcel$export(module.exports, "readJsonStream", () => $379b9575d03eccda$export$1f24b2b263bcfa75);

var $1BKqv = parcelRequire("1BKqv");
async function* $379b9575d03eccda$export$1f24b2b263bcfa75(response) {
    const reader = (0, $1BKqv.getBufferReader)(response);
    let doneStreaming = false;
    let remainder = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) try {
            const processedChunks = `${remainder}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            remainder = '';
            for (let chunk of processedChunks)try {
                yield JSON.parse(chunk);
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                remainder = chunk;
            }
        } catch (e) {
            const error = new Error(`Error Processing Stream Data: ${value}`);
            throw error;
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else throw e;
    }
    while (!doneStreaming);
}

});
parcelRegister("1BKqv", function(module, exports) {

$parcel$export(module.exports, "getBufferReader", () => $6181730ae99d6e46$export$f6383c3ea1307da9);
const $6181730ae99d6e46$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};

});


parcelRegister("dX66M", function(module, exports) {

$parcel$export(module.exports, "ACCEPTABLE_USE_VIOLATIONS_ERROR", () => $16be2229132bc005$export$c424fe9570a5f2d9);
$parcel$export(module.exports, "isHumanMessage", () => $16be2229132bc005$export$a69fab2afb88c2eb);
$parcel$export(module.exports, "isAssistantMessage", () => $16be2229132bc005$export$6f965deda7f0960c);
$parcel$export(module.exports, "isStreamResponse", () => $16be2229132bc005$export$b4631726cbc1440a);
$parcel$export(module.exports, "isAgentResponse", () => $16be2229132bc005$export$a6e5100ca2770191);
$parcel$export(module.exports, "isStreamError", () => $16be2229132bc005$export$d422a2733a3b5def);
$parcel$export(module.exports, "isStreamAUPError", () => $16be2229132bc005$export$1e1cf807ece63df4);
$parcel$export(module.exports, "isStreamAnswerPart", () => $16be2229132bc005$export$e45102edbc73b240);
$parcel$export(module.exports, "isStreamResearchStepContent", () => $16be2229132bc005$export$79a0ed7d987faa8f);
$parcel$export(module.exports, "isStreamResearchStepTitle", () => $16be2229132bc005$export$7b1c8227569f1a92);
$parcel$export(module.exports, "isStreamResearchStepSource", () => $16be2229132bc005$export$68192da24ac8c141);
$parcel$export(module.exports, "isStreamResearchStepCompleted", () => $16be2229132bc005$export$cfccfd17b68ccb0);
$parcel$export(module.exports, "isStreamResearchPayload", () => $16be2229132bc005$export$46e0fb5e4b019a49);
$parcel$export(module.exports, "isStreamTrace", () => $16be2229132bc005$export$fd5a05be03f147a0);
$parcel$export(module.exports, "isStreamPluginInvocation", () => $16be2229132bc005$export$51a1b4e474708d74);
$parcel$export(module.exports, "isFollowUpMessage", () => $16be2229132bc005$export$aeae5b4fda357302);
$parcel$export(module.exports, "isChannelNotFoundError", () => $16be2229132bc005$export$6ce1ccc24e75456f);
$parcel$export(module.exports, "isRateLimitedError", () => $16be2229132bc005$export$bc96a6a479480590);
$parcel$export(module.exports, "isHipaaError", () => $16be2229132bc005$export$f8b1b75846492611);
$parcel$export(module.exports, "isConversationChannelDataMessage", () => $16be2229132bc005$export$b454081350f4a578);

var $paD21 = parcelRequire("paD21");

var $3KVhk = parcelRequire("3KVhk");
const $16be2229132bc005$export$5945515082cc2cbf = 'CONVERSATION_CHANNEL_NOT_FOUND';
const $16be2229132bc005$export$c424fe9570a5f2d9 = 'ACCEPTABLE_USE_VIOLATIONS';
const $16be2229132bc005$export$fb661125ffb29bd6 = (message)=>{
    return $16be2229132bc005$export$a69fab2afb88c2eb(message) || $16be2229132bc005$export$6f965deda7f0960c(message) || $16be2229132bc005$export$b4631726cbc1440a(message);
};
const $16be2229132bc005$export$a69fab2afb88c2eb = (message)=>message instanceof Object && message.role === 'HUMAN';
const $16be2229132bc005$export$6f965deda7f0960c = (message)=>message instanceof Object && message.role === 'ASSISTANT';
const $16be2229132bc005$export$a6e5100ca2770191 = (message)=>message instanceof Object && $16be2229132bc005$export$6f965deda7f0960c(message.message);
const $16be2229132bc005$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $16be2229132bc005$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $16be2229132bc005$export$1e1cf807ece63df4 = (message)=>$16be2229132bc005$export$d422a2733a3b5def(message) && message.message?.message_template === $16be2229132bc005$export$c424fe9570a5f2d9;
const $16be2229132bc005$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $16be2229132bc005$export$79a0ed7d987faa8f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP';
const $16be2229132bc005$export$7b1c8227569f1a92 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE';
const $16be2229132bc005$export$68192da24ac8c141 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_SOURCE';
const $16be2229132bc005$export$cfccfd17b68ccb0 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_COMPLETE';
const $16be2229132bc005$export$46e0fb5e4b019a49 = (message)=>message instanceof Object && message.type === 'TRACE' && (message.message.message_template === 'RESEARCH_STEP' || message.message.message_template === 'RESEARCH_STEP_TITLE' || message.message.message_template === 'RESEARCH_STEP_SOURCE' || message.message.message_template === 'RESEARCH_STEP_COMPLETE');
const $16be2229132bc005$export$fd5a05be03f147a0 = (message)=>{
    // TRACE and research steps are sharing the same type, but we want to separate them
    if ($16be2229132bc005$export$46e0fb5e4b019a49(message)) return false;
    return message instanceof Object && message.type === 'TRACE';
};
const $16be2229132bc005$export$51a1b4e474708d74 = (message)=>message instanceof Object && message.type === 'PLUGIN_INVOCATION';
const $16be2229132bc005$export$821c27cda9a33379 = (message)=>message instanceof Object && message.role === 'PLUGIN_INVOCATION';
const $16be2229132bc005$export$aeae5b4fda357302 = (message)=>message !== undefined && message !== null && typeof message === 'object' && 'type' in message && message.type === 'FOLLOW_UP_QUERIES';
const $16be2229132bc005$export$6ce1ccc24e75456f = (error)=>(0, $3KVhk.isApiError)(error) && error.errorAttributes?.errorCode === $16be2229132bc005$export$5945515082cc2cbf;
const $16be2229132bc005$export$bc96a6a479480590 = (error)=>(0, $3KVhk.isApiError)(error) && error.errorAttributes.statusCode === 429;
const $16be2229132bc005$export$f8b1b75846492611 = (error)=>(0, $3KVhk.isApiError)(error) && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === (0, $paD21.ASSISTANCE_SERVICE_ERROR_CODES).HAS_HIPAA_ENABLED;
const $16be2229132bc005$export$b454081350f4a578 = (message)=>message instanceof Object && message.type === 'CONVERSATION_CHANNEL_DATA';

});
parcelRegister("paD21", function(module, exports) {

$parcel$export(module.exports, "ASSISTANCE_SERVICE_ERROR_CODES", () => $fc8fea2d953afb94$export$1106bf31edf2a9b8);
$parcel$export(module.exports, "STATUS_CODES", () => $fc8fea2d953afb94$export$333e4f57333eadfa);
const $fc8fea2d953afb94$export$e8114853eca81277 = 'ai-mate';
const $fc8fea2d953afb94$export$1106bf31edf2a9b8 = {
    AGENT_DOES_NOT_EXIST: 'errorAgentNotFound',
    USER_NOT_CREATOR: 'errorIncorrectOwner',
    AGENT_HAS_CONVERSATIONS: 'errorAgentInUse',
    AGENT_DEACTIVATED: 'convoai.rest.bad.request.archived.agent',
    ROVO_PRODUCT_NOT_ACTIVE: 'convoai.rest.rovo.product.not.active',
    HAS_HIPAA_ENABLED: 'convoai.rest.browsing.product.has.hipaa.enabled',
    FILE_SIZE_TOO_LARGE: 'convoai.rest.bad.request.file.size.too.large'
};
const $fc8fea2d953afb94$export$333e4f57333eadfa = {
    UNSUPPORTED_FILE_TYPE: 415
};

});

parcelRegister("3KVhk", function(module, exports) {

$parcel$export(module.exports, "ApiError", () => $39428d18d580ecbd$export$f2e832acab1bdd79);
$parcel$export(module.exports, "isApiError", () => $39428d18d580ecbd$export$89d83cc97c52a37);
$parcel$export(module.exports, "mapErrorToApiError", () => $39428d18d580ecbd$export$3c02d1a328d4d808);
class $39428d18d580ecbd$export$f2e832acab1bdd79 extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $39428d18d580ecbd$export$89d83cc97c52a37 = (error)=>error instanceof $39428d18d580ecbd$export$f2e832acab1bdd79;
const $39428d18d580ecbd$export$3c02d1a328d4d808 = (error)=>{
    if ($39428d18d580ecbd$export$89d83cc97c52a37(error)) return error;
    // Fallback since we expect the error to be an instance of ApiError
    return new $39428d18d580ecbd$export$f2e832acab1bdd79(error.message, {
        statusCode: 0
    });
};

});


parcelRegister("2caWH", function(module, exports) {

$parcel$export(module.exports, "addPath", () => $8463c3418aa8a2f1$export$4c25481b843feb0b);
$parcel$export(module.exports, "getTraceIdFromResponse", () => $8463c3418aa8a2f1$export$9f229e40eb65abfc);
$parcel$export(module.exports, "processResponse", () => $8463c3418aa8a2f1$export$21fcb6cfd5628534);

var $3KVhk = parcelRequire("3KVhk");
const $8463c3418aa8a2f1$export$4c25481b843feb0b = (baseUrl, path)=>{
    if (path === '') // return base url without trailing slash
    return baseUrl;
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
const $8463c3418aa8a2f1$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;
const $8463c3418aa8a2f1$var$processErrorResponse = async ({ response: response })=>{
    let errorCode;
    let outputErrorMessage;
    const responseText = await response.text();
    let rawErrorMessage;
    try {
        const errorBodyJson = JSON.parse(responseText);
        const { error_code: error_code, error_message: error_message, message_template: message_template, errors: errors, errorMessage: errorMessage } = errorBodyJson;
        rawErrorMessage = errorMessage ?? error_message;
        if (errors?.length) // Use a single error code for now
        errorCode = errors[0];
        else if (error_code) errorCode = error_code;
        else errorCode = message_template;
        if (!errorCode || !rawErrorMessage) outputErrorMessage = responseText;
        else outputErrorMessage = `${errorCode} - ${rawErrorMessage}`;
    } catch (err) {
        outputErrorMessage = responseText;
    }
    throw new (0, $3KVhk.ApiError)(`[Code ${response.status}] ${outputErrorMessage}`, {
        errorCode: errorCode,
        statusCode: response.status,
        rawErrorMessage: rawErrorMessage,
        traceId: $8463c3418aa8a2f1$export$9f229e40eb65abfc(response)
    });
};
const $8463c3418aa8a2f1$export$21fcb6cfd5628534 = async ({ response: response })=>{
    if (!response.ok || response.status >= 400) await $8463c3418aa8a2f1$var$processErrorResponse({
        response: response
    });
    return response;
};

});

parcelRegister("gmTID", function(module, exports) {

$parcel$export(module.exports, "generateConversationName", () => $862cdf48312f64dc$export$11cc4786742ed7c2);
const $862cdf48312f64dc$export$11cc4786742ed7c2 = ()=>{
    const date = new Date();
    const formattedDate = date.toLocaleDateString(undefined, {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
    });
    const formattedTime = date.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
    const name = `${formattedDate} ${formattedTime}`;
    return name;
};

});

parcelRegister("aJ4bL", function(module, exports) {

$parcel$export(module.exports, "getId", () => $18a8b9c03f260135$export$218c8c3169c024d2);
$parcel$export(module.exports, "updatePluginInvocation", () => $18a8b9c03f260135$export$a76cc257b3881cb7);
$parcel$export(module.exports, "addAnswerPart", () => $18a8b9c03f260135$export$6e5609c05ab74cc7);
$parcel$export(module.exports, "removeSensitiveData", () => $18a8b9c03f260135$export$efd4f6b5d168b654);
$parcel$export(module.exports, "createHumanMessage", () => $18a8b9c03f260135$export$4010f996e89e886a);
$parcel$export(module.exports, "toStreamResponse", () => $18a8b9c03f260135$export$3220a4ff7b3a96df);

var $dX66M = parcelRequire("dX66M");
const $18a8b9c03f260135$export$218c8c3169c024d2 = (streamResponse)=>streamResponse.message.message.id;
const $18a8b9c03f260135$var$updatePluginInvocationAssistantMessage = (response, streamPluginInvocation)=>{
    const { message: pluginInvocation } = streamPluginInvocation;
    const pluginInvocationMessage = {
        message_id: response.id,
        ...pluginInvocation
    };
    const updatedMessage = {
        ...response
    };
    const updatedPluginInvocations = [
        ...updatedMessage.plugin_invocations
    ];
    const currentIndex = updatedPluginInvocations.findIndex((pi)=>pi.plugin_name === pluginInvocationMessage.plugin_name);
    if (currentIndex === -1) updatedPluginInvocations.push(pluginInvocationMessage);
    else updatedPluginInvocations[currentIndex] = pluginInvocationMessage;
    updatedMessage.plugin_invocations = updatedPluginInvocations;
    return updatedMessage;
};
const $18a8b9c03f260135$var$updatePluginInvocationAgentResponse = (response, streamPluginInvocation)=>({
        ...response,
        message: $18a8b9c03f260135$var$updatePluginInvocationAssistantMessage(response.message, streamPluginInvocation)
    });
const $18a8b9c03f260135$export$a76cc257b3881cb7 = (response, streamPluginInvocation)=>({
        ...response,
        message: $18a8b9c03f260135$var$updatePluginInvocationAgentResponse(response.message, streamPluginInvocation)
    });
const $18a8b9c03f260135$var$addAnswerPartAssistantMessage = (response, answerPart)=>{
    const content = `${response.content}${answerPart.message.content}`;
    // Remove source indexes, e.g [^1^] from the content
    const cleanedContent = content.replace(/\[\^\d+\^\]/g, '');
    return {
        ...response,
        content: cleanedContent
    };
};
const $18a8b9c03f260135$var$addAnswerPartAgentResponse = (response, answerPart)=>({
        ...response,
        message: $18a8b9c03f260135$var$addAnswerPartAssistantMessage(response.message, answerPart)
    });
const $18a8b9c03f260135$export$6e5609c05ab74cc7 = (response, answerPart)=>({
        ...response,
        message: $18a8b9c03f260135$var$addAnswerPartAgentResponse(response.message, answerPart)
    });
const $18a8b9c03f260135$var$removeSensitiveDataAssistantMessage = (message)=>{
    const { plugin_invocations: plugin_invocations, ...rest } = message;
    return {
        ...rest,
        plugin_invocations: plugin_invocations.map((pluginInvocation)=>({
                ...pluginInvocation,
                plugin_output: '--PRIVATE--'
            }))
    };
};
const $18a8b9c03f260135$var$removeSensitiveDataAgentResponse = (message)=>({
        ...message,
        message: $18a8b9c03f260135$var$removeSensitiveDataAssistantMessage(message.message)
    });
const $18a8b9c03f260135$export$efd4f6b5d168b654 = (message)=>({
        ...message,
        message: $18a8b9c03f260135$var$removeSensitiveDataAgentResponse(message.message)
    });
const $18a8b9c03f260135$export$4010f996e89e886a = (id, content, isFromSeededConversation, requestId, fileUploads)=>{
    return {
        role: 'HUMAN',
        id: id,
        content: content,
        time_created: new Date().toISOString(),
        user_ari: 'unknown',
        plugin_invocations: [],
        isFromSeededConversation: isFromSeededConversation,
        requestId: requestId,
        file_uploads: fileUploads
    };
};
const $18a8b9c03f260135$export$3220a4ff7b3a96df = (message)=>{
    if ((0, $dX66M.isAgentResponse)(message)) return {
        type: 'FINAL_RESPONSE',
        message: message
    };
    return {
        type: 'FINAL_RESPONSE',
        message: {
            message: message
        }
    };
};

});

parcelRegister("kwREC", function(module, exports) {

$parcel$export(module.exports, "fetchFn", () => $c9c19eaadc4e24f6$export$10f0d162cb6dae7c);
const $c9c19eaadc4e24f6$export$10f0d162cb6dae7c = window.fetch;

});


parcelRegister("1xmyx", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $5d16a0171a4f2642$export$dd0a697e1782aedd);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");

var $3KVhk = parcelRequire("3KVhk");
const $5d16a0171a4f2642$var$store = (0, $iXqE5.createStore)({
    initialState: {
        cache: {}
    },
    actions: {
        updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const currentCacheEntry = state.cache[key] ?? {
                    data: null,
                    error: null,
                    isFetching: false
                };
                const newCacheEntry = {
                    ...currentCacheEntry,
                    ...value
                };
                setState({
                    cache: {
                        ...state.cache,
                        [key]: newCacheEntry
                    }
                });
            },
        getCacheEntry: (key)=>({ getState: getState })=>{
                const state = getState();
                return state.cache[key];
            }
    }
});
const $5d16a0171a4f2642$var$selector = (0, $6dDSs.createSelector)((state)=>state.cache, (_, key)=>key, (cache, key)=>cache[key] ?? {
        data: null,
        error: null,
        isFetching: false
    });
const $5d16a0171a4f2642$var$useCacheEntry = (0, $3sQ5x.createHook)($5d16a0171a4f2642$var$store, {
    selector: $5d16a0171a4f2642$var$selector
});
const $5d16a0171a4f2642$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const queryFnRef = (0, $5uXOq.useRef)(queryFn);
    queryFnRef.current = queryFn;
    const onSuccessRef = (0, $5uXOq.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $5uXOq.useRef)(onError);
    onErrorRef.current = onError;
    const [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $5d16a0171a4f2642$var$useCacheEntry(queryKey);
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        updateCacheEntry(queryKey, {
            isFetching: true
        });
        try {
            const response = await queryFnRef.current();
            updateCacheEntry(queryKey, {
                data: response
            });
            onSuccessRef.current?.(response);
            return response;
        } catch (error) {
            const apiError = (0, $3KVhk.mapErrorToApiError)(error);
            updateCacheEntry(queryKey, {
                error: apiError
            });
            onErrorRef.current?.(apiError);
        } finally{
            updateCacheEntry(queryKey, {
                isFetching: false
            });
        }
        return null;
    }, [
        updateCacheEntry,
        queryKey
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (enabled && refetchOnWindowFocus) {
            const unbind = (0, $cBeZP.bind)(window, {
                // We use visibilitychange instead of focus to prevent triggering refetch when moving between iframes such as agent embed
                type: 'visibilitychange',
                listener: ()=>{
                    if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) {
                        if (document.visibilityState === 'visible') fetchData();
                    }
                }
            });
            return unbind;
        }
    }, [
        enabled,
        fetchData,
        getCacheEntry,
        queryKey,
        refetchOnWindowFocus
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!getCacheEntry(queryKey) && enabled) fetchData();
    }, [
        queryKey,
        fetchData,
        enabled,
        getCacheEntry
    ]);
    return {
        data: cache.data,
        error: cache.error,
        isFetching: cache.isFetching,
        refetch: fetchData
    };
};

});


parcelRegister("kRFJP", function(module, exports) {

$parcel$export(module.exports, "LeftAside", () => $76d46d005e78785e$export$e56858e2d9136a46);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6tzHJ = parcelRequire("6tzHJ");

var $gOkqF = parcelRequire("gOkqF");

var $1ii8i = parcelRequire("1ii8i");
const $76d46d005e78785e$var$style = {
    root: "_ca0qv47k _n3tdv47k _19bvv47k _u5f3v47k _1bahv2br _1bsbnklw _1ul9nklw",
    rootFullWidth: "_1bsb1osq"
};
const $76d46d005e78785e$export$e56858e2d9136a46 = ({ children: children })=>{
    const { isSingleColumn: isSingleColumn } = (0, $1ii8i.useLayoutStore)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gOkqF.default), {
            space: "space.400",
            xcss: (0, $6tzHJ.cx)($76d46d005e78785e$var$style.root, isSingleColumn && $76d46d005e78785e$var$style.rootFullWidth),
            children: children
        })
    });
};

});
parcelRegister("1ii8i", function(module, exports) {

$parcel$export(module.exports, "useLayoutStore", () => $56dba5b5d1cc42fa$export$ee413f68c0e5c346);
$parcel$export(module.exports, "useLayoutStoreActions", () => $56dba5b5d1cc42fa$export$6136bc3b9858cff4);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $56dba5b5d1cc42fa$var$SINGLE_COLUMN_BREAKPOINT = 768;
const $56dba5b5d1cc42fa$var$initialState = {
    containerWidth: null
};
const $56dba5b5d1cc42fa$var$actions = {
    setContainerWidth: (containerWidth)=>({ setState: setState })=>{
            setState({
                containerWidth: containerWidth
            });
        }
};
const $56dba5b5d1cc42fa$var$LayoutStore = (0, $iXqE5.createStore)({
    initialState: $56dba5b5d1cc42fa$var$initialState,
    actions: $56dba5b5d1cc42fa$var$actions,
    name: 'LayoutStore'
});
const $56dba5b5d1cc42fa$var$useLayoutStoreInner = (0, $3sQ5x.createHook)($56dba5b5d1cc42fa$var$LayoutStore, {
    selector: (state)=>({
            ...state,
            isSingleColumn: !!(state.containerWidth && state.containerWidth < $56dba5b5d1cc42fa$var$SINGLE_COLUMN_BREAKPOINT)
        })
});
const $56dba5b5d1cc42fa$export$ee413f68c0e5c346 = ()=>$56dba5b5d1cc42fa$var$useLayoutStoreInner()[0];
const $56dba5b5d1cc42fa$export$6136bc3b9858cff4 = ()=>$56dba5b5d1cc42fa$var$useLayoutStoreInner()[1];

});


parcelRegister("l3JiM", function(module, exports) {

$parcel$export(module.exports, "ProfileContent", () => $8a0bfbf96a5a9f3f$export$ecf07060fe596e2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6tzHJ = parcelRequire("6tzHJ");

var $5sRpy = parcelRequire("5sRpy");
var $AX5oF = parcelRequire("AX5oF");

var $1ii8i = parcelRequire("1ii8i");
const $8a0bfbf96a5a9f3f$var$styles = {
    root: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1osq _p12fr84k",
    flexColumn: "_2lx21bp4",
    grid: "_1e0c11p5 _yv0eqw8w _1bsb1osq"
};
const $8a0bfbf96a5a9f3f$export$ecf07060fe596e2 = ({ children: children })=>{
    const { isSingleColumn: isSingleColumn } = (0, $1ii8i.useLayoutStore)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $8a0bfbf96a5a9f3f$var$styles.root,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $AX5oF.default), {
            xcss: (0, $6tzHJ.cx)(isSingleColumn ? $8a0bfbf96a5a9f3f$var$styles.flexColumn : $8a0bfbf96a5a9f3f$var$styles.grid),
            children: children
        })
    });
};

});

parcelRegister("d2HJp", function(module, exports) {

$parcel$export(module.exports, "useDialog", () => $2c3dd77304e93fb2$export$d55e7ee900f34e93);

var $5uXOq = parcelRequire("5uXOq");

var $lvtc2 = parcelRequire("lvtc2");
const $2c3dd77304e93fb2$export$d55e7ee900f34e93 = ()=>{
    return (0, $5uXOq.useContext)((0, $lvtc2.DialogsContext));
};

});

parcelRegister("ax2O8", function(module, exports) {

$parcel$export(module.exports, "useExpTrackerStart", () => $3f7b5fd906da5dcd$export$3ec42c6cc9df311c);

var $5uXOq = parcelRequire("5uXOq");

var $1P5xc = parcelRequire("1P5xc");

var $358cZ = parcelRequire("358cZ");
function $3f7b5fd906da5dcd$export$3ec42c6cc9df311c(options) {
    const { id: id, name: name, timeout: timeout, isTriggerOnMount: isTriggerOnMount = true, subExperiences: subExperiences, latencySloMs: latencySloMs, startAttributes: startAttributes, onSuccess: onSuccess } = options;
    const analytics = (0, $358cZ.default)();
    const tracker = analytics.expTracker();
    const triggerStartEvent = (0, $5uXOq.useCallback)(()=>{
        const options = {
            id: id,
            name: name,
            timeout: timeout,
            collect: undefined,
            attributes: startAttributes,
            onSuccess: onSuccess
        };
        if (subExperiences) options.collect = (0, $1P5xc.collectAll)(subExperiences);
        if (latencySloMs) options.attributes = {
            latencySlo: latencySloMs
        };
        tracker.start(options);
    }, [
        id,
        name,
        timeout,
        startAttributes,
        onSuccess,
        subExperiences,
        latencySloMs,
        tracker
    ]);
    const triggerSuccessEvent = (0, $5uXOq.useCallback)(()=>{
        tracker.succeed({
            name: name
        });
    }, [
        name,
        tracker
    ]);
    const triggerFailEvent = (0, $5uXOq.useCallback)((error)=>{
        tracker.stopOnError({
            name: name,
            error: error
        });
    }, [
        name,
        tracker
    ]);
    const triggerAbortEvent = (0, $5uXOq.useCallback)((reason)=>{
        tracker.abort({
            name: name,
            reason: reason
        });
    }, [
        name,
        tracker
    ]);
    // we use 'useState' here because we want to trigger start event as soon as possible, before rendering component,
    (0, $5uXOq.useState)(()=>{
        // default behaviour: trigger start event when mounting.
        // "isTriggerOnMount=false" is allow to turn off the default behaviour.
        if (isTriggerOnMount) triggerStartEvent();
    });
    // allow to trigger start event whenever consumers want like inside onClick.
    return {
        start: triggerStartEvent,
        succeed: triggerSuccessEvent,
        abort: triggerAbortEvent,
        fail: triggerFailEvent
    };
}

});
parcelRegister("1P5xc", function(module, exports) {

$parcel$export(module.exports, "collectAll", () => $06e2b88955436c6e$export$feb7963ae429f97f);
$parcel$export(module.exports, "collectAny", () => $06e2b88955436c6e$export$79dbdd3e43727beb);

var $8YP6t = parcelRequire("8YP6t");
function $06e2b88955436c6e$export$feb7963ae429f97f(experienceNames) {
    const experienceNameSet = new Set(experienceNames);
    return (events, experience)=>{
        // Fail as soon as any sub-experience is failed or aborted
        experience.stopOn(events.find((event)=>experienceNameSet.has(event.name) && (event.action === 'taskFail' || event.action === 'taskAbort')));
        // If there's a success remove the experience from the set
        // of experiences we're waiting for.
        events.forEach((event)=>{
            if ((0, $8YP6t.isStop)(event)) experienceNameSet.delete(event.name);
        });
        // Experience is considered complete if all sub-experiences
        // are complete.
        if (experienceNameSet.size === 0) experience.succeed();
    };
}
function $06e2b88955436c6e$export$79dbdd3e43727beb(experienceNames) {
    return (events, experience)=>experience.stopOn(events.find((event)=>(0, $8YP6t.isStop)(event) && (0, $8YP6t.hasName)(event, ...experienceNames)));
}

});


parcelRegister("c5iyg", function(module, exports) {

$parcel$export(module.exports, "useExpTrackerStop", () => $0d13b5a8fd39b1ff$export$432668e70196929c);

var $5uXOq = parcelRequire("5uXOq");

var $e3a3O = parcelRequire("e3a3O");

var $358cZ = parcelRequire("358cZ");
function $0d13b5a8fd39b1ff$export$432668e70196929c(options) {
    const { name: name, error: error, checkShouldAbort: checkShouldAbort } = options;
    const analytics = (0, $358cZ.default)();
    const tracker = analytics.expTracker();
    (0, $5uXOq.useEffect)(()=>{
        const triggerStopEvent = ()=>{
            if (!error) return;
            // If error has a statusCode of 429, abort instead.
            if ($0d13b5a8fd39b1ff$var$isRateLimitError(error)) {
                abortExpTracker(`Ignoring 429 error: ${error.message}`);
                return;
            }
            tracker.stopOnError({
                name: name,
                error: error
            });
        };
        const abortExpTracker = (reason)=>{
            tracker.abort({
                name: name,
                reason: reason
            });
        };
        if (error) {
            const reason = checkShouldAbort ? checkShouldAbort(error) : undefined;
            if (typeof reason === 'string' || $0d13b5a8fd39b1ff$var$isRateLimitError(error)) abortExpTracker(reason ?? `Ignoring 429 error: ${error.message}`);
            else triggerStopEvent();
        }
    }, [
        checkShouldAbort,
        error,
        name,
        tracker
    ]);
}
const $0d13b5a8fd39b1ff$var$isRateLimitError = (error)=>{
    if (error instanceof (0, $e3a3O.ApolloError) && error.networkError) return $0d13b5a8fd39b1ff$var$isRateLimitError(error.networkError);
    return 'statusCode' in error && error.statusCode === 429 || 'status' in error && error.status === 429 || error.message.includes('429');
};

});

parcelRegister("hOFm5", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_TIMEOUT_USER_EXP", () => $45f193ef8943fd17$export$6a2b57b882ff619b);
$parcel$export(module.exports, "UserExperienceNames", () => $45f193ef8943fd17$export$aff1d63763bf8a44);
$parcel$export(module.exports, "TEAM_PROFILE_PAGE_SUB_EVENT_NAMES", () => $45f193ef8943fd17$export$f6872ed66cc3dc3a);
$parcel$export(module.exports, "USER_PROFILE_PAGE_SUB_EVENT_NAMES", () => $45f193ef8943fd17$export$e302f7a9166a33eb);
$parcel$export(module.exports, "SEARCH_HOME_PAGE_SUB_EVENT_NAMES", () => $45f193ef8943fd17$export$ab5c192ffd15cb07);
$parcel$export(module.exports, "CREATE_TEAM_FLOW_SUB_EVENT_NAMES", () => $45f193ef8943fd17$export$bebaacf4c0d1b056);
// Use defaut timeout from Confluence
// https://stash.atlassian.com/projects/confcloud/repos/confluence-frontend/browse/next/packages/experience-tracker/src/ExperienceTimeout.ts#2
const $45f193ef8943fd17$export$6a2b57b882ff619b = 60000; // 60s
const $45f193ef8943fd17$export$c816bd9ab77da948 = 15000; // 15s
var $45f193ef8943fd17$export$aff1d63763bf8a44 = /*#__PURE__*/ function(UserExperienceNames) {
    UserExperienceNames["CREATE_TEAM"] = "createTeam";
    UserExperienceNames["CREATE_TEAM_OPEN_DIALOG"] = "createTeam/openDialog";
    UserExperienceNames["CREATE_TEAM_SUBMIT"] = "createTeam/create";
    // a compound experience
    UserExperienceNames["TEAM_PROFILE_PAGE"] = "teamProfile/render";
    UserExperienceNames["TEAM_PROFILE_MEMBERS"] = "teamProfile/membersPanel";
    UserExperienceNames["TEAM_PROFILE_LINKS"] = "teamProfile/links";
    UserExperienceNames["TEAM_PROFILE_WORKED_ON"] = "teamProfile/workedOn";
    UserExperienceNames["TEAM_PROFILE_TEAMS_CONTAINERS"] = "teamProfile/teamsContainers";
    UserExperienceNames["TEAM_PROFILE_TEAM_ABOUT"] = "teamProfile/teamAboutPanel";
    UserExperienceNames["TEAM_PROFILE_PROJECTS_AND_GOALS"] = "teamProfile/projectsAndGoals";
    UserExperienceNames["TEAM_PROFILE_HELP_POINTERS"] = "teamProfile/helpPointers";
    UserExperienceNames["TEAM_PROFILE_KUDOS"] = "teamProfile/kudos";
    UserExperienceNames["TEAM_PROFILE_SOFTWARE_COMPONENTS"] = "teamProfile/softwareComponents";
    UserExperienceNames["USER_PROFILE_AI_TOPICS"] = "userProfile/aiTopics";
    // a compound experience
    UserExperienceNames["USER_PROFILE_PAGE"] = "userProfile/render";
    UserExperienceNames["USER_PROFILE_PAGE_SLOW"] = "userProfile/renderSlow";
    UserExperienceNames["USER_PROFILE_WORKED_ON"] = "userProfile/workedOn";
    UserExperienceNames["USER_PROFILE_CONTAINERS"] = "userProfile/container";
    UserExperienceNames["USER_PROFILE_USER_ABOUT"] = "userProfile/userAbout";
    UserExperienceNames["USER_PROFILE_COLLABORATORS"] = "userProfile/collaborators";
    UserExperienceNames["USER_PROFILE_USERS_TEAMS"] = "userProfile/usersTeams";
    UserExperienceNames["USER_PROFILE_USER_MANAGER"] = "userProfile/userManager";
    UserExperienceNames["USER_PROFILE_TAG"] = "userProfile/tag";
    // a compound experience
    UserExperienceNames["SEARCH_HOME_PAGE"] = "searchHomePage/render";
    UserExperienceNames["SEARCH_HOME_PAGE_COLLABORATORS"] = "searchHomePage/collaborators";
    UserExperienceNames["SEARCH_HOME_PAGE_YOUR_TEAMS"] = "searchHomePage/yourTeams";
    UserExperienceNames["USER_PROFILE_PROJECTS_AND_GOALS"] = "userProfile/projectsAndGoals";
    UserExperienceNames["USER_PROFILE_MANAGERS_AND_TEAMS"] = "userProfile/managersAndTeams";
    UserExperienceNames["USER_PROFILE_KUDOS"] = "userProfile/kudos";
    // edit team name or description from Team profile page
    UserExperienceNames["EDIT_TEAM_NAME_OR_DESCRIPTION"] = "editTeamNameOrDescription";
    // remove team member
    UserExperienceNames["REMOVE_TEAM_MEMBER"] = "removeTeamMember";
    UserExperienceNames["REMOVE_TEAM_MEMBER_OPEN_DIALOG"] = "removeTeamMember/openDialog";
    UserExperienceNames["REMOVE_TEAM_MEMBER_SUBMIT"] = "removeTeamMember/submit";
    // upload user avatar from User profile page
    UserExperienceNames["UPLOAD_USER_AVATAR"] = "uploadUserAvatar";
    UserExperienceNames["UPLOAD_HEADER_IMAGE"] = "uploadHeaderImage";
    // team membership control changing
    UserExperienceNames["MEMBERSHIP_CONTROL_CHANGE"] = "membershipControl/change";
    UserExperienceNames["MEMBERSHIP_CONTROL_HANDLE_REQUESTS"] = "membershipControl/handleRequests";
    UserExperienceNames["MEMBERSHIP_CONTROL_TEAM_TYPE"] = "membershipControl/teamType";
    // agent profile page
    UserExperienceNames["AGENT_PROFILE_PAGE"] = "agentProfile/render";
    return UserExperienceNames;
}({});
const $45f193ef8943fd17$export$f6872ed66cc3dc3a = [
    "teamProfile/membersPanel",
    "teamProfile/links",
    "teamProfile/workedOn",
    "teamProfile/teamAboutPanel"
];
const $45f193ef8943fd17$export$e302f7a9166a33eb = [
    "userProfile/userAbout",
    "userProfile/usersTeams",
    "userProfile/workedOn",
    "userProfile/container",
    "userProfile/collaborators"
];
const $45f193ef8943fd17$export$ab5c192ffd15cb07 = [
    "searchHomePage/collaborators",
    "searchHomePage/yourTeams"
];
const $45f193ef8943fd17$export$bebaacf4c0d1b056 = [
    "createTeam/openDialog",
    "createTeam/create"
];
const $45f193ef8943fd17$export$74d8df99c7474c3b = [
    "removeTeamMember/openDialog",
    "removeTeamMember/submit"
];

});

parcelRegister("9OeO9", function(module, exports) {

$parcel$export(module.exports, "filterExcludedMessages", () => $c72cf1d2f4775536$export$c29ee7cc86cf93b3);
$parcel$export(module.exports, "ORG_ARI_PREFIX", () => $c72cf1d2f4775536$export$1c01d3601a97c3b);
$parcel$export(module.exports, "fromV2ToTeamSearchViewFormat", () => $c72cf1d2f4775536$export$af61e778dfb162b1);
$parcel$export(module.exports, "trimUserARI", () => $c72cf1d2f4775536$export$4fd803d471120b8f);
const $c72cf1d2f4775536$var$EXCLUDED_GRAPHQL_ERROR_MESSAGES = [
    'TeamDeleted'
];
function $c72cf1d2f4775536$export$c29ee7cc86cf93b3(errors) {
    return errors.filter((error)=>$c72cf1d2f4775536$var$EXCLUDED_GRAPHQL_ERROR_MESSAGES.every((excludedMessage)=>!error.message.includes(excludedMessage)) && error?.extensions?.classification !== 'TEAMS_TEAM_DELETED');
}
const $c72cf1d2f4775536$export$ec4e6762fd0f4a48 = 'ari:cloud:teams::team/';
const $c72cf1d2f4775536$export$cfedc369802e0c68 = 'ari:cloud:identity::team/';
const $c72cf1d2f4775536$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $c72cf1d2f4775536$export$1c01d3601a97c3b = 'ari:cloud:platform::org/';
const $c72cf1d2f4775536$export$af61e778dfb162b1 = (nodes)=>{
    return nodes.map((node)=>{
        return {
            id: $c72cf1d2f4775536$export$5916b2f8faacfe5a(node.team.id),
            orgId: node.team.organizationId,
            membershipSettings: node.team.membershipSettings,
            description: node.team.description,
            displayName: node.team.displayName,
            state: node.team.state,
            largeAvatarImageUrl: node.team.largeAvatarImageUrl,
            smallAvatarImageUrl: node.team.smallAvatarImageUrl,
            largeHeaderImageUrl: node.team.largeHeaderImageUrl,
            smallHeaderImageUrl: node.team.smallHeaderImageUrl,
            members: node.team.members?.nodes?.filter((memberNode)=>memberNode.member?.id)?.map((memberNode)=>({
                    id: $c72cf1d2f4775536$export$4fd803d471120b8f(memberNode.member?.id),
                    status: memberNode.member?.accountStatus,
                    fullName: memberNode.member?.name || '',
                    avatarUrl: memberNode.member?.picture
                })),
            memberCount: node.memberCount,
            includesYou: node.includesYou,
            isVerified: node.team.isVerified
        };
    });
};
const $c72cf1d2f4775536$export$5916b2f8faacfe5a = (teamId = '')=>{
    return teamId.replace($c72cf1d2f4775536$export$cfedc369802e0c68, '').replace($c72cf1d2f4775536$export$ec4e6762fd0f4a48, ''); // PTC-4213 will remove the references to the old team ARI
};
const $c72cf1d2f4775536$export$4fd803d471120b8f = (userId = '')=>{
    return userId.replace($c72cf1d2f4775536$export$470b0d72e4fdc43a, '');
};
const $c72cf1d2f4775536$export$a94a044414e86bdc = (orgId)=>{
    return orgId?.replace($c72cf1d2f4775536$export$1c01d3601a97c3b, '');
};

});

parcelRegister("dHLes", function(module, exports) {

$parcel$export(module.exports, "useRovoAgentData", () => $e0a1b2f6b85abbf3$export$763c7f4444e7eb2d);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $e0a1b2f6b85abbf3$var$setAgentInfo = (data)=>({ setState: setState })=>{
        setState({
            agentData: data
        });
    };
const $e0a1b2f6b85abbf3$var$actions = {
    setAgentInfo: $e0a1b2f6b85abbf3$var$setAgentInfo
};
const $e0a1b2f6b85abbf3$var$RovoAgentStore = (0, $iXqE5.createStore)({
    initialState: {
        agentData: undefined
    },
    actions: $e0a1b2f6b85abbf3$var$actions
});
const $e0a1b2f6b85abbf3$export$6301922aaad7e8f5 = (0, $3sQ5x.createHook)($e0a1b2f6b85abbf3$var$RovoAgentStore, {
    selector: (state)=>state.agentData
});
const $e0a1b2f6b85abbf3$export$763c7f4444e7eb2d = (0, $3sQ5x.createHook)($e0a1b2f6b85abbf3$var$RovoAgentStore);

});

parcelRegister("cOGeJ", function(module, exports) {

$parcel$export(module.exports, "App", () => $1bb2547f42c82b63$export$86fbec116b87613f);
$parcel$export(module.exports, "RelativeWrapperOfHeaderImage", () => $1bb2547f42c82b63$export$c0d0370fa0c37541);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
const $1bb2547f42c82b63$export$86fbec116b87613f = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "ccxr90-0"
})`height:100%;*{box-sizing:border-box;}a:hover{text-decoration:none;}`;
const $1bb2547f42c82b63$export$c0d0370fa0c37541 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "ccxr90-1"
})`position:relative;`;

});

parcelRegister("22aG8", function(module, exports) {

$parcel$export(module.exports, "default", () => $435c746a4df8d954$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1geG0 = parcelRequire("1geG0");

var $lQVnR = parcelRequire("lQVnR");
var $hOZZp = parcelRequire("hOZZp");

var $4tRqw = parcelRequire("4tRqw");
function $435c746a4df8d954$var$ContainersInProfilePage(props) {
    const { userId: userId, status: status, userFullName: userFullName } = props;
    const [{ principalUserId: principalUserId }] = (0, $1geG0.usePrincipalUser)();
    const { error: error, hasError: hasError, data: data, loading: loading } = (0, $4tRqw.default)({
        userId: userId,
        maxNumberOfCards: (0, $lQVnR.DEFAULT_CARDS_SIZE)
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hOZZp.default), {
        hasLoaded: !!data && !loading,
        isCurrentUser: principalUserId === userId,
        userStatus: status,
        hasError: hasError,
        error: error,
        items: data,
        userId: userId,
        userFullName: userFullName
    });
}
var $435c746a4df8d954$export$2e2bcd8739ae039 = $435c746a4df8d954$var$ContainersInProfilePage;

});
parcelRegister("lQVnR", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CARDS_SIZE", () => $08566b7d89a6d95f$export$eea11e2ee6ebb03f);

var $hOZZp = parcelRequire("hOZZp");
const $08566b7d89a6d95f$export$eea11e2ee6ebb03f = 4;

});
parcelRegister("hOZZp", function(module, exports) {

$parcel$export(module.exports, "default", () => $350469a961b71ae4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");

var $fHpHg = parcelRequire("fHpHg");

var $gOkqF = parcelRequire("gOkqF");

var $fOvl8 = parcelRequire("fOvl8");

var $hOFm5 = parcelRequire("hOFm5");
var $71wio = parcelRequire("71wio");
var $ax2O8 = parcelRequire("ax2O8");
var $c5iyg = parcelRequire("c5iyg");
var $fpUTy = parcelRequire("fpUTy");

var $xf627 = parcelRequire("xf627");

var $bdzum = parcelRequire("bdzum");

var $4KFLF = parcelRequire("4KFLF");

var $dnvXl = parcelRequire("dnvXl");
const $350469a961b71ae4$var$MAX_PLACES_LIMIT = 50;
function $350469a961b71ae4$var$ProfilePlaces(props) {
    const { hasError: hasError, error: error, hasLoaded: hasLoaded, isCurrentUser: isCurrentUser, userStatus: userStatus, items: items = [], userId: userId, userFullName: userFullName } = props;
    (0, $ax2O8.useExpTrackerStart)({
        id: userId,
        name: (0, $hOFm5.UserExperienceNames).USER_PROFILE_CONTAINERS,
        timeout: (0, $hOFm5.DEFAULT_TIMEOUT_USER_EXP)
    });
    (0, $c5iyg.useExpTrackerStop)({
        name: (0, $hOFm5.UserExperienceNames).USER_PROFILE_CONTAINERS,
        error: error
    });
    const renderSkeleton = ()=>{
        const defaultNumOfPlaces = 4;
        return Array(defaultNumOfPlaces).fill(undefined).map((_, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4KFLF.default), {
                type: "space",
                name: "",
                path: "",
                hasLoaded: false
            }, `item-${index}`));
    };
    const renderPlacesList = ()=>{
        /**
		 * NOTE: Following is just a hack to limit the total number of boards.
		 * In real life the total number of places will be far less than this.
		 * But since there's no guarantee that the backend will not be sending
		 * a very large number of boards, the following limit is enforced.
		 */ const places = items.slice(0, $350469a961b71ae4$var$MAX_PLACES_LIMIT);
        const Wrapper = (0, $fHpHg.fg)('user-profile-refresh') ? $350469a961b71ae4$var$ListWrapper : $dnvXl.ProfilePlacesList;
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
            "data-test-selector": "profile-places",
            children: hasLoaded ? places.map((item)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4KFLF.default), {
                    type: item.type,
                    name: item.name,
                    path: item.path,
                    icon: item.icon,
                    hasLoaded: true
                }, `${item.type}-${item.name}`)) : renderSkeleton()
        });
    };
    const headline = isCurrentUser ? $350469a961b71ae4$export$defe85febe8b728c.ownerHeadline : userStatus === (0, $fpUTy.UserStatus).inactive || userStatus === (0, $fpUTy.UserStatus).closed ? $350469a961b71ae4$export$defe85febe8b728c.otherHeadlinePast : $350469a961b71ae4$export$defe85febe8b728c.otherHeadline;
    // loading --> rendering skeleton
    // not loading + empty data --> rendering empty state and ExperienceSuccess
    // not loading + has error --> rendering nothing and "useExpTrackerStop" will trigger the stop experience event.
    // not loading + has data --> render UI and ExperienceSuccess
    if (hasLoaded && !hasError && items.length === 0) {
        const ListWrapper = (0, $fHpHg.fg)('user-profile-refresh') ? (0, $fOvl8.ItemWrapper) : $dnvXl.EmptyPlacesList;
        // trigger success event when data is loaded but it's empty
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bdzum.PanelContent), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bdzum.PanelContentHeader), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bdzum.PanelContentTitle), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...headline
                        })
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)(ListWrapper, {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $xf627.default), {
                        isCurrentUser: isCurrentUser || false,
                        userFullName: userFullName,
                        userStatus: userStatus
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $71wio.ExperienceSuccess), {
                    hasLoaded: true,
                    name: (0, $hOFm5.UserExperienceNames).USER_PROFILE_CONTAINERS
                })
            ]
        });
    }
    if (hasError) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bdzum.PanelContent), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bdzum.PanelContentHeader), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bdzum.PanelContentTitle), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...headline
                    })
                })
            }),
            renderPlacesList(),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $71wio.ExperienceSuccess), {
                hasLoaded: hasLoaded && !hasError,
                name: (0, $hOFm5.UserExperienceNames).USER_PROFILE_CONTAINERS
            })
        ]
    });
}
const $350469a961b71ae4$var$ListWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gOkqF.default), {
        space: "space.150",
        "data-test-selector": "profile-places",
        children: children
    });
};
const $350469a961b71ae4$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    ownerHeadline: {
        id: 'pf-home.profile-page.places-list.owner.headline',
        defaultMessage: 'Places you work in',
        description: 'Section headline for Places where a users personal Confluence space and Jira boards shown to profile owner'
    },
    otherHeadline: {
        id: 'pf-home.profile-page.places-list.other.headline',
        defaultMessage: 'Places they work in',
        description: 'Section headline for Places where a users personal Confluence space and Jira boards shown to a profile visitor'
    },
    otherHeadlinePast: {
        id: 'pf-home.profile-page.places-list.other.headline-past',
        defaultMessage: 'Places they work in',
        description: 'Section headline for Places where a deactivated or deleted users personal Confluence space and Jira boards shown to a profile visitor'
    }
});
var $350469a961b71ae4$export$2e2bcd8739ae039 = $350469a961b71ae4$var$ProfilePlaces;

});
parcelRegister("fOvl8", function(module, exports) {

$parcel$export(module.exports, "ItemWrapper", () => $5026174e77569aee$export$ef9839ae55b8ba40);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6tzHJ = parcelRequire("6tzHJ");

var $5sRpy = parcelRequire("5sRpy");
const $5026174e77569aee$var$styles = {
    wrapper: "_2rkopd34 _189ee4h9 _1h6dmuej _1dqonqa1 _kqswh2mm _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvutpp _p12f1osq",
    extraPadding: "_ca0qv47k _u5f3xy5q _n3tdv47k _19bvxy5q"
};
const $5026174e77569aee$export$ef9839ae55b8ba40 = ({ testId: testId, children: children, extraPadding: extraPadding, testSelector: testSelector, ...rest })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        backgroundColor: "elevation.surface",
        xcss: (0, $6tzHJ.cx)($5026174e77569aee$var$styles.wrapper, extraPadding && $5026174e77569aee$var$styles.extraPadding),
        testId: testId,
        "data-test-selector": testSelector,
        ...rest,
        children: children
    });
};

});

parcelRegister("71wio", function(module, exports) {

$parcel$export(module.exports, "ExperienceSuccess", () => $99472b68527d15eb$export$4962f3898bd5c829);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $h0nKJ = parcelRequire("h0nKJ");
function $99472b68527d15eb$export$4962f3898bd5c829(props) {
    const { hasLoaded: hasLoaded, name: name, attributes: attributes } = props;
    if (!hasLoaded) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h0nKJ.ExperienceSuccess), {
        name: name,
        attributes: attributes
    });
}

});
parcelRegister("h0nKJ", function(module, exports) {

$parcel$export(module.exports, "ExperienceSuccess", () => $7a1ec720c2434438$export$4962f3898bd5c829);

var $5uXOq = parcelRequire("5uXOq");

var $47QoQ = parcelRequire("47QoQ");
function $7a1ec720c2434438$export$4962f3898bd5c829({ name: name, attributes: attributes }) {
    const experienceTracker = (0, $5uXOq.useContext)((0, $47QoQ.ExperienceTrackerContext));
    (0, $5uXOq.useEffect)(()=>experienceTracker.succeed({
            name: name,
            attributes: attributes
        }), [
        name,
        attributes,
        experienceTracker
    ]);
    return null;
}

});


parcelRegister("fpUTy", function(module, exports) {

$parcel$export(module.exports, "UserStatus", () => $50209f2fd8f37c7d$export$a82073022ded66e8);
$parcel$export(module.exports, "FieldType", () => $50209f2fd8f37c7d$export$ed12481c953b8653);
var $50209f2fd8f37c7d$export$ef730685c1b8e238 = /*#__PURE__*/ function(UserPrivacyLevel) {
    UserPrivacyLevel["private"] = "private";
    UserPrivacyLevel["domain"] = "domain";
    UserPrivacyLevel["public"] = "public";
    return UserPrivacyLevel;
}({});
var $50209f2fd8f37c7d$export$a82073022ded66e8 = /*#__PURE__*/ function(UserStatus) {
    UserStatus["active"] = "active";
    UserStatus["inactive"] = "inactive";
    UserStatus["closed"] = "closed";
    return UserStatus;
}({});
var $50209f2fd8f37c7d$export$ed12481c953b8653 = /*#__PURE__*/ function(FieldType) {
    FieldType["FullName"] = "fullName";
    FieldType["Nickname"] = "nickname";
    FieldType["Title"] = "title";
    FieldType["Department"] = "department";
    FieldType["CompanyName"] = "companyName";
    FieldType["Location"] = "location";
    FieldType["Timezone"] = "timezone";
    FieldType["Email"] = "email";
    FieldType["PhoneNumber"] = "phoneNumber";
    FieldType["Avatar"] = "picture";
    FieldType["Language"] = "language";
    FieldType["LocalTime"] = "localTime";
    FieldType["RemoteWeekdayIndex"] = "remoteWeekdayIndex";
    FieldType["RemoteWeekdayString"] = "remoteWeekdayString";
    FieldType["RemoteTimeString"] = "remoteTimeString";
    return FieldType;
}({});
var $50209f2fd8f37c7d$export$a9678af7d3f0f4cb = /*#__PURE__*/ function(IdentityFieldName) {
    IdentityFieldName["PHONE_NUMBER"] = "phone_number";
    IdentityFieldName["JOB_TITLE"] = "job_title";
    IdentityFieldName["DEPARTMENT"] = "department";
    IdentityFieldName["COMPANY_NAME"] = "organization";
    IdentityFieldName["LOCATION"] = "location";
    IdentityFieldName["ZONEINFO"] = "zoneinfo";
    IdentityFieldName["NAME"] = "name";
    IdentityFieldName["EMAIL"] = "email";
    return IdentityFieldName;
}({});

});

parcelRegister("xf627", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d936d4b8fbdb9cb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $fpUTy = parcelRequire("fpUTy");

var $kbFku = parcelRequire("kbFku");

var $5D7Kd = parcelRequire("5D7Kd");
const $6d936d4b8fbdb9cb$var$EmptyPlacesListState = ({ isCurrentUser: isCurrentUser, userFullName: userFullName, userStatus: userStatus })=>{
    const intl = (0, $koVbs.default)();
    const renderDescText = ()=>{
        const descMessage = isCurrentUser ? $6d936d4b8fbdb9cb$var$messages.noPlacesListOwnerDesc : userStatus === (0, $fpUTy.UserStatus).inactive || userStatus === (0, $fpUTy.UserStatus).closed ? $6d936d4b8fbdb9cb$var$messages.noPlacesListPastUserDesc : $6d936d4b8fbdb9cb$var$messages.noPlacesListOtherDesc;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...descMessage,
            values: {
                user: userFullName
            }
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kbFku.default), {
        title: intl.formatMessage($6d936d4b8fbdb9cb$var$messages.noPlacesListTitle),
        description: renderDescText(),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($5D7Kd)))
    });
};
const $6d936d4b8fbdb9cb$var$messages = (0, $7VHMR.defineMessages)({
    noPlacesListTitle: {
        id: 'ptc-directory.profile-page.places-list.no-places-list.title',
        defaultMessage: "We don\u2019t have places to show here yet",
        description: 'Title of the message displayed when there is no places associated to the profile that is being viewed'
    },
    noPlacesListOwnerDesc: {
        id: 'ptc-directory.profile-page.places-list.no-places-list.owner.description',
        defaultMessage: "There are no projects or spaces you\u2019ve worked in across the last 90 days.",
        description: 'Description of the message displayed when there is no places associated to the owner profile that is being viewed'
    },
    noPlacesListOtherDesc: {
        id: 'ptc-directory.profile-page.places-list.no-places-list.other.description',
        defaultMessage: "{user} hasn\u2019t worked in any projects or spaces in the last 90 days.",
        description: 'Description of the message displayed when there is no places associated to the person profile that is being viewed'
    },
    noPlacesListPastUserDesc: {
        id: 'ptc-directory.profile-page.places-list.no-places-list.past-user.description',
        defaultMessage: "{user}\u2019s account is deactivated or deleted. We can\u2019t show the projects or spaces {user} worked in across the last 90 days.",
        description: 'Description of the message displayed when there is no places associated to a deactivated or deleted users profile that is being viewed'
    }
});
var $6d936d4b8fbdb9cb$export$2e2bcd8739ae039 = $6d936d4b8fbdb9cb$var$EmptyPlacesListState;

});
parcelRegister("kbFku", function(module, exports) {

$parcel$export(module.exports, "default", () => $77fac237b565a051$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hyN0T = parcelRequire("hyN0T");
function $77fac237b565a051$export$c696c866211ccfa4({ title: title, description: description, image: image, imageUrl: imageUrl, actions: actions, py: py, px: px, testId: testId }) {
    const img = imageUrl ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hyN0T.EmptyStateImage), {
        src: imageUrl
    }) : image;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hyN0T.EmptyStateContainer), {
        py: py,
        px: px,
        "data-testid": testId,
        children: [
            img && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hyN0T.EmptyStateImageContainer), {
                children: img
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hyN0T.EmptyStateBody), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hyN0T.EmptyStateTitle), {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hyN0T.EmptyStateDescription), {
                        children: description
                    }),
                    actions && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hyN0T.EmptyStateActions), {
                        children: actions
                    })
                ]
            })
        ]
    });
}
var $77fac237b565a051$export$2e2bcd8739ae039 = $77fac237b565a051$export$c696c866211ccfa4;

});
parcelRegister("hyN0T", function(module, exports) {

$parcel$export(module.exports, "EmptyStateContainer", () => $297d751e1c338d64$export$2a511c47e1cb5779);
$parcel$export(module.exports, "EmptyStateImageContainer", () => $297d751e1c338d64$export$bd5d2fea0a40a42f);
$parcel$export(module.exports, "EmptyStateImage", () => $297d751e1c338d64$export$a7907bb86a15af4e);
$parcel$export(module.exports, "EmptyStateBody", () => $297d751e1c338d64$export$df244a6e5075ebb4);
$parcel$export(module.exports, "EmptyStateTitle", () => $297d751e1c338d64$export$54260be545246e4e);
$parcel$export(module.exports, "EmptyStateDescription", () => $297d751e1c338d64$export$242239d9c1732d0a);
$parcel$export(module.exports, "EmptyStateActions", () => $297d751e1c338d64$export$725343b91068621d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $b4a3S = parcelRequire("b4a3S");

var $bWGt6 = parcelRequire("bWGt6");
function $297d751e1c338d64$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $297d751e1c338d64$var$gridSizeTimes = (factor)=>(0, $b4a3S.gridSize)() * factor;
const $297d751e1c338d64$export$2a511c47e1cb5779 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1i83sxm6"
})((props)=>({
        position: 'relative',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `${$297d751e1c338d64$var$gridSizeTimes(props.py || 4)}px ${$297d751e1c338d64$var$gridSizeTimes(props.px || 7)}px`,
        transition: 'box-shadow 0.25s ease',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center'
    }));
const $297d751e1c338d64$export$bd5d2fea0a40a42f = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1i83sxm5"
})({
    display: 'flex',
    flex: '0 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${$297d751e1c338d64$var$gridSizeTimes(15)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxHeight: `${$297d751e1c338d64$var$gridSizeTimes(15)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginRight: `${$297d751e1c338d64$var$gridSizeTimes(4)}px`,
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    svg: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `${$297d751e1c338d64$var$gridSizeTimes(15)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: `${$297d751e1c338d64$var$gridSizeTimes(15)}px`
    }
});
const $297d751e1c338d64$export$a7907bb86a15af4e = /*#__PURE__*/ (0, $bWGt6.default)("img", {
    target: "e1i83sxm4"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${$297d751e1c338d64$var$gridSizeTimes(15)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxHeight: `${$297d751e1c338d64$var$gridSizeTimes(15)}px`
});
const $297d751e1c338d64$export$df244a6e5075ebb4 = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1i83sxm3"
})({
    name: "p4355k",
    styles: "min-width:180px"
});
const $297d751e1c338d64$export$54260be545246e4e = /*#__PURE__*/ (0, $bWGt6.default)("h3", {
    target: "e1i83sxm2"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginBottom: `${$297d751e1c338d64$var$gridSizeTimes(2)}px`
});
const $297d751e1c338d64$export$242239d9c1732d0a = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e1i83sxm1"
})({
    name: "0",
    styles: ""
});
const $297d751e1c338d64$export$725343b91068621d = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1i83sxm0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginTop: `${$297d751e1c338d64$var$gridSizeTimes(2)}px`
});

});


parcelRegister("5D7Kd", function(module, exports) {
module.exports = new URL("PlacesListEmpty_ptc.36d458cf.svg", import.meta.url).toString();

});


parcelRegister("bdzum", function(module, exports) {

$parcel$export(module.exports, "PanelContent", () => $f894a752c1884a28$export$d30ae7d97aafb468);
$parcel$export(module.exports, "PanelContentHeader", () => $f894a752c1884a28$export$eb71a19746598b2f);
$parcel$export(module.exports, "PanelContentTitle", () => $f894a752c1884a28$export$c703356189ebc2de);
$parcel$export(module.exports, "PanelContentBody", () => $f894a752c1884a28$export$c75fef9a59663656);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

const $f894a752c1884a28$export$d30ae7d97aafb468 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1r5dj51-0"
})``;
const $f894a752c1884a28$export$eb71a19746598b2f = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1r5dj51-1"
})`display:flex;flex-direction:row;justify-content:space-between;margin-bottom:${(props)=>props.hasSubInfo ? "var(--ds-space-050, 4px)" : "var(--ds-space-200, 16px)"};position:relative;`;
const $f894a752c1884a28$export$c703356189ebc2de = /*#__PURE__*/ (0, $47bDC.default).h2.withConfig({
    componentId: "sc-1r5dj51-2"
})`font:${"var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin-top:0;word-break:'break-all';`;
const $f894a752c1884a28$export$58f06e463130acb4 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1r5dj51-3"
})`background:${`var(--ds-background-neutral, ${(0, $a7f8c6b391092279$export$9fdfb749e33cdf97)})`};border-radius:${"var(--ds-border-radius-100, 3px)"};padding:${"var(--ds-space-100, 8px)"};`;
const $f894a752c1884a28$export$c75fef9a59663656 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1r5dj51-4"
})`background:${`var(--ds-surface-raised, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`};border-radius:${"var(--ds-border-radius-100, 3px)"};box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $a7f8c6b391092279$export$7d3359664e8bb0e5)}, 0 0 1px 1px ${(0, $a7f8c6b391092279$export$46987b49aab6d1a8)}`})`};padding-top:${"var(--ds-space-200, 16px)"};padding-bottom:${"var(--ds-space-200, 16px)"};padding-left:${"var(--ds-space-075, 6px)"};padding-right:${"var(--ds-space-075, 6px)"};`;

});

parcelRegister("4KFLF", function(module, exports) {

$parcel$export(module.exports, "default", () => $755eadfeee7c7697$export$2e2bcd8739ae039);

var $9DDfD = parcelRequire("9DDfD");
var $755eadfeee7c7697$export$2e2bcd8739ae039 = (0, $9DDfD.default);

});
parcelRegister("9DDfD", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca8a13d1764cad2a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ew55A = parcelRequire("ew55A");

var $8P27X = parcelRequire("8P27X");

var $aqJO7 = parcelRequire("aqJO7");

var $1n8gK = parcelRequire("1n8gK");

var $eCE62 = parcelRequire("eCE62");

var $fHpHg = parcelRequire("fHpHg");

var $b4a3S = parcelRequire("b4a3S");

var $fOvl8 = parcelRequire("fOvl8");

var $cprXC = parcelRequire("cprXC");
var $jl7rH = parcelRequire("jl7rH");
var $99vc1 = parcelRequire("99vc1");
var $358cZ = parcelRequire("358cZ");

var $jRy8d = parcelRequire("jRy8d");
const $ca8a13d1764cad2a$export$d4349a8ff634836e = $jRy8d.PlaceLink;
const $ca8a13d1764cad2a$var$MainIcon = ({ icon: icon, type: type })=>{
    if (icon) return /*#__PURE__*/ (0, $2OMIu.jsx)($jRy8d.BaseIcon, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ew55A.default), {
            size: "small",
            src: icon,
            appearance: "square"
        })
    });
    if (type === 'space') return /*#__PURE__*/ (0, $2OMIu.jsx)($jRy8d.SpaceIcon, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8P27X))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1n8gK))),
            color: "currentColor",
            LEGACY_size: "medium",
            spacing: "spacious",
            label: ""
        })
    });
    else if (type === 'board') return /*#__PURE__*/ (0, $2OMIu.jsx)($jRy8d.BoardIcon, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aqJO7))), {
            color: "currentColor",
            LEGACY_size: "medium",
            spacing: "spacious",
            label: ""
        })
    });
    return null;
};
const $ca8a13d1764cad2a$var$HeaderIcon = ({ type: type })=>{
    switch(type){
        case 'space':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jl7rH.default), {
                size: "xsmall",
                productKey: (0, $99vc1.ShortProductKey).CONFLUENCE
            });
        case 'board':
        case 'project':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jl7rH.default), {
                size: "xsmall",
                productKey: (0, $99vc1.ShortProductKey).JIRA
            });
        default:
            return null;
    }
};
function $ca8a13d1764cad2a$var$typeToTitle(type) {
    switch(type){
        case 'space':
            return 'Confluence';
        case 'board':
        case 'project':
            return 'Jira';
        default:
            return '';
    }
}
const $ca8a13d1764cad2a$export$a67ff5ee53b7f29a = (props)=>{
    const analytics = (0, $358cZ.default)();
    const { name: name, path: path, type: type, hasLoaded: hasLoaded } = props;
    const handleAnchorClick = ()=>{
        analytics.pushUIEvent({
            source: (0, $cprXC.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'placesLink',
            action: (0, $cprXC.AnalyticsEventActions).CLICKED,
            attributes: {
                type: type
            }
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ca8a13d1764cad2a$var$PlacesItem, {
        children: hasLoaded ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)($jRy8d.Header, {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)($jRy8d.HeaderIcon, {
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)($ca8a13d1764cad2a$var$HeaderIcon, {
                                type: type
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)($jRy8d.HeaderTitle, {
                            children: $ca8a13d1764cad2a$var$typeToTitle(type)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)($jRy8d.Content, {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)($ca8a13d1764cad2a$var$MainIcon, {
                            ...props
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)($jRy8d.Details, {
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)($ca8a13d1764cad2a$export$d4349a8ff634836e, {
                                href: path,
                                onClick: handleAnchorClick,
                                children: name
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCE62.default), {
                    isShimmering: true,
                    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
                    cssFn: ()=>({
                            minHeight: (0, $b4a3S.gridSize)() * 2,
                            width: (0, $b4a3S.gridSize)() * 18.75,
                            marginBottom: "var(--ds-space-050, 4px)",
                            paddingLeft: 0,
                            paddingRight: 0
                        })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCE62.default), {
                    hasIcon: true,
                    isShimmering: true,
                    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
                    cssFn: ()=>({
                            minHeight: (0, $b4a3S.gridSize)() * 3.5,
                            paddingLeft: 0,
                            paddingRight: 0
                        })
                })
            ]
        })
    });
};
const $ca8a13d1764cad2a$var$PlacesItem = ({ children: children })=>(0, $fHpHg.fg)('user-profile-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fOvl8.ItemWrapper), {
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($jRy8d.PlacesItem, {
        children: children
    });
var $ca8a13d1764cad2a$export$2e2bcd8739ae039 = $ca8a13d1764cad2a$export$a67ff5ee53b7f29a;

});
parcelRegister("1n8gK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ffe5a82abdb038e$var$_react = $0ffe5a82abdb038e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");
function $0ffe5a82abdb038e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0ffe5a82abdb038e$var$FolderFilledIcon = (props)=>/*#__PURE__*/ $0ffe5a82abdb038e$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.2 6h7.81C21.108 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.99 1.992H3.99A1.99 1.99 0 0 1 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862z"/></svg>`
    }, props));
$0ffe5a82abdb038e$var$FolderFilledIcon.displayName = 'FolderFilledIcon';
var $0ffe5a82abdb038e$var$_default = module.exports.default = $0ffe5a82abdb038e$var$FolderFilledIcon;

});

parcelRegister("jl7rH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6685ce9a1d9528d6$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $h6M2t = parcelRequire("h6M2t");
var $jo1Bz = parcelRequire("jo1Bz");
var $39fIG = parcelRequire("39fIG");
var $ds5Yo = parcelRequire("ds5Yo");
var $kWm7C = parcelRequire("kWm7C");
var $c9lm5 = parcelRequire("c9lm5");

var $99vc1 = parcelRequire("99vc1");
function $6685ce9a1d9528d6$export$2e2bcd8739ae039(props) {
    const { productKey: productKey, size: size = 'small', defaultIcon: defaultIcon = null, productName: productName } = props;
    const mapProductKeyToIcon = {
        [(0, $99vc1.ShortProductKey).JIRA]: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $39fIG.JiraIcon), {
            size: size,
            label: productName || 'Jira',
            appearance: "brand"
        }),
        [(0, $99vc1.ShortProductKey).CONFLUENCE]: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jo1Bz.ConfluenceIcon), {
            size: size,
            label: productName || 'Confluence',
            appearance: "brand"
        }),
        [(0, $99vc1.ShortProductKey).JIRA_SOFTWARE]: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kWm7C.JiraSoftwareIcon), {
            size: size,
            label: productName || 'Jira',
            appearance: "brand"
        }),
        [(0, $99vc1.ShortProductKey).JIRA_SERVICE_DESK]: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ds5Yo.JiraServiceManagementIcon), {
            size: size,
            label: productName || 'Jira',
            appearance: "brand"
        }),
        [(0, $99vc1.ShortProductKey).JIRA_CORE]: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c9lm5.JiraWorkManagementIcon), {
            size: size,
            label: productName || 'Jira',
            appearance: "brand"
        }),
        [(0, $99vc1.ShortProductKey).BITBUCKET]: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h6M2t.BitbucketIcon), {
            size: size,
            label: productName || 'Bitbucket',
            appearance: "brand"
        })
    };
    return productKey && mapProductKeyToIcon[productKey] ? mapProductKeyToIcon[productKey] : defaultIcon;
}

});
parcelRegister("h6M2t", function(module, exports) {

$parcel$export(module.exports, "BitbucketIcon", () => $8d4219c64b075729$export$5fc1066e677788d4);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $8d4219c64b075729$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95"/>
    </svg>`;
};
const $8d4219c64b075729$export$5fc1066e677788d4 = ({ appearance: appearance, label: label = 'Bitbucket', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $8d4219c64b075729$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("jo1Bz", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", () => $88a43adeb7653a71$export$68f3db7f6af48bcb);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $88a43adeb7653a71$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
};
const $88a43adeb7653a71$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $88a43adeb7653a71$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("kWm7C", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareIcon", () => $3345272ea1f443f5$export$c3835feba2a66e67);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $jJsBW = parcelRequire("jJsBW");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $3345272ea1f443f5$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: (0, $kpt43.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $kpt43.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
  <svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
    <defs>
      <linearGradient x1="108.695%" x2="12.439%" y1="-14.936%" y2="45.215%" id="${id}-1">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
      <linearGradient x1="0%" x2="91.029%" y1="118.55%" y2="63.971%" id="${id}-2">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g stroke="none" stroke-width="1" fill-rule="nonzero">
      <path fill="${colors.iconColor}" d="M15.9669691 29.3616152C17.2195568 28.1097726 17.9233158 26.4114623 17.9233158 24.6405626 17.9233158 22.8696629 17.2195568 21.1713527 15.9669691 19.91951L7.26805808 11.2489111 3.31143376 15.2055354C2.89743442 15.6200502 2.89743442 16.291565 3.31143376 16.7060799L15.9669691 29.3616152zM28.6225045 15.2055354L15.9669691 2.55 15.9280399 2.58892922C13.3485687 5.19994003 13.3612164 9.40374108 15.9563521 11.9991833L24.6623412 20.6662432 28.6225045 16.7060799C29.0365039 16.291565 29.0365039 15.6200502 28.6225045 15.2055354z" />
      <path fill="url(#${id}-1" d="M15.9669691,11.9921053 C13.3718335,9.39666304 13.3591857,5.19286199 15.938657,2.58185118 L6.91061706,11.6063521 L11.6316697,16.3274047 L15.9669691,11.9921053 Z" />
      <path fill="url(#${id}-2" d="M20.2951906,15.5912886 L15.9669691,19.91951 C17.2195568,21.1713527 17.9233158,22.8696629 17.9233158,24.6405626 C17.9233158,26.4114623 17.2195568,28.1097726 15.9669691,29.3616152 L25.0162432,20.3123412 L20.2951906,15.5912886 Z" />
    </g>
  </svg>`;
};
const $3345272ea1f443f5$export$c3835feba2a66e67 = ({ appearance: appearance, label: label = 'Jira Software', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    const id = (0, $jJsBW.useId)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $3345272ea1f443f5$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("c9lm5", function(module, exports) {

$parcel$export(module.exports, "JiraWorkManagementIcon", () => $4c960bdd54f7d44c$export$7330b9fc5718fd30);
/* eslint-disable max-len */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $jJsBW = parcelRequire("jJsBW");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $4c960bdd54f7d44c$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: (0, $kpt43.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $kpt43.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
    <svg
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <linearGradient
        id="${id}"
        gradientUnits="userSpaceOnUse"
        x1="13.9485"
        x2="20.7792"
        y1="20.2388"
        y2="11.8277"
      >
        <stop offset="0" stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} />
        <stop offset="100%" stop-color="${colors.iconGradientStop}" />
      </linearGradient>
      <path
        d="m18.3893 7-3.4257 13.1867c4.3592 1.2052 7.8383-.3558 9.1709-5.4802l1.9988-7.6973z"
        fill="url(#${id})"
      />
      <path
      fill="${colors.iconColor}"
      d="m13.7566 24.8265 3.4257-13.1866c-4.3623-1.196-7.8383.3649-9.17087 5.4985l-2.01143 7.6881z"
      />
    </svg>`;
};
const $4c960bdd54f7d44c$export$7330b9fc5718fd30 = ({ appearance: appearance, label: label = 'Jira Work Management', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    const id = (0, $jJsBW.useId)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $4c960bdd54f7d44c$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("99vc1", function(module, exports) {

$parcel$export(module.exports, "ShortProductKey", () => $2a1405cb3f71d996$export$736dd0bf2ecc436f);
$parcel$export(module.exports, "ProductName", () => $2a1405cb3f71d996$export$acdfad52bc8c6626);
/**
 * ShortProductKey is used in code. It should not have a special characters or empty space
 */ var $2a1405cb3f71d996$export$736dd0bf2ecc436f = /*#__PURE__*/ function(ShortProductKey) {
    ShortProductKey["CONFLUENCE"] = "confluence";
    ShortProductKey["JIRA"] = "jira";
    ShortProductKey["JIRA_CORE"] = "jira_core";
    ShortProductKey["JIRA_SOFTWARE"] = "jira_software";
    ShortProductKey["JIRA_SERVICE_DESK"] = "jira_service_key";
    ShortProductKey["BITBUCKET"] = "bitbucket";
    return ShortProductKey;
}({});
var $2a1405cb3f71d996$export$acdfad52bc8c6626 = /*#__PURE__*/ function(ProductName) {
    ProductName["CONFLUENCE"] = "Confluence";
    ProductName["JIRA"] = "Jira";
    ProductName["JIRA_CORE"] = "Jira Core";
    ProductName["JIRA_SOFTWARE"] = "Jira Software";
    ProductName["JIRA_SERVICE_DESK"] = "Jira Service Desk";
    ProductName["BITBUCKET"] = "Bitbucket";
    ProductName["TEAM_CENTRAL"] = "Team Central";
    ProductName["ATLAS"] = "Atlas";
    ProductName["HOME"] = "Atlassian Home";
    return ProductName;
}({});
var $2a1405cb3f71d996$export$fc3a4bf3fb08b1b4 = /*#__PURE__*/ function(LongProductKey) {
    LongProductKey["JIRA_CORE"] = "jira-core.ondemand";
    LongProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    LongProductKey["CONFLUENCE"] = "confluence.ondemand";
    LongProductKey["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    LongProductKey["BITBUCKET"] = "bitbucket";
    return LongProductKey;
}({});

});


parcelRegister("jRy8d", function(module, exports) {

$parcel$export(module.exports, "BaseIcon", () => $6554e6caa7d5cfe0$export$20931e2295160b07);
$parcel$export(module.exports, "PlacesItem", () => $6554e6caa7d5cfe0$export$834d50fab48eb11a);
$parcel$export(module.exports, "Header", () => $6554e6caa7d5cfe0$export$8b251419efc915eb);
$parcel$export(module.exports, "HeaderIcon", () => $6554e6caa7d5cfe0$export$3a4bb31ac4bd7451);
$parcel$export(module.exports, "HeaderTitle", () => $6554e6caa7d5cfe0$export$edb76fdb8665f52);
$parcel$export(module.exports, "Content", () => $6554e6caa7d5cfe0$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "SpaceIcon", () => $6554e6caa7d5cfe0$export$38ffce4a7986ba20);
$parcel$export(module.exports, "BoardIcon", () => $6554e6caa7d5cfe0$export$2f9da8868573b55d);
$parcel$export(module.exports, "Details", () => $6554e6caa7d5cfe0$export$3e8048d3cf2ba3fd);
$parcel$export(module.exports, "PlaceLink", () => $6554e6caa7d5cfe0$export$d4349a8ff634836e);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");


var $5CtC2 = parcelRequire("5CtC2");
const $6554e6caa7d5cfe0$export$20931e2295160b07 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-6lxli0-0"
})`border-radius:${"var(--ds-border-radius-100, 3px)"};display:flex;width:${"var(--ds-space-300, 24px)"};height:${"var(--ds-space-300, 24px)"};color:${`var(--ds-surface-raised, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`};margin-left:${"var(--ds-space-050, 4px)"};margin-top:${"var(--ds-space-050, 4px)"};margin-right:${"var(--ds-space-150, 12px)"};span{display:flex;align-items:center;justify-content:center;}svg{width:${"var(--ds-space-250, 20px)"};height:${"var(--ds-space-250, 20px)"};}img{width:${"var(--ds-space-300, 24px)"};height:${"var(--ds-space-300, 24px)"};}`;
const $6554e6caa7d5cfe0$export$834d50fab48eb11a = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-6lxli0-1"
})`position:relative;border-radius:${"var(--ds-border-radius-100, 3px)"};padding:${"var(--ds-space-150, 12px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-150, 12px)"};background:${`var(--ds-surface-raised, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`};box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $a7f8c6b391092279$export$7d3359664e8bb0e5)}, 0 0 1px 1px ${(0, $a7f8c6b391092279$export$46987b49aab6d1a8)}`})`};transition:box-shadow 0.25s ease;overflow:hidden;display:flex;flex-direction:column;&:hover,&.active{box-shadow:${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $a7f8c6b391092279$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $a7f8c6b391092279$export$d2d3bedfb276cac0)}`})`};}`;
const $6554e6caa7d5cfe0$export$8b251419efc915eb = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-6lxli0-2"
})`display:flex;flex-direction:row;align-items:center;margin-bottom:${"var(--ds-space-050, 4px)"};`;
const $6554e6caa7d5cfe0$export$3a4bb31ac4bd7451 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-6lxli0-3"
})`display:flex;margin-left:${"var(--ds-space-025, 2px)"};margin-right:${"var(--ds-space-050, 4px)"};width:${"var(--ds-space-200, 16px)"};height:${"var(--ds-space-200, 16px)"};color:${`var(--ds-icon-brand, ${(0, $a7f8c6b391092279$export$b3de0ae08da2ce64)})`};`;
const $6554e6caa7d5cfe0$export$edb76fdb8665f52 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-6lxli0-4"
})`font:${"var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin-top:0px;`;
const $6554e6caa7d5cfe0$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-6lxli0-5"
})`display:flex;align-items:center;`;
const $6554e6caa7d5cfe0$export$38ffce4a7986ba20 = /*#__PURE__*/ (0, $47bDC.default)($6554e6caa7d5cfe0$export$20931e2295160b07).withConfig({
    componentId: "sc-6lxli0-6"
})`background:${`var(--ds-icon-subtle, ${(0, $a7f8c6b391092279$export$f563ee71e9ee74cd)})`};display:grid;place-items:center;`;
const $6554e6caa7d5cfe0$export$2f9da8868573b55d = /*#__PURE__*/ (0, $47bDC.default)($6554e6caa7d5cfe0$export$20931e2295160b07).withConfig({
    componentId: "sc-6lxli0-7"
})`background:${`var(--ds-icon-brand, ${(0, $a7f8c6b391092279$export$b3de0ae08da2ce64)})`};`;
const $6554e6caa7d5cfe0$export$3e8048d3cf2ba3fd = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-6lxli0-8"
})`display:flex;flex-direction:column;min-width:0;white-space:nowrap;`;
const $6554e6caa7d5cfe0$export$d4349a8ff634836e = /*#__PURE__*/ (0, $47bDC.default)((0, $5CtC2.default)).withConfig({
    componentId: "sc-6lxli0-9"
})`font:${"var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin-top:${"var(--ds-space-025, 2px)"};text-overflow:ellipsis;overflow:hidden;&:focus{box-shadow:0 0 0 2px ${`var(--ds-border-focused, ${(0, $a7f8c6b391092279$export$215b7063051591f1)})`};outline:none;border-radius:${"var(--ds-border-radius-100, 3px)"};}`;

});
parcelRegister("5CtC2", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfe9ff6a2c086eae$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cprXC = parcelRequire("cprXC");
var $358cZ = parcelRequire("358cZ");

var $2iRRL = parcelRequire("2iRRL");

var $5vx1F = parcelRequire("5vx1F");
const $bfe9ff6a2c086eae$var$isModified = (event)=>Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $bfe9ff6a2c086eae$var$getSpaAndRelativePath = (href, contextSpaPaths)=>{
    const relativePath = (0, $2iRRL.getRelativeUrl)(href);
    const isSPA = (0, $2iRRL.isSPALink)(relativePath, contextSpaPaths);
    return {
        isSPA: isSPA,
        relativePath: relativePath
    };
};
const $bfe9ff6a2c086eae$export$a6c7ac8248d6e38a = ({ href: href, onClick: onClick, target: target, testId: testId, ...rest })=>{
    const analytics = (0, $358cZ.default)();
    const { contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint, push: push } = (0, $5vx1F.useAppConfig)();
    (0, $5uXOq.useEffect)(()=>{
        if (!href) analytics.pushOperationalEvent({
            source: (0, $cprXC.AnalyticsEventSource).CLIENT_METRICS,
            actionSubject: 'link',
            action: (0, $cprXC.AnalyticsEventActions).FAILED,
            attributes: {
                contextSpaPaths: contextSpaPaths,
                contextEntryPoint: contextEntryPoint
            },
            tags: [
                'error'
            ]
        });
    }, [
        analytics,
        contextEntryPoint,
        contextSpaPaths,
        href
    ]);
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        if (onClick) onClick(event);
        if (href) {
            const { relativePath: relativePath, isSPA: isSPA } = $bfe9ff6a2c086eae$var$getSpaAndRelativePath(href, contextSpaPaths);
            if (isSPA && // only use push for links that work for SPA transitions
            !event.defaultPrevented && // set when onClick called preventDefault
            event.button === 0 && // only use push for left mouse button clicks
            (!target || target === '_self') && // let browser handle "_blank" etc
            !$bfe9ff6a2c086eae$var$isModified(event) // let browser handle clicks with modifier
            ) {
                event.preventDefault();
                push(relativePath);
            }
        }
    }, [
        onClick,
        href,
        contextSpaPaths,
        push,
        target
    ]);
    if (href) {
        const { isSPA: isSPA } = $bfe9ff6a2c086eae$var$getSpaAndRelativePath(href, contextSpaPaths);
        const props = {
            href: (0, $2iRRL.prefixWithContextEntryPoint)(href, contextEntryPoint),
            ...target ? {
                target: target
            } : isSPA ? {} : {
                target: '_blank'
            },
            ...isSPA ? {} : {
                rel: 'noopener noreferrer'
            }
        };
        // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        return /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
            ...rest,
            onClick: handleClick,
            ...props,
            "data-testid": testId
        });
    }
    // if href is missing render <a> with original onClick handler
    // and without href or target
    // Note that we trigger an operational event in `componentDidMount` to monitor why `href` is not passed.
    // I have a suspicion that empty href can cause broken link
    // eslint-disable-next-line jsx-a11y/anchor-has-content, @atlaskit/design-system/no-html-anchor, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    return /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        ...rest,
        onClick: onClick
    });
};
var $bfe9ff6a2c086eae$export$2e2bcd8739ae039 = $bfe9ff6a2c086eae$export$a6c7ac8248d6e38a;

});
parcelRegister("2iRRL", function(module, exports) {

$parcel$export(module.exports, "getDomainFromLinkUri", () => $d878e42fca3238f5$export$cda14c9dfe45538);
$parcel$export(module.exports, "getRelativeUrl", () => $d878e42fca3238f5$export$d614758658023fd);
$parcel$export(module.exports, "prefixWithContextEntryPoint", () => $d878e42fca3238f5$export$715c8f9057ac0c01);
$parcel$export(module.exports, "isSPALink", () => $d878e42fca3238f5$export$82ba20246315fbed);

var $aVe3r = parcelRequire("aVe3r");
const $d878e42fca3238f5$export$1cc7e75fbd30f64f = (location)=>`${location.hash}${location.search}`;
const $d878e42fca3238f5$export$cda14c9dfe45538 = (url)=>{
    let hostname;
    try {
        try {
            hostname = $d878e42fca3238f5$export$eb5a321f13bbb969(url);
        } catch (noProtocolError) {
            /**
			 * Backend (Legion) validates whether the string is URI compliant. But URL expects
			 * the string to have a protocol. This is not validated by URI compliancy. So
			 * following is just a quick fix just for display purposes.
			 */ hostname = $d878e42fca3238f5$export$eb5a321f13bbb969('http://' + url);
        }
    } catch (error) {
        return '';
    }
    return hostname.replace(/^www\./, '');
};
const $d878e42fca3238f5$export$eb5a321f13bbb969 = (url)=>{
    const urlObj = new URL(url);
    return urlObj.hostname;
};
const $d878e42fca3238f5$export$c8d36b71889c2b08 = (email)=>{
    const parts = email.split('@');
    if (parts.length === 1) return null;
    else if (parts.length === 2 && !parts[0]) return null;
    else if (!parts[parts.length - 1]) return null;
    return parts[parts.length - 1];
};
const $d878e42fca3238f5$export$d614758658023fd = (url)=>{
    if (!$d878e42fca3238f5$var$isAbsoluteLink(url)) return url;
    try {
        const { pathname: pathname, search: search, hash: hash } = new URL(url);
        return `${pathname}${search}${hash}`;
    } catch (error) {
        (0, $aVe3r.logException)(error, 'Cannot parse URL in getRelativeUrl', {
            url: url
        });
    }
    return url;
};
const $d878e42fca3238f5$var$isAbsoluteLink = (url)=>{
    return url.startsWith('http') || url.startsWith('www');
};
const $d878e42fca3238f5$export$715c8f9057ac0c01 = (path, contextEntryPoint = '')=>{
    if ($d878e42fca3238f5$var$isAbsoluteLink(path) || // do not prefix for absolute URL
    contextEntryPoint && path.startsWith(contextEntryPoint) || // do not prefix if the link already has product context path
    path.startsWith('/')) return path;
    return `${contextEntryPoint}/${path}`;
};
const $d878e42fca3238f5$export$82ba20246315fbed = (url, contextSpaPaths)=>{
    if (!contextSpaPaths || !contextSpaPaths.length) return false;
    let isStartWithContextSPA;
    if ($d878e42fca3238f5$var$isAbsoluteLink(url)) try {
        const { pathname: pathname, search: search, hash: hash, origin: origin } = new URL(url);
        const relativeUrl = `${pathname}${search}${hash}`;
        const isSameDomain = window.location.href.includes(origin);
        isStartWithContextSPA = !!contextSpaPaths.find((contextPath)=>{
            return relativeUrl.startsWith(contextPath);
        });
        return isStartWithContextSPA && isSameDomain;
    } catch (error) {
        (0, $aVe3r.logException)(error, 'Cannot parse URL in isSPALink', {
            url: url
        });
        return false;
    }
    // is relative link
    isStartWithContextSPA = !!contextSpaPaths.find((contextPath)=>{
        return url.startsWith(contextPath);
    });
    return isStartWithContextSPA || !url.startsWith('/');
};

});

parcelRegister("5vx1F", function(module, exports) {

$parcel$export(module.exports, "useAppConfig", () => $b128d3a0c77f9a99$export$a3e0ece8c3f698d7);
$parcel$export(module.exports, "default", () => $b128d3a0c77f9a99$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $b128d3a0c77f9a99$var$error = new Error('AppConfigProvider is not found in higher components');
const $b128d3a0c77f9a99$var$defaultState = {
    addFlag: ()=>{
        throw $b128d3a0c77f9a99$var$error;
    },
    push: ()=>{
        throw $b128d3a0c77f9a99$var$error;
    },
    replace: ()=>{
        throw $b128d3a0c77f9a99$var$error;
    },
    history: undefined,
    contextSpaPaths: [],
    contextEntryPoint: '',
    docTitle: {},
    appName: '',
    productName: '',
    env: undefined,
    cloudId: '',
    isJiraAvailable: false,
    productFeatureFlags: {},
    orgId: undefined,
    siteUrl: undefined
};
const $b128d3a0c77f9a99$var$AppConfigContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($b128d3a0c77f9a99$var$defaultState);
const $b128d3a0c77f9a99$export$a3e0ece8c3f698d7 = ()=>{
    return (0, $5uXOq.useContext)($b128d3a0c77f9a99$var$AppConfigContext);
};
var $b128d3a0c77f9a99$export$2e2bcd8739ae039 = $b128d3a0c77f9a99$var$AppConfigContext;

});





parcelRegister("dnvXl", function(module, exports) {

$parcel$export(module.exports, "ProfilePlacesList", () => $f3be4486669a69fb$export$f092d7408da4b0d);
$parcel$export(module.exports, "EmptyPlacesList", () => $f3be4486669a69fb$export$f88a6b5813accf5a);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

const $f3be4486669a69fb$export$f092d7408da4b0d = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-114isdp-0"
})`padding:${"var(--ds-space-100, 8px)"};border-radius:${"var(--ds-border-radius-100, 3px)"};background:${`var(--ds-background-neutral, ${(0, $a7f8c6b391092279$export$9fdfb749e33cdf97)})`};> div{margin-bottom:${"var(--ds-space-100, 8px)"};}> div:last-child{margin-bottom:0;}`;
const $f3be4486669a69fb$export$f88a6b5813accf5a = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-114isdp-1"
})`padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-100, 8px)"};border-radius:${"var(--ds-border-radius-100, 3px)"};box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $a7f8c6b391092279$export$7d3359664e8bb0e5)}, 0 0 1px 1px ${(0, $a7f8c6b391092279$export$46987b49aab6d1a8)}`})`};> div{margin-bottom:${"var(--ds-space-100, 8px)"};}> div:last-child{margin-bottom:0;}`;

});



parcelRegister("4tRqw", function(module, exports) {

$parcel$export(module.exports, "default", () => $40312a2e3fc29386$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $cprXC = parcelRequire("cprXC");
var $358cZ = parcelRequire("358cZ");
var $1geG0 = parcelRequire("1geG0");
var $a4jrI = parcelRequire("a4jrI");

var $2Ixyh = parcelRequire("2Ixyh");

var $6h0eh = parcelRequire("6h0eh");

var $99Eo3 = parcelRequire("99Eo3");
const $40312a2e3fc29386$var$getCurrentTime = ()=>window && window.performance ? window.performance.now() : Date.now();
function $40312a2e3fc29386$var$useContainersQuery(props) {
    const [{ cloudId: cloudId }] = (0, $a4jrI.useSite)();
    const [{ principalUserId: principalUserId }] = (0, $1geG0.usePrincipalUser)();
    const analytics = (0, $358cZ.default)();
    const [sessionId] = (0, $5uXOq.useState)((0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))());
    const [startTime, setStartTime] = (0, $5uXOq.useState)(0);
    const userId = props.userId || principalUserId;
    const request = (0, $5uXOq.useCallback)(()=>{
        return (0, $2Ixyh.teamsClient).getUserContainers({
            siteId: cloudId,
            userId: userId,
            principalId: principalUserId,
            maxNumberOfResults: props.maxNumberOfCards,
            sessionId: sessionId
        });
    }, [
        cloudId,
        principalUserId,
        props.maxNumberOfCards,
        sessionId,
        userId
    ]);
    const { fetchData: fetchData, loading: loading, data: data, error: error } = (0, $6h0eh.useServiceLight)(request);
    const loadingRef = (0, $5uXOq.useRef)(loading);
    (0, $5uXOq.useEffect)(()=>{
        setStartTime($40312a2e3fc29386$var$getCurrentTime());
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (principalUserId) fetchData();
    }, [
        fetchData,
        principalUserId
    ]);
    const triggerAnalyticsEvent = (0, $5uXOq.useCallback)((elapsedTimeMs, data)=>{
        const containers = data.Containers && data.Containers.collaborationGraphEntities || [];
        const ids = containers.map(({ id: id })=>id);
        analytics.pushOperationalEvent({
            source: (0, $cprXC.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'collaboration-graph',
            attributes: {
                resultLength: ids.length,
                sessionId: sessionId,
                resultIds: ids,
                endpoint: 'userToContainer',
                userId: userId,
                elapsedTimeMs: elapsedTimeMs
            },
            action: 'requested'
        });
    }, [
        userId,
        analytics,
        sessionId
    ]);
    if (loadingRef.current !== loading) {
        loadingRef.current = loading;
        if (!loading) {
            const end = $40312a2e3fc29386$var$getCurrentTime();
            const diff = end - startTime;
            triggerAnalyticsEvent(diff, {
                Containers: data || {
                    collaborationGraphEntities: []
                }
            });
        }
    }
    return {
        data: data ? (0, $99Eo3.toContainersViewFormat)(data.collaborationGraphEntities) : [],
        loading: loading,
        hasError: !!error,
        error: error
    };
}
var $40312a2e3fc29386$export$2e2bcd8739ae039 = $40312a2e3fc29386$var$useContainersQuery;

});
parcelRegister("99Eo3", function(module, exports) {

$parcel$export(module.exports, "toContainersViewFormat", () => $9e7b8bc46bfae30e$export$1700279c740b8615);
const $9e7b8bc46bfae30e$var$getType = ({ containerType: containerType })=>{
    switch(containerType){
        case 'jiraProject':
            return 'project';
        case 'confluenceSpace':
            return 'space';
        default:
            return 'project';
    }
};
function $9e7b8bc46bfae30e$export$1700279c740b8615(nodes) {
    if (!nodes) return [];
    return nodes.filter((container)=>!!container).filter(({ containerType: containerType = '' })=>containerType === 'jiraProject' || containerType === 'confluenceSpace').map((node)=>{
        if (!node || !node.containerDetails) return;
        return {
            id: node?.id,
            name: node?.containerDetails?.name,
            icon: node?.containerDetails?.iconUrl,
            type: $9e7b8bc46bfae30e$var$getType(node),
            path: node?.containerDetails?.url,
            hasLoaded: true
        };
    }).filter((it)=>!!it);
}

});



parcelRegister("aoiNp", function(module, exports) {

$parcel$export(module.exports, "default", () => $01edb5a63e02f351$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9uQ9L = parcelRequire("9uQ9L");

var $90veb = parcelRequire("90veb");
function $01edb5a63e02f351$export$dd5ad0b65cf665da(props) {
    const { children: children, docTitle: docTitle, title: title } = props;
    const resultTitle = [
        docTitle.start,
        title,
        docTitle.end
    ].filter((s)=>Boolean(s)).join(docTitle.delimiter || ' - ');
    return(// @ts-ignore
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9uQ9L))), {
        title: resultTitle,
        children: children
    }));
}
var $01edb5a63e02f351$export$2e2bcd8739ae039 = (0, $90veb.default)($01edb5a63e02f351$export$dd5ad0b65cf665da);

});
parcelRegister("9uQ9L", function(module, exports) {
'use strict';

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");

var $qB6JE = parcelRequire("qB6JE");
function $6e9f5f93a6c394a7$var$reducePropsToState(propsList) {
    var innermostProps = propsList[propsList.length - 1];
    if (innermostProps) return innermostProps.title;
}
function $6e9f5f93a6c394a7$var$handleStateChangeOnClient(title) {
    var nextTitle = title || '';
    if (nextTitle !== document.title) document.title = nextTitle;
}
function $6e9f5f93a6c394a7$var$DocumentTitle() {}
$6e9f5f93a6c394a7$var$DocumentTitle.prototype = Object.create($5uXOq.Component.prototype);
$6e9f5f93a6c394a7$var$DocumentTitle.displayName = 'DocumentTitle';
$6e9f5f93a6c394a7$var$DocumentTitle.propTypes = {
    title: $8rCP3.string.isRequired
};
$6e9f5f93a6c394a7$var$DocumentTitle.prototype.render = function() {
    if (this.props.children) return $5uXOq.Children.only(this.props.children);
    else return null;
};
module.exports = $qB6JE($6e9f5f93a6c394a7$var$reducePropsToState, $6e9f5f93a6c394a7$var$handleStateChangeOnClient)($6e9f5f93a6c394a7$var$DocumentTitle);

});
parcelRegister("qB6JE", function(module, exports) {
'use strict';
function $04ff36a02ec98ee9$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $5uXOq = parcelRequire("5uXOq");
var $04ff36a02ec98ee9$var$React__default = $04ff36a02ec98ee9$var$_interopDefault($5uXOq);

var $04ff36a02ec98ee9$var$shallowEqual = $04ff36a02ec98ee9$var$_interopDefault((parcelRequire("oRlQ1")));
function $04ff36a02ec98ee9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $04ff36a02ec98ee9$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $04ff36a02ec98ee9$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $04ff36a02ec98ee9$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_Component) {
            $04ff36a02ec98ee9$var$_inheritsLoose(SideEffect, _Component);
            function SideEffect() {
                return _Component.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
                return !$04ff36a02ec98ee9$var$shallowEqual(nextProps, this.props);
            };
            _proto.componentWillMount = function componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $04ff36a02ec98ee9$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($5uXOq.Component);
        $04ff36a02ec98ee9$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $04ff36a02ec98ee9$var$_defineProperty(SideEffect, "canUseDOM", $04ff36a02ec98ee9$var$canUseDOM);
        return SideEffect;
    };
}
module.exports = $04ff36a02ec98ee9$var$withSideEffect;

});
parcelRegister("oRlQ1", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});



parcelRegister("90veb", function(module, exports) {

$parcel$export(module.exports, "default", () => $1eeab5e3e2744fe2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5vx1F = parcelRequire("5vx1F");
function $1eeab5e3e2744fe2$export$2e2bcd8739ae039(WrappedComponent) {
    const nameOfWrapperComponent = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithDocumentTitleComponent extends (0, $5uXOq.PureComponent) {
        static{
            this.displayName = `withDocumentTitleHOC(${nameOfWrapperComponent})`;
        }
        render() {
            const wrappedComponentProps = this.props;
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5vx1F.default).Consumer, {
                children: ({ docTitle: docTitle })=>/*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                        ...wrappedComponentProps,
                        docTitle: docTitle
                    })
            });
        }
    }
    return WithDocumentTitleComponent;
}

});


parcelRegister("l598s", function(module, exports) {

$parcel$export(module.exports, "AsideColumn", () => $8d4ab550f4a77ef7$export$7fd6f44981b465b2);
$parcel$export(module.exports, "AsideColumnItem", () => $8d4ab550f4a77ef7$export$f634bf5b1a9553c4);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ /**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

var $3tWw5 = parcelRequire("3tWw5");

var $8vrVz = parcelRequire("8vrVz");
const $8d4ab550f4a77ef7$export$7fd6f44981b465b2 = /*#__PURE__*/ (0, $47bDC.default).aside.withConfig({
    componentId: "xyb5d3-0"
})`${(0, $3tWw5.baseColumnStyles)};flex:0 0 ${(0, $8vrVz.profileGridSizeTimes)(4)}px;margin-bottom:${"var(--ds-space-400, 32px)"};&:last-of-type{margin-bottom:0;}`;
const $8d4ab550f4a77ef7$export$f634bf5b1a9553c4 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "xyb5d3-1"
})`&:not(:last-child){margin-bottom:${"var(--ds-space-300, 24px)"};}`;

});
parcelRegister("3tWw5", function(module, exports) {

$parcel$export(module.exports, "baseColumnStyles", () => $ee07663872fb77a8$export$d0f72508c56edec0);
/**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line import/order, @repo/internal/styles/use-emotion, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

var $8vrVz = parcelRequire("8vrVz");
const $ee07663872fb77a8$export$d0f72508c56edec0 = /*#__PURE__*/ (0, $47bDC.css)`padding:0 ${(0, $8vrVz.halfGutterSize)}px;min-width:${(0, $8vrVz.minColumnWidth)}px;@media (max-width:${(0, $8vrVz.responsiveThreshold)}px){flex:1 1;padding:0;}`;

});
parcelRegister("8vrVz", function(module, exports) {

$parcel$export(module.exports, "profileGridSizeTimes", () => $5a5815e8324d59bb$export$4ee2721235c833ba);
$parcel$export(module.exports, "halfGutterSize", () => $5a5815e8324d59bb$export$a5c9f6dcfaa13620);
$parcel$export(module.exports, "minColumnWidth", () => $5a5815e8324d59bb$export$78f737406522d217);
$parcel$export(module.exports, "responsiveThreshold", () => $5a5815e8324d59bb$export$e52bb911ec277d52);
/**
 * Util function for creating sizes based on the profile grid.
 * Takes the form a of function to be consistent with Atlaskit theme grid sizes.
 */ const $5a5815e8324d59bb$export$4ee2721235c833ba = (n)=>80 * n;
const $5a5815e8324d59bb$export$a5c9f6dcfaa13620 = 20;
const $5a5815e8324d59bb$export$78f737406522d217 = $5a5815e8324d59bb$export$4ee2721235c833ba(3);
const $5a5815e8324d59bb$export$a3fc3c10977fa604 = 768;
const $5a5815e8324d59bb$export$e52bb911ec277d52 = $5a5815e8324d59bb$export$a3fc3c10977fa604 + 64;

});



parcelRegister("iW5hh", function(module, exports) {

$parcel$export(module.exports, "Body", () => $2bbe51a643ca3334$export$4b2c32e08f77ff18);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $aRm3a = parcelRequire("aRm3a");
const $2bbe51a643ca3334$export$4b2c32e08f77ff18 = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)($aRm3a.BodyOld, {
        children: children
    });
const $2bbe51a643ca3334$export$77acdd2a63439b4c = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)($aRm3a.WideBody, {
        children: children
    });
var $2bbe51a643ca3334$export$2e2bcd8739ae039 = $2bbe51a643ca3334$export$4b2c32e08f77ff18;

});
parcelRegister("aRm3a", function(module, exports) {

$parcel$export(module.exports, "BodyOld", () => $2503524b392ee619$export$9db55a75b5a749b);
$parcel$export(module.exports, "WideBody", () => $2503524b392ee619$export$77acdd2a63439b4c);
/**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

var $8vrVz = parcelRequire("8vrVz");
const $2503524b392ee619$export$4b2c32e08f77ff18 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1g7almm-0"
})`display:flex;flex-direction:column;justify-content:flex-start;min-height:calc(100vh - 56px);max-width:${(0, $8vrVz.profileGridSizeTimes)(14)}px;margin:0 auto;padding:0 ${(0, $8vrVz.halfGutterSize)}px;@media (max-width:${(0, $8vrVz.responsiveThreshold)}px){padding:0 ${"var(--ds-space-300, 24px)"};}padding-bottom:${"var(--ds-space-400, 32px)"};`;
const $2503524b392ee619$export$9db55a75b5a749b = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1g7almm-1"
})`display:flex;flex-direction:column;justify-content:flex-start;min-height:calc(100vh - 56px);max-width:${(0, $8vrVz.profileGridSizeTimes)(12.5)}px;margin:0 auto;padding:0 ${(0, $8vrVz.halfGutterSize)}px;@media (max-width:${(0, $8vrVz.responsiveThreshold)}px){padding:0 ${"var(--ds-space-300, 24px)"};}padding-bottom:${"var(--ds-space-400, 32px)"};`;
const $2503524b392ee619$export$77acdd2a63439b4c = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1g7almm-2"
})`display:flex;flex-direction:column;justify-content:flex-start;min-height:calc(100vh - 56px);max-width:${(0, $8vrVz.profileGridSizeTimes)(18)}px;margin:0 auto;padding:0 ${(0, $8vrVz.halfGutterSize)}px;@media (max-width:${(0, $8vrVz.responsiveThreshold)}px){padding:0 ${"var(--ds-space-300, 24px)"};}padding-bottom:${"var(--ds-space-400, 32px)"};`;

});


parcelRegister("2D4Mv", function(module, exports) {

$parcel$export(module.exports, "MainColumn", () => $60515872197919db$export$2d9aae88ab6846ab);
$parcel$export(module.exports, "MainColumnItem", () => $60515872197919db$export$a3de91dc1c7d9c74);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ /**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

var $b4a3S = parcelRequire("b4a3S");

var $3tWw5 = parcelRequire("3tWw5");

var $8vrVz = parcelRequire("8vrVz");
const $60515872197919db$export$2d9aae88ab6846ab = /*#__PURE__*/ (0, $47bDC.default).main.withConfig({
    componentId: "e4gbwm-0"
})`${(0, $3tWw5.baseColumnStyles)};flex:0 1 ${(0, $8vrVz.profileGridSizeTimes)(8)}px;margin-top:${"var(--ds-space-400, 32px)"};margin-bottom:${"var(--ds-space-400, 32px)"};&:last-of-type{margin-bottom:0;}`;
const $60515872197919db$export$a3de91dc1c7d9c74 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "e4gbwm-1"
})`scroll-margin-top:${(0, $b4a3S.gridSize)() * 23}px;&:not(:last-child){margin-bottom:${"var(--ds-space-400, 32px)"};}`;
const $60515872197919db$export$b59f717f8d137994 = /*#__PURE__*/ (0, $47bDC.default).main.withConfig({
    componentId: "e4gbwm-2"
})`${(0, $3tWw5.baseColumnStyles)};flex:0 1 ${(0, $8vrVz.profileGridSizeTimes)(12)}px;margin-top:${"var(--ds-space-400, 32px)"};margin-bottom:${"var(--ds-space-400, 32px)"};&:last-of-type{margin-bottom:0;}`;

});

parcelRegister("hvRGR", function(module, exports) {

$parcel$export(module.exports, "ResponsiveSection", () => $02eb0afe5749b1d4$export$6f5ca33df9ef97dc);
/**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

var $8vrVz = parcelRequire("8vrVz");

var $23Rcj = parcelRequire("23Rcj");
const $02eb0afe5749b1d4$export$6f5ca33df9ef97dc = /*#__PURE__*/ (0, $47bDC.default)((0, $23Rcj.Section)).withConfig({
    componentId: "uvj1rq-0"
})`@media (max-width:${(0, $8vrVz.responsiveThreshold)}px){flex-direction:column;justify-content:flex-start;}`;

});
parcelRegister("23Rcj", function(module, exports) {

$parcel$export(module.exports, "Section", () => $08975d0489b1e99c$export$6e2c8f0811a474ce);
/**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
const $08975d0489b1e99c$export$6e2c8f0811a474ce = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "jfynxk-0"
})`display:flex;flex-direction:row;justify-content:center;`;

});


parcelRegister("5QqXa", function(module, exports) {

$parcel$export(module.exports, "ErrorScreen", () => $c00906e735292c30$export$42f84e610f279c31);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cprXC = parcelRequire("cprXC");
var $8vAg7 = parcelRequire("8vAg7");
var $358cZ = parcelRequire("358cZ");

var $8YTXX = parcelRequire("8YTXX");

var $doCAR = parcelRequire("doCAR");

var $lT2JU = parcelRequire("lT2JU");
const $c00906e735292c30$export$db8be4c3614e42ec = new Map([
    [
        (0, $8YTXX.ErrorCategory).NotFound,
        (0, $doCAR.UserNotFound)
    ]
]);
const $c00906e735292c30$export$42f84e610f279c31 = ({ error: error })=>{
    const analytics = (0, $358cZ.default)();
    // Failed analytics
    (0, $5uXOq.useEffect)(()=>{
        analytics.pushTrackEvent({
            action: (0, $cprXC.AnalyticsEventActions).FAILED,
            actionSubject: `${(0, $cprXC.AnalyticsEventSource).USER_PROFILE_SCREEN}Load`,
            source: (0, $cprXC.AnalyticsEventSource).USER_PROFILE_SCREEN
        });
    }, [
        analytics
    ]);
    const errorCategory = (0, $8YTXX.parseErrorObjectToErrorCategory)(error);
    const ErrorComponent = errorCategory !== '' && $c00906e735292c30$export$db8be4c3614e42ec.has(errorCategory) ? $c00906e735292c30$export$db8be4c3614e42ec.get(errorCategory) : (0, $8vAg7.GenericErrorPage);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($lT2JU.LoadingWrapper, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(ErrorComponent, {})
    });
};

});
parcelRegister("8vAg7", function(module, exports) {

$parcel$export(module.exports, "GenericErrorPage", () => $e71e80a3f7cc3b66$export$5d76009b056f3e5d);
$parcel$export(module.exports, "default", () => $e71e80a3f7cc3b66$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");

var $cNW3X = parcelRequire("cNW3X");

var $hIKTz = parcelRequire("hIKTz");

var $3zOhv = parcelRequire("3zOhv");

var $h2f5h = parcelRequire("h2f5h");
const $e71e80a3f7cc3b66$export$2369ec80391a4c8c = /*#__PURE__*/ (0, $2OMIu.jsx)($h2f5h.ErrorImage, {
    src: (0, (/*@__PURE__*/$parcel$interopDefault($3zOhv)))
});
const $e71e80a3f7cc3b66$export$c120a0e80fd44ca6 = ({ title: title, body: body, image: image, actions: actions })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)($h2f5h.Container, {
        "data-test-selector": "error-page",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($h2f5h.ImageOuter, {
                children: image || $e71e80a3f7cc3b66$export$2369ec80391a4c8c
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)($h2f5h.ErrorTextContainer, {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)($h2f5h.TitleWrapper, {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)($h2f5h.Title, {
                            children: title
                        })
                    }),
                    body && /*#__PURE__*/ (0, $2OMIu.jsx)($h2f5h.DescriptionWrapper, {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)($h2f5h.Description, {
                            children: body
                        })
                    })
                ]
            }),
            actions && /*#__PURE__*/ (0, $2OMIu.jsx)($h2f5h.ButtonContainer, {
                children: actions
            })
        ]
    });
};
const $e71e80a3f7cc3b66$export$5d76009b056f3e5d = (props)=>{
    const actions = props.hasSupportLink && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
        rel: "noopener noreferrer",
        target: "_blank",
        href: `${(0, $hIKTz.getAtlassianContextUrl)('support')}/contact/#/`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$e71e80a3f7cc3b66$var$messages.contactUs
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($e71e80a3f7cc3b66$export$c120a0e80fd44ca6, {
        title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$e71e80a3f7cc3b66$var$messages.title
        }),
        body: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$e71e80a3f7cc3b66$var$messages.description
        }),
        actions: actions || undefined
    });
};
const $e71e80a3f7cc3b66$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        id: 'pf-home.generic-error-title',
        defaultMessage: 'Something went wrong'
    },
    contactUs: {
        id: 'ptc-directory.error-boundary.message-link-text',
        defaultMessage: 'Contact support',
        description: 'The text of the link leading to the Atlassian support website, shown below the error description on the error pages'
    },
    description: {
        id: 'pf-home.generic-error-description',
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things."
    }
});
var $e71e80a3f7cc3b66$export$2e2bcd8739ae039 = $e71e80a3f7cc3b66$export$c120a0e80fd44ca6;

});
parcelRegister("3zOhv", function(module, exports) {
module.exports = new URL("svg-error-window_ptc.150cf151.svg", import.meta.url).toString();

});

parcelRegister("h2f5h", function(module, exports) {

$parcel$export(module.exports, "ErrorImage", () => $2763fd34b8a451e2$export$7326e6d938a8137b);
$parcel$export(module.exports, "Container", () => $2763fd34b8a451e2$export$42a852a2b6b56249);
$parcel$export(module.exports, "ImageOuter", () => $2763fd34b8a451e2$export$6cce79b2fcc860dc);
$parcel$export(module.exports, "TitleWrapper", () => $2763fd34b8a451e2$export$585a3b23e887288b);
$parcel$export(module.exports, "ButtonContainer", () => $2763fd34b8a451e2$export$eddf54ea3db8d0f0);
$parcel$export(module.exports, "Title", () => $2763fd34b8a451e2$export$f99233281efd08a0);
$parcel$export(module.exports, "DescriptionWrapper", () => $2763fd34b8a451e2$export$2bf1f2b0d31b60fc);
$parcel$export(module.exports, "Description", () => $2763fd34b8a451e2$export$393edc798c47379d);
$parcel$export(module.exports, "ErrorTextContainer", () => $2763fd34b8a451e2$export$5086488b1ac4411e);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

const $2763fd34b8a451e2$export$7326e6d938a8137b = /*#__PURE__*/ (0, $47bDC.default).img.withConfig({
    componentId: "kvymlk-0"
})`width:263px;margin:0 0 ${"var(--ds-space-600, 48px)"} 0;display:flex;`;
const $2763fd34b8a451e2$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "kvymlk-1"
})`align-items:center;justify-content:center;display:flex;flex-wrap:wrap;margin:${"var(--ds-space-1000, 80px)"} auto 0;max-width:600px;flex-direction:column;@media (max-width:640px){flex-direction:column;}`;
const $2763fd34b8a451e2$export$6cce79b2fcc860dc = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "kvymlk-2"
})`flex:none;flex-basis:200px;justify-content:center;@media (max-width:640px){margin-right:0;flex-basis:auto;& img{max-width:100%;padding:0 ${"var(--ds-space-300, 24px)"};}}`;
const $2763fd34b8a451e2$export$585a3b23e887288b = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "kvymlk-3"
})`display:flex;margin-bottom:${"var(--ds-space-150, 12px)"};@media (max-width:640px){text-align:center;}`;
const $2763fd34b8a451e2$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "kvymlk-4"
})`display:flex;justify-content:center;text-align:center;margin-top:${"var(--ds-space-200, 16px)"};`;
const $2763fd34b8a451e2$export$f99233281efd08a0 = /*#__PURE__*/ (0, $47bDC.default).h1.withConfig({
    componentId: "kvymlk-5"
})``;
const $2763fd34b8a451e2$export$2bf1f2b0d31b60fc = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "kvymlk-6"
})`display:flex;flex-wrap:wrap;`;
const $2763fd34b8a451e2$export$393edc798c47379d = /*#__PURE__*/ (0, $47bDC.default).p.withConfig({
    componentId: "kvymlk-7"
})`font-size:1em;line-height:24px;color:${`var(--ds-text, ${(0, $a7f8c6b391092279$export$7d61b15e0da132af)})`};@media (max-width:640px){text-align:center;}`;
const $2763fd34b8a451e2$export$5086488b1ac4411e = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "kvymlk-8"
})`display:flex;justify-content:center;text-align:center;flex-wrap:wrap;width:80%;flex-direction:column;align-items:center;@media (max-width:640px){max-width:304px;width:100%;}`;

});


parcelRegister("8YTXX", function(module, exports) {

$parcel$export(module.exports, "ErrorCategory", () => $ca1539333dc2eac9$export$fe4bb20808298551);
$parcel$export(module.exports, "isRealErrorUserProfile", () => $ca1539333dc2eac9$export$ad79d1c90d717965);
$parcel$export(module.exports, "errorUserNotFound", () => $ca1539333dc2eac9$export$10bf856e639f2ac5);
$parcel$export(module.exports, "parseErrorObjectToErrorCategory", () => $ca1539333dc2eac9$export$cf76974422373a05);
$parcel$export(module.exports, "parseTeamErrorCategory", () => $ca1539333dc2eac9$export$cd92fd5c21ce6635);

var $k5jYC = parcelRequire("k5jYC");
var $ca1539333dc2eac9$export$fe4bb20808298551 = /*#__PURE__*/ function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
    return ErrorCategory;
}({});
const $ca1539333dc2eac9$export$ad79d1c90d717965 = (error)=>{
    if (!error) return false;
    if (error?.message?.includes('User not found') || error?.message?.includes('Access is denied') || error?.message?.includes('TEAM CENTRAL UNAUTHORIZED')) return false;
    if (!error.graphQLErrors) return true;
    // is ApolloError
    return !error.graphQLErrors.every((e)=>!e || e.category === "NotFound" || e.category === "NotPermitted");
};
const $ca1539333dc2eac9$export$10bf856e639f2ac5 = new Error('User not found');
function $ca1539333dc2eac9$export$cf76974422373a05(error) {
    if (!error) return '';
    if (error?.message === $ca1539333dc2eac9$export$10bf856e639f2ac5.message) return "NotFound";
    return error.graphQLErrors?.[0]?.category;
}
const $ca1539333dc2eac9$var$MAP_TEAM_STATUS_ERROR_TYPES_MAP = {
    403: (0, $k5jYC.TeamProfileErrorType).NO_PERMISSION,
    404: (0, $k5jYC.TeamProfileErrorType).TEAM_MISSING,
    410: (0, $k5jYC.TeamProfileErrorType).TEAM_DELETED
};
const $ca1539333dc2eac9$export$cd92fd5c21ce6635 = (error)=>error ? $ca1539333dc2eac9$var$MAP_TEAM_STATUS_ERROR_TYPES_MAP[error.status] || (0, $k5jYC.TeamProfileErrorType).UNKNOWN : null;

});
parcelRegister("k5jYC", function(module, exports) {

$parcel$export(module.exports, "TeamProfileErrorType", () => $939812bcfd65e5c5$export$b89d4f1cb2ee533c);
var $939812bcfd65e5c5$export$b89d4f1cb2ee533c = /*#__PURE__*/ function(TeamProfileErrorType) {
    TeamProfileErrorType["TEAM_MISSING"] = "teamMissing";
    TeamProfileErrorType["NO_PERMISSION"] = "noPermission";
    TeamProfileErrorType["TEAM_DELETED"] = "deleted";
    TeamProfileErrorType["UNKNOWN"] = "unknown";
    TeamProfileErrorType["NO_ACCESS_TO_TEAMS"] = "noAccessToTeams";
    return TeamProfileErrorType;
}({});

});


parcelRegister("doCAR", function(module, exports) {

$parcel$export(module.exports, "UserNotFound", () => $bff3efd740a53c9a$export$d1f0ba24af7dd9bb);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");

var $bMFGq = parcelRequire("bMFGq");

var $8vAg7 = parcelRequire("8vAg7");
var $358cZ = parcelRequire("358cZ");

var $lwspq = parcelRequire("lwspq");

var $5CtC2 = parcelRequire("5CtC2");

var $ew2U0 = parcelRequire("ew2U0");
const $bff3efd740a53c9a$var$Actions = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5CtC2.default), {
        href: "search",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMFGq.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...$bff3efd740a53c9a$var$messages.buttonText
            })
        })
    });
const $bff3efd740a53c9a$var$NOT_FOUND_IMAGE_WIDTH = 497;
const $bff3efd740a53c9a$export$d1f0ba24af7dd9bb = ()=>{
    const analytics = (0, $358cZ.default)();
    const expTracker = analytics.expTracker();
    // In a weird case, back and forth by browser back/next button causes `Query` of `react-apollo` does not return `error` correctly although user is not exsited.
    // So it is better to abort all current user experience tracking when user is not found.
    (0, $5uXOq.useEffect)(()=>{
        expTracker.abort({
            reason: 'User Not Found'
        });
    }, [
        expTracker
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8vAg7.default), {
        title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$bff3efd740a53c9a$var$messages.notFoundTitle
        }),
        body: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...$bff3efd740a53c9a$var$messages.notFoundDescription1
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("br", {}),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...$bff3efd740a53c9a$var$messages.notFoundDescription2
                })
            ]
        }),
        image: /*#__PURE__*/ (0, $2OMIu.jsx)($ew2U0.NotFoundImage, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($lwspq))),
            width: $bff3efd740a53c9a$var$NOT_FOUND_IMAGE_WIDTH
        }),
        actions: /*#__PURE__*/ (0, $2OMIu.jsx)($bff3efd740a53c9a$var$Actions, {})
    });
};
const $bff3efd740a53c9a$var$messages = (0, $7VHMR.defineMessages)({
    notFoundTitle: {
        id: 'ptc-directory.profile-page.not-found.title',
        defaultMessage: "Looks like we\u2019re off the beaten track",
        description: 'The title of the error page when a user tries to view a user but the user id does not exist'
    },
    notFoundDescription1: {
        id: 'ptc-directory.profile-page.not-found.description.first',
        defaultMessage: 'We landed here for a user that does not exist.',
        description: 'The first line of the description when a user landed on an invalid page'
    },
    notFoundDescription2: {
        id: 'ptc-directory.profile-page.not-found.description.second',
        defaultMessage: 'Head back to the directory to search for another user.',
        description: 'The second line of the description when a user landed on an invalid page'
    },
    buttonText: {
        id: 'ptc-directory.profile-page.error.home.button',
        defaultMessage: 'Back to directory',
        description: 'The button text to return to the search page'
    }
});

});
parcelRegister("lwspq", function(module, exports) {
module.exports = new URL("svg-user-not-found_ptc.0205a184.svg", import.meta.url).toString();

});

parcelRegister("ew2U0", function(module, exports) {

$parcel$export(module.exports, "NotFoundImage", () => $bbf7bd49de6df0f3$export$22dc9752913c971e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
const $bbf7bd49de6df0f3$export$22dc9752913c971e = /*#__PURE__*/ (0, $47bDC.default).img.withConfig({
    componentId: "sc-1wghneo-0"
})`margin:0 0 ${"var(--ds-space-500, 40px)"} 0;display:flex;`;

});


parcelRegister("lT2JU", function(module, exports) {

$parcel$export(module.exports, "SidebarContent", () => $4c2b1bf7dd612d43$export$49e8f7b58a4df4ea);
$parcel$export(module.exports, "SidebarContentNext", () => $4c2b1bf7dd612d43$export$222c2783abd9eeb3);
$parcel$export(module.exports, "AvatarWrapper", () => $4c2b1bf7dd612d43$export$f7513421c53ce141);
$parcel$export(module.exports, "Details", () => $4c2b1bf7dd612d43$export$3e8048d3cf2ba3fd);
$parcel$export(module.exports, "Name", () => $4c2b1bf7dd612d43$export$c7bd411105e2dec3);
$parcel$export(module.exports, "Nickname", () => $4c2b1bf7dd612d43$export$445f45ad592d8c5);
$parcel$export(module.exports, "LoadingWrapper", () => $4c2b1bf7dd612d43$export$43a792a870d28db2);
$parcel$export(module.exports, "NonActiveUserLozenge", () => $4c2b1bf7dd612d43$export$184eb2c877f30f66);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ 
var $47bDC = parcelRequire("47bDC");

const $4c2b1bf7dd612d43$export$3f46768c2c1337f2 = -91;
const $4c2b1bf7dd612d43$export$49e8f7b58a4df4ea = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1oxac7m-0"
})`margin-top:${$4c2b1bf7dd612d43$export$3f46768c2c1337f2}px;`;
const $4c2b1bf7dd612d43$export$222c2783abd9eeb3 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1oxac7m-1"
})`margin-top:${$4c2b1bf7dd612d43$export$3f46768c2c1337f2}px;display:flex;flex-direction:column;align-items:center;`;
const $4c2b1bf7dd612d43$export$b4afcc4b43e79a52 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1oxac7m-2"
})`height:0;padding:0;margin:${"var(--ds-space-250, 20px)"} 0 0 0;`;
const $4c2b1bf7dd612d43$export$f7513421c53ce141 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1oxac7m-3"
})`position:relative;display:inline-block;height:134px;width:134px;border-radius:50%;margin-bottom:${"var(--ds-space-200, 16px)"};`;
const $4c2b1bf7dd612d43$export$3e8048d3cf2ba3fd = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1oxac7m-4"
})`display:flex;flex-direction:column;`;
const $4c2b1bf7dd612d43$export$c7bd411105e2dec3 = /*#__PURE__*/ (0, $47bDC.default).h1.withConfig({
    componentId: "sc-1oxac7m-5"
})`font:${"var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin-top:0;margin-bottom:${"var(--ds-space-150, 12px)"};word-break:break-all;`;
const $4c2b1bf7dd612d43$export$445f45ad592d8c5 = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "sc-1oxac7m-6"
})`color:${`var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$e2ef2124cf4024b1)})`};margin-bottom:${"var(--ds-space-150, 12px)"};word-break:break-all;`;
const $4c2b1bf7dd612d43$export$43a792a870d28db2 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1oxac7m-7"
})`opacity:${(props)=>props.isLoading ? 0 : 1};`;
const $4c2b1bf7dd612d43$export$184eb2c877f30f66 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1oxac7m-8"
})`margin-bottom:${"var(--ds-space-250, 20px)"};margin-top:${"var(--ds-space-050, 4px)"};`;

});


parcelRegister("4A6VZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $407c703b4e58863e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $itVmz = parcelRequire("itVmz");
const $407c703b4e58863e$var$WorkedOnListContainer = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $itVmz.default), {
        ...props
    });
};
var $407c703b4e58863e$export$2e2bcd8739ae039 = $407c703b4e58863e$var$WorkedOnListContainer;

});
parcelRegister("itVmz", function(module, exports) {

$parcel$export(module.exports, "default", () => $833c60d0c54dcf99$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1geG0 = parcelRequire("1geG0");

var $dp4Da = parcelRequire("dp4Da");

var $dOfy3 = parcelRequire("dOfy3");

var $d2BZ2 = parcelRequire("d2BZ2");

var $2vGTQ = parcelRequire("2vGTQ");
const $833c60d0c54dcf99$var$ProfileRecentWorkClient = (props)=>{
    const { userId: userId } = props;
    const [{ principalUserId: principalUserId }] = (0, $1geG0.usePrincipalUser)();
    const [activities, setActivities] = (0, $5uXOq.useState)([]);
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
    const activityClient = (0, $dp4Da.useActivityClient)('v3', 'people');
    const { data: data } = (0, $dOfy3.useTeamsUser)(userId, !userId);
    const loadActivities = (0, $5uXOq.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const fetchedActivities = await activityClient.fetchActivities([
                50,
                125,
                250
            ], {
                limit: 50,
                actors: [
                    `ari:cloud:identity::user/${userId}`
                ]
            }, [
                'workedOn'
            ]);
            const translated = (0, $d2BZ2.transformDataFromRecentWorkClient)(fetchedActivities.workedOn);
            setActivities(translated);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            // @ts-ignore
            setError(error);
        }
    }, [
        activityClient,
        userId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (userId) loadActivities();
    }, [
        loadActivities,
        userId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2vGTQ.default), {
        userFullName: data?.fullName,
        userId: userId,
        currentUserId: principalUserId,
        error: error,
        hasError: !!error,
        isLoading: isLoading,
        activities: activities
    });
};
var $833c60d0c54dcf99$export$2e2bcd8739ae039 = $833c60d0c54dcf99$var$ProfileRecentWorkClient;

});
parcelRegister("dOfy3", function(module, exports) {

$parcel$export(module.exports, "useTeamsUser", () => $a1d86f37d993ce9d$export$14c10fb40f456eef);

var $5uXOq = parcelRequire("5uXOq");

var $hwqCZ = parcelRequire("hwqCZ");
const $a1d86f37d993ce9d$export$14c10fb40f456eef = (userId, skip)=>{
    const [users, { getUser: getUser, setUserData: setUserData, ...rest }] = (0, $hwqCZ.useUser)();
    const userState = users[userId];
    (0, $5uXOq.useEffect)(()=>{
        if (!skip) getUser(userId);
    }, [
        getUser,
        skip,
        userId
    ]);
    return {
        ...rest,
        data: userState?.user,
        isLoading: userState?.isLoading,
        error: userState?.error,
        refetch: ()=>getUser(userId, true),
        setUserData: (data)=>setUserData(userId, data)
    };
};

});
parcelRegister("hwqCZ", function(module, exports) {

$parcel$export(module.exports, "useUser", () => $ddce62566b04b8f3$export$23bbbc4533528f03);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $2Ixyh = parcelRequire("2Ixyh");
const $ddce62566b04b8f3$var$CACHE_MAX_AGE = 300000; // 5 minutes
const $ddce62566b04b8f3$var$CACHE_MAX_SIZE = 5;
const $ddce62566b04b8f3$var$initialState = {};
const $ddce62566b04b8f3$export$e324594224ef24da = {
    getUser: (userId, isRefetching)=>async ({ getState: getState, setState: setState })=>{
            const userState = getState()[userId];
            // Do not fetch the user if it is still in cache
            // Or it is loading
            // Or it is refetching
            if (!isRefetching && userState && (userState.isLoading || userState.exp > Date.now())) return;
            // Remove the oldest user from the cache if the cache is full
            const userIds = Object.keys(getState());
            if (userIds.length >= $ddce62566b04b8f3$var$CACHE_MAX_SIZE) {
                const mutableState = {
                    ...getState()
                };
                const oldestUserId = userIds.reduce((oldest, current)=>mutableState[current].exp < mutableState[oldest].exp ? current : oldest);
                delete mutableState[oldestUserId];
                setState({
                    ...mutableState
                });
            }
            setState({
                [userId]: {
                    isLoading: true,
                    error: undefined,
                    user: undefined,
                    exp: -1
                }
            });
            try {
                // AGG user query does not verify user’s org membership,
                // it can provide user info to users who are outside the org.
                // To apply proper restrictions on visibility, we need to check if the user is present in the site.
                // Read more in https://hello.atlassian.net/wiki/spaces/PTC/pages/3492140773/LDR+Replace+pf-directory+CloudUser+with+AGG+User
                const userCheckPromise = (0, $2Ixyh.teamsClient).getUserInSiteUserBase(userId);
                const userQueryPromise = (0, $2Ixyh.teamsClient).queryAGGUser(userId);
                const checkUserPresentInSiteRes = await userCheckPromise;
                if (!checkUserPresentInSiteRes.isPresent) {
                    setState({
                        [userId]: {
                            isLoading: false,
                            exp: -1
                        }
                    });
                    return;
                }
                const user = await userQueryPromise;
                setState({
                    [userId]: {
                        isLoading: false,
                        exp: Date.now() + $ddce62566b04b8f3$var$CACHE_MAX_AGE,
                        user: {
                            ...user,
                            fullName: user.name,
                            title: user.extendedProfile?.jobTitle,
                            timezone: user.zoneinfo,
                            locale: user.locale,
                            location: user.extendedProfile?.location,
                            companyName: user.extendedProfile?.organization,
                            department: user.extendedProfile?.department,
                            avatarUrl: user.picture,
                            status: user.accountStatus,
                            isBot: user.__typename === 'AppUser',
                            userType: 'user',
                            phoneNumber: user.extendedProfile?.phoneNumbers && user.extendedProfile?.phoneNumbers[0]?.value,
                            isAgent: user.appType === 'agent'
                        }
                    }
                });
            } catch (error) {
                setState({
                    [userId]: {
                        error: error instanceof Error ? error : new Error('Unknown error'),
                        isLoading: false,
                        exp: -1
                    }
                });
            }
        },
    updateUserInfo: (userId, fieldKey, value)=>async ({ getState: getState, setState: setState })=>{
            const userState = getState()[userId];
            if (!userState || !userState.user) return;
            const updatedUser = {
                ...userState.user,
                [fieldKey]: value
            };
            setState({
                [userId]: {
                    ...userState,
                    user: updatedUser
                }
            });
            try {
                await (0, $2Ixyh.teamsClient).updateUser({
                    id: userId,
                    [fieldKey]: value
                });
            } catch (error) {
                setState({
                    [userId]: {
                        ...userState,
                        user: userState.user
                    }
                });
            }
        },
    /**
	 * Expose a method to set user data
	 * Useful when we want to update user data that needs relatively long time in BE to sync
	 */ setUserData: (userId, data)=>({ getState: getState, setState: setState })=>{
            const userState = getState()[userId];
            if (!userState || !userState.user) return;
            setState({
                [userId]: {
                    ...userState,
                    user: userState.user && {
                        ...userState.user,
                        ...data
                    }
                }
            });
        }
};
const $ddce62566b04b8f3$var$Store = (0, $iXqE5.createStore)({
    initialState: $ddce62566b04b8f3$var$initialState,
    actions: $ddce62566b04b8f3$export$e324594224ef24da,
    name: 'User'
});
const $ddce62566b04b8f3$export$23bbbc4533528f03 = (0, $3sQ5x.createHook)($ddce62566b04b8f3$var$Store);

});


parcelRegister("d2BZ2", function(module, exports) {

$parcel$export(module.exports, "transformDataFromRecentWorkClient", () => $21f5f5a0f9b665aa$export$25e790c9ec501a25);

var $cACzQ = parcelRequire("cACzQ");
function $21f5f5a0f9b665aa$var$getDirectContainer(node) {
    let container = '';
    const len = node.containers?.length || 0;
    if (node.containers && len > 0) container = node.containers[len - 1].name;
    const provider = (0, $cACzQ.toTitleCase)((0, $cACzQ.replaceUnderscoresToSpace)((0, $cACzQ.replaceHypensToSpace)(node.object.product.toLowerCase())));
    return container || provider; // fallback is product name
}
function $21f5f5a0f9b665aa$var$transformContributorToActivity(contributor, type = '', date = null) {
    return {
        date: date,
        user: {
            id: contributor.accountId,
            fullName: contributor.name
        },
        type: type
    };
}
function $21f5f5a0f9b665aa$var$transformNodeToWorkLensActivityObject(node) {
    const { name: name = '', url: url = '', icon: icon = null, product: product = '' } = node.object || {};
    return {
        name: name || '',
        url: url,
        cloudId: '',
        iconUrl: icon ? icon.value : '',
        provider: product,
        container: $21f5f5a0f9b665aa$var$getDirectContainer(node)
    };
}
function $21f5f5a0f9b665aa$var$transformContributersForActor({ actor: actor, contributors: contributors, eventType: eventType, timestamp: timestamp }) {
    const updatedContributors = !contributors.length && actor ? [
        actor
    ] : contributors;
    return updatedContributors.map((contributor)=>$21f5f5a0f9b665aa$var$transformContributorToActivity(contributor, eventType, timestamp));
}
function $21f5f5a0f9b665aa$export$25e790c9ec501a25(nodes) {
    return nodes.map((node)=>{
        const { object: { id: objectId }, timestamp: timestamp } = node;
        return {
            objectId: objectId,
            lastModification: timestamp,
            activity: $21f5f5a0f9b665aa$var$transformContributersForActor(node),
            object: {
                ...$21f5f5a0f9b665aa$var$transformNodeToWorkLensActivityObject(node)
            }
        };
    });
}

});
parcelRegister("cACzQ", function(module, exports) {

$parcel$export(module.exports, "toTitleCase", () => $2a95b3777687a33a$export$f06f8b3003f18927);
$parcel$export(module.exports, "replaceUnderscoresToSpace", () => $2a95b3777687a33a$export$d3895e5768a00fee);
$parcel$export(module.exports, "replaceHypensToSpace", () => $2a95b3777687a33a$export$568995155ea86c06);
/**
 * Method to capitalise first letter of an input string
 * @param text {String} - the input string
 * @return {String}
 */ const $2a95b3777687a33a$export$1270e6249ad1a81f = (text)=>typeof text === 'string' ? text.charAt(0).toUpperCase() + text.substr(1) : '';
const $2a95b3777687a33a$export$f06f8b3003f18927 = (text)=>{
    if (typeof text !== 'string') return '';
    const words = text.split(' ');
    return words.map((word)=>$2a95b3777687a33a$export$1270e6249ad1a81f(word)).join(' ');
};
const $2a95b3777687a33a$export$d3895e5768a00fee = (text)=>typeof text === 'string' ? text// underscores to spaces
    .replace(/_/g, ' ')// spaces to space
    .replace(/ +/g, ' ') : '';
const $2a95b3777687a33a$export$568995155ea86c06 = (text)=>typeof text === 'string' ? text// underscores to spaces
    .replace(/-/g, ' ')// spaces to space
    .replace(/ +/g, ' ') : '';

});


parcelRegister("2vGTQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3992fccc562dc644$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cprXC = parcelRequire("cprXC");
var $hOFm5 = parcelRequire("hOFm5");
var $71wio = parcelRequire("71wio");
var $358cZ = parcelRequire("358cZ");
var $ax2O8 = parcelRequire("ax2O8");
var $c5iyg = parcelRequire("c5iyg");

var $8YTXX = parcelRequire("8YTXX");

var $6wvxD = parcelRequire("6wvxD");
var $35Wh1 = parcelRequire("35Wh1");

var $k5T0X = parcelRequire("k5T0X");
function $3992fccc562dc644$export$c8678fe90ec246e0(props) {
    const { activities: activities, userId: userId, currentUserId: currentUserId, isLoading: isLoading, userFullName: userFullName, hasError: hasError, error: error } = props;
    const analytics = (0, $358cZ.default)();
    const onClickViewAllLink = (0, $5uXOq.useCallback)((location)=>{
        analytics.pushUIEvent({
            source: (0, $cprXC.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'viewAllWork',
            action: (0, $cprXC.AnalyticsEventActions).CLICKED,
            attributes: {
                location: location
            }
        });
    }, [
        analytics
    ]);
    const onClickShowMore = (0, $5uXOq.useCallback)((numItemsDisplayed)=>{
        analytics.pushUIEvent({
            source: (0, $cprXC.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'moreWork',
            action: (0, $cprXC.AnalyticsEventActions).CLICKED,
            attributes: {
                numItemsDisplayed: numItemsDisplayed
            }
        });
    }, [
        analytics
    ]);
    const onActivityEntryClick = (0, $5uXOq.useCallback)((provider, entryIndex)=>{
        analytics.pushUIEvent({
            source: (0, $cprXC.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'activityEntry',
            action: (0, $cprXC.AnalyticsEventActions).CLICKED,
            attributes: {
                provider: provider.toUpperCase(),
                entryIndex: entryIndex
            }
        });
    }, [
        analytics
    ]);
    (0, $ax2O8.useExpTrackerStart)({
        id: userId,
        name: (0, $hOFm5.UserExperienceNames).USER_PROFILE_WORKED_ON,
        timeout: (0, $hOFm5.DEFAULT_TIMEOUT_USER_EXP)
    });
    (0, $c5iyg.useExpTrackerStop)({
        name: (0, $hOFm5.UserExperienceNames).USER_PROFILE_WORKED_ON,
        error: error,
        checkShouldAbort: (error)=>{
            if ((0, $8YTXX.isRealErrorUserProfile)(error)) return;
            return `Aborted because of ${error.message}`;
        }
    });
    let emptyView;
    if (hasError) emptyView = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $35Wh1.default), {
        userFullName: userFullName,
        userId: userId
    });
    else emptyView = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6wvxD.default), {
        isCurrentUser: !!userId && userId === currentUserId,
        userFullName: userFullName,
        isForTable: false
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k5T0X.default), {
                activities: activities,
                currentUserId: currentUserId,
                viewAllLink: `${userId}/work`,
                isLoading: isLoading,
                onClickViewAllLink: onClickViewAllLink,
                onClickShowMore: onClickShowMore,
                onClickActivityEntry: onActivityEntryClick,
                emptyView: emptyView,
                userId: userId
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $71wio.ExperienceSuccess), {
                hasLoaded: !hasError && !isLoading,
                name: (0, $hOFm5.UserExperienceNames).USER_PROFILE_WORKED_ON
            })
        ]
    });
}
var $3992fccc562dc644$export$2e2bcd8739ae039 = $3992fccc562dc644$export$c8678fe90ec246e0;

});
parcelRegister("6wvxD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7595a8917187f80e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $3s0xG = parcelRequire("3s0xG");

var $fHpHg = parcelRequire("fHpHg");

var $kbFku = parcelRequire("kbFku");

var $Es2dv = parcelRequire("Es2dv");

var $j8v24 = parcelRequire("j8v24");

var $4uNPw = parcelRequire("4uNPw");

var $94Q9V = parcelRequire("94Q9V");
function $7595a8917187f80e$var$EmptyWorkState(props) {
    const { isForTable: isForTable, userId: userId, userFullName: userFullName, isCurrentUser: isCurrentUser } = props;
    const intl = (0, $koVbs.default)();
    const renderDescText = ()=>{
        const descMessage = isCurrentUser ? $7595a8917187f80e$var$messages.noWorkListDescForYou : $7595a8917187f80e$var$messages.noWorkListPersonDesc;
        return userFullName ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...descMessage,
            values: {
                user: userFullName
            }
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$7595a8917187f80e$var$messages.noWorkListTeamDesc
        });
    };
    if (isForTable) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3s0xG.default), {
        header: intl.formatMessage($7595a8917187f80e$var$messages.noWorkListTitle),
        description: renderDescText(),
        imageUrl: (0, $fHpHg.fg)('enable_team_profile_visual_refresh') ? (0, (/*@__PURE__*/$parcel$interopDefault($j8v24))) : (0, (/*@__PURE__*/$parcel$interopDefault($4uNPw))),
        primaryAction: userId && userFullName && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $94Q9V.default), {
            isInEmptyState: true,
            userId: userId,
            userFullName: userFullName
        })
    });
    return (0, $fHpHg.fg)('enable_team_profile_visual_refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $Es2dv.EmptyStateNew), {
        title: intl.formatMessage($7595a8917187f80e$var$messages.noWorkListTitle),
        description: renderDescText(),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($j8v24))),
        actions: userId && userFullName && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $94Q9V.default), {
            isInEmptyState: true,
            userId: userId,
            userFullName: userFullName
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kbFku.default), {
        title: intl.formatMessage($7595a8917187f80e$var$messages.noWorkListTitle),
        description: renderDescText(),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($4uNPw))),
        actions: userId && userFullName && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $94Q9V.default), {
            isInEmptyState: true,
            userId: userId,
            userFullName: userFullName
        })
    });
}
const $7595a8917187f80e$var$messages = (0, $7VHMR.defineMessages)({
    noWorkListTitle: {
        id: 'ptc-directory.profile-page.work-list.no-work-list.title',
        defaultMessage: 'There is no work to see here',
        description: 'Title of the message displayed when there is no work associated to the profile that is being viewed'
    },
    noWorkListTeamDesc: {
        id: 'ptc-directory.profile-page.work-list.no-work-list.team.description',
        defaultMessage: 'Things the team created, edited or commented on in the last 90 days.',
        description: 'Description of the message displayed when there is no work associated to the team profile that is being viewed'
    },
    noWorkListPersonDesc: {
        id: 'ptc-directory.profile-page.work-list.no-work-list.personal.description',
        defaultMessage: 'Things {user} created, edited or commented on in the last 90 days.',
        description: 'Description of the message displayed when there is no work associated to the person profile that is being viewed'
    },
    noWorkListDescForYou: {
        id: 'ptc-directory.profile-page.work-list.no-work-list.personal.description.you',
        defaultMessage: 'Things you created, edited or commented on in the last 90 days.',
        description: 'Description of the message displayed when there is no work associated to the current logged-in person profile that is being viewed'
    }
});
var $7595a8917187f80e$export$2e2bcd8739ae039 = $7595a8917187f80e$var$EmptyWorkState;

});
parcelRegister("Es2dv", function(module, exports) {

$parcel$export(module.exports, "EmptyStateNew", () => $026e1e017f6c7821$export$4fb40e9ec756139e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bWfiu = parcelRequire("bWfiu");

var $5FmWx = parcelRequire("5FmWx");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $gOkqF = parcelRequire("gOkqF");
var $k9nuy = parcelRequire("k9nuy");
const $026e1e017f6c7821$var$styles = {
    emptyStateBackgroundStyled: "_2rkopd34 _189ee4h9 _1h6dmuej _1dqonqa1 _kqswh2mm _ca0qv47k _u5f3xy5q _n3tdv47k _19bvxy5q",
    image: "_1bsbmgvx _4t3i7l9q"
};
const $026e1e017f6c7821$export$4fb40e9ec756139e = (props)=>{
    const { title: title, description: description, imageUrl: imageUrl, actions: actions, testId: testId, image: image } = props;
    const img = imageUrl ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5FmWx.default), {
        src: imageUrl,
        alt: ""
    }) : image;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        backgroundColor: "elevation.surface",
        xcss: $026e1e017f6c7821$var$styles.emptyStateBackgroundStyled,
        testId: testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
            space: "space.400",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    xcss: $026e1e017f6c7821$var$styles.image,
                    children: img
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
                    space: "space.200",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                            children: description
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                            space: "space.050",
                            children: actions
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("j8v24", function(module, exports) {
module.exports = new URL("WorkListEmpty_ptc.6b3d5f72.svg", import.meta.url).toString();

});

parcelRegister("4uNPw", function(module, exports) {
module.exports = new URL("WorkListEmpty_ptc_old.c984a049.svg", import.meta.url).toString();

});

parcelRegister("94Q9V", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f7eabeb4f493f9b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");

var $fHpHg = parcelRequire("fHpHg");

var $6eFvr = parcelRequire("6eFvr");

var $cprXC = parcelRequire("cprXC");
var $358cZ = parcelRequire("358cZ");

var $fcwP9 = parcelRequire("fcwP9");

var $5vx1F = parcelRequire("5vx1F");
const $0f7eabeb4f493f9b$var$getConfluenceSearchLink = (userId)=>{
    return `/wiki/search?contributors=${encodeURIComponent(userId)}&lastModified=lastMonth`;
};
const $0f7eabeb4f493f9b$var$getJiraSearchLink = (userId)=>{
    // not sure why Jira does not need context-path for issue search page
    const jql = `assignee in (${userId})` + ` OR reporter in (${userId})` + ` OR creator in (${userId})` + ` OR watcher in (${userId})` + ' ORDER BY updated DESC';
    return `/issues/?jql=${encodeURIComponent(jql)}`;
};
const $0f7eabeb4f493f9b$var$SearchLink = (props)=>{
    const analytics = (0, $358cZ.default)();
    const { siteUrl: siteUrl } = (0, $5vx1F.useAppConfig)();
    const { container: container, userId: userId } = props;
    const onClickSearchLink = ()=>{
        analytics.pushUIEvent({
            source: (0, $cprXC.AnalyticsEventSource).USER_WORK_SCREEN,
            actionSubject: 'searchMoreLink',
            action: (0, $cprXC.AnalyticsEventActions).CLICKED,
            attributes: {
                container: container
            }
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fcwP9.StyledLink), {
        href: (0, $fHpHg.fg)('append_site_url_more_search') ? `${siteUrl}${container === 'Confluence' ? $0f7eabeb4f493f9b$var$getConfluenceSearchLink(userId) : $0f7eabeb4f493f9b$var$getJiraSearchLink(userId)}` : container === 'Confluence' ? $0f7eabeb4f493f9b$var$getConfluenceSearchLink(userId) : $0f7eabeb4f493f9b$var$getJiraSearchLink(userId),
        target: "_blank",
        "data-test-selector": container.toLowerCase(),
        onClick: onClickSearchLink,
        children: container
    });
};
const $0f7eabeb4f493f9b$var$SearchMoreWork = (props)=>{
    const { isInEmptyState: isInEmptyState, userId: userId, userFullName: userFullName } = props;
    if (!userId || !userFullName) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6eFvr.default), {
        as: "p",
        children: [
            isInEmptyState ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...$0f7eabeb4f493f9b$var$messages.searchInEmptyState
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...$0f7eabeb4f493f9b$var$messages.searchNotInEmptyState
            }),
            ' ',
            /*#__PURE__*/ (0, $2OMIu.jsx)($0f7eabeb4f493f9b$var$SearchLink, {
                container: "Confluence",
                userId: userId
            }),
            " ",
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...$0f7eabeb4f493f9b$var$messages.or
            }),
            ' ',
            /*#__PURE__*/ (0, $2OMIu.jsx)($0f7eabeb4f493f9b$var$SearchLink, {
                container: "Jira",
                userId: userId
            })
        ]
    });
};
const $0f7eabeb4f493f9b$var$messages = (0, $7VHMR.defineMessages)({
    searchInEmptyState: {
        id: 'ptc-directory.profile-page.work-list.search.in.empty.state',
        defaultMessage: 'You can also search in',
        description: 'A part of a full message is which "You can also search in Confluence or Jira". This is used in empty state of work list component'
    },
    searchNotInEmptyState: {
        id: 'ptc-directory.profile-page.work-list.search.in.not.empty.state',
        defaultMessage: 'Search for more in',
        description: 'A part of a full message is which "Search for more in in Confluence or Jira". This is used in empty state of work list table component'
    },
    or: {
        id: 'ptc-directory.profile-page.work-list.or',
        defaultMessage: 'or',
        description: ''
    }
});
var $0f7eabeb4f493f9b$export$2e2bcd8739ae039 = $0f7eabeb4f493f9b$var$SearchMoreWork;

});
parcelRegister("fcwP9", function(module, exports) {

$parcel$export(module.exports, "StyledLink", () => $00d9a60fe228b51d$export$9048d548939551ee);
/**
 * Use this component whenever you would need <a> or <Link>.
 * Use with `href` property to create an <a> tag and with `to` property
 * to create a <Link> tag.
 *
 * With using this component for all link elements we make sure links have
 * the proper hover and focus styles. Atlaskit/button with link appearance
 * does not have a correct focus style and is harder to deal with as it might
 * need additional props like spacing depending on where it's used.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");


var $5CtC2 = parcelRequire("5CtC2");
const $00d9a60fe228b51d$var$getColor = (props)=>props.appearance === 'subtle' ? `var(--ds-text-subtle, ${0, $a7f8c6b391092279$export$f563ee71e9ee74cd})` : `var(--ds-link, ${0, $a7f8c6b391092279$export$b3de0ae08da2ce64})`;
const $00d9a60fe228b51d$var$getHoverColor = (props)=>props.appearance === 'subtle' ? `var(--ds-text-subtle, ${0, $a7f8c6b391092279$export$7c87d337fb91a97d})` : `var(--ds-link, ${0, $a7f8c6b391092279$export$e62e8919cca44969})`;
const $00d9a60fe228b51d$var$getActiveColor = (props)=>props.appearance === 'subtle' ? `var(--ds-text, ${0, $a7f8c6b391092279$export$7c87d337fb91a97d})` : `var(--ds-link-pressed, ${0, $a7f8c6b391092279$export$e62e8919cca44969})`;
const $00d9a60fe228b51d$export$9048d548939551ee = /*#__PURE__*/ (0, $47bDC.default)((0, $5CtC2.default)).withConfig({
    componentId: "ae9szl-0"
})`color:${(props)=>$00d9a60fe228b51d$var$getColor(props)};&&:hover{color:${(props)=>$00d9a60fe228b51d$var$getHoverColor(props)};text-decoration:underline;}&&:focus{outline:2px solid ${`var(--ds-border-focused, ${(0, $a7f8c6b391092279$export$ecfc1dff386a3e7a)})`};outline-offset:2px;}&&:active{color:${(props)=>$00d9a60fe228b51d$var$getActiveColor(props)};outline:none;text-decoration:none;}`;

});



parcelRegister("35Wh1", function(module, exports) {

$parcel$export(module.exports, "default", () => $9da57ad6bfb4eb7c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $3s0xG = parcelRequire("3s0xG");

var $hIKTz = parcelRequire("hIKTz");

var $k8MiP = parcelRequire("k8MiP");

var $94Q9V = parcelRequire("94Q9V");
const $9da57ad6bfb4eb7c$var$SUPPORT_LINK_URI = (0, $hIKTz.getAtlassianContextUrl)('support');
const $9da57ad6bfb4eb7c$var$SUPPORT_LINK = (0, $hIKTz.getAtlassianContextDomain)('support');
function $9da57ad6bfb4eb7c$var$ErrorWorkState(props) {
    const { userId: userId, userFullName: userFullName } = props;
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3s0xG.default), {
        header: intl.formatMessage($9da57ad6bfb4eb7c$var$messages.errorTitle),
        description: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$9da57ad6bfb4eb7c$var$messages.errorDesc,
            values: {
                a: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                        "data-testid": "support-link",
                        href: $9da57ad6bfb4eb7c$var$SUPPORT_LINK_URI,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: $9da57ad6bfb4eb7c$var$SUPPORT_LINK
                    })
            }
        }),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($k8MiP))),
        primaryAction: userFullName && userId && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $94Q9V.default), {
            isInEmptyState: true,
            userId: userId,
            userFullName: userFullName
        })
    });
}
const $9da57ad6bfb4eb7c$var$messages = (0, $7VHMR.defineMessages)({
    errorTitle: {
        id: 'ptc-directory.profile-page.table-work-list.error.title',
        defaultMessage: 'We seem to have lost the connection',
        description: 'Title of error UI when fetching work list fails'
    },
    errorDesc: {
        id: 'ptc-directory.profile-page.table-work-list.error.desc',
        defaultMessage: 'Wait a few moments, then try refreshing the page. If this keeps happening, let us know at <a></a>.',
        description: 'Description of error UI when fetching work list fails'
    }
});
var $9da57ad6bfb4eb7c$export$2e2bcd8739ae039 = $9da57ad6bfb4eb7c$var$ErrorWorkState;

});
parcelRegister("k8MiP", function(module, exports) {
module.exports = new URL("WorkListError_ptc.b9457501.svg", import.meta.url).toString();

});


parcelRegister("k5T0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4cc7946060e52d7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");

var $3xkW0 = parcelRequire("3xkW0");

var $gkzoY = parcelRequire("gkzoY");

var $hIxwC = parcelRequire("hIxwC");
const $a4cc7946060e52d7$var$timeFormatOptions = {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
};
const $a4cc7946060e52d7$var$getDescription = (activityObject, currentUserId)=>{
    if (activityObject.activity.length <= 0 || !activityObject.activity[0].user) return null;
    const description = activityObject.activity.length > 1 ? (0, $gkzoY.getI18nDataForManyEntries)(activityObject.activity, currentUserId) : (0, $gkzoY.getI18nDataForSingleEntry)(activityObject.activity[0], currentUserId);
    return description;
};
const $a4cc7946060e52d7$var$isDefined = (prop)=>{
    return !!prop;
};
function $a4cc7946060e52d7$export$ad0c9978cddbc3ff(activities, currentUserId) {
    return activities.map((activityObject)=>{
        const i18nForDescription = $a4cc7946060e52d7$var$getDescription(activityObject, currentUserId);
        if (!i18nForDescription) return null;
        if (i18nForDescription && 'time' in i18nForDescription.params && typeof i18nForDescription.params.time === 'string') i18nForDescription.params.time = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7VHMR.FormattedDate), {
            ...$a4cc7946060e52d7$var$timeFormatOptions,
            value: i18nForDescription.params.time
        });
        const { name: name = '', iconUrl: iconUrl = '', url: url = '', container: container = '', provider: provider = '' } = activityObject?.object || {};
        return {
            objectName: name,
            objectIconUrl: iconUrl,
            objectUrl: url,
            containerName: container,
            provider: provider,
            description: i18nForDescription ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...i18nForDescription.key,
                values: i18nForDescription.params
            }) : ''
        };
    }).filter($a4cc7946060e52d7$var$isDefined);
}
const $a4cc7946060e52d7$var$getInfoText = (userId, currentUserId)=>{
    /**
	 * Return null if:
	 *  - userId or currentUserId is not defined
	 *  - current user is not viewing own activity
	 */ if (!userId || !currentUserId || userId !== currentUserId) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $hIxwC.messages).privacyAssuringInfoText
    });
};
function $a4cc7946060e52d7$export$2e2bcd8739ae039(props) {
    const { activities: activities, currentUserId: currentUserId, userId: userId, titleText: titleText, emptyView: emptyView, isLoading: isLoading, ...otherProps } = props;
    const workItems = $a4cc7946060e52d7$export$ad0c9978cddbc3ff(activities || [], currentUserId);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3xkW0.default), {
        ...otherProps,
        workItems: workItems,
        isInitiallyExpanded: false,
        emptyView: emptyView,
        titleText: titleText,
        infoText: $a4cc7946060e52d7$var$getInfoText(userId, currentUserId),
        isLoading: isLoading
    });
}

});
parcelRegister("3xkW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $83721492f8342930$export$2e2bcd8739ae039);
/* WorkList.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");

var $fOvl8 = parcelRequire("fOvl8");

var $7wrAa = parcelRequire("7wrAa");

var $fcwP9 = parcelRequire("fcwP9");

var $bdzum = parcelRequire("bdzum");

var $28q0d = parcelRequire("28q0d");

var $7Jefy = parcelRequire("7Jefy");
const $83721492f8342930$var$styles = {
    workListItemsWrapper: "_2rkoiti9 _qtt8glyw _16qszucj _ca0qpxbi _n3tdpxbi _19bvu2gc _u5f3u2gc",
    workListItemsNext: "_qtt8glyw _19bvze3t"
};
const $83721492f8342930$export$2aa3c3bd0ee6f3b7 = (props)=>{
    const [isExpanded, setIsExpanded] = (0, $5uXOq.useState)(props.isInitiallyExpanded);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onShowMore = (e)=>{
        e.preventDefault();
        const { workItems: workItems, onClickShowMore: onClickShowMore, limitExpanded: limitExpanded } = props;
        setIsExpanded(true);
        const workItemsCount = workItems.length;
        if (onClickShowMore) onClickShowMore(// No limit? Show workItems count, otherwise show smaller of limit vs count
        !limitExpanded ? workItemsCount : workItemsCount <= limitExpanded ? workItemsCount : limitExpanded);
    };
    const onClickViewAllLink = (location)=>()=>{
            if (props.onClickViewAllLink) props.onClickViewAllLink(location);
        };
    const onClickActivityEntry = (provider, entryIndex)=>()=>{
            if (props.onClickActivityEntry) props.onClickActivityEntry(provider, entryIndex);
        };
    const renderShowMoreButton = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($7Jefy.FooterLink, {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fcwP9.StyledLink), {
                appearance: "subtle",
                onClick: onShowMore,
                href: "#",
                "aria-label": formatMessage($83721492f8342930$export$defe85febe8b728c.showMoreLinkLabel),
                children: formatMessage($83721492f8342930$export$defe85febe8b728c.showMoreLink)
            })
        });
    const renderViewAllFooterButton = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($7Jefy.FooterLink, {
            "data-testid": "view-all-link__footer",
            children: renderViewAllLink({
                appearance: 'subtle',
                location: 'footer'
            })
        });
    const renderViewAllHeaderButton = ()=>props.workItems.length > 0 && props.viewAllLink && /*#__PURE__*/ (0, $2OMIu.jsx)($7Jefy.HeaderLink, {
            "data-testid": "view-all-link__header",
            children: renderViewAllLink({
                location: 'header'
            })
        });
    const renderViewAllLink = (linkOptions)=>{
        const { appearance: appearance = 'default', location: location } = linkOptions;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fcwP9.StyledLink), {
            appearance: appearance,
            href: props.viewAllLink,
            onClick: onClickViewAllLink(location),
            "aria-label": formatMessage($83721492f8342930$export$defe85febe8b728c.viewAllLinkLabel),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...$83721492f8342930$export$defe85febe8b728c.viewAllLink
            })
        });
    };
    const renderFooterButtons = ()=>{
        const { viewAllLink: viewAllLink, workItems: workItems, limitDefault: limitDefault } = props;
        const workItemsCount = workItems.length;
        const canExpand = workItemsCount > limitDefault;
        if (workItemsCount === 0) return null;
        if (!isExpanded && canExpand) return renderShowMoreButton();
        if (viewAllLink) return renderViewAllFooterButton();
        return null;
    };
    const renderWorkItems = ()=>{
        const { workItems: workItems, limitDefault: limitDefault, limitExpanded: limitExpanded, emptyView: emptyView, isLoading: isLoading } = props;
        if (isLoading) return /*#__PURE__*/ (0, $2OMIu.jsx)($7Jefy.SkeletonWrapper, {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7wrAa.default), {
                hasIcon: true,
                isShimmering: true,
                cssFn: ()=>({
                        paddingLeft: "var(--ds-space-100, 8px)",
                        paddingRight: "var(--ds-space-100, 8px)"
                    }),
                itemCount: limitDefault || 0
            })
        });
        if (!workItems.length) {
            if ((0, $fHpHg.fg)('enable_team_profile_visual_refresh')) return null;
            else return emptyView;
        }
        const limit = isExpanded ? limitExpanded : limitDefault;
        return workItems.slice(0, limit).map((resourceItem, idx)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $28q0d.default), {
                objectName: resourceItem.objectName,
                description: resourceItem.description,
                objectUrl: resourceItem.objectUrl,
                objectIconUrl: resourceItem.objectIconUrl,
                containerName: resourceItem.containerName,
                provider: resourceItem.provider,
                onClick: onClickActivityEntry(resourceItem.provider, idx)
            }, `work-item-${idx}`));
    };
    const { titleText: titleText, infoText: infoText, workItems: workItems, emptyView: emptyView } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bdzum.PanelContent), {
        "data-testid": "profile-work-list",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bdzum.PanelContentHeader), {
                hasSubInfo: !!infoText,
                "data-testid": "profile-work-list-header",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bdzum.PanelContentTitle), {
                        children: titleText || formatMessage($83721492f8342930$export$defe85febe8b728c.listTitle)
                    }),
                    renderViewAllHeaderButton()
                ]
            }),
            infoText && /*#__PURE__*/ (0, $2OMIu.jsx)($7Jefy.WorkListInfoText, {
                "data-testid": "profile-work-list-info",
                children: infoText
            }),
            (0, $fHpHg.fg)('enable_team_profile_heading_a11y_fix') ? (0, $fHpHg.fg)('enable_team_profile_visual_refresh') ? !workItems.length ? emptyView : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fOvl8.ItemWrapper), {
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sRpy.default), {
                    as: "ul",
                    xcss: $83721492f8342930$var$styles.workListItemsNext,
                    children: [
                        renderWorkItems(),
                        renderFooterButtons()
                    ]
                })
            }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sRpy.default), {
                as: "ul",
                backgroundColor: "elevation.surface.raised",
                xcss: $83721492f8342930$var$styles.workListItemsWrapper,
                children: [
                    renderWorkItems(),
                    renderFooterButtons()
                ]
            }) : !workItems.length ? emptyView : /*#__PURE__*/ (0, $2OMIu.jsxs)($7Jefy.WorkListItems, {
                children: [
                    renderWorkItems(),
                    renderFooterButtons()
                ]
            })
        ]
    });
};
$83721492f8342930$export$2aa3c3bd0ee6f3b7.defaultProps = {
    isInitiallyExpanded: false,
    workItems: [],
    limitDefault: 5,
    limitExpanded: 10,
    onClickViewAllLink: ()=>null,
    onClickShowMore: ()=>null,
    onClickActivityEntry: ()=>null
};
const $83721492f8342930$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    listTitle: {
        id: 'ptc-directory.profile-page.work-list.title',
        defaultMessage: 'Worked on'
    },
    showMoreLink: {
        id: 'ptc-directory.profile-page.work-list.show-more.link',
        defaultMessage: 'Show more',
        description: 'Link to reveal more work associated to the profile that is being viewed'
    },
    showMoreLinkLabel: {
        id: 'ptc-directory.profile-page.work-list.show-more.label',
        defaultMessage: 'Show more about worked on pages',
        description: 'Helper text for screen reader users. It is announced by screen reader when user focus the show more link'
    },
    viewAllLink: {
        id: 'ptc-directory.profile-page.work-list.view-all.link',
        defaultMessage: 'View all',
        description: 'Link to navigate to Work child page'
    },
    viewAllLinkLabel: {
        id: 'ptc-directory.profile-page.work-list.view-all.label',
        defaultMessage: 'View all worked on pages',
        description: 'Helper text for screen reader users. It is announced by screen reader when user focus the view all link'
    }
});
var $83721492f8342930$export$2e2bcd8739ae039 = $83721492f8342930$export$2aa3c3bd0ee6f3b7;

});
parcelRegister("7wrAa", function(module, exports) {

$parcel$export(module.exports, "default", () => $2df380b474bcbd2b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eCE62 = parcelRequire("eCE62");
const $2df380b474bcbd2b$var$SkeletonList = ({ hasIcon: hasIcon, hasAvatar: hasAvatar, isShimmering: isShimmering, cssFn: cssFn, itemCount: itemCount })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: Array(itemCount).fill(undefined).map((_, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCE62.default), {
                hasAvatar: hasAvatar,
                hasIcon: hasIcon,
                isShimmering: isShimmering,
                // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
                cssFn: cssFn
            }, `skeleton-${index}`))
    });
};
var $2df380b474bcbd2b$export$2e2bcd8739ae039 = $2df380b474bcbd2b$var$SkeletonList;

});

parcelRegister("28q0d", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3dac292e323847a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");

var $eOat1 = parcelRequire("eOat1");

var $fHpHg = parcelRequire("fHpHg");

var $0yZbT = parcelRequire("0yZbT");
var $6eFvr = parcelRequire("6eFvr");

var $gkzoY = parcelRequire("gkzoY");

var $inVGG = parcelRequire("inVGG");
const $c3dac292e323847a$export$314aaaef607a8c3a = (props)=>{
    const { provider: provider, objectIconUrl: objectIconUrl, objectName: objectName, containerName: containerName, description: description, objectUrl: objectUrl, onClick: onClick } = props;
    const renderDraftStatus = ()=>{
        if (!(0, $gkzoY.isConfluenceDraft)(provider, objectUrl)) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)($inVGG.LozengeWrapper, {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eOat1.default), {
                appearance: "inprogress",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...$c3dac292e323847a$var$messages.draft
                })
            })
        });
    };
    const renderBody = ()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsxs)($inVGG.Content, {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)($inVGG.ContentIcon, {
                    src: objectIconUrl,
                    alt: ""
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)($inVGG.Details, {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsxs)($inVGG.DetailsHeadline, {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6eFvr.default), {
                                    as: "p",
                                    children: objectName
                                }),
                                renderDraftStatus()
                            ]
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)($inVGG.DetailsDescription, {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)($inVGG.ContainerName, {
                                    children: containerName
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)($inVGG.Description, {
                                    children: description
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return (0, $fHpHg.fg)('enable_team_profile_heading_a11y_fix') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
        as: "li",
        testId: "work-item",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($inVGG.WorkItemLink, {
            href: objectUrl,
            onClick: onClick,
            children: renderBody()
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($inVGG.WorkItemLink, {
        href: objectUrl,
        onClick: onClick,
        children: renderBody()
    });
};
const $c3dac292e323847a$var$messages = (0, $7VHMR.defineMessages)({
    draft: {
        id: 'ptc-directory.profile-page.work-item.draft',
        defaultMessage: 'Draft',
        description: 'A status of Confluence draft page. Draft pages are pages that have not yet been published. This text shows in a lozenge and in work list'
    }
});
var $c3dac292e323847a$export$2e2bcd8739ae039 = $c3dac292e323847a$export$314aaaef607a8c3a;

});
parcelRegister("gkzoY", function(module, exports) {

$parcel$export(module.exports, "getI18nDataForSingleEntry", () => $f1991020dc579d71$export$8d4c96888e68a4cb);
$parcel$export(module.exports, "getI18nDataForManyEntries", () => $f1991020dc579d71$export$a8eeb0c18ec4b955);
$parcel$export(module.exports, "isConfluenceDraft", () => $f1991020dc579d71$export$c73d42331d87b9d8);

var $9JptI = parcelRequire("9JptI");
var $iMVUf = parcelRequire("iMVUf");

var $hIxwC = parcelRequire("hIxwC");
const $f1991020dc579d71$export$493c11ff22f45a24 = (activityDate)=>{
    if ((0, $iMVUf.default)(activityDate)) return 'Yesterday';
    if ((0, $9JptI.default)(activityDate)) return 'Today';
    return 'Time';
};
var $f1991020dc579d71$export$5f5db21fc2e4c897 = /*#__PURE__*/ function(ActivityType) {
    ActivityType["EDITED"] = "Edited";
    ActivityType["COMMENTED"] = "Commented";
    ActivityType["CREATED"] = "Created";
    ActivityType["WORKED"] = "Worked";
    // some new event type from Worklens
    ActivityType["ASSIGNED"] = "Assigned";
    ActivityType["UNASSIGNED"] = "Unassigned";
    ActivityType["LIKED"] = "Liked";
    ActivityType["PUBLISHED"] = "Published";
    ActivityType["UPDATED"] = "Updated";
    return ActivityType;
}({});
const $f1991020dc579d71$export$72f0c8726f4b058c = (activityType)=>{
    const allActivityVerbs = Object.values($f1991020dc579d71$export$5f5db21fc2e4c897);
    const supportedVerb = allActivityVerbs.find((actionType)=>{
        return actionType.toLowerCase() === activityType.toLowerCase();
    });
    return supportedVerb || "Worked";
};
const $f1991020dc579d71$export$8d4c96888e68a4cb = (activityEntry, currentUserId)=>{
    // Due to i18n'ing being a hard problem, there are many possible cases already listed in messages.
    // We'll construct the key rather than list them all here.
    // Key will be of the form: [you|other]Individual[Verb][Today|Yesterday|Time]
    const whoMadeActivity = activityEntry.user && activityEntry.user.id === currentUserId ? 'you' : 'other';
    const activityVerb = $f1991020dc579d71$export$72f0c8726f4b058c(activityEntry.type);
    const activityTime = $f1991020dc579d71$export$493c11ff22f45a24(activityEntry.date ? new Date(activityEntry.date) : new Date());
    const params = {
        name: activityEntry.user.fullName || ''
    };
    if (activityTime === 'Time') params.time = activityEntry.date || undefined;
    return {
        key: (0, $hIxwC.messages)[whoMadeActivity + 'Individual' + activityVerb + activityTime],
        params: params
    };
};
const $f1991020dc579d71$var$I18N_KEYS_VARIATIONS_FOR_MULTIPLE = {
    you: {
        // including "with you" meaning for more than 1 activity
        '2': (0, $hIxwC.messages).youDoubleWorkedOn,
        '3': (0, $hIxwC.messages).youTripleWorkedOn,
        many: (0, $hIxwC.messages).youManyWorkedOn
    },
    others: {
        '2': (0, $hIxwC.messages).othersDoubleWorkedOn,
        '3': (0, $hIxwC.messages).othersTripleWorkedOn,
        many: (0, $hIxwC.messages).othersManyWorkedOn
    }
};
const $f1991020dc579d71$export$a8eeb0c18ec4b955 = (userActivityEntries, currentUser)=>{
    const containsCurrentUser = userActivityEntries.some((activity)=>activity.user.id === currentUser);
    const otherUserFullNames = userActivityEntries.filter((activity)=>activity.user.id !== currentUser).map((activity)=>activity.user.fullName);
    // params that we will pass to our translations
    const othersCount = otherUserFullNames.length - (containsCurrentUser ? 1 : 2);
    const names = {};
    otherUserFullNames.forEach((userFullName, idx)=>{
        // @ts-ignore
        names[`name${idx + 1}`] = userFullName;
    });
    const activitiesCount = userActivityEntries.length;
    const collabAmount = activitiesCount <= 3 ? activitiesCount : 'many';
    const collabType = containsCurrentUser ? 'you' : 'others';
    return {
        // @ts-ignore
        key: $f1991020dc579d71$var$I18N_KEYS_VARIATIONS_FOR_MULTIPLE[collabType][collabAmount],
        params: {
            count: othersCount,
            ...names
        }
    };
};
function $f1991020dc579d71$export$c73d42331d87b9d8(provider, objectUrl) {
    if (!provider || !objectUrl) return false;
    return provider.toLowerCase() === 'confluence' && (objectUrl.includes('draftId=') || objectUrl.includes('draftShareId='));
}

});
parcelRegister("hIxwC", function(module, exports) {

$parcel$export(module.exports, "messages", () => $37753820e93d6f6f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");

var $idqbe = parcelRequire("idqbe");

var $fkLW1 = parcelRequire("fkLW1");

var $w7N29 = parcelRequire("w7N29");

var $8JYuv = parcelRequire("8JYuv");
/**
 * There are a LOT of messages here due to the joys of i18n. They roughly fall into the following categories"
 *  -> Single person that isn't you performed an action (one for each verb and time period combination)
 *  -> Single person that is you performed an action (one for each verb and time period combination)
 *  -> Two people performed an action (one for including you, and one for not including you)
 *  -> Three people performed an action (one for including you, and one for not including you)
 *  -> More than three people performed an action (one for including you, and one for not including you)
 */ const $37753820e93d6f6f$var$otherMsg = (0, $7VHMR.defineMessages)({
    privacyAssuringInfoText: {
        id: 'ptc-directory.work-activity.privacy-assurity',
        defaultMessage: 'Others will only see what they can access.',
        description: "Appears next to a list of recently worked on items on a user\u2019s own profile page. Only appears when viewing yourself. Text assuring the user that private activity items will not appear to others who view this page. Visibility is subject to each individual\u2019s privileges."
    }
});
const $37753820e93d6f6f$export$defe85febe8b728c = {
    ...$37753820e93d6f6f$var$otherMsg,
    ...(0, $idqbe.messages),
    ...(0, $fkLW1.messages),
    ...(0, $8JYuv.messages),
    ...(0, $w7N29.messages)
};

});
parcelRegister("idqbe", function(module, exports) {

$parcel$export(module.exports, "messages", () => $457b76d8588237f8$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $457b76d8588237f8$var$msgForCommented = (0, $7VHMR.defineMessages)({
    otherIndividualCommentedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.commented.today',
        defaultMessage: '{name} commented here today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else commented on the work today."
    },
    otherIndividualCommentedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.commented.yesterday',
        defaultMessage: '{name} commented here yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else commented on the work yesterday."
    },
    otherIndividualCommentedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.commented.time',
        defaultMessage: '{name} commented here on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else commented on the work earlier than yesterday."
    }
});
const $457b76d8588237f8$var$msgForCreated = (0, $7VHMR.defineMessages)({
    otherIndividualCreatedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.created.today',
        defaultMessage: '{name} created this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else created the work today."
    },
    otherIndividualCreatedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.created.yesterday',
        defaultMessage: '{name} created this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else created the work yesterday"
    },
    otherIndividualCreatedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.created.time',
        defaultMessage: '{name} created this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else created the work earlier than yesterday."
    }
});
const $457b76d8588237f8$var$msgForEdited = (0, $7VHMR.defineMessages)({
    otherIndividualEditedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.edited.today',
        defaultMessage: '{name} edited this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else edited the work today"
    },
    otherIndividualEditedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.edited.yesterday',
        defaultMessage: '{name} edited this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else edited the work yesterday"
    },
    otherIndividualEditedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.edited.time',
        defaultMessage: '{name} edited this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else edited the work earlier than yesterday"
    }
});
const $457b76d8588237f8$var$msgForWorked = (0, $7VHMR.defineMessages)({
    otherIndividualWorkedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.worked.today',
        defaultMessage: '{name} worked on this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else performed an unknown operation on the work today"
    },
    otherIndividualWorkedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.worked.yesterday',
        defaultMessage: '{name} worked on this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else performed an unknown operation on the work yesterday"
    },
    otherIndividualWorkedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.worked.time',
        defaultMessage: '{name} worked on this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else performed an unknown operation on the work earlier than yesterday"
    }
});
const $457b76d8588237f8$var$msgForAssigned = (0, $7VHMR.defineMessages)({
    otherIndividualAssignedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.assigned.today',
        defaultMessage: '{name} was assigned this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else assigned the work today"
    },
    otherIndividualAssignedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.assigned.yesterday',
        defaultMessage: '{name} was assigned this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else assigned the work yesterday"
    },
    otherIndividualAssignedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.assigned.time',
        defaultMessage: '{name} was assigned this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else assigned the work earlier than yesterday"
    }
});
const $457b76d8588237f8$var$msgForUnassigned = (0, $7VHMR.defineMessages)({
    otherIndividualUnassignedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.unassigned.today',
        defaultMessage: '{name} was unassigned this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else unassigned the work today"
    },
    otherIndividualUnassignedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.unassigned.yesterday',
        defaultMessage: '{name} was unassigned this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else unassigned the work yesterday"
    },
    otherIndividualUnassignedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.unassigned.time',
        defaultMessage: '{name} was unassigned this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else unassigned the work earlier than yesterday"
    }
});
const $457b76d8588237f8$var$msgForLiked = (0, $7VHMR.defineMessages)({
    otherIndividualLikedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.liked.today',
        defaultMessage: '{name} liked this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else liked the work today"
    },
    otherIndividualLikedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.liked.yesterday',
        defaultMessage: '{name} liked this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else liked the work yesterday"
    },
    otherIndividualLikedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.liked.time',
        defaultMessage: '{name} liked this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else liked the work earlier than yesterday"
    }
});
const $457b76d8588237f8$var$msgForPublished = (0, $7VHMR.defineMessages)({
    otherIndividualPublishedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.published.today',
        defaultMessage: '{name} published this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else published the work today"
    },
    otherIndividualPublishedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.published.yesterday',
        defaultMessage: '{name} published this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else published the work yesterday"
    },
    otherIndividualPublishedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.published.time',
        defaultMessage: '{name} published this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else published the work earlier than yesterday"
    }
});
const $457b76d8588237f8$var$msgForUpdated = (0, $7VHMR.defineMessages)({
    otherIndividualUpdatedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.updated.today',
        defaultMessage: '{name} updated this today',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else updated the work today"
    },
    otherIndividualUpdatedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.updated.yesterday',
        defaultMessage: '{name} updated this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else updated the work yesterday"
    },
    otherIndividualUpdatedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.other.updated.time',
        defaultMessage: '{name} updated this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when somebody else updated the work earlier than yesterday"
    }
});
const $457b76d8588237f8$export$defe85febe8b728c = {
    ...$457b76d8588237f8$var$msgForCommented,
    ...$457b76d8588237f8$var$msgForCreated,
    ...$457b76d8588237f8$var$msgForEdited,
    ...$457b76d8588237f8$var$msgForWorked,
    ...$457b76d8588237f8$var$msgForAssigned,
    ...$457b76d8588237f8$var$msgForUnassigned,
    ...$457b76d8588237f8$var$msgForLiked,
    ...$457b76d8588237f8$var$msgForPublished,
    ...$457b76d8588237f8$var$msgForUpdated
};

});

parcelRegister("fkLW1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $72439bbf142822b6$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $72439bbf142822b6$var$msgForWorked = (0, $7VHMR.defineMessages)({
    youIndividualWorkedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.worked.today',
        defaultMessage: 'You worked on this today',
        description: "This message appears in work list area of the user profile pageand indicate when you performed an unknown operation on the work today"
    },
    youIndividualWorkedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.worked.yesterday',
        defaultMessage: 'You worked on this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when you performed an unknown operation on the work yesterday"
    },
    youIndividualWorkedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.worked.time',
        defaultMessage: 'You worked on this {time}',
        description: "This message appears in work list area of the user profile pageand indicate when you performed an unknown operation on the work earlier than yesterday"
    }
});
const $72439bbf142822b6$var$msgForCommented = (0, $7VHMR.defineMessages)({
    youIndividualCommentedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.commented.today',
        defaultMessage: 'You commented here today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user commented on the work today"
    },
    youIndividualCommentedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.commented.yesterday',
        defaultMessage: 'You commented here yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user commented on the work yesterday"
    },
    youIndividualCommentedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.commented.time',
        defaultMessage: 'You commented here on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user commented on the work earlier than yesterday"
    }
});
const $72439bbf142822b6$var$msgForCreated = (0, $7VHMR.defineMessages)({
    youIndividualCreatedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.created.today',
        defaultMessage: 'You created this today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user created the work today"
    },
    youIndividualCreatedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.created.yesterday',
        defaultMessage: 'You created this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user created the work yesterday"
    },
    youIndividualCreatedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.created.time',
        defaultMessage: 'You created this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user created the work earlier than yesterday"
    }
});
const $72439bbf142822b6$var$msgForEdited = (0, $7VHMR.defineMessages)({
    youIndividualEditedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.edited.today',
        defaultMessage: 'You edited this today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user edited the work today"
    },
    youIndividualEditedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.edited.yesterday',
        defaultMessage: 'You edited this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user edited the work yesterday"
    },
    youIndividualEditedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.edited.time',
        defaultMessage: 'You edited this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user edited the work earlier than yesterday"
    }
});
const $72439bbf142822b6$var$msgForAssigned = (0, $7VHMR.defineMessages)({
    youIndividualAssignedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.assigned.today',
        defaultMessage: 'You were assigned this today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work today"
    },
    youIndividualAssignedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.assigned.yesterday',
        defaultMessage: 'You were assigned this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work yesterday"
    },
    youIndividualAssignedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.assigned.time',
        defaultMessage: 'You were assigned this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work earlier than yesterday"
    }
});
const $72439bbf142822b6$var$msgForUnassigned = (0, $7VHMR.defineMessages)({
    youIndividualUnassignedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.unassigned.today',
        defaultMessage: 'You were unassigned this today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is unassigned the work today"
    },
    youIndividualUnassignedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.unassigned.yesterday',
        defaultMessage: 'You were unassigned this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work yesterday"
    },
    youIndividualUnassignedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.unassigned.time',
        defaultMessage: 'You were unassigned this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is unassigned the work earlier than yesterday"
    }
});
const $72439bbf142822b6$var$msgForLiked = (0, $7VHMR.defineMessages)({
    youIndividualLikedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.liked.today',
        defaultMessage: 'You liked this today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user liked the work today"
    },
    youIndividualLikedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.liked.yesterday',
        defaultMessage: 'You liked this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work yesterday"
    },
    youIndividualLikedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.liked.time',
        defaultMessage: 'You liked this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user liked the work earlier than yesterday"
    }
});
const $72439bbf142822b6$var$msgForPublished = (0, $7VHMR.defineMessages)({
    youIndividualPublishedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.published.today',
        defaultMessage: 'You published this today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user published the work today"
    },
    youIndividualPublishedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.published.yesterday',
        defaultMessage: 'You published this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work yesterday"
    },
    youIndividualPublishedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.published.time',
        defaultMessage: 'You published this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user published the work earlier than yesterday"
    }
});
const $72439bbf142822b6$var$msgForUpdated = (0, $7VHMR.defineMessages)({
    youIndividualUpdatedToday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.updated.today',
        defaultMessage: 'You updated this today',
        description: "This message appears in work list area of the user profile pageand indicate when the current user updated the work today"
    },
    youIndividualUpdatedYesterday: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.updated.yesterday',
        defaultMessage: 'You updated this yesterday',
        description: "This message appears in work list area of the user profile pageand indicate when the current user is assigned the work yesterday"
    },
    youIndividualUpdatedTime: {
        id: 'ptc-directory.team-profile-page.team-work.individual.you.updated.time',
        defaultMessage: 'You updated this on {time}',
        description: "This message appears in work list area of the user profile pageand indicate when the current user updated the work earlier than yesterday"
    }
});
const $72439bbf142822b6$export$defe85febe8b728c = {
    ...$72439bbf142822b6$var$msgForWorked,
    ...$72439bbf142822b6$var$msgForCommented,
    ...$72439bbf142822b6$var$msgForCreated,
    ...$72439bbf142822b6$var$msgForEdited,
    ...$72439bbf142822b6$var$msgForAssigned,
    ...$72439bbf142822b6$var$msgForUnassigned,
    ...$72439bbf142822b6$var$msgForLiked,
    ...$72439bbf142822b6$var$msgForPublished,
    ...$72439bbf142822b6$var$msgForUpdated
};

});

parcelRegister("w7N29", function(module, exports) {

$parcel$export(module.exports, "messages", () => $493b6d4a76da7677$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $493b6d4a76da7677$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    othersManyWorkedOn: {
        id: 'ptc-directory.team-profile-page.team-work.many.others.worked',
        defaultMessage: '{name1}, {name2}, and {count} others have all worked on this',
        description: "This message appears in work list area of the user profile pageand indicate when more than three users that arent you worked on an object"
    },
    youManyWorkedOn: {
        id: 'ptc-directory.team-profile-page.team-work.many.you.worked',
        defaultMessage: 'You, {name1}, and {count} others have all worked on this',
        description: "This message appears in work list area of the user profile pageand indicate when more than three users including the current user worked on an object"
    }
});

});

parcelRegister("8JYuv", function(module, exports) {

$parcel$export(module.exports, "messages", () => $218181450e21b92d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $218181450e21b92d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    othersDoubleWorkedOn: {
        id: 'ptc-directory.team-profile-page.team-work.double.others.worked',
        defaultMessage: '{name1} and {name2} have both worked on this',
        description: "This message appears in work list area of the user profile pageand indicate when two users that arent you worked on an object"
    },
    youDoubleWorkedOn: {
        id: 'ptc-directory.team-profile-page.team-work.double.you.worked',
        defaultMessage: 'You and {name1} have both worked on this',
        description: "This message appears in work list area of the user profile pageand indicate when two users including the current user worked on an object"
    },
    // Messages for three people
    othersTripleWorkedOn: {
        id: 'ptc-directory.team-profile-page.team-work.triple.others.worked',
        defaultMessage: '{name1}, {name2}, and {name3} have all worked on this',
        description: "This message appears in work list area of the user profile pageand indicate when three users that arent you worked on an object"
    },
    youTripleWorkedOn: {
        id: 'ptc-directory.team-profile-page.team-work.triple.you.worked',
        defaultMessage: 'You, {name1}, and {name2} have all worked on this',
        description: "This message appears in work list area of the user profile pageand indicate when three users including the current user worked on an object"
    }
});

});



parcelRegister("inVGG", function(module, exports) {

$parcel$export(module.exports, "WorkItemLink", () => $8f3f4b6491778510$export$337f3677fd9cf9c1);
$parcel$export(module.exports, "Content", () => $8f3f4b6491778510$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "ContentIcon", () => $8f3f4b6491778510$export$a1ea799cb5c1b499);
$parcel$export(module.exports, "Details", () => $8f3f4b6491778510$export$3e8048d3cf2ba3fd);
$parcel$export(module.exports, "DetailsHeadline", () => $8f3f4b6491778510$export$505f19144b08f91a);
$parcel$export(module.exports, "DetailsDescription", () => $8f3f4b6491778510$export$6ac35bf2875b1dd9);
$parcel$export(module.exports, "ContainerName", () => $8f3f4b6491778510$export$b7e45c2cd09f088a);
$parcel$export(module.exports, "Description", () => $8f3f4b6491778510$export$393edc798c47379d);
$parcel$export(module.exports, "LozengeWrapper", () => $8f3f4b6491778510$export$75180efdd3f4d9c2);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");


var $5CtC2 = parcelRequire("5CtC2");
const $8f3f4b6491778510$export$337f3677fd9cf9c1 = /*#__PURE__*/ (0, $47bDC.default)((0, $5CtC2.default)).withConfig({
    componentId: "sc-1brh7h6-0"
})`position:relative;margin:0;overflow:hidden;display:block;padding-left:${"var(--ds-space-150, 12px)"};padding-right:${"var(--ds-space-150, 12px)"};border-radius:${"var(--ds-border-radius-100, 3px)"};&:hover{background:${`var(--ds-background-neutral-subtle-hovered, ${(0, $a7f8c6b391092279$export$e655ef011c4aa1a2)})`};}&:focus{outline:0;box-shadow:0 0 0 2px ${`var(--ds-border-focused, ${(0, $a7f8c6b391092279$export$ecfc1dff386a3e7a)})`};}& + &{margin:${"var(--ds-space-050, 4px)"} 0 0 0;}`;
const $8f3f4b6491778510$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1brh7h6-1"
})`display:flex;`;
const $8f3f4b6491778510$export$a1ea799cb5c1b499 = /*#__PURE__*/ (0, $47bDC.default).img.withConfig({
    componentId: "sc-1brh7h6-2"
})`border-radius:${"var(--ds-border-radius-100, 3px)"};display:flex;flex-shrink:0;width:${"var(--ds-space-300, 24px)"};height:${"var(--ds-space-300, 24px)"};margin-top:${"var(--ds-space-100, 8px)"};margin-bottom:${"var(--ds-space-100, 8px)"};`;
const $8f3f4b6491778510$export$3e8048d3cf2ba3fd = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1brh7h6-3"
})`display:flex;flex-direction:column;margin-left:${"var(--ds-space-200, 16px)"};justify-content:center;min-width:0;`;
const $8f3f4b6491778510$export$505f19144b08f91a = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1brh7h6-4"
})`padding-right:${"var(--ds-space-150, 12px)"};padding-bottom:${"var(--ds-space-025, 2px)"};display:flex;align-items:center;p{display:inline-block;font:${"var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin:0;color:${`var(--ds-text, ${(0, $a7f8c6b391092279$export$7d61b15e0da132af)})`};overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}`;
const $8f3f4b6491778510$export$6ac35bf2875b1dd9 = /*#__PURE__*/ (0, $47bDC.default).p.withConfig({
    componentId: "sc-1brh7h6-5"
})`font:${"var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};color:${`var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$7c87d337fb91a97d)})`};margin:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding-right:${"var(--ds-space-150, 12px)"};`;
const $8f3f4b6491778510$export$b7e45c2cd09f088a = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "sc-1brh7h6-6"
})`&:after{content:'\\00B7';padding-right:${"var(--ds-space-050, 4px)"};padding-left:${"var(--ds-space-050, 4px)"};}`;
const $8f3f4b6491778510$export$393edc798c47379d = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "sc-1brh7h6-7"
})``;
const $8f3f4b6491778510$export$75180efdd3f4d9c2 = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "sc-1brh7h6-8"
})`margin-left:${"var(--ds-space-050, 4px)"};`;

});


parcelRegister("7Jefy", function(module, exports) {

$parcel$export(module.exports, "HeaderLink", () => $efdb5a1a32dd522e$export$29c3409e43add430);
$parcel$export(module.exports, "FooterLink", () => $efdb5a1a32dd522e$export$e0513c91be1318ca);
$parcel$export(module.exports, "WorkListInfoText", () => $efdb5a1a32dd522e$export$fff90b174811109c);
$parcel$export(module.exports, "WorkListItems", () => $efdb5a1a32dd522e$export$3af7e1e011c8bee1);
$parcel$export(module.exports, "SkeletonWrapper", () => $efdb5a1a32dd522e$export$6069cbe61f690103);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");


var $34mB5 = parcelRequire("34mB5");
const $efdb5a1a32dd522e$export$29c3409e43add430 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-12dsuy4-0"
})`margin-left:${"var(--ds-space-300, 24px)"};`;
const $efdb5a1a32dd522e$export$e0513c91be1318ca = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-12dsuy4-1"
})`font-size:${"var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin-left:${"var(--ds-space-150, 12px)"};margin-top:${"var(--ds-space-200, 16px)"};display:flex;color:${`var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$7c87d337fb91a97d)})`};`;
const $efdb5a1a32dd522e$export$fff90b174811109c = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-12dsuy4-2"
})`display:flex;align-items:center;width:100%;${(0, $34mB5.smallTextTypography)};`;
const $efdb5a1a32dd522e$export$3af7e1e011c8bee1 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-12dsuy4-3"
})`border-radius:${"var(--ds-border-radius-100, 3px)"};background-color:${"var(--ds-surface-raised, transparent)"};box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $a7f8c6b391092279$export$7d3359664e8bb0e5)}, 0 0 1px 1px ${(0, $a7f8c6b391092279$export$46987b49aab6d1a8)}`})`};padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-100, 8px)"};${$efdb5a1a32dd522e$export$fff90b174811109c} + &{margin-top:${"var(--ds-space-200, 16px)"};}`;
const $efdb5a1a32dd522e$export$7fd31be4a556b1a0 = /*#__PURE__*/ (0, $47bDC.default).img.withConfig({
    componentId: "sc-12dsuy4-4"
})`height:${144}px;`;
const $efdb5a1a32dd522e$export$475f8a59614a59ca = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-12dsuy4-5"
})`margin-left:${"var(--ds-space-400, 32px)"};min-width:180px;`;
const $efdb5a1a32dd522e$export$a4f85c7f5a5731ac = /*#__PURE__*/ (0, $47bDC.default).h3.withConfig({
    componentId: "sc-12dsuy4-6"
})`margin-bottom:${"var(--ds-space-200, 16px)"};`;
const $efdb5a1a32dd522e$export$cb03cebe08ab9b6a = /*#__PURE__*/ (0, $47bDC.default).p.withConfig({
    componentId: "sc-12dsuy4-7"
})``;
const $efdb5a1a32dd522e$export$6069cbe61f690103 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-12dsuy4-8"
})`& + &{margin:${"var(--ds-space-050, 4px)"} 0 0 0;}`;

});
parcelRegister("34mB5", function(module, exports) {

$parcel$export(module.exports, "ellipsis", () => $3453516b05821010$export$a5b94313d6908893);
$parcel$export(module.exports, "twoLineEllipsis", () => $3453516b05821010$export$e6fc941710bd9bc7);
$parcel$export(module.exports, "ellipsisInFlexChild", () => $3453516b05821010$export$58ca30256a534b20);
$parcel$export(module.exports, "smallTextTypography", () => $3453516b05821010$export$64de456cd1a0ab3f);
$parcel$export(module.exports, "linkShadowItem", () => $3453516b05821010$export$37da6d213fb80270);
$parcel$export(module.exports, "MultilineEllipsis", () => $3453516b05821010$export$7252344cf484ff6d);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ 

var $47bDC = parcelRequire("47bDC");

var $jvpqd = parcelRequire("jvpqd");
const $3453516b05821010$export$a5b94313d6908893 = `
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
const $3453516b05821010$export$e6fc941710bd9bc7 = `
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const $3453516b05821010$export$58ca30256a534b20 = /*#__PURE__*/ (0, $47bDC.css)`min-width:0;${$3453516b05821010$export$a5b94313d6908893};`;
const $3453516b05821010$export$2c2e9c688ff3eaac = /*#__PURE__*/ (0, $47bDC.css)`font:${"var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};font-weight:${"var(--ds-font-weight-regular, 400)"};color:${`var(--ds-text, ${(0, $a7f8c6b391092279$export$7d61b15e0da132af)})`};`;
const $3453516b05821010$export$64de456cd1a0ab3f = /*#__PURE__*/ (0, $47bDC.css)`color:${`var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$f563ee71e9ee74cd)})`};font:${"var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};`;
const $3453516b05821010$export$37da6d213fb80270 = /*#__PURE__*/ (0, $47bDC.css)`background:${`var(--ds-surface-raised, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`};border-radius:${"var(--ds-border-radius-100, 3px)"};transition:box-shadow 0.25s ease;box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $a7f8c6b391092279$export$7d3359664e8bb0e5)}, 0 0 1px 1px ${(0, $a7f8c6b391092279$export$46987b49aab6d1a8)}`})`};&:hover,&.active{box-shadow:${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $a7f8c6b391092279$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $a7f8c6b391092279$export$d2d3bedfb276cac0)}`})`};}`;
const $3453516b05821010$export$7252344cf484ff6d = (maxLines = 1, lineHeight = (0, $jvpqd.rootAbsoluteLineHeight))=>(0, $47bDC.css)`overflow:hidden;-webkit-line-clamp:${maxLines};-webkit-box-orient:vertical;display:-webkit-box;text-overflow:ellipsis;max-height:${maxLines * lineHeight}px;`;

});
parcelRegister("jvpqd", function(module, exports) {

$parcel$export(module.exports, "rootAbsoluteLineHeight", () => $526dd0ec9554145d$export$914d38d0b781a6d3);
$parcel$export(module.exports, "getGlobalTheme", () => $526dd0ec9554145d$export$813ecdf77207a053);
const $526dd0ec9554145d$export$3abda77ebd0bb50f = 1.42857143;
const $526dd0ec9554145d$export$a22cfca5dbca7fb5 = 14;
const $526dd0ec9554145d$export$914d38d0b781a6d3 = $526dd0ec9554145d$export$3abda77ebd0bb50f * $526dd0ec9554145d$export$a22cfca5dbca7fb5;
const $526dd0ec9554145d$export$813ecdf77207a053 = ()=>{
    // Determine global theme
    const documentElement = document.documentElement;
    const rawTheme = documentElement.getAttribute('data-theme');
    return rawTheme === 'dark' ? 'dark' : 'light';
};

});








parcelRegister("jpaA4", function(module, exports) {

$parcel$export(module.exports, "AgentAboutPanel", () => $974158b7e780073d$export$a9a242371bd64127);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $92vDh = parcelRequire("92vDh");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");
var $bEIgH = parcelRequire("bEIgH");
var $2s57o = parcelRequire("2s57o");

var $aT0vF = parcelRequire("aT0vF");
var $2ff3W = parcelRequire("2ff3W");
var $gIlbd = parcelRequire("gIlbd");
var $6wjyA = parcelRequire("6wjyA");

var $cprXC = parcelRequire("cprXC");

var $9OeO9 = parcelRequire("9OeO9");

var $bEYMY = parcelRequire("bEYMY");
const $974158b7e780073d$var$agentAboutPanelStyles = (0, $2s57o.xcss)({
    boxShadow: 'elevation.shadow.raised',
    borderRadius: '6px',
    padding: 'space.300',
    display: 'flex',
    flexDirection: 'column'
});
const $974158b7e780073d$var$headingStyles = (0, $2s57o.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    font: 'font.heading.xxsmall'
});
const $974158b7e780073d$var$AbouSectionHeaders = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
        xcss: $974158b7e780073d$var$headingStyles,
        children: children
    });
const $974158b7e780073d$export$eceb80593c9ade2e = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $bEIgH.default), {
        xcss: $974158b7e780073d$var$agentAboutPanelStyles,
        space: "space.300",
        children: children
    });
const $974158b7e780073d$export$a9a242371bd64127 = ({ agent: agent, assistanceServiceParams: assistanceServiceParams })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const agentIdentityId = (0, $9OeO9.trimUserARI)(agent?.identity_account_id || '');
    const { getKnowledgeProductsRenderForAgent: getKnowledgeProductsRenderForAgent } = (0, $6wjyA.useKnowledgeProductsRender)({
        assistanceServiceParams: assistanceServiceParams
    });
    const isForgeAgent = agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)($974158b7e780073d$export$eceb80593c9ade2e, {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bEIgH.default), {
                    space: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)($974158b7e780073d$var$AbouSectionHeaders, {
                            children: formatMessage($974158b7e780073d$var$messages.aboutLabel)
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2Eqc8.default), {
                            space: "space.100",
                            alignBlock: "center",
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($92vDh))), {
                                    label: "",
                                    color: "currentColor"
                                }),
                                formatMessage($974158b7e780073d$var$messages.rovoAgentLabel)
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bEIgH.default), {
                    space: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)($974158b7e780073d$var$AbouSectionHeaders, {
                            children: formatMessage($974158b7e780073d$var$messages.knowledgeLabel)
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ff3W.AgentKnowledgeSection), {
                            aris: (0, $gIlbd.getEnabledKnowlegeArisFromAgent)(agent),
                            isForgeAgent: isForgeAgent,
                            knowledgeProductsRender: getKnowledgeProductsRenderForAgent({
                                sources: agent.knowledge_sources?.sources ?? [],
                                // TODO fill this with the correct value
                                cloudUrl: undefined,
                                knowledgeScopeEnabled: agent.knowledge_sources?.enabled ?? false
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bEIgH.default), {
                    space: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)($974158b7e780073d$var$AbouSectionHeaders, {
                            children: formatMessage($974158b7e780073d$var$messages.actionLabel)
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aT0vF.ActionsSection), {
                            actions: agent.action_config || []
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bEIgH.default), {
                    space: "space.100",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bEYMY.default), {
                        userId: agentIdentityId,
                        isActiveUser: !agent.deactivated,
                        userFullName: agent.name,
                        analyticsSource: (0, $cprXC.AnalyticsEventSource).USER_PROFILE_SCREEN
                    })
                })
            ]
        })
    });
};
const $974158b7e780073d$var$messages = (0, $7VHMR.defineMessages)({
    aboutLabel: {
        id: 'ptc-directory.agent-profile.about-agent.about-label',
        defaultMessage: 'About',
        description: 'Label for about section of the agent'
    },
    rovoAgentLabel: {
        id: 'ptc-directory.agent-profile.about-agent.rovo-agent-label',
        defaultMessage: 'Rovo Agent',
        description: 'The content inside About section, indicating this profile is a Rovo Agent'
    },
    knowledgeLabel: {
        id: 'ptc-directory.agent-profile.about-agent.knowledge-label',
        defaultMessage: 'Knowledge',
        description: 'Label for knowledge section of the agent'
    },
    actionLabel: {
        id: 'ptc-directory.agent-profile.about-agent.action-label',
        defaultMessage: 'Actions',
        description: 'Label for action section of the agent'
    },
    teamsLabel: {
        id: 'ptc-directory.agent-profile.about-agent.teams-label',
        defaultMessage: 'Teams',
        description: 'Label for teams section of the agent'
    },
    createTeamLabel: {
        id: 'ptc-directory.agent-profile.about-agent.teams-label',
        defaultMessage: 'Create a team together',
        description: 'Label for teams section of the agent'
    }
});

});
parcelRegister("92vDh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e2b10cb2fb36d0ad7bfa02e0b0408651>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $694cd68550180943$var$_react = $694cd68550180943$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $694cd68550180943$var$_baseNew = $694cd68550180943$var$_interopRequireDefault((parcelRequire("enEmH")));
function $694cd68550180943$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Briefcase".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Job title in Atlas, Operations in JSM.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $694cd68550180943$var$BriefcaseIcon = (props)=>/*#__PURE__*/ $694cd68550180943$var$_react.default.createElement($694cd68550180943$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 2.5a.5.5 0 0 0-.5.5v1h5V3a.5.5 0 0 0-.5-.5zM12 4V3a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v1H3a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM3 5.5a.5.5 0 0 0-.5.5v2h11V6a.5.5 0 0 0-.5-.5zm10.5 4H8.75V11h-1.5V9.5H2.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$694cd68550180943$var$BriefcaseIcon.displayName = 'BriefcaseIcon';
var $694cd68550180943$var$_default = module.exports.default = $694cd68550180943$var$BriefcaseIcon;

});

parcelRegister("aT0vF", function(module, exports) {

$parcel$export(module.exports, "ActionsSection", () => $a548167308e3df3f$export$62272bfa980718f8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $gOkqF = parcelRequire("gOkqF");
var $k9nuy = parcelRequire("k9nuy");

var $dUMeW = parcelRequire("dUMeW");

var $hWJ9c = parcelRequire("hWJ9c");
const $a548167308e3df3f$export$62272bfa980718f8 = ({ actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!actions.length) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
        children: formatMessage((0, $hWJ9c.default).noActions)
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gOkqF.default), {
        space: "space.050",
        children: actions.map((action)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dUMeW.AgentActionPill), {
                action: action
            }, action.id))
    });
};

});
parcelRegister("dUMeW", function(module, exports) {

$parcel$export(module.exports, "AgentActionPill", () => $03bc8b002becefea$export$af13476fcb733bb1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $eOat1 = parcelRequire("eOat1");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $k9nuy = parcelRequire("k9nuy");

var $aemyv = parcelRequire("aemyv");

var $kQ3hT = parcelRequire("kQ3hT");
const $03bc8b002becefea$var$styles = {
    wrapper: "_2rkoga04 _189ee4h9 _1dqonqa1 _1h6dmuej _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1ns9",
    pillIcon: "_2rkoga04 _1bsbgktf _4t3igktf _1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $03bc8b002becefea$export$af13476fcb733bb1 = ({ action: { name: name, id: id, tags: tags } })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
        xcss: $03bc8b002becefea$var$styles.wrapper,
        space: "space.050",
        alignBlock: "center",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                xcss: $03bc8b002becefea$var$styles.pillIcon,
                backgroundColor: "color.background.brand.subtlest",
                children: (0, $aemyv.getAgentActionIcon)(id)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $k9nuy.default), {
                children: [
                    name,
                    ' ',
                    tags.includes('beta') && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eOat1.default), {
                        appearance: "new",
                        children: formatMessage((0, $kQ3hT.default).betaTag)
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("aemyv", function(module, exports) {

$parcel$export(module.exports, "getAgentActionIcon", () => $f80fe35ad29ea9dc$export$8dc132872471a5e1);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $46OkO = parcelRequire("46OkO");

var $8xUwj = parcelRequire("8xUwj");

var $dRA2M = parcelRequire("dRA2M");

var $bGsST = parcelRequire("bGsST");

var $084bx = parcelRequire("084bx");

var $4HiZI = parcelRequire("4HiZI");

var $3cwUp = parcelRequire("3cwUp");

var $gIm6W = parcelRequire("gIm6W");

var $6E7rM = parcelRequire("6E7rM");

var $ia3Jy = parcelRequire("ia3Jy");
const $f80fe35ad29ea9dc$export$8dc132872471a5e1 = (actionKey)=>{
    switch(actionKey){
        case 'agent_action_jira_issue_create':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($46OkO))), {
                label: "",
                color: "var(--ds-icon-brand)"
            });
        case 'agent_action_confluence_page_create':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4HiZI))), {
                label: "",
                color: "var(--ds-icon-brand)"
            });
        case 'agent_action_jira_issue_comment':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dRA2M))), {
                label: "",
                color: "var(--ds-icon-brand)"
            });
        case 'agent_action_confluence_page_comment':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dRA2M))), {
                label: "",
                color: "var(--ds-icon-brand)"
            });
        case 'agent_action_jira_issue_move':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gIm6W))), {
                label: "",
                color: "var(--ds-icon-brand)"
            });
        case 'agent_action_jira_issue_delete':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bGsST))), {
                label: "",
                color: "var(--ds-icon-brand)"
            });
        case 'agent_action_jira_issue_assign':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3cwUp))), {
                label: "",
                color: "var(--ds-icon-brand)"
            });
        case 'agent_action_jira_issue_edit':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($084bx))), {
                label: "",
                color: "var(--ds-icon-brand)"
            });
        case 'agent_action_jira_issue_transition':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6E7rM))), {
                label: "",
                color: "var(--ds-icon-brand)"
            });
        case 'agent_action_jira_epics_suggest':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ia3Jy))), {
                label: "",
                color: "var(--ds-icon-brand)"
            });
        default:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8xUwj))), {
                label: "",
                color: "var(--ds-icon-brand)"
            });
    }
};

});
parcelRegister("8xUwj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $638d3f8186876248$var$_react = $638d3f8186876248$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $638d3f8186876248$var$_baseNew = $638d3f8186876248$var$_interopRequireDefault((parcelRequire("enEmH")));
function $638d3f8186876248$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $638d3f8186876248$var$AutomationIcon = (props)=>/*#__PURE__*/ $638d3f8186876248$var$_react.default.createElement($638d3f8186876248$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$638d3f8186876248$var$AutomationIcon.displayName = 'AutomationIcon';
var $638d3f8186876248$var$_default = module.exports.default = $638d3f8186876248$var$AutomationIcon;

});

parcelRegister("dRA2M", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a17c2f21c8f8c840$var$_react = $a17c2f21c8f8c840$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a17c2f21c8f8c840$var$_baseNew = $a17c2f21c8f8c840$var$_interopRequireDefault((parcelRequire("enEmH")));
function $a17c2f21c8f8c840$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a17c2f21c8f8c840$var$CommentIcon = (props)=>/*#__PURE__*/ $a17c2f21c8f8c840$var$_react.default.createElement($a17c2f21c8f8c840$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$a17c2f21c8f8c840$var$CommentIcon.displayName = 'CommentIcon';
var $a17c2f21c8f8c840$var$_default = module.exports.default = $a17c2f21c8f8c840$var$CommentIcon;

});

parcelRegister("6E7rM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b20915105f9f06f3ef89ee9497af0ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4d6c415062518447$var$_react = $4d6c415062518447$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4d6c415062518447$var$_baseNew = $4d6c415062518447$var$_interopRequireDefault((parcelRequire("enEmH")));
function $4d6c415062518447$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Transition".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for transitions in Analytics.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4d6c415062518447$var$TransitionIcon = (props)=>/*#__PURE__*/ $4d6c415062518447$var$_react.default.createElement($4d6c415062518447$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.75 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.122 0a2.251 2.251 0 1 1 0 1.5h-.816c-.586 0-1.062.476-1.062 1.063v5.875A2.563 2.563 0 0 1 6.188 13.5h-.816a2.25 2.25 0 1 1 0-1.5h.816c.586 0 1.062-.476 1.062-1.062V5.062A2.56 2.56 0 0 1 9.813 2.5zM3.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$4d6c415062518447$var$TransitionIcon.displayName = 'TransitionIcon';
var $4d6c415062518447$var$_default = module.exports.default = $4d6c415062518447$var$TransitionIcon;

});

parcelRegister("ia3Jy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ad24cecf3159849c56dfb3b17e77c4ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d38c0e9da79225b7$var$_react = $d38c0e9da79225b7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d38c0e9da79225b7$var$_baseNew = $d38c0e9da79225b7$var$_interopRequireDefault((parcelRequire("enEmH")));
function $d38c0e9da79225b7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItem".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d38c0e9da79225b7$var$WorkItemIcon = (props)=>/*#__PURE__*/ $d38c0e9da79225b7$var$_react.default.createElement($d38c0e9da79225b7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zm8.426 1.517 1.148.966-4 4.75a.75.75 0 0 1-1.148 0l-2-2.375 1.148-.966L7 9.086z" clip-rule="evenodd"/>`
    }, props));
$d38c0e9da79225b7$var$WorkItemIcon.displayName = 'WorkItemIcon';
var $d38c0e9da79225b7$var$_default = module.exports.default = $d38c0e9da79225b7$var$WorkItemIcon;

});


parcelRegister("kQ3hT", function(module, exports) {

$parcel$export(module.exports, "default", () => $727cd7e8b25fc8dd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $727cd7e8b25fc8dd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    betaTag: {
        id: 'rovo-chat.view-agent.beta-tag',
        defaultMessage: 'Beta',
        description: 'Tag to display for beta actions'
    }
});

});


parcelRegister("hWJ9c", function(module, exports) {

$parcel$export(module.exports, "default", () => $d83d890bb33b96c0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d83d890bb33b96c0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noActions: {
        id: 'rovo-chat.view-agent.no-actions',
        defaultMessage: 'No actions',
        description: 'Text to display when there are no actions for the agent'
    }
});

});


parcelRegister("2ff3W", function(module, exports) {

$parcel$export(module.exports, "AgentKnowledgeSection", () => $4d38d239d053a822$export$b1c40600d1679d39);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $gKZoD = parcelRequire("gKZoD");

var $k01Ou = parcelRequire("k01Ou");

var $f108J = parcelRequire("f108J");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");
var $bEIgH = parcelRequire("bEIgH");
var $6eFvr = parcelRequire("6eFvr");

var $4CMbn = parcelRequire("4CMbn");

var $gIdoN = parcelRequire("gIdoN");

var $1xmyx = parcelRequire("1xmyx");

var $aDGjB = parcelRequire("aDGjB");

var $9cRy7 = parcelRequire("9cRy7");

var $gcD1g = parcelRequire("gcD1g");
const $4d38d239d053a822$export$b1c40600d1679d39 = ({ aris: aris, isForgeAgent: isForgeAgent, knowledgeProductsRender: knowledgeProductsRender })=>{
    (0, $gKZoD.di)((0, $9cRy7.useKnowledgeFilterService));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getEntitiesByAris: getEntitiesByAris } = (0, $9cRy7.useKnowledgeFilterService)();
    const { isFetching: isFetching, data: urls } = (0, $1xmyx.useQuery)({
        queryKey: [
            'getEntitiesByAris'
        ].concat(aris || []),
        queryFn: async ()=>{
            if (!aris?.length) return [];
            const entities = await getEntitiesByAris({
                aris: aris
            });
            const links = entities.map((entity)=>entity.url);
            return links;
        },
        enabled: !isForgeAgent
    });
    const getKnowledgeRender = ()=>{
        if (isForgeAgent) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2Eqc8.default), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k01Ou))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bEIgH.default), {
                    space: "space.100",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6eFvr.default), {
                        size: "small",
                        children: formatMessage((0, $gcD1g.default).forgeKnowledgeDescription)
                    })
                })
            ]
        });
        if (!urls?.length && !knowledgeProductsRender && !isFetching) return formatMessage((0, $gcD1g.default).noKnowledgeAdded);
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bEIgH.default), {
            space: "space.050",
            children: [
                isFetching ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4CMbn.default), {
                            height: 22,
                            width: 200,
                            borderRadius: 8,
                            isShimmering: true
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4CMbn.default), {
                            height: 22,
                            width: 150,
                            borderRadius: 8,
                            isShimmering: true
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4CMbn.default), {
                            height: 22,
                            width: 200,
                            borderRadius: 8,
                            isShimmering: true
                        })
                    ]
                }) : urls?.map((url)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $gIdoN.Card), {
                        fallbackComponent: (0, $aDGjB.smartLinkFallback)(url),
                        appearance: "inline",
                        url: url
                    }, url)),
                knowledgeProductsRender
            ]
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f108J.SmartCardProvider), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
            testId: "view-agent-knowledge-cards",
            children: getKnowledgeRender()
        })
    });
};

});
parcelRegister("f108J", function(module, exports) {

$parcel$export(module.exports, "SmartCardProvider", () => $11baf0e5373e6d01$export$497ecb0280204df4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3f2cs = parcelRequire("3f2cs");

var $6YE6Y = parcelRequire("6YE6Y");

var $4IX2E = parcelRequire("4IX2E");

var $3E7XJ = parcelRequire("3E7XJ");

var $2yoyZ = parcelRequire("2yoyZ");

var $eSRMC = parcelRequire("eSRMC");
function $11baf0e5373e6d01$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product, shouldControlDataExport: shouldControlDataExport }) {
    const parentContext = (0, $5uXOq.useContext)((0, $2yoyZ.SmartCardContext));
    const defaultInitialState = (0, $5uXOq.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $5uXOq.useMemo)(()=>{
        return (0, $3f2cs.createStore)((0, $3E7XJ.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $5uXOq.useMemo)(()=>{
        const client = customClient || new (0, $eSRMC.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, platform)=>{
            const cardState = (0, $6YE6Y.getUrl)(store, url);
            return cardState.details ? (0, $4IX2E.extractPreview)(cardState.details.data, platform) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            featureFlags: featureFlags,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product,
            shouldControlDataExport: shouldControlDataExport
        };
    }, [
        customClient,
        customAuthFlow,
        isAdminHubAIEnabled,
        product,
        shouldControlDataExport,
        renderers,
        featureFlags,
        store
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2yoyZ.SmartCardContext).Provider, {
        value: parentContext || providerValue,
        children: children
    });
}
var $11baf0e5373e6d01$export$2e2bcd8739ae039 = $11baf0e5373e6d01$export$497ecb0280204df4;

});
parcelRegister("6YE6Y", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $71e9ff98b9e42922$export$94df0e59ebebf4a7);
const $71e9ff98b9e42922$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("4IX2E", function(module, exports) {

$parcel$export(module.exports, "extractPreview", () => $034cf706ba227639$export$4b0d98b1b7f6d115);

var $6tM06 = parcelRequire("6tM06");

var $1xvQk = parcelRequire("1xvQk");
const $034cf706ba227639$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $6tM06.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $1xvQk.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $1xvQk.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
};

});
parcelRegister("6tM06", function(module, exports) {

$parcel$export(module.exports, "extractPlatformIsSupported", () => $2c6087f807adf4d9$export$3e8ad908070b68b2);
const $2c6087f807adf4d9$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});

parcelRegister("1xvQk", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $20895549354ca12f$export$396ba4ef2e37dc65);
const $20895549354ca12f$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $20895549354ca12f$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
};

});


parcelRegister("3E7XJ", function(module, exports) {

$parcel$export(module.exports, "cardReducer", () => $2cbdf7ee2b1ff27e$export$3c7c3113a97b6492);

var $e74wd = parcelRequire("e74wd");
var $c8Wzl = parcelRequire("c8Wzl");
const $2cbdf7ee2b1ff27e$var$isCardAction = (action)=>{
    return [
        (0, $e74wd.ACTION_PENDING),
        (0, $e74wd.ACTION_RESOLVING),
        (0, $e74wd.ACTION_RESOLVED),
        (0, $e74wd.ACTION_RELOADING),
        (0, $e74wd.ACTION_ERROR),
        (0, $e74wd.ACTION_ERROR_FALLBACK),
        (0, $e74wd.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $2cbdf7ee2b1ff27e$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $c8Wzl.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $2cbdf7ee2b1ff27e$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $e74wd.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $e74wd.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $e74wd.ACTION_RESOLVED:
            return $2cbdf7ee2b1ff27e$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $e74wd.ACTION_RELOADING:
            return $2cbdf7ee2b1ff27e$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $e74wd.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $e74wd.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $e74wd.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $2cbdf7ee2b1ff27e$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$2cbdf7ee2b1ff27e$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $2cbdf7ee2b1ff27e$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};

});
parcelRegister("e74wd", function(module, exports) {

$parcel$export(module.exports, "ACTION_PENDING", () => $daed07f92e59fa43$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $daed07f92e59fa43$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $daed07f92e59fa43$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $daed07f92e59fa43$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $daed07f92e59fa43$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $daed07f92e59fa43$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $daed07f92e59fa43$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $daed07f92e59fa43$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $daed07f92e59fa43$export$6e470aad5ba8952e = 'pending';
const $daed07f92e59fa43$export$9a6a932a0a39498e = 'resolving';
const $daed07f92e59fa43$export$63ec8bc7a8a75482 = 'resolved';
const $daed07f92e59fa43$export$b8cfaa842c9ab487 = 'reloading';
const $daed07f92e59fa43$export$6d8ed3f9433dd372 = 'errored';
const $daed07f92e59fa43$export$cfbbb7126bc8a0c6 = 'fallback';
const $daed07f92e59fa43$export$76b5c1aca20759c6 = 'preload';
const $daed07f92e59fa43$export$2c5edb971b673330 = 'metadata';
const $daed07f92e59fa43$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("c8Wzl", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $6c6e7c90ffd243cd$export$b70265791d2079d4);
const $6c6e7c90ffd243cd$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $6c6e7c90ffd243cd$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $6c6e7c90ffd243cd$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});


parcelRegister("2yoyZ", function(module, exports) {

$parcel$export(module.exports, "SmartCardContext", () => $80e7ec654770813a$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $80e7ec654770813a$export$e1d190b530cf0ee9);
$parcel$export(module.exports, "useSmartCardContext", () => $80e7ec654770813a$export$10e9cca30e50f657);
$parcel$export(module.exports, "EditorSmartCardProviderValueGuard", () => $80e7ec654770813a$export$797e3658f090919c);
$parcel$export(module.exports, "EditorSmartCardProvider", () => $80e7ec654770813a$export$2a29ca11e08dc129);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

const $80e7ec654770813a$export$156b523e63b4f63a = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
function $80e7ec654770813a$export$e1d190b530cf0ee9() {
    const context = (0, $5uXOq.useContext)($80e7ec654770813a$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
const $80e7ec654770813a$export$10e9cca30e50f657 = ()=>$80e7ec654770813a$var$useContextMemoized($80e7ec654770813a$export$156b523e63b4f63a);
const $80e7ec654770813a$export$797e3658f090919c = ({ children: children })=>{
    const cardContext = $80e7ec654770813a$export$10e9cca30e50f657();
    if (!cardContext?.value) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};
function $80e7ec654770813a$var$useContextMemoized(reactContext) {
    const value = (0, $5uXOq.useContext)(reactContext);
    const context = (0, $5uXOq.useMemo)(()=>({
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        }), [
        value,
        reactContext
    ]);
    return context;
}
const $80e7ec654770813a$export$2a29ca11e08dc129 = ({ children: children })=>{
    const cardContext = $80e7ec654770813a$export$10e9cca30e50f657();
    const Provider = cardContext.Provider;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Provider, {
        value: cardContext.value,
        children: children
    });
};
var $80e7ec654770813a$export$2e2bcd8739ae039 = $80e7ec654770813a$export$156b523e63b4f63a;

});

parcelRegister("eSRMC", function(module, exports) {

$parcel$export(module.exports, "default", () => $88b46f96c81cb3e6$export$2e2bcd8739ae039);

var $hhZW9 = parcelRequire("hhZW9");

var $hj8yn = parcelRequire("hj8yn");

var $hLXaJ = parcelRequire("hLXaJ");

var $kc2ex = parcelRequire("kc2ex");
var $9UqZ1 = parcelRequire("9UqZ1");
var $c8Wzl = parcelRequire("c8Wzl");
var $3hu7v = parcelRequire("3hu7v");

var $bskKv = parcelRequire("bskKv");

var $iwKVT = parcelRequire("iwKVT");
const $88b46f96c81cb3e6$var$MAX_BATCH_SIZE = 50;
const $88b46f96c81cb3e6$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $88b46f96c81cb3e6$var$URL_RESPONSE_CACHE_SIZE = 100;
const $88b46f96c81cb3e6$export$d6a66073b5d79eb3 = new (0, $iwKVT.LRUMap)($88b46f96c81cb3e6$var$URL_RESPONSE_CACHE_SIZE);
class $88b46f96c81cb3e6$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
			 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
			 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
			 */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $3hu7v.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $3hu7v.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $bskKv.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $9UqZ1.getResolverUrl)(envKey, baseUrlOverride);
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($hLXaJ)))({
            limit: 1,
            interval: $88b46f96c81cb3e6$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($hhZW9)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $88b46f96c81cb3e6$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    async resolveUrl(url, force = false) {
        const hostname = new URL(url).hostname;
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $88b46f96c81cb3e6$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            responsePromise = loader.load(url);
            $88b46f96c81cb3e6$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $88b46f96c81cb3e6$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $bskKv.isSuccessfulResponse)(response) || (0, $c8Wzl.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $88b46f96c81cb3e6$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $bskKv.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($hj8yn)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $bskKv.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch (err) {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $bskKv.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($hj8yn)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $bskKv.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
	 * Fetch data for multiple ARIs (batch) in one operation
	 * @param aris Array of ARIs to fetch data for
	 */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $3hu7v.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
	 * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
	 * spec.
	 * @param data Payload including the search provider key and query. An empty search query string
	 * results in recent results being returned (pre-query).
	 * @returns JsonLd collection of search results.
	 */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $3hu7v.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $bskKv.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $3hu7v.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $3hu7v.NetworkError)) return new (0, $kc2ex.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $kc2ex.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $kc2ex.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    return new (0, $kc2ex.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $kc2ex.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $kc2ex.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
	 * This method will strigify both enumerable and  non enumerable properties of an object
	 * @param err
	 * @returns object serialized to JSON with both enumerable and non enumerable objects
	 */ stringifyError(err) {
        /**
		 * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
		 * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
		 * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
		 */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("hj8yn", function(module, exports) {
// Packages

var $fGJx3 = parcelRequire("fGJx3");
function $c99ad890679d3578$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $fGJx3.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $c99ad890679d3578$var$retry;

});
parcelRegister("fGJx3", function(module, exports) {

module.exports = (parcelRequire("6Q6YB"));

});
parcelRegister("6Q6YB", function(module, exports) {

var $8vOLa = parcelRequire("8vOLa");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $8vOLa(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("8vOLa", function(module, exports) {
function $632897d2769f1314$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $632897d2769f1314$var$RetryOperation;
$632897d2769f1314$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$632897d2769f1314$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$632897d2769f1314$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$632897d2769f1314$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$632897d2769f1314$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$632897d2769f1314$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$632897d2769f1314$var$RetryOperation.prototype.start = $632897d2769f1314$var$RetryOperation.prototype.try;
$632897d2769f1314$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$632897d2769f1314$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$632897d2769f1314$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("hLXaJ", function(module, exports) {
'use strict';
class $cf04b9d0ddc5d8fc$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $cf04b9d0ddc5d8fc$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $cf04b9d0ddc5d8fc$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $cf04b9d0ddc5d8fc$var$pThrottle;
module.exports.AbortError = $cf04b9d0ddc5d8fc$var$AbortError;

});

parcelRegister("kc2ex", function(module, exports) {

$parcel$export(module.exports, "APIError", () => $e7749b308b099e92$export$3e5b797e39668f84);
class $e7749b308b099e92$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("9UqZ1", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $140144a5ef6a9a41$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $140144a5ef6a9a41$export$dc37652c1696f231);
const $140144a5ef6a9a41$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $140144a5ef6a9a41$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $140144a5ef6a9a41$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $140144a5ef6a9a41$export$e2b040f052407032 = {
    dev: $140144a5ef6a9a41$var$devBaseUrl,
    development: $140144a5ef6a9a41$var$devBaseUrl,
    stg: $140144a5ef6a9a41$var$stgBaseUrl,
    staging: $140144a5ef6a9a41$var$stgBaseUrl,
    prd: $140144a5ef6a9a41$var$prodBaseUrl,
    prod: $140144a5ef6a9a41$var$prodBaseUrl,
    production: $140144a5ef6a9a41$var$prodBaseUrl
};
const $140144a5ef6a9a41$export$f654b28f82155665 = (envKey)=>{
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $140144a5ef6a9a41$export$e2b040f052407032 ? $140144a5ef6a9a41$export$e2b040f052407032[envKey] : $140144a5ef6a9a41$var$prodBaseUrl;
    // Otherwise, use the current origin of the page.
    return typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $140144a5ef6a9a41$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $140144a5ef6a9a41$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $140144a5ef6a9a41$export$2e2bcd8739ae039 = $140144a5ef6a9a41$export$e2b040f052407032;

});

parcelRegister("3hu7v", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $91ec02c6ef0c429c$export$bae979e68e4dc802);
$parcel$export(module.exports, "request", () => $91ec02c6ef0c429c$export$b5fe3f66a567bec0);
const $91ec02c6ef0c429c$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $91ec02c6ef0c429c$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $91ec02c6ef0c429c$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $91ec02c6ef0c429c$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $91ec02c6ef0c429c$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("bskKv", function(module, exports) {

$parcel$export(module.exports, "isSuccessfulResponse", () => $fc5f0484345f08f3$export$1b59fe731a28a49d);
$parcel$export(module.exports, "isErrorResponse", () => $fc5f0484345f08f3$export$bea7bee8a87e7c52);
const $fc5f0484345f08f3$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $fc5f0484345f08f3$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});



parcelRegister("gIdoN", function(module, exports) {

$parcel$export(module.exports, "Card", () => $b104c35d4b165ea4$export$60332b2344f7fe41);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");

var $asiGE = parcelRequire("asiGE");
var $3TR0I = parcelRequire("3TR0I");

var $4c7pe = parcelRequire("4c7pe");

var $8s5K6 = parcelRequire("8s5K6");
class $b104c35d4b165ea4$var$PlainCard extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8s5K6.CardWithURLRenderer), {
            ...this.props
        });
        return this.props.intl ? content : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
            locale: "en",
            children: content
        });
    }
}
const $b104c35d4b165ea4$export$60332b2344f7fe41 = (0, $asiGE.default)((0, $4c7pe.context))((0, $3TR0I.default)()((0, $8RXs9.default)($b104c35d4b165ea4$var$PlainCard, {
    enforceContext: false
})));

});
parcelRegister("4c7pe", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $5b9b740f8033fdc2$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $5b9b740f8033fdc2$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $5b9b740f8033fdc2$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $5b9b740f8033fdc2$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $5b9b740f8033fdc2$export$b91e0203b928470c);
const $5b9b740f8033fdc2$export$85183a312807388d = 'media';
const $5b9b740f8033fdc2$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $5b9b740f8033fdc2$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $5b9b740f8033fdc2$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
class $5b9b740f8033fdc2$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $5b9b740f8033fdc2$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $5b9b740f8033fdc2$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($5b9b740f8033fdc2$export$85183a312807388d);
};

});

parcelRegister("8s5K6", function(module, exports) {

$parcel$export(module.exports, "CardWithURLRenderer", () => $03fd544b11fef324$export$e00a7788e30dc998);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $gKZoD = parcelRequire("gKZoD");

var $7Jxgt = parcelRequire("7Jxgt");

var $evjcU = parcelRequire("evjcU");

var $45Vjm = parcelRequire("45Vjm");

var $lR50Q = parcelRequire("lR50Q");

var $gSiht = parcelRequire("gSiht");

var $kYS90 = parcelRequire("kYS90");

var $9vlyY = parcelRequire("9vlyY");

var $bErLx = parcelRequire("bErLx");

const $03fd544b11fef324$export$a7690c318cd6a95e = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(0, $lR50Q.importWithRetry)(()=>(parcelRequire("kozXi"))));
function $03fd544b11fef324$export$e00a7788e30dc998(props) {
    (0, $gKZoD.di)($03fd544b11fef324$export$a7690c318cd6a95e);
    const [id] = (0, $5uXOq.useState)(()=>props.id ? props.id : (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))());
    const { fireEvent: fireEvent } = (0, $evjcU.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        // ComponentWillUnmount
        return ()=>{
            (0, $9vlyY.clearMarks)(id);
            (0, $9vlyY.clearMeasures)(id);
        };
    }, [
        id
    ]);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, placeholder: placeholder, fallbackComponent: fallbackComponent, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline } = props;
    const isFlexibleUi = (0, $kYS90.isFlexibleUiCard)(children);
    const analyticsContext = (0, $gSiht.useSmartLinkAnalyticsContext)({
        display: isFlexibleUi ? 'flexible' : appearance,
        id: id,
        url: url ?? ''
    });
    const errorHandler = (0, $5uXOq.useCallback)((error, info)=>{
        const { componentStack: componentStack } = info;
        const errorInfo = {
            componentStack: componentStack
        };
        // NB: APIErrors are thrown in response to Object Resolver Service. We do not
        // fire an event for these, as they do not cover failed UI render events.
        // The rest of the errors caught here are unexpected, and correlate
        // to the reliability of the smart-card front-end components.
        // Likewise, chunk loading errors are not caused by a failure of smart-card rendering.
        if (error.name === 'ChunkLoadError') fireEvent('operational.smartLink.chunkLoadFailed', {
            ...analyticsContext?.attributes,
            display: appearance,
            error: error,
            errorInfo: errorInfo,
            definitionId: null
        });
        else if (error.name !== 'APIError') {
            (0, $45Vjm.startUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $45Vjm.failUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $45Vjm.failUfoExperience)('smart-link-authenticated', id || 'NULL');
            fireEvent('ui.smartLink.renderFailed', {
                ...analyticsContext?.attributes,
                display: isFlexibleUi ? 'flexible' : appearance,
                id: id ?? null,
                error: error,
                errorInfo: errorInfo
            });
        }
        onError && onError({
            status: 'errored',
            url: url ?? '',
            err: error
        });
    }, [
        analyticsContext?.attributes,
        appearance,
        fireEvent,
        id,
        isFlexibleUi,
        onError,
        url
    ]);
    if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
    const defaultFallBackComponent = ()=>null;
    const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
    const ErrorFallback = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)(FallbackComponent, {});
    const cardWithUrlProps = {
        id: id,
        url: url,
        appearance: appearance,
        onClick: onClick,
        isSelected: isSelected,
        isHovered: isHovered,
        frameStyle: frameStyle,
        container: container,
        onResolve: onResolve,
        onError: onError,
        testId: testId,
        actionOptions: actionOptions,
        inheritDimensions: inheritDimensions,
        platform: platform,
        embedIframeRef: embedIframeRef,
        embedIframeUrlType: embedIframeUrlType,
        inlinePreloaderStyle: inlinePreloaderStyle,
        ui: ui,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        placeholder: placeholder,
        removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
        resolvingPlaceholder: resolvingPlaceholder,
        truncateInline: truncateInline
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
        FallbackComponent: ErrorFallback,
        onError: errorHandler,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
            fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bErLx.LoadingCardLink), {
                ...cardWithUrlProps
            }),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($03fd544b11fef324$export$a7690c318cd6a95e, {
                ...cardWithUrlProps,
                children: children
            })
        })
    });
}

});
parcelRegister("evjcU", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $530e13ecbad66dc4$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::1f3587129789e7883af37adad3817cd2>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");


var $1r5MV = parcelRequire("1r5MV");
const $530e13ecbad66dc4$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fireEvent = (0, $5uXOq.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $1r5MV.default)(...params));
        event.fire((0, $69f87695d9db238a$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
const $69f87695d9db238a$export$3f072f06b90c3985 = 'media';

parcelRegister("1r5MV", function(module, exports) {

$parcel$export(module.exports, "default", () => $fed4fe2f4f975e57$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::eb8cd1263459fb798341024dc0c461ea>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $fed4fe2f4f975e57$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $fed4fe2f4f975e57$export$2e2bcd8739ae039 = $fed4fe2f4f975e57$var$createEventPayload;

});


parcelRegister("45Vjm", function(module, exports) {

$parcel$export(module.exports, "startUfoExperience", () => $213691361720b0f5$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $213691361720b0f5$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $213691361720b0f5$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $213691361720b0f5$export$4084c0df4a03a6af);

var $766ff = parcelRequire("766ff");
var $2DPlK = parcelRequire("2DPlK");
const $213691361720b0f5$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $2DPlK.ExperienceTypes).Experience,
    performanceType: (0, $2DPlK.ExperiencePerformanceTypes).InlineResult
};
const $213691361720b0f5$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $2DPlK.ExperienceTypes).Load,
    performanceType: (0, $2DPlK.ExperiencePerformanceTypes).PageSegmentLoad
};
const $213691361720b0f5$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $2DPlK.ExperienceTypes).Experience,
    performanceType: (0, $2DPlK.ExperiencePerformanceTypes).InlineResult
};
const $213691361720b0f5$var$ufoExperiences = {
    'smart-link-rendered': new (0, $766ff.ConcurrentExperience)('smart-link-rendered', $213691361720b0f5$var$renderExperience),
    'smart-link-authenticated': new (0, $766ff.ConcurrentExperience)('smart-link-authenticated', $213691361720b0f5$var$inlineExperience),
    'smart-link-action-invocation': new (0, $766ff.ConcurrentExperience)('smart-link-action-invocation', $213691361720b0f5$var$inlineExperience),
    'smart-link-ai-summary': new (0, $766ff.ConcurrentExperience)('smart-link-ai-summary', $213691361720b0f5$var$aiExperience)
};
const $213691361720b0f5$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $213691361720b0f5$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $213691361720b0f5$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $213691361720b0f5$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $213691361720b0f5$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $213691361720b0f5$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $213691361720b0f5$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $213691361720b0f5$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});

parcelRegister("lR50Q", function(module, exports) {

$parcel$export(module.exports, "isSpecialEvent", () => $e337e336170a4cc6$export$efca2c4705678489);
$parcel$export(module.exports, "getIconForFileType", () => $e337e336170a4cc6$export$4d685c85ebc7a1e3);
$parcel$export(module.exports, "getLazyIcons", () => $e337e336170a4cc6$export$92d31eb5326761b6);
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $e337e336170a4cc6$export$9b7e6a102056a387);
$parcel$export(module.exports, "handleOnClick", () => $e337e336170a4cc6$export$ffccab2ae3d093ef);
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $e337e336170a4cc6$export$6c837641a9ab03cb);
$parcel$export(module.exports, "importWithRetry", () => $e337e336170a4cc6$export$aacbf48ace518c5a);
$parcel$export(module.exports, "downloadUrl", () => $e337e336170a4cc6$export$8a96edb1c96563f4);
$parcel$export(module.exports, "openUrl", () => $e337e336170a4cc6$export$a238cfe4a10e6279);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $e337e336170a4cc6$export$4470f298c61a79da);
$parcel$export(module.exports, "isIconSizeLarge", () => $e337e336170a4cc6$export$d2b8fb9e780e17e7);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $fHpHg = parcelRequire("fHpHg");

var $6nvuU = parcelRequire("6nvuU");

var $bUpbd = parcelRequire("bUpbd");

var $3iiaa = parcelRequire("3iiaa");
const $e337e336170a4cc6$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($e337e336170a4cc6$export$e6c5ffa684aac4d7() || $e337e336170a4cc6$export$d8de0cd37d316fdf(evt) || $e337e336170a4cc6$export$5b1771037ab7c451(evt));
const $e337e336170a4cc6$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $e337e336170a4cc6$export$d8de0cd37d316fdf = (event)=>{
    return (0, $fHpHg.fg)('platform-smart-card-shift-key') ? event.metaKey || event.ctrlKey || event.shiftKey : event.metaKey || event.ctrlKey;
};
const $e337e336170a4cc6$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $e337e336170a4cc6$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
    if (!fileMimeType) return;
    let icon = (0, $fHpHg.fg)('platform-smart-card-icon-migration') ? $e337e336170a4cc6$var$getTypeToIconMap(fileMimeType.toLowerCase()) : $e337e336170a4cc6$var$typeToIcon[fileMimeType.toLowerCase()];
    if (!icon) return;
    const [label, importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
        label: label,
        testId: "document-file-format-icon"
    });
};
const $e337e336170a4cc6$export$371bef29a3733127 = (fileMimeType)=>{
    let icon = (0, $fHpHg.fg)('platform-smart-card-icon-migration') ? $e337e336170a4cc6$var$getTypeToIconMap(fileMimeType.toLowerCase()) : $e337e336170a4cc6$var$typeToIcon[fileMimeType.toLowerCase()];
    if (!icon) return;
    const [label] = icon;
    return label;
};


















































const $e337e336170a4cc6$var$typeToIcon = {
    'text/plain': [
        'Document',
        ()=>Promise.resolve((parcelRequire("5cf2v")))
    ],
    'application/vnd.oasis.opendocument.text': [
        'Document',
        ()=>Promise.resolve((parcelRequire("5cf2v")))
    ],
    'application/vnd.apple.pages': [
        'Document',
        ()=>Promise.resolve((parcelRequire("5cf2v")))
    ],
    'application/vnd.google-apps.document': [
        'Google Doc',
        ()=>(parcelRequire("8hQt0"))
    ],
    'application/msword': [
        'Word document',
        ()=>(parcelRequire("i1tD5"))
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
        'Word document',
        ()=>(parcelRequire("i1tD5"))
    ],
    'application/pdf': [
        'PDF document',
        ()=>(parcelRequire("24aUC"))
    ],
    'application/vnd.oasis.opendocument.spreadsheet': [
        'Spreadsheet',
        ()=>(parcelRequire("k9stF"))
    ],
    'application/vnd.apple.numbers': [
        'Spreadsheet',
        ()=>(parcelRequire("k9stF"))
    ],
    'application/vnd.google-apps.spreadsheet': [
        'Google Sheet',
        ()=>(parcelRequire("hXEQP"))
    ],
    'application/vnd.ms-excel': [
        'Excel spreadsheet',
        ()=>(parcelRequire("jOQbA"))
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
        'Excel spreadsheet',
        ()=>(parcelRequire("jOQbA"))
    ],
    'application/vnd.oasis.opendocument.presentation': [
        'Presentation',
        ()=>(parcelRequire("iW2rN"))
    ],
    'application/vnd.apple.keynote': [
        'Presentation',
        ()=>(parcelRequire("iW2rN"))
    ],
    'application/vnd.google-apps.presentation': [
        'Google Slide',
        ()=>(parcelRequire("hbZKR"))
    ],
    'application/vnd.ms-powerpoint': [
        'PowerPoint presentation',
        ()=>(parcelRequire("31tct"))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
        'PowerPoint presentation',
        ()=>(parcelRequire("31tct"))
    ],
    'application/vnd.google-apps.form': [
        'Google Form',
        ()=>(parcelRequire("9Hs6w"))
    ],
    'image/png': [
        'Image',
        ()=>(parcelRequire("rOfWv"))
    ],
    'image/jpeg': [
        'Image',
        ()=>(parcelRequire("rOfWv"))
    ],
    'image/bmp': [
        'Image',
        ()=>(parcelRequire("rOfWv"))
    ],
    'image/webp': [
        'Image',
        ()=>(parcelRequire("rOfWv"))
    ],
    'image/svg+xml': [
        'Image',
        ()=>(parcelRequire("rOfWv"))
    ],
    'image/gif': [
        'GIF',
        ()=>(parcelRequire("k0qOW"))
    ],
    'audio/midi': [
        'Audio',
        ()=>(parcelRequire("CsohK"))
    ],
    'audio/mpeg': [
        'Audio',
        ()=>(parcelRequire("CsohK"))
    ],
    'audio/webm': [
        'Audio',
        ()=>(parcelRequire("CsohK"))
    ],
    'audio/ogg': [
        'Audio',
        ()=>(parcelRequire("CsohK"))
    ],
    'audio/wav': [
        'Audio',
        ()=>(parcelRequire("CsohK"))
    ],
    'video/mp4': [
        'Video',
        ()=>(parcelRequire("4HsDf"))
    ],
    'video/quicktime': [
        'Video',
        ()=>(parcelRequire("4HsDf"))
    ],
    'video/mov': [
        'Video',
        ()=>(parcelRequire("4HsDf"))
    ],
    'video/webm': [
        'Video',
        ()=>(parcelRequire("4HsDf"))
    ],
    'video/ogg': [
        'Video',
        ()=>(parcelRequire("4HsDf"))
    ],
    'video/x-ms-wmv': [
        'Video',
        ()=>(parcelRequire("4HsDf"))
    ],
    'video/x-msvideo': [
        'Video',
        ()=>(parcelRequire("4HsDf"))
    ],
    'application/zip': [
        'Archive',
        ()=>(parcelRequire("abbu1"))
    ],
    'application/x-tar': [
        'Archive',
        ()=>(parcelRequire("abbu1"))
    ],
    'application/x-gtar': [
        'Archive',
        ()=>(parcelRequire("abbu1"))
    ],
    'application/x-7z-compressed': [
        'Archive',
        ()=>(parcelRequire("abbu1"))
    ],
    'application/x-apple-diskimage': [
        'Archive',
        ()=>(parcelRequire("abbu1"))
    ],
    'application/vnd.rar': [
        'Archive',
        ()=>(parcelRequire("abbu1"))
    ],
    'application/dmg': [
        'Executable',
        ()=>(parcelRequire("fvN53"))
    ],
    'text/css': [
        'Source Code',
        ()=>(parcelRequire("dDrgR"))
    ],
    'text/html': [
        'Source Code',
        ()=>(parcelRequire("dDrgR"))
    ],
    'application/javascript': [
        'Source Code',
        ()=>(parcelRequire("dDrgR"))
    ],
    'application/octet-stream': [
        'Binary file',
        ()=>(parcelRequire("eSVih"))
    ],
    'application/invision.prototype': [
        'Prototype',
        ()=>(parcelRequire("eSVih"))
    ],
    // TODO: Figure a way to detect those
    'application/sketch': [
        'Sketch',
        ()=>(parcelRequire("6idFd"))
    ],
    folder: [
        'Folder',
        ()=>(parcelRequire("9HbfU"))
    ]
};

























































































const $e337e336170a4cc6$export$92d31eb5326761b6 = ()=>{
    return {
        [(0, $bUpbd.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("5vx5k")))
        },
        [(0, $bUpbd.IconType).Blog]: {
            default: ()=>Promise.resolve((parcelRequire("beqqV")))
        },
        [(0, $bUpbd.IconType).Audio]: {
            default: ()=>(parcelRequire("b5hWa"))
        },
        [(0, $bUpbd.IconType).Code]: {
            default: ()=>(parcelRequire("6OsQn"))
        },
        [(0, $bUpbd.IconType).File]: {
            default: ()=>(parcelRequire("jsrZA"))
        },
        [(0, $bUpbd.IconType).Folder]: {
            default: ()=>(parcelRequire("enH9y"))
        },
        [(0, $bUpbd.IconType).Generic]: {
            default: ()=>(parcelRequire("jsrZA"))
        },
        [(0, $bUpbd.IconType).Image]: {
            default: ()=>(parcelRequire("c0CVJ"))
        },
        [(0, $bUpbd.IconType).Presentation]: {
            default: ()=>(parcelRequire("cqHeF"))
        },
        [(0, $bUpbd.IconType).Spreadsheet]: {
            default: ()=>(parcelRequire("gOJXC"))
        },
        [(0, $bUpbd.IconType).Video]: {
            default: ()=>(parcelRequire("hZ2BU"))
        },
        [(0, $bUpbd.IconType).Project]: {
            default: ()=>Promise.resolve((parcelRequire("eGeCO")))
        },
        [(0, $bUpbd.IconType).Template]: {
            default: ()=>(parcelRequire("d1JZm"))
        },
        [(0, $bUpbd.IconType).Forbidden]: {
            default: ()=>(parcelRequire("4erTB"))
        },
        [(0, $bUpbd.IconType).Default]: {
            default: ()=>Promise.resolve((parcelRequire("c95g7")))
        },
        [(0, $bUpbd.IconType).Archive]: {
            default: ()=>(parcelRequire("abbu1")),
            large: ()=>(parcelRequire("9puLh"))
        },
        [(0, $bUpbd.IconType).Executable]: {
            default: ()=>(parcelRequire("fvN53")),
            large: ()=>(parcelRequire("dklyN"))
        },
        [(0, $bUpbd.IconType).GIF]: {
            default: ()=>(parcelRequire("k0qOW")),
            large: ()=>(parcelRequire("21HEi"))
        },
        [(0, $bUpbd.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("8hQt0")),
            large: ()=>(parcelRequire("fQsqy"))
        },
        [(0, $bUpbd.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("9Hs6w")),
            large: ()=>(parcelRequire("8AqA8"))
        },
        [(0, $bUpbd.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("hXEQP")),
            large: ()=>(parcelRequire("bV3UB"))
        },
        [(0, $bUpbd.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("hbZKR")),
            large: ()=>(parcelRequire("eLRGh"))
        },
        [(0, $bUpbd.IconType).MSExcel]: {
            default: ()=>(parcelRequire("jOQbA")),
            large: ()=>(parcelRequire("7ssM4"))
        },
        [(0, $bUpbd.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("31tct")),
            large: ()=>(parcelRequire("7psNY"))
        },
        [(0, $bUpbd.IconType).MSWord]: {
            default: ()=>(parcelRequire("i1tD5")),
            large: ()=>(parcelRequire("fvwXh"))
        },
        [(0, $bUpbd.IconType).PDF]: {
            default: ()=>(parcelRequire("24aUC")),
            large: ()=>(parcelRequire("g0Y2J"))
        },
        [(0, $bUpbd.IconType).Sketch]: {
            default: ()=>(parcelRequire("6idFd")),
            large: ()=>(parcelRequire("5CNHY"))
        },
        // Bitbucket icons
        [(0, $bUpbd.IconType).Branch]: {
            default: ()=>(parcelRequire("5HDoK")),
            large: ()=>(parcelRequire("aN944"))
        },
        [(0, $bUpbd.IconType).Commit]: {
            default: ()=>(parcelRequire("kGCQL")),
            large: ()=>(parcelRequire("4Pf4L"))
        },
        [(0, $bUpbd.IconType).PullRequest]: {
            default: ()=>(parcelRequire("5Wydb")),
            large: ()=>(parcelRequire("dznHy"))
        },
        [(0, $bUpbd.IconType).Repo]: {
            default: ()=>(parcelRequire("42NaT")),
            large: ()=>(parcelRequire("hw1ma"))
        },
        // Jira icons
        [(0, $bUpbd.IconType).Bug]: {
            default: ()=>(parcelRequire("hrPZz")),
            large: ()=>(parcelRequire("kbikZ"))
        },
        [(0, $bUpbd.IconType).Change]: {
            default: ()=>(parcelRequire("gcXvG")),
            large: ()=>(parcelRequire("dqxeZ"))
        },
        [(0, $bUpbd.IconType).Epic]: {
            default: ()=>(parcelRequire("dtRZ8")),
            large: ()=>(parcelRequire("hE4nB"))
        },
        [(0, $bUpbd.IconType).Incident]: {
            default: ()=>(parcelRequire("Hrhdz")),
            large: ()=>(parcelRequire("gIeuD"))
        },
        [(0, $bUpbd.IconType).Problem]: {
            default: ()=>(parcelRequire("2SZmt")),
            large: ()=>(parcelRequire("2n0lf"))
        },
        [(0, $bUpbd.IconType).ServiceRequest]: {
            default: ()=>(parcelRequire("4lk7q")),
            large: ()=>(parcelRequire("1kUDA"))
        },
        [(0, $bUpbd.IconType).Story]: {
            default: ()=>(parcelRequire("9KliZ")),
            large: ()=>(parcelRequire("hBBc2"))
        },
        [(0, $bUpbd.IconType).SubTask]: {
            default: ()=>(parcelRequire("cV05C")),
            large: ()=>(parcelRequire("9KJn0"))
        },
        [(0, $bUpbd.IconType).Task]: {
            default: ()=>(parcelRequire("aJKNn")),
            large: ()=>(parcelRequire("3ETEX"))
        },
        // Confluence icons
        [(0, $bUpbd.IconType).LiveDocument]: {
            default: ()=>Promise.resolve((parcelRequire("pNRmB"))),
            large: ()=>Promise.resolve((parcelRequire("44Gio")))
        },
        // Provider icons
        [(0, $bUpbd.IconType).Confluence]: {
            default: ()=>Promise.resolve((parcelRequire("jo1Bz"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                        default: ConfluenceIcon
                    }))
        },
        [(0, $bUpbd.IconType).Jira]: {
            default: ()=>Promise.resolve((parcelRequire("39fIG"))).then(({ JiraIcon: JiraIcon })=>({
                        default: JiraIcon
                    }))
        },
        // Badge icons
        [(0, $bUpbd.IconType).Attachment]: {
            default: ()=>(parcelRequire("3RWFB"))
        },
        [(0, $bUpbd.IconType).CheckItem]: {
            default: ()=>(parcelRequire("eqHIz"))
        },
        [(0, $bUpbd.IconType).Comment]: {
            default: ()=>(parcelRequire("aCO9Z"))
        },
        [(0, $bUpbd.IconType).View]: {
            default: ()=>(parcelRequire("5mMrn"))
        },
        [(0, $bUpbd.IconType).React]: {
            default: ()=>(parcelRequire("2rQWl"))
        },
        [(0, $bUpbd.IconType).Vote]: {
            default: ()=>(parcelRequire("jeWP1"))
        },
        [(0, $bUpbd.IconType).PriorityBlocker]: {
            default: ()=>(parcelRequire("gMDFI"))
        },
        [(0, $bUpbd.IconType).PriorityCritical]: {
            default: ()=>(parcelRequire("4fkVg"))
        },
        [(0, $bUpbd.IconType).PriorityHigh]: {
            default: ()=>(parcelRequire("fgN6p"))
        },
        [(0, $bUpbd.IconType).PriorityHighest]: {
            default: ()=>(parcelRequire("cV2N9"))
        },
        [(0, $bUpbd.IconType).PriorityLow]: {
            default: ()=>(parcelRequire("eVavM"))
        },
        [(0, $bUpbd.IconType).PriorityLowest]: {
            default: ()=>(parcelRequire("56RVo"))
        },
        [(0, $bUpbd.IconType).PriorityMajor]: {
            default: ()=>(parcelRequire("ktXnL"))
        },
        [(0, $bUpbd.IconType).PriorityMedium]: {
            default: ()=>(parcelRequire("9mM5H"))
        },
        [(0, $bUpbd.IconType).PriorityMinor]: {
            default: ()=>(parcelRequire("1O0Re"))
        },
        [(0, $bUpbd.IconType).PriorityTrivial]: {
            default: ()=>(parcelRequire("lGGho"))
        },
        [(0, $bUpbd.IconType).PriorityUndefined]: {
            default: ()=>(parcelRequire("cwmVk"))
        },
        [(0, $bUpbd.IconType).ProgrammingLanguage]: {
            default: ()=>(parcelRequire("gasRl"))
        },
        [(0, $bUpbd.IconType).Subscriber]: {
            default: ()=>Promise.resolve((parcelRequire("IoPSi")))
        },
        [(0, $bUpbd.IconType).SubTasksProgress]: {
            default: ()=>(parcelRequire("k978r"))
        }
    };
};
const $e337e336170a4cc6$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $3iiaa.default)(fileFormat);
    if (!iconDescriptor?.icon || !iconDescriptor.label) return null;
    const lazyIcons = $e337e336170a4cc6$export$92d31eb5326761b6();
    return [
        iconDescriptor.label,
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $e337e336170a4cc6$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $e337e336170a4cc6$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $e337e336170a4cc6$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $e337e336170a4cc6$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $e337e336170a4cc6$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $e337e336170a4cc6$export$e772c8ff12451969(interval);
            return $e337e336170a4cc6$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $e337e336170a4cc6$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $e337e336170a4cc6$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $e337e336170a4cc6$export$4470f298c61a79da = (previewUrl, themeState)=>{
    try {
        const url = new URL(previewUrl);
        url.searchParams.append('themeState', (0, $6nvuU.themeObjectToString)(themeState));
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $e337e336170a4cc6$export$d2b8fb9e780e17e7 = (size)=>size && [
        (0, $bUpbd.SmartLinkSize).Large,
        (0, $bUpbd.SmartLinkSize).XLarge
    ].includes(size);

});
parcelRegister("bUpbd", function(module, exports) {

$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $fc97f3ddfe5fa7b7$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $fc97f3ddfe5fa7b7$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $fc97f3ddfe5fa7b7$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $fc97f3ddfe5fa7b7$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $fc97f3ddfe5fa7b7$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $fc97f3ddfe5fa7b7$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $fc97f3ddfe5fa7b7$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $fc97f3ddfe5fa7b7$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $fc97f3ddfe5fa7b7$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $fc97f3ddfe5fa7b7$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $fc97f3ddfe5fa7b7$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $fc97f3ddfe5fa7b7$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $fc97f3ddfe5fa7b7$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $fc97f3ddfe5fa7b7$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $fc97f3ddfe5fa7b7$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $fc97f3ddfe5fa7b7$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $fc97f3ddfe5fa7b7$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $fc97f3ddfe5fa7b7$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $fc97f3ddfe5fa7b7$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardDisplay", () => $fc97f3ddfe5fa7b7$export$6ca4ef8b3dc2c804);
const $fc97f3ddfe5fa7b7$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $fc97f3ddfe5fa7b7$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $fc97f3ddfe5fa7b7$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $fc97f3ddfe5fa7b7$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $fc97f3ddfe5fa7b7$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $fc97f3ddfe5fa7b7$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $fc97f3ddfe5fa7b7$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $fc97f3ddfe5fa7b7$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $fc97f3ddfe5fa7b7$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $fc97f3ddfe5fa7b7$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $fc97f3ddfe5fa7b7$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $fc97f3ddfe5fa7b7$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $fc97f3ddfe5fa7b7$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $fc97f3ddfe5fa7b7$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["Title"] = "Title";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    return ElementName;
}({});
var $fc97f3ddfe5fa7b7$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    return ActionName;
}({});
var $fc97f3ddfe5fa7b7$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $fc97f3ddfe5fa7b7$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $fc97f3ddfe5fa7b7$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $fc97f3ddfe5fa7b7$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $fc97f3ddfe5fa7b7$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});

});

parcelRegister("3iiaa", function(module, exports) {

$parcel$export(module.exports, "default", () => $26cc581855badf4c$export$2e2bcd8739ae039);

var $bUpbd = parcelRequire("bUpbd");
const $26cc581855badf4c$var$extractFileFormatIcon = (fileFormat)=>{
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return {
                icon: (0, $bUpbd.IconType).Folder,
                label: 'Folder'
            };
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return {
                icon: (0, $bUpbd.IconType).Document,
                label: 'Document'
            };
        case 'application/pdf':
            return {
                icon: (0, $bUpbd.IconType).PDF,
                label: 'PDF document'
            };
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return {
                icon: (0, $bUpbd.IconType).Presentation,
                label: 'Presentation'
            };
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return {
                icon: (0, $bUpbd.IconType).Spreadsheet,
                label: 'Spreadsheet'
            };
        // Google Drive
        case 'application/vnd.google-apps.document':
            return {
                icon: (0, $bUpbd.IconType).GoogleDocs,
                label: 'Google Docs'
            };
        case 'application/vnd.google-apps.form':
            return {
                icon: (0, $bUpbd.IconType).GoogleForms,
                label: 'Google Form'
            };
        case 'application/vnd.google-apps.spreadsheet':
            return {
                icon: (0, $bUpbd.IconType).GoogleSheets,
                label: 'Google Sheets'
            };
        case 'application/vnd.google-apps.presentation':
            return {
                icon: (0, $bUpbd.IconType).GoogleSlides,
                label: 'Google Slides'
            };
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return {
                icon: (0, $bUpbd.IconType).MSExcel,
                label: 'Excel spreadsheet'
            };
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return {
                icon: (0, $bUpbd.IconType).MSPowerpoint,
                label: 'PowerPoint presentation'
            };
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return {
                icon: (0, $bUpbd.IconType).MSWord,
                label: 'Word document'
            };
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return {
                icon: (0, $bUpbd.IconType).Image,
                label: 'Image'
            };
        case 'image/gif':
            return {
                icon: (0, $bUpbd.IconType).GIF,
                label: 'GIF'
            };
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return {
                icon: (0, $bUpbd.IconType).Audio,
                label: 'Audio'
            };
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return {
                icon: (0, $bUpbd.IconType).Video,
                label: 'Video'
            };
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return {
                icon: (0, $bUpbd.IconType).Code,
                label: 'Source Code'
            };
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return {
                icon: (0, $bUpbd.IconType).Archive,
                label: 'Archive'
            };
        case 'application/dmg':
            return {
                icon: (0, $bUpbd.IconType).Executable,
                label: 'Executable'
            };
        case 'application/sketch':
            return {
                icon: (0, $bUpbd.IconType).Sketch,
                label: 'Sketch'
            };
        case 'application/octet-stream':
            return {
                icon: (0, $bUpbd.IconType).Generic,
                label: 'Binary file'
            };
        case 'application/invision.prototype':
            return {
                icon: (0, $bUpbd.IconType).Generic,
                label: 'Prototype'
            };
        default:
            return undefined;
    }
};
var $26cc581855badf4c$export$2e2bcd8739ae039 = $26cc581855badf4c$var$extractFileFormatIcon;

});

parcelRegister("5cf2v", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3c89bd40cce5a369$var$_react = $3c89bd40cce5a369$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");
function $3c89bd40cce5a369$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3c89bd40cce5a369$var$Document16Icon = (props)=>/*#__PURE__*/ $3c89bd40cce5a369$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$3c89bd40cce5a369$var$Document16Icon.displayName = 'Document16Icon';
var $3c89bd40cce5a369$var$_default = module.exports.default = $3c89bd40cce5a369$var$Document16Icon;

});

parcelRegister("8hQt0", function(module, exports) {

let $60889c19822b0400$var$load = (parcelRequire("28QjX"))(4);
module.exports = $60889c19822b0400$var$load("6gtWo").then(()=>parcelRequire('62WCn'));

});

parcelRegister("i1tD5", function(module, exports) {

let $d1ef4dc72ee750a5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d1ef4dc72ee750a5$var$load("kMPo5").then(()=>parcelRequire('1QYVb'));

});

parcelRegister("24aUC", function(module, exports) {

let $18146b6766ee4c3c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $18146b6766ee4c3c$var$load("gHdaB").then(()=>parcelRequire('dSQiC'));

});

parcelRegister("k9stF", function(module, exports) {

let $eababcedc88ac1a2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eababcedc88ac1a2$var$load("iGFoj").then(()=>parcelRequire('9lW81'));

});

parcelRegister("hXEQP", function(module, exports) {

let $d137a2897ddc6052$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d137a2897ddc6052$var$load("gh5Lp").then(()=>parcelRequire('5RMdw'));

});

parcelRegister("jOQbA", function(module, exports) {

let $e6db2ad90cafb969$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e6db2ad90cafb969$var$load("8G72n").then(()=>parcelRequire('lIt3y'));

});

parcelRegister("iW2rN", function(module, exports) {

let $dc8f8abd2f302b7a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dc8f8abd2f302b7a$var$load("fZTQ9").then(()=>parcelRequire('6mEGs'));

});

parcelRegister("hbZKR", function(module, exports) {

let $c8435dfddf55dd13$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c8435dfddf55dd13$var$load("cxWGL").then(()=>parcelRequire('2TG3u'));

});

parcelRegister("31tct", function(module, exports) {

let $23381da8cf5d635d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $23381da8cf5d635d$var$load("7yUBc").then(()=>parcelRequire('4pKqP'));

});

parcelRegister("9Hs6w", function(module, exports) {

let $70fdee1f57370503$var$load = (parcelRequire("28QjX"))(4);
module.exports = $70fdee1f57370503$var$load("7PlOc").then(()=>parcelRequire('clr3L'));

});

parcelRegister("rOfWv", function(module, exports) {

let $0539818dcd43790b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0539818dcd43790b$var$load("1lU5U").then(()=>parcelRequire('e4ND1'));

});

parcelRegister("k0qOW", function(module, exports) {

let $e9089cc3b4c8e4ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e9089cc3b4c8e4ca$var$load("dhHcF").then(()=>parcelRequire('5f85G'));

});

parcelRegister("CsohK", function(module, exports) {

let $073992869ab8d0a7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $073992869ab8d0a7$var$load("9OKo1").then(()=>parcelRequire('6jqdB'));

});

parcelRegister("4HsDf", function(module, exports) {

let $36c16348d1b4c0c9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $36c16348d1b4c0c9$var$load("3hyuG").then(()=>parcelRequire('irqrc'));

});

parcelRegister("abbu1", function(module, exports) {

let $7693d6c5e3cf9a21$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7693d6c5e3cf9a21$var$load("g0waE").then(()=>parcelRequire('7xb48'));

});

parcelRegister("fvN53", function(module, exports) {

let $b4afd2a8e76d6051$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b4afd2a8e76d6051$var$load("liq6J").then(()=>parcelRequire('joiX4'));

});

parcelRegister("dDrgR", function(module, exports) {

let $9ed4124fb72d38ac$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9ed4124fb72d38ac$var$load("bquJ0").then(()=>parcelRequire('8O5CD'));

});

parcelRegister("eSVih", function(module, exports) {

let $ad628d3560b654ad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ad628d3560b654ad$var$load("3XWUu").then(()=>parcelRequire('dhMam'));

});

parcelRegister("6idFd", function(module, exports) {

let $494f05df32c8d275$var$load = (parcelRequire("28QjX"))(4);
module.exports = $494f05df32c8d275$var$load("7RstS").then(()=>parcelRequire('42hrq'));

});

parcelRegister("9HbfU", function(module, exports) {

let $70f0dc5940d07935$var$load = (parcelRequire("28QjX"))(4);
module.exports = $70f0dc5940d07935$var$load("4uC1s").then(()=>parcelRequire('h344f'));

});

parcelRegister("5vx5k", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a6357217e973b986$export$2e2bcd8739ae039);

var $5cf2v = parcelRequire("5cf2v");

var $4HiZI = parcelRequire("4HiZI");

var $lpnOy = parcelRequire("lpnOy");
const $a6357217e973b986$var$PageIconWithColor = (0, $lpnOy.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($4HiZI))), 'blueBold', (0, (/*@__PURE__*/$parcel$interopDefault($5cf2v))));
$a6357217e973b986$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $a6357217e973b986$export$2e2bcd8739ae039 = $a6357217e973b986$var$PageIconWithColor;

});
parcelRegister("lpnOy", function(module, exports) {

$parcel$export(module.exports, "renderIconPerSize", () => $858c207421e9017b$export$28dd5ad82647c000);
$parcel$export(module.exports, "renderIconTile", () => $858c207421e9017b$export$87c3646d0e299cfe);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9hW6e = parcelRequire("9hW6e");

var $bUpbd = parcelRequire("bUpbd");

var $lR50Q = parcelRequire("lR50Q");
const $858c207421e9017b$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $bUpbd.SmartLinkSize).XLarge:
        case (0, $bUpbd.SmartLinkSize).Large:
            return '24';
        default:
            return '16';
    }
};
const $858c207421e9017b$export$28dd5ad82647c000 = (IconSmall, IconLarge)=>{
    return ({ size: size, ...props })=>{
        if ((0, $lR50Q.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, $2OMIu.jsx)(IconLarge, {
            ...props
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)(IconSmall, {
            ...props
        });
    };
};
const $858c207421e9017b$export$87c3646d0e299cfe = (Icon, appearance, LegacyIcon)=>{
    return ({ size: size, ...props })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9hW6e.default), {
            appearance: appearance,
            icon: Icon,
            size: $858c207421e9017b$export$3acc3fb10995f020(size),
            ...props,
            LEGACY_fallbackComponent: LegacyIcon && /*#__PURE__*/ (0, $2OMIu.jsx)(LegacyIcon, {
                ...props
            })
        });
    };
};

});
parcelRegister("9hW6e", function(module, exports) {

$parcel$export(module.exports, "default", () => $0edd8123bdd94131$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $fHpHg = parcelRequire("fHpHg");
function $0edd8123bdd94131$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0edd8123bdd94131$var$sizeMap = {
    '16': {
        name: "157xhr7",
        styles: "width:16px;height:16px"
    },
    '24': {
        name: "rrel8y",
        styles: "width:24px;height:24px"
    },
    '32': {
        name: "68x97p",
        styles: "width:32px;height:32px"
    },
    '40': {
        name: "1mfsro6",
        styles: "width:40px;height:40px"
    },
    '48': {
        name: "18jhpep",
        styles: "width:48px;height:48px"
    }
};
const $0edd8123bdd94131$var$appearanceMap = {
    grayBold: {
        name: "algye9",
        styles: "background-color:var(--ds-background-accent-gray-bolder, #626F86);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    limeBold: {
        name: "a86nvv",
        styles: "background-color:var(--ds-background-accent-lime-bolder, #5B7F24);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    greenBold: {
        name: "13e2qqr",
        styles: "background-color:var(--ds-background-accent-green-bolder, #1F845A);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    blueBold: {
        name: "jpsdma",
        styles: "background-color:var(--ds-background-accent-blue-bolder, #0C66E4);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    redBold: {
        name: "1bg8y7a",
        styles: "background-color:var(--ds-background-accent-red-bolder, #C9372C);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    purpleBold: {
        name: "19bo3lb",
        styles: "background-color:var(--ds-background-accent-purple-bolder, #6E5DC6);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    magentaBold: {
        name: "1l16rgo",
        styles: "background-color:var(--ds-background-accent-magenta-bolder, #AE4787);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    tealBold: {
        name: "7kw5zl",
        styles: "background-color:var(--ds-background-accent-teal-bolder, #227D9B);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    orangeBold: {
        name: "h77eay",
        styles: "background-color:var(--ds-background-accent-orange-bolder, #C25100);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    yellowBold: {
        name: "sbe4w3",
        styles: "background-color:var(--ds-background-accent-yellow-bolder, #946F00);color:var(--ds-icon-inverse, #FFFFFF)"
    },
    gray: {
        name: "yxgei8",
        styles: "background-color:var(--ds-background-accent-gray-subtler, #DCDFE4);color:var(--ds-icon-accent-gray, #758195)"
    },
    lime: {
        name: "o9c6oh",
        styles: "background-color:var(--ds-background-accent-lime-subtler, #D3F1A7);color:var(--ds-icon-accent-lime, #6A9A23)"
    },
    orange: {
        name: "szqzk5",
        styles: "background-color:var(--ds-background-accent-orange-subtler, #FEDEC8);color:var(--ds-icon-accent-orange, #E56910)"
    },
    magenta: {
        name: "o6ptuw",
        styles: "background-color:var(--ds-background-accent-magenta-subtler, #FDD0EC);color:var(--ds-icon-accent-magenta, #CD519D)"
    },
    green: {
        name: "157dg7e",
        styles: "background-color:var(--ds-background-accent-green-subtler, #BAF3DB);color:var(--ds-icon-accent-green, #22A06B)"
    },
    blue: {
        name: "x3nujl",
        styles: "background-color:var(--ds-background-accent-blue-subtler, #CCE0FF);color:var(--ds-icon-accent-blue, #1D7AFC)"
    },
    red: {
        name: "zqoyws",
        styles: "background-color:var(--ds-background-accent-red-subtler, #FFD5D2);color:var(--ds-icon-accent-red, #C9372C)"
    },
    purple: {
        name: "fitjkd",
        styles: "background-color:var(--ds-background-accent-purple-subtler, #DFD8FD);color:var(--ds-icon-accent-purple, #8270DB)"
    },
    teal: {
        name: "b3m1ww",
        styles: "background-color:var(--ds-background-accent-teal-subtler, #C6EDFB);color:var(--ds-icon-accent-teal, #2898BD)"
    },
    yellow: {
        name: "1j18jub",
        styles: "background-color:var(--ds-background-accent-yellow-subtler, #F8E6A0);color:var(--ds-icon-accent-yellow, #B38600)"
    }
};
const $0edd8123bdd94131$var$shapeMap = {
    square: {
        name: "vwdoqr",
        styles: "border-radius:var(--ds-border-radius-100, 4px)"
    },
    circle: {
        name: "i2ucdk",
        styles: "border-radius:var(--ds-border-radius-circle, 32032px)"
    }
};
const $0edd8123bdd94131$var$iconTileStyles = {
    name: "1ot07ws",
    styles: "display:inline-flex;box-sizing:border-box;align-items:center;justify-content:center;font-size:0"
};
function $0edd8123bdd94131$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', LEGACY_fallbackComponent: LEGACY_fallbackComponent, testId: testId } = props;
    const ExpandedIcon = Icon;
    if (LEGACY_fallbackComponent && !(0, $fHpHg.fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
    else return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        "data-testid": testId,
        css: [
            $0edd8123bdd94131$var$iconTileStyles,
            $0edd8123bdd94131$var$appearanceMap[appearance],
            $0edd8123bdd94131$var$sizeMap[size],
            $0edd8123bdd94131$var$shapeMap[shape]
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(ExpandedIcon, {
        color: "currentColor",
        label: label,
        spacing: "spacious",
        shouldScale: true
    }));
}

});



parcelRegister("beqqV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a870c5fd48dba142$export$2e2bcd8739ae039);

var $bNzv2 = parcelRequire("bNzv2");

var $lvWaO = parcelRequire("lvWaO");

var $lpnOy = parcelRequire("lpnOy");
const $a870c5fd48dba142$var$BlogIconWithColor = (0, $lpnOy.renderIconPerSize)((0, $bNzv2.default), (0, $lvWaO.default));
$a870c5fd48dba142$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $a870c5fd48dba142$export$2e2bcd8739ae039 = $a870c5fd48dba142$var$BlogIconWithColor;

});
parcelRegister("bNzv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5d19508685c3097$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::845767e81b63ae055da0ba81295847f0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9hW6e = parcelRequire("9hW6e");

var $4pYir = parcelRequire("4pYir");

var $fHpHg = parcelRequire("fHpHg");

var $h48qR = parcelRequire("h48qR");
/**
 * __16px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $c5d19508685c3097$var$Blog16Icon = ({ label: label, testId: testId })=>{
    if ((0, $fHpHg.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9hW6e.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4pYir))),
        appearance: "blueBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h48qR.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h48qR.default), {
        label: label,
        testId: testId
    });
};
$c5d19508685c3097$var$Blog16Icon.displayName = 'Blog16Icon';
var $c5d19508685c3097$export$2e2bcd8739ae039 = $c5d19508685c3097$var$Blog16Icon;

});
parcelRegister("4pYir", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::295e96fa490818737b2d2c8ee4291bb5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $337844dabbbbc334$var$_react = $337844dabbbbc334$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $337844dabbbbc334$var$_baseNew = $337844dabbbbc334$var$_interopRequireDefault((parcelRequire("enEmH")));
function $337844dabbbbc334$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuotationMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: blockquote, comment, testimonial, blogs in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $337844dabbbbc334$var$QuotationMarkIcon = (props)=>/*#__PURE__*/ $337844dabbbbc334$var$_react.default.createElement($337844dabbbbc334$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5A2.5 2.5 0 0 0 5.5 10V9H2a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5zM9 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a4 4 0 0 1-4 4v-1.5a2.5 2.5 0 0 0 2.5-2.5V9H11a2 2 0 0 1-2-2zm5.5 3.5V4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$337844dabbbbc334$var$QuotationMarkIcon.displayName = 'QuotationMarkIcon';
var $337844dabbbbc334$var$_default = module.exports.default = $337844dabbbbc334$var$QuotationMarkIcon;

});

parcelRegister("h48qR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8758c4a3659369e9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::387cb99b24103ef6908201cae0580f7c>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $983KX = parcelRequire("983KX");
const $8758c4a3659369e9$var$Blog16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $983KX.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325m7 0a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`,
        ...props,
        size: "small"
    });
$8758c4a3659369e9$var$Blog16Icon.displayName = 'Blog16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8758c4a3659369e9$export$2e2bcd8739ae039 = $8758c4a3659369e9$var$Blog16Icon;

});


parcelRegister("lvWaO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d93d28bb47786965$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bba35c7457f1c82d9d31626969c259a0>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9hW6e = parcelRequire("9hW6e");

var $4pYir = parcelRequire("4pYir");

var $fHpHg = parcelRequire("fHpHg");

var $ivq1C = parcelRequire("ivq1C");
/**
 * __24px `blog` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $d93d28bb47786965$var$Blog24Icon = ({ label: label, testId: testId })=>{
    if ((0, $fHpHg.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9hW6e.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4pYir))),
        appearance: "blueBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ivq1C.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ivq1C.default), {
        label: label,
        testId: testId
    });
};
$d93d28bb47786965$var$Blog24Icon.displayName = 'Blog24Icon';
var $d93d28bb47786965$export$2e2bcd8739ae039 = $d93d28bb47786965$var$Blog24Icon;

});
parcelRegister("ivq1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b43f06dadd7e504e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7682b4d34bd2a783038ec83f3b47a94>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $983KX = parcelRequire("983KX");
const $b43f06dadd7e504e$var$Blog24Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $983KX.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M10.998 9.035a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.013-5.52 3.516-8.18m8.895 0a3.5 3.5 0 1 0-3.046 3.94q-.71 1.254-1.87 2.827a1.17 1.17 0 0 0 .102 1.506.85.85 0 0 0 1.298-.092q4.012-5.52 3.516-8.18M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`,
        ...props,
        size: "medium"
    });
$b43f06dadd7e504e$var$Blog24Icon.displayName = 'Blog24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b43f06dadd7e504e$export$2e2bcd8739ae039 = $b43f06dadd7e504e$var$Blog24Icon;

});



parcelRegister("b5hWa", function(module, exports) {

let $811e134d0601cef2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $811e134d0601cef2$var$load("7Bxig").then(()=>parcelRequire('fbhlk'));

});

parcelRegister("6OsQn", function(module, exports) {

let $4f5dc9601a0cea81$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4f5dc9601a0cea81$var$load("7p0m8").then(()=>parcelRequire('hqXam'));

});

parcelRegister("jsrZA", function(module, exports) {

let $e2a6588e734ef3e7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e2a6588e734ef3e7$var$load("gJXn8").then(()=>parcelRequire('7zgIl'));

});

parcelRegister("enH9y", function(module, exports) {

let $a784aff40e85e6ea$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a784aff40e85e6ea$var$load("h2MrD"),
    $a784aff40e85e6ea$var$load("bYT2S"),
    $a784aff40e85e6ea$var$load("dw98V")
]).then(()=>parcelRequire('1MtMn'));

});

parcelRegister("c0CVJ", function(module, exports) {

let $8be3aedbfd671dc0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8be3aedbfd671dc0$var$load("7tnnn").then(()=>parcelRequire('9hxOY'));

});

parcelRegister("cqHeF", function(module, exports) {

let $90c97369329fc2bd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $90c97369329fc2bd$var$load("kiwYg").then(()=>parcelRequire('ljZl2'));

});

parcelRegister("gOJXC", function(module, exports) {

let $c3e4f7aa4b6a1aa4$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c3e4f7aa4b6a1aa4$var$load("h2MrD"),
    $c3e4f7aa4b6a1aa4$var$load("bYT2S"),
    $c3e4f7aa4b6a1aa4$var$load("lbZEZ")
]).then(()=>parcelRequire('6xd5I'));

});

parcelRegister("hZ2BU", function(module, exports) {

let $d17a288be39ee61b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d17a288be39ee61b$var$load("iAuJp").then(()=>parcelRequire('IWQJN'));

});

parcelRegister("d1JZm", function(module, exports) {

let $97bf0ac67b7c1efe$var$load = (parcelRequire("28QjX"))(4);
module.exports = $97bf0ac67b7c1efe$var$load("f2LEG").then(()=>parcelRequire('fVUwb'));

});

parcelRegister("4erTB", function(module, exports) {

let $314e1bc53c0ff790$var$load = (parcelRequire("28QjX"))(4);
module.exports = $314e1bc53c0ff790$var$load("g8VDb").then(()=>parcelRequire('dU448'));

});

parcelRegister("c95g7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c2e6e563a714afa66b2c445d0695bd6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d7a67a528197b47$var$_react = $8d7a67a528197b47$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8d7a67a528197b47$var$_link = $8d7a67a528197b47$var$_interopRequireDefault((parcelRequire("bDHz4")));

var $8d7a67a528197b47$var$_link2 = $8d7a67a528197b47$var$_interopRequireDefault((parcelRequire("5gmaZ")));
function $8d7a67a528197b47$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8d7a67a528197b47$var$LinkIcon = (props)=>/*#__PURE__*/ $8d7a67a528197b47$var$_react.default.createElement($8d7a67a528197b47$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $8d7a67a528197b47$var$_link2.default
    }, props));
$8d7a67a528197b47$var$LinkIcon.Name = 'LinkIconMigration';
var $8d7a67a528197b47$var$_default = module.exports.default = $8d7a67a528197b47$var$LinkIcon;

});
parcelRegister("bDHz4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8795214424a53a62$var$_react = $8795214424a53a62$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8795214424a53a62$var$_baseNew = $8795214424a53a62$var$_interopRequireDefault((parcelRequire("enEmH")));
function $8795214424a53a62$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8795214424a53a62$var$LinkIcon = (props)=>/*#__PURE__*/ $8795214424a53a62$var$_react.default.createElement($8795214424a53a62$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$8795214424a53a62$var$LinkIcon.displayName = 'LinkIcon';
var $8795214424a53a62$var$_default = module.exports.default = $8795214424a53a62$var$LinkIcon;

});

parcelRegister("5gmaZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d4fa62011caab87$var$_react = $3d4fa62011caab87$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $3d4fa62011caab87$var$_link = $3d4fa62011caab87$var$_interopRequireDefault((parcelRequire("bDHz4")));
function $3d4fa62011caab87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3d4fa62011caab87$var$LinkIcon = (props)=>/*#__PURE__*/ $3d4fa62011caab87$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $3d4fa62011caab87$var$_link.default
    }));
$3d4fa62011caab87$var$LinkIcon.displayName = 'LinkIcon';
var $3d4fa62011caab87$var$_default = module.exports.default = $3d4fa62011caab87$var$LinkIcon;

});


parcelRegister("9puLh", function(module, exports) {

let $6d9e4f72147c1e8b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6d9e4f72147c1e8b$var$load("gv2np").then(()=>parcelRequire('6EPwW'));

});

parcelRegister("dklyN", function(module, exports) {

let $9b3dde0a292cb4a4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9b3dde0a292cb4a4$var$load("fqY8r").then(()=>parcelRequire('f4IUb'));

});

parcelRegister("21HEi", function(module, exports) {

let $179d8886d4116a24$var$load = (parcelRequire("28QjX"))(4);
module.exports = $179d8886d4116a24$var$load("3KgK2").then(()=>parcelRequire('6LFfW'));

});

parcelRegister("fQsqy", function(module, exports) {

let $b891c36c6ee36749$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b891c36c6ee36749$var$load("bjMbm").then(()=>parcelRequire('5U2qg'));

});

parcelRegister("8AqA8", function(module, exports) {

let $64064e186b642f5e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $64064e186b642f5e$var$load("d6kD8").then(()=>parcelRequire('ivUrz'));

});

parcelRegister("bV3UB", function(module, exports) {

let $8ad80d6dca5cfeb3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8ad80d6dca5cfeb3$var$load("avMjG").then(()=>parcelRequire('iss0x'));

});

parcelRegister("eLRGh", function(module, exports) {

let $ac0f186000cdfaad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ac0f186000cdfaad$var$load("5FLWf").then(()=>parcelRequire('jAQok'));

});

parcelRegister("7ssM4", function(module, exports) {

let $56e177ee0ebfec6e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $56e177ee0ebfec6e$var$load("fR83L").then(()=>parcelRequire('3UE4V'));

});

parcelRegister("7psNY", function(module, exports) {

let $56513649dab24807$var$load = (parcelRequire("28QjX"))(4);
module.exports = $56513649dab24807$var$load("b7FF0").then(()=>parcelRequire('keUOR'));

});

parcelRegister("fvwXh", function(module, exports) {

let $b4a3507b73ea305a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b4a3507b73ea305a$var$load("19uQV").then(()=>parcelRequire('asG7N'));

});

parcelRegister("g0Y2J", function(module, exports) {

let $ba8b38b998ce533d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ba8b38b998ce533d$var$load("cu15e").then(()=>parcelRequire('kQFYg'));

});

parcelRegister("5CNHY", function(module, exports) {

let $41870f65235e9d46$var$load = (parcelRequire("28QjX"))(4);
module.exports = $41870f65235e9d46$var$load("d9fZI").then(()=>parcelRequire('id8bM'));

});

parcelRegister("5HDoK", function(module, exports) {

let $426f878b4121977b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $426f878b4121977b$var$load("2gBml").then(()=>parcelRequire('eZz58'));

});

parcelRegister("aN944", function(module, exports) {

let $7db5830dec33f294$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7db5830dec33f294$var$load("81fNp").then(()=>parcelRequire('ep6Xe'));

});

parcelRegister("kGCQL", function(module, exports) {

let $f0f5ddb5338db907$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f0f5ddb5338db907$var$load("4B04n").then(()=>parcelRequire('1bKH8'));

});

parcelRegister("4Pf4L", function(module, exports) {

let $38379e91fdd15af0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $38379e91fdd15af0$var$load("22aS6").then(()=>parcelRequire('48wUg'));

});

parcelRegister("5Wydb", function(module, exports) {

let $453ce842b5513433$var$load = (parcelRequire("28QjX"))(4);
module.exports = $453ce842b5513433$var$load("eRJXJ").then(()=>parcelRequire('7k2Un'));

});

parcelRegister("dznHy", function(module, exports) {

let $9e10eddc7a338d47$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9e10eddc7a338d47$var$load("3Vhej").then(()=>parcelRequire('53v0L'));

});

parcelRegister("42NaT", function(module, exports) {

let $2f1d7e68f030cd96$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2f1d7e68f030cd96$var$load("bSFU9").then(()=>parcelRequire('baUFf'));

});

parcelRegister("hw1ma", function(module, exports) {

let $cc067a3218c540cc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cc067a3218c540cc$var$load("dbXh5").then(()=>parcelRequire('63ni3'));

});

parcelRegister("hrPZz", function(module, exports) {

let $cb3d49d299c8429d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cb3d49d299c8429d$var$load("2lEeJ").then(()=>parcelRequire('gH8rQ'));

});

parcelRegister("kbikZ", function(module, exports) {

let $eb130f2bf0321d0b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eb130f2bf0321d0b$var$load("kQYS0").then(()=>parcelRequire('eOyqU'));

});

parcelRegister("gcXvG", function(module, exports) {

let $bccbedc69a61992f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bccbedc69a61992f$var$load("fgGeY").then(()=>parcelRequire('9ElpP'));

});

parcelRegister("dqxeZ", function(module, exports) {

let $9c677d008d9c6fd2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9c677d008d9c6fd2$var$load("3tlQy").then(()=>parcelRequire('cmiE6'));

});

parcelRegister("dtRZ8", function(module, exports) {

let $9d07dc1a4fbb758f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9d07dc1a4fbb758f$var$load("iiNz6").then(()=>parcelRequire('mOZqB'));

});

parcelRegister("hE4nB", function(module, exports) {

let $cd8991d1a3468c34$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cd8991d1a3468c34$var$load("bcNqR").then(()=>parcelRequire('ekQSk'));

});

parcelRegister("Hrhdz", function(module, exports) {

let $08292cda4bf3fc3d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $08292cda4bf3fc3d$var$load("dCNPr").then(()=>parcelRequire('8XnuE'));

});

parcelRegister("gIeuD", function(module, exports) {

let $c2abff70594dbf9e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c2abff70594dbf9e$var$load("dVwCr").then(()=>parcelRequire('hCRoC'));

});

parcelRegister("2SZmt", function(module, exports) {

let $21a0390c8da9d573$var$load = (parcelRequire("28QjX"))(4);
module.exports = $21a0390c8da9d573$var$load("iLmcq").then(()=>parcelRequire('dH5jN'));

});

parcelRegister("2n0lf", function(module, exports) {

let $1b9dfea1c2151f80$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1b9dfea1c2151f80$var$load("bzp6w").then(()=>parcelRequire('hC70R'));

});

parcelRegister("4lk7q", function(module, exports) {

let $3298bac5be6aba64$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3298bac5be6aba64$var$load("cTCL4").then(()=>parcelRequire('2FdfY'));

});

parcelRegister("1kUDA", function(module, exports) {

let $0f9397baf98eefcb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0f9397baf98eefcb$var$load("knC8N").then(()=>parcelRequire('dwiQZ'));

});

parcelRegister("9KliZ", function(module, exports) {

let $7188efbcb7dc6bd0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7188efbcb7dc6bd0$var$load("idaew").then(()=>parcelRequire('lkjMR'));

});

parcelRegister("hBBc2", function(module, exports) {

let $cd12be21c5f6aa4c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cd12be21c5f6aa4c$var$load("6uKzP").then(()=>parcelRequire('eD5Cp'));

});

parcelRegister("cV05C", function(module, exports) {

let $967ae0b63084b63b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $967ae0b63084b63b$var$load("9T5ji").then(()=>parcelRequire('iVMFg'));

});

parcelRegister("9KJn0", function(module, exports) {

let $719b9a77fbab642b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $719b9a77fbab642b$var$load("2dAP4").then(()=>parcelRequire('23Ehe'));

});

parcelRegister("aJKNn", function(module, exports) {

let $7d1267eb3333bc1a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7d1267eb3333bc1a$var$load("5MTPW").then(()=>parcelRequire('g9336'));

});

parcelRegister("3ETEX", function(module, exports) {

let $2aa0485d21823c1e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2aa0485d21823c1e$var$load("3sOAt").then(()=>parcelRequire('jPICi'));

});

parcelRegister("pNRmB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bdd5c6204bb6a835$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c1228c9bdd9840505938b56c7ed44212>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9hW6e = parcelRequire("9hW6e");

var $aJxly = parcelRequire("aJxly");

var $fHpHg = parcelRequire("fHpHg");

var $e6VbZ = parcelRequire("e6VbZ");
/**
 * __16px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $bdd5c6204bb6a835$var$PageLiveDoc16Icon = ({ label: label, testId: testId })=>{
    if ((0, $fHpHg.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9hW6e.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aJxly))),
        appearance: "magentaBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e6VbZ.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e6VbZ.default), {
        label: label,
        testId: testId
    });
};
$bdd5c6204bb6a835$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var $bdd5c6204bb6a835$export$2e2bcd8739ae039 = $bdd5c6204bb6a835$var$PageLiveDoc16Icon;

});
parcelRegister("aJxly", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::622b66f09f9810e3f6fbdd627d1ccd29>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d07f94b6b1d9fd8$var$_react = $7d07f94b6b1d9fd8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7d07f94b6b1d9fd8$var$_baseNew = $7d07f94b6b1d9fd8$var$_interopRequireDefault((parcelRequire("enEmH")));
function $7d07f94b6b1d9fd8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7d07f94b6b1d9fd8$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $7d07f94b6b1d9fd8$var$_react.default.createElement($7d07f94b6b1d9fd8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h4.5V15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4.5h-1.5zM12 6H4V4.5h8zM9 9.5H4V8h5z" clip-rule="evenodd"/><path fill="currentcolor" d="m8.59 12.207 3.093-4.488c.314-.456 1.026-.14.898.4l-.481 2.014a.25.25 0 0 0 .243.308h2.16a.5.5 0 0 1 .412.783l-3.093 4.489c-.315.455-1.027.138-.898-.4l.48-2.014a.25.25 0 0 0-.243-.308h-2.16a.5.5 0 0 1-.412-.784"/>`
    }, props));
$7d07f94b6b1d9fd8$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $7d07f94b6b1d9fd8$var$_default = module.exports.default = $7d07f94b6b1d9fd8$var$PageLiveDocIcon;

});

parcelRegister("e6VbZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $41cb11de573b4eb2$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17c8c810f288fa2c4d58e06371883a6e>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $983KX = parcelRequire("983KX");
const $41cb11de573b4eb2$var$PageLiveDoc16Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $983KX.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M3 4a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h2.5a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m8.293-5.793-2.854 4.05c-.21.314.009.743.38.743h1.993c.149 0 .259.143.224.292l-.443 2.121c-.119.511.538.812.828.38l2.854-4.05c.21-.314-.008-.743-.38-.743h-1.993a.236.236 0 0 1-.224-.292l.443-2.121c.119-.511-.538-.812-.828-.38" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "small"
    });
$41cb11de573b4eb2$var$PageLiveDoc16Icon.displayName = 'PageLiveDoc16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$41cb11de573b4eb2$export$2e2bcd8739ae039 = $41cb11de573b4eb2$var$PageLiveDoc16Icon;

});


parcelRegister("44Gio", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fb3f2bdbb70bc5f1$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::724c9bd5f0d44d16613664f162286445>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9hW6e = parcelRequire("9hW6e");

var $aJxly = parcelRequire("aJxly");

var $fHpHg = parcelRequire("fHpHg");

var $lF4RB = parcelRequire("lF4RB");
/**
 * __24px `page-live-doc` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $fb3f2bdbb70bc5f1$var$PageLiveDoc24Icon = ({ label: label, testId: testId })=>{
    if ((0, $fHpHg.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9hW6e.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aJxly))),
        appearance: "magentaBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lF4RB.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lF4RB.default), {
        label: label,
        testId: testId
    });
};
$fb3f2bdbb70bc5f1$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var $fb3f2bdbb70bc5f1$export$2e2bcd8739ae039 = $fb3f2bdbb70bc5f1$var$PageLiveDoc24Icon;

});
parcelRegister("lF4RB", function(module, exports) {

$parcel$export(module.exports, "default", () => $03ae0f6e8b704939$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::15139b5f4236bc308adc0b1e9c84b98b>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $983KX = parcelRequire("983KX");
const $03ae0f6e8b704939$var$PageLiveDoc24Icon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $983KX.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#cd519d" fill-rule="evenodd" d="M24 3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3zM5.125 4.875h13.75l.153.01a1.125 1.125 0 0 1 0 2.23l-.153.01H5.125l-.153-.01a1.125 1.125 0 0 1 0-2.23zm5.25 6h-5.25l-.153.01a1.125 1.125 0 0 0 0 2.23l.153.01h5.25l.153-.01a1.125 1.125 0 0 0 0-2.23zm-.5 6h-4.75l-.153.01a1.125 1.125 0 0 0 0 2.23l.153.01h4.75l.153-.01a1.125 1.125 0 0 0 0-2.23zm7.029-7.564-4.28 6.073c-.317.473.012 1.116.57 1.116h2.988c.224 0 .389.215.337.438l-.665 3.182c-.178.766.807 1.218 1.242.569l4.28-6.073c.317-.473-.012-1.116-.57-1.116h-2.988a.353.353 0 0 1-.337-.438l.665-3.182c.178-.766-.808-1.218-1.242-.569" clip-rule="evenodd"/></svg>`,
        ...props,
        size: "medium"
    });
$03ae0f6e8b704939$var$PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$03ae0f6e8b704939$export$2e2bcd8739ae039 = $03ae0f6e8b704939$var$PageLiveDoc24Icon;

});


parcelRegister("3RWFB", function(module, exports) {

let $2d13d4f7dff55b5f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2d13d4f7dff55b5f$var$load("XRHdy").then(()=>parcelRequire('d0RKL'));

});

parcelRegister("eqHIz", function(module, exports) {

let $a81567db69594378$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a81567db69594378$var$load("lBiSz").then(()=>parcelRequire('ef0Q5'));

});

parcelRegister("aCO9Z", function(module, exports) {

let $7bc45cbea5b677ac$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7bc45cbea5b677ac$var$load("d6E0W").then(()=>parcelRequire('arNqo'));

});

parcelRegister("5mMrn", function(module, exports) {

let $3e84951f73cbf9f2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3e84951f73cbf9f2$var$load("r9Hn2").then(()=>parcelRequire('7oWcK'));

});

parcelRegister("2rQWl", function(module, exports) {

let $1c872b2a08c9d520$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1c872b2a08c9d520$var$load("aTMJq").then(()=>parcelRequire('46bVa'));

});

parcelRegister("jeWP1", function(module, exports) {

let $e01cf3f068e4ef88$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e01cf3f068e4ef88$var$load("4xN4A").then(()=>parcelRequire('98VOu'));

});

parcelRegister("gMDFI", function(module, exports) {

let $c37fe70f109b78ee$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c37fe70f109b78ee$var$load("2JrEQ").then(()=>parcelRequire('jJL9z'));

});

parcelRegister("4fkVg", function(module, exports) {

let $3178caf18816bb57$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3178caf18816bb57$var$load("czPXX").then(()=>parcelRequire('3pKEh'));

});

parcelRegister("fgN6p", function(module, exports) {

let $b1de7052f50bfcad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b1de7052f50bfcad$var$load("bW2Ht").then(()=>parcelRequire('k7gBp'));

});

parcelRegister("cV2N9", function(module, exports) {

let $967cf94be8e9a9d5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $967cf94be8e9a9d5$var$load("jlDVs").then(()=>parcelRequire('Le10t'));

});

parcelRegister("eVavM", function(module, exports) {

let $adce8af64095102c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $adce8af64095102c$var$load("9n8Rc").then(()=>parcelRequire('kc1MS'));

});

parcelRegister("56RVo", function(module, exports) {

let $3b87579a8c1c9c89$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3b87579a8c1c9c89$var$load("a0ALI").then(()=>parcelRequire('hfn9j'));

});

parcelRegister("ktXnL", function(module, exports) {

let $ee94942a5dcf51e4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ee94942a5dcf51e4$var$load("kFjg9").then(()=>parcelRequire('4zl0K'));

});

parcelRegister("9mM5H", function(module, exports) {

let $6d1b79007a44e718$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6d1b79007a44e718$var$load("50gXn").then(()=>parcelRequire('cfbO3'));

});

parcelRegister("1O0Re", function(module, exports) {

let $150b203f6494e0b7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $150b203f6494e0b7$var$load("1Bya1").then(()=>parcelRequire('jyFo7'));

});

parcelRegister("lGGho", function(module, exports) {

let $fc9e510f6e16a672$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc9e510f6e16a672$var$load("6xK7c").then(()=>parcelRequire('eJNZM'));

});

parcelRegister("cwmVk", function(module, exports) {

let $91da415d9c09f1a2$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $91da415d9c09f1a2$var$load("h2MrD"),
    $91da415d9c09f1a2$var$load("bYT2S"),
    $91da415d9c09f1a2$var$load("7Q5Zb")
]).then(()=>parcelRequire('dsSeT'));

});

parcelRegister("gasRl", function(module, exports) {

let $bc53f76066416c2b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bc53f76066416c2b$var$load("56fL9").then(()=>parcelRequire('af7Zc'));

});

parcelRegister("k978r", function(module, exports) {

let $eaaa2ec96843fef8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eaaa2ec96843fef8$var$load("6SGih").then(()=>parcelRequire('bWXJS'));

});


parcelRegister("gSiht", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkAnalyticsContext", () => $8078899623c4d78c$export$ac28ada90c4970b7);
$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $8078899623c4d78c$export$eaff10f7ec59c455);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $htBRZ = parcelRequire("htBRZ");

var $bk0S0 = parcelRequire("bk0S0");

var $2yoyZ = parcelRequire("2yoyZ");

var $6YE6Y = parcelRequire("6YE6Y");

var $fHpHg = parcelRequire("fHpHg");

var $1q6WT = parcelRequire("1q6WT");

var $4c7pe = parcelRequire("4c7pe");
const $8078899623c4d78c$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>({
        definitionId: details?.meta?.definitionId ?? null,
        resourceType: details?.meta?.resourceType ?? null,
        ...(0, $bk0S0.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    });
const $8078899623c4d78c$var$getSmartLinkAnalyticsContext = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const resolvedAttributes = $8078899623c4d78c$var$getExtendedResolvedAttributes({
        url: url
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $4c7pe.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
const $8078899623c4d78c$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $2yoyZ.useSmartLinkContext)();
    const state = store ? (0, $6YE6Y.getUrl)(store, url) : undefined;
    return (0, $5uXOq.useMemo)(()=>{
        return $8078899623c4d78c$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state?.details,
            source: source,
            status: state?.status,
            url: url,
            error: state?.error
        });
    }, [
        display,
        id,
        source,
        state?.details,
        state?.status,
        url,
        state?.error
    ]);
};
const $8078899623c4d78c$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status, error: error } = (0, $1q6WT.useSmartCardState)(url);
    const data = $8078899623c4d78c$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $fHpHg.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $htBRZ.default), {
        data: data,
        children: children
    });
};

});
parcelRegister("bk0S0", function(module, exports) {

$parcel$export(module.exports, "getResolvedAttributes", () => $132621b64053f2c2$export$7243431f5325a7b);

var $c8Wzl = parcelRequire("c8Wzl");

var $4X53C = parcelRequire("4X53C");

var $fHpHg = parcelRequire("fHpHg");
const $132621b64053f2c2$export$7243431f5325a7b = (linkDetails, details, linkStatus, error)=>{
    const status = linkStatus ?? (details && (0, $c8Wzl.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $4X53C.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: (0, $fHpHg.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? details?.meta?.key ?? error?.extensionKey ?? null : details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationActivationId: details?.meta?.activationId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};

});
parcelRegister("4X53C", function(module, exports) {

$parcel$export(module.exports, "getDisplayCategory", () => $c32ea35a98c73f5b$export$28ddbae335bd80b5);
const $c32ea35a98c73f5b$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});


parcelRegister("1q6WT", function(module, exports) {

$parcel$export(module.exports, "useSmartCardState", () => $929766de6f1781d2$export$b0444d00ba7313c6);

var $bDWQ3 = parcelRequire("bDWQ3");

var $2yoyZ = parcelRequire("2yoyZ");
const $929766de6f1781d2$var$PENDING_STATE = {
    status: 'pending'
};
function $929766de6f1781d2$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $2yoyZ.useSmartLinkContext)();
    const cardState = (0, $bDWQ3.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $929766de6f1781d2$var$PENDING_STATE;
}

});


parcelRegister("kYS90", function(module, exports) {

$parcel$export(module.exports, "isFlexibleUiCard", () => $750a2888ff5384e4$export$3c94e0f4719f5c2a);
$parcel$export(module.exports, "isFlexibleUiTitleBlock", () => $750a2888ff5384e4$export$df0092b19156b140);
$parcel$export(module.exports, "isStyleCacheProvider", () => $750a2888ff5384e4$export$14ff825bfe645006);
$parcel$export(module.exports, "isFlexibleUiBlock", () => $750a2888ff5384e4$export$b56fc89cf6e7d1e9);
$parcel$export(module.exports, "isFlexibleUiElement", () => $750a2888ff5384e4$export$d7fc505bb0bd5756);
$parcel$export(module.exports, "isFlexibleUiPreviewBlock", () => $750a2888ff5384e4$export$c0547b4405cae584);

var $5uXOq = parcelRequire("5uXOq");

var $5qsOP = parcelRequire("5qsOP");
var $2QXYS = parcelRequire("2QXYS");
var $hCJ5I = parcelRequire("hCJ5I");
var $ejUON = parcelRequire("ejUON");

var $5wGZS = parcelRequire("5wGZS");
const $750a2888ff5384e4$export$3c94e0f4719f5c2a = (children)=>{
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children).some((child)=>$750a2888ff5384e4$export$df0092b19156b140(child))) return true;
    return false;
};
const $750a2888ff5384e4$export$14ff825bfe645006 = (node)=>{
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) return true;
    else if (typeof node.type !== 'string' && node.type?.name === 'CC' && node.props.children) return true;
    return false;
};
const $750a2888ff5384e4$export$b56fc89cf6e7d1e9 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if ($750a2888ff5384e4$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $750a2888ff5384e4$export$b56fc89cf6e7d1e9(child);
        });
        return isChildrenValid;
    }
    if (Object.values($5qsOP).some((type)=>type === node.type)) return true;
    return false;
};
const $750a2888ff5384e4$export$d7fc505bb0bd5756 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (Object.values($5wGZS).some((type)=>type === node.type)) return true;
    if ($750a2888ff5384e4$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $750a2888ff5384e4$export$d7fc505bb0bd5756(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $750a2888ff5384e4$export$df0092b19156b140 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (node.type === (0, $2QXYS.default)) return true;
    if ($750a2888ff5384e4$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $750a2888ff5384e4$export$df0092b19156b140(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $750a2888ff5384e4$export$c0547b4405cae584 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node)) return false;
    if (node.type === (0, $hCJ5I.default)) return true;
    if ($750a2888ff5384e4$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $750a2888ff5384e4$export$c0547b4405cae584(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $750a2888ff5384e4$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, $ejUON.default);

});
parcelRegister("5qsOP", function(module, exports) {

$parcel$export(module.exports, "FooterBlock", () => (parcelRequire("ejUON")).default);
$parcel$export(module.exports, "MetadataBlock", () => (parcelRequire("8JDQn")).default);
$parcel$export(module.exports, "PreviewBlock", () => (parcelRequire("hCJ5I")).default);
$parcel$export(module.exports, "SnippetBlock", () => (parcelRequire("7Ki03")).default);
$parcel$export(module.exports, "TitleBlock", () => (parcelRequire("2QXYS")).default);
$parcel$export(module.exports, "CustomBlock", () => (parcelRequire("5zLRC")).default);
$parcel$export(module.exports, "InternalFooterBlock", () => (parcelRequire("fIxN9")).default);
$parcel$export(module.exports, "AISummaryBlock", () => (parcelRequire("9Ecm1")).default);
$parcel$export(module.exports, "AIFooterBlock", () => (parcelRequire("gDNla")).default);
$parcel$export(module.exports, "ActionBlock", () => (parcelRequire("U37hx")).default);

var $ejUON = parcelRequire("ejUON");

var $8JDQn = parcelRequire("8JDQn");

var $hCJ5I = parcelRequire("hCJ5I");

var $7Ki03 = parcelRequire("7Ki03");

var $2QXYS = parcelRequire("2QXYS");

var $5zLRC = parcelRequire("5zLRC");

var $fIxN9 = parcelRequire("fIxN9");

var $9Ecm1 = parcelRequire("9Ecm1");

var $gDNla = parcelRequire("gDNla");

var $U37hx = parcelRequire("U37hx");

});
parcelRegister("ejUON", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbd2e0913e686d78$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bUpbd = parcelRequire("bUpbd");

var $fIxN9 = parcelRequire("fIxN9");
/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $dbd2e0913e686d78$var$FooterBlock = ({ status: status, testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    if (status !== (0, $bUpbd.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fIxN9.default), {
        ...props,
        testId: testId
    });
};
var $dbd2e0913e686d78$export$2e2bcd8739ae039 = $dbd2e0913e686d78$var$FooterBlock;

});
parcelRegister("fIxN9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a6c540781fec32d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $bUpbd = parcelRequire("bUpbd");

var $gSLUn = parcelRequire("gSLUn");

var $5wGZS = parcelRequire("5wGZS");

var $3Uo8j = parcelRequire("3Uo8j");

var $5zLRC = parcelRequire("5zLRC");

var $hWtFf = parcelRequire("hWtFf");

var $S0OVy = parcelRequire("S0OVy");
const $7a6c540781fec32d$var$actionGroupStylesOld = null;
const $7a6c540781fec32d$var$actionGroupStyles = null;
const $7a6c540781fec32d$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $bUpbd.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $gSLUn.useFlexibleUiContext)();
    const hasActions = (0, $5uXOq.useMemo)(()=>(0, $S0OVy.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]);
    const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5zLRC.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            !hideProvider && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5wGZS.Provider), {
                ...(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') ? {
                    appearance: 'subtle'
                } : {},
                testId: `${testId}-provider`
            }),
            actions && hasActions ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hWtFf.default), {
                testId: "smart-element-group-actions",
                align: (0, $bUpbd.SmartLinkAlignment).Right,
                direction: (0, $bUpbd.SmartLinkDirection).Horizontal,
                ...(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') ? {
                    css: size === (0, $bUpbd.SmartLinkSize).XLarge && $7a6c540781fec32d$var$actionGroupStyles
                } : {
                    css: size === (0, $bUpbd.SmartLinkSize).XLarge && $7a6c540781fec32d$var$actionGroupStylesOld
                },
                width: (0, $bUpbd.SmartLinkWidth).Flexible,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Uo8j.default), {
                    onDropdownOpenChange: onDropdownOpenChange,
                    items: actions,
                    appearance: "default",
                    size: size
                })
            }) : null
        ]
    });
};
var $7a6c540781fec32d$export$2e2bcd8739ae039 = $7a6c540781fec32d$var$FooterBlockResolvedView;

});
parcelRegister("gSLUn", function(module, exports) {

$parcel$export(module.exports, "FlexibleUiContext", () => $6ed7292f85c85b1a$export$ca70b164b615de47);
$parcel$export(module.exports, "useFlexibleUiContext", () => $6ed7292f85c85b1a$export$61d7957a243df7aa);
$parcel$export(module.exports, "FlexibleUiOptionContext", () => $6ed7292f85c85b1a$export$f7433dbd6c50e26a);
$parcel$export(module.exports, "useFlexibleUiOptionContext", () => $6ed7292f85c85b1a$export$e6b5ad18b56e8f51);

var $5uXOq = parcelRequire("5uXOq");
const $6ed7292f85c85b1a$export$ca70b164b615de47 = (0, $5uXOq.createContext)(undefined);
const $6ed7292f85c85b1a$export$61d7957a243df7aa = ()=>(0, $5uXOq.useContext)($6ed7292f85c85b1a$export$ca70b164b615de47);
const $6ed7292f85c85b1a$export$f7433dbd6c50e26a = (0, $5uXOq.createContext)(undefined);
const $6ed7292f85c85b1a$export$e6b5ad18b56e8f51 = ()=>(0, $5uXOq.useContext)($6ed7292f85c85b1a$export$f7433dbd6c50e26a);

});

parcelRegister("5wGZS", function(module, exports) {

$parcel$export(module.exports, "AssignedTo", () => $1f61c22c1a2f731c$export$d3af56c23f9e459b);
$parcel$export(module.exports, "AssignedToGroup", () => $1f61c22c1a2f731c$export$fbd18f11bf3a3444);
$parcel$export(module.exports, "AttachmentCount", () => $1f61c22c1a2f731c$export$3bc3c9693a40aa);
$parcel$export(module.exports, "AuthorGroup", () => $1f61c22c1a2f731c$export$2ae2af4435dd6144);
$parcel$export(module.exports, "ChecklistProgress", () => $1f61c22c1a2f731c$export$5742b38fd5cfe410);
$parcel$export(module.exports, "CollaboratorGroup", () => $1f61c22c1a2f731c$export$a1e647014985ddb9);
$parcel$export(module.exports, "CommentCount", () => $1f61c22c1a2f731c$export$f4c1466e6fdd07b);
$parcel$export(module.exports, "CreatedOn", () => $1f61c22c1a2f731c$export$53ced9403d373871);
$parcel$export(module.exports, "CreatedBy", () => $1f61c22c1a2f731c$export$db468caedefbb630);
$parcel$export(module.exports, "DueOn", () => $1f61c22c1a2f731c$export$fea59459cfa1625b);
$parcel$export(module.exports, "LatestCommit", () => $1f61c22c1a2f731c$export$2aa8c58ab6c8ae64);
$parcel$export(module.exports, "LinkIcon", () => $1f61c22c1a2f731c$export$69387b41dfc808f7);
$parcel$export(module.exports, "Location", () => $1f61c22c1a2f731c$export$18a2be9195644f38);
$parcel$export(module.exports, "ModifiedBy", () => $1f61c22c1a2f731c$export$ebbbdcc68d717b7b);
$parcel$export(module.exports, "ModifiedOn", () => $1f61c22c1a2f731c$export$a6db3f4240728b58);
$parcel$export(module.exports, "OwnedBy", () => $1f61c22c1a2f731c$export$fa04b1f8d953704f);
$parcel$export(module.exports, "OwnedByGroup", () => $1f61c22c1a2f731c$export$90e81c873cca1e90);
$parcel$export(module.exports, "Priority", () => $1f61c22c1a2f731c$export$300334f671c43555);
$parcel$export(module.exports, "ProgrammingLanguage", () => $1f61c22c1a2f731c$export$7904b5485bf997ea);
$parcel$export(module.exports, "Provider", () => $1f61c22c1a2f731c$export$2881499e37b75b9a);
$parcel$export(module.exports, "ReactCount", () => $1f61c22c1a2f731c$export$f69df2decd5f729e);
$parcel$export(module.exports, "ReadTime", () => $1f61c22c1a2f731c$export$77dedcd16f070a20);
$parcel$export(module.exports, "SentOn", () => $1f61c22c1a2f731c$export$897b145a1ed39fe5);
$parcel$export(module.exports, "SourceBranch", () => $1f61c22c1a2f731c$export$387c3264a8f67d61);
$parcel$export(module.exports, "State", () => $1f61c22c1a2f731c$export$7254cc27399e90bd);
$parcel$export(module.exports, "SubscriberCount", () => $1f61c22c1a2f731c$export$cfafe90bba8a54db);
$parcel$export(module.exports, "SubTasksProgress", () => $1f61c22c1a2f731c$export$d441f34e4c8dd9e7);
$parcel$export(module.exports, "StoryPoints", () => $1f61c22c1a2f731c$export$634eef04d1a9a575);
$parcel$export(module.exports, "TargetBranch", () => $1f61c22c1a2f731c$export$b5e4199e062b8f44);
$parcel$export(module.exports, "Title", () => $1f61c22c1a2f731c$export$f99233281efd08a0);
$parcel$export(module.exports, "ViewCount", () => $1f61c22c1a2f731c$export$ae2d8be089b6cfe0);
$parcel$export(module.exports, "VoteCount", () => $1f61c22c1a2f731c$export$b080bef6ed7fa75a);
$parcel$export(module.exports, "Preview", () => (parcelRequire("atbcR")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("jmfre")).default);

var $bUpbd = parcelRequire("bUpbd");

var $kSyvr = parcelRequire("kSyvr");

var $atbcR = parcelRequire("atbcR");

var $jmfre = parcelRequire("jmfre");
const $1f61c22c1a2f731c$export$d3af56c23f9e459b = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).AssignedTo);
const $1f61c22c1a2f731c$export$fbd18f11bf3a3444 = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).AssignedToGroup);
const $1f61c22c1a2f731c$export$3bc3c9693a40aa = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).AttachmentCount);
const $1f61c22c1a2f731c$export$2ae2af4435dd6144 = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).AuthorGroup);
const $1f61c22c1a2f731c$export$5742b38fd5cfe410 = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).ChecklistProgress);
const $1f61c22c1a2f731c$export$a1e647014985ddb9 = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).CollaboratorGroup);
const $1f61c22c1a2f731c$export$f4c1466e6fdd07b = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).CommentCount);
const $1f61c22c1a2f731c$export$53ced9403d373871 = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).CreatedOn);
const $1f61c22c1a2f731c$export$db468caedefbb630 = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).CreatedBy);
const $1f61c22c1a2f731c$export$fea59459cfa1625b = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).DueOn);
const $1f61c22c1a2f731c$export$2aa8c58ab6c8ae64 = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).LatestCommit);
const $1f61c22c1a2f731c$export$69387b41dfc808f7 = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).LinkIcon);
const $1f61c22c1a2f731c$export$18a2be9195644f38 = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).Location);
const $1f61c22c1a2f731c$export$ebbbdcc68d717b7b = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).ModifiedBy);
const $1f61c22c1a2f731c$export$a6db3f4240728b58 = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).ModifiedOn);
const $1f61c22c1a2f731c$export$fa04b1f8d953704f = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).OwnedBy);
const $1f61c22c1a2f731c$export$90e81c873cca1e90 = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).OwnedByGroup);
const $1f61c22c1a2f731c$export$300334f671c43555 = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).Priority);
const $1f61c22c1a2f731c$export$7904b5485bf997ea = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).ProgrammingLanguage);
const $1f61c22c1a2f731c$export$2881499e37b75b9a = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).Provider);
const $1f61c22c1a2f731c$export$f69df2decd5f729e = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).ReactCount);
const $1f61c22c1a2f731c$export$77dedcd16f070a20 = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).ReadTime);
const $1f61c22c1a2f731c$export$897b145a1ed39fe5 = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).SentOn);
const $1f61c22c1a2f731c$export$387c3264a8f67d61 = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).SourceBranch);
const $1f61c22c1a2f731c$export$7254cc27399e90bd = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).State);
const $1f61c22c1a2f731c$export$cfafe90bba8a54db = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).SubscriberCount);
const $1f61c22c1a2f731c$export$d441f34e4c8dd9e7 = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).SubTasksProgress);
const $1f61c22c1a2f731c$export$634eef04d1a9a575 = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).StoryPoints);
const $1f61c22c1a2f731c$export$b5e4199e062b8f44 = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).TargetBranch);
const $1f61c22c1a2f731c$export$f99233281efd08a0 = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).Title);
const $1f61c22c1a2f731c$export$ae2d8be089b6cfe0 = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).ViewCount);
const $1f61c22c1a2f731c$export$b080bef6ed7fa75a = (0, $kSyvr.createElement)((0, $bUpbd.ElementName).VoteCount);

});
parcelRegister("kSyvr", function(module, exports) {

$parcel$export(module.exports, "createElement", () => $8e80f39e014cd5c0$export$c8a8987d4410bf2d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");

var $bUpbd = parcelRequire("bUpbd");

var $7eObK = parcelRequire("7eObK");

var $gSLUn = parcelRequire("gSLUn");

var $7DTbO = parcelRequire("7DTbO");

var $kddkO = parcelRequire("kddkO");

var $ia9bZ = parcelRequire("ia9bZ");

var $lIToQ = parcelRequire("lIToQ");

var $fDkyZ = parcelRequire("fDkyZ");

var $kg0bE = parcelRequire("kg0bE");

var $gGZ5p = parcelRequire("gGZ5p");

var $di1ar = parcelRequire("di1ar");

var $1ue1o = parcelRequire("1ue1o");
const $8e80f39e014cd5c0$var$elementMappings = {
    [(0, $bUpbd.ElementName).AttachmentCount]: {
        component: (0, $ia9bZ.default),
        props: {
            icon: (0, $bUpbd.IconType).Attachment
        }
    },
    [(0, $bUpbd.ElementName).AuthorGroup]: {
        component: (0, $kddkO.default)
    },
    [(0, $bUpbd.ElementName).ChecklistProgress]: {
        component: (0, $ia9bZ.default),
        props: {
            icon: (0, $bUpbd.IconType).CheckItem
        }
    },
    [(0, $bUpbd.ElementName).CollaboratorGroup]: {
        component: (0, $kddkO.default)
    },
    [(0, $bUpbd.ElementName).CommentCount]: {
        component: (0, $ia9bZ.default),
        props: {
            icon: (0, $bUpbd.IconType).Comment
        }
    },
    [(0, $bUpbd.ElementName).ViewCount]: {
        component: (0, $ia9bZ.default),
        props: {
            icon: (0, $bUpbd.IconType).View
        }
    },
    [(0, $bUpbd.ElementName).ReactCount]: {
        component: (0, $ia9bZ.default),
        props: {
            icon: (0, $bUpbd.IconType).React
        }
    },
    [(0, $bUpbd.ElementName).VoteCount]: {
        component: (0, $ia9bZ.default),
        props: {
            icon: (0, $bUpbd.IconType).Vote
        }
    },
    [(0, $bUpbd.ElementName).CreatedBy]: {
        component: (0, $1ue1o.default)
    },
    [(0, $bUpbd.ElementName).OwnedBy]: {
        component: (0, $1ue1o.default)
    },
    [(0, $bUpbd.ElementName).AssignedTo]: {
        component: (0, $1ue1o.default)
    },
    [(0, $bUpbd.ElementName).AssignedToGroup]: {
        component: (0, $kddkO.default)
    },
    [(0, $bUpbd.ElementName).OwnedByGroup]: {
        component: (0, $kddkO.default)
    },
    [(0, $bUpbd.ElementName).CreatedOn]: {
        component: (0, $lIToQ.default)
    },
    [(0, $bUpbd.ElementName).DueOn]: {
        component: (0, $gGZ5p.default)
    },
    [(0, $bUpbd.ElementName).LatestCommit]: {
        component: (0, $ia9bZ.default),
        props: {
            icon: (0, $bUpbd.IconType).Commit
        }
    },
    [(0, $bUpbd.ElementName).LinkIcon]: {
        component: (0, $fDkyZ.default)
    },
    [(0, $bUpbd.ElementName).ModifiedBy]: {
        component: (0, $1ue1o.default)
    },
    [(0, $bUpbd.ElementName).ModifiedOn]: {
        component: (0, $lIToQ.default)
    },
    [(0, $bUpbd.ElementName).Preview]: {
        component: (0, $di1ar.default)
    },
    [(0, $bUpbd.ElementName).Priority]: {
        component: (0, $ia9bZ.default)
    },
    [(0, $bUpbd.ElementName).ProgrammingLanguage]: {
        component: (0, $ia9bZ.default),
        props: {
            icon: (0, $bUpbd.IconType).ProgrammingLanguage
        }
    },
    [(0, $bUpbd.ElementName).Provider]: {
        component: (0, $ia9bZ.default)
    },
    [(0, $bUpbd.ElementName).ReadTime]: {
        component: (0, $1ue1o.default)
    },
    [(0, $bUpbd.ElementName).SentOn]: {
        component: (0, $lIToQ.default)
    },
    [(0, $bUpbd.ElementName).SourceBranch]: {
        component: (0, $1ue1o.default)
    },
    [(0, $bUpbd.ElementName).State]: {
        component: (0, $gGZ5p.default)
    },
    [(0, $bUpbd.ElementName).SubscriberCount]: {
        component: (0, $ia9bZ.default),
        props: {
            icon: (0, $bUpbd.IconType).Subscriber
        }
    },
    [(0, $bUpbd.ElementName).SubTasksProgress]: {
        component: (0, $ia9bZ.default),
        props: {
            icon: (0, $bUpbd.IconType).SubTasksProgress
        }
    },
    [(0, $bUpbd.ElementName).StoryPoints]: {
        component: (0, $7DTbO.default)
    },
    [(0, $bUpbd.ElementName).TargetBranch]: {
        component: (0, $1ue1o.default)
    },
    [(0, $bUpbd.ElementName).Title]: {
        component: (0, $kg0bE.default)
    },
    [(0, $bUpbd.ElementName).Location]: {
        component: (0, $kg0bE.default),
        props: {
            theme: (0, $bUpbd.SmartLinkInternalTheme).Grey
        }
    }
};
const $8e80f39e014cd5c0$var$getContextKey = (name)=>{
    // Attempt to predict context prop name in advance to reduce the amount of
    // code run during runtime
    return name.length > 0 ? name.charAt(0).toLowerCase() + name.slice(1) : undefined;
};
const $8e80f39e014cd5c0$var$getData = (elementName, contextKey, context)=>{
    if (!context) return undefined;
    const data = context[contextKey];
    switch(elementName){
        case (0, $bUpbd.ElementName).AssignedToGroup:
        case (0, $bUpbd.ElementName).AuthorGroup:
        case (0, $bUpbd.ElementName).CollaboratorGroup:
        case (0, $bUpbd.ElementName).OwnedByGroup:
            const AvatarGroupsWithFallback = [
                (0, $bUpbd.ElementName).AssignedToGroup
            ];
            const showFallbackAvatar = AvatarGroupsWithFallback.includes(elementName);
            return $8e80f39e014cd5c0$var$toAvatarGroupProps(data, showFallbackAvatar);
        case (0, $bUpbd.ElementName).AttachmentCount:
        case (0, $bUpbd.ElementName).ChecklistProgress:
        case (0, $bUpbd.ElementName).CommentCount:
        case (0, $bUpbd.ElementName).ViewCount:
        case (0, $bUpbd.ElementName).ReactCount:
        case (0, $bUpbd.ElementName).VoteCount:
        case (0, $bUpbd.ElementName).ProgrammingLanguage:
        case (0, $bUpbd.ElementName).SubscriberCount:
        case (0, $bUpbd.ElementName).LatestCommit:
        case (0, $bUpbd.ElementName).SubTasksProgress:
            return $8e80f39e014cd5c0$var$toBadgeProps(data);
        case (0, $bUpbd.ElementName).StoryPoints:
            return $8e80f39e014cd5c0$var$toAtlaskitBadgeProps(data);
        case (0, $bUpbd.ElementName).CreatedBy:
            return $8e80f39e014cd5c0$var$toFormattedTextProps((0, $7eObK.messages).created_by, context.createdBy);
        case (0, $bUpbd.ElementName).AssignedTo:
            return $8e80f39e014cd5c0$var$toFormattedTextProps((0, $7eObK.messages).assigned_to, context.assignedTo);
        case (0, $bUpbd.ElementName).OwnedBy:
            return $8e80f39e014cd5c0$var$toFormattedTextProps((0, $7eObK.messages).owned_by, context.ownedBy);
        case (0, $bUpbd.ElementName).CreatedOn:
            return $8e80f39e014cd5c0$var$toDateTimeProps('created', context.createdOn);
        case (0, $bUpbd.ElementName).DueOn:
            return $8e80f39e014cd5c0$var$toDateLozengeProps(context.dueOn);
        case (0, $bUpbd.ElementName).ModifiedBy:
            return $8e80f39e014cd5c0$var$toFormattedTextProps((0, $7eObK.messages).modified_by, context.modifiedBy);
        case (0, $bUpbd.ElementName).ModifiedOn:
            return $8e80f39e014cd5c0$var$toDateTimeProps('modified', context.modifiedOn);
        case (0, $bUpbd.ElementName).SentOn:
            return $8e80f39e014cd5c0$var$toDateTimeProps('sent', context.sentOn);
        case (0, $bUpbd.ElementName).ReadTime:
            return $8e80f39e014cd5c0$var$toFormattedTextProps((0, $7eObK.messages).read_time, data);
        case (0, $bUpbd.ElementName).SourceBranch:
        case (0, $bUpbd.ElementName).TargetBranch:
            return $8e80f39e014cd5c0$var$toTextProps(data);
        case (0, $bUpbd.ElementName).Title:
            return $8e80f39e014cd5c0$var$toLinkProps(context.title, context.url);
        default:
            return typeof data === 'object' ? data : undefined;
    }
};
const $8e80f39e014cd5c0$var$toAvatarGroupProps = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};
const $8e80f39e014cd5c0$var$toBadgeProps = (label)=>{
    return label ? {
        label: label
    } : undefined;
};
const $8e80f39e014cd5c0$var$toAtlaskitBadgeProps = (value)=>{
    return value ? {
        value: value
    } : undefined;
};
const $8e80f39e014cd5c0$var$toDateLozengeProps = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7VHMR.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};
const $8e80f39e014cd5c0$var$toDateTimeProps = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};
const $8e80f39e014cd5c0$var$toFormattedTextProps = (descriptor, context)=>{
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        }
    } : undefined;
};
const $8e80f39e014cd5c0$var$toLinkProps = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};
const $8e80f39e014cd5c0$var$toTextProps = (content)=>{
    return content ? {
        content: content
    } : undefined;
};
const $8e80f39e014cd5c0$export$c8a8987d4410bf2d = (name)=>{
    const { component: BaseElement, props: props } = $8e80f39e014cd5c0$var$elementMappings[name] || {};
    const contextKey = $8e80f39e014cd5c0$var$getContextKey(name);
    if (!BaseElement) throw Error(`Element ${name} does not exist.`);
    return (overrides)=>{
        const context = (0, $5uXOq.useContext)((0, $gSLUn.FlexibleUiContext));
        const data = $8e80f39e014cd5c0$var$getData(name, contextKey, context);
        return data ? /*#__PURE__*/ (0, $2OMIu.jsx)(BaseElement, {
            ...props,
            ...data,
            ...overrides,
            name: name
        }) : null;
    };
};

});
parcelRegister("7eObK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5151430fe2914aaf$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5151430fe2914aaf$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    more_information_about_this_work_item: {
        id: 'fabric.linking.more_information_about_this_work_item',
        defaultMessage: 'More information about this work item',
        description: 'Allows the users to see more about the work item'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Recent links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls',
        defaultMessage: 'View recent links',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found In',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes Links To',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_header: {
        id: 'fabric.linking.related_links_modal_error_header',
        defaultMessage: 'Something went wrong',
        description: 'Title for related links error'
    },
    related_links_modal_error_message: {
        id: 'fabric.linking.related_links_modal_error_message',
        defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_header: {
        id: 'fabric.linking.related_links_modal_unavailable_header',
        defaultMessage: 'No recent links',
        description: 'Title for related links being unavailable'
    },
    related_links_modal_unavailable_message: {
        id: 'fabric.linking.related_links_modal_unavailable_message',
        defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
        description: 'Informs the user that related links were not found but may be available in the future'
    },
    join_to_viewIssueTermRefresh: {
        id: 'fabric.linking.join_to_view-issue-term-refresh',
        defaultMessage: 'Join {context} to view this work item',
        description: 'Allows the user join the product or service immediately'
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: 'fabric.linking.open_issue_in_jira-issue-term-refresh',
        defaultMessage: 'Open work item in Jira',
        description: 'Click to open link in Jira'
    },
    request_access_to_viewIssueTermRefresh: {
        id: 'fabric.linking.request_access_to_view-issue-term-refresh',
        defaultMessage: 'Request access to {context} to view this work item',
        description: 'Allows the user to request access to a product or service'
    },
    status_change_permission_errorIssueTermRefresh: {
        id: 'fabric.linking.status_change_permission_error-issue-term-refresh',
        defaultMessage: "You don\u2019t have permission to transition this work item. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    }
});

});

parcelRegister("7DTbO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f2c1ffb3858a4f8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2esxr = parcelRequire("2esxr");

var $fHpHg = parcelRequire("fHpHg");
const $1f2c1ffb3858a4f8$var$badgeStylesOld = null;
const $1f2c1ffb3858a4f8$var$badgeStyles = null;
/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */ const $1f2c1ffb3858a4f8$var$AtlaskitBadge = ({ value: value, name: name, className: className, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && "_4cvr1h6o _1e0c116y",
            (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2esxr.default), {
            children: value
        })
    });
};
var $1f2c1ffb3858a4f8$export$2e2bcd8739ae039 = $1f2c1ffb3858a4f8$var$AtlaskitBadge;

});

parcelRegister("kddkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5cfe065174e19b4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $44cng = parcelRequire("44cng");

var $fHpHg = parcelRequire("fHpHg");

var $bUpbd = parcelRequire("bUpbd");

var $7eObK = parcelRequire("7eObK");

var $iLSC7 = parcelRequire("iLSC7");
const $d5cfe065174e19b4$var$MAX_COUNT = 4;
const $d5cfe065174e19b4$var$styles = null;
const $d5cfe065174e19b4$var$stylesMap = {
    xlarge: "_1e0c116y _1kvxu2gc _102oidpf",
    large: "_1e0c116y _1kvxu2gc _102oidpf",
    medium: "_1e0c116y _1kvxu2gc _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92",
    small: "_1e0c116y _1kvxu2gc _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92"
};
const $d5cfe065174e19b4$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $bUpbd.ElementName).AssignedToGroup:
            return (0, $iLSC7.getFormattedMessageAsString)(intl, (0, $7eObK.messages).assigned_to, personName);
        case (0, $bUpbd.ElementName).OwnedByGroup:
            return (0, $iLSC7.getFormattedMessageAsString)(intl, (0, $7eObK.messages).owned_by, personName);
        case (0, $bUpbd.ElementName).AuthorGroup:
            return (0, $iLSC7.getFormattedMessageAsString)(intl, (0, $7eObK.messages).created_by, personName);
        default:
            return personName;
    }
};
/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {AvatarGroupProps} AvatarGroupProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */ const $d5cfe065174e19b4$var$AvatarGroup = ({ items: items = [], maxCount: maxCount = $d5cfe065174e19b4$var$MAX_COUNT, name: name, className: className, size: size = (0, $bUpbd.SmartLinkSize).Medium, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $koVbs.default)();
    const data = (0, $5uXOq.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $bUpbd.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $iLSC7.getFormattedMessageAsString)(intl, (0, $7eObK.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
        //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $d5cfe065174e19b4$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $d5cfe065174e19b4$var$stylesMap[size],
            (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && "_1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $44cng.default), {
            maxCount: maxCount,
            appearance: "stack",
            size: "small",
            data: data,
            testId: testId
        })
    });
};
var $d5cfe065174e19b4$export$2e2bcd8739ae039 = $d5cfe065174e19b4$var$AvatarGroup;

});
parcelRegister("iLSC7", function(module, exports) {

$parcel$export(module.exports, "sizeToButtonSpacing", () => $19ea187dbea03fa8$export$9d642f65a919fb93);
$parcel$export(module.exports, "getFormattedMessage", () => $19ea187dbea03fa8$export$f1aa79f2218fb713);
$parcel$export(module.exports, "getFormattedMessageAsString", () => $19ea187dbea03fa8$export$66ecb50a9dd1768);
$parcel$export(module.exports, "getIconWidthNew", () => $19ea187dbea03fa8$export$86b6226ea65a6ddf);
$parcel$export(module.exports, "getIconWidth", () => $19ea187dbea03fa8$export$fb10bc5609c6347e);
$parcel$export(module.exports, "importIcon", () => $19ea187dbea03fa8$export$6dc831e1a0a7a851);
$parcel$export(module.exports, "getMaxLines", () => $19ea187dbea03fa8$export$c2293adf1794c09);
$parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", () => $19ea187dbea03fa8$export$475c391af8171fec);
$parcel$export(module.exports, "hasWhiteSpace", () => $19ea187dbea03fa8$export$619e376a425cb759);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $4qBtX = parcelRequire("4qBtX");

var $fHpHg = parcelRequire("fHpHg");

var $bUpbd = parcelRequire("bUpbd");
const $19ea187dbea03fa8$export$9d642f65a919fb93 = {
    [(0, $bUpbd.SmartLinkSize).Small]: 'none',
    [(0, $bUpbd.SmartLinkSize).Medium]: 'compact',
    [(0, $bUpbd.SmartLinkSize).Large]: 'compact',
    [(0, $bUpbd.SmartLinkSize).XLarge]: 'default'
};
const $19ea187dbea03fa8$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...descriptor,
            values: values
        });
    }
};
const $19ea187dbea03fa8$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
const $19ea187dbea03fa8$export$ce56b6021549537 = (size)=>{
    switch(size){
        case (0, $bUpbd.SmartLinkSize).XLarge:
            return '2rem';
        case (0, $bUpbd.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $bUpbd.SmartLinkSize).Medium:
            return '1rem';
        case (0, $bUpbd.SmartLinkSize).Small:
        default:
            return '.75rem';
    }
};
const $19ea187dbea03fa8$export$86b6226ea65a6ddf = (size)=>{
    switch(size){
        case (0, $bUpbd.SmartLinkSize).XLarge:
        case (0, $bUpbd.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $bUpbd.SmartLinkSize).Medium:
        case (0, $bUpbd.SmartLinkSize).Small:
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $19ea187dbea03fa8$export$fb10bc5609c6347e = (size)=>{
    return (0, $fHpHg.fg)('platform-smart-card-icon-migration') ? $19ea187dbea03fa8$export$86b6226ea65a6ddf(size) : $19ea187dbea03fa8$export$ce56b6021549537(size);
};
const $19ea187dbea03fa8$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $19ea187dbea03fa8$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $bUpbd.SmartLinkSize).XLarge:
        case (0, $bUpbd.SmartLinkSize).Large:
            return 1.75;
        case (0, $bUpbd.SmartLinkSize).Medium:
        case (0, $bUpbd.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $19ea187dbea03fa8$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $19ea187dbea03fa8$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $bUpbd.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $bUpbd.SmartLinkSize).Large:
            return 'space.200';
        case (0, $bUpbd.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $bUpbd.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $19ea187dbea03fa8$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};

});


parcelRegister("ia9bZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b605c3fc25da913$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");

var $bUpbd = parcelRequire("bUpbd");

var $7eObK = parcelRequire("7eObK");

var $9jPNd = parcelRequire("9jPNd");

var $92pfy = parcelRequire("92pfy");

var $1D7AK = parcelRequire("1D7AK");

var $iLSC7 = parcelRequire("iLSC7");
const $3b605c3fc25da913$var$styles = {
    container: "_zulp1b66 _1e0c116y _4cvr1h6o _1ul91ns9",
    icon: "_1e0c116y _v4pn116y _1b94116y _1ii7116y _4t3i7vkz _bna77vkz _1xjx7vkz _17527vkz _ca0qze3t _14bqze3t _1oh2ze3t _i2i3ze3t _u5f3ze3t _3tceze3t _99ztze3t _uhasze3t _n3tdze3t _1ym6ze3t _1m2uze3t _5jw9ze3t _19bvze3t _1xr1ze3t _9n9oze3t _7wy9ze3t _1bsb7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _s7n4nkob _rtqbnkob _e4kmnkob _z239nkob",
    text: "_11c81o8v"
};
const $3b605c3fc25da913$var$colorMap = {
    subtle: "_syaz131l",
    default: "_syaz1gjq"
};
const $3b605c3fc25da913$var$badgeStyles = null;
const $3b605c3fc25da913$var$iconStyles = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $3b605c3fc25da913$var$labelStylesOld = null;
const $3b605c3fc25da913$var$messageMapper = {
    [(0, $bUpbd.IconType).PriorityBlocker]: (0, $7eObK.messages).priority_blocker,
    [(0, $bUpbd.IconType).PriorityCritical]: (0, $7eObK.messages).priority_critical,
    [(0, $bUpbd.IconType).PriorityHigh]: (0, $7eObK.messages).priority_high,
    [(0, $bUpbd.IconType).PriorityHighest]: (0, $7eObK.messages).priority_highest,
    [(0, $bUpbd.IconType).PriorityLow]: (0, $7eObK.messages).priority_low,
    [(0, $bUpbd.IconType).PriorityLowest]: (0, $7eObK.messages).priority_lowest,
    [(0, $bUpbd.IconType).PriorityMajor]: (0, $7eObK.messages).priority_major,
    [(0, $bUpbd.IconType).PriorityMedium]: (0, $7eObK.messages).priority_medium,
    [(0, $bUpbd.IconType).PriorityMinor]: (0, $7eObK.messages).priority_minor,
    [(0, $bUpbd.IconType).PriorityTrivial]: (0, $7eObK.messages).priority_trivial,
    [(0, $bUpbd.IconType).PriorityUndefined]: (0, $7eObK.messages).priority_undefined
};
const $3b605c3fc25da913$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $3b605c3fc25da913$var$messageMapper[icon];
        if (descriptor) return (0, $iLSC7.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $3b605c3fc25da913$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9jPNd.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $3b605c3fc25da913$var$renderImageIcon = (url, testId)=>{
    if (url) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $92pfy.default), {
        testId: testId,
        url: url
    });
};
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BadgeProps} BadgeProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $3b605c3fc25da913$var$BadgeRefreshNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance = 'default', hideIcon: hideIcon = false, icon: icon, label: label, name: name, testId: testId = 'smart-element-badge', url: url }, ref)=>{
    const formattedMessageOrLabel = $3b605c3fc25da913$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $3b605c3fc25da913$var$renderAtlaskitIcon(icon, testId) || $3b605c3fc25da913$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        ref: ref,
        className: (0, $bwpsq.default)([
            $3b605c3fc25da913$var$styles.container,
            $3b605c3fc25da913$var$colorMap[appearance]
        ]),
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                as: "span",
                xcss: $3b605c3fc25da913$var$styles.icon,
                children: badgeIcon
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                as: "span",
                testId: `${testId}-label`,
                xcss: $3b605c3fc25da913$var$styles.text,
                children: formattedMessageOrLabel
            })
        ]
    });
});
// On cleanup of platform-linking-visual-refresh-v1, this should become
// export default withOverrideCss(Badge);
const $3b605c3fc25da913$var$BadgeRefreshNewWithOverrideCss = (0, $1D7AK.withOverrideCss)($3b605c3fc25da913$var$BadgeRefreshNew);
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BadgeProps} BadgeProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $3b605c3fc25da913$var$BadgeCompiledNew = ({ hideIcon: hideIcon = false, icon: icon, label: label, name: name, className: className, testId: testId = 'smart-element-badge', url: url })=>{
    const formattedMessageOrLabel = $3b605c3fc25da913$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $3b605c3fc25da913$var$renderAtlaskitIcon(icon, testId) || $3b605c3fc25da913$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
        ...(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]),
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_16jlidpf _1o9zidpf _i0dl1wug _syaz1oju _vwz4idpf _s7n4nkob _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v _1jtnidpf _13t3idpf _rm9uidpf _rtqbnkob _e4kmnkob _z239nkob"
                ]),
                children: badgeIcon
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                "data-testid": `${testId}-label`,
                className: (0, $bwpsq.default)([
                    "_11c8dcr7 _syaz131l _19bv1xvx _s7n4nkob"
                ]),
                children: formattedMessageOrLabel
            })
        ]
    });
};
const $3b605c3fc25da913$var$Badge = (props)=>{
    if ((0, $fHpHg.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)($3b605c3fc25da913$var$BadgeRefreshNewWithOverrideCss, {
        ...props
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)($3b605c3fc25da913$var$BadgeCompiledNew, {
        ...props
    });
};
var $3b605c3fc25da913$export$2e2bcd8739ae039 = $3b605c3fc25da913$var$Badge;

});
parcelRegister("9jPNd", function(module, exports) {

$parcel$export(module.exports, "default", () => $058881f47adcb99c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4qBtX = parcelRequire("4qBtX");

var $5cf2v = parcelRequire("5cf2v");

var $bNzv2 = parcelRequire("bNzv2");

var $jo1Bz = parcelRequire("jo1Bz");
var $39fIG = parcelRequire("39fIG");

var $fHpHg = parcelRequire("fHpHg");


var $beqqV = parcelRequire("beqqV");

var $jOKy6 = parcelRequire("jOKy6");

var $5vx5k = parcelRequire("5vx5k");

var $bUpbd = parcelRequire("bUpbd");

var $lR50Q = parcelRequire("lR50Q");





























































// prettier-ignore
const $058881f47adcb99c$var$importIconMapperOld = {
    [(0, $bUpbd.IconType).Archive]: ()=>(parcelRequire("abbu1")),
    [(0, $bUpbd.IconType).Audio]: ()=>(parcelRequire("CsohK")),
    [(0, $bUpbd.IconType).Code]: ()=>(parcelRequire("dDrgR")),
    [(0, $bUpbd.IconType).Executable]: ()=>(parcelRequire("fvN53")),
    [(0, $bUpbd.IconType).File]: ()=>(parcelRequire("eSVih")),
    [(0, $bUpbd.IconType).Folder]: ()=>(parcelRequire("9HbfU")),
    [(0, $bUpbd.IconType).Generic]: ()=>(parcelRequire("eSVih")),
    [(0, $bUpbd.IconType).GIF]: ()=>(parcelRequire("k0qOW")),
    [(0, $bUpbd.IconType).GoogleDocs]: ()=>(parcelRequire("8hQt0")),
    [(0, $bUpbd.IconType).GoogleForms]: ()=>(parcelRequire("9Hs6w")),
    [(0, $bUpbd.IconType).GoogleSheets]: ()=>(parcelRequire("hXEQP")),
    [(0, $bUpbd.IconType).GoogleSlides]: ()=>(parcelRequire("hbZKR")),
    [(0, $bUpbd.IconType).Image]: ()=>(parcelRequire("rOfWv")),
    [(0, $bUpbd.IconType).MSExcel]: ()=>(parcelRequire("jOQbA")),
    [(0, $bUpbd.IconType).MSPowerpoint]: ()=>(parcelRequire("31tct")),
    [(0, $bUpbd.IconType).MSWord]: ()=>(parcelRequire("i1tD5")),
    [(0, $bUpbd.IconType).PDF]: ()=>(parcelRequire("24aUC")),
    [(0, $bUpbd.IconType).Presentation]: ()=>(parcelRequire("iW2rN")),
    [(0, $bUpbd.IconType).Sketch]: ()=>(parcelRequire("6idFd")),
    [(0, $bUpbd.IconType).Spreadsheet]: ()=>(parcelRequire("k9stF")),
    [(0, $bUpbd.IconType).Template]: ()=>(parcelRequire("jmxyl")),
    [(0, $bUpbd.IconType).Video]: ()=>(parcelRequire("4HsDf")),
    // Bitbucket icons
    [(0, $bUpbd.IconType).Branch]: ()=>(parcelRequire("5HDoK")),
    [(0, $bUpbd.IconType).Commit]: ()=>(parcelRequire("kGCQL")),
    [(0, $bUpbd.IconType).Project]: ()=>Promise.resolve((parcelRequire("3lyRn"))),
    [(0, $bUpbd.IconType).PullRequest]: ()=>(parcelRequire("5Wydb")),
    [(0, $bUpbd.IconType).Repo]: ()=>(parcelRequire("42NaT")),
    // Jira icons
    [(0, $bUpbd.IconType).Bug]: ()=>(parcelRequire("hrPZz")),
    [(0, $bUpbd.IconType).Change]: ()=>(parcelRequire("gcXvG")),
    [(0, $bUpbd.IconType).Epic]: ()=>(parcelRequire("dtRZ8")),
    [(0, $bUpbd.IconType).Incident]: ()=>(parcelRequire("Hrhdz")),
    [(0, $bUpbd.IconType).Problem]: ()=>(parcelRequire("2SZmt")),
    [(0, $bUpbd.IconType).ServiceRequest]: ()=>(parcelRequire("4lk7q")),
    [(0, $bUpbd.IconType).Story]: ()=>(parcelRequire("9KliZ")),
    [(0, $bUpbd.IconType).SubTask]: ()=>(parcelRequire("cV05C")),
    [(0, $bUpbd.IconType).Task]: ()=>(parcelRequire("aJKNn")),
    // Provider icons
    [(0, $bUpbd.IconType).Confluence]: ()=>Promise.resolve((parcelRequire("jo1Bz"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                default: ConfluenceIcon
            })),
    [(0, $bUpbd.IconType).Jira]: ()=>Promise.resolve((parcelRequire("39fIG"))).then(({ JiraIcon: JiraIcon })=>({
                default: JiraIcon
            })),
    // Fallback icons
    [(0, $bUpbd.IconType).Default]: ()=>Promise.resolve((parcelRequire("5gmaZ"))),
    [(0, $bUpbd.IconType).Error]: ()=>Promise.resolve((parcelRequire("hWOvD"))),
    [(0, $bUpbd.IconType).Forbidden]: ()=>(parcelRequire("4wq8k")),
    // Badge
    [(0, $bUpbd.IconType).Attachment]: ()=>(parcelRequire("j63cw")),
    [(0, $bUpbd.IconType).CheckItem]: ()=>(parcelRequire("1tPgL")),
    [(0, $bUpbd.IconType).Comment]: ()=>(parcelRequire("InyqM")),
    [(0, $bUpbd.IconType).View]: ()=>(parcelRequire("5IHQq")),
    [(0, $bUpbd.IconType).React]: ()=>(parcelRequire("gzvTE")),
    [(0, $bUpbd.IconType).Vote]: ()=>(parcelRequire("4AJ9p")),
    [(0, $bUpbd.IconType).PriorityBlocker]: ()=>(parcelRequire("gMDFI")),
    [(0, $bUpbd.IconType).PriorityCritical]: ()=>(parcelRequire("4fkVg")),
    [(0, $bUpbd.IconType).PriorityHigh]: ()=>(parcelRequire("fgN6p")),
    [(0, $bUpbd.IconType).PriorityHighest]: ()=>(parcelRequire("cV2N9")),
    [(0, $bUpbd.IconType).PriorityLow]: ()=>(parcelRequire("eVavM")),
    [(0, $bUpbd.IconType).PriorityLowest]: ()=>(parcelRequire("56RVo")),
    [(0, $bUpbd.IconType).PriorityMajor]: ()=>(parcelRequire("ktXnL")),
    [(0, $bUpbd.IconType).PriorityMedium]: ()=>(parcelRequire("9mM5H")),
    [(0, $bUpbd.IconType).PriorityMinor]: ()=>(parcelRequire("1O0Re")),
    [(0, $bUpbd.IconType).PriorityTrivial]: ()=>(parcelRequire("lGGho")),
    [(0, $bUpbd.IconType).PriorityUndefined]: ()=>Promise.resolve((parcelRequire("9XF6F"))),
    [(0, $bUpbd.IconType).ProgrammingLanguage]: ()=>(parcelRequire("6p3f3")),
    [(0, $bUpbd.IconType).Subscriber]: ()=>Promise.resolve((parcelRequire("GLupd"))),
    [(0, $bUpbd.IconType).SubTasksProgress]: ()=>(parcelRequire("ctceX"))
};
const $058881f47adcb99c$var$getIconImportFn = (icon, size)=>{
    if ((0, $fHpHg.fg)('platform-smart-card-icon-migration')) {
        const item = (0, $lR50Q.getLazyIcons)()[icon];
        if ((0, $lR50Q.isIconSizeLarge)(size) && item?.large) return item.large;
        return item?.default;
    }
    return $058881f47adcb99c$var$importIconMapperOld[icon];
};
const $058881f47adcb99c$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $058881f47adcb99c$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId, size: size = (0, $bUpbd.SmartLinkSize).Medium })=>{
    const DocumentIcon = (0, $fHpHg.fg)('platform-smart-card-icon-migration') ? (0, $5vx5k.default) : (0, (/*@__PURE__*/$parcel$interopDefault($5cf2v)));
    const BlogIcon = (0, $fHpHg.fg)('platform-smart-card-icon-migration') ? (0, $beqqV.default) : (0, $bNzv2.default);
    // Check for synchonously loaded icons first for SSR purposes
    switch(icon){
        case (0, $bUpbd.IconType).Document:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(DocumentIcon, {
                label: label ?? 'document',
                testId: testId,
                ...(0, $fHpHg.fg)('platform-smart-card-icon-migration') && {
                    size: size
                }
            });
        case (0, $bUpbd.IconType).Blog:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(BlogIcon, {
                label: label ?? 'blog',
                testId: testId,
                ...(0, $fHpHg.fg)('platform-smart-card-icon-migration') && {
                    size: size
                }
            });
        case (0, $bUpbd.IconType).LiveDocument:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jOKy6.default), {
                label: label ?? 'live-doc',
                testId: testId,
                ...(0, $fHpHg.fg)('platform-smart-card-icon-migration') && {
                    size: size
                }
            });
    }
    const importFn = $058881f47adcb99c$var$getIconImportFn(icon, size);
    if (!importFn) return null;
    const ImportedIcon = $058881f47adcb99c$var$importIcon(importFn);
    switch(icon){
        case (0, $bUpbd.IconType).Confluence:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jo1Bz.ConfluenceIcon), {
                appearance: "brand",
                testId: testId,
                ...(0, $fHpHg.fg)('platform-smart-card-icon-migration') && {
                    size: size === (0, $bUpbd.SmartLinkSize).Large ? 'small' : 'xsmall'
                }
            });
        case (0, $bUpbd.IconType).Jira:
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $39fIG.JiraIcon), {
                appearance: "brand",
                testId: testId,
                ...(0, $fHpHg.fg)('platform-smart-card-icon-migration') && {
                    size: size === (0, $bUpbd.SmartLinkSize).Large ? 'small' : 'xsmall'
                }
            });
        case (0, $bUpbd.IconType).Error:
        case (0, $bUpbd.IconType).Forbidden:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                ...(0, $fHpHg.fg)('platform-smart-card-icon-migration') ? {
                    size: size,
                    color: "var(--ds-icon-danger, #C9372C)"
                } : {
                    primaryColor: `var(--ds-icon-danger, ${0, $a7f8c6b391092279$export$2010d0fb4295b346})`
                }
            });
        default:
            return /*#__PURE__*/ (0, $2OMIu.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                ...(0, $fHpHg.fg)('platform-smart-card-icon-migration') && {
                    size: size
                }
            });
    }
};
var $058881f47adcb99c$export$2e2bcd8739ae039 = $058881f47adcb99c$var$AtlaskitIcon;

});
parcelRegister("jOKy6", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4b6576b7b2733bc$export$2e2bcd8739ae039);

var $pNRmB = parcelRequire("pNRmB");

var $44Gio = parcelRequire("44Gio");

var $lpnOy = parcelRequire("lpnOy");
const $e4b6576b7b2733bc$var$LiveDocumentIconWithColor = (0, $lpnOy.renderIconPerSize)((0, $pNRmB.default), (0, $44Gio.default));
$e4b6576b7b2733bc$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $e4b6576b7b2733bc$export$2e2bcd8739ae039 = $e4b6576b7b2733bc$var$LiveDocumentIconWithColor;

});

parcelRegister("jmxyl", function(module, exports) {

let $e18a194d42132923$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e18a194d42132923$var$load("h7r1M").then(()=>parcelRequire('2i0gS'));

});

parcelRegister("4wq8k", function(module, exports) {

let $34ae6c1e537ca02d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $34ae6c1e537ca02d$var$load("j2KHt").then(()=>parcelRequire('88ixi'));

});

parcelRegister("j63cw", function(module, exports) {

let $de710f859b088584$var$load = (parcelRequire("28QjX"))(4);
module.exports = $de710f859b088584$var$load("30p9F").then(()=>parcelRequire('8FO5r'));

});

parcelRegister("1tPgL", function(module, exports) {

let $114044ee3d58a14b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $114044ee3d58a14b$var$load("gxona").then(()=>parcelRequire('gRKyK'));

});

parcelRegister("InyqM", function(module, exports) {

let $0856619390b8b2dd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0856619390b8b2dd$var$load("8mdXc").then(()=>parcelRequire('c1HKC'));

});

parcelRegister("5IHQq", function(module, exports) {

let $42a3126ecd46ae7a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $42a3126ecd46ae7a$var$load("kvjaU").then(()=>parcelRequire('c4Fdw'));

});

parcelRegister("gzvTE", function(module, exports) {

let $c108a83c4e5364a0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c108a83c4e5364a0$var$load("fF0Is").then(()=>parcelRequire('jdOHc'));

});

parcelRegister("4AJ9p", function(module, exports) {

let $357d8c3285dbb1b5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $357d8c3285dbb1b5$var$load("e83Du").then(()=>parcelRequire('gPuKh'));

});

parcelRegister("6p3f3", function(module, exports) {

let $4a9797a1641afe3b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4a9797a1641afe3b$var$load("kaqlg").then(()=>parcelRequire('7Vx4o'));

});

parcelRegister("ctceX", function(module, exports) {

let $9141b01fda9d7c26$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9141b01fda9d7c26$var$load("doN6l").then(()=>parcelRequire('gNBdu'));

});


parcelRegister("92pfy", function(module, exports) {

$parcel$export(module.exports, "default", () => $161bf6cc91482f92$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bmnhy = parcelRequire("bmnhy");

var $fHpHg = parcelRequire("fHpHg");

var $3p8Wv = parcelRequire("3p8Wv");
const $161bf6cc91482f92$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, width: width, height: height, onError: onError, onLoad: onLoad })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bmnhy))), {
        src: url,
        ...(0, $fHpHg.fg)('platform-smart-card-icon-migration') ? {
            loading: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3p8Wv.LoadingSkeletonNew), {
                testId: `${testId}-loading`,
                width: width,
                height: height
            }),
            loaded: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                src: url,
                "data-testid": `${testId}-image`,
                alt: "",
                style: {
                    width: width,
                    height: height
                }
            })
        } : {
            loading: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3p8Wv.LoadingSkeletonOld), {
                testId: `${testId}-loading`
            }),
            loaded: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
                src: url,
                "data-testid": `${testId}-image`,
                alt: ""
            })
        },
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
var $161bf6cc91482f92$export$2e2bcd8739ae039 = $161bf6cc91482f92$var$ImageIcon;

});
parcelRegister("bmnhy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8453cf1ee7ef4644$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $5uXOq = parcelRequire("5uXOq");
var $8453cf1ee7ef4644$var$React = $8453cf1ee7ef4644$var$_interopRequireWildcard($5uXOq);
function $8453cf1ee7ef4644$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $8453cf1ee7ef4644$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8453cf1ee7ef4644$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8453cf1ee7ef4644$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $8453cf1ee7ef4644$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $8453cf1ee7ef4644$var$loaded() {
    return {
        isLoaded: true
    };
}
function $8453cf1ee7ef4644$var$errored() {
    return {
        isErrored: true
    };
}
function $8453cf1ee7ef4644$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $8453cf1ee7ef4644$var$ImageRenderer = function(_React$Component) {
    $8453cf1ee7ef4644$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $8453cf1ee7ef4644$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $8453cf1ee7ef4644$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($8453cf1ee7ef4644$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($8453cf1ee7ef4644$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $8453cf1ee7ef4644$var$_possibleConstructorReturn(_this, _ret);
    }
    $8453cf1ee7ef4644$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($8453cf1ee7ef4644$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($8453cf1ee7ef4644$var$hasPropsChanged(this.props, nextProps)) this.setState($8453cf1ee7ef4644$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($8453cf1ee7ef4644$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($8453cf1ee7ef4644$var$React.Component);
module.exports.default = $8453cf1ee7ef4644$var$ImageRenderer;

});

parcelRegister("3p8Wv", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeletonNew", () => $b44bdbf2f66f9c94$export$4c64943f69fac55);
$parcel$export(module.exports, "LoadingSkeletonOld", () => $b44bdbf2f66f9c94$export$c2c783ba34989c94);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $b44bdbf2f66f9c94$var$animationNameStyles = null;
const $b44bdbf2f66f9c94$var$loadingSkeletonStyle = null;
const $b44bdbf2f66f9c94$export$4c64943f69fac55 = ({ testId: testId, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": testId,
        style: {
            width: width,
            height: height
        },
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _uiztglyw _bfhk178v _1itk1bc0 _12vemgnk _1lrw6rms _1e0c1o8l _5sag9cwz _1o51q7pw _tip812c5 _j7hqqkar _1pglp3kn"
        ])
    });
};
const $b44bdbf2f66f9c94$export$c2c783ba34989c94 = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b44bdbf2f66f9c94$export$4c64943f69fac55, {
        ...props,
        width: `${props.width}rem`,
        height: `${props.height}rem`
    });
};

});


parcelRegister("1D7AK", function(module, exports) {

$parcel$export(module.exports, "withOverrideCss", () => $029adc1037e58385$export$e0bdcacb944f1da6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $029adc1037e58385$export$e0bdcacb944f1da6(Component) {
    return (props)=>{
        const ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (props?.className && ref.current) ref.current.className = `${ref.current.className} ${props.className}`;
        }, [
            props?.className
        ]);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
            ...props,
            ref: ref
        });
    };
}

});


parcelRegister("lIToQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d29adeb210adca6a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $j7anB = parcelRequire("j7anB");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $fHpHg = parcelRequire("fHpHg");

var $7eObK = parcelRequire("7eObK");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $d29adeb210adca6a$var$stylesOld = null;
const $d29adeb210adca6a$var$styles = null;
const $d29adeb210adca6a$var$typeToDescriptorMap = {
    created: {
        relative: (0, $7eObK.messages).created_on_relative,
        absolute: (0, $7eObK.messages).created_on_absolute
    },
    modified: {
        relative: (0, $7eObK.messages).modified_on_relative,
        absolute: (0, $7eObK.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $7eObK.messages).sent_on_relative,
        absolute: (0, $7eObK.messages).sent_on_absolute
    }
};
/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {DateTimeProps} DateTimeProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */ const $d29adeb210adca6a$var$DateTime = ({ date: date, name: name, className: className, type: type, testId: testId = 'smart-element-date-time', text: text })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $koVbs.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $j7anB.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _1reo15vq _18m915vq _syaz131l _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k1j6v",
            (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k7vkz",
            className
        ]),
        children: text ? `${text} ${context}` : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...$d29adeb210adca6a$var$typeToDescriptorMap[type][typeVariant],
            values: {
                context: context
            }
        })
    });
};
var $d29adeb210adca6a$export$2e2bcd8739ae039 = $d29adeb210adca6a$var$DateTime;

});

parcelRegister("fDkyZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f688e63b5a42ba6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $c95g7 = parcelRequire("c95g7");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");

var $bUpbd = parcelRequire("bUpbd");

var $9jPNd = parcelRequire("9jPNd");

var $92pfy = parcelRequire("92pfy");

var $iLSC7 = parcelRequire("iLSC7");
const $7f688e63b5a42ba6$var$styles = {
    container: "_1ul91ns9",
    iconWrapperStyle: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $7f688e63b5a42ba6$var$positionStyleMap = {
    center: "_1wpz1h6o",
    top: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1y6m"
};
const $7f688e63b5a42ba6$var$iconStylesMapOld = {
    xlarge: "_16jlidpf _1o9zidpf _i0dl1wug _4t3iviql _1tkeviql _c71lviql _1bsbviql _1ul9viql _p12fviql _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7viql _1xjxviql _1752viql _qci8viql _15izviql _erubviql _19l3viql _1pr2viql _1u5tviql _mezjviql _e2ooviql _w8l5viql _1rg2viql _q7cvviql _xwbjviql _rtysviql _b8nkviql _4x20viql",
    large: "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    medium: "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    small: "_16jlidpf _1o9zidpf _i0dl1wug _4t3ioqnp _1tkeoqnp _c71loqnp _1bsboqnp _1ul9oqnp _p12foqnp _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7oqnp _1xjxoqnp _1752oqnp _qci8oqnp _15izoqnp _eruboqnp _19l3oqnp _1pr2oqnp _1u5toqnp _mezjoqnp _e2oooqnp _w8l5oqnp _1rg2oqnp _q7cvoqnp _xwbjoqnp _rtysoqnp _b8nkoqnp _4x20oqnp"
};
const $7f688e63b5a42ba6$var$customRenderStyleMapOld = {
    xlarge: "_1reo15vq _18m915vq _1e0ccj1k _1nmz1hna _1yyjkb7n _vwz4viql _1wybviql _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kviql",
    large: "_1reo15vq _18m915vq _1e0ccj1k _1nmz1hna _1yyjkb7n _vwz41k8s _1wyb1k8s _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102k1k8s",
    medium: "_1reo15vq _18m915vq _1e0ccj1k _1nmz1hna _1yyjkb7n _vwz41j6v _1wyb1j6v _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102k1j6v",
    small: "_1reo15vq _18m915vq _1e0ccj1k _1nmz1hna _1yyjkb7n _vwz4oqnp _1wyboqnp _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102koqnp"
};
const $7f688e63b5a42ba6$var$customRenderStyleMapNew = {
    xlarge: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kz42d",
    large: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kz42d",
    medium: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kptym",
    small: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _102kptym"
};
const $7f688e63b5a42ba6$var$renderAtlaskitIcon = (icon, testId, size = (0, $bUpbd.SmartLinkSize).Medium)=>{
    if (icon) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9jPNd.default), {
        icon: icon,
        testId: `${testId}-icon`,
        "aria-hidden": "true",
        label: "" // Since we already set aria-hidden="true", the label should be given an empty string
        ,
        ...(0, $fHpHg.fg)('platform-smart-card-icon-migration') && {
            size: size
        }
    });
};
const $7f688e63b5a42ba6$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c95g7))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $7f688e63b5a42ba6$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $bUpbd.SmartLinkSize).Medium)=>{
    const width = size === (0, $bUpbd.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $92pfy.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        ...(0, $fHpHg.fg)('platform-smart-card-icon-migration') && {
            width: width,
            height: width
        }
    });
};
/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param {IconProps} IconProps - The props necessary for the Icon element.
 * @see LinkIcon
 */ const $7f688e63b5a42ba6$var$Icon = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $bUpbd.SmartLinkPosition).Top, className: className, render: render, size: size = (0, $bUpbd.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url })=>{
    const element = (0, $5uXOq.useMemo)(()=>{
        const defaultIcon = $7f688e63b5a42ba6$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || $7f688e63b5a42ba6$var$renderImageIcon(defaultIcon, url, testId, (0, $fHpHg.fg)('platform-smart-card-icon-migration') ? size : undefined) || $7f688e63b5a42ba6$var$renderAtlaskitIcon(icon, testId, (0, $fHpHg.fg)('platform-smart-card-icon-migration') ? size : undefined) || defaultIcon;
    }, [
        overrideIcon,
        icon,
        label,
        render,
        testId,
        url,
        size
    ]);
    const width = (0, $iLSC7.getIconWidth)(size);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && $7f688e63b5a42ba6$var$styles.container,
            !(0, $fHpHg.fg)('platform-smart-card-icon-migration') && $7f688e63b5a42ba6$var$iconStylesMapOld[size],
            !(0, $fHpHg.fg)('platform-smart-card-icon-migration') && $7f688e63b5a42ba6$var$positionStyleMap[position],
            render && !(0, $fHpHg.fg)('platform-smart-card-icon-migration') && $7f688e63b5a42ba6$var$customRenderStyleMapOld[size],
            render && (0, $fHpHg.fg)('platform-smart-card-icon-migration') && $7f688e63b5a42ba6$var$customRenderStyleMapNew[size],
            className
        ]),
        children: (0, $fHpHg.fg)('platform-smart-card-icon-migration') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
            xcss: $7f688e63b5a42ba6$var$styles.iconWrapperStyle,
            style: {
                width: width,
                height: width
            },
            children: element
        }) : element
    });
};
var $7f688e63b5a42ba6$export$2e2bcd8739ae039 = $7f688e63b5a42ba6$var$Icon;

});

parcelRegister("kg0bE", function(module, exports) {

$parcel$export(module.exports, "default", () => $deada82b6b5fb3dc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $5KCCi = parcelRequire("5KCCi");

var $bUpbd = parcelRequire("bUpbd");

var $lzjiu = parcelRequire("lzjiu");

var $iLSC7 = parcelRequire("iLSC7");
const $deada82b6b5fb3dc$var$DEFAULT_MAX_LINES = 2;
const $deada82b6b5fb3dc$var$MAXIMUM_MAX_LINES = 2;
const $deada82b6b5fb3dc$var$MINIMUM_MAX_LINES = 1;
const $deada82b6b5fb3dc$var$containerStyles = null;
const $deada82b6b5fb3dc$var$getMaxLines = (maxLines)=>{
    if (maxLines > $deada82b6b5fb3dc$var$MAXIMUM_MAX_LINES) return $deada82b6b5fb3dc$var$DEFAULT_MAX_LINES;
    if (maxLines < $deada82b6b5fb3dc$var$MINIMUM_MAX_LINES) return $deada82b6b5fb3dc$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $deada82b6b5fb3dc$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span",
        children: trigger
    });
const $deada82b6b5fb3dc$var$linkStyleSizeMap = {
    xlarge: "_11c8lodh _k48pi7a9 _vwz41k8s",
    large: "_11c82smr _k48pi7a9 _vwz41j6v",
    medium: "_11c82smr _k48pi7a9 _vwz41j6v",
    small: "_11c8dcr7 _k48pi7a9 _vwz41j6v"
};
const $deada82b6b5fb3dc$var$baseAnchorStyle = null;
const $deada82b6b5fb3dc$var$workBreakStyleMap = {
    true: "_1nmz1hna",
    false: "_1nmz9jpi"
};
const $deada82b6b5fb3dc$var$anchorConstantsStyles = null;
const $deada82b6b5fb3dc$var$anchorLineClampMap = {
    1: "_1yyjkb7n",
    2: "_1yyjcs5v"
};
const $deada82b6b5fb3dc$var$anchorLinkLineHeight1Map = {
    xlarge: "_102k1k8s",
    large: "_102k1j6v",
    medium: "_102k1j6v",
    small: "_102k1j6v"
};
const $deada82b6b5fb3dc$var$anchorLinkLineHeight2Map = {
    xlarge: "_102k1wto",
    large: "_102kviql",
    medium: "_102kviql",
    small: "_102kviql"
};
const $deada82b6b5fb3dc$var$themeStyleMap = {
    grey: "_fjv618uv _93u918uv _g2lk18uv _pnzf18uv _hlwq8stv _1e2m8stv _1l4b8stv _ue8d8stv _yni7nqa1 _1bianqa1 _93jhnqa1 _64n6nqa1 _1ray131l _dlb7131l _rnxt131l _1h4d131l _10uedcr7 _ye10131l",
    black: "_syaz1gjq _9oik18uv _1bnx8stv _jf4cnqa1 _30l31gjq _9h8h1fxt",
    link: "_syaz14q2 _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
/**
 * A base element that represent an anchor.
 * @internal
 * @param {LinkProps} LinkProps - The props necessary for the Link element.
 * @see LinkIcon
 */ const $deada82b6b5fb3dc$var$Link = ({ hideTooltip: hideTooltip, maxLines: maxLines = $deada82b6b5fb3dc$var$DEFAULT_MAX_LINES, name: name, className: className, size: size = (0, $bUpbd.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $bUpbd.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank' })=>{
    const onMouseDown = (0, $lzjiu.useMouseDownEvent)();
    const hasSpace = (0, $5uXOq.useMemo)(()=>text ? (0, $iLSC7.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            $deada82b6b5fb3dc$var$linkStyleSizeMap[size],
            $deada82b6b5fb3dc$var$anchorLineClampMap[$deada82b6b5fb3dc$var$getMaxLines(maxLines)],
            "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _sudp1e54",
            $deada82b6b5fb3dc$var$workBreakStyleMap[hasSpace ? 'true' : 'false'],
            $deada82b6b5fb3dc$var$getMaxLines(maxLines) === 1 && $deada82b6b5fb3dc$var$anchorLinkLineHeight1Map[size],
            $deada82b6b5fb3dc$var$getMaxLines(maxLines) === 2 && $deada82b6b5fb3dc$var$anchorLinkLineHeight2Map[size],
            $deada82b6b5fb3dc$var$themeStyleMap[theme],
            className
        ]),
        ...target !== '_self' && {
            target: target
        },
        children: text
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug"
        ]),
        children: hideTooltip || text === undefined ? anchor : $deada82b6b5fb3dc$var$withTooltip(anchor, text, testId)
    });
};
var $deada82b6b5fb3dc$export$2e2bcd8739ae039 = $deada82b6b5fb3dc$var$Link;

});
parcelRegister("lzjiu", function(module, exports) {

$parcel$export(module.exports, "useLinkClicked", () => $d26ad2943e0bd9b8$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $d26ad2943e0bd9b8$export$df67f318ded0283c);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $gLthk = parcelRequire("gLthk");
var $d26ad2943e0bd9b8$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $d26ad2943e0bd9b8$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $gLthk.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $d26ad2943e0bd9b8$var$isNotLeftClick = (event)=>event.button !== 0;
const $d26ad2943e0bd9b8$export$df67f318ded0283c = (onMouseDown)=>{
    return $d26ad2943e0bd9b8$export$5993d3ca6c85f774(onMouseDown, $d26ad2943e0bd9b8$var$isNotLeftClick);
};

});
parcelRegister("gLthk", function(module, exports) {

$parcel$export(module.exports, "fireLinkClickedEvent", () => $1758bca267148e5f$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $1758bca267148e5f$export$263352d59c0c5966);

var $5uXOq = parcelRequire("5uXOq");

var $27VfZ = parcelRequire("27VfZ");

var $lzjiu = parcelRequire("lzjiu");

var $4c7pe = parcelRequire("4c7pe");
const $1758bca267148e5f$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $1758bca267148e5f$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $1758bca267148e5f$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $1758bca267148e5f$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $27VfZ.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($1758bca267148e5f$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $1758bca267148e5f$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $1758bca267148e5f$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $1758bca267148e5f$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $1758bca267148e5f$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $1758bca267148e5f$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $1758bca267148e5f$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $1758bca267148e5f$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $1758bca267148e5f$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides?.nonPrivacySafeAttributes
            }
        }).fire((0, $4c7pe.ANALYTICS_CHANNEL));
    };
const $1758bca267148e5f$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $1758bca267148e5f$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $lzjiu.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $lzjiu.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$1758bca267148e5f$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("27VfZ", function(module, exports) {

$parcel$export(module.exports, "browser", () => $43190baaa6b8dacf$export$3f2684e5d7cb1006);
const $43190baaa6b8dacf$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $43190baaa6b8dacf$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $43190baaa6b8dacf$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $43190baaa6b8dacf$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $43190baaa6b8dacf$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $43190baaa6b8dacf$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $43190baaa6b8dacf$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $43190baaa6b8dacf$var$result.android = /Android \d/.test(navigator.userAgent);
    $43190baaa6b8dacf$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $43190baaa6b8dacf$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $43190baaa6b8dacf$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $43190baaa6b8dacf$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $43190baaa6b8dacf$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $43190baaa6b8dacf$export$3f2684e5d7cb1006() {
    return $43190baaa6b8dacf$var$result;
}

});




parcelRegister("gGZ5p", function(module, exports) {

$parcel$export(module.exports, "default", () => $e784ad20039ef8b2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eOat1 = parcelRequire("eOat1");

var $fHpHg = parcelRequire("fHpHg");

var $gSLUn = parcelRequire("gSLUn");

var $e4sSq = parcelRequire("e4sSq");
const $e784ad20039ef8b2$var$stylesOld = null;
const $e784ad20039ef8b2$var$styles = null;
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {LozengeProps} LozengeProps - The props necessary for the Lozenge element.
 * @see State
 */ const $e784ad20039ef8b2$var$Lozenge = ({ action: action, appearance: appearance = 'default', name: name, className: className, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
    const ui = (0, $gSLUn.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e4sSq.default), {
        action: action,
        appearance: appearance,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eOat1.default), {
        appearance: appearance,
        ...(0, $fHpHg.fg)('platform-component-visual-refresh') ? {
            isBold: true
        } : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        testId: `${testId}-lozenge`,
        children: text
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _vwz41kw7",
            (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _1ul91ns9",
            className
        ]),
        children: lozenge
    });
};
var $e784ad20039ef8b2$export$2e2bcd8739ae039 = $e784ad20039ef8b2$var$Lozenge;

});
parcelRegister("e4sSq", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a02a789ec0b1db$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $j7m8K = parcelRequire("j7m8K");

var $fHpHg = parcelRequire("fHpHg");

var $evjcU = parcelRequire("evjcU");

var $1862R = parcelRequire("1862R");

var $9RoW9 = parcelRequire("9RoW9");

var $4Av71 = parcelRequire("4Av71");

var $dO0Cj = parcelRequire("dO0Cj");

var $eJH2p = parcelRequire("eJH2p");

var $4c7pe = parcelRequire("4c7pe");

var $2XAcY = parcelRequire("2XAcY");

var $fj52x = parcelRequire("fj52x");

var $3mgIX = parcelRequire("3mgIX");

var $dRhc8 = parcelRequire("dRhc8");

var $e2moW = parcelRequire("e2moW");

var $8LU0D = parcelRequire("8LU0D");
const $95a02a789ec0b1db$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $95a02a789ec0b1db$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex })=>{
    const [selected, setSelected] = (0, $5uXOq.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $5uXOq.useState)(false);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [items, setItems] = (0, $5uXOq.useState)();
    const [errorMessage, setErrorMessage] = (0, $5uXOq.useState)();
    const reload = (0, $dO0Cj.default)();
    const invoke = (0, $9RoW9.default)();
    const { fireEvent: fireEvent } = (0, $evjcU.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, invokePreviewAction: invokePreviewAction } = action?.update?.details || {};
    const handleOpenChange = (0, $5uXOq.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            fireEvent('ui.button.clicked.smartLinkStatusLozenge', {});
            fireEvent('track.smartLinkQuickAction.started', {
                smartLinkActionType: (0, $4c7pe.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $1862R.default));
                const validItems = typeof text === 'string' ? $95a02a789ec0b1db$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    fireEvent('track.smartLinkQuickAction.failed', (0, $fj52x.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $fHpHg.fg)('confluence-issue-terminology-refresh') ? (0, $dRhc8.LozengeActionErrorMessages).noDataIssueTermRefresh : (0, $dRhc8.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch (err) {
                setErrorMessage((0, $dRhc8.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                fireEvent('track.smartLinkQuickAction.failed', (0, $fj52x.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        invoke,
        isLoaded,
        text,
        fireEvent
    ]);
    const trigger = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $8LU0D.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            testId: testId,
            text: selected.text
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        testId
    ]);
    const handleItemClick = (0, $5uXOq.useCallback)(async (id, text, appearance)=>{
        try {
            fireEvent('ui.button.clicked.smartLinkStatusListItem', {});
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $eJH2p.default)(updateAction, id);
                await invoke(request);
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: (0, $4c7pe.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload(url, true, undefined, linkId);
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $4Av71.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                fireEvent('track.smartLinkQuickAction.failed', (0, $fj52x.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $dRhc8.LozengeActionErrorMessages).updateFailed);
                fireEvent('track.smartLinkQuickAction.failed', (0, $fj52x.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        invoke,
        linkId,
        reload,
        url,
        fireEvent
    ]);
    const dropdownItemGroup = (0, $5uXOq.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3mgIX.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            invokePreviewAction: invokePreviewAction
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e2moW.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        invokePreviewAction,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j7m8K.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex,
        children: dropdownItemGroup
    });
};
var $95a02a789ec0b1db$export$2e2bcd8739ae039 = (0, $2XAcY.default)($95a02a789ec0b1db$var$LozengeAction);

});
parcelRegister("1862R", function(module, exports) {

$parcel$export(module.exports, "default", () => $d173b89316e48856$export$2e2bcd8739ae039);
const $d173b89316e48856$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $d173b89316e48856$export$2e2bcd8739ae039 = $d173b89316e48856$var$extractLozengeActionItems;

});

parcelRegister("9RoW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $522a2c26d202d693$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gdE6Y = parcelRequire("gdE6Y");

var $2yoyZ = parcelRequire("2yoyZ");
const $522a2c26d202d693$var$useInvoke = ()=>{
    const { connections: connections } = (0, $2yoyZ.useSmartLinkContext)();
    const clientExt = (0, $gdE6Y.useSmartLinkClientExtension)(connections.client);
    return (0, $5uXOq.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $522a2c26d202d693$export$2e2bcd8739ae039 = $522a2c26d202d693$var$useInvoke;

});
parcelRegister("gdE6Y", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkClientExtension", () => $1623aa21d8534d73$export$303ede4eed148855);

var $5uXOq = parcelRequire("5uXOq");

var $3hu7v = parcelRequire("3hu7v");

var $8y8nH = parcelRequire("8y8nH");

var $CUTqv = parcelRequire("CUTqv");
const $1623aa21d8534d73$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $CUTqv.useResolverUrl)(cardClient);
    const invoke = (0, $5uXOq.useCallback)(async (data)=>{
        try {
            return await (0, $3hu7v.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $8y8nH.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            invoke: invoke
        }), [
        invoke
    ]);
};

});
parcelRegister("8y8nH", function(module, exports) {

$parcel$export(module.exports, "SmartLinkActionType", () => $79a992dc9de75029$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $79a992dc9de75029$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $79a992dc9de75029$export$6324b7946ad663e9 = /*#__PURE__*/ function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    return SmartLinkActionType;
}({});
class $79a992dc9de75029$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
}

});

parcelRegister("CUTqv", function(module, exports) {

$parcel$export(module.exports, "useResolverUrl", () => $d0d746b9d2a00968$export$d08617a365fbe694);

var $5uXOq = parcelRequire("5uXOq");

var $9UqZ1 = parcelRequire("9UqZ1");
const $d0d746b9d2a00968$export$d08617a365fbe694 = (cardClient)=>(0, $5uXOq.useMemo)(()=>(0, $9UqZ1.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);

});



parcelRegister("4Av71", function(module, exports) {

$parcel$export(module.exports, "getInvokeFailureReason", () => $0f559d5e01a31bc6$export$65b3f792dff0bd60);
$parcel$export(module.exports, "isInvokeCustomError", () => $0f559d5e01a31bc6$export$1694272377fa07d8);

var $4c7pe = parcelRequire("4c7pe");
const $0f559d5e01a31bc6$export$65b3f792dff0bd60 = (err)=>{
    if (!$0f559d5e01a31bc6$export$1694272377fa07d8(err)) return (0, $4c7pe.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $4c7pe.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $4c7pe.TrackQuickActionFailureReason).UnknownError;
    }
};
const $0f559d5e01a31bc6$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;

});

parcelRegister("dO0Cj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9252e4f08a54e0f8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2yoyZ = parcelRequire("2yoyZ");

var $bUpbd = parcelRequire("bUpbd");

var $45Vjm = parcelRequire("45Vjm");

var $eJeqr = parcelRequire("eJeqr");
const $9252e4f08a54e0f8$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $2yoyZ.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $eJeqr.default)();
    return (0, $5uXOq.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $bUpbd.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data);
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $45Vjm.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $9252e4f08a54e0f8$export$2e2bcd8739ae039 = $9252e4f08a54e0f8$var$useResolve;

});
parcelRegister("eJeqr", function(module, exports) {

$parcel$export(module.exports, "default", () => $89a884d5c9fb8cdf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $2yoyZ = parcelRequire("2yoyZ");

var $e74wd = parcelRequire("e74wd");
var $kc2ex = parcelRequire("kc2ex");
var $c8Wzl = parcelRequire("c8Wzl");

var $bUpbd = parcelRequire("bUpbd");

var $lAjZ9 = parcelRequire("lAjZ9");

const $89a884d5c9fb8cdf$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $2yoyZ.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $5uXOq.useCallback)((url, metadataStatus)=>{
        dispatch((0, $e74wd.cardAction)((0, $e74wd.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $5uXOq.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $bUpbd.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $e74wd.cardAction)((0, $e74wd.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $e74wd.cardAction)((0, $e74wd.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $e74wd.cardAction)((0, $e74wd.ACTION_RESOLVED), {
            url: url
        }, (0, $lAjZ9.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $e74wd.cardAction)((0, $e74wd.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $e74wd.cardAction)((0, $e74wd.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $5uXOq.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $e74wd.cardAction)((0, $e74wd.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $e74wd.cardAction)((0, $e74wd.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $5uXOq.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $c8Wzl.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $kc2ex.APIError)('fallback', hostname, (0, $0f12fbcf50ec7a4f$export$3e81ce851ffda0ad)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $kc2ex.APIError)('fatal', hostname, (0, $0f12fbcf50ec7a4f$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $kc2ex.APIError)('error', hostname, (0, $0f12fbcf50ec7a4f$export$338f7d9ccca1975d)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $7nsd3.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $89a884d5c9fb8cdf$export$2e2bcd8739ae039 = $89a884d5c9fb8cdf$var$useResponse;

});
parcelRegister("lAjZ9", function(module, exports) {

$parcel$export(module.exports, "getEmptyJsonLd", () => $71de66192c1d595d$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $71de66192c1d595d$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $71de66192c1d595d$export$e32193033a594efb);
const $71de66192c1d595d$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $71de66192c1d595d$export$2796a804c6e44f63 = ()=>$71de66192c1d595d$var$emptyData;
const $71de66192c1d595d$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$71de66192c1d595d$var$emptyData
        }
    });
const $71de66192c1d595d$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$71de66192c1d595d$var$emptyData
        }
    });

});

const $0f12fbcf50ec7a4f$export$297c39c8b9bfca0 = 'resolving';
const $0f12fbcf50ec7a4f$export$b64a888338c24e0e = 'errored';
const $0f12fbcf50ec7a4f$export$677b6edfa0002c70 = 'fallback';
const $0f12fbcf50ec7a4f$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $0f12fbcf50ec7a4f$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $0f12fbcf50ec7a4f$export$338f7d9ccca1975d = 'Error resolving metadata.';



parcelRegister("eJH2p", function(module, exports) {

$parcel$export(module.exports, "default", () => $733f3346733c3507$export$2e2bcd8739ae039);
const $733f3346733c3507$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $733f3346733c3507$export$2e2bcd8739ae039 = $733f3346733c3507$var$createStatusUpdateRequest;

});

parcelRegister("2XAcY", function(module, exports) {

$parcel$export(module.exports, "default", () => $781a8b5e330a715a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $eOat1 = parcelRequire("eOat1");

var $fHpHg = parcelRequire("fHpHg");
const $781a8b5e330a715a$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $eOat1.default), {
                appearance: props?.appearance,
                ...(0, $fHpHg.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`,
                children: props?.text
            }), [
            props?.appearance,
            props?.testId,
            props?.text
        ]);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
            fallback: fallback,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...props
            })
        });
    };
var $781a8b5e330a715a$export$2e2bcd8739ae039 = $781a8b5e330a715a$var$withErrorBoundary;

});

parcelRegister("fj52x", function(module, exports) {

$parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", () => $1175d7f43086a7fa$export$2a568ff99500df53);
$parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", () => $1175d7f43086a7fa$export$2de2d0ccc17b915f);
$parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", () => $1175d7f43086a7fa$export$c1c05f9d51f7c467);
$parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", () => $1175d7f43086a7fa$export$618660b8f2aa87e2);
const $1175d7f43086a7fa$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $1175d7f43086a7fa$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $1175d7f43086a7fa$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $1175d7f43086a7fa$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};

});

parcelRegister("3mgIX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b4716118515d7f0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $ousew = parcelRequire("ousew");

var $1eETS = parcelRequire("1eETS");
var $3jAdT = parcelRequire("3jAdT");

var $5E93O = parcelRequire("5E93O");

var $fHpHg = parcelRequire("fHpHg");


var $evjcU = parcelRequire("evjcU");

var $7eObK = parcelRequire("7eObK");

var $dijYd = parcelRequire("dijYd");

var $iLSC7 = parcelRequire("iLSC7");
const $4b4716118515d7f0$var$MAX_LINE_NUMBER = 8;
const $4b4716118515d7f0$var$contentStyles = null;
const $4b4716118515d7f0$var$linkStyles = null;
const $4b4716118515d7f0$var$textStylesBase = null;
const $4b4716118515d7f0$var$dropdownItemGroupStyles = null;
const $4b4716118515d7f0$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $4b4716118515d7f0$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $evjcU.useAnalyticsEvents)();
    const invoke = (0, $dijYd.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $5uXOq.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const dynamicCss = null;
    const content = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                    className: (0, $bwpsq.default)([
                        "_zulpu2gc _11c81ixg _1reo15vq _18m915vq _1e0c1txw _1ul9idpf _2lx2vrvc _19pkv77o _4cvr1y6m _pqme2smr _102e2smr _ngc01fxt _1t4p1fxt"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
                            testId: `${testId}-icon`,
                            LEGACY_size: "medium",
                            color: `var(--ds-icon-danger, ${(0, $a7f8c6b391092279$export$2837b5a1a71d5c02)})`,
                            LEGACY_secondaryColor: `var(--ds-background-danger, ${(0, $a7f8c6b391092279$export$4b84fd0e2c617bd)})`,
                            label: 'error',
                            spacing: "spacious"
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                            "data-testid": `${testId}-error-message`,
                            className: (0, $bwpsq.default)([
                                "_11c81ixg _1reo15vq _18m915vq _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
                                "_1yyj1n6p _102k16q4"
                            ]),
                            style: {
                                "--_t4prqe": (0, $lD23V.default)(maxLineNumber)
                            },
                            children: typeof errorMessage === 'string' ? errorMessage : (0, $iLSC7.getFormattedMessage)(errorMessage)
                        })
                    ]
                }),
                isPreviewAvailable ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        "_zulpu2gc _1reo15vq _18m915vq _11c82smr _1e0c1txw _1ul9idpf _2lx2vrvc _4cvr1h6o _80omtlke _19pku2gc _18u0xy5q _otyrv77o"
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                        target: "_blank",
                        "data-testid": `${testId}-open-embed`,
                        onClick: handlePreviewOpen,
                        children: (0, $fHpHg.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7eObK.messages).open_issue_in_jiraIssueTermRefresh
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $7eObK.messages).open_issue_in_jira
                        })
                    })
                }) : null
            ]
        });
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        testId,
        dynamicCss
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-error-item-group`,
        className: (0, $bwpsq.default)([
            "_14hp1wdt _6pup1kw7 _1eo073ad"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3jAdT.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1eETS.default), {
                testId: `${testId}-error`,
                children: content
            })
        })
    });
};
var $4b4716118515d7f0$export$2e2bcd8739ae039 = $4b4716118515d7f0$var$LozengeActionError;

});
parcelRegister("dijYd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c10f693323827949$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $evjcU = parcelRequire("evjcU");

var $9vlyY = parcelRequire("9vlyY");

var $45Vjm = parcelRequire("45Vjm");
const $c10f693323827949$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $c10f693323827949$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $evjcU.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $5uXOq.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, resourceType: resourceType = null })=>{
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $9vlyY.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $45Vjm.startUfoExperience)($c10f693323827949$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            // Invoke action
            const result = await actionFn();
            $9vlyY.mark(markName, 'resolved');
            (0, $45Vjm.succeedUfoExperience)($c10f693323827949$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $9vlyY.getMeasure(markName, 'resolved')?.duration ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            $9vlyY.mark(markName, 'errored');
            (0, $45Vjm.failUfoExperience)($c10f693323827949$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $9vlyY.getMeasure(markName, 'errored')?.duration ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $c10f693323827949$export$2e2bcd8739ae039 = $c10f693323827949$var$useInvokeClientAction;

});
parcelRegister("9vlyY", function(module, exports) {

$parcel$export(module.exports, "clearMarks", () => $28700ff0bd65ee34$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $28700ff0bd65ee34$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $28700ff0bd65ee34$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $28700ff0bd65ee34$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $28700ff0bd65ee34$export$185802fd694ee1f5);
const $28700ff0bd65ee34$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $28700ff0bd65ee34$var$hasPerformanceAPIAvailable = $28700ff0bd65ee34$var$isPerformanceAPIAvailable();
const $28700ff0bd65ee34$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $28700ff0bd65ee34$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $28700ff0bd65ee34$export$1a717feb4df1a945 = (id)=>{
    if ($28700ff0bd65ee34$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $28700ff0bd65ee34$export$de42547d395c8271 = (id)=>{
    if ($28700ff0bd65ee34$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $28700ff0bd65ee34$var$getMark = (id, status)=>{
    if ($28700ff0bd65ee34$var$hasPerformanceAPIAvailable) {
        const name = $28700ff0bd65ee34$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $28700ff0bd65ee34$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($28700ff0bd65ee34$var$hasPerformanceAPIAvailable) {
        const name = $28700ff0bd65ee34$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $28700ff0bd65ee34$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($28700ff0bd65ee34$var$hasPerformanceAPIAvailable) {
        const name = $28700ff0bd65ee34$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $28700ff0bd65ee34$export$185802fd694ee1f5 = (id, status)=>{
    if ($28700ff0bd65ee34$var$hasPerformanceAPIAvailable) {
        const name = $28700ff0bd65ee34$export$984df7f61dd7928f(id, status);
        const measure = $28700ff0bd65ee34$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $28700ff0bd65ee34$var$getMark(id, 'pending');
            const endMark = $28700ff0bd65ee34$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});



parcelRegister("dRhc8", function(module, exports) {

$parcel$export(module.exports, "LozengeActionErrorMessages", () => $4603b807fc6452f4$export$4f2e371a667ad688);

var $7eObK = parcelRequire("7eObK");
const $4603b807fc6452f4$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $7eObK.messages)['status_change_permission_error']
    },
    noDataIssueTermRefresh: {
        descriptor: (0, $7eObK.messages)['status_change_permission_errorIssueTermRefresh']
    },
    unknown: {
        descriptor: (0, $7eObK.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $7eObK.messages)['status_change_update_error']
    }
};

});

parcelRegister("e2moW", function(module, exports) {

$parcel$export(module.exports, "default", () => $edf34ef2e3b76b36$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3jAdT = parcelRequire("3jAdT");

var $kYZST = parcelRequire("kYZST");
const $edf34ef2e3b76b36$var$dropdownItemGroupStyles = null;
const $edf34ef2e3b76b36$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-item-group`,
        className: (0, $bwpsq.default)([
            "_c71l1mjv _18m91wug _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll7166n _qprf166n _n6y8usvi _109gusvi _z29hu4to _wlxpu4to _1gfl12x7 _yhjmutpp _1gqn12x7 _11lvutpp _d4lf1f4h _14hp1wdt _6pup1kw7"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3jAdT.default), {
            children: items.map((item, idx)=>/*#__PURE__*/ (0, $5uXOq.createElement)((0, $kYZST.default), {
                    ...item,
                    key: idx,
                    onClick: onClick,
                    testId: `${testId}-item-${idx}`
                }))
        })
    });
var $edf34ef2e3b76b36$export$2e2bcd8739ae039 = $edf34ef2e3b76b36$var$LozengeActionItemsGroup;

});
parcelRegister("kYZST", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaf6a498995d66e2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1eETS = parcelRequire("1eETS");

var $eOat1 = parcelRequire("eOat1");

var $fHpHg = parcelRequire("fHpHg");
const $aaf6a498995d66e2$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $5uXOq.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        onMouseEnter: handleMouseEnter,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1eETS.default), {
            onClick: handleClick,
            testId: testId,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eOat1.default), {
                appearance: appearance,
                ...(0, $fHpHg.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                children: text
            })
        })
    }));
};
var $aaf6a498995d66e2$export$2e2bcd8739ae039 = $aaf6a498995d66e2$var$LozengeActionItem;

});


parcelRegister("8LU0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $168bfc697b07af9a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dGKFs = parcelRequire("dGKFs");

var $eOat1 = parcelRequire("eOat1");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");
const $168bfc697b07af9a$var$styles = {
    chevronDown: "_18u012x7 _1e0c1txw"
};
const $168bfc697b07af9a$var$triggerLozengeStyles = null;
const $168bfc697b07af9a$var$triggerButtonStyles = null;
const $168bfc697b07af9a$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isBold, setIsBold] = (0, $5uXOq.useState)(false);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>setIsBold(true), []);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>setIsBold(false), []);
    const lozenge = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $eOat1.default), {
            appearance: appearance,
            isBold: (0, $fHpHg.fg)('platform-component-visual-refresh') ? true : isBold,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
                className: (0, $bwpsq.default)([
                    "_4cvr1h6o _1e0c1txw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        children: text
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                        as: "span",
                        xcss: $168bfc697b07af9a$var$styles.chevronDown,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dGKFs))), {
                            color: "currentColor",
                            label: "options",
                            LEGACY_size: "medium",
                            LEGACY_margin: "-4px -8px -4px -7px"
                        })
                    })
                ]
            })
        }), [
        appearance,
        isBold,
        text
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
        type: "button",
        ...props,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: triggerRef,
        className: (0, $bwpsq.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189eyh40 _1h6d3acm _bfhk18uv _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas14y2 _19h614y2 _1d3914y2 _1ejj1vm4 _1u6l1vm4 _6ssh1vm4"
        ]),
        children: lozenge
    });
};
var $168bfc697b07af9a$export$2e2bcd8739ae039 = $168bfc697b07af9a$var$LozengeActionTrigger;

});



parcelRegister("di1ar", function(module, exports) {

$parcel$export(module.exports, "default", () => $92f5f32ef44aa0d9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $92pfy = parcelRequire("92pfy");
/**
 * Media: Image
 * [aspect-ratio: 16 / 9] The context box is fixed to aspect ratio of 16:9.
 * [object-fit: cover] The replaced content is sized to maintain
 * its aspect ratio while filling the element's entire content box.
 * If the object's aspect ratio does not match the aspect ratio of its box,
 * then the object will be clipped to fit.
 * [object-position] Center alignment of the selected replaced element's
 * contents within the element's box.
 */ const $92f5f32ef44aa0d9$var$styles = null;
/**
 * A base element that displays a Media.
 * @internal
 * @param {MediaProps} MediaProps - The props necessary for the Media element.
 * @see Preview
 */ const $92f5f32ef44aa0d9$var$Media = ({ name: name, className: className, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    if (!type || !url) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1h1tcq2i _1e0c1txw _1bsb1osq _4t3i1ns9 _jqez1osq _1lg71osq _6slq1osq _x1m21osq _1chb1osq _1usb1osq _5c331osq _l9z01osq _6o691dfr _vr2g1dfr _173baqso _1niwaqso _t0h9stnw _1ulbstnw _byj21ooe _3hvr1ooe _1c0s1ssb _15j31ssb _1npy1ssb _19he1ssb _n3vc1wug _1qj91wug _4fdy1wug _18cv1wug _1aoq15vq _1iqz15vq _6fioj63w _l0jmidpf _12zuh2mm",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $92pfy.default), {
            testId: `${testId}-image`,
            url: url,
            onError: onError,
            onLoad: onLoad,
            defaultIcon: null
        })
    });
};
var $92f5f32ef44aa0d9$export$2e2bcd8739ae039 = $92f5f32ef44aa0d9$var$Media;

});

parcelRegister("1ue1o", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9e0337fbe36f102$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fHpHg = parcelRequire("fHpHg");

var $iLSC7 = parcelRequire("iLSC7");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $a9e0337fbe36f102$var$baseStyleOld = null;
const $a9e0337fbe36f102$var$baseStyle = null;
/**
 * A base element that displays some Text.
 * @internal
 * @param {TextProps} TextProps - The props necessary for the Text element.
 * @see Title
 */ const $a9e0337fbe36f102$var$Text = ({ content: content, maxLines: maxLines = 1, message: message, name: name, className: className, testId: testId = 'smart-element-text' })=>{
    if (!message && !content) return null;
    const dynamicCss = null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _1reo15vq _18m915vq _syaz131l _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
            (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            "_1yyjr31u _102k1dud",
            className
        ]),
        style: {
            "--_1erfju8": (0, $lD23V.default)(maxLines)
        },
        children: (0, $iLSC7.getFormattedMessage)(message) || content
    });
};
var $a9e0337fbe36f102$export$2e2bcd8739ae039 = $a9e0337fbe36f102$var$Text;

});


parcelRegister("atbcR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2013342980c9cf8$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bUpbd = parcelRequire("bUpbd");

var $gSLUn = parcelRequire("gSLUn");

var $di1ar = parcelRequire("di1ar");
const $c2013342980c9cf8$var$Preview = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $5uXOq.useContext)((0, $gSLUn.FlexibleUiContext));
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $bUpbd.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $di1ar.default), {
        ...rest,
        ...data
    });
};
var $c2013342980c9cf8$export$2e2bcd8739ae039 = $c2013342980c9cf8$var$Preview;

});

parcelRegister("jmfre", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec65e2a71f804275$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHpHg = parcelRequire("fHpHg");

var $gSLUn = parcelRequire("gSLUn");

var $1ue1o = parcelRequire("1ue1o");
const $ec65e2a71f804275$var$SNIPPET_DEFAULT_MAX_LINES = 3;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $ec65e2a71f804275$var$snippetBaseStyleOld = null;
const $ec65e2a71f804275$var$snippetBaseStyle = null;
const $ec65e2a71f804275$var$SnippetElement = (props)=>{
    const { content: overrideContent, maxLines: maxLines = $ec65e2a71f804275$var$SNIPPET_DEFAULT_MAX_LINES, className: className, ...restOfProps } = props ?? {};
    const context = (0, $5uXOq.useContext)((0, $gSLUn.FlexibleUiContext));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1ue1o.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && "_syaz1fxt _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && "_syaz1fxt _1ul9idpf _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        ...restOfProps
    });
};
var $ec65e2a71f804275$export$2e2bcd8739ae039 = $ec65e2a71f804275$var$SnippetElement;

});


parcelRegister("3Uo8j", function(module, exports) {

$parcel$export(module.exports, "default", () => $1386c1721ac9ef81$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ousew = parcelRequire("ousew");

var $gKZoD = parcelRequire("gKZoD");

var $jHTSg = parcelRequire("jHTSg");

var $cNW3X = parcelRequire("cNW3X");

var $j7m8K = parcelRequire("j7m8K");

var $elaEw = parcelRequire("elaEw");

var $fHpHg = parcelRequire("fHpHg");

var $5KCCi = parcelRequire("5KCCi");

var $bUpbd = parcelRequire("bUpbd");

var $7eObK = parcelRequire("7eObK");

var $gSLUn = parcelRequire("gSLUn");

var $iLSC7 = parcelRequire("iLSC7");

var $S0OVy = parcelRequire("S0OVy");

var $8kAgY = parcelRequire("8kAgY");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $1386c1721ac9ef81$var$stylesOld = null;
const $1386c1721ac9ef81$var$styles = null;
const $1386c1721ac9ef81$var$renderActionItems = (items = [], size = (0, $bUpbd.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $8kAgY.default), {
            item: item,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }, idx));
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $1386c1721ac9ef81$var$ActionGroup = ({ items: items = [], size: size = (0, $bUpbd.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    (0, $gKZoD.di)((0, $j7m8K.default));
    const context = (0, $gSLUn.useFlexibleUiContext)();
    const ui = (0, $gSLUn.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const renderableActionItems = (0, $5uXOq.useMemo)(()=>(0, $S0OVy.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $5uXOq.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $5uXOq.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $1386c1721ac9ef81$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $5uXOq.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $iLSC7.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($elaEw))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $7eObK.messages).more_actions
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j7m8K.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span",
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
                            ...props,
                            spacing: spacing,
                            testId: "action-group-more-button",
                            iconBefore: moreIcon,
                            ref: triggerRef
                        })
                    }),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex,
                children: $1386c1721ac9ef81$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick)
            });
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            !(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _vwz41j6v _dzc21h6o _1ilq1i6y",
            (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _dzc21h6o _1ilq1i6y",
            "actions-button-group"
        ]),
        "data-action-open": isOpen,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jHTSg.default), {
            children: [
                actionButtons,
                moreActionDropdown
            ]
        })
    }) : null;
};
var $1386c1721ac9ef81$export$2e2bcd8739ae039 = $1386c1721ac9ef81$var$ActionGroup;

});
parcelRegister("S0OVy", function(module, exports) {

$parcel$export(module.exports, "filterActionItems", () => $e3ed5d61e3ac26aa$export$adbd04236f07a7d8);
$parcel$export(module.exports, "renderChildren", () => $e3ed5d61e3ac26aa$export$cd762ccf1a583d69);
$parcel$export(module.exports, "renderElementItems", () => $e3ed5d61e3ac26aa$export$9678d3ca18bd7526);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bUpbd = parcelRequire("bUpbd");

var $kYS90 = parcelRequire("kYS90");

var $5wGZS = parcelRequire("5wGZS");

var $3Uo8j = parcelRequire("3Uo8j");

var $hWtFf = parcelRequire("hWtFf");
const $e3ed5d61e3ac26aa$export$f942619ce67b1a41 = {
    [(0, $bUpbd.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).Location]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).Preview]: [
        'block'
    ],
    [(0, $bUpbd.ElementName).Priority]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).Provider]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).Snippet]: [
        'block'
    ],
    [(0, $bUpbd.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).State]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).Title]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $bUpbd.ElementName).VoteCount]: [
        'inline'
    ]
};
const $e3ed5d61e3ac26aa$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $bUpbd.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $bUpbd.SmartLinkSize).Large:
            return 1;
        case (0, $bUpbd.SmartLinkSize).Medium:
            return 0.5;
        case (0, $bUpbd.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $e3ed5d61e3ac26aa$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, $3Uo8j.default);
const $e3ed5d61e3ac26aa$var$isElementDisplayValid = (name, display)=>{
    return $e3ed5d61e3ac26aa$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $e3ed5d61e3ac26aa$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $e3ed5d61e3ac26aa$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).isValidElement(node) && ((0, $kYS90.isFlexibleUiElement)(node) || node.type === (0, $hWtFf.default));
const $e3ed5d61e3ac26aa$export$adbd04236f07a7d8 = (items = [], context)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $bUpbd.ActionName).DeleteAction:
            case (0, $bUpbd.ActionName).EditAction:
            case (0, $bUpbd.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $bUpbd.ActionName)[item.name]);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $e3ed5d61e3ac26aa$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map(children, (child)=>{
        if ($e3ed5d61e3ac26aa$var$isElementOrElementGroup(child) || $e3ed5d61e3ac26aa$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $e3ed5d61e3ac26aa$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $5wGZS[name];
        const typedProps = props;
        if (Element && $e3ed5d61e3ac26aa$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, $2OMIu.jsx)(Element, {
                ...typedProps
            }, idx);
            if (!$e3ed5d61e3ac26aa$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};

});
parcelRegister("hWtFf", function(module, exports) {

$parcel$export(module.exports, "default", () => $c443718a93965e87$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHpHg = parcelRequire("fHpHg");

var $bUpbd = parcelRequire("bUpbd");

var $S0OVy = parcelRequire("S0OVy");
const $c443718a93965e87$var$alignmentStyleMap = {
    right: "_1dthh9n0 _r291h9n0 _1bahesu3 _y3gnusic",
    left: "_1dthv2br _r291v2br _1bah1y6m _y3gn1e5h"
};
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $c443718a93965e87$var$baseStyleBySizeOld = {
    xlarge: "_zulp147b _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    large: "_zulp1e9d _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    medium: "_zulpcxkx _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    small: "_zulppdf9 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v"
};
const $c443718a93965e87$var$baseStyleBySize = {
    xlarge: "_zulpv47k _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    large: "_zulppxbi _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    medium: "_zulpu2gc _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    small: "_zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf"
};
const $c443718a93965e87$var$baseStyleByDirection = {
    horizontal: "_2lx2vrvc _4cvr1h6o",
    vertical: "_2lx21bp4 _4cvr1y6m"
};
const $c443718a93965e87$var$baseStyleOld = null;
const $c443718a93965e87$var$baseStyles = null;
const $c443718a93965e87$var$widthStyle = {
    flexible: "_16jlkb7n _1o9z11wp _i0dlf1ug",
    'fit-to-content': ""
};
const $c443718a93965e87$var$positionStyle = {
    top: "_1wpz1y6m",
    center: ""
};
const $c443718a93965e87$var$horizontalStyleBase = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $c443718a93965e87$var$horizontalStyleByHeightOld = {
    xlarge: "_1e0ccj1k _102k1m1q",
    large: "_1e0ccj1k _102k1m1q",
    medium: "_1e0ccj1k _102k1k8s",
    small: "_1e0ccj1k _102k1k8s"
};
const $c443718a93965e87$var$horizontalStyleByHeight = {
    xlarge: "_1e0ccj1k _102k125z",
    large: "_1e0ccj1k _102k125z",
    medium: "_1e0ccj1k _102kz42d",
    small: "_1e0ccj1k _102kz42d"
};
const $c443718a93965e87$var$gapStylesLeft = {
    xlarge: "_7yhbv47k _m6ukidpf",
    large: "_7yhbpxbi _m6ukidpf",
    medium: "_7yhbu2gc _m6ukidpf",
    small: "_7yhb1b66 _m6ukidpf"
};
const $c443718a93965e87$var$gapStylesRight = {
    xlarge: "_24rcv47k _3dveidpf",
    large: "_24rcpxbi _3dveidpf",
    medium: "_24rcu2gc _3dveidpf",
    small: "_24rc1b66 _3dveidpf"
};
const $c443718a93965e87$var$minWidthStyle = null;
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $c443718a93965e87$var$ElementGroup = ({ align: align = (0, $bUpbd.SmartLinkAlignment).Left, children: children, direction: direction = (0, $bUpbd.SmartLinkDirection).Horizontal, size: size = (0, $bUpbd.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $bUpbd.SmartLinkWidth).FitToContent, position: position = (0, $bUpbd.SmartLinkPosition).Center, className: className })=>{
    const isHorizontal = direction === (0, $bUpbd.SmartLinkDirection).Horizontal;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-smart-element-group": true,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && $c443718a93965e87$var$baseStyleBySizeOld[size],
            (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && $c443718a93965e87$var$baseStyleBySize[size],
            $c443718a93965e87$var$baseStyleByDirection[direction],
            !(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && "_fiawglyw _1ouwidpf _f6ju1ns9",
            (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && "_fiawglyw",
            $c443718a93965e87$var$alignmentStyleMap[align],
            "_1ul99by0",
            $c443718a93965e87$var$widthStyle[width],
            isHorizontal && "_1reo15vq _18m915vq _1e0c1ule _s7n4nkob _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _1aaynkob _15tynkob _1iu61nu9 _166k1nu9 _1div1nu9 _bmfb1nu9",
            isHorizontal && !(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && $c443718a93965e87$var$horizontalStyleByHeightOld[size],
            isHorizontal && (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && $c443718a93965e87$var$horizontalStyleByHeight[size],
            isHorizontal && align === (0, $bUpbd.SmartLinkAlignment).Left && $c443718a93965e87$var$gapStylesLeft[size],
            isHorizontal && align === (0, $bUpbd.SmartLinkAlignment).Right && $c443718a93965e87$var$gapStylesRight[size],
            $c443718a93965e87$var$positionStyle[position],
            className
        ]),
        children: (0, $S0OVy.renderChildren)(children, size)
    });
};
var $c443718a93965e87$export$2e2bcd8739ae039 = $c443718a93965e87$var$ElementGroup;

});


parcelRegister("8kAgY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ac4f305142c64c0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dKqTa = parcelRequire("dKqTa");
const $7ac4f305142c64c0$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $dKqTa ? $dKqTa[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $7ac4f305142c64c0$export$2e2bcd8739ae039 = $7ac4f305142c64c0$var$ActionGroupItem;

});
parcelRegister("dKqTa", function(module, exports) {

$parcel$export(module.exports, "CustomAction", () => (parcelRequire("iQpos")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("7wN4E")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("8iCML")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("cKiZQ")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("5vDqJ")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("ipK8i")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("dq0lU")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("atFJD")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("iLDTL")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("gXOwg")).default);

var $iQpos = parcelRequire("iQpos");

var $7wN4E = parcelRequire("7wN4E");

var $8iCML = parcelRequire("8iCML");

var $cKiZQ = parcelRequire("cKiZQ");

var $5vDqJ = parcelRequire("5vDqJ");

var $ipK8i = parcelRequire("ipK8i");

var $dq0lU = parcelRequire("dq0lU");

var $atFJD = parcelRequire("atFJD");

var $iLDTL = parcelRequire("iLDTL");

var $gXOwg = parcelRequire("gXOwg");

});
parcelRegister("iQpos", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bc5468de3cc2a89$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bUpbd = parcelRequire("bUpbd");

var $5w4pI = parcelRequire("5w4pI");

var $he5H1 = parcelRequire("he5H1");

var $cE8lf = parcelRequire("cE8lf");

var $dhoCO = parcelRequire("dhoCO");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $5bc5468de3cc2a89$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $bUpbd.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, style: style, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cE8lf.default), {
        asStackItemIcon: isStackItem,
        isDisabled: isDisabled,
        icon: icon,
        size: size,
        testId: testId
    }) : undefined;
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dhoCO.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $he5H1.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5w4pI.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        children: button
    }) : button;
};
var $5bc5468de3cc2a89$export$2e2bcd8739ae039 = $5bc5468de3cc2a89$var$Action;

});
parcelRegister("5w4pI", function(module, exports) {

$parcel$export(module.exports, "default", () => $32a30b9196e5580e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $i95f5 = parcelRequire("i95f5");

var $bMFGq = parcelRequire("bMFGq");
var $1Seuh = parcelRequire("1Seuh");
var $liZ21 = parcelRequire("liZ21");
var $620fp = parcelRequire("620fp");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");

var $5KCCi = parcelRequire("5KCCi");

var $bUpbd = parcelRequire("bUpbd");

var $gSLUn = parcelRequire("gSLUn");

var $1D7AK = parcelRequire("1D7AK");

var $iLSC7 = parcelRequire("iLSC7");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $32a30b9196e5580e$var$IconOnlyLarge = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $32a30b9196e5580e$var$SizeSmall = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $32a30b9196e5580e$var$SizeSmallIconOnly = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $32a30b9196e5580e$var$SizeSmallNotIconOnly = null;
const $32a30b9196e5580e$var$IconButtonAppearanceMap = {
    default: 'default',
    danger: undefined,
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: undefined
};
const $32a30b9196e5580e$var$ButtonAppearanceMap = {
    default: 'default',
    danger: 'danger',
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: 'warning'
};
const $32a30b9196e5580e$var$tooltipOptions = {
    hideTooltipOnClick: true
};
const $32a30b9196e5580e$var$ActionButtonRefreshNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel }, ref)=>{
    const iconOnly = !content;
    const onButtonClick = (0, $5uXOq.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    const button = (0, $5uXOq.useMemo)(()=>{
        const isLinkButton = !!href;
        const spacing = size === (0, $bUpbd.SmartLinkSize).Large || size === (0, $bUpbd.SmartLinkSize).XLarge ? 'default' : 'compact';
        if (iconOnly) {
            const icon = iconBefore || iconAfter;
            const iconFn = ()=>icon || null;
            if (isLinkButton) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $620fp.default), {
                appearance: $32a30b9196e5580e$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                href: href,
                isDisabled: isDisabled,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $32a30b9196e5580e$var$tooltipOptions
            });
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
                appearance: $32a30b9196e5580e$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $32a30b9196e5580e$var$tooltipOptions
            });
        }
        const iconBeforeFn = ()=>iconBefore || null;
        const iconAfterFn = ()=>iconAfter || null;
        if (isLinkButton) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $liZ21.default), {
            appearance: $32a30b9196e5580e$var$ButtonAppearanceMap[appearance],
            "aria-label": ariaLabel,
            iconAfter: iconAfterFn,
            iconBefore: iconBeforeFn,
            isDisabled: isDisabled,
            href: href,
            onClick: onButtonClick(onClick),
            spacing: spacing,
            testId: testId,
            children: content
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMFGq.default), {
            appearance: $32a30b9196e5580e$var$ButtonAppearanceMap[appearance],
            "aria-label": ariaLabel,
            iconAfter: iconAfterFn,
            iconBefore: iconBeforeFn,
            isDisabled: isDisabled,
            isLoading: isLoading,
            onClick: onButtonClick(onClick),
            spacing: spacing,
            testId: testId,
            children: content
        });
    }, [
        appearance,
        ariaLabel,
        content,
        href,
        iconAfter,
        iconBefore,
        iconOnly,
        isDisabled,
        isLoading,
        onButtonClick,
        onClick,
        size,
        testId,
        tooltipMessage
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        testId: `${testId}-button-wrapper`,
        ref: ref,
        children: button
    });
});
// On cleanup of platform-linking-visual-refresh-v1, this should become
// export default withOverrideCss(ActionButton);
const $32a30b9196e5580e$var$ActionButtonRefreshNewWithOverrideCss = (0, $1D7AK.withOverrideCss)($32a30b9196e5580e$var$ActionButtonRefreshNew);
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $32a30b9196e5580e$var$ActionButtonNew = ({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $5uXOq.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            size === (0, $bUpbd.SmartLinkSize).Large && iconOnly && "_1gflidpf _or3fidpf _1ddvidpf _1hhaidpf _yhjmidpf _1trnidpf _1fstidpf _1xceidpf _1gqnidpf _1qdmidpf _df2ridpf _j1twidpf _11lvidpf _192bidpf _vbn7idpf _wfu3idpf _1i3bidpf _13gwidpf _4wlcidpf _rehaidpf _mp2fidpf _ro8midpf _1l0qidpf _1bnaidpf _3kh9idpf _i2vxidpf _8pvjidpf _1e1oidpf _1vtwidpf _ijvwidpf _tpwpidpf _1ad8idpf",
            size === (0, $bUpbd.SmartLinkSize).Small && "_11c8dcr7 _k48p1wq8",
            size === (0, $bUpbd.SmartLinkSize).Small && iconOnly && "_1gfl1xvx _or3f1xvx _1ddv1xvx _1hha1xvx _yhjm1xvx _1trn1xvx _1fst1xvx _1xce1xvx _1gqn1xvx _1qdm1xvx _df2r1xvx _j1tw1xvx _11lv1xvx _192b1xvx _vbn71xvx _wfu31xvx",
            size === (0, $bUpbd.SmartLinkSize).Small && !iconOnly && "_11lvpdf9 _192bpdf9 _vbn7pdf9 _wfu3pdf9 _yhjmpdf9 _1trnpdf9 _1fstpdf9 _1xcepdf9",
            className
        ]),
        "data-testid": `${testId}-button-wrapper`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i95f5.default), {
                appearance: appearance,
                iconAfter: iconAfter,
                iconBefore: iconBefore,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: (0, $iLSC7.sizeToButtonSpacing)[size],
                testId: testId,
                href: href,
                "aria-label": ariaLabel,
                children: content
            })
        })
    });
};
const $32a30b9196e5580e$var$ActionButtonHideLegacyButton = (props)=>{
    const ui = (0, $gSLUn.useFlexibleUiOptionContext)();
    if (ui?.hideLegacyButton) return /*#__PURE__*/ (0, $2OMIu.jsx)($32a30b9196e5580e$var$ActionButtonRefreshNewWithOverrideCss, {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($32a30b9196e5580e$var$ActionButtonNew, {
        ...props
    });
};
const $32a30b9196e5580e$var$ActionButton = (props)=>{
    return (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $2OMIu.jsx)($32a30b9196e5580e$var$ActionButtonHideLegacyButton, {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($32a30b9196e5580e$var$ActionButtonNew, {
        ...props
    });
};
var $32a30b9196e5580e$export$2e2bcd8739ae039 = $32a30b9196e5580e$var$ActionButton;

});

parcelRegister("he5H1", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a1600bf19ed30aa$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $1eETS = parcelRequire("1eETS");

var $lR50Q = parcelRequire("lR50Q");
const $2a1600bf19ed30aa$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1eETS.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $lR50Q.handleOnClick)(onClick),
        testId: testId,
        children: content
    });
var $2a1600bf19ed30aa$export$2e2bcd8739ae039 = $2a1600bf19ed30aa$var$ActionDropdownItem;

});

parcelRegister("cE8lf", function(module, exports) {

$parcel$export(module.exports, "default", () => $db6380d0214772aa$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHpHg = parcelRequire("fHpHg");

var $bUpbd = parcelRequire("bUpbd");
const $db6380d0214772aa$var$getIconWidth = (size)=>{
    switch(size){
        case (0, $bUpbd.SmartLinkSize).XLarge:
        case (0, $bUpbd.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $bUpbd.SmartLinkSize).Medium:
        case (0, $bUpbd.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $db6380d0214772aa$var$iconSizeStyleMap = {
    '1.5rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    '1rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    '20px': "_16jlidpf _1o9zidpf _i0dl1wug _4t3igktf _1tkegktf _c71lgktf _1bsbgktf _1ul9gktf _p12fgktf _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7gktf _1xjxgktf _1752gktf _qci8gktf _15izgktf _erubgktf _19l3gktf _1pr2gktf _1u5tgktf _mezjgktf _e2oogktf _w8l5gktf _1rg2gktf _q7cvgktf _xwbjgktf _rtysgktf _b8nkgktf _4x20gktf"
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $db6380d0214772aa$var$stackItemIconStylesOld = null;
const $db6380d0214772aa$var$stackItemIconStylesCompiled = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $db6380d0214772aa$var$iconStyleMap = {
    true: "_syaz2oi6",
    false: "_syazwdcn"
};
const $db6380d0214772aa$var$ActionIcon = ({ size: size, testId: testId, icon: icon, isDisabled: isDisabled, asStackItemIcon: asStackItemIcon })=>{
    if (!(0, $fHpHg.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $bwpsq.default)([
            !(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && $db6380d0214772aa$var$iconStyleMap[isDisabled ? 'true' : 'false'],
            asStackItemIcon && "_1e0c1o8l _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            asStackItemIcon && $db6380d0214772aa$var$iconSizeStyleMap['20px'],
            !asStackItemIcon && $db6380d0214772aa$var$iconSizeStyleMap[$db6380d0214772aa$var$getIconWidth(size)]
        ]),
        children: icon
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $bwpsq.default)([
            !(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && $db6380d0214772aa$var$iconStyleMap[isDisabled ? 'true' : 'false'],
            "_1e0c1o8l"
        ]),
        children: icon
    });
};
var $db6380d0214772aa$export$2e2bcd8739ae039 = $db6380d0214772aa$var$ActionIcon;

});

parcelRegister("dhoCO", function(module, exports) {

$parcel$export(module.exports, "default", () => $420a57c4aceaa458$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5KCCi = parcelRequire("5KCCi");

var $kKy0s = parcelRequire("kKy0s");
const $420a57c4aceaa458$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kKy0s.default), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kKy0s.default), {
                ...props,
                content: content,
                tooltipProps: tooltipProps
            })
    });
var $420a57c4aceaa458$export$2e2bcd8739ae039 = $420a57c4aceaa458$var$ActionStackItem;

});
parcelRegister("kKy0s", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a945440be228ae2$export$2e2bcd8739ae039);
/* action-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6tzHJ = parcelRequire("6tzHJ");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $7rJgC = parcelRequire("7rJgC");

var $clxo5 = parcelRequire("clxo5");

var $iLSC7 = parcelRequire("iLSC7");

var $cE8lf = parcelRequire("cE8lf");
const $4a945440be228ae2$var$stylesOld = {
    button: "_kkk2n7od _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _irr3166n _1di61dty",
    content: "_11c8dcr7 _syaz1fxt"
};
const $4a945440be228ae2$var$styles = {
    button: "_bfhk1w7a _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _1ah31i6y _irr3166n _1di61dty",
    content: "_11c81o8v _syaz1fxt"
};
const $4a945440be228ae2$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, style: style })=>{
    const space = spaceOption ?? (0, $iLSC7.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const icon = iconOption && isLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cE8lf.default), {
        asStackItemIcon: true,
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {
            testId: `${testId}-loading`
        }),
        size: size
    }) : iconOption;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
        xcss: (0, $6tzHJ.cx)(!(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && $4a945440be228ae2$var$stylesOld.button, (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && $4a945440be228ae2$var$styles.button),
        ...tooltipProps,
        onClick: onClick,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
            alignBlock: "center",
            grow: "fill",
            space: space,
            children: [
                icon,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    xcss: (0, $6tzHJ.cx)(!(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && $4a945440be228ae2$var$stylesOld.content, (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && $4a945440be228ae2$var$styles.content),
                    children: content
                })
            ]
        })
    });
};
var $4a945440be228ae2$export$2e2bcd8739ae039 = $4a945440be228ae2$var$ActionButton;

});



parcelRegister("7wN4E", function(module, exports) {

$parcel$export(module.exports, "default", () => $de1ddb4db03488b5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $kweMg = parcelRequire("kweMg");

var $7eObK = parcelRequire("7eObK");

var $iQpos = parcelRequire("iQpos");
const $de1ddb4db03488b5$var$DeleteAction = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iQpos.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7eObK.messages).delete
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kweMg))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7eObK.messages).delete
        }),
        ...props
    });
var $de1ddb4db03488b5$export$2e2bcd8739ae039 = $de1ddb4db03488b5$var$DeleteAction;

});

parcelRegister("8iCML", function(module, exports) {

$parcel$export(module.exports, "default", () => $03c9a7616404f71c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $gTpfq = parcelRequire("gTpfq");

var $7eObK = parcelRequire("7eObK");

var $iQpos = parcelRequire("iQpos");
const $03c9a7616404f71c$var$EditAction = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iQpos.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7eObK.messages).edit
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gTpfq))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7eObK.messages).edit
        }),
        ...props
    });
var $03c9a7616404f71c$export$2e2bcd8739ae039 = $03c9a7616404f71c$var$EditAction;

});
parcelRegister("gTpfq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::631c9d525a923bb24b78f7aa2d70d92c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4c55e11080ecfc1$var$_react = $c4c55e11080ecfc1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c4c55e11080ecfc1$var$_edit = $c4c55e11080ecfc1$var$_interopRequireDefault((parcelRequire("084bx")));

var $c4c55e11080ecfc1$var$_edit2 = $c4c55e11080ecfc1$var$_interopRequireDefault((parcelRequire("78GxT")));
function $c4c55e11080ecfc1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4c55e11080ecfc1$var$EditIcon = (props)=>/*#__PURE__*/ $c4c55e11080ecfc1$var$_react.default.createElement($c4c55e11080ecfc1$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $c4c55e11080ecfc1$var$_edit2.default
    }, props));
$c4c55e11080ecfc1$var$EditIcon.Name = 'EditIconMigration';
var $c4c55e11080ecfc1$var$_default = module.exports.default = $c4c55e11080ecfc1$var$EditIcon;

});
parcelRegister("78GxT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $532a48721af78794$var$_react = $532a48721af78794$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $532a48721af78794$var$_edit = $532a48721af78794$var$_interopRequireDefault((parcelRequire("084bx")));
function $532a48721af78794$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $532a48721af78794$var$EditIcon = (props)=>/*#__PURE__*/ $532a48721af78794$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $532a48721af78794$var$_edit.default
    }));
$532a48721af78794$var$EditIcon.displayName = 'EditIcon';
var $532a48721af78794$var$_default = module.exports.default = $532a48721af78794$var$EditIcon;

});



parcelRegister("cKiZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $650982a4cf7abc5f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $ckIJo = parcelRequire("ckIJo");

var $bUpbd = parcelRequire("bUpbd");

var $7eObK = parcelRequire("7eObK");

var $gSLUn = parcelRequire("gSLUn");

var $dijYd = parcelRequire("dijYd");

var $iQpos = parcelRequire("iQpos");
const $650982a4cf7abc5f$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $gSLUn.useFlexibleUiContext)();
    const invoke = (0, $dijYd.default)({});
    const data = context?.actions?.[(0, $bUpbd.ActionName).DownloadAction];
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $7eObK.messages).download_file : (0, $7eObK.messages).download;
    const tooltipMessage = isStackItem ? (0, $7eObK.messages).download_description : (0, $7eObK.messages).download;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iQpos.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...label
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ckIJo))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props
    }) : null;
};
var $650982a4cf7abc5f$export$2e2bcd8739ae039 = $650982a4cf7abc5f$var$DownloadAction;

});
parcelRegister("ckIJo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::647640fe09afef5813e2888b2ce1f074>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8faa0cf4b4836748$var$_react = $8faa0cf4b4836748$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8faa0cf4b4836748$var$_download = $8faa0cf4b4836748$var$_interopRequireDefault((parcelRequire("1KzS2")));

var $8faa0cf4b4836748$var$_download2 = $8faa0cf4b4836748$var$_interopRequireDefault((parcelRequire("d4Rcp")));
function $8faa0cf4b4836748$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DownloadIcon.
 * This component is DownloadIcon, with `UNSAFE_fallbackIcon` set to "DownloadIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8faa0cf4b4836748$var$DownloadIcon = (props)=>/*#__PURE__*/ $8faa0cf4b4836748$var$_react.default.createElement($8faa0cf4b4836748$var$_download.default, Object.assign({
        LEGACY_fallbackIcon: $8faa0cf4b4836748$var$_download2.default
    }, props));
$8faa0cf4b4836748$var$DownloadIcon.Name = 'DownloadIconMigration';
var $8faa0cf4b4836748$var$_default = module.exports.default = $8faa0cf4b4836748$var$DownloadIcon;

});
parcelRegister("1KzS2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3903aba4213e0f68da56229d9d15d40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1465e977fc5b7ff2$var$_react = $1465e977fc5b7ff2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1465e977fc5b7ff2$var$_baseNew = $1465e977fc5b7ff2$var$_interopRequireDefault((parcelRequire("enEmH")));
function $1465e977fc5b7ff2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1465e977fc5b7ff2$var$DownloadIcon = (props)=>/*#__PURE__*/ $1465e977fc5b7ff2$var$_react.default.createElement($1465e977fc5b7ff2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$1465e977fc5b7ff2$var$DownloadIcon.displayName = 'DownloadIcon';
var $1465e977fc5b7ff2$var$_default = module.exports.default = $1465e977fc5b7ff2$var$DownloadIcon;

});

parcelRegister("d4Rcp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9854ea4ebe9b25b0$var$_react = $9854ea4ebe9b25b0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $9854ea4ebe9b25b0$var$_download = $9854ea4ebe9b25b0$var$_interopRequireDefault((parcelRequire("1KzS2")));
function $9854ea4ebe9b25b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9854ea4ebe9b25b0$var$DownloadIcon = (props)=>/*#__PURE__*/ $9854ea4ebe9b25b0$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props, {
        newIcon: $9854ea4ebe9b25b0$var$_download.default
    }));
$9854ea4ebe9b25b0$var$DownloadIcon.displayName = 'DownloadIcon';
var $9854ea4ebe9b25b0$var$_default = module.exports.default = $9854ea4ebe9b25b0$var$DownloadIcon;

});



parcelRegister("5vDqJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1c08864db0c076a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $bUpbd = parcelRequire("bUpbd");

var $7eObK = parcelRequire("7eObK");

var $gSLUn = parcelRequire("gSLUn");

var $iLSC7 = parcelRequire("iLSC7");

var $bTkGW = parcelRequire("bTkGW");

var $ijUkL = parcelRequire("ijUkL");


const $b1c08864db0c076a$var$importIconMapper = {
    goal: ()=>(parcelRequire("hnjVX")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("4PRZL")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $b1c08864db0c076a$var$getIcon = (stackIconType)=>{
    const importFn = $b1c08864db0c076a$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $iLSC7.importIcon)(importFn);
};
const $b1c08864db0c076a$var$FollowAction = (props)=>{
    const context = (0, $gSLUn.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $bUpbd.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $7eObK.messages).follow : (0, $7eObK.messages).unfollow;
    const projectMessage = value ? (0, $7eObK.messages).follow_project : (0, $7eObK.messages).unfollow_project;
    const goalMessage = value ? (0, $7eObK.messages).follow_goal : (0, $7eObK.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $7eObK.messages).follow_project_description : (0, $7eObK.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $7eObK.messages).follow_goal_description : (0, $7eObK.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $b1c08864db0c076a$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, $2OMIu.jsx)(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $ijUkL.getFollowActionErrorMessage)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...errorMessage
            }),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bTkGW.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...label
        }),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props,
        onError: handleError
    });
};
var $b1c08864db0c076a$export$2e2bcd8739ae039 = $b1c08864db0c076a$var$FollowAction;

});
parcelRegister("bTkGW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed0301ba8e1b2f9c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $evjcU = parcelRequire("evjcU");

var $9RoW9 = parcelRequire("9RoW9");

var $4Av71 = parcelRequire("4Av71");

var $dO0Cj = parcelRequire("dO0Cj");

var $d7VEk = parcelRequire("d7VEk");

var $iQpos = parcelRequire("iQpos");
const $ed0301ba8e1b2f9c$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const invoke = (0, $9RoW9.default)();
    const reload = (0, $dO0Cj.default)();
    const { fireEvent: fireEvent } = (0, $evjcU.useAnalyticsEvents)();
    const handleClick = (0, $5uXOq.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                if (smartLinkActionType === 'FollowEntityAction' || smartLinkActionType === 'UnfollowEntityAction') fireEvent('ui.button.clicked.smartLinkFollowButton', {});
                else fireEvent(`ui.button.clicked.${smartLinkActionType}`, {});
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $d7VEk.default)(action);
                await invoke(request);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                fireEvent('track.smartLinkQuickAction.failed', {
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $4Av71.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        invoke,
        onClick,
        onErrorCallback,
        reload,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iQpos.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $ed0301ba8e1b2f9c$export$2e2bcd8739ae039 = $ed0301ba8e1b2f9c$var$ServerAction;

});
parcelRegister("d7VEk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4d7f7d987d2173e$export$2e2bcd8739ae039);
const $d4d7f7d987d2173e$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $d4d7f7d987d2173e$export$2e2bcd8739ae039 = $d4d7f7d987d2173e$var$createInvokeRequest;

});


parcelRegister("ijUkL", function(module, exports) {

$parcel$export(module.exports, "getFollowActionErrorMessage", () => $ea5cd806d61a3813$export$49248678d3914625);

var $7eObK = parcelRequire("7eObK");
const $ea5cd806d61a3813$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $7eObK.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $7eObK.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $7eObK.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $7eObK.messages).unfollow_goal_error;
    return (0, $7eObK.messages).generic_error_message;
};

});

parcelRegister("hnjVX", function(module, exports) {

let $ca640c14c6886c1c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ca640c14c6886c1c$var$load("h2MrD"),
    $ca640c14c6886c1c$var$load("bYT2S"),
    $ca640c14c6886c1c$var$load("bDCpg")
]).then(()=>parcelRequire('7ZB4h'));

});

parcelRegister("4PRZL", function(module, exports) {

let $3855cf2a1f4214ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3855cf2a1f4214ca$var$load("h2MrD"),
    $3855cf2a1f4214ca$var$load("bYT2S"),
    $3855cf2a1f4214ca$var$load("7YvNF")
]).then(()=>parcelRequire('cWGTr'));

});


parcelRegister("ipK8i", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bfb91fef01d7c6b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $7NkuU = parcelRequire("7NkuU");

var $bUpbd = parcelRequire("bUpbd");

var $7eObK = parcelRequire("7eObK");

var $gSLUn = parcelRequire("gSLUn");

var $dijYd = parcelRequire("dijYd");

var $iQpos = parcelRequire("iQpos");
const $1bfb91fef01d7c6b$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $gSLUn.useFlexibleUiContext)();
    const invoke = (0, $dijYd.default)({});
    const data = context?.actions?.[(0, $bUpbd.ActionName).PreviewAction];
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $7eObK.messages).preview_description : (0, $7eObK.messages).preview_improved;
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iQpos.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7eObK.messages).preview_improved
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7NkuU))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Open preview"
        }),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $1bfb91fef01d7c6b$export$2e2bcd8739ae039 = $1bfb91fef01d7c6b$var$PreviewAction;

});
parcelRegister("7NkuU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95f2961def649e58284c9134f09a8716>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5acd0264cf7f9b6d$var$_react = $5acd0264cf7f9b6d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5acd0264cf7f9b6d$var$_growDiagonal = $5acd0264cf7f9b6d$var$_interopRequireDefault((parcelRequire("34MjD")));

var $5acd0264cf7f9b6d$var$_actualSize = $5acd0264cf7f9b6d$var$_interopRequireDefault((parcelRequire("ejYdG")));
function $5acd0264cf7f9b6d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5acd0264cf7f9b6d$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $5acd0264cf7f9b6d$var$_react.default.createElement($5acd0264cf7f9b6d$var$_growDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $5acd0264cf7f9b6d$var$_actualSize.default
    }, props));
$5acd0264cf7f9b6d$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
var $5acd0264cf7f9b6d$var$_default = module.exports.default = $5acd0264cf7f9b6d$var$GrowDiagonalIcon;

});


parcelRegister("dq0lU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3c648e6deca30f6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $c95g7 = parcelRequire("c95g7");

var $bUpbd = parcelRequire("bUpbd");

var $7eObK = parcelRequire("7eObK");

var $gSLUn = parcelRequire("gSLUn");

var $dijYd = parcelRequire("dijYd");

var $iQpos = parcelRequire("iQpos");
const $b3c648e6deca30f6$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $gSLUn.useFlexibleUiContext)();
    const invoke = (0, $dijYd.default)({});
    const data = context?.actions?.[(0, $bUpbd.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)((0, $7eObK.messages).copy_url_to_clipboard);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke({
                ...data.invokeAction,
                actionFn: async ()=>{
                    await data.invokeAction?.actionFn();
                    setTooltipMessage((0, $7eObK.messages).copied_url_to_clipboard);
                }
            });
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iQpos.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7eObK.messages).copy_url_to_clipboard
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c95g7))), {
            color: "currentColor",
            label: "copy url",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $7eObK.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $b3c648e6deca30f6$export$2e2bcd8739ae039 = $b3c648e6deca30f6$var$CopyLinkAction;

});

parcelRegister("atFJD", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa950681bb69174f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bUpbd = parcelRequire("bUpbd");

var $gSLUn = parcelRequire("gSLUn");

var $ggH8A = parcelRequire("ggH8A");
const $aa950681bb69174f$var$AISummaryAction = (props)=>{
    const context = (0, $gSLUn.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $bUpbd.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ggH8A.AISummaryActionComponent), {
        ...actionData,
        ...props
    }) : null;
};
var $aa950681bb69174f$export$2e2bcd8739ae039 = $aa950681bb69174f$var$AISummaryAction;

});
parcelRegister("ggH8A", function(module, exports) {

$parcel$export(module.exports, "AISummaryActionComponent", () => $59bc79df36b55db7$export$8eed96bc6d982595);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $jiAPI = parcelRequire("jiAPI");

var $gS03z = parcelRequire("gS03z");

var $dGskR = parcelRequire("dGskR");
const $59bc79df36b55db7$export$8eed96bc6d982595 = (props)=>{
    (0, $gKZoD.di)((0, $jiAPI.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $jiAPI.default)(url);
    (0, $5uXOq.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dGskR.CopySummaryAction), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gS03z.AISummariseAction), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};

});
parcelRegister("jiAPI", function(module, exports) {

$parcel$export(module.exports, "default", () => $386842e216611f4c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eD9e3 = parcelRequire("eD9e3");
var $fT8vS = parcelRequire("fT8vS");

var $evjcU = parcelRequire("evjcU");

var $45Vjm = parcelRequire("45Vjm");

var $1q6WT = parcelRequire("1q6WT");

var $1BAw5 = parcelRequire("1BAw5");

var $lpHTP = parcelRequire("lpHTP");
const $386842e216611f4c$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $386842e216611f4c$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $lpHTP.useAISummaryConfig)();
    const cardState = (0, $1q6WT.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $evjcU.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $eD9e3.extractAri)(data);
    const dataUrl = data && (0, $fT8vS.extractLink)(data) || '';
    const onStart = (0, $5uXOq.useCallback)((id)=>{
        (0, $45Vjm.startUfoExperience)($386842e216611f4c$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $5uXOq.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $45Vjm.succeedUfoExperience)($386842e216611f4c$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $5uXOq.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $45Vjm.failUfoExperience)($386842e216611f4c$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $1BAw5.useAISummary)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $386842e216611f4c$export$2e2bcd8739ae039 = $386842e216611f4c$var$useAISummaryAction;

});
parcelRegister("eD9e3", function(module, exports) {

$parcel$export(module.exports, "extractAri", () => $a214f26d815c74a1$export$be18a6294fd426ec);
const $a214f26d815c74a1$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
};

});

parcelRegister("fT8vS", function(module, exports) {

$parcel$export(module.exports, "extractLink", () => $6757561e28199994$export$63f54cf4c5883620);

var $1xvQk = parcelRequire("1xvQk");
const $6757561e28199994$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $1xvQk.extractUrlFromLinkJsonLd)(url);
    }
};

});

parcelRegister("1BAw5", function(module, exports) {

$parcel$export(module.exports, "useAISummary", () => $c335d5392f06d38c$export$becd8f2eba1bbd96);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dAcse = parcelRequire("dAcse");

var $cdb7a = parcelRequire("cdb7a");
const $c335d5392f06d38c$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $5uXOq.useState)((0, $cdb7a.AISummariesStore).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    const { locale: locale } = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $cdb7a.AISummariesStore).get(url)) (0, $cdb7a.AISummariesStore).set(url, new (0, $dAcse.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            locale: locale,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $cdb7a.AISummariesStore).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey,
        locale
    ]);
    const summariseUrl = ()=>{
        return (0, $cdb7a.AISummariesStore).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};

});
parcelRegister("dAcse", function(module, exports) {

$parcel$export(module.exports, "AISummaryService", () => $ae442844f47ee6a3$export$73e4b807d5bd74b6);

var $7Jxgt = parcelRequire("7Jxgt");

var $9UqZ1 = parcelRequire("9UqZ1");

var $cJCZA = parcelRequire("cJCZA");

var $iqPXC = parcelRequire("iqPXC");

var $m9HC4 = parcelRequire("m9HC4");
class $ae442844f47ee6a3$export$73e4b807d5bd74b6 {
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.subscribedStateSetters = new Set();
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            const path = 'assist/chat/v1/invoke_agent/stream';
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $9UqZ1.getBaseUrl)(envKey);
                return (0, $m9HC4.addPath)(baseUrl, path);
            }
            return (0, $m9HC4.addPath)('/gateway/api/', path);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'smartlink_summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown',
                    locale: this.locale
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $cJCZA.readStream)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $m9HC4.getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.locale = props.locale;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($7Jxgt)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.message.content;
                if (chunk.type === 'ERROR') throw new (0, $iqPXC.ChunkProcessingError)(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof (0, $iqPXC.ChunkProcessingError) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
}

});
parcelRegister("cJCZA", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $5a902800f1993298$export$e45226161c660403);

var $m9HC4 = parcelRequire("m9HC4");
async function* $5a902800f1993298$export$e45226161c660403(response) {
    const reader = (0, $m9HC4.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}

});
parcelRegister("m9HC4", function(module, exports) {

$parcel$export(module.exports, "getBufferReader", () => $1d3997ae3d082df2$export$f6383c3ea1307da9);
$parcel$export(module.exports, "addPath", () => $1d3997ae3d082df2$export$4c25481b843feb0b);
$parcel$export(module.exports, "getXProductHeaderValue", () => $1d3997ae3d082df2$export$ff2962de2b2c930f);
const $1d3997ae3d082df2$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $1d3997ae3d082df2$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $1d3997ae3d082df2$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $1d3997ae3d082df2$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $1d3997ae3d082df2$export$ff2962de2b2c930f = (product)=>{
    if ($1d3997ae3d082df2$var$isJiraProduct(product)) return $1d3997ae3d082df2$var$AiMateJiraXProduct[product];
    return product;
};

});


parcelRegister("iqPXC", function(module, exports) {

$parcel$export(module.exports, "ChunkProcessingError", () => $093906959153a50b$export$fcec967a4b7ebd84);
class $093906959153a50b$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $093906959153a50b$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];

});


parcelRegister("cdb7a", function(module, exports) {

$parcel$export(module.exports, "AISummariesStore", () => $47b2d9974e382338$export$6979339b6d41707e);

var $iwKVT = parcelRequire("iwKVT");
const $47b2d9974e382338$var$AI_SUMMARY_CACHE_SIZE = 100;
const $47b2d9974e382338$export$6979339b6d41707e = new (0, $iwKVT.LRUMap)($47b2d9974e382338$var$AI_SUMMARY_CACHE_SIZE);

});


parcelRegister("lpHTP", function(module, exports) {

$parcel$export(module.exports, "useAISummaryConfig", () => $9e8d2bec6d9faa18$export$4480af2c00aa7ebe);

var $5uXOq = parcelRequire("5uXOq");

var $2yoyZ = parcelRequire("2yoyZ");
const $9e8d2bec6d9faa18$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $2yoyZ.useSmartLinkContext)();
    return (0, $5uXOq.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};

});


parcelRegister("gS03z", function(module, exports) {

$parcel$export(module.exports, "AISummariseAction", () => $65886199f2df2b6b$export$75a19de44af58722);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $c1WlH = parcelRequire("c1WlH");

var $evjcU = parcelRequire("evjcU");

var $7eObK = parcelRequire("7eObK");

var $lE9fQ = parcelRequire("lE9fQ");

var $iQpos = parcelRequire("iQpos");

var $dVfpp = parcelRequire("dVfpp");
function $65886199f2df2b6b$export$75a19de44af58722({ url: url, onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $evjcU.useAnalyticsEvents)();
    const onCompleted = (0, $5uXOq.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $dVfpp.getErrorMessage)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $5uXOq.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iQpos.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7eObK.messages).ai_summary_action
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c1WlH))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI",
            LEGACY_fallbackIcon: (0, $lE9fQ.default)
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7eObK.messages).ai_summary_action_description
        }),
        ...props
    });
}

});
parcelRegister("c1WlH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b8054c1d672105cf334f7f37a83f0cf2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c22d6edca06843c$var$_react = $8c22d6edca06843c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8c22d6edca06843c$var$_baseNew = $8c22d6edca06843c$var$_interopRequireDefault((parcelRequire("enEmH")));
function $8c22d6edca06843c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8c22d6edca06843c$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $8c22d6edca06843c$var$_react.default.createElement($8c22d6edca06843c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 4V1h1.5v3zM5.47 6.53l-4-4 1.06-1.06 4 4zm4-1.06 4-4 1.06 1.06-4 4zM1 7.25h3v1.5H1zm11 0h3v1.5h-3zM1.47 13.47l4-4 1.06 1.06-4 4zm12 1.06-4-4 1.06-1.06 4 4zM7.25 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$8c22d6edca06843c$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $8c22d6edca06843c$var$_default = module.exports.default = $8c22d6edca06843c$var$AtlassianIntelligenceIcon;

});

parcelRegister("lE9fQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c30c57d5bd872f1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $2SY35 = parcelRequire("2SY35");
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications
 */ const $0c30c57d5bd872f1$var$AiIcon = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2SY35.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                })
            ]
        })
    });
var $0c30c57d5bd872f1$export$2e2bcd8739ae039 = $0c30c57d5bd872f1$var$AiIcon;

});

parcelRegister("dVfpp", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $ead996fa99bcf034$export$82f46aa4e6535a45);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $a9fQv = parcelRequire("a9fQv");

var $5guB4 = parcelRequire("5guB4");

var $3lqrM = parcelRequire("3lqrM");
const $ead996fa99bcf034$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $a9fQv.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5guB4.default), {
                    reason: error
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...message,
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $3lqrM.default), {
                                href: url,
                                children: chunks
                            })
                    }
                })
            ]
        })
    };
};

});
parcelRegister("a9fQv", function(module, exports) {

$parcel$export(module.exports, "getIsAISummaryEnabled", () => $70d83afac1da2560$export$d439c74cb206ff29);
$parcel$export(module.exports, "getAISummaryErrorMessage", () => $70d83afac1da2560$export$cd2e891d7f87074d);

var $bUpbd = parcelRequire("bUpbd");

var $7eObK = parcelRequire("7eObK");
const $70d83afac1da2560$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $70d83afac1da2560$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $7eObK.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $bUpbd.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $7eObK.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $7eObK.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $7eObK.messages).ai_summary_error_generic,
                url: (0, $bUpbd.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};

});

parcelRegister("5guB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5062ddf62540231$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $evjcU = parcelRequire("evjcU");
const $a5062ddf62540231$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $evjcU.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $a5062ddf62540231$export$2e2bcd8739ae039 = $a5062ddf62540231$var$AIEventErrorViewed;

});

parcelRegister("3lqrM", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbfe89688056bd6f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bUpbd = parcelRequire("bUpbd");
const $dbfe89688056bd6f$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        href: (0, $bUpbd.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props,
        children: children
    });
var $dbfe89688056bd6f$export$2e2bcd8739ae039 = $dbfe89688056bd6f$var$AILearnMoreAnchor;

});



parcelRegister("dGskR", function(module, exports) {

$parcel$export(module.exports, "CopySummaryAction", () => $b3d30ea38b287d9c$export$cfa1d3eed9a61059);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $86vzA = parcelRequire("86vzA");

var $evjcU = parcelRequire("evjcU");

var $7eObK = parcelRequire("7eObK");

var $iQpos = parcelRequire("iQpos");
function $b3d30ea38b287d9c$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $evjcU.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)((0, $7eObK.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $5uXOq.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $7eObK.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iQpos.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7eObK.messages).copy_summary_action
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($86vzA))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $7eObK.messages).copy_summary_action_description),
        ...props
    });
}

});



parcelRegister("iLDTL", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa652f032e07baa9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $8xUwj = parcelRequire("8xUwj");

var $k9nuy = parcelRequire("k9nuy");

var $evjcU = parcelRequire("evjcU");

var $bUpbd = parcelRequire("bUpbd");

var $7eObK = parcelRequire("7eObK");

var $gSLUn = parcelRequire("gSLUn");

var $45C4L = parcelRequire("45C4L");

var $iQpos = parcelRequire("iQpos");

var $4EYfz = parcelRequire("4EYfz");

var $2D4gj = parcelRequire("2D4gj");

const $fa652f032e07baa9$var$AutomationModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("eWz3k")));
const $fa652f032e07baa9$var$AutomationAction = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const modal = (0, $45C4L.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $gSLUn.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $evjcU.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $bUpbd.ActionName).AutomationAction];
    const automationActionOnClick = (0, $5uXOq.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $2D4gj.getModalContent)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...modalTitle
        }) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                        as: "strong",
                        children: chunks
                    }),
                br: /*#__PURE__*/ (0, $2OMIu.jsx)("br", {})
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, $2OMIu.jsx)($fa652f032e07baa9$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $7eObK.messages).automation_action_title
    });
    const automationActionTooltip = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...(0, $7eObK.messages).automation_action_tooltip
    });
    const automationActionIconLabel = formatMessage((0, $7eObK.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iQpos.default), {
            content: automationActionTitle,
            icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8xUwj))), {
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, $4EYfz.default),
                color: "currentColor",
                label: automationActionIconLabel
            }),
            testId: "smart-action-automation-action",
            tooltipMessage: automationActionTooltip,
            ...props,
            onClick: ()=>automationActionOnClick(automationActionData)
        })
    });
};
var $fa652f032e07baa9$export$2e2bcd8739ae039 = $fa652f032e07baa9$var$AutomationAction;

});
parcelRegister("45C4L", function(module, exports) {

$parcel$export(module.exports, "SmartLinkModalProvider", () => $f6ffdb66b90d8a5b$export$bb4eb02a83e1a0f8);
$parcel$export(module.exports, "useSmartLinkModal", () => $f6ffdb66b90d8a5b$export$1fd7f5f21a6d6cb8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $3DOzD = parcelRequire("3DOzD");
const $f6ffdb66b90d8a5b$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $f6ffdb66b90d8a5b$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($f6ffdb66b90d8a5b$var$FALLBACK_API);
const $f6ffdb66b90d8a5b$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $5uXOq.useState)(null);
    const api = (0, $5uXOq.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3DOzD.StopPropagation), {
                        children: modal
                    })
                })),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $5uXOq.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $5uXOq.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($f6ffdb66b90d8a5b$export$f4c0a0f23ba57f8c.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
                fallbackRender: fallbackRender,
                onReset: onReset,
                children: element
            })
        ]
    });
};
const $f6ffdb66b90d8a5b$export$1fd7f5f21a6d6cb8 = ()=>(0, $5uXOq.useContext)($f6ffdb66b90d8a5b$export$f4c0a0f23ba57f8c);

});
parcelRegister("3DOzD", function(module, exports) {

$parcel$export(module.exports, "StopPropagation", () => $d64c4895dd912248$export$3e100bc08448f36c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $d64c4895dd912248$var$styles = null;
const $d64c4895dd912248$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $5uXOq.useCallback)((e)=>{
        // Prevent click event inside modal from bubble up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        onClick: onClick,
        className: (0, $bwpsq.default)([
            "_c71lidpf _p12fidpf _kqswstnw"
        ]),
        children: children
    });
};

});


parcelRegister("4EYfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $e99ab65bab733fc2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $e99ab65bab733fc2$var$AutomationManualTriggersGlyph = ({ label: label })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        "aria-label": label,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M14 5L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M14 5L7 12H17L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $e99ab65bab733fc2$export$2e2bcd8739ae039 = $e99ab65bab733fc2$var$AutomationManualTriggersGlyph;

});

parcelRegister("2D4gj", function(module, exports) {

$parcel$export(module.exports, "getModalContent", () => $e31bd351a8c9c698$export$93e707b363eaf5c8);

var $7eObK = parcelRequire("7eObK");
const $e31bd351a8c9c698$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $7eObK.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $7eObK.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};

});

parcelRegister("eWz3k", function(module, exports) {

let $ae11ac30f38e386b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ae11ac30f38e386b$var$load("hPzOn"),
    $ae11ac30f38e386b$var$load("h2MrD"),
    $ae11ac30f38e386b$var$load("bYT2S"),
    $ae11ac30f38e386b$var$load("fpivX")
]).then(()=>parcelRequire('aF85f'));

});


parcelRegister("gXOwg", function(module, exports) {

$parcel$export(module.exports, "default", () => $033aebcd13b7c72c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $evjcU = parcelRequire("evjcU");

var $7eObK = parcelRequire("7eObK");

var $gSLUn = parcelRequire("gSLUn");

var $45C4L = parcelRequire("45C4L");

var $iQpos = parcelRequire("iQpos");

var $lPZ6w = parcelRequire("lPZ6w");

const $033aebcd13b7c72c$var$RelatedLinksModal = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("iUPT1")));
const $033aebcd13b7c72c$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $45C4L.useSmartLinkModal)();
    const context = (0, $gSLUn.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $evjcU.useAnalyticsEvents)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, $2OMIu.jsx)($033aebcd13b7c72c$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iQpos.default), {
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...(0, $7eObK.messages).related_links_view_related_urls
        }),
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lPZ6w.default), {}),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $033aebcd13b7c72c$export$2e2bcd8739ae039 = $033aebcd13b7c72c$var$ViewRelatedLinksAction;

});
parcelRegister("lPZ6w", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3bd5dde7f9a2186$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ri3zL = parcelRequire("ri3zL");
const $b3bd5dde7f9a2186$var$rotateSvg = null;
/**
 * ChildIssuesIcon but 180 degrees rotated
 */ const $b3bd5dde7f9a2186$var$RelatedLinksActionIcon = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_t9ec1sub _1e0c1o8l"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ri3zL))), {
            color: "currentColor",
            spacing: "spacious",
            label: "View recent links..."
        })
    });
var $b3bd5dde7f9a2186$export$2e2bcd8739ae039 = $b3bd5dde7f9a2186$var$RelatedLinksActionIcon;

});
parcelRegister("ri3zL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::460873555b00dc694a7c27133071dd5e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $052087690d44aa12$var$_react = $052087690d44aa12$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $052087690d44aa12$var$_childIssues = $052087690d44aa12$var$_interopRequireDefault((parcelRequire("e7eGx")));

var $052087690d44aa12$var$_childIssues2 = $052087690d44aa12$var$_interopRequireDefault((parcelRequire("3eUwr")));
function $052087690d44aa12$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChildIssuesIcon.
 * This component is ChildIssuesIcon, with `UNSAFE_fallbackIcon` set to "ChildIssuesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for child issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $052087690d44aa12$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $052087690d44aa12$var$_react.default.createElement($052087690d44aa12$var$_childIssues.default, Object.assign({
        LEGACY_fallbackIcon: $052087690d44aa12$var$_childIssues2.default
    }, props));
$052087690d44aa12$var$ChildIssuesIcon.Name = 'ChildIssuesIconMigration';
var $052087690d44aa12$var$_default = module.exports.default = $052087690d44aa12$var$ChildIssuesIcon;

});
parcelRegister("e7eGx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::359c101bebeaae075dd3e3e9a50caec7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a46d1c4d083ccbdb$var$_react = $a46d1c4d083ccbdb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a46d1c4d083ccbdb$var$_baseNew = $a46d1c4d083ccbdb$var$_interopRequireDefault((parcelRequire("enEmH")));
function $a46d1c4d083ccbdb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChildIssues".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for child issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a46d1c4d083ccbdb$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $a46d1c4d083ccbdb$var$_react.default.createElement($a46d1c4d083ccbdb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 4.5V1H1v10a2 2 0 0 0 2 2h4v.75c0 .69.56 1.25 1.25 1.25h5.5c.69 0 1.25-.56 1.25-1.25v-3c0-.69-.56-1.25-1.25-1.25h-5.5c-.69 0-1.25.56-1.25 1.25v.75H3a.5.5 0 0 1-.5-.5V6H7v.75C7 7.44 7.56 8 8.25 8h5.5C14.44 8 15 7.44 15 6.75v-3c0-.69-.56-1.25-1.25-1.25h-5.5C7.56 2.5 7 3.06 7 3.75v.75zm6-.5v2.5h5V4zm0 7v2.5h5V11z" clip-rule="evenodd"/>`
    }, props));
$a46d1c4d083ccbdb$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $a46d1c4d083ccbdb$var$_default = module.exports.default = $a46d1c4d083ccbdb$var$ChildIssuesIcon;

});

parcelRegister("3eUwr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25be86079bb7d9c7$var$_react = $25be86079bb7d9c7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $25be86079bb7d9c7$var$_childIssues = $25be86079bb7d9c7$var$_interopRequireDefault((parcelRequire("e7eGx")));
function $25be86079bb7d9c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $25be86079bb7d9c7$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $25be86079bb7d9c7$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 0 1 1 1v1H6v-1a1 1 0 0 1 1-1"/><path fill-rule="nonzero" d="M5 18v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2m10 2v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2M10 5v1h4V5zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/></g></svg>`
    }, props, {
        newIcon: $25be86079bb7d9c7$var$_childIssues.default
    }));
$25be86079bb7d9c7$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $25be86079bb7d9c7$var$_default = module.exports.default = $25be86079bb7d9c7$var$ChildIssuesIcon;

});



parcelRegister("iUPT1", function(module, exports) {

let $dc55b48b9cf50b22$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dc55b48b9cf50b22$var$load("lhBry").then(()=>parcelRequire('65n82'));

});





parcelRegister("5zLRC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d246ee3502260646$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHpHg = parcelRequire("fHpHg");

var $bUpbd = parcelRequire("bUpbd");

var $S0OVy = parcelRequire("S0OVy");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $d246ee3502260646$var$BaseBlockStylesOld = null;
const $d246ee3502260646$var$baseBlockStyles = null;
const $d246ee3502260646$var$highlightRemoveStyles = null;
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $d246ee3502260646$var$gapsStylesOld = {
    xlarge: "_zulp1k92 _1ljq1k92",
    large: "_zulp1j6v _1ljq1j6v",
    medium: "_zulp1kwk _1ljq1kwk",
    small: "_zulp6mu8 _1ljq6mu8"
};
const $d246ee3502260646$var$gapStyles = {
    xlarge: "_zulpv47k _1ljqv47k",
    large: "_zulppxbi _1ljqpxbi",
    medium: "_zulpu2gc _1ljqu2gc",
    small: "_zulp1b66 _1ljq1b66"
};
const $d246ee3502260646$var$directionStyles = {
    vertical: "_2lx21bp4 _4cvr1y6m",
    horizontal: "_2lx2vrvc _4cvr1h6o"
};
/**
 * A block represents a collection of elements and actions that are arranged
 * in a row. All elements and actions should be contained within a Block.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $d246ee3502260646$var$Block = ({ children: children, direction: direction = (0, $bUpbd.SmartLinkDirection).Horizontal, size: size = (0, $bUpbd.SmartLinkSize).Medium, testId: testId = 'smart-block', className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style })=>{
    (0, $5uXOq.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _4cvr1h6o _vwz41j6v _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1ouwidpf _f6ju1ns9 _1uzp1mp2 _ytq1bjq5 _a7e8uxlv",
            (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1uzp1mp2 _a6bxmuej _e4i5bjq5 _1gu21oju _5b7tuxlv _17ae1oju",
            "_12ji1snc _1qu2agmp _12y310yn _12ji1kw7 _syaz1kw7 _18ql1j28 _1ifmglyw _181uglyw _1rkwglyw _te17glyw _uiztglyw",
            $d246ee3502260646$var$directionStyles[direction],
            !(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && $d246ee3502260646$var$gapsStylesOld[size],
            (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && $d246ee3502260646$var$gapStyles[size],
            className
        ]),
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: (0, $S0OVy.renderChildren)(children, size)
    });
};
var $d246ee3502260646$export$2e2bcd8739ae039 = $d246ee3502260646$var$Block;

});



parcelRegister("8JDQn", function(module, exports) {

$parcel$export(module.exports, "default", () => $033259707a3a863f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHpHg = parcelRequire("fHpHg");

var $bUpbd = parcelRequire("bUpbd");

var $5zLRC = parcelRequire("5zLRC");

var $hWtFf = parcelRequire("hWtFf");

var $S0OVy = parcelRequire("S0OVy");
const $033259707a3a863f$var$DEFAULT_MAX_LINES = 2;
const $033259707a3a863f$var$MAXIMUM_MAX_LINES = 2;
const $033259707a3a863f$var$MINIMUM_MAX_LINES = 1;
const $033259707a3a863f$var$truncateStyles = {
    '1': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54",
    '2': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjcs5v _sudp1e54"
};
const $033259707a3a863f$var$sizeStylesOld = {
    xlarge: "_vwz41m1q _102k1k7u",
    large: "_vwz41m1q _102k1k7u",
    medium: "_vwz41k8s _102k1wto",
    small: "_vwz41k8s _102k1wto"
};
const $033259707a3a863f$var$sizeStyles = {
    xlarge: "_102k8vuz",
    large: "_102k8vuz",
    medium: "_102kckbl",
    small: "_102kckbl"
};
const $033259707a3a863f$var$getMaxLines = (maxLines)=>{
    if (maxLines > $033259707a3a863f$var$MAXIMUM_MAX_LINES) return $033259707a3a863f$var$DEFAULT_MAX_LINES;
    if (maxLines < $033259707a3a863f$var$MINIMUM_MAX_LINES) return $033259707a3a863f$var$MINIMUM_MAX_LINES;
    return maxLines;
};
/**
 * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
 * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
 * @public
 * @param {MetadataBlockProps} MetadataBlockProps
 * @see Block
 */ const $033259707a3a863f$var$MetadataBlock = ({ maxLines: maxLines = $033259707a3a863f$var$DEFAULT_MAX_LINES, status: status = (0, $bUpbd.SmartLinkStatus).Fallback, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    if (primary.length === 0 && secondary.length === 0 || status !== (0, $bUpbd.SmartLinkStatus).Resolved) return null;
    const primaryElements = (0, $S0OVy.renderElementItems)(primary);
    const secondaryElements = (0, $S0OVy.renderElementItems)(secondary);
    const { size: size = (0, $bUpbd.SmartLinkSize).Medium } = blockProps;
    const maxLinesTotal = $033259707a3a863f$var$getMaxLines(maxLines);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5zLRC.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            primaryElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hWtFf.default), {
                align: (0, $bUpbd.SmartLinkAlignment).Left,
                direction: (0, $bUpbd.SmartLinkDirection).Horizontal,
                width: (0, $bUpbd.SmartLinkWidth).Flexible,
                size: size,
                className: (0, $bwpsq.default)([
                    $033259707a3a863f$var$truncateStyles[maxLinesTotal],
                    !(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && $033259707a3a863f$var$sizeStylesOld[size],
                    (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && $033259707a3a863f$var$sizeStyles[size]
                ]),
                children: primaryElements
            }),
            secondaryElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hWtFf.default), {
                align: (0, $bUpbd.SmartLinkAlignment).Right,
                direction: (0, $bUpbd.SmartLinkDirection).Horizontal,
                width: (0, $bUpbd.SmartLinkWidth).Flexible,
                size: size,
                className: (0, $bwpsq.default)([
                    $033259707a3a863f$var$truncateStyles[maxLinesTotal],
                    !(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && $033259707a3a863f$var$sizeStylesOld[size],
                    (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && $033259707a3a863f$var$sizeStyles[size]
                ]),
                children: secondaryElements
            })
        ]
    });
};
var $033259707a3a863f$export$2e2bcd8739ae039 = $033259707a3a863f$var$MetadataBlock;

});

parcelRegister("hCJ5I", function(module, exports) {

$parcel$export(module.exports, "default", () => $442b3f7868fcdefc$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bUpbd = parcelRequire("bUpbd");

var $f7uun = parcelRequire("f7uun");
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $442b3f7868fcdefc$var$PreviewBlock = ({ status: // eslint-disable-next-line @typescript-eslint/no-unused-vars
status = (0, $bUpbd.SmartLinkStatus).Fallback, testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f7uun.default), {
        ...blockProps,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $442b3f7868fcdefc$export$2e2bcd8739ae039 = $442b3f7868fcdefc$var$PreviewBlock;

});
parcelRegister("f7uun", function(module, exports) {

$parcel$export(module.exports, "default", () => $89502d4f83a4ba06$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHpHg = parcelRequire("fHpHg");

var $bUpbd = parcelRequire("bUpbd");

var $atbcR = parcelRequire("atbcR");

var $5zLRC = parcelRequire("5zLRC");
const $89502d4f83a4ba06$var$previewBlockStyleCommon = null;
const $89502d4f83a4ba06$var$ignoreContainerPaddingStyle = null;
/**
 * Represents a resolved PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlock} PreviewBlock
 * @see Block
 */ const $89502d4f83a4ba06$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps })=>{
    const [dynamicStyles, setDynamicStyles] = (0, $5uXOq.useState)(style ?? {});
    const updateStyles = (0, $5uXOq.useCallback)(()=>{
        if (placement === (0, $bUpbd.MediaPlacement).Left || placement === (0, $bUpbd.MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') ? '0px' : '0rem' : 'var(--container-padding)';
            const newStyle = {
                ...style,
                position: 'absolute',
                top: containerPadding,
                bottom: containerPadding,
                width: `calc(var(--preview-block-width) - ${containerPadding})`,
                ...placement === (0, $bUpbd.MediaPlacement).Left ? {
                    left: containerPadding
                } : {},
                ...placement === (0, $bUpbd.MediaPlacement).Right ? {
                    right: containerPadding
                } : {}
            };
            setDynamicStyles(newStyle);
        } else if (ignoreContainerPadding) setDynamicStyles({
            ...style
        });
    }, [
        ignoreContainerPadding,
        placement,
        style
    ]);
    (0, $5uXOq.useEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        placement,
        updateStyles,
        className
    ]);
    const handleOnLoad = (0, $5uXOq.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $5uXOq.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5zLRC.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            placement && "_1t26n7od _ze72n7od _10aa1osq _rjuj1osq _mr051dfr",
            !placement && ignoreContainerPadding && "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9",
            className
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $atbcR.default), {
            onError: handleOnError,
            onLoad: handleOnLoad,
            overrideUrl: overrideUrl
        })
    });
};
var $89502d4f83a4ba06$export$2e2bcd8739ae039 = $89502d4f83a4ba06$var$PreviewBlockResolvedView;

});


parcelRegister("7Ki03", function(module, exports) {

$parcel$export(module.exports, "default", () => $72e243532118c933$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bUpbd = parcelRequire("bUpbd");

var $jmfre = parcelRequire("jmfre");

var $iLSC7 = parcelRequire("iLSC7");

var $5zLRC = parcelRequire("5zLRC");
const $72e243532118c933$var$DEFAULT_MAX_LINES = 3;
const $72e243532118c933$var$MAXIMUM_MAX_LINES = 6;
const $72e243532118c933$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlockProps} SnippetBlockProps
 * @see Block
 */ const $72e243532118c933$var$SnippetBlock = ({ maxLines: maxLines = $72e243532118c933$var$DEFAULT_MAX_LINES, status: status = (0, $bUpbd.SmartLinkStatus).Fallback, testId: testId = 'smart-block-snippet', text: text, ...blockProps })=>{
    if (status !== (0, $bUpbd.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $iLSC7.getMaxLines)(maxLines, $72e243532118c933$var$DEFAULT_MAX_LINES, $72e243532118c933$var$MAXIMUM_MAX_LINES, $72e243532118c933$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5zLRC.default), {
        ...blockProps,
        testId: `${testId}-${statusTestId}-view`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jmfre.default), {
            maxLines: snippetMaxLines,
            content: text
        })
    });
};
var $72e243532118c933$export$2e2bcd8739ae039 = $72e243532118c933$var$SnippetBlock;

});

parcelRegister("2QXYS", function(module, exports) {

$parcel$export(module.exports, "default", () => $1900d170afd1705b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bUpbd = parcelRequire("bUpbd");

var $lzjiu = parcelRequire("lzjiu");

var $5wGZS = parcelRequire("5wGZS");

var $3Uo8j = parcelRequire("3Uo8j");

var $eaNSH = parcelRequire("eaNSH");

var $jdZi9 = parcelRequire("jdZi9");

var $elToC = parcelRequire("elToC");
const $1900d170afd1705b$var$actionStyles = null;
const $1900d170afd1705b$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $bUpbd.SmartLinkStatus).Pending:
        case (0, $bUpbd.SmartLinkStatus).Resolving:
            return 0, $elToC.default;
        case (0, $bUpbd.SmartLinkStatus).Resolved:
            return 0, $jdZi9.default;
        case (0, $bUpbd.SmartLinkStatus).Unauthorized:
        case (0, $bUpbd.SmartLinkStatus).Forbidden:
        case (0, $bUpbd.SmartLinkStatus).NotFound:
        case (0, $bUpbd.SmartLinkStatus).Errored:
        case (0, $bUpbd.SmartLinkStatus).Fallback:
        default:
            return 0, $eaNSH.default;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingViewNew
 * @see TitleBlockResolvedViewNew
 * @see TitleBlockErroredViewNew
 */ const $1900d170afd1705b$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, onClick: onClick, status: status = (0, $bUpbd.SmartLinkStatus).Fallback, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, theme: theme, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, className: className, ...props })=>{
    if (hideRetry && props.retry) delete props.retry;
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $5uXOq.useState)(false);
    const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Uo8j.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $lzjiu.useMouseDownEvent)();
    const title = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5wGZS.Title), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: theme,
        ...overrideText
    });
    const Component = $1900d170afd1705b$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ...props,
        actionGroup: actionGroup,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            showActionOnHover && !actionDropdownOpen && "_1bfhidpf _wn5xkb7n _h157kb7n",
            className
        ]),
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        icon: icon,
        size: props.size,
        theme: theme
    });
};
var $1900d170afd1705b$export$2e2bcd8739ae039 = $1900d170afd1705b$var$TitleBlock;

});
parcelRegister("eaNSH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2ea7e41b49b6e24$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $5sRpy = parcelRequire("5sRpy");

var $bUpbd = parcelRequire("bUpbd");

var $5wGZS = parcelRequire("5wGZS");

var $5zLRC = parcelRequire("5zLRC");

var $hWtFf = parcelRequire("hWtFf");
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $f2ea7e41b49b6e24$var$TitleBlockErroredView = ({ actionGroup: actionGroup, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
    const { descriptor: descriptor, onClick: onClick, values: values } = retry || {};
    const hasAction = onClick !== undefined;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5zLRC.default), {
        ...blockProps,
        testId: `${testId}-errored-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5wGZS.LinkIcon), {
                overrideIcon: icon,
                position: position
            }),
            title,
            descriptor && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hWtFf.default), {
                direction: (0, $bUpbd.SmartLinkDirection).Horizontal,
                align: (0, $bUpbd.SmartLinkAlignment).Right,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    onClick: onClick,
                    testId: `${testId}-errored-view-message`,
                    tabIndex: hasAction ? 0 : -1,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...descriptor,
                        values: values
                    })
                })
            }),
            actionGroup
        ]
    });
};
var $f2ea7e41b49b6e24$export$2e2bcd8739ae039 = $f2ea7e41b49b6e24$var$TitleBlockErroredView;

});

parcelRegister("jdZi9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e3ce73a4bcd4270$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHpHg = parcelRequire("fHpHg");

var $bUpbd = parcelRequire("bUpbd");

var $5wGZS = parcelRequire("5wGZS");

var $5zLRC = parcelRequire("5zLRC");

var $hWtFf = parcelRequire("hWtFf");

var $S0OVy = parcelRequire("S0OVy");
const $7e3ce73a4bcd4270$var$style = null;
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */ const $7e3ce73a4bcd4270$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size } = blockProps;
    const metadataElements = (0, $S0OVy.renderElementItems)(metadata);
    const subtitleElements = (0, $S0OVy.renderElementItems)(subtitle);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5zLRC.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5wGZS.LinkIcon), {
                overrideIcon: icon,
                position: position,
                ...(0, $fHpHg.fg)('platform-smart-card-icon-migration') && {
                    size: size
                }
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hWtFf.default), {
                direction: (0, $bUpbd.SmartLinkDirection).Vertical,
                width: (0, $bUpbd.SmartLinkWidth).Flexible,
                size: blockProps.size,
                className: (0, $bwpsq.default)([
                    "_zulp1b66"
                ]),
                children: [
                    title,
                    subtitleElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hWtFf.default), {
                        direction: (0, $bUpbd.SmartLinkDirection).Horizontal,
                        children: subtitleElements
                    })
                ]
            }),
            metadataElements && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hWtFf.default), {
                direction: (0, $bUpbd.SmartLinkDirection).Horizontal,
                align: (0, $bUpbd.SmartLinkAlignment).Right,
                position: metadataPosition ?? (0, $bUpbd.SmartLinkPosition).Center,
                size: blockProps.size,
                children: metadataElements
            }),
            actionGroup
        ]
    });
};
var $7e3ce73a4bcd4270$export$2e2bcd8739ae039 = $7e3ce73a4bcd4270$var$TitleBlockResolvedView;

});

parcelRegister("elToC", function(module, exports) {

$parcel$export(module.exports, "default", () => $25eea5e54e48d103$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fHpHg = parcelRequire("fHpHg");

var $bUpbd = parcelRequire("bUpbd");

var $3p8Wv = parcelRequire("3p8Wv");

var $iLSC7 = parcelRequire("iLSC7");

var $5zLRC = parcelRequire("5zLRC");
const $25eea5e54e48d103$var$iconStyle = {
    xlarge: "_16jlidpf _1o9zidpf _i0dl1wug _4t3iviql _1tkeviql _c71lviql _1bsbviql _1ul9viql _p12fviql _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7viql _1xjxviql _1752viql _qci8viql _15izviql _erubviql _19l3viql _1pr2viql _1u5tviql _mezjviql _e2ooviql _w8l5viql _1rg2viql _q7cvviql _xwbjviql _rtysviql _b8nkviql _4x20viql",
    large: "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    medium: "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    small: "_16jlidpf _1o9zidpf _i0dl1wug _4t3ioqnp _1tkeoqnp _c71loqnp _1bsboqnp _1ul9oqnp _p12foqnp _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7oqnp _1xjxoqnp _1752oqnp _qci8oqnp _15izoqnp _eruboqnp _19l3oqnp _1pr2oqnp _1u5toqnp _mezjoqnp _e2oooqnp _w8l5oqnp _1rg2oqnp _q7cvoqnp _xwbjoqnp _rtysoqnp _b8nkoqnp _4x20oqnp"
};
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $25eea5e54e48d103$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $bUpbd.SmartLinkSize).Medium } = blockProps;
    if ((0, $fHpHg.fg)('platform-smart-card-icon-migration')) {
        const iconWidth = (0, $iLSC7.getIconWidthNew)(size);
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5zLRC.default), {
            ...blockProps,
            testId: `${testId}-resolving-view`,
            children: [
                !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    style: {
                        width: iconWidth,
                        height: iconWidth
                    },
                    "data-testid": `${testId}-icon`,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3p8Wv.LoadingSkeletonNew), {
                        width: iconWidth,
                        height: iconWidth,
                        testId: `${testId}-icon-loading`
                    })
                }),
                title,
                actionGroup
            ]
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5zLRC.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                "data-testid": `${testId}-icon`,
                className: (0, $bwpsq.default)([
                    $25eea5e54e48d103$var$iconStyle[size]
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3p8Wv.LoadingSkeletonOld), {
                    testId: `${testId}-icon-loading`
                })
            }),
            title,
            actionGroup
        ]
    });
};
var $25eea5e54e48d103$export$2e2bcd8739ae039 = $25eea5e54e48d103$var$TitleBlockResolvingView;

});


parcelRegister("9Ecm1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ea1941c5dd22039$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bUpbd = parcelRequire("bUpbd");

var $gSLUn = parcelRequire("gSLUn");

var $7ARwI = parcelRequire("7ARwI");
/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $1ea1941c5dd22039$var$AISummaryBlock = ({ status: status, testId: testId = 'smart-ai-summary-block', ...props })=>{
    const context = (0, $gSLUn.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $bUpbd.InternalActionName).AISummaryAction];
    if (status !== (0, $bUpbd.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7ARwI.default), {
        ...props,
        testId: testId,
        url: actionData.url
    });
};
var $1ea1941c5dd22039$export$2e2bcd8739ae039 = $1ea1941c5dd22039$var$AISummaryBlock;

});
parcelRegister("7ARwI", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a4e4d93960c4e0f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $bUpbd = parcelRequire("bUpbd");

var $jiAPI = parcelRequire("jiAPI");

var $kwKU7 = parcelRequire("kwKU7");

var $h5Age = parcelRequire("h5Age");

var $5zLRC = parcelRequire("5zLRC");

var $axgPE = parcelRequire("axgPE");
const $8a4e4d93960c4e0f$var$styles = null;
const $8a4e4d93960c4e0f$var$AISummaryBlockResolvedView = (props)=>{
    (0, $gKZoD.di)((0, $jiAPI.default), (0, $kwKU7.default));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $jiAPI.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $5uXOq.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: placeholder
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5zLRC.default), {
        ...props,
        direction: (0, $bUpbd.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        /**
   * Enabled for feature discovery to allow box shadow to overflow
   * Cleanup: https://product-fabric.atlassian.net/browse/EDM-8681
   */ className: (0, $bwpsq.default)([
            "_1reoewfl _18m9ewfl"
        ]),
        children: [
            status === 'done' && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $axgPE.default), {
                fromCache: isSummarisedOnMountRef.current
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h5Age.default), {
                minHeight: minHeight,
                show: showAISummary,
                showTransition: !isSummarisedOnMountRef.current,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kwKU7.default), {
                    testId: `${testId}-ai-summary`,
                    minHeight: minHeight,
                    content: content
                })
            })
        ]
    });
};
var $8a4e4d93960c4e0f$export$2e2bcd8739ae039 = $8a4e4d93960c4e0f$var$AISummaryBlockResolvedView;

});
parcelRegister("kwKU7", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f0a1105e031b1be$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $flpap = parcelRequire("flpap");

var $fHpHg = parcelRequire("fHpHg");

var $dX177 = parcelRequire("dX177");
const $3f0a1105e031b1be$var$AISummaryCSSStyles = null;
const $3f0a1105e031b1be$var$baseStyle = null;
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */ const $3f0a1105e031b1be$var$AISummary = ({ content: content = '', className: className, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $flpap.default), {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            !(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _syaz1gjq _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $dX177.default)
            }
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $3f0a1105e031b1be$export$2e2bcd8739ae039 = $3f0a1105e031b1be$var$AISummary;

});
parcelRegister("flpap", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2bc56c6c0b4e02e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $b2bc56c6c0b4e02e$var$t() {
    return $b2bc56c6c0b4e02e$var$t = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $b2bc56c6c0b4e02e$var$t.apply(this, arguments);
}
const $b2bc56c6c0b4e02e$var$n = [
    "children",
    "options"
], $b2bc56c6c0b4e02e$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
var $b2bc56c6c0b4e02e$var$i;
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($b2bc56c6c0b4e02e$var$i || ($b2bc56c6c0b4e02e$var$i = {}));
const $b2bc56c6c0b4e02e$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
    class: "className",
    for: "htmlFor"
}), $b2bc56c6c0b4e02e$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $b2bc56c6c0b4e02e$var$o = [
    "style",
    "script"
], $b2bc56c6c0b4e02e$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $b2bc56c6c0b4e02e$var$s = /mailto:/i, $b2bc56c6c0b4e02e$var$d = /\n{2,}$/, $b2bc56c6c0b4e02e$var$p = /^(\s*>[\s\S]*?)(?=\n{2,})/, $b2bc56c6c0b4e02e$var$u = /^ *> ?/gm, $b2bc56c6c0b4e02e$var$f = /^ {2,}\n/, $b2bc56c6c0b4e02e$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$m = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $b2bc56c6c0b4e02e$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $b2bc56c6c0b4e02e$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $b2bc56c6c0b4e02e$var$k = /^(?:\n *)*\n/, $b2bc56c6c0b4e02e$var$x = /\r\n?/g, $b2bc56c6c0b4e02e$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $b2bc56c6c0b4e02e$var$v = /^\[\^([^\]]+)]/, $b2bc56c6c0b4e02e$var$S = /\f/g, $b2bc56c6c0b4e02e$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $b2bc56c6c0b4e02e$var$C = /^\s*?\[(x|\s)\]/, $b2bc56c6c0b4e02e$var$$ = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$w = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $b2bc56c6c0b4e02e$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $b2bc56c6c0b4e02e$var$T = /^<!--[\s\S]*?(?:-->)/, $b2bc56c6c0b4e02e$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $b2bc56c6c0b4e02e$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $b2bc56c6c0b4e02e$var$M = /^\{.*\}$/, $b2bc56c6c0b4e02e$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $b2bc56c6c0b4e02e$var$I = /^<([^ >]+@[^ >]+)>/, $b2bc56c6c0b4e02e$var$U = /^<([^ >]+:\/[^ >]+)>/, $b2bc56c6c0b4e02e$var$D = /-([a-z])?/gi, $b2bc56c6c0b4e02e$var$j = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $b2bc56c6c0b4e02e$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $b2bc56c6c0b4e02e$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$P = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $b2bc56c6c0b4e02e$var$_ = /\t/g, $b2bc56c6c0b4e02e$var$G = /(^ *\||\| *$)/g, $b2bc56c6c0b4e02e$var$W = /^ *:-+: *$/, $b2bc56c6c0b4e02e$var$Z = /^ *:-+ *$/, $b2bc56c6c0b4e02e$var$q = /^ *-+: *$/, $b2bc56c6c0b4e02e$var$Q = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $b2bc56c6c0b4e02e$var$V = new RegExp(`^([*_])\\1${$b2bc56c6c0b4e02e$var$Q}\\1\\1(?!\\1)`), $b2bc56c6c0b4e02e$var$X = new RegExp(`^([*_])${$b2bc56c6c0b4e02e$var$Q}\\1(?!\\1|\\w)`), $b2bc56c6c0b4e02e$var$J = new RegExp(`^==${$b2bc56c6c0b4e02e$var$Q}==`), $b2bc56c6c0b4e02e$var$K = new RegExp(`^~~${$b2bc56c6c0b4e02e$var$Q}~~`), $b2bc56c6c0b4e02e$var$Y = /^\\([^0-9A-Za-z\s])/, $b2bc56c6c0b4e02e$var$ee = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $b2bc56c6c0b4e02e$var$te = /^\n+/, $b2bc56c6c0b4e02e$var$ne = /^([ \t]*)/, $b2bc56c6c0b4e02e$var$re = /\\([^\\])/g, $b2bc56c6c0b4e02e$var$ie = / *\n+$/, $b2bc56c6c0b4e02e$var$le = /(?:^|\n)( *)$/, $b2bc56c6c0b4e02e$var$ae = "(?:\\d+\\.)", $b2bc56c6c0b4e02e$var$oe = "(?:[*+-])";
function $b2bc56c6c0b4e02e$var$ce(e) {
    return "( *)(" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe) + ") +";
}
const $b2bc56c6c0b4e02e$var$se = $b2bc56c6c0b4e02e$var$ce(1), $b2bc56c6c0b4e02e$var$de = $b2bc56c6c0b4e02e$var$ce(2);
function $b2bc56c6c0b4e02e$var$pe(e) {
    return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$se : $b2bc56c6c0b4e02e$var$de));
}
const $b2bc56c6c0b4e02e$var$ue = $b2bc56c6c0b4e02e$var$pe(1), $b2bc56c6c0b4e02e$var$fe = $b2bc56c6c0b4e02e$var$pe(2);
function $b2bc56c6c0b4e02e$var$he(e) {
    return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$se : $b2bc56c6c0b4e02e$var$de) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $b2bc56c6c0b4e02e$var$me = $b2bc56c6c0b4e02e$var$he(1), $b2bc56c6c0b4e02e$var$ge = $b2bc56c6c0b4e02e$var$he(2);
function $b2bc56c6c0b4e02e$var$ye(e) {
    const t = 1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe;
    return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
}
const $b2bc56c6c0b4e02e$var$ke = $b2bc56c6c0b4e02e$var$ye(1), $b2bc56c6c0b4e02e$var$xe = $b2bc56c6c0b4e02e$var$ye(2);
function $b2bc56c6c0b4e02e$var$be(e, t) {
    const n = 1 === t, i = n ? $b2bc56c6c0b4e02e$var$ke : $b2bc56c6c0b4e02e$var$xe, l = n ? $b2bc56c6c0b4e02e$var$me : $b2bc56c6c0b4e02e$var$ge, a = n ? $b2bc56c6c0b4e02e$var$ue : $b2bc56c6c0b4e02e$var$fe;
    return {
        match (e, t) {
            const n = $b2bc56c6c0b4e02e$var$le.exec(t.prevCapture);
            return n && (t.list || !t.inline && !t.simple) ? i.exec(e = n[1] + e) : null;
        },
        order: 1,
        parse (e, t, r) {
            const i = n ? +e[2] : void 0, o = e[0].replace($b2bc56c6c0b4e02e$var$d, "\n").match(l);
            let c = !1;
            return {
                items: o.map(function(e, n) {
                    const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, p = -1 !== s.indexOf("\n\n") || d && c;
                    c = p;
                    const u = r.inline, f = r.list;
                    let h;
                    r.list = !0, p ? (r.inline = !1, h = s.replace($b2bc56c6c0b4e02e$var$ie, "\n\n")) : (r.inline = !0, h = s.replace($b2bc56c6c0b4e02e$var$ie, ""));
                    const m = t(h, r);
                    return r.inline = u, r.list = f, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                key: i.key,
                start: t.type === $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.orderedList ? t.start : void 0
            }, t.items.map(function(t, r) {
                return e("li", {
                    key: r
                }, n(t, i));
            }))
    };
}
const $b2bc56c6c0b4e02e$var$ve = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $b2bc56c6c0b4e02e$var$Se = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $b2bc56c6c0b4e02e$var$Ee = [
    $b2bc56c6c0b4e02e$var$p,
    $b2bc56c6c0b4e02e$var$m,
    $b2bc56c6c0b4e02e$var$g,
    $b2bc56c6c0b4e02e$var$$,
    $b2bc56c6c0b4e02e$var$z,
    $b2bc56c6c0b4e02e$var$w,
    $b2bc56c6c0b4e02e$var$T,
    $b2bc56c6c0b4e02e$var$j,
    $b2bc56c6c0b4e02e$var$me,
    $b2bc56c6c0b4e02e$var$ke,
    $b2bc56c6c0b4e02e$var$ge,
    $b2bc56c6c0b4e02e$var$xe
], $b2bc56c6c0b4e02e$var$Ce = [
    ...$b2bc56c6c0b4e02e$var$Ee,
    /^[^\n]+(?:  \n|\n{2,})/,
    $b2bc56c6c0b4e02e$var$L,
    $b2bc56c6c0b4e02e$var$B
];
function $b2bc56c6c0b4e02e$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $b2bc56c6c0b4e02e$var$we(e) {
    return $b2bc56c6c0b4e02e$var$q.test(e) ? "right" : $b2bc56c6c0b4e02e$var$W.test(e) ? "center" : $b2bc56c6c0b4e02e$var$Z.test(e) ? "left" : null;
}
function $b2bc56c6c0b4e02e$var$ze(e, t, n, i) {
    const l = n.inTable;
    n.inTable = !0;
    let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text,
            text: l
        }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
    n.inTable = l;
    let o = [
        []
    ];
    return a.forEach(function(e, t) {
        e.type === $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function $b2bc56c6c0b4e02e$var$Le(e, t, n) {
    n.inline = !0;
    const i = e[2] ? e[2].replace($b2bc56c6c0b4e02e$var$G, "").split("|").map($b2bc56c6c0b4e02e$var$we) : [], l = e[3] ? function(e, t, n) {
        return e.trim().split("\n").map(function(e) {
            return $b2bc56c6c0b4e02e$var$ze(e, t, n, !0);
        });
    }(e[3], t, n) : [], a = $b2bc56c6c0b4e02e$var$ze(e[1], t, n, !!l.length);
    return n.inline = !1, l.length ? {
        align: i,
        cells: l,
        header: a,
        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.table
    } : {
        children: a,
        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.paragraph
    };
}
function $b2bc56c6c0b4e02e$var$Ae(e, t) {
    return null == e.align[t] ? {} : {
        textAlign: e.align[t]
    };
}
function $b2bc56c6c0b4e02e$var$Te(e) {
    return function(t, n) {
        return n.inline ? e.exec(t) : null;
    };
}
function $b2bc56c6c0b4e02e$var$Oe(e) {
    return function(t, n) {
        return n.inline || n.simple ? e.exec(t) : null;
    };
}
function $b2bc56c6c0b4e02e$var$Be(e) {
    return function(t, n) {
        return n.inline || n.simple ? null : e.exec(t);
    };
}
function $b2bc56c6c0b4e02e$var$Me(e) {
    return function(t) {
        return e.exec(t);
    };
}
function $b2bc56c6c0b4e02e$var$Re(e, t) {
    if (t.inline || t.simple) return null;
    let n = "";
    e.split("\n").every((e)=>!$b2bc56c6c0b4e02e$var$Ee.some((t)=>t.test(e)) && (n += e + "\n", e.trim()));
    const r = n.trimEnd();
    return "" == r ? null : [
        n,
        r
    ];
}
function $b2bc56c6c0b4e02e$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $b2bc56c6c0b4e02e$var$Ue(e) {
    return e.replace($b2bc56c6c0b4e02e$var$re, "$1");
}
function $b2bc56c6c0b4e02e$var$De(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $b2bc56c6c0b4e02e$var$je(e, t, n) {
    const r = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    const l = e(t, n);
    return n.inline = r, n.simple = i, l;
}
function $b2bc56c6c0b4e02e$var$Ne(e, t, n) {
    const r = n.inline || !1;
    n.inline = !1;
    const i = e(t, n);
    return n.inline = r, i;
}
const $b2bc56c6c0b4e02e$var$He = (e, t, n)=>({
        children: $b2bc56c6c0b4e02e$var$De(t, e[1], n)
    });
function $b2bc56c6c0b4e02e$var$Fe() {
    return {};
}
function $b2bc56c6c0b4e02e$var$Pe() {
    return null;
}
function $b2bc56c6c0b4e02e$var$_e(...e) {
    return e.filter(Boolean).join(" ");
}
function $b2bc56c6c0b4e02e$var$Ge(e, t, n) {
    let r = e;
    const i = t.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || n;
}
function $b2bc56c6c0b4e02e$export$69f434acfbdb0b32(n = "", i = {}) {
    function d(e, n, ...r) {
        const l = $b2bc56c6c0b4e02e$var$Ge(i.overrides, `${e}.props`, {});
        return i.createElement(function(e, t) {
            const n = $b2bc56c6c0b4e02e$var$Ge(t, e);
            return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $b2bc56c6c0b4e02e$var$Ge(t, `${e}.component`, e) : e;
        }(e, i.overrides), $b2bc56c6c0b4e02e$var$t({}, n, l, {
            className: $b2bc56c6c0b4e02e$var$_e(null == n ? void 0 : n.className, l.className) || void 0
        }), ...r);
    }
    function G(t) {
        t = t.replace($b2bc56c6c0b4e02e$var$E, "");
        let n = !1;
        i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $b2bc56c6c0b4e02e$var$P.test(t));
        const r = ie(re(n ? t : `${t.trimEnd().replace($b2bc56c6c0b4e02e$var$te, "")}\n\n`, {
            inline: n
        }));
        for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
        if (null === i.wrapper) return r;
        const l = i.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || i.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $5uXOq.createElement(l, {
            key: "outer"
        }, a);
    }
    function W(t, n) {
        const r = n.match($b2bc56c6c0b4e02e$var$c);
        return r ? r.reduce(function(n, r, a) {
            const o = r.indexOf("=");
            if (-1 !== o) {
                const c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($b2bc56c6c0b4e02e$var$O) && (e = e.replace($b2bc56c6c0b4e02e$var$D, function(e, t) {
                        return t.toUpperCase();
                    })), e;
                })(r.slice(0, o)).trim(), s = function(e) {
                    const t = e[0];
                    return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                }(r.slice(o + 1).trim()), d = $b2bc56c6c0b4e02e$var$l[c] || c, p = n[d] = function(e, t, n, r) {
                    return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                        const n = t.slice(0, t.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($b2bc56c6c0b4e02e$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(t, c, s, i.sanitizer);
                "string" == typeof p && ($b2bc56c6c0b4e02e$var$L.test(p) || $b2bc56c6c0b4e02e$var$B.test(p)) && (n[d] = $5uXOq.cloneElement(G(p.trim()), {
                    key: a
                }));
            } else "style" !== r && (n[$b2bc56c6c0b4e02e$var$l[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $b2bc56c6c0b4e02e$export$3e2338ea76b578c9, i.slugify = i.slugify || $b2bc56c6c0b4e02e$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $b2bc56c6c0b4e02e$var$t({}, $b2bc56c6c0b4e02e$var$a, i.namedCodesToUnicode) : $b2bc56c6c0b4e02e$var$a, i.createElement = i.createElement || $5uXOq.createElement;
    const Z = [], q = {}, Q = {
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.blockQuote]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$p),
            order: 1,
            parse: (e, t, n)=>({
                    children: t(e[0].replace($b2bc56c6c0b4e02e$var$u, ""), n)
                }),
            render: (e, t, n)=>d("blockquote", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.breakLine]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$f),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: (e, t, n)=>d("br", {
                    key: n.key
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.breakThematic]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$h),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: (e, t, n)=>d("hr", {
                    key: n.key
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeBlock]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, n, r)=>d("pre", {
                    key: r.key
                }, d("code", $b2bc56c6c0b4e02e$var$t({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeFenced]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: W("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeBlock
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeInline]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, t, n)=>d("code", {
                    key: n.key
                }, e.text)
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.footnote]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$b),
            order: 0,
            parse: (e)=>(Z.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.footnoteReference]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$v),
            order: 1,
            parse: (e)=>({
                    target: `#${i.slugify(e[1], $b2bc56c6c0b4e02e$export$c383cdd2a518017a)}`,
                    text: e[1]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href")
                }, d("sup", {
                    key: n.key
                }, e.text))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.gfmTask]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$C),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, t, n)=>d("input", {
                    checked: e.completed,
                    key: n.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.heading]: {
            match: $b2bc56c6c0b4e02e$var$Be(i.enforceAtxHeadings ? $b2bc56c6c0b4e02e$var$w : $b2bc56c6c0b4e02e$var$$),
            order: 1,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$De(t, e[2], n),
                    id: i.slugify(e[2], $b2bc56c6c0b4e02e$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            render: (e, t, n)=>d(`h${e.level}`, {
                    id: e.id,
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.headingSetext]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$z),
            order: 0,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$De(t, e[1], n),
                    level: "=" === e[2] ? 1 : 2,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.heading
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlBlock]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$L),
            order: 1,
            parse (e, t, n) {
                const [, r] = e[3].match($b2bc56c6c0b4e02e$var$ne), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $b2bc56c6c0b4e02e$var$Ce.some((e)=>e.test(c)) ? $b2bc56c6c0b4e02e$var$Ne : $b2bc56c6c0b4e02e$var$De);
                var c;
                const s = e[1].toLowerCase(), d = -1 !== $b2bc56c6c0b4e02e$var$o.indexOf(s), p = (d ? s : e[1]).trim(), u = {
                    attrs: W(p, e[2]),
                    noInnerParse: d,
                    tag: p
                };
                return n.inAnchor = n.inAnchor || "a" === s, d ? u.text = e[3] : u.children = a(t, l, n), n.inAnchor = !1, u;
            },
            render: (e, n, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$t({
                    key: r.key
                }, e.attrs), e.text || (e.children ? n(e.children, r) : ""))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlSelfClosing]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$B),
            order: 1,
            parse (e) {
                const t = e[1].trim();
                return {
                    attrs: W(t, e[2] || ""),
                    tag: t
                };
            },
            render: (e, n, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$t({}, e.attrs, {
                    key: r.key
                }))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlComment]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$T),
            order: 1,
            parse: ()=>({}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.image]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$Se),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $b2bc56c6c0b4e02e$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("img", {
                    key: n.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: i.sanitizer(e.target, "img", "src")
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$ve),
            order: 3,
            parse: (e, t, n)=>({
                    children: $b2bc56c6c0b4e02e$var$je(t, e[1], n),
                    target: $b2bc56c6c0b4e02e$var$Ue(e[2]),
                    title: e[3]
                }),
            render: (e, t, n)=>d("a", {
                    key: n.key,
                    href: i.sanitizer(e.target, "a", "href"),
                    title: e.title
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$U),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkBareUrlDetector]: {
            match: (e, t)=>t.inAnchor || i.disableAutoLink ? null : $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$R)(e, t),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkMailtoDetector]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$I),
            order: 0,
            parse (e) {
                let t = e[1], n = e[1];
                return $b2bc56c6c0b4e02e$var$s.test(n) || (n = "mailto:" + n), {
                    children: [
                        {
                            text: t.replace("mailto:", ""),
                            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                        }
                    ],
                    target: n,
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                };
            }
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.orderedList]: $b2bc56c6c0b4e02e$var$be(d, 1),
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.unorderedList]: $b2bc56c6c0b4e02e$var$be(d, 2),
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.newlineCoalescer]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$k),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$Fe,
            render: ()=>"\n"
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.paragraph]: {
            match: $b2bc56c6c0b4e02e$var$Re,
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("p", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.ref]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$N),
            order: 0,
            parse: (e)=>(q[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $b2bc56c6c0b4e02e$var$Pe
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.refImage]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$H),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("img", {
                    key: n.key,
                    alt: e.alt,
                    src: i.sanitizer(q[e.ref].target, "img", "src"),
                    title: q[e.ref].title
                }) : null
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.refLink]: {
            match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$F),
            order: 0,
            parse: (e, t, n)=>({
                    children: t(e[1], n),
                    fallbackChildren: e[0],
                    ref: e[2]
                }),
            render: (e, t, n)=>q[e.ref] ? d("a", {
                    key: n.key,
                    href: i.sanitizer(q[e.ref].target, "a", "href"),
                    title: q[e.ref].title
                }, t(e.children, n)) : d("span", {
                    key: n.key
                }, e.fallbackChildren)
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.table]: {
            match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$j),
            order: 1,
            parse: $b2bc56c6c0b4e02e$var$Le,
            render (e, t, n) {
                const r = e;
                return d("table", {
                    key: n.key
                }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                    return d("th", {
                        key: i,
                        style: $b2bc56c6c0b4e02e$var$Ae(r, i)
                    }, t(e, n));
                }))), d("tbody", null, r.cells.map(function(e, i) {
                    return d("tr", {
                        key: i
                    }, e.map(function(e, i) {
                        return d("td", {
                            key: i,
                            style: $b2bc56c6c0b4e02e$var$Ae(r, i)
                        }, t(e, n));
                    }));
                })));
            }
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text]: {
            match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$ee),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($b2bc56c6c0b4e02e$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                }),
            render: (e)=>e.text
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textBolded]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$V),
            order: 2,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("strong", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textEmphasized]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$X),
            order: 3,
            parse: (e, t, n)=>({
                    children: t(e[2], n)
                }),
            render: (e, t, n)=>d("em", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textEscaped]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$Y),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                })
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textMarked]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$J),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("mark", {
                    key: n.key
                }, t(e.children, n))
        },
        [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textStrikethroughed]: {
            match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$K),
            order: 3,
            parse: $b2bc56c6c0b4e02e$var$He,
            render: (e, t, n)=>d("del", {
                    key: n.key
                }, t(e.children, n))
        }
    };
    !0 === i.disableParsingRawHTML && (delete Q[$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlBlock], delete Q[$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlSelfClosing]);
    const re = function(e) {
        let t = Object.keys(e);
        function n(r, i) {
            let l = [];
            for(i.prevCapture = i.prevCapture || ""; r;){
                let a = 0;
                for(; a < t.length;){
                    const o = t[a], c = e[o], s = c.match(r, i);
                    if (s) {
                        const e = s[0];
                        i.prevCapture += e, r = r.substring(e.length);
                        const t = c.parse(s, n, i);
                        null == t.type && (t.type = o), l.push(t);
                        break;
                    }
                    a++;
                }
            }
            return i.prevCapture = "", l;
        }
        return t.sort(function(t, n) {
            let r = e[t].order, i = e[n].order;
            return r !== i ? r - i : t < n ? -1 : 1;
        }), function(e, t) {
            return n(function(e) {
                return e.replace($b2bc56c6c0b4e02e$var$x, "\n").replace($b2bc56c6c0b4e02e$var$S, "").replace($b2bc56c6c0b4e02e$var$_, "    ");
            }(e), t);
        };
    }(Q), ie = (le = function(e, t) {
        return function(n, r, i) {
            const l = e[n.type].render;
            return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
        };
    }(Q, i.renderRule), function e(t, n = {}) {
        if (Array.isArray(t)) {
            const r = n.key, i = [];
            let l = !1;
            for(let r = 0; r < t.length; r++){
                n.key = r;
                const a = e(t[r], n), o = "string" == typeof a;
                o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
            }
            return n.key = r, i;
        }
        return le(t, e, n);
    });
    var le;
    const ae = G(n);
    return Z.length ? d("div", null, ae, d("footer", {
        key: "footer"
    }, Z.map(function(e) {
        return d("div", {
            id: i.slugify(e.identifier, $b2bc56c6c0b4e02e$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, ie(re(e.footnote, {
            inline: !0
        })));
    }))) : ae;
}
var $b2bc56c6c0b4e02e$export$2e2bcd8739ae039 = (t)=>{
    let { children: r = "", options: i } = t, l = function(e, t) {
        if (null == e) return {};
        var n, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
        return i;
    }(t, $b2bc56c6c0b4e02e$var$n);
    return $5uXOq.cloneElement($b2bc56c6c0b4e02e$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("dX177", function(module, exports) {

$parcel$export(module.exports, "default", () => $dba04067304f7500$export$2e2bcd8739ae039);
/* ulist.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("5uXOq");
const $dba04067304f7500$var$listStyles = null;
const $dba04067304f7500$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        ...props,
        className: (0, $bwpsq.default)([
            "_19bvv47k _bozgv47k"
        ]),
        children: children
    });
var $dba04067304f7500$export$2e2bcd8739ae039 = $dba04067304f7500$var$UList;

});


parcelRegister("h5Age", function(module, exports) {

$parcel$export(module.exports, "default", () => $1597b17bb7cda7eb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5sRpy = parcelRequire("5sRpy");
const $1597b17bb7cda7eb$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $5uXOq.useState)(0);
    const ref = (0, $5uXOq.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $5uXOq.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref,
        children: children
    }) : null;
};
var $1597b17bb7cda7eb$export$2e2bcd8739ae039 = $1597b17bb7cda7eb$export$6118ed0013927eb2;

});

parcelRegister("axgPE", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcfdc8b303097e8f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $evjcU = parcelRequire("evjcU");
const $bcfdc8b303097e8f$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $evjcU.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $bcfdc8b303097e8f$export$2e2bcd8739ae039 = $bcfdc8b303097e8f$var$AIEventSummaryViewed;

});



parcelRegister("gDNla", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd4e4c34dfaf1b31$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bUpbd = parcelRequire("bUpbd");

var $kbSeB = parcelRequire("kbSeB");
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $fd4e4c34dfaf1b31$var$AIFooterBlock = ({ status: status, testId: testId = 'smart-ai-footer-block', ...props })=>{
    if (status !== (0, $bUpbd.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kbSeB.default), {
        ...props,
        testId: testId
    });
};
var $fd4e4c34dfaf1b31$export$2e2bcd8739ae039 = $fd4e4c34dfaf1b31$var$AIFooterBlock;

});
parcelRegister("kbSeB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f40630712a8719fc$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $bUpbd = parcelRequire("bUpbd");

var $gSLUn = parcelRequire("gSLUn");

var $5wGZS = parcelRequire("5wGZS");

var $5zLRC = parcelRequire("5zLRC");

var $alStY = parcelRequire("alStY");
const $f40630712a8719fc$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $gSLUn.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $bUpbd.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5zLRC.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5wGZS.Provider), {
                ...(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') ? {
                    appearance: 'subtle'
                } : {},
                testId: `${testId}-provider`
            }),
            actionData ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $alStY.AIFooterMetadata), {
                ...actionData,
                testId: `${testId}-ai-metadata`
            }) : null
        ]
    });
};
var $f40630712a8719fc$export$2e2bcd8739ae039 = $f40630712a8719fc$var$AIFooterBlockResolvedView;

});
parcelRegister("alStY", function(module, exports) {

$parcel$export(module.exports, "AIFooterMetadata", () => $3664ac12728acf52$export$175228cc2c92b3b6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $gKZoD = parcelRequire("gKZoD");

var $c1WlH = parcelRequire("c1WlH");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");

var $5KCCi = parcelRequire("5KCCi");

var $7eObK = parcelRequire("7eObK");

var $jiAPI = parcelRequire("jiAPI");

var $lE9fQ = parcelRequire("lE9fQ");

var $e8KnM = parcelRequire("e8KnM");
const $3664ac12728acf52$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $gKZoD.di)((0, $jiAPI.default));
    const { state: { status: status } } = (0, $jiAPI.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
                content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $7eObK.messages).ai_summarized_info_short
                }),
                position: "bottom",
                children: (tooltipProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                        ...tooltipProps,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e8KnM.InfoIcon), {
                            label: "Information",
                            LEGACY_size: "small",
                            color: "var(--ds-icon-subtle, #626F86)"
                        })
                    })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c1WlH))), {
                label: "AI",
                LEGACY_size: "small",
                LEGACY_fallbackIcon: (0, $lE9fQ.default),
                color: "var(--ds-icon-subtle, #626F86)"
            })
        ]
    });
};

});
parcelRegister("e8KnM", function(module, exports) {

$parcel$export(module.exports, "InfoIcon", () => $fff370fc70c6ac27$export$2957fc44b3d2481);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $9a675 = parcelRequire("9a675");

var $fxV46 = parcelRequire("fxV46");
const $fff370fc70c6ac27$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9a675))), {
        color: props.color || 'currentColor',
        LEGACY_fallbackIcon: (0, $fxV46.default),
        ...props
    });

});
parcelRegister("fxV46", function(module, exports) {

$parcel$export(module.exports, "default", () => $72a6421fe6b124be$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ltBcH = parcelRequire("ltBcH");
const $72a6421fe6b124be$var$InfoIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
                fill: "currentColor"
            })
        ]
    });
/**
 * __InfoIcon__
 */ const $72a6421fe6b124be$var$InfoIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ltBcH.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $72a6421fe6b124be$var$InfoIconGlyph
    });
var $72a6421fe6b124be$export$2e2bcd8739ae039 = $72a6421fe6b124be$var$InfoIcon;

});





parcelRegister("U37hx", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc84030eadaa1553$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gKZoD = parcelRequire("gKZoD");

var $fHpHg = parcelRequire("fHpHg");

var $bUpbd = parcelRequire("bUpbd");

var $gSLUn = parcelRequire("gSLUn");

var $dKqTa = parcelRequire("dKqTa");

var $lgNhV = parcelRequire("lgNhV");
// TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $bc84030eadaa1553$var$ignoreContainerPaddingStylesOld = null;
const $bc84030eadaa1553$var$ignoreContainerPaddingStyles = null;
const $bc84030eadaa1553$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $bc84030eadaa1553$var$sort = (a, b)=>{
    let idxA = $bc84030eadaa1553$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $bc84030eadaa1553$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $bc84030eadaa1553$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $bc84030eadaa1553$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $bc84030eadaa1553$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $bUpbd.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $bUpbd.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $bUpbd.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $bUpbd.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $bc84030eadaa1553$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, className: className, testId: testId = 'smart-block-action' })=>{
    (0, $gKZoD.di)((0, $lgNhV.ActionFooter));
    const context = (0, $gSLUn.useFlexibleUiContext)();
    const ui = (0, $gSLUn.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $5uXOq.useState)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const onLoadingChange = (0, $5uXOq.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? $bc84030eadaa1553$export$1af10e3728e3a644(ui?.size || (0, $bUpbd.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $5uXOq.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $5uXOq.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $5uXOq.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions);
        arr.sort($bc84030eadaa1553$var$sort);
        return arr.map((name)=>{
            const Action = name in $dKqTa ? $dKqTa[name] : undefined;
            return Action ? /*#__PURE__*/ (0, $2OMIu.jsx)(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/no-unsafe-design-token-usage
                style: padding && {
                    paddingInline: padding
                },
                hideTooltip: isLoading
            }, name) : null;
        });
    }, [
        context?.actions,
        onClick,
        onError,
        padding,
        size,
        spaceInline,
        isLoading,
        onLoadingChange
    ]);
    return actions ? /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        ref: blockRef,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') ? "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb129b _18u01ivi _2hwxc10g" : "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb1osq _18u01ivi _2hwxc10g",
            className
        ]),
        children: [
            actions,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lgNhV.ActionFooter), {
                message: message,
                testId: testId
            })
        ]
    }) : null;
};
var $bc84030eadaa1553$export$2e2bcd8739ae039 = $bc84030eadaa1553$var$ActionBlock;

});
parcelRegister("lgNhV", function(module, exports) {

$parcel$export(module.exports, "ActionFooter", () => $c41232c16c292ab9$export$2d2b754ac238f9aa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iZXAi = parcelRequire("iZXAi");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");

var $h5Age = parcelRequire("h5Age");
const $c41232c16c292ab9$var$containerStyles = null;
const $c41232c16c292ab9$var$errorStyles = null;
const $c41232c16c292ab9$var$styles = {
    containerStyles: "_kkk2n7od _2rkoglpi _1rjc12x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _1bsb1osq _fiawglyw",
    errorContentStyles: "_bozgv77o",
    titleStyles: "_11c8dcr7 _syaz1gjq"
};
const $c41232c16c292ab9$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iZXAi))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                LEGACY_size: "small",
                testId: "action-error-icon",
                LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`
            });
        default:
            return null;
    }
};
const $c41232c16c292ab9$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    if ((0, $fHpHg.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        backgroundColor: message.appearance === 'error' ? 'color.background.danger' : undefined,
        testId: `${testId}-footer`,
        style: {
            width: `calc(100% - var(--container-padding-left) - var(--container-padding-right))`
        },
        xcss: $c41232c16c292ab9$var$styles.containerStyles,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h5Age.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $c41232c16c292ab9$var$styles.errorContentStyles,
                children: [
                    message.icon || $c41232c16c292ab9$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                        xcss: $c41232c16c292ab9$var$styles.titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testId": `${testId}-footer`,
        className: (0, $bwpsq.default)([
            "_kkk2n7od _2rkoglpi _1yt412x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _vwz4gktf _1bsb1osq _fiawglyw",
            message.appearance === 'error' && "_bfhk1gly"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h5Age.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $c41232c16c292ab9$var$styles.errorContentStyles,
                children: [
                    message.icon || $c41232c16c292ab9$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                        xcss: $c41232c16c292ab9$var$styles.titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
};

});




parcelRegister("bErLx", function(module, exports) {

$parcel$export(module.exports, "LoadingCardLink", () => $3191d95ba3033aa9$export$1ca0544321134ad6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $lz4db = parcelRequire("lz4db");

const $3191d95ba3033aa9$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lz4db.CardLinkView), {
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $d3465c92d15636b7$export$4b2b7d155f69aed4),
        placeholder: placeholder
    }, 'lazy-render-key');
};

});
parcelRegister("lz4db", function(module, exports) {

$parcel$export(module.exports, "CardLinkView", () => $310918e6d2acfe91$export$ce508304ed2dd145);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $98deu = parcelRequire("98deu");
class $310918e6d2acfe91$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $98deu.Frame), {
            withoutBackground: true,
            ...this.props,
            children: this.props.placeholder || this.props.link
        });
    }
}

});
parcelRegister("98deu", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $77d66dccd4019078$export$b89a827e9254211a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lzjiu = parcelRequire("lzjiu");

var $dnZ7F = parcelRequire("dnZ7F");
const $77d66dccd4019078$export$b89a827e9254211a = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, link: link, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    const handleClick = (0, $5uXOq.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $5uXOq.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $lzjiu.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    const isAnchor = Boolean(link || onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = isAnchor ? (0, $dnZ7F.WrapperAnchor) : (0, $dnZ7F.WrapperSpan);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive ? 0 : undefined,
        role: isInteractive ? 'button' : undefined,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered,
        truncateInline: truncateInline,
        children: children
    });
});

});
parcelRegister("dnZ7F", function(module, exports) {

$parcel$export(module.exports, "WrapperSpan", () => $6e5916bec31bc930$export$8b5c95e985c4ec9a);
$parcel$export(module.exports, "WrapperAnchor", () => $6e5916bec31bc930$export$6e4bde711df5c2ab);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");
const $6e5916bec31bc930$var$lineHeight = 22;
const $6e5916bec31bc930$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ref: ref,
        ...props,
        className: (0, $bwpsq.default)([
            (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') ? "_1yt4x7n9 _2rkoiti9 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28" : "_1yt4x7n9 _2rkoiti9 _v56415x0 _vwz4qslr _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && !(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _vwz4183y _1e0c1abx _1yyjkb7n _sudp1e54 _17bix7n9 _nr8z1o8l _102kqslr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19ith6cr _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7h6cr _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv"
        ]),
        children: props.children
    });
});
const $6e5916bec31bc930$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        href: href,
        ref: ref,
        ...props,
        className: (0, $bwpsq.default)([
            (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') ? "_1yt4x7n9 _2rkoiti9 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28" : "_1yt4x7n9 _2rkoiti9 _v56415x0 _vwz4qslr _1e0c1nu9 _16d9qvcn _syaz1y58 _1rkwglyw _4cvxmr28",
            truncateInline && (0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && !(0, $fHpHg.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _vwz4183y _1e0c1abx _1yyjkb7n _sudp1e54 _17bix7n9 _nr8z1o8l _102kqslr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19ith6cr _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6dmr28",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qscw00 _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7h6cr _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv",
            isInteractive && "_nt751r31 _49pcglyw _1hvw1o36 _1372tlke _7ehicw00 _1j5pglyw _1di629zg"
        ]),
        children: props.children
    });
});
const $6e5916bec31bc930$var$baseWrapperStylesNew = null;
const $6e5916bec31bc930$var$baseWrapperStylesOld = null;
// if the parent instruct the wrapper to be interactive, and the wrapper is in focus, apply selectedStyles
const $6e5916bec31bc930$var$interactiveStyles = null;
const $6e5916bec31bc930$var$hoveredStyles = null;
const $6e5916bec31bc930$var$hoveredWithBackgroundStyles = null;
const $6e5916bec31bc930$var$withoutBackgroundStyles = null;
const $6e5916bec31bc930$var$withBackgroundStyles = null;
const $6e5916bec31bc930$var$truncateStylesNew = null;
const $6e5916bec31bc930$var$truncateStylesOld = null;
const $6e5916bec31bc930$var$notSelectedStyle = null;
const $6e5916bec31bc930$var$selectedStyles = null;

});



const $d3465c92d15636b7$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';


parcelRegister("kozXi", function(module, exports) {

let $ed91f0821aee719b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ed91f0821aee719b$var$load("h2MrD"),
    $ed91f0821aee719b$var$load("bYT2S"),
    $ed91f0821aee719b$var$load("1BoBg")
]).then(()=>parcelRequire('Pcn4M'));

});



parcelRegister("aDGjB", function(module, exports) {

$parcel$export(module.exports, "smartLinkFallback", () => $032b0d73402be081$export$e684dcf56ac8ae14);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8zIDr = parcelRequire("8zIDr");
const $032b0d73402be081$export$e684dcf56ac8ae14 = (url)=>()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $8zIDr.default), {
            href: url,
            target: "_blank",
            rel: "noopener noreferrer",
            children: url
        });

});

parcelRegister("9cRy7", function(module, exports) {

$parcel$export(module.exports, "useKnowledgeFilterService", () => $dcb6d5fb47296492$export$e7f441744c2ab3f0);
$parcel$export(module.exports, "useKnowledgeFilterFormField", () => $dcb6d5fb47296492$export$ad221c44afd5157f);

var $5uXOq = parcelRequire("5uXOq");

var $8lkUs = parcelRequire("8lkUs");

var $cWUIV = parcelRequire("cWUIV");
const $dcb6d5fb47296492$export$cac55d864f039044 = (0, $5uXOq.createContext)(null);
const $dcb6d5fb47296492$export$e7f441744c2ab3f0 = ()=>{
    const { siteId: siteId } = (0, $cWUIV.useSiteContext)();
    const serviceContext = (0, $5uXOq.useContext)($dcb6d5fb47296492$export$cac55d864f039044);
    const knowledgeFilterService = (0, $5uXOq.useMemo)(()=>{
        if (serviceContext) return serviceContext;
        return new (0, $8lkUs.KnowledgeFilterServiceImpl)(siteId);
    }, [
        serviceContext,
        siteId
    ]);
    return knowledgeFilterService;
};
const $dcb6d5fb47296492$export$ad221c44afd5157f = ()=>{
    const { getEntitiesByAris: getEntitiesByAris } = $dcb6d5fb47296492$export$e7f441744c2ab3f0();
    const getKnowledgeSourcesFromFormFields = (0, $5uXOq.useCallback)((fields)=>{
        const sources = [];
        for(const fieldSource in fields.knowledgeEnabledFields)if (fields.knowledgeEnabledFields[fieldSource]) {
            let configuration;
            if (fieldSource === 'confluence') configuration = {
                space_filter: fields.confluenceSpaceFilters && fields.confluenceFilterScope?.value === 'spaces' ? fields.confluenceSpaceFilters.map((filter)=>filter.ari) : [],
                parent_filter: fields.confluenceAncestorPageFilters && fields.confluenceFilterScope?.value === 'pages' ? fields.confluenceAncestorPageFilters?.map((filter)=>filter.ari) : []
            };
            else if (fieldSource === 'jira') configuration = {
                project_filter: fields.jiraProjectFilters?.map((filter)=>filter.ari) ?? []
            };
            sources.push({
                enabled: true,
                source: fieldSource,
                configuration: configuration
            });
        }
        return {
            enabled: fields.knowledgeScope,
            sources: sources
        };
    }, []);
    const getKnowledgeSourceFieldsFromScaffold = (0, $5uXOq.useCallback)(async (agent)=>{
        const { knowledge_sources: knowledge_sources } = agent;
        if (!knowledge_sources?.enabled) return {
            knowledgeScope: false
        };
        let config = {
            knowledgeScope: true,
            knowledgeEnabledFields: {}
        };
        const filterPromises = [];
        for (const { source: source, configuration: knowledgeConfig, enabled: enabled } of knowledge_sources.sources)switch(source){
            case 'confluence':
                config.knowledgeEnabledFields.confluence = enabled;
                if (knowledgeConfig?.parent_filter.length) filterPromises.push(getEntitiesByAris({
                    aris: knowledgeConfig.parent_filter
                }).then((filters)=>{
                    config.confluenceAncestorPageFilters = filters.map((page)=>({
                            ari: page.ari,
                            label: page.displayName,
                            value: page.ari,
                            url: page.url
                        }));
                    config.confluenceFilterScope = {
                        label: '',
                        value: 'pages'
                    };
                }));
                if (knowledgeConfig?.space_filter.length) filterPromises.push(getEntitiesByAris({
                    aris: knowledgeConfig.space_filter
                }).then((filters)=>{
                    config.confluenceSpaceFilters = filters.map((page)=>({
                            ari: page.ari,
                            label: page.displayName,
                            value: page.ari,
                            iconUrl: page.iconUrl,
                            url: page.url
                        }));
                    config.confluenceFilterScope = {
                        label: '',
                        value: 'spaces'
                    };
                }));
                break;
            case 'jira':
                config.knowledgeEnabledFields.jira = enabled;
                if (knowledgeConfig) filterPromises.push(getEntitiesByAris({
                    aris: knowledgeConfig.project_filter
                }).then((filters)=>{
                    config.jiraProjectFilters = filters.map((page)=>({
                            ari: page.ari,
                            label: page.displayName,
                            value: page.ari,
                            iconUrl: page.iconUrl,
                            url: page.url
                        }));
                }));
                break;
            default:
                config.knowledgeEnabledFields[source] = enabled;
                break;
        }
        await Promise.all(filterPromises);
        return config;
    }, [
        getEntitiesByAris
    ]);
    return {
        getKnowledgeSourcesFromFormFields: getKnowledgeSourcesFromFormFields,
        getKnowledgeSourceFieldsFromScaffold: getKnowledgeSourceFieldsFromScaffold
    };
};

});
parcelRegister("8lkUs", function(module, exports) {

$parcel$export(module.exports, "KnowledgeFilterServiceImpl", () => $a10c61b8d4fc1ccc$export$a0684b2b2bbfab69);

var $9TAsu = parcelRequire("9TAsu");

var $ch0Jz = parcelRequire("ch0Jz");

function $a10c61b8d4fc1ccc$var$notEmpty(value) {
    return value !== null && value !== undefined;
}
class $a10c61b8d4fc1ccc$export$a0684b2b2bbfab69 {
    constructor(siteId){
        this.siteId = siteId;
        this.entityTypeToAti = (type)=>{
            switch(type){
                case 'space':
                    return 'ati:cloud:confluence:space';
                case 'page':
                    return 'ati:cloud:confluence:page';
                case 'project':
                    return 'ati:cloud:jira:project';
            }
        };
        this.filterResults = async ({ query: query, entityType: entityType, confluenceSpaces: confluenceSpaces = [] })=>{
            const result = await (0, $ch0Jz.fetchAgg)({
                graphQuery: (0, $1a8b401768bad434$export$4bc63ef50ec3954e),
                siteId: this.siteId,
                variables: {
                    query: query,
                    entityAti: this.entityTypeToAti(entityType),
                    confluenceSpaces: confluenceSpaces
                }
            });
            return result.data.search.search.edges?.map((edge)=>edge.node).map((item)=>({
                    ari: item.ari,
                    displayName: item.displayName,
                    iconUrl: item.iconUrl,
                    spaceKey: item.spaceKey,
                    url: item.url
                }));
        };
        this.getEntitiesByAris = async (options)=>{
            let entities = {
                space: {
                    responseMapper: (response)=>response?.data?.confluence?.spaces?.filter($a10c61b8d4fc1ccc$var$notEmpty).map((space)=>({
                                ...space,
                                url: space.links.base + space.links.webUi,
                                iconUrl: space.iconUrl.path
                            })) ?? [],
                    aris: [],
                    graphQuery: (0, $1a8b401768bad434$export$21da0c227e4ca0b8)
                },
                page: {
                    responseMapper: (response)=>response?.data?.confluence?.pages?.filter($a10c61b8d4fc1ccc$var$notEmpty).map((page)=>({
                                ...page,
                                url: page.links.base + page.links.webUi
                            })) ?? [],
                    aris: [],
                    graphQuery: (0, $1a8b401768bad434$export$a970d24119afd9d2)
                },
                project: {
                    responseMapper: (response)=>response?.data?.jira?.jiraProjects?.filter($a10c61b8d4fc1ccc$var$notEmpty).map((project)=>({
                                ...project,
                                iconUrl: project.iconUrl.small
                            })) ?? [],
                    aris: [],
                    graphQuery: (0, $1a8b401768bad434$export$46cf0e4af88c5342)
                }
            };
            for (const ari of options.aris)try {
                const resourceType = ari.split(/[:\/]/)[4];
                if (entities[resourceType]) entities[resourceType].aris.push(ari);
            } catch (error) {
            // Ignore invalid aris
            }
            const aggPromises = [];
            for (const { aris: aris, graphQuery: graphQuery, responseMapper: responseMapper } of Object.values(entities))if (aris.length) aggPromises.push((0, $ch0Jz.fetchAgg)({
                graphQuery: graphQuery,
                variables: {
                    aris: aris
                }
            }).then((result)=>{
                return responseMapper(result).map((item)=>({
                        ari: item.ari,
                        displayName: item.displayName,
                        iconUrl: item.iconUrl,
                        spaceKey: item.spaceKey,
                        url: item.url
                    }));
            }));
            const results = await Promise.all(aggPromises).catch((error)=>{
                (0, $9TAsu.logException)({
                    exception: error,
                    name: 'KnowledgeFilterService.getEntitiesByAris'
                });
                return [];
            });
            return results.flat();
        };
    }
}

});
parcelRegister("ch0Jz", function(module, exports) {

$parcel$export(module.exports, "fetchAgg", () => $b9e6c51c458e4efa$export$f49dad89491f6bf2);

var $bF8MR = parcelRequire("bF8MR");
const $b9e6c51c458e4efa$export$f49dad89491f6bf2 = async ({ siteId: siteId, graphQuery: graphQuery, variables: variables })=>{
    const response = await (0, $bF8MR.performGqlFetch)({
        gqlQuery: graphQuery,
        variables: {
            siteAri: siteId ? `ari:cloud:confluence::site/${siteId}` : undefined,
            ...variables
        }
    });
    return response;
};

});
parcelRegister("bF8MR", function(module, exports) {

$parcel$export(module.exports, "performGqlFetch", () => $4f0eaaa0a7e32e00$export$f602b5befecb0b84);

var $30RFw = parcelRequire("30RFw");
const $4f0eaaa0a7e32e00$var$extractQueryName = (gqlQuery)=>{
    const operationMatch = gqlQuery.match(/(?:query|mutation)\s+(\w+)/);
    return operationMatch ? operationMatch[1] : null;
};
const $4f0eaaa0a7e32e00$export$f602b5befecb0b84 = async ({ gqlQuery: gqlQuery, headerOptions: headerOptions, variables: variables })=>{
    try {
        const response = await fetch('/gateway/api/graphql', {
            headers: {
                'Content-Type': 'application/json',
                ...headerOptions
            },
            method: 'POST',
            body: JSON.stringify({
                query: gqlQuery,
                variables: variables
            })
        });
        const json = await response.json();
        if (json?.errors?.length) await $4f0eaaa0a7e32e00$var$processGqlErrorResponse({
            errors: json.errors,
            gqlQuery: gqlQuery
        });
        return json;
    } catch (err) {
        throw new (0, $30RFw.FetchError)('GraphQL query failed', {
            cause: err
        });
    }
};
class $4f0eaaa0a7e32e00$export$ba203f24e0131ba7 extends Error {
    constructor(message, { errors: errors, queryName: queryName }){
        super(message);
        this.name = 'GraphQLError';
        this.errors = errors;
        this.queryName = queryName;
    }
}
const $4f0eaaa0a7e32e00$var$processGqlErrorResponse = async ({ errors: errors, gqlQuery: gqlQuery })=>{
    const errorsToThrow = [];
    errors.forEach((error)=>{
        errorsToThrow.push({
            message: error.message,
            status_code: error.extensions.statusCode,
            classification: error.extensions.classification
        });
    });
    throw new $4f0eaaa0a7e32e00$export$ba203f24e0131ba7('GraphQL API error', {
        errors: errorsToThrow,
        queryName: $4f0eaaa0a7e32e00$var$extractQueryName(gqlQuery)
    });
};

});
parcelRegister("30RFw", function(module, exports) {

$parcel$export(module.exports, "FetchError", () => $110cf8a7fd9e0d6d$export$26e841bcf1aeb894);
class $110cf8a7fd9e0d6d$export$26e841bcf1aeb894 extends Error {
    constructor(message, cause){
        super(message), this.cause = cause;
        this.name = 'FetchError';
        if (cause) this.cause = cause;
    }
}

});



const $1a8b401768bad434$export$4bc63ef50ec3954e = `
query ListSpaces($query: String!, $siteAri: String!, $entityAti: String!, $confluenceSpaces: [String!]) {
	search {
		search(
			query: $query
			filters: {
				entities: [$entityAti],
				locations: [$siteAri],
				confluenceFilters: {
					spacesFilter: $confluenceSpaces
				}
			}
			experience: "rovo-chat"
		) {
			edges {
				node {
					ari: id
					displayName: title
					iconUrl
					url
					... on SearchConfluenceSpace {
						spaceKey: key
					}
				}
			}
		}
	}
}
`;
const $1a8b401768bad434$export$46cf0e4af88c5342 = `
query GetProjects($aris: [ID!]!) {
  jira {
    jiraProjects(
      ids: $aris
    ) {
      ari: id
      displayName: name
      iconUrl: avatar {
        small
      }
			url: webUrl
    }
  }
}
`;
const $1a8b401768bad434$export$a970d24119afd9d2 = `
query GetPages($aris: [ID!]!) {
  confluence {
    pages(
      ids: $aris
    ) {
      ari: id
      displayName: title
			links {
        base
        webUi
      }
    }
  }
}
`;
const $1a8b401768bad434$export$21da0c227e4ca0b8 = `
query GetSpaces($aris: [ID!]!) {
  confluence {
    spaces(
      ids: $aris
    ) {
      ari: id
      displayName: name
      iconUrl: icon {
        path
      }
			spaceKey: key
			links {
        base
        webUi
      }
    }
  }
}
`;


parcelRegister("cWUIV", function(module, exports) {

$parcel$export(module.exports, "SiteContext", () => $529843c8d202139a$export$2cab3982d83485b0);
$parcel$export(module.exports, "useSiteContext", () => $529843c8d202139a$export$55c0e3cb4fbc46cf);

var $5uXOq = parcelRequire("5uXOq");
const $529843c8d202139a$export$2cab3982d83485b0 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    siteId: ''
});
const $529843c8d202139a$export$55c0e3cb4fbc46cf = ()=>{
    const context = (0, $5uXOq.useContext)($529843c8d202139a$export$2cab3982d83485b0);
    return context;
};

});


parcelRegister("gcD1g", function(module, exports) {

$parcel$export(module.exports, "default", () => $d29efdf13b012ed1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d29efdf13b012ed1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noKnowledgeAdded: {
        id: 'rovo-chat.view-agent.no-knowledge-added',
        defaultMessage: 'No custom knowledge sources',
        description: 'Message displayed when no knowledge is added to the Agent'
    },
    forgeKnowledgeDescription: {
        id: 'rovo-chat.view-agent.hidden-knowledge-description',
        defaultMessage: "Forge Agents built with code don't use typical knowledge sources",
        description: 'Description of the knowledge section, this is displayed when knowledge is purposely hidden'
    }
});

});


parcelRegister("gIlbd", function(module, exports) {

$parcel$export(module.exports, "getAAIDFromARI", () => $05d52bdf3397bd64$export$3761e66a04602cbd);
$parcel$export(module.exports, "getARIFromAAID", () => $05d52bdf3397bd64$export$acf3e1bcf222b00d);
$parcel$export(module.exports, "AgentCreatedBy", () => $05d52bdf3397bd64$export$1565ea9a9fb7ad67);
$parcel$export(module.exports, "useProfileResolution", () => $05d52bdf3397bd64$export$5d980898591175e);
$parcel$export(module.exports, "filterAndSortAgents", () => $05d52bdf3397bd64$export$13d60404a0dddebd);
$parcel$export(module.exports, "getEnabledKnowlegeArisFromAgent", () => $05d52bdf3397bd64$export$a6e36c224ec3c0cb);
$parcel$export(module.exports, "getSuggestedOotbAgents", () => $05d52bdf3397bd64$export$6d876204c5d593ac);
$parcel$export(module.exports, "isDevelopmentAgent", () => $05d52bdf3397bd64$export$9148c67556b3ebc6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $gKZoD = parcelRequire("gKZoD");

var $iItCF = parcelRequire("iItCF");

var $ixsH2 = parcelRequire("ixsH2");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");

var $awbOn = parcelRequire("awbOn");

var $4CMbn = parcelRequire("4CMbn");

var $1xmyx = parcelRequire("1xmyx");

var $jxg93 = parcelRequire("jxg93");

var $l1rbO = parcelRequire("l1rbO");

var $kwxxt = parcelRequire("kwxxt");

var $bmwD2 = parcelRequire("bmwD2");
const $05d52bdf3397bd64$export$3761e66a04602cbd = (ari)=>{
    const matched = ari.match(/\/([a-zA-Z0-9_\|\-\:]{1,128})$/);
    return matched ? matched[1] : undefined;
};
const $05d52bdf3397bd64$export$acf3e1bcf222b00d = (aaid)=>{
    return `ari:cloud:identity::user/${aaid}`;
};
const $05d52bdf3397bd64$export$1565ea9a9fb7ad67 = ({ agent: agent, siteId: siteId, simplified: simplified })=>{
    if ((0, $jxg93.isCustomerAgent)(agent)) {
        const aaid = agent.creator ? $05d52bdf3397bd64$export$3761e66a04602cbd(agent.creator) : undefined;
        if (!aaid) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)($05d52bdf3397bd64$var$ResolvingMention, {
            userId: aaid,
            siteId: siteId,
            profileCard: true,
            simplified: simplified
        });
    }
    if ((0, $jxg93.isSystemAgent)(agent) || !agent.creator) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2Eqc8.default), {
        alignBlock: "center",
        testId: "atlassian-icon",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iItCF.AtlassianIcon), {
                appearance: "brand",
                size: "small"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                children: "Atlassian"
            })
        ]
    });
    if ((0, $jxg93.isForgeAgent)(agent)) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
        children: agent.creator
    });
    return null;
};
const $05d52bdf3397bd64$var$ResolvingMention = ({ userId: userId, siteId: siteId, profileCard: profileCard = false, simplified: simplified = false })=>{
    (0, $gKZoD.di)($05d52bdf3397bd64$export$5d980898591175e);
    const { profile: profile, client: client } = $05d52bdf3397bd64$export$5d980898591175e(userId, siteId);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const fullName = profile.data?.status === 'inactive' && profile.data.fullName ? formatMessage((0, $bmwD2.default).deactivatedCreatorName, {
        name: profile.data.fullName
    }) : profile.data?.fullName;
    if (profile.isFetching || !profile.data) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4CMbn.default), {
        isShimmering: true,
        height: 18,
        width: 100,
        borderRadius: 3
    });
    if (simplified) return /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
        href: `/people/${userId}`,
        target: "_blank",
        children: fullName
    });
    return profileCard ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $awbOn.default), {
        userId: userId,
        resourceClient: client,
        ariaLabel: fullName,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ixsH2.default), {
            id: userId,
            isHighlighted: profile.data.isCurrentUser,
            text: `@${fullName}`
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ixsH2.default), {
        id: userId,
        isHighlighted: profile.data.isCurrentUser,
        text: `@${fullName}`
    });
};
function $05d52bdf3397bd64$export$5d980898591175e(userId, siteId, shouldFetch = true) {
    const profileClient = (0, $kwxxt.useProfileClient)();
    const profile = (0, $1xmyx.useQuery)({
        queryKey: [
            'fetchProfile',
            siteId,
            userId
        ],
        queryFn: async ()=>{
            try {
                const response = await profileClient.getProfile(siteId, userId);
                return response;
            } catch (error) {
                return {};
            }
        },
        enabled: shouldFetch
    });
    return {
        profile: profile,
        client: profileClient
    };
}
const $05d52bdf3397bd64$export$13d60404a0dddebd = (agents, filters)=>{
    return agents.filter((agent)=>agent.name.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase()) || agent.description?.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase())).sort((a, b)=>a.name.localeCompare(b.name));
};
const $05d52bdf3397bd64$export$a6e36c224ec3c0cb = (agent)=>{
    if (!agent.knowledge_sources?.enabled) return [];
    return agent.knowledge_sources.sources.filter((source)=>source.enabled).reduce((acc, source)=>{
        switch(source.source){
            case 'confluence':
                acc.push(...source.configuration?.parent_filter ?? []);
                acc.push(...source.configuration?.space_filter ?? []);
                break;
            case 'jira':
                acc.push(...source.configuration?.project_filter ?? []);
                break;
        }
        return acc;
    }, []);
};
const $05d52bdf3397bd64$export$6d876204c5d593ac = ({ availableAgents: availableAgents, product: product })=>{
    // If no product is provided / product is not supported, fallback to using default agents
    const defaultAgentsNamedIds = product ? (0, $l1rbO.DEFAULT_OOTB_AGENTS_NAMED_IDS)[product] ?? (0, $l1rbO.DEFAULT_AGENTS_NAMED_ID_LIST) : (0, $l1rbO.DEFAULT_AGENTS_NAMED_ID_LIST);
    const defaultAgents = availableAgents.filter((agent)=>defaultAgentsNamedIds.has(agent.named_id) || agent.external_config_reference && defaultAgentsNamedIds.has(agent.external_config_reference));
    return defaultAgents;
};
const $05d52bdf3397bd64$export$9148c67556b3ebc6 = (agent)=>{
    return (agent.action_config ?? []).some((config)=>config.id === 'agent_action_jira_issue_trigger_autodev');
};

});
parcelRegister("ixsH2", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_USER_ID", () => $706849bfa3454ce0$export$af8124aa496797f2);
$parcel$export(module.exports, "default", () => $706849bfa3454ce0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6fV04 = parcelRequire("6fV04");

var $bEt8n = parcelRequire("bEt8n");

var $jRQ22 = parcelRequire("jRQ22");

var $5FAiL = parcelRequire("5FAiL");

var $bJ5oI = parcelRequire("bJ5oI");

var $1PMrW = parcelRequire("1PMrW");

var $3TR0I = parcelRequire("3TR0I");

var $e35GK = parcelRequire("e35GK");

var $7FbWx = parcelRequire("7FbWx");

var $g5i8Y = parcelRequire("g5i8Y");
const $706849bfa3454ce0$export$7452d7062a4d0634 = 1000;
const $706849bfa3454ce0$export$af8124aa496797f2 = '_|unknown|_';
class $706849bfa3454ce0$export$92ab8442e7a15cef extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    constructor(props){
        super(props), this.handleOnClick = (e)=>{
            const { id: id, text: text, onClick: onClick } = this.props;
            if (onClick) onClick(id, text, e);
        }, this.handleOnMouseEnter = (e)=>{
            const { id: id, text: text, onMouseEnter: onMouseEnter, onHover: onHover } = this.props;
            if (onMouseEnter) onMouseEnter(id, text, e);
            this.hoverTimeout = window.setTimeout(()=>{
                if (onHover) onHover();
                this.hoverTimeout = undefined;
            }, $706849bfa3454ce0$export$7452d7062a4d0634);
        }, this.handleOnMouseLeave = (e)=>{
            const { id: id, text: text, onMouseLeave: onMouseLeave } = this.props;
            if (onMouseLeave) onMouseLeave(id, text, e);
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        }, this.getMentionType = ()=>{
            const { accessLevel: accessLevel, isHighlighted: isHighlighted } = this.props;
            if (isHighlighted) return (0, $bJ5oI.MentionType).SELF;
            if ((0, $bJ5oI.isRestricted)(accessLevel)) return (0, $bJ5oI.MentionType).RESTRICTED;
            return (0, $bJ5oI.MentionType).DEFAULT;
        };
        (0, $g5i8Y.mentionRenderedUfoExperience).getInstance(props.id).start();
    }
    componentDidMount() {
        (0, $g5i8Y.mentionRenderedUfoExperience).getInstance(this.props.id).success();
    }
    componentWillUnmount() {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        const ufoInstance = (0, $g5i8Y.mentionRenderedUfoExperience).getInstance(this.props.id);
        if ([
            (0, $e35GK.UFOExperienceState)['STARTED'],
            (0, $e35GK.UFOExperienceState)['IN_PROGRESS']
        ].includes(ufoInstance.state)) ufoInstance.abort();
    }
    renderUnknownUserError(id) {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7FbWx.UnknownUserError), {
            values: {
                userId: id.slice(-5)
            },
            children: (message)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                    children: `@${message}`
                })
        });
    }
    render() {
        const { handleOnClick: handleOnClick, handleOnMouseEnter: handleOnMouseEnter, handleOnMouseLeave: handleOnMouseLeave, props: props } = this;
        const { text: text, id: id, accessLevel: accessLevel, localId: localId } = props;
        const mentionType = this.getMentionType();
        const failedMention = text === `@${$706849bfa3454ce0$export$af8124aa496797f2}`;
        const showTooltip = mentionType === (0, $bJ5oI.MentionType).RESTRICTED;
        const mentionComponent = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6fV04.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jRQ22.default), {
                mentionType: mentionType,
                onClick: handleOnClick,
                onMouseEnter: handleOnMouseEnter,
                onMouseLeave: handleOnMouseLeave,
                spellCheck: false,
                "data-testid": `mention-${id}`,
                "data-mention-type": mentionType,
                "data-mention-tooltip": showTooltip,
                children: failedMention ? this.renderUnknownUserError(id) : text || '@...'
            })
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g5i8Y.UfoErrorBoundary), {
            id: id,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: localId,
                "data-mention-id": id,
                "data-local-id": localId,
                "data-access-level": accessLevel,
                spellCheck: false,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bEt8n.default), {
                    children: showTooltip ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Suspense, {
                        fallback: mentionComponent,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5FAiL.default), {
                            name: text,
                            children: mentionComponent
                        })
                    }) : mentionComponent
                })
            })
        });
    }
}
const $706849bfa3454ce0$var$MentionWithAnalytics = (0, $3TR0I.default)({
    onClick: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $1PMrW.fireAnalyticsMentionEvent)(createEvent)('mention', 'selected', text, id, accessLevel);
        return event;
    },
    onHover: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $1PMrW.fireAnalyticsMentionEvent)(createEvent)('mention', 'hovered', text, id, accessLevel);
        return event;
    }
})($706849bfa3454ce0$export$92ab8442e7a15cef);
const $706849bfa3454ce0$var$Mention = $706849bfa3454ce0$var$MentionWithAnalytics;
var $706849bfa3454ce0$export$2e2bcd8739ae039 = $706849bfa3454ce0$var$Mention;

});
parcelRegister("bEt8n", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70def096826601b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $7FbWx = parcelRequire("7FbWx");
const $d70def096826601b$var$EMPTY = {};
const $d70def096826601b$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState($d70def096826601b$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        let aborted = false;
        setMessages($d70def096826601b$var$EMPTY);
        (0, $7FbWx.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $d70def096826601b$var$MessagesIntlProvider = (props)=>{
    const { children: children } = props;
    const intl = (0, $koVbs.default)();
    const messages = $d70def096826601b$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        ...intl,
        messages: messages,
        children: children
    });
};
var $d70def096826601b$export$2e2bcd8739ae039 = $d70def096826601b$var$MessagesIntlProvider;

});
parcelRegister("7FbWx", function(module, exports) {

$parcel$export(module.exports, "UnknownUserError", () => $c72786cec0c8c94d$export$98e06fe7a6174253);
$parcel$export(module.exports, "NoAccessWarning", () => $c72786cec0c8c94d$export$58bd5a2057b6b855);
$parcel$export(module.exports, "NoAccessLabel", () => $c72786cec0c8c94d$export$da9f8ce14593162f);
$parcel$export(module.exports, "getMessagesForLocale", () => $c72786cec0c8c94d$export$d0a3169680473b6c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $klufr = parcelRequire("klufr");
const $c72786cec0c8c94d$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $koVbs.default)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            values: values,
            ...messageDescriptor
        });
    };
const $c72786cec0c8c94d$export$98e06fe7a6174253 = $c72786cec0c8c94d$export$392a0c6a82ab0e50((0, $klufr.messages).unknownUserError);
const $c72786cec0c8c94d$export$58bd5a2057b6b855 = $c72786cec0c8c94d$export$392a0c6a82ab0e50((0, $klufr.messages).noAccessWarning);
const $c72786cec0c8c94d$export$da9f8ce14593162f = $c72786cec0c8c94d$export$392a0c6a82ab0e50((0, $klufr.messages).noAccessLabel);
const $c72786cec0c8c94d$export$4a258ffee7316766 = $c72786cec0c8c94d$export$392a0c6a82ab0e50((0, $klufr.messages).defaultHeadline);
const $c72786cec0c8c94d$export$702321a50d74536e = $c72786cec0c8c94d$export$392a0c6a82ab0e50((0, $klufr.messages).defaultAdvisedAction);
const $c72786cec0c8c94d$export$ed7f16088a93ae9d = $c72786cec0c8c94d$export$392a0c6a82ab0e50((0, $klufr.messages).loginAgain);
const $c72786cec0c8c94d$export$3ab158df56460d1c = $c72786cec0c8c94d$export$392a0c6a82ab0e50((0, $klufr.messages).differentText);































const $c72786cec0c8c94d$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("kjBj8")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("1IJbL")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("4mARe")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("5gF4p")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("6jlVo")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("bD3T5")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("8fvAi")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("heKDP")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("lhnWB")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("kSbcO")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("k5hmg")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("lGnQw")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("aKDbg")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("2E4V8")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("ddP4M")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("fbCMA")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("1PZnF")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("9v7dI")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("iemIE")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("asBWP")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("lIxb2")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("bXQn8")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("eaCR5")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("9v8Hr")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("9cvSB")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("ahG1n")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("bTwFz")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("bmSFC")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("dc0kZ")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("bFKpZ")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $c72786cec0c8c94d$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("5gF4p")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("klufr", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2ef0deb34103adef$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2ef0deb34103adef$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    unknownUserError: {
        id: 'fabric.mention.unknow.user.error',
        defaultMessage: 'Unknown user {userId}',
        description: 'Mention user name could not be found or look up failed'
    },
    noAccessWarning: {
        id: 'fabric.mention.noAccess.warning',
        defaultMessage: "{name} won't be notified as they have no access",
        description: "Warning message to show that the mentioned user won't be notified"
    },
    noAccessLabel: {
        id: 'fabric.mention.noAccess.label',
        defaultMessage: 'No access',
        description: 'Label for no access icon'
    },
    defaultHeadline: {
        id: 'fabric.mention.error.defaultHeadline',
        defaultMessage: 'Something went wrong',
        description: 'Error message shown when there is an error communicating with backend'
    },
    defaultAdvisedAction: {
        id: 'fabric.mention.error.defaultAction',
        defaultMessage: 'Try again in a few seconds',
        description: 'Default advised action when an error occurs'
    },
    loginAgain: {
        id: 'fabric.mention.error.loginAgain',
        defaultMessage: 'Try logging out then in again',
        description: 'Login again message when there is an authentication error occurs'
    },
    differentText: {
        id: 'fabric.mention.error.differentText',
        defaultMessage: 'Try entering different text',
        description: 'Enter different text message when a forbidden error occurs'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.mentions.team.member.count',
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.mentions.team.member.count.including.you',
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.mentions.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.mentions.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    xProductMentionDescription: {
        id: 'fabric.elements.mentions.xproduct.mention.description',
        defaultMessage: 'Needs access to Confluence',
        description: 'Description for a x-product mention item in the mention list in Confluence'
    }
});

});

parcelRegister("kjBj8", function(module, exports) {

let $eca2858669ef985f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eca2858669ef985f$var$load("1lDno").then(()=>parcelRequire('1Jx70'));

});

parcelRegister("1IJbL", function(module, exports) {

let $140cf4108dc4d6f8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $140cf4108dc4d6f8$var$load("9kfsf").then(()=>parcelRequire('TgE8a'));

});

parcelRegister("4mARe", function(module, exports) {

let $32d5cea55ef761b0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $32d5cea55ef761b0$var$load("7VxjU").then(()=>parcelRequire('2gmCY'));

});

parcelRegister("5gF4p", function(module, exports) {

let $3d5e4e0895e40cc6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3d5e4e0895e40cc6$var$load("lFwfY").then(()=>parcelRequire('700d3'));

});

parcelRegister("6jlVo", function(module, exports) {

let $49858631a9fd4448$var$load = (parcelRequire("28QjX"))(4);
module.exports = $49858631a9fd4448$var$load("6niPY").then(()=>parcelRequire('jelzh'));

});

parcelRegister("bD3T5", function(module, exports) {

let $87765a33a1bbdbae$var$load = (parcelRequire("28QjX"))(4);
module.exports = $87765a33a1bbdbae$var$load("9xLSb").then(()=>parcelRequire('cdpKo'));

});

parcelRegister("8fvAi", function(module, exports) {

let $601839715a3ebfad$var$load = (parcelRequire("28QjX"))(4);
module.exports = $601839715a3ebfad$var$load("6gEiD").then(()=>parcelRequire('aNoYI'));

});

parcelRegister("heKDP", function(module, exports) {

let $c8c7ec823cb5487a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c8c7ec823cb5487a$var$load("cc9Sw").then(()=>parcelRequire('6r3eq'));

});

parcelRegister("lhnWB", function(module, exports) {

let $f7ddc24d360f9b23$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f7ddc24d360f9b23$var$load("bCfei").then(()=>parcelRequire('cpeKP'));

});

parcelRegister("kSbcO", function(module, exports) {

let $f3218afef4ce1418$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f3218afef4ce1418$var$load("721i7").then(()=>parcelRequire('g76iG'));

});

parcelRegister("k5hmg", function(module, exports) {

let $e9f1bd3f8c034ec0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e9f1bd3f8c034ec0$var$load("fm1Fn").then(()=>parcelRequire('5s8Hd'));

});

parcelRegister("lGnQw", function(module, exports) {

let $fc900493d3944d9b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc900493d3944d9b$var$load("e8civ").then(()=>parcelRequire('iCM8K'));

});

parcelRegister("aKDbg", function(module, exports) {

let $7d3c97b5107a3c36$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7d3c97b5107a3c36$var$load("54fgZ").then(()=>parcelRequire('hyMs9'));

});

parcelRegister("2E4V8", function(module, exports) {

let $1ed32251b27e6ab6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1ed32251b27e6ab6$var$load("inMW1").then(()=>parcelRequire('lqFfZ'));

});

parcelRegister("ddP4M", function(module, exports) {

let $9a041be9fc8cb41a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9a041be9fc8cb41a$var$load("iHR24").then(()=>parcelRequire('5Y1MC'));

});

parcelRegister("fbCMA", function(module, exports) {

let $b0e5f7893d521e63$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b0e5f7893d521e63$var$load("hEuBm").then(()=>parcelRequire('79NFk'));

});

parcelRegister("1PZnF", function(module, exports) {

let $156a2acfe24463af$var$load = (parcelRequire("28QjX"))(4);
module.exports = $156a2acfe24463af$var$load("acVY4").then(()=>parcelRequire('4p9lZ'));

});

parcelRegister("9v7dI", function(module, exports) {

let $6eac9c1932d8e1a1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6eac9c1932d8e1a1$var$load("31CCu").then(()=>parcelRequire('6cyyB'));

});

parcelRegister("iemIE", function(module, exports) {

let $d45b285fe9c35df9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d45b285fe9c35df9$var$load("04a1m").then(()=>parcelRequire('cyy85'));

});

parcelRegister("asBWP", function(module, exports) {

let $01f720d913532ab8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $01f720d913532ab8$var$load("cd4wS").then(()=>parcelRequire('RS2wE'));

});

parcelRegister("lIxb2", function(module, exports) {

let $fcf7714d822e2344$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fcf7714d822e2344$var$load("g8MHs").then(()=>parcelRequire('9bnl0'));

});

parcelRegister("bXQn8", function(module, exports) {

let $8b5dd4637f2daab8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8b5dd4637f2daab8$var$load("fuMFl").then(()=>parcelRequire('4vWem'));

});

parcelRegister("eaCR5", function(module, exports) {

let $a51023b83d3f60fa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a51023b83d3f60fa$var$load("9TBJu").then(()=>parcelRequire('4PLuQ'));

});

parcelRegister("9v8Hr", function(module, exports) {

let $6eadc1dbfa9113b5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6eadc1dbfa9113b5$var$load("bGDi2").then(()=>parcelRequire('grMo4'));

});

parcelRegister("9cvSB", function(module, exports) {

let $6b2df6aa6c1bab82$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6b2df6aa6c1bab82$var$load("8b51L").then(()=>parcelRequire('dABKK'));

});

parcelRegister("ahG1n", function(module, exports) {

let $77cc1676c9e1f6ff$var$load = (parcelRequire("28QjX"))(4);
module.exports = $77cc1676c9e1f6ff$var$load("iCRnm").then(()=>parcelRequire('792ZK'));

});

parcelRegister("bTwFz", function(module, exports) {

let $8a8e2c41346f58de$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8a8e2c41346f58de$var$load("c764A").then(()=>parcelRequire('ePCig'));

});

parcelRegister("bmSFC", function(module, exports) {

let $846c282ef236e241$var$load = (parcelRequire("28QjX"))(4);
module.exports = $846c282ef236e241$var$load("hVgAv").then(()=>parcelRequire('cr9Z3'));

});

parcelRegister("dc0kZ", function(module, exports) {

let $99aca862faaf2543$var$load = (parcelRequire("28QjX"))(4);
module.exports = $99aca862faaf2543$var$load("Xr1bk").then(()=>parcelRequire('eQs1M'));

});

parcelRegister("bFKpZ", function(module, exports) {

let $87f787b615ba1580$var$load = (parcelRequire("28QjX"))(4);
module.exports = $87f787b615ba1580$var$load("3jnPT").then(()=>parcelRequire('3Vms4'));

});



parcelRegister("jRQ22", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf6ad261f548dbef$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-html-button */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $bJ5oI = parcelRequire("bJ5oI");

var $5uXOq = parcelRequire("5uXOq");
const $bf6ad261f548dbef$var$mentionStyle = {
    [(0, $bJ5oI.MentionType).SELF]: {
        background: `var(--ds-background-brand-bold, ${(0, $a7f8c6b391092279$export$b3de0ae08da2ce64)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-inverse, ${(0, $a7f8c6b391092279$export$9fdfb749e33cdf97)})`,
        hoveredBackground: `var(--ds-background-brand-bold-hovered, ${(0, $a7f8c6b391092279$export$b3de0ae08da2ce64)})`,
        pressedBackground: `var(--ds-background-brand-bold-pressed, ${(0, $a7f8c6b391092279$export$b3de0ae08da2ce64)})`
    },
    [(0, $bJ5oI.MentionType).RESTRICTED]: {
        background: 'transparent',
        borderColor: `var(--ds-border-bold, ${(0, $a7f8c6b391092279$export$c39c0fe0f26207ae)})`,
        text: `var(--ds-text, ${(0, $a7f8c6b391092279$export$c39c0fe0f26207ae)})`,
        hoveredBackground: 'transparent',
        pressedBackground: 'transparent'
    },
    [(0, $bJ5oI.MentionType).DEFAULT]: {
        background: `var(--ds-background-neutral, ${(0, $a7f8c6b391092279$export$920c0d5c49070351)})`,
        borderColor: 'transparent',
        text: `var(--ds-text-subtle, ${(0, $a7f8c6b391092279$export$c39c0fe0f26207ae)})`,
        hoveredBackground: `var(--ds-background-neutral-hovered, ${(0, $a7f8c6b391092279$export$920c0d5c49070351)})`,
        pressedBackground: `var(--ds-background-neutral-pressed, ${(0, $a7f8c6b391092279$export$920c0d5c49070351)})`
    }
};
const $bf6ad261f548dbef$var$getStyle = ({ mentionType: mentionType }, property)=>{
    const obj = $bf6ad261f548dbef$var$mentionStyle[mentionType][property];
    return typeof obj === 'string' ? obj : obj;
};
const $bf6ad261f548dbef$var$PrimitiveMention = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ mentionType: mentionType, ...other }, ref)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $f8Sb3.css)("display:inline;border:1px solid ", $bf6ad261f548dbef$var$getStyle({
            mentionType: mentionType
        }, 'borderColor'), ";background:", $bf6ad261f548dbef$var$getStyle({
            mentionType: mentionType
        }, 'background'), ";color:", $bf6ad261f548dbef$var$getStyle({
            mentionType: mentionType
        }, 'text'), ";border-radius:20px;cursor:pointer;padding:0 0.3em 2px 0.23em;line-height:1.714;font-size:1em;font-weight:var(--ds-font-weight-regular, 400);word-break:break-word;&:hover{background:", $bf6ad261f548dbef$var$getStyle({
            mentionType: mentionType
        }, 'hoveredBackground'), ";}&:active{background:", $bf6ad261f548dbef$var$getStyle({
            mentionType: mentionType
        }, 'pressedBackground'), ";}"),
        ...other
    });
});
var $bf6ad261f548dbef$export$2e2bcd8739ae039 = $bf6ad261f548dbef$var$PrimitiveMention;

});
parcelRegister("bJ5oI", function(module, exports) {

$parcel$export(module.exports, "MentionType", () => $0a90277a57f2fb6e$export$2102863a3c660c6b);
$parcel$export(module.exports, "UserAccessLevel", () => $0a90277a57f2fb6e$export$81124e6148ca5db0);
$parcel$export(module.exports, "UserType", () => $0a90277a57f2fb6e$export$8436e53e45ffe15b);
$parcel$export(module.exports, "SliNames", () => $0a90277a57f2fb6e$export$7afb0727c7d7e8af);
$parcel$export(module.exports, "ComponentNames", () => $0a90277a57f2fb6e$export$5c42d9dea6d035c1);
$parcel$export(module.exports, "Actions", () => $0a90277a57f2fb6e$export$b52183d5cfb26dc9);
$parcel$export(module.exports, "MentionNameStatus", () => $0a90277a57f2fb6e$export$b8fa67dc54502853);
$parcel$export(module.exports, "isRestricted", () => $0a90277a57f2fb6e$export$dbaa15dc1820b89a);
$parcel$export(module.exports, "isSpecialMention", () => $0a90277a57f2fb6e$export$37b8dcac6198c514);
$parcel$export(module.exports, "isAppMention", () => $0a90277a57f2fb6e$export$eb590c844d13454c);
$parcel$export(module.exports, "isTeamMention", () => $0a90277a57f2fb6e$export$803b1379348dbfd5);
$parcel$export(module.exports, "isSpecialMentionText", () => $0a90277a57f2fb6e$export$d13d4f976b36a397);
$parcel$export(module.exports, "isPromise", () => $0a90277a57f2fb6e$export$4369c812aac99591);
var $0a90277a57f2fb6e$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    return MentionType;
}({});
var $0a90277a57f2fb6e$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $0a90277a57f2fb6e$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $0a90277a57f2fb6e$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $0a90277a57f2fb6e$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $0a90277a57f2fb6e$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $0a90277a57f2fb6e$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
function $0a90277a57f2fb6e$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $0a90277a57f2fb6e$export$81124e6148ca5db0[0];
}
function $0a90277a57f2fb6e$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $0a90277a57f2fb6e$export$8436e53e45ffe15b[1];
}
function $0a90277a57f2fb6e$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $0a90277a57f2fb6e$export$8436e53e45ffe15b[2];
}
function $0a90277a57f2fb6e$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $0a90277a57f2fb6e$export$8436e53e45ffe15b[3];
}
function $0a90277a57f2fb6e$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $0a90277a57f2fb6e$export$4369c812aac99591 = (p)=>!!(p && p.then);

});


parcelRegister("5FAiL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6da0c2006def87d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $c6da0c2006def87d$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("7qvc7")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $c6da0c2006def87d$export$2e2bcd8739ae039 = $c6da0c2006def87d$var$AsyncNoAccessTooltip;

});
parcelRegister("7qvc7", function(module, exports) {

let $568328a9452614b0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $568328a9452614b0$var$load("f9Wke").then(()=>parcelRequire('fQcyw'));

});


parcelRegister("1PMrW", function(module, exports) {

$parcel$export(module.exports, "SLI_EVENT_TYPE", () => $4148df2c2c748762$export$245097525aef1262);
$parcel$export(module.exports, "SMART_EVENT_TYPE", () => $4148df2c2c748762$export$c724588856bbfbcf);
$parcel$export(module.exports, "fireAnalyticsMentionEvent", () => $4148df2c2c748762$export$44902bc7b3f0b09f);
$parcel$export(module.exports, "fireAnalyticsMentionHydrationEvent", () => $4148df2c2c748762$export$91b2fa6a0fe06408);



var $bJ5oI = parcelRequire("bJ5oI");
const $4148df2c2c748762$var$packageName = "platform-pkg";
const $4148df2c2c748762$var$packageVersion = "0.0.0-use.local";
const $4148df2c2c748762$export$245097525aef1262 = 'sli';
const $4148df2c2c748762$export$c724588856bbfbcf = 'smart';
const $4148df2c2c748762$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $bJ5oI.ComponentNames).TYPEAHEAD,
                attributes: {
                    packageName: $4148df2c2c748762$var$packageName,
                    packageVersion: $4148df2c2c748762$var$packageVersion,
                    componentName: (0, $bJ5oI.ComponentNames).MENTION,
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $4e2819b72987a07d$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $b1a4d4606c309199$export$d821aa4c8afb384e));
        }
    };
const $4148df2c2c748762$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $4e2819b72987a07d$export$a1562d08625f5d7e),
            attributes: {
                packageName: $4148df2c2c748762$var$packageName,
                packageVersion: $4148df2c2c748762$var$packageVersion,
                componentName: (0, $bJ5oI.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $bJ5oI.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $b1a4d4606c309199$export$d821aa4c8afb384e));
        return event;
    };
const $4148df2c2c748762$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $4148df2c2c748762$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $b1a4d4606c309199$export$d821aa4c8afb384e));
        }
    };
const $4148df2c2c748762$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
        attributes: {
            packageName: $4148df2c2c748762$var$packageName,
            packageVersion: $4148df2c2c748762$var$packageVersion,
            componentName: (0, $bJ5oI.ComponentNames).MENTION,
            ...attributes
        }
    };
    return eventPayload;
};
const $4148df2c2c748762$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $bJ5oI.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $4148df2c2c748762$var$packageName,
                    packageVersion: $4148df2c2c748762$var$packageVersion,
                    componentName: (0, $bJ5oI.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $4e2819b72987a07d$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $b1a4d4606c309199$export$d821aa4c8afb384e));
        }
    };
// OLD Analytics
const $4148df2c2c748762$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $4148df2c2c748762$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$4148df2c2c748762$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $bJ5oI.isSpecialMentionText)(text)
        });
    };

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $4e2819b72987a07d$export$a1562d08625f5d7e = 'ui';
const $4e2819b72987a07d$export$947dac6c72b26f81 = 'track';
const $4e2819b72987a07d$export$f1d537d508d2945a = 'screen';
const $4e2819b72987a07d$export$12346a674644c156 = 'operational';
const $4e2819b72987a07d$export$b055de0e665cb20c = 'unknown';

const $b1a4d4606c309199$export$d821aa4c8afb384e = 'fabric-elements';


parcelRegister("g5i8Y", function(module, exports) {

$parcel$export(module.exports, "mentionRenderedUfoExperience", () => $2395fa272708d005$export$1d011e4240507c78);
$parcel$export(module.exports, "UfoErrorBoundary", () => $2395fa272708d005$export$5ef1c2550074a375);

var $5uXOq = parcelRequire("5uXOq");

var $766ff = parcelRequire("766ff");
var $2DPlK = parcelRequire("2DPlK");
const $2395fa272708d005$export$1d011e4240507c78 = new (0, $766ff.ConcurrentExperience)('mention-rendered', {
    platform: {
        component: 'mention'
    },
    type: (0, $2DPlK.ExperienceTypes).Load,
    performanceType: (0, $2DPlK.ExperiencePerformanceTypes).PageSegmentLoad
});
class $2395fa272708d005$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch() {
        $2395fa272708d005$export$1d011e4240507c78.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}

});


parcelRegister("awbOn", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e99cec1c60a950e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bngFq = parcelRequire("bngFq");

var $lEwUf = parcelRequire("lEwUf");
var $g9EwJ = parcelRequire("g9EwJ");

var $fHpHg = parcelRequire("fHpHg");

var $vCqQa = parcelRequire("vCqQa");

var $b4a3S = parcelRequire("b4a3S");

var $EHfmh = parcelRequire("EHfmh");

var $3JUaA = parcelRequire("3JUaA");

var $2ZCVH = parcelRequire("2ZCVH");

var $jQ0hK = parcelRequire("jQ0hK");


var $1WoQW = parcelRequire("1WoQW");

var $cJhcW = parcelRequire("cJhcW");

var $ee06t = parcelRequire("ee06t");
function $0e99cec1c60a950e$var$ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, viewingUserId: viewingUserId, trigger: trigger, product: product, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, addFlag: addFlag }) {
    if (isAgent && (0, $fHpHg.fg)('enable_agent_profile_card')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1WoQW.AgentProfileCardResourced), {
        accountId: userId,
        cloudId: cloudId,
        resourceClient: resourceClient,
        viewingUserId: viewingUserId,
        trigger: trigger,
        product: product,
        onChatClick: agentActions?.onChatClick,
        onConversationStartersClick: agentActions?.onConversationStartersClick,
        addFlag: addFlag
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cJhcW.ProfileCardLazy), {
            ...profilecardProps,
            actions: profileCardAction,
            hasError: hasError,
            errorType: errorType,
            withoutElevation: true
        })
    });
}
function $0e99cec1c60a950e$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions, ariaHideProfileTrigger: ariaHideProfileTrigger = false, isVisible: propsIsVisible }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isMounted = (0, $5uXOq.useRef)(false);
    const showDelay = trigger === 'click' || propsIsVisible && (0, $fHpHg.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $4f9eb78cf9cb8ede$export$5b956b542f1bc1b3);
    const hideDelay = trigger === 'click' || propsIsVisible && (0, $fHpHg.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $4f9eb78cf9cb8ede$export$89a9f35a94d7f196);
    const showTimer = (0, $5uXOq.useRef)(0);
    const hideTimer = (0, $5uXOq.useRef)(0);
    const [visible, setVisible] = (0, $5uXOq.useState)(false);
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(undefined);
    const [hasError, setHasError] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [data, setData] = (0, $5uXOq.useState)(null);
    const [reportingLinesData, setReportingLinesData] = (0, $5uXOq.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $5uXOq.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $5uXOq.useState)(undefined);
    const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $5uXOq.useState)(false);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $5uXOq.useState)(false);
    const triggerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
        // Don't fire any analytics if the component is unmounted
        if (!isMounted.current) return;
        (0, $jQ0hK.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const hideProfilecard = (0, $5uXOq.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    const handleKeyboardClose = (0, $5uXOq.useCallback)((event)=>{
        if (event.key && event.key !== 'Escape') return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    const handleClientSuccess = (0, $5uXOq.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData);
        setTeamCentralBaseUrl(teamCentralBaseUrl);
        setShouldShowGiveKudos(shouldShowGiveKudos);
    }, [
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    const handleClientError = (0, $5uXOq.useCallback)((err)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        setHasError,
        setIsLoading,
        setError
    ]);
    const clientFetchProfile = (0, $5uXOq.useCallback)(async ()=>{
        if (isLoading === true) // don't fetch data when fetching is in process
        return;
        setIsLoading(true);
        setHasError(false);
        setError(null);
        setData(null);
        try {
            const requests = Promise.all([
                resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                resourceClient.getReportingLines(userId),
                resourceClient.shouldShowGiveKudos(),
                resourceClient.getTeamCentralBaseUrl({
                    withOrgContext: true,
                    withSiteContext: true
                })
            ]);
            const responses = await requests;
            handleClientSuccess(...responses);
        } catch (err) {
            handleClientError(err);
        }
    }, [
        cloudId,
        fireAnalytics,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    const showProfilecard = (0, $5uXOq.useCallback)(()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
        if (!visible) fireAnalytics((0, $jQ0hK.cardTriggered)('user', 'click'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
        showProfilecard();
        if (!visible) fireAnalytics((0, $jQ0hK.cardTriggered)('user', 'hover'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onKeyPress = (0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) fireAnalytics((0, $jQ0hK.cardTriggered)('user', 'click'));
        }
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $fHpHg.fg)('fix_profilecard_trigger_isvisible')) return;
        // If the prop isVisible is not defined, we don't want to do anything
        if (propsIsVisible === undefined) return;
        // If the prop isVisible is defined, we want to show or hide the profile card based on the value
        if (propsIsVisible) showProfilecard();
        else hideProfilecard();
    }, [
        hideProfilecard,
        propsIsVisible,
        showProfilecard
    ]);
    const containerListeners = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    const filterActions = (0, $5uXOq.useCallback)(()=>{
        return (0, $EHfmh.default)(actions, data);
    }, [
        actions,
        data
    ]);
    const openKudosDrawer = ()=>{
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    const closeKudosDrawer = ()=>{
        setKudosDrawerOpen(false);
    };
    const showLoading = isLoading === true || isLoading === undefined;
    const wrapperProps = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {}, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    const profilecardProps = {
        userId: userId,
        fullName: prepopulatedData?.fullName,
        isCurrentUser: userId === viewingUserId,
        clientFetchProfile: clientFetchProfile,
        ...data,
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $vCqQa.default), {
                isOpen: !!visible,
                onClose: (event)=>{
                    hideProfilecard();
                    handleKeyboardClose(event);
                },
                placement: position,
                offset: offset ?? [
                    0,
                    8
                ],
                content: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        ...wrapperProps,
                        children: showLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)($0e99cec1c60a950e$var$LoadingView, {
                            fireAnalytics: fireAnalytics
                        }) : visible && /*#__PURE__*/ (0, $2OMIu.jsx)($0e99cec1c60a950e$var$ProfileCardContent, {
                            profilecardProps: profilecardProps,
                            isAgent: !!data?.isAgent,
                            userId: userId,
                            cloudId: cloudId,
                            resourceClient: resourceClient,
                            viewingUserId: viewingUserId,
                            trigger: trigger,
                            product: product,
                            profileCardAction: filterActions(),
                            errorType: error,
                            hasError: hasError,
                            agentActions: agentActions,
                            addFlag: addFlag
                        })
                    }),
                trigger: (triggerProps)=>{
                    const { ref: callbackRef, ...innerProps } = triggerProps;
                    const ref = (element)=>{
                        triggerRef.current = element;
                        if (typeof callbackRef === 'function') callbackRef(element);
                    };
                    const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
                    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        ...disabledAriaAttributes ? restInnerProps : triggerProps,
                        ...containerListeners,
                        ref: ref,
                        "data-testid": testId,
                        ...!ariaHideProfileTrigger && {
                            'aria-labelledby': ariaLabelledBy
                        },
                        ...disabledAriaAttributes ? {} : {
                            role: 'button',
                            //  aria-hidden cannot contain focusable elements: https://dequeuniversity.com/rules/axe/3.5/aria-hidden-focus
                            tabIndex: ariaHideProfileTrigger ? -1 : 0,
                            'aria-label': ariaHideProfileTrigger ? undefined : (0, $3JUaA.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                        },
                        ...ariaHideProfileTrigger && {
                            'aria-hidden': 'true'
                        },
                        children: children
                    });
                },
                zIndex: (0, $b4a3S.layers).modal(),
                shouldUseCaptureOnOutsideClick: true,
                autoFocus: autoFocus ?? trigger === 'click',
                // This feature gate is currently enabled only for Jira_Web to avoid UI issues in Confluence_Web.
                shouldRenderToParent: (0, $fHpHg.fg)('enable_appropriate_reading_order_in_profile_card')
            }),
            shouldShowGiveKudos && teamCentralBaseUrl && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lEwUf.GiveKudosLauncherLazy), {
                    isOpen: kudosDrawerOpen,
                    recipient: {
                        type: (0, $g9EwJ.KudosType).INDIVIDUAL,
                        recipientId: userId
                    },
                    analyticsSource: "profile-card",
                    teamCentralBaseUrl: teamCentralBaseUrl,
                    cloudId: cloudId,
                    addFlag: addFlag,
                    onClose: closeKudosDrawer
                })
            })
        ]
    });
}
const $0e99cec1c60a950e$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.CardWrapper), {
        testId: "profilecard.profilecardtrigger.loading",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ee06t.default), {
            fireAnalytics: fireAnalytics
        })
    });

});
parcelRegister("lEwUf", function(module, exports) {

$parcel$export(module.exports, "GiveKudosLauncherLazy", () => $ed488193f6568e2f$export$93fe397a02fe8b76);

var $5uXOq = parcelRequire("5uXOq");

const $ed488193f6568e2f$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("f3bwH")));

});
parcelRegister("f3bwH", function(module, exports) {

let $af5013bc783b21ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $af5013bc783b21ca$var$load("cM9em"),
    $af5013bc783b21ca$var$load("fr9NE"),
    $af5013bc783b21ca$var$load("h2MrD"),
    $af5013bc783b21ca$var$load("bYT2S"),
    $af5013bc783b21ca$var$load("joDi7")
]).then(()=>parcelRequire('63Sms'));

});


parcelRegister("g9EwJ", function(module, exports) {

$parcel$export(module.exports, "KudosType", () => $130aaec98a22129d$export$4fa2020056771264);
$parcel$export(module.exports, "FlagEventType", () => $130aaec98a22129d$export$d21f9befaa2961a);
$parcel$export(module.exports, "isFlagEventTypeValue", () => $130aaec98a22129d$export$7a1fc1a1b0477464);
var $130aaec98a22129d$export$4fa2020056771264 = /*#__PURE__*/ function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
    return KudosType;
}({});
var $130aaec98a22129d$export$d21f9befaa2961a = /*#__PURE__*/ function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["KUDOS_FAILED"] = "kudos-failed";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
    return FlagEventType;
}({});
const $130aaec98a22129d$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($130aaec98a22129d$export$d21f9befaa2961a).includes(value);
};

});

parcelRegister("EHfmh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d9c38e0f7cf9132$export$2e2bcd8739ae039);
const $4d9c38e0f7cf9132$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $4d9c38e0f7cf9132$export$2e2bcd8739ae039 = $4d9c38e0f7cf9132$var$filterActions;

});

parcelRegister("3JUaA", function(module, exports) {

$parcel$export(module.exports, "default", () => $517aa9ed7fa78ed1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $517aa9ed7fa78ed1$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($517aa9ed7fa78ed1$var$messages.label, {
        fullName: fullName
    }) : formatMessage($517aa9ed7fa78ed1$var$messages.fallbackLabel);
};
const $517aa9ed7fa78ed1$var$messages = (0, $7VHMR.defineMessages)({
    fallbackLabel: {
        id: 'profilecard.user.trigger.fallback-aria-label',
        defaultMessage: 'More information about this user',
        description: 'Label for profile card trigger when we do not have user name'
    },
    label: {
        id: 'profilecard.user.trigger.aria-label',
        defaultMessage: 'More information about {fullName}',
        description: 'Label for profile card trigger'
    }
});
var $517aa9ed7fa78ed1$export$2e2bcd8739ae039 = $517aa9ed7fa78ed1$var$getLabelMessage;

});

parcelRegister("2ZCVH", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $673c704994fbb1c9$export$6aa22a823032b784);
$parcel$export(module.exports, "ProfileImage", () => $673c704994fbb1c9$export$a7a74ab5cffd1455);
$parcel$export(module.exports, "ActionsFlexSpacer", () => $673c704994fbb1c9$export$d395c8d16f1e359d);
$parcel$export(module.exports, "KudosBlobAnimation", () => $673c704994fbb1c9$export$4a8a956251d4bf6f);
$parcel$export(module.exports, "AnimationWrapper", () => $673c704994fbb1c9$export$58517bb1b373a54c);
$parcel$export(module.exports, "AnimatedKudosButton", () => $673c704994fbb1c9$export$6196a3f52a6944fe);
$parcel$export(module.exports, "ActionButtonGroup", () => $673c704994fbb1c9$export$73d695ae27330056);
$parcel$export(module.exports, "OverflowActionButtonsWrapper", () => $673c704994fbb1c9$export$ff778e5b796745a6);
$parcel$export(module.exports, "CardContent", () => $673c704994fbb1c9$export$64ef9b8c11710c47);
$parcel$export(module.exports, "DetailsGroup", () => $673c704994fbb1c9$export$35cf684daac137ac);
$parcel$export(module.exports, "DisabledInfo", () => $673c704994fbb1c9$export$2062e7265a95a823);
$parcel$export(module.exports, "LozengeWrapper", () => $673c704994fbb1c9$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "CustomLozengeContainer", () => $673c704994fbb1c9$export$6ebf103500ba5a45);
$parcel$export(module.exports, "JobTitleLabel", () => $673c704994fbb1c9$export$d6c0e5f211c8d617);
$parcel$export(module.exports, "AppTitleLabel", () => $673c704994fbb1c9$export$4865ffa72a4d5f9);
$parcel$export(module.exports, "SpinnerContainer", () => $673c704994fbb1c9$export$a5e06607a5ac6158);
$parcel$export(module.exports, "CardContainer", () => $673c704994fbb1c9$export$8a23e74e5cf3ca41);
$parcel$export(module.exports, "DetailsLabel", () => $673c704994fbb1c9$export$138a08882ebf7289);
$parcel$export(module.exports, "DetailsLabelIcon", () => $673c704994fbb1c9$export$79d7d9b2f6a70c70);
$parcel$export(module.exports, "DetailsLabelText", () => $673c704994fbb1c9$export$b0ec2c767a0e0eab);
/* Card.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6tzHJ = parcelRequire("6tzHJ");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");
var $k9nuy = parcelRequire("k9nuy");


var $b4a3S = parcelRequire("b4a3S");

var $efqyt = parcelRequire("efqyt");

var $bWGt6 = parcelRequire("bWGt6");
function $673c704994fbb1c9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $673c704994fbb1c9$var$kudosButtonAnimationTransformationCompiled = null;
const $673c704994fbb1c9$var$styles = {
    cardWrapper: "_2rkoglpi _1bsb1gwv",
    profileImage: "_kqswstnw _154i1ejb _1ltv1ejb",
    actionsFlexSpacer: "_16jlkb7n _1o9zidpf _i0dl1wug",
    kudosBlobAnimationStyle: "_1e0cglyw _4t3i1w81 _1bsb1w81 _1pby1mrw _kqswstnw _154ixy5q",
    animationWrapper: "_mkrz1rip _kqswstnw _154ize3t _1ltvze3t _94n5ze3t _1xi2ze3t",
    animatedKudosButton: "_18u0u2gc",
    actionButtonGroup: "_zulp12x7 _uiztglyw _19pkpxbi _2hwxze3t _18u0ze3t _otyrze3t _y3gnusic _1bahesu3 _1e0c1txw",
    overflowActionButtonsWrapper: "_1e0c1o8l _1bsbzwfg _4t3izwfg",
    cardContent: "_1e0c1txw _2lx21bp4 _1tkebv7e",
    detailsGroup: "_1e0c1txw _2lx21bp4 _18u01epz _19bvxy5q _1bsb18pt",
    disabledInfo: "_11c81o8v _syaz1fxt _19pkutpp _2hwxze3t _18u0ze3t _otyrze3t",
    lozengeWrapper: "_19pkpxbi _1e0c1ule",
    customLozengeContainer: "_1e0c1txw _2lx2vrvc _1n261g80 _1bah1y6m _19pkutpp",
    spinnerContainer: "_4cvr1h6o _1e0c1txw _4t3i16xz _1bah1h6o _kqswh2mm",
    cardContainer: "_1reo15vq _18m915vq _kqswh2mm _12vemgnk _1lrw14bs _ca0q1ejb _19bv1ejb _u5f31ejb _n3td1ejb",
    cardContainerActiveUser: "_1itk1419",
    cardContainerDisabledUser: "_1itkkf3t",
    cardContainerWithElevation: "_2rkoglpi _16qs1cd0",
    detailsLabel: "_zulpu2gc _1e0c1txw _4cvr1h6o _1bah1y6m _19pkutpp _2hwxze3t _18u0ze3t _otyrze3t _o5721q9c",
    detailsLabelExtraTopSpace: "_19pkxy5q",
    detailsLabelIcon: "_1e0c1txw _1o9zidpf _syaz131l _1bsb7vkz _4t3i7vkz _s7n4jp4b _19pkze3t",
    detailsLabelText: "_1reo15vq _18m915vq _11c8dcr7 _1bto1l2s _syaz1fxt _19pkze3t _18u0ze3t",
    kudosBlobAnimation: "_1e0cglyw _4t3i1w81 _1bsb1w81 _1pby1mrw _kqswstnw _j7hq1q51 _tip8kb7n _5sagi11n _1itkiwwe",
    jobTitleLabel: "_19pkze3t _otyrze3t _18u0utpp _2hwxze3t",
    appTitleLabel: "_2rkoglpi _syaz1fxt _u5f312x7 _19bv12x7 _1bsb1ns9 _19pk1b66 _otyrze3t _18u0utpp _2hwxze3t"
};
const $673c704994fbb1c9$export$6aa22a823032b784 = ({ children: children, role: role, testId: testId, labelledBy: labelledBy })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.cardWrapper),
        backgroundColor: 'elevation.surface.overlay',
        role: role,
        testId: testId,
        "aria-labelledby": labelledBy,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$CardWrapperLegacy, {
        "data-testid": testId,
        role: role,
        "aria-labelledby": labelledBy,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$CardWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo19"
})("background-color:", (0, $efqyt.bgColor), ";border-radius:var(--ds-border-radius, 3px);width:360px;");
const $673c704994fbb1c9$export$a7a74ab5cffd1455 = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.profileImage),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$ProfileImageLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$ProfileImageLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo18"
})({
    name: "eukccz",
    styles: "position:absolute;top:var(--ds-space-300, 24px);left:var(--ds-space-300, 24px)"
});
const $673c704994fbb1c9$export$d395c8d16f1e359d = ()=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.actionsFlexSpacer)
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$ActionsFlexSpacerLegacy, {}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$ActionsFlexSpacerLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo17"
})({
    name: "18pny36",
    styles: "flex:1 0 auto"
}); // eslint-disable-next-line @atlaskit/design-system/no-keyframes-tagged-template-expression -- needs manual remediation
const $673c704994fbb1c9$var$kudosButtonAnimationTransformation = (0, $f8Sb3.keyframes)`
  0%   { transform: translate(-80px, -50px); }
  100% { transform: translate(90px, -70px); }
`;
const $673c704994fbb1c9$export$b08abf2f97b92ea5 = ()=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.kudosBlobAnimationStyle)
    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$KudosBlobAnimationStyleLegacy, {
        className: "kudos-blob-animation"
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $673c704994fbb1c9$var$KudosBlobAnimationStyleLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo16"
})("display:none;height:150px;width:150px;z-index:-1;position:absolute;top:", 32 / 14, "em;animation-name:", $673c704994fbb1c9$var$kudosButtonAnimationTransformation, ";animation-iteration-count:1;animation-duration:3s;background-image:radial-gradient(\n\t\tcircle,\n\t\tvar(--ds-background-information-pressed, #85B8FF) 0%,\n\t\tvar(--ds-background-discovery-pressed, #B8ACF6) 25%,\n\t\ttransparent 50%\n\t);overflow:hidden;");
const $673c704994fbb1c9$export$4a8a956251d4bf6f = ()=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.kudosBlobAnimationStyle)
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$KudosBlobAnimationLegacy, {});
const $673c704994fbb1c9$var$KudosBlobAnimationLegacy = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$export$b08abf2f97b92ea5, {});
const $673c704994fbb1c9$export$58517bb1b373a54c = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.animationWrapper),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$AnimationWrapperLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$AnimationWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo15"
})("clip-path:inset(0px 0px 0px 0px round ", (0, $b4a3S.borderRadius)(), "px);position:absolute;top:0;left:0;bottom:0;right:0;");
const $673c704994fbb1c9$export$6196a3f52a6944fe = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.animatedKudosButton),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$AnimatedKudosButtonLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$AnimatedKudosButtonLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo14"
})({
    name: "18xp5qc",
    styles: "margin-left:var(--ds-space-100, 8px);&:focus-within .kudos-blob-animation,&:focus .kudos-blob-animation,&:hover .kudos-blob-animation{display:block;}"
});
const $673c704994fbb1c9$export$73d695ae27330056 = ({ children: children, testId: testId })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        testId: testId,
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.actionButtonGroup),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$ActionButtonGroupLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$ActionButtonGroupLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo13"
})("user-select:none;margin:var(--ds-space-200, 16px) 0 0 0;text-align:right;display:flex;justify-content:flex-end;button,a{position:relative;}button,a,span{margin-left:var(--ds-space-100, 8px);&:first-child{margin-left:var(--ds-space-0, 0px);}}a,button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $a7f8c6b391092279$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
const $673c704994fbb1c9$export$ff778e5b796745a6 = ({ children: children, testId: testId })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        testId: testId,
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.overflowActionButtonsWrapper),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$OverflowActionButtonsWrapperLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$OverflowActionButtonsWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo12"
})("display:inline-block;width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);margin-left:var(--ds-space-100, 8px);button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $a7f8c6b391092279$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
const $673c704994fbb1c9$export$64ef9b8c11710c47 = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.cardContent),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$CardContentLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$CardContentLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo11"
})({
    name: "1jc6z0y",
    styles: "display:flex;flex-direction:column;min-height:136px"
});
const $673c704994fbb1c9$export$35cf684daac137ac = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.detailsGroup),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$DetailsGroupLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$DetailsGroupLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo10"
})({
    name: "c8pdei",
    styles: "display:flex;flex-direction:column;margin-left:116px;width:196px"
});
const $673c704994fbb1c9$export$2062e7265a95a823 = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.disabledInfo),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$DisabledInfoLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$DisabledInfoLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo9"
})("font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:", (0, $efqyt.labelTextColor), ";margin:var(--ds-space-150, 12px) 0 0 0;line-height:16px;");
const $673c704994fbb1c9$export$75180efdd3f4d9c2 = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.lozengeWrapper),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$LozengeWrapperLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$LozengeWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo8"
})({
    name: "m760b1",
    styles: "margin-top:var(--ds-space-200, 16px);text-transform:uppercase;display:block"
});
const $673c704994fbb1c9$export$6ebf103500ba5a45 = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.customLozengeContainer),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$CustomLozengeContainerLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$CustomLozengeContainerLegacy = /*#__PURE__*/ (0, $bWGt6.default)($673c704994fbb1c9$export$75180efdd3f4d9c2, {
    target: "e1ebb2vo7"
})({
    name: "15oqcei",
    styles: "display:flex;flex-direction:row;flex-wrap:wrap;justify-content:flex-start;margin-top:var(--ds-space-150, 12px);>*{margin-top:var(--ds-space-050, 4px);&:not(:last-child){margin-right:var(--ds-space-050, 4px);}}"
});
const $673c704994fbb1c9$export$d6c0e5f211c8d617 = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.jobTitleLabel),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
            maxLines: 1,
            color: "color.text.inverse",
            children: children
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$JobTitleLabelLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$JobTitleLabelLegacy = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e1ebb2vo6"
})("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:", (0, $efqyt.headerTextColor), ";margin:0 0 var(--ds-space-150, 12px) 0;");
const $673c704994fbb1c9$export$4865ffa72a4d5f9 = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.appTitleLabel),
        backgroundColor: "color.background.neutral",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
            color: "color.text",
            size: "UNSAFE_small",
            weight: "bold",
            children: children
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$AppTitleLabelLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$AppTitleLabelLegacy = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e1ebb2vo5"
})("background:", (0, $efqyt.appLabelBgColor), ";color:", (0, $efqyt.appLabelTextColor), ";border-radius:", (0, $b4a3S.borderRadius)(), ";padding:0 var(--ds-space-075, 6px);width:fit-content;font-weight:var(--ds-font-weight-bold, 700);text-transform:uppercase;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);margin:var(--ds-space-050, 4px) 0 var(--ds-space-150, 12px) 0;");
const $673c704994fbb1c9$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        testId: testId,
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.spinnerContainer),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$SpinnerContainerLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$SpinnerContainerLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo4"
})({
    name: "1e8m6rx",
    styles: "align-items:center;display:flex;height:96px;justify-content:center;position:relative"
});
const $673c704994fbb1c9$export$8a23e74e5cf3ca41 = ({ children: children, isDisabledUser: isDisabledUser, withoutElevation: withoutElevation })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.cardContainer, isDisabledUser ? $673c704994fbb1c9$var$styles.cardContainerDisabledUser : $673c704994fbb1c9$var$styles.cardContainerActiveUser, !withoutElevation && $673c704994fbb1c9$var$styles.cardContainerWithElevation),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$CardContainerLegacy, {
        isDisabledUser: isDisabledUser,
        withoutElevation: withoutElevation,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$CardContainerLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo3"
})("position:relative;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-image:linear-gradient(\n\t\tto bottom,\n\t\t", (props)=>props.isDisabledUser ? (0, $efqyt.headerBgColorDisabledUser) : (0, $efqyt.headerBgColor), "\n\t\t\t0%,\n\t\t", (props)=>props.isDisabledUser ? (0, $efqyt.headerBgColorDisabledUser) : (0, $efqyt.headerBgColor), " 100%\n\t);background-repeat:no-repeat;background-size:100% 96px;box-sizing:content-box;padding:var(--ds-space-300, 24px);box-shadow:", (props)=>props.withoutElevation ? '' : `${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${0, $a7f8c6b391092279$export$7d3359664e8bb0e5}, 0 0 1px ${0, $a7f8c6b391092279$export$d2d3bedfb276cac0}`})`}`, ";border-radius:", (props)=>props.withoutElevation ? '' : `${(0, $b4a3S.borderRadius)()}px`, ";overflow:hidden;");
const $673c704994fbb1c9$export$138a08882ebf7289 = ({ children: children, extraTopSpace: extraTopSpace = false })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.detailsLabel, extraTopSpace && $673c704994fbb1c9$var$styles.detailsLabelExtraTopSpace),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$DetailsLabelLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$DetailsLabelLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1ebb2vo2"
})({
    name: "vjwven",
    styles: "display:flex;align-items:center;margin:var(--ds-space-200, 16px) 0 0 0;white-space:nowrap;&+&{margin-top:var(--ds-space-025, 2px);}"
});
const $673c704994fbb1c9$export$79d7d9b2f6a70c70 = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        as: "dt",
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.detailsLabelIcon),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$DetailsLabelIconLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$DetailsLabelIconLegacy = /*#__PURE__*/ (0, $bWGt6.default)("dt", {
    target: "e1ebb2vo1"
})("display:flex;flex-shrink:0;color:", (0, $efqyt.labelIconColor), ";width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px);padding:var(--ds-space-050, 4px);vertical-align:top;svg{width:100%;height:100%;}");
const $673c704994fbb1c9$export$b0ec2c767a0e0eab = ({ children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        as: "dd",
        xcss: (0, $6tzHJ.cx)($673c704994fbb1c9$var$styles.detailsLabelText),
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($673c704994fbb1c9$var$DetailsLabelTextLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $673c704994fbb1c9$var$DetailsLabelTextLegacy = /*#__PURE__*/ (0, $bWGt6.default)("dd", {
    target: "e1ebb2vo0"
})("overflow:hidden;text-overflow:ellipsis;color:", (0, $efqyt.labelTextColor), ";font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-block:var(--ds-space-050, 4px);padding-left:var(--ds-space-050, 4px);margin-inline-start:0;margin-top:0;");

});
parcelRegister("efqyt", function(module, exports) {

$parcel$export(module.exports, "bgColor", () => $604493a31ede6ab5$export$7dcbec377a25efc6);
$parcel$export(module.exports, "headerBgColor", () => $604493a31ede6ab5$export$d3ec0459d8f4bbed);
$parcel$export(module.exports, "teamHeaderBgColor", () => $604493a31ede6ab5$export$afc7ad7e78cf1c79);
$parcel$export(module.exports, "headerBgColorDisabledUser", () => $604493a31ede6ab5$export$ef73fded6fab455c);
$parcel$export(module.exports, "headerTextColor", () => $604493a31ede6ab5$export$5c2df128da90e8de);
$parcel$export(module.exports, "appLabelBgColor", () => $604493a31ede6ab5$export$6f79b778f6280d31);
$parcel$export(module.exports, "appLabelTextColor", () => $604493a31ede6ab5$export$3db47a978b9599f9);
$parcel$export(module.exports, "labelTextColor", () => $604493a31ede6ab5$export$dd73341f2a5541fa);
$parcel$export(module.exports, "labelIconColor", () => $604493a31ede6ab5$export$5a20f73e634c37e3);
$parcel$export(module.exports, "errorIconColor", () => $604493a31ede6ab5$export$85e73a744c5d1042);
$parcel$export(module.exports, "errorTitleColor", () => $604493a31ede6ab5$export$be3c814f7ed506ed);

const $604493a31ede6ab5$export$7dcbec377a25efc6 = `var(--ds-surface-overlay, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`;
const $604493a31ede6ab5$export$d3ec0459d8f4bbed = `var(--ds-background-brand-bold, ${(0, $a7f8c6b391092279$export$a6ee3d71bc067634)})`;
const $604493a31ede6ab5$export$afc7ad7e78cf1c79 = `var(--ds-background-neutral, ${(0, $a7f8c6b391092279$export$8754fc7e6d8b3000)})`;
const $604493a31ede6ab5$export$ef73fded6fab455c = `var(--ds-background-disabled, ${(0, $a7f8c6b391092279$export$3e51e8f1440314ba)})`;
const $604493a31ede6ab5$export$5c2df128da90e8de = `var(--ds-text-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`;
const $604493a31ede6ab5$export$a882617dcf7f98a6 = `var(--ds-text, ${(0, $a7f8c6b391092279$export$7d61b15e0da132af)})`;
const $604493a31ede6ab5$export$6f79b778f6280d31 = `var(--ds-background-neutral, ${(0, $a7f8c6b391092279$export$9fdfb749e33cdf97)})`;
const $604493a31ede6ab5$export$3db47a978b9599f9 = `var(--ds-text, ${(0, $a7f8c6b391092279$export$c39c0fe0f26207ae)})`;
const $604493a31ede6ab5$export$dd73341f2a5541fa = `var(--ds-text, ${(0, $a7f8c6b391092279$export$7d61b15e0da132af)})`;
const $604493a31ede6ab5$export$5a20f73e634c37e3 = `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$c2e91cbeada39b8b)})`;
const $604493a31ede6ab5$export$85e73a744c5d1042 = `var(--ds-text-disabled, ${(0, $a7f8c6b391092279$export$7c87d337fb91a97d)})`;
const $604493a31ede6ab5$export$be3c814f7ed506ed = `var(--ds-text, ${(0, $a7f8c6b391092279$export$7d61b15e0da132af)})`;
const $604493a31ede6ab5$export$ddf766d3bfcf965c = `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$7c87d337fb91a97d)})`;

});


const $4f9eb78cf9cb8ede$export$5b956b542f1bc1b3 = 800;
const $4f9eb78cf9cb8ede$export$89a9f35a94d7f196 = 200;

parcelRegister("1WoQW", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardResourced", () => $2d94818ecf652245$export$4b013ffffcb40af8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $jQ0hK = parcelRequire("jQ0hK");

var $bD4ui = parcelRequire("bD4ui");

var $gp7t8 = parcelRequire("gp7t8");

var $lAOSH = parcelRequire("lAOSH");

var $hSaWA = parcelRequire("hSaWA");
const $2d94818ecf652245$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $5uXOq.useState)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $jQ0hK.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const creatorUserId = (0, $5uXOq.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $bD4ui.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const getCreator = (0, $5uXOq.useCallback)(async (creator_type, creator)=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                try {
                    if (!creatorUserId || !props.cloudId) return undefined;
                    const creatorInfo = await props.resourceClient.getProfile(creatorUserId, props.cloudId, fireAnalytics);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: `/people/${creatorUserId}`,
                        id: creatorUserId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    }, [
        creatorUserId,
        fireAnalytics,
        props.cloudId,
        props.resourceClient
    ]);
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileData = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireAnalytics);
            const agentCreatorInfo = await getCreator(profileData?.creator_type, profileData?.creator || undefined);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireAnalytics,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    (0, $5uXOq.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lAOSH.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gp7t8.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: ()=>{}
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hSaWA.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            isCreatedByViewingUser: creatorUserId === props.viewingUserId,
            product: props.product,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId
        })
    });
};

});
parcelRegister("bD4ui", function(module, exports) {

$parcel$export(module.exports, "getAAIDFromARI", () => $b80a0045e9a58980$export$3761e66a04602cbd);
const $b80a0045e9a58980$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $b80a0045e9a58980$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($b80a0045e9a58980$export$470b0d72e4fdc43a, '');
};

});

parcelRegister("gp7t8", function(module, exports) {

$parcel$export(module.exports, "default", () => $75dd9aaf56c3a018$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $bMFGq = parcelRequire("bMFGq");

var $hvAON = parcelRequire("hvAON");

var $4y6Pt = parcelRequire("4y6Pt");

var $fHpHg = parcelRequire("fHpHg");

var $6eFvr = parcelRequire("6eFvr");

var $97aaW = parcelRequire("97aaW");

var $jQ0hK = parcelRequire("jQ0hK");
const $75dd9aaf56c3a018$var$ErrorMessage = (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $5uXOq.useEffect)(()=>{
        fireAnalytics((0, $jQ0hK.profileCardRendered)('user', 'error', {
            hasRetry: hasRetry,
            errorType: errorReason
        }));
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $97aaW.ErrorTitle), {
            children: "The user is no longer available for the site"
        });
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $97aaW.ErrorTitle), {
            children: [
                "Oops, looks like we\u2019re having issues",
                /*#__PURE__*/ (0, $2OMIu.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6eFvr.default), {
                    color: "color.text.subtlest",
                    children: "Try again and we\u2019ll give it another shot"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $97aaW.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hvAON))), {
                label: "icon error",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4y6Pt))),
                LEGACY_size: "xlarge"
            }),
            errorContent(),
            reload && ((0, $fHpHg.fg)('ptc_migrate_buttons') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMFGq.default), {
                onClick: reload,
                children: "Try again"
            }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
                appearance: "link",
                onClick: reload,
                children: "Try again"
            }))
        ]
    });
};
var $75dd9aaf56c3a018$export$2e2bcd8739ae039 = $75dd9aaf56c3a018$var$ErrorMessage;

});
parcelRegister("97aaW", function(module, exports) {

$parcel$export(module.exports, "ErrorWrapper", () => $3e3fde7d702d1762$export$bb27b7e39840238f);
$parcel$export(module.exports, "ErrorTitle", () => $3e3fde7d702d1762$export$b065fd053267ec81);
$parcel$export(module.exports, "TeamErrorText", () => $3e3fde7d702d1762$export$90d92ccfb27352c6);
/* Error.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6tzHJ = parcelRequire("6tzHJ");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");


var $efqyt = parcelRequire("efqyt");

var $bWGt6 = parcelRequire("bWGt6");
const $3e3fde7d702d1762$var$styles = {
    errorWrapper: "_y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    errorTitle: "_11c82smr _syaz1fxt _19pku2gc",
    teamErrorText: "_syaz1wmz _19pku2gc"
};
const $3e3fde7d702d1762$export$bb27b7e39840238f = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($3e3fde7d702d1762$var$styles.errorWrapper),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($3e3fde7d702d1762$var$ErrorWrapperLegacy, {
        "data-testId": props.testId,
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3e3fde7d702d1762$var$ErrorWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1gaqn292"
})({
    textAlign: 'center',
    padding: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $efqyt.errorIconColor)
});
const $3e3fde7d702d1762$export$b065fd053267ec81 = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($3e3fde7d702d1762$var$styles.errorTitle),
        children: props.children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($3e3fde7d702d1762$var$ErrorTitleLegacy, {
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3e3fde7d702d1762$var$ErrorTitleLegacy = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e1gaqn291"
})({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $efqyt.errorTitleColor),
    margin: `${"var(--ds-space-100, 8px)"} 0`
});
const $3e3fde7d702d1762$export$90d92ccfb27352c6 = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($3e3fde7d702d1762$var$styles.teamErrorText),
        children: props.children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($3e3fde7d702d1762$var$TeamErrorTextLegacy, {
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3e3fde7d702d1762$var$TeamErrorTextLegacy = /*#__PURE__*/ (0, $bWGt6.default)("p", {
    target: "e1gaqn290"
})({
    color: `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$f563ee71e9ee74cd)})`,
    marginTop: "var(--ds-space-100, 8px)"
});

});


parcelRegister("lAOSH", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardWrapper", () => $6ee38d671b08bb58$export$2c6604b50c274e6f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");
const $6ee38d671b08bb58$var$styles = (0, $2s57o.xcss)({
    width: '360px'
});
const $6ee38d671b08bb58$export$2c6604b50c274e6f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
        xcss: $6ee38d671b08bb58$var$styles,
        children: children
    });
};

});

parcelRegister("hSaWA", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardLazy", () => $3a31370de5ff877d$export$ed0ca9c1d49ea0bf);

var $5uXOq = parcelRequire("5uXOq");

const $3a31370de5ff877d$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("hdPQS")));

});
parcelRegister("hdPQS", function(module, exports) {

let $c89bdf4194ef3e86$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c89bdf4194ef3e86$var$load("cM9em"),
    $c89bdf4194ef3e86$var$load("fr9NE"),
    $c89bdf4194ef3e86$var$load("h2MrD"),
    $c89bdf4194ef3e86$var$load("bYT2S"),
    $c89bdf4194ef3e86$var$load("2YJE7")
]).then(()=>parcelRequire('kr9eS'));

});



parcelRegister("cJhcW", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLazy", () => $becb744ba4eb9463$export$403d297463f226af);

var $5uXOq = parcelRequire("5uXOq");

const $becb744ba4eb9463$export$403d297463f226af = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("dwNoo")));

});
parcelRegister("dwNoo", function(module, exports) {

let $9d9493ce8ab3883b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $9d9493ce8ab3883b$var$load("h2MrD"),
    $9d9493ce8ab3883b$var$load("bYT2S"),
    $9d9493ce8ab3883b$var$load("cCyJh")
]).then(()=>parcelRequire('fW87Q'));

});


parcelRegister("ee06t", function(module, exports) {

$parcel$export(module.exports, "default", () => $c34453b94712f1bd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $clxo5 = parcelRequire("clxo5");

var $2ZCVH = parcelRequire("2ZCVH");

var $jQ0hK = parcelRequire("jQ0hK");
const $c34453b94712f1bd$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
    (0, $5uXOq.useEffect)(()=>{
        fireAnalytics((0, $jQ0hK.profileCardRendered)('user', 'spinner'));
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZCVH.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {})
    });
};
var $c34453b94712f1bd$export$2e2bcd8739ae039 = $c34453b94712f1bd$var$UserLoadingState;

});


parcelRegister("jxg93", function(module, exports) {

$parcel$export(module.exports, "isSystemAgent", () => $c69b710ea4d482bb$export$7c120b233d4844c6);
$parcel$export(module.exports, "isCustomerAgent", () => $c69b710ea4d482bb$export$f817e52cf2c5cc8c);
$parcel$export(module.exports, "isForgeAgent", () => $c69b710ea4d482bb$export$2149adda3d8a5807);
$parcel$export(module.exports, "isOOTBAgent", () => $c69b710ea4d482bb$export$7091e3bee2adaacb);
const $c69b710ea4d482bb$export$7c120b233d4844c6 = (agent)=>agent.creator_type === 'SYSTEM';
const $c69b710ea4d482bb$export$f817e52cf2c5cc8c = (agent)=>agent.creator_type === 'CUSTOMER';
const $c69b710ea4d482bb$export$2149adda3d8a5807 = (agent)=>agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE';
const $c69b710ea4d482bb$export$95433d0f8c6ad323 = (agent)=>agent.visibility === 'PRIVATE';
const $c69b710ea4d482bb$export$7091e3bee2adaacb = (agent)=>agent.creator_type === 'OOTB';
const $c69b710ea4d482bb$export$916e4870f74f205b = {
    ALL_AGENTS: 'all-agents',
    STARRED_AGENTS: 'starred-agents',
    MY_AGENTS: 'my-agents',
    TEMPLATES: 'templates',
    DEVELOPMENT: 'development'
};

});

parcelRegister("l1rbO", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_AGENTS_NAMED_ID_LIST", () => $8dd157617098e576$export$2d0163867590928d);
$parcel$export(module.exports, "DEFAULT_OOTB_AGENTS_NAMED_IDS", () => $8dd157617098e576$export$804d9ee5f4cc40a8);
$parcel$export(module.exports, "isCreateOrEditAgentAUPError", () => $8dd157617098e576$export$a08ace1426fa4a9e);
$parcel$export(module.exports, "isHipaaError", () => $8dd157617098e576$export$f8b1b75846492611);
const $8dd157617098e576$export$48783720d93c2d26 = {
    id: 'ai_mate_agent',
    named_id: 'ai_mate_agent',
    name: 'AI Mate',
    description: 'AI Mate',
    creator_type: 'SYSTEM',
    available_plugins: {},
    is_default: true,
    visibility: 'PUBLIC'
};
const $8dd157617098e576$export$2d0163867590928d = new Set([
    'decision_director_agent',
    'user_manual_writer_agent',
    'product_requirements_expert_agent'
]);
const $8dd157617098e576$export$804d9ee5f4cc40a8 = {
    ['confluence']: new Set([
        'decision_director_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ]),
    ['jira']: new Set([
        'rovo_expert_agent',
        'issue_organizer_agent',
        'jira_theme_analyzer_agent'
    ]),
    ['atlas']: new Set([
        'progress_tracker_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ])
};
const $8dd157617098e576$var$AGENT_AUP_ERROR_CODE = `convoai.agent.responsible-ai.failure`;
const $8dd157617098e576$var$HIPAA_ERROR_CODE = 'convoai.rest.browsing.product.has.hipaa.enabled';
const $8dd157617098e576$export$a08ace1426fa4a9e = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $8dd157617098e576$var$AGENT_AUP_ERROR_CODE;
const $8dd157617098e576$export$f8b1b75846492611 = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $8dd157617098e576$var$HIPAA_ERROR_CODE;

});

parcelRegister("kwxxt", function(module, exports) {

$parcel$export(module.exports, "useProfileClient", () => $7df8dddeaf2f053d$export$d43dc22a8337ee9f);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $juq2W = parcelRequire("juq2W");
const $7df8dddeaf2f053d$var$DIRECTORY_URL = '/gateway/api/directory/graphql';
let $7df8dddeaf2f053d$var$client;
const $7df8dddeaf2f053d$export$d43dc22a8337ee9f = ()=>{
    (0, $gKZoD.di)((0, $juq2W.default));
    const profileClient = (0, $5uXOq.useMemo)(()=>{
        if (!$7df8dddeaf2f053d$var$client) // To support di
        $7df8dddeaf2f053d$var$client = new (0, $juq2W.default)({
            url: $7df8dddeaf2f053d$var$DIRECTORY_URL,
            cacheSize: 1000,
            // 1 day
            cacheMaxAge: 86400000
        });
        return $7df8dddeaf2f053d$var$client;
    }, []);
    return profileClient;
};

});

parcelRegister("bmwD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1e2753fb9929072$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c1e2753fb9929072$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    deactivatedCreatorName: {
        id: 'rovo-chat.agent-card.deactivated-name',
        defaultMessage: '{name} (deactivated)',
        description: 'Name of the agent creator when it is deactivated'
    }
});

});


parcelRegister("6wjyA", function(module, exports) {

$parcel$export(module.exports, "useKnowledgeProductsRender", () => $103df3e3e9cfed60$export$3aa02e5f70d569cc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $8zIDr = parcelRequire("8zIDr");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $k9nuy = parcelRequire("k9nuy");

var $fPX8r = parcelRequire("fPX8r");

var $gi954 = parcelRequire("gi954");

var $eMkk6 = parcelRequire("eMkk6");
const $103df3e3e9cfed60$var$styles = {
    wrapper: "_4t3igktf",
    iconWrapper: "_2lx21bp4 _1n261q9c _4t3i1tcg _1bsb1tcg _1e0c1txw"
};
const $103df3e3e9cfed60$var$KnowledgeSourceProduct = ({ source: source, cloudUrl: cloudUrl })=>{
    const LinkOrText = cloudUrl ? (0, $8zIDr.default) : (0, $k9nuy.default);
    const label = (0, $fPX8r.formatKnowledgeSourceLabel)(source);
    const getLabelRender = ()=>{
        switch(source){
            case 'jira':
                return /*#__PURE__*/ (0, $2OMIu.jsx)(LinkOrText, {
                    href: `${cloudUrl}/jira`,
                    target: "_blank",
                    children: label
                });
            case 'confluence':
                return /*#__PURE__*/ (0, $2OMIu.jsx)(LinkOrText, {
                    href: `${cloudUrl}/wiki`,
                    target: "_blank",
                    children: label
                });
            case 'atlas':
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8zIDr.default), {
                    href: (0, $gi954.getAtlasHost)(),
                    target: "_blank",
                    children: label
                });
            default:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                    children: label
                });
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
        xcss: $103df3e3e9cfed60$var$styles.wrapper,
        alignBlock: "center",
        space: "space.075",
        children: [
            (0, $fPX8r.iconMapper)[source],
            getLabelRender()
        ]
    });
};
const $103df3e3e9cfed60$var$getIconRender = (knowledgeSource)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $103df3e3e9cfed60$var$styles.iconWrapper,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
            src: `/gateway/api/${knowledgeSource.iconUrl}`,
            role: "presentation",
            alt: knowledgeSource.source
        })
    });
};
const $103df3e3e9cfed60$var$KnowledgeSourceProductUsingBEFields = ({ knowledgeSource: knowledgeSource, cloudUrl: cloudUrl })=>{
    const LinkOrText = cloudUrl ? (0, $8zIDr.default) : (0, $k9nuy.default);
    const getLabelRender = ()=>{
        switch(knowledgeSource.source){
            case 'jira':
                return /*#__PURE__*/ (0, $2OMIu.jsx)(LinkOrText, {
                    href: `${cloudUrl}/jira`,
                    target: "_blank",
                    children: knowledgeSource.friendlyName
                });
            case 'confluence':
                return /*#__PURE__*/ (0, $2OMIu.jsx)(LinkOrText, {
                    href: `${cloudUrl}/wiki`,
                    target: "_blank",
                    children: knowledgeSource.friendlyName
                });
            case 'atlas':
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8zIDr.default), {
                    href: (0, $gi954.getAtlasHost)(),
                    target: "_blank",
                    children: knowledgeSource.friendlyName
                });
            default:
                return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $k9nuy.default), {
                    children: [
                        " ",
                        knowledgeSource.friendlyName
                    ]
                });
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
        xcss: $103df3e3e9cfed60$var$styles.wrapper,
        alignBlock: "center",
        space: "space.075",
        children: [
            $103df3e3e9cfed60$var$getIconRender(knowledgeSource),
            getLabelRender()
        ]
    });
};
const $103df3e3e9cfed60$export$581d4179e1c59739 = ({ sources: sources, knowledgeScopeEnabled: knowledgeScopeEnabled, allKnowledgeSourcesFiltered: allKnowledgeSourcesFiltered, cloudUrl: cloudUrl })=>{
    let processedSources = sources;
    const useBEKnowledgeSourceFields = (0, $fHpHg.fg)('rovo_use_be_knowledge_source_fields');
    // When knowledge scope is not enabled, BE by default will use all the available knowledge sources, including any new ones that added
    // we want to simulate the BE behavior here only on rendering layer
    if (!knowledgeScopeEnabled) processedSources = allKnowledgeSourcesFiltered;
    else // When knowledge scope is enabled, merge the filtered sources with their configurations from the backend
    if (useBEKnowledgeSourceFields) processedSources = sources.map((source)=>{
        const matchingSource = allKnowledgeSourcesFiltered.find((filteredSource)=>filteredSource.source === source.source);
        return {
            ...matchingSource,
            ...source
        };
    //Override with AgentKnowledgeSource config value
    });
    const knowledgeSourcesRender = [];
    processedSources.forEach((source)=>{
        if (!source.enabled) return null;
        // if confluence filters has any specific pages or space filter
        // we don't render the confluence product
        if (source.source === 'confluence' && (source.configuration?.parent_filter?.length || source.configuration?.space_filter?.length)) return null;
        // if jira filters has any specific project filter
        // we don't render the jira product
        if (source.source === 'jira' && source.configuration?.project_filter?.length) return null;
        if (useBEKnowledgeSourceFields) knowledgeSourcesRender.push(/*#__PURE__*/ (0, $2OMIu.jsx)($103df3e3e9cfed60$var$KnowledgeSourceProductUsingBEFields, {
            knowledgeSource: source,
            cloudUrl: cloudUrl
        }, source.source));
        else knowledgeSourcesRender.push(/*#__PURE__*/ (0, $2OMIu.jsx)($103df3e3e9cfed60$var$KnowledgeSourceProduct, {
            source: source.source,
            cloudUrl: cloudUrl
        }, source.source));
    });
    return knowledgeSourcesRender.length ? knowledgeSourcesRender : null;
};
const $103df3e3e9cfed60$export$3aa02e5f70d569cc = ({ assistanceServiceParams: assistanceServiceParams })=>{
    (0, $gKZoD.di)((0, $eMkk6.useKnowledgeConnectors));
    const { enabledKnowledgeSources: enabledKnowledgeSources } = (0, $eMkk6.useKnowledgeConnectors)({
        assistanceServiceParams: assistanceServiceParams
    });
    const allKnowledgeSourcesFiltered = (0, $5uXOq.useMemo)(()=>enabledKnowledgeSources.map(({ source: source, iconUrl: iconUrl, friendlyName: friendlyName })=>{
            const configuration = source === 'confluence' ? {
                parent_filter: [],
                space_filter: []
            } : source === 'jira' ? {
                project_filter: []
            } : undefined;
            return {
                source: source,
                configuration: configuration,
                enabled: true,
                iconUrl: iconUrl,
                friendlyName: friendlyName
            };
        }), [
        enabledKnowledgeSources
    ]);
    const getKnowledgeProductsRenderForAgent = (0, $5uXOq.useCallback)((params)=>{
        return $103df3e3e9cfed60$export$581d4179e1c59739({
            ...params,
            allKnowledgeSourcesFiltered: allKnowledgeSourcesFiltered
        });
    }, [
        allKnowledgeSourcesFiltered
    ]);
    return {
        getKnowledgeProductsRenderForAgent: getKnowledgeProductsRenderForAgent
    };
};

});
parcelRegister("fPX8r", function(module, exports) {

$parcel$export(module.exports, "formatKnowledgeSourceLabel", () => $cf8b7043764f902d$export$f32a352406d501db);
$parcel$export(module.exports, "iconMapper", () => $cf8b7043764f902d$export$c63040ce43e3b7ce);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4AQia = parcelRequire("4AQia");

var $iPUSi = parcelRequire("iPUSi");

var $jlqn0 = parcelRequire("jlqn0");

var $75hof = parcelRequire("75hof");

var $iItCF = parcelRequire("iItCF");
var $jo1Bz = parcelRequire("jo1Bz");
var $39fIG = parcelRequire("39fIG");
const $cf8b7043764f902d$export$f32a352406d501db = (source)=>source === 'atlas' ? 'Atlassian Home' : source.replace(/[_-]/g, ' ') // Replace underscores and dashes with spaces
    .split(' ').map((word)=>word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
const $cf8b7043764f902d$export$c63040ce43e3b7ce = {
    confluence: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jo1Bz.ConfluenceIcon), {
        size: "small",
        appearance: "brand"
    }),
    jira: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $39fIG.JiraIcon), {
        size: "small",
        appearance: "brand"
    }),
    atlas: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iItCF.AtlassianIcon), {
        label: "",
        size: "small",
        appearance: "brand"
    }),
    // TODO - Migrate to ADS icon/logo later - https://product-fabric.atlassian.net/browse/DSP-21174
    google_drive: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4AQia.default), {
        label: ""
    }),
    // TODO - Migrate to ADS icon/logo later - https://product-fabric.atlassian.net/browse/DSP-21174
    microsoft_sharepoint: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jlqn0.default), {
        label: ""
    }),
    // TODO - Migrate to ADS icon/logo later - https://product-fabric.atlassian.net/browse/DSP-21174
    slack: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $75hof.default), {
        label: ""
    }),
    // TODO - Migrate to ADS icon/logo later - https://product-fabric.atlassian.net/browse/DSP-21174
    loom: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iPUSi.default), {
        label: ""
    })
};

});
parcelRegister("4AQia", function(module, exports) {

$parcel$export(module.exports, "default", () => $faa72f2e31cd09b5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ltBcH = parcelRequire("ltBcH");
const $faa72f2e31cd09b5$var$GoogleDriveIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "20",
        height: "18",
        viewBox: "0 0 20 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M3.33374 17.3241L6.66677 11.5493H19.9999L16.6666 17.3241H3.33374Z",
                fill: "#3777E3"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M13.3335 11.5493H19.9999L13.3335 0H6.6665L13.3335 11.5493Z",
                fill: "#FFCF63"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M0 11.5493L3.3335 17.324L9.99985 5.77469L6.66656 0L0 11.5493Z",
                fill: "#11A861"
            })
        ]
    });
/**
 * __GoogleDriveIcon__
 */ const $faa72f2e31cd09b5$var$GoogleDriveIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ltBcH.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $faa72f2e31cd09b5$var$GoogleDriveIconGlyph
    });
var $faa72f2e31cd09b5$export$2e2bcd8739ae039 = $faa72f2e31cd09b5$var$GoogleDriveIcon;

});

parcelRegister("iPUSi", function(module, exports) {

$parcel$export(module.exports, "default", () => $90f6984d84735332$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ltBcH = parcelRequire("ltBcH");
const $90f6984d84735332$var$LoomIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "2 2 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
                clipPath: "url(#clip0_271_181644)",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    d: "M24.0115 12.9534H17.9154L23.1946 9.90666L22.1477 8.09334L16.8678 11.14L19.9151 5.86334L18.1014 4.81666L15.0534 10.092V4H12.9581V10.0927L9.91009 4.81666L8.09565 5.86334L11.1431 11.1387L5.86445 8.09334L4.81687 9.90666L10.0961 12.9534H4V15.0473H10.0955L4.81687 18.094L5.86378 19.9073L11.1437 16.8607L8.09565 22.1373L9.90943 23.184L12.9581 17.908V24H15.0534V17.7773L18.1574 23.1507L19.8585 22.1693L16.7537 16.7947L22.1463 19.9066L23.194 18.0934L17.9154 15.0466H24.0108V12.9534H24.0115ZM14.0057 16.8466C13.6317 16.8467 13.2613 16.7731 12.9158 16.6301C12.5703 16.487 12.2563 16.2773 11.9918 16.0129C11.7273 15.7486 11.5175 15.4347 11.3743 15.0893C11.2311 14.7438 11.1575 14.3736 11.1574 13.9997C11.1573 13.6257 11.2309 13.2554 11.374 12.91C11.5172 12.5646 11.7269 12.2506 11.9913 11.9862C12.2557 11.7218 12.5696 11.512 12.9152 11.3689C13.2607 11.2257 13.631 11.1521 14.0051 11.152C14.7604 11.1519 15.4848 11.4518 16.019 11.9857C16.5532 12.5197 16.8534 13.2439 16.8534 13.999C16.8535 14.7541 16.5536 15.4784 16.0195 16.0125C15.4854 16.5466 14.761 16.8466 14.0057 16.8466Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                    id: "clip0_271_181644",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(4 4)"
                    })
                })
            })
        ]
    });
/**
 * __LoomIcon__
 */ const $90f6984d84735332$var$LoomIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ltBcH.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $90f6984d84735332$var$LoomIconGlyph
    });
var $90f6984d84735332$export$2e2bcd8739ae039 = $90f6984d84735332$var$LoomIcon;

});

parcelRegister("jlqn0", function(module, exports) {

$parcel$export(module.exports, "default", () => $60ed48b6e54c2f8e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ltBcH = parcelRequire("ltBcH");
const $60ed48b6e54c2f8e$var$MicrosoftSharepointIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("mask", {
                id: "mask0_1701_19689",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "20",
                height: "20",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                    d: "M20 0H0V20H20V0Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                mask: "url(#mask0_1701_19689)",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M10.2328 11.4286C13.3153 11.4286 15.8142 8.87025 15.8142 5.71429C15.8142 2.55838 13.3153 0 10.2328 0C7.15024 0 4.65137 2.55838 4.65137 5.71429C4.65137 8.87025 7.15024 11.4286 10.2328 11.4286Z",
                        fill: "#036C70"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M14.8838 16.1906C17.7095 16.1906 20.0001 13.8453 20.0001 10.9524C20.0001 8.05957 17.7095 5.71436 14.8838 5.71436C12.0582 5.71436 9.76758 8.05957 9.76758 10.9524C9.76758 13.8453 12.0582 16.1906 14.8838 16.1906Z",
                        fill: "#1A9BA1"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M10.93 20C13.1135 20 14.8835 18.1879 14.8835 15.9524C14.8835 13.717 13.1135 11.9048 10.93 11.9048C8.74654 11.9048 6.97656 13.717 6.97656 15.9524C6.97656 18.1879 8.74654 20 10.93 20Z",
                        fill: "#37C6D0"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.1",
                        d: "M11.1628 5.15708V15.3189C11.1605 15.6721 10.9515 15.9893 10.6327 16.1237C10.531 16.1677 10.4219 16.1904 10.3117 16.1904H6.98145C6.9768 16.1094 6.9768 16.0333 6.9768 15.9523C6.97525 15.8728 6.97835 15.7933 6.9861 15.7142C7.07124 14.1921 7.98717 12.8491 9.35355 12.2428V11.3571C6.31257 10.8637 4.23802 7.93981 4.71991 4.82647C4.72326 4.80491 4.72671 4.78336 4.7303 4.76183C4.75345 4.60124 4.78607 4.44222 4.82797 4.28564H10.3117C10.781 4.28748 11.161 4.67657 11.1628 5.15708Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.2",
                        d: "M9.84662 4.76196H4.73038C4.21355 7.86969 6.25531 10.8181 9.29075 11.3472C9.38275 11.3632 9.475 11.3768 9.56762 11.3882C8.12575 12.0882 7.07503 14.0763 6.98573 15.7143C6.97798 15.7934 6.97488 15.8729 6.97642 15.9524C6.97642 16.0334 6.97642 16.1096 6.98107 16.1906C6.98946 16.3506 7.00968 16.5098 7.04153 16.6667H9.84625C10.1911 16.6643 10.5009 16.4504 10.6322 16.1238C10.6751 16.0199 10.6974 15.9082 10.6974 15.7953V5.6334C10.6956 5.15306 10.3159 4.76406 9.84662 4.76196Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.2",
                        d: "M9.84662 4.76196H4.73035C4.21361 7.87006 6.25568 10.8184 9.29149 11.3476C9.35362 11.3583 9.41587 11.3681 9.47825 11.3767C8.08287 12.1272 7.07361 14.1106 6.98616 15.7143H9.84662C10.3152 15.7107 10.6942 15.3227 10.6977 14.8429V5.6334C10.696 5.15289 10.316 4.7638 9.84662 4.76196Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        opacity: "0.2",
                        d: "M9.38134 4.76196H4.73019C4.24225 7.69606 6.03799 10.5216 8.85572 11.2534C7.78884 12.5014 7.13442 14.0628 6.986 15.7143H9.38134C9.85072 15.7126 10.2307 15.3234 10.2325 14.8429V5.6334C10.2322 5.15224 9.85134 4.76224 9.38134 4.76196Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M0.852563 4.76196H9.38C9.85087 4.76196 10.2325 5.15276 10.2325 5.63483V14.3653C10.2325 14.8473 9.85087 15.2382 9.38 15.2382H0.852563C0.3817 15.2382 0 14.8473 0 14.3653V5.63483C0 5.15276 0.3817 4.76196 0.852563 4.76196Z",
                        fill: "#04868B"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M3.80825 9.89327C3.60846 9.75752 3.44157 9.57689 3.32035 9.36514C3.20289 9.14377 3.14433 8.89464 3.15057 8.64277C3.14011 8.30177 3.25251 7.96864 3.46639 7.70702C3.69112 7.44504 3.98162 7.25104 4.30638 7.14607C4.67651 7.02134 5.06418 6.95988 5.45382 6.96417C5.96621 6.94499 6.4779 7.01834 6.96545 7.18083V8.27602C6.75361 8.14464 6.52287 8.04827 6.28172 7.99039C6.02007 7.92464 5.7516 7.89177 5.48218 7.89227C5.1981 7.88164 4.91582 7.94277 4.66034 8.07039C4.46307 8.15752 4.33516 8.35614 4.33475 8.57602C4.33395 8.70952 4.38401 8.83802 4.47429 8.93414C4.58091 9.04764 4.70705 9.13989 4.84638 9.20652C5.00142 9.28564 5.23397 9.39064 5.54406 9.52177C5.5782 9.53289 5.61147 9.54652 5.64358 9.56277C5.94877 9.68489 6.24317 9.83352 6.5236 10.007C6.73595 10.1411 6.91417 10.3249 7.0436 10.5433C7.17628 10.7908 7.2406 11.0706 7.22963 11.3528C7.24478 11.7029 7.14016 12.0474 6.93382 12.327C6.72816 12.5841 6.45319 12.7735 6.14312 12.8718C5.77844 12.9888 5.39781 13.0454 5.01569 13.0394C4.67282 13.041 4.33047 13.0124 3.99242 12.9536C3.707 12.9059 3.42845 12.822 3.16314 12.7041V11.5494C3.41675 11.7349 3.70007 11.8734 4.00033 11.9589C4.29958 12.0544 4.61066 12.1054 4.92406 12.1104C5.21412 12.1291 5.50367 12.0663 5.76127 11.9285C5.94172 11.8243 6.05147 11.6268 6.04686 11.4146C6.04806 11.2671 5.99103 11.1253 5.88872 11.0213C5.76147 10.8934 5.61415 10.7883 5.45291 10.7104C5.26686 10.6151 4.99291 10.4895 4.63105 10.3336C4.34317 10.2153 4.06755 10.0676 3.80825 9.89327Z",
                        fill: "white"
                    })
                ]
            })
        ]
    });
/**
 * __MicrosoftSharepointIcon__
 */ const $60ed48b6e54c2f8e$var$MicrosoftSharepointIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ltBcH.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $60ed48b6e54c2f8e$var$MicrosoftSharepointIconGlyph
    });
var $60ed48b6e54c2f8e$export$2e2bcd8739ae039 = $60ed48b6e54c2f8e$var$MicrosoftSharepointIcon;

});

parcelRegister("75hof", function(module, exports) {

$parcel$export(module.exports, "default", () => $726a7b953fa44fe1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ltBcH = parcelRequire("ltBcH");
const $726a7b953fa44fe1$var$SlackIconAiMateGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
                clipPath: "url(#clip0_271_181639)",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.33321 2C8.22767 2.00082 7.33294 2.89621 7.33375 3.99954C7.33294 5.10288 8.22849 5.99827 9.33403 5.99909H11.3343V4.00036C11.3351 2.89702 10.4396 2.00163 9.33321 2C9.33403 2 9.33403 2 9.33321 2V2ZM9.33321 7.33321H4.00077C2.89522 7.33402 1.99967 8.22941 2.00049 9.33275C1.99886 10.4361 2.89441 11.3315 3.99995 11.3331H9.33321C10.4388 11.3323 11.3343 10.4369 11.3335 9.33357C11.3343 8.22941 10.4388 7.33402 9.33321 7.33321V7.33321Z",
                        fill: "#36C5F0"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M21.9998 9.33275C22.0006 8.22941 21.1051 7.33402 19.9995 7.33321C18.894 7.33402 17.9984 8.22941 17.9992 9.33275V11.3331H19.9995C21.1051 11.3323 22.0006 10.4369 21.9998 9.33275ZM16.6665 9.33275V3.99954C16.6673 2.89702 15.7726 2.00163 14.667 2C13.5615 2.00082 12.6659 2.89621 12.6668 3.99954V9.33275C12.6651 10.4361 13.5607 11.3315 14.6662 11.3331C15.7718 11.3323 16.6673 10.4369 16.6665 9.33275Z",
                        fill: "#2EB67D"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M14.6665 21.9995C15.7721 21.9987 16.6677 21.1033 16.6668 19.9999C16.6677 18.8966 15.7721 18.0012 14.6665 18.0004H12.6663V19.9999C12.6654 21.1025 13.561 21.9979 14.6665 21.9995ZM14.6665 16.6654H19.9998C21.1054 16.6646 22.0009 15.7692 22.0001 14.6659C22.0018 13.5626 21.1062 12.6672 20.0006 12.6655H14.6674C13.5618 12.6663 12.6663 13.5617 12.6671 14.6651C12.6663 15.7692 13.561 16.6646 14.6665 16.6654V16.6654Z",
                        fill: "#ECB22E"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M2.00073 14.6663C1.99992 15.7696 2.89547 16.665 4.00102 16.6659C5.10657 16.665 6.00212 15.7696 6.0013 14.6663V12.6667H4.00102C2.89547 12.6676 1.99992 13.563 2.00073 14.6663ZM7.33401 14.6663V19.9995C7.33237 21.1029 8.22792 21.9983 9.33347 21.9999C10.439 21.9991 11.3346 21.1037 11.3338 20.0003V14.6679C11.3354 13.5646 10.4398 12.6692 9.33429 12.6676C8.22792 12.6676 7.33319 13.563 7.33401 14.6663C7.33401 14.6671 7.33401 14.6663 7.33401 14.6663Z",
                        fill: "#E01E5A"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("defs", {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("clipPath", {
                    id: "clip0_271_181639",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });
/**
 * __SlackIconAiMate__
 */ const $726a7b953fa44fe1$var$SlackIconAiMate = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ltBcH.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $726a7b953fa44fe1$var$SlackIconAiMateGlyph
    });
var $726a7b953fa44fe1$export$2e2bcd8739ae039 = $726a7b953fa44fe1$var$SlackIconAiMate;

});


parcelRegister("gi954", function(module, exports) {

$parcel$export(module.exports, "getAtlasHost", () => $fcd16e8995f4132c$export$5105758c0e772381);
$parcel$export(module.exports, "getAtlasURL", () => $fcd16e8995f4132c$export$bfee0f88bf621ad3);

var $aUv7N = parcelRequire("aUv7N");
const $fcd16e8995f4132c$var$ATLAS_PROD_URL = 'https://home.atlassian.com';
const $fcd16e8995f4132c$var$ATLAS_STAGING_URL = 'https://home.stg.atlassian.com';
const $fcd16e8995f4132c$export$5105758c0e772381 = ()=>{
    const host = window.location.host;
    const isStaging = host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com');
    return isStaging ? $fcd16e8995f4132c$var$ATLAS_STAGING_URL : $fcd16e8995f4132c$var$ATLAS_PROD_URL;
};
const $fcd16e8995f4132c$export$bfee0f88bf621ad3 = (siteId, path, orgId)=>{
    let argConcat = '?';
    let processedPath = path.startsWith('/') ? path : `/${path}`;
    if (processedPath.includes('?')) argConcat = '&';
    const basePath = orgId ? `${$fcd16e8995f4132c$export$5105758c0e772381()}/o/${orgId}` : $fcd16e8995f4132c$export$5105758c0e772381();
    return (0, $aUv7N.addRovoParamsToUrl)(`${basePath}${processedPath}${argConcat}cloudId=${siteId}`, {
        cloudId: siteId
    });
};

});

parcelRegister("eMkk6", function(module, exports) {

$parcel$export(module.exports, "useKnowledgeConnectors", () => $5c27ec814a6c40b2$export$88014f3d16427d4b);

var $5uXOq = parcelRequire("5uXOq");

var $7yKOM = parcelRequire("7yKOM");

var $5XeR3 = parcelRequire("5XeR3");
var $1xmyx = parcelRequire("1xmyx");
const $5c27ec814a6c40b2$export$88014f3d16427d4b = (0, $5XeR3.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, enabled: enabled = true })=>{
    const connectorsQuery = (0, $1xmyx.useQuery)({
        queryKey: [
            'getKnowledgeConnectors'
        ],
        queryFn: async ()=>{
            experienceTracker.start({
                id: (0, $7yKOM.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES,
                name: (0, $7yKOM.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES
            });
            return assistanceService.getAgentKnowledgeConfiguration();
        },
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $7yKOM.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $7yKOM.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES,
                error: error
            });
        },
        enabled: enabled
    });
    const isConnectorEnabled = (0, $5uXOq.useCallback)((type)=>{
        return connectorsQuery.data?.knowledgeSources?.some((value)=>value.source === type) ?? false;
    }, [
        connectorsQuery.data
    ]);
    const enabledKnowledgeSources = (0, $5uXOq.useMemo)(()=>{
        return connectorsQuery.data?.knowledgeSources ?? [];
    }, [
        connectorsQuery.data
    ]);
    return {
        enabledKnowledgeSources: enabledKnowledgeSources,
        isConnectorEnabled: isConnectorEnabled
    };
});

});


parcelRegister("bEYMY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e24d68bb611278f4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $fFBnu = parcelRequire("fFBnu");
var $1lfNR = parcelRequire("1lfNR");

var $hXwoh = parcelRequire("hXwoh");
function $e24d68bb611278f4$export$1064229c13822d9f(props) {
    const [{ orgId: orgId }] = (0, $1lfNR.useOrg)();
    return orgId ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hXwoh.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($e24d68bb611278f4$var$ProfileAboutTeamsSpinnerWrapper, {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fFBnu.default), {
            size: 'small'
        })
    });
}
var $e24d68bb611278f4$export$2e2bcd8739ae039 = $e24d68bb611278f4$export$1064229c13822d9f;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e24d68bb611278f4$var$ProfileAboutTeamsSpinnerWrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-17jr9k9-0"
})`display:flex;justify-content:center;align-items:center;`;

});
parcelRegister("fFBnu", function(module, exports) {

$parcel$export(module.exports, "default", () => $471e49775564920e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $clxo5 = parcelRequire("clxo5");

var $4hYYv = parcelRequire("4hYYv");
const $471e49775564920e$var$Spinner = ({ wrapperHeight: wrapperHeight, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)($4hYYv.SpinnerWrapper, {
        height: wrapperHeight,
        "data-test-selector": "spinner",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {
            ...props
        })
    });
var $471e49775564920e$export$2e2bcd8739ae039 = $471e49775564920e$var$Spinner;

});
parcelRegister("4hYYv", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $c6ce8360528989d6$export$52b4dfd89a6b3a1b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
const $c6ce8360528989d6$var$getHeight = ({ height: height })=>{
    if (typeof height === 'number') return `${height}px`;
    return height;
};
const $c6ce8360528989d6$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1umpdm7-0"
})`display:flex;justify-content:center;align-items:center;margin:${"var(--ds-space-200, 16px)"} 0;height:${$c6ce8360528989d6$var$getHeight};`;

});


parcelRegister("hXwoh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e355e885be98fb3$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $ousew = parcelRequire("ousew");

var $cNW3X = parcelRequire("cNW3X");

var $bMFGq = parcelRequire("bMFGq");

var $5E93O = parcelRequire("5E93O");

var $fHpHg = parcelRequire("fHpHg");


var $cprXC = parcelRequire("cprXC");
var $71wio = parcelRequire("71wio");
var $7wrAa = parcelRequire("7wrAa");
var $fFBnu = parcelRequire("fFBnu");
var $358cZ = parcelRequire("358cZ");
var $c5iyg = parcelRequire("c5iyg");
var $1geG0 = parcelRequire("1geG0");
var $hOFm5 = parcelRequire("hOFm5");

var $axo8J = parcelRequire("axo8J");

var $czPkq = parcelRequire("czPkq");

var $bnXIR = parcelRequire("bnXIR");

var $dqipP = parcelRequire("dqipP");

var $k5NaU = parcelRequire("k5NaU");

var $gQ2LQ = parcelRequire("gQ2LQ");
const $8e355e885be98fb3$export$4a2947f47d583741 = 10;
const $8e355e885be98fb3$export$b827413854913969 = 30;
function $8e355e885be98fb3$export$2697725d6b507e8c(props) {
    const analytics = (0, $358cZ.default)();
    const [enableInfiniteScroll, setEnableInfiniteScroll] = (0, $5uXOq.useState)(false);
    const [showLess, setShowLess] = (0, $5uXOq.useState)(true);
    const [{ hasLoaded: hasUserDataLoaded, principalUserId: currentUserId }] = (0, $1geG0.usePrincipalUser)();
    const { isLoading: isTeamSearchLoading, teams: teamSearchTeams, error: ApolloError, loadMore: loadMore, hasMore: hasMore } = (0, $axo8J.useTeamSearchQuery)({
        first: $8e355e885be98fb3$export$4a2947f47d583741 + 1,
        // +1 to make sure it has more than 10 teams
        batchSize: $8e355e885be98fb3$export$b827413854913969,
        memberIds: [
            props.userId
        ]
    });
    // don't need to trigger start event here because it's already triggered in `NeedBrowseUsersPerm`
    (0, $c5iyg.useExpTrackerStop)({
        name: (0, $hOFm5.UserExperienceNames).USER_PROFILE_USERS_TEAMS,
        error: ApolloError
    });
    const createProposedMember = (0, $5uXOq.useCallback)(()=>props.userFullName ? [
            {
                id: props.userId,
                value: props.userId,
                label: props.userFullName,
                avatarUrl: props.userAvatarUrl,
                type: 'user'
            }
        ] : [], [
        props.userAvatarUrl,
        props.userFullName,
        props.userId
    ]);
    const handleTeamItemClick = (0, $5uXOq.useCallback)((e, index)=>{
        analytics.pushUIEvent({
            source: (0, $cprXC.AnalyticsEventSource)[props.analyticsSource] || (0, $cprXC.AnalyticsEventSource).USER_PROFILE_SCREEN,
            action: (0, $cprXC.AnalyticsEventActions).CLICKED,
            actionSubject: 'teamProfileItem',
            attributes: {
                position: index
            }
        });
    }, [
        analytics,
        props.analyticsSource
    ]);
    const isCurrentUser = ()=>currentUserId === props.userId;
    // loading --> skeleton and do not render ExperienceSuccess
    // not loading + empty data + viewing others profile --> rendering nothing and ExperienceSuccess
    // not loading + has error --> rendering nothing and "useExpTrackerStop" will trigger the stop experience event.
    // not loading + has data --> render UI and ExperienceSuccess
    const hasNoData = !teamSearchTeams;
    if (hasNoData) return null;
    if (ApolloError) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bnXIR.AboutSectionTitle), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...$8e355e885be98fb3$export$defe85febe8b728c.teamSectionTitle
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)($gQ2LQ.ErrorContainer, {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)($gQ2LQ.ErrorIconWrapper, {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
                            LEGACY_size: "medium",
                            spacing: "spacious",
                            color: `var(--ds-icon-danger, ${(0, $a7f8c6b391092279$export$2010d0fb4295b346)})`,
                            label: $8e355e885be98fb3$export$defe85febe8b728c.errorStateTitle.defaultMessage
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)($gQ2LQ.ErrorMessageWrapper, {
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)($gQ2LQ.ErrorTitle, {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                    ...$8e355e885be98fb3$export$defe85febe8b728c.errorStateTitle
                                })
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)($gQ2LQ.ErrorMessage, {
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                                    ...$8e355e885be98fb3$export$defe85febe8b728c.errorStateMessage
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
    const onShowMoreButtonClick = ()=>{
        analytics.pushUIEvent({
            source: (0, $cprXC.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'showMore',
            action: (0, $cprXC.AnalyticsEventActions).CLICKED
        });
        setEnableInfiniteScroll(true);
        setShowLess(false);
    };
    const collapseTeamList = ()=>{
        if (!enableInfiniteScroll) setEnableInfiniteScroll(true);
        setShowLess(!showLess);
    };
    const teamList = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $czPkq.default), {
        loadMore: loadMore,
        hasMore: hasMore && enableInfiniteScroll,
        loader: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fFBnu.default), {}),
        isLoading: isTeamSearchLoading,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                showLess ? teamSearchTeams.slice(0, $8e355e885be98fb3$export$4a2947f47d583741).map((team, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dqipP.default), {
                        team: team,
                        isCurrentUser: isCurrentUser(),
                        index: index,
                        onClick: handleTeamItemClick
                    }, team.id)) : teamSearchTeams.map((team, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dqipP.default), {
                        team: team,
                        isCurrentUser: isCurrentUser(),
                        index: index,
                        onClick: handleTeamItemClick
                    }, team.id)),
                !enableInfiniteScroll && teamSearchTeams.length > $8e355e885be98fb3$export$4a2947f47d583741 && (hasMore || !hasMore && showLess) && /*#__PURE__*/ (0, $2OMIu.jsx)($gQ2LQ.ShowMoreButton, {
                    children: (0, $fHpHg.fg)('ptc_migrate_buttons') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMFGq.default), {
                        onClick: onShowMoreButtonClick,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...$8e355e885be98fb3$export$defe85febe8b728c.showMore
                        })
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
                        appearance: "link",
                        spacing: "none",
                        onClick: onShowMoreButtonClick,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...$8e355e885be98fb3$export$defe85febe8b728c.showMore
                        })
                    })
                }),
                enableInfiniteScroll && !hasMore && /*#__PURE__*/ (0, $2OMIu.jsx)($gQ2LQ.ShowMoreButton, {
                    children: (0, $fHpHg.fg)('ptc_migrate_buttons') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMFGq.default), {
                        onClick: collapseTeamList,
                        children: showLess ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...$8e355e885be98fb3$export$defe85febe8b728c.showMore
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...$8e355e885be98fb3$export$defe85febe8b728c.showLess
                        })
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
                        appearance: "link",
                        spacing: "none",
                        onClick: collapseTeamList,
                        children: showLess ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...$8e355e885be98fb3$export$defe85febe8b728c.showMore
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...$8e355e885be98fb3$export$defe85febe8b728c.showLess
                        })
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bnXIR.AboutSectionTitle), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...$8e355e885be98fb3$export$defe85febe8b728c.teamSectionTitle
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)($gQ2LQ.AboutTeamsList, {
                children: [
                    hasUserDataLoaded && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k5NaU.default), {
                        source: "teamsList",
                        isCurrentUser: isCurrentUser(),
                        proposedMembers: isCurrentUser() ? [] : createProposedMember(),
                        isActiveUser: props.isActiveUser
                    }),
                    isTeamSearchLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7wrAa.default), {
                        hasAvatar: true,
                        isShimmering: true,
                        cssFn: ()=>({
                                paddingLeft: 0,
                                paddingRight: 0
                            }),
                        itemCount: 3
                    }) : teamList
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $71wio.ExperienceSuccess), {
                hasLoaded: !isTeamSearchLoading && !ApolloError,
                name: (0, $hOFm5.UserExperienceNames).USER_PROFILE_USERS_TEAMS
            })
        ]
    });
}
const $8e355e885be98fb3$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    teamSectionTitle: {
        id: 'ptc-directory.user-profile-page.about.teams.heading',
        defaultMessage: 'Teams',
        description: 'Heading for the teams that user is a member of'
    },
    showMore: {
        id: 'ptc-directory.user-profile-page.about.teams.show.more.button',
        defaultMessage: 'Show more',
        description: 'Text for the show more button'
    },
    showLess: {
        id: 'ptc-directory.user-profile-page.about.teams.show.less.button',
        defaultMessage: 'Show less',
        description: 'Text for the show less button'
    },
    errorStateTitle: {
        id: 'ptc-directory.user-profile-page.about.teams.error.title',
        defaultMessage: 'Something went wrong',
        description: 'Error title for when teams fail to load'
    },
    errorStateMessage: {
        id: 'ptc-directory.user-profile-page.about.teams.error.message',
        defaultMessage: 'Refresh the page or try again later',
        description: 'Error instruction for when teams fail to load'
    }
});
var $8e355e885be98fb3$export$2e2bcd8739ae039 = $8e355e885be98fb3$export$2697725d6b507e8c;

});
parcelRegister("axo8J", function(module, exports) {

$parcel$export(module.exports, "useTeamSearchQuery", () => $9738f8ee6245801a$export$209c3a9213f9e947);

var $5uXOq = parcelRequire("5uXOq");

var $4ZBJN = parcelRequire("4ZBJN");
var $a4jrI = parcelRequire("a4jrI");
var $W11xX = parcelRequire("W11xX");
var $crDAB = parcelRequire("crDAB");

var $eW0E0 = parcelRequire("eW0E0");
var $386Ww = parcelRequire("386Ww");

var $971Nd = parcelRequire("971Nd");

var $bMJzL = parcelRequire("bMJzL");

var $hxit3 = parcelRequire("hxit3");

var $9OeO9 = parcelRequire("9OeO9");
const $9738f8ee6245801a$var$QueryErrorToApolloError = (error)=>{
    return new (0, $hxit3.ApolloError)(error.message, error.graphQLErrors, error.networkError ?? null, error.extensions);
};
const $9738f8ee6245801a$var$excludeKnownGraphQLErrors = (error)=>{
    const mappedError = error instanceof (0, $386Ww.UseQueryLightError) ? $9738f8ee6245801a$var$QueryErrorToApolloError(error) : error;
    if (mappedError.message?.includes('User does not have access to the org') || mappedError.graphQLErrors?.some((e)=>e.extensions?.statusCode === 403)) // Escapes from this error as discussed in https://atlassian.slack.com/archives/C04939SL1J5/p1675215336793559
    return undefined;
    else if (mappedError.graphQLErrors) {
        const filteredError = {
            ...mappedError,
            // TODO PR Question - Is duplicating an error via spreading OK? (Not really an "Error" after that)
            graphQLErrors: (0, $9OeO9.filterExcludedMessages)(mappedError.graphQLErrors)
        };
        // If there's no actual errors left, then discard the error object
        const noErrorsLeft = filteredError.networkError == null && filteredError.graphQLErrors.length === 0;
        return noErrorsLeft ? undefined : filteredError;
    }
    return mappedError;
};
function $9738f8ee6245801a$var$orgIdWithARI(orgId) {
    return orgId?.startsWith((0, $9OeO9.ORG_ARI_PREFIX)) ? orgId : `${0, $9OeO9.ORG_ARI_PREFIX}${orgId}`;
}
const $9738f8ee6245801a$export$209c3a9213f9e947 = (props)=>{
    const { cursor: cursor, first: first, memberIds: memberIds, query: query, batchSize: batchSize, skip: providedSkip } = props;
    const { orgId: orgId } = (0, $crDAB.useV3OrgIdStatus)();
    const [exitedTeams] = (0, $4ZBJN.useExitedTeams)();
    const { isLoading: isTeamsVisibilityLoading, permissions: { canViewTeams: canViewTeams } } = (0, $W11xX.useTeamVisibility)();
    const [{ cloudId: cloudId }] = (0, $a4jrI.useSite)();
    const { data: data, loading: loading, error: error, fetchMore: fetchMore } = (0, $eW0E0.useQueryLight)((0, $bMJzL.default), {
        customHeaders: {
            'X-ExperimentalApi': 'team-members-beta',
            'atl-client-name': "platform-pkg",
            'atl-client-version': "0.0.0-use.local"
        },
        operationName: 'TeamSearchV2',
        serviceUrl: `${(0, $971Nd.getConfig)().stargateRoot}/graphql`,
        variables: {
            first: first,
            memberIds: memberIds,
            query: query,
            organizationId: $9738f8ee6245801a$var$orgIdWithARI(orgId),
            after: cursor,
            sortBy: query ? null : (0, $hxit3.sortBy),
            siteId: cloudId,
            showEmptyTeams: true
        },
        skip: providedSkip || !orgId || /**
     * Don't make the call when
     * 1. the permissions are currently loading
     * 2. the permissions have loaded but the user doesn't have permission to view teams
     */ !canViewTeams || isTeamsVisibilityLoading
    });
    const filteredError = error && $9738f8ee6245801a$var$excludeKnownGraphQLErrors(error);
    const formattedTeams = (0, $5uXOq.useMemo)(()=>{
        if (!data?.team || filteredError) // GraphQL queries can have a partial failure, where some data is returned
        // but not all of it. By default, Apollo will discard any partial data if
        // there's an error:
        // https://www.apollographql.com/docs/react/data/error-handling/#partial-data-with-resolver-errors
        //
        // In PTC-6588, we wanted to be able to support partial data for the case
        // where a team has been deleted, so we set the error policy to 'all'.
        // Otherwise, the whole page fails to load because of one bad team.
        // However, most of the app wasn't written to handle partial data, so if
        // there are any errors, we return nothing.
        return [];
        return (0, $9OeO9.fromV2ToTeamSearchViewFormat)(data.team?.teamSearch?.nodes || []);
    }, [
        data,
        filteredError
    ]);
    const loadMore = ()=>{
        fetchMore({
            variables: {
                after: data?.team?.teamSearch?.pageInfo?.endCursor,
                first: batchSize || first
            },
            handleDataMerge: (prevResult, fetchMoreResult)=>{
                if (!fetchMoreResult) return prevResult;
                const prevTeams = prevResult?.team?.teamSearch?.nodes || [];
                const newTeams = fetchMoreResult?.team?.teamSearch?.nodes || [];
                return {
                    ...fetchMoreResult,
                    team: {
                        ...fetchMoreResult.team,
                        teamSearch: {
                            ...fetchMoreResult.team?.teamSearch,
                            nodes: [
                                ...prevTeams,
                                ...newTeams
                            ]
                        }
                    }
                };
            }
        });
    };
    const filteredTeams = (0, $5uXOq.useMemo)(()=>formattedTeams.filter((team)=>!exitedTeams.has(team.id)), [
        formattedTeams,
        exitedTeams
    ]);
    return {
        isLoading: loading,
        teams: filteredTeams,
        error: filteredError,
        loadMore: loadMore,
        hasMore: !!data?.team?.teamSearch?.pageInfo?.hasNextPage
    };
};

});
parcelRegister("4ZBJN", function(module, exports) {

$parcel$export(module.exports, "useTeamProfileDataState", () => $73d42d62a2d0a0b7$export$1983fe04e6d15665);
$parcel$export(module.exports, "useTeamMembersState", () => $73d42d62a2d0a0b7$export$c90591c2030bee);
$parcel$export(module.exports, "useMyMembership", () => $73d42d62a2d0a0b7$export$7d96b11823e54583);
$parcel$export(module.exports, "useExitedTeams", () => $73d42d62a2d0a0b7$export$d85ae427dffd7a31);
$parcel$export(module.exports, "useTeamAgentsState", () => $73d42d62a2d0a0b7$export$80fb38915e92c27f);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $2Ixyh = parcelRequire("2Ixyh");

var $dB0M7 = parcelRequire("dB0M7");
var $jM1Zc = parcelRequire("jM1Zc");
var $cClgP = parcelRequire("cClgP");
var $iml7z = parcelRequire("iml7z");
var $9EFz0 = parcelRequire("9EFz0");
var $fmc2y = parcelRequire("fmc2y");
var $81hCO = parcelRequire("81hCO");
var $4c0sg = parcelRequire("4c0sg");
var $luiFu = parcelRequire("luiFu");
var $1O2L3 = parcelRequire("1O2L3");
var $6UWlQ = parcelRequire("6UWlQ");

var $4A4KA = parcelRequire("4A4KA");
const $73d42d62a2d0a0b7$var$initialState = {
    teamProfile: {
        teamId: '',
        isLoading: true,
        hasLoaded: false,
        errorType: null,
        data: {}
    },
    teamMembers: {
        teamId: '',
        isLoading: true,
        isLoadingNextPage: false,
        hasLoaded: false,
        hasError: false,
        errorType: null,
        members: [],
        requestingToJoinUsers: [],
        membersPageInfo: {
            hasNextPage: false,
            cursor: null
        },
        requestingToJoinUsersPageInfo: {
            hasNextPage: false,
            cursor: null
        }
    },
    teamAgents: {
        teamId: '',
        isLoading: true,
        isLoadingNextPage: false,
        hasLoaded: false,
        hasError: false,
        errorType: null,
        members: []
    },
    myTeamMembership: {
        teamId: '',
        hasLoaded: false,
        membership: undefined
    },
    exitedTeams: new Set(),
    allTeamsData: {
        teams: [],
        isLoading: true,
        hasError: false,
        cursor: ''
    }
};
const $73d42d62a2d0a0b7$var$actions = {
    /**
	 * @deprecated set the config on the teamsClient using useTeamsClientSetup
	 */ setTeamClientRootUrl: (rootUrl)=>()=>{
            (0, $2Ixyh.teamsClient).setLegionRootUrl(rootUrl);
        },
    collectTeamData: (teamId, forceRefresh)=>async ({ dispatch: dispatch, getState: getState })=>{
            // If we already have the team's data, do not collect it again
            if (!forceRefresh && getState().teamProfile.teamId === teamId) return;
            await Promise.all([
                dispatch((0, $fmc2y.getTeamProfile)(teamId)),
                dispatch((0, $iml7z.getMyTeamMembership)(teamId)),
                dispatch((0, $9EFz0.getTeamMembers)(teamId))
            ]);
            dispatch((0, $cClgP.getRequestingToJoinUsers)(teamId));
        },
    restoreTeam: (teamId, options)=>async ({ dispatch: dispatch })=>{
            await (0, $2Ixyh.teamsClient).restoreTeam(teamId);
            if (options?.fetchTeamData) await Promise.all([
                dispatch((0, $fmc2y.getTeamProfile)(teamId)),
                dispatch((0, $iml7z.getMyTeamMembership)(teamId)),
                dispatch((0, $9EFz0.getTeamMembers)(teamId))
            ]);
        },
    fetchTeamMembersNextPage: (teamId, count = 100)=>async ({ dispatch: dispatch, getState: getState })=>{
            if (!getState().teamMembers.membersPageInfo.hasNextPage) return;
            await dispatch((0, $9EFz0.getTeamMembers)(teamId, true, count));
        },
    refreshRequestingToJoinUsers: (teamId)=>async ({ dispatch: dispatch, getState: getState })=>{
            // Check that we're refreshing data for the current team
            if (getState().teamProfile.teamId !== teamId) return [];
            return await dispatch((0, $cClgP.getRequestingToJoinUsers)(teamId));
        },
    prefillTeamData: $luiFu.prefillTeamData,
    updateTeamProfile: (teamId, data)=>async ({ dispatch: dispatch, getState: getState, setState: setState })=>{
            const isTransitioningToOpen = data.membershipSettings === 'OPEN' && getState().teamProfile.data.membershipSettings === 'MEMBER_INVITE';
            const response = await (0, $2Ixyh.teamsClient).updateTeamById(teamId, data);
            setState({
                teamProfile: {
                    ...getState().teamProfile,
                    data: response
                }
            });
            if (isTransitioningToOpen) dispatch((0, $9EFz0.getTeamMembers)(teamId));
            return response;
        },
    acceptAllJoinRequests: (teamId)=>async ({ dispatch: dispatch, getState: getState })=>{
            const requests = getState().teamMembers.requestingToJoinUsers;
            await Promise.all(requests.map((request)=>{
                return dispatch((0, $jM1Zc.approveJoinRequest)(teamId, request.membershipId.memberId, request.user));
            }));
        },
    declineAllJoinRequests: (teamId)=>async ({ dispatch: dispatch, getState: getState })=>{
            const requests = getState().teamMembers.requestingToJoinUsers;
            await Promise.all(requests.map((request)=>{
                return dispatch((0, $cClgP.declineJoinRequest)(teamId, request.membershipId.memberId));
            }));
        },
    removeTeamMember: // Throws if we cannot remove the member
    $6UWlQ.removeTeamMember,
    removeTeamAgent: $1O2L3.removeTeamAgent,
    revokeTeamInvite: (teamId, memberId)=>async ({ getState: getState, setState: setState })=>{
            const { teamMembers: { teamId: currentTeamId } } = getState();
            const removedInvite = await (0, $2Ixyh.teamsClient).revokeTeamInvite(teamId, memberId);
            if (removedInvite && removedInvite.state !== 'ALUMNI') throw Error('Invite claims to be cancelled but was not');
            if (currentTeamId !== teamId) return;
            setState({
                teamMembers: {
                    ...getState().teamMembers,
                    members: getState().teamMembers.members.filter((member)=>!!member.user && member.user.id !== memberId)
                }
            });
        },
    joinTeam: // Throws if teamsClient.selfJoinTeam throws
    $dB0M7.joinTeam,
    // Throws if teamsClient.cancelJoinRequest throws
    cancelJoinRequest: (teamId)=>async ({ getState: getState, setState: setState })=>{
            const { teamProfile: { teamId: currentTeamId } } = getState();
            await (0, $2Ixyh.teamsClient).cancelJoinRequest(teamId);
            const state = getState();
            if (currentTeamId !== teamId) return;
            setState({
                ...state,
                myTeamMembership: {
                    teamId: teamId,
                    hasLoaded: true,
                    membership: undefined
                }
            });
        },
    acceptTeamInvitation: // Throws if teamsClient.acceptTeamInvitation throws
    $dB0M7.acceptTeamInvitation,
    // Throws if teamsClient.declineTeamInvitation throws
    declineTeamInvitation: (teamId)=>async ({ getState: getState })=>{
            const { exitedTeams: exitedTeams } = getState();
            await (0, $2Ixyh.teamsClient).declineTeamInvitation(teamId);
            exitedTeams.add(teamId);
        // No need to re-fetch, when an invite is declined we navigate away
        },
    inviteUsersToTeam: // Throws if teamsClient.inviteUsersToTeam or publicApiClient.addUsersToTeam throws
    $4c0sg.inviteUsersToTeam,
    inviteAgentsToTeam: $81hCO.inviteAgentsToTeam,
    approveJoinRequest: // Throws if teamsClient.approveJoinRequest throws
    $jM1Zc.approveJoinRequest,
    declineJoinRequest: // Throws if teamsClient.declineJoinRequest throws
    $cClgP.declineJoinRequest,
    // Throws if teamsClient.deleteTeam throws
    deleteTeam: (teamId)=>async ({ getState: getState, setState: setState })=>{
            const { exitedTeams: exitedTeams } = getState();
            await (0, $2Ixyh.teamsClient).deleteTeam(teamId);
            setState({
                teamProfile: $73d42d62a2d0a0b7$var$initialState.teamProfile,
                teamMembers: $73d42d62a2d0a0b7$var$initialState.teamMembers,
                myTeamMembership: $73d42d62a2d0a0b7$var$initialState.myTeamMembership
            });
            exitedTeams.add(teamId);
        },
    getAllTeams: (allTeamsQuery, keepExistingData)=>async ({ dispatch: dispatch })=>{
            await dispatch((0, $4A4KA.default)(allTeamsQuery, keepExistingData));
        },
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required
    /**
	 * @deprecated
	 */ refreshTeamHealthMonitors: ()=>async ()=>{
            return Promise.resolve();
        }
};
const $73d42d62a2d0a0b7$var$TeamStore = (0, $iXqE5.createStore)({
    initialState: $73d42d62a2d0a0b7$var$initialState,
    actions: $73d42d62a2d0a0b7$var$actions
});
const $73d42d62a2d0a0b7$export$1983fe04e6d15665 = (0, $3sQ5x.createHook)($73d42d62a2d0a0b7$var$TeamStore, {
    selector: (state)=>state.teamProfile
});
const $73d42d62a2d0a0b7$export$c90591c2030bee = (0, $3sQ5x.createHook)($73d42d62a2d0a0b7$var$TeamStore, {
    selector: (state)=>state.teamMembers
});
const $73d42d62a2d0a0b7$export$7d96b11823e54583 = (0, $3sQ5x.createHook)($73d42d62a2d0a0b7$var$TeamStore, {
    selector: (state)=>state.myTeamMembership
});
const $73d42d62a2d0a0b7$export$d85ae427dffd7a31 = (0, $3sQ5x.createHook)($73d42d62a2d0a0b7$var$TeamStore, {
    selector: (state)=>state.exitedTeams
});
const $73d42d62a2d0a0b7$export$a50a7dc1b87fcc7 = (0, $3sQ5x.createHook)($73d42d62a2d0a0b7$var$TeamStore, {
    selector: (state)=>state.allTeamsData
});
const $73d42d62a2d0a0b7$export$80fb38915e92c27f = (0, $3sQ5x.createHook)($73d42d62a2d0a0b7$var$TeamStore, {
    selector: (state)=>state.teamAgents
});

});
parcelRegister("dB0M7", function(module, exports) {

$parcel$export(module.exports, "joinTeam", () => $309ab91cb9205761$export$47f143084f31963c);
$parcel$export(module.exports, "acceptTeamInvitation", () => $309ab91cb9205761$export$a0ce1bbc3e3f2e4d);

var $2Ixyh = parcelRequire("2Ixyh");

var $cClgP = parcelRequire("cClgP");

var $490N3 = parcelRequire("490N3");
const $309ab91cb9205761$export$e4da98dc943d58c8 = (teamId, member)=>({ getState: getState, setState: setState })=>{
        const state = getState();
        if (state.teamProfile.teamId !== teamId) return;
        const nextState = (0, $490N3.joinTeamState)(state, member);
        setState(nextState);
    };
const $309ab91cb9205761$export$47f143084f31963c = (teamId, originQuery, user)=>async ({ dispatch: dispatch })=>{
        const response = await (0, $2Ixyh.teamsClient).selfJoinTeam(teamId, originQuery);
        const newMembership = {
            ...response,
            user: user
        };
        dispatch($309ab91cb9205761$export$e4da98dc943d58c8(teamId, newMembership));
        return response;
    };
const $309ab91cb9205761$export$a0ce1bbc3e3f2e4d = (teamId, currentUserId)=>async ({ dispatch: dispatch, getState: getState })=>{
        const response = await (0, $2Ixyh.teamsClient).acceptTeamInvitation(teamId);
        const existingUser = getState().teamMembers.members.find((member)=>member.membershipId.memberId === currentUserId);
        // This membership MUST exist for the user to be able to call this function,
        // and `user` will be defined as this membership comes from the directory.
        if (!existingUser || !existingUser.user) return;
        const newMembership = {
            ...response,
            user: existingUser.user
        };
        dispatch($309ab91cb9205761$export$e4da98dc943d58c8(teamId, newMembership));
        // Don't await this, let them load afterwards
        dispatch((0, $cClgP.getRequestingToJoinUsers)(teamId));
    };

});
parcelRegister("cClgP", function(module, exports) {

$parcel$export(module.exports, "getRequestingToJoinUsers", () => $2bbb83d2dc5b1673$export$eb1265581ad35874);
$parcel$export(module.exports, "declineJoinRequest", () => $2bbb83d2dc5b1673$export$d71ce2a87bc937b0);

var $8h9rg = parcelRequire("8h9rg");
var $2Ixyh = parcelRequire("2Ixyh");

var $fK0Ul = parcelRequire("fK0Ul");

var $WUBOW = parcelRequire("WUBOW");
const $2bbb83d2dc5b1673$export$eb1265581ad35874 = (teamId)=>async ({ getState: getState, setState: setState })=>{
        const initialState = getState();
        const isOpenTeam = initialState.teamProfile.data.membershipSettings === 'OPEN';
        const membershipErrors = initialState.teamMembers.hasError;
        const hasPermissionToViewRequestingUsers = initialState.teamProfile.data.permission === 'FULL_WRITE';
        const teamChanged = initialState.teamMembers.teamId !== teamId;
        if (teamChanged || !hasPermissionToViewRequestingUsers || membershipErrors || isOpenTeam) return [];
        try {
            const requestingUsersResponse = await (0, $2Ixyh.teamsClient).queryTeamMemberships(teamId, [
                'REQUESTING_TO_JOIN'
            ], {
                first: 100,
                after: initialState.teamMembers.requestingToJoinUsersPageInfo.cursor ?? undefined
            });
            const requestingUsers = (0, $fK0Ul.isResultWithPageInfo)(requestingUsersResponse) ? requestingUsersResponse.edges : requestingUsersResponse;
            const state = getState();
            if (state.teamMembers.teamId !== teamId) return [];
            const sortedRequesters = (0, $8h9rg.sortMembersByType)(requestingUsers);
            setState({
                teamMembers: {
                    ...state.teamMembers,
                    requestingToJoinUsers: sortedRequesters
                }
            });
            return sortedRequesters;
        } catch (err) {
            (0, $WUBOW.logException)(err, 'Could not load requesting-to-join users');
            return [];
        }
    };
const $2bbb83d2dc5b1673$export$d71ce2a87bc937b0 = (teamId, memberId)=>async ({ getState: getState, setState: setState })=>{
        await (0, $2Ixyh.teamsClient).declineJoinRequest(teamId, memberId);
        const state = getState();
        if (state.teamMembers.teamId !== teamId) return;
        setState({
            ...state,
            teamMembers: {
                ...state.teamMembers,
                requestingToJoinUsers: state.teamMembers.requestingToJoinUsers.filter((user)=>user.membershipId.memberId !== memberId)
            }
        });
    };

});
parcelRegister("8h9rg", function(module, exports) {

$parcel$export(module.exports, "sortMembersByType", () => $b24adf1bf0cb2c2e$export$90b27c15351f4a21);
var $b24adf1bf0cb2c2e$var$MemberType = /*#__PURE__*/ function(MemberType) {
    MemberType[MemberType["CURRENT_USER"] = 0] = "CURRENT_USER";
    MemberType[MemberType["MEMBER"] = 1] = "MEMBER";
    MemberType[MemberType["INVITED"] = 2] = "INVITED";
    MemberType[MemberType["INACTIVE"] = 3] = "INACTIVE";
    MemberType[MemberType["DELETED"] = 4] = "DELETED";
    return MemberType;
}($b24adf1bf0cb2c2e$var$MemberType || {});
const $b24adf1bf0cb2c2e$var$checkType = (member, currentAccountId)=>{
    if (member.membershipId.memberId === currentAccountId) return 0;
    else if (member && member.state === 'INVITED') return 2;
    else if (member.user?.status === 'inactive') return 3;
    else if (member.user?.status === 'closed') return 4;
    else return 1;
};
const $b24adf1bf0cb2c2e$export$90b27c15351f4a21 = (members, currentAccountId)=>{
    const newMembers = members.map((member)=>({
            member: member,
            type: $b24adf1bf0cb2c2e$var$checkType(member, currentAccountId)
        }));
    newMembers.sort(({ member: memberA, type: typeA }, { member: memberB, type: typeB })=>{
        if (typeA === typeB) return memberA.user?.fullName.localeCompare(memberB.user?.fullName || '') || 0;
        else return typeA - typeB;
    });
    return newMembers.map(({ member: member })=>member);
};

});

parcelRegister("fK0Ul", function(module, exports) {

$parcel$export(module.exports, "isResultWithPageInfo", () => $db252f66f7c49513$export$7fb758c207c3ab4b);
function $db252f66f7c49513$export$7fb758c207c3ab4b(result) {
    return result.pageInfo !== undefined;
}

});


parcelRegister("490N3", function(module, exports) {

$parcel$export(module.exports, "joinTeamState", () => $a404bfc3a3db6a17$export$6842649be21ecf13);

var $8h9rg = parcelRequire("8h9rg");
const $a404bfc3a3db6a17$export$6842649be21ecf13 = (teamState, newMembership)=>{
    const { exitedTeams: exitedTeams, teamMembers: teamMembers, teamProfile: teamProfile } = teamState;
    const requestingToJoin = newMembership.state === 'REQUESTING_TO_JOIN';
    const teamId = newMembership.membershipId.teamId;
    if (requestingToJoin) return {
        ...teamState,
        myTeamMembership: {
            teamId: teamId,
            hasLoaded: true,
            membership: newMembership
        }
    };
    // If we're joining this team, remove it from the set of exited teams
    exitedTeams.delete(teamId);
    const currentUserId = newMembership.membershipId.memberId;
    const newMembers = teamMembers.members.filter((membership)=>{
        return membership.membershipId.memberId !== currentUserId;
    }).concat(newMembership);
    return {
        ...teamState,
        teamProfile: {
            teamId: teamId,
            hasLoaded: true,
            isLoading: false,
            errorType: null,
            data: {
                ...teamProfile.data,
                permission: 'FULL_WRITE'
            }
        },
        teamMembers: {
            teamId: teamId,
            hasLoaded: true,
            hasError: false,
            isLoading: false,
            isLoadingNextPage: false,
            errorType: null,
            members: (0, $8h9rg.sortMembersByType)(newMembers, currentUserId),
            requestingToJoinUsers: teamMembers.requestingToJoinUsers,
            membersPageInfo: teamMembers.membersPageInfo,
            requestingToJoinUsersPageInfo: {
                hasNextPage: false,
                cursor: null
            }
        },
        myTeamMembership: {
            teamId: teamId,
            hasLoaded: true,
            membership: newMembership
        }
    };
};

});


parcelRegister("jM1Zc", function(module, exports) {

$parcel$export(module.exports, "approveJoinRequest", () => $01f972d4c7697e19$export$a355add01c2f52a3);

var $8h9rg = parcelRequire("8h9rg");
var $2Ixyh = parcelRequire("2Ixyh");
const $01f972d4c7697e19$export$a355add01c2f52a3 = (teamId, memberId, user)=>async ({ getState: getState, setState: setState })=>{
        const membership = await (0, $2Ixyh.teamsClient).acceptJoinRequest(teamId, memberId);
        const state = getState();
        const { myTeamMembership: myTeamMembership, teamMembers: teamMembers, teamProfile: { teamId: currentTeamId } } = state;
        if (currentTeamId !== teamId || membership.state !== 'FULL_MEMBER') return;
        const newMembership = {
            ...membership,
            user: user
        };
        const newMembers = teamMembers.members.filter((membership)=>{
            return membership.membershipId.memberId !== memberId;
        }).concat(newMembership);
        const myMembership = myTeamMembership.membership;
        setState({
            ...state,
            teamMembers: {
                teamId: teamId,
                hasLoaded: true,
                isLoadingNextPage: false,
                hasError: false,
                isLoading: false,
                errorType: null,
                membersPageInfo: teamMembers.membersPageInfo,
                requestingToJoinUsersPageInfo: teamMembers.requestingToJoinUsersPageInfo,
                members: (0, $8h9rg.sortMembersByType)(newMembers, myMembership?.membershipId.memberId),
                requestingToJoinUsers: teamMembers.requestingToJoinUsers.filter((user)=>user.membershipId.memberId !== memberId)
            }
        });
    };

});

parcelRegister("iml7z", function(module, exports) {

$parcel$export(module.exports, "getMyTeamMembership", () => $6633f0928c762ef6$export$72e6f466f46f9da0);

var $8h9rg = parcelRequire("8h9rg");
var $2Ixyh = parcelRequire("2Ixyh");

var $3xxVR = parcelRequire("3xxVR");
const $6633f0928c762ef6$export$72e6f466f46f9da0 = (teamId, keepExistingData)=>async ({ getState: getState, setState: setState })=>{
        if (!keepExistingData) setState({
            myTeamMembership: {
                teamId: teamId,
                hasLoaded: false,
                membership: undefined
            }
        });
        const { myTeamMembership: myTeamMembership } = getState();
        if (myTeamMembership.teamId !== teamId) return;
        const { value: membership } = await (0, $3xxVR.promiseWithDefault)((0, $2Ixyh.teamsClient).getMyTeamMembership(teamId), undefined);
        const { teamMembers: teamMembers } = getState();
        const members = teamMembers.members;
        const sortedMembers = members.length > 0 && !!membership ? {
            teamMembers: {
                ...teamMembers,
                members: (0, $8h9rg.sortMembersByType)(members, membership.membershipId.memberId)
            }
        } : {};
        setState({
            myTeamMembership: {
                teamId: teamId,
                hasLoaded: true,
                membership: membership
            },
            ...sortedMembers
        });
    };

});
parcelRegister("3xxVR", function(module, exports) {

$parcel$export(module.exports, "promiseWithDefault", () => $7b09a3b816fc8ce3$export$a970b469503acdc8);
function $7b09a3b816fc8ce3$export$a970b469503acdc8(promise, defaultValue) {
    return promise.then((value)=>({
            value: value,
            success: true
        })).catch(()=>({
            value: defaultValue,
            success: false
        }));
}

});


parcelRegister("9EFz0", function(module, exports) {

$parcel$export(module.exports, "getTeamMembers", () => $482441e24c9fb357$export$e662071d38e352a1);

var $8h9rg = parcelRequire("8h9rg");
var $2Ixyh = parcelRequire("2Ixyh");

var $fK0Ul = parcelRequire("fK0Ul");
const $482441e24c9fb357$var$combineIn = (existing, newData)=>{
    const addedMemberIds = new Set(newData.map((member)=>member.membershipId.memberId));
    return existing.filter((member)=>!addedMemberIds.has(member.membershipId.memberId)).concat(newData);
};
const $482441e24c9fb357$export$e662071d38e352a1 = (teamId, keepExistingData, first = 100)=>async ({ getState: getState, setState: setState })=>{
        if (!keepExistingData) setState({
            teamMembers: {
                teamId: teamId,
                isLoading: true,
                isLoadingNextPage: false,
                hasLoaded: false,
                hasError: false,
                errorType: null,
                members: [],
                requestingToJoinUsers: [],
                membersPageInfo: {
                    hasNextPage: false,
                    cursor: null
                },
                requestingToJoinUsersPageInfo: {
                    hasNextPage: false,
                    cursor: null
                }
            },
            teamAgents: {
                teamId: teamId,
                isLoading: true,
                isLoadingNextPage: false,
                hasLoaded: false,
                hasError: false,
                errorType: null,
                members: []
            }
        });
        const { teamMembers: teamMembers } = getState();
        if (teamMembers.teamId !== teamId) return;
        setState({
            teamMembers: {
                ...teamMembers,
                isLoadingNextPage: true
            },
            teamAgents: {
                ...teamMembers
            }
        });
        try {
            const membershipsResponse = await (0, $2Ixyh.teamsClient).queryTeamMemberships(teamId, [
                'FULL_MEMBER'
            ], {
                first: first,
                after: teamMembers.membersPageInfo.cursor ?? undefined
            });
            const memberships = (0, $fK0Ul.isResultWithPageInfo)(membershipsResponse) ? membershipsResponse.edges : membershipsResponse;
            const pageInfo = (0, $fK0Ul.isResultWithPageInfo)(membershipsResponse) ? membershipsResponse.pageInfo : {
                hasNextPage: false,
                endCursor: null
            };
            const myMembership = getState().myTeamMembership.membership;
            const myAccountId = myMembership?.membershipId.memberId;
            const membershipsWithExisting = keepExistingData ? $482441e24c9fb357$var$combineIn(teamMembers.members, memberships) : memberships;
            const sortedMembers = (0, $8h9rg.sortMembersByType)(membershipsWithExisting, myAccountId);
            const membersWithoutAgents = sortedMembers.filter((member)=>!(member.user?.userType === 'agent'));
            const agents = sortedMembers.filter((member)=>member.user?.userType === 'agent');
            setState({
                teamMembers: {
                    teamId: teamId,
                    isLoading: false,
                    isLoadingNextPage: false,
                    hasLoaded: true,
                    hasError: false,
                    errorType: null,
                    members: membersWithoutAgents,
                    requestingToJoinUsers: [],
                    requestingToJoinUsersPageInfo: {
                        hasNextPage: false,
                        cursor: null
                    },
                    membersPageInfo: {
                        hasNextPage: pageInfo.hasNextPage,
                        cursor: pageInfo.endCursor
                    }
                },
                teamAgents: {
                    teamId: teamId,
                    isLoading: false,
                    isLoadingNextPage: false,
                    hasLoaded: true,
                    hasError: false,
                    errorType: null,
                    members: agents
                }
            });
        } catch (e) {
            if (getState().teamMembers.teamId !== teamId) return;
            setState({
                teamMembers: {
                    teamId: teamId,
                    isLoading: false,
                    isLoadingNextPage: false,
                    hasLoaded: true,
                    hasError: true,
                    errorType: e,
                    members: [],
                    requestingToJoinUsers: [],
                    membersPageInfo: {
                        hasNextPage: false,
                        cursor: null
                    },
                    requestingToJoinUsersPageInfo: {
                        hasNextPage: false,
                        cursor: null
                    }
                },
                teamAgents: {
                    teamId: teamId,
                    isLoading: false,
                    isLoadingNextPage: false,
                    hasLoaded: true,
                    hasError: true,
                    errorType: e,
                    members: []
                }
            });
        }
    };

});

parcelRegister("fmc2y", function(module, exports) {

$parcel$export(module.exports, "getTeamProfile", () => $5b008a72660106e7$export$7a5bb1168a5e8491);

var $2Ixyh = parcelRequire("2Ixyh");
const $5b008a72660106e7$export$7a5bb1168a5e8491 = (teamId)=>async ({ setState: setState })=>{
        setState({
            teamProfile: {
                teamId: teamId,
                isLoading: true,
                hasLoaded: false,
                errorType: null,
                data: {}
            }
        });
        try {
            const team = await (0, $2Ixyh.teamsClient).getTeamById(teamId);
            setState({
                teamProfile: {
                    teamId: teamId,
                    isLoading: false,
                    hasLoaded: true,
                    errorType: null,
                    data: team
                }
            });
        } catch (e) {
            setState({
                teamProfile: {
                    teamId: teamId,
                    isLoading: false,
                    hasLoaded: true,
                    errorType: e,
                    data: {}
                }
            });
        }
    };

});

parcelRegister("81hCO", function(module, exports) {

$parcel$export(module.exports, "inviteAgentsToTeam", () => $0f32fef3a4e1b301$export$8f3a722ac3583593);

var $2Ixyh = parcelRequire("2Ixyh");

var $WUBOW = parcelRequire("WUBOW");

var $4FhfU = parcelRequire("4FhfU");

var $eYxjH = parcelRequire("eYxjH");
const $0f32fef3a4e1b301$export$8f3a722ac3583593 = (teamId, members)=>async ({ getState: getState, setState: setState })=>{
        (0, $4FhfU.addNewMembertoTeamSubExp).addMetadata({
            apiVersion: 'v4'
        });
        const addMembershipResponse = await (0, $2Ixyh.teamsClient).addUsersToTeam(teamId, members.map((member)=>({
                accountId: member.id
            })));
        const memberships = addMembershipResponse.members.reduce((acc, partial)=>{
            if (!partial.accountId) {
                (0, $WUBOW.logInfoMessage)('teamInvitationInvalidResponse', {
                    message: 'Membership in response was invalid',
                    member: partial,
                    response: addMembershipResponse
                });
                return acc;
            }
            const user = members.find((member)=>member.id === partial.accountId);
            if (!user) {
                (0, $WUBOW.logInfoMessage)('teamInvitationInvalidResponse', {
                    message: 'Could not find user details for this member',
                    member: partial,
                    response: addMembershipResponse
                });
                return acc;
            }
            acc.push({
                membershipId: {
                    teamId: teamId,
                    memberId: partial.accountId
                },
                // state and role are deprecated in V4, so hard code them here
                state: 'FULL_MEMBER',
                role: 'REGULAR',
                user: {
                    id: user.id,
                    fullName: user.name,
                    avatarUrl: user.avatarUrl,
                    userType: 'user'
                }
            });
            return acc;
        }, []);
        const state = getState();
        // If focused team has changed whilst invite request was resolving, abort.
        if (teamId !== state.teamMembers.teamId) return;
        // Update the state with the new members.
        const nextState = (0, $eYxjH.inviteMemberState)(state, memberships);
        setState(nextState);
        return memberships;
    };

});
parcelRegister("4FhfU", function(module, exports) {

$parcel$export(module.exports, "renderTeamMemberRemoveDialogSubExp", () => $998fb1d6f0548ddd$export$d04a4af02b71bd20);
$parcel$export(module.exports, "removeMemberFromTeamSubExp", () => $998fb1d6f0548ddd$export$8e622ac1f6a9e9f4);
$parcel$export(module.exports, "removeMemberFromTeamExp", () => $998fb1d6f0548ddd$export$ded699d92af3fb9e);
$parcel$export(module.exports, "teamSettingsOverallExp", () => $998fb1d6f0548ddd$export$efd0793305afa76a);
$parcel$export(module.exports, "teamSettingsChangeTeamTypeExp", () => $998fb1d6f0548ddd$export$fba164816385656f);
$parcel$export(module.exports, "renderTeamMemberInviteDialogSubExp", () => $998fb1d6f0548ddd$export$568d3db878ad8d23);
$parcel$export(module.exports, "addNewMembertoTeamSubExp", () => $998fb1d6f0548ddd$export$d691a209050136d6);
$parcel$export(module.exports, "inviteMembersToTeamExperience", () => $998fb1d6f0548ddd$export$2bd703f1fbcc240b);

var $6tKtB = parcelRequire("6tKtB");

var $lrUJ4 = parcelRequire("lrUJ4");
var $16Yvd = parcelRequire("16Yvd");
const $998fb1d6f0548ddd$export$d04a4af02b71bd20 = new (0, $6tKtB.TeamsUFOExperience)('render-team-member-remove-dialog', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $998fb1d6f0548ddd$export$8e622ac1f6a9e9f4 = new (0, $6tKtB.TeamsUFOExperience)('remove-member-from-team-action', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $998fb1d6f0548ddd$var$removeMemberFromTeamSubExperiences = [
    $998fb1d6f0548ddd$export$d04a4af02b71bd20,
    $998fb1d6f0548ddd$export$8e622ac1f6a9e9f4
];
const $998fb1d6f0548ddd$export$ded699d92af3fb9e = new (0, $6tKtB.TeamsUFOExperience)('remove-a-member-from-team', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).Custom,
    platform: {
        component: 'people'
    },
    until: (0, $16Yvd.untilAll)($998fb1d6f0548ddd$var$removeMemberFromTeamSubExperiences.map((experience)=>({
            experience: experience
        })))
});
const $998fb1d6f0548ddd$export$efd0793305afa76a = new (0, $6tKtB.TeamsUFOExperience)('membership-control-change', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $998fb1d6f0548ddd$export$a7f093db8a7d96e1 = new (0, $6tKtB.TeamsUFOExperience)('membership-control-change-handle-requests', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $998fb1d6f0548ddd$export$fba164816385656f = new (0, $6tKtB.TeamsUFOExperience)('membership-control-change-change-team-type', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $998fb1d6f0548ddd$export$568d3db878ad8d23 = new (0, $6tKtB.TeamsUFOExperience)('render-team-member-invite-dialog', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $998fb1d6f0548ddd$export$d691a209050136d6 = new (0, $6tKtB.TeamsUFOExperience)('add-new-member-to-team-action', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $998fb1d6f0548ddd$var$inviteMembersToTeamSubExperiences = [
    $998fb1d6f0548ddd$export$568d3db878ad8d23,
    $998fb1d6f0548ddd$export$d691a209050136d6
];
const $998fb1d6f0548ddd$export$2bd703f1fbcc240b = new (0, $6tKtB.TeamsUFOExperience)('invite-members-to-team', {
    type: (0, $lrUJ4.ExperienceTypes).Experience,
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).Custom,
    platform: {
        component: 'people'
    },
    until: (0, $16Yvd.untilAll)($998fb1d6f0548ddd$var$inviteMembersToTeamSubExperiences.map((experience)=>({
            experience: experience
        })))
});

});

parcelRegister("eYxjH", function(module, exports) {

$parcel$export(module.exports, "inviteMemberState", () => $a573d5eb8c022636$export$d7fb3590d40d5847);

var $8h9rg = parcelRequire("8h9rg");
const $a573d5eb8c022636$export$d7fb3590d40d5847 = (teamState, newMemberships)=>{
    const { teamAgents: teamAgents } = teamState;
    const memberIds = new Set(newMemberships.map(({ membershipId: membershipId })=>membershipId.memberId));
    const existingMembers = teamAgents.members.filter((member)=>{
        return !memberIds.has(member.membershipId.memberId);
    });
    const finalMembers = (0, $8h9rg.sortMembersByType)(newMemberships.concat(existingMembers));
    return {
        ...teamState,
        teamAgents: {
            ...teamState.teamAgents,
            teamId: teamState.teamAgents.teamId,
            hasLoaded: true,
            hasError: false,
            isLoading: false,
            errorType: null,
            members: finalMembers
        }
    };
};

});


parcelRegister("4c0sg", function(module, exports) {

$parcel$export(module.exports, "inviteUsersToTeam", () => $5de879ce2d80d668$export$ac31c528ad2c8490);

var $8h9rg = parcelRequire("8h9rg");
var $2Ixyh = parcelRequire("2Ixyh");

var $WUBOW = parcelRequire("WUBOW");

var $4FhfU = parcelRequire("4FhfU");
const $5de879ce2d80d668$export$d7fb3590d40d5847 = (teamState, newMemberships)=>{
    const { teamMembers: teamMembers } = teamState;
    const memberIds = new Set(newMemberships.map(({ membershipId: membershipId })=>membershipId.memberId));
    const existingMembers = teamMembers.members.filter((member)=>{
        return !memberIds.has(member.membershipId.memberId);
    });
    const currentUserId = teamState.myTeamMembership.membership?.membershipId.memberId;
    const finalMembers = (0, $8h9rg.sortMembersByType)(newMemberships.concat(existingMembers), currentUserId);
    return {
        ...teamState,
        teamMembers: {
            ...teamState.teamMembers,
            teamId: teamState.teamMembers.teamId,
            hasLoaded: true,
            hasError: false,
            isLoading: false,
            errorType: null,
            members: finalMembers
        }
    };
};
const $5de879ce2d80d668$var$fetchJobTitlesOfNewMembers = (teamId, unpopulatedMembers, originQuery)=>async ({ getState: getState, setState: setState })=>{
        Promise.all(unpopulatedMembers.map((membership)=>{
            return (0, $2Ixyh.teamsClient).queryAGGUser(membership.membershipId.memberId).then((user)=>{
                return {
                    ...membership,
                    user: {
                        ...membership.user,
                        title: user.extendedProfile?.jobTitle
                    }
                };
            });
        })).then((memberships)=>{
            const state = getState();
            // Cancel if the data we fetched is stale
            if (state.teamMembers.teamId !== teamId) return;
            const titles = {};
            for (const member of memberships)titles[member.membershipId.memberId] = member.user.title || undefined;
            setState({
                ...state,
                teamMembers: {
                    ...state.teamMembers,
                    members: state.teamMembers.members.map(// @ts-ignore
                    (member)=>{
                        return {
                            ...member,
                            user: {
                                ...member.user,
                                title: titles[member.membershipId.memberId] || member.user.title
                            }
                        };
                    })
                }
            });
        }).catch((error)=>{
            (0, $WUBOW.logException)(error, 'Could not populate new team members with titles');
        });
    };
const $5de879ce2d80d668$export$ac31c528ad2c8490 = (teamId, members, originQuery)=>async ({ dispatch: dispatch, getState: getState, setState: setState })=>{
        (0, $4FhfU.addNewMembertoTeamSubExp).addMetadata({
            apiVersion: 'v4'
        });
        const addMembershipResponse = await (0, $2Ixyh.teamsClient).addUsersToTeam(teamId, members.map((member)=>({
                accountId: member.id
            })));
        const memberships = addMembershipResponse.members.reduce((acc, partial)=>{
            if (!partial.accountId) {
                (0, $WUBOW.logInfoMessage)('teamInvitationInvalidResponse', {
                    message: 'Membership in response was invalid',
                    member: partial,
                    response: addMembershipResponse
                });
                return acc;
            }
            const user = members.find((member)=>member.id === partial.accountId);
            if (!user) {
                (0, $WUBOW.logInfoMessage)('teamInvitationInvalidResponse', {
                    message: 'Could not find user details for this member',
                    member: partial,
                    response: addMembershipResponse
                });
                return acc;
            }
            acc.push({
                membershipId: {
                    teamId: teamId,
                    memberId: partial.accountId
                },
                // state and role are deprecated in V4, so hard code them here
                state: 'FULL_MEMBER',
                role: 'REGULAR',
                user: {
                    id: user.id,
                    fullName: user.name,
                    avatarUrl: user.avatarUrl,
                    userType: 'user'
                }
            });
            return acc;
        }, []);
        const state = getState();
        // If focused team has changed whilst invite request was resolving, abort.
        if (teamId !== state.teamMembers.teamId) return;
        // Update the state with the new members.
        const nextState = $5de879ce2d80d668$export$d7fb3590d40d5847(state, memberships);
        setState(nextState);
        // Send request to populate job titles off the main thread.
        const unpopulatedMembers = addMembershipResponse.members.map((member)=>({
                membershipId: {
                    teamId: teamId,
                    memberId: member.accountId
                },
                // state and role are deprecated in V4, so hard code them here
                state: 'FULL_MEMBER',
                role: 'REGULAR'
            }));
        dispatch($5de879ce2d80d668$var$fetchJobTitlesOfNewMembers(teamId, unpopulatedMembers, originQuery));
        return memberships;
    };

});

parcelRegister("luiFu", function(module, exports) {

$parcel$export(module.exports, "prefillTeamData", () => $2eb11a1b9ea1162d$export$bc2925813ab9bc57);

var $8h9rg = parcelRequire("8h9rg");

var $iml7z = parcelRequire("iml7z");

var $9EFz0 = parcelRequire("9EFz0");
const $2eb11a1b9ea1162d$var$TIMEOUT_DELAY = 5000;
function $2eb11a1b9ea1162d$var$membershipMaker(teamId) {
    return (user)=>{
        return {
            membershipId: {
                teamId: teamId,
                memberId: user.id
            },
            state: 'FULL_MEMBER',
            role: 'REGULAR',
            user: user
        };
    };
}
const $2eb11a1b9ea1162d$export$bc2925813ab9bc57 = (teamId, teamData, members, currentUser)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const newState = {
            ...getState(),
            teamProfile: {
                teamId: teamId,
                isLoading: false,
                hasLoaded: true,
                errorType: null,
                data: teamData
            },
            teamMembers: {
                teamId: teamId,
                isLoading: false,
                isLoadingNextPage: false,
                hasLoaded: true,
                hasError: false,
                errorType: null,
                members: (0, $8h9rg.sortMembersByType)(members.map($2eb11a1b9ea1162d$var$membershipMaker(teamId)), currentUser.id),
                requestingToJoinUsers: [],
                membersPageInfo: {
                    hasNextPage: false,
                    cursor: null
                },
                requestingToJoinUsersPageInfo: {
                    hasNextPage: false,
                    cursor: null
                }
            },
            myTeamMembership: {
                teamId: teamId,
                hasLoaded: true,
                membership: members.some((x)=>x.id === currentUser.id) ? $2eb11a1b9ea1162d$var$membershipMaker(teamId)(currentUser) : undefined
            }
        };
        setState(newState);
        setTimeout(()=>{
            if (getState().teamProfile.teamId !== teamId) return;
            dispatch((0, $9EFz0.getTeamMembers)(teamId, true));
            dispatch((0, $iml7z.getMyTeamMembership)(teamId, true));
        }, $2eb11a1b9ea1162d$var$TIMEOUT_DELAY);
    };

});

parcelRegister("1O2L3", function(module, exports) {

$parcel$export(module.exports, "removeTeamAgent", () => $f46ae1f42bdd6e9d$export$cc0fe1b8e0afca8c);

var $2Ixyh = parcelRequire("2Ixyh");
const $f46ae1f42bdd6e9d$export$1c43837b29355a68 = (teamState, memberId, permissions)=>{
    const { teamProfile: teamProfile, teamAgents: teamAgents } = teamState;
    const teamId = teamProfile.teamId;
    const finalAgents = {
        ...teamAgents,
        teamId: teamId,
        hasLoaded: true,
        hasError: false,
        isLoading: false,
        errorType: null,
        members: teamAgents.members.filter((agent)=>!!agent.user && agent.user.id !== memberId)
    };
    return {
        ...teamState,
        teamAgents: finalAgents
    };
};
const $f46ae1f42bdd6e9d$export$cc0fe1b8e0afca8c = (teamId, agentAtlassianAccountId, permissions)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        const removeMembershipResponse = await (0, $2Ixyh.teamsClient).removeTeamMemberships(teamId, [
            {
                accountId: agentAtlassianAccountId
            }
        ]);
        // as we only removing 1 member at a time, it is safe to say task failed with even 1 error
        if (removeMembershipResponse.errors && removeMembershipResponse.errors.length) throw Error('Membership claims to be removed but was not');
        if (state.teamMembers.teamId !== teamId) return;
        const nextState = $f46ae1f42bdd6e9d$export$1c43837b29355a68(state, agentAtlassianAccountId, permissions);
        setState(nextState);
    };

});

parcelRegister("6UWlQ", function(module, exports) {

$parcel$export(module.exports, "removeTeamMember", () => $b511d8481b97f032$export$f7c0e1c7a2575f28);

var $2Ixyh = parcelRequire("2Ixyh");
const $b511d8481b97f032$export$87a89dfcfcd29512 = (teamState, memberId, permissions)=>{
    const { exitedTeams: exitedTeams, myTeamMembership: myTeamMembership, teamMembers: teamMembers, teamProfile: teamProfile } = teamState;
    const teamId = myTeamMembership.teamId;
    const myMembership = myTeamMembership.membership;
    const isCurrentUser = myMembership && myMembership.membershipId.memberId === memberId;
    const finalMembers = {
        ...teamMembers,
        teamId: teamId,
        hasLoaded: true,
        hasError: false,
        isLoading: false,
        errorType: null,
        members: teamMembers.members.filter((member)=>!!member.user && member.user.id !== memberId)
    };
    if (!isCurrentUser) return {
        ...teamState,
        teamMembers: finalMembers
    };
    // No longer a part of this team, hide it from search results
    exitedTeams.add(teamId);
    const currentTeam = teamProfile.data;
    /**
	 * Allow admins to manage teams after they are removed from the team
	 * If currentTeam.permission is not undefined and user is not admin, they can only view the team after removal, set permission to FULL_READ
	 * If currentTeam.permission is not undefined and user is admin, they can still manage the team after removal, set permission to FULL_WRITE
	 * If currentTeam.permission is undefined, don't override the permission
	 */ const permissionAfterRemoval = currentTeam.permission ? permissions?.canAdminTeams ? 'FULL_WRITE' : 'FULL_READ' : currentTeam.permission;
    // Nullify myMembership and change permission
    return {
        ...teamState,
        teamMembers: finalMembers,
        myTeamMembership: {
            teamId: teamId,
            hasLoaded: true,
            membership: undefined
        },
        teamProfile: {
            teamId: teamId,
            isLoading: false,
            hasLoaded: true,
            errorType: null,
            data: {
                ...currentTeam,
                permission: permissionAfterRemoval
            }
        }
    };
};
const $b511d8481b97f032$export$f7c0e1c7a2575f28 = (teamId, memberId, permissions)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        const removeMembershipResponse = await (0, $2Ixyh.teamsClient).removeTeamMemberships(teamId, [
            {
                accountId: memberId
            }
        ]);
        // as we only removing 1 member at a time, it is safe to say task failed with even 1 error
        if (removeMembershipResponse.errors && removeMembershipResponse.errors.length) throw Error('Membership claims to be removed but was not');
        if (state.teamMembers.teamId !== teamId) return;
        const nextState = $b511d8481b97f032$export$87a89dfcfcd29512(state, memberId, permissions);
        setState(nextState);
    };

});

parcelRegister("4A4KA", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbe45bc0c1dcc395$export$2e2bcd8739ae039);

var $2Ixyh = parcelRequire("2Ixyh");
const $bbe45bc0c1dcc395$var$getAllTeams = (allTeamsQuery, keepExistingData)=>async ({ getState: getState, setState: setState })=>{
        if (!keepExistingData) setState({
            allTeamsData: {
                teams: [],
                isLoading: true,
                hasError: false,
                cursor: ''
            }
        });
        try {
            const { teams: newTeams, cursor: cursor } = await (0, $2Ixyh.teamsClient).getAllTeams(allTeamsQuery);
            setState({
                allTeamsData: {
                    teams: [
                        ...getState().allTeamsData.teams,
                        ...newTeams
                    ],
                    isLoading: false,
                    hasError: false,
                    cursor: cursor
                }
            });
        } catch (e) {
            setState({
                allTeamsData: {
                    isLoading: false,
                    hasError: true,
                    teams: [],
                    cursor: '',
                    errorStatusCode: e.status
                }
            });
        }
    };
var $bbe45bc0c1dcc395$export$2e2bcd8739ae039 = $bbe45bc0c1dcc395$var$getAllTeams;

});


parcelRegister("crDAB", function(module, exports) {

$parcel$export(module.exports, "useV3OrgIdStatus", () => $01473f0ff6fd762a$export$52558c271a487a01);
$parcel$export(module.exports, "verifyTeamsInSameOrgIfNeeded", () => $01473f0ff6fd762a$export$61f31a8e9c589b24);

var $cprXC = parcelRequire("cprXC");

var $1lfNR = parcelRequire("1lfNR");

var $aVe3r = parcelRequire("aVe3r");
function $01473f0ff6fd762a$export$52558c271a487a01() {
    const [{ orgId: orgId }] = (0, $1lfNR.useOrg)();
    return {
        orgId: orgId,
        isOrgLoading: !orgId
    };
}
function $01473f0ff6fd762a$export$61f31a8e9c589b24(teams, analytics, queryName, currentOrgId) {
    if (!currentOrgId) return;
    const orgARI = `ari:cloud:platform::org/${currentOrgId}`;
    const invalidTeams = teams.filter((team)=>!team.includesYou && team.orgId !== currentOrgId && team.orgId !== orgARI);
    if (invalidTeams.length) {
        const logTeamsData = invalidTeams.map((t)=>({
                teamId: t.id,
                orgId: t.orgId
            }));
        analytics.pushOperationalEvent({
            source: (0, $cprXC.AnalyticsEventSource).CLIENT_METRICS,
            actionSubject: 'TeamOrgMismatch',
            action: (0, $cprXC.AnalyticsEventActions).FAILED,
            attributes: {
                currentOrgId: currentOrgId,
                queryName: queryName
            }
        });
        (0, $aVe3r.logErrorMessage)('TeamOrgMismatch', {
            currentOrgId: currentOrgId,
            teams: logTeamsData
        });
    }
}

});

parcelRegister("eW0E0", function(module, exports) {

$parcel$export(module.exports, "useQueryLight", () => $1d7ec9cbf0852d60$export$153654f6c7880a35);
$parcel$export(module.exports, "useLazyQueryLight", () => $1d7ec9cbf0852d60$export$3309ae9fea8ae473);

var $5uXOq = parcelRequire("5uXOq");

var $1c8Um = parcelRequire("1c8Um");

var $ajpes = parcelRequire("ajpes");

var $j3BP9 = parcelRequire("j3BP9");

var $jP0Fy = parcelRequire("jP0Fy");

var $386Ww = parcelRequire("386Ww");
const $1d7ec9cbf0852d60$var$transformError = ({ error: error, graphQLErrors: graphQLErrors })=>{
    const reducedGraphqlErrorMessage = graphQLErrors && graphQLErrors.reduce((acc, gqlError)=>acc + (acc ? '\n' : '') + (gqlError.message ? gqlError.message : ''), '');
    const reducedGraphqlErrorName = graphQLErrors && graphQLErrors.reduce((acc, gqlError)=>acc + (acc ? '\n' : '') + (gqlError.name ? gqlError.name : ''), '');
    return new (0, $386Ww.UseQueryLightError)(// Network error would lead to no graphqlErrors as the query would not be fired. Hence at the front.
    error?.message || reducedGraphqlErrorMessage || 'Unknown error', error?.name || reducedGraphqlErrorName, // graphQLErrors in Apollo error is empty array when there is no error.
    // So we follow the same to make sure error handlers are working as expected.
    graphQLErrors || [], error);
};
const $1d7ec9cbf0852d60$export$153654f6c7880a35 = (query, options)=>{
    const [loading, setLoading] = (0, $5uXOq.useState)(true);
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    const [data, setData] = (0, $5uXOq.useState)(undefined);
    const variablesRef = (0, $5uXOq.useRef)(options.variables);
    // Need this to deep compare variables to avoid infinite loops in useEffect
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(variablesRef.current, options.variables)) variablesRef.current = options.variables;
    // Initial fetch, and refetch
    const fetchData = (0, $5uXOq.useCallback)(async ()=>{
        try {
            setLoading(true);
            const response = await (0, $j3BP9.fetchWithExponentialBackoff)(`${options.serviceUrl}?q=${options.operationName}`, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    ...options.customHeaders
                }),
                credentials: 'include',
                body: JSON.stringify({
                    query: (0, $1c8Um.print)(query),
                    variables: {
                        ...variablesRef.current
                    }
                })
            });
            const responseData = await response.json();
            if (response.ok) {
                if (responseData.errors) setError($1d7ec9cbf0852d60$var$transformError({
                    graphQLErrors: responseData.errors
                }));
                setData(responseData.data);
                setLoading(false);
            } else throw new Error(`Generic fetch error within useQueryLight, status ${response.status}`);
        } catch (error) {
            if (error instanceof Error) setError($1d7ec9cbf0852d60$var$transformError({
                error: error
            }));
            else {
                setError($1d7ec9cbf0852d60$var$transformError({
                    error: new Error('Unknown error')
                }));
                (0, $jP0Fy.logException)(error, `useQueryLight - ${options.operationName}`);
            }
            setData(undefined);
            setLoading(false);
        }
    }, [
        query,
        options.serviceUrl,
        options.operationName,
        options.customHeaders
    ]);
    // Fetch more
    const fetchMore = (0, $5uXOq.useCallback)(async ({ variables: variables, handleDataMerge: handleDataMerge })=>{
        try {
            // reset errors to catch new ones
            setError(undefined);
            const response = await (0, $j3BP9.fetchWithExponentialBackoff)(`${options.serviceUrl}?q=${options.operationName}`, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    ...options.customHeaders
                }),
                credentials: 'include',
                body: JSON.stringify({
                    query: (0, $1c8Um.print)(query),
                    variables: {
                        ...variablesRef.current,
                        ...variables
                    }
                })
            });
            const responseData = await response.json();
            if (response.ok) {
                if (responseData.errors) setError($1d7ec9cbf0852d60$var$transformError({
                    graphQLErrors: responseData.errors
                }));
                setData((prevData)=>handleDataMerge(prevData, responseData.data));
            } else throw new Error(`Generic fetch error within useQueryLight, status ${response.status}`);
        } catch (error) {
            if (error instanceof Error) setError($1d7ec9cbf0852d60$var$transformError({
                error: error
            }));
            else {
                setError($1d7ec9cbf0852d60$var$transformError({
                    error: new Error('Unknown error')
                }));
                (0, $jP0Fy.logException)(error, `useQueryLight fetchMore - ${options.operationName}`);
            }
        }
    }, [
        query,
        options.serviceUrl,
        options.operationName,
        options.customHeaders
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!options.skip) fetchData();
        else setLoading(false);
    }, [
        options.skip,
        variablesRef.current
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        loading: loading,
        error: error,
        data: data,
        refetch: fetchData,
        fetchMore: fetchMore
    };
};
const $1d7ec9cbf0852d60$export$3309ae9fea8ae473 = (query, options)=>{
    const [fetchTriggered, setFetchTriggered] = (0, $5uXOq.useState)(false);
    const { loading: loading, error: error, data: data, refetch: refetch, fetchMore: fetchMore } = $1d7ec9cbf0852d60$export$153654f6c7880a35(query, {
        ...options,
        skip: !fetchTriggered
    });
    const triggerFetch = (0, $5uXOq.useCallback)(()=>{
        setFetchTriggered(true);
    }, []);
    return [
        triggerFetch,
        {
            loading: loading,
            error: error,
            data: data,
            refetch: refetch,
            fetchMore: fetchMore
        }
    ];
};

});
parcelRegister("386Ww", function(module, exports) {

$parcel$export(module.exports, "UseQueryLightError", () => $183cf0807d7c466c$export$a1c33d09dbc37a86);
var $183cf0807d7c466c$export$fe4bb20808298551 = /*#__PURE__*/ function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
    return ErrorCategory;
}({});
class $183cf0807d7c466c$export$7f29b23735f2fedd extends Error {
    constructor(message){
        super(message);
        this.message = message;
    }
}
class $183cf0807d7c466c$export$a1c33d09dbc37a86 extends Error {
    constructor(message, name, graphQLErrors, networkError, extensions, extraInfo){
        super(message);
        this.graphQLErrors = graphQLErrors;
        this.networkError = networkError;
        this.extensions = extensions;
        this.extraInfo = extraInfo;
        if (name) this.name = name;
    }
}

});


parcelRegister("bMJzL", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a82ff6c572ec75c$export$2e2bcd8739ae039);

var $5cllN = parcelRequire("5cllN");
var $8a82ff6c572ec75c$export$2e2bcd8739ae039 = (0, $5cllN.default)`
	query teamSearchV2(
		$first: Int
		$after: String
		$organizationId: ID!
		$query: String = ""
		$memberIds: [ID] = []
		$sortBy: [TeamSort]
		$siteId: String!
		$showEmptyTeams: Boolean = false
	) {
		team {
			teamSearch: teamSearchV2(
				first: $first
				after: $after
				organizationId: $organizationId
				filter: { query: $query, membership: { memberIds: $memberIds } }
				sortBy: $sortBy
				siteId: $siteId
				showEmptyTeams: $showEmptyTeams
			) @optIn(to: ["Team-search-v2"]) {
				nodes {
					...TeamNodeV2
				}
				pageInfo {
					hasNextPage
					endCursor
				}
			}
		}
	}

	fragment TeamNodeV2 on TeamSearchResultV2 {
		team {
			id
			organizationId
			membershipSettings
			description
			displayName
			state
			largeAvatarImageUrl
			smallAvatarImageUrl
			largeHeaderImageUrl
			smallHeaderImageUrl
			isVerified
			members {
				nodes {
					member {
						id
						accountStatus
						name
						picture
					}
				}
			}
		}
		memberCount
		includesYou
	}
`;

});

parcelRegister("hxit3", function(module, exports) {

$parcel$export(module.exports, "ApolloError", () => $253a33297d5bf248$export$26a337512320b8c6);
$parcel$export(module.exports, "sortBy", () => $253a33297d5bf248$export$b035e44d7bb4278f);
class $253a33297d5bf248$export$26a337512320b8c6 extends Error {
    constructor(message, graphQLErrors, networkError, extraInfo, type){
        super(message);
        this.message = message;
        this.graphQLErrors = graphQLErrors;
        this.networkError = networkError;
        this.extraInfo = extraInfo;
        this.type = type;
    }
}
const $253a33297d5bf248$export$b035e44d7bb4278f = [
    {
        field: 'DISPLAY_NAME',
        order: 'ASC'
    }
];

});


parcelRegister("czPkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc67c11bc2efa9d0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $dc67c11bc2efa9d0$var$InfiniteScroller = ({ hasMore: hasMore, children: children, loadMore: loadMore, loader: loader, isLoading: isLoading })=>{
    const loadMoreRef = (0, $5uXOq.useRef)(null);
    const fetchMoreCallback = (0, $5uXOq.useCallback)(([loadMoreEntry])=>{
        // Automatically load more data when our invisible "load more" div is within the viewport
        if (loadMoreEntry.isIntersecting && hasMore && !isLoading) loadMore();
    }, [
        loadMore,
        hasMore,
        isLoading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const intersectionObserver = new IntersectionObserver(fetchMoreCallback);
        if (loadMoreRef.current) intersectionObserver.observe(loadMoreRef.current);
        return ()=>{
            intersectionObserver.disconnect();
        };
    }, [
        loadMoreRef,
        fetchMoreCallback
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            children,
            hasMore && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ref: loadMoreRef
            }),
            hasMore && loader
        ]
    });
};
var $dc67c11bc2efa9d0$export$2e2bcd8739ae039 = $dc67c11bc2efa9d0$var$InfiniteScroller;

});

parcelRegister("bnXIR", function(module, exports) {

$parcel$export(module.exports, "AboutContent", () => $37c557ba4a3876db$export$8197a708459a0877);
$parcel$export(module.exports, "EmptyState", () => $37c557ba4a3876db$export$fddf379e22a74b00);
$parcel$export(module.exports, "AboutSectionTitle", () => $37c557ba4a3876db$export$c9a3ce67560199a2);
$parcel$export(module.exports, "AboutItemList", () => $37c557ba4a3876db$export$b7e7108d011c572b);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
const $37c557ba4a3876db$export$8197a708459a0877 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1m5ose4-0"
})``;
const $37c557ba4a3876db$export$fddf379e22a74b00 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1m5ose4-1"
})`display:flex;flex-direction:column;align-items:center;width:200px;margin:${"var(--ds-space-500, 40px)"} auto ${"var(--ds-space-200, 16px)"};text-align:center;p{margin-top:${"var(--ds-space-400, 32px)"};}`;
const $37c557ba4a3876db$export$c9a3ce67560199a2 = /*#__PURE__*/ (0, $47bDC.default).h2.withConfig({
    componentId: "sc-1m5ose4-2"
})`font:${"var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin-top:${"var(--ds-space-300, 24px)"};margin-bottom:${"var(--ds-space-200, 16px)"};`;
const $37c557ba4a3876db$export$b7e7108d011c572b = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1m5ose4-3"
})`>:not(:last-child){margin-bottom:${"var(--ds-space-050, 4px)"};}`;

});

parcelRegister("dqipP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d04f22589fd92075$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $fHpHg = parcelRequire("fHpHg");

var $2Eqc8 = parcelRequire("2Eqc8");

var $5uGNN = parcelRequire("5uGNN");

var $1Jq1o = parcelRequire("1Jq1o");

var $6X789 = parcelRequire("6X789");

var $aXZMp = parcelRequire("aXZMp");

var $k1CuZ = parcelRequire("k1CuZ");

var $if6u9 = parcelRequire("if6u9");
const $d04f22589fd92075$var$findMemberText = (isCurrentUser, team)=>{
    let messageData;
    if (isCurrentUser) messageData = (0, $k1CuZ.messages).membersPlain;
    else messageData = team.includesYou ? (0, $k1CuZ.messages).membersIncludingYou : (0, $k1CuZ.messages).membersPlain;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        ...messageData,
        values: {
            memberCount: team.memberCount
        }
    });
};
function $d04f22589fd92075$export$2e2bcd8739ae039(props) {
    const { team: team, isCurrentUser: isCurrentUser, index: index, onClick: onClick } = props;
    const handleClick = (0, $5uXOq.useCallback)((e)=>{
        if (onClick) onClick(e, index);
    }, [
        index,
        onClick
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aXZMp.default), {
        teamId: team.id,
        trigger: "hover",
        triggerLinkType: "none",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Jq1o.StyledOutlineLink), {
            onClick: handleClick,
            href: `team/${team.id}`,
            tabIndex: 0,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)($if6u9.TeamsProfileItemWrapper, {
                tabIndex: -1,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)($if6u9.TeamsProfileItemAvatar, {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6X789.default), {
                            teamId: team.id,
                            avatarUrl: team.smallAvatarImageUrl
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)($if6u9.TeamsProfileItemBody, {
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2Eqc8.default), {
                                alignBlock: "center",
                                children: [
                                    /*#__PURE__*/ (0, $2OMIu.jsx)($if6u9.TeamsProfileItemTeamName, {
                                        children: team.displayName
                                    }),
                                    team.isVerified && (0, $fHpHg.fg)('verified-icon-directory') && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uGNN.VerifiedTeamIcon), {
                                        showTooltip: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)($if6u9.TeamsProfileItemTeamMembers, {
                                children: $d04f22589fd92075$var$findMemberText(isCurrentUser, team)
                            })
                        ]
                    })
                ]
            })
        })
    });
}

});
parcelRegister("1Jq1o", function(module, exports) {

$parcel$export(module.exports, "StyledOutlineLink", () => $31fcf791c8f96f92$export$2311a2c1c380abc1);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");


var $5CtC2 = parcelRequire("5CtC2");
const $31fcf791c8f96f92$export$2311a2c1c380abc1 = /*#__PURE__*/ (0, $47bDC.default)((0, $5CtC2.default)).withConfig({
    componentId: "bs9apg-0"
})`display:block;background-color:${`var(--ds-surface, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`};border:none;padding:0;&:hover{background-color:${`var(--ds-background-neutral-subtle-hovered, ${(0, $a7f8c6b391092279$export$e655ef011c4aa1a2)})`};cursor:pointer;border-radius:${"var(--ds-border-radius-100, 3px)"};}&:focus{background-color:${`var(--ds-background-neutral-subtle-hovered, ${(0, $a7f8c6b391092279$export$e655ef011c4aa1a2)})`};outline:none;box-shadow:0 0 0 2px ${`var(--ds-border-focused, ${(0, $a7f8c6b391092279$export$ecfc1dff386a3e7a)})`};border-radius:${"var(--ds-border-radius-100, 3px)"};transition:box-shadow 0.2s ease-in-out;}&:active{background-color:${`var(--ds-background-neutral-subtle-pressed, ${(0, $a7f8c6b391092279$export$e655ef011c4aa1a2)})`};}> *:focus{outline:none;}`;

});

parcelRegister("6X789", function(module, exports) {

$parcel$export(module.exports, "default", () => $c417fc4a759ff31c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $cFwjb = parcelRequire("cFwjb");

var $1pNOY = parcelRequire("1pNOY");

var $54eq5 = parcelRequire("54eq5");

var $4gBDy = parcelRequire("4gBDy");
const $c417fc4a759ff31c$var$TeamAvatarLegacy = ({ avatarUrl: avatarUrl, teamId: teamId })=>{
    const [hasError, setError] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        setError(false);
    }, [
        avatarUrl,
        teamId
    ]);
    if (hasError) return /*#__PURE__*/ (0, $2OMIu.jsx)($4gBDy.GradientImage, {
        gradientValues: (0, $54eq5.getColorFromString)(teamId)
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($4gBDy.Image, {
        src: avatarUrl,
        onError: ()=>setError(true),
        alt: ""
    });
};
function $c417fc4a759ff31c$export$49e1e29e42184983(props) {
    if ((0, $fHpHg.fg)('enable-team-avatar-switch')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cFwjb.default), {
        src: props.avatarUrl,
        size: "small"
    });
    if ((0, $fHpHg.fg)('use_consistent_default_gradient_component')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1pNOY.TeamAvatar), {
        ...props
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($c417fc4a759ff31c$var$TeamAvatarLegacy, {
        ...props
    });
}
var $c417fc4a759ff31c$export$2e2bcd8739ae039 = $c417fc4a759ff31c$export$49e1e29e42184983;

});
parcelRegister("1pNOY", function(module, exports) {

$parcel$export(module.exports, "TeamAvatar", () => $29209d6b5ceefd19$export$49e1e29e42184983);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $2s57o = parcelRequire("2s57o");

var $cFwjb = parcelRequire("cFwjb");

var $1d936 = parcelRequire("1d936");

var $g0ZLP = parcelRequire("g0ZLP");

var $iuOle = parcelRequire("iuOle");
const $29209d6b5ceefd19$var$fallbackStyle = (0, $2s57o.xcss)({
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    margin: 'space.025'
});
const $29209d6b5ceefd19$export$49e1e29e42184983 = ({ avatarUrl: avatarUrl, teamId: teamId, size: size = 'small' })=>{
    const [hasError, setError] = (0, $5uXOq.useState)(false);
    const [hasLoaded, setLoaded] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        setError(false);
        setLoaded(false);
    }, [
        avatarUrl,
        teamId
    ]);
    if (hasError) return (0, $fHpHg.fg)('use_consistent_default_gradient_component') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g0ZLP.FallbackGradient), {
        stringToHash: teamId,
        customStyles: $29209d6b5ceefd19$var$fallbackStyle
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($iuOle.GradientImage, {
        gradientValues: (0, $1d936.getColorFromString)(teamId)
    });
    return (0, $fHpHg.fg)('enable-team-avatar-switch') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cFwjb.default), {
        size: size,
        src: avatarUrl
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($iuOle.Image, {
        src: avatarUrl,
        onError: ()=>setError(true),
        onLoad: ()=>setLoaded(true),
        hasLoaded: hasLoaded,
        alt: ""
    });
};

});
parcelRegister("1d936", function(module, exports) {

$parcel$export(module.exports, "getColorFromString", () => $e49b7445cccc7a7c$export$137ec5185b12f5a2);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
const $e49b7445cccc7a7c$var$gradients = [
    `270deg, ${(0, $a7f8c6b391092279$export$1ce2d1575d444ceb)} 0%, ${(0, $a7f8c6b391092279$export$5f71e19f3a7ad9de)} 100%`,
    `270deg, ${(0, $a7f8c6b391092279$export$4b84fd0e2c617bd)} 0%, ${(0, $a7f8c6b391092279$export$be802dd0d8b57f35)} 100%`,
    `270deg, ${(0, $a7f8c6b391092279$export$363e4475840015bb)} 0%, ${(0, $a7f8c6b391092279$export$4b0a4417ed59760f)} 100%`,
    `270deg, ${(0, $a7f8c6b391092279$export$226de0355ed012f8)} 0%, ${(0, $a7f8c6b391092279$export$ecfc1dff386a3e7a)} 100%`,
    `270deg, ${(0, $a7f8c6b391092279$export$7a8f4d33f6f9772c)} 0%, ${(0, $a7f8c6b391092279$export$776c9c497ef08533)} 100%`,
    `270deg, ${(0, $a7f8c6b391092279$export$8a6341c32b6a3ee6)} 0%, ${(0, $a7f8c6b391092279$export$afbce1382ec95f73)} 100%`,
    `270deg, ${(0, $a7f8c6b391092279$export$41060a744ab0b7ae)} 0%, ${(0, $a7f8c6b391092279$export$5aae31392d72caaa)} 100%`
];
const $e49b7445cccc7a7c$export$d41d9ab3de2def3d = (str)=>{
    let hash = 0;
    let chr;
    let i;
    for(i = 0; i < str.length; i++){
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
};
const $e49b7445cccc7a7c$export$1ca062359344df12 = (id)=>{
    return $e49b7445cccc7a7c$export$489ac0f4353bcbd0(id, $e49b7445cccc7a7c$var$gradients.length);
};
const $e49b7445cccc7a7c$export$489ac0f4353bcbd0 = (id, arrayLength)=>{
    if (!id) return 0;
    const ordinal = ($e49b7445cccc7a7c$export$d41d9ab3de2def3d(id) % 50).toString()// split string into character array
    .split('')// map to array of charCodes of each character
    .map((chr)=>chr.charCodeAt(0))// add up all charCodes in the array
    .reduce((a, b)=>a + b, 0);
    return ordinal % arrayLength;
};
const $e49b7445cccc7a7c$export$137ec5185b12f5a2 = (str)=>{
    const index = $e49b7445cccc7a7c$export$1ca062359344df12(str);
    return $e49b7445cccc7a7c$var$gradients[index];
};

});

parcelRegister("g0ZLP", function(module, exports) {

$parcel$export(module.exports, "FallbackGradient", () => $7c51a3540fd4604b$export$358466f81685c10c);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $3ZbIY = parcelRequire("3ZbIY");

var $5P9wt = parcelRequire("5P9wt");
const $7c51a3540fd4604b$var$styles = (0, $2s57o.xcss)({
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    overflow: 'hidden'
});
const $7c51a3540fd4604b$var$gradientStyles = (0, $3ZbIY.gradients).map((gradient)=>(0, $2s57o.xcss)({
        backgroundImage: `linear-gradient(${gradient})`
    }));
function $7c51a3540fd4604b$export$358466f81685c10c(props) {
    const gradientIndex = (0, $5uXOq.useMemo)(()=>(0, $5P9wt.getGradientIndexByString)(props.stringToHash), [
        props.stringToHash
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
        xcss: [
            $7c51a3540fd4604b$var$styles,
            $7c51a3540fd4604b$var$gradientStyles[gradientIndex],
            ...Array.isArray(props.customStyles) ? props.customStyles : [
                props.customStyles
            ]
        ],
        testId: "profile-header-image-default",
        children: props.children
    });
}

});
parcelRegister("3ZbIY", function(module, exports) {

$parcel$export(module.exports, "gradients", () => $9295ddfc2ecd0230$export$fc5727d09955ec17);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
const $9295ddfc2ecd0230$export$fc5727d09955ec17 = [
    `270deg, ${(0, $a7f8c6b391092279$export$1ce2d1575d444ceb)} 0%, ${(0, $a7f8c6b391092279$export$5f71e19f3a7ad9de)} 100%`,
    `270deg, ${(0, $a7f8c6b391092279$export$4b84fd0e2c617bd)} 0%, ${(0, $a7f8c6b391092279$export$be802dd0d8b57f35)} 100%`,
    `270deg, ${(0, $a7f8c6b391092279$export$363e4475840015bb)} 0%, ${(0, $a7f8c6b391092279$export$4b0a4417ed59760f)} 100%`,
    `270deg, ${(0, $a7f8c6b391092279$export$226de0355ed012f8)} 0%, ${(0, $a7f8c6b391092279$export$ecfc1dff386a3e7a)} 100%`,
    `270deg, ${(0, $a7f8c6b391092279$export$7a8f4d33f6f9772c)} 0%, ${(0, $a7f8c6b391092279$export$776c9c497ef08533)} 100%`,
    `270deg, ${(0, $a7f8c6b391092279$export$8a6341c32b6a3ee6)} 0%, ${(0, $a7f8c6b391092279$export$afbce1382ec95f73)} 100%`,
    `270deg, ${(0, $a7f8c6b391092279$export$41060a744ab0b7ae)} 0%, ${(0, $a7f8c6b391092279$export$5aae31392d72caaa)} 100%`
];

});

parcelRegister("5P9wt", function(module, exports) {

$parcel$export(module.exports, "getGradientIndexByString", () => $3c022147d5460bab$export$47d4d34461987b5d);

var $3ZbIY = parcelRequire("3ZbIY");
// Code to generate index number from ids is taken from:
// src/master/src/static/gradients/README.md
/**
 * Generate 32bit integer from given string
 */ const $3c022147d5460bab$var$hashCode = (str)=>{
    let hash = 0;
    let chr;
    let i;
    for(i = 0; i < str.length; i++){
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
};
const $3c022147d5460bab$export$47d4d34461987b5d = (id)=>{
    if (!id) return 0;
    const ordinal = ($3c022147d5460bab$var$hashCode(id) % 50).toString()// split string into character array
    .split('')// map to array of charCodes of each character
    .map((chr)=>chr.charCodeAt(0))// add up all charCodes in the array
    .reduce((a, b)=>a + b, 0);
    return ordinal % (0, $3ZbIY.gradients).length;
};
const $3c022147d5460bab$export$137ec5185b12f5a2 = (str)=>{
    const index = $3c022147d5460bab$export$47d4d34461987b5d(str);
    return (0, $3ZbIY.gradients)[index];
};

});


parcelRegister("iuOle", function(module, exports) {

$parcel$export(module.exports, "GradientImage", () => $c2bf3fd8602c6c71$export$cf9c515a80d2f7a4);
$parcel$export(module.exports, "Image", () => $c2bf3fd8602c6c71$export$3e431a229df88919);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation (causes type issues)
const $c2bf3fd8602c6c71$var$commonCss = /*#__PURE__*/ (0, $47bDC.css)`width:24px;height:24px;border-radius:50%;margin:${"var(--ds-space-025, 2px)"};display:flex;`;
const $c2bf3fd8602c6c71$export$cf9c515a80d2f7a4 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1vmhbf4-0"
})`${$c2bf3fd8602c6c71$var$commonCss};background-image:linear-gradient(${(props)=>props.gradientValues});`;
const $c2bf3fd8602c6c71$export$3e431a229df88919 = /*#__PURE__*/ (0, $47bDC.default).img.withConfig({
    componentId: "sc-1vmhbf4-1"
})`${$c2bf3fd8602c6c71$var$commonCss};opacity:${(props)=>props.hasLoaded ? 1 : 0};`;

});


parcelRegister("54eq5", function(module, exports) {

$parcel$export(module.exports, "getColorFromString", () => $fa7d70c498fda131$export$137ec5185b12f5a2);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
const $fa7d70c498fda131$var$gradients = [
    `270deg, ${(0, $a7f8c6b391092279$export$1ce2d1575d444ceb)} 0%, ${(0, $a7f8c6b391092279$export$5f71e19f3a7ad9de)} 100%`,
    `270deg, ${(0, $a7f8c6b391092279$export$4b84fd0e2c617bd)} 0%, ${(0, $a7f8c6b391092279$export$be802dd0d8b57f35)} 100%`,
    `270deg, ${(0, $a7f8c6b391092279$export$363e4475840015bb)} 0%, ${(0, $a7f8c6b391092279$export$4b0a4417ed59760f)} 100%`,
    `270deg, ${(0, $a7f8c6b391092279$export$226de0355ed012f8)} 0%, ${(0, $a7f8c6b391092279$export$ecfc1dff386a3e7a)} 100%`,
    `270deg, ${(0, $a7f8c6b391092279$export$7a8f4d33f6f9772c)} 0%, ${(0, $a7f8c6b391092279$export$776c9c497ef08533)} 100%`,
    `270deg, ${(0, $a7f8c6b391092279$export$8a6341c32b6a3ee6)} 0%, ${(0, $a7f8c6b391092279$export$afbce1382ec95f73)} 100%`,
    `270deg, ${(0, $a7f8c6b391092279$export$41060a744ab0b7ae)} 0%, ${(0, $a7f8c6b391092279$export$5aae31392d72caaa)} 100%`
];
const $fa7d70c498fda131$export$d41d9ab3de2def3d = (str)=>{
    let hash = 0;
    let chr;
    let i;
    for(i = 0; i < str.length; i++){
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
};
const $fa7d70c498fda131$export$1ca062359344df12 = (id)=>{
    if (!id) return 0;
    const ordinal = ($fa7d70c498fda131$export$d41d9ab3de2def3d(id) % 50).toString()// split string into character array
    .split('')// map to array of charCodes of each character
    .map((chr)=>chr.charCodeAt(0))// add up all charCodes in the array
    .reduce((a, b)=>a + b, 0);
    return ordinal % $fa7d70c498fda131$var$gradients.length;
};
const $fa7d70c498fda131$export$137ec5185b12f5a2 = (str)=>{
    const index = $fa7d70c498fda131$export$1ca062359344df12(str);
    return $fa7d70c498fda131$var$gradients[index];
};

});

parcelRegister("4gBDy", function(module, exports) {

$parcel$export(module.exports, "GradientImage", () => $8b145f71b0c2b38c$export$cf9c515a80d2f7a4);
$parcel$export(module.exports, "Image", () => $8b145f71b0c2b38c$export$3e431a229df88919);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @repo/internal/styles/use-emotion, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
const $8b145f71b0c2b38c$var$commonCss = /*#__PURE__*/ (0, $47bDC.css)`width:24px;height:24px;border-radius:50%;margin:${"var(--ds-space-025, 2px)"};display:flex;`;
const $8b145f71b0c2b38c$export$cf9c515a80d2f7a4 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-3e4kix-0"
})`${$8b145f71b0c2b38c$var$commonCss};background-image:linear-gradient(${(props)=>props.gradientValues});`;
const $8b145f71b0c2b38c$export$3e431a229df88919 = /*#__PURE__*/ (0, $47bDC.default).img.withConfig({
    componentId: "sc-3e4kix-1"
})`${$8b145f71b0c2b38c$var$commonCss};`;

});


parcelRegister("aXZMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $1032aefdcc5c3c09$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ah6f8 = parcelRequire("ah6f8");

var $1geG0 = parcelRequire("1geG0");
var $a4jrI = parcelRequire("a4jrI");
var $crDAB = parcelRequire("crDAB");

var $cKrzW = parcelRequire("cKrzW");

var $2iRRL = parcelRequire("2iRRL");

var $5vx1F = parcelRequire("5vx1F");
var $kQ0fM = parcelRequire("kQ0fM");
function $1032aefdcc5c3c09$export$2e2bcd8739ae039(props) {
    const { children: children, onClick: onClick, position: position = 'bottom-start', trigger: trigger = 'hover', triggerLinkType: triggerLinkType = 'link', teamId: teamId } = props;
    const [{ cloudId: cloudId }] = (0, $a4jrI.useSite)();
    const addFlag = (0, $kQ0fM.useFlags)();
    const { contextEntryPoint: contextEntryPoint, push: push } = (0, $5vx1F.useAppConfig)();
    const profileClient = (0, $cKrzW.useProfileClient)();
    const [{ principalUserId: principalUserId }] = (0, $1geG0.usePrincipalUser)();
    const { orgId: orgId, isOrgLoading: isOrgLoading } = (0, $crDAB.useV3OrgIdStatus)();
    const navigateToTeam = (0, $5uXOq.useCallback)(()=>push(`team/${teamId}`), [
        push,
        teamId
    ]);
    const generateUserLink = (0, $5uXOq.useCallback)((userId)=>(0, $2iRRL.prefixWithContextEntryPoint)(userId, contextEntryPoint), [
        contextEntryPoint
    ]);
    const onUserClick = (0, $5uXOq.useCallback)((userId)=>push(userId), [
        push
    ]);
    if (isOrgLoading) return children;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ah6f8.default), {
        position: position,
        orgId: orgId,
        teamId: teamId,
        resourceClient: profileClient,
        viewingUserId: principalUserId,
        trigger: trigger,
        triggerLinkType: triggerLinkType,
        viewProfileLink: (0, $2iRRL.prefixWithContextEntryPoint)(`team/${teamId}`, contextEntryPoint),
        viewProfileOnClick: onClick || navigateToTeam,
        generateUserLink: generateUserLink,
        onUserClick: onUserClick,
        addFlag: addFlag,
        cloudId: cloudId,
        children: children
    });
}

});
parcelRegister("ah6f8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d28d6c03e0d40319$export$2e2bcd8739ae039);
// Do not export TeamProfileCard here as it will break lazy-loading for the team trigger.


var $g9igA = parcelRequire("g9igA");
var $d28d6c03e0d40319$export$2e2bcd8739ae039 = (0, $g9igA.default);

});
parcelRegister("g9igA", function(module, exports) {

$parcel$export(module.exports, "default", () => $43cbafbd59d30991$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $3TR0I = parcelRequire("3TR0I");

var $lEwUf = parcelRequire("lEwUf");
var $g9EwJ = parcelRequire("g9EwJ");

var $fHpHg = parcelRequire("fHpHg");

var $vCqQa = parcelRequire("vCqQa");

var $0yZbT = parcelRequire("0yZbT");

var $b4a3S = parcelRequire("b4a3S");

var $EHfmh = parcelRequire("EHfmh");

var $3DrJx = parcelRequire("3DrJx");

var $jQ0hK = parcelRequire("jQ0hK");

var $g4Mqd = parcelRequire("g4Mqd");


var $1P8ZX = parcelRequire("1P8ZX");

var $eDMo7 = parcelRequire("eDMo7");

var $9qNo5 = parcelRequire("9qNo5");

var $kMZDI = parcelRequire("kMZDI");
class $43cbafbd59d30991$export$f811dc569217c959 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.defaultProps = {
            actions: [],
            trigger: 'hover',
            position: 'bottom-start',
            triggerLinkType: 'link',
            shouldRenderToParent: true
        };
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentDidUpdate(prevProps) {
        const { orgId: orgId, teamId: teamId, resourceClient: resourceClient } = this.props;
        const { visible: visible } = this.state;
        // just re-fetching data when the card opens
        if (visible && (teamId !== prevProps.teamId || orgId !== prevProps.orgId || resourceClient !== prevProps.resourceClient)) this.setState({
            isLoading: undefined
        }, this.clientFetchProfile);
    }
    componentWillUnmount() {
        this._isMounted = false;
        clearTimeout(this.showTimer);
        clearTimeout(this.hideTimer);
    }
    handleClientSuccess(team, shouldShowGiveKudos, teamCentralBaseUrl) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: false,
            data: team,
            shouldShowGiveKudos: shouldShowGiveKudos,
            teamCentralBaseUrl: teamCentralBaseUrl
        });
    }
    handleClientError(err) {
        if (!this._isMounted) return;
        this.setState({
            isLoading: false,
            hasError: true,
            error: err
        });
    }
    filterActions() {
        const actions = (0, $EHfmh.default)(this.props.actions, this.state.data);
        if (this.state.shouldShowGiveKudos) {
            const kudosAction = {
                label: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $3DrJx.default).giveKudosButton
                }),
                id: 'give-kudos',
                callback: ()=>{
                    this.openKudosDrawer();
                },
                link: this.kudosUrl()
            };
            return actions.concat([
                kudosAction
            ]);
        }
        return actions;
    }
    renderPopup() {
        if (this.state.renderError) return this.props.children;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eDMo7.ErrorBoundary), {
            onError: this.onErrorBoundary,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $vCqQa.default), {
                isOpen: !!this.state.visible,
                onClose: this.onClose,
                placement: this.props.position,
                content: this.renderProfileCard,
                trigger: (triggerProps)=>this.renderTrigger(triggerProps),
                zIndex: (0, $b4a3S.layers).modal(),
                shouldFlip: true,
                autoFocus: this.props.trigger !== 'hover' && !this.openedByHover,
                shouldRenderToParent: (0, $fHpHg.fg)('enable_appropriate_reading_order_in_profile_card') && this.props.shouldRenderToParent
            })
        });
    }
    render() {
        if (this.props.children) return this.renderPopup();
        else throw new Error('Component "TeamProfileCardTrigger" must have "children" property');
    }
    constructor(...args){
        super(...args), this._isMounted = false, this.showTimer = 0, this.hideTimer = 0, this.openedByHover = false, this.openTime = 0, this.fireAnalytics = (payload)=>{
            // Don't fire any analytics if the component is unmounted
            if (!this._isMounted) return;
            if (this.props.createAnalyticsEvent) (0, $jQ0hK.fireEvent)(this.props.createAnalyticsEvent, payload);
        }, this.fireAnalyticsWithDuration = (generator)=>{
            const event = generator((0, $1P8ZX.getPageTime)() - this.openTime);
            this.fireAnalytics(event);
        }, this.hideProfilecard = (delay = 0)=>{
            clearTimeout(this.showTimer);
            clearTimeout(this.hideTimer);
            this.hideTimer = window.setTimeout(()=>{
                this.setState({
                    visible: false
                });
            }, delay);
        }, this.showProfilecard = (delay = 0)=>{
            clearTimeout(this.hideTimer);
            clearTimeout(this.showTimer);
            this.showTimer = window.setTimeout(()=>{
                if (!this.state.visible) {
                    this.clientFetchProfile();
                    this.openTime = (0, $1P8ZX.getPageTime)();
                    this.setState({
                        visible: true
                    });
                }
            }, delay);
        }, this.onClick = (event)=>{
            if (this.props.triggerLinkType === 'link') // We want to prevent navigation occurring on basic click, but it's important that
            // cmd+click, ctrl+click, etc. still work as expected.
            {
                if ((0, $g4Mqd.isBasicClick)(event)) event.preventDefault();
            }
            if (this.props.triggerLinkType === 'clickable-link') {
                if (this.props.viewProfileOnClick) this.props.viewProfileOnClick(event);
            }
            if (this.props.trigger !== 'hover') {
                this.openedByHover = false;
                this.showProfilecard(0);
                if (!this.state.visible) this.fireAnalytics((0, $jQ0hK.cardTriggered)('team', 'click'));
            }
        }, this.onMouseEnter = ()=>{
            if (this.props.trigger === 'click') return;
            if (!this.state.visible) {
                this.openedByHover = true;
                this.fireAnalytics((0, $jQ0hK.cardTriggered)('team', 'hover'));
            }
            this.showProfilecard((0, $4f9eb78cf9cb8ede$export$5b956b542f1bc1b3));
        }, this.onMouseLeave = ()=>{
            if (this.props.trigger === 'click') return;
            if (this.openedByHover) this.hideProfilecard((0, $4f9eb78cf9cb8ede$export$89a9f35a94d7f196));
        }, this.onKeyPress = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isTriggeredByKeyboard: true
                });
                this.showProfilecard(0);
                if (!this.state.visible) this.fireAnalytics((0, $jQ0hK.cardTriggered)('team', 'click'));
            }
        }, this.onClose = ()=>{
            this.hideProfilecard();
            this.setState({
                isTriggeredByKeyboard: false
            });
        }, this.openKudosDrawer = ()=>{
            this.hideProfilecard((0, $4f9eb78cf9cb8ede$export$89a9f35a94d7f196));
            this.setState({
                kudosDrawerOpen: true
            });
        }, this.closeKudosDrawer = ()=>{
            this.setState({
                kudosDrawerOpen: false
            });
        }, this.kudosUrl = ()=>{
            const recipientId = this.props.teamId && `&recipientId=${this.props.teamId}` || '';
            const cloudId = this.props.cloudId && `&cloudId=${this.props.cloudId}` || '';
            return `${this.state.teamCentralBaseUrl}/kudos/give?type=team${recipientId}${cloudId}`;
        }, this.stopPropagation = (event)=>{
            // We need to stop propagation when users click on the card, so that it
            // doesn't trigger any special effects that occur when clicking the trigger.
            event.stopPropagation();
        }, this.triggerListeners = {
            onClick: this.onClick,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        }, this.cardListeners = {
            onClick: this.stopPropagation,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        }, this.state = {
            visible: false,
            isLoading: undefined,
            hasError: false,
            error: null,
            data: null,
            shouldShowGiveKudos: false,
            teamCentralBaseUrl: undefined,
            kudosDrawerOpen: false,
            isTriggeredByKeyboard: false
        }, this.clientFetchProfile = ()=>{
            const { orgId: orgId, teamId: teamId } = this.props;
            const { isLoading: isLoading } = this.state;
            if (isLoading === true) // don't fetch data when fetching is in process
            return;
            this.setState({
                isLoading: true,
                data: null
            }, ()=>{
                const fireEvent = (event)=>{
                    this.fireAnalytics(event);
                };
                const requests = Promise.all([
                    this.props.resourceClient.getTeamProfile(teamId, orgId, fireEvent),
                    this.props.resourceClient.shouldShowGiveKudos(),
                    this.props.resourceClient.getTeamCentralBaseUrl({
                        withOrgContext: true,
                        withSiteContext: true
                    })
                ]);
                requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
            });
        }, this.onErrorBoundary = ()=>{
            this.fireAnalytics((0, $jQ0hK.profileCardRendered)('team', 'errorBoundary', {
                duration: 0
            }));
            this.setState({
                renderError: true
            });
        }, this.renderProfileCard = ()=>{
            const { generateUserLink: generateUserLink, onUserClick: onUserClick, viewingUserId: viewingUserId, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick } = this.props;
            const { data: data, error: error, hasError: hasError, isLoading: isLoading } = this.state;
            const newProps = {
                clientFetchProfile: this.clientFetchProfile,
                actions: this.filterActions(),
                analytics: this.fireAnalyticsWithDuration,
                team: data || undefined,
                generateUserLink: generateUserLink,
                onUserClick: onUserClick,
                viewingUserId: viewingUserId,
                viewProfileLink: viewProfileLink,
                viewProfileOnClick: viewProfileOnClick
            };
            return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ...this.cardListeners,
                children: this.state.visible && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                    fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kMZDI.default), {
                        analytics: this.fireAnalyticsWithDuration
                    }),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9qNo5.TeamProfileCardLazy), {
                        ...newProps,
                        isLoading: isLoading,
                        hasError: hasError,
                        errorType: error,
                        isTriggeredByKeyboard: this.state.isTriggeredByKeyboard
                    })
                })
            });
        }, this.renderKudosLauncher = ()=>{
            return this.state.shouldShowGiveKudos && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lEwUf.GiveKudosLauncherLazy), {
                    isOpen: this.state.kudosDrawerOpen,
                    recipient: {
                        type: (0, $g9EwJ.KudosType).TEAM,
                        recipientId: this.props.teamId
                    },
                    analyticsSource: "team-profile-card",
                    teamCentralBaseUrl: this.state.teamCentralBaseUrl,
                    cloudId: this.props.cloudId || '',
                    addFlag: this.props.addFlag,
                    onClose: this.closeKudosDrawer
                })
            });
        }, this.renderTrigger = (triggerProps)=>{
            const { children: children, intl: intl, triggerLinkType: triggerLinkType, viewProfileLink: viewProfileLink } = this.props;
            if (triggerLinkType === 'none') return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    this.renderKudosLauncher(),
                    (0, $fHpHg.fg)('enable_team_profilecard_toggletip_a11y_fix') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                        as: "span",
                        role: "button",
                        testId: "team-profilecard-trigger-wrapper",
                        tabIndex: 0,
                        "aria-label": intl.formatMessage((0, $3DrJx.default).teamProfileCardAriaLabel),
                        onKeyUp: this.onKeyPress,
                        ...triggerProps,
                        ...this.triggerListeners,
                        children: children
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        "data-testid": "team-profilecard-trigger-wrapper",
                        ...triggerProps,
                        ...this.triggerListeners,
                        children: children
                    })
                ]
            });
            return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    this.renderKudosLauncher(),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("a", {
                        "data-testid": "team-profilecard-trigger-wrapper",
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            color: 'initial',
                            textDecoration: 'none'
                        },
                        href: viewProfileLink,
                        ...triggerProps,
                        ref: triggerProps.ref,
                        ...this.triggerListeners,
                        children: children
                    })
                ]
            });
        };
    }
}
var $43cbafbd59d30991$export$2e2bcd8739ae039 = (0, $3TR0I.default)()((0, $8RXs9.default)($43cbafbd59d30991$export$f811dc569217c959));

});
parcelRegister("3DrJx", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a440b6b1eac1ef2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $8a440b6b1eac1ef2$var$messages = (0, $7VHMR.defineMessages)({
    inactiveAccountMsg: {
        id: 'pt.profile-card.inactive.account',
        defaultMessage: 'Account deactivated',
        description: 'A text in a grey lozenge shows that this user is inactive'
    },
    generalDescMsgForDisabledUser: {
        id: 'pt.profile-card.general.msg.disabled.user',
        defaultMessage: 'You can no longer collaborate with this person.',
        description: 'A first sentence of a long text explains this user is inactive/closed'
    },
    inactiveAccountDescMsgNoDate: {
        id: 'pt.profile-card.inactive.account.no.date',
        defaultMessage: 'Their account has been deactivated.',
        description: 'A long text explains this user is inactive when we do not know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: 'pt.profile-card.inactive.account.has.date.this.week',
        defaultMessage: 'Their account was deactivated this week.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: 'pt.profile-card.inactive.account.has.date.this.month',
        defaultMessage: 'Their account was deactivated this month.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: 'pt.profile-card.inactive.account.has.date.last.month',
        defaultMessage: 'Their account was deactivated last month.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: 'pt.profile-card.inactive.account.has.date.a.few.months',
        defaultMessage: 'Their account has been deactivated for a few months.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: 'pt.profile-card.inactive.account.has.date.several.months',
        defaultMessage: 'Their account has been deactivated for several months.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: 'pt.profile-card.inactive.account.has.date.more.than.a.year',
        defaultMessage: 'Their account has been deactivated for more than a year.',
        description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
    },
    closedAccountMsg: {
        id: 'pt.profile-card.closed.account',
        defaultMessage: 'Account deleted',
        description: 'A text in a grey lozenge shows that this user is closed/deleted'
    },
    closedAccountDescMsgNoDate: {
        id: 'pt.profile-card.closed.account.no.date',
        defaultMessage: 'Their account has been deleted.',
        description: 'A long text explains this user is closed when we do not know the date of starting to close'
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: 'pt.profile-card.closed.account.has.date.this.week',
        defaultMessage: 'Their account was deleted this week.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: 'pt.profile-card.closed.account.has.date.this.month',
        defaultMessage: 'Their account was deleted this month.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: 'pt.profile-card.closed.account.has.date.last.month',
        defaultMessage: 'Their account was deleted last month.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: 'pt.profile-card.closed.account.has.date.a.few.months',
        defaultMessage: 'Their account has been deleted for a few months.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: 'pt.profile-card.closed.account.has.date.several.months',
        defaultMessage: 'Their account has been deleted for several months.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: 'pt.profile-card.closed.account.has.date.more.than.a.year',
        defaultMessage: 'Their account has been deleted for more than a year.',
        description: 'A long text explains this user is closed when we know the date of starting to close'
    },
    disabledAccountDefaultName: {
        id: 'pt.profile-card.disabled.account.default.name',
        defaultMessage: 'Former user',
        description: 'A default name when we cannot get name of an inactive or closed user'
    },
    teamViewProfile: {
        id: 'pt.team-profile-card.team.action.view-profile',
        defaultMessage: 'View profile',
        description: "Button that takes you to view this team\u2019s profile"
    },
    memberCount: {
        id: 'pt.team-profile-card.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team'
    },
    memberCountIncludingYou: {
        id: 'pt.team-profile-card.team.member.count-including-you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team and highlight that the user is a member'
    },
    membersMoreThan50: {
        id: 'pt.team-profile-card.team.member.many',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the team has more than 50 members'
    },
    membersMoreThan50IncludingYou: {
        id: 'pt.team-profile-card.team.member.many-including-you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the team has more than 50 members and highlight that the user is a member'
    },
    teamErrorTitle: {
        id: 'pt.team-profile-card.error.title',
        defaultMessage: "We\u2019re having trouble retrieving this teams information",
        description: 'Title for an error view explaining that data for this team cannot be accessed'
    },
    teamErrorText: {
        id: 'pt.team-profile-card.error.suggestion',
        defaultMessage: 'Wait a few moments, then try again.',
        description: 'Second line suggesting how to fix the issue'
    },
    teamErrorButton: {
        id: 'pt.team-profile-card.error.refresh-button',
        defaultMessage: 'Try again',
        description: 'Text on a button that will try to get the data again when clicked'
    },
    teamForbiddenErrorStateTitle: {
        id: 'pt.team-profile-card.forbidden-error-state.title',
        defaultMessage: "We can\u2019t show you this team",
        description: 'Title for the error state that is displayed when a user lacks access to the team'
    },
    teamForbiddenErrorStateDescription: {
        id: 'pt.team-profile-card.forbidden-error-state.description',
        defaultMessage: "You don\u2019t have access to view this team.",
        description: 'Description for the error state that is displayed when a user lacks access to the team'
    },
    managerSectionHeading: {
        id: 'pt.team-profile-card.manager.heading',
        defaultMessage: 'Manager',
        description: "Title for a section on the profile card that show the user's direct manager"
    },
    directReportsSectionHeading: {
        id: 'pt.team-profile-card.directReports.heading',
        defaultMessage: 'Direct reports',
        description: "Title for a section on the profile card that show the user's direct reports"
    },
    teamProfileCardAriaLabel: {
        id: 'pt.team-profile-card.aria-label',
        defaultMessage: 'More information about this team',
        description: 'Aria label for the team profile card'
    },
    giveKudosButton: {
        id: 'pt.profile-card.give-kudos',
        defaultMessage: 'Give kudos',
        description: 'Title for the button on the profile card for a user to give a kudos'
    },
    profileCardMoreIconLabel: {
        id: 'pt.profile-card.more-icon-label',
        defaultMessage: 'More',
        description: 'Label for the meatballs icon on the profile card, which when clicked will provide more options'
    },
    profileCardMoreReportingLinesLabel: {
        id: 'pt.user-profile-card.reporting-lines.more-icon-label',
        defaultMessage: '+{count} more {count, plural, one {profile} other {profiles}}',
        description: 'Label for the "more profiles" indicator in the reporting lines section of the user profile card'
    },
    profileCardMoreMembersLabel: {
        id: 'pt.team.profile-card.members.more-icon-label',
        defaultMessage: '+{count} more {count, plural, one {members} other {members}}',
        description: 'Label for the "more members" indicator in the members section of the team profile card'
    }
});
var $8a440b6b1eac1ef2$export$2e2bcd8739ae039 = $8a440b6b1eac1ef2$var$messages;

});

parcelRegister("g4Mqd", function(module, exports) {

$parcel$export(module.exports, "isBasicClick", () => $e3093b8b25a4e7a8$export$eddcd8a5b7e09991);
const $e3093b8b25a4e7a8$export$eddcd8a5b7e09991 = (event)=>{
    return !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

});

parcelRegister("eDMo7", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $d5afcdb7b4152906$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");
class $d5afcdb7b4152906$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch() {
        // Failure analytics here too
        this.props.onError();
    }
    render() {
        return this.props.children;
    }
}
var $d5afcdb7b4152906$export$2e2bcd8739ae039 = $d5afcdb7b4152906$export$e926676385687eaf;

});

parcelRegister("9qNo5", function(module, exports) {

$parcel$export(module.exports, "TeamProfileCardLazy", () => $c6fd9e0220b77ffd$export$82a49d896f41ca78);

var $5uXOq = parcelRequire("5uXOq");

const $c6fd9e0220b77ffd$export$82a49d896f41ca78 = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("jeEMK")));

});
parcelRegister("jeEMK", function(module, exports) {

let $e00ef6390dfe786b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e00ef6390dfe786b$var$load("ajINL").then(()=>parcelRequire('iY9BQ'));

});


parcelRegister("kMZDI", function(module, exports) {

$parcel$export(module.exports, "default", () => $90113ddcb9e4bff1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $clxo5 = parcelRequire("clxo5");

var $6g0KK = parcelRequire("6g0KK");

var $jQ0hK = parcelRequire("jQ0hK");
var $90113ddcb9e4bff1$export$2e2bcd8739ae039 = (props)=>{
    const { analytics: analytics } = props;
    (0, $5uXOq.useEffect)(()=>{
        analytics((duration)=>(0, $jQ0hK.profileCardRendered)('team', 'spinner', {
                duration: duration
            }));
    }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $6g0KK.CardWrapper), {
        testId: "team-profilecard",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6g0KK.CardHeader), {
                isLoading: true
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6g0KK.CardContent), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6g0KK.LoadingWrapper), {
                    testId: "team-profilecard-spinner",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {})
                })
            })
        ]
    });
};

});
parcelRegister("6g0KK", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $5f2b9e73ca8b4dfc$export$6aa22a823032b784);
$parcel$export(module.exports, "TeamForbiddenErrorStateWrapper", () => $5f2b9e73ca8b4dfc$export$66ecf3d3b7b1c016);
$parcel$export(module.exports, "CardHeader", () => $5f2b9e73ca8b4dfc$export$5665775b26e26c5d);
$parcel$export(module.exports, "CardContent", () => $5f2b9e73ca8b4dfc$export$64ef9b8c11710c47);
$parcel$export(module.exports, "TeamName", () => $5f2b9e73ca8b4dfc$export$8fe6f0aed18a58c7);
$parcel$export(module.exports, "MemberCount", () => $5f2b9e73ca8b4dfc$export$1cbd03a20253b620);
$parcel$export(module.exports, "AvatarSection", () => $5f2b9e73ca8b4dfc$export$82a6f3ee677bdbfe);
$parcel$export(module.exports, "DescriptionWrapper", () => $5f2b9e73ca8b4dfc$export$2bf1f2b0d31b60fc);
$parcel$export(module.exports, "Description", () => $5f2b9e73ca8b4dfc$export$393edc798c47379d);
$parcel$export(module.exports, "ActionButtons", () => $5f2b9e73ca8b4dfc$export$88c65d2d98aab183);
$parcel$export(module.exports, "WrappedButton", () => $5f2b9e73ca8b4dfc$export$44e087c32db6077d);
$parcel$export(module.exports, "MoreButton", () => $5f2b9e73ca8b4dfc$export$7f94856880993f27);
$parcel$export(module.exports, "LoadingWrapper", () => $5f2b9e73ca8b4dfc$export$43a792a870d28db2);
$parcel$export(module.exports, "AccessLockSVGWrapper", () => $5f2b9e73ca8b4dfc$export$71bcd744fda975e5);
/* TeamCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6tzHJ = parcelRequire("6tzHJ");

var $bWfiu = parcelRequire("bWfiu");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");
var $k9nuy = parcelRequire("k9nuy");


var $b4a3S = parcelRequire("b4a3S");

var $efqyt = parcelRequire("efqyt");

var $dCOB1 = parcelRequire("dCOB1");

var $bWGt6 = parcelRequire("bWGt6");
function $5f2b9e73ca8b4dfc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5f2b9e73ca8b4dfc$var$styles = {
    cardtriggerwrapper: "_1e0c1kw7",
    cardwrapper: "_2rkoglpi _1bsbnklw _kqswh2mm",
    teamforbiddenerrorstatewrapper: "_1bsbnklw _kqswh2mm",
    cardheader: "_4t3i1qr7 _1bsb1osq",
    cardcontent: "_1e0c1txw _2lx21bp4 _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _1tke1l8a",
    teamname: "_11c8lodh _1reo15vq _18m915vq _1p1dglyw _c71lckbl _1e0ccj1k",
    membercount: "_syaz1wmz _19pk1b66",
    avatarsection: "_19pkpxbi _18u01i6y",
    descriptionwrapper: "_19pkpxbi _4cvr1h6o _1e0c1txw",
    description: "_1reo15vq _18m915vq _c71l1wqb _1e0ccj1k",
    actionbuttons: "_1bsb1osq _1e0c1txw _1bah1yb4 _19pk1ejb _2hwx10v4 _otyridpf _18u0x0bf",
    wrappedbutton: "_i0dlidpf _16jlkb7n _18u0u2gc",
    morebutton: "_18u0u2gc",
    loadingwrapper: "_y3gn1h6o _19pk1jfw _otyr1jfw",
    accesslocksvgwrapper: "_otyr1ejb"
};
const $5f2b9e73ca8b4dfc$export$a443be8291b92497 = ()=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.cardtriggerwrapper)
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$CardTriggerWrapperLegacy, {}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$CardTriggerWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q14"
})({
    name: "ck88l6",
    styles: "display:inherit"
});
const $5f2b9e73ca8b4dfc$export$6aa22a823032b784 = ({ testId: testId, children: children })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.cardwrapper),
        backgroundColor: "elevation.surface.overlay",
        testId: testId,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$CardWrapperLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$CardWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q13"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: (0, $efqyt.bgColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $b4a3S.borderRadius)()}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: '320px',
    position: 'relative',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale'
});
const $5f2b9e73ca8b4dfc$export$66ecf3d3b7b1c016 = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.teamforbiddenerrorstatewrapper),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$TeamForbiddenErrorStateWrapperLegacy, {
        "data-testid": props.testId,
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$TeamForbiddenErrorStateWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q12"
})({
    name: "14xkrbi",
    styles: "width:320px;position:relative"
});
const $5f2b9e73ca8b4dfc$export$5665775b26e26c5d = ({ image: image, isLoading: isLoading, label: label })=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? isLoading || !image ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.cardheader),
        backgroundColor: "color.background.neutral"
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dCOB1.CoverImage), {
        alt: label || '',
        src: image
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$CardHeaderLegacy, {
        image: image,
        isLoading: isLoading
    }); // eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$CardHeaderLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q11"
})("background-color:", (props)=>props.isLoading ? `var(--ds-background-neutral, ${0, $a7f8c6b391092279$export$9fdfb749e33cdf97})` : props.image ? '' : (0, $efqyt.teamHeaderBgColor), ";background-image:", (props)=>props.image ? `url(${props.image})` : '', ";background-repeat:no-repeat;background-position:center;background-size:cover;box-sizing:content-box;height:128px;");
const $5f2b9e73ca8b4dfc$export$64ef9b8c11710c47 = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.cardcontent),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$CardContentLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$CardContentLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q10"
})({
    name: "1rjz27l",
    styles: "display:flex;flex-direction:column;padding:var(--ds-space-300, 24px);min-height:104px"
});
const $5f2b9e73ca8b4dfc$export$8fe6f0aed18a58c7 = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? (0, $fHpHg.fg)('enable_profilecard_h2tag_a11y_fix') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.teamname),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
            size: "medium",
            as: "h2",
            children: props.children
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.teamname),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$TeamNameLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$TeamNameLegacy = /*#__PURE__*/ (0, $bWGt6.default)("h6", {
    target: "e14jp07q9"
})({
    name: "1ms0od4",
    styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);text-transform:none;overflow:hidden;max-height:48px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical"
});
const $5f2b9e73ca8b4dfc$export$1cbd03a20253b620 = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.membercount),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$MemberCountLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$MemberCountLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q8"
})({
    color: `var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$f563ee71e9ee74cd)})`,
    marginTop: "var(--ds-space-050, 4px)"
});
const $5f2b9e73ca8b4dfc$export$82a6f3ee677bdbfe = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.avatarsection),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$AvatarSectionLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/use-primitives -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$AvatarSectionLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q7"
})({
    name: "li9rw7",
    styles: "margin-top:var(--ds-space-200, 16px);margin-left:var(--ds-space-negative-025, -2px)"
});
const $5f2b9e73ca8b4dfc$export$2bf1f2b0d31b60fc = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.descriptionwrapper),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$DescriptionWrapperLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$DescriptionWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q6"
})({
    name: "vi4bqq",
    styles: "margin-top:var(--ds-space-200, 16px);align-items:center;display:flex"
});
const $5f2b9e73ca8b4dfc$export$393edc798c47379d = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.description),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
            maxLines: 3,
            ...props
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$DescriptionLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$DescriptionLegacy = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "e14jp07q5"
})({
    name: "yog5y2",
    styles: "overflow:hidden;max-height:60px;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical"
});
const $5f2b9e73ca8b4dfc$export$88c65d2d98aab183 = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.actionbuttons),
        backgroundColor: "elevation.surface.overlay",
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$ActionButtonsLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$ActionButtonsLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q4"
})({
    width: 'calc(100% + 8px)',
    display: 'flex',
    justifyContent: 'space-between',
    margin: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-negative-300, -24px)"} 0 ${"var(--ds-space-negative-100, -8px)"}`,
    backgroundColor: "var(--ds-surface-overlay, hsla(0, 100%, 100%, 0.2))"
});
const $5f2b9e73ca8b4dfc$export$44e087c32db6077d = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.wrappedbutton),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$WrappedButtonLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$WrappedButtonLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q3"
})({
    name: "1svotkm",
    styles: "flex-basis:0;flex-grow:1;margin-left:var(--ds-space-100, 8px)"
});
const $5f2b9e73ca8b4dfc$export$7f94856880993f27 = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.morebutton),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$MoreButtonLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/use-primitives -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$MoreButtonLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q2"
})({
    name: "9kivhj",
    styles: "margin-left:var(--ds-space-100, 8px)"
});
const $5f2b9e73ca8b4dfc$export$43a792a870d28db2 = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.loadingwrapper),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$LoadingWrapperLegacy, {
        "data-testid": props.testId,
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$LoadingWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q1"
})({
    name: "o13o72",
    styles: "text-align:center;margin-top:var(--ds-space-500, 40px)"
});
const $5f2b9e73ca8b4dfc$export$71bcd744fda975e5 = (props)=>(0, $fHpHg.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: (0, $6tzHJ.cx)($5f2b9e73ca8b4dfc$var$styles.accesslocksvgwrapper),
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)($5f2b9e73ca8b4dfc$var$AccessLockSVGWrapperLegacy, {
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/use-primitives -- Ignored via go/DSP-18766
const $5f2b9e73ca8b4dfc$var$AccessLockSVGWrapperLegacy = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e14jp07q0"
})({
    name: "ifz8jz",
    styles: "margin-bottom:var(--ds-space-300, 24px)"
});

});
parcelRegister("dCOB1", function(module, exports) {

$parcel$export(module.exports, "CoverImage", () => $dda6dae762a2b7aa$export$a65e282337ff0f53);
/* CoverImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5sRpy = parcelRequire("5sRpy");
const $dda6dae762a2b7aa$var$styles = {
    container: "_1reo15vq _18m915vq _1bsb1osq _4t3i1qr7 _kqswh2mm _13liglpi _qrwqglpi _1e0c1txw _1bah1h6o _4cvr1h6o",
    image: "_1bsbnklw _4t3i1wug"
};
const $dda6dae762a2b7aa$export$a65e282337ff0f53 = ({ src: src, alt: alt = '' })=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const imgRef = (0, $5uXOq.useRef)(null);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        ref: containerRef,
        xcss: $dda6dae762a2b7aa$var$styles.container,
        backgroundColor: "color.background.neutral",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
            as: "img",
            ref: imgRef,
            src: src,
            alt: alt,
            xcss: $dda6dae762a2b7aa$var$styles.image
        })
    });
};

});





parcelRegister("cKrzW", function(module, exports) {

$parcel$export(module.exports, "useProfileClient", () => $95c0cd06559e0df2$export$d43dc22a8337ee9f);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $7VfBo = parcelRequire("7VfBo");

var $glY8Q = parcelRequire("glY8Q");

var $971Nd = parcelRequire("971Nd");

var $5vx1F = parcelRequire("5vx1F");
const $95c0cd06559e0df2$var$CACHE_MAX_AGE = 60000;
function $95c0cd06559e0df2$var$currentClientMatchesConfig(state, enableTeamCentral, cloudId) {
    if (!state.profileClient) return false;
    return state.enableTeamCentral === enableTeamCentral && state.cloudId === cloudId;
}
const $95c0cd06559e0df2$var$actions = {
    getClient: ()=>({ getState: getState, dispatch: dispatch })=>{
            const currentClient = getState().profileClient;
            if (currentClient) return currentClient;
            return dispatch($95c0cd06559e0df2$var$actions.createClient());
        },
    createClient: (enableTeamCentral = false, cloudId = 'None', productName = '')=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            if ($95c0cd06559e0df2$var$currentClientMatchesConfig(currentState, enableTeamCentral, cloudId)) return currentState.profileClient;
            // Immediately save config to avoid re-create loop
            setState({
                enableTeamCentral: enableTeamCentral,
                cloudId: cloudId
            });
            const { stargateRoot: stargateRoot } = (0, $971Nd.getConfig)();
            const profileClient = new (0, $7VfBo.default)({
                gatewayGraphqlUrl: `${stargateRoot}/graphql`,
                url: `${stargateRoot}/directory/graphql`,
                teamCentralDisabled: !enableTeamCentral,
                cacheSize: 20,
                cacheMaxAge: $95c0cd06559e0df2$var$CACHE_MAX_AGE,
                cloudId: cloudId,
                productIdentifier: productName.toLowerCase()
            });
            setState({
                profileClient: profileClient
            });
            return profileClient;
        }
};
const $95c0cd06559e0df2$var$ProfileClientStore = (0, $iXqE5.createStore)({
    initialState: {
        enableTeamCentral: false,
        cloudId: 'None'
    },
    actions: $95c0cd06559e0df2$var$actions
});
const $95c0cd06559e0df2$var$useProfileClientState = (0, $3sQ5x.createHook)($95c0cd06559e0df2$var$ProfileClientStore);
const $95c0cd06559e0df2$export$d43dc22a8337ee9f = ()=>{
    const [{ hasWorkspace: hasWorkspace, orgHasWorkspace: orgHasWorkspace }] = (0, $glY8Q.useTeamCentralStore)();
    const [state, { getClient: getClient, createClient: createClient }] = $95c0cd06559e0df2$var$useProfileClientState();
    const { cloudId: cloudId, productName: productName } = (0, $5vx1F.useAppConfig)();
    const enableTeamCentral = hasWorkspace || orgHasWorkspace;
    (0, $5uXOq.useEffect)(()=>{
        if (!$95c0cd06559e0df2$var$currentClientMatchesConfig(state, enableTeamCentral, cloudId)) // re-create the client
        createClient(enableTeamCentral, cloudId, productName);
    }, [
        createClient,
        enableTeamCentral,
        state,
        cloudId,
        productName
    ]);
    return getClient();
};

});

parcelRegister("kQ0fM", function(module, exports) {

$parcel$export(module.exports, "useFlags", () => $e65fd592cfee3a11$export$2879604e6aec4ab);

var $5uXOq = parcelRequire("5uXOq");

var $358cZ = parcelRequire("358cZ");

var $5vx1F = parcelRequire("5vx1F");
const $e65fd592cfee3a11$export$2879604e6aec4ab = ()=>{
    const { addFlag: addFlag } = (0, $5uXOq.useContext)((0, $5vx1F.default));
    const analytics = (0, $358cZ.default)();
    const addFlagWithAnalytics = (flag, analyticsEvent)=>{
        if (analyticsEvent?.sendAnalytics) analytics.pushScreenEvent({
            name: analyticsEvent.name
        });
        addFlag(flag);
    };
    return addFlagWithAnalytics;
};

});


parcelRegister("k1CuZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3d8f1ac03ffeeb00$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $3d8f1ac03ffeeb00$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    membersPlain: {
        id: 'ptc-directory.user-profile-page.about.teams.item.members.plain',
        defaultMessage: '{memberCount, number} {memberCount, plural, one {member} other {members}}',
        description: 'Either the number of members your team has when you are viewing your own profile, or someone elses team that you are not a member of'
    },
    membersIncludingYou: {
        id: 'ptc-directory.user-profile-page.about.teams.item.members.including.you',
        defaultMessage: '{memberCount, number} {memberCount, plural, one {member, including you} other {members, including you}}',
        description: 'The number of team members, when viewing someone elses profile and you are also a member'
    },
    createTeamLabel: {
        id: 'ptc-directory.team-profile-page.create.team.button',
        defaultMessage: 'Create a team',
        description: 'Label of the CTA to create a new team. It is located in the list of teams a user is already a member of'
    },
    createTeamLabelOtherPeople: {
        id: 'ptc-directory.team-profile-page.create.team.button.other-people',
        defaultMessage: 'Create a team together',
        description: 'Label of the CTA to create a new team with other people. It is located in the list of teams a user is already a member of'
    }
});

});

parcelRegister("if6u9", function(module, exports) {

$parcel$export(module.exports, "OutlineLink", () => $82609d0598082e73$export$5749dbf81b0a6091);
$parcel$export(module.exports, "TeamsProfileItemWrapper", () => $82609d0598082e73$export$dfa3a67150a99336);
$parcel$export(module.exports, "TeamsProfileItemAvatar", () => $82609d0598082e73$export$5b03fe4ece786130);
$parcel$export(module.exports, "TeamsProfileAddIcon", () => $82609d0598082e73$export$e26c34d851c862e3);
$parcel$export(module.exports, "TeamsProfileItemBody", () => $82609d0598082e73$export$6dae78c6213b453c);
$parcel$export(module.exports, "TeamsProfileItemTeamName", () => $82609d0598082e73$export$14cef269f8b93bc1);
$parcel$export(module.exports, "TeamsProfileItemTeamMembers", () => $82609d0598082e73$export$b7842987d4a39270);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");


var $1Jq1o = parcelRequire("1Jq1o");

var $34mB5 = parcelRequire("34mB5");
const $82609d0598082e73$export$5749dbf81b0a6091 = (0, $1Jq1o.StyledOutlineLink).withComponent('button');
const $82609d0598082e73$export$dfa3a67150a99336 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-8junt6-0"
})`display:flex;flex-basis:auto;${(0, $34mB5.ellipsisInFlexChild)} height:${"var(--ds-space-500, 40px)"};align-items:center;`;
const $82609d0598082e73$export$5b03fe4ece786130 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-8junt6-1"
})`display:flex;padding-right:${"var(--ds-space-100, 8px)"};`;
const $82609d0598082e73$export$99f8df7d064294cc = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-8junt6-2"
})`display:flex;padding-right:${"var(--ds-space-100, 8px)"};margin:0px ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"};`;
const $82609d0598082e73$export$e26c34d851c862e3 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-8junt6-3"
})`display:flex;padding-right:${"var(--ds-space-100, 8px)"};margin:${"var(--ds-space-025, 2px)"};`;
const $82609d0598082e73$export$6dae78c6213b453c = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-8junt6-4"
})`display:flex;flex-flow:column;flex-basis:auto;${(0, $34mB5.ellipsisInFlexChild)};`;
const $82609d0598082e73$export$14cef269f8b93bc1 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-8junt6-5"
})`font:${"var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};padding-bottom:${"var(--ds-space-025, 2px)"};flex-basis:auto;${(0, $34mB5.ellipsisInFlexChild)} color:${`var(--ds-text, ${(0, $a7f8c6b391092279$export$7d61b15e0da132af)})`};`;
const $82609d0598082e73$export$b7842987d4a39270 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-8junt6-6"
})`font:${"var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};color:${`var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$7c87d337fb91a97d)})`};`;

});


parcelRegister("k5NaU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dd006167e57ce60$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $cprXC = parcelRequire("cprXC");
var $358cZ = parcelRequire("358cZ");
var $d2HJp = parcelRequire("d2HJp");

var $jFFo8 = parcelRequire("jFFo8");
var $W11xX = parcelRequire("W11xX");

var $fgg17 = parcelRequire("fgg17");

var $k1CuZ = parcelRequire("k1CuZ");

var $2PdLl = parcelRequire("2PdLl");

var $if6u9 = parcelRequire("if6u9");
const $9dd006167e57ce60$var$TeamsProfileItemButton = (props)=>{
    const analytics = (0, $358cZ.default)();
    const { openDialog: openDialog } = (0, $d2HJp.useDialog)();
    const { proposedMembers: proposedMembers, source: source, isCurrentUser: isCurrentUser, isActiveUser: isActiveUser } = props;
    const { permissions: { canCreateTeams: canCreateTeams } } = (0, $W11xX.useTeamVisibility)();
    const [{ hasBrowseUsersPermission: hasBrowseUsersPermission }] = (0, $jFFo8.useSettings)();
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        // Track where trigger button is being clicked from
        analytics.pushUIEvent({
            source: (0, $cprXC.AnalyticsEventSource).CREATE_TEAM_MODAL,
            action: (0, $cprXC.AnalyticsEventActions).CLICKED,
            actionSubject: 'teamCreateDialogTriggerButton',
            attributes: {
                // Record where in the UI the modal was triggered from
                trigger: source
            }
        });
        // @ts-ignore
        openDialog((0, $fgg17.default), {
            proposedMembers: proposedMembers || []
        });
    }, [
        analytics,
        openDialog,
        proposedMembers,
        source
    ]);
    const canStartTeamWithUser = hasBrowseUsersPermission && isActiveUser && canCreateTeams;
    /**
	 * Show the button if:
	 * - it's the current user's profile page
	 * - or it's other people's profile pages and the user has permission
	 */ const showButton = isCurrentUser || !isCurrentUser && canStartTeamWithUser;
    return showButton ? /*#__PURE__*/ (0, $2OMIu.jsx)($if6u9.OutlineLink, {
        onClick: handleClick,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)($if6u9.TeamsProfileItemWrapper, {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)($if6u9.TeamsProfileAddIcon, {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2PdLl.TeamAddIcon), {})
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)($if6u9.TeamsProfileItemBody, {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($if6u9.TeamsProfileItemTeamName, {
                        children: isCurrentUser ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $k1CuZ.messages).createTeamLabel
                        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                            ...(0, $k1CuZ.messages).createTeamLabelOtherPeople
                        })
                    })
                })
            ]
        })
    }) : null;
};
var $9dd006167e57ce60$export$2e2bcd8739ae039 = $9dd006167e57ce60$var$TeamsProfileItemButton;

});
parcelRegister("jFFo8", function(module, exports) {

$parcel$export(module.exports, "useSettings", () => $7c193c8abeb4488a$export$9115b42802a3e44f);
$parcel$export(module.exports, "useSettingsFeatureFlag", () => $7c193c8abeb4488a$export$f2df9067cb58ea32);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $2Ixyh = parcelRequire("2Ixyh");

var $3xxVR = parcelRequire("3xxVR");

var $2Z5MT = parcelRequire("2Z5MT");
const $7c193c8abeb4488a$export$28456d095a642fd = 'internal.browse-users-allowed';
const $7c193c8abeb4488a$var$actions = {
    /**
	 * Fetches bup settings from pf-directory/legion service
	 * @param product - Product name.
	 * @param cloudId - Cloud Id.
	 */ getSettings: (product, cloudId)=>async ({ getState: getState, setState: setState })=>{
            if (getState().isFetching || getState().hasLoadedSettings) return;
            setState({
                isFetching: true
            });
            try {
                const directorySettingPromise = cloudId ? (0, $2Ixyh.teamsClient).querySettings(cloudId, product) : Promise.resolve({
                    [$7c193c8abeb4488a$export$28456d095a642fd]: true
                });
                return await (0, $3xxVR.promiseWithDefault)(directorySettingPromise, {
                    [$7c193c8abeb4488a$export$28456d095a642fd]: false
                }).then(({ value: browseUsersEnabled, success: settingsSuccess })=>{
                    const settingsFromRequests = {
                        // If settings cannot be accessed, default to permission denied.
                        [$7c193c8abeb4488a$export$28456d095a642fd]: false,
                        ...browseUsersEnabled
                    };
                    // Fallback as needed to compute effective flag values
                    const finalSettings = {
                        ...(0, $2Z5MT.getSettingsFromStorage)() || {},
                        ...settingsFromRequests
                    };
                    setState({
                        hasLoadedSettings: true,
                        hasErrorOnFetchSettings: !settingsSuccess,
                        hasBrowseUsersPermission: !!finalSettings[$7c193c8abeb4488a$export$28456d095a642fd],
                        settings: finalSettings
                    });
                });
            } catch  {
                setState({
                    hasErrorOnFetchSettings: true,
                    hasLoadedSettings: true
                });
            } finally{
                setState({
                    isFetching: false
                });
            }
        }
};
const $7c193c8abeb4488a$var$initialState = {
    hasLoadedSettings: false,
    hasErrorOnFetchSettings: false,
    hasBrowseUsersPermission: false,
    isFetching: false,
    settings: {
        [$7c193c8abeb4488a$export$28456d095a642fd]: false,
        ...(0, $2Z5MT.getSettingsFromStorage)() || {}
    }
};
/**
 * Manage states of settings
 */ const $7c193c8abeb4488a$var$Store = (0, $iXqE5.createStore)({
    initialState: $7c193c8abeb4488a$var$initialState,
    actions: $7c193c8abeb4488a$var$actions,
    name: 'Settings'
});
const $7c193c8abeb4488a$export$8376625f8bb18347 = (0, $gg7kZ.createContainer)($7c193c8abeb4488a$var$Store, {
    onInit: ()=>({ setState: setState }, state)=>{
            setState(state);
        }
});
const $7c193c8abeb4488a$export$9115b42802a3e44f = (0, $3sQ5x.createHook)($7c193c8abeb4488a$var$Store);
const $7c193c8abeb4488a$export$f2df9067cb58ea32 = (flagName)=>{
    const [{ settings: settings }] = $7c193c8abeb4488a$export$9115b42802a3e44f();
    return settings[flagName];
};

});

parcelRegister("fgg17", function(module, exports) {

$parcel$export(module.exports, "default", () => $37d36f704974b039$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jqBCD = parcelRequire("jqBCD");
const $37d36f704974b039$var$TeamCreateDialogLazy = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jqBCD.default), {
            ...props
        })
    });
};
var $37d36f704974b039$export$2e2bcd8739ae039 = $37d36f704974b039$var$TeamCreateDialogLazy;

});
parcelRegister("jqBCD", function(module, exports) {

$parcel$export(module.exports, "default", () => $34f9d368ff6c635b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $34f9d368ff6c635b$var$TeamCreateDialogLazyWrapper = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("7jb9f")));
var $34f9d368ff6c635b$export$2e2bcd8739ae039 = $34f9d368ff6c635b$var$TeamCreateDialogLazyWrapper;

});
parcelRegister("7jb9f", function(module, exports) {

let $5522f489c620ff5c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5522f489c620ff5c$var$load("sxA8y").then(()=>parcelRequire('6Z63D'));

});



parcelRegister("2PdLl", function(module, exports) {

$parcel$export(module.exports, "TeamAddIcon", () => $15b580e77f98c2ea$export$6972ee87109b1a65);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $15b580e77f98c2ea$export$6972ee87109b1a65 = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                y: "0.5",
                width: "24",
                height: "24",
                rx: "12",
                fill: "#F1F2F4"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "16",
                height: "16",
                transform: "translate(4 4.5)",
                fill: "white",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.6667 11.8333V9.16667C12.6667 8.98986 12.5964 8.82029 12.4714 8.69526C12.3464 8.57024 12.1768 8.5 12 8.5C11.8232 8.5 11.6536 8.57024 11.5286 8.69526C11.4036 8.82029 11.3333 8.98986 11.3333 9.16667V11.8333H8.66667C8.48986 11.8333 8.32029 11.9036 8.19526 12.0286C8.07024 12.1536 8 12.3232 8 12.5C8 12.6768 8.07024 12.8464 8.19526 12.9714C8.32029 13.0964 8.48986 13.1667 8.66667 13.1667H11.3333V15.8333C11.3333 16.0101 11.4036 16.1797 11.5286 16.3047C11.6536 16.4298 11.8232 16.5 12 16.5C12.1768 16.5 12.3464 16.4298 12.4714 16.3047C12.5964 16.1797 12.6667 16.0101 12.6667 15.8333V13.1667H15.3333C15.5101 13.1667 15.6797 13.0964 15.8047 12.9714C15.9298 12.8464 16 12.6768 16 12.5C16 12.3232 15.9298 12.1536 15.8047 12.0286C15.6797 11.9036 15.5101 11.8333 15.3333 11.8333H12.6667Z",
                fill: "#42526E"
            })
        ]
    });
};

});


parcelRegister("gQ2LQ", function(module, exports) {

$parcel$export(module.exports, "AboutTeamsList", () => $e52aa975a2e230a2$export$f8d76b4306b647d6);
$parcel$export(module.exports, "ShowMoreButton", () => $e52aa975a2e230a2$export$e41c325c8b11c297);
$parcel$export(module.exports, "ErrorContainer", () => $e52aa975a2e230a2$export$97bdf39f6b82bb0);
$parcel$export(module.exports, "ErrorTitle", () => $e52aa975a2e230a2$export$b065fd053267ec81);
$parcel$export(module.exports, "ErrorMessageWrapper", () => $e52aa975a2e230a2$export$9e874bb1adc98a55);
$parcel$export(module.exports, "ErrorIconWrapper", () => $e52aa975a2e230a2$export$b2471e0920d79944);
$parcel$export(module.exports, "ErrorMessage", () => $e52aa975a2e230a2$export$915e9e7bd4f0f96d);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $47bDC = parcelRequire("47bDC");

const $e52aa975a2e230a2$export$eb5006ed1ea4bea6 = /*#__PURE__*/ (0, $47bDC.default).h6.withConfig({
    componentId: "sc-11mcmk0-0"
})`color:${`var(--ds-text, ${(0, $a7f8c6b391092279$export$7d61b15e0da132af)})`};margin-bottom:${"var(--ds-space-200, 16px)"};`;
const $e52aa975a2e230a2$export$f8d76b4306b647d6 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-11mcmk0-1"
})`display:flex;flex-direction:column;>:not(:last-child){margin-bottom:${"var(--ds-space-050, 4px)"};}`;
const $e52aa975a2e230a2$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-11mcmk0-2"
})`margin-right:${"var(--ds-space-100, 8px)"};`;
const $e52aa975a2e230a2$export$e41c325c8b11c297 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-11mcmk0-3"
})`text-align:left;padding:${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"};`;
const $e52aa975a2e230a2$export$97bdf39f6b82bb0 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-11mcmk0-4"
})`display:flex;`;
const $e52aa975a2e230a2$export$b065fd053267ec81 = /*#__PURE__*/ (0, $47bDC.default).h5.withConfig({
    componentId: "sc-11mcmk0-5"
})`color:${`var(--ds-text, ${(0, $a7f8c6b391092279$export$7d61b15e0da132af)})`};`;
const $e52aa975a2e230a2$export$9e874bb1adc98a55 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-11mcmk0-6"
})``;
const $e52aa975a2e230a2$export$b2471e0920d79944 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-11mcmk0-7"
})`margin-right:${"var(--ds-space-100, 8px)"};`;
const $e52aa975a2e230a2$export$915e9e7bd4f0f96d = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-11mcmk0-8"
})`color:${`var(--ds-text-subtlest, ${(0, $a7f8c6b391092279$export$7c87d337fb91a97d)})`};font:${"var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};`;

});




parcelRegister("b3aog", function(module, exports) {

$parcel$export(module.exports, "AgentActions", () => $95e2e6615a2d89b0$export$a091e6fbe251d12f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $bMFGq = parcelRequire("bMFGq");
var $1Seuh = parcelRequire("1Seuh");

var $j7m8K = parcelRequire("j7m8K");
var $1eETS = parcelRequire("1eETS");
var $3jAdT = parcelRequire("3jAdT");

var $elaEw = parcelRequire("elaEw");

var $fHpHg = parcelRequire("fHpHg");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");
var $2s57o = parcelRequire("2s57o");

var $c4kDv = parcelRequire("c4kDv");

var $9N2bi = parcelRequire("9N2bi");

var $koLZ3 = parcelRequire("koLZ3");
const $95e2e6615a2d89b0$var$chatToAgentButtonContainer = (0, $2s57o.xcss)({
    width: '100%'
});
const $95e2e6615a2d89b0$var$chatToAgentButtonWrapper = (0, $2s57o.xcss)({
    display: 'flex',
    justifyContent: 'center',
    lineHeight: '20px',
    fontWeight: 'font.weight.medium'
});
const $95e2e6615a2d89b0$var$chatPillTextStyles = (0, $2s57o.xcss)({
    wordBreak: 'break-word',
    textAlign: 'left',
    whiteSpace: 'pre-wrap'
});
const $95e2e6615a2d89b0$var$chatPillIconWrapper = (0, $2s57o.xcss)({
    minWidth: '20px',
    height: '20px'
});
const $95e2e6615a2d89b0$var$buildAgentActions = ({ onDuplicateAgent: onDuplicateAgent, onCopyAgent: onCopyAgent })=>{
    return [
        {
            text: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $koLZ3.messages).actionDuplicate
            }),
            onClick: onDuplicateAgent
        },
        {
            text: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $koLZ3.messages).actionCopyLink
            }),
            onClick: onCopyAgent
        }
    ];
};
const $95e2e6615a2d89b0$var$buildAgentSettings = ({ onEditAgent: onEditAgent, onDeleteAgent: onDeleteAgent })=>{
    return [
        {
            text: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $koLZ3.messages).actionEdit
            }),
            onClick: onEditAgent
        },
        {
            text: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $koLZ3.messages).actionDelete
            }),
            onClick: onDeleteAgent
        }
    ];
};
const $95e2e6615a2d89b0$export$a091e6fbe251d12f = ({ onEditAgent: onEditAgent, onDeleteAgent: onDeleteAgent, onDuplicateAgent: onDuplicateAgent, onCopyAgent: onCopyAgent, onChatClick: onChatClick, isAgentCreatedByUser: isAgentCreatedByUser, agentId: agentId, isForgeAgent: isForgeAgent, assistanceServiceParams: assistanceServiceParams })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const agentActions = $95e2e6615a2d89b0$var$buildAgentActions({
        onDuplicateAgent: onDuplicateAgent,
        onCopyAgent: onCopyAgent
    });
    const agentSetting = $95e2e6615a2d89b0$var$buildAgentSettings({
        onEditAgent: onEditAgent,
        onDeleteAgent: onDeleteAgent
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2Eqc8.default), {
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                xcss: $95e2e6615a2d89b0$var$chatToAgentButtonContainer,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMFGq.default), {
                    shouldFitContainer: true,
                    onClick: onChatClick,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                        xcss: $95e2e6615a2d89b0$var$chatToAgentButtonWrapper,
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2Eqc8.default), {
                            space: "space.050",
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                                    xcss: $95e2e6615a2d89b0$var$chatPillIconWrapper,
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c4kDv.ChatPillIcon), {})
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                                    xcss: $95e2e6615a2d89b0$var$chatPillTextStyles,
                                    children: formatMessage((0, $koLZ3.messages).actionChatToAgent)
                                })
                            ]
                        })
                    })
                })
            }),
            (0, $fHpHg.fg)('rovo_use_agent_permissions') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9N2bi.AgentDropdownMenu), {
                agentId: agentId,
                isAgentCreatedByUser: isAgentCreatedByUser,
                isForgeAgent: isForgeAgent,
                onCopyAgent: onCopyAgent,
                onDeleteAgent: onDeleteAgent,
                onDuplicateAgent: onDuplicateAgent,
                onEditAgent: onEditAgent,
                loadPermissionsOnMount: true,
                assistanceServiceParams: assistanceServiceParams
            }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $j7m8K.default), {
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
                        ...props,
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($elaEw))),
                        label: "more",
                        ref: triggerRef
                    }),
                placement: "bottom-end",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3jAdT.default), {
                        children: agentActions.map(({ text: text, onClick: onClick }, idx)=>{
                            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1eETS.default), {
                                onClick: onClick,
                                children: text
                            }, idx);
                        })
                    }),
                    isAgentCreatedByUser && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3jAdT.default), {
                        hasSeparator: true,
                        children: agentSetting.map(({ text: text, onClick: onClick }, idx)=>{
                            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1eETS.default), {
                                onClick: onClick,
                                children: text
                            }, idx);
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("c4kDv", function(module, exports) {

$parcel$export(module.exports, "ChatPillIcon", () => $b2f302403fa3d0c4$export$38f9b635c1c454e7);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bHQe1 = parcelRequire("bHQe1");

var $aiTU0 = parcelRequire("aiTU0");
const $b2f302403fa3d0c4$export$38f9b635c1c454e7 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bHQe1))), {
        ...props,
        label: "",
        LEGACY_size: "small",
        LEGACY_fallbackIcon: (0, $aiTU0.default)
    });

});
parcelRegister("bHQe1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7997b223b163fea361e6870d11885d8e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $885c38b15d1e1cf7$var$_react = $885c38b15d1e1cf7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $885c38b15d1e1cf7$var$_baseNew = $885c38b15d1e1cf7$var$_interopRequireDefault((parcelRequire("enEmH")));
function $885c38b15d1e1cf7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiChat".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Rovo Chat.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $885c38b15d1e1cf7$var$AiChatIcon = (props)=>/*#__PURE__*/ $885c38b15d1e1cf7$var$_react.default.createElement($885c38b15d1e1cf7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2z" clip-rule="evenodd"/><path fill="currentcolor" d="M6 7.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$885c38b15d1e1cf7$var$AiChatIcon.displayName = 'AiChatIcon';
var $885c38b15d1e1cf7$var$_default = module.exports.default = $885c38b15d1e1cf7$var$AiChatIcon;

});

parcelRegister("aiTU0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0d427a8b30fef0e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ltBcH = parcelRequire("ltBcH");
const $f0d427a8b30fef0e$var$ChatIconGlyph = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M8.00023 14.25C7.86431 14.25 7.73094 14.287 7.61439 14.3569L3.75024 16.6752V14V4.99998C3.75024 4.30963 4.30988 3.74999 5.00023 3.74998L15.0002 3.74984C15.6906 3.74984 16.2502 4.30948 16.2502 4.99984V12.9999C16.2502 13.6902 15.6906 14.2498 15.0003 14.2499L8.00023 14.25Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinejoin: "round",
                fill: "transparent"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "6",
                y: "8",
                width: "2",
                height: "2",
                rx: "1",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "9",
                y: "8",
                width: "2",
                height: "2",
                rx: "1",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                x: "12",
                y: "8",
                width: "2",
                height: "2",
                rx: "1",
                fill: "currentColor"
            })
        ]
    });
/**
 * __ChatIcon__
 */ const $f0d427a8b30fef0e$var$ChatIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ltBcH.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $f0d427a8b30fef0e$var$ChatIconGlyph
    });
var $f0d427a8b30fef0e$export$2e2bcd8739ae039 = $f0d427a8b30fef0e$var$ChatIcon;

});


parcelRegister("9N2bi", function(module, exports) {

$parcel$export(module.exports, "ChatToAgentButton", () => $77f9b0226443e820$export$ffe1cf57f0b5db02);
$parcel$export(module.exports, "AgentDropdownMenu", () => $77f9b0226443e820$export$fc284fc0f7cc8f16);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bMFGq = parcelRequire("bMFGq");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");

var $42Y0q = parcelRequire("42Y0q");
var $c4kDv = parcelRequire("c4kDv");

var $1j7Rq = parcelRequire("1j7Rq");

var $c9RYv = parcelRequire("c9RYv");
const $77f9b0226443e820$var$styles = {
    chatToAgentButtonContainer: "_1bsb1osq",
    chatPillButtonInline: "_18zrv77o",
    chatPillText: "_1nmz1hna _y3gn1e5h _o5721jtm",
    chatPillIconWrapper: "_1ul9gktf _4t3igktf",
    chatToAgentButtonWrapper: "_1e0c1txw _1bah1h6o _k48p1wq8"
};
const $77f9b0226443e820$export$ffe1cf57f0b5db02 = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $77f9b0226443e820$var$styles.chatToAgentButtonContainer,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMFGq.default), {
            testId: "view-agent-modal-chat-to-agent-button",
            shouldFitContainer: true,
            onClick: onClick,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                xcss: $77f9b0226443e820$var$styles.chatToAgentButtonWrapper,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                    space: "space.050",
                    xcss: $77f9b0226443e820$var$styles.chatPillButtonInline,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                            xcss: $77f9b0226443e820$var$styles.chatPillIconWrapper,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c4kDv.ChatPillIcon), {})
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                            xcss: $77f9b0226443e820$var$styles.chatPillText,
                            children: formatMessage((0, $c9RYv.default).chatToAgentButton)
                        })
                    ]
                })
            })
        })
    });
};
const $77f9b0226443e820$export$fc284fc0f7cc8f16 = (props)=>{
    const { refetch: refetch } = (0, $1j7Rq.useAgentPermissions)({
        agentId: props.agentId,
        enabled: false,
        assistanceServiceParams: props.assistanceServiceParams
    });
    const loadAgentPermissions = (0, $5uXOq.useCallback)(async ()=>{
        const response = await refetch();
        return {
            isEditEnabled: response?.permissions.AGENT_UPDATE?.permitted ?? false,
            isDeleteEnabled: response?.permissions.AGENT_DEACTIVATE?.permitted ?? false
        };
    }, [
        refetch
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42Y0q.AgentDropdownMenu), {
        ...props,
        loadAgentPermissions: loadAgentPermissions
    });
};

});
parcelRegister("42Y0q", function(module, exports) {

$parcel$export(module.exports, "AgentDropdownMenu", () => $488cfbf54b52fa02$export$fc284fc0f7cc8f16);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $bMFGq = parcelRequire("bMFGq");
var $1Seuh = parcelRequire("1Seuh");

var $j7m8K = parcelRequire("j7m8K");
var $1eETS = parcelRequire("1eETS");
var $3jAdT = parcelRequire("3jAdT");

var $elaEw = parcelRequire("elaEw");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");

var $c4kDv = parcelRequire("c4kDv");

var $lC7nf = parcelRequire("lC7nf");
const $488cfbf54b52fa02$var$styles = {
    chatToAgentButtonContainer: "_1bsb1osq",
    chatToAgentButtonWrapper: "_1e0c1txw _1bah1h6o _k48p1wq8",
    chatPillButtonInline: "_18zrv77o",
    chatPillText: "_1nmz1hna _y3gn1e5h _o5721jtm",
    chatPillIconWrapper: "_1ul9gktf _4t3igktf"
};
const $488cfbf54b52fa02$export$ffe1cf57f0b5db02 = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $488cfbf54b52fa02$var$styles.chatToAgentButtonContainer,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMFGq.default), {
            testId: "view-agent-modal-chat-to-agent-button",
            shouldFitContainer: true,
            onClick: onClick,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                xcss: $488cfbf54b52fa02$var$styles.chatToAgentButtonWrapper,
                children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                    space: "space.050",
                    xcss: $488cfbf54b52fa02$var$styles.chatPillButtonInline,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                            xcss: $488cfbf54b52fa02$var$styles.chatPillIconWrapper,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c4kDv.ChatPillIcon), {})
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                            xcss: $488cfbf54b52fa02$var$styles.chatPillText,
                            children: formatMessage((0, $lC7nf.default).chatToAgentButton)
                        })
                    ]
                })
            })
        })
    });
};
const $488cfbf54b52fa02$export$fc284fc0f7cc8f16 = ({ isAgentCreatedByUser: isAgentCreatedByUser, isAutodevTemplateAgent: isAutodevTemplateAgent, onEditAgent: onEditAgent, onCopyAgent: onCopyAgent, onDuplicateAgent: onDuplicateAgent, onDeleteAgent: onDeleteAgent, onViewAgentFullProfileClick: onViewAgentFullProfileClick, isForgeAgent: isForgeAgent, showViewAgentOption: showViewAgentOption = false, onViewAgentClick: onViewAgentClick, onDropdownTriggerClick: onDropdownTriggerClick, spacing: spacing, appearance: appearance, dropdownMenuTestId: dropdownMenuTestId, doesAgentHaveIdentityAccountId: doesAgentHaveIdentityAccountId, loadAgentPermissions: loadAgentPermissions, loadPermissionsOnMount: loadPermissionsOnMount, shouldTriggerStopPropagation: shouldTriggerStopPropagation })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [hasBeenCopied, setHasBeenCopied] = (0, $5uXOq.useState)(false);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [permissions, setPermissions] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        const fetchData = async ()=>{
            if (!loadAgentPermissions) {
                const canEditDelete = isAgentCreatedByUser && !isForgeAgent;
                setPermissions({
                    isEditEnabled: canEditDelete,
                    isDeleteEnabled: canEditDelete
                });
                return;
            }
            setIsLoading(true);
            const { isEditEnabled: isEditEnabled, isDeleteEnabled: isDeleteEnabled } = await loadAgentPermissions();
            setIsLoading(false);
            setPermissions({
                isEditEnabled: isEditEnabled,
                isDeleteEnabled: isDeleteEnabled
            });
        };
        // Only load once
        if (!permissions && (isOpen || loadPermissionsOnMount)) fetchData();
    }, [
        isAgentCreatedByUser,
        isForgeAgent,
        isOpen,
        loadAgentPermissions,
        loadPermissionsOnMount,
        permissions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isOpen) setHasBeenCopied(false);
    }, [
        isOpen
    ]);
    const renderEditDelete = ()=>{
        if (!permissions?.isEditEnabled && !permissions?.isDeleteEnabled) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3jAdT.default), {
            hasSeparator: true,
            children: [
                permissions.isEditEnabled && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1eETS.default), {
                    onClick: onEditAgent,
                    children: formatMessage((0, $lC7nf.default).editAgent)
                }),
                permissions.isDeleteEnabled && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1eETS.default), {
                    onClick: onDeleteAgent,
                    children: formatMessage((0, $lC7nf.default).deleteAgent)
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $j7m8K.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        testId: dropdownMenuTestId,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
                ...props,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($elaEw))),
                label: formatMessage((0, $lC7nf.default).moreActionsLabel),
                ref: triggerRef,
                spacing: spacing,
                appearance: appearance,
                onClick: (e, analyticsEvent)=>{
                    if (onDropdownTriggerClick) onDropdownTriggerClick(e, analyticsEvent);
                    if (shouldTriggerStopPropagation) e.stopPropagation();
                    props.onClick?.(e);
                }
            }),
        onOpenChange: (args)=>{
            setIsOpen(args.isOpen);
            if (!args.isOpen) setHasBeenCopied(false);
        },
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3jAdT.default), {
                children: [
                    showViewAgentOption && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1eETS.default), {
                        onClick: onViewAgentClick,
                        children: formatMessage((0, $lC7nf.default).viewAgent)
                    }),
                    doesAgentHaveIdentityAccountId && onViewAgentFullProfileClick && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1eETS.default), {
                        onClick: onViewAgentFullProfileClick,
                        children: formatMessage((0, $lC7nf.default).viewAgentFullProfile)
                    }),
                    !isForgeAgent && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1eETS.default), {
                        onClick: onDuplicateAgent,
                        children: isAutodevTemplateAgent && (0, $fHpHg.fg)('rovo_chat_add_template_tab_to_modal') ? formatMessage((0, $lC7nf.default).useTemplateButton) : formatMessage((0, $lC7nf.default).duplicateAgent)
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1eETS.default), {
                        onClick: (e)=>{
                            e.stopPropagation();
                            setHasBeenCopied(true);
                            onCopyAgent?.(e);
                        },
                        children: formatMessage(hasBeenCopied ? (0, $lC7nf.default).linkedCopiedToProfile : (0, $lC7nf.default).copyLinkToProfile)
                    })
                ]
            }),
            renderEditDelete()
        ]
    });
};

});
parcelRegister("lC7nf", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6b1e7f2420d296d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c6b1e7f2420d296d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    chatToAgentButton: {
        id: 'rovo-chat.view-agent.chat-to-agent-button',
        defaultMessage: 'Chat to Agent',
        description: 'Button to chat to agent'
    },
    moreActionsLabel: {
        id: 'rovo-chat.view-agent.more-actions-label',
        defaultMessage: 'More actions',
        description: 'More actions dropdown menu label'
    },
    duplicateAgent: {
        id: 'rovo-chat.view-agent.duplicate-agent',
        defaultMessage: 'Duplicate Agent',
        description: 'Button to duplicate an agent'
    },
    editAgent: {
        id: 'rovo-chat.view-agent.edit-agent',
        defaultMessage: 'Edit Agent',
        description: 'Button to edit an agent'
    },
    deleteAgent: {
        id: 'rovo-chat.view-agent.delete-agent',
        defaultMessage: 'Delete Agent',
        description: 'Button to delete an agent'
    },
    copyLinkToProfile: {
        id: 'rovo-chat.view-agent.copy-link-to-profile',
        defaultMessage: 'Copy link',
        description: 'Button to copy the link to the agent profile'
    },
    linkedCopiedToProfile: {
        id: 'rovo-chat.view-agent.link-copied-to-profile',
        defaultMessage: 'Copied URL',
        description: 'Button confirming link to agent profile is copied'
    },
    viewAgent: {
        id: 'rovo-chat.view-agents.view-agent',
        defaultMessage: 'View Agent',
        description: 'Button to view an agent'
    },
    viewAgentFullProfile: {
        id: 'rovo-chat.view-agents.view-agent-full-profile',
        defaultMessage: 'View full profile',
        description: 'Button to view an agent full profile'
    },
    useTemplateButton: {
        id: 'rovo-chat.view-agents.use-template-button',
        defaultMessage: 'Use template',
        description: 'Button to copy and use a template'
    }
});

});


parcelRegister("1j7Rq", function(module, exports) {

$parcel$export(module.exports, "useAgentPermissions", () => $32f83589708edb6b$export$be862330bf692bad);

var $7yKOM = parcelRequire("7yKOM");

var $5XeR3 = parcelRequire("5XeR3");
var $1xmyx = parcelRequire("1xmyx");
const $32f83589708edb6b$export$be862330bf692bad = (0, $5XeR3.createHookWithAssistanceService)(({ agentId: agentId, enabled: enabled, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    const query = (0, $1xmyx.useQuery)({
        queryKey: [
            'getAgentPermissions',
            agentId
        ],
        queryFn: async ()=>{
            experienceTracker.start({
                id: (0, $7yKOM.ExperienceName).GET_AGENT_PERMISSIONS,
                name: (0, $7yKOM.ExperienceName).GET_AGENT_PERMISSIONS
            });
            return await assistanceService.getAgentPermissions(agentId, {
                permission_ids: [
                    'AGENT_CREATE',
                    'AGENT_UPDATE',
                    'AGENT_DELETE',
                    'AGENT_DEACTIVATE',
                    'AGENT_READ'
                ]
            });
        },
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $7yKOM.ExperienceName).GET_AGENT_PERMISSIONS
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $7yKOM.ExperienceName).GET_AGENT_PERMISSIONS,
                error: error
            });
        },
        enabled: enabled
    });
    return query;
});

});

parcelRegister("c9RYv", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f96a59a620fbed9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5f96a59a620fbed9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    chatToAgentButton: {
        id: 'rovo-chat.view-agent.chat-to-agent-button',
        defaultMessage: 'Chat to Agent',
        description: 'Button to chat to agent'
    }
});

});


parcelRegister("koLZ3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e653eec5630b62ed$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $e653eec5630b62ed$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    actionChatToAgent: {
        id: 'ptc-directory.agent-profile.action.dropdown.chat-to-agent.nonfinal',
        defaultMessage: 'Chat to Agent',
        description: 'Text for the "chat to agent" action to chat to the agent'
    },
    actionDelete: {
        id: 'ptc-directory.agent-profile.action.dropdown.delete.nonfinal',
        defaultMessage: 'Delete Agent',
        description: 'Text for the "Delete" action to delete an agent'
    },
    actionEdit: {
        id: 'ptc-directory.agent-profile.action.dropdown.edit.nonfinal',
        defaultMessage: 'Edit Agent',
        description: 'Text for the "Edit" action to edit an agent'
    },
    actionCopyLink: {
        id: 'ptc-directory.agent-profile.action.dropdown.copy-link.nonfinal',
        defaultMessage: 'Copy link',
        description: 'Text for the Copy link of an agent'
    },
    actionDuplicate: {
        id: 'ptc-directory.agent-profile.action.dropdown.duplicate.nonfinal',
        defaultMessage: 'Duplicate Agent',
        description: 'Text for the Duplicate Agent action to create a duplicate'
    },
    agentDeletedSuccessFlagTitle: {
        id: 'ptc-directory.agent-profile.delete-agent-success-flag-title',
        defaultMessage: 'Agent deleted',
        description: 'Flag message title displayed when an agent is deleted'
    },
    agentDeletedSuccessFlagDescription: {
        id: 'ptc-directory.agent-profile.delete-agent-success-flag-description',
        defaultMessage: 'You deleted {agentName}',
        description: 'Flag message description displayed when an agent is deleted'
    },
    agentDeletedErrorFlagTitle: {
        id: 'ptc-directory.agent-profile.delete-agent-error-flag-title',
        defaultMessage: 'Failed to delete Agent',
        description: 'Flag message title displayed when there is an error deleting agent'
    },
    agentDeletedErrorFlagDescription: {
        id: 'ptc-directory.agent-profile.delete-agent-error-flag-description',
        defaultMessage: 'Something went wrong while deleting the agent. Try again in a few moments.',
        description: 'Flag message description displayed when there is an error deleting agent'
    }
});

});


parcelRegister("bAcbB", function(module, exports) {

$parcel$export(module.exports, "AgentConversationStartersSection", () => $adbd9d5986ab4abc$export$574a87e4832466ff);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $bEIgH = parcelRequire("bEIgH");

var $igh1A = parcelRequire("igh1A");

var $12iuy = parcelRequire("12iuy");
const $adbd9d5986ab4abc$export$574a87e4832466ff = ({ isAgentDefault: isAgentDefault, onConversationStarterClick: onConversationStarterClick, userDefinedConversationStarters: userDefinedConversationStarters })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleConversationStarterClick = (conversationStarter)=>{
        onConversationStarterClick(conversationStarter);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bEIgH.default), {
        space: "space.200",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $12iuy.MainContentHeaders), {
                children: formatMessage($adbd9d5986ab4abc$var$messages.openChatLabel)
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bEIgH.default), {
                alignInline: "start",
                space: "space.100",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $igh1A.AgentConversationStarters), {
                    isAgentDefault: isAgentDefault,
                    onConversationStarterClick: handleConversationStarterClick,
                    userDefinedConversationStarters: userDefinedConversationStarters
                })
            })
        ]
    });
};
const $adbd9d5986ab4abc$var$messages = (0, $7VHMR.defineMessages)({
    openChatLabel: {
        id: 'ptc-directory.agent-profile.conversation-starter.header',
        defaultMessage: 'Open chat',
        description: 'Label for about section of the agent'
    }
});

});
parcelRegister("igh1A", function(module, exports) {

$parcel$export(module.exports, "getConversationStarters", () => $8d0979fc6478c4ab$export$c2d882153e0984c5);
$parcel$export(module.exports, "AgentConversationStarters", () => $8d0979fc6478c4ab$export$171adfc74aa509c3);
$parcel$export(module.exports, "ConversationStarters", () => $8d0979fc6478c4ab$export$ea338c37011da44c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $1Seuh = parcelRequire("1Seuh");

var $cacF6 = parcelRequire("cacF6");

var $2Eqc8 = parcelRequire("2Eqc8");

var $fCcoY = parcelRequire("fCcoY");

var $4Ypk3 = parcelRequire("4Ypk3");
const $8d0979fc6478c4ab$export$c2d882153e0984c5 = ({ userDefinedConversationStarters: userDefinedConversationStartersParam, isAgentDefault: isAgentDefault })=>{
    const type = 'static';
    const customAgentConversationStarters = [
        {
            message: (0, $4Ypk3.messages).agentEmptyStateSuggestion1,
            type: type
        },
        {
            message: (0, $4Ypk3.messages).agentEmptyStateSuggestion2,
            type: type
        },
        {
            message: (0, $4Ypk3.messages).agentEmptyStateSuggestion3,
            type: type
        }
    ];
    const userDefinedConversationStarters = userDefinedConversationStartersParam ?? [];
    const defaultAgentConversationStarters = [
        {
            message: (0, $4Ypk3.messages).emptyStateSuggestion1,
            type: type
        },
        {
            message: (0, $4Ypk3.messages).emptyStateSuggestion2,
            type: type
        },
        {
            message: (0, $4Ypk3.messages).emptyStateSuggestion3,
            type: type
        }
    ];
    const getCombinedConversationStarters = ()=>{
        const shouldCombine = !isAgentDefault;
        if (shouldCombine) // Return user defined suggestions + static fallback suggestions with a max of 3 suggestions (user defined taking precendence over fallback)
        return [
            ...userDefinedConversationStarters,
            ...customAgentConversationStarters
        ].slice(0, 3);
        return defaultAgentConversationStarters;
    };
    return {
        userDefinedConversationStarters: userDefinedConversationStarters,
        customAgentConversationStarters: customAgentConversationStarters,
        defaultAgentConversationStarters: defaultAgentConversationStarters,
        combinedConversationStarters: getCombinedConversationStarters()
    };
};
const $8d0979fc6478c4ab$export$171adfc74aa509c3 = ({ userDefinedConversationStarters: userDefinedConversationStarters, isAgentDefault: isAgentDefault, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { combinedConversationStarters: combinedConversationStarters } = (0, $5uXOq.useMemo)(()=>$8d0979fc6478c4ab$export$c2d882153e0984c5({
            userDefinedConversationStarters: userDefinedConversationStarters,
            isAgentDefault: isAgentDefault
        }), [
        userDefinedConversationStarters,
        isAgentDefault
    ]);
    const starters = (0, $5uXOq.useMemo)(()=>combinedConversationStarters.map((starter)=>typeof starter.message === 'string' ? {
                message: starter.message,
                type: starter.type
            } : {
                message: formatMessage(starter.message),
                type: starter.type
            }), [
        combinedConversationStarters,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($8d0979fc6478c4ab$export$ea338c37011da44c, {
        starters: starters,
        ...props
    });
};
const $8d0979fc6478c4ab$export$ea338c37011da44c = ({ starters: starters, onConversationStarterClick: onConversationStarterClick, showReloadButton: showReloadButton = false, onReloadButtonClick: onReloadButtonClick = ()=>{}, onBrowseAgentsClick: onBrowseAgentsClick })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            starters.map((starter, index)=>{
                const isLastStarter = index === starters.length - 1;
                const chatPill = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCcoY.ChatPill), {
                    testId: "conversation-starter",
                    onClick: ()=>onConversationStarterClick(starter),
                    children: starter.message
                }, starter.message);
                return isLastStarter && showReloadButton ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2Eqc8.default), {
                    space: "space.050",
                    grow: "fill",
                    alignInline: "end",
                    children: [
                        chatPill,
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cacF6))),
                            onClick: onReloadButtonClick,
                            appearance: "subtle",
                            label: ""
                        })
                    ]
                }, starter.message) : chatPill;
            }),
            !!onBrowseAgentsClick && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCcoY.BrowseAgentsPill), {
                onClick: onBrowseAgentsClick
            })
        ]
    });
};

});
parcelRegister("cacF6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::34150578bc9ce6805d69153dc5cf8a40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8db03d9ce8392d47$var$_react = $8db03d9ce8392d47$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8db03d9ce8392d47$var$_baseNew = $8db03d9ce8392d47$var$_interopRequireDefault((parcelRequire("enEmH")));
function $8db03d9ce8392d47$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Retry".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for retry.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8db03d9ce8392d47$var$RetryIcon = (props)=>/*#__PURE__*/ $8db03d9ce8392d47$var$_react.default.createElement($8db03d9ce8392d47$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.75 2.75a5.25 5.25 0 0 0 0 10.5v1.5A6.75 6.75 0 1 1 13.5 8v1.19l1.345-1.345 1.06 1.06-2.625 2.625a.75.75 0 0 1-1.06 0L9.595 8.905l1.06-1.06L12 9.189V8c0-2.9-2.35-5.25-5.25-5.25" clip-rule="evenodd"/>`
    }, props));
$8db03d9ce8392d47$var$RetryIcon.displayName = 'RetryIcon';
var $8db03d9ce8392d47$var$_default = module.exports.default = $8db03d9ce8392d47$var$RetryIcon;

});

parcelRegister("fCcoY", function(module, exports) {

$parcel$export(module.exports, "ChatPill", () => $b697c070232bf7df$export$e33faa86e0996d96);
$parcel$export(module.exports, "BrowseAgentsPill", () => $b697c070232bf7df$export$76b47032dcd9063b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $6tzHJ = parcelRequire("6tzHJ");

var $dzThm = parcelRequire("dzThm");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $7rJgC = parcelRequire("7rJgC");

var $c4kDv = parcelRequire("c4kDv");

var $fHw2L = parcelRequire("fHw2L");
const $b697c070232bf7df$var$stylesCompiled = {
    pillLineHeight: "_vwz47vkz"
};
const $b697c070232bf7df$var$styles = {
    conversationStarterPill: "_2rkopd34 _11c82smr _189ee4h9 _1dqonqa1 _1h6dmuej _syaz1fxt _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _1o0zgqwt _k48p1wq8 _1bto1l2s _o5721q9c _1o9zkb7n _bfhk18uv _1bsb1osq _irr315ej _1di6ip91",
    button: "_2rkoiti9 _11c82smr _189ee4h9 _1dqonqa1 _1h6dmuej _syaz1gjq _ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp _k48p1wq8 _1bto1l2s _o5721q9c _1o9zkb7n _bfhk1w7a _irr3166n _1di61dty",
    buttonInline: "_18zrv77o",
    queryText: "_1nmz1hna _y3gn1e5h",
    whiteSpacePreWrap: "_o5721jtm"
};
const $b697c070232bf7df$export$e33faa86e0996d96 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, whiteSpacePreWrap: whiteSpacePreWrap = true, renderIcon: renderIcon = true, ...props }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
        ref: ref,
        ...props,
        xcss: $b697c070232bf7df$var$styles.button,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                $b697c070232bf7df$var$stylesCompiled.pillLineHeight
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                space: "space.075",
                alignBlock: "baseline",
                children: [
                    renderIcon ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c4kDv.ChatPillIcon), {}) : null,
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                        xcss: (0, $6tzHJ.cx)($b697c070232bf7df$var$styles.queryText, whiteSpacePreWrap && $b697c070232bf7df$var$styles.whiteSpacePreWrap),
                        children: children
                    })
                ]
            })
        })
    }));
const $b697c070232bf7df$export$76b47032dcd9063b = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
        ref: ref,
        ...props,
        xcss: $b697c070232bf7df$var$styles.button,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                $b697c070232bf7df$var$stylesCompiled.pillLineHeight
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                space: "space.050",
                xcss: $b697c070232bf7df$var$styles.buttonInline,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dzThm))), {
                        color: "currentColor",
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                        xcss: $b697c070232bf7df$var$styles.queryText,
                        children: formatMessage((0, $fHw2L.default).browseAgentsPillLabel)
                    })
                ]
            })
        })
    });
});
const $b697c070232bf7df$export$f7619b16091e62a2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, whiteSpacePreWrap: whiteSpacePreWrap = true, ...props }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
        ref: ref,
        ...props,
        xcss: $b697c070232bf7df$var$styles.conversationStarterPill,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                $b697c070232bf7df$var$stylesCompiled.pillLineHeight
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
                space: "space.050",
                xcss: $b697c070232bf7df$var$styles.buttonInline,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c4kDv.ChatPillIcon), {}),
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                        xcss: (0, $6tzHJ.cx)($b697c070232bf7df$var$styles.queryText, whiteSpacePreWrap && $b697c070232bf7df$var$styles.whiteSpacePreWrap),
                        children: children
                    })
                ]
            })
        })
    }));

});
parcelRegister("dzThm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ec2830ef4a5653740a2b8f60e21924b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e296c7b2f136f91$var$_react = $9e296c7b2f136f91$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9e296c7b2f136f91$var$_baseNew = $9e296c7b2f136f91$var$_interopRequireDefault((parcelRequire("enEmH")));
function $9e296c7b2f136f91$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9e296c7b2f136f91$var$AiAgentIcon = (props)=>/*#__PURE__*/ $9e296c7b2f136f91$var$_react.default.createElement($9e296c7b2f136f91$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$9e296c7b2f136f91$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $9e296c7b2f136f91$var$_default = module.exports.default = $9e296c7b2f136f91$var$AiAgentIcon;

});

parcelRegister("fHw2L", function(module, exports) {

$parcel$export(module.exports, "default", () => $0de12b1fb29250e4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0de12b1fb29250e4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    browseAgentsPillLabel: {
        id: 'ai-mate.rovo-agent-components.browse-agents-pill.label',
        defaultMessage: 'Browse Agents',
        description: 'The label displayed on the browse agents pill'
    }
});

});


parcelRegister("4Ypk3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $792f0c6340762235$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $792f0c6340762235$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    emptyStateSuggestion1: {
        id: 'ai-mate.chat-history.empty-state.suggestion1',
        defaultMessage: 'Are any of my tickets overdue?',
        description: 'The first suggestion displayed in the empty state of the chat history'
    },
    emptyStateSuggestion2: {
        id: 'ai-mate.chat-history.empty-state.suggestion2',
        defaultMessage: 'What should I work on next?',
        description: 'The second suggestion displayed in the empty state of the chat history'
    },
    emptyStateSuggestion3: {
        id: 'ai-mate.chat-history.empty-state.suggestion3',
        defaultMessage: 'Write an update about my week',
        description: 'The third suggestion displayed in the empty state of the chat history'
    },
    agentEmptyStateSuggestion1: {
        id: 'ai-mate.chat-history.empty-state.agent-suggestion1',
        defaultMessage: 'Tell me about yourself',
        description: 'The first suggestion displayed in the empty state when an agent is selected'
    },
    agentEmptyStateSuggestion2: {
        id: 'ai-mate.chat-history.empty-state.agent-suggestion2',
        defaultMessage: 'What can you help me with?',
        description: 'The second suggestion displayed in the empty state when an agent is selected'
    },
    agentEmptyStateSuggestion3: {
        id: 'ai-mate.chat-history.empty-state.agent-suggestion3',
        defaultMessage: "Summarize what I'm looking at",
        description: 'The third suggestion displayed in the empty state when an agent is selected'
    }
});

});


parcelRegister("12iuy", function(module, exports) {

$parcel$export(module.exports, "MainContentHeaders", () => $0291864077870e1c$export$161f9e38c5e0d38e);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6eFvr = parcelRequire("6eFvr");
const $0291864077870e1c$export$161f9e38c5e0d38e = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6eFvr.default), {
        size: "large",
        color: "color.text.subtle",
        weight: "semibold",
        children: children
    });

});


parcelRegister("ejUW9", function(module, exports) {

$parcel$export(module.exports, "AgentCreator", () => $1b736d322a78c635$export$d892e919a94dad49);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dc822 = parcelRequire("dc822");

var $dOfy3 = parcelRequire("dOfy3");

var $9OeO9 = parcelRequire("9OeO9");
const $1b736d322a78c635$export$d892e919a94dad49 = ({ creator: creator, create_type: create_type })=>{
    const userId = create_type === 'CUSTOMER' && creator ? (0, $9OeO9.trimUserARI)(creator) : '';
    const { isLoading: isLoading, data: data } = (0, $dOfy3.useTeamsUser)(userId, !userId);
    const getCreator = ()=>{
        switch(create_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'FORGE':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                return {
                    type: 'CUSTOMER',
                    name: data?.fullName || '',
                    profileLink: data?.id ? `/people/${(0, $9OeO9.trimUserARI)(data.id)}` : '/people/search'
                };
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dc822.AgentProfileCreator), {
        creator: getCreator(),
        isLoading: isLoading,
        onCreatorLinkClick: ()=>{}
    });
};

});

parcelRegister("fHBgM", function(module, exports) {

$parcel$export(module.exports, "default", () => $491d2a467f928a39$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $bMFGq = parcelRequire("bMFGq");

var $k5Wbc = parcelRequire("k5Wbc");

var $hordk = parcelRequire("hordk");
var $g1QfP = parcelRequire("g1QfP");
var $7CjwE = parcelRequire("7CjwE");
var $eUaFh = parcelRequire("eUaFh");
var $7Sb4G = parcelRequire("7Sb4G");

var $0yZbT = parcelRequire("0yZbT");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");
const $491d2a467f928a39$var$errStyles = (0, $2s57o.xcss)({
    marginTop: 'space.150'
});
const $491d2a467f928a39$var$agentResponseMessageTemplate = {
    AGENT_DOES_NOT_EXIST: 'errorAgentNotFound',
    USER_NOT_CREATOR: 'errorIncorrectOwner',
    AGENT_HAS_CONVERSATIONS: 'errorAgentInUse',
    AGENT_DELETE_SUCCESS: 'agentDeletedSuccess'
};
const $491d2a467f928a39$export$39d869cf16a68f79 = ({ onClose: onClose, agentName: agentName, agentId: agentId, onDelete: onDelete })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [deleteError, setDeleteError] = (0, $5uXOq.useState)();
    const [isDeletePending, setIsDeletePending] = (0, $5uXOq.useState)(false);
    const handleDeleteAgent = (0, $5uXOq.useCallback)(async ()=>{
        if (agentId) {
            setIsDeletePending(true);
            try {
                await onDelete?.();
                onClose?.();
            } catch (error) {
                setDeleteError(formatMessage($491d2a467f928a39$var$messages[$491d2a467f928a39$var$agentResponseMessageTemplate[error?.message_template]]));
            } finally{
                setIsDeletePending(false);
            }
        }
    }, [
        agentId,
        formatMessage,
        onClose,
        onDelete
    ]);
    if (!agentId) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hordk.default), {
        width: "small",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eUaFh.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Sb4G.default), {
                    children: formatMessage($491d2a467f928a39$var$messages.title, {
                        agentName: agentName
                    })
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $g1QfP.default), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6eFvr.default), {
                        as: "p",
                        children: formatMessage($491d2a467f928a39$var$messages.body)
                    }),
                    deleteError && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
                        xcss: $491d2a467f928a39$var$errStyles,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k5Wbc.ErrorMessage), {
                            children: deleteError
                        })
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7CjwE.default), {
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMFGq.default), {
                                appearance: "subtle",
                                onClick: onClose,
                                children: formatMessage($491d2a467f928a39$var$messages.cancelText)
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMFGq.default), {
                                appearance: "danger",
                                isDisabled: !!deleteError || isDeletePending,
                                onClick: (_e, _event)=>{
                                    handleDeleteAgent();
                                },
                                children: formatMessage($491d2a467f928a39$var$messages.confirmText)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $491d2a467f928a39$export$2e2bcd8739ae039 = $491d2a467f928a39$export$39d869cf16a68f79;
const $491d2a467f928a39$var$messages = (0, $7VHMR.defineMessages)({
    cancelText: {
        id: 'ptc-directory.agent-profile.agent-delete-confirm.cancel-text',
        defaultMessage: 'Cancel'
    },
    confirmText: {
        id: 'ptc-directory.agent-profile.agent-delete-confirm.confirm-text',
        defaultMessage: 'Delete'
    },
    title: {
        id: 'ptc-directory.agent-profile.delete-agent-confirm-title',
        defaultMessage: 'Delete "{agentName}"?',
        description: 'Title text for the delete agent confirmation modal'
    },
    body: {
        id: 'ptc-directory.agent-profile.delete-agent-confirm-body',
        defaultMessage: `Are you sure you want to delete this agent? This action cannot be undone.`,
        description: 'Body text for the delete agent confirmation modal'
    },
    error: {
        id: 'ptc-directory.agent-profile.delete-agent-error',
        defaultMessage: 'Could not delete agent',
        description: 'Error message displayed when an agent cannot be deleted'
    },
    errorAgentNotFound: {
        id: 'ptc-directory.agent-profile.delete-agent-error.agent-not-found',
        defaultMessage: 'That agent could not be found.',
        description: 'Error message displayed when an agent cannot be found'
    },
    errorAgentInUse: {
        id: 'ptc-directory.agent-profile.delete-agent-error.agent-in-use',
        defaultMessage: 'Agent is currently in use. Try again later.',
        description: 'Error message displayed when an agent is in use'
    },
    errorIncorrectOwner: {
        id: 'ptc-directory.agent-profile.delete-agent-error.incorrect-owner',
        defaultMessage: 'You cannot delete agents you have not created yourself. Please contact the agent owner.',
        description: 'Error message displayed when the agent owner is incorrect'
    },
    agentDeletedSuccess: {
        id: 'ptc-directory.agent-profile.delete-agent-success',
        defaultMessage: 'Agent has been deleted!',
        description: 'Success message displayed when an agent is deleted'
    }
});

});

parcelRegister("kc4uV", function(module, exports) {

$parcel$export(module.exports, "useAgentActions", () => $fa5826bcbf58c225$export$9115df56efd01c09);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $aUv7N = parcelRequire("aUv7N");

var $2ys8y = parcelRequire("2ys8y");

var $598gS = parcelRequire("598gS");
var $ccGHD = parcelRequire("ccGHD");
var $e2tyv = parcelRequire("e2tyv");

var $js2Ve = parcelRequire("js2Ve");

var $cprXC = parcelRequire("cprXC");

var $kQ0fM = parcelRequire("kQ0fM");
var $j3Ju0 = parcelRequire("j3Ju0");

var $koLZ3 = parcelRequire("koLZ3");
const $fa5826bcbf58c225$export$9115df56efd01c09 = ({ agentId: agentId, agentName: agentName, agentIdentityAccountId: agentIdentityAccountId, assistanceServiceParams: assistanceServiceParams })=>{
    const addFlag = (0, $kQ0fM.useFlags)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { push: push } = (0, $j3Ju0.useRouter)();
    const { favouriteAgent: favouriteAgent, unfavouriteAgent: unfavouriteAgent } = (0, $598gS.useAgentFavourites)({
        assistanceServiceParams: assistanceServiceParams
    });
    const { onEditAgent: onEditAgent, onCopyAgent: onCopyAgent, onDuplicateAgent: onDuplicateAgent } = (0, $ccGHD.useAgentUrlActions)({
        siteId: assistanceServiceParams.siteId
    });
    const { deleteAgent: deleteRovoAgent } = (0, $e2tyv.useDeleteAgent)({
        assistanceServiceParams: assistanceServiceParams
    });
    const setFavouriteAgent = (0, $5uXOq.useCallback)(async (isFavourite, onSuccess)=>{
        if (!agentId) return;
        if (isFavourite) return await favouriteAgent.mutate(agentId, {
            onSuccess: onSuccess
        });
        else return await unfavouriteAgent.mutate(agentId, {
            onSuccess: onSuccess
        });
    }, [
        agentId,
        favouriteAgent,
        unfavouriteAgent
    ]);
    const { fireEvent: fireEvent } = (0, $js2Ve.usePeopleTeamAnalyticsEvents)();
    const editAgent = ()=>{
        if (!agentId) return;
        fireEvent('ui.editAgent.clicked', {});
        onEditAgent(agentId);
    };
    const copyAgent = ()=>{
        if (!agentId) return;
        fireEvent('ui.copyAgent.clicked', {});
        onCopyAgent({
            agentId: agentId,
            agentIdentityAccountId: agentIdentityAccountId
        });
    };
    const duplicateAgent = ()=>{
        if (!agentId) return;
        fireEvent('ui.duplicateAgent.clicked', {});
        onDuplicateAgent(agentId, 'agentProfilePage');
    };
    const deleteAgent = ()=>{
        if (!agentId) return;
        fireEvent('ui.deleteAgent.clicked', {});
        deleteRovoAgent.mutate(agentId, {
            onSuccess: ()=>{
                addFlag({
                    title: formatMessage((0, $koLZ3.messages).agentDeletedSuccessFlagTitle),
                    description: formatMessage((0, $koLZ3.messages).agentDeletedSuccessFlagDescription, {
                        agentName: agentName
                    }),
                    type: 'success',
                    id: 'ptc-directory.agent-profile.delete-agent-success'
                }, {
                    sendAnalytics: true,
                    name: (0, $cprXC.AnalyticsEventSource).AGENT_DELETE_SUCCESS_FLAG
                });
                setTimeout(()=>{
                    push('search');
                }, 100);
            },
            onError: ()=>{
                addFlag({
                    title: formatMessage((0, $koLZ3.messages).agentDeletedErrorFlagTitle),
                    description: formatMessage((0, $koLZ3.messages).agentDeletedErrorFlagDescription),
                    type: 'error',
                    id: 'ptc-directory.agent-profile.delete-agent-error'
                }, {
                    sendAnalytics: true,
                    name: (0, $cprXC.AnalyticsEventSource).AGENT_DELETE_ERROR_FLAG
                });
            }
        });
    };
    const onChatWithAgent = ()=>{
        if (!agentId) return;
        fireEvent('ui.chatWithAgent.clicked', {});
        window.open((0, $aUv7N.addRovoParamsToUrl)(`${(0, $2ys8y.getATLContextUrl)('home')}/chat`, {
            pathway: 'chat',
            cloudId: assistanceServiceParams.siteId,
            agentId: agentId
        }), '_blank', 'noopener, noreferrer');
    };
    const startConversation = (prompt)=>{
        if (!agentId) return;
        fireEvent('ui.startConversationWithAgent.clicked', {});
        window.open((0, $aUv7N.addRovoParamsToUrl)(`${(0, $2ys8y.getATLContextUrl)('home')}/chat`, {
            pathway: 'chat',
            prompt: prompt,
            cloudId: assistanceServiceParams.siteId,
            agentId: agentId
        }), '_blank', 'noopener, noreferrer');
    };
    return {
        setFavouriteAgent: setFavouriteAgent,
        editAgent: editAgent,
        copyAgent: copyAgent,
        duplicateAgent: duplicateAgent,
        deleteAgent: deleteAgent,
        onChatWithAgent: onChatWithAgent,
        startConversation: startConversation
    };
};

});
parcelRegister("598gS", function(module, exports) {

$parcel$export(module.exports, "useAgentFavourites", () => $efd127cc1f9afc67$export$5c4c46b1f93a6e69);

var $7yKOM = parcelRequire("7yKOM");

var $5XeR3 = parcelRequire("5XeR3");
var $8boD2 = parcelRequire("8boD2");
const $efd127cc1f9afc67$export$5c4c46b1f93a6e69 = (0, $5XeR3.createHookWithAssistanceService)(({ onError: onError, onSuccess: onSuccess, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    const favouriteAgent = (0, $8boD2.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $7yKOM.ExperienceName).FAVOURITE_AGENT,
                name: (0, $7yKOM.ExperienceName).FAVOURITE_AGENT
            });
            return await assistanceService.favouriteAgent(id);
        },
        onSuccess: async ()=>{
            experienceTracker.succeed({
                name: (0, $7yKOM.ExperienceName).FAVOURITE_AGENT
            });
            onSuccess?.({
                favourite: true
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $7yKOM.ExperienceName).FAVOURITE_AGENT,
                error: error
            });
            onError?.({
                favourite: true
            });
        }
    });
    const unfavouriteAgent = (0, $8boD2.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $7yKOM.ExperienceName).UNFAVOURITE_AGENT,
                name: (0, $7yKOM.ExperienceName).UNFAVOURITE_AGENT
            });
            return await assistanceService.unfavouriteAgent(id);
        },
        onSuccess: async ()=>{
            experienceTracker.succeed({
                name: (0, $7yKOM.ExperienceName).UNFAVOURITE_AGENT
            });
            onSuccess?.({
                favourite: false
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $7yKOM.ExperienceName).UNFAVOURITE_AGENT,
                error: error
            });
            onError?.({
                favourite: false
            });
        }
    });
    return {
        favouriteAgent: favouriteAgent,
        unfavouriteAgent: unfavouriteAgent
    };
});

});
parcelRegister("8boD2", function(module, exports) {

$parcel$export(module.exports, "useMutation", () => $7edeb0baf06e5d45$export$609860bf8b0084c);

var $5uXOq = parcelRequire("5uXOq");

var $3KVhk = parcelRequire("3KVhk");
const $7edeb0baf06e5d45$export$609860bf8b0084c = ({ mutationFn: mutationFn, onSuccess: onSuccess, onError: onError })=>{
    const mutationFnRef = (0, $5uXOq.useRef)(mutationFn);
    mutationFnRef.current = mutationFn;
    const onSuccessRef = (0, $5uXOq.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $5uXOq.useRef)(onError);
    onErrorRef.current = onError;
    const [data, setData] = (0, $5uXOq.useState)(null);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [isSubmitting, setIsSubmitting] = (0, $5uXOq.useState)(false);
    const mutate = (0, $5uXOq.useCallback)(async (payload, mutateCallback)=>{
        setIsSubmitting(true);
        try {
            const response = await mutationFnRef.current(payload);
            setData(response);
            onSuccessRef.current?.(response);
            mutateCallback?.onSuccess?.(response);
        } catch (error) {
            const apiError = (0, $3KVhk.mapErrorToApiError)(error);
            setError(apiError);
            onErrorRef.current?.(apiError, payload);
            mutateCallback?.onError?.(apiError);
        } finally{
            setIsSubmitting(false);
        }
    }, []);
    return {
        data: data,
        error: error,
        isSubmitting: isSubmitting,
        mutate: mutate
    };
};

});


parcelRegister("ccGHD", function(module, exports) {

$parcel$export(module.exports, "useAgentUrlActions", () => $11670b5117598d42$export$56665b80ee272742);

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $aUv7N = parcelRequire("aUv7N");

var $edoq1 = parcelRequire("edoq1");

var $5KKNJ = parcelRequire("5KKNJ");

var $7Xpcu = parcelRequire("7Xpcu");
const $11670b5117598d42$export$56665b80ee272742 = ({ siteId: siteId })=>{
    const { atlasURL: atlasURL } = (0, $7Xpcu.useAtlasURL)(siteId);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $edoq1.useAnalytics)();
    const onEditAgent = (0, $5uXOq.useCallback)((agentId)=>{
        if ((0, $fHpHg.fg)('redirect_rovo_to_agent_studio_enabled')) window.open((0, $5KKNJ.getAtlassianStudioAgentEditUrl)(siteId, agentId));
        else window.open(atlasURL(`/chat/agents/${agentId}/edit`), '_blank', 'noopener, noreferrer');
    }, [
        atlasURL,
        siteId
    ]);
    const onCopyAgent = (0, $5uXOq.useCallback)(({ agentId: agentId, agentIdentityAccountId: agentIdentityAccountId })=>{
        if (agentIdentityAccountId) {
            navigator.clipboard.writeText(`${window.location.origin}/people/agent/${agentId}`);
            return;
        }
        const rovoParams = (0, $aUv7N.encodeRovoParams)({
            pathway: 'chat',
            agentId: agentId
        });
        navigator.clipboard.writeText(atlasURL(`/chat?${rovoParams}`));
    }, [
        atlasURL
    ]);
    const onDuplicateAgent = (0, $5uXOq.useCallback)((agentId, source)=>{
        if ((0, $fHpHg.fg)('redirect_rovo_to_agent_studio_enabled')) window.open((0, $5KKNJ.getAtlassianStudioAgentDuplicateUrl)(siteId, agentId));
        else {
            const rovoParams = (0, $aUv7N.encodeRovoParams)({
                pathway: 'agents-create',
                agentId: agentId
            });
            window.open(atlasURL(`/chat/agents/new?${rovoParams}`), '_blank', 'noopener, noreferrer');
        }
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'duplicateAgentButton',
            attributes: {
                agentId: agentId,
                source: source
            }
        });
    }, [
        atlasURL,
        sendAnalyticsEvent,
        siteId
    ]);
    const onViewAgentFullProfile = (0, $5uXOq.useCallback)((agentId)=>{
        window.open(`${window.location.origin}/people/agent/${agentId}`, '_blank', 'noopener, noreferrer');
    }, []);
    const onStartNewChatWindowWithPrompt = (0, $5uXOq.useCallback)((agentId, prompt)=>{
        const rovoParams = (0, $aUv7N.encodeRovoParams)({
            pathway: 'chat',
            agentId: agentId,
            prompt: prompt
        });
        window.open(atlasURL(`/chat?${rovoParams}`), '_blank', 'noopener, noreferrer');
    }, [
        atlasURL
    ]);
    return {
        onEditAgent: onEditAgent,
        onCopyAgent: onCopyAgent,
        onDuplicateAgent: onDuplicateAgent,
        onViewAgentFullProfile: onViewAgentFullProfile,
        onStartNewChatWindowWithPrompt: onStartNewChatWindowWithPrompt
    };
};

});
parcelRegister("5KKNJ", function(module, exports) {

$parcel$export(module.exports, "getAtlassianStudioAgentCreateUrl", () => $d0f175727fca7617$export$fe475324c26e3007);
$parcel$export(module.exports, "getAtlassianStudioAgentEditUrl", () => $d0f175727fca7617$export$a20abb994c34f0a4);
$parcel$export(module.exports, "getAtlassianStudioAgentDuplicateUrl", () => $d0f175727fca7617$export$36c11ab884b7b2cb);
const $d0f175727fca7617$export$fe475324c26e3007 = (siteId)=>`/studio/s/${siteId}/agents/create/identity`;
// helpers to generate urls to redirect from rovo to atlassian studio using the enrichment route in studio
const $d0f175727fca7617$var$getAtlassianStudioRedirectBaseUrl = (siteId, agentId)=>`/studio/s/${siteId}/agents/enrich/rovo/agents/${agentId}`;
const $d0f175727fca7617$export$a20abb994c34f0a4 = (siteId, agentId)=>`${$d0f175727fca7617$var$getAtlassianStudioRedirectBaseUrl(siteId, agentId)}?redirect=${encodeURIComponent('/:agentId/identity')}`;
const $d0f175727fca7617$export$36c11ab884b7b2cb = (siteId, agentId)=>`${$d0f175727fca7617$var$getAtlassianStudioRedirectBaseUrl(siteId, agentId)}?redirect=${encodeURIComponent('/create')}`;

});

parcelRegister("7Xpcu", function(module, exports) {

$parcel$export(module.exports, "useAtlasURL", () => $e34b6e2f2630b391$export$8a1abb7c176bd202);

var $5uXOq = parcelRequire("5uXOq");

var $gi954 = parcelRequire("gi954");

var $VZjx2 = parcelRequire("VZjx2");
const $e34b6e2f2630b391$export$8a1abb7c176bd202 = (siteId)=>{
    const { data: tenantData } = (0, $VZjx2.useTenantDataController)(siteId);
    const atlasURL = (0, $5uXOq.useCallback)((path)=>(0, $gi954.getAtlasURL)(siteId, path, tenantData?.orgId), [
        siteId,
        tenantData?.orgId
    ]);
    return {
        atlasURL: atlasURL
    };
};
const $e34b6e2f2630b391$export$b61b99f9ac0264be = (siteId)=>{
    const { atlasURL: atlasURL } = $e34b6e2f2630b391$export$8a1abb7c176bd202(siteId);
    return atlasURL('/chat/agents/new');
};

});
parcelRegister("VZjx2", function(module, exports) {

$parcel$export(module.exports, "useTenantDataController", () => $720ce0d62979cb9e$export$b863fec6791eae25);

var $7yKOM = parcelRequire("7yKOM");
var $jopI1 = parcelRequire("jopI1");

var $1xmyx = parcelRequire("1xmyx");

var $1NuQ2 = parcelRequire("1NuQ2");
const $720ce0d62979cb9e$export$b863fec6791eae25 = (siteId)=>{
    const experience = (0, $jopI1.useAIMateExperienceTracker)();
    const { data: data, isFetching: isFetching, error: error } = (0, $1xmyx.useQuery)({
        queryKey: [
            'viewAgentTenantData',
            siteId
        ],
        queryFn: async ()=>{
            experience.start({
                id: (0, $7yKOM.ExperienceName).FETCH_AGENT_TENANT_DATA,
                name: (0, $7yKOM.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
            const result = await (0, $1NuQ2.getCloudUrlFromId)(siteId);
            return result;
        },
        onSuccess: ()=>{
            experience.succeed({
                name: (0, $7yKOM.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $7yKOM.ExperienceName).FETCH_AGENT_TENANT_DATA,
                error: error
            });
        }
    });
    return {
        data: data,
        isFetching: isFetching,
        error: error
    };
};

});
parcelRegister("1NuQ2", function(module, exports) {

$parcel$export(module.exports, "getCloudUrlFromId", () => $4ed6d66577de479b$export$d4ace54df9bd6bb1);

var $bF8MR = parcelRequire("bF8MR");
const $4ed6d66577de479b$var$CloudIdLookupQuery = `
query tenantQuery($cloudIds: [ID!]) {
  tenantContexts(cloudIds: $cloudIds) {
    cloudUrl
	orgId
  }
}
`;
const $4ed6d66577de479b$export$d4ace54df9bd6bb1 = async (cloudId)=>{
    const response = await (0, $bF8MR.performGqlFetch)({
        gqlQuery: $4ed6d66577de479b$var$CloudIdLookupQuery,
        variables: {
            cloudIds: [
                cloudId
            ]
        }
    });
    return response.data?.tenantContexts?.[0];
};

});




parcelRegister("e2tyv", function(module, exports) {

$parcel$export(module.exports, "useDeleteAgent", () => $b8cb6aa324ebb071$export$89877d4f8d8790ca);

var $7yKOM = parcelRequire("7yKOM");

var $5XeR3 = parcelRequire("5XeR3");
var $8boD2 = parcelRequire("8boD2");
const $b8cb6aa324ebb071$export$89877d4f8d8790ca = (0, $5XeR3.createHookWithAssistanceService)(({ onSuccess: onSuccess, onError: onError, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, onInit: onInit })=>{
    const deleteAgent = (0, $8boD2.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $7yKOM.ExperienceName).DELETE_AGENT,
                name: (0, $7yKOM.ExperienceName).DELETE_AGENT
            });
            onInit?.(id);
            return await assistanceService.deleteAgent(id);
        },
        onSuccess: async (data)=>{
            experienceTracker.succeed({
                name: (0, $7yKOM.ExperienceName).DELETE_AGENT
            });
            onSuccess?.();
            return data;
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $7yKOM.ExperienceName).DELETE_AGENT,
                error: error
            });
            onError?.();
        }
    });
    return {
        deleteAgent: deleteAgent
    };
});

});

parcelRegister("j3Ju0", function(module, exports) {

$parcel$export(module.exports, "useRouter", () => $82a3cd03a5cb8e8b$export$9a302a45f65d0572);

var $5uXOq = parcelRequire("5uXOq");

var $5vx1F = parcelRequire("5vx1F");
const $82a3cd03a5cb8e8b$export$9a302a45f65d0572 = ()=>{
    const { contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint, push: push, replace: replace, history: history } = (0, $5uXOq.useContext)((0, $5vx1F.default));
    return {
        contextSpaPaths: contextSpaPaths,
        contextEntryPoint: contextEntryPoint,
        push: push,
        replace: replace,
        history: history
    };
};

});



parcelRegister("gkYls", function(module, exports) {

let $be4d52e5ae266699$var$load = (parcelRequire("28QjX"))(4);
module.exports = $be4d52e5ae266699$var$load("9tpRL").then(()=>parcelRequire('1jrZC'));

});


parcelRegister("iVTy4", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7cc8a7bd66a4771$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9NUk1 = parcelRequire("9NUk1");
var $358cZ = parcelRequire("358cZ");

var $5vx1F = parcelRequire("5vx1F");

var $7WjTt = parcelRequire("7WjTt");
function $a7cc8a7bd66a4771$var$recordPageVisitOrigin(replace) {
    const url = new URL(window.location.href);
    if (!url || !url.searchParams) return;
    // ref contains a product like confluence, jira etc.
    const ref = url.searchParams.get('ref') || '';
    // src contains a location like appswitcher, peopledrawer etc.
    const src = url.searchParams.get('src') || '';
    if (!ref && !src) return;
    // save referrer info for retrieving it in further screen events
    (0, $9NUk1.default).set({
        src: src,
        ref: ref
    });
    url.searchParams.delete('ref');
    url.searchParams.delete('src');
    // replace location if it changed after removing ref and src query params
    if (replace) replace(`${url.pathname}${url.search}`);
}
function $a7cc8a7bd66a4771$var$RecordTransition(props) {
    const { name: name } = props;
    const { replace: replace } = (0, $5vx1F.useAppConfig)();
    const refInitialLoadTracked = (0, $5uXOq.useRef)(false);
    const analytics = (0, $358cZ.default)();
    (0, $5uXOq.useEffect)(()=>{
        if (!refInitialLoadTracked.current) {
            refInitialLoadTracked.current = true;
            // stores referrer info
            $a7cc8a7bd66a4771$var$recordPageVisitOrigin(replace);
        } else // cleanup stored referrer info on transition
        (0, $9NUk1.default).cleanup();
        (0, $7WjTt.default)(name, analytics);
    }, [
        analytics,
        name,
        replace
    ]);
    return null;
}
var $a7cc8a7bd66a4771$export$2e2bcd8739ae039 = $a7cc8a7bd66a4771$var$RecordTransition;

});
parcelRegister("7WjTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f92c959838ab92b$export$2e2bcd8739ae039);

var $kWith = parcelRequire("kWith");
let $4f92c959838ab92b$var$dwellHelper = null;
const $4f92c959838ab92b$var$buildDwellEventData = (source)=>{
    return {
        actionSubject: 'page',
        source: source
    };
};
const $4f92c959838ab92b$var$sendDwellEvent = (eventData, analyticsClient)=>{
    analyticsClient.sendTrackEvent(eventData);
};
const $4f92c959838ab92b$var$initialiseDwellTime = (eventSource, analyticsClient)=>{
    if (eventSource) {
        const updatedEventData = $4f92c959838ab92b$var$buildDwellEventData(eventSource);
        $4f92c959838ab92b$var$dwellHelper = (0, $kWith.default)((eventData)=>$4f92c959838ab92b$var$sendDwellEvent(eventData, analyticsClient), updatedEventData);
        $4f92c959838ab92b$var$dwellHelper.start();
    }
};
const $4f92c959838ab92b$var$recordNewPageForDwellTime = (eventSource)=>{
    if ($4f92c959838ab92b$var$dwellHelper) {
        if (eventSource) {
            const updatedEventData = $4f92c959838ab92b$var$buildDwellEventData(eventSource);
            $4f92c959838ab92b$var$dwellHelper.newPage(updatedEventData);
        } else // eslint-disable-next-line no-console
        console.error('Unable to record dwell time transition - missing analytics key or source mapping for route');
    } else // eslint-disable-next-line no-console
    console.error('Dwell time has not been initialised');
};
/**
 * Initialises dwell time measurement, or records a page transition if it is already initialised.
 * Note that dwell time will only be initialised on routes that have an analytics key, which should be
 * all routes except for those that result in a redirect.
 */ const $4f92c959838ab92b$var$recordDwellTime = (analyticsKey, analyticsClient)=>{
    const eventName = analyticsClient.mapAnalyticsKeyToEvent(analyticsKey);
    const eventSource = eventName ? `${eventName}Screen` : null;
    if (!$4f92c959838ab92b$var$dwellHelper) $4f92c959838ab92b$var$initialiseDwellTime(eventSource, analyticsClient);
    else $4f92c959838ab92b$var$recordNewPageForDwellTime(eventSource);
};
var $4f92c959838ab92b$export$2e2bcd8739ae039 = $4f92c959838ab92b$var$recordDwellTime;

});
parcelRegister("kWith", function(module, exports) {

$parcel$export(module.exports, "default", () => $6693f36f228c4adf$export$2e2bcd8739ae039);

var $3mT7S = parcelRequire("3mT7S");
const $6693f36f228c4adf$var$getDwellTimeHelper = (sendMethod, eventData)=>{
    return new (0, $3mT7S.default)(sendMethod, eventData);
};
var $6693f36f228c4adf$export$2e2bcd8739ae039 = $6693f36f228c4adf$var$getDwellTimeHelper;

});




parcelRegister("gOnVe", function(module, exports) {

$parcel$export(module.exports, "default", () => $01f1dd95ed538035$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cprXC = parcelRequire("cprXC");
var $70e7z = parcelRequire("70e7z");

var $3x9dX = parcelRequire("3x9dX");

var $iVTy4 = parcelRequire("iVTy4");
function $01f1dd95ed538035$var$hasProfileProp(state) {
    return !!state && 'profile' in state;
}
const $01f1dd95ed538035$var$KudosPageRoute = ({ match: match, location: location })=>{
    const { uuid: uuid } = match.params;
    const profile = $01f1dd95ed538035$var$hasProfileProp(location.state) ? location.state.profile : undefined;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVTy4.default), {
                name: (0, $cprXC.AnalyticsKeys).KUDOS_PAGE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $70e7z.default), {
                name: (0, $cprXC.AnalyticsKeys).KUDOS_PAGE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3x9dX.default), {
                uuid: uuid,
                referrerProfile: profile
            })
        ]
    });
};
var $01f1dd95ed538035$export$2e2bcd8739ae039 = $01f1dd95ed538035$var$KudosPageRoute;

});
parcelRegister("3x9dX", function(module, exports) {

$parcel$export(module.exports, "default", () => $62c22d2f09fd3f6e$export$2e2bcd8739ae039);

var $4qBtX = parcelRequire("4qBtX");

const $62c22d2f09fd3f6e$var$LazyKudosPage = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("lI9BB")),
    loading: ()=>null
});
$62c22d2f09fd3f6e$var$LazyKudosPage.displayName = 'lazy(KudosPage)';
var $62c22d2f09fd3f6e$export$2e2bcd8739ae039 = $62c22d2f09fd3f6e$var$LazyKudosPage;

});
parcelRegister("lI9BB", function(module, exports) {

let $fce5287b00bc8ceb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fce5287b00bc8ceb$var$load("dW7Hm").then(()=>parcelRequire('7nOlP'));

});



parcelRegister("8VgL2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac6eeccd2db35ba5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cprXC = parcelRequire("cprXC");
var $cz9fD = parcelRequire("cz9fD");
var $358cZ = parcelRequire("358cZ");
var $1geG0 = parcelRequire("1geG0");

var $cBsWe = parcelRequire("cBsWe");
function $ac6eeccd2db35ba5$export$2e2bcd8739ae039(props) {
    const { contextEntryPoint: contextEntryPoint, location: location } = props;
    const [{ principalUserId: principalUserId }] = (0, $1geG0.usePrincipalUser)();
    const analytics = (0, $358cZ.default)();
    const url = new URL(window.location.href);
    const ref = (0, $cz9fD.sanitiseValue)(url.searchParams.get('ref') || '', {
        shouldHaveSafeCharsOnly: true,
        shouldEncode: true
    });
    (0, $5uXOq.useEffect)(()=>{
        analytics.pushTrackEvent({
            source: (0, $cprXC.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'redirectMePathToMyProfile',
            action: (0, $cprXC.AnalyticsEventActions).REDIRECTED,
            attributes: {
                ref: ref
            }
        });
    }, [
        analytics,
        ref
    ]);
    if (!principalUserId) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBsWe.default), {
        to: `${contextEntryPoint}/${principalUserId}${location.search}`
    });
}

});
parcelRegister("cBsWe", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f2f26fb0076f3c5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5vx1F = parcelRequire("5vx1F");
const $5f2f26fb0076f3c5$var$Redirect = ({ to: to })=>{
    const { replace: replace } = (0, $5vx1F.useAppConfig)();
    (0, $5uXOq.useEffect)(()=>{
        replace(to);
    }, [
        replace,
        to
    ]);
    return null;
};
var $5f2f26fb0076f3c5$export$2e2bcd8739ae039 = $5f2f26fb0076f3c5$var$Redirect;

});


parcelRegister("2ZwzQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0bad2e4c0723fb1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cBsWe = parcelRequire("cBsWe");
const $b0bad2e4c0723fb1$var$RootRedirect = ({ location: location })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBsWe.default), {
        to: `search${location.search}`
    });
var $b0bad2e4c0723fb1$export$2e2bcd8739ae039 = $b0bad2e4c0723fb1$var$RootRedirect;

});

parcelRegister("3w4by", function(module, exports) {

$parcel$export(module.exports, "RouteWithOrgIdLoading", () => $aa4ffff1c195ac7b$export$ae0909755df943ac);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fCZyz = parcelRequire("fCZyz");

var $47bDC = parcelRequire("47bDC");

var $clxo5 = parcelRequire("clxo5");

var $1lfNR = parcelRequire("1lfNR");

var $jP0Fy = parcelRequire("jP0Fy");

var $2ZwzQ = parcelRequire("2ZwzQ");
function $aa4ffff1c195ac7b$export$ae0909755df943ac({ LoadingComponent: LoadingComponent, ...props }) {
    const [{ orgId: orgId }] = (0, $1lfNR.useOrg)();
    const [timedOut, setTimedOut] = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useState(false);
    const handleNoOrgId = (0, $5uXOq.useCallback)(()=>{
        (0, $jP0Fy.logInfoMessage)('No orgId found after 10 seconds', {
            ...props
        });
        setTimedOut(true);
    }, [
        setTimedOut,
        props
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (orgId) return;
        const timeout = setTimeout(()=>{
            if (!orgId) handleNoOrgId();
        }, 10000);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        orgId,
        handleNoOrgId
    ]);
    if (timedOut) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2ZwzQ.default), {
        location: {
            search: ''
        }
    });
    if (!orgId) return LoadingComponent ? /*#__PURE__*/ (0, $2OMIu.jsx)(LoadingComponent, {}) : /*#__PURE__*/ (0, $2OMIu.jsx)($aa4ffff1c195ac7b$var$DefaultLoadingWrapper, {
        "data-testid": "route-with-org-id-loading",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {
            size: 'large'
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fCZyz.default), {
        ...props
    });
}
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aa4ffff1c195ac7b$var$DefaultLoadingWrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1wps406-0"
})`height:100%;width:100%;padding-top:100px;display:flex;justify-content:center;align-items:center;`;

});

parcelRegister("jc4mG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ded4739f4f10fe59$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cprXC = parcelRequire("cprXC");
var $70e7z = parcelRequire("70e7z");

var $iVTy4 = parcelRequire("iVTy4");

var $jo67S = parcelRequire("jo67S");
const $ded4739f4f10fe59$var$SearchPageRoute = ()=>{
    const url = new URL(window.location.href);
    const searchQuery = url.searchParams.get('q') || '';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVTy4.default), {
                name: (0, $cprXC.AnalyticsKeys).PEOPLE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $70e7z.default), {
                name: (0, $cprXC.AnalyticsKeys).PEOPLE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jo67S.default), {
                    searchQuery: searchQuery
                })
            })
        ]
    });
};
var $ded4739f4f10fe59$export$2e2bcd8739ae039 = $ded4739f4f10fe59$var$SearchPageRoute;

});
parcelRegister("jo67S", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d8fa1e641ef5463$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

const $5d8fa1e641ef5463$var$LazySearchPage = (0, $5uXOq.lazy)(()=>(parcelRequire("6yKU0")));
var $5d8fa1e641ef5463$export$2e2bcd8739ae039 = $5d8fa1e641ef5463$var$LazySearchPage;

});
parcelRegister("6yKU0", function(module, exports) {

let $4c6a4ce715c16ad6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4c6a4ce715c16ad6$var$load("cXg04").then(()=>parcelRequire('jXtYw'));

});



parcelRegister("5vxza", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a8d89f9035be748$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cprXC = parcelRequire("cprXC");
var $70e7z = parcelRequire("70e7z");

var $iVTy4 = parcelRequire("iVTy4");

var $7pP9C = parcelRequire("7pP9C");
const $1a8d89f9035be748$var$SearchTeamsError = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVTy4.default), {
                name: (0, $cprXC.AnalyticsKeys).ALL_TEAMS_DISABLED
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $70e7z.default), {
                name: (0, $cprXC.AnalyticsKeys).ALL_TEAMS_DISABLED
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7pP9C.LazyTeamsDisabled), {})
        ]
    });
};
var $1a8d89f9035be748$export$2e2bcd8739ae039 = $1a8d89f9035be748$var$SearchTeamsError;

});
parcelRegister("7pP9C", function(module, exports) {

$parcel$export(module.exports, "LazyTeamsDisabled", () => $069c80755f15c8bf$export$f063de2a1a254e59);

var $4qBtX = parcelRequire("4qBtX");

const $069c80755f15c8bf$export$f063de2a1a254e59 = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("5Hkbh")).then((module)=>module.TeamsDisabled),
    loading: ()=>null
});
$069c80755f15c8bf$export$f063de2a1a254e59.displayName = 'lazy(TeamsDisabled)';

});
parcelRegister("5Hkbh", function(module, exports) {

let $42609f6d8b626fa1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $42609f6d8b626fa1$var$load("6DbKw").then(()=>parcelRequire('lCHrj'));

});



parcelRegister("dSoDN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fe81c5abb2fa7c2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cprXC = parcelRequire("cprXC");
var $2jWR9 = parcelRequire("2jWR9");
var $70e7z = parcelRequire("70e7z");

var $iVTy4 = parcelRequire("iVTy4");

var $em6X9 = parcelRequire("em6X9");
const $9fe81c5abb2fa7c2$var$TeamProfileRoute = ({ match: match })=>{
    const { teamId: teamId } = match.params;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVTy4.default), {
                name: (0, $cprXC.AnalyticsKeys).TEAM_PROFILE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $70e7z.default), {
                name: (0, $cprXC.AnalyticsKeys).TEAM_PROFILE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2jWR9.default), {
                teamId: teamId
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $em6X9.default), {
                teamId: teamId
            })
        ]
    });
};
var $9fe81c5abb2fa7c2$export$2e2bcd8739ae039 = $9fe81c5abb2fa7c2$var$TeamProfileRoute;

});
parcelRegister("2jWR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cde655297f31bc9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lbMXQ = parcelRequire("lbMXQ");

var $358cZ = parcelRequire("358cZ");
function $1cde655297f31bc9$export$2e2bcd8739ae039({ teamId: teamId }) {
    const analytics = (0, $358cZ.default)();
    (0, $lbMXQ.useInjectedEventAttribute)('teamId', teamId);
    (0, $5uXOq.useEffect)(()=>{
        analytics.setTeamId(teamId);
        ()=>{
            analytics.setTeamId(undefined);
        };
    }, [
        analytics,
        teamId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {});
}

});

parcelRegister("em6X9", function(module, exports) {

$parcel$export(module.exports, "default", () => $28e201475e687857$export$2e2bcd8739ae039);

var $4qBtX = parcelRequire("4qBtX");

const $28e201475e687857$var$TeamProfilePage = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("iN3Ro")),
    loading: ()=>null
});
$28e201475e687857$var$TeamProfilePage.displayName = 'lazy(TeamProfilePage)';
var $28e201475e687857$export$2e2bcd8739ae039 = $28e201475e687857$var$TeamProfilePage;

});
parcelRegister("iN3Ro", function(module, exports) {

let $dadfcc2b16bd44d0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $dadfcc2b16bd44d0$var$load("cM9em"),
    $dadfcc2b16bd44d0$var$load("fr9NE"),
    $dadfcc2b16bd44d0$var$load("h2MrD"),
    $dadfcc2b16bd44d0$var$load("bYT2S"),
    $dadfcc2b16bd44d0$var$load("4rVZK")
]).then(()=>parcelRequire('2TfvH'));

});



parcelRegister("7toiV", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb3bb7b581124320$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cBsWe = parcelRequire("cBsWe");
const $bb3bb7b581124320$var$TeamNoIdRedirect = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBsWe.default), {
        to: "/search"
    });
var $bb3bb7b581124320$export$2e2bcd8739ae039 = $bb3bb7b581124320$var$TeamNoIdRedirect;

});

parcelRegister("fWVIY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ea0d5fc1d2acb1d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cprXC = parcelRequire("cprXC");
var $70e7z = parcelRequire("70e7z");

var $5KHom = parcelRequire("5KHom");

var $iVTy4 = parcelRequire("iVTy4");
const $1ea0d5fc1d2acb1d$var$UserProfileRoute = ({ match: match })=>{
    const { userId: userId } = match.params;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVTy4.default), {
                name: (0, $cprXC.AnalyticsKeys).PROFILE_PAGE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $70e7z.default), {
                name: (0, $cprXC.AnalyticsKeys).PROFILE_PAGE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KHom.default), {
                userId: decodeURIComponent(userId)
            })
        ]
    });
};
var $1ea0d5fc1d2acb1d$export$2e2bcd8739ae039 = $1ea0d5fc1d2acb1d$var$UserProfileRoute;

});
parcelRegister("5KHom", function(module, exports) {

$parcel$export(module.exports, "default", () => $937b400954c1aece$export$2e2bcd8739ae039);

var $4qBtX = parcelRequire("4qBtX");

const $937b400954c1aece$var$LazyUserProfile = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("7CNHb")),
    loading: ()=>null
});
$937b400954c1aece$var$LazyUserProfile.displayName = 'lazy(UserProfile)';
var $937b400954c1aece$export$2e2bcd8739ae039 = $937b400954c1aece$var$LazyUserProfile;

});
parcelRegister("7CNHb", function(module, exports) {

let $58d2a1843556563c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $58d2a1843556563c$var$load("cM9em"),
    $58d2a1843556563c$var$load("fr9NE"),
    $58d2a1843556563c$var$load("h2MrD"),
    $58d2a1843556563c$var$load("bYT2S"),
    $58d2a1843556563c$var$load("gtMmV")
]).then(()=>parcelRequire('ibWHc'));

});



parcelRegister("fl2tR", function(module, exports) {

$parcel$export(module.exports, "default", () => $07f934244273239e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cBsWe = parcelRequire("cBsWe");
const $07f934244273239e$var$UserProfileUnknownRoute = ({ match: match })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBsWe.default), {
        to: match.params.userId
    });
var $07f934244273239e$export$2e2bcd8739ae039 = $07f934244273239e$var$UserProfileUnknownRoute;

});

parcelRegister("fNxAa", function(module, exports) {

$parcel$export(module.exports, "default", () => $95398e17e0884842$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cprXC = parcelRequire("cprXC");
var $70e7z = parcelRequire("70e7z");

var $iVTy4 = parcelRequire("iVTy4");

var $gcU92 = parcelRequire("gcU92");
const $95398e17e0884842$var$UserProfileWorkedOn = ({ match: match })=>{
    const { userId: userId } = match.params;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iVTy4.default), {
                name: (0, $cprXC.AnalyticsKeys).PROFILE_WORKED_ON_PAGE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $70e7z.default), {
                name: (0, $cprXC.AnalyticsKeys).PROFILE_WORKED_ON_PAGE_VIEW
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gcU92.default), {
                userId: decodeURIComponent(userId)
            })
        ]
    });
};
var $95398e17e0884842$export$2e2bcd8739ae039 = $95398e17e0884842$var$UserProfileWorkedOn;

});
parcelRegister("gcU92", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a8af328bd8d30b2$export$2e2bcd8739ae039);

var $4qBtX = parcelRequire("4qBtX");

const $4a8af328bd8d30b2$var$LazyUserProfileWorkedOn = (0, (/*@__PURE__*/$parcel$interopDefault($4qBtX)))({
    loader: ()=>(parcelRequire("j7eDx")),
    loading: ()=>null
});
$4a8af328bd8d30b2$var$LazyUserProfileWorkedOn.displayName = 'lazy(UserProfileWorkedOn)';
var $4a8af328bd8d30b2$export$2e2bcd8739ae039 = $4a8af328bd8d30b2$var$LazyUserProfileWorkedOn;

});
parcelRegister("j7eDx", function(module, exports) {

let $deaa064dc2c85f05$var$load = (parcelRequire("28QjX"))(4);
module.exports = $deaa064dc2c85f05$var$load("8gzdD").then(()=>parcelRequire('gOSec'));

});




parcelRegister("hKTTU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2b9200bbfb7ea3c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $99vc1 = parcelRequire("99vc1");

var $2iRRL = parcelRequire("2iRRL");

var $5vx1F = parcelRequire("5vx1F");

var $ibwcC = parcelRequire("ibwcC");
const $c2b9200bbfb7ea3c$var$appProductMap = {
    '': '',
    'site-directory': '',
    'confluence-directory': (0, $99vc1.ProductName).CONFLUENCE,
    'jira-directory': (0, $99vc1.ProductName).JIRA,
    'teamcentral-directory': (0, $99vc1.ProductName).ATLAS,
    'home-directory': (0, $99vc1.ProductName).HOME
};
const $c2b9200bbfb7ea3c$var$mapAppToProduct = (app)=>{
    return $c2b9200bbfb7ea3c$var$appProductMap[app];
};
class $c2b9200bbfb7ea3c$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    render() {
        // This is here to let productFeatureFlags from getting updated via props
        const productFeatureFlags = {
            ...this.state.productFeatureFlags,
            ...this.props.productFeatureFlags
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5vx1F.default).Provider, {
            value: {
                ...this.props,
                ...this.state,
                productFeatureFlags: productFeatureFlags
            },
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.addFlag = (props)=>{
            const { type: type, ...rest } = props;
            this.props.addFlag({
                ...rest,
                id: rest.id ? `${rest.id}.${Date.now()}` : Date.now(),
                type: type,
                appearance: 'normal',
                icon: (0, $ibwcC.getTypeIcon)(type)
            });
        }, this.push = (path)=>{
            const { contextEntryPoint: contextEntryPoint } = this.props;
            const finalPath = (0, $2iRRL.prefixWithContextEntryPoint)(path, contextEntryPoint);
            return this.props.push(finalPath);
        }, this.replace = (path)=>{
            const { contextEntryPoint: contextEntryPoint } = this.props;
            const finalPath = (0, $2iRRL.prefixWithContextEntryPoint)(path, contextEntryPoint);
            return this.props.replace(finalPath);
        }, this.state = {
            addFlag: this.addFlag,
            push: this.push,
            replace: this.replace,
            productName: $c2b9200bbfb7ea3c$var$mapAppToProduct(this.props.appName),
            productFeatureFlags: this.props.productFeatureFlags,
            invitePeopleHandlers: this.props.invitePeopleHandlers
        };
    }
}

});
parcelRegister("ibwcC", function(module, exports) {

$parcel$export(module.exports, "getTypeIcon", () => $7c67a4e0e7c0d71f$export$672f92b0d52b7cfe);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5E93O = parcelRequire("5E93O");

var $k01Ou = parcelRequire("k01Ou");

var $bMdrA = parcelRequire("bMdrA");

var $85eFT = parcelRequire("85eFT");

const $7c67a4e0e7c0d71f$var$flagIconByType = {
    error: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
        label: "error123",
        spacing: "spacious",
        color: `var(--ds-icon-danger, ${(0, $a7f8c6b391092279$export$4a7404f376229999)})`
    }),
    warning: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($85eFT))), {
        label: "warning123",
        spacing: "spacious",
        color: `var(--ds-icon-warning, ${(0, $a7f8c6b391092279$export$c6930421db9fa514)})`
    }),
    info: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k01Ou))), {
        label: "info123",
        spacing: "spacious",
        color: `var(--ds-icon-information, ${(0, $a7f8c6b391092279$export$e62e8919cca44969)})`
    })
};
const $7c67a4e0e7c0d71f$var$defaultIcon = /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bMdrA))), {
    label: "winner123",
    spacing: "spacious",
    color: `var(--ds-icon-success, ${(0, $a7f8c6b391092279$export$940e1f69e873f202)})`
});
const $7c67a4e0e7c0d71f$export$672f92b0d52b7cfe = (type = 'normal')=>$7c67a4e0e7c0d71f$var$flagIconByType[type] || $7c67a4e0e7c0d71f$var$defaultIcon;

});


parcelRegister("5WY7F", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e213ab75c6f9f8b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cprXC = parcelRequire("cprXC");
var $8vAg7 = parcelRequire("8vAg7");
var $aVe3r = parcelRequire("aVe3r");
class $7e213ab75c6f9f8b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        const { analytics: analytics, appName: appName } = this.props;
        (0, $aVe3r.logException)(error, 'Caught error in ErrorBoundaryApp', {
            info: errorInfo,
            tags: {
                severity: 'high',
                boundary: 'AppRoot'
            }
        });
        analytics.pushOperationalEvent({
            source: (0, $cprXC.AnalyticsEventSource).CLIENT_METRICS,
            actionSubject: 'errorBoundary',
            action: (0, $cprXC.AnalyticsEventActions).TRIGGERED,
            attributes: {
                product: appName,
                boundary: 'app',
                error: error.toString()
            },
            tags: [
                'error',
                'error-boundary'
            ]
        });
    }
    render() {
        if (!this.state.hasError) return this.props.children;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8vAg7.GenericErrorPage), {
            hasSupportLink: true
        });
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        };
    }
}

});

parcelRegister("kUn7S", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f19b976d67279bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cprXC = parcelRequire("cprXC");
var $358cZ = parcelRequire("358cZ");
var $1geG0 = parcelRequire("1geG0");
var $kYgQW = parcelRequire("kYgQW");
var $a4jrI = parcelRequire("a4jrI");

var $80MA9 = parcelRequire("80MA9");
const $4f19b976d67279bd$var$mapAppNameToProduct = {
    '': 'STANDALONE',
    'site-directory': 'STANDALONE',
    'confluence-directory': 'CONFLUENCE',
    'jira-directory': 'JIRA',
    'teamcentral-directory': 'TOWNSQUARE',
    'home-directory': 'HOME'
};
function $4f19b976d67279bd$export$f07589effd6b0ff3(props) {
    const { appName: appName, children: children } = props;
    const [{ cloudId: cloudId }] = (0, $a4jrI.useSite)();
    const [{ principalUserId: principalUserId }, { getPrincipalUserInfo: getPrincipalUserInfo }] = (0, $1geG0.usePrincipalUser)();
    const analytics = (0, $358cZ.default)();
    const [{ hasLoadedSettings: hasLoadedSettings, hasErrorOnFetchSettings: hasErrorOnFetchSettings, isFetching: isFetching }, { getSettings: getSettings }] = (0, $kYgQW.useSettings)();
    (0, $5uXOq.useEffect)(()=>{
        analytics.startUIViewedEvent(principalUserId);
    }, [
        analytics,
        principalUserId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hasLoadedSettings) analytics.pushOperationalEvent({
            action: hasErrorOnFetchSettings ? (0, $cprXC.AnalyticsEventActions).FAILED : (0, $cprXC.AnalyticsEventActions).SUCCEEDED,
            actionSubject: (0, $80MA9.SliAnalytics).GetSettings,
            source: (0, $cprXC.AnalyticsEventSource).DIRECTORY_APP
        });
    }, [
        analytics,
        hasLoadedSettings,
        hasErrorOnFetchSettings
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const product = $4f19b976d67279bd$var$mapAppNameToProduct[appName];
        // currently, cloudId is a required prop of Embedded Directory
        if (!hasLoadedSettings && !isFetching && cloudId) getSettings(product, cloudId);
    }, [
        appName,
        hasLoadedSettings,
        getSettings,
        cloudId,
        isFetching
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // currently, cloudId is a required prop of Embedded Directory
        if (cloudId) getPrincipalUserInfo(cloudId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cloudId
    ]);
    return children;
}
var $4f19b976d67279bd$export$2e2bcd8739ae039 = $4f19b976d67279bd$export$f07589effd6b0ff3;

});
parcelRegister("kYgQW", function(module, exports) {

$parcel$export(module.exports, "useFeatureFlag", () => $8e2f040835215540$export$61acb772777ef35d);
$parcel$export(module.exports, "useSettings", () => $8e2f040835215540$export$9115b42802a3e44f);

var $26UcG = parcelRequire("26UcG");
var $jFFo8 = parcelRequire("jFFo8");
const $8e2f040835215540$export$c5cecc6f5d4bab3e = ()=>{
    return true;
};
const $8e2f040835215540$export$61acb772777ef35d = (flagName)=>{
    return (0, $26UcG.useFeatureFlag)(flagName);
};
const $8e2f040835215540$export$9115b42802a3e44f = ()=>{
    return (0, $jFFo8.useSettings)();
};

});
parcelRegister("26UcG", function(module, exports) {

$parcel$export(module.exports, "useFeatureFlag", () => $3bff5030a3f7fb58$export$61acb772777ef35d);

var $jFFo8 = parcelRequire("jFFo8");

var $gKRfs = parcelRequire("gKRfs");
const $3bff5030a3f7fb58$export$61acb772777ef35d = (flag)=>{
    const { productFeatureFlags: productFeatureFlags } = (0, $gKRfs.useAppConfig)();
    const flagValue = (0, $jFFo8.useSettingsFeatureFlag)(flag);
    if (productFeatureFlags && productFeatureFlags[flag] !== undefined) return productFeatureFlags[flag];
    return flagValue;
};
const $3bff5030a3f7fb58$export$80200644648c0ee1 = (flagName)=>!!$3bff5030a3f7fb58$export$61acb772777ef35d(flagName);

});


parcelRegister("80MA9", function(module, exports) {

$parcel$export(module.exports, "SliAnalytics", () => $b13704bd28f3d0dd$export$9cb5f615baf57db6);
var $b13704bd28f3d0dd$export$9cb5f615baf57db6 = /*#__PURE__*/ function(SliAnalytics) {
    SliAnalytics["GetTeamProfile"] = "GetTeamProfile";
    SliAnalytics["GetTeamMembers"] = "GetTeamMembers";
    SliAnalytics["GetTeamLinks"] = "GetTeamLinks";
    SliAnalytics["TeamSearch"] = "TeamSearch";
    SliAnalytics["AccountCentricUserSearch"] = "AccountCentricUserSearch";
    SliAnalytics["LoadProfileAbout"] = "LoadProfileAbout";
    SliAnalytics["GetSettings"] = "GetSettings";
    return SliAnalytics;
}({});

});




parcelRegister("c9lD2", function(module, exports) {

$parcel$export(module.exports, "createShowFlagHandler", () => $3cf06505514424b8$export$58bf1d914631d59f);

var $5uXOq = parcelRequire("5uXOq");

var $7HGHK = parcelRequire("7HGHK");

var $fG9jT = parcelRequire("fG9jT");
const $3cf06505514424b8$var$FLAG_PTC_ID_DEFAULT = 'ptc-people-directory.flag-id';
const $3cf06505514424b8$export$58bf1d914631d59f = (showFlag, dismissFlag)=>(flagFromPTC)=>{
        const flagType = flagFromPTC.type === 'success' || flagFromPTC.type === 'error' || flagFromPTC.type === 'info' || flagFromPTC.type === 'warning' ? flagFromPTC.type : 'success';
        const flagTitle = flagFromPTC.title;
        const flagDesc = flagFromPTC.description;
        const flagActions = flagFromPTC?.actions;
        showFlag({
            render: ({ key: key })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fG9jT.default), {
                    key: key,
                    id: key || flagFromPTC.id || $3cf06505514424b8$var$FLAG_PTC_ID_DEFAULT,
                    flagType: flagType,
                    title: flagTitle != null ? flagTitle : '',
                    description: flagDesc != null ? flagDesc : '',
                    messageId: `spa-apps-people-profiles.utils.create-show-flag-handler.common-flag.showFlag.${key || flagFromPTC.id || $3cf06505514424b8$var$FLAG_PTC_ID_DEFAULT}`,
                    messageType: "transactional",
                    actions: flagActions,
                    isAutoDismiss: true,
                    onDismissed: (id)=>{
                        dismissFlag((0, $7HGHK.toFlagId)(id));
                    }
                })
        });
    };

});
parcelRegister("fG9jT", function(module, exports) {

$parcel$export(module.exports, "default", () => $874cfd4b776497f7$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$874cfd4b776497f7$export$2e2bcd8739ae039 = (0, $3KRpp.CommonFlag);

});


parcelRegister("fnaRp", function(module, exports) {

$parcel$export(module.exports, "peopleProfilesPageLoad", () => $73adf83f024db228$export$37d218590c0c9938);

var $2nKjG = parcelRequire("2nKjG");
const $73adf83f024db228$export$37d218590c0c9938 = (0, $2nKjG.metrics).pageLoad({
    key: 'people-profiles'
});

});



//# sourceMappingURL=async-people-profiles.01c8041c.js.map
